'use strict';Object.defineProperty(exports,'__esModule',{value:true});var React=require('react'),PropTypes=require('prop-types'),dayjs=require('dayjs'),styled=require('styled-components'),ReactDOM=require('react-dom'),framerMotion=require('framer-motion'),require$$0$2=require('react-is'),reactResponsive=require('react-responsive'),uuid=require('uuid');function _interopDefaultLegacy(e){return e&&typeof e==='object'&&'default'in e?e:{'default':e}}function _interopNamespace(e){if(e&&e.__esModule)return e;var n=Object.create(null);if(e){Object.keys(e).forEach(function(k){if(k!=='default'){var d=Object.getOwnPropertyDescriptor(e,k);Object.defineProperty(n,k,d.get?d:{enumerable:true,get:function(){return e[k];}});}});}n['default']=e;return Object.freeze(n);}var React__default=/*#__PURE__*/_interopDefaultLegacy(React);var React__namespace=/*#__PURE__*/_interopNamespace(React);var PropTypes__default=/*#__PURE__*/_interopDefaultLegacy(PropTypes);var dayjs__default=/*#__PURE__*/_interopDefaultLegacy(dayjs);var styled__default=/*#__PURE__*/_interopDefaultLegacy(styled);var ReactDOM__namespace=/*#__PURE__*/_interopNamespace(ReactDOM);var ReactDOM__default=/*#__PURE__*/_interopDefaultLegacy(ReactDOM);var require$$0__default=/*#__PURE__*/_interopDefaultLegacy(require$$0$2);function ownKeys$7(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2$2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys$7(Object(source), true).forEach(function (key) {
        _defineProperty$8(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys$7(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _typeof$6(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof$6 = function (obj) {
      return typeof obj;
    };
  } else {
    _typeof$6 = function (obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof$6(obj);
}

function _classCallCheck$k(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties$5(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass$g(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties$5(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties$5(Constructor, staticProps);
  return Constructor;
}

function _defineProperty$8(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _extends$g() {
  _extends$g = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$g.apply(this, arguments);
}

function _inherits$e(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf$1(subClass, superClass);
}

function _getPrototypeOf$1(o) {
  _getPrototypeOf$1 = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf$1(o);
}

function _setPrototypeOf$1(o, p) {
  _setPrototypeOf$1 = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf$1(o, p);
}

function _isNativeReflectConstruct$1() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _objectWithoutPropertiesLoose$3(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties$7(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose$3(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _assertThisInitialized$1(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn$e(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized$1(self);
}

function _createSuper$1(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct$1();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf$1(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf$1(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn$e(this, result);
  };
}

function _taggedTemplateLiteral$5(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

function _slicedToArray$7(arr, i) {
  return _arrayWithHoles$7(arr) || _iterableToArrayLimit$7(arr, i) || _unsupportedIterableToArray$6(arr, i) || _nonIterableRest$7();
}

function _toConsumableArray$5(arr) {
  return _arrayWithoutHoles$5(arr) || _iterableToArray$5(arr) || _unsupportedIterableToArray$6(arr) || _nonIterableSpread$5();
}

function _arrayWithoutHoles$5(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray$6(arr);
}

function _arrayWithHoles$7(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArray$5(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

function _iterableToArrayLimit$7(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _unsupportedIterableToArray$6(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray$6(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$6(o, minLen);
}

function _arrayLikeToArray$6(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _nonIterableSpread$5() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _nonIterableRest$7() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function getDefaultExportFromCjs (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

function getAugmentedNamespace(n) {
	if (n.__esModule) return n;
	var a = Object.defineProperty({}, '__esModule', {value: true});
	Object.keys(n).forEach(function (k) {
		var d = Object.getOwnPropertyDescriptor(n, k);
		Object.defineProperty(a, k, d.get ? d : {
			enumerable: true,
			get: function () {
				return n[k];
			}
		});
	});
	return a;
}

function commonjsRequire (path) {
	throw new Error('Could not dynamically require "' + path + '". Please configure the dynamicRequireTargets or/and ignoreDynamicRequires option of @rollup/plugin-commonjs appropriately for this require call to work.');
}var relativeTime$1 = {exports: {}};(function (module, exports) {
!function(r,e){module.exports=e();}(commonjsGlobal,(function(){return function(r,e,t){r=r||{};var n=e.prototype,o={future:"in %s",past:"%s ago",s:"a few seconds",m:"a minute",mm:"%d minutes",h:"an hour",hh:"%d hours",d:"a day",dd:"%d days",M:"a month",MM:"%d months",y:"a year",yy:"%d years"};function i(r,e,t,o){return n.fromToBase(r,e,t,o)}t.en.relativeTime=o,n.fromToBase=function(e,n,i,d,u){for(var f,a,s,l=i.$locale().relativeTime||o,h=r.thresholds||[{l:"s",r:44,d:"second"},{l:"m",r:89},{l:"mm",r:44,d:"minute"},{l:"h",r:89},{l:"hh",r:21,d:"hour"},{l:"d",r:35},{l:"dd",r:25,d:"day"},{l:"M",r:45},{l:"MM",r:10,d:"month"},{l:"y",r:17},{l:"yy",d:"year"}],m=h.length,c=0;c<m;c+=1){var y=h[c];y.d&&(f=d?t(e).diff(i,y.d,!0):i.diff(e,y.d,!0));var p=(r.rounding||Math.round)(Math.abs(f));if(s=f>0,p<=y.r||!y.r){p<=1&&c>0&&(y=h[c-1]);var v=l[y.l];u&&(p=u(""+p)),a="string"==typeof v?v.replace("%d",p):v(p,n,y.l,s);break}}if(n)return a;var M=s?l.future:l.past;return "function"==typeof M?M(a):M.replace("%s",a)},n.to=function(r,e){return i(r,e,this,!0)},n.from=function(r,e){return i(r,e,this)};var d=function(r){return r.$u?t.utc():t()};n.toNow=function(r){return this.to(d(this),r)},n.fromNow=function(r){return this.from(d(this),r)};}}));
}(relativeTime$1));

var relativeTime = relativeTime$1.exports;var fr = {exports: {}};(function (module, exports) {
!function(e,n){module.exports=n(dayjs__default['default']);}(commonjsGlobal,(function(e){function n(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var t=n(e),i={name:"fr",weekdays:"dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi".split("_"),weekdaysShort:"dim._lun._mar._mer._jeu._ven._sam.".split("_"),weekdaysMin:"di_lu_ma_me_je_ve_sa".split("_"),months:"janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre".split("_"),monthsShort:"janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.".split("_"),weekStart:1,yearStart:4,formats:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY HH:mm",LLLL:"dddd D MMMM YYYY HH:mm"},relativeTime:{future:"dans %s",past:"il y a %s",s:"quelques secondes",m:"une minute",mm:"%d minutes",h:"une heure",hh:"%d heures",d:"un jour",dd:"%d jours",M:"un mois",MM:"%d mois",y:"un an",yy:"%d ans"},ordinal:function(e){return ""+e+(1===e?"er":"")}};return t.default.locale(i,null,!0),i}));
}(fr));var de = {exports: {}};(function (module, exports) {
!function(e,n){module.exports=n(dayjs__default['default']);}(commonjsGlobal,(function(e){function n(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var t=n(e),a={s:"ein paar Sekunden",m:["eine Minute","einer Minute"],mm:"%d Minuten",h:["eine Stunde","einer Stunde"],hh:"%d Stunden",d:["ein Tag","einem Tag"],dd:["%d Tage","%d Tagen"],M:["ein Monat","einem Monat"],MM:["%d Monate","%d Monaten"],y:["ein Jahr","einem Jahr"],yy:["%d Jahre","%d Jahren"]};function i(e,n,t){var i=a[t];return Array.isArray(i)&&(i=i[n?0:1]),i.replace("%d",e)}var r={name:"de",weekdays:"Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag".split("_"),weekdaysShort:"So._Mo._Di._Mi._Do._Fr._Sa.".split("_"),weekdaysMin:"So_Mo_Di_Mi_Do_Fr_Sa".split("_"),months:"Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember".split("_"),monthsShort:"Jan_Feb_März_Apr_Mai_Juni_Juli_Aug_Sept_Okt_Nov_Dez".split("_"),ordinal:function(e){return e+"."},weekStart:1,yearStart:4,formats:{LTS:"HH:mm:ss",LT:"HH:mm",L:"DD.MM.YYYY",LL:"D. MMMM YYYY",LLL:"D. MMMM YYYY HH:mm",LLLL:"dddd, D. MMMM YYYY HH:mm"},relativeTime:{future:"in %s",past:"vor %s",s:i,m:i,mm:i,h:i,hh:i,d:i,dd:i,M:i,MM:i,y:i,yy:i}};return t.default.locale(r,null,!0),r}));
}(de));var es = {exports: {}};(function (module, exports) {
!function(e,o){module.exports=o(dayjs__default['default']);}(commonjsGlobal,(function(e){function o(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var s=o(e),d={name:"es",monthsShort:"ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic".split("_"),weekdays:"domingo_lunes_martes_miércoles_jueves_viernes_sábado".split("_"),weekdaysShort:"dom._lun._mar._mié._jue._vie._sáb.".split("_"),weekdaysMin:"do_lu_ma_mi_ju_vi_sá".split("_"),months:"enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre".split("_"),weekStart:1,formats:{LT:"H:mm",LTS:"H:mm:ss",L:"DD/MM/YYYY",LL:"D [de] MMMM [de] YYYY",LLL:"D [de] MMMM [de] YYYY H:mm",LLLL:"dddd, D [de] MMMM [de] YYYY H:mm"},relativeTime:{future:"en %s",past:"hace %s",s:"unos segundos",m:"un minuto",mm:"%d minutos",h:"una hora",hh:"%d horas",d:"un día",dd:"%d días",M:"un mes",MM:"%d meses",y:"un año",yy:"%d años"},ordinal:function(e){return e+"º"}};return s.default.locale(d,null,!0),d}));
}(es));var dist$2 = {exports: {}};var check = function (it) {
  return it && it.Math == Math && it;
};

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global$r =
  // eslint-disable-next-line es/no-global-this -- safe
  check(typeof globalThis == 'object' && globalThis) ||
  check(typeof window == 'object' && window) ||
  // eslint-disable-next-line no-restricted-globals -- safe
  check(typeof self == 'object' && self) ||
  check(typeof commonjsGlobal == 'object' && commonjsGlobal) ||
  // eslint-disable-next-line no-new-func -- fallback
  (function () { return this; })() || Function('return this')();var objectGetOwnPropertyDescriptor = {};var fails$r = function (exec) {
  try {
    return !!exec();
  } catch (error) {
    return true;
  }
};var fails$q = fails$r;

// Detect IE8's incomplete defineProperty implementation
var descriptors = !fails$q(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty({}, 1, { get: function () { return 7; } })[1] != 7;
});var objectPropertyIsEnumerable = {};var $propertyIsEnumerable$1 = {}.propertyIsEnumerable;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getOwnPropertyDescriptor$5 = Object.getOwnPropertyDescriptor;

// Nashorn ~ JDK8 bug
var NASHORN_BUG = getOwnPropertyDescriptor$5 && !$propertyIsEnumerable$1.call({ 1: 2 }, 1);

// `Object.prototype.propertyIsEnumerable` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.propertyisenumerable
objectPropertyIsEnumerable.f = NASHORN_BUG ? function propertyIsEnumerable(V) {
  var descriptor = getOwnPropertyDescriptor$5(this, V);
  return !!descriptor && descriptor.enumerable;
} : $propertyIsEnumerable$1;var createPropertyDescriptor$5 = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};var toString$8 = {}.toString;

var classofRaw$1 = function (it) {
  return toString$8.call(it).slice(8, -1);
};var fails$p = fails$r;
var classof$8 = classofRaw$1;

var split = ''.split;

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var indexedObject = fails$p(function () {
  // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
  // eslint-disable-next-line no-prototype-builtins -- safe
  return !Object('z').propertyIsEnumerable(0);
}) ? function (it) {
  return classof$8(it) == 'String' ? split.call(it, '') : Object(it);
} : Object;// `RequireObjectCoercible` abstract operation
// https://tc39.es/ecma262/#sec-requireobjectcoercible
var requireObjectCoercible$a = function (it) {
  if (it == undefined) throw TypeError("Can't call method on " + it);
  return it;
};// toObject with fallback for non-array-like ES3 strings
var IndexedObject$4 = indexedObject;
var requireObjectCoercible$9 = requireObjectCoercible$a;

var toIndexedObject$9 = function (it) {
  return IndexedObject$4(requireObjectCoercible$9(it));
};var isObject$z = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};var isObject$y = isObject$z;

// `ToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-toprimitive
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
var toPrimitive$5 = function (input, PREFERRED_STRING) {
  if (!isObject$y(input)) return input;
  var fn, val;
  if (PREFERRED_STRING && typeof (fn = input.toString) == 'function' && !isObject$y(val = fn.call(input))) return val;
  if (typeof (fn = input.valueOf) == 'function' && !isObject$y(val = fn.call(input))) return val;
  if (!PREFERRED_STRING && typeof (fn = input.toString) == 'function' && !isObject$y(val = fn.call(input))) return val;
  throw TypeError("Can't convert object to primitive value");
};var requireObjectCoercible$8 = requireObjectCoercible$a;

// `ToObject` abstract operation
// https://tc39.es/ecma262/#sec-toobject
var toObject$b = function (argument) {
  return Object(requireObjectCoercible$8(argument));
};var toObject$a = toObject$b;

var hasOwnProperty$e = {}.hasOwnProperty;

var has$i = Object.hasOwn || function hasOwn(it, key) {
  return hasOwnProperty$e.call(toObject$a(it), key);
};var global$q = global$r;
var isObject$x = isObject$z;

var document$5 = global$q.document;
// typeof document.createElement is 'object' in old IE
var EXISTS = isObject$x(document$5) && isObject$x(document$5.createElement);

var documentCreateElement$1 = function (it) {
  return EXISTS ? document$5.createElement(it) : {};
};var DESCRIPTORS$c = descriptors;
var fails$o = fails$r;
var createElement$1 = documentCreateElement$1;

// Thank's IE8 for his funny defineProperty
var ie8DomDefine = !DESCRIPTORS$c && !fails$o(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- requied for testing
  return Object.defineProperty(createElement$1('div'), 'a', {
    get: function () { return 7; }
  }).a != 7;
});var DESCRIPTORS$b = descriptors;
var propertyIsEnumerableModule$2 = objectPropertyIsEnumerable;
var createPropertyDescriptor$4 = createPropertyDescriptor$5;
var toIndexedObject$8 = toIndexedObject$9;
var toPrimitive$4 = toPrimitive$5;
var has$h = has$i;
var IE8_DOM_DEFINE$1 = ie8DomDefine;

// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $getOwnPropertyDescriptor$1 = Object.getOwnPropertyDescriptor;

// `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
objectGetOwnPropertyDescriptor.f = DESCRIPTORS$b ? $getOwnPropertyDescriptor$1 : function getOwnPropertyDescriptor(O, P) {
  O = toIndexedObject$8(O);
  P = toPrimitive$4(P, true);
  if (IE8_DOM_DEFINE$1) try {
    return $getOwnPropertyDescriptor$1(O, P);
  } catch (error) { /* empty */ }
  if (has$h(O, P)) return createPropertyDescriptor$4(!propertyIsEnumerableModule$2.f.call(O, P), O[P]);
};var objectDefineProperty = {};var isObject$w = isObject$z;

var anObject$i = function (it) {
  if (!isObject$w(it)) {
    throw TypeError(String(it) + ' is not an object');
  } return it;
};var DESCRIPTORS$a = descriptors;
var IE8_DOM_DEFINE = ie8DomDefine;
var anObject$h = anObject$i;
var toPrimitive$3 = toPrimitive$5;

// eslint-disable-next-line es/no-object-defineproperty -- safe
var $defineProperty$1 = Object.defineProperty;

// `Object.defineProperty` method
// https://tc39.es/ecma262/#sec-object.defineproperty
objectDefineProperty.f = DESCRIPTORS$a ? $defineProperty$1 : function defineProperty(O, P, Attributes) {
  anObject$h(O);
  P = toPrimitive$3(P, true);
  anObject$h(Attributes);
  if (IE8_DOM_DEFINE) try {
    return $defineProperty$1(O, P, Attributes);
  } catch (error) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};var DESCRIPTORS$9 = descriptors;
var definePropertyModule$6 = objectDefineProperty;
var createPropertyDescriptor$3 = createPropertyDescriptor$5;

var createNonEnumerableProperty$a = DESCRIPTORS$9 ? function (object, key, value) {
  return definePropertyModule$6.f(object, key, createPropertyDescriptor$3(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};var redefine$a = {exports: {}};var global$p = global$r;
var createNonEnumerableProperty$9 = createNonEnumerableProperty$a;

var setGlobal$3 = function (key, value) {
  try {
    createNonEnumerableProperty$9(global$p, key, value);
  } catch (error) {
    global$p[key] = value;
  } return value;
};var global$o = global$r;
var setGlobal$2 = setGlobal$3;

var SHARED = '__core-js_shared__';
var store$3 = global$o[SHARED] || setGlobal$2(SHARED, {});

var sharedStore = store$3;var store$2 = sharedStore;

var functionToString$1 = Function.toString;

// this helper broken in `core-js@3.4.1-3.4.4`, so we can't use `shared` helper
if (typeof store$2.inspectSource != 'function') {
  store$2.inspectSource = function (it) {
    return functionToString$1.call(it);
  };
}

var inspectSource$3 = store$2.inspectSource;var global$n = global$r;
var inspectSource$2 = inspectSource$3;

var WeakMap$4 = global$n.WeakMap;

var nativeWeakMap = typeof WeakMap$4 === 'function' && /native code/.test(inspectSource$2(WeakMap$4));var shared$6 = {exports: {}};var store$1 = sharedStore;

(shared$6.exports = function (key, value) {
  return store$1[key] || (store$1[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: '3.15.2',
  mode: 'global',
  copyright: '© 2021 Denis Pushkarev (zloirock.ru)'
});var id$2 = 0;
var postfix = Math.random();

var uid$4 = function (key) {
  return 'Symbol(' + String(key === undefined ? '' : key) + ')_' + (++id$2 + postfix).toString(36);
};var shared$5 = shared$6.exports;
var uid$3 = uid$4;

var keys$a = shared$5('keys');

var sharedKey$4 = function (key) {
  return keys$a[key] || (keys$a[key] = uid$3(key));
};var hiddenKeys$6 = {};var NATIVE_WEAK_MAP$1 = nativeWeakMap;
var global$m = global$r;
var isObject$v = isObject$z;
var createNonEnumerableProperty$8 = createNonEnumerableProperty$a;
var objectHas = has$i;
var shared$4 = sharedStore;
var sharedKey$3 = sharedKey$4;
var hiddenKeys$5 = hiddenKeys$6;

var OBJECT_ALREADY_INITIALIZED = 'Object already initialized';
var WeakMap$3 = global$m.WeakMap;
var set$2, get$2, has$g;

var enforce = function (it) {
  return has$g(it) ? get$2(it) : set$2(it, {});
};

var getterFor = function (TYPE) {
  return function (it) {
    var state;
    if (!isObject$v(it) || (state = get$2(it)).type !== TYPE) {
      throw TypeError('Incompatible receiver, ' + TYPE + ' required');
    } return state;
  };
};

if (NATIVE_WEAK_MAP$1 || shared$4.state) {
  var store = shared$4.state || (shared$4.state = new WeakMap$3());
  var wmget = store.get;
  var wmhas = store.has;
  var wmset = store.set;
  set$2 = function (it, metadata) {
    if (wmhas.call(store, it)) throw new TypeError(OBJECT_ALREADY_INITIALIZED);
    metadata.facade = it;
    wmset.call(store, it, metadata);
    return metadata;
  };
  get$2 = function (it) {
    return wmget.call(store, it) || {};
  };
  has$g = function (it) {
    return wmhas.call(store, it);
  };
} else {
  var STATE = sharedKey$3('state');
  hiddenKeys$5[STATE] = true;
  set$2 = function (it, metadata) {
    if (objectHas(it, STATE)) throw new TypeError(OBJECT_ALREADY_INITIALIZED);
    metadata.facade = it;
    createNonEnumerableProperty$8(it, STATE, metadata);
    return metadata;
  };
  get$2 = function (it) {
    return objectHas(it, STATE) ? it[STATE] : {};
  };
  has$g = function (it) {
    return objectHas(it, STATE);
  };
}

var internalState = {
  set: set$2,
  get: get$2,
  has: has$g,
  enforce: enforce,
  getterFor: getterFor
};var global$l = global$r;
var createNonEnumerableProperty$7 = createNonEnumerableProperty$a;
var has$f = has$i;
var setGlobal$1 = setGlobal$3;
var inspectSource$1 = inspectSource$3;
var InternalStateModule$6 = internalState;

var getInternalState$5 = InternalStateModule$6.get;
var enforceInternalState = InternalStateModule$6.enforce;
var TEMPLATE = String(String).split('String');

(redefine$a.exports = function (O, key, value, options) {
  var unsafe = options ? !!options.unsafe : false;
  var simple = options ? !!options.enumerable : false;
  var noTargetGet = options ? !!options.noTargetGet : false;
  var state;
  if (typeof value == 'function') {
    if (typeof key == 'string' && !has$f(value, 'name')) {
      createNonEnumerableProperty$7(value, 'name', key);
    }
    state = enforceInternalState(value);
    if (!state.source) {
      state.source = TEMPLATE.join(typeof key == 'string' ? key : '');
    }
  }
  if (O === global$l) {
    if (simple) O[key] = value;
    else setGlobal$1(key, value);
    return;
  } else if (!unsafe) {
    delete O[key];
  } else if (!noTargetGet && O[key]) {
    simple = true;
  }
  if (simple) O[key] = value;
  else createNonEnumerableProperty$7(O, key, value);
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
})(Function.prototype, 'toString', function toString() {
  return typeof this == 'function' && getInternalState$5(this).source || inspectSource$1(this);
});var global$k = global$r;

var path$2 = global$k;var path$1 = path$2;
var global$j = global$r;

var aFunction$6 = function (variable) {
  return typeof variable == 'function' ? variable : undefined;
};

var getBuiltIn$6 = function (namespace, method) {
  return arguments.length < 2 ? aFunction$6(path$1[namespace]) || aFunction$6(global$j[namespace])
    : path$1[namespace] && path$1[namespace][method] || global$j[namespace] && global$j[namespace][method];
};var objectGetOwnPropertyNames = {};var ceil = Math.ceil;
var floor$1 = Math.floor;

// `ToInteger` abstract operation
// https://tc39.es/ecma262/#sec-tointeger
var toInteger$7 = function (argument) {
  return isNaN(argument = +argument) ? 0 : (argument > 0 ? floor$1 : ceil)(argument);
};var toInteger$6 = toInteger$7;

var min$5 = Math.min;

// `ToLength` abstract operation
// https://tc39.es/ecma262/#sec-tolength
var toLength$b = function (argument) {
  return argument > 0 ? min$5(toInteger$6(argument), 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
};var toInteger$5 = toInteger$7;

var max$3 = Math.max;
var min$4 = Math.min;

// Helper for a popular repeating case of the spec:
// Let integer be ? ToInteger(index).
// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
var toAbsoluteIndex$2 = function (index, length) {
  var integer = toInteger$5(index);
  return integer < 0 ? max$3(integer + length, 0) : min$4(integer, length);
};var toIndexedObject$7 = toIndexedObject$9;
var toLength$a = toLength$b;
var toAbsoluteIndex$1 = toAbsoluteIndex$2;

// `Array.prototype.{ indexOf, includes }` methods implementation
var createMethod$5 = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIndexedObject$7($this);
    var length = toLength$a(O.length);
    var index = toAbsoluteIndex$1(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare -- NaN check
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare -- NaN check
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) {
      if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};

var arrayIncludes$5 = {
  // `Array.prototype.includes` method
  // https://tc39.es/ecma262/#sec-array.prototype.includes
  includes: createMethod$5(true),
  // `Array.prototype.indexOf` method
  // https://tc39.es/ecma262/#sec-array.prototype.indexof
  indexOf: createMethod$5(false)
};var has$e = has$i;
var toIndexedObject$6 = toIndexedObject$9;
var indexOf$1 = arrayIncludes$5.indexOf;
var hiddenKeys$4 = hiddenKeys$6;

var objectKeysInternal = function (object, names) {
  var O = toIndexedObject$6(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) !has$e(hiddenKeys$4, key) && has$e(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has$e(O, key = names[i++])) {
    ~indexOf$1(result, key) || result.push(key);
  }
  return result;
};// IE8- don't enum bug keys
var enumBugKeys$3 = [
  'constructor',
  'hasOwnProperty',
  'isPrototypeOf',
  'propertyIsEnumerable',
  'toLocaleString',
  'toString',
  'valueOf'
];var internalObjectKeys$1 = objectKeysInternal;
var enumBugKeys$2 = enumBugKeys$3;

var hiddenKeys$3 = enumBugKeys$2.concat('length', 'prototype');

// `Object.getOwnPropertyNames` method
// https://tc39.es/ecma262/#sec-object.getownpropertynames
// eslint-disable-next-line es/no-object-getownpropertynames -- safe
objectGetOwnPropertyNames.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return internalObjectKeys$1(O, hiddenKeys$3);
};var objectGetOwnPropertySymbols = {};// eslint-disable-next-line es/no-object-getownpropertysymbols -- safe
objectGetOwnPropertySymbols.f = Object.getOwnPropertySymbols;var getBuiltIn$5 = getBuiltIn$6;
var getOwnPropertyNamesModule$1 = objectGetOwnPropertyNames;
var getOwnPropertySymbolsModule$2 = objectGetOwnPropertySymbols;
var anObject$g = anObject$i;

// all object keys, includes non-enumerable and symbols
var ownKeys$6 = getBuiltIn$5('Reflect', 'ownKeys') || function ownKeys(it) {
  var keys = getOwnPropertyNamesModule$1.f(anObject$g(it));
  var getOwnPropertySymbols = getOwnPropertySymbolsModule$2.f;
  return getOwnPropertySymbols ? keys.concat(getOwnPropertySymbols(it)) : keys;
};var has$d = has$i;
var ownKeys$5 = ownKeys$6;
var getOwnPropertyDescriptorModule$1 = objectGetOwnPropertyDescriptor;
var definePropertyModule$5 = objectDefineProperty;

var copyConstructorProperties$2 = function (target, source) {
  var keys = ownKeys$5(source);
  var defineProperty = definePropertyModule$5.f;
  var getOwnPropertyDescriptor = getOwnPropertyDescriptorModule$1.f;
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    if (!has$d(target, key)) defineProperty(target, key, getOwnPropertyDescriptor(source, key));
  }
};var fails$n = fails$r;

var replacement = /#|\.prototype\./;

var isForced$4 = function (feature, detection) {
  var value = data[normalize(feature)];
  return value == POLYFILL ? true
    : value == NATIVE ? false
    : typeof detection == 'function' ? fails$n(detection)
    : !!detection;
};

var normalize = isForced$4.normalize = function (string) {
  return String(string).replace(replacement, '.').toLowerCase();
};

var data = isForced$4.data = {};
var NATIVE = isForced$4.NATIVE = 'N';
var POLYFILL = isForced$4.POLYFILL = 'P';

var isForced_1 = isForced$4;var global$i = global$r;
var getOwnPropertyDescriptor$4 = objectGetOwnPropertyDescriptor.f;
var createNonEnumerableProperty$6 = createNonEnumerableProperty$a;
var redefine$9 = redefine$a.exports;
var setGlobal = setGlobal$3;
var copyConstructorProperties$1 = copyConstructorProperties$2;
var isForced$3 = isForced_1;

/*
  options.target      - name of the target object
  options.global      - target is the global object
  options.stat        - export as static methods of target
  options.proto       - export as prototype methods of target
  options.real        - real prototype method for the `pure` version
  options.forced      - export even if the native feature is available
  options.bind        - bind methods to the target, required for the `pure` version
  options.wrap        - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe      - use the simple assignment of property instead of delete + defineProperty
  options.sham        - add a flag to not completely full polyfills
  options.enumerable  - export as enumerable property
  options.noTargetGet - prevent calling a getter on target
*/
var _export = function (options, source) {
  var TARGET = options.target;
  var GLOBAL = options.global;
  var STATIC = options.stat;
  var FORCED, target, key, targetProperty, sourceProperty, descriptor;
  if (GLOBAL) {
    target = global$i;
  } else if (STATIC) {
    target = global$i[TARGET] || setGlobal(TARGET, {});
  } else {
    target = (global$i[TARGET] || {}).prototype;
  }
  if (target) for (key in source) {
    sourceProperty = source[key];
    if (options.noTargetGet) {
      descriptor = getOwnPropertyDescriptor$4(target, key);
      targetProperty = descriptor && descriptor.value;
    } else targetProperty = target[key];
    FORCED = isForced$3(GLOBAL ? key : TARGET + (STATIC ? '.' : '#') + key, options.forced);
    // contained in target
    if (!FORCED && targetProperty !== undefined) {
      if (typeof sourceProperty === typeof targetProperty) continue;
      copyConstructorProperties$1(sourceProperty, targetProperty);
    }
    // add a flag to not completely full polyfills
    if (options.sham || (targetProperty && targetProperty.sham)) {
      createNonEnumerableProperty$6(sourceProperty, 'sham', true);
    }
    // extend global
    redefine$9(target, key, sourceProperty, options);
  }
};var internalObjectKeys = objectKeysInternal;
var enumBugKeys$1 = enumBugKeys$3;

// `Object.keys` method
// https://tc39.es/ecma262/#sec-object.keys
// eslint-disable-next-line es/no-object-keys -- safe
var objectKeys$4 = Object.keys || function keys(O) {
  return internalObjectKeys(O, enumBugKeys$1);
};var DESCRIPTORS$8 = descriptors;
var fails$m = fails$r;
var objectKeys$3 = objectKeys$4;
var getOwnPropertySymbolsModule$1 = objectGetOwnPropertySymbols;
var propertyIsEnumerableModule$1 = objectPropertyIsEnumerable;
var toObject$9 = toObject$b;
var IndexedObject$3 = indexedObject;

// eslint-disable-next-line es/no-object-assign -- safe
var $assign = Object.assign;
// eslint-disable-next-line es/no-object-defineproperty -- required for testing
var defineProperty$c = Object.defineProperty;

// `Object.assign` method
// https://tc39.es/ecma262/#sec-object.assign
var objectAssign = !$assign || fails$m(function () {
  // should have correct order of operations (Edge bug)
  if (DESCRIPTORS$8 && $assign({ b: 1 }, $assign(defineProperty$c({}, 'a', {
    enumerable: true,
    get: function () {
      defineProperty$c(this, 'b', {
        value: 3,
        enumerable: false
      });
    }
  }), { b: 2 })).b !== 1) return true;
  // should work with symbols and should have deterministic property order (V8 bug)
  var A = {};
  var B = {};
  // eslint-disable-next-line es/no-symbol -- safe
  var symbol = Symbol();
  var alphabet = 'abcdefghijklmnopqrst';
  A[symbol] = 7;
  alphabet.split('').forEach(function (chr) { B[chr] = chr; });
  return $assign({}, A)[symbol] != 7 || objectKeys$3($assign({}, B)).join('') != alphabet;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars -- required for `.length`
  var T = toObject$9(target);
  var argumentsLength = arguments.length;
  var index = 1;
  var getOwnPropertySymbols = getOwnPropertySymbolsModule$1.f;
  var propertyIsEnumerable = propertyIsEnumerableModule$1.f;
  while (argumentsLength > index) {
    var S = IndexedObject$3(arguments[index++]);
    var keys = getOwnPropertySymbols ? objectKeys$3(S).concat(getOwnPropertySymbols(S)) : objectKeys$3(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) {
      key = keys[j++];
      if (!DESCRIPTORS$8 || propertyIsEnumerable.call(S, key)) T[key] = S[key];
    }
  } return T;
} : $assign;var $$p = _export;
var assign$1 = objectAssign;

// `Object.assign` method
// https://tc39.es/ecma262/#sec-object.assign
// eslint-disable-next-line es/no-object-assign -- required for testing
$$p({ target: 'Object', stat: true, forced: Object.assign !== assign$1 }, {
  assign: assign$1
});// iterable DOM collections
// flag - `iterable` interface - 'entries', 'keys', 'values', 'forEach' methods
var domIterables = {
  CSSRuleList: 0,
  CSSStyleDeclaration: 0,
  CSSValueList: 0,
  ClientRectList: 0,
  DOMRectList: 0,
  DOMStringList: 0,
  DOMTokenList: 1,
  DataTransferItemList: 0,
  FileList: 0,
  HTMLAllCollection: 0,
  HTMLCollection: 0,
  HTMLFormElement: 0,
  HTMLSelectElement: 0,
  MediaList: 0,
  MimeTypeArray: 0,
  NamedNodeMap: 0,
  NodeList: 1,
  PaintRequestList: 0,
  Plugin: 0,
  PluginArray: 0,
  SVGLengthList: 0,
  SVGNumberList: 0,
  SVGPathSegList: 0,
  SVGPointList: 0,
  SVGStringList: 0,
  SVGTransformList: 0,
  SourceBufferList: 0,
  StyleSheetList: 0,
  TextTrackCueList: 0,
  TextTrackList: 0,
  TouchList: 0
};var aFunction$5 = function (it) {
  if (typeof it != 'function') {
    throw TypeError(String(it) + ' is not a function');
  } return it;
};var aFunction$4 = aFunction$5;

// optional / simple context binding
var functionBindContext = function (fn, that, length) {
  aFunction$4(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 0: return function () {
      return fn.call(that);
    };
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};var classof$7 = classofRaw$1;

// `IsArray` abstract operation
// https://tc39.es/ecma262/#sec-isarray
// eslint-disable-next-line es/no-array-isarray -- safe
var isArray$r = Array.isArray || function isArray(arg) {
  return classof$7(arg) == 'Array';
};var getBuiltIn$4 = getBuiltIn$6;

var engineUserAgent = getBuiltIn$4('navigator', 'userAgent') || '';var global$h = global$r;
var userAgent$2 = engineUserAgent;

var process$4 = global$h.process;
var versions = process$4 && process$4.versions;
var v8 = versions && versions.v8;
var match$1, version$1;

if (v8) {
  match$1 = v8.split('.');
  version$1 = match$1[0] < 4 ? 1 : match$1[0] + match$1[1];
} else if (userAgent$2) {
  match$1 = userAgent$2.match(/Edge\/(\d+)/);
  if (!match$1 || match$1[1] >= 74) {
    match$1 = userAgent$2.match(/Chrome\/(\d+)/);
    if (match$1) version$1 = match$1[1];
  }
}

var engineV8Version = version$1 && +version$1;/* eslint-disable es/no-symbol -- required for testing */

var V8_VERSION$3 = engineV8Version;
var fails$l = fails$r;

// eslint-disable-next-line es/no-object-getownpropertysymbols -- required for testing
var nativeSymbol = !!Object.getOwnPropertySymbols && !fails$l(function () {
  var symbol = Symbol();
  // Chrome 38 Symbol has incorrect toString conversion
  // `get-own-property-symbols` polyfill symbols converted to object are not Symbol instances
  return !String(symbol) || !(Object(symbol) instanceof Symbol) ||
    // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
    !Symbol.sham && V8_VERSION$3 && V8_VERSION$3 < 41;
});/* eslint-disable es/no-symbol -- required for testing */

var NATIVE_SYMBOL$2 = nativeSymbol;

var useSymbolAsUid = NATIVE_SYMBOL$2
  && !Symbol.sham
  && typeof Symbol.iterator == 'symbol';var global$g = global$r;
var shared$3 = shared$6.exports;
var has$c = has$i;
var uid$2 = uid$4;
var NATIVE_SYMBOL$1 = nativeSymbol;
var USE_SYMBOL_AS_UID$1 = useSymbolAsUid;

var WellKnownSymbolsStore$1 = shared$3('wks');
var Symbol$8 = global$g.Symbol;
var createWellKnownSymbol = USE_SYMBOL_AS_UID$1 ? Symbol$8 : Symbol$8 && Symbol$8.withoutSetter || uid$2;

var wellKnownSymbol$n = function (name) {
  if (!has$c(WellKnownSymbolsStore$1, name) || !(NATIVE_SYMBOL$1 || typeof WellKnownSymbolsStore$1[name] == 'string')) {
    if (NATIVE_SYMBOL$1 && has$c(Symbol$8, name)) {
      WellKnownSymbolsStore$1[name] = Symbol$8[name];
    } else {
      WellKnownSymbolsStore$1[name] = createWellKnownSymbol('Symbol.' + name);
    }
  } return WellKnownSymbolsStore$1[name];
};var isObject$u = isObject$z;
var isArray$q = isArray$r;
var wellKnownSymbol$m = wellKnownSymbol$n;

var SPECIES$6 = wellKnownSymbol$m('species');

// `ArraySpeciesCreate` abstract operation
// https://tc39.es/ecma262/#sec-arrayspeciescreate
var arraySpeciesCreate$2 = function (originalArray, length) {
  var C;
  if (isArray$q(originalArray)) {
    C = originalArray.constructor;
    // cross-realm fallback
    if (typeof C == 'function' && (C === Array || isArray$q(C.prototype))) C = undefined;
    else if (isObject$u(C)) {
      C = C[SPECIES$6];
      if (C === null) C = undefined;
    }
  } return new (C === undefined ? Array : C)(length === 0 ? 0 : length);
};var bind$a = functionBindContext;
var IndexedObject$2 = indexedObject;
var toObject$8 = toObject$b;
var toLength$9 = toLength$b;
var arraySpeciesCreate$1 = arraySpeciesCreate$2;

var push$1 = [].push;

// `Array.prototype.{ forEach, map, filter, some, every, find, findIndex, filterOut }` methods implementation
var createMethod$4 = function (TYPE) {
  var IS_MAP = TYPE == 1;
  var IS_FILTER = TYPE == 2;
  var IS_SOME = TYPE == 3;
  var IS_EVERY = TYPE == 4;
  var IS_FIND_INDEX = TYPE == 6;
  var IS_FILTER_OUT = TYPE == 7;
  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
  return function ($this, callbackfn, that, specificCreate) {
    var O = toObject$8($this);
    var self = IndexedObject$2(O);
    var boundFunction = bind$a(callbackfn, that, 3);
    var length = toLength$9(self.length);
    var index = 0;
    var create = specificCreate || arraySpeciesCreate$1;
    var target = IS_MAP ? create($this, length) : IS_FILTER || IS_FILTER_OUT ? create($this, 0) : undefined;
    var value, result;
    for (;length > index; index++) if (NO_HOLES || index in self) {
      value = self[index];
      result = boundFunction(value, index, O);
      if (TYPE) {
        if (IS_MAP) target[index] = result; // map
        else if (result) switch (TYPE) {
          case 3: return true;              // some
          case 5: return value;             // find
          case 6: return index;             // findIndex
          case 2: push$1.call(target, value); // filter
        } else switch (TYPE) {
          case 4: return false;             // every
          case 7: push$1.call(target, value); // filterOut
        }
      }
    }
    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : target;
  };
};

var arrayIteration = {
  // `Array.prototype.forEach` method
  // https://tc39.es/ecma262/#sec-array.prototype.foreach
  forEach: createMethod$4(0),
  // `Array.prototype.map` method
  // https://tc39.es/ecma262/#sec-array.prototype.map
  map: createMethod$4(1),
  // `Array.prototype.filter` method
  // https://tc39.es/ecma262/#sec-array.prototype.filter
  filter: createMethod$4(2),
  // `Array.prototype.some` method
  // https://tc39.es/ecma262/#sec-array.prototype.some
  some: createMethod$4(3),
  // `Array.prototype.every` method
  // https://tc39.es/ecma262/#sec-array.prototype.every
  every: createMethod$4(4),
  // `Array.prototype.find` method
  // https://tc39.es/ecma262/#sec-array.prototype.find
  find: createMethod$4(5),
  // `Array.prototype.findIndex` method
  // https://tc39.es/ecma262/#sec-array.prototype.findIndex
  findIndex: createMethod$4(6),
  // `Array.prototype.filterOut` method
  // https://github.com/tc39/proposal-array-filtering
  filterOut: createMethod$4(7)
};var fails$k = fails$r;

var arrayMethodIsStrict$3 = function (METHOD_NAME, argument) {
  var method = [][METHOD_NAME];
  return !!method && fails$k(function () {
    // eslint-disable-next-line no-useless-call,no-throw-literal -- required for testing
    method.call(null, argument || function () { throw 1; }, 1);
  });
};var $forEach$1 = arrayIteration.forEach;
var arrayMethodIsStrict$2 = arrayMethodIsStrict$3;

var STRICT_METHOD$2 = arrayMethodIsStrict$2('forEach');

// `Array.prototype.forEach` method implementation
// https://tc39.es/ecma262/#sec-array.prototype.foreach
var arrayForEach = !STRICT_METHOD$2 ? function forEach(callbackfn /* , thisArg */) {
  return $forEach$1(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
// eslint-disable-next-line es/no-array-prototype-foreach -- safe
} : [].forEach;var global$f = global$r;
var DOMIterables$1 = domIterables;
var forEach$2 = arrayForEach;
var createNonEnumerableProperty$5 = createNonEnumerableProperty$a;

for (var COLLECTION_NAME$1 in DOMIterables$1) {
  var Collection$1 = global$f[COLLECTION_NAME$1];
  var CollectionPrototype$1 = Collection$1 && Collection$1.prototype;
  // some Chrome versions have non-configurable methods on DOMTokenList
  if (CollectionPrototype$1 && CollectionPrototype$1.forEach !== forEach$2) try {
    createNonEnumerableProperty$5(CollectionPrototype$1, 'forEach', forEach$2);
  } catch (error) {
    CollectionPrototype$1.forEach = forEach$2;
  }
}var DESCRIPTORS$7 = descriptors;
var objectKeys$2 = objectKeys$4;
var toIndexedObject$5 = toIndexedObject$9;
var propertyIsEnumerable$2 = objectPropertyIsEnumerable.f;

// `Object.{ entries, values }` methods implementation
var createMethod$3 = function (TO_ENTRIES) {
  return function (it) {
    var O = toIndexedObject$5(it);
    var keys = objectKeys$2(O);
    var length = keys.length;
    var i = 0;
    var result = [];
    var key;
    while (length > i) {
      key = keys[i++];
      if (!DESCRIPTORS$7 || propertyIsEnumerable$2.call(O, key)) {
        result.push(TO_ENTRIES ? [key, O[key]] : O[key]);
      }
    }
    return result;
  };
};

var objectToArray = {
  // `Object.entries` method
  // https://tc39.es/ecma262/#sec-object.entries
  entries: createMethod$3(true),
  // `Object.values` method
  // https://tc39.es/ecma262/#sec-object.values
  values: createMethod$3(false)
};var $$o = _export;
var $values = objectToArray.values;

// `Object.values` method
// https://tc39.es/ecma262/#sec-object.values
$$o({ target: 'Object', stat: true }, {
  values: function values(O) {
    return $values(O);
  }
});var global$e = global$r;

var nativePromiseConstructor = global$e.Promise;var redefine$8 = redefine$a.exports;

var redefineAll$4 = function (target, src, options) {
  for (var key in src) redefine$8(target, key, src[key], options);
  return target;
};var isObject$t = isObject$z;

var aPossiblePrototype$1 = function (it) {
  if (!isObject$t(it) && it !== null) {
    throw TypeError("Can't set " + String(it) + ' as a prototype');
  } return it;
};/* eslint-disable no-proto -- safe */

var anObject$f = anObject$i;
var aPossiblePrototype = aPossiblePrototype$1;

// `Object.setPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.setprototypeof
// Works with __proto__ only. Old v8 can't work with null proto objects.
// eslint-disable-next-line es/no-object-setprototypeof -- safe
var objectSetPrototypeOf = Object.setPrototypeOf || ('__proto__' in {} ? function () {
  var CORRECT_SETTER = false;
  var test = {};
  var setter;
  try {
    // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
    setter = Object.getOwnPropertyDescriptor(Object.prototype, '__proto__').set;
    setter.call(test, []);
    CORRECT_SETTER = test instanceof Array;
  } catch (error) { /* empty */ }
  return function setPrototypeOf(O, proto) {
    anObject$f(O);
    aPossiblePrototype(proto);
    if (CORRECT_SETTER) setter.call(O, proto);
    else O.__proto__ = proto;
    return O;
  };
}() : undefined);var defineProperty$b = objectDefineProperty.f;
var has$b = has$i;
var wellKnownSymbol$l = wellKnownSymbol$n;

var TO_STRING_TAG$3 = wellKnownSymbol$l('toStringTag');

var setToStringTag$5 = function (it, TAG, STATIC) {
  if (it && !has$b(it = STATIC ? it : it.prototype, TO_STRING_TAG$3)) {
    defineProperty$b(it, TO_STRING_TAG$3, { configurable: true, value: TAG });
  }
};var getBuiltIn$3 = getBuiltIn$6;
var definePropertyModule$4 = objectDefineProperty;
var wellKnownSymbol$k = wellKnownSymbol$n;
var DESCRIPTORS$6 = descriptors;

var SPECIES$5 = wellKnownSymbol$k('species');

var setSpecies$2 = function (CONSTRUCTOR_NAME) {
  var Constructor = getBuiltIn$3(CONSTRUCTOR_NAME);
  var defineProperty = definePropertyModule$4.f;

  if (DESCRIPTORS$6 && Constructor && !Constructor[SPECIES$5]) {
    defineProperty(Constructor, SPECIES$5, {
      configurable: true,
      get: function () { return this; }
    });
  }
};var anInstance$4 = function (it, Constructor, name) {
  if (!(it instanceof Constructor)) {
    throw TypeError('Incorrect ' + (name ? name + ' ' : '') + 'invocation');
  } return it;
};var iterators = {};var wellKnownSymbol$j = wellKnownSymbol$n;
var Iterators$4 = iterators;

var ITERATOR$5 = wellKnownSymbol$j('iterator');
var ArrayPrototype$1 = Array.prototype;

// check on default Array iterator
var isArrayIteratorMethod$2 = function (it) {
  return it !== undefined && (Iterators$4.Array === it || ArrayPrototype$1[ITERATOR$5] === it);
};var wellKnownSymbol$i = wellKnownSymbol$n;

var TO_STRING_TAG$2 = wellKnownSymbol$i('toStringTag');
var test = {};

test[TO_STRING_TAG$2] = 'z';

var toStringTagSupport = String(test) === '[object z]';var TO_STRING_TAG_SUPPORT$2 = toStringTagSupport;
var classofRaw = classofRaw$1;
var wellKnownSymbol$h = wellKnownSymbol$n;

var TO_STRING_TAG$1 = wellKnownSymbol$h('toStringTag');
// ES3 wrong here
var CORRECT_ARGUMENTS = classofRaw(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (error) { /* empty */ }
};

// getting tag from ES6+ `Object.prototype.toString`
var classof$6 = TO_STRING_TAG_SUPPORT$2 ? classofRaw : function (it) {
  var O, tag, result;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (tag = tryGet(O = Object(it), TO_STRING_TAG$1)) == 'string' ? tag
    // builtinTag case
    : CORRECT_ARGUMENTS ? classofRaw(O)
    // ES3 arguments fallback
    : (result = classofRaw(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : result;
};var classof$5 = classof$6;
var Iterators$3 = iterators;
var wellKnownSymbol$g = wellKnownSymbol$n;

var ITERATOR$4 = wellKnownSymbol$g('iterator');

var getIteratorMethod$2 = function (it) {
  if (it != undefined) return it[ITERATOR$4]
    || it['@@iterator']
    || Iterators$3[classof$5(it)];
};var anObject$e = anObject$i;

var iteratorClose$2 = function (iterator) {
  var returnMethod = iterator['return'];
  if (returnMethod !== undefined) {
    return anObject$e(returnMethod.call(iterator)).value;
  }
};var anObject$d = anObject$i;
var isArrayIteratorMethod$1 = isArrayIteratorMethod$2;
var toLength$8 = toLength$b;
var bind$9 = functionBindContext;
var getIteratorMethod$1 = getIteratorMethod$2;
var iteratorClose$1 = iteratorClose$2;

var Result = function (stopped, result) {
  this.stopped = stopped;
  this.result = result;
};

var iterate$5 = function (iterable, unboundFunction, options) {
  var that = options && options.that;
  var AS_ENTRIES = !!(options && options.AS_ENTRIES);
  var IS_ITERATOR = !!(options && options.IS_ITERATOR);
  var INTERRUPTED = !!(options && options.INTERRUPTED);
  var fn = bind$9(unboundFunction, that, 1 + AS_ENTRIES + INTERRUPTED);
  var iterator, iterFn, index, length, result, next, step;

  var stop = function (condition) {
    if (iterator) iteratorClose$1(iterator);
    return new Result(true, condition);
  };

  var callFn = function (value) {
    if (AS_ENTRIES) {
      anObject$d(value);
      return INTERRUPTED ? fn(value[0], value[1], stop) : fn(value[0], value[1]);
    } return INTERRUPTED ? fn(value, stop) : fn(value);
  };

  if (IS_ITERATOR) {
    iterator = iterable;
  } else {
    iterFn = getIteratorMethod$1(iterable);
    if (typeof iterFn != 'function') throw TypeError('Target is not iterable');
    // optimisation for array iterators
    if (isArrayIteratorMethod$1(iterFn)) {
      for (index = 0, length = toLength$8(iterable.length); length > index; index++) {
        result = callFn(iterable[index]);
        if (result && result instanceof Result) return result;
      } return new Result(false);
    }
    iterator = iterFn.call(iterable);
  }

  next = iterator.next;
  while (!(step = next.call(iterator)).done) {
    try {
      result = callFn(step.value);
    } catch (error) {
      iteratorClose$1(iterator);
      throw error;
    }
    if (typeof result == 'object' && result && result instanceof Result) return result;
  } return new Result(false);
};var wellKnownSymbol$f = wellKnownSymbol$n;

var ITERATOR$3 = wellKnownSymbol$f('iterator');
var SAFE_CLOSING = false;

try {
  var called = 0;
  var iteratorWithReturn = {
    next: function () {
      return { done: !!called++ };
    },
    'return': function () {
      SAFE_CLOSING = true;
    }
  };
  iteratorWithReturn[ITERATOR$3] = function () {
    return this;
  };
  // eslint-disable-next-line es/no-array-from, no-throw-literal -- required for testing
  Array.from(iteratorWithReturn, function () { throw 2; });
} catch (error) { /* empty */ }

var checkCorrectnessOfIteration$3 = function (exec, SKIP_CLOSING) {
  if (!SKIP_CLOSING && !SAFE_CLOSING) return false;
  var ITERATION_SUPPORT = false;
  try {
    var object = {};
    object[ITERATOR$3] = function () {
      return {
        next: function () {
          return { done: ITERATION_SUPPORT = true };
        }
      };
    };
    exec(object);
  } catch (error) { /* empty */ }
  return ITERATION_SUPPORT;
};var anObject$c = anObject$i;
var aFunction$3 = aFunction$5;
var wellKnownSymbol$e = wellKnownSymbol$n;

var SPECIES$4 = wellKnownSymbol$e('species');

// `SpeciesConstructor` abstract operation
// https://tc39.es/ecma262/#sec-speciesconstructor
var speciesConstructor$2 = function (O, defaultConstructor) {
  var C = anObject$c(O).constructor;
  var S;
  return C === undefined || (S = anObject$c(C)[SPECIES$4]) == undefined ? defaultConstructor : aFunction$3(S);
};var getBuiltIn$2 = getBuiltIn$6;

var html$2 = getBuiltIn$2('document', 'documentElement');var userAgent$1 = engineUserAgent;

var engineIsIos = /(?:iphone|ipod|ipad).*applewebkit/i.test(userAgent$1);var classof$4 = classofRaw$1;
var global$d = global$r;

var engineIsNode = classof$4(global$d.process) == 'process';var global$c = global$r;
var fails$j = fails$r;
var bind$8 = functionBindContext;
var html$1 = html$2;
var createElement = documentCreateElement$1;
var IS_IOS$1 = engineIsIos;
var IS_NODE$3 = engineIsNode;

var location = global$c.location;
var set$1 = global$c.setImmediate;
var clear = global$c.clearImmediate;
var process$3 = global$c.process;
var MessageChannel = global$c.MessageChannel;
var Dispatch = global$c.Dispatch;
var counter = 0;
var queue = {};
var ONREADYSTATECHANGE = 'onreadystatechange';
var defer, channel, port;

var run = function (id) {
  // eslint-disable-next-line no-prototype-builtins -- safe
  if (queue.hasOwnProperty(id)) {
    var fn = queue[id];
    delete queue[id];
    fn();
  }
};

var runner = function (id) {
  return function () {
    run(id);
  };
};

var listener = function (event) {
  run(event.data);
};

var post = function (id) {
  // old engines have not location.origin
  global$c.postMessage(id + '', location.protocol + '//' + location.host);
};

// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!set$1 || !clear) {
  set$1 = function setImmediate(fn) {
    var args = [];
    var i = 1;
    while (arguments.length > i) args.push(arguments[i++]);
    queue[++counter] = function () {
      // eslint-disable-next-line no-new-func -- spec requirement
      (typeof fn == 'function' ? fn : Function(fn)).apply(undefined, args);
    };
    defer(counter);
    return counter;
  };
  clear = function clearImmediate(id) {
    delete queue[id];
  };
  // Node.js 0.8-
  if (IS_NODE$3) {
    defer = function (id) {
      process$3.nextTick(runner(id));
    };
  // Sphere (JS game engine) Dispatch API
  } else if (Dispatch && Dispatch.now) {
    defer = function (id) {
      Dispatch.now(runner(id));
    };
  // Browsers with MessageChannel, includes WebWorkers
  // except iOS - https://github.com/zloirock/core-js/issues/624
  } else if (MessageChannel && !IS_IOS$1) {
    channel = new MessageChannel();
    port = channel.port2;
    channel.port1.onmessage = listener;
    defer = bind$8(port.postMessage, port, 1);
  // Browsers with postMessage, skip WebWorkers
  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if (
    global$c.addEventListener &&
    typeof postMessage == 'function' &&
    !global$c.importScripts &&
    location && location.protocol !== 'file:' &&
    !fails$j(post)
  ) {
    defer = post;
    global$c.addEventListener('message', listener, false);
  // IE8-
  } else if (ONREADYSTATECHANGE in createElement('script')) {
    defer = function (id) {
      html$1.appendChild(createElement('script'))[ONREADYSTATECHANGE] = function () {
        html$1.removeChild(this);
        run(id);
      };
    };
  // Rest old browsers
  } else {
    defer = function (id) {
      setTimeout(runner(id), 0);
    };
  }
}

var task$2 = {
  set: set$1,
  clear: clear
};var userAgent = engineUserAgent;

var engineIsWebosWebkit = /web0s(?!.*chrome)/i.test(userAgent);var global$b = global$r;
var getOwnPropertyDescriptor$3 = objectGetOwnPropertyDescriptor.f;
var macrotask = task$2.set;
var IS_IOS = engineIsIos;
var IS_WEBOS_WEBKIT = engineIsWebosWebkit;
var IS_NODE$2 = engineIsNode;

var MutationObserver$1 = global$b.MutationObserver || global$b.WebKitMutationObserver;
var document$4 = global$b.document;
var process$2 = global$b.process;
var Promise$3 = global$b.Promise;
// Node.js 11 shows ExperimentalWarning on getting `queueMicrotask`
var queueMicrotaskDescriptor = getOwnPropertyDescriptor$3(global$b, 'queueMicrotask');
var queueMicrotask = queueMicrotaskDescriptor && queueMicrotaskDescriptor.value;

var flush, head$1, last$2, notify$1, toggle, node, promise, then;

// modern engines have queueMicrotask method
if (!queueMicrotask) {
  flush = function () {
    var parent, fn;
    if (IS_NODE$2 && (parent = process$2.domain)) parent.exit();
    while (head$1) {
      fn = head$1.fn;
      head$1 = head$1.next;
      try {
        fn();
      } catch (error) {
        if (head$1) notify$1();
        else last$2 = undefined;
        throw error;
      }
    } last$2 = undefined;
    if (parent) parent.enter();
  };

  // browsers with MutationObserver, except iOS - https://github.com/zloirock/core-js/issues/339
  // also except WebOS Webkit https://github.com/zloirock/core-js/issues/898
  if (!IS_IOS && !IS_NODE$2 && !IS_WEBOS_WEBKIT && MutationObserver$1 && document$4) {
    toggle = true;
    node = document$4.createTextNode('');
    new MutationObserver$1(flush).observe(node, { characterData: true });
    notify$1 = function () {
      node.data = toggle = !toggle;
    };
  // environments with maybe non-completely correct, but existent Promise
  } else if (Promise$3 && Promise$3.resolve) {
    // Promise.resolve without an argument throws an error in LG WebOS 2
    promise = Promise$3.resolve(undefined);
    // workaround of WebKit ~ iOS Safari 10.1 bug
    promise.constructor = Promise$3;
    then = promise.then;
    notify$1 = function () {
      then.call(promise, flush);
    };
  // Node.js without promises
  } else if (IS_NODE$2) {
    notify$1 = function () {
      process$2.nextTick(flush);
    };
  // for other environments - macrotask based on:
  // - setImmediate
  // - MessageChannel
  // - window.postMessag
  // - onreadystatechange
  // - setTimeout
  } else {
    notify$1 = function () {
      // strange IE + webpack dev server bug - use .call(global)
      macrotask.call(global$b, flush);
    };
  }
}

var microtask$1 = queueMicrotask || function (fn) {
  var task = { fn: fn, next: undefined };
  if (last$2) last$2.next = task;
  if (!head$1) {
    head$1 = task;
    notify$1();
  } last$2 = task;
};var newPromiseCapability$2 = {};var aFunction$2 = aFunction$5;

var PromiseCapability = function (C) {
  var resolve, reject;
  this.promise = new C(function ($$resolve, $$reject) {
    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
    resolve = $$resolve;
    reject = $$reject;
  });
  this.resolve = aFunction$2(resolve);
  this.reject = aFunction$2(reject);
};

// `NewPromiseCapability` abstract operation
// https://tc39.es/ecma262/#sec-newpromisecapability
newPromiseCapability$2.f = function (C) {
  return new PromiseCapability(C);
};var anObject$b = anObject$i;
var isObject$s = isObject$z;
var newPromiseCapability$1 = newPromiseCapability$2;

var promiseResolve$1 = function (C, x) {
  anObject$b(C);
  if (isObject$s(x) && x.constructor === C) return x;
  var promiseCapability = newPromiseCapability$1.f(C);
  var resolve = promiseCapability.resolve;
  resolve(x);
  return promiseCapability.promise;
};var global$a = global$r;

var hostReportErrors$1 = function (a, b) {
  var console = global$a.console;
  if (console && console.error) {
    arguments.length === 1 ? console.error(a) : console.error(a, b);
  }
};var perform$1 = function (exec) {
  try {
    return { error: false, value: exec() };
  } catch (error) {
    return { error: true, value: error };
  }
};var engineIsBrowser = typeof window == 'object';var $$n = _export;
var global$9 = global$r;
var getBuiltIn$1 = getBuiltIn$6;
var NativePromise = nativePromiseConstructor;
var redefine$7 = redefine$a.exports;
var redefineAll$3 = redefineAll$4;
var setPrototypeOf$2 = objectSetPrototypeOf;
var setToStringTag$4 = setToStringTag$5;
var setSpecies$1 = setSpecies$2;
var isObject$r = isObject$z;
var aFunction$1 = aFunction$5;
var anInstance$3 = anInstance$4;
var inspectSource = inspectSource$3;
var iterate$4 = iterate$5;
var checkCorrectnessOfIteration$2 = checkCorrectnessOfIteration$3;
var speciesConstructor$1 = speciesConstructor$2;
var task$1 = task$2.set;
var microtask = microtask$1;
var promiseResolve = promiseResolve$1;
var hostReportErrors = hostReportErrors$1;
var newPromiseCapabilityModule = newPromiseCapability$2;
var perform = perform$1;
var InternalStateModule$5 = internalState;
var isForced$2 = isForced_1;
var wellKnownSymbol$d = wellKnownSymbol$n;
var IS_BROWSER = engineIsBrowser;
var IS_NODE$1 = engineIsNode;
var V8_VERSION$2 = engineV8Version;

var SPECIES$3 = wellKnownSymbol$d('species');
var PROMISE = 'Promise';
var getInternalState$4 = InternalStateModule$5.get;
var setInternalState$5 = InternalStateModule$5.set;
var getInternalPromiseState = InternalStateModule$5.getterFor(PROMISE);
var NativePromisePrototype = NativePromise && NativePromise.prototype;
var PromiseConstructor = NativePromise;
var PromiseConstructorPrototype = NativePromisePrototype;
var TypeError$1 = global$9.TypeError;
var document$3 = global$9.document;
var process$1 = global$9.process;
var newPromiseCapability = newPromiseCapabilityModule.f;
var newGenericPromiseCapability = newPromiseCapability;
var DISPATCH_EVENT = !!(document$3 && document$3.createEvent && global$9.dispatchEvent);
var NATIVE_REJECTION_EVENT = typeof PromiseRejectionEvent == 'function';
var UNHANDLED_REJECTION = 'unhandledrejection';
var REJECTION_HANDLED = 'rejectionhandled';
var PENDING = 0;
var FULFILLED = 1;
var REJECTED = 2;
var HANDLED = 1;
var UNHANDLED = 2;
var SUBCLASSING = false;
var Internal, OwnPromiseCapability, PromiseWrapper, nativeThen;

var FORCED$2 = isForced$2(PROMISE, function () {
  var PROMISE_CONSTRUCTOR_SOURCE = inspectSource(PromiseConstructor);
  var GLOBAL_CORE_JS_PROMISE = PROMISE_CONSTRUCTOR_SOURCE !== String(PromiseConstructor);
  // V8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
  // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
  // We can't detect it synchronously, so just check versions
  if (!GLOBAL_CORE_JS_PROMISE && V8_VERSION$2 === 66) return true;
  // We can't use @@species feature detection in V8 since it causes
  // deoptimization and performance degradation
  // https://github.com/zloirock/core-js/issues/679
  if (V8_VERSION$2 >= 51 && /native code/.test(PROMISE_CONSTRUCTOR_SOURCE)) return false;
  // Detect correctness of subclassing with @@species support
  var promise = new PromiseConstructor(function (resolve) { resolve(1); });
  var FakePromise = function (exec) {
    exec(function () { /* empty */ }, function () { /* empty */ });
  };
  var constructor = promise.constructor = {};
  constructor[SPECIES$3] = FakePromise;
  SUBCLASSING = promise.then(function () { /* empty */ }) instanceof FakePromise;
  if (!SUBCLASSING) return true;
  // Unhandled rejections tracking support, NodeJS Promise without it fails @@species test
  return !GLOBAL_CORE_JS_PROMISE && IS_BROWSER && !NATIVE_REJECTION_EVENT;
});

var INCORRECT_ITERATION$1 = FORCED$2 || !checkCorrectnessOfIteration$2(function (iterable) {
  PromiseConstructor.all(iterable)['catch'](function () { /* empty */ });
});

// helpers
var isThenable = function (it) {
  var then;
  return isObject$r(it) && typeof (then = it.then) == 'function' ? then : false;
};

var notify = function (state, isReject) {
  if (state.notified) return;
  state.notified = true;
  var chain = state.reactions;
  microtask(function () {
    var value = state.value;
    var ok = state.state == FULFILLED;
    var index = 0;
    // variable length - can't use forEach
    while (chain.length > index) {
      var reaction = chain[index++];
      var handler = ok ? reaction.ok : reaction.fail;
      var resolve = reaction.resolve;
      var reject = reaction.reject;
      var domain = reaction.domain;
      var result, then, exited;
      try {
        if (handler) {
          if (!ok) {
            if (state.rejection === UNHANDLED) onHandleUnhandled(state);
            state.rejection = HANDLED;
          }
          if (handler === true) result = value;
          else {
            if (domain) domain.enter();
            result = handler(value); // can throw
            if (domain) {
              domain.exit();
              exited = true;
            }
          }
          if (result === reaction.promise) {
            reject(TypeError$1('Promise-chain cycle'));
          } else if (then = isThenable(result)) {
            then.call(result, resolve, reject);
          } else resolve(result);
        } else reject(value);
      } catch (error) {
        if (domain && !exited) domain.exit();
        reject(error);
      }
    }
    state.reactions = [];
    state.notified = false;
    if (isReject && !state.rejection) onUnhandled(state);
  });
};

var dispatchEvent = function (name, promise, reason) {
  var event, handler;
  if (DISPATCH_EVENT) {
    event = document$3.createEvent('Event');
    event.promise = promise;
    event.reason = reason;
    event.initEvent(name, false, true);
    global$9.dispatchEvent(event);
  } else event = { promise: promise, reason: reason };
  if (!NATIVE_REJECTION_EVENT && (handler = global$9['on' + name])) handler(event);
  else if (name === UNHANDLED_REJECTION) hostReportErrors('Unhandled promise rejection', reason);
};

var onUnhandled = function (state) {
  task$1.call(global$9, function () {
    var promise = state.facade;
    var value = state.value;
    var IS_UNHANDLED = isUnhandled(state);
    var result;
    if (IS_UNHANDLED) {
      result = perform(function () {
        if (IS_NODE$1) {
          process$1.emit('unhandledRejection', value, promise);
        } else dispatchEvent(UNHANDLED_REJECTION, promise, value);
      });
      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
      state.rejection = IS_NODE$1 || isUnhandled(state) ? UNHANDLED : HANDLED;
      if (result.error) throw result.value;
    }
  });
};

var isUnhandled = function (state) {
  return state.rejection !== HANDLED && !state.parent;
};

var onHandleUnhandled = function (state) {
  task$1.call(global$9, function () {
    var promise = state.facade;
    if (IS_NODE$1) {
      process$1.emit('rejectionHandled', promise);
    } else dispatchEvent(REJECTION_HANDLED, promise, state.value);
  });
};

var bind$7 = function (fn, state, unwrap) {
  return function (value) {
    fn(state, value, unwrap);
  };
};

var internalReject = function (state, value, unwrap) {
  if (state.done) return;
  state.done = true;
  if (unwrap) state = unwrap;
  state.value = value;
  state.state = REJECTED;
  notify(state, true);
};

var internalResolve = function (state, value, unwrap) {
  if (state.done) return;
  state.done = true;
  if (unwrap) state = unwrap;
  try {
    if (state.facade === value) throw TypeError$1("Promise can't be resolved itself");
    var then = isThenable(value);
    if (then) {
      microtask(function () {
        var wrapper = { done: false };
        try {
          then.call(value,
            bind$7(internalResolve, wrapper, state),
            bind$7(internalReject, wrapper, state)
          );
        } catch (error) {
          internalReject(wrapper, error, state);
        }
      });
    } else {
      state.value = value;
      state.state = FULFILLED;
      notify(state, false);
    }
  } catch (error) {
    internalReject({ done: false }, error, state);
  }
};

// constructor polyfill
if (FORCED$2) {
  // 25.4.3.1 Promise(executor)
  PromiseConstructor = function Promise(executor) {
    anInstance$3(this, PromiseConstructor, PROMISE);
    aFunction$1(executor);
    Internal.call(this);
    var state = getInternalState$4(this);
    try {
      executor(bind$7(internalResolve, state), bind$7(internalReject, state));
    } catch (error) {
      internalReject(state, error);
    }
  };
  PromiseConstructorPrototype = PromiseConstructor.prototype;
  // eslint-disable-next-line no-unused-vars -- required for `.length`
  Internal = function Promise(executor) {
    setInternalState$5(this, {
      type: PROMISE,
      done: false,
      notified: false,
      parent: false,
      reactions: [],
      rejection: false,
      state: PENDING,
      value: undefined
    });
  };
  Internal.prototype = redefineAll$3(PromiseConstructorPrototype, {
    // `Promise.prototype.then` method
    // https://tc39.es/ecma262/#sec-promise.prototype.then
    then: function then(onFulfilled, onRejected) {
      var state = getInternalPromiseState(this);
      var reaction = newPromiseCapability(speciesConstructor$1(this, PromiseConstructor));
      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
      reaction.fail = typeof onRejected == 'function' && onRejected;
      reaction.domain = IS_NODE$1 ? process$1.domain : undefined;
      state.parent = true;
      state.reactions.push(reaction);
      if (state.state != PENDING) notify(state, false);
      return reaction.promise;
    },
    // `Promise.prototype.catch` method
    // https://tc39.es/ecma262/#sec-promise.prototype.catch
    'catch': function (onRejected) {
      return this.then(undefined, onRejected);
    }
  });
  OwnPromiseCapability = function () {
    var promise = new Internal();
    var state = getInternalState$4(promise);
    this.promise = promise;
    this.resolve = bind$7(internalResolve, state);
    this.reject = bind$7(internalReject, state);
  };
  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
    return C === PromiseConstructor || C === PromiseWrapper
      ? new OwnPromiseCapability(C)
      : newGenericPromiseCapability(C);
  };

  if (typeof NativePromise == 'function' && NativePromisePrototype !== Object.prototype) {
    nativeThen = NativePromisePrototype.then;

    if (!SUBCLASSING) {
      // make `Promise#then` return a polyfilled `Promise` for native promise-based APIs
      redefine$7(NativePromisePrototype, 'then', function then(onFulfilled, onRejected) {
        var that = this;
        return new PromiseConstructor(function (resolve, reject) {
          nativeThen.call(that, resolve, reject);
        }).then(onFulfilled, onRejected);
      // https://github.com/zloirock/core-js/issues/640
      }, { unsafe: true });

      // makes sure that native promise-based APIs `Promise#catch` properly works with patched `Promise#then`
      redefine$7(NativePromisePrototype, 'catch', PromiseConstructorPrototype['catch'], { unsafe: true });
    }

    // make `.constructor === Promise` work for native promise-based APIs
    try {
      delete NativePromisePrototype.constructor;
    } catch (error) { /* empty */ }

    // make `instanceof Promise` work for native promise-based APIs
    if (setPrototypeOf$2) {
      setPrototypeOf$2(NativePromisePrototype, PromiseConstructorPrototype);
    }
  }
}

$$n({ global: true, wrap: true, forced: FORCED$2 }, {
  Promise: PromiseConstructor
});

setToStringTag$4(PromiseConstructor, PROMISE, false);
setSpecies$1(PROMISE);

PromiseWrapper = getBuiltIn$1(PROMISE);

// statics
$$n({ target: PROMISE, stat: true, forced: FORCED$2 }, {
  // `Promise.reject` method
  // https://tc39.es/ecma262/#sec-promise.reject
  reject: function reject(r) {
    var capability = newPromiseCapability(this);
    capability.reject.call(undefined, r);
    return capability.promise;
  }
});

$$n({ target: PROMISE, stat: true, forced: FORCED$2 }, {
  // `Promise.resolve` method
  // https://tc39.es/ecma262/#sec-promise.resolve
  resolve: function resolve(x) {
    return promiseResolve(this, x);
  }
});

$$n({ target: PROMISE, stat: true, forced: INCORRECT_ITERATION$1 }, {
  // `Promise.all` method
  // https://tc39.es/ecma262/#sec-promise.all
  all: function all(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform(function () {
      var $promiseResolve = aFunction$1(C.resolve);
      var values = [];
      var counter = 0;
      var remaining = 1;
      iterate$4(iterable, function (promise) {
        var index = counter++;
        var alreadyCalled = false;
        values.push(undefined);
        remaining++;
        $promiseResolve.call(C, promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[index] = value;
          --remaining || resolve(values);
        }, reject);
      });
      --remaining || resolve(values);
    });
    if (result.error) reject(result.value);
    return capability.promise;
  },
  // `Promise.race` method
  // https://tc39.es/ecma262/#sec-promise.race
  race: function race(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var reject = capability.reject;
    var result = perform(function () {
      var $promiseResolve = aFunction$1(C.resolve);
      iterate$4(iterable, function (promise) {
        $promiseResolve.call(C, promise).then(capability.resolve, reject);
      });
    });
    if (result.error) reject(result.value);
    return capability.promise;
  }
});var TO_STRING_TAG_SUPPORT$1 = toStringTagSupport;
var classof$3 = classof$6;

// `Object.prototype.toString` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.tostring
var objectToString$4 = TO_STRING_TAG_SUPPORT$1 ? {}.toString : function toString() {
  return '[object ' + classof$3(this) + ']';
};var TO_STRING_TAG_SUPPORT = toStringTagSupport;
var redefine$6 = redefine$a.exports;
var toString$7 = objectToString$4;

// `Object.prototype.toString` method
// https://tc39.es/ecma262/#sec-object.prototype.tostring
if (!TO_STRING_TAG_SUPPORT) {
  redefine$6(Object.prototype, 'toString', toString$7, { unsafe: true });
}var win;

if (typeof window !== "undefined") {
    win = window;
} else if (typeof commonjsGlobal !== "undefined") {
    win = commonjsGlobal;
} else if (typeof self !== "undefined"){
    win = self;
} else {
    win = {};
}

var window_1 = win;var fails$i = fails$r;

var freezing = !fails$i(function () {
  // eslint-disable-next-line es/no-object-isextensible, es/no-object-preventextensions -- required for testing
  return Object.isExtensible(Object.preventExtensions({}));
});var internalMetadata = {exports: {}};var hiddenKeys$2 = hiddenKeys$6;
var isObject$q = isObject$z;
var has$a = has$i;
var defineProperty$a = objectDefineProperty.f;
var uid$1 = uid$4;
var FREEZING$1 = freezing;

var METADATA = uid$1('meta');
var id$1 = 0;

// eslint-disable-next-line es/no-object-isextensible -- safe
var isExtensible$1 = Object.isExtensible || function () {
  return true;
};

var setMetadata = function (it) {
  defineProperty$a(it, METADATA, { value: {
    objectID: 'O' + id$1++, // object ID
    weakData: {}          // weak collections IDs
  } });
};

var fastKey$1 = function (it, create) {
  // return a primitive with prefix
  if (!isObject$q(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has$a(it, METADATA)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible$1(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMetadata(it);
  // return object ID
  } return it[METADATA].objectID;
};

var getWeakData$1 = function (it, create) {
  if (!has$a(it, METADATA)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible$1(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMetadata(it);
  // return the store of weak collections IDs
  } return it[METADATA].weakData;
};

// add metadata on freeze-family methods calling
var onFreeze$1 = function (it) {
  if (FREEZING$1 && meta.REQUIRED && isExtensible$1(it) && !has$a(it, METADATA)) setMetadata(it);
  return it;
};

var meta = internalMetadata.exports = {
  REQUIRED: false,
  fastKey: fastKey$1,
  getWeakData: getWeakData$1,
  onFreeze: onFreeze$1
};

hiddenKeys$2[METADATA] = true;var $$m = _export;
var FREEZING = freezing;
var fails$h = fails$r;
var isObject$p = isObject$z;
var onFreeze = internalMetadata.exports.onFreeze;

// eslint-disable-next-line es/no-object-freeze -- safe
var $freeze = Object.freeze;
var FAILS_ON_PRIMITIVES$2 = fails$h(function () { $freeze(1); });

// `Object.freeze` method
// https://tc39.es/ecma262/#sec-object.freeze
$$m({ target: 'Object', stat: true, forced: FAILS_ON_PRIMITIVES$2, sham: !FREEZING }, {
  freeze: function freeze(it) {
    return $freeze && isObject$p(it) ? $freeze(onFreeze(it)) : it;
  }
});var toPrimitive$2 = toPrimitive$5;
var definePropertyModule$3 = objectDefineProperty;
var createPropertyDescriptor$2 = createPropertyDescriptor$5;

var createProperty$3 = function (object, key, value) {
  var propertyKey = toPrimitive$2(key);
  if (propertyKey in object) definePropertyModule$3.f(object, propertyKey, createPropertyDescriptor$2(0, value));
  else object[propertyKey] = value;
};var fails$g = fails$r;
var wellKnownSymbol$c = wellKnownSymbol$n;
var V8_VERSION$1 = engineV8Version;

var SPECIES$2 = wellKnownSymbol$c('species');

var arrayMethodHasSpeciesSupport$4 = function (METHOD_NAME) {
  // We can't use this feature detection in V8 since it causes
  // deoptimization and serious performance degradation
  // https://github.com/zloirock/core-js/issues/677
  return V8_VERSION$1 >= 51 || !fails$g(function () {
    var array = [];
    var constructor = array.constructor = {};
    constructor[SPECIES$2] = function () {
      return { foo: 1 };
    };
    return array[METHOD_NAME](Boolean).foo !== 1;
  });
};var $$l = _export;
var isObject$o = isObject$z;
var isArray$p = isArray$r;
var toAbsoluteIndex = toAbsoluteIndex$2;
var toLength$7 = toLength$b;
var toIndexedObject$4 = toIndexedObject$9;
var createProperty$2 = createProperty$3;
var wellKnownSymbol$b = wellKnownSymbol$n;
var arrayMethodHasSpeciesSupport$3 = arrayMethodHasSpeciesSupport$4;

var HAS_SPECIES_SUPPORT$2 = arrayMethodHasSpeciesSupport$3('slice');

var SPECIES$1 = wellKnownSymbol$b('species');
var nativeSlice = [].slice;
var max$2 = Math.max;

// `Array.prototype.slice` method
// https://tc39.es/ecma262/#sec-array.prototype.slice
// fallback for not array-like ES3 strings and DOM objects
$$l({ target: 'Array', proto: true, forced: !HAS_SPECIES_SUPPORT$2 }, {
  slice: function slice(start, end) {
    var O = toIndexedObject$4(this);
    var length = toLength$7(O.length);
    var k = toAbsoluteIndex(start, length);
    var fin = toAbsoluteIndex(end === undefined ? length : end, length);
    // inline `ArraySpeciesCreate` for usage native `Array#slice` where it's possible
    var Constructor, result, n;
    if (isArray$p(O)) {
      Constructor = O.constructor;
      // cross-realm fallback
      if (typeof Constructor == 'function' && (Constructor === Array || isArray$p(Constructor.prototype))) {
        Constructor = undefined;
      } else if (isObject$o(Constructor)) {
        Constructor = Constructor[SPECIES$1];
        if (Constructor === null) Constructor = undefined;
      }
      if (Constructor === Array || Constructor === undefined) {
        return nativeSlice.call(O, k, fin);
      }
    }
    result = new (Constructor === undefined ? Array : Constructor)(max$2(fin - k, 0));
    for (n = 0; k < fin; k++, n++) if (k in O) createProperty$2(result, n, O[k]);
    result.length = n;
    return result;
  }
});var anObject$a = anObject$i;

// `RegExp.prototype.flags` getter implementation
// https://tc39.es/ecma262/#sec-get-regexp.prototype.flags
var regexpFlags$1 = function () {
  var that = anObject$a(this);
  var result = '';
  if (that.global) result += 'g';
  if (that.ignoreCase) result += 'i';
  if (that.multiline) result += 'm';
  if (that.dotAll) result += 's';
  if (that.unicode) result += 'u';
  if (that.sticky) result += 'y';
  return result;
};var redefine$5 = redefine$a.exports;
var anObject$9 = anObject$i;
var fails$f = fails$r;
var flags = regexpFlags$1;

var TO_STRING = 'toString';
var RegExpPrototype$1 = RegExp.prototype;
var nativeToString = RegExpPrototype$1[TO_STRING];

var NOT_GENERIC = fails$f(function () { return nativeToString.call({ source: 'a', flags: 'b' }) != '/a/b'; });
// FF44- RegExp#toString has a wrong name
var INCORRECT_NAME = nativeToString.name != TO_STRING;

// `RegExp.prototype.toString` method
// https://tc39.es/ecma262/#sec-regexp.prototype.tostring
if (NOT_GENERIC || INCORRECT_NAME) {
  redefine$5(RegExp.prototype, TO_STRING, function toString() {
    var R = anObject$9(this);
    var p = String(R.source);
    var rf = R.flags;
    var f = String(rf === undefined && R instanceof RegExp && !('flags' in RegExpPrototype$1) ? flags.call(R) : rf);
    return '/' + p + '/' + f;
  }, { unsafe: true });
}var $$k = _export;
var global$8 = global$r;
var task = task$2;

var FORCED$1 = !global$8.setImmediate || !global$8.clearImmediate;

// http://w3c.github.io/setImmediate/
$$k({ global: true, bind: true, enumerable: true, forced: FORCED$1 }, {
  // `setImmediate` method
  // http://w3c.github.io/setImmediate/#si-setImmediate
  setImmediate: task.set,
  // `clearImmediate` method
  // http://w3c.github.io/setImmediate/#si-clearImmediate
  clearImmediate: task.clear
});var $$j = _export;
var toObject$7 = toObject$b;
var nativeKeys$2 = objectKeys$4;
var fails$e = fails$r;

var FAILS_ON_PRIMITIVES$1 = fails$e(function () { nativeKeys$2(1); });

// `Object.keys` method
// https://tc39.es/ecma262/#sec-object.keys
$$j({ target: 'Object', stat: true, forced: FAILS_ON_PRIMITIVES$1 }, {
  keys: function keys(it) {
    return nativeKeys$2(toObject$7(it));
  }
});var $$i = _export;
var $filter = arrayIteration.filter;
var arrayMethodHasSpeciesSupport$2 = arrayMethodHasSpeciesSupport$4;

var HAS_SPECIES_SUPPORT$1 = arrayMethodHasSpeciesSupport$2('filter');

// `Array.prototype.filter` method
// https://tc39.es/ecma262/#sec-array.prototype.filter
// with adding support of @@species
$$i({ target: 'Array', proto: true, forced: !HAS_SPECIES_SUPPORT$1 }, {
  filter: function filter(callbackfn /* , thisArg */) {
    return $filter(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});/**
 * Module exports.
 */

var browser$1 = deprecate;

/**
 * Mark that a method should not be used.
 * Returns a modified function which warns once by default.
 *
 * If `localStorage.noDeprecation = true` is set, then it is a no-op.
 *
 * If `localStorage.throwDeprecation = true` is set, then deprecated functions
 * will throw an Error when invoked.
 *
 * If `localStorage.traceDeprecation = true` is set, then deprecated functions
 * will invoke `console.trace()` instead of `console.error()`.
 *
 * @param {Function} fn - the function to deprecate
 * @param {String} msg - the string to print to the console when `fn` is invoked
 * @returns {Function} a new "deprecated" version of `fn`
 * @api public
 */

function deprecate (fn, msg) {
  if (config$1('noDeprecation')) {
    return fn;
  }

  var warned = false;
  function deprecated() {
    if (!warned) {
      if (config$1('throwDeprecation')) {
        throw new Error(msg);
      } else if (config$1('traceDeprecation')) {
        console.trace(msg);
      } else {
        console.warn(msg);
      }
      warned = true;
    }
    return fn.apply(this, arguments);
  }

  return deprecated;
}

/**
 * Checks `localStorage` for boolean values for the given `name`.
 *
 * @param {String} name
 * @returns {Boolean}
 * @api private
 */

function config$1 (name) {
  // accessing global.localStorage can trigger a DOMException in sandboxed iframes
  try {
    if (!commonjsGlobal.localStorage) return false;
  } catch (_) {
    return false;
  }
  var val = commonjsGlobal.localStorage[name];
  if (null == val) return false;
  return String(val).toLowerCase() === 'true';
}var dist$1 = {};Object.defineProperty(dist$1, "__esModule", { value: true });
dist$1.dedent = void 0;
function dedent(templ) {
    var values = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        values[_i - 1] = arguments[_i];
    }
    var strings = Array.from(typeof templ === 'string' ? [templ] : templ);
    strings[strings.length - 1] = strings[strings.length - 1].replace(/\r?\n([\t ]*)$/, '');
    var indentLengths = strings.reduce(function (arr, str) {
        var matches = str.match(/\n([\t ]+|(?!\s).)/g);
        if (matches) {
            return arr.concat(matches.map(function (match) { var _a, _b; return (_b = (_a = match.match(/[\t ]/g)) === null || _a === void 0 ? void 0 : _a.length) !== null && _b !== void 0 ? _b : 0; }));
        }
        return arr;
    }, []);
    if (indentLengths.length) {
        var pattern_1 = new RegExp("\n[\t ]{" + Math.min.apply(Math, indentLengths) + "}", 'g');
        strings = strings.map(function (str) { return str.replace(pattern_1, '\n'); });
    }
    strings[0] = strings[0].replace(/^\r?\n/, '');
    var string = strings[0];
    values.forEach(function (value, i) {
        string += value + strings[i + 1];
    });
    return string;
}
dist$1.dedent = dedent;
var _default$4 = dist$1.default = dedent;var _templateObject$X;

function _taggedTemplateLiteral$4(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

function _classCallCheck$j(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties$4(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass$f(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$4(Constructor.prototype, protoProps); if (staticProps) _defineProperties$4(Constructor, staticProps); return Constructor; }

var generateRandomId = function generateRandomId() {
  // generates a random 13 character string
  return Math.random().toString(16).slice(2);
};

var Channel = /*#__PURE__*/function () {
  function Channel() {
    var _this = this;

    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        transport = _ref.transport,
        _ref$async = _ref.async,
        async = _ref$async === void 0 ? false : _ref$async;

    _classCallCheck$j(this, Channel);

    this.isAsync = void 0;
    this.sender = generateRandomId();
    this.events = {};
    this.data = {};
    this.transport = void 0;
    this.addPeerListener = browser$1(function (eventName, listener) {
      _this.addListener(eventName, listener);
    }, _default$4(_templateObject$X || (_templateObject$X = _taggedTemplateLiteral$4(["\n      channel.addPeerListener is deprecated\n    "]))));
    this.isAsync = async;

    if (transport) {
      this.transport = transport;
      this.transport.setHandler(function (event) {
        return _this.handleEvent(event);
      });
    }
  }

  _createClass$f(Channel, [{
    key: "hasTransport",
    get: function get() {
      return !!this.transport;
    }
  }, {
    key: "addListener",
    value: function addListener(eventName, listener) {
      this.events[eventName] = this.events[eventName] || [];
      this.events[eventName].push(listener);
    }
  }, {
    key: "emit",
    value: function emit(eventName) {
      var _this2 = this;

      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      var event = {
        type: eventName,
        args: args,
        from: this.sender
      };
      var options = {};

      if (args.length >= 1 && args[0] && args[0].options) {
        options = args[0].options;
      }

      var handler = function handler() {
        if (_this2.transport) {
          _this2.transport.send(event, options);
        }

        _this2.handleEvent(event);
      };

      if (this.isAsync) {
        // todo I'm not sure how to test this
        setImmediate(handler);
      } else {
        handler();
      }
    }
  }, {
    key: "last",
    value: function last(eventName) {
      return this.data[eventName];
    }
  }, {
    key: "eventNames",
    value: function eventNames() {
      return Object.keys(this.events);
    }
  }, {
    key: "listenerCount",
    value: function listenerCount(eventName) {
      var listeners = this.listeners(eventName);
      return listeners ? listeners.length : 0;
    }
  }, {
    key: "listeners",
    value: function listeners(eventName) {
      var listeners = this.events[eventName];
      return listeners || undefined;
    }
  }, {
    key: "once",
    value: function once(eventName, listener) {
      var onceListener = this.onceListener(eventName, listener);
      this.addListener(eventName, onceListener);
    }
  }, {
    key: "removeAllListeners",
    value: function removeAllListeners(eventName) {
      if (!eventName) {
        this.events = {};
      } else if (this.events[eventName]) {
        delete this.events[eventName];
      }
    }
  }, {
    key: "removeListener",
    value: function removeListener(eventName, listener) {
      var listeners = this.listeners(eventName);

      if (listeners) {
        this.events[eventName] = listeners.filter(function (l) {
          return l !== listener;
        });
      }
    }
  }, {
    key: "on",
    value: function on(eventName, listener) {
      this.addListener(eventName, listener);
    }
  }, {
    key: "off",
    value: function off(eventName, listener) {
      this.removeListener(eventName, listener);
    }
  }, {
    key: "handleEvent",
    value: function handleEvent(event) {
      var listeners = this.listeners(event.type);

      if (listeners && listeners.length) {
        listeners.forEach(function (fn) {
          fn.apply(event, event.args);
        });
      }

      this.data[event.type] = event.args;
    }
  }, {
    key: "onceListener",
    value: function onceListener(eventName, listener) {
      var _this3 = this;

      var onceListener = function onceListener() {
        _this3.removeListener(eventName, onceListener);

        return listener.apply(void 0, arguments);
      };

      return onceListener;
    }
  }]);

  return Channel;
}();var $$h = _export;
var fails$d = fails$r;
var isArray$o = isArray$r;
var isObject$n = isObject$z;
var toObject$6 = toObject$b;
var toLength$6 = toLength$b;
var createProperty$1 = createProperty$3;
var arraySpeciesCreate = arraySpeciesCreate$2;
var arrayMethodHasSpeciesSupport$1 = arrayMethodHasSpeciesSupport$4;
var wellKnownSymbol$a = wellKnownSymbol$n;
var V8_VERSION = engineV8Version;

var IS_CONCAT_SPREADABLE = wellKnownSymbol$a('isConcatSpreadable');
var MAX_SAFE_INTEGER$2 = 0x1FFFFFFFFFFFFF;
var MAXIMUM_ALLOWED_INDEX_EXCEEDED = 'Maximum allowed index exceeded';

// We can't use this feature detection in V8 since it causes
// deoptimization and serious performance degradation
// https://github.com/zloirock/core-js/issues/679
var IS_CONCAT_SPREADABLE_SUPPORT = V8_VERSION >= 51 || !fails$d(function () {
  var array = [];
  array[IS_CONCAT_SPREADABLE] = false;
  return array.concat()[0] !== array;
});

var SPECIES_SUPPORT = arrayMethodHasSpeciesSupport$1('concat');

var isConcatSpreadable = function (O) {
  if (!isObject$n(O)) return false;
  var spreadable = O[IS_CONCAT_SPREADABLE];
  return spreadable !== undefined ? !!spreadable : isArray$o(O);
};

var FORCED = !IS_CONCAT_SPREADABLE_SUPPORT || !SPECIES_SUPPORT;

// `Array.prototype.concat` method
// https://tc39.es/ecma262/#sec-array.prototype.concat
// with adding support of @@isConcatSpreadable and @@species
$$h({ target: 'Array', proto: true, forced: FORCED }, {
  // eslint-disable-next-line no-unused-vars -- required for `.length`
  concat: function concat(arg) {
    var O = toObject$6(this);
    var A = arraySpeciesCreate(O, 0);
    var n = 0;
    var i, k, length, len, E;
    for (i = -1, length = arguments.length; i < length; i++) {
      E = i === -1 ? O : arguments[i];
      if (isConcatSpreadable(E)) {
        len = toLength$6(E.length);
        if (n + len > MAX_SAFE_INTEGER$2) throw TypeError(MAXIMUM_ALLOWED_INDEX_EXCEEDED);
        for (k = 0; k < len; k++, n++) if (k in E) createProperty$1(A, n, E[k]);
      } else {
        if (n >= MAX_SAFE_INTEGER$2) throw TypeError(MAXIMUM_ALLOWED_INDEX_EXCEEDED);
        createProperty$1(A, n++, E);
      }
    }
    A.length = n;
    return A;
  }
});var isObject$m = isObject$z;
var setPrototypeOf$1 = objectSetPrototypeOf;

// makes subclassing work correct for wrapped built-ins
var inheritIfRequired$2 = function ($this, dummy, Wrapper) {
  var NewTarget, NewTargetPrototype;
  if (
    // it can work only with native `setPrototypeOf`
    setPrototypeOf$1 &&
    // we haven't completely correct pre-ES6 way for getting `new.target`, so use this
    typeof (NewTarget = dummy.constructor) == 'function' &&
    NewTarget !== Wrapper &&
    isObject$m(NewTargetPrototype = NewTarget.prototype) &&
    NewTargetPrototype !== Wrapper.prototype
  ) setPrototypeOf$1($this, NewTargetPrototype);
  return $this;
};var $$g = _export;
var global$7 = global$r;
var isForced$1 = isForced_1;
var redefine$4 = redefine$a.exports;
var InternalMetadataModule$1 = internalMetadata.exports;
var iterate$3 = iterate$5;
var anInstance$2 = anInstance$4;
var isObject$l = isObject$z;
var fails$c = fails$r;
var checkCorrectnessOfIteration$1 = checkCorrectnessOfIteration$3;
var setToStringTag$3 = setToStringTag$5;
var inheritIfRequired$1 = inheritIfRequired$2;

var collection$2 = function (CONSTRUCTOR_NAME, wrapper, common) {
  var IS_MAP = CONSTRUCTOR_NAME.indexOf('Map') !== -1;
  var IS_WEAK = CONSTRUCTOR_NAME.indexOf('Weak') !== -1;
  var ADDER = IS_MAP ? 'set' : 'add';
  var NativeConstructor = global$7[CONSTRUCTOR_NAME];
  var NativePrototype = NativeConstructor && NativeConstructor.prototype;
  var Constructor = NativeConstructor;
  var exported = {};

  var fixMethod = function (KEY) {
    var nativeMethod = NativePrototype[KEY];
    redefine$4(NativePrototype, KEY,
      KEY == 'add' ? function add(value) {
        nativeMethod.call(this, value === 0 ? 0 : value);
        return this;
      } : KEY == 'delete' ? function (key) {
        return IS_WEAK && !isObject$l(key) ? false : nativeMethod.call(this, key === 0 ? 0 : key);
      } : KEY == 'get' ? function get(key) {
        return IS_WEAK && !isObject$l(key) ? undefined : nativeMethod.call(this, key === 0 ? 0 : key);
      } : KEY == 'has' ? function has(key) {
        return IS_WEAK && !isObject$l(key) ? false : nativeMethod.call(this, key === 0 ? 0 : key);
      } : function set(key, value) {
        nativeMethod.call(this, key === 0 ? 0 : key, value);
        return this;
      }
    );
  };

  var REPLACE = isForced$1(
    CONSTRUCTOR_NAME,
    typeof NativeConstructor != 'function' || !(IS_WEAK || NativePrototype.forEach && !fails$c(function () {
      new NativeConstructor().entries().next();
    }))
  );

  if (REPLACE) {
    // create collection constructor
    Constructor = common.getConstructor(wrapper, CONSTRUCTOR_NAME, IS_MAP, ADDER);
    InternalMetadataModule$1.REQUIRED = true;
  } else if (isForced$1(CONSTRUCTOR_NAME, true)) {
    var instance = new Constructor();
    // early implementations not supports chaining
    var HASNT_CHAINING = instance[ADDER](IS_WEAK ? {} : -0, 1) != instance;
    // V8 ~ Chromium 40- weak-collections throws on primitives, but should return false
    var THROWS_ON_PRIMITIVES = fails$c(function () { instance.has(1); });
    // most early implementations doesn't supports iterables, most modern - not close it correctly
    // eslint-disable-next-line no-new -- required for testing
    var ACCEPT_ITERABLES = checkCorrectnessOfIteration$1(function (iterable) { new NativeConstructor(iterable); });
    // for early implementations -0 and +0 not the same
    var BUGGY_ZERO = !IS_WEAK && fails$c(function () {
      // V8 ~ Chromium 42- fails only with 5+ elements
      var $instance = new NativeConstructor();
      var index = 5;
      while (index--) $instance[ADDER](index, index);
      return !$instance.has(-0);
    });

    if (!ACCEPT_ITERABLES) {
      Constructor = wrapper(function (dummy, iterable) {
        anInstance$2(dummy, Constructor, CONSTRUCTOR_NAME);
        var that = inheritIfRequired$1(new NativeConstructor(), dummy, Constructor);
        if (iterable != undefined) iterate$3(iterable, that[ADDER], { that: that, AS_ENTRIES: IS_MAP });
        return that;
      });
      Constructor.prototype = NativePrototype;
      NativePrototype.constructor = Constructor;
    }

    if (THROWS_ON_PRIMITIVES || BUGGY_ZERO) {
      fixMethod('delete');
      fixMethod('has');
      IS_MAP && fixMethod('get');
    }

    if (BUGGY_ZERO || HASNT_CHAINING) fixMethod(ADDER);

    // weak collections should not contains .clear method
    if (IS_WEAK && NativePrototype.clear) delete NativePrototype.clear;
  }

  exported[CONSTRUCTOR_NAME] = Constructor;
  $$g({ global: true, forced: Constructor != NativeConstructor }, exported);

  setToStringTag$3(Constructor, CONSTRUCTOR_NAME);

  if (!IS_WEAK) common.setStrong(Constructor, CONSTRUCTOR_NAME, IS_MAP);

  return Constructor;
};var DESCRIPTORS$5 = descriptors;
var definePropertyModule$2 = objectDefineProperty;
var anObject$8 = anObject$i;
var objectKeys$1 = objectKeys$4;

// `Object.defineProperties` method
// https://tc39.es/ecma262/#sec-object.defineproperties
// eslint-disable-next-line es/no-object-defineproperties -- safe
var objectDefineProperties = DESCRIPTORS$5 ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject$8(O);
  var keys = objectKeys$1(Properties);
  var length = keys.length;
  var index = 0;
  var key;
  while (length > index) definePropertyModule$2.f(O, key = keys[index++], Properties[key]);
  return O;
};var anObject$7 = anObject$i;
var defineProperties = objectDefineProperties;
var enumBugKeys = enumBugKeys$3;
var hiddenKeys$1 = hiddenKeys$6;
var html = html$2;
var documentCreateElement = documentCreateElement$1;
var sharedKey$2 = sharedKey$4;

var GT = '>';
var LT = '<';
var PROTOTYPE$1 = 'prototype';
var SCRIPT$1 = 'script';
var IE_PROTO$1 = sharedKey$2('IE_PROTO');

var EmptyConstructor = function () { /* empty */ };

var scriptTag = function (content) {
  return LT + SCRIPT$1 + GT + content + LT + '/' + SCRIPT$1 + GT;
};

// Create object with fake `null` prototype: use ActiveX Object with cleared prototype
var NullProtoObjectViaActiveX = function (activeXDocument) {
  activeXDocument.write(scriptTag(''));
  activeXDocument.close();
  var temp = activeXDocument.parentWindow.Object;
  activeXDocument = null; // avoid memory leak
  return temp;
};

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var NullProtoObjectViaIFrame = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = documentCreateElement('iframe');
  var JS = 'java' + SCRIPT$1 + ':';
  var iframeDocument;
  iframe.style.display = 'none';
  html.appendChild(iframe);
  // https://github.com/zloirock/core-js/issues/475
  iframe.src = String(JS);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(scriptTag('document.F=Object'));
  iframeDocument.close();
  return iframeDocument.F;
};

// Check for document.domain and active x support
// No need to use active x approach when document.domain is not set
// see https://github.com/es-shims/es5-shim/issues/150
// variation of https://github.com/kitcambridge/es5-shim/commit/4f738ac066346
// avoid IE GC bug
var activeXDocument;
var NullProtoObject = function () {
  try {
    /* global ActiveXObject -- old IE */
    activeXDocument = document.domain && new ActiveXObject('htmlfile');
  } catch (error) { /* ignore */ }
  NullProtoObject = activeXDocument ? NullProtoObjectViaActiveX(activeXDocument) : NullProtoObjectViaIFrame();
  var length = enumBugKeys.length;
  while (length--) delete NullProtoObject[PROTOTYPE$1][enumBugKeys[length]];
  return NullProtoObject();
};

hiddenKeys$1[IE_PROTO$1] = true;

// `Object.create` method
// https://tc39.es/ecma262/#sec-object.create
var objectCreate$1 = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    EmptyConstructor[PROTOTYPE$1] = anObject$7(O);
    result = new EmptyConstructor();
    EmptyConstructor[PROTOTYPE$1] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO$1] = O;
  } else result = NullProtoObject();
  return Properties === undefined ? result : defineProperties(result, Properties);
};var fails$b = fails$r;

var correctPrototypeGetter = !fails$b(function () {
  function F() { /* empty */ }
  F.prototype.constructor = null;
  // eslint-disable-next-line es/no-object-getprototypeof -- required for testing
  return Object.getPrototypeOf(new F()) !== F.prototype;
});var has$9 = has$i;
var toObject$5 = toObject$b;
var sharedKey$1 = sharedKey$4;
var CORRECT_PROTOTYPE_GETTER$1 = correctPrototypeGetter;

var IE_PROTO = sharedKey$1('IE_PROTO');
var ObjectPrototype$1 = Object.prototype;

// `Object.getPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.getprototypeof
// eslint-disable-next-line es/no-object-getprototypeof -- safe
var objectGetPrototypeOf = CORRECT_PROTOTYPE_GETTER$1 ? Object.getPrototypeOf : function (O) {
  O = toObject$5(O);
  if (has$9(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectPrototype$1 : null;
};var fails$a = fails$r;
var getPrototypeOf$2 = objectGetPrototypeOf;
var createNonEnumerableProperty$4 = createNonEnumerableProperty$a;
var has$8 = has$i;
var wellKnownSymbol$9 = wellKnownSymbol$n;

var ITERATOR$2 = wellKnownSymbol$9('iterator');
var BUGGY_SAFARI_ITERATORS$1 = false;

var returnThis$2 = function () { return this; };

// `%IteratorPrototype%` object
// https://tc39.es/ecma262/#sec-%iteratorprototype%-object
var IteratorPrototype$2, PrototypeOfArrayIteratorPrototype, arrayIterator;

/* eslint-disable es/no-array-prototype-keys -- safe */
if ([].keys) {
  arrayIterator = [].keys();
  // Safari 8 has buggy iterators w/o `next`
  if (!('next' in arrayIterator)) BUGGY_SAFARI_ITERATORS$1 = true;
  else {
    PrototypeOfArrayIteratorPrototype = getPrototypeOf$2(getPrototypeOf$2(arrayIterator));
    if (PrototypeOfArrayIteratorPrototype !== Object.prototype) IteratorPrototype$2 = PrototypeOfArrayIteratorPrototype;
  }
}

var NEW_ITERATOR_PROTOTYPE = IteratorPrototype$2 == undefined || fails$a(function () {
  var test = {};
  // FF44- legacy iterators case
  return IteratorPrototype$2[ITERATOR$2].call(test) !== test;
});

if (NEW_ITERATOR_PROTOTYPE) IteratorPrototype$2 = {};

// `%IteratorPrototype%[@@iterator]()` method
// https://tc39.es/ecma262/#sec-%iteratorprototype%-@@iterator
if (!has$8(IteratorPrototype$2, ITERATOR$2)) {
  createNonEnumerableProperty$4(IteratorPrototype$2, ITERATOR$2, returnThis$2);
}

var iteratorsCore = {
  IteratorPrototype: IteratorPrototype$2,
  BUGGY_SAFARI_ITERATORS: BUGGY_SAFARI_ITERATORS$1
};var IteratorPrototype$1 = iteratorsCore.IteratorPrototype;
var create$5 = objectCreate$1;
var createPropertyDescriptor$1 = createPropertyDescriptor$5;
var setToStringTag$2 = setToStringTag$5;
var Iterators$2 = iterators;

var returnThis$1 = function () { return this; };

var createIteratorConstructor$1 = function (IteratorConstructor, NAME, next) {
  var TO_STRING_TAG = NAME + ' Iterator';
  IteratorConstructor.prototype = create$5(IteratorPrototype$1, { next: createPropertyDescriptor$1(1, next) });
  setToStringTag$2(IteratorConstructor, TO_STRING_TAG, false);
  Iterators$2[TO_STRING_TAG] = returnThis$1;
  return IteratorConstructor;
};var $$f = _export;
var createIteratorConstructor = createIteratorConstructor$1;
var getPrototypeOf$1 = objectGetPrototypeOf;
var setPrototypeOf = objectSetPrototypeOf;
var setToStringTag$1 = setToStringTag$5;
var createNonEnumerableProperty$3 = createNonEnumerableProperty$a;
var redefine$3 = redefine$a.exports;
var wellKnownSymbol$8 = wellKnownSymbol$n;
var Iterators$1 = iterators;
var IteratorsCore = iteratorsCore;

var IteratorPrototype = IteratorsCore.IteratorPrototype;
var BUGGY_SAFARI_ITERATORS = IteratorsCore.BUGGY_SAFARI_ITERATORS;
var ITERATOR$1 = wellKnownSymbol$8('iterator');
var KEYS = 'keys';
var VALUES = 'values';
var ENTRIES = 'entries';

var returnThis = function () { return this; };

var defineIterator$3 = function (Iterable, NAME, IteratorConstructor, next, DEFAULT, IS_SET, FORCED) {
  createIteratorConstructor(IteratorConstructor, NAME, next);

  var getIterationMethod = function (KIND) {
    if (KIND === DEFAULT && defaultIterator) return defaultIterator;
    if (!BUGGY_SAFARI_ITERATORS && KIND in IterablePrototype) return IterablePrototype[KIND];
    switch (KIND) {
      case KEYS: return function keys() { return new IteratorConstructor(this, KIND); };
      case VALUES: return function values() { return new IteratorConstructor(this, KIND); };
      case ENTRIES: return function entries() { return new IteratorConstructor(this, KIND); };
    } return function () { return new IteratorConstructor(this); };
  };

  var TO_STRING_TAG = NAME + ' Iterator';
  var INCORRECT_VALUES_NAME = false;
  var IterablePrototype = Iterable.prototype;
  var nativeIterator = IterablePrototype[ITERATOR$1]
    || IterablePrototype['@@iterator']
    || DEFAULT && IterablePrototype[DEFAULT];
  var defaultIterator = !BUGGY_SAFARI_ITERATORS && nativeIterator || getIterationMethod(DEFAULT);
  var anyNativeIterator = NAME == 'Array' ? IterablePrototype.entries || nativeIterator : nativeIterator;
  var CurrentIteratorPrototype, methods, KEY;

  // fix native
  if (anyNativeIterator) {
    CurrentIteratorPrototype = getPrototypeOf$1(anyNativeIterator.call(new Iterable()));
    if (IteratorPrototype !== Object.prototype && CurrentIteratorPrototype.next) {
      if (getPrototypeOf$1(CurrentIteratorPrototype) !== IteratorPrototype) {
        if (setPrototypeOf) {
          setPrototypeOf(CurrentIteratorPrototype, IteratorPrototype);
        } else if (typeof CurrentIteratorPrototype[ITERATOR$1] != 'function') {
          createNonEnumerableProperty$3(CurrentIteratorPrototype, ITERATOR$1, returnThis);
        }
      }
      // Set @@toStringTag to native iterators
      setToStringTag$1(CurrentIteratorPrototype, TO_STRING_TAG, true);
    }
  }

  // fix Array.prototype.{ values, @@iterator }.name in V8 / FF
  if (DEFAULT == VALUES && nativeIterator && nativeIterator.name !== VALUES) {
    INCORRECT_VALUES_NAME = true;
    defaultIterator = function values() { return nativeIterator.call(this); };
  }

  // define iterator
  if (IterablePrototype[ITERATOR$1] !== defaultIterator) {
    createNonEnumerableProperty$3(IterablePrototype, ITERATOR$1, defaultIterator);
  }
  Iterators$1[NAME] = defaultIterator;

  // export additional methods
  if (DEFAULT) {
    methods = {
      values: getIterationMethod(VALUES),
      keys: IS_SET ? defaultIterator : getIterationMethod(KEYS),
      entries: getIterationMethod(ENTRIES)
    };
    if (FORCED) for (KEY in methods) {
      if (BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME || !(KEY in IterablePrototype)) {
        redefine$3(IterablePrototype, KEY, methods[KEY]);
      }
    } else $$f({ target: NAME, proto: true, forced: BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME }, methods);
  }

  return methods;
};var defineProperty$9 = objectDefineProperty.f;
var create$4 = objectCreate$1;
var redefineAll$2 = redefineAll$4;
var bind$6 = functionBindContext;
var anInstance$1 = anInstance$4;
var iterate$2 = iterate$5;
var defineIterator$2 = defineIterator$3;
var setSpecies = setSpecies$2;
var DESCRIPTORS$4 = descriptors;
var fastKey = internalMetadata.exports.fastKey;
var InternalStateModule$4 = internalState;

var setInternalState$4 = InternalStateModule$4.set;
var internalStateGetterFor$1 = InternalStateModule$4.getterFor;

var collectionStrong$1 = {
  getConstructor: function (wrapper, CONSTRUCTOR_NAME, IS_MAP, ADDER) {
    var C = wrapper(function (that, iterable) {
      anInstance$1(that, C, CONSTRUCTOR_NAME);
      setInternalState$4(that, {
        type: CONSTRUCTOR_NAME,
        index: create$4(null),
        first: undefined,
        last: undefined,
        size: 0
      });
      if (!DESCRIPTORS$4) that.size = 0;
      if (iterable != undefined) iterate$2(iterable, that[ADDER], { that: that, AS_ENTRIES: IS_MAP });
    });

    var getInternalState = internalStateGetterFor$1(CONSTRUCTOR_NAME);

    var define = function (that, key, value) {
      var state = getInternalState(that);
      var entry = getEntry(that, key);
      var previous, index;
      // change existing entry
      if (entry) {
        entry.value = value;
      // create new entry
      } else {
        state.last = entry = {
          index: index = fastKey(key, true),
          key: key,
          value: value,
          previous: previous = state.last,
          next: undefined,
          removed: false
        };
        if (!state.first) state.first = entry;
        if (previous) previous.next = entry;
        if (DESCRIPTORS$4) state.size++;
        else that.size++;
        // add to index
        if (index !== 'F') state.index[index] = entry;
      } return that;
    };

    var getEntry = function (that, key) {
      var state = getInternalState(that);
      // fast case
      var index = fastKey(key);
      var entry;
      if (index !== 'F') return state.index[index];
      // frozen object case
      for (entry = state.first; entry; entry = entry.next) {
        if (entry.key == key) return entry;
      }
    };

    redefineAll$2(C.prototype, {
      // `{ Map, Set }.prototype.clear()` methods
      // https://tc39.es/ecma262/#sec-map.prototype.clear
      // https://tc39.es/ecma262/#sec-set.prototype.clear
      clear: function clear() {
        var that = this;
        var state = getInternalState(that);
        var data = state.index;
        var entry = state.first;
        while (entry) {
          entry.removed = true;
          if (entry.previous) entry.previous = entry.previous.next = undefined;
          delete data[entry.index];
          entry = entry.next;
        }
        state.first = state.last = undefined;
        if (DESCRIPTORS$4) state.size = 0;
        else that.size = 0;
      },
      // `{ Map, Set }.prototype.delete(key)` methods
      // https://tc39.es/ecma262/#sec-map.prototype.delete
      // https://tc39.es/ecma262/#sec-set.prototype.delete
      'delete': function (key) {
        var that = this;
        var state = getInternalState(that);
        var entry = getEntry(that, key);
        if (entry) {
          var next = entry.next;
          var prev = entry.previous;
          delete state.index[entry.index];
          entry.removed = true;
          if (prev) prev.next = next;
          if (next) next.previous = prev;
          if (state.first == entry) state.first = next;
          if (state.last == entry) state.last = prev;
          if (DESCRIPTORS$4) state.size--;
          else that.size--;
        } return !!entry;
      },
      // `{ Map, Set }.prototype.forEach(callbackfn, thisArg = undefined)` methods
      // https://tc39.es/ecma262/#sec-map.prototype.foreach
      // https://tc39.es/ecma262/#sec-set.prototype.foreach
      forEach: function forEach(callbackfn /* , that = undefined */) {
        var state = getInternalState(this);
        var boundFunction = bind$6(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
        var entry;
        while (entry = entry ? entry.next : state.first) {
          boundFunction(entry.value, entry.key, this);
          // revert to the last existing entry
          while (entry && entry.removed) entry = entry.previous;
        }
      },
      // `{ Map, Set}.prototype.has(key)` methods
      // https://tc39.es/ecma262/#sec-map.prototype.has
      // https://tc39.es/ecma262/#sec-set.prototype.has
      has: function has(key) {
        return !!getEntry(this, key);
      }
    });

    redefineAll$2(C.prototype, IS_MAP ? {
      // `Map.prototype.get(key)` method
      // https://tc39.es/ecma262/#sec-map.prototype.get
      get: function get(key) {
        var entry = getEntry(this, key);
        return entry && entry.value;
      },
      // `Map.prototype.set(key, value)` method
      // https://tc39.es/ecma262/#sec-map.prototype.set
      set: function set(key, value) {
        return define(this, key === 0 ? 0 : key, value);
      }
    } : {
      // `Set.prototype.add(value)` method
      // https://tc39.es/ecma262/#sec-set.prototype.add
      add: function add(value) {
        return define(this, value = value === 0 ? 0 : value, value);
      }
    });
    if (DESCRIPTORS$4) defineProperty$9(C.prototype, 'size', {
      get: function () {
        return getInternalState(this).size;
      }
    });
    return C;
  },
  setStrong: function (C, CONSTRUCTOR_NAME, IS_MAP) {
    var ITERATOR_NAME = CONSTRUCTOR_NAME + ' Iterator';
    var getInternalCollectionState = internalStateGetterFor$1(CONSTRUCTOR_NAME);
    var getInternalIteratorState = internalStateGetterFor$1(ITERATOR_NAME);
    // `{ Map, Set }.prototype.{ keys, values, entries, @@iterator }()` methods
    // https://tc39.es/ecma262/#sec-map.prototype.entries
    // https://tc39.es/ecma262/#sec-map.prototype.keys
    // https://tc39.es/ecma262/#sec-map.prototype.values
    // https://tc39.es/ecma262/#sec-map.prototype-@@iterator
    // https://tc39.es/ecma262/#sec-set.prototype.entries
    // https://tc39.es/ecma262/#sec-set.prototype.keys
    // https://tc39.es/ecma262/#sec-set.prototype.values
    // https://tc39.es/ecma262/#sec-set.prototype-@@iterator
    defineIterator$2(C, CONSTRUCTOR_NAME, function (iterated, kind) {
      setInternalState$4(this, {
        type: ITERATOR_NAME,
        target: iterated,
        state: getInternalCollectionState(iterated),
        kind: kind,
        last: undefined
      });
    }, function () {
      var state = getInternalIteratorState(this);
      var kind = state.kind;
      var entry = state.last;
      // revert to the last existing entry
      while (entry && entry.removed) entry = entry.previous;
      // get next entry
      if (!state.target || !(state.last = entry = entry ? entry.next : state.state.first)) {
        // or finish the iteration
        state.target = undefined;
        return { value: undefined, done: true };
      }
      // return step by kind
      if (kind == 'keys') return { value: entry.key, done: false };
      if (kind == 'values') return { value: entry.value, done: false };
      return { value: [entry.key, entry.value], done: false };
    }, IS_MAP ? 'entries' : 'values', !IS_MAP, true);

    // `{ Map, Set }.prototype[@@species]` accessors
    // https://tc39.es/ecma262/#sec-get-map-@@species
    // https://tc39.es/ecma262/#sec-get-set-@@species
    setSpecies(CONSTRUCTOR_NAME);
  }
};var collection$1 = collection$2;
var collectionStrong = collectionStrong$1;

// `Set` constructor
// https://tc39.es/ecma262/#sec-set-objects
collection$1('Set', function (init) {
  return function Set() { return init(this, arguments.length ? arguments[0] : undefined); };
}, collectionStrong);var toInteger$4 = toInteger$7;
var requireObjectCoercible$7 = requireObjectCoercible$a;

// `String.prototype.{ codePointAt, at }` methods implementation
var createMethod$2 = function (CONVERT_TO_STRING) {
  return function ($this, pos) {
    var S = String(requireObjectCoercible$7($this));
    var position = toInteger$4(pos);
    var size = S.length;
    var first, second;
    if (position < 0 || position >= size) return CONVERT_TO_STRING ? '' : undefined;
    first = S.charCodeAt(position);
    return first < 0xD800 || first > 0xDBFF || position + 1 === size
      || (second = S.charCodeAt(position + 1)) < 0xDC00 || second > 0xDFFF
        ? CONVERT_TO_STRING ? S.charAt(position) : first
        : CONVERT_TO_STRING ? S.slice(position, position + 2) : (first - 0xD800 << 10) + (second - 0xDC00) + 0x10000;
  };
};

var stringMultibyte = {
  // `String.prototype.codePointAt` method
  // https://tc39.es/ecma262/#sec-string.prototype.codepointat
  codeAt: createMethod$2(false),
  // `String.prototype.at` method
  // https://github.com/mathiasbynens/String.prototype.at
  charAt: createMethod$2(true)
};var charAt$1 = stringMultibyte.charAt;
var InternalStateModule$3 = internalState;
var defineIterator$1 = defineIterator$3;

var STRING_ITERATOR = 'String Iterator';
var setInternalState$3 = InternalStateModule$3.set;
var getInternalState$3 = InternalStateModule$3.getterFor(STRING_ITERATOR);

// `String.prototype[@@iterator]` method
// https://tc39.es/ecma262/#sec-string.prototype-@@iterator
defineIterator$1(String, 'String', function (iterated) {
  setInternalState$3(this, {
    type: STRING_ITERATOR,
    string: String(iterated),
    index: 0
  });
// `%StringIteratorPrototype%.next` method
// https://tc39.es/ecma262/#sec-%stringiteratorprototype%.next
}, function next() {
  var state = getInternalState$3(this);
  var string = state.string;
  var index = state.index;
  var point;
  if (index >= string.length) return { value: undefined, done: true };
  point = charAt$1(string, index);
  state.index += point.length;
  return { value: point, done: false };
});var wellKnownSymbol$7 = wellKnownSymbol$n;
var create$3 = objectCreate$1;
var definePropertyModule$1 = objectDefineProperty;

var UNSCOPABLES = wellKnownSymbol$7('unscopables');
var ArrayPrototype = Array.prototype;

// Array.prototype[@@unscopables]
// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
if (ArrayPrototype[UNSCOPABLES] == undefined) {
  definePropertyModule$1.f(ArrayPrototype, UNSCOPABLES, {
    configurable: true,
    value: create$3(null)
  });
}

// add a key to Array.prototype[@@unscopables]
var addToUnscopables$4 = function (key) {
  ArrayPrototype[UNSCOPABLES][key] = true;
};var toIndexedObject$3 = toIndexedObject$9;
var addToUnscopables$3 = addToUnscopables$4;
var Iterators = iterators;
var InternalStateModule$2 = internalState;
var defineIterator = defineIterator$3;

var ARRAY_ITERATOR = 'Array Iterator';
var setInternalState$2 = InternalStateModule$2.set;
var getInternalState$2 = InternalStateModule$2.getterFor(ARRAY_ITERATOR);

// `Array.prototype.entries` method
// https://tc39.es/ecma262/#sec-array.prototype.entries
// `Array.prototype.keys` method
// https://tc39.es/ecma262/#sec-array.prototype.keys
// `Array.prototype.values` method
// https://tc39.es/ecma262/#sec-array.prototype.values
// `Array.prototype[@@iterator]` method
// https://tc39.es/ecma262/#sec-array.prototype-@@iterator
// `CreateArrayIterator` internal method
// https://tc39.es/ecma262/#sec-createarrayiterator
var es_array_iterator = defineIterator(Array, 'Array', function (iterated, kind) {
  setInternalState$2(this, {
    type: ARRAY_ITERATOR,
    target: toIndexedObject$3(iterated), // target
    index: 0,                          // next index
    kind: kind                         // kind
  });
// `%ArrayIteratorPrototype%.next` method
// https://tc39.es/ecma262/#sec-%arrayiteratorprototype%.next
}, function () {
  var state = getInternalState$2(this);
  var target = state.target;
  var kind = state.kind;
  var index = state.index++;
  if (!target || index >= target.length) {
    state.target = undefined;
    return { value: undefined, done: true };
  }
  if (kind == 'keys') return { value: index, done: false };
  if (kind == 'values') return { value: target[index], done: false };
  return { value: [index, target[index]], done: false };
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values%
// https://tc39.es/ecma262/#sec-createunmappedargumentsobject
// https://tc39.es/ecma262/#sec-createmappedargumentsobject
Iterators.Arguments = Iterators.Array;

// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables$3('keys');
addToUnscopables$3('values');
addToUnscopables$3('entries');var global$6 = global$r;
var DOMIterables = domIterables;
var ArrayIteratorMethods = es_array_iterator;
var createNonEnumerableProperty$2 = createNonEnumerableProperty$a;
var wellKnownSymbol$6 = wellKnownSymbol$n;

var ITERATOR = wellKnownSymbol$6('iterator');
var TO_STRING_TAG = wellKnownSymbol$6('toStringTag');
var ArrayValues = ArrayIteratorMethods.values;

for (var COLLECTION_NAME in DOMIterables) {
  var Collection = global$6[COLLECTION_NAME];
  var CollectionPrototype = Collection && Collection.prototype;
  if (CollectionPrototype) {
    // some Chrome versions have non-configurable methods on DOMTokenList
    if (CollectionPrototype[ITERATOR] !== ArrayValues) try {
      createNonEnumerableProperty$2(CollectionPrototype, ITERATOR, ArrayValues);
    } catch (error) {
      CollectionPrototype[ITERATOR] = ArrayValues;
    }
    if (!CollectionPrototype[TO_STRING_TAG]) {
      createNonEnumerableProperty$2(CollectionPrototype, TO_STRING_TAG, COLLECTION_NAME);
    }
    if (DOMIterables[COLLECTION_NAME]) for (var METHOD_NAME in ArrayIteratorMethods) {
      // some Chrome versions have non-configurable methods on DOMTokenList
      if (CollectionPrototype[METHOD_NAME] !== ArrayIteratorMethods[METHOD_NAME]) try {
        createNonEnumerableProperty$2(CollectionPrototype, METHOD_NAME, ArrayIteratorMethods[METHOD_NAME]);
      } catch (error) {
        CollectionPrototype[METHOD_NAME] = ArrayIteratorMethods[METHOD_NAME];
      }
    }
  }
}var regexpStickyHelpers = {};var fails$9 = fails$r;

// babel-minify transpiles RegExp('a', 'y') -> /a/y and it causes SyntaxError,
var RE = function (s, f) {
  return RegExp(s, f);
};

regexpStickyHelpers.UNSUPPORTED_Y = fails$9(function () {
  var re = RE('a', 'y');
  re.lastIndex = 2;
  return re.exec('abcd') != null;
});

regexpStickyHelpers.BROKEN_CARET = fails$9(function () {
  // https://bugzilla.mozilla.org/show_bug.cgi?id=773687
  var re = RE('^r', 'gy');
  re.lastIndex = 2;
  return re.exec('str') != null;
});var fails$8 = fails$r;

var regexpUnsupportedDotAll = fails$8(function () {
  // babel-minify transpiles RegExp('.', 's') -> /./s and it causes SyntaxError
  var re = RegExp('.', (typeof '').charAt(0));
  return !(re.dotAll && re.exec('\n') && re.flags === 's');
});var fails$7 = fails$r;

var regexpUnsupportedNcg = fails$7(function () {
  // babel-minify transpiles RegExp('.', 'g') -> /./g and it causes SyntaxError
  var re = RegExp('(?<a>b)', (typeof '').charAt(5));
  return re.exec('b').groups.a !== 'b' ||
    'b'.replace(re, '$<a>c') !== 'bc';
});/* eslint-disable regexp/no-assertion-capturing-group, regexp/no-empty-group, regexp/no-lazy-ends -- testing */
/* eslint-disable regexp/no-useless-quantifier -- testing */
var regexpFlags = regexpFlags$1;
var stickyHelpers$1 = regexpStickyHelpers;
var shared$2 = shared$6.exports;
var create$2 = objectCreate$1;
var getInternalState$1 = internalState.get;
var UNSUPPORTED_DOT_ALL = regexpUnsupportedDotAll;
var UNSUPPORTED_NCG = regexpUnsupportedNcg;

var nativeExec = RegExp.prototype.exec;
var nativeReplace = shared$2('native-string-replace', String.prototype.replace);

var patchedExec = nativeExec;

var UPDATES_LAST_INDEX_WRONG = (function () {
  var re1 = /a/;
  var re2 = /b*/g;
  nativeExec.call(re1, 'a');
  nativeExec.call(re2, 'a');
  return re1.lastIndex !== 0 || re2.lastIndex !== 0;
})();

var UNSUPPORTED_Y$1 = stickyHelpers$1.UNSUPPORTED_Y || stickyHelpers$1.BROKEN_CARET;

// nonparticipating capturing group, copied from es5-shim's String#split patch.
var NPCG_INCLUDED = /()??/.exec('')[1] !== undefined;

var PATCH = UPDATES_LAST_INDEX_WRONG || NPCG_INCLUDED || UNSUPPORTED_Y$1 || UNSUPPORTED_DOT_ALL || UNSUPPORTED_NCG;

if (PATCH) {
  // eslint-disable-next-line max-statements -- TODO
  patchedExec = function exec(str) {
    var re = this;
    var state = getInternalState$1(re);
    var raw = state.raw;
    var result, reCopy, lastIndex, match, i, object, group;

    if (raw) {
      raw.lastIndex = re.lastIndex;
      result = patchedExec.call(raw, str);
      re.lastIndex = raw.lastIndex;
      return result;
    }

    var groups = state.groups;
    var sticky = UNSUPPORTED_Y$1 && re.sticky;
    var flags = regexpFlags.call(re);
    var source = re.source;
    var charsAdded = 0;
    var strCopy = str;

    if (sticky) {
      flags = flags.replace('y', '');
      if (flags.indexOf('g') === -1) {
        flags += 'g';
      }

      strCopy = String(str).slice(re.lastIndex);
      // Support anchored sticky behavior.
      if (re.lastIndex > 0 && (!re.multiline || re.multiline && str[re.lastIndex - 1] !== '\n')) {
        source = '(?: ' + source + ')';
        strCopy = ' ' + strCopy;
        charsAdded++;
      }
      // ^(? + rx + ) is needed, in combination with some str slicing, to
      // simulate the 'y' flag.
      reCopy = new RegExp('^(?:' + source + ')', flags);
    }

    if (NPCG_INCLUDED) {
      reCopy = new RegExp('^' + source + '$(?!\\s)', flags);
    }
    if (UPDATES_LAST_INDEX_WRONG) lastIndex = re.lastIndex;

    match = nativeExec.call(sticky ? reCopy : re, strCopy);

    if (sticky) {
      if (match) {
        match.input = match.input.slice(charsAdded);
        match[0] = match[0].slice(charsAdded);
        match.index = re.lastIndex;
        re.lastIndex += match[0].length;
      } else re.lastIndex = 0;
    } else if (UPDATES_LAST_INDEX_WRONG && match) {
      re.lastIndex = re.global ? match.index + match[0].length : lastIndex;
    }
    if (NPCG_INCLUDED && match && match.length > 1) {
      // Fix browsers whose `exec` methods don't consistently return `undefined`
      // for NPCG, like IE8. NOTE: This doesn' work for /(.?)?/
      nativeReplace.call(match[0], reCopy, function () {
        for (i = 1; i < arguments.length - 2; i++) {
          if (arguments[i] === undefined) match[i] = undefined;
        }
      });
    }

    if (match && groups) {
      match.groups = object = create$2(null);
      for (i = 0; i < groups.length; i++) {
        group = groups[i];
        object[group[0]] = match[group[1]];
      }
    }

    return match;
  };
}

var regexpExec$3 = patchedExec;var $$e = _export;
var exec = regexpExec$3;

// `RegExp.prototype.exec` method
// https://tc39.es/ecma262/#sec-regexp.prototype.exec
$$e({ target: 'RegExp', proto: true, forced: /./.exec !== exec }, {
  exec: exec
});// TODO: Remove from `core-js@4` since it's moved to entry points

var redefine$2 = redefine$a.exports;
var regexpExec$2 = regexpExec$3;
var fails$6 = fails$r;
var wellKnownSymbol$5 = wellKnownSymbol$n;
var createNonEnumerableProperty$1 = createNonEnumerableProperty$a;

var SPECIES = wellKnownSymbol$5('species');
var RegExpPrototype = RegExp.prototype;

var fixRegexpWellKnownSymbolLogic = function (KEY, exec, FORCED, SHAM) {
  var SYMBOL = wellKnownSymbol$5(KEY);

  var DELEGATES_TO_SYMBOL = !fails$6(function () {
    // String methods call symbol-named RegEp methods
    var O = {};
    O[SYMBOL] = function () { return 7; };
    return ''[KEY](O) != 7;
  });

  var DELEGATES_TO_EXEC = DELEGATES_TO_SYMBOL && !fails$6(function () {
    // Symbol-named RegExp methods call .exec
    var execCalled = false;
    var re = /a/;

    if (KEY === 'split') {
      // We can't use real regex here since it causes deoptimization
      // and serious performance degradation in V8
      // https://github.com/zloirock/core-js/issues/306
      re = {};
      // RegExp[@@split] doesn't call the regex's exec method, but first creates
      // a new one. We need to return the patched regex when creating the new one.
      re.constructor = {};
      re.constructor[SPECIES] = function () { return re; };
      re.flags = '';
      re[SYMBOL] = /./[SYMBOL];
    }

    re.exec = function () { execCalled = true; return null; };

    re[SYMBOL]('');
    return !execCalled;
  });

  if (
    !DELEGATES_TO_SYMBOL ||
    !DELEGATES_TO_EXEC ||
    FORCED
  ) {
    var nativeRegExpMethod = /./[SYMBOL];
    var methods = exec(SYMBOL, ''[KEY], function (nativeMethod, regexp, str, arg2, forceStringMethod) {
      var $exec = regexp.exec;
      if ($exec === regexpExec$2 || $exec === RegExpPrototype.exec) {
        if (DELEGATES_TO_SYMBOL && !forceStringMethod) {
          // The native String method already delegates to @@method (this
          // polyfilled function), leasing to infinite recursion.
          // We avoid it by directly calling the native @@method method.
          return { done: true, value: nativeRegExpMethod.call(regexp, str, arg2) };
        }
        return { done: true, value: nativeMethod.call(str, regexp, arg2) };
      }
      return { done: false };
    });

    redefine$2(String.prototype, KEY, methods[0]);
    redefine$2(RegExpPrototype, SYMBOL, methods[1]);
  }

  if (SHAM) createNonEnumerableProperty$1(RegExpPrototype[SYMBOL], 'sham', true);
};var charAt = stringMultibyte.charAt;

// `AdvanceStringIndex` abstract operation
// https://tc39.es/ecma262/#sec-advancestringindex
var advanceStringIndex$3 = function (S, index, unicode) {
  return index + (unicode ? charAt(S, index).length : 1);
};var toObject$4 = toObject$b;

var floor = Math.floor;
var replace$1 = ''.replace;
var SUBSTITUTION_SYMBOLS = /\$([$&'`]|\d{1,2}|<[^>]*>)/g;
var SUBSTITUTION_SYMBOLS_NO_NAMED = /\$([$&'`]|\d{1,2})/g;

// `GetSubstitution` abstract operation
// https://tc39.es/ecma262/#sec-getsubstitution
var getSubstitution$1 = function (matched, str, position, captures, namedCaptures, replacement) {
  var tailPos = position + matched.length;
  var m = captures.length;
  var symbols = SUBSTITUTION_SYMBOLS_NO_NAMED;
  if (namedCaptures !== undefined) {
    namedCaptures = toObject$4(namedCaptures);
    symbols = SUBSTITUTION_SYMBOLS;
  }
  return replace$1.call(replacement, symbols, function (match, ch) {
    var capture;
    switch (ch.charAt(0)) {
      case '$': return '$';
      case '&': return matched;
      case '`': return str.slice(0, position);
      case "'": return str.slice(tailPos);
      case '<':
        capture = namedCaptures[ch.slice(1, -1)];
        break;
      default: // \d\d?
        var n = +ch;
        if (n === 0) return match;
        if (n > m) {
          var f = floor(n / 10);
          if (f === 0) return match;
          if (f <= m) return captures[f - 1] === undefined ? ch.charAt(1) : captures[f - 1] + ch.charAt(1);
          return match;
        }
        capture = captures[n - 1];
    }
    return capture === undefined ? '' : capture;
  });
};var classof$2 = classofRaw$1;
var regexpExec$1 = regexpExec$3;

// `RegExpExec` abstract operation
// https://tc39.es/ecma262/#sec-regexpexec
var regexpExecAbstract = function (R, S) {
  var exec = R.exec;
  if (typeof exec === 'function') {
    var result = exec.call(R, S);
    if (typeof result !== 'object') {
      throw TypeError('RegExp exec method returned something other than an Object or null');
    }
    return result;
  }

  if (classof$2(R) !== 'RegExp') {
    throw TypeError('RegExp#exec called on incompatible receiver');
  }

  return regexpExec$1.call(R, S);
};var fixRegExpWellKnownSymbolLogic$3 = fixRegexpWellKnownSymbolLogic;
var fails$5 = fails$r;
var anObject$6 = anObject$i;
var toLength$5 = toLength$b;
var toInteger$3 = toInteger$7;
var requireObjectCoercible$6 = requireObjectCoercible$a;
var advanceStringIndex$2 = advanceStringIndex$3;
var getSubstitution = getSubstitution$1;
var regExpExec$2 = regexpExecAbstract;
var wellKnownSymbol$4 = wellKnownSymbol$n;

var REPLACE = wellKnownSymbol$4('replace');
var max$1 = Math.max;
var min$3 = Math.min;

var maybeToString = function (it) {
  return it === undefined ? it : String(it);
};

// IE <= 11 replaces $0 with the whole match, as if it was $&
// https://stackoverflow.com/questions/6024666/getting-ie-to-replace-a-regex-with-the-literal-string-0
var REPLACE_KEEPS_$0 = (function () {
  // eslint-disable-next-line regexp/prefer-escape-replacement-dollar-char -- required for testing
  return 'a'.replace(/./, '$0') === '$0';
})();

// Safari <= 13.0.3(?) substitutes nth capture where n>m with an empty string
var REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE = (function () {
  if (/./[REPLACE]) {
    return /./[REPLACE]('a', '$0') === '';
  }
  return false;
})();

var REPLACE_SUPPORTS_NAMED_GROUPS = !fails$5(function () {
  var re = /./;
  re.exec = function () {
    var result = [];
    result.groups = { a: '7' };
    return result;
  };
  return ''.replace(re, '$<a>') !== '7';
});

// @@replace logic
fixRegExpWellKnownSymbolLogic$3('replace', function (_, nativeReplace, maybeCallNative) {
  var UNSAFE_SUBSTITUTE = REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE ? '$' : '$0';

  return [
    // `String.prototype.replace` method
    // https://tc39.es/ecma262/#sec-string.prototype.replace
    function replace(searchValue, replaceValue) {
      var O = requireObjectCoercible$6(this);
      var replacer = searchValue == undefined ? undefined : searchValue[REPLACE];
      return replacer !== undefined
        ? replacer.call(searchValue, O, replaceValue)
        : nativeReplace.call(String(O), searchValue, replaceValue);
    },
    // `RegExp.prototype[@@replace]` method
    // https://tc39.es/ecma262/#sec-regexp.prototype-@@replace
    function (string, replaceValue) {
      if (
        typeof replaceValue === 'string' &&
        replaceValue.indexOf(UNSAFE_SUBSTITUTE) === -1 &&
        replaceValue.indexOf('$<') === -1
      ) {
        var res = maybeCallNative(nativeReplace, this, string, replaceValue);
        if (res.done) return res.value;
      }

      var rx = anObject$6(this);
      var S = String(string);

      var functionalReplace = typeof replaceValue === 'function';
      if (!functionalReplace) replaceValue = String(replaceValue);

      var global = rx.global;
      if (global) {
        var fullUnicode = rx.unicode;
        rx.lastIndex = 0;
      }
      var results = [];
      while (true) {
        var result = regExpExec$2(rx, S);
        if (result === null) break;

        results.push(result);
        if (!global) break;

        var matchStr = String(result[0]);
        if (matchStr === '') rx.lastIndex = advanceStringIndex$2(S, toLength$5(rx.lastIndex), fullUnicode);
      }

      var accumulatedResult = '';
      var nextSourcePosition = 0;
      for (var i = 0; i < results.length; i++) {
        result = results[i];

        var matched = String(result[0]);
        var position = max$1(min$3(toInteger$3(result.index), S.length), 0);
        var captures = [];
        // NOTE: This is equivalent to
        //   captures = result.slice(1).map(maybeToString)
        // but for some reason `nativeSlice.call(result, 1, result.length)` (called in
        // the slice polyfill when slicing native arrays) "doesn't work" in safari 9 and
        // causes a crash (https://pastebin.com/N21QzeQA) when trying to debug it.
        for (var j = 1; j < result.length; j++) captures.push(maybeToString(result[j]));
        var namedCaptures = result.groups;
        if (functionalReplace) {
          var replacerArgs = [matched].concat(captures, position, S);
          if (namedCaptures !== undefined) replacerArgs.push(namedCaptures);
          var replacement = String(replaceValue.apply(undefined, replacerArgs));
        } else {
          replacement = getSubstitution(matched, S, position, captures, namedCaptures, replaceValue);
        }
        if (position >= nextSourcePosition) {
          accumulatedResult += S.slice(nextSourcePosition, position) + replacement;
          nextSourcePosition = position + matched.length;
        }
      }
      return accumulatedResult + S.slice(nextSourcePosition);
    }
  ];
}, !REPLACE_SUPPORTS_NAMED_GROUPS || !REPLACE_KEEPS_$0 || REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE);var LOGLEVEL = window_1.LOGLEVEL,
    console$1 = window_1.console;
var levels = {
  trace: 1,
  debug: 2,
  info: 3,
  warn: 4,
  error: 5,
  silent: 10
};
var currentLogLevelString = LOGLEVEL;
var currentLogLevelNumber = levels[currentLogLevelString] || levels.info;
var logger = {
  trace: function trace(message) {
    for (var _len = arguments.length, rest = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      rest[_key - 1] = arguments[_key];
    }

    return currentLogLevelNumber <= levels.trace && console$1.trace.apply(console$1, [message].concat(rest));
  },
  debug: function debug(message) {
    for (var _len2 = arguments.length, rest = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
      rest[_key2 - 1] = arguments[_key2];
    }

    return currentLogLevelNumber <= levels.debug && console$1.debug.apply(console$1, [message].concat(rest));
  },
  info: function info(message) {
    for (var _len3 = arguments.length, rest = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
      rest[_key3 - 1] = arguments[_key3];
    }

    return currentLogLevelNumber <= levels.info && console$1.info.apply(console$1, [message].concat(rest));
  },
  warn: function warn(message) {
    for (var _len4 = arguments.length, rest = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
      rest[_key4 - 1] = arguments[_key4];
    }

    return currentLogLevelNumber <= levels.warn && console$1.warn.apply(console$1, [message].concat(rest));
  },
  error: function error(message) {
    for (var _len5 = arguments.length, rest = new Array(_len5 > 1 ? _len5 - 1 : 0), _key5 = 1; _key5 < _len5; _key5++) {
      rest[_key5 - 1] = arguments[_key5];
    }

    return currentLogLevelNumber <= levels.error && console$1.error.apply(console$1, [message].concat(rest));
  },
  log: function log(message) {
    for (var _len6 = arguments.length, rest = new Array(_len6 > 1 ? _len6 - 1 : 0), _key6 = 1; _key6 < _len6; _key6++) {
      rest[_key6 - 1] = arguments[_key6];
    }

    return currentLogLevelNumber < levels.silent && console$1.log.apply(console$1, [message].concat(rest));
  }
};
var logged = new Set();
var once = function once(type) {
  return function (message) {
    if (logged.has(message)) return undefined;
    logged.add(message);

    for (var _len7 = arguments.length, rest = new Array(_len7 > 1 ? _len7 - 1 : 0), _key7 = 1; _key7 < _len7; _key7++) {
      rest[_key7 - 1] = arguments[_key7];
    }

    return logger[type].apply(logger, [message].concat(rest));
  };
};

once.clear = function () {
  return logged.clear();
};

once.trace = once('trace');
once.debug = once('debug');
once.info = once('info');
once.warn = once('warn');
once.error = once('error');
once.log = once('log');var $$d = _export;
var $find = arrayIteration.find;
var addToUnscopables$2 = addToUnscopables$4;

var FIND = 'find';
var SKIPS_HOLES$1 = true;

// Shouldn't skip holes
if (FIND in []) Array(1)[FIND](function () { SKIPS_HOLES$1 = false; });

// `Array.prototype.find` method
// https://tc39.es/ecma262/#sec-array.prototype.find
$$d({ target: 'Array', proto: true, forced: SKIPS_HOLES$1 }, {
  find: function find(callbackfn /* , that = undefined */) {
    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});

// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables$2(FIND);var types;

(function (types) {
  types["TAB"] = "tab";
  types["PANEL"] = "panel";
  types["TOOL"] = "tool";
  types["TOOLEXTRA"] = "toolextra";
  types["PREVIEW"] = "preview";
  types["NOTES_ELEMENT"] = "notes-element";
})(types || (types = {}));

function isSupportedType(type) {
  return !!Object.values(types).find(function (typeVal) {
    return typeVal === type;
  });
}function _classCallCheck$i(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
var AddonStore = function AddonStore() {
  var _this = this;

  _classCallCheck$i(this, AddonStore);

  this.loaders = {};
  this.elements = {};
  this.config = {};
  this.channel = void 0;
  this.promise = void 0;
  this.resolve = void 0;

  this.getChannel = function () {
    // this.channel should get overwritten by setChannel. If it wasn't called (e.g. in non-browser environment), throw.
    if (!_this.channel) {
      throw new Error('Accessing non-existent addons channel, see https://storybook.js.org/basics/faq/#why-is-there-no-addons-channel');
    }

    return _this.channel;
  };

  this.ready = function () {
    return _this.promise;
  };

  this.hasChannel = function () {
    return !!_this.channel;
  };

  this.setChannel = function (channel) {
    _this.channel = channel;

    _this.resolve();
  };

  this.getElements = function (type) {
    if (!_this.elements[type]) {
      _this.elements[type] = {};
    }

    return _this.elements[type];
  };

  this.addPanel = function (name, options) {
    _this.add(name, Object.assign({
      type: types.PANEL
    }, options));
  };

  this.add = function (name, addon) {
    var type = addon.type;

    var collection = _this.getElements(type);

    collection[name] = Object.assign({
      id: name
    }, addon);
  };

  this.setConfig = function (value) {
    Object.assign(_this.config, value);
  };

  this.getConfig = function () {
    return _this.config;
  };

  this.register = function (name, registerCallback) {
    if (_this.loaders[name]) {
      logger.warn("".concat(name, " was loaded twice, this could have bad side-effects"));
    }

    _this.loaders[name] = registerCallback;
  };

  this.loadAddons = function (api) {
    Object.values(_this.loaders).forEach(function (value) {
      return value(api);
    });
  };

  this.promise = new Promise(function (res) {
    _this.resolve = function () {
      return res(_this.getChannel());
    };
  });
}; // Enforce addons store to be a singleton

var KEY = '__STORYBOOK_ADDONS';

function getAddonsStore() {
  if (!window_1[KEY]) {
    window_1[KEY] = new AddonStore();
  }

  return window_1[KEY];
} // Exporting this twice in order to to be able to import it like { addons } instead of 'addons'
// prefer import { addons } from '@storybook/addons' over import addons from '@storybook/addons'
//
// See public_api.ts


var addons = getAddonsStore();var DESCRIPTORS$3 = descriptors;
var defineProperty$8 = objectDefineProperty.f;

var FunctionPrototype = Function.prototype;
var FunctionPrototypeToString = FunctionPrototype.toString;
var nameRE = /^\s*function ([^ (]*)/;
var NAME = 'name';

// Function instances `.name` property
// https://tc39.es/ecma262/#sec-function-instances-name
if (DESCRIPTORS$3 && !(NAME in FunctionPrototype)) {
  defineProperty$8(FunctionPrototype, NAME, {
    configurable: true,
    get: function () {
      try {
        return FunctionPrototypeToString.call(this).match(nameRE)[1];
      } catch (error) {
        return '';
      }
    }
  });
}var makeDecorator = function makeDecorator(_ref) {
  var name = _ref.name,
      parameterName = _ref.parameterName,
      wrapper = _ref.wrapper,
      _ref$skipIfNoParamete = _ref.skipIfNoParametersOrOptions,
      skipIfNoParametersOrOptions = _ref$skipIfNoParamete === void 0 ? false : _ref$skipIfNoParamete;

  var decorator = function decorator(options) {
    return function (getStory, context) {
      var parameters = context.parameters && context.parameters[parameterName];

      if (parameters && parameters.disable) {
        return getStory(context);
      }

      if (skipIfNoParametersOrOptions && !options && !parameters) {
        return getStory(context);
      }

      return wrapper(getStory, context, {
        options: options,
        parameters: parameters
      });
    };
  };

  return function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    // Used without options as .addDecorator(decorator)
    if (typeof args[0] === 'function') {
      return decorator().apply(void 0, args);
    }

    return function () {
      // Used as [.]addDecorator(decorator(options))
      if (arguments.length > 1) {
        // Used as [.]addDecorator(decorator(option1, option2))
        if (args.length > 1) {
          return decorator(args).apply(void 0, arguments);
        }

        return decorator.apply(void 0, args).apply(void 0, arguments);
      }

      throw new Error("Passing stories directly into ".concat(name, "() is not allowed,\n        instead use addDecorator(").concat(name, ") and pass options with the '").concat(parameterName, "' parameter"));
    };
  };
};function mockChannel() {
  var transport = {
    setHandler: function setHandler() {},
    send: function send() {}
  };
  return new Channel({
    transport: transport
  });
}var redefineAll$1 = redefineAll$4;
var getWeakData = internalMetadata.exports.getWeakData;
var anObject$5 = anObject$i;
var isObject$k = isObject$z;
var anInstance = anInstance$4;
var iterate$1 = iterate$5;
var ArrayIterationModule = arrayIteration;
var $has = has$i;
var InternalStateModule$1 = internalState;

var setInternalState$1 = InternalStateModule$1.set;
var internalStateGetterFor = InternalStateModule$1.getterFor;
var find$2 = ArrayIterationModule.find;
var findIndex$3 = ArrayIterationModule.findIndex;
var id = 0;

// fallback for uncaught frozen keys
var uncaughtFrozenStore = function (store) {
  return store.frozen || (store.frozen = new UncaughtFrozenStore());
};

var UncaughtFrozenStore = function () {
  this.entries = [];
};

var findUncaughtFrozen = function (store, key) {
  return find$2(store.entries, function (it) {
    return it[0] === key;
  });
};

UncaughtFrozenStore.prototype = {
  get: function (key) {
    var entry = findUncaughtFrozen(this, key);
    if (entry) return entry[1];
  },
  has: function (key) {
    return !!findUncaughtFrozen(this, key);
  },
  set: function (key, value) {
    var entry = findUncaughtFrozen(this, key);
    if (entry) entry[1] = value;
    else this.entries.push([key, value]);
  },
  'delete': function (key) {
    var index = findIndex$3(this.entries, function (it) {
      return it[0] === key;
    });
    if (~index) this.entries.splice(index, 1);
    return !!~index;
  }
};

var collectionWeak$1 = {
  getConstructor: function (wrapper, CONSTRUCTOR_NAME, IS_MAP, ADDER) {
    var C = wrapper(function (that, iterable) {
      anInstance(that, C, CONSTRUCTOR_NAME);
      setInternalState$1(that, {
        type: CONSTRUCTOR_NAME,
        id: id++,
        frozen: undefined
      });
      if (iterable != undefined) iterate$1(iterable, that[ADDER], { that: that, AS_ENTRIES: IS_MAP });
    });

    var getInternalState = internalStateGetterFor(CONSTRUCTOR_NAME);

    var define = function (that, key, value) {
      var state = getInternalState(that);
      var data = getWeakData(anObject$5(key), true);
      if (data === true) uncaughtFrozenStore(state).set(key, value);
      else data[state.id] = value;
      return that;
    };

    redefineAll$1(C.prototype, {
      // `{ WeakMap, WeakSet }.prototype.delete(key)` methods
      // https://tc39.es/ecma262/#sec-weakmap.prototype.delete
      // https://tc39.es/ecma262/#sec-weakset.prototype.delete
      'delete': function (key) {
        var state = getInternalState(this);
        if (!isObject$k(key)) return false;
        var data = getWeakData(key);
        if (data === true) return uncaughtFrozenStore(state)['delete'](key);
        return data && $has(data, state.id) && delete data[state.id];
      },
      // `{ WeakMap, WeakSet }.prototype.has(key)` methods
      // https://tc39.es/ecma262/#sec-weakmap.prototype.has
      // https://tc39.es/ecma262/#sec-weakset.prototype.has
      has: function has(key) {
        var state = getInternalState(this);
        if (!isObject$k(key)) return false;
        var data = getWeakData(key);
        if (data === true) return uncaughtFrozenStore(state).has(key);
        return data && $has(data, state.id);
      }
    });

    redefineAll$1(C.prototype, IS_MAP ? {
      // `WeakMap.prototype.get(key)` method
      // https://tc39.es/ecma262/#sec-weakmap.prototype.get
      get: function get(key) {
        var state = getInternalState(this);
        if (isObject$k(key)) {
          var data = getWeakData(key);
          if (data === true) return uncaughtFrozenStore(state).get(key);
          return data ? data[state.id] : undefined;
        }
      },
      // `WeakMap.prototype.set(key, value)` method
      // https://tc39.es/ecma262/#sec-weakmap.prototype.set
      set: function set(key, value) {
        return define(this, key, value);
      }
    } : {
      // `WeakSet.prototype.add(value)` method
      // https://tc39.es/ecma262/#sec-weakset.prototype.add
      add: function add(value) {
        return define(this, value, true);
      }
    });

    return C;
  }
};var global$5 = global$r;
var redefineAll = redefineAll$4;
var InternalMetadataModule = internalMetadata.exports;
var collection = collection$2;
var collectionWeak = collectionWeak$1;
var isObject$j = isObject$z;
var enforceIternalState = internalState.enforce;
var NATIVE_WEAK_MAP = nativeWeakMap;

var IS_IE11 = !global$5.ActiveXObject && 'ActiveXObject' in global$5;
// eslint-disable-next-line es/no-object-isextensible -- safe
var isExtensible = Object.isExtensible;
var InternalWeakMap;

var wrapper = function (init) {
  return function WeakMap() {
    return init(this, arguments.length ? arguments[0] : undefined);
  };
};

// `WeakMap` constructor
// https://tc39.es/ecma262/#sec-weakmap-constructor
var $WeakMap$1 = collection('WeakMap', wrapper, collectionWeak);

// IE11 WeakMap frozen keys fix
// We can't use feature detection because it crash some old IE builds
// https://github.com/zloirock/core-js/issues/485
if (NATIVE_WEAK_MAP && IS_IE11) {
  InternalWeakMap = collectionWeak.getConstructor(wrapper, 'WeakMap', true);
  InternalMetadataModule.REQUIRED = true;
  var WeakMapPrototype = $WeakMap$1.prototype;
  var nativeDelete = WeakMapPrototype['delete'];
  var nativeHas = WeakMapPrototype.has;
  var nativeGet = WeakMapPrototype.get;
  var nativeSet = WeakMapPrototype.set;
  redefineAll(WeakMapPrototype, {
    'delete': function (key) {
      if (isObject$j(key) && !isExtensible(key)) {
        var state = enforceIternalState(this);
        if (!state.frozen) state.frozen = new InternalWeakMap();
        return nativeDelete.call(this, key) || state.frozen['delete'](key);
      } return nativeDelete.call(this, key);
    },
    has: function has(key) {
      if (isObject$j(key) && !isExtensible(key)) {
        var state = enforceIternalState(this);
        if (!state.frozen) state.frozen = new InternalWeakMap();
        return nativeHas.call(this, key) || state.frozen.has(key);
      } return nativeHas.call(this, key);
    },
    get: function get(key) {
      if (isObject$j(key) && !isExtensible(key)) {
        var state = enforceIternalState(this);
        if (!state.frozen) state.frozen = new InternalWeakMap();
        return nativeHas.call(this, key) ? nativeGet.call(this, key) : state.frozen.get(key);
      } return nativeGet.call(this, key);
    },
    set: function set(key, value) {
      if (isObject$j(key) && !isExtensible(key)) {
        var state = enforceIternalState(this);
        if (!state.frozen) state.frozen = new InternalWeakMap();
        nativeHas.call(this, key) ? nativeSet.call(this, key, value) : state.frozen.set(key, value);
      } else nativeSet.call(this, key, value);
      return this;
    }
  });
}var $$c = _export;
var $includes = arrayIncludes$5.includes;
var addToUnscopables$1 = addToUnscopables$4;

// `Array.prototype.includes` method
// https://tc39.es/ecma262/#sec-array.prototype.includes
$$c({ target: 'Array', proto: true }, {
  includes: function includes(el /* , fromIndex = 0 */) {
    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
  }
});

// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables$1('includes');var isObject$i = isObject$z;
var classof$1 = classofRaw$1;
var wellKnownSymbol$3 = wellKnownSymbol$n;

var MATCH$1 = wellKnownSymbol$3('match');

// `IsRegExp` abstract operation
// https://tc39.es/ecma262/#sec-isregexp
var isRegexp = function (it) {
  var isRegExp;
  return isObject$i(it) && ((isRegExp = it[MATCH$1]) !== undefined ? !!isRegExp : classof$1(it) == 'RegExp');
};var isRegExp$3 = isRegexp;

var notARegexp = function (it) {
  if (isRegExp$3(it)) {
    throw TypeError("The method doesn't accept regular expressions");
  } return it;
};var wellKnownSymbol$2 = wellKnownSymbol$n;

var MATCH = wellKnownSymbol$2('match');

var correctIsRegexpLogic = function (METHOD_NAME) {
  var regexp = /./;
  try {
    '/./'[METHOD_NAME](regexp);
  } catch (error1) {
    try {
      regexp[MATCH] = false;
      return '/./'[METHOD_NAME](regexp);
    } catch (error2) { /* empty */ }
  } return false;
};var $$b = _export;
var notARegExp$1 = notARegexp;
var requireObjectCoercible$5 = requireObjectCoercible$a;
var correctIsRegExpLogic$1 = correctIsRegexpLogic;

// `String.prototype.includes` method
// https://tc39.es/ecma262/#sec-string.prototype.includes
$$b({ target: 'String', proto: true, forced: !correctIsRegExpLogic$1('includes') }, {
  includes: function includes(searchString /* , position = 0 */) {
    return !!~String(requireObjectCoercible$5(this))
      .indexOf(notARegExp$1(searchString), arguments.length > 1 ? arguments[1] : undefined);
  }
});var $$a = _export;
var $map = arrayIteration.map;
var arrayMethodHasSpeciesSupport = arrayMethodHasSpeciesSupport$4;

var HAS_SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('map');

// `Array.prototype.map` method
// https://tc39.es/ecma262/#sec-array.prototype.map
// with adding support of @@species
$$a({ target: 'Array', proto: true, forced: !HAS_SPECIES_SUPPORT }, {
  map: function map(callbackfn /* , thisArg */) {
    return $map(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});var $$9 = _export;
var $entries = objectToArray.entries;

// `Object.entries` method
// https://tc39.es/ecma262/#sec-object.entries
$$9({ target: 'Object', stat: true }, {
  entries: function entries(O) {
    return $entries(O);
  }
});var objectGetOwnPropertyNamesExternal = {};/* eslint-disable es/no-object-getownpropertynames -- safe */

var toIndexedObject$2 = toIndexedObject$9;
var $getOwnPropertyNames$1 = objectGetOwnPropertyNames.f;

var toString$6 = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return $getOwnPropertyNames$1(it);
  } catch (error) {
    return windowNames.slice();
  }
};

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
objectGetOwnPropertyNamesExternal.f = function getOwnPropertyNames(it) {
  return windowNames && toString$6.call(it) == '[object Window]'
    ? getWindowNames(it)
    : $getOwnPropertyNames$1(toIndexedObject$2(it));
};var wellKnownSymbolWrapped = {};var wellKnownSymbol$1 = wellKnownSymbol$n;

wellKnownSymbolWrapped.f = wellKnownSymbol$1;var path = path$2;
var has$7 = has$i;
var wrappedWellKnownSymbolModule$1 = wellKnownSymbolWrapped;
var defineProperty$7 = objectDefineProperty.f;

var defineWellKnownSymbol$2 = function (NAME) {
  var Symbol = path.Symbol || (path.Symbol = {});
  if (!has$7(Symbol, NAME)) defineProperty$7(Symbol, NAME, {
    value: wrappedWellKnownSymbolModule$1.f(NAME)
  });
};var $$8 = _export;
var global$4 = global$r;
var getBuiltIn = getBuiltIn$6;
var DESCRIPTORS$2 = descriptors;
var NATIVE_SYMBOL = nativeSymbol;
var USE_SYMBOL_AS_UID = useSymbolAsUid;
var fails$4 = fails$r;
var has$6 = has$i;
var isArray$n = isArray$r;
var isObject$h = isObject$z;
var anObject$4 = anObject$i;
var toObject$3 = toObject$b;
var toIndexedObject$1 = toIndexedObject$9;
var toPrimitive$1 = toPrimitive$5;
var createPropertyDescriptor = createPropertyDescriptor$5;
var nativeObjectCreate = objectCreate$1;
var objectKeys = objectKeys$4;
var getOwnPropertyNamesModule = objectGetOwnPropertyNames;
var getOwnPropertyNamesExternal = objectGetOwnPropertyNamesExternal;
var getOwnPropertySymbolsModule = objectGetOwnPropertySymbols;
var getOwnPropertyDescriptorModule = objectGetOwnPropertyDescriptor;
var definePropertyModule = objectDefineProperty;
var propertyIsEnumerableModule = objectPropertyIsEnumerable;
var createNonEnumerableProperty = createNonEnumerableProperty$a;
var redefine$1 = redefine$a.exports;
var shared$1 = shared$6.exports;
var sharedKey = sharedKey$4;
var hiddenKeys = hiddenKeys$6;
var uid = uid$4;
var wellKnownSymbol = wellKnownSymbol$n;
var wrappedWellKnownSymbolModule = wellKnownSymbolWrapped;
var defineWellKnownSymbol$1 = defineWellKnownSymbol$2;
var setToStringTag = setToStringTag$5;
var InternalStateModule = internalState;
var $forEach = arrayIteration.forEach;

var HIDDEN = sharedKey('hidden');
var SYMBOL = 'Symbol';
var PROTOTYPE = 'prototype';
var TO_PRIMITIVE = wellKnownSymbol('toPrimitive');
var setInternalState = InternalStateModule.set;
var getInternalState = InternalStateModule.getterFor(SYMBOL);
var ObjectPrototype = Object[PROTOTYPE];
var $Symbol = global$4.Symbol;
var $stringify = getBuiltIn('JSON', 'stringify');
var nativeGetOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
var nativeDefineProperty = definePropertyModule.f;
var nativeGetOwnPropertyNames = getOwnPropertyNamesExternal.f;
var nativePropertyIsEnumerable = propertyIsEnumerableModule.f;
var AllSymbols = shared$1('symbols');
var ObjectPrototypeSymbols = shared$1('op-symbols');
var StringToSymbolRegistry = shared$1('string-to-symbol-registry');
var SymbolToStringRegistry = shared$1('symbol-to-string-registry');
var WellKnownSymbolsStore = shared$1('wks');
var QObject = global$4.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var USE_SETTER = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDescriptor = DESCRIPTORS$2 && fails$4(function () {
  return nativeObjectCreate(nativeDefineProperty({}, 'a', {
    get: function () { return nativeDefineProperty(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (O, P, Attributes) {
  var ObjectPrototypeDescriptor = nativeGetOwnPropertyDescriptor(ObjectPrototype, P);
  if (ObjectPrototypeDescriptor) delete ObjectPrototype[P];
  nativeDefineProperty(O, P, Attributes);
  if (ObjectPrototypeDescriptor && O !== ObjectPrototype) {
    nativeDefineProperty(ObjectPrototype, P, ObjectPrototypeDescriptor);
  }
} : nativeDefineProperty;

var wrap = function (tag, description) {
  var symbol = AllSymbols[tag] = nativeObjectCreate($Symbol[PROTOTYPE]);
  setInternalState(symbol, {
    type: SYMBOL,
    tag: tag,
    description: description
  });
  if (!DESCRIPTORS$2) symbol.description = description;
  return symbol;
};

var isSymbol$8 = USE_SYMBOL_AS_UID ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return Object(it) instanceof $Symbol;
};

var $defineProperty = function defineProperty(O, P, Attributes) {
  if (O === ObjectPrototype) $defineProperty(ObjectPrototypeSymbols, P, Attributes);
  anObject$4(O);
  var key = toPrimitive$1(P, true);
  anObject$4(Attributes);
  if (has$6(AllSymbols, key)) {
    if (!Attributes.enumerable) {
      if (!has$6(O, HIDDEN)) nativeDefineProperty(O, HIDDEN, createPropertyDescriptor(1, {}));
      O[HIDDEN][key] = true;
    } else {
      if (has$6(O, HIDDEN) && O[HIDDEN][key]) O[HIDDEN][key] = false;
      Attributes = nativeObjectCreate(Attributes, { enumerable: createPropertyDescriptor(0, false) });
    } return setSymbolDescriptor(O, key, Attributes);
  } return nativeDefineProperty(O, key, Attributes);
};

var $defineProperties = function defineProperties(O, Properties) {
  anObject$4(O);
  var properties = toIndexedObject$1(Properties);
  var keys = objectKeys(properties).concat($getOwnPropertySymbols(properties));
  $forEach(keys, function (key) {
    if (!DESCRIPTORS$2 || $propertyIsEnumerable.call(properties, key)) $defineProperty(O, key, properties[key]);
  });
  return O;
};

var $create = function create(O, Properties) {
  return Properties === undefined ? nativeObjectCreate(O) : $defineProperties(nativeObjectCreate(O), Properties);
};

var $propertyIsEnumerable = function propertyIsEnumerable(V) {
  var P = toPrimitive$1(V, true);
  var enumerable = nativePropertyIsEnumerable.call(this, P);
  if (this === ObjectPrototype && has$6(AllSymbols, P) && !has$6(ObjectPrototypeSymbols, P)) return false;
  return enumerable || !has$6(this, P) || !has$6(AllSymbols, P) || has$6(this, HIDDEN) && this[HIDDEN][P] ? enumerable : true;
};

var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(O, P) {
  var it = toIndexedObject$1(O);
  var key = toPrimitive$1(P, true);
  if (it === ObjectPrototype && has$6(AllSymbols, key) && !has$6(ObjectPrototypeSymbols, key)) return;
  var descriptor = nativeGetOwnPropertyDescriptor(it, key);
  if (descriptor && has$6(AllSymbols, key) && !(has$6(it, HIDDEN) && it[HIDDEN][key])) {
    descriptor.enumerable = true;
  }
  return descriptor;
};

var $getOwnPropertyNames = function getOwnPropertyNames(O) {
  var names = nativeGetOwnPropertyNames(toIndexedObject$1(O));
  var result = [];
  $forEach(names, function (key) {
    if (!has$6(AllSymbols, key) && !has$6(hiddenKeys, key)) result.push(key);
  });
  return result;
};

var $getOwnPropertySymbols = function getOwnPropertySymbols(O) {
  var IS_OBJECT_PROTOTYPE = O === ObjectPrototype;
  var names = nativeGetOwnPropertyNames(IS_OBJECT_PROTOTYPE ? ObjectPrototypeSymbols : toIndexedObject$1(O));
  var result = [];
  $forEach(names, function (key) {
    if (has$6(AllSymbols, key) && (!IS_OBJECT_PROTOTYPE || has$6(ObjectPrototype, key))) {
      result.push(AllSymbols[key]);
    }
  });
  return result;
};

// `Symbol` constructor
// https://tc39.es/ecma262/#sec-symbol-constructor
if (!NATIVE_SYMBOL) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor');
    var description = !arguments.length || arguments[0] === undefined ? undefined : String(arguments[0]);
    var tag = uid(description);
    var setter = function (value) {
      if (this === ObjectPrototype) setter.call(ObjectPrototypeSymbols, value);
      if (has$6(this, HIDDEN) && has$6(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDescriptor(this, tag, createPropertyDescriptor(1, value));
    };
    if (DESCRIPTORS$2 && USE_SETTER) setSymbolDescriptor(ObjectPrototype, tag, { configurable: true, set: setter });
    return wrap(tag, description);
  };

  redefine$1($Symbol[PROTOTYPE], 'toString', function toString() {
    return getInternalState(this).tag;
  });

  redefine$1($Symbol, 'withoutSetter', function (description) {
    return wrap(uid(description), description);
  });

  propertyIsEnumerableModule.f = $propertyIsEnumerable;
  definePropertyModule.f = $defineProperty;
  getOwnPropertyDescriptorModule.f = $getOwnPropertyDescriptor;
  getOwnPropertyNamesModule.f = getOwnPropertyNamesExternal.f = $getOwnPropertyNames;
  getOwnPropertySymbolsModule.f = $getOwnPropertySymbols;

  wrappedWellKnownSymbolModule.f = function (name) {
    return wrap(wellKnownSymbol(name), name);
  };

  if (DESCRIPTORS$2) {
    // https://github.com/tc39/proposal-Symbol-description
    nativeDefineProperty($Symbol[PROTOTYPE], 'description', {
      configurable: true,
      get: function description() {
        return getInternalState(this).description;
      }
    });
    {
      redefine$1(ObjectPrototype, 'propertyIsEnumerable', $propertyIsEnumerable, { unsafe: true });
    }
  }
}

$$8({ global: true, wrap: true, forced: !NATIVE_SYMBOL, sham: !NATIVE_SYMBOL }, {
  Symbol: $Symbol
});

$forEach(objectKeys(WellKnownSymbolsStore), function (name) {
  defineWellKnownSymbol$1(name);
});

$$8({ target: SYMBOL, stat: true, forced: !NATIVE_SYMBOL }, {
  // `Symbol.for` method
  // https://tc39.es/ecma262/#sec-symbol.for
  'for': function (key) {
    var string = String(key);
    if (has$6(StringToSymbolRegistry, string)) return StringToSymbolRegistry[string];
    var symbol = $Symbol(string);
    StringToSymbolRegistry[string] = symbol;
    SymbolToStringRegistry[symbol] = string;
    return symbol;
  },
  // `Symbol.keyFor` method
  // https://tc39.es/ecma262/#sec-symbol.keyfor
  keyFor: function keyFor(sym) {
    if (!isSymbol$8(sym)) throw TypeError(sym + ' is not a symbol');
    if (has$6(SymbolToStringRegistry, sym)) return SymbolToStringRegistry[sym];
  },
  useSetter: function () { USE_SETTER = true; },
  useSimple: function () { USE_SETTER = false; }
});

$$8({ target: 'Object', stat: true, forced: !NATIVE_SYMBOL, sham: !DESCRIPTORS$2 }, {
  // `Object.create` method
  // https://tc39.es/ecma262/#sec-object.create
  create: $create,
  // `Object.defineProperty` method
  // https://tc39.es/ecma262/#sec-object.defineproperty
  defineProperty: $defineProperty,
  // `Object.defineProperties` method
  // https://tc39.es/ecma262/#sec-object.defineproperties
  defineProperties: $defineProperties,
  // `Object.getOwnPropertyDescriptor` method
  // https://tc39.es/ecma262/#sec-object.getownpropertydescriptors
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor
});

$$8({ target: 'Object', stat: true, forced: !NATIVE_SYMBOL }, {
  // `Object.getOwnPropertyNames` method
  // https://tc39.es/ecma262/#sec-object.getownpropertynames
  getOwnPropertyNames: $getOwnPropertyNames,
  // `Object.getOwnPropertySymbols` method
  // https://tc39.es/ecma262/#sec-object.getownpropertysymbols
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
// https://bugs.chromium.org/p/v8/issues/detail?id=3443
$$8({ target: 'Object', stat: true, forced: fails$4(function () { getOwnPropertySymbolsModule.f(1); }) }, {
  getOwnPropertySymbols: function getOwnPropertySymbols(it) {
    return getOwnPropertySymbolsModule.f(toObject$3(it));
  }
});

// `JSON.stringify` method behavior with symbols
// https://tc39.es/ecma262/#sec-json.stringify
if ($stringify) {
  var FORCED_JSON_STRINGIFY = !NATIVE_SYMBOL || fails$4(function () {
    var symbol = $Symbol();
    // MS Edge converts symbol values to JSON as {}
    return $stringify([symbol]) != '[null]'
      // WebKit converts symbol values to JSON as null
      || $stringify({ a: symbol }) != '{}'
      // V8 throws on boxed symbols
      || $stringify(Object(symbol)) != '{}';
  });

  $$8({ target: 'JSON', stat: true, forced: FORCED_JSON_STRINGIFY }, {
    // eslint-disable-next-line no-unused-vars -- required for `.length`
    stringify: function stringify(it, replacer, space) {
      var args = [it];
      var index = 1;
      var $replacer;
      while (arguments.length > index) args.push(arguments[index++]);
      $replacer = replacer;
      if (!isObject$h(replacer) && it === undefined || isSymbol$8(it)) return; // IE8 returns string on undefined
      if (!isArray$n(replacer)) replacer = function (key, value) {
        if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
        if (!isSymbol$8(value)) return value;
      };
      args[1] = replacer;
      return $stringify.apply(null, args);
    }
  });
}

// `Symbol.prototype[@@toPrimitive]` method
// https://tc39.es/ecma262/#sec-symbol.prototype-@@toprimitive
if (!$Symbol[PROTOTYPE][TO_PRIMITIVE]) {
  createNonEnumerableProperty($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
}
// `Symbol.prototype[@@toStringTag]` property
// https://tc39.es/ecma262/#sec-symbol.prototype-@@tostringtag
setToStringTag($Symbol, SYMBOL);

hiddenKeys[HIDDEN] = true;var $$7 = _export;
var DESCRIPTORS$1 = descriptors;
var global$3 = global$r;
var has$5 = has$i;
var isObject$g = isObject$z;
var defineProperty$6 = objectDefineProperty.f;
var copyConstructorProperties = copyConstructorProperties$2;

var NativeSymbol = global$3.Symbol;

if (DESCRIPTORS$1 && typeof NativeSymbol == 'function' && (!('description' in NativeSymbol.prototype) ||
  // Safari 12 bug
  NativeSymbol().description !== undefined
)) {
  var EmptyStringDescriptionStore = {};
  // wrap Symbol constructor for correct work with undefined description
  var SymbolWrapper = function Symbol() {
    var description = arguments.length < 1 || arguments[0] === undefined ? undefined : String(arguments[0]);
    var result = this instanceof SymbolWrapper
      ? new NativeSymbol(description)
      // in Edge 13, String(Symbol(undefined)) === 'Symbol(undefined)'
      : description === undefined ? NativeSymbol() : NativeSymbol(description);
    if (description === '') EmptyStringDescriptionStore[result] = true;
    return result;
  };
  copyConstructorProperties(SymbolWrapper, NativeSymbol);
  var symbolPrototype = SymbolWrapper.prototype = NativeSymbol.prototype;
  symbolPrototype.constructor = SymbolWrapper;

  var symbolToString$1 = symbolPrototype.toString;
  var native = String(NativeSymbol('test')) == 'Symbol(test)';
  var regexp = /^Symbol\((.*)\)[^)]+$/;
  defineProperty$6(symbolPrototype, 'description', {
    configurable: true,
    get: function description() {
      var symbol = isObject$g(this) ? this.valueOf() : this;
      var string = symbolToString$1.call(symbol);
      if (has$5(EmptyStringDescriptionStore, symbol)) return '';
      var desc = native ? string.slice(7, -1) : string.replace(regexp, '$1');
      return desc === '' ? undefined : desc;
    }
  });

  $$7({ global: true, forced: true }, {
    Symbol: SymbolWrapper
  });
}var defineWellKnownSymbol = defineWellKnownSymbol$2;

// `Symbol.iterator` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.iterator
defineWellKnownSymbol('iterator');var anObject$3 = anObject$i;
var iteratorClose = iteratorClose$2;

// call something on iterator step with safe closing on error
var callWithSafeIterationClosing$1 = function (iterator, fn, value, ENTRIES) {
  try {
    return ENTRIES ? fn(anObject$3(value)[0], value[1]) : fn(value);
  } catch (error) {
    iteratorClose(iterator);
    throw error;
  }
};var bind$5 = functionBindContext;
var toObject$2 = toObject$b;
var callWithSafeIterationClosing = callWithSafeIterationClosing$1;
var isArrayIteratorMethod = isArrayIteratorMethod$2;
var toLength$4 = toLength$b;
var createProperty = createProperty$3;
var getIteratorMethod = getIteratorMethod$2;

// `Array.from` method implementation
// https://tc39.es/ecma262/#sec-array.from
var arrayFrom = function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
  var O = toObject$2(arrayLike);
  var C = typeof this == 'function' ? this : Array;
  var argumentsLength = arguments.length;
  var mapfn = argumentsLength > 1 ? arguments[1] : undefined;
  var mapping = mapfn !== undefined;
  var iteratorMethod = getIteratorMethod(O);
  var index = 0;
  var length, result, step, iterator, next, value;
  if (mapping) mapfn = bind$5(mapfn, argumentsLength > 2 ? arguments[2] : undefined, 2);
  // if the target is not iterable or it's an array with the default iterator - use a simple case
  if (iteratorMethod != undefined && !(C == Array && isArrayIteratorMethod(iteratorMethod))) {
    iterator = iteratorMethod.call(O);
    next = iterator.next;
    result = new C();
    for (;!(step = next.call(iterator)).done; index++) {
      value = mapping ? callWithSafeIterationClosing(iterator, mapfn, [step.value, index], true) : step.value;
      createProperty(result, index, value);
    }
  } else {
    length = toLength$4(O.length);
    result = new C(length);
    for (;length > index; index++) {
      value = mapping ? mapfn(O[index], index) : O[index];
      createProperty(result, index, value);
    }
  }
  result.length = index;
  return result;
};var $$6 = _export;
var from = arrayFrom;
var checkCorrectnessOfIteration = checkCorrectnessOfIteration$3;

var INCORRECT_ITERATION = !checkCorrectnessOfIteration(function (iterable) {
  // eslint-disable-next-line es/no-array-from -- required for testing
  Array.from(iterable);
});

// `Array.from` method
// https://tc39.es/ecma262/#sec-array.from
$$6({ target: 'Array', stat: true, forced: INCORRECT_ITERATION }, {
  from: from
});var events; // Enables: `import Events from ...`

(function (events) {
  events["CHANNEL_CREATED"] = "channelCreated";
  events["STORY_SPECIFIED"] = "storySpecified";
  events["SET_STORIES"] = "setStories";
  events["SET_CURRENT_STORY"] = "setCurrentStory";
  events["CURRENT_STORY_WAS_SET"] = "currentStoryWasSet";
  events["FORCE_RE_RENDER"] = "forceReRender";
  events["STORY_CHANGED"] = "storyChanged";
  events["STORY_UNCHANGED"] = "storyUnchanged";
  events["STORY_RENDERED"] = "storyRendered";
  events["STORY_MISSING"] = "storyMissing";
  events["STORY_ERRORED"] = "storyErrored";
  events["STORY_THREW_EXCEPTION"] = "storyThrewException";
  events["UPDATE_STORY_ARGS"] = "updateStoryArgs";
  events["STORY_ARGS_UPDATED"] = "storyArgsUpdated";
  events["RESET_STORY_ARGS"] = "resetStoryArgs";
  events["UPDATE_GLOBALS"] = "updateGlobals";
  events["GLOBALS_UPDATED"] = "globalsUpdated";
  events["REGISTER_SUBSCRIPTION"] = "registerSubscription";
  events["PREVIEW_KEYDOWN"] = "previewKeydown";
  events["SELECT_STORY"] = "selectStory";
  events["STORIES_COLLAPSE_ALL"] = "storiesCollapseAll";
  events["STORIES_EXPAND_ALL"] = "storiesExpandAll";
  events["DOCS_RENDERED"] = "docsRendered";
  events["SHARED_STATE_CHANGED"] = "sharedStateChanged";
  events["SHARED_STATE_SET"] = "sharedStateSet";
  events["NAVIGATE_URL"] = "navigateUrl";
})(events || (events = {}));

var Events = events; // Enables: `import * as Events from ...` or `import { CHANNEL_CREATED } as Events from ...`
// This is the preferred method

var CHANNEL_CREATED = events.CHANNEL_CREATED,
    STORY_SPECIFIED = events.STORY_SPECIFIED,
    SET_STORIES = events.SET_STORIES,
    SET_CURRENT_STORY = events.SET_CURRENT_STORY,
    CURRENT_STORY_WAS_SET = events.CURRENT_STORY_WAS_SET,
    FORCE_RE_RENDER = events.FORCE_RE_RENDER,
    STORY_CHANGED = events.STORY_CHANGED,
    STORY_UNCHANGED = events.STORY_UNCHANGED,
    STORY_RENDERED = events.STORY_RENDERED,
    STORY_MISSING = events.STORY_MISSING,
    STORY_ERRORED = events.STORY_ERRORED,
    STORY_THREW_EXCEPTION = events.STORY_THREW_EXCEPTION,
    UPDATE_STORY_ARGS = events.UPDATE_STORY_ARGS,
    STORY_ARGS_UPDATED = events.STORY_ARGS_UPDATED,
    RESET_STORY_ARGS = events.RESET_STORY_ARGS,
    UPDATE_GLOBALS = events.UPDATE_GLOBALS,
    GLOBALS_UPDATED = events.GLOBALS_UPDATED,
    REGISTER_SUBSCRIPTION = events.REGISTER_SUBSCRIPTION,
    PREVIEW_KEYDOWN = events.PREVIEW_KEYDOWN,
    SELECT_STORY = events.SELECT_STORY,
    STORIES_COLLAPSE_ALL = events.STORIES_COLLAPSE_ALL,
    STORIES_EXPAND_ALL = events.STORIES_EXPAND_ALL,
    DOCS_RENDERED = events.DOCS_RENDERED,
    SHARED_STATE_CHANGED = events.SHARED_STATE_CHANGED,
    SHARED_STATE_SET = events.SHARED_STATE_SET,
    NAVIGATE_URL = events.NAVIGATE_URL;var esm$1=/*#__PURE__*/Object.freeze({__proto__:null,'default': Events,CHANNEL_CREATED: CHANNEL_CREATED,STORY_SPECIFIED: STORY_SPECIFIED,SET_STORIES: SET_STORIES,SET_CURRENT_STORY: SET_CURRENT_STORY,CURRENT_STORY_WAS_SET: CURRENT_STORY_WAS_SET,FORCE_RE_RENDER: FORCE_RE_RENDER,STORY_CHANGED: STORY_CHANGED,STORY_UNCHANGED: STORY_UNCHANGED,STORY_RENDERED: STORY_RENDERED,STORY_MISSING: STORY_MISSING,STORY_ERRORED: STORY_ERRORED,STORY_THREW_EXCEPTION: STORY_THREW_EXCEPTION,UPDATE_STORY_ARGS: UPDATE_STORY_ARGS,STORY_ARGS_UPDATED: STORY_ARGS_UPDATED,RESET_STORY_ARGS: RESET_STORY_ARGS,UPDATE_GLOBALS: UPDATE_GLOBALS,GLOBALS_UPDATED: GLOBALS_UPDATED,REGISTER_SUBSCRIPTION: REGISTER_SUBSCRIPTION,PREVIEW_KEYDOWN: PREVIEW_KEYDOWN,SELECT_STORY: SELECT_STORY,STORIES_COLLAPSE_ALL: STORIES_COLLAPSE_ALL,STORIES_EXPAND_ALL: STORIES_EXPAND_ALL,DOCS_RENDERED: DOCS_RENDERED,SHARED_STATE_CHANGED: SHARED_STATE_CHANGED,SHARED_STATE_SET: SHARED_STATE_SET,NAVIGATE_URL: NAVIGATE_URL});function _slicedToArray$6(arr, i) { return _arrayWithHoles$6(arr) || _iterableToArrayLimit$6(arr, i) || _unsupportedIterableToArray$5(arr, i) || _nonIterableRest$6(); }

function _nonIterableRest$6() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArrayLimit$6(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles$6(arr) { if (Array.isArray(arr)) return arr; }

function _toConsumableArray$4(arr) { return _arrayWithoutHoles$4(arr) || _iterableToArray$4(arr) || _unsupportedIterableToArray$5(arr) || _nonIterableSpread$4(); }

function _nonIterableSpread$4() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray$5(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$5(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$5(o, minLen); }

function _iterableToArray$4(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles$4(arr) { if (Array.isArray(arr)) return _arrayLikeToArray$5(arr); }

function _arrayLikeToArray$5(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck$h(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties$3(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass$e(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$3(Constructor.prototype, protoProps); if (staticProps) _defineProperties$3(Constructor, staticProps); return Constructor; }
var globalWindow = window_1.window;
var RenderEvents = [STORY_RENDERED, DOCS_RENDERED];
var HooksContext = /*#__PURE__*/function () {
  function HooksContext() {
    var _this = this;

    _classCallCheck$h(this, HooksContext);

    this.hookListsMap = void 0;
    this.mountedDecorators = void 0;
    this.prevMountedDecorators = void 0;
    this.currentHooks = void 0;
    this.nextHookIndex = void 0;
    this.currentPhase = void 0;
    this.currentEffects = void 0;
    this.prevEffects = void 0;
    this.currentDecoratorName = void 0;
    this.hasUpdates = void 0;
    this.currentContext = void 0;

    this.renderListener = function () {
      _this.triggerEffects();

      _this.currentContext = null;

      _this.removeRenderListeners();
    };

    this.init();
  }

  _createClass$e(HooksContext, [{
    key: "init",
    value: function init() {
      this.hookListsMap = new WeakMap();
      this.mountedDecorators = new Set();
      this.prevMountedDecorators = this.mountedDecorators;
      this.currentHooks = [];
      this.nextHookIndex = 0;
      this.currentPhase = 'NONE';
      this.currentEffects = [];
      this.prevEffects = [];
      this.currentDecoratorName = null;
      this.hasUpdates = false;
      this.currentContext = null;
    }
  }, {
    key: "clean",
    value: function clean() {
      this.prevEffects.forEach(function (effect) {
        if (effect.destroy) {
          effect.destroy();
        }
      });
      this.init();
      this.removeRenderListeners();
    }
  }, {
    key: "getNextHook",
    value: function getNextHook() {
      var hook = this.currentHooks[this.nextHookIndex];
      this.nextHookIndex += 1;
      return hook;
    }
  }, {
    key: "triggerEffects",
    value: function triggerEffects() {
      var _this2 = this;

      // destroy removed effects
      this.prevEffects.forEach(function (effect) {
        if (!_this2.currentEffects.includes(effect) && effect.destroy) {
          effect.destroy();
        }
      }); // trigger added effects

      this.currentEffects.forEach(function (effect) {
        if (!_this2.prevEffects.includes(effect)) {
          // eslint-disable-next-line no-param-reassign
          effect.destroy = effect.create();
        }
      });
      this.prevEffects = this.currentEffects;
      this.currentEffects = [];
    }
  }, {
    key: "addRenderListeners",
    value: function addRenderListeners() {
      var _this3 = this;

      this.removeRenderListeners();
      var channel = addons.getChannel();
      RenderEvents.forEach(function (e) {
        return channel.on(e, _this3.renderListener);
      });
    }
  }, {
    key: "removeRenderListeners",
    value: function removeRenderListeners() {
      var _this4 = this;

      var channel = addons.getChannel();
      RenderEvents.forEach(function (e) {
        return channel.removeListener(e, _this4.renderListener);
      });
    }
  }]);

  return HooksContext;
}();

var hookify = function hookify(fn) {
  return function () {
    var _ref = typeof (arguments.length <= 0 ? undefined : arguments[0]) === 'function' ? arguments.length <= 1 ? undefined : arguments[1] : arguments.length <= 0 ? undefined : arguments[0],
        hooks = _ref.hooks;

    var prevPhase = hooks.currentPhase;
    var prevHooks = hooks.currentHooks;
    var prevNextHookIndex = hooks.nextHookIndex;
    var prevDecoratorName = hooks.currentDecoratorName;
    hooks.currentDecoratorName = fn.name;

    if (hooks.prevMountedDecorators.has(fn)) {
      hooks.currentPhase = 'UPDATE';
      hooks.currentHooks = hooks.hookListsMap.get(fn) || [];
    } else {
      hooks.currentPhase = 'MOUNT';
      hooks.currentHooks = [];
      hooks.hookListsMap.set(fn, hooks.currentHooks);
      hooks.prevMountedDecorators.add(fn);
    }

    hooks.nextHookIndex = 0;
    var prevContext = globalWindow.STORYBOOK_HOOKS_CONTEXT;
    globalWindow.STORYBOOK_HOOKS_CONTEXT = hooks;
    var result = fn.apply(void 0, arguments);
    globalWindow.STORYBOOK_HOOKS_CONTEXT = prevContext;

    if (hooks.currentPhase === 'UPDATE' && hooks.getNextHook() != null) {
      throw new Error('Rendered fewer hooks than expected. This may be caused by an accidental early return statement.');
    }

    hooks.currentPhase = prevPhase;
    hooks.currentHooks = prevHooks;
    hooks.nextHookIndex = prevNextHookIndex;
    hooks.currentDecoratorName = prevDecoratorName;
    return result;
  };
}; // Counter to prevent infinite loops.


var numberOfRenders = 0;
var RENDER_LIMIT = 25;
var applyHooks = function applyHooks(applyDecorators) {
  return function (getStory, decorators) {
    var decorated = applyDecorators(hookify(getStory), decorators.map(hookify));
    return function (context) {
      var hooks = context.hooks;
      hooks.prevMountedDecorators = hooks.mountedDecorators;
      hooks.mountedDecorators = new Set([getStory].concat(_toConsumableArray$4(decorators)));
      hooks.currentContext = context;
      hooks.hasUpdates = false;
      var result = decorated(context);
      numberOfRenders = 1;

      while (hooks.hasUpdates) {
        hooks.hasUpdates = false;
        hooks.currentEffects = [];
        result = decorated(context);
        numberOfRenders += 1;

        if (numberOfRenders > RENDER_LIMIT) {
          throw new Error('Too many re-renders. Storybook limits the number of renders to prevent an infinite loop.');
        }
      }

      hooks.addRenderListeners();
      return result;
    };
  };
};

var areDepsEqual = function areDepsEqual(deps, nextDeps) {
  return deps.length === nextDeps.length && deps.every(function (dep, i) {
    return dep === nextDeps[i];
  });
};

var invalidHooksError = function invalidHooksError() {
  return new Error('Storybook preview hooks can only be called inside decorators and story functions.');
};

function getHooksContextOrNull() {
  return globalWindow.STORYBOOK_HOOKS_CONTEXT || null;
}

function getHooksContextOrThrow() {
  var hooks = getHooksContextOrNull();

  if (hooks == null) {
    throw invalidHooksError();
  }

  return hooks;
}

function useHook(name, callback, deps) {
  var hooks = getHooksContextOrThrow();

  if (hooks.currentPhase === 'MOUNT') {
    if (deps != null && !Array.isArray(deps)) {
      logger.warn("".concat(name, " received a final argument that is not an array (instead, received ").concat(deps, "). When specified, the final argument must be an array."));
    }

    var _hook = {
      name: name,
      deps: deps
    };
    hooks.currentHooks.push(_hook);
    callback(_hook);
    return _hook;
  }

  if (hooks.currentPhase === 'UPDATE') {
    var _hook2 = hooks.getNextHook();

    if (_hook2 == null) {
      throw new Error('Rendered more hooks than during the previous render.');
    }

    if (_hook2.name !== name) {
      logger.warn("Storybook has detected a change in the order of Hooks".concat(hooks.currentDecoratorName ? " called by ".concat(hooks.currentDecoratorName) : '', ". This will lead to bugs and errors if not fixed."));
    }

    if (deps != null && _hook2.deps == null) {
      logger.warn("".concat(name, " received a final argument during this render, but not during the previous render. Even though the final argument is optional, its type cannot change between renders."));
    }

    if (deps != null && _hook2.deps != null && deps.length !== _hook2.deps.length) {
      logger.warn("The final argument passed to ".concat(name, " changed size between renders. The order and size of this array must remain constant.\nPrevious: ").concat(_hook2.deps, "\nIncoming: ").concat(deps));
    }

    if (deps == null || _hook2.deps == null || !areDepsEqual(deps, _hook2.deps)) {
      callback(_hook2);
      _hook2.deps = deps;
    }

    return _hook2;
  }

  throw invalidHooksError();
}

function useMemoLike(name, nextCreate, deps) {
  var _useHook = useHook(name, function (hook) {
    // eslint-disable-next-line no-param-reassign
    hook.memoizedState = nextCreate();
  }, deps),
      memoizedState = _useHook.memoizedState;

  return memoizedState;
}
/* Returns a memoized value, see https://reactjs.org/docs/hooks-reference.html#usememo */


function useMemo(nextCreate, deps) {
  return useMemoLike('useMemo', nextCreate, deps);
}
/* Returns a memoized callback, see https://reactjs.org/docs/hooks-reference.html#usecallback */

function useCallback(callback, deps) {
  return useMemoLike('useCallback', function () {
    return callback;
  }, deps);
}

function useRefLike(name, initialValue) {
  return useMemoLike(name, function () {
    return {
      current: initialValue
    };
  }, []);
}
/* Returns a mutable ref object, see https://reactjs.org/docs/hooks-reference.html#useref */


function useRef(initialValue) {
  return useRefLike('useRef', initialValue);
}

function triggerUpdate() {
  var hooks = getHooksContextOrNull(); // Rerun getStory if updates were triggered synchronously, force rerender otherwise

  if (hooks != null && hooks.currentPhase !== 'NONE') {
    hooks.hasUpdates = true;
  } else {
    try {
      addons.getChannel().emit(FORCE_RE_RENDER);
    } catch (e) {
      logger.warn('State updates of Storybook preview hooks work only in browser');
    }
  }
}

function useStateLike(name, initialState) {
  var stateRef = useRefLike(name, // @ts-ignore S type should never be function, but there's no way to tell that to TypeScript
  typeof initialState === 'function' ? initialState() : initialState);

  var setState = function setState(update) {
    // @ts-ignore S type should never be function, but there's no way to tell that to TypeScript
    stateRef.current = typeof update === 'function' ? update(stateRef.current) : update;
    triggerUpdate();
  };

  return [stateRef.current, setState];
}
/* Returns a stateful value, and a function to update it, see https://reactjs.org/docs/hooks-reference.html#usestate */


function useState(initialState) {
  return useStateLike('useState', initialState);
}
/* A redux-like alternative to useState, see https://reactjs.org/docs/hooks-reference.html#usereducer */

function useReducer(reducer, initialArg, init) {
  var initialState = init != null ? function () {
    return init(initialArg);
  } : initialArg;

  var _useStateLike = useStateLike('useReducer', initialState),
      _useStateLike2 = _slicedToArray$6(_useStateLike, 2),
      state = _useStateLike2[0],
      setState = _useStateLike2[1];

  var dispatch = function dispatch(action) {
    return setState(function (prevState) {
      return reducer(prevState, action);
    });
  };

  return [state, dispatch];
}
/*
  Triggers a side effect, see https://reactjs.org/docs/hooks-reference.html#usestate
  Effects are triggered synchronously after rendering the story
*/

function useEffect(create, deps) {
  var hooks = getHooksContextOrThrow();
  var effect = useMemoLike('useEffect', function () {
    return {
      create: create
    };
  }, deps);

  if (!hooks.currentEffects.includes(effect)) {
    hooks.currentEffects.push(effect);
  }
}

/* Accepts a map of Storybook channel event listeners, returns an emit function */
function useChannel(eventMap) {
  var deps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var channel = addons.getChannel();
  useEffect(function () {
    Object.entries(eventMap).forEach(function (_ref2) {
      var _ref3 = _slicedToArray$6(_ref2, 2),
          type = _ref3[0],
          listener = _ref3[1];

      return channel.on(type, listener);
    });
    return function () {
      Object.entries(eventMap).forEach(function (_ref4) {
        var _ref5 = _slicedToArray$6(_ref4, 2),
            type = _ref5[0],
            listener = _ref5[1];

        return channel.removeListener(type, listener);
      });
    };
  }, [].concat(_toConsumableArray$4(Object.keys(eventMap)), _toConsumableArray$4(deps)));
  return useCallback(channel.emit.bind(channel), [channel]);
}
/* Returns current story context */

function useStoryContext() {
  var _getHooksContextOrThr = getHooksContextOrThrow(),
      currentContext = _getHooksContextOrThr.currentContext;

  if (currentContext == null) {
    throw invalidHooksError();
  }

  return currentContext;
}
/* Returns current value of a story parameter */

function useParameter(parameterKey, defaultValue) {
  var _useStoryContext = useStoryContext(),
      parameters = _useStoryContext.parameters;

  if (parameterKey) {
    return parameters[parameterKey] || defaultValue;
  }

  return undefined;
}
/* Returns current value of story args */

function useArgs() {
  var channel = addons.getChannel();

  var _useStoryContext2 = useStoryContext(),
      storyId = _useStoryContext2.id,
      args = _useStoryContext2.args;

  var updateArgs = useCallback(function (updatedArgs) {
    return channel.emit(UPDATE_STORY_ARGS, {
      storyId: storyId,
      updatedArgs: updatedArgs
    });
  }, [channel, storyId]);
  var resetArgs = useCallback(function (argNames) {
    return channel.emit(RESET_STORY_ARGS, {
      storyId: storyId,
      argNames: argNames
    });
  }, [channel, storyId]);
  return [args, updateArgs, resetArgs];
}
/* Returns current value of global args */

function useGlobals() {
  var channel = addons.getChannel();

  var _useStoryContext3 = useStoryContext(),
      globals = _useStoryContext3.globals;

  var updateGlobals = useCallback(function (newGlobals) {
    return channel.emit(UPDATE_GLOBALS, {
      globals: newGlobals
    });
  }, [channel]);
  return [globals, updateGlobals];
}// There can only be 1 default export per entry point and it has to be directly from public_api
var public_api=/*#__PURE__*/Object.freeze({__proto__:null,'default': addons,makeDecorator: makeDecorator,Channel: Channel,AddonStore: AddonStore,addons: addons,get types(){return types},isSupportedType: isSupportedType,mockChannel: mockChannel,HooksContext: HooksContext,applyHooks: applyHooks,useMemo: useMemo,useCallback: useCallback,useRef: useRef,useState: useState,useReducer: useReducer,useEffect: useEffect,useChannel: useChannel,useStoryContext: useStoryContext,useParameter: useParameter,useArgs: useArgs,useGlobals: useGlobals});var require$$0$1 = /*@__PURE__*/getAugmentedNamespace(public_api);var shared = {};Object.defineProperty(shared, "__esModule", {
  value: true
});
shared.CLICK = shared.SET_OPTIONS = shared.CHANGE = shared.SET = shared.RESET = shared.PANEL_ID = shared.ADDON_ID = shared.PARAM_KEY = void 0;
// addons, panels and events get unique names using a prefix
var PARAM_KEY = 'knobs';
shared.PARAM_KEY = PARAM_KEY;
var ADDON_ID = 'storybookjs/knobs';
shared.ADDON_ID = ADDON_ID;
var PANEL_ID = "".concat(ADDON_ID, "/panel");
shared.PANEL_ID = PANEL_ID;
var RESET = "".concat(ADDON_ID, "/reset");
shared.RESET = RESET;
var SET = "".concat(ADDON_ID, "/set");
shared.SET = SET;
var CHANGE = "".concat(ADDON_ID, "/change");
shared.CHANGE = CHANGE;
var SET_OPTIONS = "".concat(ADDON_ID, "/set-options");
shared.SET_OPTIONS = SET_OPTIONS;
var CLICK = "".concat(ADDON_ID, "/click");
shared.CLICK = CLICK;var registerKnobs$1 = {};var $$5 = _export;
var fails$3 = fails$r;
var toObject$1 = toObject$b;
var nativeGetPrototypeOf = objectGetPrototypeOf;
var CORRECT_PROTOTYPE_GETTER = correctPrototypeGetter;

var FAILS_ON_PRIMITIVES = fails$3(function () { nativeGetPrototypeOf(1); });

// `Object.getPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.getprototypeof
$$5({ target: 'Object', stat: true, forced: FAILS_ON_PRIMITIVES, sham: !CORRECT_PROTOTYPE_GETTER }, {
  getPrototypeOf: function getPrototypeOf(it) {
    return nativeGetPrototypeOf(toObject$1(it));
  }
});var dist = {};/**
 * A specialized version of `_.reduce` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @param {boolean} [initAccum] Specify using the first element of `array` as
 *  the initial value.
 * @returns {*} Returns the accumulated value.
 */

function arrayReduce$2(array, iteratee, accumulator, initAccum) {
  var index = -1,
      length = array == null ? 0 : array.length;

  if (initAccum && length) {
    accumulator = array[++index];
  }
  while (++index < length) {
    accumulator = iteratee(accumulator, array[index], index, array);
  }
  return accumulator;
}

var _arrayReduce = arrayReduce$2;/**
 * The base implementation of `_.propertyOf` without support for deep paths.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Function} Returns the new accessor function.
 */

function basePropertyOf$1(object) {
  return function(key) {
    return object == null ? undefined : object[key];
  };
}

var _basePropertyOf = basePropertyOf$1;var basePropertyOf = _basePropertyOf;

/** Used to map Latin Unicode letters to basic Latin letters. */
var deburredLetters = {
  // Latin-1 Supplement block.
  '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
  '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
  '\xc7': 'C',  '\xe7': 'c',
  '\xd0': 'D',  '\xf0': 'd',
  '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
  '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
  '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
  '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
  '\xd1': 'N',  '\xf1': 'n',
  '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
  '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
  '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
  '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
  '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
  '\xc6': 'Ae', '\xe6': 'ae',
  '\xde': 'Th', '\xfe': 'th',
  '\xdf': 'ss',
  // Latin Extended-A block.
  '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
  '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
  '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
  '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
  '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
  '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
  '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
  '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
  '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
  '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
  '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
  '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
  '\u0134': 'J',  '\u0135': 'j',
  '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
  '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
  '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
  '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
  '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
  '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
  '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
  '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
  '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
  '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
  '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
  '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
  '\u0163': 't',  '\u0165': 't', '\u0167': 't',
  '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
  '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
  '\u0174': 'W',  '\u0175': 'w',
  '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
  '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
  '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
  '\u0132': 'IJ', '\u0133': 'ij',
  '\u0152': 'Oe', '\u0153': 'oe',
  '\u0149': "'n", '\u017f': 's'
};

/**
 * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
 * letters to basic Latin letters.
 *
 * @private
 * @param {string} letter The matched letter to deburr.
 * @returns {string} Returns the deburred letter.
 */
var deburrLetter$1 = basePropertyOf(deburredLetters);

var _deburrLetter = deburrLetter$1;/** Detect free variable `global` from Node.js. */

var freeGlobal$2 = typeof commonjsGlobal == 'object' && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;

var _freeGlobal = freeGlobal$2;var freeGlobal$1 = _freeGlobal;

/** Detect free variable `self`. */
var freeSelf$1 = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root$a = freeGlobal$1 || freeSelf$1 || Function('return this')();

var _root = root$a;var root$9 = _root;

/** Built-in value references. */
var Symbol$7 = root$9.Symbol;

var _Symbol = Symbol$7;/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */

function arrayMap$9(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

var _arrayMap = arrayMap$9;/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */

var isArray$m = Array.isArray;

var isArray_1 = isArray$m;var Symbol$6 = _Symbol;

/** Used for built-in method references. */
var objectProto$h = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$d = objectProto$h.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString$1 = objectProto$h.toString;

/** Built-in value references. */
var symToStringTag$1 = Symbol$6 ? Symbol$6.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag$1(value) {
  var isOwn = hasOwnProperty$d.call(value, symToStringTag$1),
      tag = value[symToStringTag$1];

  try {
    value[symToStringTag$1] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString$1.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag$1] = tag;
    } else {
      delete value[symToStringTag$1];
    }
  }
  return result;
}

var _getRawTag = getRawTag$1;/** Used for built-in method references. */

var objectProto$g = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto$g.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString$3(value) {
  return nativeObjectToString.call(value);
}

var _objectToString = objectToString$3;var Symbol$5 = _Symbol,
    getRawTag = _getRawTag,
    objectToString$2 = _objectToString;

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = Symbol$5 ? Symbol$5.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag$7(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString$2(value);
}

var _baseGetTag = baseGetTag$7;/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */

function isObjectLike$b(value) {
  return value != null && typeof value == 'object';
}

var isObjectLike_1 = isObjectLike$b;var baseGetTag$6 = _baseGetTag,
    isObjectLike$a = isObjectLike_1;

/** `Object#toString` result references. */
var symbolTag$4 = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol$7(value) {
  return typeof value == 'symbol' ||
    (isObjectLike$a(value) && baseGetTag$6(value) == symbolTag$4);
}

var isSymbol_1 = isSymbol$7;var Symbol$4 = _Symbol,
    arrayMap$8 = _arrayMap,
    isArray$l = isArray_1,
    isSymbol$6 = isSymbol_1;

/** Used as references for various `Number` constants. */
var INFINITY$3 = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var symbolProto$2 = Symbol$4 ? Symbol$4.prototype : undefined,
    symbolToString = symbolProto$2 ? symbolProto$2.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString$1(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isArray$l(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return arrayMap$8(value, baseToString$1) + '';
  }
  if (isSymbol$6(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY$3) ? '-0' : result;
}

var _baseToString = baseToString$1;var baseToString = _baseToString;

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString$5(value) {
  return value == null ? '' : baseToString(value);
}

var toString_1 = toString$5;var deburrLetter = _deburrLetter,
    toString$4 = toString_1;

/** Used to match Latin Unicode letters (excluding mathematical operators). */
var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;

/** Used to compose unicode character classes. */
var rsComboMarksRange$3 = '\\u0300-\\u036f',
    reComboHalfMarksRange$3 = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange$3 = '\\u20d0-\\u20ff',
    rsComboRange$3 = rsComboMarksRange$3 + reComboHalfMarksRange$3 + rsComboSymbolsRange$3;

/** Used to compose unicode capture groups. */
var rsCombo$2 = '[' + rsComboRange$3 + ']';

/**
 * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
 * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
 */
var reComboMark = RegExp(rsCombo$2, 'g');

/**
 * Deburrs `string` by converting
 * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
 * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
 * letters to basic Latin letters and removing
 * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to deburr.
 * @returns {string} Returns the deburred string.
 * @example
 *
 * _.deburr('déjà vu');
 * // => 'deja vu'
 */
function deburr$1(string) {
  string = toString$4(string);
  return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
}

var deburr_1 = deburr$1;/** Used to match words composed of alphanumeric characters. */

var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;

/**
 * Splits an ASCII `string` into an array of its words.
 *
 * @private
 * @param {string} The string to inspect.
 * @returns {Array} Returns the words of `string`.
 */
function asciiWords$1(string) {
  return string.match(reAsciiWord) || [];
}

var _asciiWords = asciiWords$1;/** Used to detect strings that need a more robust regexp to match words. */

var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;

/**
 * Checks if `string` contains a word composed of Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a word is found, else `false`.
 */
function hasUnicodeWord$1(string) {
  return reHasUnicodeWord.test(string);
}

var _hasUnicodeWord = hasUnicodeWord$1;/** Used to compose unicode character classes. */

var rsAstralRange$2 = '\\ud800-\\udfff',
    rsComboMarksRange$2 = '\\u0300-\\u036f',
    reComboHalfMarksRange$2 = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange$2 = '\\u20d0-\\u20ff',
    rsComboRange$2 = rsComboMarksRange$2 + reComboHalfMarksRange$2 + rsComboSymbolsRange$2,
    rsDingbatRange = '\\u2700-\\u27bf',
    rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
    rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
    rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
    rsPunctuationRange = '\\u2000-\\u206f',
    rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
    rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
    rsVarRange$2 = '\\ufe0e\\ufe0f',
    rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;

/** Used to compose unicode capture groups. */
var rsApos$1 = "['\u2019]",
    rsBreak = '[' + rsBreakRange + ']',
    rsCombo$1 = '[' + rsComboRange$2 + ']',
    rsDigits = '\\d+',
    rsDingbat = '[' + rsDingbatRange + ']',
    rsLower = '[' + rsLowerRange + ']',
    rsMisc = '[^' + rsAstralRange$2 + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
    rsFitz$1 = '\\ud83c[\\udffb-\\udfff]',
    rsModifier$1 = '(?:' + rsCombo$1 + '|' + rsFitz$1 + ')',
    rsNonAstral$1 = '[^' + rsAstralRange$2 + ']',
    rsRegional$1 = '(?:\\ud83c[\\udde6-\\uddff]){2}',
    rsSurrPair$1 = '[\\ud800-\\udbff][\\udc00-\\udfff]',
    rsUpper = '[' + rsUpperRange + ']',
    rsZWJ$2 = '\\u200d';

/** Used to compose unicode regexes. */
var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')',
    rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')',
    rsOptContrLower = '(?:' + rsApos$1 + '(?:d|ll|m|re|s|t|ve))?',
    rsOptContrUpper = '(?:' + rsApos$1 + '(?:D|LL|M|RE|S|T|VE))?',
    reOptMod$1 = rsModifier$1 + '?',
    rsOptVar$1 = '[' + rsVarRange$2 + ']?',
    rsOptJoin$1 = '(?:' + rsZWJ$2 + '(?:' + [rsNonAstral$1, rsRegional$1, rsSurrPair$1].join('|') + ')' + rsOptVar$1 + reOptMod$1 + ')*',
    rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])',
    rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])',
    rsSeq$1 = rsOptVar$1 + reOptMod$1 + rsOptJoin$1,
    rsEmoji = '(?:' + [rsDingbat, rsRegional$1, rsSurrPair$1].join('|') + ')' + rsSeq$1;

/** Used to match complex or compound words. */
var reUnicodeWord = RegExp([
  rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
  rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [rsBreak, rsUpper + rsMiscLower, '$'].join('|') + ')',
  rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
  rsUpper + '+' + rsOptContrUpper,
  rsOrdUpper,
  rsOrdLower,
  rsDigits,
  rsEmoji
].join('|'), 'g');

/**
 * Splits a Unicode `string` into an array of its words.
 *
 * @private
 * @param {string} The string to inspect.
 * @returns {Array} Returns the words of `string`.
 */
function unicodeWords$1(string) {
  return string.match(reUnicodeWord) || [];
}

var _unicodeWords = unicodeWords$1;var asciiWords = _asciiWords,
    hasUnicodeWord = _hasUnicodeWord,
    toString$3 = toString_1,
    unicodeWords = _unicodeWords;

/**
 * Splits `string` into an array of its words.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to inspect.
 * @param {RegExp|string} [pattern] The pattern to match words.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Array} Returns the words of `string`.
 * @example
 *
 * _.words('fred, barney, & pebbles');
 * // => ['fred', 'barney', 'pebbles']
 *
 * _.words('fred, barney, & pebbles', /[^, ]+/g);
 * // => ['fred', 'barney', '&', 'pebbles']
 */
function words$1(string, pattern, guard) {
  string = toString$3(string);
  pattern = guard ? undefined : pattern;

  if (pattern === undefined) {
    return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
  }
  return string.match(pattern) || [];
}

var words_1 = words$1;var arrayReduce$1 = _arrayReduce,
    deburr = deburr_1,
    words = words_1;

/** Used to compose unicode capture groups. */
var rsApos = "['\u2019]";

/** Used to match apostrophes. */
var reApos = RegExp(rsApos, 'g');

/**
 * Creates a function like `_.camelCase`.
 *
 * @private
 * @param {Function} callback The function to combine each word.
 * @returns {Function} Returns the new compounder function.
 */
function createCompounder$1(callback) {
  return function(string) {
    return arrayReduce$1(words(deburr(string).replace(reApos, '')), callback, '');
  };
}

var _createCompounder = createCompounder$1;/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */

function baseSlice$2(array, start, end) {
  var index = -1,
      length = array.length;

  if (start < 0) {
    start = -start > length ? 0 : (length + start);
  }
  end = end > length ? length : end;
  if (end < 0) {
    end += length;
  }
  length = start > end ? 0 : ((end - start) >>> 0);
  start >>>= 0;

  var result = Array(length);
  while (++index < length) {
    result[index] = array[index + start];
  }
  return result;
}

var _baseSlice = baseSlice$2;var baseSlice$1 = _baseSlice;

/**
 * Casts `array` to a slice if it's needed.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {number} start The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the cast slice.
 */
function castSlice$1(array, start, end) {
  var length = array.length;
  end = end === undefined ? length : end;
  return (!start && end >= length) ? array : baseSlice$1(array, start, end);
}

var _castSlice = castSlice$1;/** Used to compose unicode character classes. */

var rsAstralRange$1 = '\\ud800-\\udfff',
    rsComboMarksRange$1 = '\\u0300-\\u036f',
    reComboHalfMarksRange$1 = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange$1 = '\\u20d0-\\u20ff',
    rsComboRange$1 = rsComboMarksRange$1 + reComboHalfMarksRange$1 + rsComboSymbolsRange$1,
    rsVarRange$1 = '\\ufe0e\\ufe0f';

/** Used to compose unicode capture groups. */
var rsZWJ$1 = '\\u200d';

/** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
var reHasUnicode = RegExp('[' + rsZWJ$1 + rsAstralRange$1  + rsComboRange$1 + rsVarRange$1 + ']');

/**
 * Checks if `string` contains Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a symbol is found, else `false`.
 */
function hasUnicode$2(string) {
  return reHasUnicode.test(string);
}

var _hasUnicode = hasUnicode$2;/**
 * Converts an ASCII `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */

function asciiToArray$1(string) {
  return string.split('');
}

var _asciiToArray = asciiToArray$1;/** Used to compose unicode character classes. */

var rsAstralRange = '\\ud800-\\udfff',
    rsComboMarksRange = '\\u0300-\\u036f',
    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange = '\\u20d0-\\u20ff',
    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
    rsVarRange = '\\ufe0e\\ufe0f';

/** Used to compose unicode capture groups. */
var rsAstral = '[' + rsAstralRange + ']',
    rsCombo = '[' + rsComboRange + ']',
    rsFitz = '\\ud83c[\\udffb-\\udfff]',
    rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
    rsNonAstral = '[^' + rsAstralRange + ']',
    rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
    rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
    rsZWJ = '\\u200d';

/** Used to compose unicode regexes. */
var reOptMod = rsModifier + '?',
    rsOptVar = '[' + rsVarRange + ']?',
    rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
    rsSeq = rsOptVar + reOptMod + rsOptJoin,
    rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

/**
 * Converts a Unicode `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function unicodeToArray$1(string) {
  return string.match(reUnicode) || [];
}

var _unicodeToArray = unicodeToArray$1;var asciiToArray = _asciiToArray,
    hasUnicode$1 = _hasUnicode,
    unicodeToArray = _unicodeToArray;

/**
 * Converts `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function stringToArray$1(string) {
  return hasUnicode$1(string)
    ? unicodeToArray(string)
    : asciiToArray(string);
}

var _stringToArray = stringToArray$1;var castSlice = _castSlice,
    hasUnicode = _hasUnicode,
    stringToArray = _stringToArray,
    toString$2 = toString_1;

/**
 * Creates a function like `_.lowerFirst`.
 *
 * @private
 * @param {string} methodName The name of the `String` case method to use.
 * @returns {Function} Returns the new case function.
 */
function createCaseFirst$1(methodName) {
  return function(string) {
    string = toString$2(string);

    var strSymbols = hasUnicode(string)
      ? stringToArray(string)
      : undefined;

    var chr = strSymbols
      ? strSymbols[0]
      : string.charAt(0);

    var trailing = strSymbols
      ? castSlice(strSymbols, 1).join('')
      : string.slice(1);

    return chr[methodName]() + trailing;
  };
}

var _createCaseFirst = createCaseFirst$1;var createCaseFirst = _createCaseFirst;

/**
 * Converts the first character of `string` to upper case.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.upperFirst('fred');
 * // => 'Fred'
 *
 * _.upperFirst('FRED');
 * // => 'FRED'
 */
var upperFirst$1 = createCaseFirst('toUpperCase');

var upperFirst_1 = upperFirst$1;var createCompounder = _createCompounder,
    upperFirst = upperFirst_1;

/**
 * Converts `string` to
 * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
 *
 * @static
 * @memberOf _
 * @since 3.1.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the start cased string.
 * @example
 *
 * _.startCase('--foo-bar--');
 * // => 'Foo Bar'
 *
 * _.startCase('fooBar');
 * // => 'Foo Bar'
 *
 * _.startCase('__FOO_BAR__');
 * // => 'FOO BAR'
 */
var startCase = createCompounder(function(result, word, index) {
  return result + (index ? ' ' : '') + upperFirst(word);
});

var startCase_1 = startCase;Object.defineProperty(dist, "__esModule", {
  value: true
});
dist.isExportStory = isExportStory;
dist.parseKind = dist.storyNameFromExport = toId_1 = dist.toId = sanitize_1 = dist.sanitize = void 0;

var _startCase = _interopRequireDefault$r(startCase_1);

function _interopRequireDefault$r(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _slicedToArray$5(arr, i) { return _arrayWithHoles$5(arr) || _iterableToArrayLimit$5(arr, i) || _nonIterableRest$5(); }

function _nonIterableRest$5() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit$5(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles$5(arr) { if (Array.isArray(arr)) return arr; }

/**
 * Remove punctuation and illegal characters from a story ID.
 *
 * See https://gist.github.com/davidjrice/9d2af51100e41c6c4b4a
 */
var sanitize = function sanitize(string) {
  return string.toLowerCase() // eslint-disable-next-line no-useless-escape
  .replace(/[ ’–—―′¿'`~!@#$%^&*()_|+\-=?;:'",.<>\{\}\[\]\\\/]/gi, '-').replace(/-+/g, '-').replace(/^-+/, '').replace(/-+$/, '');
};

var sanitize_1 = dist.sanitize = sanitize;

var sanitizeSafe = function sanitizeSafe(string, part) {
  var sanitized = sanitize(string);

  if (sanitized === '') {
    throw new Error("Invalid ".concat(part, " '").concat(string, "', must include alphanumeric characters"));
  }

  return sanitized;
};
/**
 * Generate a storybook ID from a component/kind and story name.
 */


var toId = function toId(kind, name) {
  return "".concat(sanitizeSafe(kind, 'kind'), "--").concat(sanitizeSafe(name, 'name'));
};
/**
 * Transform a CSF named export into a readable story name
 */


var toId_1 = dist.toId = toId;

var storyNameFromExport = function storyNameFromExport(key) {
  return (0, _startCase["default"])(key);
};

dist.storyNameFromExport = storyNameFromExport;

function matches$2(storyKey, arrayOrRegex) {
  if (Array.isArray(arrayOrRegex)) {
    return arrayOrRegex.includes(storyKey);
  }

  return storyKey.match(arrayOrRegex);
}
/**
 * Does a named export match CSF inclusion/exclusion options?
 */


function isExportStory(key, _ref) {
  var includeStories = _ref.includeStories,
      excludeStories = _ref.excludeStories;
  return (// https://babeljs.io/docs/en/babel-plugin-transform-modules-commonjs
    key !== '__esModule' && (!includeStories || matches$2(key, includeStories)) && (!excludeStories || !matches$2(key, excludeStories))
  );
}

/**
 * Parse out the component/kind name from a path, using the given separator config.
 */
var parseKind = function parseKind(kind, _ref2) {
  var rootSeparator = _ref2.rootSeparator,
      groupSeparator = _ref2.groupSeparator;

  var _kind$split = kind.split(rootSeparator, 2),
      _kind$split2 = _slicedToArray$5(_kind$split, 2),
      root = _kind$split2[0],
      remainder = _kind$split2[1];

  var groups = (remainder || kind).split(groupSeparator).filter(function (i) {
    return !!i;
  }); // when there's no remainder, it means the root wasn't found/split

  return {
    root: remainder ? root : null,
    groups: groups
  };
};

dist.parseKind = parseKind;function _defineProperty$7(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray$4(arr, i) { return _arrayWithHoles$4(arr) || _iterableToArrayLimit$4(arr, i) || _unsupportedIterableToArray$4(arr, i) || _nonIterableRest$4(); }

function _nonIterableRest$4() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray$4(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$4(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$4(o, minLen); }

function _arrayLikeToArray$4(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit$4(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles$4(arr) { if (Array.isArray(arr)) return arr; }
function useSharedState(sharedId, defaultState) {
  var channel = addons.getChannel();

  var _ref = channel.last("".concat(SHARED_STATE_CHANGED, "-manager-").concat(sharedId)) || channel.last("".concat(SHARED_STATE_SET, "-manager-").concat(sharedId)) || [],
      _ref2 = _slicedToArray$4(_ref, 1),
      lastValue = _ref2[0];

  var _useState = useState(lastValue || defaultState),
      _useState2 = _slicedToArray$4(_useState, 2),
      state = _useState2[0],
      setState = _useState2[1];

  var allListeners = useMemo(function () {
    var _ref3;

    return _ref3 = {}, _defineProperty$7(_ref3, "".concat(SHARED_STATE_CHANGED, "-manager-").concat(sharedId), function manager(s) {
      return setState(s);
    }), _defineProperty$7(_ref3, "".concat(SHARED_STATE_SET, "-manager-").concat(sharedId), function manager(s) {
      return setState(s);
    }), _ref3;
  }, [sharedId]);
  var emit = useChannel(allListeners, [sharedId]);
  useEffect(function () {
    // init
    if (defaultState !== undefined && !lastValue) {
      emit("".concat(SHARED_STATE_SET, "-client-").concat(sharedId), defaultState);
    }
  }, [sharedId]);
  return [state, function (s) {
    setState(s);
    emit("".concat(SHARED_STATE_CHANGED, "-client-").concat(sharedId), s);
  }];
}
function useAddonState(addonId, defaultState) {
  return useSharedState(addonId, defaultState);
}var aFunction = aFunction$5;
var toObject = toObject$b;
var IndexedObject$1 = indexedObject;
var toLength$3 = toLength$b;

// `Array.prototype.{ reduce, reduceRight }` methods implementation
var createMethod$1 = function (IS_RIGHT) {
  return function (that, callbackfn, argumentsLength, memo) {
    aFunction(callbackfn);
    var O = toObject(that);
    var self = IndexedObject$1(O);
    var length = toLength$3(O.length);
    var index = IS_RIGHT ? length - 1 : 0;
    var i = IS_RIGHT ? -1 : 1;
    if (argumentsLength < 2) while (true) {
      if (index in self) {
        memo = self[index];
        index += i;
        break;
      }
      index += i;
      if (IS_RIGHT ? index < 0 : length <= index) {
        throw TypeError('Reduce of empty array with no initial value');
      }
    }
    for (;IS_RIGHT ? index >= 0 : length > index; index += i) if (index in self) {
      memo = callbackfn(memo, self[index], index, O);
    }
    return memo;
  };
};

var arrayReduce = {
  // `Array.prototype.reduce` method
  // https://tc39.es/ecma262/#sec-array.prototype.reduce
  left: createMethod$1(false),
  // `Array.prototype.reduceRight` method
  // https://tc39.es/ecma262/#sec-array.prototype.reduceright
  right: createMethod$1(true)
};var $$4 = _export;
var $reduce = arrayReduce.left;
var arrayMethodIsStrict$1 = arrayMethodIsStrict$3;
var CHROME_VERSION = engineV8Version;
var IS_NODE = engineIsNode;

var STRICT_METHOD$1 = arrayMethodIsStrict$1('reduce');
// Chrome 80-82 has a critical bug
// https://bugs.chromium.org/p/chromium/issues/detail?id=1049982
var CHROME_BUG = !IS_NODE && CHROME_VERSION > 79 && CHROME_VERSION < 83;

// `Array.prototype.reduce` method
// https://tc39.es/ecma262/#sec-array.prototype.reduce
$$4({ target: 'Array', proto: true, forced: !STRICT_METHOD$1 || CHROME_BUG }, {
  reduce: function reduce(callbackfn /* , initialValue */) {
    return $reduce(this, callbackfn, arguments.length, arguments.length > 1 ? arguments[1] : undefined);
  }
});function _objectWithoutProperties$6(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose$2(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose$2(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var defaultContext = {
  id: 'unspecified',
  name: 'unspecified',
  kind: 'unspecified',
  parameters: {},
  args: {},
  argTypes: {},
  globals: {}
};
var decorateStory = function decorateStory(storyFn, decorator, bindWithContext) {
  // Bind the partially decorated storyFn so that when it is called it always knows about the story context,
  // no matter what it is passed directly. This is because we cannot guarantee a decorator will
  // pass the context down to the next decorated story in the chain.
  var boundStoryFunction = bindWithContext(storyFn);
  return function (context) {
    return decorator(boundStoryFunction, context);
  };
};
var defaultDecorateStory = function defaultDecorateStory(storyFn, decorators) {
  // We use a trick to avoid recreating the bound story function inside `decorateStory`.
  // Instead we pass it a context "getter", which is defined once (at "decoration time")
  // The getter reads a variable which is scoped to this call of `decorateStory`
  // (ie to this story), so there is no possibility of overlap.
  // This will break if you call the same story twice interleaved
  // (React might do it if you rendered the same story twice in the one ReactDom.render call, for instance)
  var contextStore = {
    value: defaultContext
  };
  /**
   * When you call the story function inside a decorator, e.g.:
   *
   * ```jsx
   * <div>{storyFn({ foo: 'bar' })}</div>
   * ```
   *
   * This will override the `foo` property on the `innerContext`, which gets
   * merged in with the default context
   */

  var bindWithContext = function bindWithContext(decoratedStoryFn) {
    return (// (NOTE: You cannot override the parameters key, it is fixed)
      function () {
        var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        _ref.id;
            _ref.name;
            _ref.kind;
            _ref.parameters;
            var contextUpdate = _objectWithoutProperties$6(_ref, ["id", "name", "kind", "parameters"]);

        contextStore.value = Object.assign({}, contextStore.value, contextUpdate);
        return decoratedStoryFn(contextStore.value);
      }
    );
  };

  var decoratedWithContextStore = decorators.reduce(function (story, decorator) {
    return decorateStory(story, decorator, bindWithContext);
  }, storyFn);
  return function () {
    var context = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultContext;
    contextStore.value = context;
    return decoratedWithContextStore(context); // Pass the context directly into the first decorator
  };
};var _templateObject$W, _templateObject2$O;

function _objectWithoutProperties$5(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose$1(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose$1(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _typeof$5(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof$5 = function _typeof(obj) { return typeof obj; }; } else { _typeof$5 = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof$5(obj); }

function _taggedTemplateLiteral$3(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

function _classCallCheck$g(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties$2(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass$d(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$2(Constructor.prototype, protoProps); if (staticProps) _defineProperties$2(Constructor, staticProps); return Constructor; }
// relevant framework instanciates them via `start.js`. The good news is this happens right away.

var singleton;
var addDecoratorDeprecationWarning = browser$1(function () {}, "`addDecorator` is deprecated, and will be removed in Storybook 7.0.\nInstead, use `export const decorators = [];` in your `preview.js`.\nRead more at https://github.com/storybookjs/storybook/blob/next/MIGRATION.md#deprecated-addparameters-and-adddecorator).");
var addDecorator = function addDecorator(decorator) {
  var deprecationWarning = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  if (!singleton) throw new Error("Singleton client API not yet initialized, cannot call addDecorator");
  if (deprecationWarning) addDecoratorDeprecationWarning();
  singleton.addDecorator(decorator);
};
var addParametersDeprecationWarning = browser$1(function () {}, "`addParameters` is deprecated, and will be removed in Storybook 7.0.\nInstead, use `export const parameters = {};` in your `preview.js`.\nRead more at https://github.com/storybookjs/storybook/blob/next/MIGRATION.md#deprecated-addparameters-and-adddecorator).");
var addParameters = function addParameters(parameters) {
  var deprecationWarning = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  if (!singleton) throw new Error("Singleton client API not yet initialized, cannot call addParameters");
  if (deprecationWarning) addParametersDeprecationWarning();
  singleton.addParameters(parameters);
};
var addLoaderDeprecationWarning = browser$1(function () {}, "`addLoader` is deprecated, and will be removed in Storybook 7.0.\nInstead, use `export const loaders = [];` in your `preview.js`.\nRead more at https://github.com/storybookjs/storybook/blob/next/MIGRATION.md#deprecated-addparameters-and-adddecorator).");
var addLoader = function addLoader(loader) {
  var deprecationWarning = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  if (!singleton) throw new Error("Singleton client API not yet initialized, cannot call addParameters");
  if (deprecationWarning) addLoaderDeprecationWarning();
  singleton.addLoader(loader);
};
var addArgsEnhancer = function addArgsEnhancer(enhancer) {
  if (!singleton) throw new Error("Singleton client API not yet initialized, cannot call addArgsEnhancer");
  singleton.addArgsEnhancer(enhancer);
};
var addArgTypesEnhancer = function addArgTypesEnhancer(enhancer) {
  if (!singleton) throw new Error("Singleton client API not yet initialized, cannot call addArgTypesEnhancer");
  singleton.addArgTypesEnhancer(enhancer);
};
var setGlobalRender = function setGlobalRender(render) {
  if (!singleton) throw new Error("Singleton client API not yet initialized, cannot call setGobalRender");
  singleton.globalRender = render;
};
var invalidStoryTypes = new Set(['string', 'number', 'boolean', 'symbol']);

var ClientApi = /*#__PURE__*/function () {
  // React Native Fast refresh doesn't allow multiple dispose calls
  function ClientApi(_ref) {
    var _this = this;

    var storyStore = _ref.storyStore,
        _ref$decorateStory = _ref.decorateStory,
        decorateStory = _ref$decorateStory === void 0 ? defaultDecorateStory : _ref$decorateStory,
        noStoryModuleAddMethodHotDispose = _ref.noStoryModuleAddMethodHotDispose;

    _classCallCheck$g(this, ClientApi);

    this._storyStore = void 0;
    this._addons = void 0;
    this._decorateStory = void 0;
    this._globalRender = void 0;
    this._noStoryModuleAddMethodHotDispose = void 0;
    this.setAddon = browser$1(function (addon) {
      _this._addons = Object.assign({}, _this._addons, addon);
    }, _default$4(_templateObject$W || (_templateObject$W = _taggedTemplateLiteral$3(["\n      `setAddon` is deprecated and will be removed in Storybook 7.0.\n\n      https://github.com/storybookjs/storybook/blob/next/MIGRATION.md#deprecated-setaddon\n    "], ["\n      \\`setAddon\\` is deprecated and will be removed in Storybook 7.0.\n\n      https://github.com/storybookjs/storybook/blob/next/MIGRATION.md#deprecated-setaddon\n    "]))));

    this.addDecorator = function (decorator) {
      _this._storyStore.addGlobalMetadata({
        decorators: [decorator]
      });
    };

    this.clearDecorators = browser$1(function () {
      _this._storyStore.clearGlobalDecorators();
    }, _default$4(_templateObject2$O || (_templateObject2$O = _taggedTemplateLiteral$3(["\n      `clearDecorators` is deprecated and will be removed in Storybook 7.0.\n\n      https://github.com/storybookjs/storybook/blob/next/MIGRATION.md#deprecated-cleardecorators\n    "], ["\n      \\`clearDecorators\\` is deprecated and will be removed in Storybook 7.0.\n\n      https://github.com/storybookjs/storybook/blob/next/MIGRATION.md#deprecated-cleardecorators\n    "]))));

    this.addParameters = function (parameters) {
      _this._storyStore.addGlobalMetadata({
        parameters: parameters
      });
    };

    this.addLoader = function (loader) {
      _this._storyStore.addGlobalMetadata({
        loaders: [loader]
      });
    };

    this.addArgsEnhancer = function (enhancer) {
      _this._storyStore.addArgsEnhancer(enhancer);
    };

    this.addArgTypesEnhancer = function (enhancer) {
      _this._storyStore.addArgTypesEnhancer(enhancer);
    };

    this.storiesOf = function (kind, m) {
      if (!kind && typeof kind !== 'string') {
        throw new Error('Invalid or missing kind provided for stories, should be a string');
      }

      if (!m) {
        logger.warn("Missing 'module' parameter for story with a kind of '".concat(kind, "'. It will break your HMR"));
      }

      if (m) {
        var proto = Object.getPrototypeOf(m);

        if (proto.exports && proto.exports.default) {
          // FIXME: throw an error in SB6.0
          logger.error("Illegal mix of CSF default export and storiesOf calls in a single file: ".concat(proto.i));
        }
      }

      if (m && m.hot && m.hot.dispose) {
        m.hot.dispose(function () {
          var _storyStore = _this._storyStore; // If HMR dispose happens in a story file, we know that HMR will pass up to the configuration file (preview.js)
          // and be handled by the HMR.allow in config_api, leading to a re-run of configuration.
          // So configuration is about to happen--we can skip the safety check.

          _storyStore.removeStoryKind(kind, {
            allowUnsafe: true
          });
        });
      }

      var hasAdded = false;
      var api = {
        kind: kind.toString(),
        add: function add() {
          return api;
        },
        addDecorator: function addDecorator() {
          return api;
        },
        addLoader: function addLoader() {
          return api;
        },
        addParameters: function addParameters() {
          return api;
        }
      }; // apply addons

      Object.keys(_this._addons).forEach(function (name) {
        var addon = _this._addons[name];

        api[name] = function () {
          for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
          }

          addon.apply(api, args);
          return api;
        };
      });

      api.add = function (storyName, storyFn) {
        var parameters = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        hasAdded = true;
        var id = parameters.__id || toId_1(kind, storyName);

        if (typeof storyName !== 'string') {
          throw new Error("Invalid or missing storyName provided for a \"".concat(kind, "\" story."));
        }

        if (!storyFn || Array.isArray(storyFn) || invalidStoryTypes.has(_typeof$5(storyFn))) {
          throw new Error("Cannot load story \"".concat(storyName, "\" in \"").concat(kind, "\" due to invalid format. Storybook expected a function/object but received ").concat(_typeof$5(storyFn), " instead."));
        }

        if (!_this._noStoryModuleAddMethodHotDispose && m && m.hot && m.hot.dispose) {
          m.hot.dispose(function () {
            var _storyStore = _this._storyStore; // See note about allowUnsafe above

            _storyStore.remove(id, {
              allowUnsafe: true
            });
          });
        }

        var fileName = m && m.id ? "".concat(m.id) : undefined;

        var decorators = parameters.decorators,
            loaders = parameters.loaders,
            storyParameters = _objectWithoutProperties$5(parameters, ["decorators", "loaders"]);

        _this._storyStore.addStory({
          id: id,
          kind: kind,
          name: storyName,
          storyFn: storyFn,
          parameters: Object.assign({
            fileName: fileName
          }, storyParameters),
          decorators: decorators,
          loaders: loaders
        }, {
          applyDecorators: applyHooks(_this._decorateStory)
        });

        return api;
      };

      api.addDecorator = function (decorator) {
        if (hasAdded) throw new Error("You cannot add a decorator after the first story for a kind.\nRead more here: https://github.com/storybookjs/storybook/blob/master/MIGRATION.md#can-no-longer-add-decoratorsparameters-after-stories");

        _this._storyStore.addKindMetadata(kind, {
          decorators: [decorator]
        });

        return api;
      };

      api.addLoader = function (loader) {
        if (hasAdded) throw new Error("You cannot add a loader after the first story for a kind.");

        _this._storyStore.addKindMetadata(kind, {
          loaders: [loader]
        });

        return api;
      };

      api.addParameters = function (parameters) {
        if (hasAdded) throw new Error("You cannot add parameters after the first story for a kind.\nRead more here: https://github.com/storybookjs/storybook/blob/master/MIGRATION.md#can-no-longer-add-decoratorsparameters-after-stories");

        _this._storyStore.addKindMetadata(kind, {
          parameters: parameters
        });

        return api;
      };

      return api;
    };

    this.getStorybook = function () {
      return _this._storyStore.getStorybook();
    };

    this.raw = function () {
      return _this._storyStore.raw();
    };

    this.store = function () {
      return _this._storyStore;
    };

    this._storyStore = storyStore;
    this._addons = {};
    this._noStoryModuleAddMethodHotDispose = noStoryModuleAddMethodHotDispose || false;
    this._decorateStory = decorateStory;
    if (!storyStore) throw new Error('storyStore is required');
    singleton = this;
  }

  _createClass$d(ClientApi, [{
    key: "globalRender",
    get: function get() {
      return this._globalRender;
    },
    set: function set(render) {
      this._globalRender = render;
    } // what are the occasions that "m" is a boolean vs an obj

  }]);

  return ClientApi;
}();/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */

function overArg$2(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

var _overArg = overArg$2;var overArg$1 = _overArg;

/** Built-in value references. */
var getPrototype$3 = overArg$1(Object.getPrototypeOf, Object);

var _getPrototype = getPrototype$3;var baseGetTag$5 = _baseGetTag,
    getPrototype$2 = _getPrototype,
    isObjectLike$9 = isObjectLike_1;

/** `Object#toString` result references. */
var objectTag$4 = '[object Object]';

/** Used for built-in method references. */
var funcProto$2 = Function.prototype,
    objectProto$f = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString$2 = funcProto$2.toString;

/** Used to check objects for own properties. */
var hasOwnProperty$c = objectProto$f.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString$2.call(Object);

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject$4(value) {
  if (!isObjectLike$9(value) || baseGetTag$5(value) != objectTag$4) {
    return false;
  }
  var proto = getPrototype$2(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty$c.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
    funcToString$2.call(Ctor) == objectCtorString;
}

var isPlainObject_1 = isPlainObject$4;function _toConsumableArray$3(arr) { return _arrayWithoutHoles$3(arr) || _iterableToArray$3(arr) || _unsupportedIterableToArray$3(arr) || _nonIterableSpread$3(); }

function _nonIterableSpread$3() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray$3(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles$3(arr) { if (Array.isArray(arr)) return _arrayLikeToArray$3(arr); }

function _slicedToArray$3(arr, i) { return _arrayWithHoles$3(arr) || _iterableToArrayLimit$3(arr, i) || _unsupportedIterableToArray$3(arr, i) || _nonIterableRest$3(); }

function _nonIterableRest$3() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray$3(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$3(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$3(o, minLen); }

function _arrayLikeToArray$3(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit$3(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles$3(arr) { if (Array.isArray(arr)) return arr; }
/**
 * Safely combine parameters recursively. Only copy objects when needed.
 * Algorithm = always overwrite the existing value UNLESS both values
 * are plain objects. In this case flag the key as "special" and handle
 * it with a heuristic.
 */

var combineParameters = function combineParameters() {
  for (var _len = arguments.length, parameterSets = new Array(_len), _key = 0; _key < _len; _key++) {
    parameterSets[_key] = arguments[_key];
  }

  var mergeKeys = {};
  var combined = parameterSets.reduce(function (acc, p) {
    Object.entries(p).forEach(function (_ref) {
      var _ref2 = _slicedToArray$3(_ref, 2),
          key = _ref2[0],
          value = _ref2[1];

      var existing = acc[key];

      if (Array.isArray(value) || typeof existing === 'undefined') {
        acc[key] = value;
      } else if (isPlainObject_1(value) && isPlainObject_1(existing)) {
        // do nothing, we'll handle this later
        mergeKeys[key] = true;
      } else if (typeof value !== 'undefined') {
        acc[key] = value;
      }
    });
    return acc;
  }, {});
  Object.keys(mergeKeys).forEach(function (key) {
    var mergeValues = parameterSets.map(function (p) {
      return p[key];
    }).filter(function (value) {
      return typeof value !== 'undefined';
    });

    if (mergeValues.every(function (value) {
      return isPlainObject_1(value);
    })) {
      combined[key] = combineParameters.apply(void 0, _toConsumableArray$3(mergeValues));
    } else {
      combined[key] = mergeValues[mergeValues.length - 1];
    }
  });
  return combined;
};var runtime = {exports: {}};/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

(function (module) {
var runtime = (function (exports) {

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined$1; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  function define(obj, key, value) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
    return obj[key];
  }
  try {
    // IE 8 has a broken Object.defineProperty that only works on DOM objects.
    define({}, "");
  } catch (err) {
    define = function(obj, key, value) {
      return obj[key] = value;
    };
  }

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  exports.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  define(IteratorPrototype, iteratorSymbol, function () {
    return this;
  });

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = GeneratorFunctionPrototype;
  define(Gp, "constructor", GeneratorFunctionPrototype);
  define(GeneratorFunctionPrototype, "constructor", GeneratorFunction);
  GeneratorFunction.displayName = define(
    GeneratorFunctionPrototype,
    toStringTagSymbol,
    "GeneratorFunction"
  );

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      define(prototype, method, function(arg) {
        return this._invoke(method, arg);
      });
    });
  }

  exports.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  exports.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      define(genFun, toStringTagSymbol, "GeneratorFunction");
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  exports.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator, PromiseImpl) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return PromiseImpl.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return PromiseImpl.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration.
          result.value = unwrapped;
          resolve(result);
        }, function(error) {
          // If a rejected Promise was yielded, throw the rejection back
          // into the async generator function so it can be handled there.
          return invoke("throw", error, resolve, reject);
        });
      }
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new PromiseImpl(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  define(AsyncIterator.prototype, asyncIteratorSymbol, function () {
    return this;
  });
  exports.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  exports.async = function(innerFn, outerFn, self, tryLocsList, PromiseImpl) {
    if (PromiseImpl === void 0) PromiseImpl = Promise;

    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList),
      PromiseImpl
    );

    return exports.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined$1) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        // Note: ["return"] must be used for ES3 parsing compatibility.
        if (delegate.iterator["return"]) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined$1;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined$1;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  define(Gp, toStringTagSymbol, "Generator");

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  define(Gp, iteratorSymbol, function() {
    return this;
  });

  define(Gp, "toString", function() {
    return "[object Generator]";
  });

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  exports.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined$1;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  exports.values = values;

  function doneResult() {
    return { value: undefined$1, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined$1;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined$1;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined$1;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined$1;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined$1;
      }

      return ContinueSentinel;
    }
  };

  // Regardless of whether this script is executing as a CommonJS module
  // or not, return the runtime object so that we can declare the variable
  // regeneratorRuntime in the outer scope, which allows this module to be
  // injected easily by `bin/regenerator --include-runtime script.js`.
  return exports;

}(
  // If this script is executing as a CommonJS module, use module.exports
  // as the regeneratorRuntime namespace. Otherwise create a new empty
  // object. Either way, the resulting object will be used to initialize
  // the regeneratorRuntime variable at the top of this file.
  module.exports 
));

try {
  regeneratorRuntime = runtime;
} catch (accidentalStrictMode) {
  // This module should not be running in strict mode, so the above
  // assignment should always work unless something is misconfigured. Just
  // in case runtime.js accidentally runs in strict mode, in modern engines
  // we can explicitly access globalThis. In older engines we can escape
  // strict mode using a global Function call. This could conceivably fail
  // if a Content Security Policy forbids using Function, but in that case
  // the proper solution is to fix the accidental strict mode problem. If
  // you've misconfigured your bundler to force strict mode and applied a
  // CSP to forbid Function, and you're not willing to fix either of those
  // problems, please detail your unique predicament in a GitHub issue.
  if (typeof globalThis === "object") {
    globalThis.regeneratorRuntime = runtime;
  } else {
    Function("r", "regeneratorRuntime = r")(runtime);
  }
}
}(runtime));var fixRegExpWellKnownSymbolLogic$2 = fixRegexpWellKnownSymbolLogic;
var isRegExp$2 = isRegexp;
var anObject$2 = anObject$i;
var requireObjectCoercible$4 = requireObjectCoercible$a;
var speciesConstructor = speciesConstructor$2;
var advanceStringIndex$1 = advanceStringIndex$3;
var toLength$2 = toLength$b;
var callRegExpExec = regexpExecAbstract;
var regexpExec = regexpExec$3;
var stickyHelpers = regexpStickyHelpers;
var fails$2 = fails$r;

var UNSUPPORTED_Y = stickyHelpers.UNSUPPORTED_Y;
var arrayPush$4 = [].push;
var min$2 = Math.min;
var MAX_UINT32 = 0xFFFFFFFF;

// Chrome 51 has a buggy "split" implementation when RegExp#exec !== nativeExec
// Weex JS has frozen built-in prototypes, so use try / catch wrapper
var SPLIT_WORKS_WITH_OVERWRITTEN_EXEC = !fails$2(function () {
  // eslint-disable-next-line regexp/no-empty-group -- required for testing
  var re = /(?:)/;
  var originalExec = re.exec;
  re.exec = function () { return originalExec.apply(this, arguments); };
  var result = 'ab'.split(re);
  return result.length !== 2 || result[0] !== 'a' || result[1] !== 'b';
});

// @@split logic
fixRegExpWellKnownSymbolLogic$2('split', function (SPLIT, nativeSplit, maybeCallNative) {
  var internalSplit;
  if (
    'abbc'.split(/(b)*/)[1] == 'c' ||
    // eslint-disable-next-line regexp/no-empty-group -- required for testing
    'test'.split(/(?:)/, -1).length != 4 ||
    'ab'.split(/(?:ab)*/).length != 2 ||
    '.'.split(/(.?)(.?)/).length != 4 ||
    // eslint-disable-next-line regexp/no-assertion-capturing-group, regexp/no-empty-group -- required for testing
    '.'.split(/()()/).length > 1 ||
    ''.split(/.?/).length
  ) {
    // based on es5-shim implementation, need to rework it
    internalSplit = function (separator, limit) {
      var string = String(requireObjectCoercible$4(this));
      var lim = limit === undefined ? MAX_UINT32 : limit >>> 0;
      if (lim === 0) return [];
      if (separator === undefined) return [string];
      // If `separator` is not a regex, use native split
      if (!isRegExp$2(separator)) {
        return nativeSplit.call(string, separator, lim);
      }
      var output = [];
      var flags = (separator.ignoreCase ? 'i' : '') +
                  (separator.multiline ? 'm' : '') +
                  (separator.unicode ? 'u' : '') +
                  (separator.sticky ? 'y' : '');
      var lastLastIndex = 0;
      // Make `global` and avoid `lastIndex` issues by working with a copy
      var separatorCopy = new RegExp(separator.source, flags + 'g');
      var match, lastIndex, lastLength;
      while (match = regexpExec.call(separatorCopy, string)) {
        lastIndex = separatorCopy.lastIndex;
        if (lastIndex > lastLastIndex) {
          output.push(string.slice(lastLastIndex, match.index));
          if (match.length > 1 && match.index < string.length) arrayPush$4.apply(output, match.slice(1));
          lastLength = match[0].length;
          lastLastIndex = lastIndex;
          if (output.length >= lim) break;
        }
        if (separatorCopy.lastIndex === match.index) separatorCopy.lastIndex++; // Avoid an infinite loop
      }
      if (lastLastIndex === string.length) {
        if (lastLength || !separatorCopy.test('')) output.push('');
      } else output.push(string.slice(lastLastIndex));
      return output.length > lim ? output.slice(0, lim) : output;
    };
  // Chakra, V8
  } else if ('0'.split(undefined, 0).length) {
    internalSplit = function (separator, limit) {
      return separator === undefined && limit === 0 ? [] : nativeSplit.call(this, separator, limit);
    };
  } else internalSplit = nativeSplit;

  return [
    // `String.prototype.split` method
    // https://tc39.es/ecma262/#sec-string.prototype.split
    function split(separator, limit) {
      var O = requireObjectCoercible$4(this);
      var splitter = separator == undefined ? undefined : separator[SPLIT];
      return splitter !== undefined
        ? splitter.call(separator, O, limit)
        : internalSplit.call(String(O), separator, limit);
    },
    // `RegExp.prototype[@@split]` method
    // https://tc39.es/ecma262/#sec-regexp.prototype-@@split
    //
    // NOTE: This cannot be properly polyfilled in engines that don't support
    // the 'y' flag.
    function (string, limit) {
      var res = maybeCallNative(internalSplit, this, string, limit, internalSplit !== nativeSplit);
      if (res.done) return res.value;

      var rx = anObject$2(this);
      var S = String(string);
      var C = speciesConstructor(rx, RegExp);

      var unicodeMatching = rx.unicode;
      var flags = (rx.ignoreCase ? 'i' : '') +
                  (rx.multiline ? 'm' : '') +
                  (rx.unicode ? 'u' : '') +
                  (UNSUPPORTED_Y ? 'g' : 'y');

      // ^(? + rx + ) is needed, in combination with some S slicing, to
      // simulate the 'y' flag.
      var splitter = new C(UNSUPPORTED_Y ? '^(?:' + rx.source + ')' : rx, flags);
      var lim = limit === undefined ? MAX_UINT32 : limit >>> 0;
      if (lim === 0) return [];
      if (S.length === 0) return callRegExpExec(splitter, S) === null ? [S] : [];
      var p = 0;
      var q = 0;
      var A = [];
      while (q < S.length) {
        splitter.lastIndex = UNSUPPORTED_Y ? 0 : q;
        var z = callRegExpExec(splitter, UNSUPPORTED_Y ? S.slice(q) : S);
        var e;
        if (
          z === null ||
          (e = min$2(toLength$2(splitter.lastIndex + (UNSUPPORTED_Y ? q : 0)), S.length)) === p
        ) {
          q = advanceStringIndex$1(S, q, unicodeMatching);
        } else {
          A.push(S.slice(p, q));
          if (A.length === lim) return A;
          for (var i = 1; i <= z.length - 1; i++) {
            A.push(z[i]);
            if (A.length === lim) return A;
          }
          q = p = e;
        }
      }
      A.push(S.slice(p));
      return A;
    }
  ];
}, !SPLIT_WORKS_WITH_OVERWRITTEN_EXEC, UNSUPPORTED_Y);var $$3 = _export;
var getOwnPropertyDescriptor$2 = objectGetOwnPropertyDescriptor.f;
var toLength$1 = toLength$b;
var notARegExp = notARegexp;
var requireObjectCoercible$3 = requireObjectCoercible$a;
var correctIsRegExpLogic = correctIsRegexpLogic;

// eslint-disable-next-line es/no-string-prototype-startswith -- safe
var $startsWith = ''.startsWith;
var min$1 = Math.min;

var CORRECT_IS_REGEXP_LOGIC = correctIsRegExpLogic('startsWith');
// https://github.com/zloirock/core-js/pull/702
var MDN_POLYFILL_BUG = !CORRECT_IS_REGEXP_LOGIC && !!function () {
  var descriptor = getOwnPropertyDescriptor$2(String.prototype, 'startsWith');
  return descriptor && !descriptor.writable;
}();

// `String.prototype.startsWith` method
// https://tc39.es/ecma262/#sec-string.prototype.startswith
$$3({ target: 'String', proto: true, forced: !MDN_POLYFILL_BUG && !CORRECT_IS_REGEXP_LOGIC }, {
  startsWith: function startsWith(searchString /* , position = 0 */) {
    var that = String(requireObjectCoercible$3(this));
    notARegExp(searchString);
    var index = toLength$1(min$1(arguments.length > 1 ? arguments[1] : undefined, that.length));
    var search = String(searchString);
    return $startsWith
      ? $startsWith.call(that, search, index)
      : that.slice(index, index + search.length) === search;
  }
});var memoizerific = {exports: {}};(function (module, exports) {
(function(f){{module.exports=f();}})(function(){return (function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof commonjsRequire=="function"&&commonjsRequire;if(!u&&a)return a(o,!0);if(i)return i(o,!0);var f=new Error("Cannot find module '"+o+"'");throw f.code="MODULE_NOT_FOUND",f}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e)},l,l.exports,e,t,n,r);}return n[o].exports}var i=typeof commonjsRequire=="function"&&commonjsRequire;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(_dereq_,module,exports){
module.exports = function(forceSimilar) {
	if (typeof Map !== 'function' || forceSimilar) {
		var Similar = _dereq_('./similar');
		return new Similar();
	}
	else {
		return new Map();
	}
};

},{"./similar":2}],2:[function(_dereq_,module,exports){
function Similar() {
	this.list = [];
	this.lastItem = undefined;
	this.size = 0;

	return this;
}

Similar.prototype.get = function(key) {
	var index;

	if (this.lastItem && this.isEqual(this.lastItem.key, key)) {
		return this.lastItem.val;
	}

	index = this.indexOf(key);
	if (index >= 0) {
		this.lastItem = this.list[index];
		return this.list[index].val;
	}

	return undefined;
};

Similar.prototype.set = function(key, val) {
	var index;

	if (this.lastItem && this.isEqual(this.lastItem.key, key)) {
		this.lastItem.val = val;
		return this;
	}

	index = this.indexOf(key);
	if (index >= 0) {
		this.lastItem = this.list[index];
		this.list[index].val = val;
		return this;
	}

	this.lastItem = { key: key, val: val };
	this.list.push(this.lastItem);
	this.size++;

	return this;
};

Similar.prototype.delete = function(key) {
	var index;

	if (this.lastItem && this.isEqual(this.lastItem.key, key)) {
		this.lastItem = undefined;
	}

	index = this.indexOf(key);
	if (index >= 0) {
		this.size--;
		return this.list.splice(index, 1)[0];
	}

	return undefined;
};


// important that has() doesn't use get() in case an existing key has a falsy value, in which case has() would return false
Similar.prototype.has = function(key) {
	var index;

	if (this.lastItem && this.isEqual(this.lastItem.key, key)) {
		return true;
	}

	index = this.indexOf(key);
	if (index >= 0) {
		this.lastItem = this.list[index];
		return true;
	}

	return false;
};

Similar.prototype.forEach = function(callback, thisArg) {
	var i;
	for (i = 0; i < this.size; i++) {
		callback.call(thisArg || this, this.list[i].val, this.list[i].key, this);
	}
};

Similar.prototype.indexOf = function(key) {
	var i;
	for (i = 0; i < this.size; i++) {
		if (this.isEqual(this.list[i].key, key)) {
			return i;
		}
	}
	return -1;
};

// check if the numbers are equal, or whether they are both precisely NaN (isNaN returns true for all non-numbers)
Similar.prototype.isEqual = function(val1, val2) {
	return val1 === val2 || (val1 !== val1 && val2 !== val2);
};

module.exports = Similar;
},{}],3:[function(_dereq_,module,exports){
var MapOrSimilar = _dereq_('map-or-similar');

module.exports = function (limit) {
	var cache = new MapOrSimilar(undefined === 'true'),
		lru = [];

	return function (fn) {
		var memoizerific = function () {
			var currentCache = cache,
				newMap,
				fnResult,
				argsLengthMinusOne = arguments.length - 1,
				lruPath = Array(argsLengthMinusOne + 1),
				isMemoized = true,
				i;

			if ((memoizerific.numArgs || memoizerific.numArgs === 0) && memoizerific.numArgs !== argsLengthMinusOne + 1) {
				throw new Error('Memoizerific functions should always be called with the same number of arguments');
			}

			// loop through each argument to traverse the map tree
			for (i = 0; i < argsLengthMinusOne; i++) {
				lruPath[i] = {
					cacheItem: currentCache,
					arg: arguments[i]
				};

				// climb through the hierarchical map tree until the second-last argument has been found, or an argument is missing.
				// if all arguments up to the second-last have been found, this will potentially be a cache hit (determined later)
				if (currentCache.has(arguments[i])) {
					currentCache = currentCache.get(arguments[i]);
					continue;
				}

				isMemoized = false;

				// make maps until last value
				newMap = new MapOrSimilar(undefined === 'true');
				currentCache.set(arguments[i], newMap);
				currentCache = newMap;
			}

			// we are at the last arg, check if it is really memoized
			if (isMemoized) {
				if (currentCache.has(arguments[argsLengthMinusOne])) {
					fnResult = currentCache.get(arguments[argsLengthMinusOne]);
				}
				else {
					isMemoized = false;
				}
			}

			if (!isMemoized) {
				fnResult = fn.apply(null, arguments);
				currentCache.set(arguments[argsLengthMinusOne], fnResult);
			}

			if (limit > 0) {
				lruPath[argsLengthMinusOne] = {
					cacheItem: currentCache,
					arg: arguments[argsLengthMinusOne]
				};

				if (isMemoized) {
					moveToMostRecentLru(lru, lruPath);
				}
				else {
					lru.push(lruPath);
				}

				if (lru.length > limit) {
					removeCachedResult(lru.shift());
				}
			}

			memoizerific.wasMemoized = isMemoized;
			memoizerific.numArgs = argsLengthMinusOne + 1;

			return fnResult;
		};

		memoizerific.limit = limit;
		memoizerific.wasMemoized = false;
		memoizerific.cache = cache;
		memoizerific.lru = lru;

		return memoizerific;
	};
};

// move current args to most recent position
function moveToMostRecentLru(lru, lruPath) {
	var lruLen = lru.length,
		lruPathLen = lruPath.length,
		isMatch,
		i, ii;

	for (i = 0; i < lruLen; i++) {
		isMatch = true;
		for (ii = 0; ii < lruPathLen; ii++) {
			if (!isEqual(lru[i][ii].arg, lruPath[ii].arg)) {
				isMatch = false;
				break;
			}
		}
		if (isMatch) {
			break;
		}
	}

	lru.push(lru.splice(i, 1)[0]);
}

// remove least recently used cache item and all dead branches
function removeCachedResult(removedLru) {
	var removedLruLen = removedLru.length,
		currentLru = removedLru[removedLruLen - 1],
		tmp,
		i;

	currentLru.cacheItem.delete(currentLru.arg);

	// walk down the tree removing dead branches (size 0) along the way
	for (i = removedLruLen - 2; i >= 0; i--) {
		currentLru = removedLru[i];
		tmp = currentLru.cacheItem.get(currentLru.arg);

		if (!tmp || !tmp.size) {
			currentLru.cacheItem.delete(currentLru.arg);
		} else {
			break;
		}
	}
}

// check if the numbers are equal, or whether they are both precisely NaN (isNaN returns true for all non-numbers)
function isEqual(val1, val2) {
	return val1 === val2 || (val1 !== val1 && val2 !== val2);
}
},{"map-or-similar":1}]},{},[3])(3)
});
}(memoizerific));

var memoize$3 = memoizerific.exports;var stable$1 = {exports: {}};(function (module, exports) {
//! stable.js 0.1.8, https://github.com/Two-Screen/stable
//! © 2018 Angry Bytes and contributors. MIT licensed.

(function (global, factory) {
  module.exports = factory() ;
}(commonjsGlobal, (function () {
  // A stable array sort, because `Array#sort()` is not guaranteed stable.
  // This is an implementation of merge sort, without recursion.

  var stable = function (arr, comp) {
    return exec(arr.slice(), comp)
  };

  stable.inplace = function (arr, comp) {
    var result = exec(arr, comp);

    // This simply copies back if the result isn't in the original array,
    // which happens on an odd number of passes.
    if (result !== arr) {
      pass(result, null, arr.length, arr);
    }

    return arr
  };

  // Execute the sort using the input array and a second buffer as work space.
  // Returns one of those two, containing the final result.
  function exec(arr, comp) {
    if (typeof(comp) !== 'function') {
      comp = function (a, b) {
        return String(a).localeCompare(b)
      };
    }

    // Short-circuit when there's nothing to sort.
    var len = arr.length;
    if (len <= 1) {
      return arr
    }

    // Rather than dividing input, simply iterate chunks of 1, 2, 4, 8, etc.
    // Chunks are the size of the left or right hand in merge sort.
    // Stop when the left-hand covers all of the array.
    var buffer = new Array(len);
    for (var chk = 1; chk < len; chk *= 2) {
      pass(arr, comp, chk, buffer);

      var tmp = arr;
      arr = buffer;
      buffer = tmp;
    }

    return arr
  }

  // Run a single pass with the given chunk size.
  var pass = function (arr, comp, chk, result) {
    var len = arr.length;
    var i = 0;
    // Step size / double chunk size.
    var dbl = chk * 2;
    // Bounds of the left and right chunks.
    var l, r, e;
    // Iterators over the left and right chunk.
    var li, ri;

    // Iterate over pairs of chunks.
    for (l = 0; l < len; l += dbl) {
      r = l + chk;
      e = r + chk;
      if (r > len) r = len;
      if (e > len) e = len;

      // Iterate both chunks in parallel.
      li = l;
      ri = r;
      while (true) {
        // Compare the chunks.
        if (li < r && ri < e) {
          // This works for a regular `sort()` compatible comparator,
          // but also for a simple comparator like: `a > b`
          if (comp(arr[li], arr[ri]) <= 0) {
            result[i++] = arr[li++];
          }
          else {
            result[i++] = arr[ri++];
          }
        }
        // Nothing to compare, just flush what's left.
        else if (li < r) {
          result[i++] = arr[li++];
        }
        else if (ri < e) {
          result[i++] = arr[ri++];
        }
        // Both iterators are at the chunk ends.
        else {
          break
        }
      }
    }
  };

  return stable;

})));
}(stable$1));

var stable = stable$1.exports;/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */

function isObject$f(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

var isObject_1 = isObject$f;var baseGetTag$4 = _baseGetTag,
    isObject$e = isObject_1;

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag$2 = '[object Function]',
    genTag$1 = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction$5(value) {
  if (!isObject$e(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag$4(value);
  return tag == funcTag$2 || tag == genTag$1 || tag == asyncTag || tag == proxyTag;
}

var isFunction_1 = isFunction$5;var root$8 = _root;

/** Used to detect overreaching core-js shims. */
var coreJsData$1 = root$8['__core-js_shared__'];

var _coreJsData = coreJsData$1;var coreJsData = _coreJsData;

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked$1(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

var _isMasked = isMasked$1;/** Used for built-in method references. */

var funcProto$1 = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString$1 = funcProto$1.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource$2(func) {
  if (func != null) {
    try {
      return funcToString$1.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

var _toSource = toSource$2;var isFunction$4 = isFunction_1,
    isMasked = _isMasked,
    isObject$d = isObject_1,
    toSource$1 = _toSource;

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto$e = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty$b = objectProto$e.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty$b).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative$1(value) {
  if (!isObject$d(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction$4(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource$1(value));
}

var _baseIsNative = baseIsNative$1;/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */

function getValue$1(object, key) {
  return object == null ? undefined : object[key];
}

var _getValue = getValue$1;var baseIsNative = _baseIsNative,
    getValue = _getValue;

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative$7(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

var _getNative = getNative$7;var getNative$6 = _getNative;

var defineProperty$5 = (function() {
  try {
    var func = getNative$6(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}());

var _defineProperty$6 = defineProperty$5;var defineProperty$4 = _defineProperty$6;

/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function baseAssignValue$4(object, key, value) {
  if (key == '__proto__' && defineProperty$4) {
    defineProperty$4(object, key, {
      'configurable': true,
      'enumerable': true,
      'value': value,
      'writable': true
    });
  } else {
    object[key] = value;
  }
}

var _baseAssignValue = baseAssignValue$4;/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */

function createBaseFor$1(fromRight) {
  return function(object, iteratee, keysFunc) {
    var index = -1,
        iterable = Object(object),
        props = keysFunc(object),
        length = props.length;

    while (length--) {
      var key = props[fromRight ? length : ++index];
      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }
    return object;
  };
}

var _createBaseFor = createBaseFor$1;var createBaseFor = _createBaseFor;

/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */
var baseFor$2 = createBaseFor();

var _baseFor = baseFor$2;/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */

function baseTimes$1(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

var _baseTimes = baseTimes$1;var baseGetTag$3 = _baseGetTag,
    isObjectLike$8 = isObjectLike_1;

/** `Object#toString` result references. */
var argsTag$3 = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments$1(value) {
  return isObjectLike$8(value) && baseGetTag$3(value) == argsTag$3;
}

var _baseIsArguments = baseIsArguments$1;var baseIsArguments = _baseIsArguments,
    isObjectLike$7 = isObjectLike_1;

/** Used for built-in method references. */
var objectProto$d = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$a = objectProto$d.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable$1 = objectProto$d.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments$5 = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
  return isObjectLike$7(value) && hasOwnProperty$a.call(value, 'callee') &&
    !propertyIsEnumerable$1.call(value, 'callee');
};

var isArguments_1 = isArguments$5;var isBuffer$7 = {exports: {}};/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */

function stubFalse() {
  return false;
}

var stubFalse_1 = stubFalse;(function (module, exports) {
var root = _root,
    stubFalse = stubFalse_1;

/** Detect free variable `exports`. */
var freeExports = exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && 'object' == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

module.exports = isBuffer;
}(isBuffer$7, isBuffer$7.exports));/** Used as references for various `Number` constants. */

var MAX_SAFE_INTEGER$1 = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex$5(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER$1 : length;

  return !!length &&
    (type == 'number' ||
      (type != 'symbol' && reIsUint.test(value))) &&
        (value > -1 && value % 1 == 0 && value < length);
}

var _isIndex = isIndex$5;/** Used as references for various `Number` constants. */

var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength$3(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

var isLength_1 = isLength$3;var baseGetTag$2 = _baseGetTag,
    isLength$2 = isLength_1,
    isObjectLike$6 = isObjectLike_1;

/** `Object#toString` result references. */
var argsTag$2 = '[object Arguments]',
    arrayTag$2 = '[object Array]',
    boolTag$3 = '[object Boolean]',
    dateTag$3 = '[object Date]',
    errorTag$2 = '[object Error]',
    funcTag$1 = '[object Function]',
    mapTag$6 = '[object Map]',
    numberTag$3 = '[object Number]',
    objectTag$3 = '[object Object]',
    regexpTag$3 = '[object RegExp]',
    setTag$6 = '[object Set]',
    stringTag$4 = '[object String]',
    weakMapTag$2 = '[object WeakMap]';

var arrayBufferTag$3 = '[object ArrayBuffer]',
    dataViewTag$4 = '[object DataView]',
    float32Tag$2 = '[object Float32Array]',
    float64Tag$2 = '[object Float64Array]',
    int8Tag$2 = '[object Int8Array]',
    int16Tag$2 = '[object Int16Array]',
    int32Tag$2 = '[object Int32Array]',
    uint8Tag$2 = '[object Uint8Array]',
    uint8ClampedTag$2 = '[object Uint8ClampedArray]',
    uint16Tag$2 = '[object Uint16Array]',
    uint32Tag$2 = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag$2] = typedArrayTags[float64Tag$2] =
typedArrayTags[int8Tag$2] = typedArrayTags[int16Tag$2] =
typedArrayTags[int32Tag$2] = typedArrayTags[uint8Tag$2] =
typedArrayTags[uint8ClampedTag$2] = typedArrayTags[uint16Tag$2] =
typedArrayTags[uint32Tag$2] = true;
typedArrayTags[argsTag$2] = typedArrayTags[arrayTag$2] =
typedArrayTags[arrayBufferTag$3] = typedArrayTags[boolTag$3] =
typedArrayTags[dataViewTag$4] = typedArrayTags[dateTag$3] =
typedArrayTags[errorTag$2] = typedArrayTags[funcTag$1] =
typedArrayTags[mapTag$6] = typedArrayTags[numberTag$3] =
typedArrayTags[objectTag$3] = typedArrayTags[regexpTag$3] =
typedArrayTags[setTag$6] = typedArrayTags[stringTag$4] =
typedArrayTags[weakMapTag$2] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray$1(value) {
  return isObjectLike$6(value) &&
    isLength$2(value.length) && !!typedArrayTags[baseGetTag$2(value)];
}

var _baseIsTypedArray = baseIsTypedArray$1;/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */

function baseUnary$6(func) {
  return function(value) {
    return func(value);
  };
}

var _baseUnary = baseUnary$6;var _nodeUtil = {exports: {}};(function (module, exports) {
var freeGlobal = _freeGlobal;

/** Detect free variable `exports`. */
var freeExports = exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && 'object' == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    // Use `util.types` for Node.js 10+.
    var types = freeModule && freeModule.require && freeModule.require('util').types;

    if (types) {
      return types;
    }

    // Legacy `process.binding('util')` for Node.js < 10.
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

module.exports = nodeUtil;
}(_nodeUtil, _nodeUtil.exports));var baseIsTypedArray = _baseIsTypedArray,
    baseUnary$5 = _baseUnary,
    nodeUtil$2 = _nodeUtil.exports;

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil$2 && nodeUtil$2.isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray$4 = nodeIsTypedArray ? baseUnary$5(nodeIsTypedArray) : baseIsTypedArray;

var isTypedArray_1 = isTypedArray$4;var baseTimes = _baseTimes,
    isArguments$4 = isArguments_1,
    isArray$k = isArray_1,
    isBuffer$6 = isBuffer$7.exports,
    isIndex$4 = _isIndex,
    isTypedArray$3 = isTypedArray_1;

/** Used for built-in method references. */
var objectProto$c = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$9 = objectProto$c.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys$2(value, inherited) {
  var isArr = isArray$k(value),
      isArg = !isArr && isArguments$4(value),
      isBuff = !isArr && !isArg && isBuffer$6(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray$3(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty$9.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           isIndex$4(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

var _arrayLikeKeys = arrayLikeKeys$2;/** Used for built-in method references. */

var objectProto$b = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype$4(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto$b;

  return value === proto;
}

var _isPrototype = isPrototype$4;var overArg = _overArg;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys$1 = overArg(Object.keys, Object);

var _nativeKeys = nativeKeys$1;var isPrototype$3 = _isPrototype,
    nativeKeys = _nativeKeys;

/** Used for built-in method references. */
var objectProto$a = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$8 = objectProto$a.hasOwnProperty;

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys$2(object) {
  if (!isPrototype$3(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty$8.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

var _baseKeys = baseKeys$2;var isFunction$3 = isFunction_1,
    isLength$1 = isLength_1;

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike$9(value) {
  return value != null && isLength$1(value.length) && !isFunction$3(value);
}

var isArrayLike_1 = isArrayLike$9;var arrayLikeKeys$1 = _arrayLikeKeys,
    baseKeys$1 = _baseKeys,
    isArrayLike$8 = isArrayLike_1;

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys$9(object) {
  return isArrayLike$8(object) ? arrayLikeKeys$1(object) : baseKeys$1(object);
}

var keys_1 = keys$9;var baseFor$1 = _baseFor,
    keys$8 = keys_1;

/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */
function baseForOwn$3(object, iteratee) {
  return object && baseFor$1(object, iteratee, keys$8);
}

var _baseForOwn = baseForOwn$3;/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */

function listCacheClear$1() {
  this.__data__ = [];
  this.size = 0;
}

var _listCacheClear = listCacheClear$1;/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */

function eq$5(value, other) {
  return value === other || (value !== value && other !== other);
}

var eq_1 = eq$5;var eq$4 = eq_1;

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf$4(array, key) {
  var length = array.length;
  while (length--) {
    if (eq$4(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

var _assocIndexOf = assocIndexOf$4;var assocIndexOf$3 = _assocIndexOf;

/** Used for built-in method references. */
var arrayProto$1 = Array.prototype;

/** Built-in value references. */
var splice$1 = arrayProto$1.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete$1(key) {
  var data = this.__data__,
      index = assocIndexOf$3(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice$1.call(data, index, 1);
  }
  --this.size;
  return true;
}

var _listCacheDelete = listCacheDelete$1;var assocIndexOf$2 = _assocIndexOf;

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet$1(key) {
  var data = this.__data__,
      index = assocIndexOf$2(data, key);

  return index < 0 ? undefined : data[index][1];
}

var _listCacheGet = listCacheGet$1;var assocIndexOf$1 = _assocIndexOf;

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas$1(key) {
  return assocIndexOf$1(this.__data__, key) > -1;
}

var _listCacheHas = listCacheHas$1;var assocIndexOf = _assocIndexOf;

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet$1(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

var _listCacheSet = listCacheSet$1;var listCacheClear = _listCacheClear,
    listCacheDelete = _listCacheDelete,
    listCacheGet = _listCacheGet,
    listCacheHas = _listCacheHas,
    listCacheSet = _listCacheSet;

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache$4(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache$4.prototype.clear = listCacheClear;
ListCache$4.prototype['delete'] = listCacheDelete;
ListCache$4.prototype.get = listCacheGet;
ListCache$4.prototype.has = listCacheHas;
ListCache$4.prototype.set = listCacheSet;

var _ListCache = ListCache$4;var ListCache$3 = _ListCache;

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear$1() {
  this.__data__ = new ListCache$3;
  this.size = 0;
}

var _stackClear = stackClear$1;/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */

function stackDelete$1(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

var _stackDelete = stackDelete$1;/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */

function stackGet$1(key) {
  return this.__data__.get(key);
}

var _stackGet = stackGet$1;/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */

function stackHas$1(key) {
  return this.__data__.has(key);
}

var _stackHas = stackHas$1;var getNative$5 = _getNative,
    root$7 = _root;

/* Built-in method references that are verified to be native. */
var Map$4 = getNative$5(root$7, 'Map');

var _Map = Map$4;var getNative$4 = _getNative;

/* Built-in method references that are verified to be native. */
var nativeCreate$4 = getNative$4(Object, 'create');

var _nativeCreate = nativeCreate$4;var nativeCreate$3 = _nativeCreate;

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear$1() {
  this.__data__ = nativeCreate$3 ? nativeCreate$3(null) : {};
  this.size = 0;
}

var _hashClear = hashClear$1;/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */

function hashDelete$1(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

var _hashDelete = hashDelete$1;var nativeCreate$2 = _nativeCreate;

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED$2 = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto$9 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$7 = objectProto$9.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet$1(key) {
  var data = this.__data__;
  if (nativeCreate$2) {
    var result = data[key];
    return result === HASH_UNDEFINED$2 ? undefined : result;
  }
  return hasOwnProperty$7.call(data, key) ? data[key] : undefined;
}

var _hashGet = hashGet$1;var nativeCreate$1 = _nativeCreate;

/** Used for built-in method references. */
var objectProto$8 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$6 = objectProto$8.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas$1(key) {
  var data = this.__data__;
  return nativeCreate$1 ? (data[key] !== undefined) : hasOwnProperty$6.call(data, key);
}

var _hashHas = hashHas$1;var nativeCreate = _nativeCreate;

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED$1 = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet$1(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED$1 : value;
  return this;
}

var _hashSet = hashSet$1;var hashClear = _hashClear,
    hashDelete = _hashDelete,
    hashGet = _hashGet,
    hashHas = _hashHas,
    hashSet = _hashSet;

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash$1(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash$1.prototype.clear = hashClear;
Hash$1.prototype['delete'] = hashDelete;
Hash$1.prototype.get = hashGet;
Hash$1.prototype.has = hashHas;
Hash$1.prototype.set = hashSet;

var _Hash = Hash$1;var Hash = _Hash,
    ListCache$2 = _ListCache,
    Map$3 = _Map;

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear$1() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map$3 || ListCache$2),
    'string': new Hash
  };
}

var _mapCacheClear = mapCacheClear$1;/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */

function isKeyable$1(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

var _isKeyable = isKeyable$1;var isKeyable = _isKeyable;

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData$4(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

var _getMapData = getMapData$4;var getMapData$3 = _getMapData;

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete$1(key) {
  var result = getMapData$3(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

var _mapCacheDelete = mapCacheDelete$1;var getMapData$2 = _getMapData;

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet$1(key) {
  return getMapData$2(this, key).get(key);
}

var _mapCacheGet = mapCacheGet$1;var getMapData$1 = _getMapData;

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas$1(key) {
  return getMapData$1(this, key).has(key);
}

var _mapCacheHas = mapCacheHas$1;var getMapData = _getMapData;

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet$1(key, value) {
  var data = getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

var _mapCacheSet = mapCacheSet$1;var mapCacheClear = _mapCacheClear,
    mapCacheDelete = _mapCacheDelete,
    mapCacheGet = _mapCacheGet,
    mapCacheHas = _mapCacheHas,
    mapCacheSet = _mapCacheSet;

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache$3(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache$3.prototype.clear = mapCacheClear;
MapCache$3.prototype['delete'] = mapCacheDelete;
MapCache$3.prototype.get = mapCacheGet;
MapCache$3.prototype.has = mapCacheHas;
MapCache$3.prototype.set = mapCacheSet;

var _MapCache = MapCache$3;var ListCache$1 = _ListCache,
    Map$2 = _Map,
    MapCache$2 = _MapCache;

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE$2 = 200;

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet$1(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache$1) {
    var pairs = data.__data__;
    if (!Map$2 || (pairs.length < LARGE_ARRAY_SIZE$2 - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache$2(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

var _stackSet = stackSet$1;var ListCache = _ListCache,
    stackClear = _stackClear,
    stackDelete = _stackDelete,
    stackGet = _stackGet,
    stackHas = _stackHas,
    stackSet = _stackSet;

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack$4(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
}

// Add methods to `Stack`.
Stack$4.prototype.clear = stackClear;
Stack$4.prototype['delete'] = stackDelete;
Stack$4.prototype.get = stackGet;
Stack$4.prototype.has = stackHas;
Stack$4.prototype.set = stackSet;

var _Stack = Stack$4;/** Used to stand-in for `undefined` hash values. */

var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd$1(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}

var _setCacheAdd = setCacheAdd$1;/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */

function setCacheHas$1(value) {
  return this.__data__.has(value);
}

var _setCacheHas = setCacheHas$1;var MapCache$1 = _MapCache,
    setCacheAdd = _setCacheAdd,
    setCacheHas = _setCacheHas;

/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache$4(values) {
  var index = -1,
      length = values == null ? 0 : values.length;

  this.__data__ = new MapCache$1;
  while (++index < length) {
    this.add(values[index]);
  }
}

// Add methods to `SetCache`.
SetCache$4.prototype.add = SetCache$4.prototype.push = setCacheAdd;
SetCache$4.prototype.has = setCacheHas;

var _SetCache = SetCache$4;/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */

function arraySome$1(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

var _arraySome = arraySome$1;/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */

function cacheHas$4(cache, key) {
  return cache.has(key);
}

var _cacheHas = cacheHas$4;var SetCache$3 = _SetCache,
    arraySome = _arraySome,
    cacheHas$3 = _cacheHas;

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG$5 = 1,
    COMPARE_UNORDERED_FLAG$3 = 2;

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays$2(array, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG$5,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  // Check that cyclic values are equal.
  var arrStacked = stack.get(array);
  var othStacked = stack.get(other);
  if (arrStacked && othStacked) {
    return arrStacked == other && othStacked == array;
  }
  var index = -1,
      result = true,
      seen = (bitmask & COMPARE_UNORDERED_FLAG$3) ? new SetCache$3 : undefined;

  stack.set(array, other);
  stack.set(other, array);

  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, arrValue, index, other, array, stack)
        : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (seen) {
      if (!arraySome(other, function(othValue, othIndex) {
            if (!cacheHas$3(seen, othIndex) &&
                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
              return seen.push(othIndex);
            }
          })) {
        result = false;
        break;
      }
    } else if (!(
          arrValue === othValue ||
            equalFunc(arrValue, othValue, bitmask, customizer, stack)
        )) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  stack['delete'](other);
  return result;
}

var _equalArrays = equalArrays$2;var root$6 = _root;

/** Built-in value references. */
var Uint8Array$3 = root$6.Uint8Array;

var _Uint8Array = Uint8Array$3;/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */

function mapToArray$1(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

var _mapToArray = mapToArray$1;/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */

function setToArray$3(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

var _setToArray = setToArray$3;var Symbol$3 = _Symbol,
    Uint8Array$2 = _Uint8Array,
    eq$3 = eq_1,
    equalArrays$1 = _equalArrays,
    mapToArray = _mapToArray,
    setToArray$2 = _setToArray;

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG$4 = 1,
    COMPARE_UNORDERED_FLAG$2 = 2;

/** `Object#toString` result references. */
var boolTag$2 = '[object Boolean]',
    dateTag$2 = '[object Date]',
    errorTag$1 = '[object Error]',
    mapTag$5 = '[object Map]',
    numberTag$2 = '[object Number]',
    regexpTag$2 = '[object RegExp]',
    setTag$5 = '[object Set]',
    stringTag$3 = '[object String]',
    symbolTag$3 = '[object Symbol]';

var arrayBufferTag$2 = '[object ArrayBuffer]',
    dataViewTag$3 = '[object DataView]';

/** Used to convert symbols to primitives and strings. */
var symbolProto$1 = Symbol$3 ? Symbol$3.prototype : undefined,
    symbolValueOf$1 = symbolProto$1 ? symbolProto$1.valueOf : undefined;

/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalByTag$1(object, other, tag, bitmask, customizer, equalFunc, stack) {
  switch (tag) {
    case dataViewTag$3:
      if ((object.byteLength != other.byteLength) ||
          (object.byteOffset != other.byteOffset)) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;

    case arrayBufferTag$2:
      if ((object.byteLength != other.byteLength) ||
          !equalFunc(new Uint8Array$2(object), new Uint8Array$2(other))) {
        return false;
      }
      return true;

    case boolTag$2:
    case dateTag$2:
    case numberTag$2:
      // Coerce booleans to `1` or `0` and dates to milliseconds.
      // Invalid dates are coerced to `NaN`.
      return eq$3(+object, +other);

    case errorTag$1:
      return object.name == other.name && object.message == other.message;

    case regexpTag$2:
    case stringTag$3:
      // Coerce regexes to strings and treat strings, primitives and objects,
      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
      // for more details.
      return object == (other + '');

    case mapTag$5:
      var convert = mapToArray;

    case setTag$5:
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG$4;
      convert || (convert = setToArray$2);

      if (object.size != other.size && !isPartial) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= COMPARE_UNORDERED_FLAG$2;

      // Recursively compare objects (susceptible to call stack limits).
      stack.set(object, other);
      var result = equalArrays$1(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
      stack['delete'](object);
      return result;

    case symbolTag$3:
      if (symbolValueOf$1) {
        return symbolValueOf$1.call(object) == symbolValueOf$1.call(other);
      }
  }
  return false;
}

var _equalByTag = equalByTag$1;/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */

function arrayPush$3(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

var _arrayPush = arrayPush$3;var arrayPush$2 = _arrayPush,
    isArray$j = isArray_1;

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys$2(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray$j(object) ? result : arrayPush$2(result, symbolsFunc(object));
}

var _baseGetAllKeys = baseGetAllKeys$2;/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */

function arrayFilter$2(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

var _arrayFilter = arrayFilter$2;/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */

function stubArray$2() {
  return [];
}

var stubArray_1 = stubArray$2;var arrayFilter$1 = _arrayFilter,
    stubArray$1 = stubArray_1;

/** Used for built-in method references. */
var objectProto$7 = Object.prototype;

/** Built-in value references. */
var propertyIsEnumerable = objectProto$7.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols$1 = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols$3 = !nativeGetSymbols$1 ? stubArray$1 : function(object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return arrayFilter$1(nativeGetSymbols$1(object), function(symbol) {
    return propertyIsEnumerable.call(object, symbol);
  });
};

var _getSymbols = getSymbols$3;var baseGetAllKeys$1 = _baseGetAllKeys,
    getSymbols$2 = _getSymbols,
    keys$7 = keys_1;

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys$2(object) {
  return baseGetAllKeys$1(object, keys$7, getSymbols$2);
}

var _getAllKeys = getAllKeys$2;var getAllKeys$1 = _getAllKeys;

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG$3 = 1;

/** Used for built-in method references. */
var objectProto$6 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$5 = objectProto$6.hasOwnProperty;

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects$1(object, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG$3,
      objProps = getAllKeys$1(object),
      objLength = objProps.length,
      othProps = getAllKeys$1(other),
      othLength = othProps.length;

  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : hasOwnProperty$5.call(other, key))) {
      return false;
    }
  }
  // Check that cyclic values are equal.
  var objStacked = stack.get(object);
  var othStacked = stack.get(other);
  if (objStacked && othStacked) {
    return objStacked == other && othStacked == object;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);

  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, objValue, key, other, object, stack)
        : customizer(objValue, othValue, key, object, other, stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if (!(compared === undefined
          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
          : compared
        )) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor &&
        ('constructor' in object && 'constructor' in other) &&
        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  stack['delete'](other);
  return result;
}

var _equalObjects = equalObjects$1;var getNative$3 = _getNative,
    root$5 = _root;

/* Built-in method references that are verified to be native. */
var DataView$2 = getNative$3(root$5, 'DataView');

var _DataView = DataView$2;var getNative$2 = _getNative,
    root$4 = _root;

/* Built-in method references that are verified to be native. */
var Promise$2 = getNative$2(root$4, 'Promise');

var _Promise = Promise$2;var getNative$1 = _getNative,
    root$3 = _root;

/* Built-in method references that are verified to be native. */
var Set$3 = getNative$1(root$3, 'Set');

var _Set = Set$3;var getNative = _getNative,
    root$2 = _root;

/* Built-in method references that are verified to be native. */
var WeakMap$2 = getNative(root$2, 'WeakMap');

var _WeakMap = WeakMap$2;var DataView$1 = _DataView,
    Map$1 = _Map,
    Promise$1 = _Promise,
    Set$2 = _Set,
    WeakMap$1 = _WeakMap,
    baseGetTag$1 = _baseGetTag,
    toSource = _toSource;

/** `Object#toString` result references. */
var mapTag$4 = '[object Map]',
    objectTag$2 = '[object Object]',
    promiseTag = '[object Promise]',
    setTag$4 = '[object Set]',
    weakMapTag$1 = '[object WeakMap]';

var dataViewTag$2 = '[object DataView]';

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView$1),
    mapCtorString = toSource(Map$1),
    promiseCtorString = toSource(Promise$1),
    setCtorString = toSource(Set$2),
    weakMapCtorString = toSource(WeakMap$1);

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag$5 = baseGetTag$1;

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((DataView$1 && getTag$5(new DataView$1(new ArrayBuffer(1))) != dataViewTag$2) ||
    (Map$1 && getTag$5(new Map$1) != mapTag$4) ||
    (Promise$1 && getTag$5(Promise$1.resolve()) != promiseTag) ||
    (Set$2 && getTag$5(new Set$2) != setTag$4) ||
    (WeakMap$1 && getTag$5(new WeakMap$1) != weakMapTag$1)) {
  getTag$5 = function(value) {
    var result = baseGetTag$1(value),
        Ctor = result == objectTag$2 ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : '';

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag$2;
        case mapCtorString: return mapTag$4;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag$4;
        case weakMapCtorString: return weakMapTag$1;
      }
    }
    return result;
  };
}

var _getTag = getTag$5;var Stack$3 = _Stack,
    equalArrays = _equalArrays,
    equalByTag = _equalByTag,
    equalObjects = _equalObjects,
    getTag$4 = _getTag,
    isArray$i = isArray_1,
    isBuffer$5 = isBuffer$7.exports,
    isTypedArray$2 = isTypedArray_1;

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG$2 = 1;

/** `Object#toString` result references. */
var argsTag$1 = '[object Arguments]',
    arrayTag$1 = '[object Array]',
    objectTag$1 = '[object Object]';

/** Used for built-in method references. */
var objectProto$5 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$4 = objectProto$5.hasOwnProperty;

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep$1(object, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = isArray$i(object),
      othIsArr = isArray$i(other),
      objTag = objIsArr ? arrayTag$1 : getTag$4(object),
      othTag = othIsArr ? arrayTag$1 : getTag$4(other);

  objTag = objTag == argsTag$1 ? objectTag$1 : objTag;
  othTag = othTag == argsTag$1 ? objectTag$1 : othTag;

  var objIsObj = objTag == objectTag$1,
      othIsObj = othTag == objectTag$1,
      isSameTag = objTag == othTag;

  if (isSameTag && isBuffer$5(object)) {
    if (!isBuffer$5(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack || (stack = new Stack$3);
    return (objIsArr || isTypedArray$2(object))
      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
  }
  if (!(bitmask & COMPARE_PARTIAL_FLAG$2)) {
    var objIsWrapped = objIsObj && hasOwnProperty$4.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && hasOwnProperty$4.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
          othUnwrapped = othIsWrapped ? other.value() : other;

      stack || (stack = new Stack$3);
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new Stack$3);
  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}

var _baseIsEqualDeep = baseIsEqualDeep$1;var baseIsEqualDeep = _baseIsEqualDeep,
    isObjectLike$5 = isObjectLike_1;

/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual$3(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || (!isObjectLike$5(value) && !isObjectLike$5(other))) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual$3, stack);
}

var _baseIsEqual = baseIsEqual$3;var Stack$2 = _Stack,
    baseIsEqual$2 = _baseIsEqual;

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG$1 = 1,
    COMPARE_UNORDERED_FLAG$1 = 2;

/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */
function baseIsMatch$1(object, source, matchData, customizer) {
  var index = matchData.length,
      length = index,
      noCustomizer = !customizer;

  if (object == null) {
    return !length;
  }
  object = Object(object);
  while (index--) {
    var data = matchData[index];
    if ((noCustomizer && data[2])
          ? data[1] !== object[data[0]]
          : !(data[0] in object)
        ) {
      return false;
    }
  }
  while (++index < length) {
    data = matchData[index];
    var key = data[0],
        objValue = object[key],
        srcValue = data[1];

    if (noCustomizer && data[2]) {
      if (objValue === undefined && !(key in object)) {
        return false;
      }
    } else {
      var stack = new Stack$2;
      if (customizer) {
        var result = customizer(objValue, srcValue, key, object, source, stack);
      }
      if (!(result === undefined
            ? baseIsEqual$2(srcValue, objValue, COMPARE_PARTIAL_FLAG$1 | COMPARE_UNORDERED_FLAG$1, customizer, stack)
            : result
          )) {
        return false;
      }
    }
  }
  return true;
}

var _baseIsMatch = baseIsMatch$1;var isObject$c = isObject_1;

/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */
function isStrictComparable$2(value) {
  return value === value && !isObject$c(value);
}

var _isStrictComparable = isStrictComparable$2;var isStrictComparable$1 = _isStrictComparable,
    keys$6 = keys_1;

/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */
function getMatchData$1(object) {
  var result = keys$6(object),
      length = result.length;

  while (length--) {
    var key = result[length],
        value = object[key];

    result[length] = [key, value, isStrictComparable$1(value)];
  }
  return result;
}

var _getMatchData = getMatchData$1;/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */

function matchesStrictComparable$2(key, srcValue) {
  return function(object) {
    if (object == null) {
      return false;
    }
    return object[key] === srcValue &&
      (srcValue !== undefined || (key in Object(object)));
  };
}

var _matchesStrictComparable = matchesStrictComparable$2;var baseIsMatch = _baseIsMatch,
    getMatchData = _getMatchData,
    matchesStrictComparable$1 = _matchesStrictComparable;

/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatches$1(source) {
  var matchData = getMatchData(source);
  if (matchData.length == 1 && matchData[0][2]) {
    return matchesStrictComparable$1(matchData[0][0], matchData[0][1]);
  }
  return function(object) {
    return object === source || baseIsMatch(object, source, matchData);
  };
}

var _baseMatches = baseMatches$1;var isArray$h = isArray_1,
    isSymbol$5 = isSymbol_1;

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/;

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey$3(value, object) {
  if (isArray$h(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || isSymbol$5(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

var _isKey = isKey$3;var MapCache = _MapCache;

/** Error message constants. */
var FUNC_ERROR_TEXT$3 = 'Expected a function';

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize$2(func, resolver) {
  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT$3);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result) || cache;
    return result;
  };
  memoized.cache = new (memoize$2.Cache || MapCache);
  return memoized;
}

// Expose `MapCache`.
memoize$2.Cache = MapCache;

var memoize_1 = memoize$2;var memoize$1 = memoize_1;

/** Used as the maximum memoize cache size. */
var MAX_MEMOIZE_SIZE = 500;

/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */
function memoizeCapped$1(func) {
  var result = memoize$1(func, function(key) {
    if (cache.size === MAX_MEMOIZE_SIZE) {
      cache.clear();
    }
    return key;
  });

  var cache = result.cache;
  return result;
}

var _memoizeCapped = memoizeCapped$1;var memoizeCapped = _memoizeCapped;

/** Used to match property names within property paths. */
var rePropName$1 = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/** Used to match backslashes in property paths. */
var reEscapeChar$1 = /\\(\\)?/g;

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath$2 = memoizeCapped(function(string) {
  var result = [];
  if (string.charCodeAt(0) === 46 /* . */) {
    result.push('');
  }
  string.replace(rePropName$1, function(match, number, quote, subString) {
    result.push(quote ? subString.replace(reEscapeChar$1, '$1') : (number || match));
  });
  return result;
});

var _stringToPath = stringToPath$2;var isArray$g = isArray_1,
    isKey$2 = _isKey,
    stringToPath$1 = _stringToPath,
    toString$1 = toString_1;

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */
function castPath$6(value, object) {
  if (isArray$g(value)) {
    return value;
  }
  return isKey$2(value, object) ? [value] : stringToPath$1(toString$1(value));
}

var _castPath = castPath$6;var isSymbol$4 = isSymbol_1;

/** Used as references for various `Number` constants. */
var INFINITY$2 = 1 / 0;

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey$6(value) {
  if (typeof value == 'string' || isSymbol$4(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY$2) ? '-0' : result;
}

var _toKey = toKey$6;var castPath$5 = _castPath,
    toKey$5 = _toKey;

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet$5(object, path) {
  path = castPath$5(path, object);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[toKey$5(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

var _baseGet = baseGet$5;var baseGet$4 = _baseGet;

/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get$1(object, path, defaultValue) {
  var result = object == null ? undefined : baseGet$4(object, path);
  return result === undefined ? defaultValue : result;
}

var get_1 = get$1;/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */

function baseHasIn$1(object, key) {
  return object != null && key in Object(object);
}

var _baseHasIn = baseHasIn$1;var castPath$4 = _castPath,
    isArguments$3 = isArguments_1,
    isArray$f = isArray_1,
    isIndex$3 = _isIndex,
    isLength = isLength_1,
    toKey$4 = _toKey;

/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */
function hasPath$1(object, path, hasFunc) {
  path = castPath$4(path, object);

  var index = -1,
      length = path.length,
      result = false;

  while (++index < length) {
    var key = toKey$4(path[index]);
    if (!(result = object != null && hasFunc(object, key))) {
      break;
    }
    object = object[key];
  }
  if (result || ++index != length) {
    return result;
  }
  length = object == null ? 0 : object.length;
  return !!length && isLength(length) && isIndex$3(key, length) &&
    (isArray$f(object) || isArguments$3(object));
}

var _hasPath = hasPath$1;var baseHasIn = _baseHasIn,
    hasPath = _hasPath;

/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */
function hasIn$2(object, path) {
  return object != null && hasPath(object, path, baseHasIn);
}

var hasIn_1 = hasIn$2;var baseIsEqual$1 = _baseIsEqual,
    get = get_1,
    hasIn$1 = hasIn_1,
    isKey$1 = _isKey,
    isStrictComparable = _isStrictComparable,
    matchesStrictComparable = _matchesStrictComparable,
    toKey$3 = _toKey;

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatchesProperty$1(path, srcValue) {
  if (isKey$1(path) && isStrictComparable(srcValue)) {
    return matchesStrictComparable(toKey$3(path), srcValue);
  }
  return function(object) {
    var objValue = get(object, path);
    return (objValue === undefined && objValue === srcValue)
      ? hasIn$1(object, path)
      : baseIsEqual$1(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
  };
}

var _baseMatchesProperty = baseMatchesProperty$1;/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */

function identity$5(value) {
  return value;
}

var identity_1 = identity$5;/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */

function baseProperty$1(key) {
  return function(object) {
    return object == null ? undefined : object[key];
  };
}

var _baseProperty = baseProperty$1;var baseGet$3 = _baseGet;

/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyDeep$1(path) {
  return function(object) {
    return baseGet$3(object, path);
  };
}

var _basePropertyDeep = basePropertyDeep$1;var baseProperty = _baseProperty,
    basePropertyDeep = _basePropertyDeep,
    isKey = _isKey,
    toKey$2 = _toKey;

/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */
function property$1(path) {
  return isKey(path) ? baseProperty(toKey$2(path)) : basePropertyDeep(path);
}

var property_1 = property$1;var baseMatches = _baseMatches,
    baseMatchesProperty = _baseMatchesProperty,
    identity$4 = identity_1,
    isArray$e = isArray_1,
    property = property_1;

/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */
function baseIteratee$8(value) {
  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
  if (typeof value == 'function') {
    return value;
  }
  if (value == null) {
    return identity$4;
  }
  if (typeof value == 'object') {
    return isArray$e(value)
      ? baseMatchesProperty(value[0], value[1])
      : baseMatches(value);
  }
  return property(value);
}

var _baseIteratee = baseIteratee$8;var baseAssignValue$3 = _baseAssignValue,
    baseForOwn$2 = _baseForOwn,
    baseIteratee$7 = _baseIteratee;

/**
 * Creates an object with the same keys as `object` and values generated
 * by running each own enumerable string keyed property of `object` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, key, object).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns the new mapped object.
 * @see _.mapKeys
 * @example
 *
 * var users = {
 *   'fred':    { 'user': 'fred',    'age': 40 },
 *   'pebbles': { 'user': 'pebbles', 'age': 1 }
 * };
 *
 * _.mapValues(users, function(o) { return o.age; });
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 *
 * // The `_.property` iteratee shorthand.
 * _.mapValues(users, 'age');
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 */
function mapValues(object, iteratee) {
  var result = {};
  iteratee = baseIteratee$7(iteratee);

  baseForOwn$2(object, function(value, key, object) {
    baseAssignValue$3(result, key, iteratee(value, key, object));
  });
  return result;
}

var mapValues_1 = mapValues;var baseAssignValue$2 = _baseAssignValue,
    eq$2 = eq_1;

/** Used for built-in method references. */
var objectProto$4 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$3 = objectProto$4.hasOwnProperty;

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue$3(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty$3.call(object, key) && eq$2(objValue, value)) ||
      (value === undefined && !(key in object))) {
    baseAssignValue$2(object, key, value);
  }
}

var _assignValue = assignValue$3;var assignValue$2 = _assignValue,
    castPath$3 = _castPath,
    isIndex$2 = _isIndex,
    isObject$b = isObject_1,
    toKey$1 = _toKey;

/**
 * The base implementation of `_.set`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @param {Function} [customizer] The function to customize path creation.
 * @returns {Object} Returns `object`.
 */
function baseSet$2(object, path, value, customizer) {
  if (!isObject$b(object)) {
    return object;
  }
  path = castPath$3(path, object);

  var index = -1,
      length = path.length,
      lastIndex = length - 1,
      nested = object;

  while (nested != null && ++index < length) {
    var key = toKey$1(path[index]),
        newValue = value;

    if (key === '__proto__' || key === 'constructor' || key === 'prototype') {
      return object;
    }

    if (index != lastIndex) {
      var objValue = nested[key];
      newValue = customizer ? customizer(objValue, key, nested) : undefined;
      if (newValue === undefined) {
        newValue = isObject$b(objValue)
          ? objValue
          : (isIndex$2(path[index + 1]) ? [] : {});
      }
    }
    assignValue$2(nested, key, newValue);
    nested = nested[key];
  }
  return object;
}

var _baseSet = baseSet$2;var baseGet$2 = _baseGet,
    baseSet$1 = _baseSet,
    castPath$2 = _castPath;

/**
 * The base implementation of  `_.pickBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} paths The property paths to pick.
 * @param {Function} predicate The function invoked per property.
 * @returns {Object} Returns the new object.
 */
function basePickBy$2(object, paths, predicate) {
  var index = -1,
      length = paths.length,
      result = {};

  while (++index < length) {
    var path = paths[index],
        value = baseGet$2(object, path);

    if (predicate(value, path)) {
      baseSet$1(result, castPath$2(path, object), value);
    }
  }
  return result;
}

var _basePickBy = basePickBy$2;var basePickBy$1 = _basePickBy,
    hasIn = hasIn_1;

/**
 * The base implementation of `_.pick` without support for individual
 * property identifiers.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} paths The property paths to pick.
 * @returns {Object} Returns the new object.
 */
function basePick$1(object, paths) {
  return basePickBy$1(object, paths, function(value, path) {
    return hasIn(object, path);
  });
}

var _basePick = basePick$1;var Symbol$2 = _Symbol,
    isArguments$2 = isArguments_1,
    isArray$d = isArray_1;

/** Built-in value references. */
var spreadableSymbol = Symbol$2 ? Symbol$2.isConcatSpreadable : undefined;

/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */
function isFlattenable$1(value) {
  return isArray$d(value) || isArguments$2(value) ||
    !!(spreadableSymbol && value && value[spreadableSymbol]);
}

var _isFlattenable = isFlattenable$1;var arrayPush$1 = _arrayPush,
    isFlattenable = _isFlattenable;

/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */
function baseFlatten$4(array, depth, predicate, isStrict, result) {
  var index = -1,
      length = array.length;

  predicate || (predicate = isFlattenable);
  result || (result = []);

  while (++index < length) {
    var value = array[index];
    if (depth > 0 && predicate(value)) {
      if (depth > 1) {
        // Recursively flatten arrays (susceptible to call stack limits).
        baseFlatten$4(value, depth - 1, predicate, isStrict, result);
      } else {
        arrayPush$1(result, value);
      }
    } else if (!isStrict) {
      result[result.length] = value;
    }
  }
  return result;
}

var _baseFlatten = baseFlatten$4;var baseFlatten$3 = _baseFlatten;

/**
 * Flattens `array` a single level deep.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to flatten.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * _.flatten([1, [2, [3, [4]], 5]]);
 * // => [1, 2, [3, [4]], 5]
 */
function flatten$1(array) {
  var length = array == null ? 0 : array.length;
  return length ? baseFlatten$3(array, 1) : [];
}

var flatten_1 = flatten$1;/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */

function apply$1(func, thisArg, args) {
  switch (args.length) {
    case 0: return func.call(thisArg);
    case 1: return func.call(thisArg, args[0]);
    case 2: return func.call(thisArg, args[0], args[1]);
    case 3: return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

var _apply = apply$1;var apply = _apply;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax$4 = Math.max;

/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */
function overRest$2(func, start, transform) {
  start = nativeMax$4(start === undefined ? (func.length - 1) : start, 0);
  return function() {
    var args = arguments,
        index = -1,
        length = nativeMax$4(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = transform(array);
    return apply(func, this, otherArgs);
  };
}

var _overRest = overRest$2;/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */

function constant$1(value) {
  return function() {
    return value;
  };
}

var constant_1 = constant$1;var constant = constant_1,
    defineProperty$3 = _defineProperty$6,
    identity$3 = identity_1;

/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var baseSetToString$1 = !defineProperty$3 ? identity$3 : function(func, string) {
  return defineProperty$3(func, 'toString', {
    'configurable': true,
    'enumerable': false,
    'value': constant(string),
    'writable': true
  });
};

var _baseSetToString = baseSetToString$1;/** Used to detect hot functions by number of calls within a span of milliseconds. */

var HOT_COUNT = 800,
    HOT_SPAN = 16;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeNow = Date.now;

/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */
function shortOut$1(func) {
  var count = 0,
      lastCalled = 0;

  return function() {
    var stamp = nativeNow(),
        remaining = HOT_SPAN - (stamp - lastCalled);

    lastCalled = stamp;
    if (remaining > 0) {
      if (++count >= HOT_COUNT) {
        return arguments[0];
      }
    } else {
      count = 0;
    }
    return func.apply(undefined, arguments);
  };
}

var _shortOut = shortOut$1;var baseSetToString = _baseSetToString,
    shortOut = _shortOut;

/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var setToString$2 = shortOut(baseSetToString);

var _setToString = setToString$2;var flatten = flatten_1,
    overRest$1 = _overRest,
    setToString$1 = _setToString;

/**
 * A specialized version of `baseRest` which flattens the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @returns {Function} Returns the new function.
 */
function flatRest$2(func) {
  return setToString$1(overRest$1(func, undefined, flatten), func + '');
}

var _flatRest = flatRest$2;var basePick = _basePick,
    flatRest$1 = _flatRest;

/**
 * Creates an object composed of the picked `object` properties.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [paths] The property paths to pick.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.pick(object, ['a', 'c']);
 * // => { 'a': 1, 'c': 3 }
 */
var pick = flatRest$1(function(object, paths) {
  return object == null ? {} : basePick(object, paths);
});

var pick_1 = pick;// a string of all valid unicode whitespaces
var whitespaces$2 = '\u0009\u000A\u000B\u000C\u000D\u0020\u00A0\u1680\u2000\u2001\u2002' +
  '\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';var requireObjectCoercible$2 = requireObjectCoercible$a;
var whitespaces$1 = whitespaces$2;

var whitespace = '[' + whitespaces$1 + ']';
var ltrim = RegExp('^' + whitespace + whitespace + '*');
var rtrim = RegExp(whitespace + whitespace + '*$');

// `String.prototype.{ trim, trimStart, trimEnd, trimLeft, trimRight }` methods implementation
var createMethod = function (TYPE) {
  return function ($this) {
    var string = String(requireObjectCoercible$2($this));
    if (TYPE & 1) string = string.replace(ltrim, '');
    if (TYPE & 2) string = string.replace(rtrim, '');
    return string;
  };
};

var stringTrim = {
  // `String.prototype.{ trimLeft, trimStart }` methods
  // https://tc39.es/ecma262/#sec-string.prototype.trimstart
  start: createMethod(1),
  // `String.prototype.{ trimRight, trimEnd }` methods
  // https://tc39.es/ecma262/#sec-string.prototype.trimend
  end: createMethod(2),
  // `String.prototype.trim` method
  // https://tc39.es/ecma262/#sec-string.prototype.trim
  trim: createMethod(3)
};var DESCRIPTORS = descriptors;
var global$2 = global$r;
var isForced = isForced_1;
var redefine = redefine$a.exports;
var has$4 = has$i;
var classof = classofRaw$1;
var inheritIfRequired = inheritIfRequired$2;
var toPrimitive = toPrimitive$5;
var fails$1 = fails$r;
var create$1 = objectCreate$1;
var getOwnPropertyNames$1 = objectGetOwnPropertyNames.f;
var getOwnPropertyDescriptor$1 = objectGetOwnPropertyDescriptor.f;
var defineProperty$2 = objectDefineProperty.f;
var trim$1 = stringTrim.trim;

var NUMBER = 'Number';
var NativeNumber = global$2[NUMBER];
var NumberPrototype = NativeNumber.prototype;

// Opera ~12 has broken Object#toString
var BROKEN_CLASSOF = classof(create$1(NumberPrototype)) == NUMBER;

// `ToNumber` abstract operation
// https://tc39.es/ecma262/#sec-tonumber
var toNumber$4 = function (argument) {
  var it = toPrimitive(argument, false);
  var first, third, radix, maxCode, digits, length, index, code;
  if (typeof it == 'string' && it.length > 2) {
    it = trim$1(it);
    first = it.charCodeAt(0);
    if (first === 43 || first === 45) {
      third = it.charCodeAt(2);
      if (third === 88 || third === 120) return NaN; // Number('+0x1') should be NaN, old V8 fix
    } else if (first === 48) {
      switch (it.charCodeAt(1)) {
        case 66: case 98: radix = 2; maxCode = 49; break; // fast equal of /^0b[01]+$/i
        case 79: case 111: radix = 8; maxCode = 55; break; // fast equal of /^0o[0-7]+$/i
        default: return +it;
      }
      digits = it.slice(2);
      length = digits.length;
      for (index = 0; index < length; index++) {
        code = digits.charCodeAt(index);
        // parseInt parses a string to a first unavailable symbol
        // but ToNumber should return NaN if a string contains unavailable symbols
        if (code < 48 || code > maxCode) return NaN;
      } return parseInt(digits, radix);
    }
  } return +it;
};

// `Number` constructor
// https://tc39.es/ecma262/#sec-number-constructor
if (isForced(NUMBER, !NativeNumber(' 0o1') || !NativeNumber('0b1') || NativeNumber('+0x1'))) {
  var NumberWrapper = function Number(value) {
    var it = arguments.length < 1 ? 0 : value;
    var dummy = this;
    return dummy instanceof NumberWrapper
      // check on 1..constructor(foo) case
      && (BROKEN_CLASSOF ? fails$1(function () { NumberPrototype.valueOf.call(dummy); }) : classof(dummy) != NUMBER)
        ? inheritIfRequired(new NativeNumber(toNumber$4(it)), dummy, NumberWrapper) : toNumber$4(it);
  };
  for (var keys$5 = DESCRIPTORS ? getOwnPropertyNames$1(NativeNumber) : (
    // ES3:
    'MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,' +
    // ES2015 (in case, if modules with ES2015 Number statics required before):
    'EPSILON,isFinite,isInteger,isNaN,isSafeInteger,MAX_SAFE_INTEGER,' +
    'MIN_SAFE_INTEGER,parseFloat,parseInt,isInteger,' +
    // ESNext
    'fromString,range'
  ).split(','), j = 0, key$2; keys$5.length > j; j++) {
    if (has$4(NativeNumber, key$2 = keys$5[j]) && !has$4(NumberWrapper, key$2)) {
      defineProperty$2(NumberWrapper, key$2, getOwnPropertyDescriptor$1(NativeNumber, key$2));
    }
  }
  NumberWrapper.prototype = NumberPrototype;
  NumberPrototype.constructor = NumberWrapper;
  redefine(global$2, NUMBER, NumberWrapper);
}var $$2 = _export;
var $findIndex = arrayIteration.findIndex;
var addToUnscopables = addToUnscopables$4;

var FIND_INDEX = 'findIndex';
var SKIPS_HOLES = true;

// Shouldn't skip holes
if (FIND_INDEX in []) Array(1)[FIND_INDEX](function () { SKIPS_HOLES = false; });

// `Array.prototype.findIndex` method
// https://tc39.es/ecma262/#sec-array.prototype.findindex
$$2({ target: 'Array', proto: true, forced: SKIPS_HOLES }, {
  findIndex: function findIndex(callbackfn /* , that = undefined */) {
    return $findIndex(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});

// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables(FIND_INDEX);var $$1 = _export;
var IndexedObject = indexedObject;
var toIndexedObject = toIndexedObject$9;
var arrayMethodIsStrict = arrayMethodIsStrict$3;

var nativeJoin = [].join;

var ES3_STRINGS = IndexedObject != Object;
var STRICT_METHOD = arrayMethodIsStrict('join', ',');

// `Array.prototype.join` method
// https://tc39.es/ecma262/#sec-array.prototype.join
$$1({ target: 'Array', proto: true, forced: ES3_STRINGS || !STRICT_METHOD }, {
  join: function join(separator) {
    return nativeJoin.call(toIndexedObject(this), separator === undefined ? ',' : separator);
  }
});var _templateObject$V, _templateObject2$N;

function _taggedTemplateLiteral$2(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

function _toConsumableArray$2(arr) { return _arrayWithoutHoles$2(arr) || _iterableToArray$2(arr) || _unsupportedIterableToArray$2(arr) || _nonIterableSpread$2(); }

function _nonIterableSpread$2() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray$2(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles$2(arr) { if (Array.isArray(arr)) return _arrayLikeToArray$2(arr); }

function _defineProperty$5(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray$2(arr, i) { return _arrayWithHoles$2(arr) || _iterableToArrayLimit$2(arr, i) || _unsupportedIterableToArray$2(arr, i) || _nonIterableRest$2(); }

function _nonIterableRest$2() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray$2(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$2(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$2(o, minLen); }

function _arrayLikeToArray$2(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit$2(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles$2(arr) { if (Array.isArray(arr)) return arr; }

function _typeof$4(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof$4 = function _typeof(obj) { return typeof obj; }; } else { _typeof$4 = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof$4(obj); }
var INCOMPATIBLE = Symbol('incompatible');

var map$1 = function map(arg, type) {
  if (arg === undefined || arg === null || !type) return arg;

  switch (type.name) {
    case 'string':
      return String(arg);

    case 'enum':
      return arg;

    case 'number':
      return Number(arg);

    case 'boolean':
      return arg === 'true';

    case 'array':
      if (!type.value || !Array.isArray(arg)) return INCOMPATIBLE;
      return arg.reduce(function (acc, item, index) {
        var mapped = map(item, type.value);
        if (mapped !== INCOMPATIBLE) acc[index] = mapped;
        return acc;
      }, new Array(arg.length));

    case 'object':
      if (typeof arg === 'string' || typeof arg === 'number') return arg;
      if (!type.value || _typeof$4(arg) !== 'object') return INCOMPATIBLE;
      return Object.entries(arg).reduce(function (acc, _ref) {
        var _ref2 = _slicedToArray$2(_ref, 2),
            key = _ref2[0],
            val = _ref2[1];

        var mapped = map(val, type.value[key]);
        return mapped === INCOMPATIBLE ? acc : Object.assign(acc, _defineProperty$5({}, key, mapped));
      }, {});

    default:
      return INCOMPATIBLE;
  }
};

var mapArgsToTypes = function mapArgsToTypes(args, argTypes) {
  return Object.entries(args).reduce(function (acc, _ref3) {
    var _ref4 = _slicedToArray$2(_ref3, 2),
        key = _ref4[0],
        value = _ref4[1];

    if (!argTypes[key]) return acc;
    var mapped = map$1(value, argTypes[key].type);
    return mapped === INCOMPATIBLE ? acc : Object.assign(acc, _defineProperty$5({}, key, mapped));
  }, {});
};
var combineArgs = function combineArgs(value, update) {
  if (Array.isArray(value) && Array.isArray(update)) {
    return update.reduce(function (acc, upd, index) {
      acc[index] = combineArgs(value[index], update[index]);
      return acc;
    }, _toConsumableArray$2(value)).filter(function (v) {
      return v !== undefined;
    });
  }

  if (!isPlainObject_1(value) || !isPlainObject_1(update)) return update;
  return Object.keys(Object.assign({}, value, update)).reduce(function (acc, key) {
    if (key in update) {
      var combined = combineArgs(value[key], update[key]);
      if (combined !== undefined) acc[key] = combined;
    } else {
      acc[key] = value[key];
    }

    return acc;
  }, {});
};
var validateOptions = function validateOptions(args, argTypes) {
  return Object.entries(argTypes).reduce(function (acc, _ref5) {
    var _ref6 = _slicedToArray$2(_ref5, 2),
        key = _ref6[0],
        options = _ref6[1].options;

    if (!options) {
      if (key in args) {
        acc[key] = args[key];
      }

      return acc;
    }

    if (!Array.isArray(options)) {
      once.error(_default$4(_templateObject$V || (_templateObject$V = _taggedTemplateLiteral$2(["\n        Invalid argType: '", ".options' should be an array.\n\n        More info: https://storybook.js.org/docs/react/api/argtypes\n      "])), key));
      acc[key] = args[key];
      return acc;
    }

    if (options.some(function (opt) {
      return opt && ['object', 'function'].includes(_typeof$4(opt));
    })) {
      once.error(_default$4(_templateObject2$N || (_templateObject2$N = _taggedTemplateLiteral$2(["\n        Invalid argType: '", ".options' should only contain primitives. Use a 'mapping' for complex values.\n\n        More info: https://storybook.js.org/docs/react/writing-stories/args#mapping-to-complex-arg-values\n      "])), key));
      acc[key] = args[key];
      return acc;
    }

    var isArray = Array.isArray(args[key]);
    var invalidIndex = isArray && args[key].findIndex(function (val) {
      return !options.includes(val);
    });
    var isValidArray = isArray && invalidIndex === -1;

    if (args[key] === undefined || options.includes(args[key]) || isValidArray) {
      acc[key] = args[key];
      return acc;
    }

    var field = isArray ? "".concat(key, "[").concat(invalidIndex, "]") : key;
    var supportedOptions = options.map(function (opt) {
      return typeof opt === 'string' ? "'".concat(opt, "'") : String(opt);
    }).join(', ');
    once.warn("Received illegal value for '".concat(field, "'. Supported options: ").concat(supportedOptions));
    return acc;
  }, {});
};var fails = fails$r;
var whitespaces = whitespaces$2;

var non = '\u200B\u0085\u180E';

// check that a method works with the correct list
// of whitespaces and has a correct name
var stringTrimForced = function (METHOD_NAME) {
  return fails(function () {
    return !!whitespaces[METHOD_NAME]() || non[METHOD_NAME]() != non || whitespaces[METHOD_NAME].name !== METHOD_NAME;
  });
};var $ = _export;
var $trim = stringTrim.trim;
var forcedStringTrimMethod = stringTrimForced;

// `String.prototype.trim` method
// https://tc39.es/ecma262/#sec-string.prototype.trim
$({ target: 'String', proto: true, forced: forcedStringTrimMethod('trim') }, {
  trim: function trim() {
    return $trim(this);
  }
});var STORY_KIND_PATH_SEPARATOR = /\s*\/\s*/;
var storySort = function storySort() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return function (a, b) {
    // If the two stories have the same story kind, then use the default
    // ordering, which is the order they are defined in the story file.
    // only when includeNames is falsy
    if (a[1].kind === b[1].kind && !options.includeNames) {
      return 0;
    } // Get the StorySortParameter options.


    var method = options.method || 'configure';
    var order = options.order || []; // Examine each part of the story kind in turn.

    var storyKindA = a[1].kind.trim().split(STORY_KIND_PATH_SEPARATOR);
    var storyKindB = b[1].kind.trim().split(STORY_KIND_PATH_SEPARATOR);

    if (options.includeNames) {
      storyKindA.push(a[1].name);
      storyKindB.push(b[1].name);
    }

    var depth = 0;

    while (storyKindA[depth] || storyKindB[depth]) {
      // Stories with a shorter depth should go first.
      if (!storyKindA[depth]) {
        return -1;
      }

      if (!storyKindB[depth]) {
        return 1;
      } // Compare the next part of the story kind.


      var nameA = storyKindA[depth];
      var nameB = storyKindB[depth];

      if (nameA !== nameB) {
        // Look for the names in the given `order` array.
        var indexA = order.indexOf(nameA);
        var indexB = order.indexOf(nameB);
        var indexWildcard = order.indexOf('*'); // If at least one of the names is found, sort by the `order` array.

        if (indexA !== -1 || indexB !== -1) {
          // If one of the names is not found and there is a wildcard, insert it at the wildcard position.
          // Otherwise, list it last.
          if (indexA === -1) {
            if (indexWildcard !== -1) {
              indexA = indexWildcard;
            } else {
              indexA = order.length;
            }
          }

          if (indexB === -1) {
            if (indexWildcard !== -1) {
              indexB = indexWildcard;
            } else {
              indexB = order.length;
            }
          }

          return indexA - indexB;
        } // Use the default configure() order.


        if (method === 'configure') {
          return 0;
        } // Otherwise, use alphabetical order.


        return nameA.localeCompare(nameB, options.locales ? options.locales : undefined, {
          numeric: true,
          sensitivity: 'accent'
        });
      } // If a nested array is provided for a name, use it for ordering.


      var index = order.indexOf(nameA);
      order = index !== -1 && Array.isArray(order[index + 1]) ? order[index + 1] : []; // We'll need to look at the next part of the name.

      depth += 1;
    } // Identical story kinds. The shortcut at the start of this function prevents
    // this from ever being used.

    /* istanbul ignore next */


    return 0;
  };
};var ensureArgTypes = function ensureArgTypes(context) {
  var _context$parameters = context.parameters,
      _context$parameters$a = _context$parameters.argTypes,
      userArgTypes = _context$parameters$a === void 0 ? {} : _context$parameters$a,
      _context$parameters$a2 = _context$parameters.args,
      args = _context$parameters$a2 === void 0 ? {} : _context$parameters$a2;
  if (!args) return userArgTypes;
  var argTypes = mapValues_1(args, function (_arg, name) {
    return {
      name: name
    };
  });
  return combineParameters(argTypes, userArgTypes);
};var _templateObject$U;

function _taggedTemplateLiteral$1(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

function _typeof$3(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof$3 = function _typeof(obj) { return typeof obj; }; } else { _typeof$3 = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof$3(obj); }

var inferType = function inferType(value, name, visited) {
  var type = _typeof$3(value);

  switch (type) {
    case 'boolean':
    case 'string':
    case 'number':
    case 'function':
      return {
        name: type
      };

    case 'symbol':
      return {
        name: 'other',
        value: 'symbol'
      };
  }

  if (value) {
    if (visited.has(value)) {
      logger.warn(_default$4(_templateObject$U || (_templateObject$U = _taggedTemplateLiteral$1(["\n        We've detected a cycle in arg '", "'. Args should be JSON-serializable.\n\n        More info: https://storybook.js.org/docs/react/essentials/controls#fully-custom-args\n      "])), name));
      return {
        name: 'other',
        value: 'cyclic object'
      };
    }

    visited.add(value);

    if (Array.isArray(value)) {
      var childType = value.length > 0 ? inferType(value[0], name, new Set(visited)) : {
        name: 'other',
        value: 'unknown'
      };
      return {
        name: 'array',
        value: childType
      };
    }

    var fieldTypes = mapValues_1(value, function (field) {
      return inferType(field, name, new Set(visited));
    });
    return {
      name: 'object',
      value: fieldTypes
    };
  }

  return {
    name: 'object',
    value: {}
  };
};

var inferArgTypes = function inferArgTypes(context) {
  var id = context.id,
      parameters = context.parameters;
  var _parameters$argTypes = parameters.argTypes,
      userArgTypes = _parameters$argTypes === void 0 ? {} : _parameters$argTypes,
      _parameters$args = parameters.args,
      args = _parameters$args === void 0 ? {} : _parameters$args;
  if (!args) return userArgTypes;
  var argTypes = mapValues_1(args, function (arg, key) {
    return {
      type: inferType(arg, "".concat(id, ".").concat(key), new Set())
    };
  });
  return combineParameters(argTypes, userArgTypes);
};var fixRegExpWellKnownSymbolLogic$1 = fixRegexpWellKnownSymbolLogic;
var anObject$1 = anObject$i;
var toLength = toLength$b;
var requireObjectCoercible$1 = requireObjectCoercible$a;
var advanceStringIndex = advanceStringIndex$3;
var regExpExec$1 = regexpExecAbstract;

// @@match logic
fixRegExpWellKnownSymbolLogic$1('match', function (MATCH, nativeMatch, maybeCallNative) {
  return [
    // `String.prototype.match` method
    // https://tc39.es/ecma262/#sec-string.prototype.match
    function match(regexp) {
      var O = requireObjectCoercible$1(this);
      var matcher = regexp == undefined ? undefined : regexp[MATCH];
      return matcher !== undefined ? matcher.call(regexp, O) : new RegExp(regexp)[MATCH](String(O));
    },
    // `RegExp.prototype[@@match]` method
    // https://tc39.es/ecma262/#sec-regexp.prototype-@@match
    function (string) {
      var res = maybeCallNative(nativeMatch, this, string);
      if (res.done) return res.value;

      var rx = anObject$1(this);
      var S = String(string);

      if (!rx.global) return regExpExec$1(rx, S);

      var fullUnicode = rx.unicode;
      rx.lastIndex = 0;
      var A = [];
      var n = 0;
      var result;
      while ((result = regExpExec$1(rx, S)) !== null) {
        var matchStr = String(result[0]);
        A[n] = matchStr;
        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
        n++;
      }
      return n === 0 ? null : A;
    }
  ];
});var arrayPush = _arrayPush,
    getPrototype$1 = _getPrototype,
    getSymbols$1 = _getSymbols,
    stubArray = stubArray_1;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own and inherited enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbolsIn$2 = !nativeGetSymbols ? stubArray : function(object) {
  var result = [];
  while (object) {
    arrayPush(result, getSymbols$1(object));
    object = getPrototype$1(object);
  }
  return result;
};

var _getSymbolsIn = getSymbolsIn$2;/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */

function nativeKeysIn$1(object) {
  var result = [];
  if (object != null) {
    for (var key in Object(object)) {
      result.push(key);
    }
  }
  return result;
}

var _nativeKeysIn = nativeKeysIn$1;var isObject$a = isObject_1,
    isPrototype$2 = _isPrototype,
    nativeKeysIn = _nativeKeysIn;

/** Used for built-in method references. */
var objectProto$3 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$2 = objectProto$3.hasOwnProperty;

/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeysIn$1(object) {
  if (!isObject$a(object)) {
    return nativeKeysIn(object);
  }
  var isProto = isPrototype$2(object),
      result = [];

  for (var key in object) {
    if (!(key == 'constructor' && (isProto || !hasOwnProperty$2.call(object, key)))) {
      result.push(key);
    }
  }
  return result;
}

var _baseKeysIn = baseKeysIn$1;var arrayLikeKeys = _arrayLikeKeys,
    baseKeysIn = _baseKeysIn,
    isArrayLike$7 = isArrayLike_1;

/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */
function keysIn$5(object) {
  return isArrayLike$7(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
}

var keysIn_1 = keysIn$5;var baseGetAllKeys = _baseGetAllKeys,
    getSymbolsIn$1 = _getSymbolsIn,
    keysIn$4 = keysIn_1;

/**
 * Creates an array of own and inherited enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeysIn$3(object) {
  return baseGetAllKeys(object, keysIn$4, getSymbolsIn$1);
}

var _getAllKeysIn = getAllKeysIn$3;var arrayMap$7 = _arrayMap,
    baseIteratee$6 = _baseIteratee,
    basePickBy = _basePickBy,
    getAllKeysIn$2 = _getAllKeysIn;

/**
 * Creates an object composed of the `object` properties `predicate` returns
 * truthy for. The predicate is invoked with two arguments: (value, key).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The source object.
 * @param {Function} [predicate=_.identity] The function invoked per property.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.pickBy(object, _.isNumber);
 * // => { 'a': 1, 'c': 3 }
 */
function pickBy(object, predicate) {
  if (object == null) {
    return {};
  }
  var props = arrayMap$7(getAllKeysIn$2(object), function(prop) {
    return [prop];
  });
  predicate = baseIteratee$6(predicate);
  return basePickBy(object, props, function(value, path) {
    return predicate(value, path[0]);
  });
}

var pickBy_1 = pickBy;

var pickBy$1 = pickBy_1;var matches$1 = function matches(name, descriptor) {
  return Array.isArray(descriptor) ? descriptor.includes(name) : name.match(descriptor);
};

var filterArgTypes = function filterArgTypes(argTypes, include, exclude) {
  if (!include && !exclude) {
    return argTypes;
  }

  return argTypes && pickBy$1(argTypes, function (argType, key) {
    var name = argType.name || key;
    return (!include || matches$1(name, include)) && (!exclude || !matches$1(name, exclude));
  });
};var inferControl = function inferControl(argType, name, matchers) {
  var type = argType.type,
      options = argType.options;

  if (!type && !options) {
    return undefined;
  } // args that end with background or color e.g. iconColor


  if (matchers.color && matchers.color.test(name)) {
    var controlType = argType.type.name;

    if (controlType === 'string') {
      return {
        control: {
          type: 'color'
        }
      };
    }

    logger.warn("Addon controls: Control of type color only supports string, received \"".concat(controlType, "\" instead"));
  } // args that end with date e.g. purchaseDate


  if (matchers.date && matchers.date.test(name)) {
    return {
      control: {
        type: 'date'
      }
    };
  }

  switch (type.name) {
    case 'array':
      return {
        control: {
          type: 'object'
        }
      };

    case 'boolean':
      return {
        control: {
          type: 'boolean'
        }
      };

    case 'string':
      return {
        control: {
          type: 'text'
        }
      };

    case 'number':
      return {
        control: {
          type: 'number'
        }
      };

    case 'enum':
      {
        var _ref = type,
            value = _ref.value;
        return {
          control: {
            type: (value === null || value === void 0 ? void 0 : value.length) <= 5 ? 'radio' : 'select'
          },
          options: value
        };
      }

    case 'function':
    case 'symbol':
    case 'void':
      return null;

    default:
      return {
        control: {
          type: options ? 'select' : 'object'
        }
      };
  }
};

var inferControls = function inferControls(context) {
  var _context$parameters = context.parameters,
      __isArgsStory = _context$parameters.__isArgsStory,
      argTypes = _context$parameters.argTypes,
      _context$parameters$c = _context$parameters.controls;
  _context$parameters$c = _context$parameters$c === void 0 ? {} : _context$parameters$c;
  var _context$parameters$c2 = _context$parameters$c.include,
      include = _context$parameters$c2 === void 0 ? null : _context$parameters$c2,
      _context$parameters$c3 = _context$parameters$c.exclude,
      exclude = _context$parameters$c3 === void 0 ? null : _context$parameters$c3,
      _context$parameters$c4 = _context$parameters$c.matchers,
      matchers = _context$parameters$c4 === void 0 ? {} : _context$parameters$c4;
  if (!__isArgsStory) return argTypes;
  var filteredArgTypes = filterArgTypes(argTypes, include, exclude);
  var withControls = mapValues_1(filteredArgTypes, function (argType, name) {
    return (argType === null || argType === void 0 ? void 0 : argType.type) && inferControl(argType, name, matchers);
  });
  return combineParameters(withControls, filteredArgTypes);
};var _templateObject$T, _templateObject2$M, _templateObject3$D;

function asyncGeneratorStep$1(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator$1(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep$1(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep$1(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _toConsumableArray$1(arr) { return _arrayWithoutHoles$1(arr) || _iterableToArray$1(arr) || _unsupportedIterableToArray$1(arr) || _nonIterableSpread$1(); }

function _nonIterableSpread$1() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray$1(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles$1(arr) { if (Array.isArray(arr)) return _arrayLikeToArray$1(arr); }

function _classCallCheck$f(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties$1(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass$c(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties$1(Constructor.prototype, protoProps); if (staticProps) _defineProperties$1(Constructor, staticProps); return Constructor; }

function _defineProperty$4(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray$1(arr, i) { return _arrayWithHoles$1(arr) || _iterableToArrayLimit$1(arr, i) || _unsupportedIterableToArray$1(arr, i) || _nonIterableRest$1(); }

function _nonIterableRest$1() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray$1(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$1(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$1(o, minLen); }

function _arrayLikeToArray$1(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit$1(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles$1(arr) { if (Array.isArray(arr)) return arr; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

function extractSanitizedKindNameFromStorySpecifier(storySpecifier) {
  if (typeof storySpecifier === 'string') {
    return storySpecifier.split('--').shift();
  }

  return sanitize_1(storySpecifier.kind);
}

function extractIdFromStorySpecifier(storySpecifier) {
  if (typeof storySpecifier === 'string') {
    return storySpecifier;
  }

  return toId_1(storySpecifier.kind, storySpecifier.name);
}

var isStoryDocsOnly = function isStoryDocsOnly(parameters) {
  return parameters && parameters.docsOnly;
};

var includeStory = function includeStory(story) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
    includeDocsOnly: false
  };

  if (options.includeDocsOnly) {
    return true;
  }

  return !isStoryDocsOnly(story.parameters);
};

var checkGlobals = function checkGlobals(parameters) {
  var globals = parameters.globals,
      globalTypes = parameters.globalTypes;

  if (globals || globalTypes) {
    logger.error('Global args/argTypes can only be set globally', JSON.stringify({
      globals: globals,
      globalTypes: globalTypes
    }));
  }
};

var checkStorySort = function checkStorySort(parameters) {
  var options = parameters.options;
  if (options !== null && options !== void 0 && options.storySort) logger.error('The storySort option parameter can only be set globally');
};

var storyFnWarning = browser$1(function () {}, _default$4(_templateObject$T || (_templateObject$T = _taggedTemplateLiteral(["\n  `storyFn` is deprecated and will be removed in Storybook 7.0.\n\n  https://github.com/storybookjs/storybook/blob/next/MIGRATION.md#deprecated-storyfn"], ["\n  \\`storyFn\\` is deprecated and will be removed in Storybook 7.0.\n\n  https://github.com/storybookjs/storybook/blob/next/MIGRATION.md#deprecated-storyfn"]))));
var argTypeDefaultValueWarning = browser$1(function () {}, _default$4(_templateObject2$M || (_templateObject2$M = _taggedTemplateLiteral(["\n  `argType.defaultValue` is deprecated and will be removed in Storybook 7.0.\n\n  https://github.com/storybookjs/storybook/blob/next/MIGRATION.md#deprecated-argtype-defaultValue"], ["\n  \\`argType.defaultValue\\` is deprecated and will be removed in Storybook 7.0.\n\n  https://github.com/storybookjs/storybook/blob/next/MIGRATION.md#deprecated-argtype-defaultValue"]))));

var toExtracted = function toExtracted(obj) {
  return Object.entries(obj).reduce(function (acc, _ref) {
    var _ref2 = _slicedToArray$1(_ref, 2),
        key = _ref2[0],
        value = _ref2[1];

    if (typeof value === 'function') {
      return acc;
    } // NOTE: We're serializing argTypes twice, at the top-level and also in parameters.
    // We currently rely on useParameters in the manager, so strip out the top-level argTypes
    // instead for performance.


    if (['hooks', 'argTypes'].includes(key)) {
      return acc;
    }

    if (Array.isArray(value)) {
      return Object.assign(acc, _defineProperty$4({}, key, value.slice().sort()));
    }

    return Object.assign(acc, _defineProperty$4({}, key, value));
  }, {});
};

var StoryStore = /*#__PURE__*/function () {
  // Keyed on kind name
  // Keyed on storyId
  function StoryStore(params) {
    var _this = this;

    _classCallCheck$f(this, StoryStore);

    this._error = void 0;
    this._channel = void 0;
    this._configuring = void 0;
    this._globals = void 0;
    this._initialGlobals = void 0;
    this._defaultGlobals = void 0;
    this._globalMetadata = void 0;
    this._kinds = void 0;
    this._stories = void 0;
    this._argsEnhancers = void 0;
    this._argTypesEnhancers = void 0;
    this._selectionSpecifier = void 0;
    this._selection = void 0;

    this.remove = function (id) {
      var _ref3 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
          _ref3$allowUnsafe = _ref3.allowUnsafe,
          allowUnsafe = _ref3$allowUnsafe === void 0 ? false : _ref3$allowUnsafe;

      if (!_this._configuring && !allowUnsafe) throw new Error('Cannot remove a story when not configuring, see https://github.com/storybookjs/storybook/blob/next/MIGRATION.md#story-store-immutable-outside-of-configuration');
      var _stories = _this._stories;
      var story = _stories[id];
      delete _stories[id];
      if (story) story.hooks.clean();
    };

    this.fromId = function (id) {
      try {
        var data = _this._stories[id];

        if (!data || !data.getDecorated) {
          return null;
        }

        return _this.mergeAdditionalDataToStory(data);
      } catch (e) {
        logger.warn('failed to get story:', _this._stories);
        logger.error(e);
        return null;
      }
    };

    this.setError = function (err) {
      _this._error = err;
    };

    this.getError = function () {
      return _this._error;
    };

    this.getSelection = function () {
      return _this._selection;
    };

    this.getDataForManager = function () {
      return {
        v: 2,
        globalParameters: _this._globalMetadata.parameters,
        globals: _this._globals,
        error: _this.getError(),
        kindParameters: mapValues_1(_this._kinds, function (metadata) {
          return metadata.parameters;
        }),
        stories: _this.extract({
          includeDocsOnly: true,
          normalizeParameters: true
        })
      };
    };

    this.getStoriesJsonData = function () {
      var value = _this.getDataForManager();

      var allowed = ['fileName', 'docsOnly', 'framework', '__id', '__isArgsStory'];
      return {
        v: 2,
        globalParameters: pick_1(value.globalParameters, allowed),
        kindParameters: mapValues_1(value.kindParameters, function (v) {
          return pick_1(v, allowed);
        }),
        stories: mapValues_1(value.stories, function (v) {
          return Object.assign({}, pick_1(v, ['id', 'name', 'kind', 'story']), {
            parameters: pick_1(v.parameters, allowed)
          });
        })
      };
    };

    this.pushToManager = function () {
      if (_this._channel) {
        // send to the parent frame.
        _this._channel.emit(Events.SET_STORIES, _this.getDataForManager());
      }
    };

    this.getStoriesForKind = function (kind) {
      return _this.raw().filter(function (story) {
        return story.kind === kind;
      });
    };

    // Assume we are configuring until we hear otherwise
    this._configuring = true;
    this._globals = {};
    this._defaultGlobals = {};
    this._initialGlobals = {};
    this._globalMetadata = {
      parameters: {},
      decorators: [],
      loaders: []
    };
    this._kinds = {};
    this._stories = {};
    this._argsEnhancers = [];
    this._argTypesEnhancers = [ensureArgTypes];
    this._error = undefined;
    this._channel = params.channel;
    this.setupListeners();
  }

  _createClass$c(StoryStore, [{
    key: "setupListeners",
    value: function setupListeners() {
      var _this2 = this;

      // Channel can be null in StoryShots
      if (!this._channel) return;

      this._channel.on(Events.SET_CURRENT_STORY, function (_ref4) {
        var storyId = _ref4.storyId,
            viewMode = _ref4.viewMode;
        return _this2.setSelection({
          storyId: storyId,
          viewMode: viewMode
        });
      });

      this._channel.on(Events.UPDATE_STORY_ARGS, function (_ref5) {
        var storyId = _ref5.storyId,
            updatedArgs = _ref5.updatedArgs;
        return _this2.updateStoryArgs(storyId, updatedArgs);
      });

      this._channel.on(Events.RESET_STORY_ARGS, function (_ref6) {
        var storyId = _ref6.storyId,
            argNames = _ref6.argNames;
        return _this2.resetStoryArgs(storyId, argNames);
      });

      this._channel.on(Events.UPDATE_GLOBALS, function (_ref7) {
        var globals = _ref7.globals;
        return _this2.updateGlobals(globals);
      });
    }
  }, {
    key: "startConfiguring",
    value: function startConfiguring() {
      this._configuring = true;

      var safePush = function safePush(enhancer, enhancers) {
        if (!enhancers.includes(enhancer)) enhancers.push(enhancer);
      }; // run these at the end


      safePush(inferArgTypes, this._argTypesEnhancers);
      safePush(inferControls, this._argTypesEnhancers);
    }
  }, {
    key: "finishConfiguring",
    value: function finishConfiguring() {
      this._configuring = false;
      var _this$_globalMetadata = this._globalMetadata.parameters,
          _this$_globalMetadata2 = _this$_globalMetadata.globals,
          globals = _this$_globalMetadata2 === void 0 ? {} : _this$_globalMetadata2,
          _this$_globalMetadata3 = _this$_globalMetadata.globalTypes,
          globalTypes = _this$_globalMetadata3 === void 0 ? {} : _this$_globalMetadata3;
      var allowedGlobals = new Set([].concat(_toConsumableArray$1(Object.keys(globals)), _toConsumableArray$1(Object.keys(globalTypes))));
      var defaultGlobals = Object.entries(globalTypes).reduce(function (acc, _ref8) {
        var _ref9 = _slicedToArray$1(_ref8, 2),
            arg = _ref9[0],
            defaultValue = _ref9[1].defaultValue;

        if (defaultValue) acc[arg] = defaultValue;
        return acc;
      }, {});
      this._initialGlobals = Object.assign({}, defaultGlobals, globals); // To deal with HMR & persistence, we consider the previous value of global args, and:
      //   1. Remove any keys that are not in the new parameter
      //   2. Preference any keys that were already set
      //   3. Use any new keys from the new parameter

      this._globals = Object.entries(this._globals || {}).reduce(function (acc, _ref10) {
        var _ref11 = _slicedToArray$1(_ref10, 2),
            key = _ref11[0],
            previousValue = _ref11[1];

        if (allowedGlobals.has(key)) acc[key] = previousValue;
        return acc;
      }, Object.assign({}, this._initialGlobals)); // Set the current selection based on the current selection specifier, if selection is not yet set

      var stories = this.sortedStories();
      var foundStory;

      if (this._selectionSpecifier && !this._selection) {
        var _this$_selectionSpeci = this._selectionSpecifier,
            storySpecifier = _this$_selectionSpeci.storySpecifier,
            viewMode = _this$_selectionSpeci.viewMode,
            urlArgs = _this$_selectionSpeci.args,
            urlGlobals = _this$_selectionSpeci.globals;

        if (urlGlobals) {
          var allowedUrlGlobals = Object.entries(urlGlobals).reduce(function (acc, _ref12) {
            var _ref13 = _slicedToArray$1(_ref12, 2),
                key = _ref13[0],
                value = _ref13[1];

            if (allowedGlobals.has(key)) acc[key] = value;
            return acc;
          }, {});
          this._globals = combineParameters(this._globals, allowedUrlGlobals);
        }

        if (storySpecifier === '*') {
          // '*' means select the first story. If there is none, we have no selection.
          var _stories2 = _slicedToArray$1(stories, 1);

          foundStory = _stories2[0];
        } else if (typeof storySpecifier === 'string') {
          // Find the story with the exact id that matches the specifier (see #11571)
          foundStory = Object.values(stories).find(function (s) {
            return s.id === storySpecifier;
          });

          if (!foundStory) {
            // Fallback to the first story that starts with the specifier
            foundStory = Object.values(stories).find(function (s) {
              return s.id.startsWith(storySpecifier);
            });
          }
        } else {
          // Try and find a story matching the name/kind, setting no selection if they don't exist.
          var name = storySpecifier.name,
              kind = storySpecifier.kind;
          foundStory = this.getRawStory(kind, name);
        }

        if (foundStory) {
          if (urlArgs) {
            var mappedUrlArgs = mapArgsToTypes(urlArgs, foundStory.argTypes);
            foundStory.args = combineArgs(foundStory.args, mappedUrlArgs);
          }

          foundStory.args = validateOptions(foundStory.args, foundStory.argTypes);
          this.setSelection({
            storyId: foundStory.id,
            viewMode: viewMode
          });

          this._channel.emit(Events.STORY_SPECIFIED, {
            storyId: foundStory.id,
            viewMode: viewMode
          });
        }
      } // If we didn't find a story matching the specifier, we always want to emit CURRENT_STORY_WAS_SET anyway
      // in order to tell the StoryRenderer to render something (a "missing story" view)


      if (!foundStory && this._channel) {
        this._channel.emit(Events.CURRENT_STORY_WAS_SET, this._selection);
      }

      this.pushToManager();
    }
  }, {
    key: "addGlobalMetadata",
    value: function addGlobalMetadata(_ref14) {
      var _ref14$parameters = _ref14.parameters,
          parameters = _ref14$parameters === void 0 ? {} : _ref14$parameters,
          _ref14$decorators = _ref14.decorators,
          decorators = _ref14$decorators === void 0 ? [] : _ref14$decorators,
          _ref14$loaders = _ref14.loaders,
          loaders = _ref14$loaders === void 0 ? [] : _ref14$loaders;

      if (parameters) {
        var args = parameters.args,
            argTypes = parameters.argTypes;
        if (args || argTypes) logger.warn('Found args/argTypes in global parameters.', JSON.stringify({
          args: args,
          argTypes: argTypes
        }));
      }

      var globalParameters = this._globalMetadata.parameters;
      this._globalMetadata.parameters = combineParameters(globalParameters, parameters);

      function _safeAdd(items, collection, caption) {
        items.forEach(function (item) {
          if (collection.includes(item)) {
            logger.warn("You tried to add a duplicate ".concat(caption, ", this is not expected"), item);
          } else {
            collection.push(item);
          }
        });
      }

      _safeAdd(decorators, this._globalMetadata.decorators, 'decorator');

      _safeAdd(loaders, this._globalMetadata.loaders, 'loader');
    }
  }, {
    key: "clearGlobalDecorators",
    value: function clearGlobalDecorators() {
      this._globalMetadata.decorators = [];
    }
  }, {
    key: "ensureKind",
    value: function ensureKind(kind) {
      if (!this._kinds[kind]) {
        this._kinds[kind] = {
          order: Object.keys(this._kinds).length,
          parameters: {},
          decorators: [],
          loaders: []
        };
      }
    }
  }, {
    key: "addKindMetadata",
    value: function addKindMetadata(kind, _ref15) {
      var _this$_kinds$kind$dec, _this$_kinds$kind$loa;

      var _ref15$parameters = _ref15.parameters,
          parameters = _ref15$parameters === void 0 ? {} : _ref15$parameters,
          _ref15$decorators = _ref15.decorators,
          decorators = _ref15$decorators === void 0 ? [] : _ref15$decorators,
          _ref15$loaders = _ref15.loaders,
          loaders = _ref15$loaders === void 0 ? [] : _ref15$loaders;

      if (this.shouldBlockAddingKindMetadata(kind)) {
        return;
      }

      this.ensureKind(kind);

      if (parameters) {
        checkGlobals(parameters);
        checkStorySort(parameters);
      }

      this._kinds[kind].parameters = combineParameters(this._kinds[kind].parameters, parameters);

      (_this$_kinds$kind$dec = this._kinds[kind].decorators).push.apply(_this$_kinds$kind$dec, _toConsumableArray$1(decorators));

      (_this$_kinds$kind$loa = this._kinds[kind].loaders).push.apply(_this$_kinds$kind$loa, _toConsumableArray$1(loaders));
    }
  }, {
    key: "addArgsEnhancer",
    value: function addArgsEnhancer(argsEnhancer) {
      if (Object.keys(this._stories).length > 0) throw new Error('Cannot add an args enhancer to the store after a story has been added.');

      this._argsEnhancers.push(argsEnhancer);
    }
  }, {
    key: "addArgTypesEnhancer",
    value: function addArgTypesEnhancer(argTypesEnhancer) {
      if (Object.keys(this._stories).length > 0) throw new Error('Cannot add an argTypes enhancer to the store after a story has been added.');

      this._argTypesEnhancers.push(argTypesEnhancer);
    } // Combine the global, kind & story parameters of a story

  }, {
    key: "combineStoryParameters",
    value: function combineStoryParameters(parameters, kind) {
      return combineParameters(this._globalMetadata.parameters, this._kinds[kind].parameters, parameters);
    }
  }, {
    key: "shouldBlockAddingStory",
    value: function shouldBlockAddingStory(id) {
      return this.isSingleStoryMode() && id !== extractIdFromStorySpecifier(this._selectionSpecifier.storySpecifier);
    }
  }, {
    key: "shouldBlockAddingKindMetadata",
    value: function shouldBlockAddingKindMetadata(kind) {
      return this.isSingleStoryMode() && sanitize_1(kind) !== extractSanitizedKindNameFromStorySpecifier(this._selectionSpecifier.storySpecifier);
    }
  }, {
    key: "addStory",
    value: function addStory(_ref16, _ref17) {
      var _this3 = this;

      var id = _ref16.id,
          kind = _ref16.kind,
          name = _ref16.name,
          original = _ref16.storyFn,
          _ref16$parameters = _ref16.parameters,
          storyParameters = _ref16$parameters === void 0 ? {} : _ref16$parameters,
          _ref16$decorators = _ref16.decorators,
          storyDecorators = _ref16$decorators === void 0 ? [] : _ref16$decorators,
          _ref16$loaders = _ref16.loaders,
          storyLoaders = _ref16$loaders === void 0 ? [] : _ref16$loaders;
      var applyDecorators = _ref17.applyDecorators,
          _ref17$allowUnsafe = _ref17.allowUnsafe,
          allowUnsafe = _ref17$allowUnsafe === void 0 ? false : _ref17$allowUnsafe;
      if (!this._configuring && !allowUnsafe) throw new Error('Cannot add a story when not configuring, see https://github.com/storybookjs/storybook/blob/next/MIGRATION.md#story-store-immutable-outside-of-configuration');

      if (this.shouldBlockAddingStory(id)) {
        return;
      }

      checkGlobals(storyParameters);
      checkStorySort(storyParameters);
      var _stories = this._stories;

      if (_stories[id]) {
        logger.warn(_default$4(_templateObject3$D || (_templateObject3$D = _taggedTemplateLiteral(["\n        Story with id ", " already exists in the store!\n\n        Perhaps you added the same story twice, or you have a name collision?\n        Story ids need to be unique -- ensure you aren't using the same names modulo url-sanitization.\n      "])), id));
      }

      var identification = {
        id: id,
        kind: kind,
        name: name,
        story: name // legacy

      }; // immutable original storyFn

      var getOriginal = function getOriginal() {
        return original;
      };

      this.ensureKind(kind);
      var kindMetadata = this._kinds[kind];
      var decorators = [].concat(_toConsumableArray$1(storyDecorators), _toConsumableArray$1(kindMetadata.decorators), _toConsumableArray$1(this._globalMetadata.decorators));
      var loaders = [].concat(_toConsumableArray$1(this._globalMetadata.loaders), _toConsumableArray$1(kindMetadata.loaders), _toConsumableArray$1(storyLoaders));

      var finalStoryFn = function finalStoryFn(context) {
        var _context$args = context.args,
            args = _context$args === void 0 ? {} : _context$args,
            _context$argTypes = context.argTypes,
            argTypes = _context$argTypes === void 0 ? {} : _context$argTypes,
            parameters = context.parameters;
        var _parameters$passArgsF = parameters.passArgsFirst,
            passArgsFirst = _parameters$passArgsF === void 0 ? true : _parameters$passArgsF;
        var mapped = Object.assign({}, context, {
          args: Object.entries(args).reduce(function (acc, _ref18) {
            var _ref19 = _slicedToArray$1(_ref18, 2),
                key = _ref19[0],
                val = _ref19[1];

            var _ref20 = argTypes[key] || {},
                mapping = _ref20.mapping;

            acc[key] = mapping && val in mapping ? mapping[val] : val;
            return acc;
          }, {})
        });
        return passArgsFirst ? original(mapped.args, mapped) : original(mapped);
      }; // lazily decorate the story when it's loaded


      var getDecorated = memoize$3(1)(function () {
        return applyDecorators(finalStoryFn, decorators);
      });
      var hooks = new HooksContext(); // We need the combined parameters now in order to calculate argTypes, but we won't keep them

      var combinedParameters = this.combineStoryParameters(storyParameters, kind); // We are going to make various UI changes in both the manager and the preview
      // based on whether it's an "args story", i.e. whether the story accepts a first
      // argument which is an `Args` object. Here we store it as a parameter on every story
      // for convenience, but we preface it with `__` to denote that it's an internal API
      // and that users probably shouldn't look at it.

      var _combinedParameters$p = combinedParameters.passArgsFirst,
          passArgsFirst = _combinedParameters$p === void 0 ? true : _combinedParameters$p;

      var __isArgsStory = passArgsFirst && original.length > 0;

      var _this$_argTypesEnhanc = this._argTypesEnhancers.reduce(function (accumulatedParameters, enhancer) {
        return Object.assign({}, accumulatedParameters, {
          argTypes: enhancer(Object.assign({}, identification, {
            storyFn: original,
            parameters: accumulatedParameters,
            args: {},
            argTypes: {},
            globals: {},
            originalStoryFn: getOriginal()
          }))
        });
      }, Object.assign({
        __isArgsStory: __isArgsStory
      }, combinedParameters)),
          _this$_argTypesEnhanc2 = _this$_argTypesEnhanc.argTypes,
          argTypes = _this$_argTypesEnhanc2 === void 0 ? {} : _this$_argTypesEnhanc2;

      var storyParametersWithArgTypes = Object.assign({}, storyParameters, {
        argTypes: argTypes,
        __isArgsStory: __isArgsStory
      });

      var storyFn = function storyFn(runtimeContext) {
        var _this3$_selection;

        storyFnWarning();
        return getDecorated()(Object.assign({}, identification, runtimeContext, {
          // Calculate "combined" parameters at render time (NOTE: for perf we could just use combinedParameters from above?)
          parameters: _this3.combineStoryParameters(storyParametersWithArgTypes, kind),
          hooks: hooks,
          args: _stories[id].args,
          argTypes: argTypes,
          globals: _this3._globals,
          viewMode: (_this3$_selection = _this3._selection) === null || _this3$_selection === void 0 ? void 0 : _this3$_selection.viewMode,
          originalStoryFn: getOriginal()
        }));
      };

      var unboundStoryFn = function unboundStoryFn(context) {
        return getDecorated()(context);
      };

      var applyLoaders = /*#__PURE__*/function () {
        var _ref21 = _asyncToGenerator$1( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
          var _this3$_selection2;

          var context, loadResults, loaded;
          return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  context = Object.assign({}, identification, {
                    // Calculate "combined" parameters at render time (NOTE: for perf we could just use combinedParameters from above?)
                    parameters: _this3.combineStoryParameters(storyParametersWithArgTypes, kind),
                    hooks: hooks,
                    args: _stories[id].args,
                    argTypes: argTypes,
                    globals: _this3._globals,
                    viewMode: (_this3$_selection2 = _this3._selection) === null || _this3$_selection2 === void 0 ? void 0 : _this3$_selection2.viewMode,
                    originalStoryFn: getOriginal()
                  });
                  _context.next = 3;
                  return Promise.all(loaders.map(function (loader) {
                    return loader(context);
                  }));

                case 3:
                  loadResults = _context.sent;
                  loaded = Object.assign.apply(Object, [{}].concat(_toConsumableArray$1(loadResults)));
                  return _context.abrupt("return", Object.assign({}, context, {
                    loaded: loaded
                  }));

                case 6:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }));

        return function applyLoaders() {
          return _ref21.apply(this, arguments);
        };
      }(); // Pull out parameters.args.$ || .argTypes.$.defaultValue into initialArgs


      var passedArgs = Object.assign({}, this._kinds[kind].parameters.args, storyParameters.args);
      var defaultArgs = Object.entries(argTypes).reduce(function (acc, _ref22) {
        var _ref23 = _slicedToArray$1(_ref22, 2),
            arg = _ref23[0],
            defaultValue = _ref23[1].defaultValue;

        if (typeof defaultValue !== 'undefined') {
          acc[arg] = defaultValue;
        }

        return acc;
      }, {});

      if (Object.keys(defaultArgs).length > 0) {
        argTypeDefaultValueWarning();
      }

      var initialArgsBeforeEnhancers = Object.assign({}, defaultArgs, passedArgs);

      var initialArgs = this._argsEnhancers.reduce(function (accumulatedArgs, enhancer) {
        return Object.assign({}, accumulatedArgs, enhancer(Object.assign({}, identification, {
          parameters: combinedParameters,
          args: initialArgsBeforeEnhancers,
          argTypes: argTypes,
          globals: {},
          originalStoryFn: getOriginal()
        })));
      }, initialArgsBeforeEnhancers);

      var runPlayFunction = /*#__PURE__*/function () {
        var _ref24 = _asyncToGenerator$1( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
          var _ref25, play;

          return regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  _ref25 = combinedParameters, play = _ref25.play;
                  return _context2.abrupt("return", play ? play() : undefined);

                case 2:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2);
        }));

        return function runPlayFunction() {
          return _ref24.apply(this, arguments);
        };
      }();

      _stories[id] = Object.assign({}, identification, {
        hooks: hooks,
        getDecorated: getDecorated,
        getOriginal: getOriginal,
        applyLoaders: applyLoaders,
        runPlayFunction: runPlayFunction,
        storyFn: storyFn,
        unboundStoryFn: unboundStoryFn,
        parameters: storyParametersWithArgTypes,
        args: initialArgs,
        argTypes: argTypes,
        initialArgs: initialArgs
      });
    }
  }, {
    key: "removeStoryKind",
    value: function removeStoryKind(kind) {
      var _ref26 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
          _ref26$allowUnsafe = _ref26.allowUnsafe,
          allowUnsafe = _ref26$allowUnsafe === void 0 ? false : _ref26$allowUnsafe;

      if (!this._configuring && !allowUnsafe) throw new Error('Cannot remove a kind when not configuring, see https://github.com/storybookjs/storybook/blob/next/MIGRATION.md#story-store-immutable-outside-of-configuration');
      if (!this._kinds[kind]) return;
      this._kinds[kind].parameters = {};
      this._kinds[kind].decorators = [];
      this.cleanHooksForKind(kind);
      this._stories = Object.entries(this._stories).reduce(function (acc, _ref27) {
        var _ref28 = _slicedToArray$1(_ref27, 2),
            id = _ref28[0],
            story = _ref28[1];

        if (story.kind !== kind) acc[id] = story;
        return acc;
      }, {});
    }
  }, {
    key: "updateGlobals",
    value: function updateGlobals(newGlobals) {
      this._globals = Object.assign({}, this._globals, newGlobals);

      this._channel.emit(Events.GLOBALS_UPDATED, {
        globals: this._globals,
        initialGlobals: this._initialGlobals
      });
    }
  }, {
    key: "updateStoryArgs",
    value: function updateStoryArgs(id, newArgs) {
      if (!this._stories[id]) throw new Error("No story for id ".concat(id));
      var args = this._stories[id].args;
      this._stories[id].args = Object.assign({}, args, newArgs);

      this._channel.emit(Events.STORY_ARGS_UPDATED, {
        storyId: id,
        args: this._stories[id].args
      });
    }
  }, {
    key: "resetStoryArgs",
    value: function resetStoryArgs(id, argNames) {
      var _this4 = this;

      if (!this._stories[id]) throw new Error("No story for id ".concat(id));
      var _this$_stories$id = this._stories[id],
          args = _this$_stories$id.args,
          initialArgs = _this$_stories$id.initialArgs;
      this._stories[id].args = Object.assign({}, args); // Make a copy to avoid problems

      (argNames || Object.keys(args)).forEach(function (name) {
        // We overwrite like this to ensure we can reset to falsey values
        _this4._stories[id].args[name] = initialArgs[name];
      });

      this._channel.emit(Events.STORY_ARGS_UPDATED, {
        storyId: id,
        args: this._stories[id].args
      });
    }
  }, {
    key: "raw",
    value: function raw(options) {
      var _this5 = this;

      return Object.values(this._stories).filter(function (i) {
        return !!i.getDecorated;
      }).filter(function (i) {
        return includeStory(i, options);
      }).map(function (i) {
        return _this5.mergeAdditionalDataToStory(i);
      });
    }
  }, {
    key: "sortedStories",
    value: function sortedStories() {
      var _this$_globalMetadata4,
          _this$_globalMetadata5,
          _this6 = this;

      // NOTE: when kinds are HMR'ed they get temporarily removed from the `_stories` array
      // and thus lose order. However `_kinds[x].order` preservers the original load order
      var kindOrder = mapValues_1(this._kinds, function (_ref29) {
        var order = _ref29.order;
        return order;
      });
      var storySortParameter = (_this$_globalMetadata4 = this._globalMetadata.parameters) === null || _this$_globalMetadata4 === void 0 ? void 0 : (_this$_globalMetadata5 = _this$_globalMetadata4.options) === null || _this$_globalMetadata5 === void 0 ? void 0 : _this$_globalMetadata5.storySort;
      var storyEntries = Object.entries(this._stories); // Add the kind parameters and global parameters to each entry

      var stories = storyEntries.map(function (_ref30) {
        var _ref31 = _slicedToArray$1(_ref30, 2),
            id = _ref31[0],
            story = _ref31[1];

        return [id, story, _this6._kinds[story.kind].parameters, _this6._globalMetadata.parameters];
      });

      if (storySortParameter) {
        var sortFn;

        if (typeof storySortParameter === 'function') {
          sortFn = storySortParameter;
        } else {
          sortFn = storySort(storySortParameter);
        }

        stable.inplace(stories, sortFn);
      } else {
        stable.inplace(stories, function (s1, s2) {
          return kindOrder[s1[1].kind] - kindOrder[s2[1].kind];
        });
      }

      return stories.map(function (_ref32) {
        var _ref33 = _slicedToArray$1(_ref32, 2);
            _ref33[0];
            var s = _ref33[1];

        return s;
      });
    }
  }, {
    key: "extract",
    value: function extract() {
      var _this7 = this;

      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var stories = this.sortedStories(); // removes function values from all stories so they are safe to transport over the channel

      return stories.reduce(function (acc, story) {
        if (!includeStory(story, options)) return acc;
        var extracted = toExtracted(story);
        if (options.normalizeParameters) return Object.assign(acc, _defineProperty$4({}, story.id, extracted));
        var _ref34 = extracted,
            parameters = _ref34.parameters,
            kind = _ref34.kind;
        return Object.assign(acc, _defineProperty$4({}, story.id, Object.assign(extracted, {
          parameters: _this7.combineStoryParameters(parameters, kind)
        })));
      }, {});
    }
  }, {
    key: "clearError",
    value: function clearError() {
      this._error = null;
    }
  }, {
    key: "setSelectionSpecifier",
    value: function setSelectionSpecifier(selectionSpecifier) {
      this._selectionSpecifier = selectionSpecifier;
    }
  }, {
    key: "setSelection",
    value: function setSelection(selection) {
      this._selection = selection;

      if (this._channel) {
        this._channel.emit(Events.CURRENT_STORY_WAS_SET, this._selection);
      }
    }
  }, {
    key: "isSingleStoryMode",
    value: function isSingleStoryMode() {
      if (!this._selectionSpecifier) {
        return false;
      }

      var _this$_selectionSpeci2 = this._selectionSpecifier,
          singleStory = _this$_selectionSpeci2.singleStory,
          storySpecifier = _this$_selectionSpeci2.storySpecifier;
      return storySpecifier && storySpecifier !== '*' && singleStory;
    }
  }, {
    key: "getStoryKinds",
    value: function getStoryKinds() {
      return Array.from(new Set(this.raw().map(function (s) {
        return s.kind;
      })));
    }
  }, {
    key: "getRawStory",
    value: function getRawStory(kind, name) {
      return this.getStoriesForKind(kind).find(function (s) {
        return s.name === name;
      });
    }
  }, {
    key: "cleanHooks",
    value: function cleanHooks(id) {
      if (this._stories[id]) {
        this._stories[id].hooks.clean();
      }
    }
  }, {
    key: "cleanHooksForKind",
    value: function cleanHooksForKind(kind) {
      var _this8 = this;

      this.getStoriesForKind(kind).map(function (story) {
        return _this8.cleanHooks(story.id);
      });
    } // This API is a re-implementation of Storybook's original getStorybook() API.
    // As such it may not behave *exactly* the same, but aims to. Some notes:
    //  - It is *NOT* sorted by the user's sort function, but remains sorted in "insertion order"
    //  - It does not include docs-only stories

  }, {
    key: "getStorybook",
    value: function getStorybook() {
      var _this9 = this;

      return Object.values(this.raw().reduce(function (kinds, story) {
        if (!includeStory(story)) return kinds;
        var kind = story.kind,
            name = story.name,
            storyFn = story.storyFn,
            fileName = story.parameters.fileName; // eslint-disable-next-line no-param-reassign

        if (!kinds[kind]) kinds[kind] = {
          kind: kind,
          fileName: fileName,
          stories: []
        };
        kinds[kind].stories.push({
          name: name,
          render: storyFn
        });
        return kinds;
      }, {})).sort(function (s1, s2) {
        return _this9._kinds[s1.kind].order - _this9._kinds[s2.kind].order;
      });
    }
  }, {
    key: "mergeAdditionalDataToStory",
    value: function mergeAdditionalDataToStory(story) {
      return Object.assign({}, story, {
        parameters: this.combineStoryParameters(story.parameters, story.kind),
        globals: this._globals
      });
    }
  }]);

  return StoryStore;
}();function _classCallCheck$e(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* eslint no-underscore-dangle: 0 */
var ConfigApi = function ConfigApi(_ref) {
  var _this = this;

  var storyStore = _ref.storyStore;

  _classCallCheck$e(this, ConfigApi);

  this._storyStore = void 0;

  this.configure = function (loaders, module) {

    _this._storyStore.startConfiguring();

    try {
      loaders();

      _this._storyStore.clearError();
    } catch (err) {
      _this._storyStore.setError(err);
    }

    _this._storyStore.finishConfiguring();
  };

  this._storyStore = storyStore;
};function pathToId(path) {
  var match = (path || '').match(/^\/story\/(.+)/);

  if (!match) {
    throw new Error("Invalid path '".concat(path, "',  must start with '/story/'"));
  }

  return match[1];
}var document$2 = window_1.document; // https://html.spec.whatwg.org/multipage/scripting.html

var runScriptTypes = ['application/javascript', 'application/ecmascript', 'application/x-ecmascript', 'application/x-javascript', 'text/ecmascript', 'text/javascript', 'text/javascript1.0', 'text/javascript1.1', 'text/javascript1.2', 'text/javascript1.3', 'text/javascript1.4', 'text/javascript1.5', 'text/jscript', 'text/livescript', 'text/x-ecmascript', 'text/x-javascript'];
var SCRIPT = 'script';
var SCRIPTS_ROOT_ID = 'scripts-root'; // trigger DOMContentLoaded

function simulateDOMContentLoaded() {
  var DOMContentLoadedEvent = document$2.createEvent('Event');
  DOMContentLoadedEvent.initEvent('DOMContentLoaded', true, true);
  document$2.dispatchEvent(DOMContentLoadedEvent);
}

function insertScript($script, callback, $scriptRoot) {
  var scriptEl = document$2.createElement('script');
  scriptEl.type = 'text/javascript';

  if ($script.src) {
    scriptEl.onload = callback;
    scriptEl.onerror = callback;
    scriptEl.src = $script.src;
  } else {
    scriptEl.textContent = $script.innerText;
  } // re-insert the script tag so it executes.


  if ($scriptRoot) $scriptRoot.appendChild(scriptEl);else document$2.head.appendChild(scriptEl); // clean-up

  $script.parentNode.removeChild($script); // run the callback immediately for inline scripts

  if (!$script.src) callback();
} // runs an array of async functions in sequential order

/* eslint-disable no-param-reassign, no-plusplus */


function insertScriptsSequentially(scriptsToExecute, callback) {
  var index = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
  scriptsToExecute[index](function () {
    index++;

    if (index === scriptsToExecute.length) {
      callback();
    } else {
      insertScriptsSequentially(scriptsToExecute, callback, index);
    }
  });
}

function simulatePageLoad($container) {
  var $scriptsRoot = document$2.getElementById(SCRIPTS_ROOT_ID);

  if (!$scriptsRoot) {
    $scriptsRoot = document$2.createElement('div');
    $scriptsRoot.id = SCRIPTS_ROOT_ID;
    document$2.body.appendChild($scriptsRoot);
  } else {
    $scriptsRoot.innerHTML = '';
  }

  var $scripts = Array.from($container.querySelectorAll(SCRIPT));

  if ($scripts.length) {
    var scriptsToExecute = [];
    $scripts.forEach(function ($script) {
      var typeAttr = $script.getAttribute('type'); // only run script tags without the type attribute
      // or with a javascript mime attribute value from the list

      if (!typeAttr || runScriptTypes.includes(typeAttr)) {
        scriptsToExecute.push(function (callback) {
          return insertScript($script, callback, $scriptsRoot);
        });
      }
    }); // insert the script tags sequentially
    // to preserve execution order

    if (scriptsToExecute.length) {
      insertScriptsSequentially(scriptsToExecute, simulateDOMContentLoaded, undefined);
    }
  } else {
    simulateDOMContentLoaded();
  }
}// `SameValue` abstract operation
// https://tc39.es/ecma262/#sec-samevalue
// eslint-disable-next-line es/no-object-is -- safe
var sameValue$1 = Object.is || function is(x, y) {
  // eslint-disable-next-line no-self-compare -- NaN check
  return x === y ? x !== 0 || 1 / x === 1 / y : x != x && y != y;
};var fixRegExpWellKnownSymbolLogic = fixRegexpWellKnownSymbolLogic;
var anObject = anObject$i;
var requireObjectCoercible = requireObjectCoercible$a;
var sameValue = sameValue$1;
var regExpExec = regexpExecAbstract;

// @@search logic
fixRegExpWellKnownSymbolLogic('search', function (SEARCH, nativeSearch, maybeCallNative) {
  return [
    // `String.prototype.search` method
    // https://tc39.es/ecma262/#sec-string.prototype.search
    function search(regexp) {
      var O = requireObjectCoercible(this);
      var searcher = regexp == undefined ? undefined : regexp[SEARCH];
      return searcher !== undefined ? searcher.call(regexp, O) : new RegExp(regexp)[SEARCH](String(O));
    },
    // `RegExp.prototype[@@search]` method
    // https://tc39.es/ecma262/#sec-regexp.prototype-@@search
    function (string) {
      var res = maybeCallNative(nativeSearch, this, string);
      if (res.done) return res.value;

      var rx = anObject(this);
      var S = String(string);

      var previousLastIndex = rx.lastIndex;
      if (!sameValue(previousLastIndex, 0)) rx.lastIndex = 0;
      var result = regExpExec(rx, S);
      if (!sameValue(rx.lastIndex, previousLastIndex)) rx.lastIndex = previousLastIndex;
      return result === null ? -1 : result.index;
    }
  ];
});/* eslint complexity: [2, 18], max-statements: [2, 33] */
var shams = function hasSymbols() {
	if (typeof Symbol !== 'function' || typeof Object.getOwnPropertySymbols !== 'function') { return false; }
	if (typeof Symbol.iterator === 'symbol') { return true; }

	var obj = {};
	var sym = Symbol('test');
	var symObj = Object(sym);
	if (typeof sym === 'string') { return false; }

	if (Object.prototype.toString.call(sym) !== '[object Symbol]') { return false; }
	if (Object.prototype.toString.call(symObj) !== '[object Symbol]') { return false; }

	// temp disabled per https://github.com/ljharb/object.assign/issues/17
	// if (sym instanceof Symbol) { return false; }
	// temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
	// if (!(symObj instanceof Symbol)) { return false; }

	// if (typeof Symbol.prototype.toString !== 'function') { return false; }
	// if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }

	var symVal = 42;
	obj[sym] = symVal;
	for (sym in obj) { return false; } // eslint-disable-line no-restricted-syntax, no-unreachable-loop
	if (typeof Object.keys === 'function' && Object.keys(obj).length !== 0) { return false; }

	if (typeof Object.getOwnPropertyNames === 'function' && Object.getOwnPropertyNames(obj).length !== 0) { return false; }

	var syms = Object.getOwnPropertySymbols(obj);
	if (syms.length !== 1 || syms[0] !== sym) { return false; }

	if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) { return false; }

	if (typeof Object.getOwnPropertyDescriptor === 'function') {
		var descriptor = Object.getOwnPropertyDescriptor(obj, sym);
		if (descriptor.value !== symVal || descriptor.enumerable !== true) { return false; }
	}

	return true;
};var origSymbol = typeof Symbol !== 'undefined' && Symbol;
var hasSymbolSham = shams;

var hasSymbols$1 = function hasNativeSymbols() {
	if (typeof origSymbol !== 'function') { return false; }
	if (typeof Symbol !== 'function') { return false; }
	if (typeof origSymbol('foo') !== 'symbol') { return false; }
	if (typeof Symbol('bar') !== 'symbol') { return false; }

	return hasSymbolSham();
};/* eslint no-invalid-this: 1 */

var ERROR_MESSAGE = 'Function.prototype.bind called on incompatible ';
var slice = Array.prototype.slice;
var toStr$1 = Object.prototype.toString;
var funcType = '[object Function]';

var implementation$1 = function bind(that) {
    var target = this;
    if (typeof target !== 'function' || toStr$1.call(target) !== funcType) {
        throw new TypeError(ERROR_MESSAGE + target);
    }
    var args = slice.call(arguments, 1);

    var bound;
    var binder = function () {
        if (this instanceof bound) {
            var result = target.apply(
                this,
                args.concat(slice.call(arguments))
            );
            if (Object(result) === result) {
                return result;
            }
            return this;
        } else {
            return target.apply(
                that,
                args.concat(slice.call(arguments))
            );
        }
    };

    var boundLength = Math.max(0, target.length - args.length);
    var boundArgs = [];
    for (var i = 0; i < boundLength; i++) {
        boundArgs.push('$' + i);
    }

    bound = Function('binder', 'return function (' + boundArgs.join(',') + '){ return binder.apply(this,arguments); }')(binder);

    if (target.prototype) {
        var Empty = function Empty() {};
        Empty.prototype = target.prototype;
        bound.prototype = new Empty();
        Empty.prototype = null;
    }

    return bound;
};var implementation = implementation$1;

var functionBind = Function.prototype.bind || implementation;var bind$4 = functionBind;

var src = bind$4.call(Function.call, Object.prototype.hasOwnProperty);var undefined$1;

var $SyntaxError = SyntaxError;
var $Function = Function;
var $TypeError$1 = TypeError;

// eslint-disable-next-line consistent-return
var getEvalledConstructor = function (expressionSyntax) {
	try {
		return $Function('"use strict"; return (' + expressionSyntax + ').constructor;')();
	} catch (e) {}
};

var $gOPD = Object.getOwnPropertyDescriptor;
if ($gOPD) {
	try {
		$gOPD({}, '');
	} catch (e) {
		$gOPD = null; // this is IE 8, which has a broken gOPD
	}
}

var throwTypeError = function () {
	throw new $TypeError$1();
};
var ThrowTypeError = $gOPD
	? (function () {
		try {
			// eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
			arguments.callee; // IE 8 does not throw here
			return throwTypeError;
		} catch (calleeThrows) {
			try {
				// IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
				return $gOPD(arguments, 'callee').get;
			} catch (gOPDthrows) {
				return throwTypeError;
			}
		}
	}())
	: throwTypeError;

var hasSymbols = hasSymbols$1();

var getProto = Object.getPrototypeOf || function (x) { return x.__proto__; }; // eslint-disable-line no-proto

var needsEval = {};

var TypedArray = typeof Uint8Array === 'undefined' ? undefined$1 : getProto(Uint8Array);

var INTRINSICS = {
	'%AggregateError%': typeof AggregateError === 'undefined' ? undefined$1 : AggregateError,
	'%Array%': Array,
	'%ArrayBuffer%': typeof ArrayBuffer === 'undefined' ? undefined$1 : ArrayBuffer,
	'%ArrayIteratorPrototype%': hasSymbols ? getProto([][Symbol.iterator]()) : undefined$1,
	'%AsyncFromSyncIteratorPrototype%': undefined$1,
	'%AsyncFunction%': needsEval,
	'%AsyncGenerator%': needsEval,
	'%AsyncGeneratorFunction%': needsEval,
	'%AsyncIteratorPrototype%': needsEval,
	'%Atomics%': typeof Atomics === 'undefined' ? undefined$1 : Atomics,
	'%BigInt%': typeof BigInt === 'undefined' ? undefined$1 : BigInt,
	'%Boolean%': Boolean,
	'%DataView%': typeof DataView === 'undefined' ? undefined$1 : DataView,
	'%Date%': Date,
	'%decodeURI%': decodeURI,
	'%decodeURIComponent%': decodeURIComponent,
	'%encodeURI%': encodeURI,
	'%encodeURIComponent%': encodeURIComponent,
	'%Error%': Error,
	'%eval%': eval, // eslint-disable-line no-eval
	'%EvalError%': EvalError,
	'%Float32Array%': typeof Float32Array === 'undefined' ? undefined$1 : Float32Array,
	'%Float64Array%': typeof Float64Array === 'undefined' ? undefined$1 : Float64Array,
	'%FinalizationRegistry%': typeof FinalizationRegistry === 'undefined' ? undefined$1 : FinalizationRegistry,
	'%Function%': $Function,
	'%GeneratorFunction%': needsEval,
	'%Int8Array%': typeof Int8Array === 'undefined' ? undefined$1 : Int8Array,
	'%Int16Array%': typeof Int16Array === 'undefined' ? undefined$1 : Int16Array,
	'%Int32Array%': typeof Int32Array === 'undefined' ? undefined$1 : Int32Array,
	'%isFinite%': isFinite,
	'%isNaN%': isNaN,
	'%IteratorPrototype%': hasSymbols ? getProto(getProto([][Symbol.iterator]())) : undefined$1,
	'%JSON%': typeof JSON === 'object' ? JSON : undefined$1,
	'%Map%': typeof Map === 'undefined' ? undefined$1 : Map,
	'%MapIteratorPrototype%': typeof Map === 'undefined' || !hasSymbols ? undefined$1 : getProto(new Map()[Symbol.iterator]()),
	'%Math%': Math,
	'%Number%': Number,
	'%Object%': Object,
	'%parseFloat%': parseFloat,
	'%parseInt%': parseInt,
	'%Promise%': typeof Promise === 'undefined' ? undefined$1 : Promise,
	'%Proxy%': typeof Proxy === 'undefined' ? undefined$1 : Proxy,
	'%RangeError%': RangeError,
	'%ReferenceError%': ReferenceError,
	'%Reflect%': typeof Reflect === 'undefined' ? undefined$1 : Reflect,
	'%RegExp%': RegExp,
	'%Set%': typeof Set === 'undefined' ? undefined$1 : Set,
	'%SetIteratorPrototype%': typeof Set === 'undefined' || !hasSymbols ? undefined$1 : getProto(new Set()[Symbol.iterator]()),
	'%SharedArrayBuffer%': typeof SharedArrayBuffer === 'undefined' ? undefined$1 : SharedArrayBuffer,
	'%String%': String,
	'%StringIteratorPrototype%': hasSymbols ? getProto(''[Symbol.iterator]()) : undefined$1,
	'%Symbol%': hasSymbols ? Symbol : undefined$1,
	'%SyntaxError%': $SyntaxError,
	'%ThrowTypeError%': ThrowTypeError,
	'%TypedArray%': TypedArray,
	'%TypeError%': $TypeError$1,
	'%Uint8Array%': typeof Uint8Array === 'undefined' ? undefined$1 : Uint8Array,
	'%Uint8ClampedArray%': typeof Uint8ClampedArray === 'undefined' ? undefined$1 : Uint8ClampedArray,
	'%Uint16Array%': typeof Uint16Array === 'undefined' ? undefined$1 : Uint16Array,
	'%Uint32Array%': typeof Uint32Array === 'undefined' ? undefined$1 : Uint32Array,
	'%URIError%': URIError,
	'%WeakMap%': typeof WeakMap === 'undefined' ? undefined$1 : WeakMap,
	'%WeakRef%': typeof WeakRef === 'undefined' ? undefined$1 : WeakRef,
	'%WeakSet%': typeof WeakSet === 'undefined' ? undefined$1 : WeakSet
};

var doEval = function doEval(name) {
	var value;
	if (name === '%AsyncFunction%') {
		value = getEvalledConstructor('async function () {}');
	} else if (name === '%GeneratorFunction%') {
		value = getEvalledConstructor('function* () {}');
	} else if (name === '%AsyncGeneratorFunction%') {
		value = getEvalledConstructor('async function* () {}');
	} else if (name === '%AsyncGenerator%') {
		var fn = doEval('%AsyncGeneratorFunction%');
		if (fn) {
			value = fn.prototype;
		}
	} else if (name === '%AsyncIteratorPrototype%') {
		var gen = doEval('%AsyncGenerator%');
		if (gen) {
			value = getProto(gen.prototype);
		}
	}

	INTRINSICS[name] = value;

	return value;
};

var LEGACY_ALIASES = {
	'%ArrayBufferPrototype%': ['ArrayBuffer', 'prototype'],
	'%ArrayPrototype%': ['Array', 'prototype'],
	'%ArrayProto_entries%': ['Array', 'prototype', 'entries'],
	'%ArrayProto_forEach%': ['Array', 'prototype', 'forEach'],
	'%ArrayProto_keys%': ['Array', 'prototype', 'keys'],
	'%ArrayProto_values%': ['Array', 'prototype', 'values'],
	'%AsyncFunctionPrototype%': ['AsyncFunction', 'prototype'],
	'%AsyncGenerator%': ['AsyncGeneratorFunction', 'prototype'],
	'%AsyncGeneratorPrototype%': ['AsyncGeneratorFunction', 'prototype', 'prototype'],
	'%BooleanPrototype%': ['Boolean', 'prototype'],
	'%DataViewPrototype%': ['DataView', 'prototype'],
	'%DatePrototype%': ['Date', 'prototype'],
	'%ErrorPrototype%': ['Error', 'prototype'],
	'%EvalErrorPrototype%': ['EvalError', 'prototype'],
	'%Float32ArrayPrototype%': ['Float32Array', 'prototype'],
	'%Float64ArrayPrototype%': ['Float64Array', 'prototype'],
	'%FunctionPrototype%': ['Function', 'prototype'],
	'%Generator%': ['GeneratorFunction', 'prototype'],
	'%GeneratorPrototype%': ['GeneratorFunction', 'prototype', 'prototype'],
	'%Int8ArrayPrototype%': ['Int8Array', 'prototype'],
	'%Int16ArrayPrototype%': ['Int16Array', 'prototype'],
	'%Int32ArrayPrototype%': ['Int32Array', 'prototype'],
	'%JSONParse%': ['JSON', 'parse'],
	'%JSONStringify%': ['JSON', 'stringify'],
	'%MapPrototype%': ['Map', 'prototype'],
	'%NumberPrototype%': ['Number', 'prototype'],
	'%ObjectPrototype%': ['Object', 'prototype'],
	'%ObjProto_toString%': ['Object', 'prototype', 'toString'],
	'%ObjProto_valueOf%': ['Object', 'prototype', 'valueOf'],
	'%PromisePrototype%': ['Promise', 'prototype'],
	'%PromiseProto_then%': ['Promise', 'prototype', 'then'],
	'%Promise_all%': ['Promise', 'all'],
	'%Promise_reject%': ['Promise', 'reject'],
	'%Promise_resolve%': ['Promise', 'resolve'],
	'%RangeErrorPrototype%': ['RangeError', 'prototype'],
	'%ReferenceErrorPrototype%': ['ReferenceError', 'prototype'],
	'%RegExpPrototype%': ['RegExp', 'prototype'],
	'%SetPrototype%': ['Set', 'prototype'],
	'%SharedArrayBufferPrototype%': ['SharedArrayBuffer', 'prototype'],
	'%StringPrototype%': ['String', 'prototype'],
	'%SymbolPrototype%': ['Symbol', 'prototype'],
	'%SyntaxErrorPrototype%': ['SyntaxError', 'prototype'],
	'%TypedArrayPrototype%': ['TypedArray', 'prototype'],
	'%TypeErrorPrototype%': ['TypeError', 'prototype'],
	'%Uint8ArrayPrototype%': ['Uint8Array', 'prototype'],
	'%Uint8ClampedArrayPrototype%': ['Uint8ClampedArray', 'prototype'],
	'%Uint16ArrayPrototype%': ['Uint16Array', 'prototype'],
	'%Uint32ArrayPrototype%': ['Uint32Array', 'prototype'],
	'%URIErrorPrototype%': ['URIError', 'prototype'],
	'%WeakMapPrototype%': ['WeakMap', 'prototype'],
	'%WeakSetPrototype%': ['WeakSet', 'prototype']
};

var bind$3 = functionBind;
var hasOwn$1 = src;
var $concat = bind$3.call(Function.call, Array.prototype.concat);
var $spliceApply = bind$3.call(Function.apply, Array.prototype.splice);
var $replace = bind$3.call(Function.call, String.prototype.replace);
var $strSlice = bind$3.call(Function.call, String.prototype.slice);

/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */
var rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
var reEscapeChar = /\\(\\)?/g; /** Used to match backslashes in property paths. */
var stringToPath = function stringToPath(string) {
	var first = $strSlice(string, 0, 1);
	var last = $strSlice(string, -1);
	if (first === '%' && last !== '%') {
		throw new $SyntaxError('invalid intrinsic syntax, expected closing `%`');
	} else if (last === '%' && first !== '%') {
		throw new $SyntaxError('invalid intrinsic syntax, expected opening `%`');
	}
	var result = [];
	$replace(string, rePropName, function (match, number, quote, subString) {
		result[result.length] = quote ? $replace(subString, reEscapeChar, '$1') : number || match;
	});
	return result;
};
/* end adaptation */

var getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
	var intrinsicName = name;
	var alias;
	if (hasOwn$1(LEGACY_ALIASES, intrinsicName)) {
		alias = LEGACY_ALIASES[intrinsicName];
		intrinsicName = '%' + alias[0] + '%';
	}

	if (hasOwn$1(INTRINSICS, intrinsicName)) {
		var value = INTRINSICS[intrinsicName];
		if (value === needsEval) {
			value = doEval(intrinsicName);
		}
		if (typeof value === 'undefined' && !allowMissing) {
			throw new $TypeError$1('intrinsic ' + name + ' exists, but is not available. Please file an issue!');
		}

		return {
			alias: alias,
			name: intrinsicName,
			value: value
		};
	}

	throw new $SyntaxError('intrinsic ' + name + ' does not exist!');
};

var getIntrinsic = function GetIntrinsic(name, allowMissing) {
	if (typeof name !== 'string' || name.length === 0) {
		throw new $TypeError$1('intrinsic name must be a non-empty string');
	}
	if (arguments.length > 1 && typeof allowMissing !== 'boolean') {
		throw new $TypeError$1('"allowMissing" argument must be a boolean');
	}

	var parts = stringToPath(name);
	var intrinsicBaseName = parts.length > 0 ? parts[0] : '';

	var intrinsic = getBaseIntrinsic('%' + intrinsicBaseName + '%', allowMissing);
	var intrinsicRealName = intrinsic.name;
	var value = intrinsic.value;
	var skipFurtherCaching = false;

	var alias = intrinsic.alias;
	if (alias) {
		intrinsicBaseName = alias[0];
		$spliceApply(parts, $concat([0, 1], alias));
	}

	for (var i = 1, isOwn = true; i < parts.length; i += 1) {
		var part = parts[i];
		var first = $strSlice(part, 0, 1);
		var last = $strSlice(part, -1);
		if (
			(
				(first === '"' || first === "'" || first === '`')
				|| (last === '"' || last === "'" || last === '`')
			)
			&& first !== last
		) {
			throw new $SyntaxError('property names with quotes must have matching quotes');
		}
		if (part === 'constructor' || !isOwn) {
			skipFurtherCaching = true;
		}

		intrinsicBaseName += '.' + part;
		intrinsicRealName = '%' + intrinsicBaseName + '%';

		if (hasOwn$1(INTRINSICS, intrinsicRealName)) {
			value = INTRINSICS[intrinsicRealName];
		} else if (value != null) {
			if (!(part in value)) {
				if (!allowMissing) {
					throw new $TypeError$1('base intrinsic for ' + name + ' exists, but the property is not available.');
				}
				return void undefined$1;
			}
			if ($gOPD && (i + 1) >= parts.length) {
				var desc = $gOPD(value, part);
				isOwn = !!desc;

				// By convention, when a data property is converted to an accessor
				// property to emulate a data property that does not suffer from
				// the override mistake, that accessor's getter is marked with
				// an `originalValue` property. Here, when we detect this, we
				// uphold the illusion by pretending to see that original data
				// property, i.e., returning the value rather than the getter
				// itself.
				if (isOwn && 'get' in desc && !('originalValue' in desc.get)) {
					value = desc.get;
				} else {
					value = value[part];
				}
			} else {
				isOwn = hasOwn$1(value, part);
				value = value[part];
			}

			if (isOwn && !skipFurtherCaching) {
				INTRINSICS[intrinsicRealName] = value;
			}
		}
	}
	return value;
};var callBind$1 = {exports: {}};(function (module) {

var bind = functionBind;
var GetIntrinsic = getIntrinsic;

var $apply = GetIntrinsic('%Function.prototype.apply%');
var $call = GetIntrinsic('%Function.prototype.call%');
var $reflectApply = GetIntrinsic('%Reflect.apply%', true) || bind.call($call, $apply);

var $gOPD = GetIntrinsic('%Object.getOwnPropertyDescriptor%', true);
var $defineProperty = GetIntrinsic('%Object.defineProperty%', true);
var $max = GetIntrinsic('%Math.max%');

if ($defineProperty) {
	try {
		$defineProperty({}, 'a', { value: 1 });
	} catch (e) {
		// IE 8 has a broken defineProperty
		$defineProperty = null;
	}
}

module.exports = function callBind(originalFunction) {
	var func = $reflectApply(bind, $call, arguments);
	if ($gOPD && $defineProperty) {
		var desc = $gOPD(func, 'length');
		if (desc.configurable) {
			// original length, plus the receiver, minus any additional arguments (after the receiver)
			$defineProperty(
				func,
				'length',
				{ value: 1 + $max(0, originalFunction.length - (arguments.length - 1)) }
			);
		}
	}
	return func;
};

var applyBind = function applyBind() {
	return $reflectApply(bind, $apply, arguments);
};

if ($defineProperty) {
	$defineProperty(module.exports, 'apply', { value: applyBind });
} else {
	module.exports.apply = applyBind;
}
}(callBind$1));var GetIntrinsic$1 = getIntrinsic;

var callBind = callBind$1.exports;

var $indexOf = callBind(GetIntrinsic$1('String.prototype.indexOf'));

var callBound$1 = function callBoundIntrinsic(name, allowMissing) {
	var intrinsic = GetIntrinsic$1(name, !!allowMissing);
	if (typeof intrinsic === 'function' && $indexOf(name, '.prototype.') > -1) {
		return callBind(intrinsic);
	}
	return intrinsic;
};var _nodeResolve_empty = {};var _nodeResolve_empty$1=/*#__PURE__*/Object.freeze({__proto__:null,'default': _nodeResolve_empty});var require$$0 = /*@__PURE__*/getAugmentedNamespace(_nodeResolve_empty$1);var hasMap$1 = typeof Map === 'function' && Map.prototype;
var mapSizeDescriptor = Object.getOwnPropertyDescriptor && hasMap$1 ? Object.getOwnPropertyDescriptor(Map.prototype, 'size') : null;
var mapSize = hasMap$1 && mapSizeDescriptor && typeof mapSizeDescriptor.get === 'function' ? mapSizeDescriptor.get : null;
var mapForEach = hasMap$1 && Map.prototype.forEach;
var hasSet$1 = typeof Set === 'function' && Set.prototype;
var setSizeDescriptor = Object.getOwnPropertyDescriptor && hasSet$1 ? Object.getOwnPropertyDescriptor(Set.prototype, 'size') : null;
var setSize = hasSet$1 && setSizeDescriptor && typeof setSizeDescriptor.get === 'function' ? setSizeDescriptor.get : null;
var setForEach = hasSet$1 && Set.prototype.forEach;
var hasWeakMap = typeof WeakMap === 'function' && WeakMap.prototype;
var weakMapHas = hasWeakMap ? WeakMap.prototype.has : null;
var hasWeakSet = typeof WeakSet === 'function' && WeakSet.prototype;
var weakSetHas = hasWeakSet ? WeakSet.prototype.has : null;
var hasWeakRef = typeof WeakRef === 'function' && WeakRef.prototype;
var weakRefDeref = hasWeakRef ? WeakRef.prototype.deref : null;
var booleanValueOf = Boolean.prototype.valueOf;
var objectToString$1 = Object.prototype.toString;
var functionToString = Function.prototype.toString;
var match = String.prototype.match;
var bigIntValueOf = typeof BigInt === 'function' ? BigInt.prototype.valueOf : null;
var gOPS = Object.getOwnPropertySymbols;
var symToString = typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol' ? Symbol.prototype.toString : null;
var hasShammedSymbols = typeof Symbol === 'function' && typeof Symbol.iterator === 'object';
var isEnumerable = Object.prototype.propertyIsEnumerable;

var gPO = (typeof Reflect === 'function' ? Reflect.getPrototypeOf : Object.getPrototypeOf) || (
    [].__proto__ === Array.prototype // eslint-disable-line no-proto
        ? function (O) {
            return O.__proto__; // eslint-disable-line no-proto
        }
        : null
);

var inspectCustom = require$$0.custom;
var inspectSymbol = inspectCustom && isSymbol$3(inspectCustom) ? inspectCustom : null;
var toStringTag = typeof Symbol === 'function' && typeof Symbol.toStringTag !== 'undefined' ? Symbol.toStringTag : null;

var objectInspect = function inspect_(obj, options, depth, seen) {
    var opts = options || {};

    if (has$3(opts, 'quoteStyle') && (opts.quoteStyle !== 'single' && opts.quoteStyle !== 'double')) {
        throw new TypeError('option "quoteStyle" must be "single" or "double"');
    }
    if (
        has$3(opts, 'maxStringLength') && (typeof opts.maxStringLength === 'number'
            ? opts.maxStringLength < 0 && opts.maxStringLength !== Infinity
            : opts.maxStringLength !== null
        )
    ) {
        throw new TypeError('option "maxStringLength", if provided, must be a positive integer, Infinity, or `null`');
    }
    var customInspect = has$3(opts, 'customInspect') ? opts.customInspect : true;
    if (typeof customInspect !== 'boolean' && customInspect !== 'symbol') {
        throw new TypeError('option "customInspect", if provided, must be `true`, `false`, or `\'symbol\'`');
    }

    if (
        has$3(opts, 'indent')
        && opts.indent !== null
        && opts.indent !== '\t'
        && !(parseInt(opts.indent, 10) === opts.indent && opts.indent > 0)
    ) {
        throw new TypeError('options "indent" must be "\\t", an integer > 0, or `null`');
    }

    if (typeof obj === 'undefined') {
        return 'undefined';
    }
    if (obj === null) {
        return 'null';
    }
    if (typeof obj === 'boolean') {
        return obj ? 'true' : 'false';
    }

    if (typeof obj === 'string') {
        return inspectString(obj, opts);
    }
    if (typeof obj === 'number') {
        if (obj === 0) {
            return Infinity / obj > 0 ? '0' : '-0';
        }
        return String(obj);
    }
    if (typeof obj === 'bigint') {
        return String(obj) + 'n';
    }

    var maxDepth = typeof opts.depth === 'undefined' ? 5 : opts.depth;
    if (typeof depth === 'undefined') { depth = 0; }
    if (depth >= maxDepth && maxDepth > 0 && typeof obj === 'object') {
        return isArray$c(obj) ? '[Array]' : '[Object]';
    }

    var indent = getIndent(opts, depth);

    if (typeof seen === 'undefined') {
        seen = [];
    } else if (indexOf(seen, obj) >= 0) {
        return '[Circular]';
    }

    function inspect(value, from, noIndent) {
        if (from) {
            seen = seen.slice();
            seen.push(from);
        }
        if (noIndent) {
            var newOpts = {
                depth: opts.depth
            };
            if (has$3(opts, 'quoteStyle')) {
                newOpts.quoteStyle = opts.quoteStyle;
            }
            return inspect_(value, newOpts, depth + 1, seen);
        }
        return inspect_(value, opts, depth + 1, seen);
    }

    if (typeof obj === 'function') {
        var name = nameOf(obj);
        var keys = arrObjKeys(obj, inspect);
        return '[Function' + (name ? ': ' + name : ' (anonymous)') + ']' + (keys.length > 0 ? ' { ' + keys.join(', ') + ' }' : '');
    }
    if (isSymbol$3(obj)) {
        var symString = hasShammedSymbols ? String(obj).replace(/^(Symbol\(.*\))_[^)]*$/, '$1') : symToString.call(obj);
        return typeof obj === 'object' && !hasShammedSymbols ? markBoxed(symString) : symString;
    }
    if (isElement$1(obj)) {
        var s = '<' + String(obj.nodeName).toLowerCase();
        var attrs = obj.attributes || [];
        for (var i = 0; i < attrs.length; i++) {
            s += ' ' + attrs[i].name + '=' + wrapQuotes(quote(attrs[i].value), 'double', opts);
        }
        s += '>';
        if (obj.childNodes && obj.childNodes.length) { s += '...'; }
        s += '</' + String(obj.nodeName).toLowerCase() + '>';
        return s;
    }
    if (isArray$c(obj)) {
        if (obj.length === 0) { return '[]'; }
        var xs = arrObjKeys(obj, inspect);
        if (indent && !singleLineValues(xs)) {
            return '[' + indentedJoin(xs, indent) + ']';
        }
        return '[ ' + xs.join(', ') + ' ]';
    }
    if (isError(obj)) {
        var parts = arrObjKeys(obj, inspect);
        if (parts.length === 0) { return '[' + String(obj) + ']'; }
        return '{ [' + String(obj) + '] ' + parts.join(', ') + ' }';
    }
    if (typeof obj === 'object' && customInspect) {
        if (inspectSymbol && typeof obj[inspectSymbol] === 'function') {
            return obj[inspectSymbol]();
        } else if (customInspect !== 'symbol' && typeof obj.inspect === 'function') {
            return obj.inspect();
        }
    }
    if (isMap$2(obj)) {
        var mapParts = [];
        mapForEach.call(obj, function (value, key) {
            mapParts.push(inspect(key, obj, true) + ' => ' + inspect(value, obj));
        });
        return collectionOf('Map', mapSize.call(obj), mapParts, indent);
    }
    if (isSet$2(obj)) {
        var setParts = [];
        setForEach.call(obj, function (value) {
            setParts.push(inspect(value, obj));
        });
        return collectionOf('Set', setSize.call(obj), setParts, indent);
    }
    if (isWeakMap(obj)) {
        return weakCollectionOf('WeakMap');
    }
    if (isWeakSet(obj)) {
        return weakCollectionOf('WeakSet');
    }
    if (isWeakRef(obj)) {
        return weakCollectionOf('WeakRef');
    }
    if (isNumber$1(obj)) {
        return markBoxed(inspect(Number(obj)));
    }
    if (isBigInt(obj)) {
        return markBoxed(inspect(bigIntValueOf.call(obj)));
    }
    if (isBoolean(obj)) {
        return markBoxed(booleanValueOf.call(obj));
    }
    if (isString$3(obj)) {
        return markBoxed(inspect(String(obj)));
    }
    if (!isDate$1(obj) && !isRegExp$1(obj)) {
        var ys = arrObjKeys(obj, inspect);
        var isPlainObject = gPO ? gPO(obj) === Object.prototype : obj instanceof Object || obj.constructor === Object;
        var protoTag = obj instanceof Object ? '' : 'null prototype';
        var stringTag = !isPlainObject && toStringTag && Object(obj) === obj && toStringTag in obj ? toStr(obj).slice(8, -1) : protoTag ? 'Object' : '';
        var constructorTag = isPlainObject || typeof obj.constructor !== 'function' ? '' : obj.constructor.name ? obj.constructor.name + ' ' : '';
        var tag = constructorTag + (stringTag || protoTag ? '[' + [].concat(stringTag || [], protoTag || []).join(': ') + '] ' : '');
        if (ys.length === 0) { return tag + '{}'; }
        if (indent) {
            return tag + '{' + indentedJoin(ys, indent) + '}';
        }
        return tag + '{ ' + ys.join(', ') + ' }';
    }
    return String(obj);
};

function wrapQuotes(s, defaultStyle, opts) {
    var quoteChar = (opts.quoteStyle || defaultStyle) === 'double' ? '"' : "'";
    return quoteChar + s + quoteChar;
}

function quote(s) {
    return String(s).replace(/"/g, '&quot;');
}

function isArray$c(obj) { return toStr(obj) === '[object Array]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isDate$1(obj) { return toStr(obj) === '[object Date]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isRegExp$1(obj) { return toStr(obj) === '[object RegExp]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isError(obj) { return toStr(obj) === '[object Error]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isString$3(obj) { return toStr(obj) === '[object String]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isNumber$1(obj) { return toStr(obj) === '[object Number]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }
function isBoolean(obj) { return toStr(obj) === '[object Boolean]' && (!toStringTag || !(typeof obj === 'object' && toStringTag in obj)); }

// Symbol and BigInt do have Symbol.toStringTag by spec, so that can't be used to eliminate false positives
function isSymbol$3(obj) {
    if (hasShammedSymbols) {
        return obj && typeof obj === 'object' && obj instanceof Symbol;
    }
    if (typeof obj === 'symbol') {
        return true;
    }
    if (!obj || typeof obj !== 'object' || !symToString) {
        return false;
    }
    try {
        symToString.call(obj);
        return true;
    } catch (e) {}
    return false;
}

function isBigInt(obj) {
    if (!obj || typeof obj !== 'object' || !bigIntValueOf) {
        return false;
    }
    try {
        bigIntValueOf.call(obj);
        return true;
    } catch (e) {}
    return false;
}

var hasOwn = Object.prototype.hasOwnProperty || function (key) { return key in this; };
function has$3(obj, key) {
    return hasOwn.call(obj, key);
}

function toStr(obj) {
    return objectToString$1.call(obj);
}

function nameOf(f) {
    if (f.name) { return f.name; }
    var m = match.call(functionToString.call(f), /^function\s*([\w$]+)/);
    if (m) { return m[1]; }
    return null;
}

function indexOf(xs, x) {
    if (xs.indexOf) { return xs.indexOf(x); }
    for (var i = 0, l = xs.length; i < l; i++) {
        if (xs[i] === x) { return i; }
    }
    return -1;
}

function isMap$2(x) {
    if (!mapSize || !x || typeof x !== 'object') {
        return false;
    }
    try {
        mapSize.call(x);
        try {
            setSize.call(x);
        } catch (s) {
            return true;
        }
        return x instanceof Map; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}

function isWeakMap(x) {
    if (!weakMapHas || !x || typeof x !== 'object') {
        return false;
    }
    try {
        weakMapHas.call(x, weakMapHas);
        try {
            weakSetHas.call(x, weakSetHas);
        } catch (s) {
            return true;
        }
        return x instanceof WeakMap; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}

function isWeakRef(x) {
    if (!weakRefDeref || !x || typeof x !== 'object') {
        return false;
    }
    try {
        weakRefDeref.call(x);
        return true;
    } catch (e) {}
    return false;
}

function isSet$2(x) {
    if (!setSize || !x || typeof x !== 'object') {
        return false;
    }
    try {
        setSize.call(x);
        try {
            mapSize.call(x);
        } catch (m) {
            return true;
        }
        return x instanceof Set; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}

function isWeakSet(x) {
    if (!weakSetHas || !x || typeof x !== 'object') {
        return false;
    }
    try {
        weakSetHas.call(x, weakSetHas);
        try {
            weakMapHas.call(x, weakMapHas);
        } catch (s) {
            return true;
        }
        return x instanceof WeakSet; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}

function isElement$1(x) {
    if (!x || typeof x !== 'object') { return false; }
    if (typeof HTMLElement !== 'undefined' && x instanceof HTMLElement) {
        return true;
    }
    return typeof x.nodeName === 'string' && typeof x.getAttribute === 'function';
}

function inspectString(str, opts) {
    if (str.length > opts.maxStringLength) {
        var remaining = str.length - opts.maxStringLength;
        var trailer = '... ' + remaining + ' more character' + (remaining > 1 ? 's' : '');
        return inspectString(str.slice(0, opts.maxStringLength), opts) + trailer;
    }
    // eslint-disable-next-line no-control-regex
    var s = str.replace(/(['\\])/g, '\\$1').replace(/[\x00-\x1f]/g, lowbyte);
    return wrapQuotes(s, 'single', opts);
}

function lowbyte(c) {
    var n = c.charCodeAt(0);
    var x = {
        8: 'b',
        9: 't',
        10: 'n',
        12: 'f',
        13: 'r'
    }[n];
    if (x) { return '\\' + x; }
    return '\\x' + (n < 0x10 ? '0' : '') + n.toString(16).toUpperCase();
}

function markBoxed(str) {
    return 'Object(' + str + ')';
}

function weakCollectionOf(type) {
    return type + ' { ? }';
}

function collectionOf(type, size, entries, indent) {
    var joinedEntries = indent ? indentedJoin(entries, indent) : entries.join(', ');
    return type + ' (' + size + ') {' + joinedEntries + '}';
}

function singleLineValues(xs) {
    for (var i = 0; i < xs.length; i++) {
        if (indexOf(xs[i], '\n') >= 0) {
            return false;
        }
    }
    return true;
}

function getIndent(opts, depth) {
    var baseIndent;
    if (opts.indent === '\t') {
        baseIndent = '\t';
    } else if (typeof opts.indent === 'number' && opts.indent > 0) {
        baseIndent = Array(opts.indent + 1).join(' ');
    } else {
        return null;
    }
    return {
        base: baseIndent,
        prev: Array(depth + 1).join(baseIndent)
    };
}

function indentedJoin(xs, indent) {
    if (xs.length === 0) { return ''; }
    var lineJoiner = '\n' + indent.prev + indent.base;
    return lineJoiner + xs.join(',' + lineJoiner) + '\n' + indent.prev;
}

function arrObjKeys(obj, inspect) {
    var isArr = isArray$c(obj);
    var xs = [];
    if (isArr) {
        xs.length = obj.length;
        for (var i = 0; i < obj.length; i++) {
            xs[i] = has$3(obj, i) ? inspect(obj[i], obj) : '';
        }
    }
    var syms = typeof gOPS === 'function' ? gOPS(obj) : [];
    var symMap;
    if (hasShammedSymbols) {
        symMap = {};
        for (var k = 0; k < syms.length; k++) {
            symMap['$' + syms[k]] = syms[k];
        }
    }

    for (var key in obj) { // eslint-disable-line no-restricted-syntax
        if (!has$3(obj, key)) { continue; } // eslint-disable-line no-restricted-syntax, no-continue
        if (isArr && String(Number(key)) === key && key < obj.length) { continue; } // eslint-disable-line no-restricted-syntax, no-continue
        if (hasShammedSymbols && symMap['$' + key] instanceof Symbol) {
            // this is to prevent shammed Symbols, which are stored as strings, from being included in the string key section
            continue; // eslint-disable-line no-restricted-syntax, no-continue
        } else if ((/[^\w$]/).test(key)) {
            xs.push(inspect(key, obj) + ': ' + inspect(obj[key], obj));
        } else {
            xs.push(key + ': ' + inspect(obj[key], obj));
        }
    }
    if (typeof gOPS === 'function') {
        for (var j = 0; j < syms.length; j++) {
            if (isEnumerable.call(obj, syms[j])) {
                xs.push('[' + inspect(syms[j]) + ']: ' + inspect(obj[syms[j]], obj));
            }
        }
    }
    return xs;
}var GetIntrinsic = getIntrinsic;
var callBound = callBound$1;
var inspect = objectInspect;

var $TypeError = GetIntrinsic('%TypeError%');
var $WeakMap = GetIntrinsic('%WeakMap%', true);
var $Map = GetIntrinsic('%Map%', true);

var $weakMapGet = callBound('WeakMap.prototype.get', true);
var $weakMapSet = callBound('WeakMap.prototype.set', true);
var $weakMapHas = callBound('WeakMap.prototype.has', true);
var $mapGet = callBound('Map.prototype.get', true);
var $mapSet = callBound('Map.prototype.set', true);
var $mapHas = callBound('Map.prototype.has', true);

/*
 * This function traverses the list returning the node corresponding to the
 * given key.
 *
 * That node is also moved to the head of the list, so that if it's accessed
 * again we don't need to traverse the whole list. By doing so, all the recently
 * used nodes can be accessed relatively quickly.
 */
var listGetNode = function (list, key) { // eslint-disable-line consistent-return
	for (var prev = list, curr; (curr = prev.next) !== null; prev = curr) {
		if (curr.key === key) {
			prev.next = curr.next;
			curr.next = list.next;
			list.next = curr; // eslint-disable-line no-param-reassign
			return curr;
		}
	}
};

var listGet = function (objects, key) {
	var node = listGetNode(objects, key);
	return node && node.value;
};
var listSet = function (objects, key, value) {
	var node = listGetNode(objects, key);
	if (node) {
		node.value = value;
	} else {
		// Prepend the new node to the beginning of the list
		objects.next = { // eslint-disable-line no-param-reassign
			key: key,
			next: objects.next,
			value: value
		};
	}
};
var listHas = function (objects, key) {
	return !!listGetNode(objects, key);
};

var sideChannel = function getSideChannel() {
	var $wm;
	var $m;
	var $o;
	var channel = {
		assert: function (key) {
			if (!channel.has(key)) {
				throw new $TypeError('Side channel does not contain ' + inspect(key));
			}
		},
		get: function (key) { // eslint-disable-line consistent-return
			if ($WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
				if ($wm) {
					return $weakMapGet($wm, key);
				}
			} else if ($Map) {
				if ($m) {
					return $mapGet($m, key);
				}
			} else {
				if ($o) { // eslint-disable-line no-lonely-if
					return listGet($o, key);
				}
			}
		},
		has: function (key) {
			if ($WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
				if ($wm) {
					return $weakMapHas($wm, key);
				}
			} else if ($Map) {
				if ($m) {
					return $mapHas($m, key);
				}
			} else {
				if ($o) { // eslint-disable-line no-lonely-if
					return listHas($o, key);
				}
			}
			return false;
		},
		set: function (key, value) {
			if ($WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
				if (!$wm) {
					$wm = new $WeakMap();
				}
				$weakMapSet($wm, key, value);
			} else if ($Map) {
				if (!$m) {
					$m = new $Map();
				}
				$mapSet($m, key, value);
			} else {
				if (!$o) {
					/*
					 * Initialize the linked list as an empty node, so that we don't have
					 * to special-case handling of the first node: we can always refer to
					 * it as (previous node).next, instead of something like (list).head
					 */
					$o = { key: {}, next: null };
				}
				listSet($o, key, value);
			}
		}
	};
	return channel;
};var replace = String.prototype.replace;
var percentTwenties = /%20/g;

var Format = {
    RFC1738: 'RFC1738',
    RFC3986: 'RFC3986'
};

var formats$3 = {
    'default': Format.RFC3986,
    formatters: {
        RFC1738: function (value) {
            return replace.call(value, percentTwenties, '+');
        },
        RFC3986: function (value) {
            return String(value);
        }
    },
    RFC1738: Format.RFC1738,
    RFC3986: Format.RFC3986
};var formats$2 = formats$3;

var has$2 = Object.prototype.hasOwnProperty;
var isArray$b = Array.isArray;

var hexTable = (function () {
    var array = [];
    for (var i = 0; i < 256; ++i) {
        array.push('%' + ((i < 16 ? '0' : '') + i.toString(16)).toUpperCase());
    }

    return array;
}());

var compactQueue = function compactQueue(queue) {
    while (queue.length > 1) {
        var item = queue.pop();
        var obj = item.obj[item.prop];

        if (isArray$b(obj)) {
            var compacted = [];

            for (var j = 0; j < obj.length; ++j) {
                if (typeof obj[j] !== 'undefined') {
                    compacted.push(obj[j]);
                }
            }

            item.obj[item.prop] = compacted;
        }
    }
};

var arrayToObject = function arrayToObject(source, options) {
    var obj = options && options.plainObjects ? Object.create(null) : {};
    for (var i = 0; i < source.length; ++i) {
        if (typeof source[i] !== 'undefined') {
            obj[i] = source[i];
        }
    }

    return obj;
};

var merge$2 = function merge(target, source, options) {
    /* eslint no-param-reassign: 0 */
    if (!source) {
        return target;
    }

    if (typeof source !== 'object') {
        if (isArray$b(target)) {
            target.push(source);
        } else if (target && typeof target === 'object') {
            if ((options && (options.plainObjects || options.allowPrototypes)) || !has$2.call(Object.prototype, source)) {
                target[source] = true;
            }
        } else {
            return [target, source];
        }

        return target;
    }

    if (!target || typeof target !== 'object') {
        return [target].concat(source);
    }

    var mergeTarget = target;
    if (isArray$b(target) && !isArray$b(source)) {
        mergeTarget = arrayToObject(target, options);
    }

    if (isArray$b(target) && isArray$b(source)) {
        source.forEach(function (item, i) {
            if (has$2.call(target, i)) {
                var targetItem = target[i];
                if (targetItem && typeof targetItem === 'object' && item && typeof item === 'object') {
                    target[i] = merge(targetItem, item, options);
                } else {
                    target.push(item);
                }
            } else {
                target[i] = item;
            }
        });
        return target;
    }

    return Object.keys(source).reduce(function (acc, key) {
        var value = source[key];

        if (has$2.call(acc, key)) {
            acc[key] = merge(acc[key], value, options);
        } else {
            acc[key] = value;
        }
        return acc;
    }, mergeTarget);
};

var assign = function assignSingleSource(target, source) {
    return Object.keys(source).reduce(function (acc, key) {
        acc[key] = source[key];
        return acc;
    }, target);
};

var decode = function (str, decoder, charset) {
    var strWithoutPlus = str.replace(/\+/g, ' ');
    if (charset === 'iso-8859-1') {
        // unescape never throws, no try...catch needed:
        return strWithoutPlus.replace(/%[0-9a-f]{2}/gi, unescape);
    }
    // utf-8
    try {
        return decodeURIComponent(strWithoutPlus);
    } catch (e) {
        return strWithoutPlus;
    }
};

var encode$1 = function encode(str, defaultEncoder, charset, kind, format) {
    // This code was originally written by Brian White (mscdex) for the io.js core querystring library.
    // It has been adapted here for stricter adherence to RFC 3986
    if (str.length === 0) {
        return str;
    }

    var string = str;
    if (typeof str === 'symbol') {
        string = Symbol.prototype.toString.call(str);
    } else if (typeof str !== 'string') {
        string = String(str);
    }

    if (charset === 'iso-8859-1') {
        return escape(string).replace(/%u[0-9a-f]{4}/gi, function ($0) {
            return '%26%23' + parseInt($0.slice(2), 16) + '%3B';
        });
    }

    var out = '';
    for (var i = 0; i < string.length; ++i) {
        var c = string.charCodeAt(i);

        if (
            c === 0x2D // -
            || c === 0x2E // .
            || c === 0x5F // _
            || c === 0x7E // ~
            || (c >= 0x30 && c <= 0x39) // 0-9
            || (c >= 0x41 && c <= 0x5A) // a-z
            || (c >= 0x61 && c <= 0x7A) // A-Z
            || (format === formats$2.RFC1738 && (c === 0x28 || c === 0x29)) // ( )
        ) {
            out += string.charAt(i);
            continue;
        }

        if (c < 0x80) {
            out = out + hexTable[c];
            continue;
        }

        if (c < 0x800) {
            out = out + (hexTable[0xC0 | (c >> 6)] + hexTable[0x80 | (c & 0x3F)]);
            continue;
        }

        if (c < 0xD800 || c >= 0xE000) {
            out = out + (hexTable[0xE0 | (c >> 12)] + hexTable[0x80 | ((c >> 6) & 0x3F)] + hexTable[0x80 | (c & 0x3F)]);
            continue;
        }

        i += 1;
        c = 0x10000 + (((c & 0x3FF) << 10) | (string.charCodeAt(i) & 0x3FF));
        out += hexTable[0xF0 | (c >> 18)]
            + hexTable[0x80 | ((c >> 12) & 0x3F)]
            + hexTable[0x80 | ((c >> 6) & 0x3F)]
            + hexTable[0x80 | (c & 0x3F)];
    }

    return out;
};

var compact = function compact(value) {
    var queue = [{ obj: { o: value }, prop: 'o' }];
    var refs = [];

    for (var i = 0; i < queue.length; ++i) {
        var item = queue[i];
        var obj = item.obj[item.prop];

        var keys = Object.keys(obj);
        for (var j = 0; j < keys.length; ++j) {
            var key = keys[j];
            var val = obj[key];
            if (typeof val === 'object' && val !== null && refs.indexOf(val) === -1) {
                queue.push({ obj: obj, prop: key });
                refs.push(val);
            }
        }
    }

    compactQueue(queue);

    return value;
};

var isRegExp = function isRegExp(obj) {
    return Object.prototype.toString.call(obj) === '[object RegExp]';
};

var isBuffer$4 = function isBuffer(obj) {
    if (!obj || typeof obj !== 'object') {
        return false;
    }

    return !!(obj.constructor && obj.constructor.isBuffer && obj.constructor.isBuffer(obj));
};

var combine = function combine(a, b) {
    return [].concat(a, b);
};

var maybeMap = function maybeMap(val, fn) {
    if (isArray$b(val)) {
        var mapped = [];
        for (var i = 0; i < val.length; i += 1) {
            mapped.push(fn(val[i]));
        }
        return mapped;
    }
    return fn(val);
};

var utils$h = {
    arrayToObject: arrayToObject,
    assign: assign,
    combine: combine,
    compact: compact,
    decode: decode,
    encode: encode$1,
    isBuffer: isBuffer$4,
    isRegExp: isRegExp,
    maybeMap: maybeMap,
    merge: merge$2
};var getSideChannel = sideChannel;
var utils$g = utils$h;
var formats$1 = formats$3;
var has$1 = Object.prototype.hasOwnProperty;

var arrayPrefixGenerators = {
    brackets: function brackets(prefix) {
        return prefix + '[]';
    },
    comma: 'comma',
    indices: function indices(prefix, key) {
        return prefix + '[' + key + ']';
    },
    repeat: function repeat(prefix) {
        return prefix;
    }
};

var isArray$a = Array.isArray;
var push = Array.prototype.push;
var pushToArray = function (arr, valueOrArray) {
    push.apply(arr, isArray$a(valueOrArray) ? valueOrArray : [valueOrArray]);
};

var toISO = Date.prototype.toISOString;

var defaultFormat = formats$1['default'];
var defaults$4 = {
    addQueryPrefix: false,
    allowDots: false,
    charset: 'utf-8',
    charsetSentinel: false,
    delimiter: '&',
    encode: true,
    encoder: utils$g.encode,
    encodeValuesOnly: false,
    format: defaultFormat,
    formatter: formats$1.formatters[defaultFormat],
    // deprecated
    indices: false,
    serializeDate: function serializeDate(date) {
        return toISO.call(date);
    },
    skipNulls: false,
    strictNullHandling: false
};

var isNonNullishPrimitive = function isNonNullishPrimitive(v) {
    return typeof v === 'string'
        || typeof v === 'number'
        || typeof v === 'boolean'
        || typeof v === 'symbol'
        || typeof v === 'bigint';
};

var stringify$1 = function stringify(
    object,
    prefix,
    generateArrayPrefix,
    strictNullHandling,
    skipNulls,
    encoder,
    filter,
    sort,
    allowDots,
    serializeDate,
    format,
    formatter,
    encodeValuesOnly,
    charset,
    sideChannel
) {
    var obj = object;

    if (sideChannel.has(object)) {
        throw new RangeError('Cyclic object value');
    }

    if (typeof filter === 'function') {
        obj = filter(prefix, obj);
    } else if (obj instanceof Date) {
        obj = serializeDate(obj);
    } else if (generateArrayPrefix === 'comma' && isArray$a(obj)) {
        obj = utils$g.maybeMap(obj, function (value) {
            if (value instanceof Date) {
                return serializeDate(value);
            }
            return value;
        });
    }

    if (obj === null) {
        if (strictNullHandling) {
            return encoder && !encodeValuesOnly ? encoder(prefix, defaults$4.encoder, charset, 'key', format) : prefix;
        }

        obj = '';
    }

    if (isNonNullishPrimitive(obj) || utils$g.isBuffer(obj)) {
        if (encoder) {
            var keyValue = encodeValuesOnly ? prefix : encoder(prefix, defaults$4.encoder, charset, 'key', format);
            return [formatter(keyValue) + '=' + formatter(encoder(obj, defaults$4.encoder, charset, 'value', format))];
        }
        return [formatter(prefix) + '=' + formatter(String(obj))];
    }

    var values = [];

    if (typeof obj === 'undefined') {
        return values;
    }

    var objKeys;
    if (generateArrayPrefix === 'comma' && isArray$a(obj)) {
        // we need to join elements in
        objKeys = [{ value: obj.length > 0 ? obj.join(',') || null : undefined }];
    } else if (isArray$a(filter)) {
        objKeys = filter;
    } else {
        var keys = Object.keys(obj);
        objKeys = sort ? keys.sort(sort) : keys;
    }

    for (var i = 0; i < objKeys.length; ++i) {
        var key = objKeys[i];
        var value = typeof key === 'object' && key.value !== undefined ? key.value : obj[key];

        if (skipNulls && value === null) {
            continue;
        }

        var keyPrefix = isArray$a(obj)
            ? typeof generateArrayPrefix === 'function' ? generateArrayPrefix(prefix, key) : prefix
            : prefix + (allowDots ? '.' + key : '[' + key + ']');

        sideChannel.set(object, true);
        var valueSideChannel = getSideChannel();
        pushToArray(values, stringify(
            value,
            keyPrefix,
            generateArrayPrefix,
            strictNullHandling,
            skipNulls,
            encoder,
            filter,
            sort,
            allowDots,
            serializeDate,
            format,
            formatter,
            encodeValuesOnly,
            charset,
            valueSideChannel
        ));
    }

    return values;
};

var normalizeStringifyOptions = function normalizeStringifyOptions(opts) {
    if (!opts) {
        return defaults$4;
    }

    if (opts.encoder !== null && opts.encoder !== undefined && typeof opts.encoder !== 'function') {
        throw new TypeError('Encoder has to be a function.');
    }

    var charset = opts.charset || defaults$4.charset;
    if (typeof opts.charset !== 'undefined' && opts.charset !== 'utf-8' && opts.charset !== 'iso-8859-1') {
        throw new TypeError('The charset option must be either utf-8, iso-8859-1, or undefined');
    }

    var format = formats$1['default'];
    if (typeof opts.format !== 'undefined') {
        if (!has$1.call(formats$1.formatters, opts.format)) {
            throw new TypeError('Unknown format option provided.');
        }
        format = opts.format;
    }
    var formatter = formats$1.formatters[format];

    var filter = defaults$4.filter;
    if (typeof opts.filter === 'function' || isArray$a(opts.filter)) {
        filter = opts.filter;
    }

    return {
        addQueryPrefix: typeof opts.addQueryPrefix === 'boolean' ? opts.addQueryPrefix : defaults$4.addQueryPrefix,
        allowDots: typeof opts.allowDots === 'undefined' ? defaults$4.allowDots : !!opts.allowDots,
        charset: charset,
        charsetSentinel: typeof opts.charsetSentinel === 'boolean' ? opts.charsetSentinel : defaults$4.charsetSentinel,
        delimiter: typeof opts.delimiter === 'undefined' ? defaults$4.delimiter : opts.delimiter,
        encode: typeof opts.encode === 'boolean' ? opts.encode : defaults$4.encode,
        encoder: typeof opts.encoder === 'function' ? opts.encoder : defaults$4.encoder,
        encodeValuesOnly: typeof opts.encodeValuesOnly === 'boolean' ? opts.encodeValuesOnly : defaults$4.encodeValuesOnly,
        filter: filter,
        format: format,
        formatter: formatter,
        serializeDate: typeof opts.serializeDate === 'function' ? opts.serializeDate : defaults$4.serializeDate,
        skipNulls: typeof opts.skipNulls === 'boolean' ? opts.skipNulls : defaults$4.skipNulls,
        sort: typeof opts.sort === 'function' ? opts.sort : null,
        strictNullHandling: typeof opts.strictNullHandling === 'boolean' ? opts.strictNullHandling : defaults$4.strictNullHandling
    };
};

var stringify_1 = function (object, opts) {
    var obj = object;
    var options = normalizeStringifyOptions(opts);

    var objKeys;
    var filter;

    if (typeof options.filter === 'function') {
        filter = options.filter;
        obj = filter('', obj);
    } else if (isArray$a(options.filter)) {
        filter = options.filter;
        objKeys = filter;
    }

    var keys = [];

    if (typeof obj !== 'object' || obj === null) {
        return '';
    }

    var arrayFormat;
    if (opts && opts.arrayFormat in arrayPrefixGenerators) {
        arrayFormat = opts.arrayFormat;
    } else if (opts && 'indices' in opts) {
        arrayFormat = opts.indices ? 'indices' : 'repeat';
    } else {
        arrayFormat = 'indices';
    }

    var generateArrayPrefix = arrayPrefixGenerators[arrayFormat];

    if (!objKeys) {
        objKeys = Object.keys(obj);
    }

    if (options.sort) {
        objKeys.sort(options.sort);
    }

    var sideChannel = getSideChannel();
    for (var i = 0; i < objKeys.length; ++i) {
        var key = objKeys[i];

        if (options.skipNulls && obj[key] === null) {
            continue;
        }
        pushToArray(keys, stringify$1(
            obj[key],
            key,
            generateArrayPrefix,
            options.strictNullHandling,
            options.skipNulls,
            options.encode ? options.encoder : null,
            options.filter,
            options.sort,
            options.allowDots,
            options.serializeDate,
            options.format,
            options.formatter,
            options.encodeValuesOnly,
            options.charset,
            sideChannel
        ));
    }

    var joined = keys.join(options.delimiter);
    var prefix = options.addQueryPrefix === true ? '?' : '';

    if (options.charsetSentinel) {
        if (options.charset === 'iso-8859-1') {
            // encodeURIComponent('&#10003;'), the "numeric entity" representation of a checkmark
            prefix += 'utf8=%26%2310003%3B&';
        } else {
            // encodeURIComponent('✓')
            prefix += 'utf8=%E2%9C%93&';
        }
    }

    return joined.length > 0 ? prefix + joined : '';
};var utils$f = utils$h;

var has = Object.prototype.hasOwnProperty;
var isArray$9 = Array.isArray;

var defaults$3 = {
    allowDots: false,
    allowPrototypes: false,
    allowSparse: false,
    arrayLimit: 20,
    charset: 'utf-8',
    charsetSentinel: false,
    comma: false,
    decoder: utils$f.decode,
    delimiter: '&',
    depth: 5,
    ignoreQueryPrefix: false,
    interpretNumericEntities: false,
    parameterLimit: 1000,
    parseArrays: true,
    plainObjects: false,
    strictNullHandling: false
};

var interpretNumericEntities = function (str) {
    return str.replace(/&#(\d+);/g, function ($0, numberStr) {
        return String.fromCharCode(parseInt(numberStr, 10));
    });
};

var parseArrayValue = function (val, options) {
    if (val && typeof val === 'string' && options.comma && val.indexOf(',') > -1) {
        return val.split(',');
    }

    return val;
};

// This is what browsers will submit when the ✓ character occurs in an
// application/x-www-form-urlencoded body and the encoding of the page containing
// the form is iso-8859-1, or when the submitted form has an accept-charset
// attribute of iso-8859-1. Presumably also with other charsets that do not contain
// the ✓ character, such as us-ascii.
var isoSentinel = 'utf8=%26%2310003%3B'; // encodeURIComponent('&#10003;')

// These are the percent-encoded utf-8 octets representing a checkmark, indicating that the request actually is utf-8 encoded.
var charsetSentinel = 'utf8=%E2%9C%93'; // encodeURIComponent('✓')

var parseValues = function parseQueryStringValues(str, options) {
    var obj = {};
    var cleanStr = options.ignoreQueryPrefix ? str.replace(/^\?/, '') : str;
    var limit = options.parameterLimit === Infinity ? undefined : options.parameterLimit;
    var parts = cleanStr.split(options.delimiter, limit);
    var skipIndex = -1; // Keep track of where the utf8 sentinel was found
    var i;

    var charset = options.charset;
    if (options.charsetSentinel) {
        for (i = 0; i < parts.length; ++i) {
            if (parts[i].indexOf('utf8=') === 0) {
                if (parts[i] === charsetSentinel) {
                    charset = 'utf-8';
                } else if (parts[i] === isoSentinel) {
                    charset = 'iso-8859-1';
                }
                skipIndex = i;
                i = parts.length; // The eslint settings do not allow break;
            }
        }
    }

    for (i = 0; i < parts.length; ++i) {
        if (i === skipIndex) {
            continue;
        }
        var part = parts[i];

        var bracketEqualsPos = part.indexOf(']=');
        var pos = bracketEqualsPos === -1 ? part.indexOf('=') : bracketEqualsPos + 1;

        var key, val;
        if (pos === -1) {
            key = options.decoder(part, defaults$3.decoder, charset, 'key');
            val = options.strictNullHandling ? null : '';
        } else {
            key = options.decoder(part.slice(0, pos), defaults$3.decoder, charset, 'key');
            val = utils$f.maybeMap(
                parseArrayValue(part.slice(pos + 1), options),
                function (encodedVal) {
                    return options.decoder(encodedVal, defaults$3.decoder, charset, 'value');
                }
            );
        }

        if (val && options.interpretNumericEntities && charset === 'iso-8859-1') {
            val = interpretNumericEntities(val);
        }

        if (part.indexOf('[]=') > -1) {
            val = isArray$9(val) ? [val] : val;
        }

        if (has.call(obj, key)) {
            obj[key] = utils$f.combine(obj[key], val);
        } else {
            obj[key] = val;
        }
    }

    return obj;
};

var parseObject = function (chain, val, options, valuesParsed) {
    var leaf = valuesParsed ? val : parseArrayValue(val, options);

    for (var i = chain.length - 1; i >= 0; --i) {
        var obj;
        var root = chain[i];

        if (root === '[]' && options.parseArrays) {
            obj = [].concat(leaf);
        } else {
            obj = options.plainObjects ? Object.create(null) : {};
            var cleanRoot = root.charAt(0) === '[' && root.charAt(root.length - 1) === ']' ? root.slice(1, -1) : root;
            var index = parseInt(cleanRoot, 10);
            if (!options.parseArrays && cleanRoot === '') {
                obj = { 0: leaf };
            } else if (
                !isNaN(index)
                && root !== cleanRoot
                && String(index) === cleanRoot
                && index >= 0
                && (options.parseArrays && index <= options.arrayLimit)
            ) {
                obj = [];
                obj[index] = leaf;
            } else {
                obj[cleanRoot] = leaf;
            }
        }

        leaf = obj;
    }

    return leaf;
};

var parseKeys = function parseQueryStringKeys(givenKey, val, options, valuesParsed) {
    if (!givenKey) {
        return;
    }

    // Transform dot notation to bracket notation
    var key = options.allowDots ? givenKey.replace(/\.([^.[]+)/g, '[$1]') : givenKey;

    // The regex chunks

    var brackets = /(\[[^[\]]*])/;
    var child = /(\[[^[\]]*])/g;

    // Get the parent

    var segment = options.depth > 0 && brackets.exec(key);
    var parent = segment ? key.slice(0, segment.index) : key;

    // Stash the parent if it exists

    var keys = [];
    if (parent) {
        // If we aren't using plain objects, optionally prefix keys that would overwrite object prototype properties
        if (!options.plainObjects && has.call(Object.prototype, parent)) {
            if (!options.allowPrototypes) {
                return;
            }
        }

        keys.push(parent);
    }

    // Loop through children appending to the array until we hit depth

    var i = 0;
    while (options.depth > 0 && (segment = child.exec(key)) !== null && i < options.depth) {
        i += 1;
        if (!options.plainObjects && has.call(Object.prototype, segment[1].slice(1, -1))) {
            if (!options.allowPrototypes) {
                return;
            }
        }
        keys.push(segment[1]);
    }

    // If there's a remainder, just add whatever is left

    if (segment) {
        keys.push('[' + key.slice(segment.index) + ']');
    }

    return parseObject(keys, val, options, valuesParsed);
};

var normalizeParseOptions = function normalizeParseOptions(opts) {
    if (!opts) {
        return defaults$3;
    }

    if (opts.decoder !== null && opts.decoder !== undefined && typeof opts.decoder !== 'function') {
        throw new TypeError('Decoder has to be a function.');
    }

    if (typeof opts.charset !== 'undefined' && opts.charset !== 'utf-8' && opts.charset !== 'iso-8859-1') {
        throw new TypeError('The charset option must be either utf-8, iso-8859-1, or undefined');
    }
    var charset = typeof opts.charset === 'undefined' ? defaults$3.charset : opts.charset;

    return {
        allowDots: typeof opts.allowDots === 'undefined' ? defaults$3.allowDots : !!opts.allowDots,
        allowPrototypes: typeof opts.allowPrototypes === 'boolean' ? opts.allowPrototypes : defaults$3.allowPrototypes,
        allowSparse: typeof opts.allowSparse === 'boolean' ? opts.allowSparse : defaults$3.allowSparse,
        arrayLimit: typeof opts.arrayLimit === 'number' ? opts.arrayLimit : defaults$3.arrayLimit,
        charset: charset,
        charsetSentinel: typeof opts.charsetSentinel === 'boolean' ? opts.charsetSentinel : defaults$3.charsetSentinel,
        comma: typeof opts.comma === 'boolean' ? opts.comma : defaults$3.comma,
        decoder: typeof opts.decoder === 'function' ? opts.decoder : defaults$3.decoder,
        delimiter: typeof opts.delimiter === 'string' || utils$f.isRegExp(opts.delimiter) ? opts.delimiter : defaults$3.delimiter,
        // eslint-disable-next-line no-implicit-coercion, no-extra-parens
        depth: (typeof opts.depth === 'number' || opts.depth === false) ? +opts.depth : defaults$3.depth,
        ignoreQueryPrefix: opts.ignoreQueryPrefix === true,
        interpretNumericEntities: typeof opts.interpretNumericEntities === 'boolean' ? opts.interpretNumericEntities : defaults$3.interpretNumericEntities,
        parameterLimit: typeof opts.parameterLimit === 'number' ? opts.parameterLimit : defaults$3.parameterLimit,
        parseArrays: opts.parseArrays !== false,
        plainObjects: typeof opts.plainObjects === 'boolean' ? opts.plainObjects : defaults$3.plainObjects,
        strictNullHandling: typeof opts.strictNullHandling === 'boolean' ? opts.strictNullHandling : defaults$3.strictNullHandling
    };
};

var parse$1 = function (str, opts) {
    var options = normalizeParseOptions(opts);

    if (str === '' || str === null || typeof str === 'undefined') {
        return options.plainObjects ? Object.create(null) : {};
    }

    var tempObj = typeof str === 'string' ? parseValues(str, options) : str;
    var obj = options.plainObjects ? Object.create(null) : {};

    // Iterate over the keys and setup the new object

    var keys = Object.keys(tempObj);
    for (var i = 0; i < keys.length; ++i) {
        var key = keys[i];
        var newObj = parseKeys(key, tempObj[key], options, typeof str === 'string');
        obj = utils$f.merge(obj, newObj, options);
    }

    if (options.allowSparse === true) {
        return obj;
    }

    return utils$f.compact(obj);
};var stringify = stringify_1;
var parse = parse$1;
var formats = formats$3;

var lib$2 = {
    formats: formats,
    parse: parse,
    stringify: stringify
};var document$1 = window_1.document;
var getQueryParams = function getQueryParams() {
  // document.location is not defined in react-native
  if (document$1 && document$1.location && document$1.location.search) {
    return lib$2.parse(document$1.location.search, {
      ignoreQueryPrefix: true
    });
  }

  return {};
};
var getQueryParam = function getQueryParam(key) {
  var params = getQueryParams();
  return params[key];
};var esm=/*#__PURE__*/Object.freeze({__proto__:null,addArgsEnhancer: addArgsEnhancer,addArgTypesEnhancer: addArgTypesEnhancer,addDecorator: addDecorator,addLoader: addLoader,addParameters: addParameters,setGlobalRender: setGlobalRender,ClientApi: ClientApi,combineParameters: combineParameters,ConfigApi: ConfigApi,defaultDecorateStory: defaultDecorateStory,filterArgTypes: filterArgTypes,getQueryParam: getQueryParam,getQueryParams: getQueryParams,pathToId: pathToId,simulateDOMContentLoaded: simulateDOMContentLoaded,simulatePageLoad: simulatePageLoad,StoryStore: StoryStore,HooksContext: HooksContext,applyHooks: applyHooks,useMemo: useMemo,useCallback: useCallback,useRef: useRef,useState: useState,useReducer: useReducer,useEffect: useEffect,useChannel: useChannel,useStoryContext: useStoryContext,useParameter: useParameter,useArgs: useArgs,useGlobals: useGlobals,useSharedState: useSharedState,useAddonState: useAddonState,inferControls: inferControls});var require$$1 = /*@__PURE__*/getAugmentedNamespace(esm);var require$$2 = /*@__PURE__*/getAugmentedNamespace(esm$1);var root$1 = _root;

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now$3 = function() {
  return root$1.Date.now();
};

var now_1 = now$3;/** Used to match a single whitespace character. */

var reWhitespace = /\s/;

/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
 * character of `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the index of the last non-whitespace character.
 */
function trimmedEndIndex$1(string) {
  var index = string.length;

  while (index-- && reWhitespace.test(string.charAt(index))) {}
  return index;
}

var _trimmedEndIndex = trimmedEndIndex$1;var trimmedEndIndex = _trimmedEndIndex;

/** Used to match leading whitespace. */
var reTrimStart = /^\s+/;

/**
 * The base implementation of `_.trim`.
 *
 * @private
 * @param {string} string The string to trim.
 * @returns {string} Returns the trimmed string.
 */
function baseTrim$1(string) {
  return string
    ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '')
    : string;
}

var _baseTrim = baseTrim$1;var baseTrim = _baseTrim,
    isObject$9 = isObject_1,
    isSymbol$2 = isSymbol_1;

/** Used as references for various `Number` constants. */
var NAN$1 = 0 / 0;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex$1 = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary$1 = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal$1 = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt$1 = parseInt;

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber$3(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol$2(value)) {
    return NAN$1;
  }
  if (isObject$9(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject$9(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = baseTrim(value);
  var isBinary = reIsBinary$1.test(value);
  return (isBinary || reIsOctal$1.test(value))
    ? freeParseInt$1(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex$1.test(value) ? NAN$1 : +value);
}

var toNumber_1 = toNumber$3;var isObject$8 = isObject_1,
    now$2 = now_1,
    toNumber$2 = toNumber_1;

/** Error message constants. */
var FUNC_ERROR_TEXT$2 = 'Expected a function';

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax$3 = Math.max,
    nativeMin$2 = Math.min;

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce$5(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT$2);
  }
  wait = toNumber$2(wait) || 0;
  if (isObject$8(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax$3(toNumber$2(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        timeWaiting = wait - timeSinceLastCall;

    return maxing
      ? nativeMin$2(timeWaiting, maxWait - timeSinceLastInvoke)
      : timeWaiting;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now$2();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now$2());
  }

  function debounced() {
    var time = now$2(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        clearTimeout(timerId);
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

var debounce_1 = debounce$5;var KnobManager = {};/*!
 * escape-html
 * Copyright(c) 2012-2013 TJ Holowaychuk
 * Copyright(c) 2015 Andreas Lubbe
 * Copyright(c) 2015 Tiancheng "Timothy" Gu
 * MIT Licensed
 */

/**
 * Module variables.
 * @private
 */

var matchHtmlRegExp = /["'&<>]/;

/**
 * Module exports.
 * @public
 */

var escapeHtml_1 = escapeHtml;

/**
 * Escape special characters in the given string of html.
 *
 * @param  {string} string The string to escape for inserting into HTML
 * @return {string}
 * @public
 */

function escapeHtml(string) {
  var str = '' + string;
  var match = matchHtmlRegExp.exec(str);

  if (!match) {
    return str;
  }

  var escape;
  var html = '';
  var index = 0;
  var lastIndex = 0;

  for (index = match.index; index < str.length; index++) {
    switch (str.charCodeAt(index)) {
      case 34: // "
        escape = '&quot;';
        break;
      case 38: // &
        escape = '&amp;';
        break;
      case 39: // '
        escape = '&#39;';
        break;
      case 60: // <
        escape = '&lt;';
        break;
      case 62: // >
        escape = '&gt;';
        break;
      default:
        continue;
    }

    if (lastIndex !== index) {
      html += str.substring(lastIndex, index);
    }

    lastIndex = index + 1;
    html += escape;
  }

  return lastIndex !== index
    ? html + str.substring(lastIndex, index)
    : html;
}var KnobStore = {};(function (exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var callArg = function callArg(fn) {
  return fn();
};

var callAll = function callAll(fns) {
  return fns.forEach(callArg);
};

var KnobStore = /*#__PURE__*/function () {
  function KnobStore() {
    _classCallCheck(this, KnobStore);

    _defineProperty(this, "store", {});

    _defineProperty(this, "callbacks", []);
  }

  _createClass(KnobStore, [{
    key: "has",
    value: function has(key) {
      return this.store[key] !== undefined;
    }
  }, {
    key: "set",
    value: function set(key, value) {
      this.store[key] = _objectSpread(_objectSpread({}, value), {}, {
        used: true,
        groupId: value.groupId
      }); // debounce the execution of the callbacks for 50 milliseconds

      if (this.timer) {
        clearTimeout(this.timer);
      }

      this.timer = setTimeout(callAll, 50, this.callbacks);
    }
  }, {
    key: "update",
    value: function update(key, options) {
      this.store[key] = _objectSpread(_objectSpread({}, this.store[key]), options);
    }
  }, {
    key: "get",
    value: function get(key) {
      var knob = this.store[key];

      if (knob) {
        knob.used = true;
      }

      return knob;
    }
  }, {
    key: "getAll",
    value: function getAll() {
      return this.store;
    }
  }, {
    key: "reset",
    value: function reset() {
      this.store = {};
    }
  }, {
    key: "markAllUnused",
    value: function markAllUnused() {
      var _this = this;

      Object.keys(this.store).forEach(function (knobName) {
        _this.store[knobName].used = false;
      });
    }
  }, {
    key: "subscribe",
    value: function subscribe(cb) {
      this.callbacks.push(cb);
    }
  }, {
    key: "unsubscribe",
    value: function unsubscribe(cb) {
      var index = this.callbacks.indexOf(cb);
      this.callbacks.splice(index, 1);
    }
  }]);

  return KnobStore;
}();

exports["default"] = KnobStore;
}(KnobStore));var converters$1 = {};Object.defineProperty(converters$1, "__esModule", {
  value: true
});
converters$1.deserializers = converters$1.serializers = converters$1.converters = void 0;

var unconvertable = function unconvertable() {
  return undefined;
};

var converters = {
  jsonParse: function jsonParse(value) {
    return JSON.parse(value);
  },
  jsonStringify: function jsonStringify(value) {
    return JSON.stringify(value);
  },
  simple: function simple(value) {
    return value;
  },
  stringifyIfSet: function stringifyIfSet(value) {
    return value === null || value === undefined ? '' : String(value);
  },
  stringifyIfTruthy: function stringifyIfTruthy(value) {
    return value ? String(value) : null;
  },
  toArray: function toArray(value) {
    if (Array.isArray(value)) {
      return value;
    }

    return value.split(',');
  },
  toBoolean: function toBoolean(value) {
    return value === 'true';
  },
  toDate: function toDate(value) {
    return new Date(value).getTime() || new Date().getTime();
  },
  toFloat: function toFloat(value) {
    return value === '' ? null : parseFloat(value);
  }
};
converters$1.converters = converters;
var serializers = {
  array: converters.simple,
  "boolean": converters.stringifyIfTruthy,
  button: unconvertable,
  checkbox: converters.simple,
  color: converters.simple,
  date: converters.toDate,
  files: unconvertable,
  number: converters.stringifyIfSet,
  object: converters.jsonStringify,
  options: converters.simple,
  radios: converters.simple,
  select: converters.simple,
  text: converters.simple
};
converters$1.serializers = serializers;
var deserializers = {
  array: converters.toArray,
  "boolean": converters.toBoolean,
  button: unconvertable,
  checkbox: converters.simple,
  color: converters.simple,
  date: converters.toDate,
  files: unconvertable,
  number: converters.toFloat,
  object: converters.jsonParse,
  options: converters.simple,
  radios: converters.simple,
  select: converters.simple,
  text: converters.simple
};
converters$1.deserializers = deserializers;(function (exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _global = window_1;

var _escapeHtml = _interopRequireDefault(escapeHtml_1);

var _clientApi = require$$1;

var _KnobStore = _interopRequireDefault(KnobStore);

var _shared = shared;

var _converters = converters$1;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr && (typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]); if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var knobValuesFromUrl = Object.entries((0, _clientApi.getQueryParams)()).reduce(function (acc, _ref) {
  var _ref2 = _slicedToArray(_ref, 2),
      k = _ref2[0],
      v = _ref2[1];

  if (k.includes('knob-')) {
    return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, k.replace('knob-', ''), v));
  }

  return acc;
}, {}); // This is used by _mayCallChannel to determine how long to wait to before triggering a panel update

var PANEL_UPDATE_INTERVAL = 400;

function escapeStrings(obj) {
  if (typeof obj === 'string') {
    return (0, _escapeHtml["default"])(obj);
  }

  if (obj == null || _typeof(obj) !== 'object') {
    return obj;
  }

  if (Array.isArray(obj)) {
    var newArray = obj.map(escapeStrings);
    var didChange = newArray.some(function (newValue, key) {
      return newValue !== obj[key];
    });
    return didChange ? newArray : obj;
  }

  return Object.entries(obj).reduce(function (acc, _ref3) {
    var _ref4 = _slicedToArray(_ref3, 2),
        key = _ref4[0],
        oldValue = _ref4[1];

    var newValue = escapeStrings(oldValue);
    return newValue === oldValue ? acc : _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, key, newValue));
  }, obj);
}

var KnobManager = /*#__PURE__*/function () {
  function KnobManager() {
    _classCallCheck(this, KnobManager);

    _defineProperty(this, "knobStore", new _KnobStore["default"]());

    _defineProperty(this, "options", {});

    _defineProperty(this, "calling", false);
  }

  _createClass(KnobManager, [{
    key: "setChannel",
    value: function setChannel(channel) {
      this.channel = channel;
    }
  }, {
    key: "setOptions",
    value: function setOptions(options) {
      this.options = options;
    }
  }, {
    key: "getKnobValue",
    value: function getKnobValue(_ref5) {
      var value = _ref5.value;
      return this.options.escapeHTML ? escapeStrings(value) : value;
    }
  }, {
    key: "knob",
    value: function knob(name, options) {
      this._mayCallChannel();

      var knobName = options.groupId ? "".concat(name, "_").concat(options.groupId) : name;
      var knobStore = this.knobStore;
      var existingKnob = knobStore.get(knobName); // We need to return the value set by the knob editor via this.
      // Normally the knobs are reset and so re-use is safe as long as the types match
      // when in storyshots, though the change event isn't called and so the knobs aren't reset, making this code fail
      // so always create a new knob when in storyshots

      if (existingKnob && options.type === existingKnob.type && _global.navigator && ( // userAgent is not set in react-native
      !_global.navigator.userAgent || !_global.navigator.userAgent.includes('jsdom'))) {
        options.value;
            var restOptions = _objectWithoutProperties(options, ["value"]);

        knobStore.update(knobName, restOptions);
        return this.getKnobValue(existingKnob);
      }

      var knobInfo = _objectSpread(_objectSpread({}, options), {}, {
        name: knobName,
        label: name
      });

      if (knobValuesFromUrl[knobName]) {
        var _value = _converters.deserializers[options.type](knobValuesFromUrl[knobName]);

        knobInfo.defaultValue = _value;
        knobInfo.value = _value;
        delete knobValuesFromUrl[knobName];
      } else {
        knobInfo.defaultValue = options.value;
      }

      knobStore.set(knobName, knobInfo);
      return this.getKnobValue(knobStore.get(knobName));
    }
  }, {
    key: "_mayCallChannel",
    value: function _mayCallChannel() {
      var _this = this;

      // Re rendering of the story may cause changes to the knobStore. Some new knobs maybe added and
      // Some knobs may go unused. So we need to update the panel accordingly. For example remove the
      // unused knobs from the panel. This function sends the `setKnobs` message to the channel
      // triggering a panel re-render.
      if (!this.channel) {
        // to prevent call to undefined channel and therefore throwing TypeError
        return;
      }

      if (this.calling) {
        // If a call to channel has already registered ignore this call.
        // Once the previous call is completed all the changes to knobStore including the one that
        // triggered this, will be added to the panel.
        // This avoids emitting to the channel within very short periods of time.
        return;
      }

      this.calling = true;
      var timestamp = +new Date();
      setTimeout(function () {
        _this.calling = false; // emit to the channel and trigger a panel re-render

        if (_this.channel) _this.channel.emit(_shared.SET, {
          knobs: _this.knobStore.getAll(),
          timestamp: timestamp
        });
      }, PANEL_UPDATE_INTERVAL);
    }
  }]);

  return KnobManager;
}();

exports["default"] = KnobManager;
}(KnobManager));Object.defineProperty(registerKnobs$1, "__esModule", {
  value: true
});
registerKnobs$1.registerKnobs = registerKnobs;
registerKnobs$1.manager = void 0;

var _addons = _interopRequireDefault$q(require$$0$1);

var _clientApi = require$$1;

var _coreEvents = require$$2;

var _debounce$1 = _interopRequireDefault$q(debounce_1);

var _KnobManager = _interopRequireDefault$q(KnobManager);

var _shared = shared;

function _interopRequireDefault$q(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var manager = new _KnobManager["default"]();
registerKnobs$1.manager = manager;
var knobStore = manager.knobStore;
var COMPONENT_FORCE_RENDER_DEBOUNCE_DELAY_MS = 325;

function forceReRender() {
  _addons["default"].getChannel().emit(_coreEvents.FORCE_RE_RENDER);
}

function setPaneKnobs() {
  var timestamp = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : +new Date();

  var channel = _addons["default"].getChannel();

  channel.emit(_shared.SET, {
    knobs: knobStore.getAll(),
    timestamp: timestamp
  });
}

var resetAndForceUpdate = function resetAndForceUpdate() {
  knobStore.markAllUnused();
  forceReRender();
}; // Increase performance by reducing how frequently the story is recreated during knob changes


var debouncedResetAndForceUpdate = (0, _debounce$1["default"])(resetAndForceUpdate, COMPONENT_FORCE_RENDER_DEBOUNCE_DELAY_MS);

function knobChanged(change) {
  var name = change.name;
  var value = change.value; // Update the related knob and it's value.

  var knobOptions = knobStore.get(name);
  knobOptions.value = value;

  if (!manager.options.disableForceUpdate && !knobOptions.disableForceUpdate) {
    if (!manager.options.disableDebounce && !knobOptions.disableDebounce) {
      debouncedResetAndForceUpdate();
    } else {
      resetAndForceUpdate();
    }
  }
}

function knobClicked(clicked) {
  var knobOptions = knobStore.get(clicked.name);

  if (knobOptions.callback && knobOptions.callback() !== false) {
    forceReRender();
  }
}

function resetKnobs() {
  knobStore.reset();
  setPaneKnobs(false);
}

function resetKnobsAndForceReRender() {
  knobStore.reset();
  forceReRender();
  setPaneKnobs(false);
}

function disconnectCallbacks() {
  var channel = _addons["default"].getChannel();

  channel.removeListener(_shared.CHANGE, knobChanged);
  channel.removeListener(_shared.CLICK, knobClicked);
  channel.removeListener(_coreEvents.STORY_CHANGED, resetKnobs);
  channel.removeListener(_shared.RESET, resetKnobsAndForceReRender);
  knobStore.unsubscribe(setPaneKnobs);
}

function connectCallbacks() {
  var channel = _addons["default"].getChannel();

  channel.on(_shared.CHANGE, knobChanged);
  channel.on(_shared.CLICK, knobClicked);
  channel.on(_coreEvents.STORY_CHANGED, resetKnobs);
  channel.on(_shared.RESET, resetKnobsAndForceReRender);
  knobStore.subscribe(setPaneKnobs);
  return disconnectCallbacks;
}

function registerKnobs() {
  (0, _clientApi.useEffect)(connectCallbacks, []);
}(function (module, exports) {

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  knob: true,
  text: true,
  "boolean": true,
  number: true,
  color: true,
  object: true,
  select: true,
  radios: true,
  array: true,
  date: true,
  button: true,
  files: true,
  optionsKnob: true,
  withKnobs: true
};
exports.knob = knob;
exports.text = text;
exports["boolean"] = _boolean;
exports.number = number;
exports.color = color;
exports.object = object;
exports.select = select;
exports.radios = radios;
exports.array = array;
exports.date = date;
exports.button = button;
exports.files = files;
exports.optionsKnob = optionsKnob;
exports.withKnobs = void 0;

var _addons = _interopRequireWildcard(require$$0$1);

var _shared = shared;

Object.keys(_shared).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _shared[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _shared[key];
    }
  });
});

var _registerKnobs = registerKnobs$1;

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function knob(name, options) {
  return _registerKnobs.manager.knob(name, options);
}

function text(name, value, groupId) {
  return _registerKnobs.manager.knob(name, {
    type: 'text',
    value: value,
    groupId: groupId
  });
}

function _boolean(name, value, groupId) {
  return _registerKnobs.manager.knob(name, {
    type: 'boolean',
    value: value,
    groupId: groupId
  });
}

function number(name, value) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var groupId = arguments.length > 3 ? arguments[3] : undefined;
  var rangeDefaults = {
    min: 0,
    max: 10,
    step: 1
  };
  var mergedOptions = options.range ? _objectSpread(_objectSpread({}, rangeDefaults), options) : options;

  var finalOptions = _objectSpread(_objectSpread({
    type: 'number'
  }, mergedOptions), {}, {
    value: value,
    groupId: groupId
  });

  return _registerKnobs.manager.knob(name, finalOptions);
}

function color(name, value, groupId) {
  return _registerKnobs.manager.knob(name, {
    type: 'color',
    value: value,
    groupId: groupId
  });
}

function object(name, value, groupId) {
  return _registerKnobs.manager.knob(name, {
    type: 'object',
    value: value,
    groupId: groupId
  });
}

function select(name, options, value, groupId) {
  return _registerKnobs.manager.knob(name, {
    type: 'select',
    selectV2: true,
    options: options,
    value: value,
    groupId: groupId
  });
}

function radios(name, options, value, groupId) {
  return _registerKnobs.manager.knob(name, {
    type: 'radios',
    options: options,
    value: value,
    groupId: groupId
  });
}

function array(name, value) {
  var separator = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : ',';
  var groupId = arguments.length > 3 ? arguments[3] : undefined;
  return _registerKnobs.manager.knob(name, {
    type: 'array',
    value: value,
    separator: separator,
    groupId: groupId
  });
}

function date(name) {
  var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new Date();
  var groupId = arguments.length > 2 ? arguments[2] : undefined;
  var proxyValue = value ? value.getTime() : new Date().getTime();
  return _registerKnobs.manager.knob(name, {
    type: 'date',
    value: proxyValue,
    groupId: groupId
  });
}

function button(name, callback, groupId) {
  return _registerKnobs.manager.knob(name, {
    type: 'button',
    callback: callback,
    hideLabel: true,
    groupId: groupId
  });
}

function files(name, accept) {
  var value = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  var groupId = arguments.length > 3 ? arguments[3] : undefined;
  return _registerKnobs.manager.knob(name, {
    type: 'files',
    accept: accept,
    value: value,
    groupId: groupId
  });
}

function optionsKnob(name, valuesObj, value, optionsObj, groupId) {
  return _registerKnobs.manager.knob(name, {
    type: 'options',
    options: valuesObj,
    value: value,
    optionsObj: optionsObj,
    groupId: groupId
  });
}

var defaultOptions = {
  escapeHTML: true
};
var withKnobs = (0, _addons.makeDecorator)({
  name: 'withKnobs',
  parameterName: 'knobs',
  skipIfNoParametersOrOptions: false,
  wrapper: function wrapper(getStory, context, _ref) {
    var options = _ref.options,
        parameters = _ref.parameters;
    var storyOptions = parameters || options;

    var allOptions = _objectSpread(_objectSpread({}, defaultOptions), storyOptions);

    var channel = _addons["default"].getChannel();

    _registerKnobs.manager.setChannel(channel);

    _registerKnobs.manager.setOptions(allOptions);

    channel.emit(_shared.SET_OPTIONS, allOptions);
    (0, _registerKnobs.registerKnobs)();
    return getStory(context);
  }
});
exports.withKnobs = withKnobs;

if (module && module.hot && module.hot.decline) {
  module.hot.decline();
}
}(dist$2, dist$2.exports));var common$1 = {
  black: '#000',
  white: '#fff'
};
var common$2 = common$1;var red = {
  50: '#ffebee',
  100: '#ffcdd2',
  200: '#ef9a9a',
  300: '#e57373',
  400: '#ef5350',
  500: '#f44336',
  600: '#e53935',
  700: '#d32f2f',
  800: '#c62828',
  900: '#b71c1c',
  A100: '#ff8a80',
  A200: '#ff5252',
  A400: '#ff1744',
  A700: '#d50000'
};
var red$1 = red;var pink = {
  50: '#fce4ec',
  100: '#f8bbd0',
  200: '#f48fb1',
  300: '#f06292',
  400: '#ec407a',
  500: '#e91e63',
  600: '#d81b60',
  700: '#c2185b',
  800: '#ad1457',
  900: '#880e4f',
  A100: '#ff80ab',
  A200: '#ff4081',
  A400: '#f50057',
  A700: '#c51162'
};
var pink$1 = pink;var indigo = {
  50: '#e8eaf6',
  100: '#c5cae9',
  200: '#9fa8da',
  300: '#7986cb',
  400: '#5c6bc0',
  500: '#3f51b5',
  600: '#3949ab',
  700: '#303f9f',
  800: '#283593',
  900: '#1a237e',
  A100: '#8c9eff',
  A200: '#536dfe',
  A400: '#3d5afe',
  A700: '#304ffe'
};
var indigo$1 = indigo;var blue = {
  50: '#e3f2fd',
  100: '#bbdefb',
  200: '#90caf9',
  300: '#64b5f6',
  400: '#42a5f5',
  500: '#2196f3',
  600: '#1e88e5',
  700: '#1976d2',
  800: '#1565c0',
  900: '#0d47a1',
  A100: '#82b1ff',
  A200: '#448aff',
  A400: '#2979ff',
  A700: '#2962ff'
};
var blue$1 = blue;var green = {
  50: '#e8f5e9',
  100: '#c8e6c9',
  200: '#a5d6a7',
  300: '#81c784',
  400: '#66bb6a',
  500: '#4caf50',
  600: '#43a047',
  700: '#388e3c',
  800: '#2e7d32',
  900: '#1b5e20',
  A100: '#b9f6ca',
  A200: '#69f0ae',
  A400: '#00e676',
  A700: '#00c853'
};
var green$1 = green;var orange = {
  50: '#fff3e0',
  100: '#ffe0b2',
  200: '#ffcc80',
  300: '#ffb74d',
  400: '#ffa726',
  500: '#ff9800',
  600: '#fb8c00',
  700: '#f57c00',
  800: '#ef6c00',
  900: '#e65100',
  A100: '#ffd180',
  A200: '#ffab40',
  A400: '#ff9100',
  A700: '#ff6d00'
};
var orange$1 = orange;var grey = {
  50: '#fafafa',
  100: '#f5f5f5',
  200: '#eeeeee',
  300: '#e0e0e0',
  400: '#bdbdbd',
  500: '#9e9e9e',
  600: '#757575',
  700: '#616161',
  800: '#424242',
  900: '#212121',
  A100: '#d5d5d5',
  A200: '#aaaaaa',
  A400: '#303030',
  A700: '#616161'
};
var grey$1 = grey;function _extends$f() {
  _extends$f = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$f.apply(this, arguments);
}function _typeof$2(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof$2 = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof$2 = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof$2(obj);
}function isPlainObject$3(item) {
  return item && _typeof$2(item) === 'object' && item.constructor === Object;
}
function deepmerge(target, source) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
    clone: true
  };
  var output = options.clone ? _extends$f({}, target) : target;

  if (isPlainObject$3(target) && isPlainObject$3(source)) {
    Object.keys(source).forEach(function (key) {
      // Avoid prototype pollution
      if (key === '__proto__') {
        return;
      }

      if (isPlainObject$3(source[key]) && key in target) {
        output[key] = deepmerge(target[key], source[key], options);
      } else {
        output[key] = source[key];
      }
    });
  }

  return output;
}function _defineProperty$3(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}/**
 * WARNING: Don't import this directly.
 * Use `MuiError` from `@material-ui/utils/macros/MuiError.macro` instead.
 * @param {number} code
 */
function formatMuiErrorMessage(code) {
  // Apply babel-plugin-transform-template-literals in loose mode
  // loose mode is safe iff we're concatenating primitives
  // see https://babeljs.io/docs/en/babel-plugin-transform-template-literals#loose

  /* eslint-disable prefer-template */
  var url = 'https://material-ui.com/production-error/?code=' + code;

  for (var i = 1; i < arguments.length; i += 1) {
    // rest params over-transpile for this case
    // eslint-disable-next-line prefer-rest-params
    url += '&args[]=' + encodeURIComponent(arguments[i]);
  }

  return 'Minified Material-UI error #' + code + '; visit ' + url + ' for the full message.';
  /* eslint-enable prefer-template */
}/* eslint-disable no-use-before-define */

/**
 * Returns a number whose value is limited to the given range.
 *
 * @param {number} value The value to be clamped
 * @param {number} min The lower boundary of the output range
 * @param {number} max The upper boundary of the output range
 * @returns {number} A number in the range [min, max]
 */
function clamp(value) {
  var min = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var max = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;

  return Math.min(Math.max(min, value), max);
}
/**
 * Converts a color from CSS hex format to CSS rgb format.
 *
 * @param {string} color - Hex color, i.e. #nnn or #nnnnnn
 * @returns {string} A CSS rgb color string
 */


function hexToRgb(color) {
  color = color.substr(1);
  var re = new RegExp(".{1,".concat(color.length >= 6 ? 2 : 1, "}"), 'g');
  var colors = color.match(re);

  if (colors && colors[0].length === 1) {
    colors = colors.map(function (n) {
      return n + n;
    });
  }

  return colors ? "rgb".concat(colors.length === 4 ? 'a' : '', "(").concat(colors.map(function (n, index) {
    return index < 3 ? parseInt(n, 16) : Math.round(parseInt(n, 16) / 255 * 1000) / 1000;
  }).join(', '), ")") : '';
}
/**
 * Converts a color from hsl format to rgb format.
 *
 * @param {string} color - HSL color values
 * @returns {string} rgb color values
 */

function hslToRgb(color) {
  color = decomposeColor(color);
  var _color = color,
      values = _color.values;
  var h = values[0];
  var s = values[1] / 100;
  var l = values[2] / 100;
  var a = s * Math.min(l, 1 - l);

  var f = function f(n) {
    var k = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (n + h / 30) % 12;
    return l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
  };

  var type = 'rgb';
  var rgb = [Math.round(f(0) * 255), Math.round(f(8) * 255), Math.round(f(4) * 255)];

  if (color.type === 'hsla') {
    type += 'a';
    rgb.push(values[3]);
  }

  return recomposeColor({
    type: type,
    values: rgb
  });
}
/**
 * Returns an object with the type and values of a color.
 *
 * Note: Does not support rgb % values.
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @returns {object} - A MUI color object: {type: string, values: number[]}
 */

function decomposeColor(color) {
  // Idempotent
  if (color.type) {
    return color;
  }

  if (color.charAt(0) === '#') {
    return decomposeColor(hexToRgb(color));
  }

  var marker = color.indexOf('(');
  var type = color.substring(0, marker);

  if (['rgb', 'rgba', 'hsl', 'hsla'].indexOf(type) === -1) {
    throw new Error(formatMuiErrorMessage(3, color));
  }

  var values = color.substring(marker + 1, color.length - 1).split(',');
  values = values.map(function (value) {
    return parseFloat(value);
  });
  return {
    type: type,
    values: values
  };
}
/**
 * Converts a color object with type and values to a string.
 *
 * @param {object} color - Decomposed color
 * @param {string} color.type - One of: 'rgb', 'rgba', 'hsl', 'hsla'
 * @param {array} color.values - [n,n,n] or [n,n,n,n]
 * @returns {string} A CSS color string
 */

function recomposeColor(color) {
  var type = color.type;
  var values = color.values;

  if (type.indexOf('rgb') !== -1) {
    // Only convert the first 3 values to int (i.e. not alpha)
    values = values.map(function (n, i) {
      return i < 3 ? parseInt(n, 10) : n;
    });
  } else if (type.indexOf('hsl') !== -1) {
    values[1] = "".concat(values[1], "%");
    values[2] = "".concat(values[2], "%");
  }

  return "".concat(type, "(").concat(values.join(', '), ")");
}
/**
 * Calculates the contrast ratio between two colors.
 *
 * Formula: https://www.w3.org/TR/WCAG20-TECHS/G17.html#G17-tests
 *
 * @param {string} foreground - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @param {string} background - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @returns {number} A contrast ratio value in the range 0 - 21.
 */

function getContrastRatio(foreground, background) {
  var lumA = getLuminance(foreground);
  var lumB = getLuminance(background);
  return (Math.max(lumA, lumB) + 0.05) / (Math.min(lumA, lumB) + 0.05);
}
/**
 * The relative brightness of any point in a color space,
 * normalized to 0 for darkest black and 1 for lightest white.
 *
 * Formula: https://www.w3.org/TR/WCAG20-TECHS/G17.html#G17-tests
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @returns {number} The relative brightness of the color in the range 0 - 1
 */

function getLuminance(color) {
  color = decomposeColor(color);
  var rgb = color.type === 'hsl' ? decomposeColor(hslToRgb(color)).values : color.values;
  rgb = rgb.map(function (val) {
    val /= 255; // normalized

    return val <= 0.03928 ? val / 12.92 : Math.pow((val + 0.055) / 1.055, 2.4);
  }); // Truncate at 3 digits

  return Number((0.2126 * rgb[0] + 0.7152 * rgb[1] + 0.0722 * rgb[2]).toFixed(3));
}
/**
 * Set the absolute transparency of a color.
 * Any existing alpha values are overwritten.
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @param {number} value - value to set the alpha channel to in the range 0 -1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 *
 * @deprecated
 * Use `import { alpha } from '@material-ui/core/styles'` instead.
 */

function fade(color, value) {

  return alpha$2(color, value);
}
/**
 * Set the absolute transparency of a color.
 * Any existing alpha value is overwritten.
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @param {number} value - value to set the alpha channel to in the range 0-1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */

function alpha$2(color, value) {
  color = decomposeColor(color);
  value = clamp(value);

  if (color.type === 'rgb' || color.type === 'hsl') {
    color.type += 'a';
  }

  color.values[3] = value;
  return recomposeColor(color);
}
/**
 * Darkens a color.
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @param {number} coefficient - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */

function darken(color, coefficient) {
  color = decomposeColor(color);
  coefficient = clamp(coefficient);

  if (color.type.indexOf('hsl') !== -1) {
    color.values[2] *= 1 - coefficient;
  } else if (color.type.indexOf('rgb') !== -1) {
    for (var i = 0; i < 3; i += 1) {
      color.values[i] *= 1 - coefficient;
    }
  }

  return recomposeColor(color);
}
/**
 * Lightens a color.
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @param {number} coefficient - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */

function lighten(color, coefficient) {
  color = decomposeColor(color);
  coefficient = clamp(coefficient);

  if (color.type.indexOf('hsl') !== -1) {
    color.values[2] += (100 - color.values[2]) * coefficient;
  } else if (color.type.indexOf('rgb') !== -1) {
    for (var i = 0; i < 3; i += 1) {
      color.values[i] += (255 - color.values[i]) * coefficient;
    }
  }

  return recomposeColor(color);
}function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}function _objectWithoutProperties$4(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}// Sorted ASC by size. That's important.
// It can't be configured as it's used statically for propTypes.
var keys$4 = ['xs', 'sm', 'md', 'lg', 'xl']; // Keep in mind that @media is inclusive by the CSS specification.

function createBreakpoints(breakpoints) {
  var _breakpoints$values = breakpoints.values,
      values = _breakpoints$values === void 0 ? {
    xs: 0,
    sm: 600,
    md: 960,
    lg: 1280,
    xl: 1920
  } : _breakpoints$values,
      _breakpoints$unit = breakpoints.unit,
      unit = _breakpoints$unit === void 0 ? 'px' : _breakpoints$unit,
      _breakpoints$step = breakpoints.step,
      step = _breakpoints$step === void 0 ? 5 : _breakpoints$step,
      other = _objectWithoutProperties$4(breakpoints, ["values", "unit", "step"]);

  function up(key) {
    var value = typeof values[key] === 'number' ? values[key] : key;
    return "@media (min-width:".concat(value).concat(unit, ")");
  }

  function down(key) {
    var endIndex = keys$4.indexOf(key) + 1;
    var upperbound = values[keys$4[endIndex]];

    if (endIndex === keys$4.length) {
      // xl down applies to all sizes
      return up('xs');
    }

    var value = typeof upperbound === 'number' && endIndex > 0 ? upperbound : key;
    return "@media (max-width:".concat(value - step / 100).concat(unit, ")");
  }

  function between(start, end) {
    var endIndex = keys$4.indexOf(end);

    if (endIndex === keys$4.length - 1) {
      return up(start);
    }

    return "@media (min-width:".concat(typeof values[start] === 'number' ? values[start] : start).concat(unit, ") and ") + "(max-width:".concat((endIndex !== -1 && typeof values[keys$4[endIndex + 1]] === 'number' ? values[keys$4[endIndex + 1]] : end) - step / 100).concat(unit, ")");
  }

  function only(key) {
    return between(key, key);
  }

  function width(key) {

    return values[key];
  }

  return _extends$f({
    keys: keys$4,
    values: values,
    up: up,
    down: down,
    between: between,
    only: only,
    width: width
  }, other);
}function createMixins(breakpoints, spacing, mixins) {
  var _toolbar;

  return _extends$f({
    gutters: function gutters() {
      var styles = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      console.warn(['Material-UI: theme.mixins.gutters() is deprecated.', 'You can use the source of the mixin directly:', "\n      paddingLeft: theme.spacing(2),\n      paddingRight: theme.spacing(2),\n      [theme.breakpoints.up('sm')]: {\n        paddingLeft: theme.spacing(3),\n        paddingRight: theme.spacing(3),\n      },\n      "].join('\n'));
      return _extends$f({
        paddingLeft: spacing(2),
        paddingRight: spacing(2)
      }, styles, _defineProperty$3({}, breakpoints.up('sm'), _extends$f({
        paddingLeft: spacing(3),
        paddingRight: spacing(3)
      }, styles[breakpoints.up('sm')])));
    },
    toolbar: (_toolbar = {
      minHeight: 56
    }, _defineProperty$3(_toolbar, "".concat(breakpoints.up('xs'), " and (orientation: landscape)"), {
      minHeight: 48
    }), _defineProperty$3(_toolbar, breakpoints.up('sm'), {
      minHeight: 64
    }), _toolbar)
  }, mixins);
}var light = {
  // The colors used to style the text.
  text: {
    // The most important text.
    primary: 'rgba(0, 0, 0, 0.87)',
    // Secondary text.
    secondary: 'rgba(0, 0, 0, 0.54)',
    // Disabled text have even lower visual prominence.
    disabled: 'rgba(0, 0, 0, 0.38)',
    // Text hints.
    hint: 'rgba(0, 0, 0, 0.38)'
  },
  // The color used to divide different elements.
  divider: 'rgba(0, 0, 0, 0.12)',
  // The background colors used to style the surfaces.
  // Consistency between these values is important.
  background: {
    paper: common$2.white,
    default: grey$1[50]
  },
  // The colors used to style the action elements.
  action: {
    // The color of an active action like an icon button.
    active: 'rgba(0, 0, 0, 0.54)',
    // The color of an hovered action.
    hover: 'rgba(0, 0, 0, 0.04)',
    hoverOpacity: 0.04,
    // The color of a selected action.
    selected: 'rgba(0, 0, 0, 0.08)',
    selectedOpacity: 0.08,
    // The color of a disabled action.
    disabled: 'rgba(0, 0, 0, 0.26)',
    // The background color of a disabled action.
    disabledBackground: 'rgba(0, 0, 0, 0.12)',
    disabledOpacity: 0.38,
    focus: 'rgba(0, 0, 0, 0.12)',
    focusOpacity: 0.12,
    activatedOpacity: 0.12
  }
};
var dark = {
  text: {
    primary: common$2.white,
    secondary: 'rgba(255, 255, 255, 0.7)',
    disabled: 'rgba(255, 255, 255, 0.5)',
    hint: 'rgba(255, 255, 255, 0.5)',
    icon: 'rgba(255, 255, 255, 0.5)'
  },
  divider: 'rgba(255, 255, 255, 0.12)',
  background: {
    paper: grey$1[800],
    default: '#303030'
  },
  action: {
    active: common$2.white,
    hover: 'rgba(255, 255, 255, 0.08)',
    hoverOpacity: 0.08,
    selected: 'rgba(255, 255, 255, 0.16)',
    selectedOpacity: 0.16,
    disabled: 'rgba(255, 255, 255, 0.3)',
    disabledBackground: 'rgba(255, 255, 255, 0.12)',
    disabledOpacity: 0.38,
    focus: 'rgba(255, 255, 255, 0.12)',
    focusOpacity: 0.12,
    activatedOpacity: 0.24
  }
};

function addLightOrDark(intent, direction, shade, tonalOffset) {
  var tonalOffsetLight = tonalOffset.light || tonalOffset;
  var tonalOffsetDark = tonalOffset.dark || tonalOffset * 1.5;

  if (!intent[direction]) {
    if (intent.hasOwnProperty(shade)) {
      intent[direction] = intent[shade];
    } else if (direction === 'light') {
      intent.light = lighten(intent.main, tonalOffsetLight);
    } else if (direction === 'dark') {
      intent.dark = darken(intent.main, tonalOffsetDark);
    }
  }
}

function createPalette(palette) {
  var _palette$primary = palette.primary,
      primary = _palette$primary === void 0 ? {
    light: indigo$1[300],
    main: indigo$1[500],
    dark: indigo$1[700]
  } : _palette$primary,
      _palette$secondary = palette.secondary,
      secondary = _palette$secondary === void 0 ? {
    light: pink$1.A200,
    main: pink$1.A400,
    dark: pink$1.A700
  } : _palette$secondary,
      _palette$error = palette.error,
      error = _palette$error === void 0 ? {
    light: red$1[300],
    main: red$1[500],
    dark: red$1[700]
  } : _palette$error,
      _palette$warning = palette.warning,
      warning = _palette$warning === void 0 ? {
    light: orange$1[300],
    main: orange$1[500],
    dark: orange$1[700]
  } : _palette$warning,
      _palette$info = palette.info,
      info = _palette$info === void 0 ? {
    light: blue$1[300],
    main: blue$1[500],
    dark: blue$1[700]
  } : _palette$info,
      _palette$success = palette.success,
      success = _palette$success === void 0 ? {
    light: green$1[300],
    main: green$1[500],
    dark: green$1[700]
  } : _palette$success,
      _palette$type = palette.type,
      type = _palette$type === void 0 ? 'light' : _palette$type,
      _palette$contrastThre = palette.contrastThreshold,
      contrastThreshold = _palette$contrastThre === void 0 ? 3 : _palette$contrastThre,
      _palette$tonalOffset = palette.tonalOffset,
      tonalOffset = _palette$tonalOffset === void 0 ? 0.2 : _palette$tonalOffset,
      other = _objectWithoutProperties$4(palette, ["primary", "secondary", "error", "warning", "info", "success", "type", "contrastThreshold", "tonalOffset"]); // Use the same logic as
  // Bootstrap: https://github.com/twbs/bootstrap/blob/1d6e3710dd447de1a200f29e8fa521f8a0908f70/scss/_functions.scss#L59
  // and material-components-web https://github.com/material-components/material-components-web/blob/ac46b8863c4dab9fc22c4c662dc6bd1b65dd652f/packages/mdc-theme/_functions.scss#L54


  function getContrastText(background) {
    var contrastText = getContrastRatio(background, dark.text.primary) >= contrastThreshold ? dark.text.primary : light.text.primary;

    return contrastText;
  }

  var augmentColor = function augmentColor(color) {
    var mainShade = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 500;
    var lightShade = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 300;
    var darkShade = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 700;
    color = _extends$f({}, color);

    if (!color.main && color[mainShade]) {
      color.main = color[mainShade];
    }

    if (!color.main) {
      throw new Error(formatMuiErrorMessage(4, mainShade));
    }

    if (typeof color.main !== 'string') {
      throw new Error(formatMuiErrorMessage(5, JSON.stringify(color.main)));
    }

    addLightOrDark(color, 'light', lightShade, tonalOffset);
    addLightOrDark(color, 'dark', darkShade, tonalOffset);

    if (!color.contrastText) {
      color.contrastText = getContrastText(color.main);
    }

    return color;
  };

  var types = {
    dark: dark,
    light: light
  };

  var paletteOutput = deepmerge(_extends$f({
    // A collection of common colors.
    common: common$2,
    // The palette type, can be light or dark.
    type: type,
    // The colors used to represent primary interface elements for a user.
    primary: augmentColor(primary),
    // The colors used to represent secondary interface elements for a user.
    secondary: augmentColor(secondary, 'A400', 'A200', 'A700'),
    // The colors used to represent interface elements that the user should be made aware of.
    error: augmentColor(error),
    // The colors used to represent potentially dangerous actions or important messages.
    warning: augmentColor(warning),
    // The colors used to present information to the user that is neutral and not necessarily important.
    info: augmentColor(info),
    // The colors used to indicate the successful completion of an action that user triggered.
    success: augmentColor(success),
    // The grey colors.
    grey: grey$1,
    // Used by `getContrastText()` to maximize the contrast between
    // the background and the text.
    contrastThreshold: contrastThreshold,
    // Takes a background color and returns the text color that maximizes the contrast.
    getContrastText: getContrastText,
    // Generate a rich color object.
    augmentColor: augmentColor,
    // Used by the functions below to shift a color's luminance by approximately
    // two indexes within its tonal palette.
    // E.g., shift from Red 500 to Red 300 or Red 700.
    tonalOffset: tonalOffset
  }, types[type]), other);
  return paletteOutput;
}function round$2(value) {
  return Math.round(value * 1e5) / 1e5;
}

function roundWithDeprecationWarning(value) {

  return round$2(value);
}

var caseAllCaps = {
  textTransform: 'uppercase'
};
var defaultFontFamily = '"Roboto", "Helvetica", "Arial", sans-serif';
/**
 * @see @link{https://material.io/design/typography/the-type-system.html}
 * @see @link{https://material.io/design/typography/understanding-typography.html}
 */

function createTypography(palette, typography) {
  var _ref = typeof typography === 'function' ? typography(palette) : typography,
      _ref$fontFamily = _ref.fontFamily,
      fontFamily = _ref$fontFamily === void 0 ? defaultFontFamily : _ref$fontFamily,
      _ref$fontSize = _ref.fontSize,
      fontSize = _ref$fontSize === void 0 ? 14 : _ref$fontSize,
      _ref$fontWeightLight = _ref.fontWeightLight,
      fontWeightLight = _ref$fontWeightLight === void 0 ? 300 : _ref$fontWeightLight,
      _ref$fontWeightRegula = _ref.fontWeightRegular,
      fontWeightRegular = _ref$fontWeightRegula === void 0 ? 400 : _ref$fontWeightRegula,
      _ref$fontWeightMedium = _ref.fontWeightMedium,
      fontWeightMedium = _ref$fontWeightMedium === void 0 ? 500 : _ref$fontWeightMedium,
      _ref$fontWeightBold = _ref.fontWeightBold,
      fontWeightBold = _ref$fontWeightBold === void 0 ? 700 : _ref$fontWeightBold,
      _ref$htmlFontSize = _ref.htmlFontSize,
      htmlFontSize = _ref$htmlFontSize === void 0 ? 16 : _ref$htmlFontSize,
      allVariants = _ref.allVariants,
      pxToRem2 = _ref.pxToRem,
      other = _objectWithoutProperties$4(_ref, ["fontFamily", "fontSize", "fontWeightLight", "fontWeightRegular", "fontWeightMedium", "fontWeightBold", "htmlFontSize", "allVariants", "pxToRem"]);

  var coef = fontSize / 14;

  var pxToRem = pxToRem2 || function (size) {
    return "".concat(size / htmlFontSize * coef, "rem");
  };

  var buildVariant = function buildVariant(fontWeight, size, lineHeight, letterSpacing, casing) {
    return _extends$f({
      fontFamily: fontFamily,
      fontWeight: fontWeight,
      fontSize: pxToRem(size),
      // Unitless following https://meyerweb.com/eric/thoughts/2006/02/08/unitless-line-heights/
      lineHeight: lineHeight
    }, fontFamily === defaultFontFamily ? {
      letterSpacing: "".concat(round$2(letterSpacing / size), "em")
    } : {}, casing, allVariants);
  };

  var variants = {
    h1: buildVariant(fontWeightLight, 96, 1.167, -1.5),
    h2: buildVariant(fontWeightLight, 60, 1.2, -0.5),
    h3: buildVariant(fontWeightRegular, 48, 1.167, 0),
    h4: buildVariant(fontWeightRegular, 34, 1.235, 0.25),
    h5: buildVariant(fontWeightRegular, 24, 1.334, 0),
    h6: buildVariant(fontWeightMedium, 20, 1.6, 0.15),
    subtitle1: buildVariant(fontWeightRegular, 16, 1.75, 0.15),
    subtitle2: buildVariant(fontWeightMedium, 14, 1.57, 0.1),
    body1: buildVariant(fontWeightRegular, 16, 1.5, 0.15),
    body2: buildVariant(fontWeightRegular, 14, 1.43, 0.15),
    button: buildVariant(fontWeightMedium, 14, 1.75, 0.4, caseAllCaps),
    caption: buildVariant(fontWeightRegular, 12, 1.66, 0.4),
    overline: buildVariant(fontWeightRegular, 12, 2.66, 1, caseAllCaps)
  };
  return deepmerge(_extends$f({
    htmlFontSize: htmlFontSize,
    pxToRem: pxToRem,
    round: roundWithDeprecationWarning,
    // TODO v5: remove
    fontFamily: fontFamily,
    fontSize: fontSize,
    fontWeightLight: fontWeightLight,
    fontWeightRegular: fontWeightRegular,
    fontWeightMedium: fontWeightMedium,
    fontWeightBold: fontWeightBold
  }, variants), other, {
    clone: false // No need to clone deep

  });
}var shadowKeyUmbraOpacity = 0.2;
var shadowKeyPenumbraOpacity = 0.14;
var shadowAmbientShadowOpacity = 0.12;

function createShadow() {
  return ["".concat(arguments.length <= 0 ? undefined : arguments[0], "px ").concat(arguments.length <= 1 ? undefined : arguments[1], "px ").concat(arguments.length <= 2 ? undefined : arguments[2], "px ").concat(arguments.length <= 3 ? undefined : arguments[3], "px rgba(0,0,0,").concat(shadowKeyUmbraOpacity, ")"), "".concat(arguments.length <= 4 ? undefined : arguments[4], "px ").concat(arguments.length <= 5 ? undefined : arguments[5], "px ").concat(arguments.length <= 6 ? undefined : arguments[6], "px ").concat(arguments.length <= 7 ? undefined : arguments[7], "px rgba(0,0,0,").concat(shadowKeyPenumbraOpacity, ")"), "".concat(arguments.length <= 8 ? undefined : arguments[8], "px ").concat(arguments.length <= 9 ? undefined : arguments[9], "px ").concat(arguments.length <= 10 ? undefined : arguments[10], "px ").concat(arguments.length <= 11 ? undefined : arguments[11], "px rgba(0,0,0,").concat(shadowAmbientShadowOpacity, ")")].join(',');
} // Values from https://github.com/material-components/material-components-web/blob/be8747f94574669cb5e7add1a7c54fa41a89cec7/packages/mdc-elevation/_variables.scss


var shadows = ['none', createShadow(0, 2, 1, -1, 0, 1, 1, 0, 0, 1, 3, 0), createShadow(0, 3, 1, -2, 0, 2, 2, 0, 0, 1, 5, 0), createShadow(0, 3, 3, -2, 0, 3, 4, 0, 0, 1, 8, 0), createShadow(0, 2, 4, -1, 0, 4, 5, 0, 0, 1, 10, 0), createShadow(0, 3, 5, -1, 0, 5, 8, 0, 0, 1, 14, 0), createShadow(0, 3, 5, -1, 0, 6, 10, 0, 0, 1, 18, 0), createShadow(0, 4, 5, -2, 0, 7, 10, 1, 0, 2, 16, 1), createShadow(0, 5, 5, -3, 0, 8, 10, 1, 0, 3, 14, 2), createShadow(0, 5, 6, -3, 0, 9, 12, 1, 0, 3, 16, 2), createShadow(0, 6, 6, -3, 0, 10, 14, 1, 0, 4, 18, 3), createShadow(0, 6, 7, -4, 0, 11, 15, 1, 0, 4, 20, 3), createShadow(0, 7, 8, -4, 0, 12, 17, 2, 0, 5, 22, 4), createShadow(0, 7, 8, -4, 0, 13, 19, 2, 0, 5, 24, 4), createShadow(0, 7, 9, -4, 0, 14, 21, 2, 0, 5, 26, 4), createShadow(0, 8, 9, -5, 0, 15, 22, 2, 0, 6, 28, 5), createShadow(0, 8, 10, -5, 0, 16, 24, 2, 0, 6, 30, 5), createShadow(0, 8, 11, -5, 0, 17, 26, 2, 0, 6, 32, 5), createShadow(0, 9, 11, -5, 0, 18, 28, 2, 0, 7, 34, 6), createShadow(0, 9, 12, -6, 0, 19, 29, 2, 0, 7, 36, 6), createShadow(0, 10, 13, -6, 0, 20, 31, 3, 0, 8, 38, 7), createShadow(0, 10, 13, -6, 0, 21, 33, 3, 0, 8, 40, 7), createShadow(0, 10, 14, -6, 0, 22, 35, 3, 0, 8, 42, 7), createShadow(0, 11, 14, -7, 0, 23, 36, 3, 0, 9, 44, 8), createShadow(0, 11, 15, -7, 0, 24, 38, 3, 0, 9, 46, 8)];
var shadows$1 = shadows;var shape = {
  borderRadius: 4
};
var shape$1 = shape;function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}function createUnarySpacing(theme) {
  var themeSpacing = theme.spacing || 8;

  if (typeof themeSpacing === 'number') {
    return function (abs) {

      return themeSpacing * abs;
    };
  }

  if (Array.isArray(themeSpacing)) {
    return function (abs) {

      return themeSpacing[abs];
    };
  }

  if (typeof themeSpacing === 'function') {
    return themeSpacing;
  }

  return function () {
    return undefined;
  };
}function createSpacing() {
  var spacingInput = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 8;

  // Already transformed.
  if (spacingInput.mui) {
    return spacingInput;
  } // Material Design layouts are visually balanced. Most measurements align to an 8dp grid applied, which aligns both spacing and the overall layout.
  // Smaller components, such as icons and type, can align to a 4dp grid.
  // https://material.io/design/layout/understanding-layout.html#usage


  var transform = createUnarySpacing({
    spacing: spacingInput
  });

  var spacing = function spacing() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    if (args.length === 0) {
      return transform(1);
    }

    if (args.length === 1) {
      return transform(args[0]);
    }

    return args.map(function (argument) {
      if (typeof argument === 'string') {
        return argument;
      }

      var output = transform(argument);
      return typeof output === 'number' ? "".concat(output, "px") : output;
    }).join(' ');
  }; // Backward compatibility, to remove in v5.


  Object.defineProperty(spacing, 'unit', {
    get: function get() {

      return spacingInput;
    }
  });
  spacing.mui = true;
  return spacing;
}// Follow https://material.google.com/motion/duration-easing.html#duration-easing-natural-easing-curves
// to learn the context in which each easing should be used.
var easing = {
  // This is the most common easing curve.
  easeInOut: 'cubic-bezier(0.4, 0, 0.2, 1)',
  // Objects enter the screen at full velocity from off-screen and
  // slowly decelerate to a resting point.
  easeOut: 'cubic-bezier(0.0, 0, 0.2, 1)',
  // Objects leave the screen at full velocity. They do not decelerate when off-screen.
  easeIn: 'cubic-bezier(0.4, 0, 1, 1)',
  // The sharp curve is used by objects that may return to the screen at any time.
  sharp: 'cubic-bezier(0.4, 0, 0.6, 1)'
}; // Follow https://material.io/guidelines/motion/duration-easing.html#duration-easing-common-durations
// to learn when use what timing

var duration = {
  shortest: 150,
  shorter: 200,
  short: 250,
  // most basic recommended timing
  standard: 300,
  // this is to be used in complex animations
  complex: 375,
  // recommended when something is entering screen
  enteringScreen: 225,
  // recommended when something is leaving screen
  leavingScreen: 195
};

function formatMs(milliseconds) {
  return "".concat(Math.round(milliseconds), "ms");
}
/**
 * @param {string|Array} props
 * @param {object} param
 * @param {string} param.prop
 * @param {number} param.duration
 * @param {string} param.easing
 * @param {number} param.delay
 */


var transitions = {
  easing: easing,
  duration: duration,
  create: function create() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ['all'];
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var _options$duration = options.duration,
        durationOption = _options$duration === void 0 ? duration.standard : _options$duration,
        _options$easing = options.easing,
        easingOption = _options$easing === void 0 ? easing.easeInOut : _options$easing,
        _options$delay = options.delay,
        delay = _options$delay === void 0 ? 0 : _options$delay;
        _objectWithoutProperties$4(options, ["duration", "easing", "delay"]);

    return (Array.isArray(props) ? props : [props]).map(function (animatedProp) {
      return "".concat(animatedProp, " ").concat(typeof durationOption === 'string' ? durationOption : formatMs(durationOption), " ").concat(easingOption, " ").concat(typeof delay === 'string' ? delay : formatMs(delay));
    }).join(',');
  },
  getAutoHeightDuration: function getAutoHeightDuration(height) {
    if (!height) {
      return 0;
    }

    var constant = height / 36; // https://www.wolframalpha.com/input/?i=(4+%2B+15+*+(x+%2F+36+)+**+0.25+%2B+(x+%2F+36)+%2F+5)+*+10

    return Math.round((4 + 15 * Math.pow(constant, 0.25) + constant / 5) * 10);
  }
};// We need to centralize the zIndex definitions as they work
// like global values in the browser.
var zIndex$1 = {
  mobileStepper: 1000,
  speedDial: 1050,
  appBar: 1100,
  drawer: 1200,
  modal: 1300,
  snackbar: 1400,
  tooltip: 1500
};
var zIndex$2 = zIndex$1;function createTheme() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var _options$breakpoints = options.breakpoints,
      breakpointsInput = _options$breakpoints === void 0 ? {} : _options$breakpoints,
      _options$mixins = options.mixins,
      mixinsInput = _options$mixins === void 0 ? {} : _options$mixins,
      _options$palette = options.palette,
      paletteInput = _options$palette === void 0 ? {} : _options$palette,
      spacingInput = options.spacing,
      _options$typography = options.typography,
      typographyInput = _options$typography === void 0 ? {} : _options$typography,
      other = _objectWithoutProperties$4(options, ["breakpoints", "mixins", "palette", "spacing", "typography"]);

  var palette = createPalette(paletteInput);
  var breakpoints = createBreakpoints(breakpointsInput);
  var spacing = createSpacing(spacingInput);
  var muiTheme = deepmerge({
    breakpoints: breakpoints,
    direction: 'ltr',
    mixins: createMixins(breakpoints, spacing, mixinsInput),
    overrides: {},
    // Inject custom styles
    palette: palette,
    props: {},
    // Provide default props
    shadows: shadows$1,
    typography: createTypography(palette, typographyInput),
    spacing: spacing,
    shape: shape$1,
    transitions: transitions,
    zIndex: zIndex$2
  }, other);

  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }

  muiTheme = args.reduce(function (acc, argument) {
    return deepmerge(acc, argument);
  }, muiTheme);

  return muiTheme;
}var hasSymbol = typeof Symbol === 'function' && Symbol.for;
var nested = hasSymbol ? Symbol.for('mui.nested') : '__THEME_NESTED__';/**
 * This is the list of the style rule name we use as drop in replacement for the built-in
 * pseudo classes (:checked, :disabled, :focused, etc.).
 *
 * Why do they exist in the first place?
 * These classes are used at a specificity of 2.
 * It allows them to override previously definied styles as well as
 * being untouched by simple user overrides.
 */

var pseudoClasses = ['checked', 'disabled', 'error', 'focused', 'focusVisible', 'required', 'expanded', 'selected']; // Returns a function which generates unique class names based on counters.
// When new generator function is created, rule counter is reset.
// We need to reset the rule counter for SSR for each request.
//
// It's inspired by
// https://github.com/cssinjs/jss/blob/4e6a05dd3f7b6572fdd3ab216861d9e446c20331/src/utils/createGenerateClassName.js

function createGenerateClassName() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _options$disableGloba = options.disableGlobal,
      disableGlobal = _options$disableGloba === void 0 ? false : _options$disableGloba,
      _options$productionPr = options.productionPrefix,
      productionPrefix = _options$productionPr === void 0 ? 'jss' : _options$productionPr,
      _options$seed = options.seed,
      seed = _options$seed === void 0 ? '' : _options$seed;
  var seedPrefix = seed === '' ? '' : "".concat(seed, "-");
  var ruleCounter = 0;

  var getNextCounterId = function getNextCounterId() {
    ruleCounter += 1;

    return ruleCounter;
  };

  return function (rule, styleSheet) {
    var name = styleSheet.options.name; // Is a global static MUI style?

    if (name && name.indexOf('Mui') === 0 && !styleSheet.options.link && !disableGlobal) {
      // We can use a shorthand class name, we never use the keys to style the components.
      if (pseudoClasses.indexOf(rule.key) !== -1) {
        return "Mui-".concat(rule.key);
      }

      var prefix = "".concat(seedPrefix).concat(name, "-").concat(rule.key);

      if (!styleSheet.options.theme[nested] || seed !== '') {
        return prefix;
      }

      return "".concat(prefix, "-").concat(getNextCounterId());
    }

    {
      return "".concat(seedPrefix).concat(productionPrefix).concat(getNextCounterId());
    }
  };
}function createStyles$1(styles) {
  return styles;
}/* eslint-disable no-restricted-syntax */
function getThemeProps(params) {
  var theme = params.theme,
      name = params.name,
      props = params.props;

  if (!theme || !theme.props || !theme.props[name]) {
    return props;
  } // Resolve default props, code borrow from React source.
  // https://github.com/facebook/react/blob/15a8f031838a553e41c0b66eb1bcf1da8448104d/packages/react/src/ReactElement.js#L221


  var defaultProps = theme.props[name];
  var propName;

  for (propName in defaultProps) {
    if (props[propName] === undefined) {
      props[propName] = defaultProps[propName];
    }
  }

  return props;
}var _typeof$1 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var isBrowser$2 = (typeof window === "undefined" ? "undefined" : _typeof$1(window)) === "object" && (typeof document === "undefined" ? "undefined" : _typeof$1(document)) === 'object' && document.nodeType === 9;function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass$b(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  _setPrototypeOf(subClass, superClass);
}function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}var plainObjectConstrurctor = {}.constructor;
function cloneStyle(style) {
  if (style == null || typeof style !== 'object') return style;
  if (Array.isArray(style)) return style.map(cloneStyle);
  if (style.constructor !== plainObjectConstrurctor) return style;
  var newStyle = {};

  for (var name in style) {
    newStyle[name] = cloneStyle(style[name]);
  }

  return newStyle;
}

/**
 * Create a rule instance.
 */

function createRule(name, decl, options) {
  if (name === void 0) {
    name = 'unnamed';
  }

  var jss = options.jss;
  var declCopy = cloneStyle(decl);
  var rule = jss.plugins.onCreateRule(name, declCopy, options);
  if (rule) return rule; // It is an at-rule and it has no instance.

  if (name[0] === '@') ;

  return null;
}

var join = function join(value, by) {
  var result = '';

  for (var i = 0; i < value.length; i++) {
    // Remove !important from the value, it will be readded later.
    if (value[i] === '!important') break;
    if (result) result += by;
    result += value[i];
  }

  return result;
};

/**
 * Converts array values to string.
 *
 * `margin: [['5px', '10px']]` > `margin: 5px 10px;`
 * `border: ['1px', '2px']` > `border: 1px, 2px;`
 * `margin: [['5px', '10px'], '!important']` > `margin: 5px 10px !important;`
 * `color: ['red', !important]` > `color: red !important;`
 */
var toCssValue = function toCssValue(value, ignoreImportant) {
  if (ignoreImportant === void 0) {
    ignoreImportant = false;
  }

  if (!Array.isArray(value)) return value;
  var cssValue = ''; // Support space separated values via `[['5px', '10px']]`.

  if (Array.isArray(value[0])) {
    for (var i = 0; i < value.length; i++) {
      if (value[i] === '!important') break;
      if (cssValue) cssValue += ', ';
      cssValue += join(value[i], ' ');
    }
  } else cssValue = join(value, ', '); // Add !important, because it was ignored.


  if (!ignoreImportant && value[value.length - 1] === '!important') {
    cssValue += ' !important';
  }

  return cssValue;
};

/**
 * Indent a string.
 * http://jsperf.com/array-join-vs-for
 */
function indentStr(str, indent) {
  var result = '';

  for (var index = 0; index < indent; index++) {
    result += '  ';
  }

  return result + str;
}
/**
 * Converts a Rule to CSS string.
 */


function toCss(selector, style, options) {
  if (options === void 0) {
    options = {};
  }

  var result = '';
  if (!style) return result;
  var _options = options,
      _options$indent = _options.indent,
      indent = _options$indent === void 0 ? 0 : _options$indent;
  var fallbacks = style.fallbacks;
  if (selector) indent++; // Apply fallbacks first.

  if (fallbacks) {
    // Array syntax {fallbacks: [{prop: value}]}
    if (Array.isArray(fallbacks)) {
      for (var index = 0; index < fallbacks.length; index++) {
        var fallback = fallbacks[index];

        for (var prop in fallback) {
          var value = fallback[prop];

          if (value != null) {
            if (result) result += '\n';
            result += indentStr(prop + ": " + toCssValue(value) + ";", indent);
          }
        }
      }
    } else {
      // Object syntax {fallbacks: {prop: value}}
      for (var _prop in fallbacks) {
        var _value = fallbacks[_prop];

        if (_value != null) {
          if (result) result += '\n';
          result += indentStr(_prop + ": " + toCssValue(_value) + ";", indent);
        }
      }
    }
  }

  for (var _prop2 in style) {
    var _value2 = style[_prop2];

    if (_value2 != null && _prop2 !== 'fallbacks') {
      if (result) result += '\n';
      result += indentStr(_prop2 + ": " + toCssValue(_value2) + ";", indent);
    }
  } // Allow empty style in this case, because properties will be added dynamically.


  if (!result && !options.allowEmpty) return result; // When rule is being stringified before selector was defined.

  if (!selector) return result;
  indent--;
  if (result) result = "\n" + result + "\n";
  return indentStr(selector + " {" + result, indent) + indentStr('}', indent);
}

var escapeRegex = /([[\].#*$><+~=|^:(),"'`\s])/g;
var nativeEscape = typeof CSS !== 'undefined' && CSS.escape;
var escape$1 = (function (str) {
  return nativeEscape ? nativeEscape(str) : str.replace(escapeRegex, '\\$1');
});

var BaseStyleRule =
/*#__PURE__*/
function () {
  function BaseStyleRule(key, style, options) {
    this.type = 'style';
    this.key = void 0;
    this.isProcessed = false;
    this.style = void 0;
    this.renderer = void 0;
    this.renderable = void 0;
    this.options = void 0;
    var sheet = options.sheet,
        Renderer = options.Renderer;
    this.key = key;
    this.options = options;
    this.style = style;
    if (sheet) this.renderer = sheet.renderer;else if (Renderer) this.renderer = new Renderer();
  }
  /**
   * Get or set a style property.
   */


  var _proto = BaseStyleRule.prototype;

  _proto.prop = function prop(name, value, options) {
    // It's a getter.
    if (value === undefined) return this.style[name]; // Don't do anything if the value has not changed.

    var force = options ? options.force : false;
    if (!force && this.style[name] === value) return this;
    var newValue = value;

    if (!options || options.process !== false) {
      newValue = this.options.jss.plugins.onChangeValue(value, name, this);
    }

    var isEmpty = newValue == null || newValue === false;
    var isDefined = name in this.style; // Value is empty and wasn't defined before.

    if (isEmpty && !isDefined && !force) return this; // We are going to remove this value.

    var remove = isEmpty && isDefined;
    if (remove) delete this.style[name];else this.style[name] = newValue; // Renderable is defined if StyleSheet option `link` is true.

    if (this.renderable && this.renderer) {
      if (remove) this.renderer.removeProperty(this.renderable, name);else this.renderer.setProperty(this.renderable, name, newValue);
      return this;
    }

    var sheet = this.options.sheet;

    if (sheet && sheet.attached) ;

    return this;
  };

  return BaseStyleRule;
}();
var StyleRule =
/*#__PURE__*/
function (_BaseStyleRule) {
  _inheritsLoose(StyleRule, _BaseStyleRule);

  function StyleRule(key, style, options) {
    var _this;

    _this = _BaseStyleRule.call(this, key, style, options) || this;
    _this.selectorText = void 0;
    _this.id = void 0;
    _this.renderable = void 0;
    var selector = options.selector,
        scoped = options.scoped,
        sheet = options.sheet,
        generateId = options.generateId;

    if (selector) {
      _this.selectorText = selector;
    } else if (scoped !== false) {
      _this.id = generateId(_assertThisInitialized(_assertThisInitialized(_this)), sheet);
      _this.selectorText = "." + escape$1(_this.id);
    }

    return _this;
  }
  /**
   * Set selector string.
   * Attention: use this with caution. Most browsers didn't implement
   * selectorText setter, so this may result in rerendering of entire Style Sheet.
   */


  var _proto2 = StyleRule.prototype;

  /**
   * Apply rule to an element inline.
   */
  _proto2.applyTo = function applyTo(renderable) {
    var renderer = this.renderer;

    if (renderer) {
      var json = this.toJSON();

      for (var prop in json) {
        renderer.setProperty(renderable, prop, json[prop]);
      }
    }

    return this;
  }
  /**
   * Returns JSON representation of the rule.
   * Fallbacks are not supported.
   * Useful for inline styles.
   */
  ;

  _proto2.toJSON = function toJSON() {
    var json = {};

    for (var prop in this.style) {
      var value = this.style[prop];
      if (typeof value !== 'object') json[prop] = value;else if (Array.isArray(value)) json[prop] = toCssValue(value);
    }

    return json;
  }
  /**
   * Generates a CSS string.
   */
  ;

  _proto2.toString = function toString(options) {
    var sheet = this.options.sheet;
    var link = sheet ? sheet.options.link : false;
    var opts = link ? _extends$f({}, options, {
      allowEmpty: true
    }) : options;
    return toCss(this.selectorText, this.style, opts);
  };

  _createClass$b(StyleRule, [{
    key: "selector",
    set: function set(selector) {
      if (selector === this.selectorText) return;
      this.selectorText = selector;
      var renderer = this.renderer,
          renderable = this.renderable;
      if (!renderable || !renderer) return;
      var hasChanged = renderer.setSelector(renderable, selector); // If selector setter is not implemented, rerender the rule.

      if (!hasChanged) {
        renderer.replaceRule(renderable, this);
      }
    }
    /**
     * Get selector string.
     */
    ,
    get: function get() {
      return this.selectorText;
    }
  }]);

  return StyleRule;
}(BaseStyleRule);
var pluginStyleRule = {
  onCreateRule: function onCreateRule(name, style, options) {
    if (name[0] === '@' || options.parent && options.parent.type === 'keyframes') {
      return null;
    }

    return new StyleRule(name, style, options);
  }
};

var defaultToStringOptions = {
  indent: 1,
  children: true
};
var atRegExp = /@([\w-]+)/;
/**
 * Conditional rule for @media, @supports
 */

var ConditionalRule =
/*#__PURE__*/
function () {
  function ConditionalRule(key, styles, options) {
    this.type = 'conditional';
    this.at = void 0;
    this.key = void 0;
    this.query = void 0;
    this.rules = void 0;
    this.options = void 0;
    this.isProcessed = false;
    this.renderable = void 0;
    this.key = key;
    var atMatch = key.match(atRegExp);
    this.at = atMatch ? atMatch[1] : 'unknown'; // Key might contain a unique suffix in case the `name` passed by user was duplicate.

    this.query = options.name || "@" + this.at;
    this.options = options;
    this.rules = new RuleList(_extends$f({}, options, {
      parent: this
    }));

    for (var name in styles) {
      this.rules.add(name, styles[name]);
    }

    this.rules.process();
  }
  /**
   * Get a rule.
   */


  var _proto = ConditionalRule.prototype;

  _proto.getRule = function getRule(name) {
    return this.rules.get(name);
  }
  /**
   * Get index of a rule.
   */
  ;

  _proto.indexOf = function indexOf(rule) {
    return this.rules.indexOf(rule);
  }
  /**
   * Create and register rule, run plugins.
   */
  ;

  _proto.addRule = function addRule(name, style, options) {
    var rule = this.rules.add(name, style, options);
    if (!rule) return null;
    this.options.jss.plugins.onProcessRule(rule);
    return rule;
  }
  /**
   * Generates a CSS string.
   */
  ;

  _proto.toString = function toString(options) {
    if (options === void 0) {
      options = defaultToStringOptions;
    }

    if (options.indent == null) options.indent = defaultToStringOptions.indent;
    if (options.children == null) options.children = defaultToStringOptions.children;

    if (options.children === false) {
      return this.query + " {}";
    }

    var children = this.rules.toString(options);
    return children ? this.query + " {\n" + children + "\n}" : '';
  };

  return ConditionalRule;
}();
var keyRegExp = /@media|@supports\s+/;
var pluginConditionalRule = {
  onCreateRule: function onCreateRule(key, styles, options) {
    return keyRegExp.test(key) ? new ConditionalRule(key, styles, options) : null;
  }
};

var defaultToStringOptions$1 = {
  indent: 1,
  children: true
};
var nameRegExp = /@keyframes\s+([\w-]+)/;
/**
 * Rule for @keyframes
 */

var KeyframesRule =
/*#__PURE__*/
function () {
  function KeyframesRule(key, frames, options) {
    this.type = 'keyframes';
    this.at = '@keyframes';
    this.key = void 0;
    this.name = void 0;
    this.id = void 0;
    this.rules = void 0;
    this.options = void 0;
    this.isProcessed = false;
    this.renderable = void 0;
    var nameMatch = key.match(nameRegExp);

    if (nameMatch && nameMatch[1]) {
      this.name = nameMatch[1];
    } else {
      this.name = 'noname';
    }

    this.key = this.type + "-" + this.name;
    this.options = options;
    var scoped = options.scoped,
        sheet = options.sheet,
        generateId = options.generateId;
    this.id = scoped === false ? this.name : escape$1(generateId(this, sheet));
    this.rules = new RuleList(_extends$f({}, options, {
      parent: this
    }));

    for (var name in frames) {
      this.rules.add(name, frames[name], _extends$f({}, options, {
        parent: this
      }));
    }

    this.rules.process();
  }
  /**
   * Generates a CSS string.
   */


  var _proto = KeyframesRule.prototype;

  _proto.toString = function toString(options) {
    if (options === void 0) {
      options = defaultToStringOptions$1;
    }

    if (options.indent == null) options.indent = defaultToStringOptions$1.indent;
    if (options.children == null) options.children = defaultToStringOptions$1.children;

    if (options.children === false) {
      return this.at + " " + this.id + " {}";
    }

    var children = this.rules.toString(options);
    if (children) children = "\n" + children + "\n";
    return this.at + " " + this.id + " {" + children + "}";
  };

  return KeyframesRule;
}();
var keyRegExp$1 = /@keyframes\s+/;
var refRegExp$1 = /\$([\w-]+)/g;

var findReferencedKeyframe = function findReferencedKeyframe(val, keyframes) {
  if (typeof val === 'string') {
    return val.replace(refRegExp$1, function (match, name) {
      if (name in keyframes) {
        return keyframes[name];
      }
      return match;
    });
  }

  return val;
};
/**
 * Replace the reference for a animation name.
 */


var replaceRef = function replaceRef(style, prop, keyframes) {
  var value = style[prop];
  var refKeyframe = findReferencedKeyframe(value, keyframes);

  if (refKeyframe !== value) {
    style[prop] = refKeyframe;
  }
};

var plugin = {
  onCreateRule: function onCreateRule(key, frames, options) {
    return typeof key === 'string' && keyRegExp$1.test(key) ? new KeyframesRule(key, frames, options) : null;
  },
  // Animation name ref replacer.
  onProcessStyle: function onProcessStyle(style, rule, sheet) {
    if (rule.type !== 'style' || !sheet) return style;
    if ('animation-name' in style) replaceRef(style, 'animation-name', sheet.keyframes);
    if ('animation' in style) replaceRef(style, 'animation', sheet.keyframes);
    return style;
  },
  onChangeValue: function onChangeValue(val, prop, rule) {
    var sheet = rule.options.sheet;

    if (!sheet) {
      return val;
    }

    switch (prop) {
      case 'animation':
        return findReferencedKeyframe(val, sheet.keyframes);

      case 'animation-name':
        return findReferencedKeyframe(val, sheet.keyframes);

      default:
        return val;
    }
  }
};

var KeyframeRule =
/*#__PURE__*/
function (_BaseStyleRule) {
  _inheritsLoose(KeyframeRule, _BaseStyleRule);

  function KeyframeRule() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _BaseStyleRule.call.apply(_BaseStyleRule, [this].concat(args)) || this;
    _this.renderable = void 0;
    return _this;
  }

  var _proto = KeyframeRule.prototype;

  /**
   * Generates a CSS string.
   */
  _proto.toString = function toString(options) {
    var sheet = this.options.sheet;
    var link = sheet ? sheet.options.link : false;
    var opts = link ? _extends$f({}, options, {
      allowEmpty: true
    }) : options;
    return toCss(this.key, this.style, opts);
  };

  return KeyframeRule;
}(BaseStyleRule);
var pluginKeyframeRule = {
  onCreateRule: function onCreateRule(key, style, options) {
    if (options.parent && options.parent.type === 'keyframes') {
      return new KeyframeRule(key, style, options);
    }

    return null;
  }
};

var FontFaceRule =
/*#__PURE__*/
function () {
  function FontFaceRule(key, style, options) {
    this.type = 'font-face';
    this.at = '@font-face';
    this.key = void 0;
    this.style = void 0;
    this.options = void 0;
    this.isProcessed = false;
    this.renderable = void 0;
    this.key = key;
    this.style = style;
    this.options = options;
  }
  /**
   * Generates a CSS string.
   */


  var _proto = FontFaceRule.prototype;

  _proto.toString = function toString(options) {
    if (Array.isArray(this.style)) {
      var str = '';

      for (var index = 0; index < this.style.length; index++) {
        str += toCss(this.at, this.style[index]);
        if (this.style[index + 1]) str += '\n';
      }

      return str;
    }

    return toCss(this.at, this.style, options);
  };

  return FontFaceRule;
}();
var keyRegExp$2 = /@font-face/;
var pluginFontFaceRule = {
  onCreateRule: function onCreateRule(key, style, options) {
    return keyRegExp$2.test(key) ? new FontFaceRule(key, style, options) : null;
  }
};

var ViewportRule =
/*#__PURE__*/
function () {
  function ViewportRule(key, style, options) {
    this.type = 'viewport';
    this.at = '@viewport';
    this.key = void 0;
    this.style = void 0;
    this.options = void 0;
    this.isProcessed = false;
    this.renderable = void 0;
    this.key = key;
    this.style = style;
    this.options = options;
  }
  /**
   * Generates a CSS string.
   */


  var _proto = ViewportRule.prototype;

  _proto.toString = function toString(options) {
    return toCss(this.key, this.style, options);
  };

  return ViewportRule;
}();
var pluginViewportRule = {
  onCreateRule: function onCreateRule(key, style, options) {
    return key === '@viewport' || key === '@-ms-viewport' ? new ViewportRule(key, style, options) : null;
  }
};

var SimpleRule =
/*#__PURE__*/
function () {
  function SimpleRule(key, value, options) {
    this.type = 'simple';
    this.key = void 0;
    this.value = void 0;
    this.options = void 0;
    this.isProcessed = false;
    this.renderable = void 0;
    this.key = key;
    this.value = value;
    this.options = options;
  }
  /**
   * Generates a CSS string.
   */
  // eslint-disable-next-line no-unused-vars


  var _proto = SimpleRule.prototype;

  _proto.toString = function toString(options) {
    if (Array.isArray(this.value)) {
      var str = '';

      for (var index = 0; index < this.value.length; index++) {
        str += this.key + " " + this.value[index] + ";";
        if (this.value[index + 1]) str += '\n';
      }

      return str;
    }

    return this.key + " " + this.value + ";";
  };

  return SimpleRule;
}();
var keysMap = {
  '@charset': true,
  '@import': true,
  '@namespace': true
};
var pluginSimpleRule = {
  onCreateRule: function onCreateRule(key, value, options) {
    return key in keysMap ? new SimpleRule(key, value, options) : null;
  }
};

var plugins$1 = [pluginStyleRule, pluginConditionalRule, plugin, pluginKeyframeRule, pluginFontFaceRule, pluginViewportRule, pluginSimpleRule];

var defaultUpdateOptions = {
  process: true
};
var forceUpdateOptions = {
  force: true,
  process: true
  /**
   * Contains rules objects and allows adding/removing etc.
   * Is used for e.g. by `StyleSheet` or `ConditionalRule`.
   */

};

var RuleList =
/*#__PURE__*/
function () {
  // Rules registry for access by .get() method.
  // It contains the same rule registered by name and by selector.
  // Original styles object.
  // Used to ensure correct rules order.
  function RuleList(options) {
    this.map = {};
    this.raw = {};
    this.index = [];
    this.counter = 0;
    this.options = void 0;
    this.classes = void 0;
    this.keyframes = void 0;
    this.options = options;
    this.classes = options.classes;
    this.keyframes = options.keyframes;
  }
  /**
   * Create and register rule.
   *
   * Will not render after Style Sheet was rendered the first time.
   */


  var _proto = RuleList.prototype;

  _proto.add = function add(name, decl, ruleOptions) {
    var _this$options = this.options,
        parent = _this$options.parent,
        sheet = _this$options.sheet,
        jss = _this$options.jss,
        Renderer = _this$options.Renderer,
        generateId = _this$options.generateId,
        scoped = _this$options.scoped;

    var options = _extends$f({
      classes: this.classes,
      parent: parent,
      sheet: sheet,
      jss: jss,
      Renderer: Renderer,
      generateId: generateId,
      scoped: scoped,
      name: name,
      keyframes: this.keyframes,
      selector: undefined
    }, ruleOptions); // When user uses .createStyleSheet(), duplicate names are not possible, but
    // `sheet.addRule()` opens the door for any duplicate rule name. When this happens
    // we need to make the key unique within this RuleList instance scope.


    var key = name;

    if (name in this.raw) {
      key = name + "-d" + this.counter++;
    } // We need to save the original decl before creating the rule
    // because cache plugin needs to use it as a key to return a cached rule.


    this.raw[key] = decl;

    if (key in this.classes) {
      // E.g. rules inside of @media container
      options.selector = "." + escape$1(this.classes[key]);
    }

    var rule = createRule(key, decl, options);
    if (!rule) return null;
    this.register(rule);
    var index = options.index === undefined ? this.index.length : options.index;
    this.index.splice(index, 0, rule);
    return rule;
  }
  /**
   * Get a rule.
   */
  ;

  _proto.get = function get(name) {
    return this.map[name];
  }
  /**
   * Delete a rule.
   */
  ;

  _proto.remove = function remove(rule) {
    this.unregister(rule);
    delete this.raw[rule.key];
    this.index.splice(this.index.indexOf(rule), 1);
  }
  /**
   * Get index of a rule.
   */
  ;

  _proto.indexOf = function indexOf(rule) {
    return this.index.indexOf(rule);
  }
  /**
   * Run `onProcessRule()` plugins on every rule.
   */
  ;

  _proto.process = function process() {
    var plugins = this.options.jss.plugins; // We need to clone array because if we modify the index somewhere else during a loop
    // we end up with very hard-to-track-down side effects.

    this.index.slice(0).forEach(plugins.onProcessRule, plugins);
  }
  /**
   * Register a rule in `.map`, `.classes` and `.keyframes` maps.
   */
  ;

  _proto.register = function register(rule) {
    this.map[rule.key] = rule;

    if (rule instanceof StyleRule) {
      this.map[rule.selector] = rule;
      if (rule.id) this.classes[rule.key] = rule.id;
    } else if (rule instanceof KeyframesRule && this.keyframes) {
      this.keyframes[rule.name] = rule.id;
    }
  }
  /**
   * Unregister a rule.
   */
  ;

  _proto.unregister = function unregister(rule) {
    delete this.map[rule.key];

    if (rule instanceof StyleRule) {
      delete this.map[rule.selector];
      delete this.classes[rule.key];
    } else if (rule instanceof KeyframesRule) {
      delete this.keyframes[rule.name];
    }
  }
  /**
   * Update the function values with a new data.
   */
  ;

  _proto.update = function update() {
    var name;
    var data;
    var options;

    if (typeof (arguments.length <= 0 ? undefined : arguments[0]) === 'string') {
      name = arguments.length <= 0 ? undefined : arguments[0]; // $FlowFixMe[invalid-tuple-index]

      data = arguments.length <= 1 ? undefined : arguments[1]; // $FlowFixMe[invalid-tuple-index]

      options = arguments.length <= 2 ? undefined : arguments[2];
    } else {
      data = arguments.length <= 0 ? undefined : arguments[0]; // $FlowFixMe[invalid-tuple-index]

      options = arguments.length <= 1 ? undefined : arguments[1];
      name = null;
    }

    if (name) {
      this.updateOne(this.map[name], data, options);
    } else {
      for (var index = 0; index < this.index.length; index++) {
        this.updateOne(this.index[index], data, options);
      }
    }
  }
  /**
   * Execute plugins, update rule props.
   */
  ;

  _proto.updateOne = function updateOne(rule, data, options) {
    if (options === void 0) {
      options = defaultUpdateOptions;
    }

    var _this$options2 = this.options,
        plugins = _this$options2.jss.plugins,
        sheet = _this$options2.sheet; // It is a rules container like for e.g. ConditionalRule.

    if (rule.rules instanceof RuleList) {
      rule.rules.update(data, options);
      return;
    }

    var styleRule = rule;
    var style = styleRule.style;
    plugins.onUpdate(data, rule, sheet, options); // We rely on a new `style` ref in case it was mutated during onUpdate hook.

    if (options.process && style && style !== styleRule.style) {
      // We need to run the plugins in case new `style` relies on syntax plugins.
      plugins.onProcessStyle(styleRule.style, styleRule, sheet); // Update and add props.

      for (var prop in styleRule.style) {
        var nextValue = styleRule.style[prop];
        var prevValue = style[prop]; // We need to use `force: true` because `rule.style` has been updated during onUpdate hook, so `rule.prop()` will not update the CSSOM rule.
        // We do this comparison to avoid unneeded `rule.prop()` calls, since we have the old `style` object here.

        if (nextValue !== prevValue) {
          styleRule.prop(prop, nextValue, forceUpdateOptions);
        }
      } // Remove props.


      for (var _prop in style) {
        var _nextValue = styleRule.style[_prop];
        var _prevValue = style[_prop]; // We need to use `force: true` because `rule.style` has been updated during onUpdate hook, so `rule.prop()` will not update the CSSOM rule.
        // We do this comparison to avoid unneeded `rule.prop()` calls, since we have the old `style` object here.

        if (_nextValue == null && _nextValue !== _prevValue) {
          styleRule.prop(_prop, null, forceUpdateOptions);
        }
      }
    }
  }
  /**
   * Convert rules to a CSS string.
   */
  ;

  _proto.toString = function toString(options) {
    var str = '';
    var sheet = this.options.sheet;
    var link = sheet ? sheet.options.link : false;

    for (var index = 0; index < this.index.length; index++) {
      var rule = this.index[index];
      var css = rule.toString(options); // No need to render an empty rule.

      if (!css && !link) continue;
      if (str) str += '\n';
      str += css;
    }

    return str;
  };

  return RuleList;
}();

var StyleSheet =
/*#__PURE__*/
function () {
  function StyleSheet(styles, options) {
    this.options = void 0;
    this.deployed = void 0;
    this.attached = void 0;
    this.rules = void 0;
    this.renderer = void 0;
    this.classes = void 0;
    this.keyframes = void 0;
    this.queue = void 0;
    this.attached = false;
    this.deployed = false;
    this.classes = {};
    this.keyframes = {};
    this.options = _extends$f({}, options, {
      sheet: this,
      parent: this,
      classes: this.classes,
      keyframes: this.keyframes
    });

    if (options.Renderer) {
      this.renderer = new options.Renderer(this);
    }

    this.rules = new RuleList(this.options);

    for (var name in styles) {
      this.rules.add(name, styles[name]);
    }

    this.rules.process();
  }
  /**
   * Attach renderable to the render tree.
   */


  var _proto = StyleSheet.prototype;

  _proto.attach = function attach() {
    if (this.attached) return this;
    if (this.renderer) this.renderer.attach();
    this.attached = true; // Order is important, because we can't use insertRule API if style element is not attached.

    if (!this.deployed) this.deploy();
    return this;
  }
  /**
   * Remove renderable from render tree.
   */
  ;

  _proto.detach = function detach() {
    if (!this.attached) return this;
    if (this.renderer) this.renderer.detach();
    this.attached = false;
    return this;
  }
  /**
   * Add a rule to the current stylesheet.
   * Will insert a rule also after the stylesheet has been rendered first time.
   */
  ;

  _proto.addRule = function addRule(name, decl, options) {
    var queue = this.queue; // Plugins can create rules.
    // In order to preserve the right order, we need to queue all `.addRule` calls,
    // which happen after the first `rules.add()` call.

    if (this.attached && !queue) this.queue = [];
    var rule = this.rules.add(name, decl, options);
    if (!rule) return null;
    this.options.jss.plugins.onProcessRule(rule);

    if (this.attached) {
      if (!this.deployed) return rule; // Don't insert rule directly if there is no stringified version yet.
      // It will be inserted all together when .attach is called.

      if (queue) queue.push(rule);else {
        this.insertRule(rule);

        if (this.queue) {
          this.queue.forEach(this.insertRule, this);
          this.queue = undefined;
        }
      }
      return rule;
    } // We can't add rules to a detached style node.
    // We will redeploy the sheet once user will attach it.


    this.deployed = false;
    return rule;
  }
  /**
   * Insert rule into the StyleSheet
   */
  ;

  _proto.insertRule = function insertRule(rule) {
    if (this.renderer) {
      this.renderer.insertRule(rule);
    }
  }
  /**
   * Create and add rules.
   * Will render also after Style Sheet was rendered the first time.
   */
  ;

  _proto.addRules = function addRules(styles, options) {
    var added = [];

    for (var name in styles) {
      var rule = this.addRule(name, styles[name], options);
      if (rule) added.push(rule);
    }

    return added;
  }
  /**
   * Get a rule by name.
   */
  ;

  _proto.getRule = function getRule(name) {
    return this.rules.get(name);
  }
  /**
   * Delete a rule by name.
   * Returns `true`: if rule has been deleted from the DOM.
   */
  ;

  _proto.deleteRule = function deleteRule(name) {
    var rule = typeof name === 'object' ? name : this.rules.get(name);

    if (!rule || // Style sheet was created without link: true and attached, in this case we
    // won't be able to remove the CSS rule from the DOM.
    this.attached && !rule.renderable) {
      return false;
    }

    this.rules.remove(rule);

    if (this.attached && rule.renderable && this.renderer) {
      return this.renderer.deleteRule(rule.renderable);
    }

    return true;
  }
  /**
   * Get index of a rule.
   */
  ;

  _proto.indexOf = function indexOf(rule) {
    return this.rules.indexOf(rule);
  }
  /**
   * Deploy pure CSS string to a renderable.
   */
  ;

  _proto.deploy = function deploy() {
    if (this.renderer) this.renderer.deploy();
    this.deployed = true;
    return this;
  }
  /**
   * Update the function values with a new data.
   */
  ;

  _proto.update = function update() {
    var _this$rules;

    (_this$rules = this.rules).update.apply(_this$rules, arguments);

    return this;
  }
  /**
   * Updates a single rule.
   */
  ;

  _proto.updateOne = function updateOne(rule, data, options) {
    this.rules.updateOne(rule, data, options);
    return this;
  }
  /**
   * Convert rules to a CSS string.
   */
  ;

  _proto.toString = function toString(options) {
    return this.rules.toString(options);
  };

  return StyleSheet;
}();

var PluginsRegistry =
/*#__PURE__*/
function () {
  function PluginsRegistry() {
    this.plugins = {
      internal: [],
      external: []
    };
    this.registry = void 0;
  }

  var _proto = PluginsRegistry.prototype;

  /**
   * Call `onCreateRule` hooks and return an object if returned by a hook.
   */
  _proto.onCreateRule = function onCreateRule(name, decl, options) {
    for (var i = 0; i < this.registry.onCreateRule.length; i++) {
      var rule = this.registry.onCreateRule[i](name, decl, options);
      if (rule) return rule;
    }

    return null;
  }
  /**
   * Call `onProcessRule` hooks.
   */
  ;

  _proto.onProcessRule = function onProcessRule(rule) {
    if (rule.isProcessed) return;
    var sheet = rule.options.sheet;

    for (var i = 0; i < this.registry.onProcessRule.length; i++) {
      this.registry.onProcessRule[i](rule, sheet);
    }

    if (rule.style) this.onProcessStyle(rule.style, rule, sheet);
    rule.isProcessed = true;
  }
  /**
   * Call `onProcessStyle` hooks.
   */
  ;

  _proto.onProcessStyle = function onProcessStyle(style, rule, sheet) {
    for (var i = 0; i < this.registry.onProcessStyle.length; i++) {
      // $FlowFixMe[prop-missing]
      rule.style = this.registry.onProcessStyle[i](rule.style, rule, sheet);
    }
  }
  /**
   * Call `onProcessSheet` hooks.
   */
  ;

  _proto.onProcessSheet = function onProcessSheet(sheet) {
    for (var i = 0; i < this.registry.onProcessSheet.length; i++) {
      this.registry.onProcessSheet[i](sheet);
    }
  }
  /**
   * Call `onUpdate` hooks.
   */
  ;

  _proto.onUpdate = function onUpdate(data, rule, sheet, options) {
    for (var i = 0; i < this.registry.onUpdate.length; i++) {
      this.registry.onUpdate[i](data, rule, sheet, options);
    }
  }
  /**
   * Call `onChangeValue` hooks.
   */
  ;

  _proto.onChangeValue = function onChangeValue(value, prop, rule) {
    var processedValue = value;

    for (var i = 0; i < this.registry.onChangeValue.length; i++) {
      processedValue = this.registry.onChangeValue[i](processedValue, prop, rule);
    }

    return processedValue;
  }
  /**
   * Register a plugin.
   */
  ;

  _proto.use = function use(newPlugin, options) {
    if (options === void 0) {
      options = {
        queue: 'external'
      };
    }

    var plugins = this.plugins[options.queue]; // Avoids applying same plugin twice, at least based on ref.

    if (plugins.indexOf(newPlugin) !== -1) {
      return;
    }

    plugins.push(newPlugin);
    this.registry = [].concat(this.plugins.external, this.plugins.internal).reduce(function (registry, plugin) {
      for (var name in plugin) {
        if (name in registry) {
          registry[name].push(plugin[name]);
        }
      }

      return registry;
    }, {
      onCreateRule: [],
      onProcessRule: [],
      onProcessStyle: [],
      onProcessSheet: [],
      onChangeValue: [],
      onUpdate: []
    });
  };

  return PluginsRegistry;
}();

/**
 * Sheets registry to access them all at one place.
 */
var SheetsRegistry =
/*#__PURE__*/
function () {
  function SheetsRegistry() {
    this.registry = [];
  }

  var _proto = SheetsRegistry.prototype;

  /**
   * Register a Style Sheet.
   */
  _proto.add = function add(sheet) {
    var registry = this.registry;
    var index = sheet.options.index;
    if (registry.indexOf(sheet) !== -1) return;

    if (registry.length === 0 || index >= this.index) {
      registry.push(sheet);
      return;
    } // Find a position.


    for (var i = 0; i < registry.length; i++) {
      if (registry[i].options.index > index) {
        registry.splice(i, 0, sheet);
        return;
      }
    }
  }
  /**
   * Reset the registry.
   */
  ;

  _proto.reset = function reset() {
    this.registry = [];
  }
  /**
   * Remove a Style Sheet.
   */
  ;

  _proto.remove = function remove(sheet) {
    var index = this.registry.indexOf(sheet);
    this.registry.splice(index, 1);
  }
  /**
   * Convert all attached sheets to a CSS string.
   */
  ;

  _proto.toString = function toString(_temp) {
    var _ref = _temp === void 0 ? {} : _temp,
        attached = _ref.attached,
        options = _objectWithoutPropertiesLoose(_ref, ["attached"]);

    var css = '';

    for (var i = 0; i < this.registry.length; i++) {
      var sheet = this.registry[i];

      if (attached != null && sheet.attached !== attached) {
        continue;
      }

      if (css) css += '\n';
      css += sheet.toString(options);
    }

    return css;
  };

  _createClass$b(SheetsRegistry, [{
    key: "index",

    /**
     * Current highest index number.
     */
    get: function get() {
      return this.registry.length === 0 ? 0 : this.registry[this.registry.length - 1].options.index;
    }
  }]);

  return SheetsRegistry;
}();

/**
 * This is a global sheets registry. Only DomRenderer will add sheets to it.
 * On the server one should use an own SheetsRegistry instance and add the
 * sheets to it, because you need to make sure to create a new registry for
 * each request in order to not leak sheets across requests.
 */

var registry = new SheetsRegistry();

/* eslint-disable */

/**
 * Now that `globalThis` is available on most platforms
 * (https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/globalThis#browser_compatibility)
 * we check for `globalThis` first. `globalThis` is necessary for jss
 * to run in Agoric's secure version of JavaScript (SES). Under SES,
 * `globalThis` exists, but `window`, `self`, and `Function('return
 * this')()` are all undefined for security reasons.
 *
 * https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
 */
var globalThis$1 = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' && window.Math === Math ? window : typeof self !== 'undefined' && self.Math === Math ? self : Function('return this')();

var ns = '2f1acc6c3a606b082e5eef5e54414ffb';
if (globalThis$1[ns] == null) globalThis$1[ns] = 0; // Bundle may contain multiple JSS versions at the same time. In order to identify
// the current version with just one short number and use it for classes generation
// we use a counter. Also it is more accurate, because user can manually reevaluate
// the module.

var moduleId = globalThis$1[ns]++;

/**
 * Returns a function which generates unique class names based on counters.
 * When new generator function is created, rule counter is reseted.
 * We need to reset the rule counter for SSR for each request.
 */
var createGenerateId = function createGenerateId(options) {
  if (options === void 0) {
    options = {};
  }

  var ruleCounter = 0;

  var generateId = function generateId(rule, sheet) {
    ruleCounter += 1;

    var jssId = '';
    var prefix = '';

    if (sheet) {
      if (sheet.options.classNamePrefix) {
        prefix = sheet.options.classNamePrefix;
      }

      if (sheet.options.jss.id != null) {
        jssId = String(sheet.options.jss.id);
      }
    }

    if (options.minify) {
      // Using "c" because a number can't be the first char in a class name.
      return "" + (prefix || 'c') + moduleId + jssId + ruleCounter;
    }

    return prefix + rule.key + "-" + moduleId + (jssId ? "-" + jssId : '') + "-" + ruleCounter;
  };

  return generateId;
};

/**
 * Cache the value from the first time a function is called.
 */
var memoize = function memoize(fn) {
  var value;
  return function () {
    if (!value) value = fn();
    return value;
  };
};

/**
 * Get a style property value.
 */
var getPropertyValue = function getPropertyValue(cssRule, prop) {
  try {
    // Support CSSTOM.
    if (cssRule.attributeStyleMap) {
      return cssRule.attributeStyleMap.get(prop);
    }

    return cssRule.style.getPropertyValue(prop);
  } catch (err) {
    // IE may throw if property is unknown.
    return '';
  }
};

/**
 * Set a style property.
 */
var setProperty = function setProperty(cssRule, prop, value) {
  try {
    var cssValue = value;

    if (Array.isArray(value)) {
      cssValue = toCssValue(value, true);

      if (value[value.length - 1] === '!important') {
        cssRule.style.setProperty(prop, cssValue, 'important');
        return true;
      }
    } // Support CSSTOM.


    if (cssRule.attributeStyleMap) {
      cssRule.attributeStyleMap.set(prop, cssValue);
    } else {
      cssRule.style.setProperty(prop, cssValue);
    }
  } catch (err) {
    // IE may throw if property is unknown.
    return false;
  }

  return true;
};

/**
 * Remove a style property.
 */
var removeProperty = function removeProperty(cssRule, prop) {
  try {
    // Support CSSTOM.
    if (cssRule.attributeStyleMap) {
      cssRule.attributeStyleMap.delete(prop);
    } else {
      cssRule.style.removeProperty(prop);
    }
  } catch (err) {
  }
};

/**
 * Set the selector.
 */
var setSelector = function setSelector(cssRule, selectorText) {
  cssRule.selectorText = selectorText; // Return false if setter was not successful.
  // Currently works in chrome only.

  return cssRule.selectorText === selectorText;
};
/**
 * Gets the `head` element upon the first call and caches it.
 * We assume it can't be null.
 */


var getHead = memoize(function () {
  return document.querySelector('head');
});
/**
 * Find attached sheet with an index higher than the passed one.
 */

function findHigherSheet(registry, options) {
  for (var i = 0; i < registry.length; i++) {
    var sheet = registry[i];

    if (sheet.attached && sheet.options.index > options.index && sheet.options.insertionPoint === options.insertionPoint) {
      return sheet;
    }
  }

  return null;
}
/**
 * Find attached sheet with the highest index.
 */


function findHighestSheet(registry, options) {
  for (var i = registry.length - 1; i >= 0; i--) {
    var sheet = registry[i];

    if (sheet.attached && sheet.options.insertionPoint === options.insertionPoint) {
      return sheet;
    }
  }

  return null;
}
/**
 * Find a comment with "jss" inside.
 */


function findCommentNode(text) {
  var head = getHead();

  for (var i = 0; i < head.childNodes.length; i++) {
    var node = head.childNodes[i];

    if (node.nodeType === 8 && node.nodeValue.trim() === text) {
      return node;
    }
  }

  return null;
}

/**
 * Find a node before which we can insert the sheet.
 */
function findPrevNode(options) {
  var registry$1 = registry.registry;

  if (registry$1.length > 0) {
    // Try to insert before the next higher sheet.
    var sheet = findHigherSheet(registry$1, options);

    if (sheet && sheet.renderer) {
      return {
        parent: sheet.renderer.element.parentNode,
        node: sheet.renderer.element
      };
    } // Otherwise insert after the last attached.


    sheet = findHighestSheet(registry$1, options);

    if (sheet && sheet.renderer) {
      return {
        parent: sheet.renderer.element.parentNode,
        node: sheet.renderer.element.nextSibling
      };
    }
  } // Try to find a comment placeholder if registry is empty.


  var insertionPoint = options.insertionPoint;

  if (insertionPoint && typeof insertionPoint === 'string') {
    var comment = findCommentNode(insertionPoint);

    if (comment) {
      return {
        parent: comment.parentNode,
        node: comment.nextSibling
      };
    } // If user specifies an insertion point and it can't be found in the document -
  }

  return false;
}
/**
 * Insert style element into the DOM.
 */


function insertStyle(style, options) {
  var insertionPoint = options.insertionPoint;
  var nextNode = findPrevNode(options);

  if (nextNode !== false && nextNode.parent) {
    nextNode.parent.insertBefore(style, nextNode.node);
    return;
  } // Works with iframes and any node types.


  if (insertionPoint && typeof insertionPoint.nodeType === 'number') {
    // https://stackoverflow.com/questions/41328728/force-casting-in-flow
    var insertionPointElement = insertionPoint;
    var parentNode = insertionPointElement.parentNode;
    if (parentNode) parentNode.insertBefore(style, insertionPointElement.nextSibling);
    return;
  }

  getHead().appendChild(style);
}
/**
 * Read jss nonce setting from the page if the user has set it.
 */


var getNonce = memoize(function () {
  var node = document.querySelector('meta[property="csp-nonce"]');
  return node ? node.getAttribute('content') : null;
});

var _insertRule = function insertRule(container, rule, index) {
  try {
    if ('insertRule' in container) {
      var c = container;
      c.insertRule(rule, index);
    } // Keyframes rule.
    else if ('appendRule' in container) {
        var _c = container;

        _c.appendRule(rule);
      }
  } catch (err) {
    return false;
  }

  return container.cssRules[index];
};

var getValidRuleInsertionIndex = function getValidRuleInsertionIndex(container, index) {
  var maxIndex = container.cssRules.length; // In case previous insertion fails, passed index might be wrong

  if (index === undefined || index > maxIndex) {
    // eslint-disable-next-line no-param-reassign
    return maxIndex;
  }

  return index;
};

var createStyle = function createStyle() {
  var el = document.createElement('style'); // Without it, IE will have a broken source order specificity if we
  // insert rules after we insert the style tag.
  // It seems to kick-off the source order specificity algorithm.

  el.textContent = '\n';
  return el;
};

var DomRenderer =
/*#__PURE__*/
function () {
  // HTMLStyleElement needs fixing https://github.com/facebook/flow/issues/2696
  // Will be empty if link: true option is not set, because
  // it is only for use together with insertRule API.
  function DomRenderer(sheet) {
    this.getPropertyValue = getPropertyValue;
    this.setProperty = setProperty;
    this.removeProperty = removeProperty;
    this.setSelector = setSelector;
    this.element = void 0;
    this.sheet = void 0;
    this.hasInsertedRules = false;
    this.cssRules = [];
    // There is no sheet when the renderer is used from a standalone StyleRule.
    if (sheet) registry.add(sheet);
    this.sheet = sheet;

    var _ref = this.sheet ? this.sheet.options : {},
        media = _ref.media,
        meta = _ref.meta,
        element = _ref.element;

    this.element = element || createStyle();
    this.element.setAttribute('data-jss', '');
    if (media) this.element.setAttribute('media', media);
    if (meta) this.element.setAttribute('data-meta', meta);
    var nonce = getNonce();
    if (nonce) this.element.setAttribute('nonce', nonce);
  }
  /**
   * Insert style element into render tree.
   */


  var _proto = DomRenderer.prototype;

  _proto.attach = function attach() {
    // In the case the element node is external and it is already in the DOM.
    if (this.element.parentNode || !this.sheet) return;
    insertStyle(this.element, this.sheet.options); // When rules are inserted using `insertRule` API, after `sheet.detach().attach()`
    // most browsers create a new CSSStyleSheet, except of all IEs.

    var deployed = Boolean(this.sheet && this.sheet.deployed);

    if (this.hasInsertedRules && deployed) {
      this.hasInsertedRules = false;
      this.deploy();
    }
  }
  /**
   * Remove style element from render tree.
   */
  ;

  _proto.detach = function detach() {
    if (!this.sheet) return;
    var parentNode = this.element.parentNode;
    if (parentNode) parentNode.removeChild(this.element); // In the most browsers, rules inserted using insertRule() API will be lost when style element is removed.
    // Though IE will keep them and we need a consistent behavior.

    if (this.sheet.options.link) {
      this.cssRules = [];
      this.element.textContent = '\n';
    }
  }
  /**
   * Inject CSS string into element.
   */
  ;

  _proto.deploy = function deploy() {
    var sheet = this.sheet;
    if (!sheet) return;

    if (sheet.options.link) {
      this.insertRules(sheet.rules);
      return;
    }

    this.element.textContent = "\n" + sheet.toString() + "\n";
  }
  /**
   * Insert RuleList into an element.
   */
  ;

  _proto.insertRules = function insertRules(rules, nativeParent) {
    for (var i = 0; i < rules.index.length; i++) {
      this.insertRule(rules.index[i], i, nativeParent);
    }
  }
  /**
   * Insert a rule into element.
   */
  ;

  _proto.insertRule = function insertRule(rule, index, nativeParent) {
    if (nativeParent === void 0) {
      nativeParent = this.element.sheet;
    }

    if (rule.rules) {
      var parent = rule;
      var latestNativeParent = nativeParent;

      if (rule.type === 'conditional' || rule.type === 'keyframes') {
        var _insertionIndex = getValidRuleInsertionIndex(nativeParent, index); // We need to render the container without children first.


        latestNativeParent = _insertRule(nativeParent, parent.toString({
          children: false
        }), _insertionIndex);

        if (latestNativeParent === false) {
          return false;
        }

        this.refCssRule(rule, _insertionIndex, latestNativeParent);
      }

      this.insertRules(parent.rules, latestNativeParent);
      return latestNativeParent;
    }

    var ruleStr = rule.toString();
    if (!ruleStr) return false;
    var insertionIndex = getValidRuleInsertionIndex(nativeParent, index);

    var nativeRule = _insertRule(nativeParent, ruleStr, insertionIndex);

    if (nativeRule === false) {
      return false;
    }

    this.hasInsertedRules = true;
    this.refCssRule(rule, insertionIndex, nativeRule);
    return nativeRule;
  };

  _proto.refCssRule = function refCssRule(rule, index, cssRule) {
    rule.renderable = cssRule; // We only want to reference the top level rules, deleteRule API doesn't support removing nested rules
    // like rules inside media queries or keyframes

    if (rule.options.parent instanceof StyleSheet) {
      this.cssRules[index] = cssRule;
    }
  }
  /**
   * Delete a rule.
   */
  ;

  _proto.deleteRule = function deleteRule(cssRule) {
    var sheet = this.element.sheet;
    var index = this.indexOf(cssRule);
    if (index === -1) return false;
    sheet.deleteRule(index);
    this.cssRules.splice(index, 1);
    return true;
  }
  /**
   * Get index of a CSS Rule.
   */
  ;

  _proto.indexOf = function indexOf(cssRule) {
    return this.cssRules.indexOf(cssRule);
  }
  /**
   * Generate a new CSS rule and replace the existing one.
   *
   * Only used for some old browsers because they can't set a selector.
   */
  ;

  _proto.replaceRule = function replaceRule(cssRule, rule) {
    var index = this.indexOf(cssRule);
    if (index === -1) return false;
    this.element.sheet.deleteRule(index);
    this.cssRules.splice(index, 1);
    return this.insertRule(rule, index);
  }
  /**
   * Get all rules elements.
   */
  ;

  _proto.getRules = function getRules() {
    return this.element.sheet.cssRules;
  };

  return DomRenderer;
}();

var instanceCounter = 0;

var Jss =
/*#__PURE__*/
function () {
  function Jss(options) {
    this.id = instanceCounter++;
    this.version = "10.7.1";
    this.plugins = new PluginsRegistry();
    this.options = {
      id: {
        minify: false
      },
      createGenerateId: createGenerateId,
      Renderer: isBrowser$2 ? DomRenderer : null,
      plugins: []
    };
    this.generateId = createGenerateId({
      minify: false
    });

    for (var i = 0; i < plugins$1.length; i++) {
      this.plugins.use(plugins$1[i], {
        queue: 'internal'
      });
    }

    this.setup(options);
  }
  /**
   * Prepares various options, applies plugins.
   * Should not be used twice on the same instance, because there is no plugins
   * deduplication logic.
   */


  var _proto = Jss.prototype;

  _proto.setup = function setup(options) {
    if (options === void 0) {
      options = {};
    }

    if (options.createGenerateId) {
      this.options.createGenerateId = options.createGenerateId;
    }

    if (options.id) {
      this.options.id = _extends$f({}, this.options.id, options.id);
    }

    if (options.createGenerateId || options.id) {
      this.generateId = this.options.createGenerateId(this.options.id);
    }

    if (options.insertionPoint != null) this.options.insertionPoint = options.insertionPoint;

    if ('Renderer' in options) {
      this.options.Renderer = options.Renderer;
    } // eslint-disable-next-line prefer-spread


    if (options.plugins) this.use.apply(this, options.plugins);
    return this;
  }
  /**
   * Create a Style Sheet.
   */
  ;

  _proto.createStyleSheet = function createStyleSheet(styles, options) {
    if (options === void 0) {
      options = {};
    }

    var _options = options,
        index = _options.index;

    if (typeof index !== 'number') {
      index = registry.index === 0 ? 0 : registry.index + 1;
    }

    var sheet = new StyleSheet(styles, _extends$f({}, options, {
      jss: this,
      generateId: options.generateId || this.generateId,
      insertionPoint: this.options.insertionPoint,
      Renderer: this.options.Renderer,
      index: index
    }));
    this.plugins.onProcessSheet(sheet);
    return sheet;
  }
  /**
   * Detach the Style Sheet and remove it from the registry.
   */
  ;

  _proto.removeStyleSheet = function removeStyleSheet(sheet) {
    sheet.detach();
    registry.remove(sheet);
    return this;
  }
  /**
   * Create a rule without a Style Sheet.
   * [Deprecated] will be removed in the next major version.
   */
  ;

  _proto.createRule = function createRule$1(name, style, options) {
    if (style === void 0) {
      style = {};
    }

    if (options === void 0) {
      options = {};
    }

    // Enable rule without name for inline styles.
    if (typeof name === 'object') {
      // $FlowFixMe[incompatible-call]
      return this.createRule(undefined, name, style);
    } // $FlowFixMe[incompatible-type]


    var ruleOptions = _extends$f({}, options, {
      name: name,
      jss: this,
      Renderer: this.options.Renderer
    });

    if (!ruleOptions.generateId) ruleOptions.generateId = this.generateId;
    if (!ruleOptions.classes) ruleOptions.classes = {};
    if (!ruleOptions.keyframes) ruleOptions.keyframes = {};

    var rule = createRule(name, style, ruleOptions);

    if (rule) this.plugins.onProcessRule(rule);
    return rule;
  }
  /**
   * Register plugin. Passed function will be invoked with a rule instance.
   */
  ;

  _proto.use = function use() {
    var _this = this;

    for (var _len = arguments.length, plugins = new Array(_len), _key = 0; _key < _len; _key++) {
      plugins[_key] = arguments[_key];
    }

    plugins.forEach(function (plugin) {
      _this.plugins.use(plugin);
    });
    return this;
  };

  return Jss;
}();

/**
 * Extracts a styles object with only props that contain function values.
 */
function getDynamicStyles(styles) {
  var to = null;

  for (var key in styles) {
    var value = styles[key];
    var type = typeof value;

    if (type === 'function') {
      if (!to) to = {};
      to[key] = value;
    } else if (type === 'object' && value !== null && !Array.isArray(value)) {
      var extracted = getDynamicStyles(value);

      if (extracted) {
        if (!to) to = {};
        to[key] = extracted;
      }
    }
  }

  return to;
}

/**
 * A better abstraction over CSS.
 *
 * @copyright Oleg Isonen (Slobodskoi) / Isonen 2014-present
 * @website https://github.com/cssinjs/jss
 * @license MIT
 */

/**
 * Export a constant indicating if this browser has CSSTOM support.
 * https://developers.google.com/web/updates/2018/03/cssom
 */
var hasCSSTOMSupport = typeof CSS === 'object' && CSS != null && 'number' in CSS;
/**
 * Creates a new instance of Jss.
 */

var create = function create(options) {
  return new Jss(options);
};
/**
 * A global Jss instance.
 */

create();var now$1 = Date.now();
var fnValuesNs = "fnValues" + now$1;
var fnRuleNs = "fnStyle" + ++now$1;

var functionPlugin = function functionPlugin() {
  return {
    onCreateRule: function onCreateRule(name, decl, options) {
      if (typeof decl !== 'function') return null;
      var rule = createRule(name, {}, options);
      rule[fnRuleNs] = decl;
      return rule;
    },
    onProcessStyle: function onProcessStyle(style, rule) {
      // We need to extract function values from the declaration, so that we can keep core unaware of them.
      // We need to do that only once.
      // We don't need to extract functions on each style update, since this can happen only once.
      // We don't support function values inside of function rules.
      if (fnValuesNs in rule || fnRuleNs in rule) return style;
      var fnValues = {};

      for (var prop in style) {
        var value = style[prop];
        if (typeof value !== 'function') continue;
        delete style[prop];
        fnValues[prop] = value;
      } // $FlowFixMe[prop-missing]


      rule[fnValuesNs] = fnValues;
      return style;
    },
    onUpdate: function onUpdate(data, rule, sheet, options) {
      var styleRule = rule; // $FlowFixMe[prop-missing]

      var fnRule = styleRule[fnRuleNs]; // If we have a style function, the entire rule is dynamic and style object
      // will be returned from that function.

      if (fnRule) {
        // Empty object will remove all currently defined props
        // in case function rule returns a falsy value.
        styleRule.style = fnRule(data) || {};
      } // $FlowFixMe[prop-missing]


      var fnValues = styleRule[fnValuesNs]; // If we have a fn values map, it is a rule with function values.

      if (fnValues) {
        for (var _prop in fnValues) {
          styleRule.prop(_prop, fnValues[_prop](data), options);
        }
      }
    }
  };
};

var functions = functionPlugin;var at = '@global';
var atPrefix = '@global ';

var GlobalContainerRule =
/*#__PURE__*/
function () {
  function GlobalContainerRule(key, styles, options) {
    this.type = 'global';
    this.at = at;
    this.rules = void 0;
    this.options = void 0;
    this.key = void 0;
    this.isProcessed = false;
    this.key = key;
    this.options = options;
    this.rules = new RuleList(_extends$f({}, options, {
      parent: this
    }));

    for (var selector in styles) {
      this.rules.add(selector, styles[selector]);
    }

    this.rules.process();
  }
  /**
   * Get a rule.
   */


  var _proto = GlobalContainerRule.prototype;

  _proto.getRule = function getRule(name) {
    return this.rules.get(name);
  }
  /**
   * Create and register rule, run plugins.
   */
  ;

  _proto.addRule = function addRule(name, style, options) {
    var rule = this.rules.add(name, style, options);
    if (rule) this.options.jss.plugins.onProcessRule(rule);
    return rule;
  }
  /**
   * Get index of a rule.
   */
  ;

  _proto.indexOf = function indexOf(rule) {
    return this.rules.indexOf(rule);
  }
  /**
   * Generates a CSS string.
   */
  ;

  _proto.toString = function toString() {
    return this.rules.toString();
  };

  return GlobalContainerRule;
}();

var GlobalPrefixedRule =
/*#__PURE__*/
function () {
  function GlobalPrefixedRule(key, style, options) {
    this.type = 'global';
    this.at = at;
    this.options = void 0;
    this.rule = void 0;
    this.isProcessed = false;
    this.key = void 0;
    this.key = key;
    this.options = options;
    var selector = key.substr(atPrefix.length);
    this.rule = options.jss.createRule(selector, style, _extends$f({}, options, {
      parent: this
    }));
  }

  var _proto2 = GlobalPrefixedRule.prototype;

  _proto2.toString = function toString(options) {
    return this.rule ? this.rule.toString(options) : '';
  };

  return GlobalPrefixedRule;
}();

var separatorRegExp$1 = /\s*,\s*/g;

function addScope(selector, scope) {
  var parts = selector.split(separatorRegExp$1);
  var scoped = '';

  for (var i = 0; i < parts.length; i++) {
    scoped += scope + " " + parts[i].trim();
    if (parts[i + 1]) scoped += ', ';
  }

  return scoped;
}

function handleNestedGlobalContainerRule(rule, sheet) {
  var options = rule.options,
      style = rule.style;
  var rules = style ? style[at] : null;
  if (!rules) return;

  for (var name in rules) {
    sheet.addRule(name, rules[name], _extends$f({}, options, {
      selector: addScope(name, rule.selector)
    }));
  }

  delete style[at];
}

function handlePrefixedGlobalRule(rule, sheet) {
  var options = rule.options,
      style = rule.style;

  for (var prop in style) {
    if (prop[0] !== '@' || prop.substr(0, at.length) !== at) continue;
    var selector = addScope(prop.substr(at.length), rule.selector);
    sheet.addRule(selector, style[prop], _extends$f({}, options, {
      selector: selector
    }));
    delete style[prop];
  }
}
/**
 * Convert nested rules to separate, remove them from original styles.
 *
 * @param {Rule} rule
 * @api public
 */


function jssGlobal() {
  function onCreateRule(name, styles, options) {
    if (!name) return null;

    if (name === at) {
      return new GlobalContainerRule(name, styles, options);
    }

    if (name[0] === '@' && name.substr(0, atPrefix.length) === atPrefix) {
      return new GlobalPrefixedRule(name, styles, options);
    }

    var parent = options.parent;

    if (parent) {
      if (parent.type === 'global' || parent.options.parent && parent.options.parent.type === 'global') {
        options.scoped = false;
      }
    }

    if (options.scoped === false) {
      options.selector = name;
    }

    return null;
  }

  function onProcessRule(rule, sheet) {
    if (rule.type !== 'style' || !sheet) return;
    handleNestedGlobalContainerRule(rule, sheet);
    handlePrefixedGlobalRule(rule, sheet);
  }

  return {
    onCreateRule: onCreateRule,
    onProcessRule: onProcessRule
  };
}var separatorRegExp = /\s*,\s*/g;
var parentRegExp = /&/g;
var refRegExp = /\$([\w-]+)/g;
/**
 * Convert nested rules to separate, remove them from original styles.
 *
 * @param {Rule} rule
 * @api public
 */

function jssNested() {
  // Get a function to be used for $ref replacement.
  function getReplaceRef(container, sheet) {
    return function (match, key) {
      var rule = container.getRule(key) || sheet && sheet.getRule(key);

      if (rule) {
        rule = rule;
        return rule.selector;
      }
      return key;
    };
  }

  function replaceParentRefs(nestedProp, parentProp) {
    var parentSelectors = parentProp.split(separatorRegExp);
    var nestedSelectors = nestedProp.split(separatorRegExp);
    var result = '';

    for (var i = 0; i < parentSelectors.length; i++) {
      var parent = parentSelectors[i];

      for (var j = 0; j < nestedSelectors.length; j++) {
        var nested = nestedSelectors[j];
        if (result) result += ', '; // Replace all & by the parent or prefix & with the parent.

        result += nested.indexOf('&') !== -1 ? nested.replace(parentRegExp, parent) : parent + " " + nested;
      }
    }

    return result;
  }

  function getOptions(rule, container, prevOptions) {
    // Options has been already created, now we only increase index.
    if (prevOptions) return _extends$f({}, prevOptions, {
      index: prevOptions.index + 1 // $FlowFixMe[prop-missing]

    });
    var nestingLevel = rule.options.nestingLevel;
    nestingLevel = nestingLevel === undefined ? 1 : nestingLevel + 1;

    var options = _extends$f({}, rule.options, {
      nestingLevel: nestingLevel,
      index: container.indexOf(rule) + 1 // We don't need the parent name to be set options for chlid.

    });

    delete options.name;
    return options;
  }

  function onProcessStyle(style, rule, sheet) {
    if (rule.type !== 'style') return style;
    var styleRule = rule;
    var container = styleRule.options.parent;
    var options;
    var replaceRef;

    for (var prop in style) {
      var isNested = prop.indexOf('&') !== -1;
      var isNestedConditional = prop[0] === '@';
      if (!isNested && !isNestedConditional) continue;
      options = getOptions(styleRule, container, options);

      if (isNested) {
        var selector = replaceParentRefs(prop, styleRule.selector); // Lazily create the ref replacer function just once for
        // all nested rules within the sheet.

        if (!replaceRef) replaceRef = getReplaceRef(container, sheet); // Replace all $refs.

        selector = selector.replace(refRegExp, replaceRef);
        container.addRule(selector, style[prop], _extends$f({}, options, {
          selector: selector
        }));
      } else if (isNestedConditional) {
        // Place conditional right after the parent rule to ensure right ordering.
        container.addRule(prop, {}, options) // Flow expects more options but they aren't required
        // And flow doesn't know this will always be a StyleRule which has the addRule method
        // $FlowFixMe[incompatible-use]
        // $FlowFixMe[prop-missing]
        .addRule(styleRule.key, style[prop], {
          selector: styleRule.selector
        });
      }

      delete style[prop];
    }

    return style;
  }

  return {
    onProcessStyle: onProcessStyle
  };
}/* eslint-disable no-var, prefer-template */
var uppercasePattern = /[A-Z]/g;
var msPattern = /^ms-/;
var cache$2 = {};

function toHyphenLower(match) {
  return '-' + match.toLowerCase()
}

function hyphenateStyleName(name) {
  if (cache$2.hasOwnProperty(name)) {
    return cache$2[name]
  }

  var hName = name.replace(uppercasePattern, toHyphenLower);
  return (cache$2[name] = msPattern.test(hName) ? '-' + hName : hName)
}/**
 * Convert camel cased property names to dash separated.
 *
 * @param {Object} style
 * @return {Object}
 */

function convertCase(style) {
  var converted = {};

  for (var prop in style) {
    var key = prop.indexOf('--') === 0 ? prop : hyphenateStyleName(prop);
    converted[key] = style[prop];
  }

  if (style.fallbacks) {
    if (Array.isArray(style.fallbacks)) converted.fallbacks = style.fallbacks.map(convertCase);else converted.fallbacks = convertCase(style.fallbacks);
  }

  return converted;
}
/**
 * Allow camel cased property names by converting them back to dasherized.
 *
 * @param {Rule} rule
 */


function camelCase() {
  function onProcessStyle(style) {
    if (Array.isArray(style)) {
      // Handle rules like @font-face, which can have multiple styles in an array
      for (var index = 0; index < style.length; index++) {
        style[index] = convertCase(style[index]);
      }

      return style;
    }

    return convertCase(style);
  }

  function onChangeValue(value, prop, rule) {
    if (prop.indexOf('--') === 0) {
      return value;
    }

    var hyphenatedProp = hyphenateStyleName(prop); // There was no camel case in place

    if (prop === hyphenatedProp) return value;
    rule.prop(hyphenatedProp, value); // Core will ignore that property value we set the proper one above.

    return null;
  }

  return {
    onProcessStyle: onProcessStyle,
    onChangeValue: onChangeValue
  };
}var px = hasCSSTOMSupport && CSS ? CSS.px : 'px';
var ms = hasCSSTOMSupport && CSS ? CSS.ms : 'ms';
var percent = hasCSSTOMSupport && CSS ? CSS.percent : '%';
/**
 * Generated jss-plugin-default-unit CSS property units
 *
 * @type object
 */

var defaultUnits = {
  // Animation properties
  'animation-delay': ms,
  'animation-duration': ms,
  // Background properties
  'background-position': px,
  'background-position-x': px,
  'background-position-y': px,
  'background-size': px,
  // Border Properties
  border: px,
  'border-bottom': px,
  'border-bottom-left-radius': px,
  'border-bottom-right-radius': px,
  'border-bottom-width': px,
  'border-left': px,
  'border-left-width': px,
  'border-radius': px,
  'border-right': px,
  'border-right-width': px,
  'border-top': px,
  'border-top-left-radius': px,
  'border-top-right-radius': px,
  'border-top-width': px,
  'border-width': px,
  'border-block': px,
  'border-block-end': px,
  'border-block-end-width': px,
  'border-block-start': px,
  'border-block-start-width': px,
  'border-block-width': px,
  'border-inline': px,
  'border-inline-end': px,
  'border-inline-end-width': px,
  'border-inline-start': px,
  'border-inline-start-width': px,
  'border-inline-width': px,
  'border-start-start-radius': px,
  'border-start-end-radius': px,
  'border-end-start-radius': px,
  'border-end-end-radius': px,
  // Margin properties
  margin: px,
  'margin-bottom': px,
  'margin-left': px,
  'margin-right': px,
  'margin-top': px,
  'margin-block': px,
  'margin-block-end': px,
  'margin-block-start': px,
  'margin-inline': px,
  'margin-inline-end': px,
  'margin-inline-start': px,
  // Padding properties
  padding: px,
  'padding-bottom': px,
  'padding-left': px,
  'padding-right': px,
  'padding-top': px,
  'padding-block': px,
  'padding-block-end': px,
  'padding-block-start': px,
  'padding-inline': px,
  'padding-inline-end': px,
  'padding-inline-start': px,
  // Mask properties
  'mask-position-x': px,
  'mask-position-y': px,
  'mask-size': px,
  // Width and height properties
  height: px,
  width: px,
  'min-height': px,
  'max-height': px,
  'min-width': px,
  'max-width': px,
  // Position properties
  bottom: px,
  left: px,
  top: px,
  right: px,
  inset: px,
  'inset-block': px,
  'inset-block-end': px,
  'inset-block-start': px,
  'inset-inline': px,
  'inset-inline-end': px,
  'inset-inline-start': px,
  // Shadow properties
  'box-shadow': px,
  'text-shadow': px,
  // Column properties
  'column-gap': px,
  'column-rule': px,
  'column-rule-width': px,
  'column-width': px,
  // Font and text properties
  'font-size': px,
  'font-size-delta': px,
  'letter-spacing': px,
  'text-decoration-thickness': px,
  'text-indent': px,
  'text-stroke': px,
  'text-stroke-width': px,
  'word-spacing': px,
  // Motion properties
  motion: px,
  'motion-offset': px,
  // Outline properties
  outline: px,
  'outline-offset': px,
  'outline-width': px,
  // Perspective properties
  perspective: px,
  'perspective-origin-x': percent,
  'perspective-origin-y': percent,
  // Transform properties
  'transform-origin': percent,
  'transform-origin-x': percent,
  'transform-origin-y': percent,
  'transform-origin-z': percent,
  // Transition properties
  'transition-delay': ms,
  'transition-duration': ms,
  // Alignment properties
  'vertical-align': px,
  'flex-basis': px,
  // Some random properties
  'shape-margin': px,
  size: px,
  gap: px,
  // Grid properties
  grid: px,
  'grid-gap': px,
  'row-gap': px,
  'grid-row-gap': px,
  'grid-column-gap': px,
  'grid-template-rows': px,
  'grid-template-columns': px,
  'grid-auto-rows': px,
  'grid-auto-columns': px,
  // Not existing properties.
  // Used to avoid issues with jss-plugin-expand integration.
  'box-shadow-x': px,
  'box-shadow-y': px,
  'box-shadow-blur': px,
  'box-shadow-spread': px,
  'font-line-height': px,
  'text-shadow-x': px,
  'text-shadow-y': px,
  'text-shadow-blur': px
};

/**
 * Clones the object and adds a camel cased property version.
 */
function addCamelCasedVersion(obj) {
  var regExp = /(-[a-z])/g;

  var replace = function replace(str) {
    return str[1].toUpperCase();
  };

  var newObj = {};

  for (var _key in obj) {
    newObj[_key] = obj[_key];
    newObj[_key.replace(regExp, replace)] = obj[_key];
  }

  return newObj;
}

var units = addCamelCasedVersion(defaultUnits);
/**
 * Recursive deep style passing function
 */

function iterate(prop, value, options) {
  if (value == null) return value;

  if (Array.isArray(value)) {
    for (var i = 0; i < value.length; i++) {
      value[i] = iterate(prop, value[i], options);
    }
  } else if (typeof value === 'object') {
    if (prop === 'fallbacks') {
      for (var innerProp in value) {
        value[innerProp] = iterate(innerProp, value[innerProp], options);
      }
    } else {
      for (var _innerProp in value) {
        value[_innerProp] = iterate(prop + "-" + _innerProp, value[_innerProp], options);
      }
    } // eslint-disable-next-line no-restricted-globals

  } else if (typeof value === 'number' && isNaN(value) === false) {
    var unit = options[prop] || units[prop]; // Add the unit if available, except for the special case of 0px.

    if (unit && !(value === 0 && unit === px)) {
      return typeof unit === 'function' ? unit(value).toString() : "" + value + unit;
    }

    return value.toString();
  }

  return value;
}
/**
 * Add unit to numeric values.
 */


function defaultUnit(options) {
  if (options === void 0) {
    options = {};
  }

  var camelCasedOptions = addCamelCasedVersion(options);

  function onProcessStyle(style, rule) {
    if (rule.type !== 'style') return style;

    for (var prop in style) {
      style[prop] = iterate(prop, style[prop], camelCasedOptions);
    }

    return style;
  }

  function onChangeValue(value, prop) {
    return iterate(prop, value, camelCasedOptions);
  }

  return {
    onProcessStyle: onProcessStyle,
    onChangeValue: onChangeValue
  };
}// Export javascript style and css style vendor prefixes.
var js = '';
var css$1 = '';
var vendor = '';
var browser = '';
var isTouch = isBrowser$2 && 'ontouchstart' in document.documentElement; // We should not do anything if required serverside.

if (isBrowser$2) {
  // Order matters. We need to check Webkit the last one because
  // other vendors use to add Webkit prefixes to some properties
  var jsCssMap$1 = {
    Moz: '-moz-',
    ms: '-ms-',
    O: '-o-',
    Webkit: '-webkit-'
  };

  var _document$createEleme$1 = document.createElement('p'),
      style$1 = _document$createEleme$1.style;

  var testProp = 'Transform';

  for (var key in jsCssMap$1) {
    if (key + testProp in style$1) {
      js = key;
      css$1 = jsCssMap$1[key];
      break;
    }
  } // Correctly detect the Edge browser.


  if (js === 'Webkit' && 'msHyphens' in style$1) {
    js = 'ms';
    css$1 = jsCssMap$1.ms;
    browser = 'edge';
  } // Correctly detect the Safari browser.


  if (js === 'Webkit' && '-apple-trailing-word' in style$1) {
    vendor = 'apple';
  }
}
/**
 * Vendor prefix string for the current browser.
 *
 * @type {{js: String, css: String, vendor: String, browser: String}}
 * @api public
 */


var prefix = {
  js: js,
  css: css$1,
  vendor: vendor,
  browser: browser,
  isTouch: isTouch
};

/**
 * Test if a keyframe at-rule should be prefixed or not
 *
 * @param {String} vendor prefix string for the current browser.
 * @return {String}
 * @api public
 */

function supportedKeyframes(key) {
  // Keyframes is already prefixed. e.g. key = '@-webkit-keyframes a'
  if (key[1] === '-') return key; // No need to prefix IE/Edge. Older browsers will ignore unsupported rules.
  // https://caniuse.com/#search=keyframes

  if (prefix.js === 'ms') return key;
  return "@" + prefix.css + "keyframes" + key.substr(10);
}

// https://caniuse.com/#search=appearance

var appearence = {
  noPrefill: ['appearance'],
  supportedProperty: function supportedProperty(prop) {
    if (prop !== 'appearance') return false;
    if (prefix.js === 'ms') return "-webkit-" + prop;
    return prefix.css + prop;
  }
};

// https://caniuse.com/#search=color-adjust

var colorAdjust = {
  noPrefill: ['color-adjust'],
  supportedProperty: function supportedProperty(prop) {
    if (prop !== 'color-adjust') return false;
    if (prefix.js === 'Webkit') return prefix.css + "print-" + prop;
    return prop;
  }
};

var regExp = /[-\s]+(.)?/g;
/**
 * Replaces the letter with the capital letter
 *
 * @param {String} match
 * @param {String} c
 * @return {String}
 * @api private
 */

function toUpper(match, c) {
  return c ? c.toUpperCase() : '';
}
/**
 * Convert dash separated strings to camel-cased.
 *
 * @param {String} str
 * @return {String}
 * @api private
 */


function camelize(str) {
  return str.replace(regExp, toUpper);
}

/**
 * Convert dash separated strings to pascal cased.
 *
 * @param {String} str
 * @return {String}
 * @api private
 */

function pascalize(str) {
  return camelize("-" + str);
}

// but we can use a longhand property instead.
// https://caniuse.com/#search=mask

var mask = {
  noPrefill: ['mask'],
  supportedProperty: function supportedProperty(prop, style) {
    if (!/^mask/.test(prop)) return false;

    if (prefix.js === 'Webkit') {
      var longhand = 'mask-image';

      if (camelize(longhand) in style) {
        return prop;
      }

      if (prefix.js + pascalize(longhand) in style) {
        return prefix.css + prop;
      }
    }

    return prop;
  }
};

// https://caniuse.com/#search=text-orientation

var textOrientation = {
  noPrefill: ['text-orientation'],
  supportedProperty: function supportedProperty(prop) {
    if (prop !== 'text-orientation') return false;

    if (prefix.vendor === 'apple' && !prefix.isTouch) {
      return prefix.css + prop;
    }

    return prop;
  }
};

// https://caniuse.com/#search=transform

var transform = {
  noPrefill: ['transform'],
  supportedProperty: function supportedProperty(prop, style, options) {
    if (prop !== 'transform') return false;

    if (options.transform) {
      return prop;
    }

    return prefix.css + prop;
  }
};

// https://caniuse.com/#search=transition

var transition$1 = {
  noPrefill: ['transition'],
  supportedProperty: function supportedProperty(prop, style, options) {
    if (prop !== 'transition') return false;

    if (options.transition) {
      return prop;
    }

    return prefix.css + prop;
  }
};

// https://caniuse.com/#search=writing-mode

var writingMode = {
  noPrefill: ['writing-mode'],
  supportedProperty: function supportedProperty(prop) {
    if (prop !== 'writing-mode') return false;

    if (prefix.js === 'Webkit' || prefix.js === 'ms' && prefix.browser !== 'edge') {
      return prefix.css + prop;
    }

    return prop;
  }
};

// https://caniuse.com/#search=user-select

var userSelect = {
  noPrefill: ['user-select'],
  supportedProperty: function supportedProperty(prop) {
    if (prop !== 'user-select') return false;

    if (prefix.js === 'Moz' || prefix.js === 'ms' || prefix.vendor === 'apple') {
      return prefix.css + prop;
    }

    return prop;
  }
};

// https://caniuse.com/#search=multicolumn
// https://github.com/postcss/autoprefixer/issues/491
// https://github.com/postcss/autoprefixer/issues/177

var breakPropsOld = {
  supportedProperty: function supportedProperty(prop, style) {
    if (!/^break-/.test(prop)) return false;

    if (prefix.js === 'Webkit') {
      var jsProp = "WebkitColumn" + pascalize(prop);
      return jsProp in style ? prefix.css + "column-" + prop : false;
    }

    if (prefix.js === 'Moz') {
      var _jsProp = "page" + pascalize(prop);

      return _jsProp in style ? "page-" + prop : false;
    }

    return false;
  }
};

// See https://github.com/postcss/autoprefixer/issues/324.

var inlineLogicalOld = {
  supportedProperty: function supportedProperty(prop, style) {
    if (!/^(border|margin|padding)-inline/.test(prop)) return false;
    if (prefix.js === 'Moz') return prop;
    var newProp = prop.replace('-inline', '');
    return prefix.js + pascalize(newProp) in style ? prefix.css + newProp : false;
  }
};

// Camelization is required because we can't test using.
// CSS syntax for e.g. in FF.

var unprefixed = {
  supportedProperty: function supportedProperty(prop, style) {
    return camelize(prop) in style ? prop : false;
  }
};

var prefixed = {
  supportedProperty: function supportedProperty(prop, style) {
    var pascalized = pascalize(prop); // Return custom CSS variable without prefixing.

    if (prop[0] === '-') return prop; // Return already prefixed value without prefixing.

    if (prop[0] === '-' && prop[1] === '-') return prop;
    if (prefix.js + pascalized in style) return prefix.css + prop; // Try webkit fallback.

    if (prefix.js !== 'Webkit' && "Webkit" + pascalized in style) return "-webkit-" + prop;
    return false;
  }
};

// https://caniuse.com/#search=scroll-snap

var scrollSnap = {
  supportedProperty: function supportedProperty(prop) {
    if (prop.substring(0, 11) !== 'scroll-snap') return false;

    if (prefix.js === 'ms') {
      return "" + prefix.css + prop;
    }

    return prop;
  }
};

// https://caniuse.com/#search=overscroll-behavior

var overscrollBehavior = {
  supportedProperty: function supportedProperty(prop) {
    if (prop !== 'overscroll-behavior') return false;

    if (prefix.js === 'ms') {
      return prefix.css + "scroll-chaining";
    }

    return prop;
  }
};

var propMap = {
  'flex-grow': 'flex-positive',
  'flex-shrink': 'flex-negative',
  'flex-basis': 'flex-preferred-size',
  'justify-content': 'flex-pack',
  order: 'flex-order',
  'align-items': 'flex-align',
  'align-content': 'flex-line-pack' // 'align-self' is handled by 'align-self' plugin.

}; // Support old flex spec from 2012.

var flex2012 = {
  supportedProperty: function supportedProperty(prop, style) {
    var newProp = propMap[prop];
    if (!newProp) return false;
    return prefix.js + pascalize(newProp) in style ? prefix.css + newProp : false;
  }
};

var propMap$1 = {
  flex: 'box-flex',
  'flex-grow': 'box-flex',
  'flex-direction': ['box-orient', 'box-direction'],
  order: 'box-ordinal-group',
  'align-items': 'box-align',
  'flex-flow': ['box-orient', 'box-direction'],
  'justify-content': 'box-pack'
};
var propKeys = Object.keys(propMap$1);

var prefixCss = function prefixCss(p) {
  return prefix.css + p;
}; // Support old flex spec from 2009.


var flex2009 = {
  supportedProperty: function supportedProperty(prop, style, _ref) {
    var multiple = _ref.multiple;

    if (propKeys.indexOf(prop) > -1) {
      var newProp = propMap$1[prop];

      if (!Array.isArray(newProp)) {
        return prefix.js + pascalize(newProp) in style ? prefix.css + newProp : false;
      }

      if (!multiple) return false;

      for (var i = 0; i < newProp.length; i++) {
        if (!(prefix.js + pascalize(newProp[0]) in style)) {
          return false;
        }
      }

      return newProp.map(prefixCss);
    }

    return false;
  }
};

// plugins = [
//   ...plugins,
//    breakPropsOld,
//    inlineLogicalOld,
//    unprefixed,
//    prefixed,
//    scrollSnap,
//    flex2012,
//    flex2009
// ]
// Plugins without 'noPrefill' value, going last.
// 'flex-*' plugins should be at the bottom.
// 'flex2009' going after 'flex2012'.
// 'prefixed' going after 'unprefixed'

var plugins = [appearence, colorAdjust, mask, textOrientation, transform, transition$1, writingMode, userSelect, breakPropsOld, inlineLogicalOld, unprefixed, prefixed, scrollSnap, overscrollBehavior, flex2012, flex2009];
var propertyDetectors = plugins.filter(function (p) {
  return p.supportedProperty;
}).map(function (p) {
  return p.supportedProperty;
});
var noPrefill = plugins.filter(function (p) {
  return p.noPrefill;
}).reduce(function (a, p) {
  a.push.apply(a, _toConsumableArray(p.noPrefill));
  return a;
}, []);

var el;
var cache = {};

if (isBrowser$2) {
  el = document.createElement('p'); // We test every property on vendor prefix requirement.
  // Once tested, result is cached. It gives us up to 70% perf boost.
  // http://jsperf.com/element-style-object-access-vs-plain-object
  //
  // Prefill cache with known css properties to reduce amount of
  // properties we need to feature test at runtime.
  // http://davidwalsh.name/vendor-prefix

  var computed = window.getComputedStyle(document.documentElement, '');

  for (var key$1 in computed) {
    // eslint-disable-next-line no-restricted-globals
    if (!isNaN(key$1)) cache[computed[key$1]] = computed[key$1];
  } // Properties that cannot be correctly detected using the
  // cache prefill method.


  noPrefill.forEach(function (x) {
    return delete cache[x];
  });
}
/**
 * Test if a property is supported, returns supported property with vendor
 * prefix if required. Returns `false` if not supported.
 *
 * @param {String} prop dash separated
 * @param {Object} [options]
 * @return {String|Boolean}
 * @api public
 */


function supportedProperty(prop, options) {
  if (options === void 0) {
    options = {};
  }

  // For server-side rendering.
  if (!el) return prop; // Remove cache for benchmark tests or return property from the cache.

  if (cache[prop] != null) {
    return cache[prop];
  } // Check if 'transition' or 'transform' natively supported in browser.


  if (prop === 'transition' || prop === 'transform') {
    options[prop] = prop in el.style;
  } // Find a plugin for current prefix property.


  for (var i = 0; i < propertyDetectors.length; i++) {
    cache[prop] = propertyDetectors[i](prop, el.style, options); // Break loop, if value found.

    if (cache[prop]) break;
  } // Reset styles for current property.
  // Firefox can even throw an error for invalid properties, e.g., "0".


  try {
    el.style[prop] = '';
  } catch (err) {
    return false;
  }

  return cache[prop];
}

var cache$1 = {};
var transitionProperties = {
  transition: 1,
  'transition-property': 1,
  '-webkit-transition': 1,
  '-webkit-transition-property': 1
};
var transPropsRegExp = /(^\s*[\w-]+)|, (\s*[\w-]+)(?![^()]*\))/g;
var el$1;
/**
 * Returns prefixed value transition/transform if needed.
 *
 * @param {String} match
 * @param {String} p1
 * @param {String} p2
 * @return {String}
 * @api private
 */

function prefixTransitionCallback(match, p1, p2) {
  if (p1 === 'var') return 'var';
  if (p1 === 'all') return 'all';
  if (p2 === 'all') return ', all';
  var prefixedValue = p1 ? supportedProperty(p1) : ", " + supportedProperty(p2);
  if (!prefixedValue) return p1 || p2;
  return prefixedValue;
}

if (isBrowser$2) el$1 = document.createElement('p');
/**
 * Returns prefixed value if needed. Returns `false` if value is not supported.
 *
 * @param {String} property
 * @param {String} value
 * @return {String|Boolean}
 * @api public
 */

function supportedValue(property, value) {
  // For server-side rendering.
  var prefixedValue = value;
  if (!el$1 || property === 'content') return value; // It is a string or a number as a string like '1'.
  // We want only prefixable values here.
  // eslint-disable-next-line no-restricted-globals

  if (typeof prefixedValue !== 'string' || !isNaN(parseInt(prefixedValue, 10))) {
    return prefixedValue;
  } // Create cache key for current value.


  var cacheKey = property + prefixedValue; // Remove cache for benchmark tests or return value from cache.

  if (cache$1[cacheKey] != null) {
    return cache$1[cacheKey];
  } // IE can even throw an error in some cases, for e.g. style.content = 'bar'.


  try {
    // Test value as it is.
    el$1.style[property] = prefixedValue;
  } catch (err) {
    // Return false if value not supported.
    cache$1[cacheKey] = false;
    return false;
  } // If 'transition' or 'transition-property' property.


  if (transitionProperties[property]) {
    prefixedValue = prefixedValue.replace(transPropsRegExp, prefixTransitionCallback);
  } else if (el$1.style[property] === '') {
    // Value with a vendor prefix.
    prefixedValue = prefix.css + prefixedValue; // Hardcode test to convert "flex" to "-ms-flexbox" for IE10.

    if (prefixedValue === '-ms-flex') el$1.style[property] = '-ms-flexbox'; // Test prefixed value.

    el$1.style[property] = prefixedValue; // Return false if value not supported.

    if (el$1.style[property] === '') {
      cache$1[cacheKey] = false;
      return false;
    }
  } // Reset styles for current property.


  el$1.style[property] = ''; // Write current value to cache.

  cache$1[cacheKey] = prefixedValue;
  return cache$1[cacheKey];
}/**
 * Add vendor prefix to a property name when needed.
 *
 * @api public
 */

function jssVendorPrefixer() {
  function onProcessRule(rule) {
    if (rule.type === 'keyframes') {
      var atRule = rule;
      atRule.at = supportedKeyframes(atRule.at);
    }
  }

  function prefixStyle(style) {
    for (var prop in style) {
      var value = style[prop];

      if (prop === 'fallbacks' && Array.isArray(value)) {
        style[prop] = value.map(prefixStyle);
        continue;
      }

      var changeProp = false;
      var supportedProp = supportedProperty(prop);
      if (supportedProp && supportedProp !== prop) changeProp = true;
      var changeValue = false;
      var supportedValue$1 = supportedValue(supportedProp, toCssValue(value));
      if (supportedValue$1 && supportedValue$1 !== value) changeValue = true;

      if (changeProp || changeValue) {
        if (changeProp) delete style[prop];
        style[supportedProp || prop] = supportedValue$1 || value;
      }
    }

    return style;
  }

  function onProcessStyle(style, rule) {
    if (rule.type !== 'style') return style;
    return prefixStyle(style);
  }

  function onChangeValue(value, prop) {
    return supportedValue(prop, toCssValue(value)) || value;
  }

  return {
    onProcessRule: onProcessRule,
    onProcessStyle: onProcessStyle,
    onChangeValue: onChangeValue
  };
}/**
 * Sort props by length.
 */
function jssPropsSort() {
  var sort = function sort(prop0, prop1) {
    if (prop0.length === prop1.length) {
      return prop0 > prop1 ? 1 : -1;
    }

    return prop0.length - prop1.length;
  };

  return {
    onProcessStyle: function onProcessStyle(style, rule) {
      if (rule.type !== 'style') return style;
      var newStyle = {};
      var props = Object.keys(style).sort(sort);

      for (var i = 0; i < props.length; i++) {
        newStyle[props[i]] = style[props[i]];
      }

      return newStyle;
    }
  };
}function jssPreset() {
  return {
    plugins: [functions(), jssGlobal(), jssNested(), camelCase(), defaultUnit(), // Disable the vendor prefixer server-side, it does nothing.
    // This way, we can get a performance boost.
    // In the documentation, we are using `autoprefixer` to solve this problem.
    typeof window === 'undefined' ? null : jssVendorPrefixer(), jssPropsSort()]
  };
}function mergeClasses$2() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var baseClasses = options.baseClasses,
      newClasses = options.newClasses;
      options.Component;

  if (!newClasses) {
    return baseClasses;
  }

  var nextClasses = _extends$f({}, baseClasses);

  Object.keys(newClasses).forEach(function (key) {

    if (newClasses[key]) {
      nextClasses[key] = "".concat(baseClasses[key], " ").concat(newClasses[key]);
    }
  });
  return nextClasses;
}// Used https://github.com/thinkloop/multi-key-cache as inspiration
var multiKeyStore = {
  set: function set(cache, key1, key2, value) {
    var subCache = cache.get(key1);

    if (!subCache) {
      subCache = new Map();
      cache.set(key1, subCache);
    }

    subCache.set(key2, value);
  },
  get: function get(cache, key1, key2) {
    var subCache = cache.get(key1);
    return subCache ? subCache.get(key2) : undefined;
  },
  delete: function _delete(cache, key1, key2) {
    var subCache = cache.get(key1);
    subCache.delete(key2);
  }
};
var multiKeyStore$1 = multiKeyStore;var ThemeContext = React__default['default'].createContext(null);

var ThemeContext$1 = ThemeContext;function useTheme$1() {
  var theme = React__default['default'].useContext(ThemeContext$1);

  return theme;
}var jss = create(jssPreset()); // Use a singleton or the provided one by the context.
//
// The counter-based approach doesn't tolerate any mistake.
// It's much safer to use the same counter everywhere.

var generateClassName = createGenerateClassName(); // Exported for test purposes

var sheetsManager = new Map();
var defaultOptions = {
  disableGeneration: false,
  generateClassName: generateClassName,
  jss: jss,
  sheetsCache: null,
  sheetsManager: sheetsManager,
  sheetsRegistry: null
};
var StylesContext = React__default['default'].createContext(defaultOptions);/* eslint-disable import/prefer-default-export */
// Global index counter to preserve source order.
// We create the style sheet during the creation of the component,
// children are handled after the parents, so the order of style elements would be parent->child.
// It is a problem though when a parent passes a className
// which needs to override any child's styles.
// StyleSheet of the child has a higher specificity, because of the source order.
// So our solution is to render sheets them in the reverse order child->sheet, so
// that parent has a higher specificity.
var indexCounter = -1e9;
function increment() {
  indexCounter += 1;

  return indexCounter;
}// We use the same empty object to ref count the styles that don't need a theme object.
var noopTheme = {};
var noopTheme$1 = noopTheme;function getStylesCreator(stylesOrCreator) {
  var themingEnabled = typeof stylesOrCreator === 'function';

  return {
    create: function create(theme, name) {
      var styles;

      try {
        styles = themingEnabled ? stylesOrCreator(theme) : stylesOrCreator;
      } catch (err) {

        throw err;
      }

      if (!name || !theme.overrides || !theme.overrides[name]) {
        return styles;
      }

      var overrides = theme.overrides[name];

      var stylesWithOverrides = _extends$f({}, styles);

      Object.keys(overrides).forEach(function (key) {

        stylesWithOverrides[key] = deepmerge(stylesWithOverrides[key], overrides[key]);
      });
      return stylesWithOverrides;
    },
    options: {}
  };
}function getClasses(_ref, classes, Component) {
  var state = _ref.state,
      stylesOptions = _ref.stylesOptions;

  if (stylesOptions.disableGeneration) {
    return classes || {};
  }

  if (!state.cacheClasses) {
    state.cacheClasses = {
      // Cache for the finalized classes value.
      value: null,
      // Cache for the last used classes prop pointer.
      lastProp: null,
      // Cache for the last used rendered classes pointer.
      lastJSS: {}
    };
  } // Tracks if either the rendered classes or classes prop has changed,
  // requiring the generation of a new finalized classes object.


  var generate = false;

  if (state.classes !== state.cacheClasses.lastJSS) {
    state.cacheClasses.lastJSS = state.classes;
    generate = true;
  }

  if (classes !== state.cacheClasses.lastProp) {
    state.cacheClasses.lastProp = classes;
    generate = true;
  }

  if (generate) {
    state.cacheClasses.value = mergeClasses$2({
      baseClasses: state.cacheClasses.lastJSS,
      newClasses: classes,
      Component: Component
    });
  }

  return state.cacheClasses.value;
}

function attach(_ref2, props) {
  var state = _ref2.state,
      theme = _ref2.theme,
      stylesOptions = _ref2.stylesOptions,
      stylesCreator = _ref2.stylesCreator,
      name = _ref2.name;

  if (stylesOptions.disableGeneration) {
    return;
  }

  var sheetManager = multiKeyStore$1.get(stylesOptions.sheetsManager, stylesCreator, theme);

  if (!sheetManager) {
    sheetManager = {
      refs: 0,
      staticSheet: null,
      dynamicStyles: null
    };
    multiKeyStore$1.set(stylesOptions.sheetsManager, stylesCreator, theme, sheetManager);
  }

  var options = _extends$f({}, stylesCreator.options, stylesOptions, {
    theme: theme,
    flip: typeof stylesOptions.flip === 'boolean' ? stylesOptions.flip : theme.direction === 'rtl'
  });

  options.generateId = options.serverGenerateClassName || options.generateClassName;
  var sheetsRegistry = stylesOptions.sheetsRegistry;

  if (sheetManager.refs === 0) {
    var staticSheet;

    if (stylesOptions.sheetsCache) {
      staticSheet = multiKeyStore$1.get(stylesOptions.sheetsCache, stylesCreator, theme);
    }

    var styles = stylesCreator.create(theme, name);

    if (!staticSheet) {
      staticSheet = stylesOptions.jss.createStyleSheet(styles, _extends$f({
        link: false
      }, options));
      staticSheet.attach();

      if (stylesOptions.sheetsCache) {
        multiKeyStore$1.set(stylesOptions.sheetsCache, stylesCreator, theme, staticSheet);
      }
    }

    if (sheetsRegistry) {
      sheetsRegistry.add(staticSheet);
    }

    sheetManager.staticSheet = staticSheet;
    sheetManager.dynamicStyles = getDynamicStyles(styles);
  }

  if (sheetManager.dynamicStyles) {
    var dynamicSheet = stylesOptions.jss.createStyleSheet(sheetManager.dynamicStyles, _extends$f({
      link: true
    }, options));
    dynamicSheet.update(props);
    dynamicSheet.attach();
    state.dynamicSheet = dynamicSheet;
    state.classes = mergeClasses$2({
      baseClasses: sheetManager.staticSheet.classes,
      newClasses: dynamicSheet.classes
    });

    if (sheetsRegistry) {
      sheetsRegistry.add(dynamicSheet);
    }
  } else {
    state.classes = sheetManager.staticSheet.classes;
  }

  sheetManager.refs += 1;
}

function update$1(_ref3, props) {
  var state = _ref3.state;

  if (state.dynamicSheet) {
    state.dynamicSheet.update(props);
  }
}

function detach(_ref4) {
  var state = _ref4.state,
      theme = _ref4.theme,
      stylesOptions = _ref4.stylesOptions,
      stylesCreator = _ref4.stylesCreator;

  if (stylesOptions.disableGeneration) {
    return;
  }

  var sheetManager = multiKeyStore$1.get(stylesOptions.sheetsManager, stylesCreator, theme);
  sheetManager.refs -= 1;
  var sheetsRegistry = stylesOptions.sheetsRegistry;

  if (sheetManager.refs === 0) {
    multiKeyStore$1.delete(stylesOptions.sheetsManager, stylesCreator, theme);
    stylesOptions.jss.removeStyleSheet(sheetManager.staticSheet);

    if (sheetsRegistry) {
      sheetsRegistry.remove(sheetManager.staticSheet);
    }
  }

  if (state.dynamicSheet) {
    stylesOptions.jss.removeStyleSheet(state.dynamicSheet);

    if (sheetsRegistry) {
      sheetsRegistry.remove(state.dynamicSheet);
    }
  }
}

function useSynchronousEffect(func, values) {
  var key = React__default['default'].useRef([]);
  var output; // Store "generation" key. Just returns a new object every time

  var currentKey = React__default['default'].useMemo(function () {
    return {};
  }, values); // eslint-disable-line react-hooks/exhaustive-deps
  // "the first render", or "memo dropped the value"

  if (key.current !== currentKey) {
    key.current = currentKey;
    output = func();
  }

  React__default['default'].useEffect(function () {
    return function () {
      if (output) {
        output();
      }
    };
  }, [currentKey] // eslint-disable-line react-hooks/exhaustive-deps
  );
}

function makeStyles$1(stylesOrCreator) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var name = options.name,
      classNamePrefixOption = options.classNamePrefix,
      Component = options.Component,
      _options$defaultTheme = options.defaultTheme,
      defaultTheme = _options$defaultTheme === void 0 ? noopTheme$1 : _options$defaultTheme,
      stylesOptions2 = _objectWithoutProperties$4(options, ["name", "classNamePrefix", "Component", "defaultTheme"]);

  var stylesCreator = getStylesCreator(stylesOrCreator);
  var classNamePrefix = name || classNamePrefixOption || 'makeStyles';
  stylesCreator.options = {
    index: increment(),
    name: name,
    meta: classNamePrefix,
    classNamePrefix: classNamePrefix
  };

  var useStyles = function useStyles() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var theme = useTheme$1() || defaultTheme;

    var stylesOptions = _extends$f({}, React__default['default'].useContext(StylesContext), stylesOptions2);

    var instance = React__default['default'].useRef();
    var shouldUpdate = React__default['default'].useRef();
    useSynchronousEffect(function () {
      var current = {
        name: name,
        state: {},
        stylesCreator: stylesCreator,
        stylesOptions: stylesOptions,
        theme: theme
      };
      attach(current, props);
      shouldUpdate.current = false;
      instance.current = current;
      return function () {
        detach(current);
      };
    }, [theme, stylesCreator]);
    React__default['default'].useEffect(function () {
      if (shouldUpdate.current) {
        update$1(instance.current, props);
      }

      shouldUpdate.current = true;
    });
    var classes = getClasses(instance.current, props.classes, Component);

    return classes;
  };

  return useStyles;
}function _classCallCheck$d(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}function toVal(mix) {
	var k, y, str='';

	if (typeof mix === 'string' || typeof mix === 'number') {
		str += mix;
	} else if (typeof mix === 'object') {
		if (Array.isArray(mix)) {
			for (k=0; k < mix.length; k++) {
				if (mix[k]) {
					if (y = toVal(mix[k])) {
						str && (str += ' ');
						str += y;
					}
				}
			}
		} else {
			for (k in mix) {
				if (mix[k]) {
					str && (str += ' ');
					str += k;
				}
			}
		}
	}

	return str;
}

function clsx () {
	var i=0, tmp, x, str='';
	while (i < arguments.length) {
		if (tmp = arguments[i++]) {
			if (x = toVal(tmp)) {
				str && (str += ' ');
				str += x;
			}
		}
	}
	return str;
}var reactIs = require$$0__default['default'];

/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var REACT_STATICS = {
  childContextTypes: true,
  contextType: true,
  contextTypes: true,
  defaultProps: true,
  displayName: true,
  getDefaultProps: true,
  getDerivedStateFromError: true,
  getDerivedStateFromProps: true,
  mixins: true,
  propTypes: true,
  type: true
};
var KNOWN_STATICS = {
  name: true,
  length: true,
  prototype: true,
  caller: true,
  callee: true,
  arguments: true,
  arity: true
};
var FORWARD_REF_STATICS = {
  '$$typeof': true,
  render: true,
  defaultProps: true,
  displayName: true,
  propTypes: true
};
var MEMO_STATICS = {
  '$$typeof': true,
  compare: true,
  defaultProps: true,
  displayName: true,
  propTypes: true,
  type: true
};
var TYPE_STATICS = {};
TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;
TYPE_STATICS[reactIs.Memo] = MEMO_STATICS;

function getStatics(component) {
  // React v16.11 and below
  if (reactIs.isMemo(component)) {
    return MEMO_STATICS;
  } // React v16.12 and above


  return TYPE_STATICS[component['$$typeof']] || REACT_STATICS;
}

var defineProperty$1 = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = Object.prototype;
function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
  if (typeof sourceComponent !== 'string') {
    // don't hoist over string (html) components
    if (objectPrototype) {
      var inheritedComponent = getPrototypeOf(sourceComponent);

      if (inheritedComponent && inheritedComponent !== objectPrototype) {
        hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
      }
    }

    var keys = getOwnPropertyNames(sourceComponent);

    if (getOwnPropertySymbols) {
      keys = keys.concat(getOwnPropertySymbols(sourceComponent));
    }

    var targetStatics = getStatics(targetComponent);
    var sourceStatics = getStatics(sourceComponent);

    for (var i = 0; i < keys.length; ++i) {
      var key = keys[i];

      if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
        var descriptor = getOwnPropertyDescriptor(sourceComponent, key);

        try {
          // Avoid failures from read-only properties
          defineProperty$1(targetComponent, key, descriptor);
        } catch (e) {}
      }
    }
  }

  return targetComponent;
}

var hoistNonReactStatics_cjs = hoistNonReactStatics;function mergeOuterLocalTheme(outerTheme, localTheme) {
  if (typeof localTheme === 'function') {
    var mergedTheme = localTheme(outerTheme);

    return mergedTheme;
  }

  return _extends$f({}, outerTheme, localTheme);
}
/**
 * This component takes a `theme` prop.
 * It makes the `theme` available down the React tree thanks to React context.
 * This component should preferably be used at **the root of your component tree**.
 */


function ThemeProvider(props) {
  var children = props.children,
      localTheme = props.theme;
  var outerTheme = useTheme$1();

  var theme = React__default['default'].useMemo(function () {
    var output = outerTheme === null ? localTheme : mergeOuterLocalTheme(outerTheme, localTheme);

    if (output != null) {
      output[nested] = outerTheme !== null;
    }

    return output;
  }, [localTheme, outerTheme]);
  return /*#__PURE__*/React__default['default'].createElement(ThemeContext$1.Provider, {
    value: theme
  }, children);
}// It does not modify the component passed to it;
// instead, it returns a new component, with a `classes` property.

var withStyles$1 = function withStyles(stylesOrCreator) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return function (Component) {
    var defaultTheme = options.defaultTheme,
        _options$withTheme = options.withTheme,
        withTheme = _options$withTheme === void 0 ? false : _options$withTheme,
        name = options.name,
        stylesOptions = _objectWithoutProperties$4(options, ["defaultTheme", "withTheme", "name"]);

    var classNamePrefix = name;

    var useStyles = makeStyles$1(stylesOrCreator, _extends$f({
      defaultTheme: defaultTheme,
      Component: Component,
      name: name || Component.displayName,
      classNamePrefix: classNamePrefix
    }, stylesOptions));
    var WithStyles = /*#__PURE__*/React__default['default'].forwardRef(function WithStyles(props, ref) {
      props.classes;
          var innerRef = props.innerRef,
          other = _objectWithoutProperties$4(props, ["classes", "innerRef"]); // The wrapper receives only user supplied props, which could be a subset of
      // the actual props Component might receive due to merging with defaultProps.
      // So copying it here would give us the same result in the wrapper as well.


      var classes = useStyles(_extends$f({}, Component.defaultProps, props));
      var theme;
      var more = other;

      if (typeof name === 'string' || withTheme) {
        // name and withTheme are invariant in the outer scope
        // eslint-disable-next-line react-hooks/rules-of-hooks
        theme = useTheme$1() || defaultTheme;

        if (name) {
          more = getThemeProps({
            theme: theme,
            name: name,
            props: other
          });
        } // Provide the theme to the wrapped component.
        // So we don't have to use the `withTheme()` Higher-order Component.


        if (withTheme && !more.theme) {
          more.theme = theme;
        }
      }

      return /*#__PURE__*/React__default['default'].createElement(Component, _extends$f({
        ref: innerRef || ref,
        classes: classes
      }, more));
    });

    hoistNonReactStatics_cjs(WithStyles, Component);

    return WithStyles;
  };
};

var withStylesWithoutDefault = withStyles$1;// To remove in v5

function createStyles(styles) {
  // warning(
  //   warnOnce,
  //   [
  //     'Material-UI: createStyles from @material-ui/core/styles is deprecated.',
  //     'Please use @material-ui/styles/createStyles',
  //   ].join('\n'),
  // );
  // warnOnce = true;
  return createStyles$1(styles);
}var defaultTheme = createTheme();
var defaultTheme$1 = defaultTheme;function makeStyles(stylesOrCreator) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return makeStyles$1(stylesOrCreator, _extends$f({
    defaultTheme: defaultTheme$1
  }, options));
}function useTheme() {
  var theme = useTheme$1() || defaultTheme$1;

  return theme;
}function withStyles(stylesOrCreator, options) {
  return withStylesWithoutDefault(stylesOrCreator, _extends$f({
    defaultTheme: defaultTheme$1
  }, options));
}// It should to be noted that this function isn't equivalent to `text-transform: capitalize`.
//
// A strict capitalization should uppercase the first letter of each word a the sentence.
// We only handle the first word.
function capitalize(string) {
  if (typeof string !== 'string') {
    throw new Error(formatMuiErrorMessage(7));
  }

  return string.charAt(0).toUpperCase() + string.slice(1);
}/**
 * Safe chained function
 *
 * Will only create a new function if needed,
 * otherwise will pass back existing functions or null.
 *
 * @param {function} functions to chain
 * @returns {function|null}
 */
function createChainedFunction() {
  for (var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }

  return funcs.reduce(function (acc, func) {
    if (func == null) {
      return acc;
    }

    return function chainedFunction() {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      acc.apply(this, args);
      func.apply(this, args);
    };
  }, function () {});
}var styles$C = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      userSelect: 'none',
      width: '1em',
      height: '1em',
      display: 'inline-block',
      fill: 'currentColor',
      flexShrink: 0,
      fontSize: theme.typography.pxToRem(24),
      transition: theme.transitions.create('fill', {
        duration: theme.transitions.duration.shorter
      })
    },

    /* Styles applied to the root element if `color="primary"`. */
    colorPrimary: {
      color: theme.palette.primary.main
    },

    /* Styles applied to the root element if `color="secondary"`. */
    colorSecondary: {
      color: theme.palette.secondary.main
    },

    /* Styles applied to the root element if `color="action"`. */
    colorAction: {
      color: theme.palette.action.active
    },

    /* Styles applied to the root element if `color="error"`. */
    colorError: {
      color: theme.palette.error.main
    },

    /* Styles applied to the root element if `color="disabled"`. */
    colorDisabled: {
      color: theme.palette.action.disabled
    },

    /* Styles applied to the root element if `fontSize="inherit"`. */
    fontSizeInherit: {
      fontSize: 'inherit'
    },

    /* Styles applied to the root element if `fontSize="small"`. */
    fontSizeSmall: {
      fontSize: theme.typography.pxToRem(20)
    },

    /* Styles applied to the root element if `fontSize="large"`. */
    fontSizeLarge: {
      fontSize: theme.typography.pxToRem(35)
    }
  };
};
var SvgIcon = /*#__PURE__*/React__namespace.forwardRef(function SvgIcon(props, ref) {
  var children = props.children,
      classes = props.classes,
      className = props.className,
      _props$color = props.color,
      color = _props$color === void 0 ? 'inherit' : _props$color,
      _props$component = props.component,
      Component = _props$component === void 0 ? 'svg' : _props$component,
      _props$fontSize = props.fontSize,
      fontSize = _props$fontSize === void 0 ? 'medium' : _props$fontSize,
      htmlColor = props.htmlColor,
      titleAccess = props.titleAccess,
      _props$viewBox = props.viewBox,
      viewBox = _props$viewBox === void 0 ? '0 0 24 24' : _props$viewBox,
      other = _objectWithoutProperties$4(props, ["children", "classes", "className", "color", "component", "fontSize", "htmlColor", "titleAccess", "viewBox"]);

  return /*#__PURE__*/React__namespace.createElement(Component, _extends$f({
    className: clsx(classes.root, className, color !== 'inherit' && classes["color".concat(capitalize(color))], fontSize !== 'default' && fontSize !== 'medium' && classes["fontSize".concat(capitalize(fontSize))]),
    focusable: "false",
    viewBox: viewBox,
    color: htmlColor,
    "aria-hidden": titleAccess ? undefined : true,
    role: titleAccess ? 'img' : undefined,
    ref: ref
  }, other), children, titleAccess ? /*#__PURE__*/React__namespace.createElement("title", null, titleAccess) : null);
});
SvgIcon.muiName = 'SvgIcon';
var SvgIcon$1 = withStyles(styles$C, {
  name: 'MuiSvgIcon'
})(SvgIcon);/**
 * Private module reserved for @material-ui/x packages.
 */

function createSvgIcon(path, displayName) {
  var Component = function Component(props, ref) {
    return /*#__PURE__*/React__default['default'].createElement(SvgIcon$1, _extends$f({
      ref: ref
    }, props), path);
  };

  Component.muiName = SvgIcon$1.muiName;
  return /*#__PURE__*/React__default['default'].memo( /*#__PURE__*/React__default['default'].forwardRef(Component));
}// Corresponds to 10 frames at 60 Hz.
// A few bytes payload overhead when lodash/debounce is ~3 kB and debounce ~300 B.
function debounce$4(func) {
  var wait = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 166;
  var timeout;

  function debounced() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    // eslint-disable-next-line consistent-this
    var that = this;

    var later = function later() {
      func.apply(that, args);
    };

    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  }

  debounced.clear = function () {
    clearTimeout(timeout);
  };

  return debounced;
}function isMuiElement(element, muiNames) {
  return /*#__PURE__*/React__namespace.isValidElement(element) && muiNames.indexOf(element.type.muiName) !== -1;
}function ownerDocument(node) {
  return node && node.ownerDocument || document;
}function ownerWindow(node) {
  var doc = ownerDocument(node);
  return doc.defaultView || window;
}// TODO v5: consider to make it private
function setRef(ref, value) {
  if (typeof ref === 'function') {
    ref(value);
  } else if (ref) {
    ref.current = value;
  }
}/* eslint-disable react-hooks/rules-of-hooks, react-hooks/exhaustive-deps */
function useControlled(_ref) {
  var controlled = _ref.controlled,
      defaultProp = _ref.default;
      _ref.name;
      _ref.state;

  var _React$useRef = React__namespace.useRef(controlled !== undefined),
      isControlled = _React$useRef.current;

  var _React$useState = React__namespace.useState(defaultProp),
      valueState = _React$useState[0],
      setValue = _React$useState[1];

  var value = isControlled ? controlled : valueState;

  var setValueIfUncontrolled = React__namespace.useCallback(function (newValue) {
    if (!isControlled) {
      setValue(newValue);
    }
  }, []);
  return [value, setValueIfUncontrolled];
}var useEnhancedEffect$6 = typeof window !== 'undefined' ? React__namespace.useLayoutEffect : React__namespace.useEffect;
/**
 * https://github.com/facebook/react/issues/14099#issuecomment-440013892
 *
 * @param {function} fn
 */

function useEventCallback(fn) {
  var ref = React__namespace.useRef(fn);
  useEnhancedEffect$6(function () {
    ref.current = fn;
  });
  return React__namespace.useCallback(function () {
    return (ref.current).apply(void 0, arguments);
  }, []);
}function useForkRef(refA, refB) {
  /**
   * This will create a new function if the ref props change and are defined.
   * This means react will call the old forkRef with `null` and the new forkRef
   * with the ref. Cleanup naturally emerges from this behavior
   */
  return React__namespace.useMemo(function () {
    if (refA == null && refB == null) {
      return null;
    }

    return function (refValue) {
      setRef(refA, refValue);
      setRef(refB, refValue);
    };
  }, [refA, refB]);
}/**
 * Private module reserved for @material-ui/x packages.
 */

function useId(idOverride) {
  var _React$useState = React__namespace.useState(idOverride),
      defaultId = _React$useState[0],
      setDefaultId = _React$useState[1];

  var id = idOverride || defaultId;
  React__namespace.useEffect(function () {
    if (defaultId == null) {
      // Fallback to this default id when possible.
      // Use the random value for client-side rendering only.
      // We can't use it server-side.
      setDefaultId("mui-".concat(Math.round(Math.random() * 1e5)));
    }
  }, [defaultId]);
  return id;
}// based on https://github.com/WICG/focus-visible/blob/v4.1.5/src/focus-visible.js
var hadKeyboardEvent = true;
var hadFocusVisibleRecently = false;
var hadFocusVisibleRecentlyTimeout = null;
var inputTypesWhitelist = {
  text: true,
  search: true,
  url: true,
  tel: true,
  email: true,
  password: true,
  number: true,
  date: true,
  month: true,
  week: true,
  time: true,
  datetime: true,
  'datetime-local': true
};
/**
 * Computes whether the given element should automatically trigger the
 * `focus-visible` class being added, i.e. whether it should always match
 * `:focus-visible` when focused.
 * @param {Element} node
 * @return {boolean}
 */

function focusTriggersKeyboardModality(node) {
  var type = node.type,
      tagName = node.tagName;

  if (tagName === 'INPUT' && inputTypesWhitelist[type] && !node.readOnly) {
    return true;
  }

  if (tagName === 'TEXTAREA' && !node.readOnly) {
    return true;
  }

  if (node.isContentEditable) {
    return true;
  }

  return false;
}
/**
 * Keep track of our keyboard modality state with `hadKeyboardEvent`.
 * If the most recent user interaction was via the keyboard;
 * and the key press did not include a meta, alt/option, or control key;
 * then the modality is keyboard. Otherwise, the modality is not keyboard.
 * @param {KeyboardEvent} event
 */


function handleKeyDown(event) {
  if (event.metaKey || event.altKey || event.ctrlKey) {
    return;
  }

  hadKeyboardEvent = true;
}
/**
 * If at any point a user clicks with a pointing device, ensure that we change
 * the modality away from keyboard.
 * This avoids the situation where a user presses a key on an already focused
 * element, and then clicks on a different element, focusing it with a
 * pointing device, while we still think we're in keyboard modality.
 */


function handlePointerDown() {
  hadKeyboardEvent = false;
}

function handleVisibilityChange() {
  if (this.visibilityState === 'hidden') {
    // If the tab becomes active again, the browser will handle calling focus
    // on the element (Safari actually calls it twice).
    // If this tab change caused a blur on an element with focus-visible,
    // re-apply the class when the user switches back to the tab.
    if (hadFocusVisibleRecently) {
      hadKeyboardEvent = true;
    }
  }
}

function prepare(doc) {
  doc.addEventListener('keydown', handleKeyDown, true);
  doc.addEventListener('mousedown', handlePointerDown, true);
  doc.addEventListener('pointerdown', handlePointerDown, true);
  doc.addEventListener('touchstart', handlePointerDown, true);
  doc.addEventListener('visibilitychange', handleVisibilityChange, true);
}

function isFocusVisible(event) {
  var target = event.target;

  try {
    return target.matches(':focus-visible');
  } catch (error) {} // browsers not implementing :focus-visible will throw a SyntaxError
  // we use our own heuristic for those browsers
  // rethrow might be better if it's not the expected error but do we really
  // want to crash if focus-visible malfunctioned?
  // no need for validFocusTarget check. the user does that by attaching it to
  // focusable events only


  return hadKeyboardEvent || focusTriggersKeyboardModality(target);
}
/**
 * Should be called if a blur event is fired on a focus-visible element
 */


function handleBlurVisible() {
  // To detect a tab/window switch, we look for a blur event followed
  // rapidly by a visibility change.
  // If we don't see a visibility change within 100ms, it's probably a
  // regular focus change.
  hadFocusVisibleRecently = true;
  window.clearTimeout(hadFocusVisibleRecentlyTimeout);
  hadFocusVisibleRecentlyTimeout = window.setTimeout(function () {
    hadFocusVisibleRecently = false;
  }, 100);
}

function useIsFocusVisible() {
  var ref = React__namespace.useCallback(function (instance) {
    var node = ReactDOM__namespace.findDOMNode(instance);

    if (node != null) {
      prepare(node.ownerDocument);
    }
  }, []);

  return {
    isFocusVisible: isFocusVisible,
    onBlurVisible: handleBlurVisible,
    ref: ref
  };
}/**
 * Checks if a given element has a CSS class.
 * 
 * @param element the element
 * @param className the CSS class name
 */
function hasClass(element, className) {
  if (element.classList) return !!className && element.classList.contains(className);
  return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
}/**
 * Adds a CSS class to a given element.
 * 
 * @param element the element
 * @param className the CSS class name
 */

function addClass(element, className) {
  if (element.classList) element.classList.add(className);else if (!hasClass(element, className)) if (typeof element.className === 'string') element.className = element.className + " " + className;else element.setAttribute('class', (element.className && element.className.baseVal || '') + " " + className);
}function replaceClassName(origClass, classToRemove) {
  return origClass.replace(new RegExp("(^|\\s)" + classToRemove + "(?:\\s|$)", 'g'), '$1').replace(/\s+/g, ' ').replace(/^\s*|\s*$/g, '');
}
/**
 * Removes a CSS class from a given element.
 * 
 * @param element the element
 * @param className the CSS class name
 */


function removeClass$1(element, className) {
  if (element.classList) {
    element.classList.remove(className);
  } else if (typeof element.className === 'string') {
    element.className = replaceClassName(element.className, className);
  } else {
    element.setAttribute('class', replaceClassName(element.className && element.className.baseVal || '', className));
  }
}var config = {
  disabled: false
};var TransitionGroupContext = React__default['default'].createContext(null);var UNMOUNTED = 'unmounted';
var EXITED = 'exited';
var ENTERING = 'entering';
var ENTERED = 'entered';
var EXITING = 'exiting';
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * ---
 *
 * **Note**: `Transition` is a platform-agnostic base component. If you're using
 * transitions in CSS, you'll probably want to use
 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
 * instead. It inherits all the features of `Transition`, but contains
 * additional features necessary to play nice with CSS transitions (hence the
 * name of the component).
 *
 * ---
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the
 * components. It's up to you to give meaning and effect to those states. For
 * example we can add styles to a component when it enters or exits:
 *
 * ```jsx
 * import { Transition } from 'react-transition-group';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 1 },
 *   entered:  { opacity: 1 },
 *   exiting:  { opacity: 0 },
 *   exited:  { opacity: 0 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {state => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component
 * begins the "Enter" stage. During this stage, the component will shift from
 * its current transition state, to `'entering'` for the duration of the
 * transition and then to the `'entered'` stage once it's complete. Let's take
 * the following example (we'll use the
 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <Transition in={inProp} timeout={500}>
 *         {state => (
 *           // ...
 *         )}
 *       </Transition>
 *       <button onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state
 * and stay there for 500ms (the value of `timeout`) before it finally switches
 * to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from
 * `'exiting'` to `'exited'`.
 */

var Transition = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(Transition, _React$Component);

  function Transition(props, context) {
    var _this;

    _this = _React$Component.call(this, props, context) || this;
    var parentGroup = context; // In the context of a TransitionGroup all enters are really appears

    var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
    var initialStatus;
    _this.appearStatus = null;

    if (props.in) {
      if (appear) {
        initialStatus = EXITED;
        _this.appearStatus = ENTERING;
      } else {
        initialStatus = ENTERED;
      }
    } else {
      if (props.unmountOnExit || props.mountOnEnter) {
        initialStatus = UNMOUNTED;
      } else {
        initialStatus = EXITED;
      }
    }

    _this.state = {
      status: initialStatus
    };
    _this.nextCallback = null;
    return _this;
  }

  Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
    var nextIn = _ref.in;

    if (nextIn && prevState.status === UNMOUNTED) {
      return {
        status: EXITED
      };
    }

    return null;
  } // getSnapshotBeforeUpdate(prevProps) {
  //   let nextStatus = null
  //   if (prevProps !== this.props) {
  //     const { status } = this.state
  //     if (this.props.in) {
  //       if (status !== ENTERING && status !== ENTERED) {
  //         nextStatus = ENTERING
  //       }
  //     } else {
  //       if (status === ENTERING || status === ENTERED) {
  //         nextStatus = EXITING
  //       }
  //     }
  //   }
  //   return { nextStatus }
  // }
  ;

  var _proto = Transition.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.updateStatus(true, this.appearStatus);
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    var nextStatus = null;

    if (prevProps !== this.props) {
      var status = this.state.status;

      if (this.props.in) {
        if (status !== ENTERING && status !== ENTERED) {
          nextStatus = ENTERING;
        }
      } else {
        if (status === ENTERING || status === ENTERED) {
          nextStatus = EXITING;
        }
      }
    }

    this.updateStatus(false, nextStatus);
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.cancelNextCallback();
  };

  _proto.getTimeouts = function getTimeouts() {
    var timeout = this.props.timeout;
    var exit, enter, appear;
    exit = enter = appear = timeout;

    if (timeout != null && typeof timeout !== 'number') {
      exit = timeout.exit;
      enter = timeout.enter; // TODO: remove fallback for next major

      appear = timeout.appear !== undefined ? timeout.appear : enter;
    }

    return {
      exit: exit,
      enter: enter,
      appear: appear
    };
  };

  _proto.updateStatus = function updateStatus(mounting, nextStatus) {
    if (mounting === void 0) {
      mounting = false;
    }

    if (nextStatus !== null) {
      // nextStatus will always be ENTERING or EXITING.
      this.cancelNextCallback();

      if (nextStatus === ENTERING) {
        this.performEnter(mounting);
      } else {
        this.performExit();
      }
    } else if (this.props.unmountOnExit && this.state.status === EXITED) {
      this.setState({
        status: UNMOUNTED
      });
    }
  };

  _proto.performEnter = function performEnter(mounting) {
    var _this2 = this;

    var enter = this.props.enter;
    var appearing = this.context ? this.context.isMounting : mounting;

    var _ref2 = this.props.nodeRef ? [appearing] : [ReactDOM__default['default'].findDOMNode(this), appearing],
        maybeNode = _ref2[0],
        maybeAppearing = _ref2[1];

    var timeouts = this.getTimeouts();
    var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
    // if we are mounting and running this it means appear _must_ be set

    if (!mounting && !enter || config.disabled) {
      this.safeSetState({
        status: ENTERED
      }, function () {
        _this2.props.onEntered(maybeNode);
      });
      return;
    }

    this.props.onEnter(maybeNode, maybeAppearing);
    this.safeSetState({
      status: ENTERING
    }, function () {
      _this2.props.onEntering(maybeNode, maybeAppearing);

      _this2.onTransitionEnd(enterTimeout, function () {
        _this2.safeSetState({
          status: ENTERED
        }, function () {
          _this2.props.onEntered(maybeNode, maybeAppearing);
        });
      });
    });
  };

  _proto.performExit = function performExit() {
    var _this3 = this;

    var exit = this.props.exit;
    var timeouts = this.getTimeouts();
    var maybeNode = this.props.nodeRef ? undefined : ReactDOM__default['default'].findDOMNode(this); // no exit animation skip right to EXITED

    if (!exit || config.disabled) {
      this.safeSetState({
        status: EXITED
      }, function () {
        _this3.props.onExited(maybeNode);
      });
      return;
    }

    this.props.onExit(maybeNode);
    this.safeSetState({
      status: EXITING
    }, function () {
      _this3.props.onExiting(maybeNode);

      _this3.onTransitionEnd(timeouts.exit, function () {
        _this3.safeSetState({
          status: EXITED
        }, function () {
          _this3.props.onExited(maybeNode);
        });
      });
    });
  };

  _proto.cancelNextCallback = function cancelNextCallback() {
    if (this.nextCallback !== null) {
      this.nextCallback.cancel();
      this.nextCallback = null;
    }
  };

  _proto.safeSetState = function safeSetState(nextState, callback) {
    // This shouldn't be necessary, but there are weird race conditions with
    // setState callbacks and unmounting in testing, so always make sure that
    // we can cancel any pending setState callbacks after we unmount.
    callback = this.setNextCallback(callback);
    this.setState(nextState, callback);
  };

  _proto.setNextCallback = function setNextCallback(callback) {
    var _this4 = this;

    var active = true;

    this.nextCallback = function (event) {
      if (active) {
        active = false;
        _this4.nextCallback = null;
        callback(event);
      }
    };

    this.nextCallback.cancel = function () {
      active = false;
    };

    return this.nextCallback;
  };

  _proto.onTransitionEnd = function onTransitionEnd(timeout, handler) {
    this.setNextCallback(handler);
    var node = this.props.nodeRef ? this.props.nodeRef.current : ReactDOM__default['default'].findDOMNode(this);
    var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;

    if (!node || doesNotHaveTimeoutOrListener) {
      setTimeout(this.nextCallback, 0);
      return;
    }

    if (this.props.addEndListener) {
      var _ref3 = this.props.nodeRef ? [this.nextCallback] : [node, this.nextCallback],
          maybeNode = _ref3[0],
          maybeNextCallback = _ref3[1];

      this.props.addEndListener(maybeNode, maybeNextCallback);
    }

    if (timeout != null) {
      setTimeout(this.nextCallback, timeout);
    }
  };

  _proto.render = function render() {
    var status = this.state.status;

    if (status === UNMOUNTED) {
      return null;
    }

    var _this$props = this.props,
        children = _this$props.children;
        _this$props.in;
        _this$props.mountOnEnter;
        _this$props.unmountOnExit;
        _this$props.appear;
        _this$props.enter;
        _this$props.exit;
        _this$props.timeout;
        _this$props.addEndListener;
        _this$props.onEnter;
        _this$props.onEntering;
        _this$props.onEntered;
        _this$props.onExit;
        _this$props.onExiting;
        _this$props.onExited;
        _this$props.nodeRef;
        var childProps = _objectWithoutPropertiesLoose(_this$props, ["children", "in", "mountOnEnter", "unmountOnExit", "appear", "enter", "exit", "timeout", "addEndListener", "onEnter", "onEntering", "onEntered", "onExit", "onExiting", "onExited", "nodeRef"]);

    return (
      /*#__PURE__*/
      // allows for nested Transitions
      React__default['default'].createElement(TransitionGroupContext.Provider, {
        value: null
      }, typeof children === 'function' ? children(status, childProps) : React__default['default'].cloneElement(React__default['default'].Children.only(children), childProps))
    );
  };

  return Transition;
}(React__default['default'].Component);

Transition.contextType = TransitionGroupContext;
Transition.propTypes = {}; // Name the function so it is clearer in the documentation

function noop$4() {}

Transition.defaultProps = {
  in: false,
  mountOnEnter: false,
  unmountOnExit: false,
  appear: false,
  enter: true,
  exit: true,
  onEnter: noop$4,
  onEntering: noop$4,
  onEntered: noop$4,
  onExit: noop$4,
  onExiting: noop$4,
  onExited: noop$4
};
Transition.UNMOUNTED = UNMOUNTED;
Transition.EXITED = EXITED;
Transition.ENTERING = ENTERING;
Transition.ENTERED = ENTERED;
Transition.EXITING = EXITING;
var Transition$1 = Transition;var _addClass = function addClass$1(node, classes) {
  return node && classes && classes.split(' ').forEach(function (c) {
    return addClass(node, c);
  });
};

var removeClass = function removeClass(node, classes) {
  return node && classes && classes.split(' ').forEach(function (c) {
    return removeClass$1(node, c);
  });
};
/**
 * A transition component inspired by the excellent
 * [ng-animate](https://docs.angularjs.org/api/ngAnimate) library, you should
 * use it if you're using CSS transitions or animations. It's built upon the
 * [`Transition`](https://reactcommunity.org/react-transition-group/transition)
 * component, so it inherits all of its props.
 *
 * `CSSTransition` applies a pair of class names during the `appear`, `enter`,
 * and `exit` states of the transition. The first class is applied and then a
 * second `*-active` class in order to activate the CSS transition. After the
 * transition, matching `*-done` class names are applied to persist the
 * transition state.
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <CSSTransition in={inProp} timeout={200} classNames="my-node">
 *         <div>
 *           {"I'll receive my-node-* classes"}
 *         </div>
 *       </CSSTransition>
 *       <button type="button" onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the `in` prop is set to `true`, the child component will first receive
 * the class `example-enter`, then the `example-enter-active` will be added in
 * the next tick. `CSSTransition` [forces a
 * reflow](https://github.com/reactjs/react-transition-group/blob/5007303e729a74be66a21c3e2205e4916821524b/src/CSSTransition.js#L208-L215)
 * between before adding the `example-enter-active`. This is an important trick
 * because it allows us to transition between `example-enter` and
 * `example-enter-active` even though they were added immediately one after
 * another. Most notably, this is what makes it possible for us to animate
 * _appearance_.
 *
 * ```css
 * .my-node-enter {
 *   opacity: 0;
 * }
 * .my-node-enter-active {
 *   opacity: 1;
 *   transition: opacity 200ms;
 * }
 * .my-node-exit {
 *   opacity: 1;
 * }
 * .my-node-exit-active {
 *   opacity: 0;
 *   transition: opacity 200ms;
 * }
 * ```
 *
 * `*-active` classes represent which styles you want to animate **to**, so it's
 * important to add `transition` declaration only to them, otherwise transitions
 * might not behave as intended! This might not be obvious when the transitions
 * are symmetrical, i.e. when `*-enter-active` is the same as `*-exit`, like in
 * the example above (minus `transition`), but it becomes apparent in more
 * complex transitions.
 *
 * **Note**: If you're using the
 * [`appear`](http://reactcommunity.org/react-transition-group/transition#Transition-prop-appear)
 * prop, make sure to define styles for `.appear-*` classes as well.
 */


var CSSTransition = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(CSSTransition, _React$Component);

  function CSSTransition() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    _this.appliedClasses = {
      appear: {},
      enter: {},
      exit: {}
    };

    _this.onEnter = function (maybeNode, maybeAppearing) {
      var _this$resolveArgument = _this.resolveArguments(maybeNode, maybeAppearing),
          node = _this$resolveArgument[0],
          appearing = _this$resolveArgument[1];

      _this.removeClasses(node, 'exit');

      _this.addClass(node, appearing ? 'appear' : 'enter', 'base');

      if (_this.props.onEnter) {
        _this.props.onEnter(maybeNode, maybeAppearing);
      }
    };

    _this.onEntering = function (maybeNode, maybeAppearing) {
      var _this$resolveArgument2 = _this.resolveArguments(maybeNode, maybeAppearing),
          node = _this$resolveArgument2[0],
          appearing = _this$resolveArgument2[1];

      var type = appearing ? 'appear' : 'enter';

      _this.addClass(node, type, 'active');

      if (_this.props.onEntering) {
        _this.props.onEntering(maybeNode, maybeAppearing);
      }
    };

    _this.onEntered = function (maybeNode, maybeAppearing) {
      var _this$resolveArgument3 = _this.resolveArguments(maybeNode, maybeAppearing),
          node = _this$resolveArgument3[0],
          appearing = _this$resolveArgument3[1];

      var type = appearing ? 'appear' : 'enter';

      _this.removeClasses(node, type);

      _this.addClass(node, type, 'done');

      if (_this.props.onEntered) {
        _this.props.onEntered(maybeNode, maybeAppearing);
      }
    };

    _this.onExit = function (maybeNode) {
      var _this$resolveArgument4 = _this.resolveArguments(maybeNode),
          node = _this$resolveArgument4[0];

      _this.removeClasses(node, 'appear');

      _this.removeClasses(node, 'enter');

      _this.addClass(node, 'exit', 'base');

      if (_this.props.onExit) {
        _this.props.onExit(maybeNode);
      }
    };

    _this.onExiting = function (maybeNode) {
      var _this$resolveArgument5 = _this.resolveArguments(maybeNode),
          node = _this$resolveArgument5[0];

      _this.addClass(node, 'exit', 'active');

      if (_this.props.onExiting) {
        _this.props.onExiting(maybeNode);
      }
    };

    _this.onExited = function (maybeNode) {
      var _this$resolveArgument6 = _this.resolveArguments(maybeNode),
          node = _this$resolveArgument6[0];

      _this.removeClasses(node, 'exit');

      _this.addClass(node, 'exit', 'done');

      if (_this.props.onExited) {
        _this.props.onExited(maybeNode);
      }
    };

    _this.resolveArguments = function (maybeNode, maybeAppearing) {
      return _this.props.nodeRef ? [_this.props.nodeRef.current, maybeNode] // here `maybeNode` is actually `appearing`
      : [maybeNode, maybeAppearing];
    };

    _this.getClassNames = function (type) {
      var classNames = _this.props.classNames;
      var isStringClassNames = typeof classNames === 'string';
      var prefix = isStringClassNames && classNames ? classNames + "-" : '';
      var baseClassName = isStringClassNames ? "" + prefix + type : classNames[type];
      var activeClassName = isStringClassNames ? baseClassName + "-active" : classNames[type + "Active"];
      var doneClassName = isStringClassNames ? baseClassName + "-done" : classNames[type + "Done"];
      return {
        baseClassName: baseClassName,
        activeClassName: activeClassName,
        doneClassName: doneClassName
      };
    };

    return _this;
  }

  var _proto = CSSTransition.prototype;

  _proto.addClass = function addClass(node, type, phase) {
    var className = this.getClassNames(type)[phase + "ClassName"];

    var _this$getClassNames = this.getClassNames('enter'),
        doneClassName = _this$getClassNames.doneClassName;

    if (type === 'appear' && phase === 'done' && doneClassName) {
      className += " " + doneClassName;
    } // This is to force a repaint,
    // which is necessary in order to transition styles when adding a class name.


    if (phase === 'active') {
      /* eslint-disable no-unused-expressions */
      node && node.scrollTop;
    }

    if (className) {
      this.appliedClasses[type][phase] = className;

      _addClass(node, className);
    }
  };

  _proto.removeClasses = function removeClasses(node, type) {
    var _this$appliedClasses$ = this.appliedClasses[type],
        baseClassName = _this$appliedClasses$.base,
        activeClassName = _this$appliedClasses$.active,
        doneClassName = _this$appliedClasses$.done;
    this.appliedClasses[type] = {};

    if (baseClassName) {
      removeClass(node, baseClassName);
    }

    if (activeClassName) {
      removeClass(node, activeClassName);
    }

    if (doneClassName) {
      removeClass(node, doneClassName);
    }
  };

  _proto.render = function render() {
    var _this$props = this.props;
        _this$props.classNames;
        var props = _objectWithoutPropertiesLoose(_this$props, ["classNames"]);

    return /*#__PURE__*/React__default['default'].createElement(Transition$1, _extends$f({}, props, {
      onEnter: this.onEnter,
      onEntered: this.onEntered,
      onEntering: this.onEntering,
      onExit: this.onExit,
      onExiting: this.onExiting,
      onExited: this.onExited
    }));
  };

  return CSSTransition;
}(React__default['default'].Component);

CSSTransition.defaultProps = {
  classNames: ''
};
CSSTransition.propTypes = {};
var CSSTransition$1 = CSSTransition;/**
 * Given `this.props.children`, return an object mapping key to child.
 *
 * @param {*} children `this.props.children`
 * @return {object} Mapping of key to child
 */

function getChildMapping(children, mapFn) {
  var mapper = function mapper(child) {
    return mapFn && React.isValidElement(child) ? mapFn(child) : child;
  };

  var result = Object.create(null);
  if (children) React.Children.map(children, function (c) {
    return c;
  }).forEach(function (child) {
    // run the map function here instead so that the key is the computed one
    result[child.key] = mapper(child);
  });
  return result;
}
/**
 * When you're adding or removing children some may be added or removed in the
 * same render pass. We want to show *both* since we want to simultaneously
 * animate elements in and out. This function takes a previous set of keys
 * and a new set of keys and merges them with its best guess of the correct
 * ordering. In the future we may expose some of the utilities in
 * ReactMultiChild to make this easy, but for now React itself does not
 * directly have this concept of the union of prevChildren and nextChildren
 * so we implement it here.
 *
 * @param {object} prev prev children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @param {object} next next children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @return {object} a key set that contains all keys in `prev` and all keys
 * in `next` in a reasonable order.
 */

function mergeChildMappings(prev, next) {
  prev = prev || {};
  next = next || {};

  function getValueForKey(key) {
    return key in next ? next[key] : prev[key];
  } // For each key of `next`, the list of keys to insert before that key in
  // the combined list


  var nextKeysPending = Object.create(null);
  var pendingKeys = [];

  for (var prevKey in prev) {
    if (prevKey in next) {
      if (pendingKeys.length) {
        nextKeysPending[prevKey] = pendingKeys;
        pendingKeys = [];
      }
    } else {
      pendingKeys.push(prevKey);
    }
  }

  var i;
  var childMapping = {};

  for (var nextKey in next) {
    if (nextKeysPending[nextKey]) {
      for (i = 0; i < nextKeysPending[nextKey].length; i++) {
        var pendingNextKey = nextKeysPending[nextKey][i];
        childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
      }
    }

    childMapping[nextKey] = getValueForKey(nextKey);
  } // Finally, add the keys which didn't appear before any key in `next`


  for (i = 0; i < pendingKeys.length; i++) {
    childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
  }

  return childMapping;
}

function getProp(child, prop, props) {
  return props[prop] != null ? props[prop] : child.props[prop];
}

function getInitialChildMapping(props, onExited) {
  return getChildMapping(props.children, function (child) {
    return React.cloneElement(child, {
      onExited: onExited.bind(null, child),
      in: true,
      appear: getProp(child, 'appear', props),
      enter: getProp(child, 'enter', props),
      exit: getProp(child, 'exit', props)
    });
  });
}
function getNextChildMapping(nextProps, prevChildMapping, onExited) {
  var nextChildMapping = getChildMapping(nextProps.children);
  var children = mergeChildMappings(prevChildMapping, nextChildMapping);
  Object.keys(children).forEach(function (key) {
    var child = children[key];
    if (!React.isValidElement(child)) return;
    var hasPrev = (key in prevChildMapping);
    var hasNext = (key in nextChildMapping);
    var prevChild = prevChildMapping[key];
    var isLeaving = React.isValidElement(prevChild) && !prevChild.props.in; // item is new (entering)

    if (hasNext && (!hasPrev || isLeaving)) {
      // console.log('entering', key)
      children[key] = React.cloneElement(child, {
        onExited: onExited.bind(null, child),
        in: true,
        exit: getProp(child, 'exit', nextProps),
        enter: getProp(child, 'enter', nextProps)
      });
    } else if (!hasNext && hasPrev && !isLeaving) {
      // item is old (exiting)
      // console.log('leaving', key)
      children[key] = React.cloneElement(child, {
        in: false
      });
    } else if (hasNext && hasPrev && React.isValidElement(prevChild)) {
      // item hasn't changed transition states
      // copy over the last transition props;
      // console.log('unchanged', key)
      children[key] = React.cloneElement(child, {
        onExited: onExited.bind(null, child),
        in: prevChild.props.in,
        exit: getProp(child, 'exit', nextProps),
        enter: getProp(child, 'enter', nextProps)
      });
    }
  });
  return children;
}var values$2 = Object.values || function (obj) {
  return Object.keys(obj).map(function (k) {
    return obj[k];
  });
};

var defaultProps$1 = {
  component: 'div',
  childFactory: function childFactory(child) {
    return child;
  }
};
/**
 * The `<TransitionGroup>` component manages a set of transition components
 * (`<Transition>` and `<CSSTransition>`) in a list. Like with the transition
 * components, `<TransitionGroup>` is a state machine for managing the mounting
 * and unmounting of components over time.
 *
 * Consider the example below. As items are removed or added to the TodoList the
 * `in` prop is toggled automatically by the `<TransitionGroup>`.
 *
 * Note that `<TransitionGroup>`  does not define any animation behavior!
 * Exactly _how_ a list item animates is up to the individual transition
 * component. This means you can mix and match animations across different list
 * items.
 */

var TransitionGroup = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(TransitionGroup, _React$Component);

  function TransitionGroup(props, context) {
    var _this;

    _this = _React$Component.call(this, props, context) || this;

    var handleExited = _this.handleExited.bind(_assertThisInitialized(_this)); // Initial children should all be entering, dependent on appear


    _this.state = {
      contextValue: {
        isMounting: true
      },
      handleExited: handleExited,
      firstRender: true
    };
    return _this;
  }

  var _proto = TransitionGroup.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.mounted = true;
    this.setState({
      contextValue: {
        isMounting: false
      }
    });
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.mounted = false;
  };

  TransitionGroup.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, _ref) {
    var prevChildMapping = _ref.children,
        handleExited = _ref.handleExited,
        firstRender = _ref.firstRender;
    return {
      children: firstRender ? getInitialChildMapping(nextProps, handleExited) : getNextChildMapping(nextProps, prevChildMapping, handleExited),
      firstRender: false
    };
  } // node is `undefined` when user provided `nodeRef` prop
  ;

  _proto.handleExited = function handleExited(child, node) {
    var currentChildMapping = getChildMapping(this.props.children);
    if (child.key in currentChildMapping) return;

    if (child.props.onExited) {
      child.props.onExited(node);
    }

    if (this.mounted) {
      this.setState(function (state) {
        var children = _extends$f({}, state.children);

        delete children[child.key];
        return {
          children: children
        };
      });
    }
  };

  _proto.render = function render() {
    var _this$props = this.props,
        Component = _this$props.component,
        childFactory = _this$props.childFactory,
        props = _objectWithoutPropertiesLoose(_this$props, ["component", "childFactory"]);

    var contextValue = this.state.contextValue;
    var children = values$2(this.state.children).map(childFactory);
    delete props.appear;
    delete props.enter;
    delete props.exit;

    if (Component === null) {
      return /*#__PURE__*/React__default['default'].createElement(TransitionGroupContext.Provider, {
        value: contextValue
      }, children);
    }

    return /*#__PURE__*/React__default['default'].createElement(TransitionGroupContext.Provider, {
      value: contextValue
    }, /*#__PURE__*/React__default['default'].createElement(Component, props, children));
  };

  return TransitionGroup;
}(React__default['default'].Component);

TransitionGroup.propTypes = {};
TransitionGroup.defaultProps = defaultProps$1;
var TransitionGroup$1 = TransitionGroup;var reflow = function reflow(node) {
  return node.scrollTop;
};
function getTransitionProps(props, options) {
  var timeout = props.timeout,
      _props$style = props.style,
      style = _props$style === void 0 ? {} : _props$style;
  return {
    duration: style.transitionDuration || typeof timeout === 'number' ? timeout : timeout[options.mode] || 0,
    delay: style.transitionDelay
  };
}var styles$B = function styles(theme) {
  var elevations = {};
  theme.shadows.forEach(function (shadow, index) {
    elevations["elevation".concat(index)] = {
      boxShadow: shadow
    };
  });
  return _extends$f({
    /* Styles applied to the root element. */
    root: {
      backgroundColor: theme.palette.background.paper,
      color: theme.palette.text.primary,
      transition: theme.transitions.create('box-shadow')
    },

    /* Styles applied to the root element if `square={false}`. */
    rounded: {
      borderRadius: theme.shape.borderRadius
    },

    /* Styles applied to the root element if `variant="outlined"`. */
    outlined: {
      border: "1px solid ".concat(theme.palette.divider)
    }
  }, elevations);
};
var Paper = /*#__PURE__*/React__namespace.forwardRef(function Paper(props, ref) {
  var classes = props.classes,
      className = props.className,
      _props$component = props.component,
      Component = _props$component === void 0 ? 'div' : _props$component,
      _props$square = props.square,
      square = _props$square === void 0 ? false : _props$square,
      _props$elevation = props.elevation,
      elevation = _props$elevation === void 0 ? 1 : _props$elevation,
      _props$variant = props.variant,
      variant = _props$variant === void 0 ? 'elevation' : _props$variant,
      other = _objectWithoutProperties$4(props, ["classes", "className", "component", "square", "elevation", "variant"]);

  return /*#__PURE__*/React__namespace.createElement(Component, _extends$f({
    className: clsx(classes.root, className, variant === 'outlined' ? classes.outlined : classes["elevation".concat(elevation)], !square && classes.rounded),
    ref: ref
  }, other));
});
var Paper$1 = withStyles(styles$B, {
  name: 'MuiPaper'
})(Paper);var useEnhancedEffect$5 = typeof window === 'undefined' ? React__namespace.useEffect : React__namespace.useLayoutEffect;
/**
 * @ignore - internal component.
 */

function Ripple(props) {
  var classes = props.classes,
      _props$pulsate = props.pulsate,
      pulsate = _props$pulsate === void 0 ? false : _props$pulsate,
      rippleX = props.rippleX,
      rippleY = props.rippleY,
      rippleSize = props.rippleSize,
      inProp = props.in,
      _props$onExited = props.onExited,
      onExited = _props$onExited === void 0 ? function () {} : _props$onExited,
      timeout = props.timeout;

  var _React$useState = React__namespace.useState(false),
      leaving = _React$useState[0],
      setLeaving = _React$useState[1];

  var rippleClassName = clsx(classes.ripple, classes.rippleVisible, pulsate && classes.ripplePulsate);
  var rippleStyles = {
    width: rippleSize,
    height: rippleSize,
    top: -(rippleSize / 2) + rippleY,
    left: -(rippleSize / 2) + rippleX
  };
  var childClassName = clsx(classes.child, leaving && classes.childLeaving, pulsate && classes.childPulsate);
  var handleExited = useEventCallback(onExited); // Ripple is used for user feedback (e.g. click or press) so we want to apply styles with the highest priority

  useEnhancedEffect$5(function () {
    if (!inProp) {
      // react-transition-group#onExit
      setLeaving(true); // react-transition-group#onExited

      var timeoutId = setTimeout(handleExited, timeout);
      return function () {
        clearTimeout(timeoutId);
      };
    }

    return undefined;
  }, [handleExited, inProp, timeout]);
  return /*#__PURE__*/React__namespace.createElement("span", {
    className: rippleClassName,
    style: rippleStyles
  }, /*#__PURE__*/React__namespace.createElement("span", {
    className: childClassName
  }));
}var DURATION = 550;
var DELAY_RIPPLE = 80;
var styles$A = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      overflow: 'hidden',
      pointerEvents: 'none',
      position: 'absolute',
      zIndex: 0,
      top: 0,
      right: 0,
      bottom: 0,
      left: 0,
      borderRadius: 'inherit'
    },

    /* Styles applied to the internal `Ripple` components `ripple` class. */
    ripple: {
      opacity: 0,
      position: 'absolute'
    },

    /* Styles applied to the internal `Ripple` components `rippleVisible` class. */
    rippleVisible: {
      opacity: 0.3,
      transform: 'scale(1)',
      animation: "$enter ".concat(DURATION, "ms ").concat(theme.transitions.easing.easeInOut)
    },

    /* Styles applied to the internal `Ripple` components `ripplePulsate` class. */
    ripplePulsate: {
      animationDuration: "".concat(theme.transitions.duration.shorter, "ms")
    },

    /* Styles applied to the internal `Ripple` components `child` class. */
    child: {
      opacity: 1,
      display: 'block',
      width: '100%',
      height: '100%',
      borderRadius: '50%',
      backgroundColor: 'currentColor'
    },

    /* Styles applied to the internal `Ripple` components `childLeaving` class. */
    childLeaving: {
      opacity: 0,
      animation: "$exit ".concat(DURATION, "ms ").concat(theme.transitions.easing.easeInOut)
    },

    /* Styles applied to the internal `Ripple` components `childPulsate` class. */
    childPulsate: {
      position: 'absolute',
      left: 0,
      top: 0,
      animation: "$pulsate 2500ms ".concat(theme.transitions.easing.easeInOut, " 200ms infinite")
    },
    '@keyframes enter': {
      '0%': {
        transform: 'scale(0)',
        opacity: 0.1
      },
      '100%': {
        transform: 'scale(1)',
        opacity: 0.3
      }
    },
    '@keyframes exit': {
      '0%': {
        opacity: 1
      },
      '100%': {
        opacity: 0
      }
    },
    '@keyframes pulsate': {
      '0%': {
        transform: 'scale(1)'
      },
      '50%': {
        transform: 'scale(0.92)'
      },
      '100%': {
        transform: 'scale(1)'
      }
    }
  };
};
/**
 * @ignore - internal component.
 *
 * TODO v5: Make private
 */

var TouchRipple = /*#__PURE__*/React__namespace.forwardRef(function TouchRipple(props, ref) {
  var _props$center = props.center,
      centerProp = _props$center === void 0 ? false : _props$center,
      classes = props.classes,
      className = props.className,
      other = _objectWithoutProperties$4(props, ["center", "classes", "className"]);

  var _React$useState = React__namespace.useState([]),
      ripples = _React$useState[0],
      setRipples = _React$useState[1];

  var nextKey = React__namespace.useRef(0);
  var rippleCallback = React__namespace.useRef(null);
  React__namespace.useEffect(function () {
    if (rippleCallback.current) {
      rippleCallback.current();
      rippleCallback.current = null;
    }
  }, [ripples]); // Used to filter out mouse emulated events on mobile.

  var ignoringMouseDown = React__namespace.useRef(false); // We use a timer in order to only show the ripples for touch "click" like events.
  // We don't want to display the ripple for touch scroll events.

  var startTimer = React__namespace.useRef(null); // This is the hook called once the previous timeout is ready.

  var startTimerCommit = React__namespace.useRef(null);
  var container = React__namespace.useRef(null);
  React__namespace.useEffect(function () {
    return function () {
      clearTimeout(startTimer.current);
    };
  }, []);
  var startCommit = React__namespace.useCallback(function (params) {
    var pulsate = params.pulsate,
        rippleX = params.rippleX,
        rippleY = params.rippleY,
        rippleSize = params.rippleSize,
        cb = params.cb;
    setRipples(function (oldRipples) {
      return [].concat(_toConsumableArray(oldRipples), [/*#__PURE__*/React__namespace.createElement(Ripple, {
        key: nextKey.current,
        classes: classes,
        timeout: DURATION,
        pulsate: pulsate,
        rippleX: rippleX,
        rippleY: rippleY,
        rippleSize: rippleSize
      })]);
    });
    nextKey.current += 1;
    rippleCallback.current = cb;
  }, [classes]);
  var start = React__namespace.useCallback(function () {
    var event = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var cb = arguments.length > 2 ? arguments[2] : undefined;
    var _options$pulsate = options.pulsate,
        pulsate = _options$pulsate === void 0 ? false : _options$pulsate,
        _options$center = options.center,
        center = _options$center === void 0 ? centerProp || options.pulsate : _options$center,
        _options$fakeElement = options.fakeElement,
        fakeElement = _options$fakeElement === void 0 ? false : _options$fakeElement;

    if (event.type === 'mousedown' && ignoringMouseDown.current) {
      ignoringMouseDown.current = false;
      return;
    }

    if (event.type === 'touchstart') {
      ignoringMouseDown.current = true;
    }

    var element = fakeElement ? null : container.current;
    var rect = element ? element.getBoundingClientRect() : {
      width: 0,
      height: 0,
      left: 0,
      top: 0
    }; // Get the size of the ripple

    var rippleX;
    var rippleY;
    var rippleSize;

    if (center || event.clientX === 0 && event.clientY === 0 || !event.clientX && !event.touches) {
      rippleX = Math.round(rect.width / 2);
      rippleY = Math.round(rect.height / 2);
    } else {
      var _ref = event.touches ? event.touches[0] : event,
          clientX = _ref.clientX,
          clientY = _ref.clientY;

      rippleX = Math.round(clientX - rect.left);
      rippleY = Math.round(clientY - rect.top);
    }

    if (center) {
      rippleSize = Math.sqrt((2 * Math.pow(rect.width, 2) + Math.pow(rect.height, 2)) / 3); // For some reason the animation is broken on Mobile Chrome if the size if even.

      if (rippleSize % 2 === 0) {
        rippleSize += 1;
      }
    } else {
      var sizeX = Math.max(Math.abs((element ? element.clientWidth : 0) - rippleX), rippleX) * 2 + 2;
      var sizeY = Math.max(Math.abs((element ? element.clientHeight : 0) - rippleY), rippleY) * 2 + 2;
      rippleSize = Math.sqrt(Math.pow(sizeX, 2) + Math.pow(sizeY, 2));
    } // Touche devices


    if (event.touches) {
      // check that this isn't another touchstart due to multitouch
      // otherwise we will only clear a single timer when unmounting while two
      // are running
      if (startTimerCommit.current === null) {
        // Prepare the ripple effect.
        startTimerCommit.current = function () {
          startCommit({
            pulsate: pulsate,
            rippleX: rippleX,
            rippleY: rippleY,
            rippleSize: rippleSize,
            cb: cb
          });
        }; // Delay the execution of the ripple effect.


        startTimer.current = setTimeout(function () {
          if (startTimerCommit.current) {
            startTimerCommit.current();
            startTimerCommit.current = null;
          }
        }, DELAY_RIPPLE); // We have to make a tradeoff with this value.
      }
    } else {
      startCommit({
        pulsate: pulsate,
        rippleX: rippleX,
        rippleY: rippleY,
        rippleSize: rippleSize,
        cb: cb
      });
    }
  }, [centerProp, startCommit]);
  var pulsate = React__namespace.useCallback(function () {
    start({}, {
      pulsate: true
    });
  }, [start]);
  var stop = React__namespace.useCallback(function (event, cb) {
    clearTimeout(startTimer.current); // The touch interaction occurs too quickly.
    // We still want to show ripple effect.

    if (event.type === 'touchend' && startTimerCommit.current) {
      event.persist();
      startTimerCommit.current();
      startTimerCommit.current = null;
      startTimer.current = setTimeout(function () {
        stop(event, cb);
      });
      return;
    }

    startTimerCommit.current = null;
    setRipples(function (oldRipples) {
      if (oldRipples.length > 0) {
        return oldRipples.slice(1);
      }

      return oldRipples;
    });
    rippleCallback.current = cb;
  }, []);
  React__namespace.useImperativeHandle(ref, function () {
    return {
      pulsate: pulsate,
      start: start,
      stop: stop
    };
  }, [pulsate, start, stop]);
  return /*#__PURE__*/React__namespace.createElement("span", _extends$f({
    className: clsx(classes.root, className),
    ref: container
  }, other), /*#__PURE__*/React__namespace.createElement(TransitionGroup$1, {
    component: null,
    exit: true
  }, ripples));
});
var TouchRipple$1 = withStyles(styles$A, {
  flip: false,
  name: 'MuiTouchRipple'
})( /*#__PURE__*/React__namespace.memo(TouchRipple));var styles$z = {
  /* Styles applied to the root element. */
  root: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'relative',
    WebkitTapHighlightColor: 'transparent',
    backgroundColor: 'transparent',
    // Reset default value
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0,
    border: 0,
    margin: 0,
    // Remove the margin in Safari
    borderRadius: 0,
    padding: 0,
    // Remove the padding in Firefox
    cursor: 'pointer',
    userSelect: 'none',
    verticalAlign: 'middle',
    '-moz-appearance': 'none',
    // Reset
    '-webkit-appearance': 'none',
    // Reset
    textDecoration: 'none',
    // So we take precedent over the style of a native <a /> element.
    color: 'inherit',
    '&::-moz-focus-inner': {
      borderStyle: 'none' // Remove Firefox dotted outline.

    },
    '&$disabled': {
      pointerEvents: 'none',
      // Disable link interactions
      cursor: 'default'
    },
    '@media print': {
      colorAdjust: 'exact'
    }
  },

  /* Pseudo-class applied to the root element if `disabled={true}`. */
  disabled: {},

  /* Pseudo-class applied to the root element if keyboard focused. */
  focusVisible: {}
};
/**
 * `ButtonBase` contains as few styles as possible.
 * It aims to be a simple building block for creating a button.
 * It contains a load of style reset and some focus/ripple logic.
 */

var ButtonBase = /*#__PURE__*/React__namespace.forwardRef(function ButtonBase(props, ref) {
  var action = props.action,
      buttonRefProp = props.buttonRef,
      _props$centerRipple = props.centerRipple,
      centerRipple = _props$centerRipple === void 0 ? false : _props$centerRipple,
      children = props.children,
      classes = props.classes,
      className = props.className,
      _props$component = props.component,
      component = _props$component === void 0 ? 'button' : _props$component,
      _props$disabled = props.disabled,
      disabled = _props$disabled === void 0 ? false : _props$disabled,
      _props$disableRipple = props.disableRipple,
      disableRipple = _props$disableRipple === void 0 ? false : _props$disableRipple,
      _props$disableTouchRi = props.disableTouchRipple,
      disableTouchRipple = _props$disableTouchRi === void 0 ? false : _props$disableTouchRi,
      _props$focusRipple = props.focusRipple,
      focusRipple = _props$focusRipple === void 0 ? false : _props$focusRipple,
      focusVisibleClassName = props.focusVisibleClassName,
      onBlur = props.onBlur,
      onClick = props.onClick,
      onFocus = props.onFocus,
      onFocusVisible = props.onFocusVisible,
      onKeyDown = props.onKeyDown,
      onKeyUp = props.onKeyUp,
      onMouseDown = props.onMouseDown,
      onMouseLeave = props.onMouseLeave,
      onMouseUp = props.onMouseUp,
      onTouchEnd = props.onTouchEnd,
      onTouchMove = props.onTouchMove,
      onTouchStart = props.onTouchStart,
      onDragLeave = props.onDragLeave,
      _props$tabIndex = props.tabIndex,
      tabIndex = _props$tabIndex === void 0 ? 0 : _props$tabIndex,
      TouchRippleProps = props.TouchRippleProps,
      _props$type = props.type,
      type = _props$type === void 0 ? 'button' : _props$type,
      other = _objectWithoutProperties$4(props, ["action", "buttonRef", "centerRipple", "children", "classes", "className", "component", "disabled", "disableRipple", "disableTouchRipple", "focusRipple", "focusVisibleClassName", "onBlur", "onClick", "onFocus", "onFocusVisible", "onKeyDown", "onKeyUp", "onMouseDown", "onMouseLeave", "onMouseUp", "onTouchEnd", "onTouchMove", "onTouchStart", "onDragLeave", "tabIndex", "TouchRippleProps", "type"]);

  var buttonRef = React__namespace.useRef(null);

  function getButtonNode() {
    // #StrictMode ready
    return ReactDOM__namespace.findDOMNode(buttonRef.current);
  }

  var rippleRef = React__namespace.useRef(null);

  var _React$useState = React__namespace.useState(false),
      focusVisible = _React$useState[0],
      setFocusVisible = _React$useState[1];

  if (disabled && focusVisible) {
    setFocusVisible(false);
  }

  var _useIsFocusVisible = useIsFocusVisible(),
      isFocusVisible = _useIsFocusVisible.isFocusVisible,
      onBlurVisible = _useIsFocusVisible.onBlurVisible,
      focusVisibleRef = _useIsFocusVisible.ref;

  React__namespace.useImperativeHandle(action, function () {
    return {
      focusVisible: function focusVisible() {
        setFocusVisible(true);
        buttonRef.current.focus();
      }
    };
  }, []);
  React__namespace.useEffect(function () {
    if (focusVisible && focusRipple && !disableRipple) {
      rippleRef.current.pulsate();
    }
  }, [disableRipple, focusRipple, focusVisible]);

  function useRippleHandler(rippleAction, eventCallback) {
    var skipRippleAction = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : disableTouchRipple;
    return useEventCallback(function (event) {
      if (eventCallback) {
        eventCallback(event);
      }

      var ignore = skipRippleAction;

      if (!ignore && rippleRef.current) {
        rippleRef.current[rippleAction](event);
      }

      return true;
    });
  }

  var handleMouseDown = useRippleHandler('start', onMouseDown);
  var handleDragLeave = useRippleHandler('stop', onDragLeave);
  var handleMouseUp = useRippleHandler('stop', onMouseUp);
  var handleMouseLeave = useRippleHandler('stop', function (event) {
    if (focusVisible) {
      event.preventDefault();
    }

    if (onMouseLeave) {
      onMouseLeave(event);
    }
  });
  var handleTouchStart = useRippleHandler('start', onTouchStart);
  var handleTouchEnd = useRippleHandler('stop', onTouchEnd);
  var handleTouchMove = useRippleHandler('stop', onTouchMove);
  var handleBlur = useRippleHandler('stop', function (event) {
    if (focusVisible) {
      onBlurVisible(event);
      setFocusVisible(false);
    }

    if (onBlur) {
      onBlur(event);
    }
  }, false);
  var handleFocus = useEventCallback(function (event) {
    // Fix for https://github.com/facebook/react/issues/7769
    if (!buttonRef.current) {
      buttonRef.current = event.currentTarget;
    }

    if (isFocusVisible(event)) {
      setFocusVisible(true);

      if (onFocusVisible) {
        onFocusVisible(event);
      }
    }

    if (onFocus) {
      onFocus(event);
    }
  });

  var isNonNativeButton = function isNonNativeButton() {
    var button = getButtonNode();
    return component && component !== 'button' && !(button.tagName === 'A' && button.href);
  };
  /**
   * IE 11 shim for https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/repeat
   */


  var keydownRef = React__namespace.useRef(false);
  var handleKeyDown = useEventCallback(function (event) {
    // Check if key is already down to avoid repeats being counted as multiple activations
    if (focusRipple && !keydownRef.current && focusVisible && rippleRef.current && event.key === ' ') {
      keydownRef.current = true;
      event.persist();
      rippleRef.current.stop(event, function () {
        rippleRef.current.start(event);
      });
    }

    if (event.target === event.currentTarget && isNonNativeButton() && event.key === ' ') {
      event.preventDefault();
    }

    if (onKeyDown) {
      onKeyDown(event);
    } // Keyboard accessibility for non interactive elements


    if (event.target === event.currentTarget && isNonNativeButton() && event.key === 'Enter' && !disabled) {
      event.preventDefault();

      if (onClick) {
        onClick(event);
      }
    }
  });
  var handleKeyUp = useEventCallback(function (event) {
    // calling preventDefault in keyUp on a <button> will not dispatch a click event if Space is pressed
    // https://codesandbox.io/s/button-keyup-preventdefault-dn7f0
    if (focusRipple && event.key === ' ' && rippleRef.current && focusVisible && !event.defaultPrevented) {
      keydownRef.current = false;
      event.persist();
      rippleRef.current.stop(event, function () {
        rippleRef.current.pulsate(event);
      });
    }

    if (onKeyUp) {
      onKeyUp(event);
    } // Keyboard accessibility for non interactive elements


    if (onClick && event.target === event.currentTarget && isNonNativeButton() && event.key === ' ' && !event.defaultPrevented) {
      onClick(event);
    }
  });
  var ComponentProp = component;

  if (ComponentProp === 'button' && other.href) {
    ComponentProp = 'a';
  }

  var buttonProps = {};

  if (ComponentProp === 'button') {
    buttonProps.type = type;
    buttonProps.disabled = disabled;
  } else {
    if (ComponentProp !== 'a' || !other.href) {
      buttonProps.role = 'button';
    }

    buttonProps['aria-disabled'] = disabled;
  }

  var handleUserRef = useForkRef(buttonRefProp, ref);
  var handleOwnRef = useForkRef(focusVisibleRef, buttonRef);
  var handleRef = useForkRef(handleUserRef, handleOwnRef);

  var _React$useState2 = React__namespace.useState(false),
      mountedState = _React$useState2[0],
      setMountedState = _React$useState2[1];

  React__namespace.useEffect(function () {
    setMountedState(true);
  }, []);
  var enableTouchRipple = mountedState && !disableRipple && !disabled;

  return /*#__PURE__*/React__namespace.createElement(ComponentProp, _extends$f({
    className: clsx(classes.root, className, focusVisible && [classes.focusVisible, focusVisibleClassName], disabled && classes.disabled),
    onBlur: handleBlur,
    onClick: onClick,
    onFocus: handleFocus,
    onKeyDown: handleKeyDown,
    onKeyUp: handleKeyUp,
    onMouseDown: handleMouseDown,
    onMouseLeave: handleMouseLeave,
    onMouseUp: handleMouseUp,
    onDragLeave: handleDragLeave,
    onTouchEnd: handleTouchEnd,
    onTouchMove: handleTouchMove,
    onTouchStart: handleTouchStart,
    ref: handleRef,
    tabIndex: disabled ? -1 : tabIndex
  }, buttonProps, other), children, enableTouchRipple ?
  /*#__PURE__*/

  /* TouchRipple is only needed client-side, x2 boost on the server. */
  React__namespace.createElement(TouchRipple$1, _extends$f({
    ref: rippleRef,
    center: centerRipple
  }, TouchRippleProps)) : null);
});
var ButtonBase$1 = withStyles(styles$z, {
  name: 'MuiButtonBase'
})(ButtonBase);var styles$y = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      textAlign: 'center',
      flex: '0 0 auto',
      fontSize: theme.typography.pxToRem(24),
      padding: 12,
      borderRadius: '50%',
      overflow: 'visible',
      // Explicitly set the default value to solve a bug on IE 11.
      color: theme.palette.action.active,
      transition: theme.transitions.create('background-color', {
        duration: theme.transitions.duration.shortest
      }),
      '&:hover': {
        backgroundColor: alpha$2(theme.palette.action.active, theme.palette.action.hoverOpacity),
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          backgroundColor: 'transparent'
        }
      },
      '&$disabled': {
        backgroundColor: 'transparent',
        color: theme.palette.action.disabled
      }
    },

    /* Styles applied to the root element if `edge="start"`. */
    edgeStart: {
      marginLeft: -12,
      '$sizeSmall&': {
        marginLeft: -3
      }
    },

    /* Styles applied to the root element if `edge="end"`. */
    edgeEnd: {
      marginRight: -12,
      '$sizeSmall&': {
        marginRight: -3
      }
    },

    /* Styles applied to the root element if `color="inherit"`. */
    colorInherit: {
      color: 'inherit'
    },

    /* Styles applied to the root element if `color="primary"`. */
    colorPrimary: {
      color: theme.palette.primary.main,
      '&:hover': {
        backgroundColor: alpha$2(theme.palette.primary.main, theme.palette.action.hoverOpacity),
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          backgroundColor: 'transparent'
        }
      }
    },

    /* Styles applied to the root element if `color="secondary"`. */
    colorSecondary: {
      color: theme.palette.secondary.main,
      '&:hover': {
        backgroundColor: alpha$2(theme.palette.secondary.main, theme.palette.action.hoverOpacity),
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          backgroundColor: 'transparent'
        }
      }
    },

    /* Pseudo-class applied to the root element if `disabled={true}`. */
    disabled: {},

    /* Styles applied to the root element if `size="small"`. */
    sizeSmall: {
      padding: 3,
      fontSize: theme.typography.pxToRem(18)
    },

    /* Styles applied to the children container element. */
    label: {
      width: '100%',
      display: 'flex',
      alignItems: 'inherit',
      justifyContent: 'inherit'
    }
  };
};
/**
 * Refer to the [Icons](/components/icons/) section of the documentation
 * regarding the available icon options.
 */

var IconButton = /*#__PURE__*/React__namespace.forwardRef(function IconButton(props, ref) {
  var _props$edge = props.edge,
      edge = _props$edge === void 0 ? false : _props$edge,
      children = props.children,
      classes = props.classes,
      className = props.className,
      _props$color = props.color,
      color = _props$color === void 0 ? 'default' : _props$color,
      _props$disabled = props.disabled,
      disabled = _props$disabled === void 0 ? false : _props$disabled,
      _props$disableFocusRi = props.disableFocusRipple,
      disableFocusRipple = _props$disableFocusRi === void 0 ? false : _props$disableFocusRi,
      _props$size = props.size,
      size = _props$size === void 0 ? 'medium' : _props$size,
      other = _objectWithoutProperties$4(props, ["edge", "children", "classes", "className", "color", "disabled", "disableFocusRipple", "size"]);

  return /*#__PURE__*/React__namespace.createElement(ButtonBase$1, _extends$f({
    className: clsx(classes.root, className, color !== 'default' && classes["color".concat(capitalize(color))], disabled && classes.disabled, size === "small" && classes["size".concat(capitalize(size))], {
      'start': classes.edgeStart,
      'end': classes.edgeEnd
    }[edge]),
    centerRipple: true,
    focusRipple: !disableFocusRipple,
    disabled: disabled,
    ref: ref
  }, other), /*#__PURE__*/React__namespace.createElement("span", {
    className: classes.label
  }, children));
});
var IconButton$1 = withStyles(styles$y, {
  name: 'MuiIconButton'
})(IconButton);var styles$x = {
  entering: {
    opacity: 1
  },
  entered: {
    opacity: 1
  }
};
var defaultTimeout = {
  enter: duration.enteringScreen,
  exit: duration.leavingScreen
};
/**
 * The Fade transition is used by the [Modal](/components/modal/) component.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */

var Fade = /*#__PURE__*/React__namespace.forwardRef(function Fade(props, ref) {
  var children = props.children,
      _props$disableStrictM = props.disableStrictModeCompat,
      disableStrictModeCompat = _props$disableStrictM === void 0 ? false : _props$disableStrictM,
      inProp = props.in,
      onEnter = props.onEnter,
      onEntered = props.onEntered,
      onEntering = props.onEntering,
      onExit = props.onExit,
      onExited = props.onExited,
      onExiting = props.onExiting,
      style = props.style,
      _props$TransitionComp = props.TransitionComponent,
      TransitionComponent = _props$TransitionComp === void 0 ? Transition$1 : _props$TransitionComp,
      _props$timeout = props.timeout,
      timeout = _props$timeout === void 0 ? defaultTimeout : _props$timeout,
      other = _objectWithoutProperties$4(props, ["children", "disableStrictModeCompat", "in", "onEnter", "onEntered", "onEntering", "onExit", "onExited", "onExiting", "style", "TransitionComponent", "timeout"]);

  var theme = useTheme();
  var enableStrictModeCompat = theme.unstable_strictMode && !disableStrictModeCompat;
  var nodeRef = React__namespace.useRef(null);
  var foreignRef = useForkRef(children.ref, ref);
  var handleRef = useForkRef(enableStrictModeCompat ? nodeRef : undefined, foreignRef);

  var normalizedTransitionCallback = function normalizedTransitionCallback(callback) {
    return function (nodeOrAppearing, maybeAppearing) {
      if (callback) {
        var _ref = enableStrictModeCompat ? [nodeRef.current, nodeOrAppearing] : [nodeOrAppearing, maybeAppearing],
            _ref2 = _slicedToArray(_ref, 2),
            node = _ref2[0],
            isAppearing = _ref2[1]; // onEnterXxx and onExitXxx callbacks have a different arguments.length value.


        if (isAppearing === undefined) {
          callback(node);
        } else {
          callback(node, isAppearing);
        }
      }
    };
  };

  var handleEntering = normalizedTransitionCallback(onEntering);
  var handleEnter = normalizedTransitionCallback(function (node, isAppearing) {
    reflow(node); // So the animation always start from the start.

    var transitionProps = getTransitionProps({
      style: style,
      timeout: timeout
    }, {
      mode: 'enter'
    });
    node.style.webkitTransition = theme.transitions.create('opacity', transitionProps);
    node.style.transition = theme.transitions.create('opacity', transitionProps);

    if (onEnter) {
      onEnter(node, isAppearing);
    }
  });
  var handleEntered = normalizedTransitionCallback(onEntered);
  var handleExiting = normalizedTransitionCallback(onExiting);
  var handleExit = normalizedTransitionCallback(function (node) {
    var transitionProps = getTransitionProps({
      style: style,
      timeout: timeout
    }, {
      mode: 'exit'
    });
    node.style.webkitTransition = theme.transitions.create('opacity', transitionProps);
    node.style.transition = theme.transitions.create('opacity', transitionProps);

    if (onExit) {
      onExit(node);
    }
  });
  var handleExited = normalizedTransitionCallback(onExited);
  return /*#__PURE__*/React__namespace.createElement(TransitionComponent, _extends$f({
    appear: true,
    in: inProp,
    nodeRef: enableStrictModeCompat ? nodeRef : undefined,
    onEnter: handleEnter,
    onEntered: handleEntered,
    onEntering: handleEntering,
    onExit: handleExit,
    onExited: handleExited,
    onExiting: handleExiting,
    timeout: timeout
  }, other), function (state, childProps) {
    return /*#__PURE__*/React__namespace.cloneElement(children, _extends$f({
      style: _extends$f({
        opacity: 0,
        visibility: state === 'exited' && !inProp ? 'hidden' : undefined
      }, styles$x[state], style, children.props.style),
      ref: handleRef
    }, childProps));
  });
});
var Fade$1 = Fade;var styles$w = {
  /* Styles applied to the root element. */
  root: {
    // Improve scrollable dialog support.
    zIndex: -1,
    position: 'fixed',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    right: 0,
    bottom: 0,
    top: 0,
    left: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    WebkitTapHighlightColor: 'transparent'
  },

  /* Styles applied to the root element if `invisible={true}`. */
  invisible: {
    backgroundColor: 'transparent'
  }
};
var Backdrop = /*#__PURE__*/React__namespace.forwardRef(function Backdrop(props, ref) {
  var children = props.children,
      classes = props.classes,
      className = props.className,
      _props$invisible = props.invisible,
      invisible = _props$invisible === void 0 ? false : _props$invisible,
      open = props.open,
      transitionDuration = props.transitionDuration,
      _props$TransitionComp = props.TransitionComponent,
      TransitionComponent = _props$TransitionComp === void 0 ? Fade$1 : _props$TransitionComp,
      other = _objectWithoutProperties$4(props, ["children", "classes", "className", "invisible", "open", "transitionDuration", "TransitionComponent"]);

  return /*#__PURE__*/React__namespace.createElement(TransitionComponent, _extends$f({
    in: open,
    timeout: transitionDuration
  }, other), /*#__PURE__*/React__namespace.createElement("div", {
    className: clsx(classes.root, className, invisible && classes.invisible),
    "aria-hidden": true,
    ref: ref
  }, children));
});
var Backdrop$1 = withStyles(styles$w, {
  name: 'MuiBackdrop'
})(Backdrop);var styles$v = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      margin: 0
    },

    /* Styles applied to the root element if `variant="body2"`. */
    body2: theme.typography.body2,

    /* Styles applied to the root element if `variant="body1"`. */
    body1: theme.typography.body1,

    /* Styles applied to the root element if `variant="caption"`. */
    caption: theme.typography.caption,

    /* Styles applied to the root element if `variant="button"`. */
    button: theme.typography.button,

    /* Styles applied to the root element if `variant="h1"`. */
    h1: theme.typography.h1,

    /* Styles applied to the root element if `variant="h2"`. */
    h2: theme.typography.h2,

    /* Styles applied to the root element if `variant="h3"`. */
    h3: theme.typography.h3,

    /* Styles applied to the root element if `variant="h4"`. */
    h4: theme.typography.h4,

    /* Styles applied to the root element if `variant="h5"`. */
    h5: theme.typography.h5,

    /* Styles applied to the root element if `variant="h6"`. */
    h6: theme.typography.h6,

    /* Styles applied to the root element if `variant="subtitle1"`. */
    subtitle1: theme.typography.subtitle1,

    /* Styles applied to the root element if `variant="subtitle2"`. */
    subtitle2: theme.typography.subtitle2,

    /* Styles applied to the root element if `variant="overline"`. */
    overline: theme.typography.overline,

    /* Styles applied to the root element if `variant="srOnly"`. Only accessible to screen readers. */
    srOnly: {
      position: 'absolute',
      height: 1,
      width: 1,
      overflow: 'hidden'
    },

    /* Styles applied to the root element if `align="left"`. */
    alignLeft: {
      textAlign: 'left'
    },

    /* Styles applied to the root element if `align="center"`. */
    alignCenter: {
      textAlign: 'center'
    },

    /* Styles applied to the root element if `align="right"`. */
    alignRight: {
      textAlign: 'right'
    },

    /* Styles applied to the root element if `align="justify"`. */
    alignJustify: {
      textAlign: 'justify'
    },

    /* Styles applied to the root element if `nowrap={true}`. */
    noWrap: {
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap'
    },

    /* Styles applied to the root element if `gutterBottom={true}`. */
    gutterBottom: {
      marginBottom: '0.35em'
    },

    /* Styles applied to the root element if `paragraph={true}`. */
    paragraph: {
      marginBottom: 16
    },

    /* Styles applied to the root element if `color="inherit"`. */
    colorInherit: {
      color: 'inherit'
    },

    /* Styles applied to the root element if `color="primary"`. */
    colorPrimary: {
      color: theme.palette.primary.main
    },

    /* Styles applied to the root element if `color="secondary"`. */
    colorSecondary: {
      color: theme.palette.secondary.main
    },

    /* Styles applied to the root element if `color="textPrimary"`. */
    colorTextPrimary: {
      color: theme.palette.text.primary
    },

    /* Styles applied to the root element if `color="textSecondary"`. */
    colorTextSecondary: {
      color: theme.palette.text.secondary
    },

    /* Styles applied to the root element if `color="error"`. */
    colorError: {
      color: theme.palette.error.main
    },

    /* Styles applied to the root element if `display="inline"`. */
    displayInline: {
      display: 'inline'
    },

    /* Styles applied to the root element if `display="block"`. */
    displayBlock: {
      display: 'block'
    }
  };
};
var defaultVariantMapping = {
  h1: 'h1',
  h2: 'h2',
  h3: 'h3',
  h4: 'h4',
  h5: 'h5',
  h6: 'h6',
  subtitle1: 'h6',
  subtitle2: 'h6',
  body1: 'p',
  body2: 'p'
};
var Typography = /*#__PURE__*/React__namespace.forwardRef(function Typography(props, ref) {
  var _props$align = props.align,
      align = _props$align === void 0 ? 'inherit' : _props$align,
      classes = props.classes,
      className = props.className,
      _props$color = props.color,
      color = _props$color === void 0 ? 'initial' : _props$color,
      component = props.component,
      _props$display = props.display,
      display = _props$display === void 0 ? 'initial' : _props$display,
      _props$gutterBottom = props.gutterBottom,
      gutterBottom = _props$gutterBottom === void 0 ? false : _props$gutterBottom,
      _props$noWrap = props.noWrap,
      noWrap = _props$noWrap === void 0 ? false : _props$noWrap,
      _props$paragraph = props.paragraph,
      paragraph = _props$paragraph === void 0 ? false : _props$paragraph,
      _props$variant = props.variant,
      variant = _props$variant === void 0 ? 'body1' : _props$variant,
      _props$variantMapping = props.variantMapping,
      variantMapping = _props$variantMapping === void 0 ? defaultVariantMapping : _props$variantMapping,
      other = _objectWithoutProperties$4(props, ["align", "classes", "className", "color", "component", "display", "gutterBottom", "noWrap", "paragraph", "variant", "variantMapping"]);

  var Component = component || (paragraph ? 'p' : variantMapping[variant] || defaultVariantMapping[variant]) || 'span';
  return /*#__PURE__*/React__namespace.createElement(Component, _extends$f({
    className: clsx(classes.root, className, variant !== 'inherit' && classes[variant], color !== 'initial' && classes["color".concat(capitalize(color))], noWrap && classes.noWrap, gutterBottom && classes.gutterBottom, paragraph && classes.paragraph, align !== 'inherit' && classes["align".concat(capitalize(align))], display !== 'initial' && classes["display".concat(capitalize(display))]),
    ref: ref
  }, other));
});
var Typography$1 = withStyles(styles$v, {
  name: 'MuiTypography'
})(Typography);var styles$u = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: _extends$f({}, theme.typography.button, {
      boxSizing: 'border-box',
      minWidth: 64,
      padding: '6px 16px',
      borderRadius: theme.shape.borderRadius,
      color: theme.palette.text.primary,
      transition: theme.transitions.create(['background-color', 'box-shadow', 'border'], {
        duration: theme.transitions.duration.short
      }),
      '&:hover': {
        textDecoration: 'none',
        backgroundColor: alpha$2(theme.palette.text.primary, theme.palette.action.hoverOpacity),
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          backgroundColor: 'transparent'
        },
        '&$disabled': {
          backgroundColor: 'transparent'
        }
      },
      '&$disabled': {
        color: theme.palette.action.disabled
      }
    }),

    /* Styles applied to the span element that wraps the children. */
    label: {
      width: '100%',
      // Ensure the correct width for iOS Safari
      display: 'inherit',
      alignItems: 'inherit',
      justifyContent: 'inherit'
    },

    /* Styles applied to the root element if `variant="text"`. */
    text: {
      padding: '6px 8px'
    },

    /* Styles applied to the root element if `variant="text"` and `color="primary"`. */
    textPrimary: {
      color: theme.palette.primary.main,
      '&:hover': {
        backgroundColor: alpha$2(theme.palette.primary.main, theme.palette.action.hoverOpacity),
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          backgroundColor: 'transparent'
        }
      }
    },

    /* Styles applied to the root element if `variant="text"` and `color="secondary"`. */
    textSecondary: {
      color: theme.palette.secondary.main,
      '&:hover': {
        backgroundColor: alpha$2(theme.palette.secondary.main, theme.palette.action.hoverOpacity),
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          backgroundColor: 'transparent'
        }
      }
    },

    /* Styles applied to the root element if `variant="outlined"`. */
    outlined: {
      padding: '5px 15px',
      border: "1px solid ".concat(theme.palette.type === 'light' ? 'rgba(0, 0, 0, 0.23)' : 'rgba(255, 255, 255, 0.23)'),
      '&$disabled': {
        border: "1px solid ".concat(theme.palette.action.disabledBackground)
      }
    },

    /* Styles applied to the root element if `variant="outlined"` and `color="primary"`. */
    outlinedPrimary: {
      color: theme.palette.primary.main,
      border: "1px solid ".concat(alpha$2(theme.palette.primary.main, 0.5)),
      '&:hover': {
        border: "1px solid ".concat(theme.palette.primary.main),
        backgroundColor: alpha$2(theme.palette.primary.main, theme.palette.action.hoverOpacity),
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          backgroundColor: 'transparent'
        }
      }
    },

    /* Styles applied to the root element if `variant="outlined"` and `color="secondary"`. */
    outlinedSecondary: {
      color: theme.palette.secondary.main,
      border: "1px solid ".concat(alpha$2(theme.palette.secondary.main, 0.5)),
      '&:hover': {
        border: "1px solid ".concat(theme.palette.secondary.main),
        backgroundColor: alpha$2(theme.palette.secondary.main, theme.palette.action.hoverOpacity),
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          backgroundColor: 'transparent'
        }
      },
      '&$disabled': {
        border: "1px solid ".concat(theme.palette.action.disabled)
      }
    },

    /* Styles applied to the root element if `variant="contained"`. */
    contained: {
      color: theme.palette.getContrastText(theme.palette.grey[300]),
      backgroundColor: theme.palette.grey[300],
      boxShadow: theme.shadows[2],
      '&:hover': {
        backgroundColor: theme.palette.grey.A100,
        boxShadow: theme.shadows[4],
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          boxShadow: theme.shadows[2],
          backgroundColor: theme.palette.grey[300]
        },
        '&$disabled': {
          backgroundColor: theme.palette.action.disabledBackground
        }
      },
      '&$focusVisible': {
        boxShadow: theme.shadows[6]
      },
      '&:active': {
        boxShadow: theme.shadows[8]
      },
      '&$disabled': {
        color: theme.palette.action.disabled,
        boxShadow: theme.shadows[0],
        backgroundColor: theme.palette.action.disabledBackground
      }
    },

    /* Styles applied to the root element if `variant="contained"` and `color="primary"`. */
    containedPrimary: {
      color: theme.palette.primary.contrastText,
      backgroundColor: theme.palette.primary.main,
      '&:hover': {
        backgroundColor: theme.palette.primary.dark,
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          backgroundColor: theme.palette.primary.main
        }
      }
    },

    /* Styles applied to the root element if `variant="contained"` and `color="secondary"`. */
    containedSecondary: {
      color: theme.palette.secondary.contrastText,
      backgroundColor: theme.palette.secondary.main,
      '&:hover': {
        backgroundColor: theme.palette.secondary.dark,
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          backgroundColor: theme.palette.secondary.main
        }
      }
    },

    /* Styles applied to the root element if `disableElevation={true}`. */
    disableElevation: {
      boxShadow: 'none',
      '&:hover': {
        boxShadow: 'none'
      },
      '&$focusVisible': {
        boxShadow: 'none'
      },
      '&:active': {
        boxShadow: 'none'
      },
      '&$disabled': {
        boxShadow: 'none'
      }
    },

    /* Pseudo-class applied to the ButtonBase root element if the button is keyboard focused. */
    focusVisible: {},

    /* Pseudo-class applied to the root element if `disabled={true}`. */
    disabled: {},

    /* Styles applied to the root element if `color="inherit"`. */
    colorInherit: {
      color: 'inherit',
      borderColor: 'currentColor'
    },

    /* Styles applied to the root element if `size="small"` and `variant="text"`. */
    textSizeSmall: {
      padding: '4px 5px',
      fontSize: theme.typography.pxToRem(13)
    },

    /* Styles applied to the root element if `size="large"` and `variant="text"`. */
    textSizeLarge: {
      padding: '8px 11px',
      fontSize: theme.typography.pxToRem(15)
    },

    /* Styles applied to the root element if `size="small"` and `variant="outlined"`. */
    outlinedSizeSmall: {
      padding: '3px 9px',
      fontSize: theme.typography.pxToRem(13)
    },

    /* Styles applied to the root element if `size="large"` and `variant="outlined"`. */
    outlinedSizeLarge: {
      padding: '7px 21px',
      fontSize: theme.typography.pxToRem(15)
    },

    /* Styles applied to the root element if `size="small"` and `variant="contained"`. */
    containedSizeSmall: {
      padding: '4px 10px',
      fontSize: theme.typography.pxToRem(13)
    },

    /* Styles applied to the root element if `size="large"` and `variant="contained"`. */
    containedSizeLarge: {
      padding: '8px 22px',
      fontSize: theme.typography.pxToRem(15)
    },

    /* Styles applied to the root element if `size="small"`. */
    sizeSmall: {},

    /* Styles applied to the root element if `size="large"`. */
    sizeLarge: {},

    /* Styles applied to the root element if `fullWidth={true}`. */
    fullWidth: {
      width: '100%'
    },

    /* Styles applied to the startIcon element if supplied. */
    startIcon: {
      display: 'inherit',
      marginRight: 8,
      marginLeft: -4,
      '&$iconSizeSmall': {
        marginLeft: -2
      }
    },

    /* Styles applied to the endIcon element if supplied. */
    endIcon: {
      display: 'inherit',
      marginRight: -4,
      marginLeft: 8,
      '&$iconSizeSmall': {
        marginRight: -2
      }
    },

    /* Styles applied to the icon element if supplied and `size="small"`. */
    iconSizeSmall: {
      '& > *:first-child': {
        fontSize: 18
      }
    },

    /* Styles applied to the icon element if supplied and `size="medium"`. */
    iconSizeMedium: {
      '& > *:first-child': {
        fontSize: 20
      }
    },

    /* Styles applied to the icon element if supplied and `size="large"`. */
    iconSizeLarge: {
      '& > *:first-child': {
        fontSize: 22
      }
    }
  };
};
var Button$2 = /*#__PURE__*/React__namespace.forwardRef(function Button(props, ref) {
  var children = props.children,
      classes = props.classes,
      className = props.className,
      _props$color = props.color,
      color = _props$color === void 0 ? 'default' : _props$color,
      _props$component = props.component,
      component = _props$component === void 0 ? 'button' : _props$component,
      _props$disabled = props.disabled,
      disabled = _props$disabled === void 0 ? false : _props$disabled,
      _props$disableElevati = props.disableElevation,
      disableElevation = _props$disableElevati === void 0 ? false : _props$disableElevati,
      _props$disableFocusRi = props.disableFocusRipple,
      disableFocusRipple = _props$disableFocusRi === void 0 ? false : _props$disableFocusRi,
      endIconProp = props.endIcon,
      focusVisibleClassName = props.focusVisibleClassName,
      _props$fullWidth = props.fullWidth,
      fullWidth = _props$fullWidth === void 0 ? false : _props$fullWidth,
      _props$size = props.size,
      size = _props$size === void 0 ? 'medium' : _props$size,
      startIconProp = props.startIcon,
      _props$type = props.type,
      type = _props$type === void 0 ? 'button' : _props$type,
      _props$variant = props.variant,
      variant = _props$variant === void 0 ? 'text' : _props$variant,
      other = _objectWithoutProperties$4(props, ["children", "classes", "className", "color", "component", "disabled", "disableElevation", "disableFocusRipple", "endIcon", "focusVisibleClassName", "fullWidth", "size", "startIcon", "type", "variant"]);

  var startIcon = startIconProp && /*#__PURE__*/React__namespace.createElement("span", {
    className: clsx(classes.startIcon, classes["iconSize".concat(capitalize(size))])
  }, startIconProp);
  var endIcon = endIconProp && /*#__PURE__*/React__namespace.createElement("span", {
    className: clsx(classes.endIcon, classes["iconSize".concat(capitalize(size))])
  }, endIconProp);
  return /*#__PURE__*/React__namespace.createElement(ButtonBase$1, _extends$f({
    className: clsx(classes.root, classes[variant], className, color === 'inherit' ? classes.colorInherit : color !== 'default' && classes["".concat(variant).concat(capitalize(color))], size !== 'medium' && [classes["".concat(variant, "Size").concat(capitalize(size))], classes["size".concat(capitalize(size))]], disableElevation && classes.disableElevation, disabled && classes.disabled, fullWidth && classes.fullWidth),
    component: component,
    disabled: disabled,
    focusRipple: !disableFocusRipple,
    focusVisibleClassName: clsx(classes.focusVisible, focusVisibleClassName),
    ref: ref,
    type: type
  }, other), /*#__PURE__*/React__namespace.createElement("span", {
    className: classes.label
  }, startIcon, children, endIcon));
});
var Button$3 = withStyles(styles$u, {
  name: 'MuiButton'
})(Button$2);/**
 * @ignore - internal component.
 */

var FormControlContext = React__namespace.createContext();

function useFormControl$1() {
  return React__namespace.useContext(FormControlContext);
}
var FormControlContext$1 = FormControlContext;function useFormControl() {
  return React__namespace.useContext(FormControlContext$1);
}var SIZE = 44;
var styles$t = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      display: 'inline-block'
    },

    /* Styles applied to the root element if `variant="static"`. */
    static: {
      transition: theme.transitions.create('transform')
    },

    /* Styles applied to the root element if `variant="indeterminate"`. */
    indeterminate: {
      animation: '$circular-rotate 1.4s linear infinite'
    },

    /* Styles applied to the root element if `variant="determinate"`. */
    determinate: {
      transition: theme.transitions.create('transform')
    },

    /* Styles applied to the root element if `color="primary"`. */
    colorPrimary: {
      color: theme.palette.primary.main
    },

    /* Styles applied to the root element if `color="secondary"`. */
    colorSecondary: {
      color: theme.palette.secondary.main
    },

    /* Styles applied to the `svg` element. */
    svg: {
      display: 'block' // Keeps the progress centered

    },

    /* Styles applied to the `circle` svg path. */
    circle: {
      stroke: 'currentColor' // Use butt to follow the specification, by chance, it's already the default CSS value.
      // strokeLinecap: 'butt',

    },

    /* Styles applied to the `circle` svg path if `variant="static"`. */
    circleStatic: {
      transition: theme.transitions.create('stroke-dashoffset')
    },

    /* Styles applied to the `circle` svg path if `variant="indeterminate"`. */
    circleIndeterminate: {
      animation: '$circular-dash 1.4s ease-in-out infinite',
      // Some default value that looks fine waiting for the animation to kicks in.
      strokeDasharray: '80px, 200px',
      strokeDashoffset: '0px' // Add the unit to fix a Edge 16 and below bug.

    },

    /* Styles applied to the `circle` svg path if `variant="determinate"`. */
    circleDeterminate: {
      transition: theme.transitions.create('stroke-dashoffset')
    },
    '@keyframes circular-rotate': {
      '0%': {
        // Fix IE 11 wobbly
        transformOrigin: '50% 50%'
      },
      '100%': {
        transform: 'rotate(360deg)'
      }
    },
    '@keyframes circular-dash': {
      '0%': {
        strokeDasharray: '1px, 200px',
        strokeDashoffset: '0px'
      },
      '50%': {
        strokeDasharray: '100px, 200px',
        strokeDashoffset: '-15px'
      },
      '100%': {
        strokeDasharray: '100px, 200px',
        strokeDashoffset: '-125px'
      }
    },

    /* Styles applied to the `circle` svg path if `disableShrink={true}`. */
    circleDisableShrink: {
      animation: 'none'
    }
  };
};
/**
 * ## ARIA
 *
 * If the progress bar is describing the loading progress of a particular region of a page,
 * you should use `aria-describedby` to point to the progress bar, and set the `aria-busy`
 * attribute to `true` on that region until it has finished loading.
 */

var CircularProgress = /*#__PURE__*/React__namespace.forwardRef(function CircularProgress(props, ref) {
  var classes = props.classes,
      className = props.className,
      _props$color = props.color,
      color = _props$color === void 0 ? 'primary' : _props$color,
      _props$disableShrink = props.disableShrink,
      disableShrink = _props$disableShrink === void 0 ? false : _props$disableShrink,
      _props$size = props.size,
      size = _props$size === void 0 ? 40 : _props$size,
      style = props.style,
      _props$thickness = props.thickness,
      thickness = _props$thickness === void 0 ? 3.6 : _props$thickness,
      _props$value = props.value,
      value = _props$value === void 0 ? 0 : _props$value,
      _props$variant = props.variant,
      variant = _props$variant === void 0 ? 'indeterminate' : _props$variant,
      other = _objectWithoutProperties$4(props, ["classes", "className", "color", "disableShrink", "size", "style", "thickness", "value", "variant"]);

  var circleStyle = {};
  var rootStyle = {};
  var rootProps = {};

  if (variant === 'determinate' || variant === 'static') {
    var circumference = 2 * Math.PI * ((SIZE - thickness) / 2);
    circleStyle.strokeDasharray = circumference.toFixed(3);
    rootProps['aria-valuenow'] = Math.round(value);
    circleStyle.strokeDashoffset = "".concat(((100 - value) / 100 * circumference).toFixed(3), "px");
    rootStyle.transform = 'rotate(-90deg)';
  }

  return /*#__PURE__*/React__namespace.createElement("div", _extends$f({
    className: clsx(classes.root, className, color !== 'inherit' && classes["color".concat(capitalize(color))], {
      'determinate': classes.determinate,
      'indeterminate': classes.indeterminate,
      'static': classes.static
    }[variant]),
    style: _extends$f({
      width: size,
      height: size
    }, rootStyle, style),
    ref: ref,
    role: "progressbar"
  }, rootProps, other), /*#__PURE__*/React__namespace.createElement("svg", {
    className: classes.svg,
    viewBox: "".concat(SIZE / 2, " ").concat(SIZE / 2, " ").concat(SIZE, " ").concat(SIZE)
  }, /*#__PURE__*/React__namespace.createElement("circle", {
    className: clsx(classes.circle, disableShrink && classes.circleDisableShrink, {
      'determinate': classes.circleDeterminate,
      'indeterminate': classes.circleIndeterminate,
      'static': classes.circleStatic
    }[variant]),
    style: circleStyle,
    cx: SIZE,
    cy: SIZE,
    r: (SIZE - thickness) / 2,
    fill: "none",
    strokeWidth: thickness
  })));
});
var CircularProgress$1 = withStyles(styles$t, {
  name: 'MuiCircularProgress',
  flip: false
})(CircularProgress);function mapEventPropToEvent(eventProp) {
  return eventProp.substring(2).toLowerCase();
}

function clickedRootScrollbar(event) {
  return document.documentElement.clientWidth < event.clientX || document.documentElement.clientHeight < event.clientY;
}
/**
 * Listen for click events that occur somewhere in the document, outside of the element itself.
 * For instance, if you need to hide a menu when people click anywhere else on your page.
 */


function ClickAwayListener(props) {
  var children = props.children,
      _props$disableReactTr = props.disableReactTree,
      disableReactTree = _props$disableReactTr === void 0 ? false : _props$disableReactTr,
      _props$mouseEvent = props.mouseEvent,
      mouseEvent = _props$mouseEvent === void 0 ? 'onClick' : _props$mouseEvent,
      onClickAway = props.onClickAway,
      _props$touchEvent = props.touchEvent,
      touchEvent = _props$touchEvent === void 0 ? 'onTouchEnd' : _props$touchEvent;
  var movedRef = React__namespace.useRef(false);
  var nodeRef = React__namespace.useRef(null);
  var activatedRef = React__namespace.useRef(false);
  var syntheticEventRef = React__namespace.useRef(false);
  React__namespace.useEffect(function () {
    // Ensure that this component is not "activated" synchronously.
    // https://github.com/facebook/react/issues/20074
    setTimeout(function () {
      activatedRef.current = true;
    }, 0);
    return function () {
      activatedRef.current = false;
    };
  }, []); // can be removed once we drop support for non ref forwarding class components

  var handleOwnRef = React__namespace.useCallback(function (instance) {
    // #StrictMode ready
    nodeRef.current = ReactDOM__namespace.findDOMNode(instance);
  }, []);
  var handleRef = useForkRef(children.ref, handleOwnRef); // The handler doesn't take event.defaultPrevented into account:
  //
  // event.preventDefault() is meant to stop default behaviours like
  // clicking a checkbox to check it, hitting a button to submit a form,
  // and hitting left arrow to move the cursor in a text input etc.
  // Only special HTML elements have these default behaviors.

  var handleClickAway = useEventCallback(function (event) {
    // Given developers can stop the propagation of the synthetic event,
    // we can only be confident with a positive value.
    var insideReactTree = syntheticEventRef.current;
    syntheticEventRef.current = false; // 1. IE 11 support, which trigger the handleClickAway even after the unbind
    // 2. The child might render null.
    // 3. Behave like a blur listener.

    if (!activatedRef.current || !nodeRef.current || clickedRootScrollbar(event)) {
      return;
    } // Do not act if user performed touchmove


    if (movedRef.current) {
      movedRef.current = false;
      return;
    }

    var insideDOM; // If not enough, can use https://github.com/DieterHolvoet/event-propagation-path/blob/master/propagationPath.js

    if (event.composedPath) {
      insideDOM = event.composedPath().indexOf(nodeRef.current) > -1;
    } else {
      // TODO v6 remove dead logic https://caniuse.com/#search=composedPath.
      var doc = ownerDocument(nodeRef.current);
      insideDOM = !doc.documentElement.contains(event.target) || nodeRef.current.contains(event.target);
    }

    if (!insideDOM && (disableReactTree || !insideReactTree)) {
      onClickAway(event);
    }
  }); // Keep track of mouse/touch events that bubbled up through the portal.

  var createHandleSynthetic = function createHandleSynthetic(handlerName) {
    return function (event) {
      syntheticEventRef.current = true;
      var childrenPropsHandler = children.props[handlerName];

      if (childrenPropsHandler) {
        childrenPropsHandler(event);
      }
    };
  };

  var childrenProps = {
    ref: handleRef
  };

  if (touchEvent !== false) {
    childrenProps[touchEvent] = createHandleSynthetic(touchEvent);
  }

  React__namespace.useEffect(function () {
    if (touchEvent !== false) {
      var mappedTouchEvent = mapEventPropToEvent(touchEvent);
      var doc = ownerDocument(nodeRef.current);

      var handleTouchMove = function handleTouchMove() {
        movedRef.current = true;
      };

      doc.addEventListener(mappedTouchEvent, handleClickAway);
      doc.addEventListener('touchmove', handleTouchMove);
      return function () {
        doc.removeEventListener(mappedTouchEvent, handleClickAway);
        doc.removeEventListener('touchmove', handleTouchMove);
      };
    }

    return undefined;
  }, [handleClickAway, touchEvent]);

  if (mouseEvent !== false) {
    childrenProps[mouseEvent] = createHandleSynthetic(mouseEvent);
  }

  React__namespace.useEffect(function () {
    if (mouseEvent !== false) {
      var mappedMouseEvent = mapEventPropToEvent(mouseEvent);
      var doc = ownerDocument(nodeRef.current);
      doc.addEventListener(mappedMouseEvent, handleClickAway);
      return function () {
        doc.removeEventListener(mappedMouseEvent, handleClickAway);
      };
    }

    return undefined;
  }, [handleClickAway, mouseEvent]);
  return /*#__PURE__*/React__namespace.createElement(React__namespace.Fragment, null, /*#__PURE__*/React__namespace.cloneElement(children, childrenProps));
}function getContainer$1(container) {
  container = typeof container === 'function' ? container() : container; // #StrictMode ready

  return ReactDOM__namespace.findDOMNode(container);
}

var useEnhancedEffect$4 = typeof window !== 'undefined' ? React__namespace.useLayoutEffect : React__namespace.useEffect;
/**
 * Portals provide a first-class way to render children into a DOM node
 * that exists outside the DOM hierarchy of the parent component.
 */

var Portal$3 = /*#__PURE__*/React__namespace.forwardRef(function Portal(props, ref) {
  var children = props.children,
      container = props.container,
      _props$disablePortal = props.disablePortal,
      disablePortal = _props$disablePortal === void 0 ? false : _props$disablePortal,
      onRendered = props.onRendered;

  var _React$useState = React__namespace.useState(null),
      mountNode = _React$useState[0],
      setMountNode = _React$useState[1];

  var handleRef = useForkRef( /*#__PURE__*/React__namespace.isValidElement(children) ? children.ref : null, ref);
  useEnhancedEffect$4(function () {
    if (!disablePortal) {
      setMountNode(getContainer$1(container) || document.body);
    }
  }, [container, disablePortal]);
  useEnhancedEffect$4(function () {
    if (mountNode && !disablePortal) {
      setRef(ref, mountNode);
      return function () {
        setRef(ref, null);
      };
    }

    return undefined;
  }, [ref, mountNode, disablePortal]);
  useEnhancedEffect$4(function () {
    if (onRendered && (mountNode || disablePortal)) {
      onRendered();
    }
  }, [onRendered, mountNode, disablePortal]);

  if (disablePortal) {
    if ( /*#__PURE__*/React__namespace.isValidElement(children)) {
      return /*#__PURE__*/React__namespace.cloneElement(children, {
        ref: handleRef
      });
    }

    return children;
  }

  return mountNode ? /*#__PURE__*/ReactDOM__namespace.createPortal(children, mountNode) : mountNode;
});

var Portal$4 = Portal$3;// A change of the browser zoom change the scrollbar size.
// Credit https://github.com/twbs/bootstrap/blob/3ffe3a5d82f6f561b82ff78d82b32a7d14aed558/js/src/modal.js#L512-L519
function getScrollbarSize() {
  var scrollDiv = document.createElement('div');
  scrollDiv.style.width = '99px';
  scrollDiv.style.height = '99px';
  scrollDiv.style.position = 'absolute';
  scrollDiv.style.top = '-9999px';
  scrollDiv.style.overflow = 'scroll';
  document.body.appendChild(scrollDiv);
  var scrollbarSize = scrollDiv.offsetWidth - scrollDiv.clientWidth;
  document.body.removeChild(scrollDiv);
  return scrollbarSize;
}function isOverflowing(container) {
  var doc = ownerDocument(container);

  if (doc.body === container) {
    return ownerWindow(doc).innerWidth > doc.documentElement.clientWidth;
  }

  return container.scrollHeight > container.clientHeight;
}

function ariaHidden(node, show) {
  if (show) {
    node.setAttribute('aria-hidden', 'true');
  } else {
    node.removeAttribute('aria-hidden');
  }
}

function getPaddingRight(node) {
  return parseInt(window.getComputedStyle(node)['padding-right'], 10) || 0;
}

function ariaHiddenSiblings(container, mountNode, currentNode) {
  var nodesToExclude = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];
  var show = arguments.length > 4 ? arguments[4] : undefined;
  var blacklist = [mountNode, currentNode].concat(_toConsumableArray(nodesToExclude));
  var blacklistTagNames = ['TEMPLATE', 'SCRIPT', 'STYLE'];
  [].forEach.call(container.children, function (node) {
    if (node.nodeType === 1 && blacklist.indexOf(node) === -1 && blacklistTagNames.indexOf(node.tagName) === -1) {
      ariaHidden(node, show);
    }
  });
}

function findIndexOf(containerInfo, callback) {
  var idx = -1;
  containerInfo.some(function (item, index) {
    if (callback(item)) {
      idx = index;
      return true;
    }

    return false;
  });
  return idx;
}

function handleContainer(containerInfo, props) {
  var restoreStyle = [];
  var restorePaddings = [];
  var container = containerInfo.container;
  var fixedNodes;

  if (!props.disableScrollLock) {
    if (isOverflowing(container)) {
      // Compute the size before applying overflow hidden to avoid any scroll jumps.
      var scrollbarSize = getScrollbarSize();
      restoreStyle.push({
        value: container.style.paddingRight,
        key: 'padding-right',
        el: container
      }); // Use computed style, here to get the real padding to add our scrollbar width.

      container.style['padding-right'] = "".concat(getPaddingRight(container) + scrollbarSize, "px"); // .mui-fixed is a global helper.

      fixedNodes = ownerDocument(container).querySelectorAll('.mui-fixed');
      [].forEach.call(fixedNodes, function (node) {
        restorePaddings.push(node.style.paddingRight);
        node.style.paddingRight = "".concat(getPaddingRight(node) + scrollbarSize, "px");
      });
    } // Improve Gatsby support
    // https://css-tricks.com/snippets/css/force-vertical-scrollbar/


    var parent = container.parentElement;
    var scrollContainer = parent.nodeName === 'HTML' && window.getComputedStyle(parent)['overflow-y'] === 'scroll' ? parent : container; // Block the scroll even if no scrollbar is visible to account for mobile keyboard
    // screensize shrink.

    restoreStyle.push({
      value: scrollContainer.style.overflow,
      key: 'overflow',
      el: scrollContainer
    });
    scrollContainer.style.overflow = 'hidden';
  }

  var restore = function restore() {
    if (fixedNodes) {
      [].forEach.call(fixedNodes, function (node, i) {
        if (restorePaddings[i]) {
          node.style.paddingRight = restorePaddings[i];
        } else {
          node.style.removeProperty('padding-right');
        }
      });
    }

    restoreStyle.forEach(function (_ref) {
      var value = _ref.value,
          el = _ref.el,
          key = _ref.key;

      if (value) {
        el.style.setProperty(key, value);
      } else {
        el.style.removeProperty(key);
      }
    });
  };

  return restore;
}

function getHiddenSiblings(container) {
  var hiddenSiblings = [];
  [].forEach.call(container.children, function (node) {
    if (node.getAttribute && node.getAttribute('aria-hidden') === 'true') {
      hiddenSiblings.push(node);
    }
  });
  return hiddenSiblings;
}
/**
 * @ignore - do not document.
 *
 * Proper state management for containers and the modals in those containers.
 * Simplified, but inspired by react-overlay's ModalManager class.
 * Used by the Modal to ensure proper styling of containers.
 */


var ModalManager = /*#__PURE__*/function () {
  function ModalManager() {
    _classCallCheck$d(this, ModalManager);

    // this.modals[modalIndex] = modal
    this.modals = []; // this.containers[containerIndex] = {
    //   modals: [],
    //   container,
    //   restore: null,
    // }

    this.containers = [];
  }

  _createClass$b(ModalManager, [{
    key: "add",
    value: function add(modal, container) {
      var modalIndex = this.modals.indexOf(modal);

      if (modalIndex !== -1) {
        return modalIndex;
      }

      modalIndex = this.modals.length;
      this.modals.push(modal); // If the modal we are adding is already in the DOM.

      if (modal.modalRef) {
        ariaHidden(modal.modalRef, false);
      }

      var hiddenSiblingNodes = getHiddenSiblings(container);
      ariaHiddenSiblings(container, modal.mountNode, modal.modalRef, hiddenSiblingNodes, true);
      var containerIndex = findIndexOf(this.containers, function (item) {
        return item.container === container;
      });

      if (containerIndex !== -1) {
        this.containers[containerIndex].modals.push(modal);
        return modalIndex;
      }

      this.containers.push({
        modals: [modal],
        container: container,
        restore: null,
        hiddenSiblingNodes: hiddenSiblingNodes
      });
      return modalIndex;
    }
  }, {
    key: "mount",
    value: function mount(modal, props) {
      var containerIndex = findIndexOf(this.containers, function (item) {
        return item.modals.indexOf(modal) !== -1;
      });
      var containerInfo = this.containers[containerIndex];

      if (!containerInfo.restore) {
        containerInfo.restore = handleContainer(containerInfo, props);
      }
    }
  }, {
    key: "remove",
    value: function remove(modal) {
      var modalIndex = this.modals.indexOf(modal);

      if (modalIndex === -1) {
        return modalIndex;
      }

      var containerIndex = findIndexOf(this.containers, function (item) {
        return item.modals.indexOf(modal) !== -1;
      });
      var containerInfo = this.containers[containerIndex];
      containerInfo.modals.splice(containerInfo.modals.indexOf(modal), 1);
      this.modals.splice(modalIndex, 1); // If that was the last modal in a container, clean up the container.

      if (containerInfo.modals.length === 0) {
        // The modal might be closed before it had the chance to be mounted in the DOM.
        if (containerInfo.restore) {
          containerInfo.restore();
        }

        if (modal.modalRef) {
          // In case the modal wasn't in the DOM yet.
          ariaHidden(modal.modalRef, true);
        }

        ariaHiddenSiblings(containerInfo.container, modal.mountNode, modal.modalRef, containerInfo.hiddenSiblingNodes, false);
        this.containers.splice(containerIndex, 1);
      } else {
        // Otherwise make sure the next top modal is visible to a screen reader.
        var nextTop = containerInfo.modals[containerInfo.modals.length - 1]; // as soon as a modal is adding its modalRef is undefined. it can't set
        // aria-hidden because the dom element doesn't exist either
        // when modal was unmounted before modalRef gets null

        if (nextTop.modalRef) {
          ariaHidden(nextTop.modalRef, false);
        }
      }

      return modalIndex;
    }
  }, {
    key: "isTopModal",
    value: function isTopModal(modal) {
      return this.modals.length > 0 && this.modals[this.modals.length - 1] === modal;
    }
  }]);

  return ModalManager;
}();/* eslint-disable consistent-return, jsx-a11y/no-noninteractive-tabindex, camelcase */
/**
 * Utility component that locks focus inside the component.
 */

function Unstable_TrapFocus(props) {
  var children = props.children,
      _props$disableAutoFoc = props.disableAutoFocus,
      disableAutoFocus = _props$disableAutoFoc === void 0 ? false : _props$disableAutoFoc,
      _props$disableEnforce = props.disableEnforceFocus,
      disableEnforceFocus = _props$disableEnforce === void 0 ? false : _props$disableEnforce,
      _props$disableRestore = props.disableRestoreFocus,
      disableRestoreFocus = _props$disableRestore === void 0 ? false : _props$disableRestore,
      getDoc = props.getDoc,
      isEnabled = props.isEnabled,
      open = props.open;
  var ignoreNextEnforceFocus = React__namespace.useRef();
  var sentinelStart = React__namespace.useRef(null);
  var sentinelEnd = React__namespace.useRef(null);
  var nodeToRestore = React__namespace.useRef();
  var rootRef = React__namespace.useRef(null); // can be removed once we drop support for non ref forwarding class components

  var handleOwnRef = React__namespace.useCallback(function (instance) {
    // #StrictMode ready
    rootRef.current = ReactDOM__namespace.findDOMNode(instance);
  }, []);
  var handleRef = useForkRef(children.ref, handleOwnRef);
  var prevOpenRef = React__namespace.useRef();
  React__namespace.useEffect(function () {
    prevOpenRef.current = open;
  }, [open]);

  if (!prevOpenRef.current && open && typeof window !== 'undefined') {
    // WARNING: Potentially unsafe in concurrent mode.
    // The way the read on `nodeToRestore` is setup could make this actually safe.
    // Say we render `open={false}` -> `open={true}` but never commit.
    // We have now written a state that wasn't committed. But no committed effect
    // will read this wrong value. We only read from `nodeToRestore` in effects
    // that were committed on `open={true}`
    // WARNING: Prevents the instance from being garbage collected. Should only
    // hold a weak ref.
    nodeToRestore.current = getDoc().activeElement;
  }

  React__namespace.useEffect(function () {
    if (!open) {
      return;
    }

    var doc = ownerDocument(rootRef.current); // We might render an empty child.

    if (!disableAutoFocus && rootRef.current && !rootRef.current.contains(doc.activeElement)) {
      if (!rootRef.current.hasAttribute('tabIndex')) {

        rootRef.current.setAttribute('tabIndex', -1);
      }

      rootRef.current.focus();
    }

    var contain = function contain() {
      var rootElement = rootRef.current; // Cleanup functions are executed lazily in React 17.
      // Contain can be called between the component being unmounted and its cleanup function being run.

      if (rootElement === null) {
        return;
      }

      if (!doc.hasFocus() || disableEnforceFocus || !isEnabled() || ignoreNextEnforceFocus.current) {
        ignoreNextEnforceFocus.current = false;
        return;
      }

      if (rootRef.current && !rootRef.current.contains(doc.activeElement)) {
        rootRef.current.focus();
      }
    };

    var loopFocus = function loopFocus(event) {
      // 9 = Tab
      if (disableEnforceFocus || !isEnabled() || event.keyCode !== 9) {
        return;
      } // Make sure the next tab starts from the right place.


      if (doc.activeElement === rootRef.current) {
        // We need to ignore the next contain as
        // it will try to move the focus back to the rootRef element.
        ignoreNextEnforceFocus.current = true;

        if (event.shiftKey) {
          sentinelEnd.current.focus();
        } else {
          sentinelStart.current.focus();
        }
      }
    };

    doc.addEventListener('focus', contain, true);
    doc.addEventListener('keydown', loopFocus, true); // With Edge, Safari and Firefox, no focus related events are fired when the focused area stops being a focused area
    // e.g. https://bugzilla.mozilla.org/show_bug.cgi?id=559561.
    //
    // The whatwg spec defines how the browser should behave but does not explicitly mention any events:
    // https://html.spec.whatwg.org/multipage/interaction.html#focus-fixup-rule.

    var interval = setInterval(function () {
      contain();
    }, 50);
    return function () {
      clearInterval(interval);
      doc.removeEventListener('focus', contain, true);
      doc.removeEventListener('keydown', loopFocus, true); // restoreLastFocus()

      if (!disableRestoreFocus) {
        // In IE 11 it is possible for document.activeElement to be null resulting
        // in nodeToRestore.current being null.
        // Not all elements in IE 11 have a focus method.
        // Once IE 11 support is dropped the focus() call can be unconditional.
        if (nodeToRestore.current && nodeToRestore.current.focus) {
          nodeToRestore.current.focus();
        }

        nodeToRestore.current = null;
      }
    };
  }, [disableAutoFocus, disableEnforceFocus, disableRestoreFocus, isEnabled, open]);
  return /*#__PURE__*/React__namespace.createElement(React__namespace.Fragment, null, /*#__PURE__*/React__namespace.createElement("div", {
    tabIndex: 0,
    ref: sentinelStart,
    "data-test": "sentinelStart"
  }), /*#__PURE__*/React__namespace.cloneElement(children, {
    ref: handleRef
  }), /*#__PURE__*/React__namespace.createElement("div", {
    tabIndex: 0,
    ref: sentinelEnd,
    "data-test": "sentinelEnd"
  }));
}var styles$s = {
  /* Styles applied to the root element. */
  root: {
    zIndex: -1,
    position: 'fixed',
    right: 0,
    bottom: 0,
    top: 0,
    left: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    WebkitTapHighlightColor: 'transparent'
  },

  /* Styles applied to the root element if `invisible={true}`. */
  invisible: {
    backgroundColor: 'transparent'
  }
};
/**
 * @ignore - internal component.
 */

var SimpleBackdrop = /*#__PURE__*/React__namespace.forwardRef(function SimpleBackdrop(props, ref) {
  var _props$invisible = props.invisible,
      invisible = _props$invisible === void 0 ? false : _props$invisible,
      open = props.open,
      other = _objectWithoutProperties$4(props, ["invisible", "open"]);

  return open ? /*#__PURE__*/React__namespace.createElement("div", _extends$f({
    "aria-hidden": true,
    ref: ref
  }, other, {
    style: _extends$f({}, styles$s.root, invisible ? styles$s.invisible : {}, other.style)
  })) : null;
});
var SimpleBackdrop$1 = SimpleBackdrop;function getContainer(container) {
  container = typeof container === 'function' ? container() : container;
  return ReactDOM__namespace.findDOMNode(container);
}

function getHasTransition(props) {
  return props.children ? props.children.props.hasOwnProperty('in') : false;
} // A modal manager used to track and manage the state of open Modals.
// Modals don't open on the server so this won't conflict with concurrent requests.


var defaultManager = new ModalManager();
var styles$r = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      position: 'fixed',
      zIndex: theme.zIndex.modal,
      right: 0,
      bottom: 0,
      top: 0,
      left: 0
    },

    /* Styles applied to the root element if the `Modal` has exited. */
    hidden: {
      visibility: 'hidden'
    }
  };
};
/**
 * Modal is a lower-level construct that is leveraged by the following components:
 *
 * - [Dialog](/api/dialog/)
 * - [Drawer](/api/drawer/)
 * - [Menu](/api/menu/)
 * - [Popover](/api/popover/)
 *
 * If you are creating a modal dialog, you probably want to use the [Dialog](/api/dialog/) component
 * rather than directly using Modal.
 *
 * This component shares many concepts with [react-overlays](https://react-bootstrap.github.io/react-overlays/#modals).
 */

var Modal = /*#__PURE__*/React__namespace.forwardRef(function Modal(inProps, ref) {
  var theme = useTheme$1();
  var props = getThemeProps({
    name: 'MuiModal',
    props: _extends$f({}, inProps),
    theme: theme
  });

  var _props$BackdropCompon = props.BackdropComponent,
      BackdropComponent = _props$BackdropCompon === void 0 ? SimpleBackdrop$1 : _props$BackdropCompon,
      BackdropProps = props.BackdropProps,
      children = props.children,
      _props$closeAfterTran = props.closeAfterTransition,
      closeAfterTransition = _props$closeAfterTran === void 0 ? false : _props$closeAfterTran,
      container = props.container,
      _props$disableAutoFoc = props.disableAutoFocus,
      disableAutoFocus = _props$disableAutoFoc === void 0 ? false : _props$disableAutoFoc,
      _props$disableBackdro = props.disableBackdropClick,
      disableBackdropClick = _props$disableBackdro === void 0 ? false : _props$disableBackdro,
      _props$disableEnforce = props.disableEnforceFocus,
      disableEnforceFocus = _props$disableEnforce === void 0 ? false : _props$disableEnforce,
      _props$disableEscapeK = props.disableEscapeKeyDown,
      disableEscapeKeyDown = _props$disableEscapeK === void 0 ? false : _props$disableEscapeK,
      _props$disablePortal = props.disablePortal,
      disablePortal = _props$disablePortal === void 0 ? false : _props$disablePortal,
      _props$disableRestore = props.disableRestoreFocus,
      disableRestoreFocus = _props$disableRestore === void 0 ? false : _props$disableRestore,
      _props$disableScrollL = props.disableScrollLock,
      disableScrollLock = _props$disableScrollL === void 0 ? false : _props$disableScrollL,
      _props$hideBackdrop = props.hideBackdrop,
      hideBackdrop = _props$hideBackdrop === void 0 ? false : _props$hideBackdrop,
      _props$keepMounted = props.keepMounted,
      keepMounted = _props$keepMounted === void 0 ? false : _props$keepMounted,
      _props$manager = props.manager,
      manager = _props$manager === void 0 ? defaultManager : _props$manager,
      onBackdropClick = props.onBackdropClick,
      onClose = props.onClose,
      onEscapeKeyDown = props.onEscapeKeyDown,
      onRendered = props.onRendered,
      open = props.open,
      other = _objectWithoutProperties$4(props, ["BackdropComponent", "BackdropProps", "children", "closeAfterTransition", "container", "disableAutoFocus", "disableBackdropClick", "disableEnforceFocus", "disableEscapeKeyDown", "disablePortal", "disableRestoreFocus", "disableScrollLock", "hideBackdrop", "keepMounted", "manager", "onBackdropClick", "onClose", "onEscapeKeyDown", "onRendered", "open"]);

  var _React$useState = React__namespace.useState(true),
      exited = _React$useState[0],
      setExited = _React$useState[1];

  var modal = React__namespace.useRef({});
  var mountNodeRef = React__namespace.useRef(null);
  var modalRef = React__namespace.useRef(null);
  var handleRef = useForkRef(modalRef, ref);
  var hasTransition = getHasTransition(props);

  var getDoc = function getDoc() {
    return ownerDocument(mountNodeRef.current);
  };

  var getModal = function getModal() {
    modal.current.modalRef = modalRef.current;
    modal.current.mountNode = mountNodeRef.current;
    return modal.current;
  };

  var handleMounted = function handleMounted() {
    manager.mount(getModal(), {
      disableScrollLock: disableScrollLock
    }); // Fix a bug on Chrome where the scroll isn't initially 0.

    modalRef.current.scrollTop = 0;
  };

  var handleOpen = useEventCallback(function () {
    var resolvedContainer = getContainer(container) || getDoc().body;
    manager.add(getModal(), resolvedContainer); // The element was already mounted.

    if (modalRef.current) {
      handleMounted();
    }
  });
  var isTopModal = React__namespace.useCallback(function () {
    return manager.isTopModal(getModal());
  }, [manager]);
  var handlePortalRef = useEventCallback(function (node) {
    mountNodeRef.current = node;

    if (!node) {
      return;
    }

    if (onRendered) {
      onRendered();
    }

    if (open && isTopModal()) {
      handleMounted();
    } else {
      ariaHidden(modalRef.current, true);
    }
  });
  var handleClose = React__namespace.useCallback(function () {
    manager.remove(getModal());
  }, [manager]);
  React__namespace.useEffect(function () {
    return function () {
      handleClose();
    };
  }, [handleClose]);
  React__namespace.useEffect(function () {
    if (open) {
      handleOpen();
    } else if (!hasTransition || !closeAfterTransition) {
      handleClose();
    }
  }, [open, handleClose, hasTransition, closeAfterTransition, handleOpen]);

  if (!keepMounted && !open && (!hasTransition || exited)) {
    return null;
  }

  var handleEnter = function handleEnter() {
    setExited(false);
  };

  var handleExited = function handleExited() {
    setExited(true);

    if (closeAfterTransition) {
      handleClose();
    }
  };

  var handleBackdropClick = function handleBackdropClick(event) {
    if (event.target !== event.currentTarget) {
      return;
    }

    if (onBackdropClick) {
      onBackdropClick(event);
    }

    if (!disableBackdropClick && onClose) {
      onClose(event, 'backdropClick');
    }
  };

  var handleKeyDown = function handleKeyDown(event) {
    // The handler doesn't take event.defaultPrevented into account:
    //
    // event.preventDefault() is meant to stop default behaviours like
    // clicking a checkbox to check it, hitting a button to submit a form,
    // and hitting left arrow to move the cursor in a text input etc.
    // Only special HTML elements have these default behaviors.
    if (event.key !== 'Escape' || !isTopModal()) {
      return;
    }

    if (onEscapeKeyDown) {
      onEscapeKeyDown(event);
    }

    if (!disableEscapeKeyDown) {
      // Swallow the event, in case someone is listening for the escape key on the body.
      event.stopPropagation();

      if (onClose) {
        onClose(event, 'escapeKeyDown');
      }
    }
  };

  var inlineStyle = styles$r(theme || {
    zIndex: zIndex$2
  });
  var childProps = {};

  if (children.props.tabIndex === undefined) {
    childProps.tabIndex = children.props.tabIndex || '-1';
  } // It's a Transition like component


  if (hasTransition) {
    childProps.onEnter = createChainedFunction(handleEnter, children.props.onEnter);
    childProps.onExited = createChainedFunction(handleExited, children.props.onExited);
  }

  return /*#__PURE__*/React__namespace.createElement(Portal$4, {
    ref: handlePortalRef,
    container: container,
    disablePortal: disablePortal
  }, /*#__PURE__*/React__namespace.createElement("div", _extends$f({
    ref: handleRef,
    onKeyDown: handleKeyDown,
    role: "presentation"
  }, other, {
    style: _extends$f({}, inlineStyle.root, !open && exited ? inlineStyle.hidden : {}, other.style)
  }), hideBackdrop ? null : /*#__PURE__*/React__namespace.createElement(BackdropComponent, _extends$f({
    open: open,
    onClick: handleBackdropClick
  }, BackdropProps)), /*#__PURE__*/React__namespace.createElement(Unstable_TrapFocus, {
    disableEnforceFocus: disableEnforceFocus,
    disableAutoFocus: disableAutoFocus,
    disableRestoreFocus: disableRestoreFocus,
    getDoc: getDoc,
    isEnabled: isTopModal,
    open: open
  }, /*#__PURE__*/React__namespace.cloneElement(children, childProps))));
});
var Modal$1 = Modal;var styles$q = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      '@media print': {
        // Use !important to override the Modal inline-style.
        position: 'absolute !important'
      }
    },

    /* Styles applied to the container element if `scroll="paper"`. */
    scrollPaper: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center'
    },

    /* Styles applied to the container element if `scroll="body"`. */
    scrollBody: {
      overflowY: 'auto',
      overflowX: 'hidden',
      textAlign: 'center',
      '&:after': {
        content: '""',
        display: 'inline-block',
        verticalAlign: 'middle',
        height: '100%',
        width: '0'
      }
    },

    /* Styles applied to the container element. */
    container: {
      height: '100%',
      '@media print': {
        height: 'auto'
      },
      // We disable the focus ring for mouse, touch and keyboard users.
      outline: 0
    },

    /* Styles applied to the `Paper` component. */
    paper: {
      margin: 32,
      position: 'relative',
      overflowY: 'auto',
      // Fix IE 11 issue, to remove at some point.
      '@media print': {
        overflowY: 'visible',
        boxShadow: 'none'
      }
    },

    /* Styles applied to the `Paper` component if `scroll="paper"`. */
    paperScrollPaper: {
      display: 'flex',
      flexDirection: 'column',
      maxHeight: 'calc(100% - 64px)'
    },

    /* Styles applied to the `Paper` component if `scroll="body"`. */
    paperScrollBody: {
      display: 'inline-block',
      verticalAlign: 'middle',
      textAlign: 'left' // 'initial' doesn't work on IE 11

    },

    /* Styles applied to the `Paper` component if `maxWidth=false`. */
    paperWidthFalse: {
      maxWidth: 'calc(100% - 64px)'
    },

    /* Styles applied to the `Paper` component if `maxWidth="xs"`. */
    paperWidthXs: {
      maxWidth: Math.max(theme.breakpoints.values.xs, 444),
      '&$paperScrollBody': _defineProperty$3({}, theme.breakpoints.down(Math.max(theme.breakpoints.values.xs, 444) + 32 * 2), {
        maxWidth: 'calc(100% - 64px)'
      })
    },

    /* Styles applied to the `Paper` component if `maxWidth="sm"`. */
    paperWidthSm: {
      maxWidth: theme.breakpoints.values.sm,
      '&$paperScrollBody': _defineProperty$3({}, theme.breakpoints.down(theme.breakpoints.values.sm + 32 * 2), {
        maxWidth: 'calc(100% - 64px)'
      })
    },

    /* Styles applied to the `Paper` component if `maxWidth="md"`. */
    paperWidthMd: {
      maxWidth: theme.breakpoints.values.md,
      '&$paperScrollBody': _defineProperty$3({}, theme.breakpoints.down(theme.breakpoints.values.md + 32 * 2), {
        maxWidth: 'calc(100% - 64px)'
      })
    },

    /* Styles applied to the `Paper` component if `maxWidth="lg"`. */
    paperWidthLg: {
      maxWidth: theme.breakpoints.values.lg,
      '&$paperScrollBody': _defineProperty$3({}, theme.breakpoints.down(theme.breakpoints.values.lg + 32 * 2), {
        maxWidth: 'calc(100% - 64px)'
      })
    },

    /* Styles applied to the `Paper` component if `maxWidth="xl"`. */
    paperWidthXl: {
      maxWidth: theme.breakpoints.values.xl,
      '&$paperScrollBody': _defineProperty$3({}, theme.breakpoints.down(theme.breakpoints.values.xl + 32 * 2), {
        maxWidth: 'calc(100% - 64px)'
      })
    },

    /* Styles applied to the `Paper` component if `fullWidth={true}`. */
    paperFullWidth: {
      width: 'calc(100% - 64px)'
    },

    /* Styles applied to the `Paper` component if `fullScreen={true}`. */
    paperFullScreen: {
      margin: 0,
      width: '100%',
      maxWidth: '100%',
      height: '100%',
      maxHeight: 'none',
      borderRadius: 0,
      '&$paperScrollBody': {
        margin: 0,
        maxWidth: '100%'
      }
    }
  };
};
var defaultTransitionDuration = {
  enter: duration.enteringScreen,
  exit: duration.leavingScreen
};
/**
 * Dialogs are overlaid modal paper based components with a backdrop.
 */

var Dialog = /*#__PURE__*/React__namespace.forwardRef(function Dialog(props, ref) {
  var BackdropProps = props.BackdropProps,
      children = props.children,
      classes = props.classes,
      className = props.className,
      _props$disableBackdro = props.disableBackdropClick,
      disableBackdropClick = _props$disableBackdro === void 0 ? false : _props$disableBackdro,
      _props$disableEscapeK = props.disableEscapeKeyDown,
      disableEscapeKeyDown = _props$disableEscapeK === void 0 ? false : _props$disableEscapeK,
      _props$fullScreen = props.fullScreen,
      fullScreen = _props$fullScreen === void 0 ? false : _props$fullScreen,
      _props$fullWidth = props.fullWidth,
      fullWidth = _props$fullWidth === void 0 ? false : _props$fullWidth,
      _props$maxWidth = props.maxWidth,
      maxWidth = _props$maxWidth === void 0 ? 'sm' : _props$maxWidth,
      onBackdropClick = props.onBackdropClick,
      onClose = props.onClose,
      onEnter = props.onEnter,
      onEntered = props.onEntered,
      onEntering = props.onEntering,
      onEscapeKeyDown = props.onEscapeKeyDown,
      onExit = props.onExit,
      onExited = props.onExited,
      onExiting = props.onExiting,
      open = props.open,
      _props$PaperComponent = props.PaperComponent,
      PaperComponent = _props$PaperComponent === void 0 ? Paper$1 : _props$PaperComponent,
      _props$PaperProps = props.PaperProps,
      PaperProps = _props$PaperProps === void 0 ? {} : _props$PaperProps,
      _props$scroll = props.scroll,
      scroll = _props$scroll === void 0 ? 'paper' : _props$scroll,
      _props$TransitionComp = props.TransitionComponent,
      TransitionComponent = _props$TransitionComp === void 0 ? Fade$1 : _props$TransitionComp,
      _props$transitionDura = props.transitionDuration,
      transitionDuration = _props$transitionDura === void 0 ? defaultTransitionDuration : _props$transitionDura,
      TransitionProps = props.TransitionProps,
      ariaDescribedby = props['aria-describedby'],
      ariaLabelledby = props['aria-labelledby'],
      other = _objectWithoutProperties$4(props, ["BackdropProps", "children", "classes", "className", "disableBackdropClick", "disableEscapeKeyDown", "fullScreen", "fullWidth", "maxWidth", "onBackdropClick", "onClose", "onEnter", "onEntered", "onEntering", "onEscapeKeyDown", "onExit", "onExited", "onExiting", "open", "PaperComponent", "PaperProps", "scroll", "TransitionComponent", "transitionDuration", "TransitionProps", "aria-describedby", "aria-labelledby"]);

  var mouseDownTarget = React__namespace.useRef();

  var handleMouseDown = function handleMouseDown(event) {
    mouseDownTarget.current = event.target;
  };

  var handleBackdropClick = function handleBackdropClick(event) {
    // Ignore the events not coming from the "backdrop"
    // We don't want to close the dialog when clicking the dialog content.
    if (event.target !== event.currentTarget) {
      return;
    } // Make sure the event starts and ends on the same DOM element.


    if (event.target !== mouseDownTarget.current) {
      return;
    }

    mouseDownTarget.current = null;

    if (onBackdropClick) {
      onBackdropClick(event);
    }

    if (!disableBackdropClick && onClose) {
      onClose(event, 'backdropClick');
    }
  };

  return /*#__PURE__*/React__namespace.createElement(Modal$1, _extends$f({
    className: clsx(classes.root, className),
    BackdropComponent: Backdrop$1,
    BackdropProps: _extends$f({
      transitionDuration: transitionDuration
    }, BackdropProps),
    closeAfterTransition: true
  }, disableBackdropClick ? {
    disableBackdropClick: disableBackdropClick
  } : {}, {
    disableEscapeKeyDown: disableEscapeKeyDown,
    onEscapeKeyDown: onEscapeKeyDown,
    onClose: onClose,
    open: open,
    ref: ref
  }, other), /*#__PURE__*/React__namespace.createElement(TransitionComponent, _extends$f({
    appear: true,
    in: open,
    timeout: transitionDuration,
    onEnter: onEnter,
    onEntering: onEntering,
    onEntered: onEntered,
    onExit: onExit,
    onExiting: onExiting,
    onExited: onExited,
    role: "none presentation"
  }, TransitionProps), /*#__PURE__*/React__namespace.createElement("div", {
    className: clsx(classes.container, classes["scroll".concat(capitalize(scroll))]),
    onMouseUp: handleBackdropClick,
    onMouseDown: handleMouseDown
  }, /*#__PURE__*/React__namespace.createElement(PaperComponent, _extends$f({
    elevation: 24,
    role: "dialog",
    "aria-describedby": ariaDescribedby,
    "aria-labelledby": ariaLabelledby
  }, PaperProps, {
    className: clsx(classes.paper, classes["paperScroll".concat(capitalize(scroll))], classes["paperWidth".concat(capitalize(String(maxWidth)))], PaperProps.className, fullScreen && classes.paperFullScreen, fullWidth && classes.paperFullWidth)
  }), children))));
});
var Dialog$1 = withStyles(styles$q, {
  name: 'MuiDialog'
})(Dialog);var styles$p = {
  /* Styles applied to the root element. */
  root: {
    display: 'flex',
    alignItems: 'center',
    padding: 8,
    justifyContent: 'flex-end',
    flex: '0 0 auto'
  },

  /* Styles applied to the root element if `disableSpacing={false}`. */
  spacing: {
    '& > :not(:first-child)': {
      marginLeft: 8
    }
  }
};
var DialogActions = /*#__PURE__*/React__namespace.forwardRef(function DialogActions(props, ref) {
  var _props$disableSpacing = props.disableSpacing,
      disableSpacing = _props$disableSpacing === void 0 ? false : _props$disableSpacing,
      classes = props.classes,
      className = props.className,
      other = _objectWithoutProperties$4(props, ["disableSpacing", "classes", "className"]);

  return /*#__PURE__*/React__namespace.createElement("div", _extends$f({
    className: clsx(classes.root, className, !disableSpacing && classes.spacing),
    ref: ref
  }, other));
});
var DialogActions$1 = withStyles(styles$p, {
  name: 'MuiDialogActions'
})(DialogActions);var styles$o = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      flex: '1 1 auto',
      WebkitOverflowScrolling: 'touch',
      // Add iOS momentum scrolling.
      overflowY: 'auto',
      padding: '8px 24px',
      '&:first-child': {
        // dialog without title
        paddingTop: 20
      }
    },

    /* Styles applied to the root element if `dividers={true}`. */
    dividers: {
      padding: '16px 24px',
      borderTop: "1px solid ".concat(theme.palette.divider),
      borderBottom: "1px solid ".concat(theme.palette.divider)
    }
  };
};
var DialogContent = /*#__PURE__*/React__namespace.forwardRef(function DialogContent(props, ref) {
  var classes = props.classes,
      className = props.className,
      _props$dividers = props.dividers,
      dividers = _props$dividers === void 0 ? false : _props$dividers,
      other = _objectWithoutProperties$4(props, ["classes", "className", "dividers"]);

  return /*#__PURE__*/React__namespace.createElement("div", _extends$f({
    className: clsx(classes.root, className, dividers && classes.dividers),
    ref: ref
  }, other));
});
var DialogContent$1 = withStyles(styles$o, {
  name: 'MuiDialogContent'
})(DialogContent);function formControlState(_ref) {
  var props = _ref.props,
      states = _ref.states,
      muiFormControl = _ref.muiFormControl;
  return states.reduce(function (acc, state) {
    acc[state] = props[state];

    if (muiFormControl) {
      if (typeof props[state] === 'undefined') {
        acc[state] = muiFormControl[state];
      }
    }

    return acc;
  }, {});
}function getStyleValue(computedStyle, property) {
  return parseInt(computedStyle[property], 10) || 0;
}

var useEnhancedEffect$3 = typeof window !== 'undefined' ? React__namespace.useLayoutEffect : React__namespace.useEffect;
var styles$n = {
  /* Styles applied to the shadow textarea element. */
  shadow: {
    // Visibility needed to hide the extra text area on iPads
    visibility: 'hidden',
    // Remove from the content flow
    position: 'absolute',
    // Ignore the scrollbar width
    overflow: 'hidden',
    height: 0,
    top: 0,
    left: 0,
    // Create a new layer, increase the isolation of the computed values
    transform: 'translateZ(0)'
  }
};
var TextareaAutosize = /*#__PURE__*/React__namespace.forwardRef(function TextareaAutosize(props, ref) {
  var onChange = props.onChange,
      rows = props.rows,
      rowsMax = props.rowsMax,
      rowsMinProp = props.rowsMin,
      maxRowsProp = props.maxRows,
      _props$minRows = props.minRows,
      minRowsProp = _props$minRows === void 0 ? 1 : _props$minRows,
      style = props.style,
      value = props.value,
      other = _objectWithoutProperties$4(props, ["onChange", "rows", "rowsMax", "rowsMin", "maxRows", "minRows", "style", "value"]);

  var maxRows = maxRowsProp || rowsMax;
  var minRows = rows || rowsMinProp || minRowsProp;

  var _React$useRef = React__namespace.useRef(value != null),
      isControlled = _React$useRef.current;

  var inputRef = React__namespace.useRef(null);
  var handleRef = useForkRef(ref, inputRef);
  var shadowRef = React__namespace.useRef(null);
  var renders = React__namespace.useRef(0);

  var _React$useState = React__namespace.useState({}),
      state = _React$useState[0],
      setState = _React$useState[1];

  var syncHeight = React__namespace.useCallback(function () {
    var input = inputRef.current;
    var computedStyle = window.getComputedStyle(input);
    var inputShallow = shadowRef.current;
    inputShallow.style.width = computedStyle.width;
    inputShallow.value = input.value || props.placeholder || 'x';

    if (inputShallow.value.slice(-1) === '\n') {
      // Certain fonts which overflow the line height will cause the textarea
      // to report a different scrollHeight depending on whether the last line
      // is empty. Make it non-empty to avoid this issue.
      inputShallow.value += ' ';
    }

    var boxSizing = computedStyle['box-sizing'];
    var padding = getStyleValue(computedStyle, 'padding-bottom') + getStyleValue(computedStyle, 'padding-top');
    var border = getStyleValue(computedStyle, 'border-bottom-width') + getStyleValue(computedStyle, 'border-top-width'); // The height of the inner content

    var innerHeight = inputShallow.scrollHeight - padding; // Measure height of a textarea with a single row

    inputShallow.value = 'x';
    var singleRowHeight = inputShallow.scrollHeight - padding; // The height of the outer content

    var outerHeight = innerHeight;

    if (minRows) {
      outerHeight = Math.max(Number(minRows) * singleRowHeight, outerHeight);
    }

    if (maxRows) {
      outerHeight = Math.min(Number(maxRows) * singleRowHeight, outerHeight);
    }

    outerHeight = Math.max(outerHeight, singleRowHeight); // Take the box sizing into account for applying this value as a style.

    var outerHeightStyle = outerHeight + (boxSizing === 'border-box' ? padding + border : 0);
    var overflow = Math.abs(outerHeight - innerHeight) <= 1;
    setState(function (prevState) {
      // Need a large enough difference to update the height.
      // This prevents infinite rendering loop.
      if (renders.current < 20 && (outerHeightStyle > 0 && Math.abs((prevState.outerHeightStyle || 0) - outerHeightStyle) > 1 || prevState.overflow !== overflow)) {
        renders.current += 1;
        return {
          overflow: overflow,
          outerHeightStyle: outerHeightStyle
        };
      }

      return prevState;
    });
  }, [maxRows, minRows, props.placeholder]);
  React__namespace.useEffect(function () {
    var handleResize = debounce$4(function () {
      renders.current = 0;
      syncHeight();
    });
    window.addEventListener('resize', handleResize);
    return function () {
      handleResize.clear();
      window.removeEventListener('resize', handleResize);
    };
  }, [syncHeight]);
  useEnhancedEffect$3(function () {
    syncHeight();
  });
  React__namespace.useEffect(function () {
    renders.current = 0;
  }, [value]);

  var handleChange = function handleChange(event) {
    renders.current = 0;

    if (!isControlled) {
      syncHeight();
    }

    if (onChange) {
      onChange(event);
    }
  };

  return /*#__PURE__*/React__namespace.createElement(React__namespace.Fragment, null, /*#__PURE__*/React__namespace.createElement("textarea", _extends$f({
    value: value,
    onChange: handleChange,
    ref: handleRef // Apply the rows prop to get a "correct" first SSR paint
    ,
    rows: minRows,
    style: _extends$f({
      height: state.outerHeightStyle,
      // Need a large enough difference to allow scrolling.
      // This prevents infinite rendering loop.
      overflow: state.overflow ? 'hidden' : null
    }, style)
  }, other)), /*#__PURE__*/React__namespace.createElement("textarea", {
    "aria-hidden": true,
    className: props.className,
    readOnly: true,
    ref: shadowRef,
    tabIndex: -1,
    style: _extends$f({}, styles$n.shadow, style)
  }));
});
var TextareaAutosize$1 = TextareaAutosize;// Supports determination of isControlled().
// Controlled input accepts its current value as a prop.
//
// @see https://facebook.github.io/react/docs/forms.html#controlled-components
// @param value
// @returns {boolean} true if string (including '') or number (including zero)
function hasValue(value) {
  return value != null && !(Array.isArray(value) && value.length === 0);
} // Determine if field is empty or filled.
// Response determines if label is presented above field or as placeholder.
//
// @param obj
// @param SSR
// @returns {boolean} False when not present or empty string.
//                    True when any number or string with length.

function isFilled(obj) {
  var SSR = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return obj && (hasValue(obj.value) && obj.value !== '' || SSR && hasValue(obj.defaultValue) && obj.defaultValue !== '');
} // Determine if an Input is adorned on start.
// It's corresponding to the left with LTR.
//
// @param obj
// @returns {boolean} False when no adornments.
//                    True when adorned at the start.

function isAdornedStart(obj) {
  return obj.startAdornment;
}var styles$m = function styles(theme) {
  var light = theme.palette.type === 'light';
  var placeholder = {
    color: 'currentColor',
    opacity: light ? 0.42 : 0.5,
    transition: theme.transitions.create('opacity', {
      duration: theme.transitions.duration.shorter
    })
  };
  var placeholderHidden = {
    opacity: '0 !important'
  };
  var placeholderVisible = {
    opacity: light ? 0.42 : 0.5
  };
  return {
    '@global': {
      '@keyframes mui-auto-fill': {},
      '@keyframes mui-auto-fill-cancel': {}
    },

    /* Styles applied to the root element. */
    root: _extends$f({}, theme.typography.body1, {
      color: theme.palette.text.primary,
      lineHeight: '1.1876em',
      // Reset (19px), match the native input line-height
      boxSizing: 'border-box',
      // Prevent padding issue with fullWidth.
      position: 'relative',
      cursor: 'text',
      display: 'inline-flex',
      alignItems: 'center',
      '&$disabled': {
        color: theme.palette.text.disabled,
        cursor: 'default'
      }
    }),

    /* Styles applied to the root element if the component is a descendant of `FormControl`. */
    formControl: {},

    /* Styles applied to the root element if the component is focused. */
    focused: {},

    /* Styles applied to the root element if `disabled={true}`. */
    disabled: {},

    /* Styles applied to the root element if `startAdornment` is provided. */
    adornedStart: {},

    /* Styles applied to the root element if `endAdornment` is provided. */
    adornedEnd: {},

    /* Pseudo-class applied to the root element if `error={true}`. */
    error: {},

    /* Styles applied to the `input` element if `margin="dense"`. */
    marginDense: {},

    /* Styles applied to the root element if `multiline={true}`. */
    multiline: {
      padding: "".concat(8 - 2, "px 0 ").concat(8 - 1, "px"),
      '&$marginDense': {
        paddingTop: 4 - 1
      }
    },

    /* Styles applied to the root element if the color is secondary. */
    colorSecondary: {},

    /* Styles applied to the root element if `fullWidth={true}`. */
    fullWidth: {
      width: '100%'
    },

    /* Styles applied to the `input` element. */
    input: {
      font: 'inherit',
      letterSpacing: 'inherit',
      color: 'currentColor',
      padding: "".concat(8 - 2, "px 0 ").concat(8 - 1, "px"),
      border: 0,
      boxSizing: 'content-box',
      background: 'none',
      height: '1.1876em',
      // Reset (19px), match the native input line-height
      margin: 0,
      // Reset for Safari
      WebkitTapHighlightColor: 'transparent',
      display: 'block',
      // Make the flex item shrink with Firefox
      minWidth: 0,
      width: '100%',
      // Fix IE 11 width issue
      animationName: 'mui-auto-fill-cancel',
      animationDuration: '10ms',
      '&::-webkit-input-placeholder': placeholder,
      '&::-moz-placeholder': placeholder,
      // Firefox 19+
      '&:-ms-input-placeholder': placeholder,
      // IE 11
      '&::-ms-input-placeholder': placeholder,
      // Edge
      '&:focus': {
        outline: 0
      },
      // Reset Firefox invalid required input style
      '&:invalid': {
        boxShadow: 'none'
      },
      '&::-webkit-search-decoration': {
        // Remove the padding when type=search.
        '-webkit-appearance': 'none'
      },
      // Show and hide the placeholder logic
      'label[data-shrink=false] + $formControl &': {
        '&::-webkit-input-placeholder': placeholderHidden,
        '&::-moz-placeholder': placeholderHidden,
        // Firefox 19+
        '&:-ms-input-placeholder': placeholderHidden,
        // IE 11
        '&::-ms-input-placeholder': placeholderHidden,
        // Edge
        '&:focus::-webkit-input-placeholder': placeholderVisible,
        '&:focus::-moz-placeholder': placeholderVisible,
        // Firefox 19+
        '&:focus:-ms-input-placeholder': placeholderVisible,
        // IE 11
        '&:focus::-ms-input-placeholder': placeholderVisible // Edge

      },
      '&$disabled': {
        opacity: 1 // Reset iOS opacity

      },
      '&:-webkit-autofill': {
        animationDuration: '5000s',
        animationName: 'mui-auto-fill'
      }
    },

    /* Styles applied to the `input` element if `margin="dense"`. */
    inputMarginDense: {
      paddingTop: 4 - 1
    },

    /* Styles applied to the `input` element if `multiline={true}`. */
    inputMultiline: {
      height: 'auto',
      resize: 'none',
      padding: 0
    },

    /* Styles applied to the `input` element if `type="search"`. */
    inputTypeSearch: {
      // Improve type search style.
      '-moz-appearance': 'textfield',
      '-webkit-appearance': 'textfield'
    },

    /* Styles applied to the `input` element if `startAdornment` is provided. */
    inputAdornedStart: {},

    /* Styles applied to the `input` element if `endAdornment` is provided. */
    inputAdornedEnd: {},

    /* Styles applied to the `input` element if `hiddenLabel={true}`. */
    inputHiddenLabel: {}
  };
};
var useEnhancedEffect$2 = typeof window === 'undefined' ? React__namespace.useEffect : React__namespace.useLayoutEffect;
/**
 * `InputBase` contains as few styles as possible.
 * It aims to be a simple building block for creating an input.
 * It contains a load of style reset and some state logic.
 */

var InputBase$3 = /*#__PURE__*/React__namespace.forwardRef(function InputBase(props, ref) {
  var ariaDescribedby = props['aria-describedby'],
      autoComplete = props.autoComplete,
      autoFocus = props.autoFocus,
      classes = props.classes,
      className = props.className;
      props.color;
      var defaultValue = props.defaultValue,
      disabled = props.disabled,
      endAdornment = props.endAdornment;
      props.error;
      var _props$fullWidth = props.fullWidth,
      fullWidth = _props$fullWidth === void 0 ? false : _props$fullWidth,
      id = props.id,
      _props$inputComponent = props.inputComponent,
      inputComponent = _props$inputComponent === void 0 ? 'input' : _props$inputComponent,
      _props$inputProps = props.inputProps,
      inputPropsProp = _props$inputProps === void 0 ? {} : _props$inputProps,
      inputRefProp = props.inputRef;
      props.margin;
      var _props$multiline = props.multiline,
      multiline = _props$multiline === void 0 ? false : _props$multiline,
      name = props.name,
      onBlur = props.onBlur,
      onChange = props.onChange,
      onClick = props.onClick,
      onFocus = props.onFocus,
      onKeyDown = props.onKeyDown,
      onKeyUp = props.onKeyUp,
      placeholder = props.placeholder,
      readOnly = props.readOnly,
      renderSuffix = props.renderSuffix,
      rows = props.rows,
      rowsMax = props.rowsMax,
      rowsMin = props.rowsMin,
      maxRows = props.maxRows,
      minRows = props.minRows,
      startAdornment = props.startAdornment,
      _props$type = props.type,
      type = _props$type === void 0 ? 'text' : _props$type,
      valueProp = props.value,
      other = _objectWithoutProperties$4(props, ["aria-describedby", "autoComplete", "autoFocus", "classes", "className", "color", "defaultValue", "disabled", "endAdornment", "error", "fullWidth", "id", "inputComponent", "inputProps", "inputRef", "margin", "multiline", "name", "onBlur", "onChange", "onClick", "onFocus", "onKeyDown", "onKeyUp", "placeholder", "readOnly", "renderSuffix", "rows", "rowsMax", "rowsMin", "maxRows", "minRows", "startAdornment", "type", "value"]);

  var value = inputPropsProp.value != null ? inputPropsProp.value : valueProp;

  var _React$useRef = React__namespace.useRef(value != null),
      isControlled = _React$useRef.current;

  var inputRef = React__namespace.useRef();
  var handleInputRefWarning = React__namespace.useCallback(function (instance) {
  }, []);
  var handleInputPropsRefProp = useForkRef(inputPropsProp.ref, handleInputRefWarning);
  var handleInputRefProp = useForkRef(inputRefProp, handleInputPropsRefProp);
  var handleInputRef = useForkRef(inputRef, handleInputRefProp);

  var _React$useState = React__namespace.useState(false),
      focused = _React$useState[0],
      setFocused = _React$useState[1];

  var muiFormControl = useFormControl$1();

  var fcs = formControlState({
    props: props,
    muiFormControl: muiFormControl,
    states: ['color', 'disabled', 'error', 'hiddenLabel', 'margin', 'required', 'filled']
  });
  fcs.focused = muiFormControl ? muiFormControl.focused : focused; // The blur won't fire when the disabled state is set on a focused input.
  // We need to book keep the focused state manually.

  React__namespace.useEffect(function () {
    if (!muiFormControl && disabled && focused) {
      setFocused(false);

      if (onBlur) {
        onBlur();
      }
    }
  }, [muiFormControl, disabled, focused, onBlur]);
  var onFilled = muiFormControl && muiFormControl.onFilled;
  var onEmpty = muiFormControl && muiFormControl.onEmpty;
  var checkDirty = React__namespace.useCallback(function (obj) {
    if (isFilled(obj)) {
      if (onFilled) {
        onFilled();
      }
    } else if (onEmpty) {
      onEmpty();
    }
  }, [onFilled, onEmpty]);
  useEnhancedEffect$2(function () {
    if (isControlled) {
      checkDirty({
        value: value
      });
    }
  }, [value, checkDirty, isControlled]);

  var handleFocus = function handleFocus(event) {
    // Fix a bug with IE 11 where the focus/blur events are triggered
    // while the input is disabled.
    if (fcs.disabled) {
      event.stopPropagation();
      return;
    }

    if (onFocus) {
      onFocus(event);
    }

    if (inputPropsProp.onFocus) {
      inputPropsProp.onFocus(event);
    }

    if (muiFormControl && muiFormControl.onFocus) {
      muiFormControl.onFocus(event);
    } else {
      setFocused(true);
    }
  };

  var handleBlur = function handleBlur(event) {
    if (onBlur) {
      onBlur(event);
    }

    if (inputPropsProp.onBlur) {
      inputPropsProp.onBlur(event);
    }

    if (muiFormControl && muiFormControl.onBlur) {
      muiFormControl.onBlur(event);
    } else {
      setFocused(false);
    }
  };

  var handleChange = function handleChange(event) {
    if (!isControlled) {
      var element = event.target || inputRef.current;

      if (element == null) {
        throw new Error(formatMuiErrorMessage(1));
      }

      checkDirty({
        value: element.value
      });
    }

    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    if (inputPropsProp.onChange) {
      inputPropsProp.onChange.apply(inputPropsProp, [event].concat(args));
    } // Perform in the willUpdate


    if (onChange) {
      onChange.apply(void 0, [event].concat(args));
    }
  }; // Check the input state on mount, in case it was filled by the user
  // or auto filled by the browser before the hydration (for SSR).


  React__namespace.useEffect(function () {
    checkDirty(inputRef.current);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  var handleClick = function handleClick(event) {
    if (inputRef.current && event.currentTarget === event.target) {
      inputRef.current.focus();
    }

    if (onClick) {
      onClick(event);
    }
  };

  var InputComponent = inputComponent;

  var inputProps = _extends$f({}, inputPropsProp, {
    ref: handleInputRef
  });

  if (typeof InputComponent !== 'string') {
    inputProps = _extends$f({
      // Rename ref to inputRef as we don't know the
      // provided `inputComponent` structure.
      inputRef: handleInputRef,
      type: type
    }, inputProps, {
      ref: null
    });
  } else if (multiline) {
    if (rows && !maxRows && !minRows && !rowsMax && !rowsMin) {
      InputComponent = 'textarea';
    } else {
      inputProps = _extends$f({
        minRows: rows || minRows,
        rowsMax: rowsMax,
        maxRows: maxRows
      }, inputProps);
      InputComponent = TextareaAutosize$1;
    }
  } else {
    inputProps = _extends$f({
      type: type
    }, inputProps);
  }

  var handleAutoFill = function handleAutoFill(event) {
    // Provide a fake value as Chrome might not let you access it for security reasons.
    checkDirty(event.animationName === 'mui-auto-fill-cancel' ? inputRef.current : {
      value: 'x'
    });
  };

  React__namespace.useEffect(function () {
    if (muiFormControl) {
      muiFormControl.setAdornedStart(Boolean(startAdornment));
    }
  }, [muiFormControl, startAdornment]);
  return /*#__PURE__*/React__namespace.createElement("div", _extends$f({
    className: clsx(classes.root, classes["color".concat(capitalize(fcs.color || 'primary'))], className, fcs.disabled && classes.disabled, fcs.error && classes.error, fullWidth && classes.fullWidth, fcs.focused && classes.focused, muiFormControl && classes.formControl, multiline && classes.multiline, startAdornment && classes.adornedStart, endAdornment && classes.adornedEnd, fcs.margin === 'dense' && classes.marginDense),
    onClick: handleClick,
    ref: ref
  }, other), startAdornment, /*#__PURE__*/React__namespace.createElement(FormControlContext$1.Provider, {
    value: null
  }, /*#__PURE__*/React__namespace.createElement(InputComponent, _extends$f({
    "aria-invalid": fcs.error,
    "aria-describedby": ariaDescribedby,
    autoComplete: autoComplete,
    autoFocus: autoFocus,
    defaultValue: defaultValue,
    disabled: fcs.disabled,
    id: id,
    onAnimationStart: handleAutoFill,
    name: name,
    placeholder: placeholder,
    readOnly: readOnly,
    required: fcs.required,
    rows: rows,
    value: value,
    onKeyDown: onKeyDown,
    onKeyUp: onKeyUp
  }, inputProps, {
    className: clsx(classes.input, inputPropsProp.className, fcs.disabled && classes.disabled, multiline && classes.inputMultiline, fcs.hiddenLabel && classes.inputHiddenLabel, startAdornment && classes.inputAdornedStart, endAdornment && classes.inputAdornedEnd, type === 'search' && classes.inputTypeSearch, fcs.margin === 'dense' && classes.inputMarginDense),
    onBlur: handleBlur,
    onChange: handleChange,
    onFocus: handleFocus
  }))), endAdornment, renderSuffix ? renderSuffix(_extends$f({}, fcs, {
    startAdornment: startAdornment
  })) : null);
});
var InputBase$4 = withStyles(styles$m, {
  name: 'MuiInputBase'
})(InputBase$3);var styles$l = function styles(theme) {
  var light = theme.palette.type === 'light';
  var bottomLineColor = light ? 'rgba(0, 0, 0, 0.42)' : 'rgba(255, 255, 255, 0.7)';
  var backgroundColor = light ? 'rgba(0, 0, 0, 0.09)' : 'rgba(255, 255, 255, 0.09)';
  return {
    /* Styles applied to the root element. */
    root: {
      position: 'relative',
      backgroundColor: backgroundColor,
      borderTopLeftRadius: theme.shape.borderRadius,
      borderTopRightRadius: theme.shape.borderRadius,
      transition: theme.transitions.create('background-color', {
        duration: theme.transitions.duration.shorter,
        easing: theme.transitions.easing.easeOut
      }),
      '&:hover': {
        backgroundColor: light ? 'rgba(0, 0, 0, 0.13)' : 'rgba(255, 255, 255, 0.13)',
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          backgroundColor: backgroundColor
        }
      },
      '&$focused': {
        backgroundColor: light ? 'rgba(0, 0, 0, 0.09)' : 'rgba(255, 255, 255, 0.09)'
      },
      '&$disabled': {
        backgroundColor: light ? 'rgba(0, 0, 0, 0.12)' : 'rgba(255, 255, 255, 0.12)'
      }
    },

    /* Styles applied to the root element if color secondary. */
    colorSecondary: {
      '&$underline:after': {
        borderBottomColor: theme.palette.secondary.main
      }
    },

    /* Styles applied to the root element if `disableUnderline={false}`. */
    underline: {
      '&:after': {
        borderBottom: "2px solid ".concat(theme.palette.primary.main),
        left: 0,
        bottom: 0,
        // Doing the other way around crash on IE 11 "''" https://github.com/cssinjs/jss/issues/242
        content: '""',
        position: 'absolute',
        right: 0,
        transform: 'scaleX(0)',
        transition: theme.transitions.create('transform', {
          duration: theme.transitions.duration.shorter,
          easing: theme.transitions.easing.easeOut
        }),
        pointerEvents: 'none' // Transparent to the hover style.

      },
      '&$focused:after': {
        transform: 'scaleX(1)'
      },
      '&$error:after': {
        borderBottomColor: theme.palette.error.main,
        transform: 'scaleX(1)' // error is always underlined in red

      },
      '&:before': {
        borderBottom: "1px solid ".concat(bottomLineColor),
        left: 0,
        bottom: 0,
        // Doing the other way around crash on IE 11 "''" https://github.com/cssinjs/jss/issues/242
        content: '"\\00a0"',
        position: 'absolute',
        right: 0,
        transition: theme.transitions.create('border-bottom-color', {
          duration: theme.transitions.duration.shorter
        }),
        pointerEvents: 'none' // Transparent to the hover style.

      },
      '&:hover:before': {
        borderBottom: "1px solid ".concat(theme.palette.text.primary)
      },
      '&$disabled:before': {
        borderBottomStyle: 'dotted'
      }
    },

    /* Pseudo-class applied to the root element if the component is focused. */
    focused: {},

    /* Pseudo-class applied to the root element if `disabled={true}`. */
    disabled: {},

    /* Styles applied to the root element if `startAdornment` is provided. */
    adornedStart: {
      paddingLeft: 12
    },

    /* Styles applied to the root element if `endAdornment` is provided. */
    adornedEnd: {
      paddingRight: 12
    },

    /* Pseudo-class applied to the root element if `error={true}`. */
    error: {},

    /* Styles applied to the `input` element if `margin="dense"`. */
    marginDense: {},

    /* Styles applied to the root element if `multiline={true}`. */
    multiline: {
      padding: '27px 12px 10px',
      '&$marginDense': {
        paddingTop: 23,
        paddingBottom: 6
      }
    },

    /* Styles applied to the `input` element. */
    input: {
      padding: '27px 12px 10px',
      '&:-webkit-autofill': {
        WebkitBoxShadow: theme.palette.type === 'light' ? null : '0 0 0 100px #266798 inset',
        WebkitTextFillColor: theme.palette.type === 'light' ? null : '#fff',
        caretColor: theme.palette.type === 'light' ? null : '#fff',
        borderTopLeftRadius: 'inherit',
        borderTopRightRadius: 'inherit'
      }
    },

    /* Styles applied to the `input` element if `margin="dense"`. */
    inputMarginDense: {
      paddingTop: 23,
      paddingBottom: 6
    },

    /* Styles applied to the `input` if in `<FormControl hiddenLabel />`. */
    inputHiddenLabel: {
      paddingTop: 18,
      paddingBottom: 19,
      '&$inputMarginDense': {
        paddingTop: 10,
        paddingBottom: 11
      }
    },

    /* Styles applied to the `input` element if `multiline={true}`. */
    inputMultiline: {
      padding: 0
    },

    /* Styles applied to the `input` element if `startAdornment` is provided. */
    inputAdornedStart: {
      paddingLeft: 0
    },

    /* Styles applied to the `input` element if `endAdornment` is provided. */
    inputAdornedEnd: {
      paddingRight: 0
    }
  };
};
var FilledInput = /*#__PURE__*/React__namespace.forwardRef(function FilledInput(props, ref) {
  var disableUnderline = props.disableUnderline,
      classes = props.classes,
      _props$fullWidth = props.fullWidth,
      fullWidth = _props$fullWidth === void 0 ? false : _props$fullWidth,
      _props$inputComponent = props.inputComponent,
      inputComponent = _props$inputComponent === void 0 ? 'input' : _props$inputComponent,
      _props$multiline = props.multiline,
      multiline = _props$multiline === void 0 ? false : _props$multiline,
      _props$type = props.type,
      type = _props$type === void 0 ? 'text' : _props$type,
      other = _objectWithoutProperties$4(props, ["disableUnderline", "classes", "fullWidth", "inputComponent", "multiline", "type"]);

  return /*#__PURE__*/React__namespace.createElement(InputBase$4, _extends$f({
    classes: _extends$f({}, classes, {
      root: clsx(classes.root, !disableUnderline && classes.underline),
      underline: null
    }),
    fullWidth: fullWidth,
    inputComponent: inputComponent,
    multiline: multiline,
    ref: ref,
    type: type
  }, other));
});
FilledInput.muiName = 'Input';
var FilledInput$1 = withStyles(styles$l, {
  name: 'MuiFilledInput'
})(FilledInput);var styles$k = {
  /* Styles applied to the root element. */
  root: {
    display: 'inline-flex',
    flexDirection: 'column',
    position: 'relative',
    // Reset fieldset default style.
    minWidth: 0,
    padding: 0,
    margin: 0,
    border: 0,
    verticalAlign: 'top' // Fix alignment issue on Safari.

  },

  /* Styles applied to the root element if `margin="normal"`. */
  marginNormal: {
    marginTop: 16,
    marginBottom: 8
  },

  /* Styles applied to the root element if `margin="dense"`. */
  marginDense: {
    marginTop: 8,
    marginBottom: 4
  },

  /* Styles applied to the root element if `fullWidth={true}`. */
  fullWidth: {
    width: '100%'
  }
};
/**
 * Provides context such as filled/focused/error/required for form inputs.
 * Relying on the context provides high flexibility and ensures that the state always stays
 * consistent across the children of the `FormControl`.
 * This context is used by the following components:
 *
 *  - FormLabel
 *  - FormHelperText
 *  - Input
 *  - InputLabel
 *
 * You can find one composition example below and more going to [the demos](/components/text-fields/#components).
 *
 * ```jsx
 * <FormControl>
 *   <InputLabel htmlFor="my-input">Email address</InputLabel>
 *   <Input id="my-input" aria-describedby="my-helper-text" />
 *   <FormHelperText id="my-helper-text">We'll never share your email.</FormHelperText>
 * </FormControl>
 * ```
 *
 * ⚠️Only one input can be used within a FormControl.
 */

var FormControl = /*#__PURE__*/React__namespace.forwardRef(function FormControl(props, ref) {
  var children = props.children,
      classes = props.classes,
      className = props.className,
      _props$color = props.color,
      color = _props$color === void 0 ? 'primary' : _props$color,
      _props$component = props.component,
      Component = _props$component === void 0 ? 'div' : _props$component,
      _props$disabled = props.disabled,
      disabled = _props$disabled === void 0 ? false : _props$disabled,
      _props$error = props.error,
      error = _props$error === void 0 ? false : _props$error,
      _props$fullWidth = props.fullWidth,
      fullWidth = _props$fullWidth === void 0 ? false : _props$fullWidth,
      visuallyFocused = props.focused,
      _props$hiddenLabel = props.hiddenLabel,
      hiddenLabel = _props$hiddenLabel === void 0 ? false : _props$hiddenLabel,
      _props$margin = props.margin,
      margin = _props$margin === void 0 ? 'none' : _props$margin,
      _props$required = props.required,
      required = _props$required === void 0 ? false : _props$required,
      size = props.size,
      _props$variant = props.variant,
      variant = _props$variant === void 0 ? 'standard' : _props$variant,
      other = _objectWithoutProperties$4(props, ["children", "classes", "className", "color", "component", "disabled", "error", "fullWidth", "focused", "hiddenLabel", "margin", "required", "size", "variant"]);

  var _React$useState = React__namespace.useState(function () {
    // We need to iterate through the children and find the Input in order
    // to fully support server-side rendering.
    var initialAdornedStart = false;

    if (children) {
      React__namespace.Children.forEach(children, function (child) {
        if (!isMuiElement(child, ['Input', 'Select'])) {
          return;
        }

        var input = isMuiElement(child, ['Select']) ? child.props.input : child;

        if (input && isAdornedStart(input.props)) {
          initialAdornedStart = true;
        }
      });
    }

    return initialAdornedStart;
  }),
      adornedStart = _React$useState[0],
      setAdornedStart = _React$useState[1];

  var _React$useState2 = React__namespace.useState(function () {
    // We need to iterate through the children and find the Input in order
    // to fully support server-side rendering.
    var initialFilled = false;

    if (children) {
      React__namespace.Children.forEach(children, function (child) {
        if (!isMuiElement(child, ['Input', 'Select'])) {
          return;
        }

        if (isFilled(child.props, true)) {
          initialFilled = true;
        }
      });
    }

    return initialFilled;
  }),
      filled = _React$useState2[0],
      setFilled = _React$useState2[1];

  var _React$useState3 = React__namespace.useState(false),
      _focused = _React$useState3[0],
      setFocused = _React$useState3[1];

  var focused = visuallyFocused !== undefined ? visuallyFocused : _focused;

  if (disabled && focused) {
    setFocused(false);
  }

  var registerEffect;

  var onFilled = React__namespace.useCallback(function () {
    setFilled(true);
  }, []);
  var onEmpty = React__namespace.useCallback(function () {
    setFilled(false);
  }, []);
  var childContext = {
    adornedStart: adornedStart,
    setAdornedStart: setAdornedStart,
    color: color,
    disabled: disabled,
    error: error,
    filled: filled,
    focused: focused,
    fullWidth: fullWidth,
    hiddenLabel: hiddenLabel,
    margin: (size === 'small' ? 'dense' : undefined) || margin,
    onBlur: function onBlur() {
      setFocused(false);
    },
    onEmpty: onEmpty,
    onFilled: onFilled,
    onFocus: function onFocus() {
      setFocused(true);
    },
    registerEffect: registerEffect,
    required: required,
    variant: variant
  };
  return /*#__PURE__*/React__namespace.createElement(FormControlContext$1.Provider, {
    value: childContext
  }, /*#__PURE__*/React__namespace.createElement(Component, _extends$f({
    className: clsx(classes.root, className, margin !== 'none' && classes["margin".concat(capitalize(margin))], fullWidth && classes.fullWidth),
    ref: ref
  }, other), children));
});
var FormControl$1 = withStyles(styles$k, {
  name: 'MuiFormControl'
})(FormControl);var styles$j = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: _extends$f({
      color: theme.palette.text.secondary
    }, theme.typography.caption, {
      textAlign: 'left',
      marginTop: 3,
      margin: 0,
      '&$disabled': {
        color: theme.palette.text.disabled
      },
      '&$error': {
        color: theme.palette.error.main
      }
    }),

    /* Pseudo-class applied to the root element if `error={true}`. */
    error: {},

    /* Pseudo-class applied to the root element if `disabled={true}`. */
    disabled: {},

    /* Styles applied to the root element if `margin="dense"`. */
    marginDense: {
      marginTop: 4
    },

    /* Styles applied to the root element if `variant="filled"` or `variant="outlined"`. */
    contained: {
      marginLeft: 14,
      marginRight: 14
    },

    /* Pseudo-class applied to the root element if `focused={true}`. */
    focused: {},

    /* Pseudo-class applied to the root element if `filled={true}`. */
    filled: {},

    /* Pseudo-class applied to the root element if `required={true}`. */
    required: {}
  };
};
var FormHelperText = /*#__PURE__*/React__namespace.forwardRef(function FormHelperText(props, ref) {
  var children = props.children,
      classes = props.classes,
      className = props.className,
      _props$component = props.component,
      Component = _props$component === void 0 ? 'p' : _props$component;
      props.disabled;
      props.error;
      props.filled;
      props.focused;
      props.margin;
      props.required;
      props.variant;
      var other = _objectWithoutProperties$4(props, ["children", "classes", "className", "component", "disabled", "error", "filled", "focused", "margin", "required", "variant"]);

  var muiFormControl = useFormControl();
  var fcs = formControlState({
    props: props,
    muiFormControl: muiFormControl,
    states: ['variant', 'margin', 'disabled', 'error', 'filled', 'focused', 'required']
  });
  return /*#__PURE__*/React__namespace.createElement(Component, _extends$f({
    className: clsx(classes.root, (fcs.variant === 'filled' || fcs.variant === 'outlined') && classes.contained, className, fcs.disabled && classes.disabled, fcs.error && classes.error, fcs.filled && classes.filled, fcs.focused && classes.focused, fcs.required && classes.required, fcs.margin === 'dense' && classes.marginDense),
    ref: ref
  }, other), children === ' ' ?
  /*#__PURE__*/
  // eslint-disable-next-line react/no-danger
  React__namespace.createElement("span", {
    dangerouslySetInnerHTML: {
      __html: '&#8203;'
    }
  }) : children);
});
var FormHelperText$1 = withStyles(styles$j, {
  name: 'MuiFormHelperText'
})(FormHelperText);var styles$i = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: _extends$f({
      color: theme.palette.text.secondary
    }, theme.typography.body1, {
      lineHeight: 1,
      padding: 0,
      '&$focused': {
        color: theme.palette.primary.main
      },
      '&$disabled': {
        color: theme.palette.text.disabled
      },
      '&$error': {
        color: theme.palette.error.main
      }
    }),

    /* Styles applied to the root element if the color is secondary. */
    colorSecondary: {
      '&$focused': {
        color: theme.palette.secondary.main
      }
    },

    /* Pseudo-class applied to the root element if `focused={true}`. */
    focused: {},

    /* Pseudo-class applied to the root element if `disabled={true}`. */
    disabled: {},

    /* Pseudo-class applied to the root element if `error={true}`. */
    error: {},

    /* Pseudo-class applied to the root element if `filled={true}`. */
    filled: {},

    /* Pseudo-class applied to the root element if `required={true}`. */
    required: {},

    /* Styles applied to the asterisk element. */
    asterisk: {
      '&$error': {
        color: theme.palette.error.main
      }
    }
  };
};
var FormLabel = /*#__PURE__*/React__namespace.forwardRef(function FormLabel(props, ref) {
  var children = props.children,
      classes = props.classes,
      className = props.className;
      props.color;
      var _props$component = props.component,
      Component = _props$component === void 0 ? 'label' : _props$component;
      props.disabled;
      props.error;
      props.filled;
      props.focused;
      props.required;
      var other = _objectWithoutProperties$4(props, ["children", "classes", "className", "color", "component", "disabled", "error", "filled", "focused", "required"]);

  var muiFormControl = useFormControl();
  var fcs = formControlState({
    props: props,
    muiFormControl: muiFormControl,
    states: ['color', 'required', 'focused', 'disabled', 'error', 'filled']
  });
  return /*#__PURE__*/React__namespace.createElement(Component, _extends$f({
    className: clsx(classes.root, classes["color".concat(capitalize(fcs.color || 'primary'))], className, fcs.disabled && classes.disabled, fcs.error && classes.error, fcs.filled && classes.filled, fcs.focused && classes.focused, fcs.required && classes.required),
    ref: ref
  }, other), children, fcs.required && /*#__PURE__*/React__namespace.createElement("span", {
    "aria-hidden": true,
    className: clsx(classes.asterisk, fcs.error && classes.error)
  }, "\u2009", '*'));
});
var FormLabel$1 = withStyles(styles$i, {
  name: 'MuiFormLabel'
})(FormLabel);function getScale(value) {
  return "scale(".concat(value, ", ").concat(Math.pow(value, 2), ")");
}

var styles$h = {
  entering: {
    opacity: 1,
    transform: getScale(1)
  },
  entered: {
    opacity: 1,
    transform: 'none'
  }
};
/**
 * The Grow transition is used by the [Tooltip](/components/tooltips/) and
 * [Popover](/components/popover/) components.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */

var Grow = /*#__PURE__*/React__namespace.forwardRef(function Grow(props, ref) {
  var children = props.children,
      _props$disableStrictM = props.disableStrictModeCompat,
      disableStrictModeCompat = _props$disableStrictM === void 0 ? false : _props$disableStrictM,
      inProp = props.in,
      onEnter = props.onEnter,
      onEntered = props.onEntered,
      onEntering = props.onEntering,
      onExit = props.onExit,
      onExited = props.onExited,
      onExiting = props.onExiting,
      style = props.style,
      _props$timeout = props.timeout,
      timeout = _props$timeout === void 0 ? 'auto' : _props$timeout,
      _props$TransitionComp = props.TransitionComponent,
      TransitionComponent = _props$TransitionComp === void 0 ? Transition$1 : _props$TransitionComp,
      other = _objectWithoutProperties$4(props, ["children", "disableStrictModeCompat", "in", "onEnter", "onEntered", "onEntering", "onExit", "onExited", "onExiting", "style", "timeout", "TransitionComponent"]);

  var timer = React__namespace.useRef();
  var autoTimeout = React__namespace.useRef();
  var theme = useTheme();
  var enableStrictModeCompat = theme.unstable_strictMode && !disableStrictModeCompat;
  var nodeRef = React__namespace.useRef(null);
  var foreignRef = useForkRef(children.ref, ref);
  var handleRef = useForkRef(enableStrictModeCompat ? nodeRef : undefined, foreignRef);

  var normalizedTransitionCallback = function normalizedTransitionCallback(callback) {
    return function (nodeOrAppearing, maybeAppearing) {
      if (callback) {
        var _ref = enableStrictModeCompat ? [nodeRef.current, nodeOrAppearing] : [nodeOrAppearing, maybeAppearing],
            _ref2 = _slicedToArray(_ref, 2),
            node = _ref2[0],
            isAppearing = _ref2[1]; // onEnterXxx and onExitXxx callbacks have a different arguments.length value.


        if (isAppearing === undefined) {
          callback(node);
        } else {
          callback(node, isAppearing);
        }
      }
    };
  };

  var handleEntering = normalizedTransitionCallback(onEntering);
  var handleEnter = normalizedTransitionCallback(function (node, isAppearing) {
    reflow(node); // So the animation always start from the start.

    var _getTransitionProps = getTransitionProps({
      style: style,
      timeout: timeout
    }, {
      mode: 'enter'
    }),
        transitionDuration = _getTransitionProps.duration,
        delay = _getTransitionProps.delay;

    var duration;

    if (timeout === 'auto') {
      duration = theme.transitions.getAutoHeightDuration(node.clientHeight);
      autoTimeout.current = duration;
    } else {
      duration = transitionDuration;
    }

    node.style.transition = [theme.transitions.create('opacity', {
      duration: duration,
      delay: delay
    }), theme.transitions.create('transform', {
      duration: duration * 0.666,
      delay: delay
    })].join(',');

    if (onEnter) {
      onEnter(node, isAppearing);
    }
  });
  var handleEntered = normalizedTransitionCallback(onEntered);
  var handleExiting = normalizedTransitionCallback(onExiting);
  var handleExit = normalizedTransitionCallback(function (node) {
    var _getTransitionProps2 = getTransitionProps({
      style: style,
      timeout: timeout
    }, {
      mode: 'exit'
    }),
        transitionDuration = _getTransitionProps2.duration,
        delay = _getTransitionProps2.delay;

    var duration;

    if (timeout === 'auto') {
      duration = theme.transitions.getAutoHeightDuration(node.clientHeight);
      autoTimeout.current = duration;
    } else {
      duration = transitionDuration;
    }

    node.style.transition = [theme.transitions.create('opacity', {
      duration: duration,
      delay: delay
    }), theme.transitions.create('transform', {
      duration: duration * 0.666,
      delay: delay || duration * 0.333
    })].join(',');
    node.style.opacity = '0';
    node.style.transform = getScale(0.75);

    if (onExit) {
      onExit(node);
    }
  });
  var handleExited = normalizedTransitionCallback(onExited);

  var addEndListener = function addEndListener(nodeOrNext, maybeNext) {
    var next = enableStrictModeCompat ? nodeOrNext : maybeNext;

    if (timeout === 'auto') {
      timer.current = setTimeout(next, autoTimeout.current || 0);
    }
  };

  React__namespace.useEffect(function () {
    return function () {
      clearTimeout(timer.current);
    };
  }, []);
  return /*#__PURE__*/React__namespace.createElement(TransitionComponent, _extends$f({
    appear: true,
    in: inProp,
    nodeRef: enableStrictModeCompat ? nodeRef : undefined,
    onEnter: handleEnter,
    onEntered: handleEntered,
    onEntering: handleEntering,
    onExit: handleExit,
    onExited: handleExited,
    onExiting: handleExiting,
    addEndListener: addEndListener,
    timeout: timeout === 'auto' ? null : timeout
  }, other), function (state, childProps) {
    return /*#__PURE__*/React__namespace.cloneElement(children, _extends$f({
      style: _extends$f({
        opacity: 0,
        transform: getScale(0.75),
        visibility: state === 'exited' && !inProp ? 'hidden' : undefined
      }, styles$h[state], style, children.props.style),
      ref: handleRef
    }, childProps));
  });
});
Grow.muiSupportAuto = true;
var Grow$1 = Grow;var styles$g = function styles(theme) {
  var light = theme.palette.type === 'light';
  var bottomLineColor = light ? 'rgba(0, 0, 0, 0.42)' : 'rgba(255, 255, 255, 0.7)';
  return {
    /* Styles applied to the root element. */
    root: {
      position: 'relative'
    },

    /* Styles applied to the root element if the component is a descendant of `FormControl`. */
    formControl: {
      'label + &': {
        marginTop: 16
      }
    },

    /* Styles applied to the root element if the component is focused. */
    focused: {},

    /* Styles applied to the root element if `disabled={true}`. */
    disabled: {},

    /* Styles applied to the root element if color secondary. */
    colorSecondary: {
      '&$underline:after': {
        borderBottomColor: theme.palette.secondary.main
      }
    },

    /* Styles applied to the root element if `disableUnderline={false}`. */
    underline: {
      '&:after': {
        borderBottom: "2px solid ".concat(theme.palette.primary.main),
        left: 0,
        bottom: 0,
        // Doing the other way around crash on IE 11 "''" https://github.com/cssinjs/jss/issues/242
        content: '""',
        position: 'absolute',
        right: 0,
        transform: 'scaleX(0)',
        transition: theme.transitions.create('transform', {
          duration: theme.transitions.duration.shorter,
          easing: theme.transitions.easing.easeOut
        }),
        pointerEvents: 'none' // Transparent to the hover style.

      },
      '&$focused:after': {
        transform: 'scaleX(1)'
      },
      '&$error:after': {
        borderBottomColor: theme.palette.error.main,
        transform: 'scaleX(1)' // error is always underlined in red

      },
      '&:before': {
        borderBottom: "1px solid ".concat(bottomLineColor),
        left: 0,
        bottom: 0,
        // Doing the other way around crash on IE 11 "''" https://github.com/cssinjs/jss/issues/242
        content: '"\\00a0"',
        position: 'absolute',
        right: 0,
        transition: theme.transitions.create('border-bottom-color', {
          duration: theme.transitions.duration.shorter
        }),
        pointerEvents: 'none' // Transparent to the hover style.

      },
      '&:hover:not($disabled):before': {
        borderBottom: "2px solid ".concat(theme.palette.text.primary),
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          borderBottom: "1px solid ".concat(bottomLineColor)
        }
      },
      '&$disabled:before': {
        borderBottomStyle: 'dotted'
      }
    },

    /* Pseudo-class applied to the root element if `error={true}`. */
    error: {},

    /* Styles applied to the `input` element if `margin="dense"`. */
    marginDense: {},

    /* Styles applied to the root element if `multiline={true}`. */
    multiline: {},

    /* Styles applied to the root element if `fullWidth={true}`. */
    fullWidth: {},

    /* Styles applied to the `input` element. */
    input: {},

    /* Styles applied to the `input` element if `margin="dense"`. */
    inputMarginDense: {},

    /* Styles applied to the `input` element if `multiline={true}`. */
    inputMultiline: {},

    /* Styles applied to the `input` element if `type="search"`. */
    inputTypeSearch: {}
  };
};
var Input$2 = /*#__PURE__*/React__namespace.forwardRef(function Input(props, ref) {
  var disableUnderline = props.disableUnderline,
      classes = props.classes,
      _props$fullWidth = props.fullWidth,
      fullWidth = _props$fullWidth === void 0 ? false : _props$fullWidth,
      _props$inputComponent = props.inputComponent,
      inputComponent = _props$inputComponent === void 0 ? 'input' : _props$inputComponent,
      _props$multiline = props.multiline,
      multiline = _props$multiline === void 0 ? false : _props$multiline,
      _props$type = props.type,
      type = _props$type === void 0 ? 'text' : _props$type,
      other = _objectWithoutProperties$4(props, ["disableUnderline", "classes", "fullWidth", "inputComponent", "multiline", "type"]);

  return /*#__PURE__*/React__namespace.createElement(InputBase$4, _extends$f({
    classes: _extends$f({}, classes, {
      root: clsx(classes.root, !disableUnderline && classes.underline),
      underline: null
    }),
    fullWidth: fullWidth,
    inputComponent: inputComponent,
    multiline: multiline,
    ref: ref,
    type: type
  }, other));
});
Input$2.muiName = 'Input';
var Input$3 = withStyles(styles$g, {
  name: 'MuiInput'
})(Input$2);var styles$f = {
  /* Styles applied to the root element. */
  root: {
    display: 'flex',
    height: '0.01em',
    // Fix IE 11 flexbox alignment. To remove at some point.
    maxHeight: '2em',
    alignItems: 'center',
    whiteSpace: 'nowrap'
  },

  /* Styles applied to the root element if `variant="filled"`. */
  filled: {
    '&$positionStart:not($hiddenLabel)': {
      marginTop: 16
    }
  },

  /* Styles applied to the root element if `position="start"`. */
  positionStart: {
    marginRight: 8
  },

  /* Styles applied to the root element if `position="end"`. */
  positionEnd: {
    marginLeft: 8
  },

  /* Styles applied to the root element if `disablePointerEvents=true`. */
  disablePointerEvents: {
    pointerEvents: 'none'
  },

  /* Styles applied if the adornment is used inside <FormControl hiddenLabel />. */
  hiddenLabel: {},

  /* Styles applied if the adornment is used inside <FormControl margin="dense" />. */
  marginDense: {}
};
var InputAdornment = /*#__PURE__*/React__namespace.forwardRef(function InputAdornment(props, ref) {
  var children = props.children,
      classes = props.classes,
      className = props.className,
      _props$component = props.component,
      Component = _props$component === void 0 ? 'div' : _props$component,
      _props$disablePointer = props.disablePointerEvents,
      disablePointerEvents = _props$disablePointer === void 0 ? false : _props$disablePointer,
      _props$disableTypogra = props.disableTypography,
      disableTypography = _props$disableTypogra === void 0 ? false : _props$disableTypogra,
      position = props.position,
      variantProp = props.variant,
      other = _objectWithoutProperties$4(props, ["children", "classes", "className", "component", "disablePointerEvents", "disableTypography", "position", "variant"]);

  var muiFormControl = useFormControl$1() || {};
  var variant = variantProp;

  if (variantProp && muiFormControl.variant) ;

  if (muiFormControl && !variant) {
    variant = muiFormControl.variant;
  }

  return /*#__PURE__*/React__namespace.createElement(FormControlContext$1.Provider, {
    value: null
  }, /*#__PURE__*/React__namespace.createElement(Component, _extends$f({
    className: clsx(classes.root, className, position === 'end' ? classes.positionEnd : classes.positionStart, disablePointerEvents && classes.disablePointerEvents, muiFormControl.hiddenLabel && classes.hiddenLabel, variant === 'filled' && classes.filled, muiFormControl.margin === 'dense' && classes.marginDense),
    ref: ref
  }, other), typeof children === 'string' && !disableTypography ? /*#__PURE__*/React__namespace.createElement(Typography$1, {
    color: "textSecondary"
  }, children) : children));
});
var InputAdornment$1 = withStyles(styles$f, {
  name: 'MuiInputAdornment'
})(InputAdornment);var styles$e = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      display: 'block',
      transformOrigin: 'top left'
    },

    /* Pseudo-class applied to the root element if `focused={true}`. */
    focused: {},

    /* Pseudo-class applied to the root element if `disabled={true}`. */
    disabled: {},

    /* Pseudo-class applied to the root element if `error={true}`. */
    error: {},

    /* Pseudo-class applied to the root element if `required={true}`. */
    required: {},

    /* Pseudo-class applied to the asterisk element. */
    asterisk: {},

    /* Styles applied to the root element if the component is a descendant of `FormControl`. */
    formControl: {
      position: 'absolute',
      left: 0,
      top: 0,
      // slight alteration to spec spacing to match visual spec result
      transform: 'translate(0, 24px) scale(1)'
    },

    /* Styles applied to the root element if `margin="dense"`. */
    marginDense: {
      // Compensation for the `Input.inputDense` style.
      transform: 'translate(0, 21px) scale(1)'
    },

    /* Styles applied to the `input` element if `shrink={true}`. */
    shrink: {
      transform: 'translate(0, 1.5px) scale(0.75)',
      transformOrigin: 'top left'
    },

    /* Styles applied to the `input` element if `disableAnimation={false}`. */
    animated: {
      transition: theme.transitions.create(['color', 'transform'], {
        duration: theme.transitions.duration.shorter,
        easing: theme.transitions.easing.easeOut
      })
    },

    /* Styles applied to the root element if `variant="filled"`. */
    filled: {
      // Chrome's autofill feature gives the input field a yellow background.
      // Since the input field is behind the label in the HTML tree,
      // the input field is drawn last and hides the label with an opaque background color.
      // zIndex: 1 will raise the label above opaque background-colors of input.
      zIndex: 1,
      pointerEvents: 'none',
      transform: 'translate(12px, 20px) scale(1)',
      '&$marginDense': {
        transform: 'translate(12px, 17px) scale(1)'
      },
      '&$shrink': {
        transform: 'translate(12px, 10px) scale(0.75)',
        '&$marginDense': {
          transform: 'translate(12px, 7px) scale(0.75)'
        }
      }
    },

    /* Styles applied to the root element if `variant="outlined"`. */
    outlined: {
      // see comment above on filled.zIndex
      zIndex: 1,
      pointerEvents: 'none',
      transform: 'translate(14px, 20px) scale(1)',
      '&$marginDense': {
        transform: 'translate(14px, 12px) scale(1)'
      },
      '&$shrink': {
        transform: 'translate(14px, -6px) scale(0.75)'
      }
    }
  };
};
var InputLabel = /*#__PURE__*/React__namespace.forwardRef(function InputLabel(props, ref) {
  var classes = props.classes,
      className = props.className,
      _props$disableAnimati = props.disableAnimation,
      disableAnimation = _props$disableAnimati === void 0 ? false : _props$disableAnimati;
      props.margin;
      var shrinkProp = props.shrink;
      props.variant;
      var other = _objectWithoutProperties$4(props, ["classes", "className", "disableAnimation", "margin", "shrink", "variant"]);

  var muiFormControl = useFormControl();
  var shrink = shrinkProp;

  if (typeof shrink === 'undefined' && muiFormControl) {
    shrink = muiFormControl.filled || muiFormControl.focused || muiFormControl.adornedStart;
  }

  var fcs = formControlState({
    props: props,
    muiFormControl: muiFormControl,
    states: ['margin', 'variant']
  });
  return /*#__PURE__*/React__namespace.createElement(FormLabel$1, _extends$f({
    "data-shrink": shrink,
    className: clsx(classes.root, className, muiFormControl && classes.formControl, !disableAnimation && classes.animated, shrink && classes.shrink, fcs.margin === 'dense' && classes.marginDense, {
      'filled': classes.filled,
      'outlined': classes.outlined
    }[fcs.variant]),
    classes: {
      focused: classes.focused,
      disabled: classes.disabled,
      error: classes.error,
      required: classes.required,
      asterisk: classes.asterisk
    },
    ref: ref
  }, other));
});
var InputLabel$1 = withStyles(styles$e, {
  name: 'MuiInputLabel'
})(InputLabel);/**
 * @ignore - internal component.
 */

var ListContext = React__namespace.createContext({});

var ListContext$1 = ListContext;var styles$d = {
  /* Styles applied to the root element. */
  root: {
    listStyle: 'none',
    margin: 0,
    padding: 0,
    position: 'relative'
  },

  /* Styles applied to the root element if `disablePadding={false}`. */
  padding: {
    paddingTop: 8,
    paddingBottom: 8
  },

  /* Styles applied to the root element if dense. */
  dense: {},

  /* Styles applied to the root element if a `subheader` is provided. */
  subheader: {
    paddingTop: 0
  }
};
var List = /*#__PURE__*/React__namespace.forwardRef(function List(props, ref) {
  var children = props.children,
      classes = props.classes,
      className = props.className,
      _props$component = props.component,
      Component = _props$component === void 0 ? 'ul' : _props$component,
      _props$dense = props.dense,
      dense = _props$dense === void 0 ? false : _props$dense,
      _props$disablePadding = props.disablePadding,
      disablePadding = _props$disablePadding === void 0 ? false : _props$disablePadding,
      subheader = props.subheader,
      other = _objectWithoutProperties$4(props, ["children", "classes", "className", "component", "dense", "disablePadding", "subheader"]);

  var context = React__namespace.useMemo(function () {
    return {
      dense: dense
    };
  }, [dense]);
  return /*#__PURE__*/React__namespace.createElement(ListContext$1.Provider, {
    value: context
  }, /*#__PURE__*/React__namespace.createElement(Component, _extends$f({
    className: clsx(classes.root, className, dense && classes.dense, !disablePadding && classes.padding, subheader && classes.subheader),
    ref: ref
  }, other), subheader, children));
});
var List$1 = withStyles(styles$d, {
  name: 'MuiList'
})(List);function getOffsetTop(rect, vertical) {
  var offset = 0;

  if (typeof vertical === 'number') {
    offset = vertical;
  } else if (vertical === 'center') {
    offset = rect.height / 2;
  } else if (vertical === 'bottom') {
    offset = rect.height;
  }

  return offset;
}
function getOffsetLeft(rect, horizontal) {
  var offset = 0;

  if (typeof horizontal === 'number') {
    offset = horizontal;
  } else if (horizontal === 'center') {
    offset = rect.width / 2;
  } else if (horizontal === 'right') {
    offset = rect.width;
  }

  return offset;
}

function getTransformOriginValue(transformOrigin) {
  return [transformOrigin.horizontal, transformOrigin.vertical].map(function (n) {
    return typeof n === 'number' ? "".concat(n, "px") : n;
  }).join(' ');
} // Sum the scrollTop between two elements.


function getScrollParent$2(parent, child) {
  var element = child;
  var scrollTop = 0;

  while (element && element !== parent) {
    element = element.parentElement;
    scrollTop += element.scrollTop;
  }

  return scrollTop;
}

function getAnchorEl$1(anchorEl) {
  return typeof anchorEl === 'function' ? anchorEl() : anchorEl;
}

var styles$c = {
  /* Styles applied to the root element. */
  root: {},

  /* Styles applied to the `Paper` component. */
  paper: {
    position: 'absolute',
    overflowY: 'auto',
    overflowX: 'hidden',
    // So we see the popover when it's empty.
    // It's most likely on issue on userland.
    minWidth: 16,
    minHeight: 16,
    maxWidth: 'calc(100% - 32px)',
    maxHeight: 'calc(100% - 32px)',
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0
  }
};
var Popover = /*#__PURE__*/React__namespace.forwardRef(function Popover(props, ref) {
  var action = props.action,
      anchorEl = props.anchorEl,
      _props$anchorOrigin = props.anchorOrigin,
      anchorOrigin = _props$anchorOrigin === void 0 ? {
    vertical: 'top',
    horizontal: 'left'
  } : _props$anchorOrigin,
      anchorPosition = props.anchorPosition,
      _props$anchorReferenc = props.anchorReference,
      anchorReference = _props$anchorReferenc === void 0 ? 'anchorEl' : _props$anchorReferenc,
      children = props.children,
      classes = props.classes,
      className = props.className,
      containerProp = props.container,
      _props$elevation = props.elevation,
      elevation = _props$elevation === void 0 ? 8 : _props$elevation,
      getContentAnchorEl = props.getContentAnchorEl,
      _props$marginThreshol = props.marginThreshold,
      marginThreshold = _props$marginThreshol === void 0 ? 16 : _props$marginThreshol,
      onEnter = props.onEnter,
      onEntered = props.onEntered,
      onEntering = props.onEntering,
      onExit = props.onExit,
      onExited = props.onExited,
      onExiting = props.onExiting,
      open = props.open,
      _props$PaperProps = props.PaperProps,
      PaperProps = _props$PaperProps === void 0 ? {} : _props$PaperProps,
      _props$transformOrigi = props.transformOrigin,
      transformOrigin = _props$transformOrigi === void 0 ? {
    vertical: 'top',
    horizontal: 'left'
  } : _props$transformOrigi,
      _props$TransitionComp = props.TransitionComponent,
      TransitionComponent = _props$TransitionComp === void 0 ? Grow$1 : _props$TransitionComp,
      _props$transitionDura = props.transitionDuration,
      transitionDurationProp = _props$transitionDura === void 0 ? 'auto' : _props$transitionDura,
      _props$TransitionProp = props.TransitionProps,
      TransitionProps = _props$TransitionProp === void 0 ? {} : _props$TransitionProp,
      other = _objectWithoutProperties$4(props, ["action", "anchorEl", "anchorOrigin", "anchorPosition", "anchorReference", "children", "classes", "className", "container", "elevation", "getContentAnchorEl", "marginThreshold", "onEnter", "onEntered", "onEntering", "onExit", "onExited", "onExiting", "open", "PaperProps", "transformOrigin", "TransitionComponent", "transitionDuration", "TransitionProps"]);

  var paperRef = React__namespace.useRef(); // Returns the top/left offset of the position
  // to attach to on the anchor element (or body if none is provided)

  var getAnchorOffset = React__namespace.useCallback(function (contentAnchorOffset) {
    if (anchorReference === 'anchorPosition') {

      return anchorPosition;
    }

    var resolvedAnchorEl = getAnchorEl$1(anchorEl); // If an anchor element wasn't provided, just use the parent body element of this Popover

    var anchorElement = resolvedAnchorEl && resolvedAnchorEl.nodeType === 1 ? resolvedAnchorEl : ownerDocument(paperRef.current).body;
    var anchorRect = anchorElement.getBoundingClientRect();

    var anchorVertical = contentAnchorOffset === 0 ? anchorOrigin.vertical : 'center';
    return {
      top: anchorRect.top + getOffsetTop(anchorRect, anchorVertical),
      left: anchorRect.left + getOffsetLeft(anchorRect, anchorOrigin.horizontal)
    };
  }, [anchorEl, anchorOrigin.horizontal, anchorOrigin.vertical, anchorPosition, anchorReference]); // Returns the vertical offset of inner content to anchor the transform on if provided

  var getContentAnchorOffset = React__namespace.useCallback(function (element) {
    var contentAnchorOffset = 0;

    if (getContentAnchorEl && anchorReference === 'anchorEl') {
      var contentAnchorEl = getContentAnchorEl(element);

      if (contentAnchorEl && element.contains(contentAnchorEl)) {
        var scrollTop = getScrollParent$2(element, contentAnchorEl);
        contentAnchorOffset = contentAnchorEl.offsetTop + contentAnchorEl.clientHeight / 2 - scrollTop || 0;
      } // != the default value
    }

    return contentAnchorOffset;
  }, [anchorOrigin.vertical, anchorReference, getContentAnchorEl]); // Return the base transform origin using the element
  // and taking the content anchor offset into account if in use

  var getTransformOrigin = React__namespace.useCallback(function (elemRect) {
    var contentAnchorOffset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    return {
      vertical: getOffsetTop(elemRect, transformOrigin.vertical) + contentAnchorOffset,
      horizontal: getOffsetLeft(elemRect, transformOrigin.horizontal)
    };
  }, [transformOrigin.horizontal, transformOrigin.vertical]);
  var getPositioningStyle = React__namespace.useCallback(function (element) {
    // Check if the parent has requested anchoring on an inner content node
    var contentAnchorOffset = getContentAnchorOffset(element);
    var elemRect = {
      width: element.offsetWidth,
      height: element.offsetHeight
    }; // Get the transform origin point on the element itself

    var elemTransformOrigin = getTransformOrigin(elemRect, contentAnchorOffset);

    if (anchorReference === 'none') {
      return {
        top: null,
        left: null,
        transformOrigin: getTransformOriginValue(elemTransformOrigin)
      };
    } // Get the offset of of the anchoring element


    var anchorOffset = getAnchorOffset(contentAnchorOffset); // Calculate element positioning

    var top = anchorOffset.top - elemTransformOrigin.vertical;
    var left = anchorOffset.left - elemTransformOrigin.horizontal;
    var bottom = top + elemRect.height;
    var right = left + elemRect.width; // Use the parent window of the anchorEl if provided

    var containerWindow = ownerWindow(getAnchorEl$1(anchorEl)); // Window thresholds taking required margin into account

    var heightThreshold = containerWindow.innerHeight - marginThreshold;
    var widthThreshold = containerWindow.innerWidth - marginThreshold; // Check if the vertical axis needs shifting

    if (top < marginThreshold) {
      var diff = top - marginThreshold;
      top -= diff;
      elemTransformOrigin.vertical += diff;
    } else if (bottom > heightThreshold) {
      var _diff = bottom - heightThreshold;

      top -= _diff;
      elemTransformOrigin.vertical += _diff;
    }


    if (left < marginThreshold) {
      var _diff2 = left - marginThreshold;

      left -= _diff2;
      elemTransformOrigin.horizontal += _diff2;
    } else if (right > widthThreshold) {
      var _diff3 = right - widthThreshold;

      left -= _diff3;
      elemTransformOrigin.horizontal += _diff3;
    }

    return {
      top: "".concat(Math.round(top), "px"),
      left: "".concat(Math.round(left), "px"),
      transformOrigin: getTransformOriginValue(elemTransformOrigin)
    };
  }, [anchorEl, anchorReference, getAnchorOffset, getContentAnchorOffset, getTransformOrigin, marginThreshold]);
  var setPositioningStyles = React__namespace.useCallback(function () {
    var element = paperRef.current;

    if (!element) {
      return;
    }

    var positioning = getPositioningStyle(element);

    if (positioning.top !== null) {
      element.style.top = positioning.top;
    }

    if (positioning.left !== null) {
      element.style.left = positioning.left;
    }

    element.style.transformOrigin = positioning.transformOrigin;
  }, [getPositioningStyle]);

  var handleEntering = function handleEntering(element, isAppearing) {
    if (onEntering) {
      onEntering(element, isAppearing);
    }

    setPositioningStyles();
  };

  var handlePaperRef = React__namespace.useCallback(function (instance) {
    // #StrictMode ready
    paperRef.current = ReactDOM__namespace.findDOMNode(instance);
  }, []);
  React__namespace.useEffect(function () {
    if (open) {
      setPositioningStyles();
    }
  });
  React__namespace.useImperativeHandle(action, function () {
    return open ? {
      updatePosition: function updatePosition() {
        setPositioningStyles();
      }
    } : null;
  }, [open, setPositioningStyles]);
  React__namespace.useEffect(function () {
    if (!open) {
      return undefined;
    }

    var handleResize = debounce$4(function () {
      setPositioningStyles();
    });
    window.addEventListener('resize', handleResize);
    return function () {
      handleResize.clear();
      window.removeEventListener('resize', handleResize);
    };
  }, [open, setPositioningStyles]);
  var transitionDuration = transitionDurationProp;

  if (transitionDurationProp === 'auto' && !TransitionComponent.muiSupportAuto) {
    transitionDuration = undefined;
  } // If the container prop is provided, use that
  // If the anchorEl prop is provided, use its parent body element as the container
  // If neither are provided let the Modal take care of choosing the container


  var container = containerProp || (anchorEl ? ownerDocument(getAnchorEl$1(anchorEl)).body : undefined);
  return /*#__PURE__*/React__namespace.createElement(Modal$1, _extends$f({
    container: container,
    open: open,
    ref: ref,
    BackdropProps: {
      invisible: true
    },
    className: clsx(classes.root, className)
  }, other), /*#__PURE__*/React__namespace.createElement(TransitionComponent, _extends$f({
    appear: true,
    in: open,
    onEnter: onEnter,
    onEntered: onEntered,
    onExit: onExit,
    onExited: onExited,
    onExiting: onExiting,
    timeout: transitionDuration
  }, TransitionProps, {
    onEntering: createChainedFunction(handleEntering, TransitionProps.onEntering)
  }), /*#__PURE__*/React__namespace.createElement(Paper$1, _extends$f({
    elevation: elevation,
    ref: handlePaperRef
  }, PaperProps, {
    className: clsx(classes.paper, PaperProps.className)
  }), children)));
});
var Popover$1 = withStyles(styles$c, {
  name: 'MuiPopover'
})(Popover);function nextItem(list, item, disableListWrap) {
  if (list === item) {
    return list.firstChild;
  }

  if (item && item.nextElementSibling) {
    return item.nextElementSibling;
  }

  return disableListWrap ? null : list.firstChild;
}

function previousItem(list, item, disableListWrap) {
  if (list === item) {
    return disableListWrap ? list.firstChild : list.lastChild;
  }

  if (item && item.previousElementSibling) {
    return item.previousElementSibling;
  }

  return disableListWrap ? null : list.lastChild;
}

function textCriteriaMatches(nextFocus, textCriteria) {
  if (textCriteria === undefined) {
    return true;
  }

  var text = nextFocus.innerText;

  if (text === undefined) {
    // jsdom doesn't support innerText
    text = nextFocus.textContent;
  }

  text = text.trim().toLowerCase();

  if (text.length === 0) {
    return false;
  }

  if (textCriteria.repeating) {
    return text[0] === textCriteria.keys[0];
  }

  return text.indexOf(textCriteria.keys.join('')) === 0;
}

function moveFocus(list, currentFocus, disableListWrap, disabledItemsFocusable, traversalFunction, textCriteria) {
  var wrappedOnce = false;
  var nextFocus = traversalFunction(list, currentFocus, currentFocus ? disableListWrap : false);

  while (nextFocus) {
    // Prevent infinite loop.
    if (nextFocus === list.firstChild) {
      if (wrappedOnce) {
        return;
      }

      wrappedOnce = true;
    } // Same logic as useAutocomplete.js


    var nextFocusDisabled = disabledItemsFocusable ? false : nextFocus.disabled || nextFocus.getAttribute('aria-disabled') === 'true';

    if (!nextFocus.hasAttribute('tabindex') || !textCriteriaMatches(nextFocus, textCriteria) || nextFocusDisabled) {
      // Move to the next element.
      nextFocus = traversalFunction(list, nextFocus, disableListWrap);
    } else {
      nextFocus.focus();
      return;
    }
  }
}

var useEnhancedEffect$1 = typeof window === 'undefined' ? React__namespace.useEffect : React__namespace.useLayoutEffect;
/**
 * A permanently displayed menu following https://www.w3.org/TR/wai-aria-practices/#menubutton.
 * It's exposed to help customization of the [`Menu`](/api/menu/) component. If you
 * use it separately you need to move focus into the component manually. Once
 * the focus is placed inside the component it is fully keyboard accessible.
 */

var MenuList = /*#__PURE__*/React__namespace.forwardRef(function MenuList(props, ref) {
  var actions = props.actions,
      _props$autoFocus = props.autoFocus,
      autoFocus = _props$autoFocus === void 0 ? false : _props$autoFocus,
      _props$autoFocusItem = props.autoFocusItem,
      autoFocusItem = _props$autoFocusItem === void 0 ? false : _props$autoFocusItem,
      children = props.children,
      className = props.className,
      _props$disabledItemsF = props.disabledItemsFocusable,
      disabledItemsFocusable = _props$disabledItemsF === void 0 ? false : _props$disabledItemsF,
      _props$disableListWra = props.disableListWrap,
      disableListWrap = _props$disableListWra === void 0 ? false : _props$disableListWra,
      onKeyDown = props.onKeyDown,
      _props$variant = props.variant,
      variant = _props$variant === void 0 ? 'selectedMenu' : _props$variant,
      other = _objectWithoutProperties$4(props, ["actions", "autoFocus", "autoFocusItem", "children", "className", "disabledItemsFocusable", "disableListWrap", "onKeyDown", "variant"]);

  var listRef = React__namespace.useRef(null);
  var textCriteriaRef = React__namespace.useRef({
    keys: [],
    repeating: true,
    previousKeyMatched: true,
    lastTime: null
  });
  useEnhancedEffect$1(function () {
    if (autoFocus) {
      listRef.current.focus();
    }
  }, [autoFocus]);
  React__namespace.useImperativeHandle(actions, function () {
    return {
      adjustStyleForScrollbar: function adjustStyleForScrollbar(containerElement, theme) {
        // Let's ignore that piece of logic if users are already overriding the width
        // of the menu.
        var noExplicitWidth = !listRef.current.style.width;

        if (containerElement.clientHeight < listRef.current.clientHeight && noExplicitWidth) {
          var scrollbarSize = "".concat(getScrollbarSize(), "px");
          listRef.current.style[theme.direction === 'rtl' ? 'paddingLeft' : 'paddingRight'] = scrollbarSize;
          listRef.current.style.width = "calc(100% + ".concat(scrollbarSize, ")");
        }

        return listRef.current;
      }
    };
  }, []);

  var handleKeyDown = function handleKeyDown(event) {
    var list = listRef.current;
    var key = event.key;
    /**
     * @type {Element} - will always be defined since we are in a keydown handler
     * attached to an element. A keydown event is either dispatched to the activeElement
     * or document.body or document.documentElement. Only the first case will
     * trigger this specific handler.
     */

    var currentFocus = ownerDocument(list).activeElement;

    if (key === 'ArrowDown') {
      // Prevent scroll of the page
      event.preventDefault();
      moveFocus(list, currentFocus, disableListWrap, disabledItemsFocusable, nextItem);
    } else if (key === 'ArrowUp') {
      event.preventDefault();
      moveFocus(list, currentFocus, disableListWrap, disabledItemsFocusable, previousItem);
    } else if (key === 'Home') {
      event.preventDefault();
      moveFocus(list, null, disableListWrap, disabledItemsFocusable, nextItem);
    } else if (key === 'End') {
      event.preventDefault();
      moveFocus(list, null, disableListWrap, disabledItemsFocusable, previousItem);
    } else if (key.length === 1) {
      var criteria = textCriteriaRef.current;
      var lowerKey = key.toLowerCase();
      var currTime = performance.now();

      if (criteria.keys.length > 0) {
        // Reset
        if (currTime - criteria.lastTime > 500) {
          criteria.keys = [];
          criteria.repeating = true;
          criteria.previousKeyMatched = true;
        } else if (criteria.repeating && lowerKey !== criteria.keys[0]) {
          criteria.repeating = false;
        }
      }

      criteria.lastTime = currTime;
      criteria.keys.push(lowerKey);
      var keepFocusOnCurrent = currentFocus && !criteria.repeating && textCriteriaMatches(currentFocus, criteria);

      if (criteria.previousKeyMatched && (keepFocusOnCurrent || moveFocus(list, currentFocus, false, disabledItemsFocusable, nextItem, criteria))) {
        event.preventDefault();
      } else {
        criteria.previousKeyMatched = false;
      }
    }

    if (onKeyDown) {
      onKeyDown(event);
    }
  };

  var handleOwnRef = React__namespace.useCallback(function (instance) {
    // #StrictMode ready
    listRef.current = ReactDOM__namespace.findDOMNode(instance);
  }, []);
  var handleRef = useForkRef(handleOwnRef, ref);
  /**
   * the index of the item should receive focus
   * in a `variant="selectedMenu"` it's the first `selected` item
   * otherwise it's the very first item.
   */

  var activeItemIndex = -1; // since we inject focus related props into children we have to do a lookahead
  // to check if there is a `selected` item. We're looking for the last `selected`
  // item and use the first valid item as a fallback

  React__namespace.Children.forEach(children, function (child, index) {
    if (! /*#__PURE__*/React__namespace.isValidElement(child)) {
      return;
    }

    if (!child.props.disabled) {
      if (variant === 'selectedMenu' && child.props.selected) {
        activeItemIndex = index;
      } else if (activeItemIndex === -1) {
        activeItemIndex = index;
      }
    }
  });
  var items = React__namespace.Children.map(children, function (child, index) {
    if (index === activeItemIndex) {
      var newChildProps = {};

      if (autoFocusItem) {
        newChildProps.autoFocus = true;
      }

      if (child.props.tabIndex === undefined && variant === 'selectedMenu') {
        newChildProps.tabIndex = 0;
      }

      return /*#__PURE__*/React__namespace.cloneElement(child, newChildProps);
    }

    return child;
  });
  return /*#__PURE__*/React__namespace.createElement(List$1, _extends$f({
    role: "menu",
    ref: handleRef,
    className: className,
    onKeyDown: handleKeyDown,
    tabIndex: autoFocus ? 0 : -1
  }, other), items);
});
var MenuList$1 = MenuList;var RTL_ORIGIN = {
  vertical: 'top',
  horizontal: 'right'
};
var LTR_ORIGIN = {
  vertical: 'top',
  horizontal: 'left'
};
var styles$b = {
  /* Styles applied to the `Paper` component. */
  paper: {
    // specZ: The maximum height of a simple menu should be one or more rows less than the view
    // height. This ensures a tapable area outside of the simple menu with which to dismiss
    // the menu.
    maxHeight: 'calc(100% - 96px)',
    // Add iOS momentum scrolling.
    WebkitOverflowScrolling: 'touch'
  },

  /* Styles applied to the `List` component via `MenuList`. */
  list: {
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0
  }
};
var Menu = /*#__PURE__*/React__namespace.forwardRef(function Menu(props, ref) {
  var _props$autoFocus = props.autoFocus,
      autoFocus = _props$autoFocus === void 0 ? true : _props$autoFocus,
      children = props.children,
      classes = props.classes,
      _props$disableAutoFoc = props.disableAutoFocusItem,
      disableAutoFocusItem = _props$disableAutoFoc === void 0 ? false : _props$disableAutoFoc,
      _props$MenuListProps = props.MenuListProps,
      MenuListProps = _props$MenuListProps === void 0 ? {} : _props$MenuListProps,
      onClose = props.onClose,
      onEnteringProp = props.onEntering,
      open = props.open,
      _props$PaperProps = props.PaperProps,
      PaperProps = _props$PaperProps === void 0 ? {} : _props$PaperProps,
      PopoverClasses = props.PopoverClasses,
      _props$transitionDura = props.transitionDuration,
      transitionDuration = _props$transitionDura === void 0 ? 'auto' : _props$transitionDura,
      _props$TransitionProp = props.TransitionProps;
  _props$TransitionProp = _props$TransitionProp === void 0 ? {} : _props$TransitionProp;

  var onEntering = _props$TransitionProp.onEntering,
      TransitionProps = _objectWithoutProperties$4(_props$TransitionProp, ["onEntering"]),
      _props$variant = props.variant,
      variant = _props$variant === void 0 ? 'selectedMenu' : _props$variant,
      other = _objectWithoutProperties$4(props, ["autoFocus", "children", "classes", "disableAutoFocusItem", "MenuListProps", "onClose", "onEntering", "open", "PaperProps", "PopoverClasses", "transitionDuration", "TransitionProps", "variant"]);

  var theme = useTheme();
  var autoFocusItem = autoFocus && !disableAutoFocusItem && open;
  var menuListActionsRef = React__namespace.useRef(null);
  var contentAnchorRef = React__namespace.useRef(null);

  var getContentAnchorEl = function getContentAnchorEl() {
    return contentAnchorRef.current;
  };

  var handleEntering = function handleEntering(element, isAppearing) {
    if (menuListActionsRef.current) {
      menuListActionsRef.current.adjustStyleForScrollbar(element, theme);
    }

    if (onEnteringProp) {
      onEnteringProp(element, isAppearing);
    }

    if (onEntering) {
      onEntering(element, isAppearing);
    }
  };

  var handleListKeyDown = function handleListKeyDown(event) {
    if (event.key === 'Tab') {
      event.preventDefault();

      if (onClose) {
        onClose(event, 'tabKeyDown');
      }
    }
  };
  /**
   * the index of the item should receive focus
   * in a `variant="selectedMenu"` it's the first `selected` item
   * otherwise it's the very first item.
   */


  var activeItemIndex = -1; // since we inject focus related props into children we have to do a lookahead
  // to check if there is a `selected` item. We're looking for the last `selected`
  // item and use the first valid item as a fallback

  React__namespace.Children.map(children, function (child, index) {
    if (! /*#__PURE__*/React__namespace.isValidElement(child)) {
      return;
    }

    if (!child.props.disabled) {
      if (variant !== "menu" && child.props.selected) {
        activeItemIndex = index;
      } else if (activeItemIndex === -1) {
        activeItemIndex = index;
      }
    }
  });
  var items = React__namespace.Children.map(children, function (child, index) {
    if (index === activeItemIndex) {
      return /*#__PURE__*/React__namespace.cloneElement(child, {
        ref: function ref(instance) {
          // #StrictMode ready
          contentAnchorRef.current = ReactDOM__namespace.findDOMNode(instance);
          setRef(child.ref, instance);
        }
      });
    }

    return child;
  });
  return /*#__PURE__*/React__namespace.createElement(Popover$1, _extends$f({
    getContentAnchorEl: getContentAnchorEl,
    classes: PopoverClasses,
    onClose: onClose,
    TransitionProps: _extends$f({
      onEntering: handleEntering
    }, TransitionProps),
    anchorOrigin: theme.direction === 'rtl' ? RTL_ORIGIN : LTR_ORIGIN,
    transformOrigin: theme.direction === 'rtl' ? RTL_ORIGIN : LTR_ORIGIN,
    PaperProps: _extends$f({}, PaperProps, {
      classes: _extends$f({}, PaperProps.classes, {
        root: classes.paper
      })
    }),
    open: open,
    ref: ref,
    transitionDuration: transitionDuration
  }, other), /*#__PURE__*/React__namespace.createElement(MenuList$1, _extends$f({
    onKeyDown: handleListKeyDown,
    actions: menuListActionsRef,
    autoFocus: autoFocus && (activeItemIndex === -1 || disableAutoFocusItem),
    autoFocusItem: autoFocusItem,
    variant: variant
  }, MenuListProps, {
    className: clsx(classes.list, MenuListProps.className)
  }), items));
});
var Menu$1 = withStyles(styles$b, {
  name: 'MuiMenu'
})(Menu);/**
 * @ignore - internal component.
 */

var NativeSelectInput = /*#__PURE__*/React__namespace.forwardRef(function NativeSelectInput(props, ref) {
  var classes = props.classes,
      className = props.className,
      disabled = props.disabled,
      IconComponent = props.IconComponent,
      inputRef = props.inputRef,
      _props$variant = props.variant,
      variant = _props$variant === void 0 ? 'standard' : _props$variant,
      other = _objectWithoutProperties$4(props, ["classes", "className", "disabled", "IconComponent", "inputRef", "variant"]);

  return /*#__PURE__*/React__namespace.createElement(React__namespace.Fragment, null, /*#__PURE__*/React__namespace.createElement("select", _extends$f({
    className: clsx(classes.root, // TODO v5: merge root and select
    classes.select, classes[variant], className, disabled && classes.disabled),
    disabled: disabled,
    ref: inputRef || ref
  }, other)), props.multiple ? null : /*#__PURE__*/React__namespace.createElement(IconComponent, {
    className: clsx(classes.icon, classes["icon".concat(capitalize(variant))], disabled && classes.disabled)
  }));
});
var NativeSelectInput$1 = NativeSelectInput;/**
 * @ignore - internal component.
 */

var ArrowDropDownIcon = createSvgIcon( /*#__PURE__*/React__namespace.createElement("path", {
  d: "M7 10l5 5 5-5z"
}));var styles$a = function styles(theme) {
  return {
    /* Styles applied to the select component `root` class. */
    root: {},

    /* Styles applied to the select component `select` class. */
    select: {
      '-moz-appearance': 'none',
      // Reset
      '-webkit-appearance': 'none',
      // Reset
      // When interacting quickly, the text can end up selected.
      // Native select can't be selected either.
      userSelect: 'none',
      borderRadius: 0,
      // Reset
      minWidth: 16,
      // So it doesn't collapse.
      cursor: 'pointer',
      '&:focus': {
        // Show that it's not an text input
        backgroundColor: theme.palette.type === 'light' ? 'rgba(0, 0, 0, 0.05)' : 'rgba(255, 255, 255, 0.05)',
        borderRadius: 0 // Reset Chrome style

      },
      // Remove IE 11 arrow
      '&::-ms-expand': {
        display: 'none'
      },
      '&$disabled': {
        cursor: 'default'
      },
      '&[multiple]': {
        height: 'auto'
      },
      '&:not([multiple]) option, &:not([multiple]) optgroup': {
        backgroundColor: theme.palette.background.paper
      },
      '&&': {
        paddingRight: 24
      }
    },

    /* Styles applied to the select component if `variant="filled"`. */
    filled: {
      '&&': {
        paddingRight: 32
      }
    },

    /* Styles applied to the select component if `variant="outlined"`. */
    outlined: {
      borderRadius: theme.shape.borderRadius,
      '&&': {
        paddingRight: 32
      }
    },

    /* Styles applied to the select component `selectMenu` class. */
    selectMenu: {
      height: 'auto',
      // Resets for multpile select with chips
      minHeight: '1.1876em',
      // Required for select\text-field height consistency
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      overflow: 'hidden'
    },

    /* Pseudo-class applied to the select component `disabled` class. */
    disabled: {},

    /* Styles applied to the icon component. */
    icon: {
      // We use a position absolute over a flexbox in order to forward the pointer events
      // to the input and to support wrapping tags..
      position: 'absolute',
      right: 0,
      top: 'calc(50% - 12px)',
      // Center vertically
      pointerEvents: 'none',
      // Don't block pointer events on the select under the icon.
      color: theme.palette.action.active,
      '&$disabled': {
        color: theme.palette.action.disabled
      }
    },

    /* Styles applied to the icon component if the popup is open. */
    iconOpen: {
      transform: 'rotate(180deg)'
    },

    /* Styles applied to the icon component if `variant="filled"`. */
    iconFilled: {
      right: 7
    },

    /* Styles applied to the icon component if `variant="outlined"`. */
    iconOutlined: {
      right: 7
    },

    /* Styles applied to the underlying native input component. */
    nativeInput: {
      bottom: 0,
      left: 0,
      position: 'absolute',
      opacity: 0,
      pointerEvents: 'none',
      width: '100%'
    }
  };
};
var defaultInput = /*#__PURE__*/React__namespace.createElement(Input$3, null);
/**
 * An alternative to `<Select native />` with a much smaller bundle size footprint.
 */

var NativeSelect = /*#__PURE__*/React__namespace.forwardRef(function NativeSelect(props, ref) {
  var children = props.children,
      classes = props.classes,
      _props$IconComponent = props.IconComponent,
      IconComponent = _props$IconComponent === void 0 ? ArrowDropDownIcon : _props$IconComponent,
      _props$input = props.input,
      input = _props$input === void 0 ? defaultInput : _props$input,
      inputProps = props.inputProps;
      props.variant;
      var other = _objectWithoutProperties$4(props, ["children", "classes", "IconComponent", "input", "inputProps", "variant"]);

  var muiFormControl = useFormControl();
  var fcs = formControlState({
    props: props,
    muiFormControl: muiFormControl,
    states: ['variant']
  });
  return /*#__PURE__*/React__namespace.cloneElement(input, _extends$f({
    // Most of the logic is implemented in `NativeSelectInput`.
    // The `Select` component is a simple API wrapper to expose something better to play with.
    inputComponent: NativeSelectInput$1,
    inputProps: _extends$f({
      children: children,
      classes: classes,
      IconComponent: IconComponent,
      variant: fcs.variant,
      type: undefined
    }, inputProps, input ? input.props.inputProps : {}),
    ref: ref
  }, other));
});
NativeSelect.muiName = 'Select';
withStyles(styles$a, {
  name: 'MuiNativeSelect'
})(NativeSelect);var styles$9 = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      position: 'absolute',
      bottom: 0,
      right: 0,
      top: -5,
      left: 0,
      margin: 0,
      padding: '0 8px',
      pointerEvents: 'none',
      borderRadius: 'inherit',
      borderStyle: 'solid',
      borderWidth: 1,
      overflow: 'hidden'
    },

    /* Styles applied to the legend element when `labelWidth` is provided. */
    legend: {
      textAlign: 'left',
      padding: 0,
      lineHeight: '11px',
      // sync with `height` in `legend` styles
      transition: theme.transitions.create('width', {
        duration: 150,
        easing: theme.transitions.easing.easeOut
      })
    },

    /* Styles applied to the legend element. */
    legendLabelled: {
      display: 'block',
      width: 'auto',
      textAlign: 'left',
      padding: 0,
      height: 11,
      // sync with `lineHeight` in `legend` styles
      fontSize: '0.75em',
      visibility: 'hidden',
      maxWidth: 0.01,
      transition: theme.transitions.create('max-width', {
        duration: 50,
        easing: theme.transitions.easing.easeOut
      }),
      '& > span': {
        paddingLeft: 5,
        paddingRight: 5,
        display: 'inline-block'
      }
    },

    /* Styles applied to the legend element is notched. */
    legendNotched: {
      maxWidth: 1000,
      transition: theme.transitions.create('max-width', {
        duration: 100,
        easing: theme.transitions.easing.easeOut,
        delay: 50
      })
    }
  };
};
/**
 * @ignore - internal component.
 */

var NotchedOutline = /*#__PURE__*/React__namespace.forwardRef(function NotchedOutline(props, ref) {
  props.children;
      var classes = props.classes,
      className = props.className,
      label = props.label,
      labelWidthProp = props.labelWidth,
      notched = props.notched,
      style = props.style,
      other = _objectWithoutProperties$4(props, ["children", "classes", "className", "label", "labelWidth", "notched", "style"]);

  var theme = useTheme();
  var align = theme.direction === 'rtl' ? 'right' : 'left';

  if (label !== undefined) {
    return /*#__PURE__*/React__namespace.createElement("fieldset", _extends$f({
      "aria-hidden": true,
      className: clsx(classes.root, className),
      ref: ref,
      style: style
    }, other), /*#__PURE__*/React__namespace.createElement("legend", {
      className: clsx(classes.legendLabelled, notched && classes.legendNotched)
    }, label ? /*#__PURE__*/React__namespace.createElement("span", null, label) : /*#__PURE__*/React__namespace.createElement("span", {
      dangerouslySetInnerHTML: {
        __html: '&#8203;'
      }
    })));
  }

  var labelWidth = labelWidthProp > 0 ? labelWidthProp * 0.75 + 8 : 0.01;
  return /*#__PURE__*/React__namespace.createElement("fieldset", _extends$f({
    "aria-hidden": true,
    style: _extends$f(_defineProperty$3({}, "padding".concat(capitalize(align)), 8), style),
    className: clsx(classes.root, className),
    ref: ref
  }, other), /*#__PURE__*/React__namespace.createElement("legend", {
    className: classes.legend,
    style: {
      // IE 11: fieldset with legend does not render
      // a border radius. This maintains consistency
      // by always having a legend rendered
      width: notched ? labelWidth : 0.01
    }
  }, /*#__PURE__*/React__namespace.createElement("span", {
    dangerouslySetInnerHTML: {
      __html: '&#8203;'
    }
  })));
});
var NotchedOutline$1 = withStyles(styles$9, {
  name: 'PrivateNotchedOutline'
})(NotchedOutline);var styles$8 = function styles(theme) {
  var borderColor = theme.palette.type === 'light' ? 'rgba(0, 0, 0, 0.23)' : 'rgba(255, 255, 255, 0.23)';
  return {
    /* Styles applied to the root element. */
    root: {
      position: 'relative',
      borderRadius: theme.shape.borderRadius,
      '&:hover $notchedOutline': {
        borderColor: theme.palette.text.primary
      },
      // Reset on touch devices, it doesn't add specificity
      '@media (hover: none)': {
        '&:hover $notchedOutline': {
          borderColor: borderColor
        }
      },
      '&$focused $notchedOutline': {
        borderColor: theme.palette.primary.main,
        borderWidth: 2
      },
      '&$error $notchedOutline': {
        borderColor: theme.palette.error.main
      },
      '&$disabled $notchedOutline': {
        borderColor: theme.palette.action.disabled
      }
    },

    /* Styles applied to the root element if the color is secondary. */
    colorSecondary: {
      '&$focused $notchedOutline': {
        borderColor: theme.palette.secondary.main
      }
    },

    /* Styles applied to the root element if the component is focused. */
    focused: {},

    /* Styles applied to the root element if `disabled={true}`. */
    disabled: {},

    /* Styles applied to the root element if `startAdornment` is provided. */
    adornedStart: {
      paddingLeft: 14
    },

    /* Styles applied to the root element if `endAdornment` is provided. */
    adornedEnd: {
      paddingRight: 14
    },

    /* Pseudo-class applied to the root element if `error={true}`. */
    error: {},

    /* Styles applied to the `input` element if `margin="dense"`. */
    marginDense: {},

    /* Styles applied to the root element if `multiline={true}`. */
    multiline: {
      padding: '18.5px 14px',
      '&$marginDense': {
        paddingTop: 10.5,
        paddingBottom: 10.5
      }
    },

    /* Styles applied to the `NotchedOutline` element. */
    notchedOutline: {
      borderColor: borderColor
    },

    /* Styles applied to the `input` element. */
    input: {
      padding: '18.5px 14px',
      '&:-webkit-autofill': {
        WebkitBoxShadow: theme.palette.type === 'light' ? null : '0 0 0 100px #266798 inset',
        WebkitTextFillColor: theme.palette.type === 'light' ? null : '#fff',
        caretColor: theme.palette.type === 'light' ? null : '#fff',
        borderRadius: 'inherit'
      }
    },

    /* Styles applied to the `input` element if `margin="dense"`. */
    inputMarginDense: {
      paddingTop: 10.5,
      paddingBottom: 10.5
    },

    /* Styles applied to the `input` element if `multiline={true}`. */
    inputMultiline: {
      padding: 0
    },

    /* Styles applied to the `input` element if `startAdornment` is provided. */
    inputAdornedStart: {
      paddingLeft: 0
    },

    /* Styles applied to the `input` element if `endAdornment` is provided. */
    inputAdornedEnd: {
      paddingRight: 0
    }
  };
};
var OutlinedInput = /*#__PURE__*/React__namespace.forwardRef(function OutlinedInput(props, ref) {
  var classes = props.classes,
      _props$fullWidth = props.fullWidth,
      fullWidth = _props$fullWidth === void 0 ? false : _props$fullWidth,
      _props$inputComponent = props.inputComponent,
      inputComponent = _props$inputComponent === void 0 ? 'input' : _props$inputComponent,
      label = props.label,
      _props$labelWidth = props.labelWidth,
      labelWidth = _props$labelWidth === void 0 ? 0 : _props$labelWidth,
      _props$multiline = props.multiline,
      multiline = _props$multiline === void 0 ? false : _props$multiline,
      notched = props.notched,
      _props$type = props.type,
      type = _props$type === void 0 ? 'text' : _props$type,
      other = _objectWithoutProperties$4(props, ["classes", "fullWidth", "inputComponent", "label", "labelWidth", "multiline", "notched", "type"]);

  return /*#__PURE__*/React__namespace.createElement(InputBase$4, _extends$f({
    renderSuffix: function renderSuffix(state) {
      return /*#__PURE__*/React__namespace.createElement(NotchedOutline$1, {
        className: classes.notchedOutline,
        label: label,
        labelWidth: labelWidth,
        notched: typeof notched !== 'undefined' ? notched : Boolean(state.startAdornment || state.filled || state.focused)
      });
    },
    classes: _extends$f({}, classes, {
      root: clsx(classes.root, classes.underline),
      notchedOutline: null
    }),
    fullWidth: fullWidth,
    inputComponent: inputComponent,
    multiline: multiline,
    ref: ref,
    type: type
  }, other));
});
OutlinedInput.muiName = 'Input';
var OutlinedInput$1 = withStyles(styles$8, {
  name: 'MuiOutlinedInput'
})(OutlinedInput);/**!
 * @fileOverview Kickass library to create and place poppers near their reference elements.
 * @version 1.16.1-lts
 * @license
 * Copyright (c) 2016 Federico Zivolo and contributors
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */
var isBrowser$1 = typeof window !== 'undefined' && typeof document !== 'undefined' && typeof navigator !== 'undefined';

var timeoutDuration = function () {
  var longerTimeoutBrowsers = ['Edge', 'Trident', 'Firefox'];
  for (var i = 0; i < longerTimeoutBrowsers.length; i += 1) {
    if (isBrowser$1 && navigator.userAgent.indexOf(longerTimeoutBrowsers[i]) >= 0) {
      return 1;
    }
  }
  return 0;
}();

function microtaskDebounce(fn) {
  var called = false;
  return function () {
    if (called) {
      return;
    }
    called = true;
    window.Promise.resolve().then(function () {
      called = false;
      fn();
    });
  };
}

function taskDebounce(fn) {
  var scheduled = false;
  return function () {
    if (!scheduled) {
      scheduled = true;
      setTimeout(function () {
        scheduled = false;
        fn();
      }, timeoutDuration);
    }
  };
}

var supportsMicroTasks = isBrowser$1 && window.Promise;

/**
* Create a debounced version of a method, that's asynchronously deferred
* but called in the minimum time possible.
*
* @method
* @memberof Popper.Utils
* @argument {Function} fn
* @returns {Function}
*/
var debounce$3 = supportsMicroTasks ? microtaskDebounce : taskDebounce;

/**
 * Check if the given variable is a function
 * @method
 * @memberof Popper.Utils
 * @argument {Any} functionToCheck - variable to check
 * @returns {Boolean} answer to: is a function?
 */
function isFunction$2(functionToCheck) {
  var getType = {};
  return functionToCheck && getType.toString.call(functionToCheck) === '[object Function]';
}

/**
 * Get CSS computed property of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Eement} element
 * @argument {String} property
 */
function getStyleComputedProperty(element, property) {
  if (element.nodeType !== 1) {
    return [];
  }
  // NOTE: 1 DOM access here
  var window = element.ownerDocument.defaultView;
  var css = window.getComputedStyle(element, null);
  return property ? css[property] : css;
}

/**
 * Returns the parentNode or the host of the element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} parent
 */
function getParentNode$1(element) {
  if (element.nodeName === 'HTML') {
    return element;
  }
  return element.parentNode || element.host;
}

/**
 * Returns the scrolling parent of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} scroll parent
 */
function getScrollParent$1(element) {
  // Return body, `getScroll` will take care to get the correct `scrollTop` from it
  if (!element) {
    return document.body;
  }

  switch (element.nodeName) {
    case 'HTML':
    case 'BODY':
      return element.ownerDocument.body;
    case '#document':
      return element.body;
  }

  // Firefox want us to check `-x` and `-y` variations as well

  var _getStyleComputedProp = getStyleComputedProperty(element),
      overflow = _getStyleComputedProp.overflow,
      overflowX = _getStyleComputedProp.overflowX,
      overflowY = _getStyleComputedProp.overflowY;

  if (/(auto|scroll|overlay)/.test(overflow + overflowY + overflowX)) {
    return element;
  }

  return getScrollParent$1(getParentNode$1(element));
}

/**
 * Returns the reference node of the reference object, or the reference object itself.
 * @method
 * @memberof Popper.Utils
 * @param {Element|Object} reference - the reference element (the popper will be relative to this)
 * @returns {Element} parent
 */
function getReferenceNode(reference) {
  return reference && reference.referenceNode ? reference.referenceNode : reference;
}

var isIE11 = isBrowser$1 && !!(window.MSInputMethodContext && document.documentMode);
var isIE10 = isBrowser$1 && /MSIE 10/.test(navigator.userAgent);

/**
 * Determines if the browser is Internet Explorer
 * @method
 * @memberof Popper.Utils
 * @param {Number} version to check
 * @returns {Boolean} isIE
 */
function isIE(version) {
  if (version === 11) {
    return isIE11;
  }
  if (version === 10) {
    return isIE10;
  }
  return isIE11 || isIE10;
}

/**
 * Returns the offset parent of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} offset parent
 */
function getOffsetParent$2(element) {
  if (!element) {
    return document.documentElement;
  }

  var noOffsetParent = isIE(10) ? document.body : null;

  // NOTE: 1 DOM access here
  var offsetParent = element.offsetParent || null;
  // Skip hidden elements which don't have an offsetParent
  while (offsetParent === noOffsetParent && element.nextElementSibling) {
    offsetParent = (element = element.nextElementSibling).offsetParent;
  }

  var nodeName = offsetParent && offsetParent.nodeName;

  if (!nodeName || nodeName === 'BODY' || nodeName === 'HTML') {
    return element ? element.ownerDocument.documentElement : document.documentElement;
  }

  // .offsetParent will return the closest TH, TD or TABLE in case
  // no offsetParent is present, I hate this job...
  if (['TH', 'TD', 'TABLE'].indexOf(offsetParent.nodeName) !== -1 && getStyleComputedProperty(offsetParent, 'position') === 'static') {
    return getOffsetParent$2(offsetParent);
  }

  return offsetParent;
}

function isOffsetContainer(element) {
  var nodeName = element.nodeName;

  if (nodeName === 'BODY') {
    return false;
  }
  return nodeName === 'HTML' || getOffsetParent$2(element.firstElementChild) === element;
}

/**
 * Finds the root node (document, shadowDOM root) of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} node
 * @returns {Element} root node
 */
function getRoot(node) {
  if (node.parentNode !== null) {
    return getRoot(node.parentNode);
  }

  return node;
}

/**
 * Finds the offset parent common to the two provided nodes
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element1
 * @argument {Element} element2
 * @returns {Element} common offset parent
 */
function findCommonOffsetParent(element1, element2) {
  // This check is needed to avoid errors in case one of the elements isn't defined for any reason
  if (!element1 || !element1.nodeType || !element2 || !element2.nodeType) {
    return document.documentElement;
  }

  // Here we make sure to give as "start" the element that comes first in the DOM
  var order = element1.compareDocumentPosition(element2) & Node.DOCUMENT_POSITION_FOLLOWING;
  var start = order ? element1 : element2;
  var end = order ? element2 : element1;

  // Get common ancestor container
  var range = document.createRange();
  range.setStart(start, 0);
  range.setEnd(end, 0);
  var commonAncestorContainer = range.commonAncestorContainer;

  // Both nodes are inside #document

  if (element1 !== commonAncestorContainer && element2 !== commonAncestorContainer || start.contains(end)) {
    if (isOffsetContainer(commonAncestorContainer)) {
      return commonAncestorContainer;
    }

    return getOffsetParent$2(commonAncestorContainer);
  }

  // one of the nodes is inside shadowDOM, find which one
  var element1root = getRoot(element1);
  if (element1root.host) {
    return findCommonOffsetParent(element1root.host, element2);
  } else {
    return findCommonOffsetParent(element1, getRoot(element2).host);
  }
}

/**
 * Gets the scroll value of the given element in the given side (top and left)
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @argument {String} side `top` or `left`
 * @returns {number} amount of scrolled pixels
 */
function getScroll$1(element) {
  var side = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'top';

  var upperSide = side === 'top' ? 'scrollTop' : 'scrollLeft';
  var nodeName = element.nodeName;

  if (nodeName === 'BODY' || nodeName === 'HTML') {
    var html = element.ownerDocument.documentElement;
    var scrollingElement = element.ownerDocument.scrollingElement || html;
    return scrollingElement[upperSide];
  }

  return element[upperSide];
}

/*
 * Sum or subtract the element scroll values (left and top) from a given rect object
 * @method
 * @memberof Popper.Utils
 * @param {Object} rect - Rect object you want to change
 * @param {HTMLElement} element - The element from the function reads the scroll values
 * @param {Boolean} subtract - set to true if you want to subtract the scroll values
 * @return {Object} rect - The modifier rect object
 */
function includeScroll(rect, element) {
  var subtract = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  var scrollTop = getScroll$1(element, 'top');
  var scrollLeft = getScroll$1(element, 'left');
  var modifier = subtract ? -1 : 1;
  rect.top += scrollTop * modifier;
  rect.bottom += scrollTop * modifier;
  rect.left += scrollLeft * modifier;
  rect.right += scrollLeft * modifier;
  return rect;
}

/*
 * Helper to detect borders of a given element
 * @method
 * @memberof Popper.Utils
 * @param {CSSStyleDeclaration} styles
 * Result of `getStyleComputedProperty` on the given element
 * @param {String} axis - `x` or `y`
 * @return {number} borders - The borders size of the given axis
 */

function getBordersSize$1(styles, axis) {
  var sideA = axis === 'x' ? 'Left' : 'Top';
  var sideB = sideA === 'Left' ? 'Right' : 'Bottom';

  return parseFloat(styles['border' + sideA + 'Width']) + parseFloat(styles['border' + sideB + 'Width']);
}

function getSize(axis, body, html, computedStyle) {
  return Math.max(body['offset' + axis], body['scroll' + axis], html['client' + axis], html['offset' + axis], html['scroll' + axis], isIE(10) ? parseInt(html['offset' + axis]) + parseInt(computedStyle['margin' + (axis === 'Height' ? 'Top' : 'Left')]) + parseInt(computedStyle['margin' + (axis === 'Height' ? 'Bottom' : 'Right')]) : 0);
}

function getWindowSizes(document) {
  var body = document.body;
  var html = document.documentElement;
  var computedStyle = isIE(10) && getComputedStyle(html);

  return {
    height: getSize('Height', body, html, computedStyle),
    width: getSize('Width', body, html, computedStyle)
  };
}

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();





var defineProperty = function (obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

var _extends$e = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

/**
 * Given element offsets, generate an output similar to getBoundingClientRect
 * @method
 * @memberof Popper.Utils
 * @argument {Object} offsets
 * @returns {Object} ClientRect like output
 */
function getClientRect(offsets) {
  return _extends$e({}, offsets, {
    right: offsets.left + offsets.width,
    bottom: offsets.top + offsets.height
  });
}

/**
 * Get bounding client rect of given element
 * @method
 * @memberof Popper.Utils
 * @param {HTMLElement} element
 * @return {Object} client rect
 */
function getBoundingClientRect$1(element) {
  var rect = {};

  // IE10 10 FIX: Please, don't ask, the element isn't
  // considered in DOM in some circumstances...
  // This isn't reproducible in IE10 compatibility mode of IE11
  try {
    if (isIE(10)) {
      rect = element.getBoundingClientRect();
      var scrollTop = getScroll$1(element, 'top');
      var scrollLeft = getScroll$1(element, 'left');
      rect.top += scrollTop;
      rect.left += scrollLeft;
      rect.bottom += scrollTop;
      rect.right += scrollLeft;
    } else {
      rect = element.getBoundingClientRect();
    }
  } catch (e) {}

  var result = {
    left: rect.left,
    top: rect.top,
    width: rect.right - rect.left,
    height: rect.bottom - rect.top
  };

  // subtract scrollbar size from sizes
  var sizes = element.nodeName === 'HTML' ? getWindowSizes(element.ownerDocument) : {};
  var width = sizes.width || element.clientWidth || result.width;
  var height = sizes.height || element.clientHeight || result.height;

  var horizScrollbar = element.offsetWidth - width;
  var vertScrollbar = element.offsetHeight - height;

  // if an hypothetical scrollbar is detected, we must be sure it's not a `border`
  // we make this check conditional for performance reasons
  if (horizScrollbar || vertScrollbar) {
    var styles = getStyleComputedProperty(element);
    horizScrollbar -= getBordersSize$1(styles, 'x');
    vertScrollbar -= getBordersSize$1(styles, 'y');

    result.width -= horizScrollbar;
    result.height -= vertScrollbar;
  }

  return getClientRect(result);
}

function getOffsetRectRelativeToArbitraryNode(children, parent) {
  var fixedPosition = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  var isIE10 = isIE(10);
  var isHTML = parent.nodeName === 'HTML';
  var childrenRect = getBoundingClientRect$1(children);
  var parentRect = getBoundingClientRect$1(parent);
  var scrollParent = getScrollParent$1(children);

  var styles = getStyleComputedProperty(parent);
  var borderTopWidth = parseFloat(styles.borderTopWidth);
  var borderLeftWidth = parseFloat(styles.borderLeftWidth);

  // In cases where the parent is fixed, we must ignore negative scroll in offset calc
  if (fixedPosition && isHTML) {
    parentRect.top = Math.max(parentRect.top, 0);
    parentRect.left = Math.max(parentRect.left, 0);
  }
  var offsets = getClientRect({
    top: childrenRect.top - parentRect.top - borderTopWidth,
    left: childrenRect.left - parentRect.left - borderLeftWidth,
    width: childrenRect.width,
    height: childrenRect.height
  });
  offsets.marginTop = 0;
  offsets.marginLeft = 0;

  // Subtract margins of documentElement in case it's being used as parent
  // we do this only on HTML because it's the only element that behaves
  // differently when margins are applied to it. The margins are included in
  // the box of the documentElement, in the other cases not.
  if (!isIE10 && isHTML) {
    var marginTop = parseFloat(styles.marginTop);
    var marginLeft = parseFloat(styles.marginLeft);

    offsets.top -= borderTopWidth - marginTop;
    offsets.bottom -= borderTopWidth - marginTop;
    offsets.left -= borderLeftWidth - marginLeft;
    offsets.right -= borderLeftWidth - marginLeft;

    // Attach marginTop and marginLeft because in some circumstances we may need them
    offsets.marginTop = marginTop;
    offsets.marginLeft = marginLeft;
  }

  if (isIE10 && !fixedPosition ? parent.contains(scrollParent) : parent === scrollParent && scrollParent.nodeName !== 'BODY') {
    offsets = includeScroll(offsets, parent);
  }

  return offsets;
}

function getViewportOffsetRectRelativeToArtbitraryNode(element) {
  var excludeScroll = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var html = element.ownerDocument.documentElement;
  var relativeOffset = getOffsetRectRelativeToArbitraryNode(element, html);
  var width = Math.max(html.clientWidth, window.innerWidth || 0);
  var height = Math.max(html.clientHeight, window.innerHeight || 0);

  var scrollTop = !excludeScroll ? getScroll$1(html) : 0;
  var scrollLeft = !excludeScroll ? getScroll$1(html, 'left') : 0;

  var offset = {
    top: scrollTop - relativeOffset.top + relativeOffset.marginTop,
    left: scrollLeft - relativeOffset.left + relativeOffset.marginLeft,
    width: width,
    height: height
  };

  return getClientRect(offset);
}

/**
 * Check if the given element is fixed or is inside a fixed parent
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @argument {Element} customContainer
 * @returns {Boolean} answer to "isFixed?"
 */
function isFixed(element) {
  var nodeName = element.nodeName;
  if (nodeName === 'BODY' || nodeName === 'HTML') {
    return false;
  }
  if (getStyleComputedProperty(element, 'position') === 'fixed') {
    return true;
  }
  var parentNode = getParentNode$1(element);
  if (!parentNode) {
    return false;
  }
  return isFixed(parentNode);
}

/**
 * Finds the first parent of an element that has a transformed property defined
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} first transformed parent or documentElement
 */

function getFixedPositionOffsetParent(element) {
  // This check is needed to avoid errors in case one of the elements isn't defined for any reason
  if (!element || !element.parentElement || isIE()) {
    return document.documentElement;
  }
  var el = element.parentElement;
  while (el && getStyleComputedProperty(el, 'transform') === 'none') {
    el = el.parentElement;
  }
  return el || document.documentElement;
}

/**
 * Computed the boundaries limits and return them
 * @method
 * @memberof Popper.Utils
 * @param {HTMLElement} popper
 * @param {HTMLElement} reference
 * @param {number} padding
 * @param {HTMLElement} boundariesElement - Element used to define the boundaries
 * @param {Boolean} fixedPosition - Is in fixed position mode
 * @returns {Object} Coordinates of the boundaries
 */
function getBoundaries(popper, reference, padding, boundariesElement) {
  var fixedPosition = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;

  // NOTE: 1 DOM access here

  var boundaries = { top: 0, left: 0 };
  var offsetParent = fixedPosition ? getFixedPositionOffsetParent(popper) : findCommonOffsetParent(popper, getReferenceNode(reference));

  // Handle viewport case
  if (boundariesElement === 'viewport') {
    boundaries = getViewportOffsetRectRelativeToArtbitraryNode(offsetParent, fixedPosition);
  } else {
    // Handle other cases based on DOM element used as boundaries
    var boundariesNode = void 0;
    if (boundariesElement === 'scrollParent') {
      boundariesNode = getScrollParent$1(getParentNode$1(reference));
      if (boundariesNode.nodeName === 'BODY') {
        boundariesNode = popper.ownerDocument.documentElement;
      }
    } else if (boundariesElement === 'window') {
      boundariesNode = popper.ownerDocument.documentElement;
    } else {
      boundariesNode = boundariesElement;
    }

    var offsets = getOffsetRectRelativeToArbitraryNode(boundariesNode, offsetParent, fixedPosition);

    // In case of HTML, we need a different computation
    if (boundariesNode.nodeName === 'HTML' && !isFixed(offsetParent)) {
      var _getWindowSizes = getWindowSizes(popper.ownerDocument),
          height = _getWindowSizes.height,
          width = _getWindowSizes.width;

      boundaries.top += offsets.top - offsets.marginTop;
      boundaries.bottom = height + offsets.top;
      boundaries.left += offsets.left - offsets.marginLeft;
      boundaries.right = width + offsets.left;
    } else {
      // for all the other DOM elements, this one is good
      boundaries = offsets;
    }
  }

  // Add paddings
  padding = padding || 0;
  var isPaddingNumber = typeof padding === 'number';
  boundaries.left += isPaddingNumber ? padding : padding.left || 0;
  boundaries.top += isPaddingNumber ? padding : padding.top || 0;
  boundaries.right -= isPaddingNumber ? padding : padding.right || 0;
  boundaries.bottom -= isPaddingNumber ? padding : padding.bottom || 0;

  return boundaries;
}

function getArea(_ref) {
  var width = _ref.width,
      height = _ref.height;

  return width * height;
}

/**
 * Utility used to transform the `auto` placement to the placement with more
 * available space.
 * @method
 * @memberof Popper.Utils
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function computeAutoPlacement$1(placement, refRect, popper, reference, boundariesElement) {
  var padding = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;

  if (placement.indexOf('auto') === -1) {
    return placement;
  }

  var boundaries = getBoundaries(popper, reference, padding, boundariesElement);

  var rects = {
    top: {
      width: boundaries.width,
      height: refRect.top - boundaries.top
    },
    right: {
      width: boundaries.right - refRect.right,
      height: boundaries.height
    },
    bottom: {
      width: boundaries.width,
      height: boundaries.bottom - refRect.bottom
    },
    left: {
      width: refRect.left - boundaries.left,
      height: boundaries.height
    }
  };

  var sortedAreas = Object.keys(rects).map(function (key) {
    return _extends$e({
      key: key
    }, rects[key], {
      area: getArea(rects[key])
    });
  }).sort(function (a, b) {
    return b.area - a.area;
  });

  var filteredAreas = sortedAreas.filter(function (_ref2) {
    var width = _ref2.width,
        height = _ref2.height;
    return width >= popper.clientWidth && height >= popper.clientHeight;
  });

  var computedPlacement = filteredAreas.length > 0 ? filteredAreas[0].key : sortedAreas[0].key;

  var variation = placement.split('-')[1];

  return computedPlacement + (variation ? '-' + variation : '');
}

/**
 * Get offsets to the reference element
 * @method
 * @memberof Popper.Utils
 * @param {Object} state
 * @param {Element} popper - the popper element
 * @param {Element} reference - the reference element (the popper will be relative to this)
 * @param {Element} fixedPosition - is in fixed position mode
 * @returns {Object} An object containing the offsets which will be applied to the popper
 */
function getReferenceOffsets(state, popper, reference) {
  var fixedPosition = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

  var commonOffsetParent = fixedPosition ? getFixedPositionOffsetParent(popper) : findCommonOffsetParent(popper, getReferenceNode(reference));
  return getOffsetRectRelativeToArbitraryNode(reference, commonOffsetParent, fixedPosition);
}

/**
 * Get the outer sizes of the given element (offset size + margins)
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Object} object containing width and height properties
 */
function getOuterSizes(element) {
  var window = element.ownerDocument.defaultView;
  var styles = window.getComputedStyle(element);
  var x = parseFloat(styles.marginTop || 0) + parseFloat(styles.marginBottom || 0);
  var y = parseFloat(styles.marginLeft || 0) + parseFloat(styles.marginRight || 0);
  var result = {
    width: element.offsetWidth + y,
    height: element.offsetHeight + x
  };
  return result;
}

/**
 * Get the opposite placement of the given one
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement
 * @returns {String} flipped placement
 */
function getOppositePlacement$1(placement) {
  var hash = { left: 'right', right: 'left', bottom: 'top', top: 'bottom' };
  return placement.replace(/left|right|bottom|top/g, function (matched) {
    return hash[matched];
  });
}

/**
 * Get offsets to the popper
 * @method
 * @memberof Popper.Utils
 * @param {Object} position - CSS position the Popper will get applied
 * @param {HTMLElement} popper - the popper element
 * @param {Object} referenceOffsets - the reference offsets (the popper will be relative to this)
 * @param {String} placement - one of the valid placement options
 * @returns {Object} popperOffsets - An object containing the offsets which will be applied to the popper
 */
function getPopperOffsets(popper, referenceOffsets, placement) {
  placement = placement.split('-')[0];

  // Get popper node sizes
  var popperRect = getOuterSizes(popper);

  // Add position, width and height to our offsets object
  var popperOffsets = {
    width: popperRect.width,
    height: popperRect.height
  };

  // depending by the popper placement we have to compute its offsets slightly differently
  var isHoriz = ['right', 'left'].indexOf(placement) !== -1;
  var mainSide = isHoriz ? 'top' : 'left';
  var secondarySide = isHoriz ? 'left' : 'top';
  var measurement = isHoriz ? 'height' : 'width';
  var secondaryMeasurement = !isHoriz ? 'height' : 'width';

  popperOffsets[mainSide] = referenceOffsets[mainSide] + referenceOffsets[measurement] / 2 - popperRect[measurement] / 2;
  if (placement === secondarySide) {
    popperOffsets[secondarySide] = referenceOffsets[secondarySide] - popperRect[secondaryMeasurement];
  } else {
    popperOffsets[secondarySide] = referenceOffsets[getOppositePlacement$1(secondarySide)];
  }

  return popperOffsets;
}

/**
 * Mimics the `find` method of Array
 * @method
 * @memberof Popper.Utils
 * @argument {Array} arr
 * @argument prop
 * @argument value
 * @returns index or -1
 */
function find$1(arr, check) {
  // use native find if supported
  if (Array.prototype.find) {
    return arr.find(check);
  }

  // use `filter` to obtain the same behavior of `find`
  return arr.filter(check)[0];
}

/**
 * Return the index of the matching object
 * @method
 * @memberof Popper.Utils
 * @argument {Array} arr
 * @argument prop
 * @argument value
 * @returns index or -1
 */
function findIndex$2(arr, prop, value) {
  // use native findIndex if supported
  if (Array.prototype.findIndex) {
    return arr.findIndex(function (cur) {
      return cur[prop] === value;
    });
  }

  // use `find` + `indexOf` if `findIndex` isn't supported
  var match = find$1(arr, function (obj) {
    return obj[prop] === value;
  });
  return arr.indexOf(match);
}

/**
 * Loop trough the list of modifiers and run them in order,
 * each of them will then edit the data object.
 * @method
 * @memberof Popper.Utils
 * @param {dataObject} data
 * @param {Array} modifiers
 * @param {String} ends - Optional modifier name used as stopper
 * @returns {dataObject}
 */
function runModifiers(modifiers, data, ends) {
  var modifiersToRun = ends === undefined ? modifiers : modifiers.slice(0, findIndex$2(modifiers, 'name', ends));

  modifiersToRun.forEach(function (modifier) {
    if (modifier['function']) {
      // eslint-disable-line dot-notation
      console.warn('`modifier.function` is deprecated, use `modifier.fn`!');
    }
    var fn = modifier['function'] || modifier.fn; // eslint-disable-line dot-notation
    if (modifier.enabled && isFunction$2(fn)) {
      // Add properties to offsets to make them a complete clientRect object
      // we do this before each modifier to make sure the previous one doesn't
      // mess with these values
      data.offsets.popper = getClientRect(data.offsets.popper);
      data.offsets.reference = getClientRect(data.offsets.reference);

      data = fn(data, modifier);
    }
  });

  return data;
}

/**
 * Updates the position of the popper, computing the new offsets and applying
 * the new style.<br />
 * Prefer `scheduleUpdate` over `update` because of performance reasons.
 * @method
 * @memberof Popper
 */
function update() {
  // if popper is destroyed, don't perform any further update
  if (this.state.isDestroyed) {
    return;
  }

  var data = {
    instance: this,
    styles: {},
    arrowStyles: {},
    attributes: {},
    flipped: false,
    offsets: {}
  };

  // compute reference element offsets
  data.offsets.reference = getReferenceOffsets(this.state, this.popper, this.reference, this.options.positionFixed);

  // compute auto placement, store placement inside the data object,
  // modifiers will be able to edit `placement` if needed
  // and refer to originalPlacement to know the original value
  data.placement = computeAutoPlacement$1(this.options.placement, data.offsets.reference, this.popper, this.reference, this.options.modifiers.flip.boundariesElement, this.options.modifiers.flip.padding);

  // store the computed placement inside `originalPlacement`
  data.originalPlacement = data.placement;

  data.positionFixed = this.options.positionFixed;

  // compute the popper offsets
  data.offsets.popper = getPopperOffsets(this.popper, data.offsets.reference, data.placement);

  data.offsets.popper.position = this.options.positionFixed ? 'fixed' : 'absolute';

  // run the modifiers
  data = runModifiers(this.modifiers, data);

  // the first `update` will call `onCreate` callback
  // the other ones will call `onUpdate` callback
  if (!this.state.isCreated) {
    this.state.isCreated = true;
    this.options.onCreate(data);
  } else {
    this.options.onUpdate(data);
  }
}

/**
 * Helper used to know if the given modifier is enabled.
 * @method
 * @memberof Popper.Utils
 * @returns {Boolean}
 */
function isModifierEnabled(modifiers, modifierName) {
  return modifiers.some(function (_ref) {
    var name = _ref.name,
        enabled = _ref.enabled;
    return enabled && name === modifierName;
  });
}

/**
 * Get the prefixed supported property name
 * @method
 * @memberof Popper.Utils
 * @argument {String} property (camelCase)
 * @returns {String} prefixed property (camelCase or PascalCase, depending on the vendor prefix)
 */
function getSupportedPropertyName(property) {
  var prefixes = [false, 'ms', 'Webkit', 'Moz', 'O'];
  var upperProp = property.charAt(0).toUpperCase() + property.slice(1);

  for (var i = 0; i < prefixes.length; i++) {
    var prefix = prefixes[i];
    var toCheck = prefix ? '' + prefix + upperProp : property;
    if (typeof document.body.style[toCheck] !== 'undefined') {
      return toCheck;
    }
  }
  return null;
}

/**
 * Destroys the popper.
 * @method
 * @memberof Popper
 */
function destroy() {
  this.state.isDestroyed = true;

  // touch DOM only if `applyStyle` modifier is enabled
  if (isModifierEnabled(this.modifiers, 'applyStyle')) {
    this.popper.removeAttribute('x-placement');
    this.popper.style.position = '';
    this.popper.style.top = '';
    this.popper.style.left = '';
    this.popper.style.right = '';
    this.popper.style.bottom = '';
    this.popper.style.willChange = '';
    this.popper.style[getSupportedPropertyName('transform')] = '';
  }

  this.disableEventListeners();

  // remove the popper if user explicitly asked for the deletion on destroy
  // do not use `remove` because IE11 doesn't support it
  if (this.options.removeOnDestroy) {
    this.popper.parentNode.removeChild(this.popper);
  }
  return this;
}

/**
 * Get the window associated with the element
 * @argument {Element} element
 * @returns {Window}
 */
function getWindow$1(element) {
  var ownerDocument = element.ownerDocument;
  return ownerDocument ? ownerDocument.defaultView : window;
}

function attachToScrollParents(scrollParent, event, callback, scrollParents) {
  var isBody = scrollParent.nodeName === 'BODY';
  var target = isBody ? scrollParent.ownerDocument.defaultView : scrollParent;
  target.addEventListener(event, callback, { passive: true });

  if (!isBody) {
    attachToScrollParents(getScrollParent$1(target.parentNode), event, callback, scrollParents);
  }
  scrollParents.push(target);
}

/**
 * Setup needed event listeners used to update the popper position
 * @method
 * @memberof Popper.Utils
 * @private
 */
function setupEventListeners(reference, options, state, updateBound) {
  // Resize event listener on window
  state.updateBound = updateBound;
  getWindow$1(reference).addEventListener('resize', state.updateBound, { passive: true });

  // Scroll event listener on scroll parents
  var scrollElement = getScrollParent$1(reference);
  attachToScrollParents(scrollElement, 'scroll', state.updateBound, state.scrollParents);
  state.scrollElement = scrollElement;
  state.eventsEnabled = true;

  return state;
}

/**
 * It will add resize/scroll events and start recalculating
 * position of the popper element when they are triggered.
 * @method
 * @memberof Popper
 */
function enableEventListeners() {
  if (!this.state.eventsEnabled) {
    this.state = setupEventListeners(this.reference, this.options, this.state, this.scheduleUpdate);
  }
}

/**
 * Remove event listeners used to update the popper position
 * @method
 * @memberof Popper.Utils
 * @private
 */
function removeEventListeners(reference, state) {
  // Remove resize event listener on window
  getWindow$1(reference).removeEventListener('resize', state.updateBound);

  // Remove scroll event listener on scroll parents
  state.scrollParents.forEach(function (target) {
    target.removeEventListener('scroll', state.updateBound);
  });

  // Reset state
  state.updateBound = null;
  state.scrollParents = [];
  state.scrollElement = null;
  state.eventsEnabled = false;
  return state;
}

/**
 * It will remove resize/scroll events and won't recalculate popper position
 * when they are triggered. It also won't trigger `onUpdate` callback anymore,
 * unless you call `update` method manually.
 * @method
 * @memberof Popper
 */
function disableEventListeners() {
  if (this.state.eventsEnabled) {
    cancelAnimationFrame(this.scheduleUpdate);
    this.state = removeEventListeners(this.reference, this.state);
  }
}

/**
 * Tells if a given input is a number
 * @method
 * @memberof Popper.Utils
 * @param {*} input to check
 * @return {Boolean}
 */
function isNumeric(n) {
  return n !== '' && !isNaN(parseFloat(n)) && isFinite(n);
}

/**
 * Set the style to the given popper
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element - Element to apply the style to
 * @argument {Object} styles
 * Object with a list of properties and values which will be applied to the element
 */
function setStyles(element, styles) {
  Object.keys(styles).forEach(function (prop) {
    var unit = '';
    // add unit if the value is numeric and is one of the following
    if (['width', 'height', 'top', 'right', 'bottom', 'left'].indexOf(prop) !== -1 && isNumeric(styles[prop])) {
      unit = 'px';
    }
    element.style[prop] = styles[prop] + unit;
  });
}

/**
 * Set the attributes to the given popper
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element - Element to apply the attributes to
 * @argument {Object} styles
 * Object with a list of properties and values which will be applied to the element
 */
function setAttributes(element, attributes) {
  Object.keys(attributes).forEach(function (prop) {
    var value = attributes[prop];
    if (value !== false) {
      element.setAttribute(prop, attributes[prop]);
    } else {
      element.removeAttribute(prop);
    }
  });
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} data.styles - List of style properties - values to apply to popper element
 * @argument {Object} data.attributes - List of attribute properties - values to apply to popper element
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The same data object
 */
function applyStyle(data) {
  // any property present in `data.styles` will be applied to the popper,
  // in this way we can make the 3rd party modifiers add custom styles to it
  // Be aware, modifiers could override the properties defined in the previous
  // lines of this modifier!
  setStyles(data.instance.popper, data.styles);

  // any property present in `data.attributes` will be applied to the popper,
  // they will be set as HTML attributes of the element
  setAttributes(data.instance.popper, data.attributes);

  // if arrowElement is defined and arrowStyles has some properties
  if (data.arrowElement && Object.keys(data.arrowStyles).length) {
    setStyles(data.arrowElement, data.arrowStyles);
  }

  return data;
}

/**
 * Set the x-placement attribute before everything else because it could be used
 * to add margins to the popper margins needs to be calculated to get the
 * correct popper offsets.
 * @method
 * @memberof Popper.modifiers
 * @param {HTMLElement} reference - The reference element used to position the popper
 * @param {HTMLElement} popper - The HTML element used as popper
 * @param {Object} options - Popper.js options
 */
function applyStyleOnLoad(reference, popper, options, modifierOptions, state) {
  // compute reference element offsets
  var referenceOffsets = getReferenceOffsets(state, popper, reference, options.positionFixed);

  // compute auto placement, store placement inside the data object,
  // modifiers will be able to edit `placement` if needed
  // and refer to originalPlacement to know the original value
  var placement = computeAutoPlacement$1(options.placement, referenceOffsets, popper, reference, options.modifiers.flip.boundariesElement, options.modifiers.flip.padding);

  popper.setAttribute('x-placement', placement);

  // Apply `position` to popper before anything else because
  // without the position applied we can't guarantee correct computations
  setStyles(popper, { position: options.positionFixed ? 'fixed' : 'absolute' });

  return options;
}

/**
 * @function
 * @memberof Popper.Utils
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Boolean} shouldRound - If the offsets should be rounded at all
 * @returns {Object} The popper's position offsets rounded
 *
 * The tale of pixel-perfect positioning. It's still not 100% perfect, but as
 * good as it can be within reason.
 * Discussion here: https://github.com/FezVrasta/popper.js/pull/715
 *
 * Low DPI screens cause a popper to be blurry if not using full pixels (Safari
 * as well on High DPI screens).
 *
 * Firefox prefers no rounding for positioning and does not have blurriness on
 * high DPI screens.
 *
 * Only horizontal placement and left/right values need to be considered.
 */
function getRoundedOffsets(data, shouldRound) {
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;
  var round = Math.round,
      floor = Math.floor;

  var noRound = function noRound(v) {
    return v;
  };

  var referenceWidth = round(reference.width);
  var popperWidth = round(popper.width);

  var isVertical = ['left', 'right'].indexOf(data.placement) !== -1;
  var isVariation = data.placement.indexOf('-') !== -1;
  var sameWidthParity = referenceWidth % 2 === popperWidth % 2;
  var bothOddWidth = referenceWidth % 2 === 1 && popperWidth % 2 === 1;

  var horizontalToInteger = !shouldRound ? noRound : isVertical || isVariation || sameWidthParity ? round : floor;
  var verticalToInteger = !shouldRound ? noRound : round;

  return {
    left: horizontalToInteger(bothOddWidth && !isVariation && shouldRound ? popper.left - 1 : popper.left),
    top: verticalToInteger(popper.top),
    bottom: verticalToInteger(popper.bottom),
    right: horizontalToInteger(popper.right)
  };
}

var isFirefox = isBrowser$1 && /Firefox/i.test(navigator.userAgent);

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function computeStyle(data, options) {
  var x = options.x,
      y = options.y;
  var popper = data.offsets.popper;

  // Remove this legacy support in Popper.js v2

  var legacyGpuAccelerationOption = find$1(data.instance.modifiers, function (modifier) {
    return modifier.name === 'applyStyle';
  }).gpuAcceleration;
  if (legacyGpuAccelerationOption !== undefined) {
    console.warn('WARNING: `gpuAcceleration` option moved to `computeStyle` modifier and will not be supported in future versions of Popper.js!');
  }
  var gpuAcceleration = legacyGpuAccelerationOption !== undefined ? legacyGpuAccelerationOption : options.gpuAcceleration;

  var offsetParent = getOffsetParent$2(data.instance.popper);
  var offsetParentRect = getBoundingClientRect$1(offsetParent);

  // Styles
  var styles = {
    position: popper.position
  };

  var offsets = getRoundedOffsets(data, window.devicePixelRatio < 2 || !isFirefox);

  var sideA = x === 'bottom' ? 'top' : 'bottom';
  var sideB = y === 'right' ? 'left' : 'right';

  // if gpuAcceleration is set to `true` and transform is supported,
  //  we use `translate3d` to apply the position to the popper we
  // automatically use the supported prefixed version if needed
  var prefixedProperty = getSupportedPropertyName('transform');

  // now, let's make a step back and look at this code closely (wtf?)
  // If the content of the popper grows once it's been positioned, it
  // may happen that the popper gets misplaced because of the new content
  // overflowing its reference element
  // To avoid this problem, we provide two options (x and y), which allow
  // the consumer to define the offset origin.
  // If we position a popper on top of a reference element, we can set
  // `x` to `top` to make the popper grow towards its top instead of
  // its bottom.
  var left = void 0,
      top = void 0;
  if (sideA === 'bottom') {
    // when offsetParent is <html> the positioning is relative to the bottom of the screen (excluding the scrollbar)
    // and not the bottom of the html element
    if (offsetParent.nodeName === 'HTML') {
      top = -offsetParent.clientHeight + offsets.bottom;
    } else {
      top = -offsetParentRect.height + offsets.bottom;
    }
  } else {
    top = offsets.top;
  }
  if (sideB === 'right') {
    if (offsetParent.nodeName === 'HTML') {
      left = -offsetParent.clientWidth + offsets.right;
    } else {
      left = -offsetParentRect.width + offsets.right;
    }
  } else {
    left = offsets.left;
  }
  if (gpuAcceleration && prefixedProperty) {
    styles[prefixedProperty] = 'translate3d(' + left + 'px, ' + top + 'px, 0)';
    styles[sideA] = 0;
    styles[sideB] = 0;
    styles.willChange = 'transform';
  } else {
    // othwerise, we use the standard `top`, `left`, `bottom` and `right` properties
    var invertTop = sideA === 'bottom' ? -1 : 1;
    var invertLeft = sideB === 'right' ? -1 : 1;
    styles[sideA] = top * invertTop;
    styles[sideB] = left * invertLeft;
    styles.willChange = sideA + ', ' + sideB;
  }

  // Attributes
  var attributes = {
    'x-placement': data.placement
  };

  // Update `data` attributes, styles and arrowStyles
  data.attributes = _extends$e({}, attributes, data.attributes);
  data.styles = _extends$e({}, styles, data.styles);
  data.arrowStyles = _extends$e({}, data.offsets.arrow, data.arrowStyles);

  return data;
}

/**
 * Helper used to know if the given modifier depends from another one.<br />
 * It checks if the needed modifier is listed and enabled.
 * @method
 * @memberof Popper.Utils
 * @param {Array} modifiers - list of modifiers
 * @param {String} requestingName - name of requesting modifier
 * @param {String} requestedName - name of requested modifier
 * @returns {Boolean}
 */
function isModifierRequired(modifiers, requestingName, requestedName) {
  var requesting = find$1(modifiers, function (_ref) {
    var name = _ref.name;
    return name === requestingName;
  });

  var isRequired = !!requesting && modifiers.some(function (modifier) {
    return modifier.name === requestedName && modifier.enabled && modifier.order < requesting.order;
  });

  if (!isRequired) {
    var _requesting = '`' + requestingName + '`';
    var requested = '`' + requestedName + '`';
    console.warn(requested + ' modifier is required by ' + _requesting + ' modifier in order to work, be sure to include it before ' + _requesting + '!');
  }
  return isRequired;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function arrow$2(data, options) {
  var _data$offsets$arrow;

  // arrow depends on keepTogether in order to work
  if (!isModifierRequired(data.instance.modifiers, 'arrow', 'keepTogether')) {
    return data;
  }

  var arrowElement = options.element;

  // if arrowElement is a string, suppose it's a CSS selector
  if (typeof arrowElement === 'string') {
    arrowElement = data.instance.popper.querySelector(arrowElement);

    // if arrowElement is not found, don't run the modifier
    if (!arrowElement) {
      return data;
    }
  } else {
    // if the arrowElement isn't a query selector we must check that the
    // provided DOM node is child of its popper node
    if (!data.instance.popper.contains(arrowElement)) {
      console.warn('WARNING: `arrow.element` must be child of its popper element!');
      return data;
    }
  }

  var placement = data.placement.split('-')[0];
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var isVertical = ['left', 'right'].indexOf(placement) !== -1;

  var len = isVertical ? 'height' : 'width';
  var sideCapitalized = isVertical ? 'Top' : 'Left';
  var side = sideCapitalized.toLowerCase();
  var altSide = isVertical ? 'left' : 'top';
  var opSide = isVertical ? 'bottom' : 'right';
  var arrowElementSize = getOuterSizes(arrowElement)[len];

  //
  // extends keepTogether behavior making sure the popper and its
  // reference have enough pixels in conjunction
  //

  // top/left side
  if (reference[opSide] - arrowElementSize < popper[side]) {
    data.offsets.popper[side] -= popper[side] - (reference[opSide] - arrowElementSize);
  }
  // bottom/right side
  if (reference[side] + arrowElementSize > popper[opSide]) {
    data.offsets.popper[side] += reference[side] + arrowElementSize - popper[opSide];
  }
  data.offsets.popper = getClientRect(data.offsets.popper);

  // compute center of the popper
  var center = reference[side] + reference[len] / 2 - arrowElementSize / 2;

  // Compute the sideValue using the updated popper offsets
  // take popper margin in account because we don't have this info available
  var css = getStyleComputedProperty(data.instance.popper);
  var popperMarginSide = parseFloat(css['margin' + sideCapitalized]);
  var popperBorderSide = parseFloat(css['border' + sideCapitalized + 'Width']);
  var sideValue = center - data.offsets.popper[side] - popperMarginSide - popperBorderSide;

  // prevent arrowElement from being placed not contiguously to its popper
  sideValue = Math.max(Math.min(popper[len] - arrowElementSize, sideValue), 0);

  data.arrowElement = arrowElement;
  data.offsets.arrow = (_data$offsets$arrow = {}, defineProperty(_data$offsets$arrow, side, Math.round(sideValue)), defineProperty(_data$offsets$arrow, altSide, ''), _data$offsets$arrow);

  return data;
}

/**
 * Get the opposite placement variation of the given one
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement variation
 * @returns {String} flipped placement variation
 */
function getOppositeVariation(variation) {
  if (variation === 'end') {
    return 'start';
  } else if (variation === 'start') {
    return 'end';
  }
  return variation;
}

/**
 * List of accepted placements to use as values of the `placement` option.<br />
 * Valid placements are:
 * - `auto`
 * - `top`
 * - `right`
 * - `bottom`
 * - `left`
 *
 * Each placement can have a variation from this list:
 * - `-start`
 * - `-end`
 *
 * Variations are interpreted easily if you think of them as the left to right
 * written languages. Horizontally (`top` and `bottom`), `start` is left and `end`
 * is right.<br />
 * Vertically (`left` and `right`), `start` is top and `end` is bottom.
 *
 * Some valid examples are:
 * - `top-end` (on top of reference, right aligned)
 * - `right-start` (on right of reference, top aligned)
 * - `bottom` (on bottom, centered)
 * - `auto-end` (on the side with more space available, alignment depends by placement)
 *
 * @static
 * @type {Array}
 * @enum {String}
 * @readonly
 * @method placements
 * @memberof Popper
 */
var placements$2 = ['auto-start', 'auto', 'auto-end', 'top-start', 'top', 'top-end', 'right-start', 'right', 'right-end', 'bottom-end', 'bottom', 'bottom-start', 'left-end', 'left', 'left-start'];

// Get rid of `auto` `auto-start` and `auto-end`
var validPlacements = placements$2.slice(3);

/**
 * Given an initial placement, returns all the subsequent placements
 * clockwise (or counter-clockwise).
 *
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement - A valid placement (it accepts variations)
 * @argument {Boolean} counter - Set to true to walk the placements counterclockwise
 * @returns {Array} placements including their variations
 */
function clockwise(placement) {
  var counter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var index = validPlacements.indexOf(placement);
  var arr = validPlacements.slice(index + 1).concat(validPlacements.slice(0, index));
  return counter ? arr.reverse() : arr;
}

var BEHAVIORS = {
  FLIP: 'flip',
  CLOCKWISE: 'clockwise',
  COUNTERCLOCKWISE: 'counterclockwise'
};

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function flip$3(data, options) {
  // if `inner` modifier is enabled, we can't use the `flip` modifier
  if (isModifierEnabled(data.instance.modifiers, 'inner')) {
    return data;
  }

  if (data.flipped && data.placement === data.originalPlacement) {
    // seems like flip is trying to loop, probably there's not enough space on any of the flippable sides
    return data;
  }

  var boundaries = getBoundaries(data.instance.popper, data.instance.reference, options.padding, options.boundariesElement, data.positionFixed);

  var placement = data.placement.split('-')[0];
  var placementOpposite = getOppositePlacement$1(placement);
  var variation = data.placement.split('-')[1] || '';

  var flipOrder = [];

  switch (options.behavior) {
    case BEHAVIORS.FLIP:
      flipOrder = [placement, placementOpposite];
      break;
    case BEHAVIORS.CLOCKWISE:
      flipOrder = clockwise(placement);
      break;
    case BEHAVIORS.COUNTERCLOCKWISE:
      flipOrder = clockwise(placement, true);
      break;
    default:
      flipOrder = options.behavior;
  }

  flipOrder.forEach(function (step, index) {
    if (placement !== step || flipOrder.length === index + 1) {
      return data;
    }

    placement = data.placement.split('-')[0];
    placementOpposite = getOppositePlacement$1(placement);

    var popperOffsets = data.offsets.popper;
    var refOffsets = data.offsets.reference;

    // using floor because the reference offsets may contain decimals we are not going to consider here
    var floor = Math.floor;
    var overlapsRef = placement === 'left' && floor(popperOffsets.right) > floor(refOffsets.left) || placement === 'right' && floor(popperOffsets.left) < floor(refOffsets.right) || placement === 'top' && floor(popperOffsets.bottom) > floor(refOffsets.top) || placement === 'bottom' && floor(popperOffsets.top) < floor(refOffsets.bottom);

    var overflowsLeft = floor(popperOffsets.left) < floor(boundaries.left);
    var overflowsRight = floor(popperOffsets.right) > floor(boundaries.right);
    var overflowsTop = floor(popperOffsets.top) < floor(boundaries.top);
    var overflowsBottom = floor(popperOffsets.bottom) > floor(boundaries.bottom);

    var overflowsBoundaries = placement === 'left' && overflowsLeft || placement === 'right' && overflowsRight || placement === 'top' && overflowsTop || placement === 'bottom' && overflowsBottom;

    // flip the variation if required
    var isVertical = ['top', 'bottom'].indexOf(placement) !== -1;

    // flips variation if reference element overflows boundaries
    var flippedVariationByRef = !!options.flipVariations && (isVertical && variation === 'start' && overflowsLeft || isVertical && variation === 'end' && overflowsRight || !isVertical && variation === 'start' && overflowsTop || !isVertical && variation === 'end' && overflowsBottom);

    // flips variation if popper content overflows boundaries
    var flippedVariationByContent = !!options.flipVariationsByContent && (isVertical && variation === 'start' && overflowsRight || isVertical && variation === 'end' && overflowsLeft || !isVertical && variation === 'start' && overflowsBottom || !isVertical && variation === 'end' && overflowsTop);

    var flippedVariation = flippedVariationByRef || flippedVariationByContent;

    if (overlapsRef || overflowsBoundaries || flippedVariation) {
      // this boolean to detect any flip loop
      data.flipped = true;

      if (overlapsRef || overflowsBoundaries) {
        placement = flipOrder[index + 1];
      }

      if (flippedVariation) {
        variation = getOppositeVariation(variation);
      }

      data.placement = placement + (variation ? '-' + variation : '');

      // this object contains `position`, we want to preserve it along with
      // any additional property we may add in the future
      data.offsets.popper = _extends$e({}, data.offsets.popper, getPopperOffsets(data.instance.popper, data.offsets.reference, data.placement));

      data = runModifiers(data.instance.modifiers, data, 'flip');
    }
  });
  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function keepTogether(data) {
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var placement = data.placement.split('-')[0];
  var floor = Math.floor;
  var isVertical = ['top', 'bottom'].indexOf(placement) !== -1;
  var side = isVertical ? 'right' : 'bottom';
  var opSide = isVertical ? 'left' : 'top';
  var measurement = isVertical ? 'width' : 'height';

  if (popper[side] < floor(reference[opSide])) {
    data.offsets.popper[opSide] = floor(reference[opSide]) - popper[measurement];
  }
  if (popper[opSide] > floor(reference[side])) {
    data.offsets.popper[opSide] = floor(reference[side]);
  }

  return data;
}

/**
 * Converts a string containing value + unit into a px value number
 * @function
 * @memberof {modifiers~offset}
 * @private
 * @argument {String} str - Value + unit string
 * @argument {String} measurement - `height` or `width`
 * @argument {Object} popperOffsets
 * @argument {Object} referenceOffsets
 * @returns {Number|String}
 * Value in pixels, or original string if no values were extracted
 */
function toValue(str, measurement, popperOffsets, referenceOffsets) {
  // separate value from unit
  var split = str.match(/((?:\-|\+)?\d*\.?\d*)(.*)/);
  var value = +split[1];
  var unit = split[2];

  // If it's not a number it's an operator, I guess
  if (!value) {
    return str;
  }

  if (unit.indexOf('%') === 0) {
    var element = void 0;
    switch (unit) {
      case '%p':
        element = popperOffsets;
        break;
      case '%':
      case '%r':
      default:
        element = referenceOffsets;
    }

    var rect = getClientRect(element);
    return rect[measurement] / 100 * value;
  } else if (unit === 'vh' || unit === 'vw') {
    // if is a vh or vw, we calculate the size based on the viewport
    var size = void 0;
    if (unit === 'vh') {
      size = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
    } else {
      size = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
    }
    return size / 100 * value;
  } else {
    // if is an explicit pixel unit, we get rid of the unit and keep the value
    // if is an implicit unit, it's px, and we return just the value
    return value;
  }
}

/**
 * Parse an `offset` string to extrapolate `x` and `y` numeric offsets.
 * @function
 * @memberof {modifiers~offset}
 * @private
 * @argument {String} offset
 * @argument {Object} popperOffsets
 * @argument {Object} referenceOffsets
 * @argument {String} basePlacement
 * @returns {Array} a two cells array with x and y offsets in numbers
 */
function parseOffset(offset, popperOffsets, referenceOffsets, basePlacement) {
  var offsets = [0, 0];

  // Use height if placement is left or right and index is 0 otherwise use width
  // in this way the first offset will use an axis and the second one
  // will use the other one
  var useHeight = ['right', 'left'].indexOf(basePlacement) !== -1;

  // Split the offset string to obtain a list of values and operands
  // The regex addresses values with the plus or minus sign in front (+10, -20, etc)
  var fragments = offset.split(/(\+|\-)/).map(function (frag) {
    return frag.trim();
  });

  // Detect if the offset string contains a pair of values or a single one
  // they could be separated by comma or space
  var divider = fragments.indexOf(find$1(fragments, function (frag) {
    return frag.search(/,|\s/) !== -1;
  }));

  if (fragments[divider] && fragments[divider].indexOf(',') === -1) {
    console.warn('Offsets separated by white space(s) are deprecated, use a comma (,) instead.');
  }

  // If divider is found, we divide the list of values and operands to divide
  // them by ofset X and Y.
  var splitRegex = /\s*,\s*|\s+/;
  var ops = divider !== -1 ? [fragments.slice(0, divider).concat([fragments[divider].split(splitRegex)[0]]), [fragments[divider].split(splitRegex)[1]].concat(fragments.slice(divider + 1))] : [fragments];

  // Convert the values with units to absolute pixels to allow our computations
  ops = ops.map(function (op, index) {
    // Most of the units rely on the orientation of the popper
    var measurement = (index === 1 ? !useHeight : useHeight) ? 'height' : 'width';
    var mergeWithPrevious = false;
    return op
    // This aggregates any `+` or `-` sign that aren't considered operators
    // e.g.: 10 + +5 => [10, +, +5]
    .reduce(function (a, b) {
      if (a[a.length - 1] === '' && ['+', '-'].indexOf(b) !== -1) {
        a[a.length - 1] = b;
        mergeWithPrevious = true;
        return a;
      } else if (mergeWithPrevious) {
        a[a.length - 1] += b;
        mergeWithPrevious = false;
        return a;
      } else {
        return a.concat(b);
      }
    }, [])
    // Here we convert the string values into number values (in px)
    .map(function (str) {
      return toValue(str, measurement, popperOffsets, referenceOffsets);
    });
  });

  // Loop trough the offsets arrays and execute the operations
  ops.forEach(function (op, index) {
    op.forEach(function (frag, index2) {
      if (isNumeric(frag)) {
        offsets[index] += frag * (op[index2 - 1] === '-' ? -1 : 1);
      }
    });
  });
  return offsets;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @argument {Number|String} options.offset=0
 * The offset value as described in the modifier description
 * @returns {Object} The data object, properly modified
 */
function offset$2(data, _ref) {
  var offset = _ref.offset;
  var placement = data.placement,
      _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var basePlacement = placement.split('-')[0];

  var offsets = void 0;
  if (isNumeric(+offset)) {
    offsets = [+offset, 0];
  } else {
    offsets = parseOffset(offset, popper, reference, basePlacement);
  }

  if (basePlacement === 'left') {
    popper.top += offsets[0];
    popper.left -= offsets[1];
  } else if (basePlacement === 'right') {
    popper.top += offsets[0];
    popper.left += offsets[1];
  } else if (basePlacement === 'top') {
    popper.left += offsets[0];
    popper.top -= offsets[1];
  } else if (basePlacement === 'bottom') {
    popper.left += offsets[0];
    popper.top += offsets[1];
  }

  data.popper = popper;
  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function preventOverflow$2(data, options) {
  var boundariesElement = options.boundariesElement || getOffsetParent$2(data.instance.popper);

  // If offsetParent is the reference element, we really want to
  // go one step up and use the next offsetParent as reference to
  // avoid to make this modifier completely useless and look like broken
  if (data.instance.reference === boundariesElement) {
    boundariesElement = getOffsetParent$2(boundariesElement);
  }

  // NOTE: DOM access here
  // resets the popper's position so that the document size can be calculated excluding
  // the size of the popper element itself
  var transformProp = getSupportedPropertyName('transform');
  var popperStyles = data.instance.popper.style; // assignment to help minification
  var top = popperStyles.top,
      left = popperStyles.left,
      transform = popperStyles[transformProp];

  popperStyles.top = '';
  popperStyles.left = '';
  popperStyles[transformProp] = '';

  var boundaries = getBoundaries(data.instance.popper, data.instance.reference, options.padding, boundariesElement, data.positionFixed);

  // NOTE: DOM access here
  // restores the original style properties after the offsets have been computed
  popperStyles.top = top;
  popperStyles.left = left;
  popperStyles[transformProp] = transform;

  options.boundaries = boundaries;

  var order = options.priority;
  var popper = data.offsets.popper;

  var check = {
    primary: function primary(placement) {
      var value = popper[placement];
      if (popper[placement] < boundaries[placement] && !options.escapeWithReference) {
        value = Math.max(popper[placement], boundaries[placement]);
      }
      return defineProperty({}, placement, value);
    },
    secondary: function secondary(placement) {
      var mainSide = placement === 'right' ? 'left' : 'top';
      var value = popper[mainSide];
      if (popper[placement] > boundaries[placement] && !options.escapeWithReference) {
        value = Math.min(popper[mainSide], boundaries[placement] - (placement === 'right' ? popper.width : popper.height));
      }
      return defineProperty({}, mainSide, value);
    }
  };

  order.forEach(function (placement) {
    var side = ['left', 'top'].indexOf(placement) !== -1 ? 'primary' : 'secondary';
    popper = _extends$e({}, popper, check[side](placement));
  });

  data.offsets.popper = popper;

  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function shift(data) {
  var placement = data.placement;
  var basePlacement = placement.split('-')[0];
  var shiftvariation = placement.split('-')[1];

  // if shift shiftvariation is specified, run the modifier
  if (shiftvariation) {
    var _data$offsets = data.offsets,
        reference = _data$offsets.reference,
        popper = _data$offsets.popper;

    var isVertical = ['bottom', 'top'].indexOf(basePlacement) !== -1;
    var side = isVertical ? 'left' : 'top';
    var measurement = isVertical ? 'width' : 'height';

    var shiftOffsets = {
      start: defineProperty({}, side, reference[side]),
      end: defineProperty({}, side, reference[side] + reference[measurement] - popper[measurement])
    };

    data.offsets.popper = _extends$e({}, popper, shiftOffsets[shiftvariation]);
  }

  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function hide$2(data) {
  if (!isModifierRequired(data.instance.modifiers, 'hide', 'preventOverflow')) {
    return data;
  }

  var refRect = data.offsets.reference;
  var bound = find$1(data.instance.modifiers, function (modifier) {
    return modifier.name === 'preventOverflow';
  }).boundaries;

  if (refRect.bottom < bound.top || refRect.left > bound.right || refRect.top > bound.bottom || refRect.right < bound.left) {
    // Avoid unnecessary DOM access if visibility hasn't changed
    if (data.hide === true) {
      return data;
    }

    data.hide = true;
    data.attributes['x-out-of-boundaries'] = '';
  } else {
    // Avoid unnecessary DOM access if visibility hasn't changed
    if (data.hide === false) {
      return data;
    }

    data.hide = false;
    data.attributes['x-out-of-boundaries'] = false;
  }

  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function inner(data) {
  var placement = data.placement;
  var basePlacement = placement.split('-')[0];
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var isHoriz = ['left', 'right'].indexOf(basePlacement) !== -1;

  var subtractLength = ['top', 'left'].indexOf(basePlacement) === -1;

  popper[isHoriz ? 'left' : 'top'] = reference[basePlacement] - (subtractLength ? popper[isHoriz ? 'width' : 'height'] : 0);

  data.placement = getOppositePlacement$1(placement);
  data.offsets.popper = getClientRect(popper);

  return data;
}

/**
 * Modifier function, each modifier can have a function of this type assigned
 * to its `fn` property.<br />
 * These functions will be called on each update, this means that you must
 * make sure they are performant enough to avoid performance bottlenecks.
 *
 * @function ModifierFn
 * @argument {dataObject} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {dataObject} The data object, properly modified
 */

/**
 * Modifiers are plugins used to alter the behavior of your poppers.<br />
 * Popper.js uses a set of 9 modifiers to provide all the basic functionalities
 * needed by the library.
 *
 * Usually you don't want to override the `order`, `fn` and `onLoad` props.
 * All the other properties are configurations that could be tweaked.
 * @namespace modifiers
 */
var modifiers = {
  /**
   * Modifier used to shift the popper on the start or end of its reference
   * element.<br />
   * It will read the variation of the `placement` property.<br />
   * It can be one either `-end` or `-start`.
   * @memberof modifiers
   * @inner
   */
  shift: {
    /** @prop {number} order=100 - Index used to define the order of execution */
    order: 100,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: shift
  },

  /**
   * The `offset` modifier can shift your popper on both its axis.
   *
   * It accepts the following units:
   * - `px` or unit-less, interpreted as pixels
   * - `%` or `%r`, percentage relative to the length of the reference element
   * - `%p`, percentage relative to the length of the popper element
   * - `vw`, CSS viewport width unit
   * - `vh`, CSS viewport height unit
   *
   * For length is intended the main axis relative to the placement of the popper.<br />
   * This means that if the placement is `top` or `bottom`, the length will be the
   * `width`. In case of `left` or `right`, it will be the `height`.
   *
   * You can provide a single value (as `Number` or `String`), or a pair of values
   * as `String` divided by a comma or one (or more) white spaces.<br />
   * The latter is a deprecated method because it leads to confusion and will be
   * removed in v2.<br />
   * Additionally, it accepts additions and subtractions between different units.
   * Note that multiplications and divisions aren't supported.
   *
   * Valid examples are:
   * ```
   * 10
   * '10%'
   * '10, 10'
   * '10%, 10'
   * '10 + 10%'
   * '10 - 5vh + 3%'
   * '-10px + 5vh, 5px - 6%'
   * ```
   * > **NB**: If you desire to apply offsets to your poppers in a way that may make them overlap
   * > with their reference element, unfortunately, you will have to disable the `flip` modifier.
   * > You can read more on this at this [issue](https://github.com/FezVrasta/popper.js/issues/373).
   *
   * @memberof modifiers
   * @inner
   */
  offset: {
    /** @prop {number} order=200 - Index used to define the order of execution */
    order: 200,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: offset$2,
    /** @prop {Number|String} offset=0
     * The offset value as described in the modifier description
     */
    offset: 0
  },

  /**
   * Modifier used to prevent the popper from being positioned outside the boundary.
   *
   * A scenario exists where the reference itself is not within the boundaries.<br />
   * We can say it has "escaped the boundaries" — or just "escaped".<br />
   * In this case we need to decide whether the popper should either:
   *
   * - detach from the reference and remain "trapped" in the boundaries, or
   * - if it should ignore the boundary and "escape with its reference"
   *
   * When `escapeWithReference` is set to`true` and reference is completely
   * outside its boundaries, the popper will overflow (or completely leave)
   * the boundaries in order to remain attached to the edge of the reference.
   *
   * @memberof modifiers
   * @inner
   */
  preventOverflow: {
    /** @prop {number} order=300 - Index used to define the order of execution */
    order: 300,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: preventOverflow$2,
    /**
     * @prop {Array} [priority=['left','right','top','bottom']]
     * Popper will try to prevent overflow following these priorities by default,
     * then, it could overflow on the left and on top of the `boundariesElement`
     */
    priority: ['left', 'right', 'top', 'bottom'],
    /**
     * @prop {number} padding=5
     * Amount of pixel used to define a minimum distance between the boundaries
     * and the popper. This makes sure the popper always has a little padding
     * between the edges of its container
     */
    padding: 5,
    /**
     * @prop {String|HTMLElement} boundariesElement='scrollParent'
     * Boundaries used by the modifier. Can be `scrollParent`, `window`,
     * `viewport` or any DOM element.
     */
    boundariesElement: 'scrollParent'
  },

  /**
   * Modifier used to make sure the reference and its popper stay near each other
   * without leaving any gap between the two. Especially useful when the arrow is
   * enabled and you want to ensure that it points to its reference element.
   * It cares only about the first axis. You can still have poppers with margin
   * between the popper and its reference element.
   * @memberof modifiers
   * @inner
   */
  keepTogether: {
    /** @prop {number} order=400 - Index used to define the order of execution */
    order: 400,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: keepTogether
  },

  /**
   * This modifier is used to move the `arrowElement` of the popper to make
   * sure it is positioned between the reference element and its popper element.
   * It will read the outer size of the `arrowElement` node to detect how many
   * pixels of conjunction are needed.
   *
   * It has no effect if no `arrowElement` is provided.
   * @memberof modifiers
   * @inner
   */
  arrow: {
    /** @prop {number} order=500 - Index used to define the order of execution */
    order: 500,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: arrow$2,
    /** @prop {String|HTMLElement} element='[x-arrow]' - Selector or node used as arrow */
    element: '[x-arrow]'
  },

  /**
   * Modifier used to flip the popper's placement when it starts to overlap its
   * reference element.
   *
   * Requires the `preventOverflow` modifier before it in order to work.
   *
   * **NOTE:** this modifier will interrupt the current update cycle and will
   * restart it if it detects the need to flip the placement.
   * @memberof modifiers
   * @inner
   */
  flip: {
    /** @prop {number} order=600 - Index used to define the order of execution */
    order: 600,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: flip$3,
    /**
     * @prop {String|Array} behavior='flip'
     * The behavior used to change the popper's placement. It can be one of
     * `flip`, `clockwise`, `counterclockwise` or an array with a list of valid
     * placements (with optional variations)
     */
    behavior: 'flip',
    /**
     * @prop {number} padding=5
     * The popper will flip if it hits the edges of the `boundariesElement`
     */
    padding: 5,
    /**
     * @prop {String|HTMLElement} boundariesElement='viewport'
     * The element which will define the boundaries of the popper position.
     * The popper will never be placed outside of the defined boundaries
     * (except if `keepTogether` is enabled)
     */
    boundariesElement: 'viewport',
    /**
     * @prop {Boolean} flipVariations=false
     * The popper will switch placement variation between `-start` and `-end` when
     * the reference element overlaps its boundaries.
     *
     * The original placement should have a set variation.
     */
    flipVariations: false,
    /**
     * @prop {Boolean} flipVariationsByContent=false
     * The popper will switch placement variation between `-start` and `-end` when
     * the popper element overlaps its reference boundaries.
     *
     * The original placement should have a set variation.
     */
    flipVariationsByContent: false
  },

  /**
   * Modifier used to make the popper flow toward the inner of the reference element.
   * By default, when this modifier is disabled, the popper will be placed outside
   * the reference element.
   * @memberof modifiers
   * @inner
   */
  inner: {
    /** @prop {number} order=700 - Index used to define the order of execution */
    order: 700,
    /** @prop {Boolean} enabled=false - Whether the modifier is enabled or not */
    enabled: false,
    /** @prop {ModifierFn} */
    fn: inner
  },

  /**
   * Modifier used to hide the popper when its reference element is outside of the
   * popper boundaries. It will set a `x-out-of-boundaries` attribute which can
   * be used to hide with a CSS selector the popper when its reference is
   * out of boundaries.
   *
   * Requires the `preventOverflow` modifier before it in order to work.
   * @memberof modifiers
   * @inner
   */
  hide: {
    /** @prop {number} order=800 - Index used to define the order of execution */
    order: 800,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: hide$2
  },

  /**
   * Computes the style that will be applied to the popper element to gets
   * properly positioned.
   *
   * Note that this modifier will not touch the DOM, it just prepares the styles
   * so that `applyStyle` modifier can apply it. This separation is useful
   * in case you need to replace `applyStyle` with a custom implementation.
   *
   * This modifier has `850` as `order` value to maintain backward compatibility
   * with previous versions of Popper.js. Expect the modifiers ordering method
   * to change in future major versions of the library.
   *
   * @memberof modifiers
   * @inner
   */
  computeStyle: {
    /** @prop {number} order=850 - Index used to define the order of execution */
    order: 850,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: computeStyle,
    /**
     * @prop {Boolean} gpuAcceleration=true
     * If true, it uses the CSS 3D transformation to position the popper.
     * Otherwise, it will use the `top` and `left` properties
     */
    gpuAcceleration: true,
    /**
     * @prop {string} [x='bottom']
     * Where to anchor the X axis (`bottom` or `top`). AKA X offset origin.
     * Change this if your popper should grow in a direction different from `bottom`
     */
    x: 'bottom',
    /**
     * @prop {string} [x='left']
     * Where to anchor the Y axis (`left` or `right`). AKA Y offset origin.
     * Change this if your popper should grow in a direction different from `right`
     */
    y: 'right'
  },

  /**
   * Applies the computed styles to the popper element.
   *
   * All the DOM manipulations are limited to this modifier. This is useful in case
   * you want to integrate Popper.js inside a framework or view library and you
   * want to delegate all the DOM manipulations to it.
   *
   * Note that if you disable this modifier, you must make sure the popper element
   * has its position set to `absolute` before Popper.js can do its work!
   *
   * Just disable this modifier and define your own to achieve the desired effect.
   *
   * @memberof modifiers
   * @inner
   */
  applyStyle: {
    /** @prop {number} order=900 - Index used to define the order of execution */
    order: 900,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: applyStyle,
    /** @prop {Function} */
    onLoad: applyStyleOnLoad,
    /**
     * @deprecated since version 1.10.0, the property moved to `computeStyle` modifier
     * @prop {Boolean} gpuAcceleration=true
     * If true, it uses the CSS 3D transformation to position the popper.
     * Otherwise, it will use the `top` and `left` properties
     */
    gpuAcceleration: undefined
  }
};

/**
 * The `dataObject` is an object containing all the information used by Popper.js.
 * This object is passed to modifiers and to the `onCreate` and `onUpdate` callbacks.
 * @name dataObject
 * @property {Object} data.instance The Popper.js instance
 * @property {String} data.placement Placement applied to popper
 * @property {String} data.originalPlacement Placement originally defined on init
 * @property {Boolean} data.flipped True if popper has been flipped by flip modifier
 * @property {Boolean} data.hide True if the reference element is out of boundaries, useful to know when to hide the popper
 * @property {HTMLElement} data.arrowElement Node used as arrow by arrow modifier
 * @property {Object} data.styles Any CSS property defined here will be applied to the popper. It expects the JavaScript nomenclature (eg. `marginBottom`)
 * @property {Object} data.arrowStyles Any CSS property defined here will be applied to the popper arrow. It expects the JavaScript nomenclature (eg. `marginBottom`)
 * @property {Object} data.boundaries Offsets of the popper boundaries
 * @property {Object} data.offsets The measurements of popper, reference and arrow elements
 * @property {Object} data.offsets.popper `top`, `left`, `width`, `height` values
 * @property {Object} data.offsets.reference `top`, `left`, `width`, `height` values
 * @property {Object} data.offsets.arrow] `top` and `left` offsets, only one of them will be different from 0
 */

/**
 * Default options provided to Popper.js constructor.<br />
 * These can be overridden using the `options` argument of Popper.js.<br />
 * To override an option, simply pass an object with the same
 * structure of the `options` object, as the 3rd argument. For example:
 * ```
 * new Popper(ref, pop, {
 *   modifiers: {
 *     preventOverflow: { enabled: false }
 *   }
 * })
 * ```
 * @type {Object}
 * @static
 * @memberof Popper
 */
var Defaults = {
  /**
   * Popper's placement.
   * @prop {Popper.placements} placement='bottom'
   */
  placement: 'bottom',

  /**
   * Set this to true if you want popper to position it self in 'fixed' mode
   * @prop {Boolean} positionFixed=false
   */
  positionFixed: false,

  /**
   * Whether events (resize, scroll) are initially enabled.
   * @prop {Boolean} eventsEnabled=true
   */
  eventsEnabled: true,

  /**
   * Set to true if you want to automatically remove the popper when
   * you call the `destroy` method.
   * @prop {Boolean} removeOnDestroy=false
   */
  removeOnDestroy: false,

  /**
   * Callback called when the popper is created.<br />
   * By default, it is set to no-op.<br />
   * Access Popper.js instance with `data.instance`.
   * @prop {onCreate}
   */
  onCreate: function onCreate() {},

  /**
   * Callback called when the popper is updated. This callback is not called
   * on the initialization/creation of the popper, but only on subsequent
   * updates.<br />
   * By default, it is set to no-op.<br />
   * Access Popper.js instance with `data.instance`.
   * @prop {onUpdate}
   */
  onUpdate: function onUpdate() {},

  /**
   * List of modifiers used to modify the offsets before they are applied to the popper.
   * They provide most of the functionalities of Popper.js.
   * @prop {modifiers}
   */
  modifiers: modifiers
};

/**
 * @callback onCreate
 * @param {dataObject} data
 */

/**
 * @callback onUpdate
 * @param {dataObject} data
 */

// Utils
// Methods
var Popper$2 = function () {
  /**
   * Creates a new Popper.js instance.
   * @class Popper
   * @param {Element|referenceObject} reference - The reference element used to position the popper
   * @param {Element} popper - The HTML / XML element used as the popper
   * @param {Object} options - Your custom options to override the ones defined in [Defaults](#defaults)
   * @return {Object} instance - The generated Popper.js instance
   */
  function Popper(reference, popper) {
    var _this = this;

    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    classCallCheck(this, Popper);

    this.scheduleUpdate = function () {
      return requestAnimationFrame(_this.update);
    };

    // make update() debounced, so that it only runs at most once-per-tick
    this.update = debounce$3(this.update.bind(this));

    // with {} we create a new object with the options inside it
    this.options = _extends$e({}, Popper.Defaults, options);

    // init state
    this.state = {
      isDestroyed: false,
      isCreated: false,
      scrollParents: []
    };

    // get reference and popper elements (allow jQuery wrappers)
    this.reference = reference && reference.jquery ? reference[0] : reference;
    this.popper = popper && popper.jquery ? popper[0] : popper;

    // Deep merge modifiers options
    this.options.modifiers = {};
    Object.keys(_extends$e({}, Popper.Defaults.modifiers, options.modifiers)).forEach(function (name) {
      _this.options.modifiers[name] = _extends$e({}, Popper.Defaults.modifiers[name] || {}, options.modifiers ? options.modifiers[name] : {});
    });

    // Refactoring modifiers' list (Object => Array)
    this.modifiers = Object.keys(this.options.modifiers).map(function (name) {
      return _extends$e({
        name: name
      }, _this.options.modifiers[name]);
    })
    // sort the modifiers by order
    .sort(function (a, b) {
      return a.order - b.order;
    });

    // modifiers have the ability to execute arbitrary code when Popper.js get inited
    // such code is executed in the same order of its modifier
    // they could add new properties to their options configuration
    // BE AWARE: don't add options to `options.modifiers.name` but to `modifierOptions`!
    this.modifiers.forEach(function (modifierOptions) {
      if (modifierOptions.enabled && isFunction$2(modifierOptions.onLoad)) {
        modifierOptions.onLoad(_this.reference, _this.popper, _this.options, modifierOptions, _this.state);
      }
    });

    // fire the first update to position the popper in the right place
    this.update();

    var eventsEnabled = this.options.eventsEnabled;
    if (eventsEnabled) {
      // setup event listeners, they will take care of update the position in specific situations
      this.enableEventListeners();
    }

    this.state.eventsEnabled = eventsEnabled;
  }

  // We can't use class properties because they don't get listed in the
  // class prototype and break stuff like Sinon stubs


  createClass(Popper, [{
    key: 'update',
    value: function update$$1() {
      return update.call(this);
    }
  }, {
    key: 'destroy',
    value: function destroy$$1() {
      return destroy.call(this);
    }
  }, {
    key: 'enableEventListeners',
    value: function enableEventListeners$$1() {
      return enableEventListeners.call(this);
    }
  }, {
    key: 'disableEventListeners',
    value: function disableEventListeners$$1() {
      return disableEventListeners.call(this);
    }

    /**
     * Schedules an update. It will run on the next UI update available.
     * @method scheduleUpdate
     * @memberof Popper
     */


    /**
     * Collection of utilities useful when writing custom modifiers.
     * Starting from version 1.7, this method is available only if you
     * include `popper-utils.js` before `popper.js`.
     *
     * **DEPRECATION**: This way to access PopperUtils is deprecated
     * and will be removed in v2! Use the PopperUtils module directly instead.
     * Due to the high instability of the methods contained in Utils, we can't
     * guarantee them to follow semver. Use them at your own risk!
     * @static
     * @private
     * @type {Object}
     * @deprecated since version 1.8
     * @member Utils
     * @memberof Popper
     */

  }]);
  return Popper;
}();

/**
 * The `referenceObject` is an object that provides an interface compatible with Popper.js
 * and lets you use it as replacement of a real DOM node.<br />
 * You can use this method to position a popper relatively to a set of coordinates
 * in case you don't have a DOM node to use as reference.
 *
 * ```
 * new Popper(referenceObject, popperNode);
 * ```
 *
 * NB: This feature isn't supported in Internet Explorer 10.
 * @name referenceObject
 * @property {Function} data.getBoundingClientRect
 * A function that returns a set of coordinates compatible with the native `getBoundingClientRect` method.
 * @property {number} data.clientWidth
 * An ES6 getter that will return the width of the virtual reference element.
 * @property {number} data.clientHeight
 * An ES6 getter that will return the height of the virtual reference element.
 */


Popper$2.Utils = (typeof window !== 'undefined' ? window : global).PopperUtils;
Popper$2.placements = placements$2;
Popper$2.Defaults = Defaults;

var PopperJs = Popper$2;function flipPlacement(placement, theme) {
  var direction = theme && theme.direction || 'ltr';

  if (direction === 'ltr') {
    return placement;
  }

  switch (placement) {
    case 'bottom-end':
      return 'bottom-start';

    case 'bottom-start':
      return 'bottom-end';

    case 'top-end':
      return 'top-start';

    case 'top-start':
      return 'top-end';

    default:
      return placement;
  }
}

function getAnchorEl(anchorEl) {
  return typeof anchorEl === 'function' ? anchorEl() : anchorEl;
}

var useEnhancedEffect = typeof window !== 'undefined' ? React__namespace.useLayoutEffect : React__namespace.useEffect;
var defaultPopperOptions = {};
/**
 * Poppers rely on the 3rd party library [Popper.js](https://popper.js.org/docs/v1/) for positioning.
 */

var Popper = /*#__PURE__*/React__namespace.forwardRef(function Popper(props, ref) {
  var anchorEl = props.anchorEl,
      children = props.children,
      container = props.container,
      _props$disablePortal = props.disablePortal,
      disablePortal = _props$disablePortal === void 0 ? false : _props$disablePortal,
      _props$keepMounted = props.keepMounted,
      keepMounted = _props$keepMounted === void 0 ? false : _props$keepMounted,
      modifiers = props.modifiers,
      open = props.open,
      _props$placement = props.placement,
      initialPlacement = _props$placement === void 0 ? 'bottom' : _props$placement,
      _props$popperOptions = props.popperOptions,
      popperOptions = _props$popperOptions === void 0 ? defaultPopperOptions : _props$popperOptions,
      popperRefProp = props.popperRef,
      style = props.style,
      _props$transition = props.transition,
      transition = _props$transition === void 0 ? false : _props$transition,
      other = _objectWithoutProperties$4(props, ["anchorEl", "children", "container", "disablePortal", "keepMounted", "modifiers", "open", "placement", "popperOptions", "popperRef", "style", "transition"]);

  var tooltipRef = React__namespace.useRef(null);
  var ownRef = useForkRef(tooltipRef, ref);
  var popperRef = React__namespace.useRef(null);
  var handlePopperRef = useForkRef(popperRef, popperRefProp);
  var handlePopperRefRef = React__namespace.useRef(handlePopperRef);
  useEnhancedEffect(function () {
    handlePopperRefRef.current = handlePopperRef;
  }, [handlePopperRef]);
  React__namespace.useImperativeHandle(popperRefProp, function () {
    return popperRef.current;
  }, []);

  var _React$useState = React__namespace.useState(true),
      exited = _React$useState[0],
      setExited = _React$useState[1];

  var theme = useTheme$1();
  var rtlPlacement = flipPlacement(initialPlacement, theme);
  /**
   * placement initialized from prop but can change during lifetime if modifiers.flip.
   * modifiers.flip is essentially a flip for controlled/uncontrolled behavior
   */

  var _React$useState2 = React__namespace.useState(rtlPlacement),
      placement = _React$useState2[0],
      setPlacement = _React$useState2[1];

  React__namespace.useEffect(function () {
    if (popperRef.current) {
      popperRef.current.update();
    }
  });
  var handleOpen = React__namespace.useCallback(function () {
    if (!tooltipRef.current || !anchorEl || !open) {
      return;
    }

    if (popperRef.current) {
      popperRef.current.destroy();
      handlePopperRefRef.current(null);
    }

    var handlePopperUpdate = function handlePopperUpdate(data) {
      setPlacement(data.placement);
    };

    getAnchorEl(anchorEl);

    var popper = new PopperJs(getAnchorEl(anchorEl), tooltipRef.current, _extends$f({
      placement: rtlPlacement
    }, popperOptions, {
      modifiers: _extends$f({}, disablePortal ? {} : {
        // It's using scrollParent by default, we can use the viewport when using a portal.
        preventOverflow: {
          boundariesElement: 'window'
        }
      }, modifiers, popperOptions.modifiers),
      // We could have been using a custom modifier like react-popper is doing.
      // But it seems this is the best public API for this use case.
      onCreate: createChainedFunction(handlePopperUpdate, popperOptions.onCreate),
      onUpdate: createChainedFunction(handlePopperUpdate, popperOptions.onUpdate)
    }));
    handlePopperRefRef.current(popper);
  }, [anchorEl, disablePortal, modifiers, open, rtlPlacement, popperOptions]);
  var handleRef = React__namespace.useCallback(function (node) {
    setRef(ownRef, node);
    handleOpen();
  }, [ownRef, handleOpen]);

  var handleEnter = function handleEnter() {
    setExited(false);
  };

  var handleClose = function handleClose() {
    if (!popperRef.current) {
      return;
    }

    popperRef.current.destroy();
    handlePopperRefRef.current(null);
  };

  var handleExited = function handleExited() {
    setExited(true);
    handleClose();
  };

  React__namespace.useEffect(function () {
    return function () {
      handleClose();
    };
  }, []);
  React__namespace.useEffect(function () {
    if (!open && !transition) {
      // Otherwise handleExited will call this.
      handleClose();
    }
  }, [open, transition]);

  if (!keepMounted && !open && (!transition || exited)) {
    return null;
  }

  var childProps = {
    placement: placement
  };

  if (transition) {
    childProps.TransitionProps = {
      in: open,
      onEnter: handleEnter,
      onExited: handleExited
    };
  }

  return /*#__PURE__*/React__namespace.createElement(Portal$4, {
    disablePortal: disablePortal,
    container: container
  }, /*#__PURE__*/React__namespace.createElement("div", _extends$f({
    ref: handleRef,
    role: "tooltip"
  }, other, {
    style: _extends$f({
      // Prevents scroll issue, waiting for Popper.js to add this style once initiated.
      position: 'fixed',
      // Fix Popper.js display issue
      top: 0,
      left: 0,
      display: !open && keepMounted && !transition ? 'none' : null
    }, style)
  }), typeof children === 'function' ? children(childProps) : children));
});
var Popper$1 = Popper;function _inherits$d(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}function _possibleConstructorReturn$d(self, call) {
  if (call && (_typeof$2(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}function areEqualValues(a, b) {
  if (_typeof$2(b) === 'object' && b !== null) {
    return a === b;
  }

  return String(a) === String(b);
}

function isEmpty$1(display) {
  return display == null || typeof display === 'string' && !display.trim();
}
/**
 * @ignore - internal component.
 */


var SelectInput$1 = /*#__PURE__*/React__namespace.forwardRef(function SelectInput(props, ref) {
  var ariaLabel = props['aria-label'],
      autoFocus = props.autoFocus,
      autoWidth = props.autoWidth,
      children = props.children,
      classes = props.classes,
      className = props.className,
      defaultValue = props.defaultValue,
      disabled = props.disabled,
      displayEmpty = props.displayEmpty,
      IconComponent = props.IconComponent,
      inputRefProp = props.inputRef,
      labelId = props.labelId,
      _props$MenuProps = props.MenuProps,
      MenuProps = _props$MenuProps === void 0 ? {} : _props$MenuProps,
      multiple = props.multiple,
      name = props.name,
      onBlur = props.onBlur,
      onChange = props.onChange,
      onClose = props.onClose,
      onFocus = props.onFocus,
      onOpen = props.onOpen,
      openProp = props.open,
      readOnly = props.readOnly,
      renderValue = props.renderValue,
      _props$SelectDisplayP = props.SelectDisplayProps,
      SelectDisplayProps = _props$SelectDisplayP === void 0 ? {} : _props$SelectDisplayP,
      tabIndexProp = props.tabIndex;
      props.type;
      var valueProp = props.value,
      _props$variant = props.variant,
      variant = _props$variant === void 0 ? 'standard' : _props$variant,
      other = _objectWithoutProperties$4(props, ["aria-label", "autoFocus", "autoWidth", "children", "classes", "className", "defaultValue", "disabled", "displayEmpty", "IconComponent", "inputRef", "labelId", "MenuProps", "multiple", "name", "onBlur", "onChange", "onClose", "onFocus", "onOpen", "open", "readOnly", "renderValue", "SelectDisplayProps", "tabIndex", "type", "value", "variant"]);

  var _useControlled = useControlled({
    controlled: valueProp,
    default: defaultValue,
    name: 'Select'
  }),
      _useControlled2 = _slicedToArray(_useControlled, 2),
      value = _useControlled2[0],
      setValue = _useControlled2[1];

  var inputRef = React__namespace.useRef(null);

  var _React$useState = React__namespace.useState(null),
      displayNode = _React$useState[0],
      setDisplayNode = _React$useState[1];

  var _React$useRef = React__namespace.useRef(openProp != null),
      isOpenControlled = _React$useRef.current;

  var _React$useState2 = React__namespace.useState(),
      menuMinWidthState = _React$useState2[0],
      setMenuMinWidthState = _React$useState2[1];

  var _React$useState3 = React__namespace.useState(false),
      openState = _React$useState3[0],
      setOpenState = _React$useState3[1];

  var handleRef = useForkRef(ref, inputRefProp);
  React__namespace.useImperativeHandle(handleRef, function () {
    return {
      focus: function focus() {
        displayNode.focus();
      },
      node: inputRef.current,
      value: value
    };
  }, [displayNode, value]);
  React__namespace.useEffect(function () {
    if (autoFocus && displayNode) {
      displayNode.focus();
    }
  }, [autoFocus, displayNode]);
  React__namespace.useEffect(function () {
    if (displayNode) {
      var label = ownerDocument(displayNode).getElementById(labelId);

      if (label) {
        var handler = function handler() {
          if (getSelection().isCollapsed) {
            displayNode.focus();
          }
        };

        label.addEventListener('click', handler);
        return function () {
          label.removeEventListener('click', handler);
        };
      }
    }

    return undefined;
  }, [labelId, displayNode]);

  var update = function update(open, event) {
    if (open) {
      if (onOpen) {
        onOpen(event);
      }
    } else if (onClose) {
      onClose(event);
    }

    if (!isOpenControlled) {
      setMenuMinWidthState(autoWidth ? null : displayNode.clientWidth);
      setOpenState(open);
    }
  };

  var handleMouseDown = function handleMouseDown(event) {
    // Ignore everything but left-click
    if (event.button !== 0) {
      return;
    } // Hijack the default focus behavior.


    event.preventDefault();
    displayNode.focus();
    update(true, event);
  };

  var handleClose = function handleClose(event) {
    update(false, event);
  };

  var childrenArray = React__namespace.Children.toArray(children); // Support autofill.

  var handleChange = function handleChange(event) {
    var index = childrenArray.map(function (child) {
      return child.props.value;
    }).indexOf(event.target.value);

    if (index === -1) {
      return;
    }

    var child = childrenArray[index];
    setValue(child.props.value);

    if (onChange) {
      onChange(event, child);
    }
  };

  var handleItemClick = function handleItemClick(child) {
    return function (event) {
      if (!multiple) {
        update(false, event);
      }

      var newValue;

      if (multiple) {
        newValue = Array.isArray(value) ? value.slice() : [];
        var itemIndex = value.indexOf(child.props.value);

        if (itemIndex === -1) {
          newValue.push(child.props.value);
        } else {
          newValue.splice(itemIndex, 1);
        }
      } else {
        newValue = child.props.value;
      }

      if (child.props.onClick) {
        child.props.onClick(event);
      }

      if (value === newValue) {
        return;
      }

      setValue(newValue);

      if (onChange) {
        event.persist(); // Preact support, target is read only property on a native event.

        Object.defineProperty(event, 'target', {
          writable: true,
          value: {
            value: newValue,
            name: name
          }
        });
        onChange(event, child);
      }
    };
  };

  var handleKeyDown = function handleKeyDown(event) {
    if (!readOnly) {
      var validKeys = [' ', 'ArrowUp', 'ArrowDown', // The native select doesn't respond to enter on MacOS, but it's recommended by
      // https://www.w3.org/TR/wai-aria-practices/examples/listbox/listbox-collapsible.html
      'Enter'];

      if (validKeys.indexOf(event.key) !== -1) {
        event.preventDefault();
        update(true, event);
      }
    }
  };

  var open = displayNode !== null && (isOpenControlled ? openProp : openState);

  var handleBlur = function handleBlur(event) {
    // if open event.stopImmediatePropagation
    if (!open && onBlur) {
      event.persist(); // Preact support, target is read only property on a native event.

      Object.defineProperty(event, 'target', {
        writable: true,
        value: {
          value: value,
          name: name
        }
      });
      onBlur(event);
    }
  };

  delete other['aria-invalid'];
  var display;
  var displaySingle;
  var displayMultiple = [];
  var computeDisplay = false;

  if (isFilled({
    value: value
  }) || displayEmpty) {
    if (renderValue) {
      display = renderValue(value);
    } else {
      computeDisplay = true;
    }
  }

  var items = childrenArray.map(function (child) {
    if (! /*#__PURE__*/React__namespace.isValidElement(child)) {
      return null;
    }

    var selected;

    if (multiple) {
      if (!Array.isArray(value)) {
        throw new Error(formatMuiErrorMessage(2));
      }

      selected = value.some(function (v) {
        return areEqualValues(v, child.props.value);
      });

      if (selected && computeDisplay) {
        displayMultiple.push(child.props.children);
      }
    } else {
      selected = areEqualValues(value, child.props.value);

      if (selected && computeDisplay) {
        displaySingle = child.props.children;
      }
    }

    return /*#__PURE__*/React__namespace.cloneElement(child, {
      'aria-selected': selected ? 'true' : undefined,
      onClick: handleItemClick(child),
      onKeyUp: function onKeyUp(event) {
        if (event.key === ' ') {
          // otherwise our MenuItems dispatches a click event
          // it's not behavior of the native <option> and causes
          // the select to close immediately since we open on space keydown
          event.preventDefault();
        }

        if (child.props.onKeyUp) {
          child.props.onKeyUp(event);
        }
      },
      role: 'option',
      selected: selected,
      value: undefined,
      // The value is most likely not a valid HTML attribute.
      'data-value': child.props.value // Instead, we provide it as a data attribute.

    });
  });

  if (computeDisplay) {
    display = multiple ? displayMultiple.join(', ') : displaySingle;
  } // Avoid performing a layout computation in the render method.


  var menuMinWidth = menuMinWidthState;

  if (!autoWidth && isOpenControlled && displayNode) {
    menuMinWidth = displayNode.clientWidth;
  }

  var tabIndex;

  if (typeof tabIndexProp !== 'undefined') {
    tabIndex = tabIndexProp;
  } else {
    tabIndex = disabled ? null : 0;
  }

  var buttonId = SelectDisplayProps.id || (name ? "mui-component-select-".concat(name) : undefined);
  return /*#__PURE__*/React__namespace.createElement(React__namespace.Fragment, null, /*#__PURE__*/React__namespace.createElement("div", _extends$f({
    className: clsx(classes.root, // TODO v5: merge root and select
    classes.select, classes.selectMenu, classes[variant], className, disabled && classes.disabled),
    ref: setDisplayNode,
    tabIndex: tabIndex,
    role: "button",
    "aria-disabled": disabled ? 'true' : undefined,
    "aria-expanded": open ? 'true' : undefined,
    "aria-haspopup": "listbox",
    "aria-label": ariaLabel,
    "aria-labelledby": [labelId, buttonId].filter(Boolean).join(' ') || undefined,
    onKeyDown: handleKeyDown,
    onMouseDown: disabled || readOnly ? null : handleMouseDown,
    onBlur: handleBlur,
    onFocus: onFocus
  }, SelectDisplayProps, {
    // The id is required for proper a11y
    id: buttonId
  }), isEmpty$1(display) ?
  /*#__PURE__*/
  // eslint-disable-next-line react/no-danger
  React__namespace.createElement("span", {
    dangerouslySetInnerHTML: {
      __html: '&#8203;'
    }
  }) : display), /*#__PURE__*/React__namespace.createElement("input", _extends$f({
    value: Array.isArray(value) ? value.join(',') : value,
    name: name,
    ref: inputRef,
    "aria-hidden": true,
    onChange: handleChange,
    tabIndex: -1,
    className: classes.nativeInput,
    autoFocus: autoFocus
  }, other)), /*#__PURE__*/React__namespace.createElement(IconComponent, {
    className: clsx(classes.icon, classes["icon".concat(capitalize(variant))], open && classes.iconOpen, disabled && classes.disabled)
  }), /*#__PURE__*/React__namespace.createElement(Menu$1, _extends$f({
    id: "menu-".concat(name || ''),
    anchorEl: displayNode,
    open: open,
    onClose: handleClose
  }, MenuProps, {
    MenuListProps: _extends$f({
      'aria-labelledby': labelId,
      role: 'listbox',
      disableListWrap: true
    }, MenuProps.MenuListProps),
    PaperProps: _extends$f({}, MenuProps.PaperProps, {
      style: _extends$f({
        minWidth: menuMinWidth
      }, MenuProps.PaperProps != null ? MenuProps.PaperProps.style : null)
    })
  }), items));
});
var SelectInput$2 = SelectInput$1;var styles$7 = styles$a;

var _ref = /*#__PURE__*/React__namespace.createElement(Input$3, null);

var _ref2 = /*#__PURE__*/React__namespace.createElement(FilledInput$1, null);

var Select = /*#__PURE__*/React__namespace.forwardRef(function Select(props, ref) {
  var _props$autoWidth = props.autoWidth,
      autoWidth = _props$autoWidth === void 0 ? false : _props$autoWidth,
      children = props.children,
      classes = props.classes,
      _props$displayEmpty = props.displayEmpty,
      displayEmpty = _props$displayEmpty === void 0 ? false : _props$displayEmpty,
      _props$IconComponent = props.IconComponent,
      IconComponent = _props$IconComponent === void 0 ? ArrowDropDownIcon : _props$IconComponent,
      id = props.id,
      input = props.input,
      inputProps = props.inputProps,
      label = props.label,
      labelId = props.labelId,
      _props$labelWidth = props.labelWidth,
      labelWidth = _props$labelWidth === void 0 ? 0 : _props$labelWidth,
      MenuProps = props.MenuProps,
      _props$multiple = props.multiple,
      multiple = _props$multiple === void 0 ? false : _props$multiple,
      _props$native = props.native,
      native = _props$native === void 0 ? false : _props$native,
      onClose = props.onClose,
      onOpen = props.onOpen,
      open = props.open,
      renderValue = props.renderValue,
      SelectDisplayProps = props.SelectDisplayProps,
      _props$variant = props.variant,
      variantProps = _props$variant === void 0 ? 'standard' : _props$variant,
      other = _objectWithoutProperties$4(props, ["autoWidth", "children", "classes", "displayEmpty", "IconComponent", "id", "input", "inputProps", "label", "labelId", "labelWidth", "MenuProps", "multiple", "native", "onClose", "onOpen", "open", "renderValue", "SelectDisplayProps", "variant"]);

  var inputComponent = native ? NativeSelectInput$1 : SelectInput$2;
  var muiFormControl = useFormControl();
  var fcs = formControlState({
    props: props,
    muiFormControl: muiFormControl,
    states: ['variant']
  });
  var variant = fcs.variant || variantProps;
  var InputComponent = input || {
    standard: _ref,
    outlined: /*#__PURE__*/React__namespace.createElement(OutlinedInput$1, {
      label: label,
      labelWidth: labelWidth
    }),
    filled: _ref2
  }[variant];
  return /*#__PURE__*/React__namespace.cloneElement(InputComponent, _extends$f({
    // Most of the logic is implemented in `SelectInput`.
    // The `Select` component is a simple API wrapper to expose something better to play with.
    inputComponent: inputComponent,
    inputProps: _extends$f({
      children: children,
      IconComponent: IconComponent,
      variant: variant,
      type: undefined,
      // We render a select. We can ignore the type provided by the `Input`.
      multiple: multiple
    }, native ? {
      id: id
    } : {
      autoWidth: autoWidth,
      displayEmpty: displayEmpty,
      labelId: labelId,
      MenuProps: MenuProps,
      onClose: onClose,
      onOpen: onOpen,
      open: open,
      renderValue: renderValue,
      SelectDisplayProps: _extends$f({
        id: id
      }, SelectDisplayProps)
    }, inputProps, {
      classes: inputProps ? mergeClasses$2({
        baseClasses: classes,
        newClasses: inputProps.classes,
        Component: Select
      }) : classes
    }, input ? input.props.inputProps : {}),
    ref: ref
  }, other));
});
Select.muiName = 'Select';
var Select$1 = withStyles(styles$7, {
  name: 'MuiSelect'
})(Select);var styles$6 = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      position: 'relative',
      display: 'flex',
      alignItems: 'center'
    },

    /* Styles applied to the root element if `disableGutters={false}`. */
    gutters: _defineProperty$3({
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2)
    }, theme.breakpoints.up('sm'), {
      paddingLeft: theme.spacing(3),
      paddingRight: theme.spacing(3)
    }),

    /* Styles applied to the root element if `variant="regular"`. */
    regular: theme.mixins.toolbar,

    /* Styles applied to the root element if `variant="dense"`. */
    dense: {
      minHeight: 48
    }
  };
};
var Toolbar = /*#__PURE__*/React__namespace.forwardRef(function Toolbar(props, ref) {
  var classes = props.classes,
      className = props.className,
      _props$component = props.component,
      Component = _props$component === void 0 ? 'div' : _props$component,
      _props$disableGutters = props.disableGutters,
      disableGutters = _props$disableGutters === void 0 ? false : _props$disableGutters,
      _props$variant = props.variant,
      variant = _props$variant === void 0 ? 'regular' : _props$variant,
      other = _objectWithoutProperties$4(props, ["classes", "className", "component", "disableGutters", "variant"]);

  return /*#__PURE__*/React__namespace.createElement(Component, _extends$f({
    className: clsx(classes.root, classes[variant], className, !disableGutters && classes.gutters),
    ref: ref
  }, other));
});
var Toolbar$1 = withStyles(styles$6, {
  name: 'MuiToolbar'
})(Toolbar);var variantComponent = {
  standard: Input$3,
  filled: FilledInput$1,
  outlined: OutlinedInput$1
};
var styles$5 = {
  /* Styles applied to the root element. */
  root: {}
};
/**
 * The `TextField` is a convenience wrapper for the most common cases (80%).
 * It cannot be all things to all people, otherwise the API would grow out of control.
 *
 * ## Advanced Configuration
 *
 * It's important to understand that the text field is a simple abstraction
 * on top of the following components:
 *
 * - [FormControl](/api/form-control/)
 * - [InputLabel](/api/input-label/)
 * - [FilledInput](/api/filled-input/)
 * - [OutlinedInput](/api/outlined-input/)
 * - [Input](/api/input/)
 * - [FormHelperText](/api/form-helper-text/)
 *
 * If you wish to alter the props applied to the `input` element, you can do so as follows:
 *
 * ```jsx
 * const inputProps = {
 *   step: 300,
 * };
 *
 * return <TextField id="time" type="time" inputProps={inputProps} />;
 * ```
 *
 * For advanced cases, please look at the source of TextField by clicking on the
 * "Edit this page" button above. Consider either:
 *
 * - using the upper case props for passing values directly to the components
 * - using the underlying components directly as shown in the demos
 */

var TextField = /*#__PURE__*/React__namespace.forwardRef(function TextField(props, ref) {
  var autoComplete = props.autoComplete,
      _props$autoFocus = props.autoFocus,
      autoFocus = _props$autoFocus === void 0 ? false : _props$autoFocus,
      children = props.children,
      classes = props.classes,
      className = props.className,
      _props$color = props.color,
      color = _props$color === void 0 ? 'primary' : _props$color,
      defaultValue = props.defaultValue,
      _props$disabled = props.disabled,
      disabled = _props$disabled === void 0 ? false : _props$disabled,
      _props$error = props.error,
      error = _props$error === void 0 ? false : _props$error,
      FormHelperTextProps = props.FormHelperTextProps,
      _props$fullWidth = props.fullWidth,
      fullWidth = _props$fullWidth === void 0 ? false : _props$fullWidth,
      helperText = props.helperText,
      hiddenLabel = props.hiddenLabel,
      id = props.id,
      InputLabelProps = props.InputLabelProps,
      inputProps = props.inputProps,
      InputProps = props.InputProps,
      inputRef = props.inputRef,
      label = props.label,
      _props$multiline = props.multiline,
      multiline = _props$multiline === void 0 ? false : _props$multiline,
      name = props.name,
      onBlur = props.onBlur,
      onChange = props.onChange,
      onFocus = props.onFocus,
      placeholder = props.placeholder,
      _props$required = props.required,
      required = _props$required === void 0 ? false : _props$required,
      rows = props.rows,
      rowsMax = props.rowsMax,
      maxRows = props.maxRows,
      minRows = props.minRows,
      _props$select = props.select,
      select = _props$select === void 0 ? false : _props$select,
      SelectProps = props.SelectProps,
      type = props.type,
      value = props.value,
      _props$variant = props.variant,
      variant = _props$variant === void 0 ? 'standard' : _props$variant,
      other = _objectWithoutProperties$4(props, ["autoComplete", "autoFocus", "children", "classes", "className", "color", "defaultValue", "disabled", "error", "FormHelperTextProps", "fullWidth", "helperText", "hiddenLabel", "id", "InputLabelProps", "inputProps", "InputProps", "inputRef", "label", "multiline", "name", "onBlur", "onChange", "onFocus", "placeholder", "required", "rows", "rowsMax", "maxRows", "minRows", "select", "SelectProps", "type", "value", "variant"]);

  var InputMore = {};

  if (variant === 'outlined') {
    if (InputLabelProps && typeof InputLabelProps.shrink !== 'undefined') {
      InputMore.notched = InputLabelProps.shrink;
    }

    if (label) {
      var _InputLabelProps$requ;

      var displayRequired = (_InputLabelProps$requ = InputLabelProps === null || InputLabelProps === void 0 ? void 0 : InputLabelProps.required) !== null && _InputLabelProps$requ !== void 0 ? _InputLabelProps$requ : required;
      InputMore.label = /*#__PURE__*/React__namespace.createElement(React__namespace.Fragment, null, label, displayRequired && "\xA0*");
    }
  }

  if (select) {
    // unset defaults from textbox inputs
    if (!SelectProps || !SelectProps.native) {
      InputMore.id = undefined;
    }

    InputMore['aria-describedby'] = undefined;
  }

  var helperTextId = helperText && id ? "".concat(id, "-helper-text") : undefined;
  var inputLabelId = label && id ? "".concat(id, "-label") : undefined;
  var InputComponent = variantComponent[variant];
  var InputElement = /*#__PURE__*/React__namespace.createElement(InputComponent, _extends$f({
    "aria-describedby": helperTextId,
    autoComplete: autoComplete,
    autoFocus: autoFocus,
    defaultValue: defaultValue,
    fullWidth: fullWidth,
    multiline: multiline,
    name: name,
    rows: rows,
    rowsMax: rowsMax,
    maxRows: maxRows,
    minRows: minRows,
    type: type,
    value: value,
    id: id,
    inputRef: inputRef,
    onBlur: onBlur,
    onChange: onChange,
    onFocus: onFocus,
    placeholder: placeholder,
    inputProps: inputProps
  }, InputMore, InputProps));
  return /*#__PURE__*/React__namespace.createElement(FormControl$1, _extends$f({
    className: clsx(classes.root, className),
    disabled: disabled,
    error: error,
    fullWidth: fullWidth,
    hiddenLabel: hiddenLabel,
    ref: ref,
    required: required,
    color: color,
    variant: variant
  }, other), label && /*#__PURE__*/React__namespace.createElement(InputLabel$1, _extends$f({
    htmlFor: id,
    id: inputLabelId
  }, InputLabelProps), label), select ? /*#__PURE__*/React__namespace.createElement(Select$1, _extends$f({
    "aria-describedby": helperTextId,
    id: id,
    labelId: inputLabelId,
    value: value,
    input: InputElement
  }, SelectProps), children) : InputElement, helperText && /*#__PURE__*/React__namespace.createElement(FormHelperText$1, _extends$f({
    id: helperTextId
  }, FormHelperTextProps), helperText));
});
var TextField$1 = withStyles(styles$5, {
  name: 'MuiTextField'
})(TextField);function round$1(value) {
  return Math.round(value * 1e5) / 1e5;
}

function arrowGenerator() {
  return {
    '&[x-placement*="bottom"] $arrow': {
      top: 0,
      left: 0,
      marginTop: '-0.71em',
      marginLeft: 4,
      marginRight: 4,
      '&::before': {
        transformOrigin: '0 100%'
      }
    },
    '&[x-placement*="top"] $arrow': {
      bottom: 0,
      left: 0,
      marginBottom: '-0.71em',
      marginLeft: 4,
      marginRight: 4,
      '&::before': {
        transformOrigin: '100% 0'
      }
    },
    '&[x-placement*="right"] $arrow': {
      left: 0,
      marginLeft: '-0.71em',
      height: '1em',
      width: '0.71em',
      marginTop: 4,
      marginBottom: 4,
      '&::before': {
        transformOrigin: '100% 100%'
      }
    },
    '&[x-placement*="left"] $arrow': {
      right: 0,
      marginRight: '-0.71em',
      height: '1em',
      width: '0.71em',
      marginTop: 4,
      marginBottom: 4,
      '&::before': {
        transformOrigin: '0 0'
      }
    }
  };
}

var styles$4 = function styles(theme) {
  return {
    /* Styles applied to the Popper component. */
    popper: {
      zIndex: theme.zIndex.tooltip,
      pointerEvents: 'none' // disable jss-rtl plugin

    },

    /* Styles applied to the Popper component if `interactive={true}`. */
    popperInteractive: {
      pointerEvents: 'auto'
    },

    /* Styles applied to the Popper component if `arrow={true}`. */
    popperArrow: arrowGenerator(),

    /* Styles applied to the tooltip (label wrapper) element. */
    tooltip: {
      backgroundColor: alpha$2(theme.palette.grey[700], 0.9),
      borderRadius: theme.shape.borderRadius,
      color: theme.palette.common.white,
      fontFamily: theme.typography.fontFamily,
      padding: '4px 8px',
      fontSize: theme.typography.pxToRem(10),
      lineHeight: "".concat(round$1(14 / 10), "em"),
      maxWidth: 300,
      wordWrap: 'break-word',
      fontWeight: theme.typography.fontWeightMedium
    },

    /* Styles applied to the tooltip (label wrapper) element if `arrow={true}`. */
    tooltipArrow: {
      position: 'relative',
      margin: '0'
    },

    /* Styles applied to the arrow element. */
    arrow: {
      overflow: 'hidden',
      position: 'absolute',
      width: '1em',
      height: '0.71em'
      /* = width / sqrt(2) = (length of the hypotenuse) */
      ,
      boxSizing: 'border-box',
      color: alpha$2(theme.palette.grey[700], 0.9),
      '&::before': {
        content: '""',
        margin: 'auto',
        display: 'block',
        width: '100%',
        height: '100%',
        backgroundColor: 'currentColor',
        transform: 'rotate(45deg)'
      }
    },

    /* Styles applied to the tooltip (label wrapper) element if the tooltip is opened by touch. */
    touch: {
      padding: '8px 16px',
      fontSize: theme.typography.pxToRem(14),
      lineHeight: "".concat(round$1(16 / 14), "em"),
      fontWeight: theme.typography.fontWeightRegular
    },

    /* Styles applied to the tooltip (label wrapper) element if `placement` contains "left". */
    tooltipPlacementLeft: _defineProperty$3({
      transformOrigin: 'right center',
      margin: '0 24px '
    }, theme.breakpoints.up('sm'), {
      margin: '0 14px'
    }),

    /* Styles applied to the tooltip (label wrapper) element if `placement` contains "right". */
    tooltipPlacementRight: _defineProperty$3({
      transformOrigin: 'left center',
      margin: '0 24px'
    }, theme.breakpoints.up('sm'), {
      margin: '0 14px'
    }),

    /* Styles applied to the tooltip (label wrapper) element if `placement` contains "top". */
    tooltipPlacementTop: _defineProperty$3({
      transformOrigin: 'center bottom',
      margin: '24px 0'
    }, theme.breakpoints.up('sm'), {
      margin: '14px 0'
    }),

    /* Styles applied to the tooltip (label wrapper) element if `placement` contains "bottom". */
    tooltipPlacementBottom: _defineProperty$3({
      transformOrigin: 'center top',
      margin: '24px 0'
    }, theme.breakpoints.up('sm'), {
      margin: '14px 0'
    })
  };
};
var hystersisOpen = false;
var hystersisTimer = null;
var Tooltip$3 = /*#__PURE__*/React__namespace.forwardRef(function Tooltip(props, ref) {
  var _props$arrow = props.arrow,
      arrow = _props$arrow === void 0 ? false : _props$arrow,
      children = props.children,
      classes = props.classes,
      _props$disableFocusLi = props.disableFocusListener,
      disableFocusListener = _props$disableFocusLi === void 0 ? false : _props$disableFocusLi,
      _props$disableHoverLi = props.disableHoverListener,
      disableHoverListener = _props$disableHoverLi === void 0 ? false : _props$disableHoverLi,
      _props$disableTouchLi = props.disableTouchListener,
      disableTouchListener = _props$disableTouchLi === void 0 ? false : _props$disableTouchLi,
      _props$enterDelay = props.enterDelay,
      enterDelay = _props$enterDelay === void 0 ? 100 : _props$enterDelay,
      _props$enterNextDelay = props.enterNextDelay,
      enterNextDelay = _props$enterNextDelay === void 0 ? 0 : _props$enterNextDelay,
      _props$enterTouchDela = props.enterTouchDelay,
      enterTouchDelay = _props$enterTouchDela === void 0 ? 700 : _props$enterTouchDela,
      idProp = props.id,
      _props$interactive = props.interactive,
      interactive = _props$interactive === void 0 ? false : _props$interactive,
      _props$leaveDelay = props.leaveDelay,
      leaveDelay = _props$leaveDelay === void 0 ? 0 : _props$leaveDelay,
      _props$leaveTouchDela = props.leaveTouchDelay,
      leaveTouchDelay = _props$leaveTouchDela === void 0 ? 1500 : _props$leaveTouchDela,
      onClose = props.onClose,
      onOpen = props.onOpen,
      openProp = props.open,
      _props$placement = props.placement,
      placement = _props$placement === void 0 ? 'bottom' : _props$placement,
      _props$PopperComponen = props.PopperComponent,
      PopperComponent = _props$PopperComponen === void 0 ? Popper$1 : _props$PopperComponen,
      PopperProps = props.PopperProps,
      title = props.title,
      _props$TransitionComp = props.TransitionComponent,
      TransitionComponent = _props$TransitionComp === void 0 ? Grow$1 : _props$TransitionComp,
      TransitionProps = props.TransitionProps,
      other = _objectWithoutProperties$4(props, ["arrow", "children", "classes", "disableFocusListener", "disableHoverListener", "disableTouchListener", "enterDelay", "enterNextDelay", "enterTouchDelay", "id", "interactive", "leaveDelay", "leaveTouchDelay", "onClose", "onOpen", "open", "placement", "PopperComponent", "PopperProps", "title", "TransitionComponent", "TransitionProps"]);

  var theme = useTheme();

  var _React$useState = React__namespace.useState(),
      childNode = _React$useState[0],
      setChildNode = _React$useState[1];

  var _React$useState2 = React__namespace.useState(null),
      arrowRef = _React$useState2[0],
      setArrowRef = _React$useState2[1];

  var ignoreNonTouchEvents = React__namespace.useRef(false);
  var closeTimer = React__namespace.useRef();
  var enterTimer = React__namespace.useRef();
  var leaveTimer = React__namespace.useRef();
  var touchTimer = React__namespace.useRef();

  var _useControlled = useControlled({
    controlled: openProp,
    default: false,
    name: 'Tooltip',
    state: 'open'
  }),
      _useControlled2 = _slicedToArray(_useControlled, 2),
      openState = _useControlled2[0],
      setOpenState = _useControlled2[1];

  var open = openState;

  var id = useId(idProp);
  React__namespace.useEffect(function () {
    return function () {
      clearTimeout(closeTimer.current);
      clearTimeout(enterTimer.current);
      clearTimeout(leaveTimer.current);
      clearTimeout(touchTimer.current);
    };
  }, []);

  var handleOpen = function handleOpen(event) {
    clearTimeout(hystersisTimer);
    hystersisOpen = true; // The mouseover event will trigger for every nested element in the tooltip.
    // We can skip rerendering when the tooltip is already open.
    // We are using the mouseover event instead of the mouseenter event to fix a hide/show issue.

    setOpenState(true);

    if (onOpen) {
      onOpen(event);
    }
  };

  var handleEnter = function handleEnter() {
    var forward = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
    return function (event) {
      var childrenProps = children.props;

      if (event.type === 'mouseover' && childrenProps.onMouseOver && forward) {
        childrenProps.onMouseOver(event);
      }

      if (ignoreNonTouchEvents.current && event.type !== 'touchstart') {
        return;
      } // Remove the title ahead of time.
      // We don't want to wait for the next render commit.
      // We would risk displaying two tooltips at the same time (native + this one).


      if (childNode) {
        childNode.removeAttribute('title');
      }

      clearTimeout(enterTimer.current);
      clearTimeout(leaveTimer.current);

      if (enterDelay || hystersisOpen && enterNextDelay) {
        event.persist();
        enterTimer.current = setTimeout(function () {
          handleOpen(event);
        }, hystersisOpen ? enterNextDelay : enterDelay);
      } else {
        handleOpen(event);
      }
    };
  };

  var _useIsFocusVisible = useIsFocusVisible(),
      isFocusVisible = _useIsFocusVisible.isFocusVisible,
      onBlurVisible = _useIsFocusVisible.onBlurVisible,
      focusVisibleRef = _useIsFocusVisible.ref;

  var _React$useState3 = React__namespace.useState(false),
      childIsFocusVisible = _React$useState3[0],
      setChildIsFocusVisible = _React$useState3[1];

  var handleBlur = function handleBlur() {
    if (childIsFocusVisible) {
      setChildIsFocusVisible(false);
      onBlurVisible();
    }
  };

  var handleFocus = function handleFocus() {
    var forward = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
    return function (event) {
      // Workaround for https://github.com/facebook/react/issues/7769
      // The autoFocus of React might trigger the event before the componentDidMount.
      // We need to account for this eventuality.
      if (!childNode) {
        setChildNode(event.currentTarget);
      }

      if (isFocusVisible(event)) {
        setChildIsFocusVisible(true);
        handleEnter()(event);
      }

      var childrenProps = children.props;

      if (childrenProps.onFocus && forward) {
        childrenProps.onFocus(event);
      }
    };
  };

  var handleClose = function handleClose(event) {
    clearTimeout(hystersisTimer);
    hystersisTimer = setTimeout(function () {
      hystersisOpen = false;
    }, 800 + leaveDelay);
    setOpenState(false);

    if (onClose) {
      onClose(event);
    }

    clearTimeout(closeTimer.current);
    closeTimer.current = setTimeout(function () {
      ignoreNonTouchEvents.current = false;
    }, theme.transitions.duration.shortest);
  };

  var handleLeave = function handleLeave() {
    var forward = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
    return function (event) {
      var childrenProps = children.props;

      if (event.type === 'blur') {
        if (childrenProps.onBlur && forward) {
          childrenProps.onBlur(event);
        }

        handleBlur();
      }

      if (event.type === 'mouseleave' && childrenProps.onMouseLeave && event.currentTarget === childNode) {
        childrenProps.onMouseLeave(event);
      }

      clearTimeout(enterTimer.current);
      clearTimeout(leaveTimer.current);
      event.persist();
      leaveTimer.current = setTimeout(function () {
        handleClose(event);
      }, leaveDelay);
    };
  };

  var detectTouchStart = function detectTouchStart(event) {
    ignoreNonTouchEvents.current = true;
    var childrenProps = children.props;

    if (childrenProps.onTouchStart) {
      childrenProps.onTouchStart(event);
    }
  };

  var handleTouchStart = function handleTouchStart(event) {
    detectTouchStart(event);
    clearTimeout(leaveTimer.current);
    clearTimeout(closeTimer.current);
    clearTimeout(touchTimer.current);
    event.persist();
    touchTimer.current = setTimeout(function () {
      handleEnter()(event);
    }, enterTouchDelay);
  };

  var handleTouchEnd = function handleTouchEnd(event) {
    if (children.props.onTouchEnd) {
      children.props.onTouchEnd(event);
    }

    clearTimeout(touchTimer.current);
    clearTimeout(leaveTimer.current);
    event.persist();
    leaveTimer.current = setTimeout(function () {
      handleClose(event);
    }, leaveTouchDelay);
  };

  var handleUseRef = useForkRef(setChildNode, ref);
  var handleFocusRef = useForkRef(focusVisibleRef, handleUseRef); // can be removed once we drop support for non ref forwarding class components

  var handleOwnRef = React__namespace.useCallback(function (instance) {
    // #StrictMode ready
    setRef(handleFocusRef, ReactDOM__namespace.findDOMNode(instance));
  }, [handleFocusRef]);
  var handleRef = useForkRef(children.ref, handleOwnRef); // There is no point in displaying an empty tooltip.

  if (title === '') {
    open = false;
  } // For accessibility and SEO concerns, we render the title to the DOM node when
  // the tooltip is hidden. However, we have made a tradeoff when
  // `disableHoverListener` is set. This title logic is disabled.
  // It's allowing us to keep the implementation size minimal.
  // We are open to change the tradeoff.


  var shouldShowNativeTitle = !open && !disableHoverListener;

  var childrenProps = _extends$f({
    'aria-describedby': open ? id : null,
    title: shouldShowNativeTitle && typeof title === 'string' ? title : null
  }, other, children.props, {
    className: clsx(other.className, children.props.className),
    onTouchStart: detectTouchStart,
    ref: handleRef
  });

  var interactiveWrapperListeners = {};

  if (!disableTouchListener) {
    childrenProps.onTouchStart = handleTouchStart;
    childrenProps.onTouchEnd = handleTouchEnd;
  }

  if (!disableHoverListener) {
    childrenProps.onMouseOver = handleEnter();
    childrenProps.onMouseLeave = handleLeave();

    if (interactive) {
      interactiveWrapperListeners.onMouseOver = handleEnter(false);
      interactiveWrapperListeners.onMouseLeave = handleLeave(false);
    }
  }

  if (!disableFocusListener) {
    childrenProps.onFocus = handleFocus();
    childrenProps.onBlur = handleLeave();

    if (interactive) {
      interactiveWrapperListeners.onFocus = handleFocus(false);
      interactiveWrapperListeners.onBlur = handleLeave(false);
    }
  }

  var mergedPopperProps = React__namespace.useMemo(function () {
    return deepmerge({
      popperOptions: {
        modifiers: {
          arrow: {
            enabled: Boolean(arrowRef),
            element: arrowRef
          }
        }
      }
    }, PopperProps);
  }, [arrowRef, PopperProps]);
  return /*#__PURE__*/React__namespace.createElement(React__namespace.Fragment, null, /*#__PURE__*/React__namespace.cloneElement(children, childrenProps), /*#__PURE__*/React__namespace.createElement(PopperComponent, _extends$f({
    className: clsx(classes.popper, interactive && classes.popperInteractive, arrow && classes.popperArrow),
    placement: placement,
    anchorEl: childNode,
    open: childNode ? open : false,
    id: childrenProps['aria-describedby'],
    transition: true
  }, interactiveWrapperListeners, mergedPopperProps), function (_ref) {
    var placementInner = _ref.placement,
        TransitionPropsInner = _ref.TransitionProps;
    return /*#__PURE__*/React__namespace.createElement(TransitionComponent, _extends$f({
      timeout: theme.transitions.duration.shorter
    }, TransitionPropsInner, TransitionProps), /*#__PURE__*/React__namespace.createElement("div", {
      className: clsx(classes.tooltip, classes["tooltipPlacement".concat(capitalize(placementInner.split('-')[0]))], ignoreNonTouchEvents.current && classes.touch, arrow && classes.tooltipArrow)
    }, title, arrow ? /*#__PURE__*/React__namespace.createElement("span", {
      className: classes.arrow,
      ref: setArrowRef
    }) : null));
  }));
});
var Tooltip$4 = withStyles(styles$4, {
  name: 'MuiTooltip',
  flip: false
})(Tooltip$3);var MuiPickersContext = React.createContext(null);
var MuiPickersUtilsProvider = function MuiPickersUtilsProvider(_ref) {
  var Utils = _ref.utils,
      children = _ref.children,
      locale = _ref.locale,
      libInstance = _ref.libInstance;
  var utils = React.useMemo(function () {
    return new Utils({
      locale: locale,
      instance: libInstance
    });
  }, [Utils, libInstance, locale]);
  return React.createElement(MuiPickersContext.Provider, {
    value: utils,
    children: children
  });
};

var checkUtils = function checkUtils(utils) {
  if (!utils) {
    // tslint:disable-next-line
    throw new Error('Can not find utils in context. You either a) forgot to wrap your component tree in MuiPickersUtilsProvider; or b) mixed named and direct file imports.  Recommendation: use named imports from the module index.');
  }
};
function useUtils() {
  var utils = React.useContext(MuiPickersContext);
  checkUtils(utils);
  return utils;
}/** Use it instead of .includes method for IE support */
function arrayIncludes$4(array, itemOrItems) {
  if (Array.isArray(itemOrItems)) {
    return itemOrItems.every(function (item) {
      return array.indexOf(item) !== -1;
    });
  }

  return array.indexOf(itemOrItems) !== -1;
}

var DIALOG_WIDTH = 310;
var DIALOG_WIDTH_WIDER = 325;
var VIEW_HEIGHT = 305;

var useStyles$8 = makeStyles(function (theme) {
  return {
    staticWrapperRoot: {
      overflow: 'hidden',
      minWidth: DIALOG_WIDTH,
      display: 'flex',
      flexDirection: 'column',
      backgroundColor: theme.palette.background.paper
    }
  };
}, {
  name: 'MuiPickersStaticWrapper'
});
var StaticWrapper = function StaticWrapper(_ref) {
  var children = _ref.children;
  var classes = useStyles$8();
  return React.createElement("div", {
    className: classes.staticWrapperRoot,
    children: children
  });
};

var ModalDialog = function ModalDialog(_ref) {
  var children = _ref.children,
      classes = _ref.classes,
      onAccept = _ref.onAccept,
      onDismiss = _ref.onDismiss,
      onClear = _ref.onClear,
      onSetToday = _ref.onSetToday,
      okLabel = _ref.okLabel,
      cancelLabel = _ref.cancelLabel,
      clearLabel = _ref.clearLabel,
      todayLabel = _ref.todayLabel,
      clearable = _ref.clearable,
      showTodayButton = _ref.showTodayButton;
      _ref.showTabs;
      var wider = _ref.wider,
      other = _objectWithoutProperties$4(_ref, ["children", "classes", "onAccept", "onDismiss", "onClear", "onSetToday", "okLabel", "cancelLabel", "clearLabel", "todayLabel", "clearable", "showTodayButton", "showTabs", "wider"]);

  return React.createElement(Dialog$1, _extends$f({
    role: "dialog",
    onClose: onDismiss,
    classes: {
      paper: clsx(classes.dialogRoot, wider && classes.dialogRootWider)
    }
  }, other), React.createElement(DialogContent$1, {
    children: children,
    className: classes.dialog
  }), React.createElement(DialogActions$1, {
    classes: {
      root: clsx((clearable || showTodayButton) && classes.withAdditionalAction)
    }
  }, clearable && React.createElement(Button$3, {
    color: "primary",
    onClick: onClear
  }, clearLabel), showTodayButton && React.createElement(Button$3, {
    color: "primary",
    onClick: onSetToday
  }, todayLabel), cancelLabel && React.createElement(Button$3, {
    color: "primary",
    onClick: onDismiss
  }, cancelLabel), okLabel && React.createElement(Button$3, {
    color: "primary",
    onClick: onAccept
  }, okLabel)));
};
ModalDialog.displayName = 'ModalDialog';
var styles$3 = createStyles({
  dialogRoot: {
    minWidth: DIALOG_WIDTH
  },
  dialogRootWider: {
    minWidth: DIALOG_WIDTH_WIDER
  },
  dialog: {
    '&:first-child': {
      padding: 0
    }
  },
  withAdditionalAction: {
    // set justifyContent to default value to fix IE11 layout bug
    // see https://github.com/dmtrKovalenko/material-ui-pickers/pull/267
    justifyContent: 'flex-start',
    '& > *:first-child': {
      marginRight: 'auto'
    }
  }
});
var ModalDialog$1 = withStyles(styles$3, {
  name: 'MuiPickersModal'
})(ModalDialog);

var useIsomorphicEffect = typeof window === 'undefined' ? React.useEffect : React.useLayoutEffect;
function runKeyHandler(e, keyHandlers) {
  var handler = keyHandlers[e.key];

  if (handler) {
    handler(); // if event was handled prevent other side effects (e.g. page scroll)

    e.preventDefault();
  }
}
function useKeyDown(active, keyHandlers) {
  var keyHandlersRef = React.useRef(keyHandlers);
  keyHandlersRef.current = keyHandlers;
  useIsomorphicEffect(function () {
    if (active) {
      var handleKeyDown = function handleKeyDown(event) {
        runKeyHandler(event, keyHandlersRef.current);
      };

      window.addEventListener('keydown', handleKeyDown);
      return function () {
        window.removeEventListener('keydown', handleKeyDown);
      };
    }
  }, [active]);
}

var ModalWrapper = function ModalWrapper(_ref) {
  var open = _ref.open,
      children = _ref.children,
      okLabel = _ref.okLabel,
      cancelLabel = _ref.cancelLabel,
      clearLabel = _ref.clearLabel,
      todayLabel = _ref.todayLabel,
      showTodayButton = _ref.showTodayButton,
      clearable = _ref.clearable,
      DialogProps = _ref.DialogProps,
      showTabs = _ref.showTabs,
      wider = _ref.wider,
      InputComponent = _ref.InputComponent,
      DateInputProps = _ref.DateInputProps,
      onClear = _ref.onClear,
      onAccept = _ref.onAccept,
      onDismiss = _ref.onDismiss,
      onSetToday = _ref.onSetToday,
      other = _objectWithoutProperties$4(_ref, ["open", "children", "okLabel", "cancelLabel", "clearLabel", "todayLabel", "showTodayButton", "clearable", "DialogProps", "showTabs", "wider", "InputComponent", "DateInputProps", "onClear", "onAccept", "onDismiss", "onSetToday"]);

  useKeyDown(open, {
    Enter: onAccept
  });
  return React.createElement(React.Fragment, null, React.createElement(InputComponent, _extends$f({}, other, DateInputProps)), React.createElement(ModalDialog$1, _extends$f({
    wider: wider,
    showTabs: showTabs,
    open: open,
    onClear: onClear,
    onAccept: onAccept,
    onDismiss: onDismiss,
    onSetToday: onSetToday,
    clearLabel: clearLabel,
    todayLabel: todayLabel,
    okLabel: okLabel,
    cancelLabel: cancelLabel,
    clearable: clearable,
    showTodayButton: showTodayButton,
    children: children
  }, DialogProps)));
};
ModalWrapper.defaultProps = {
  okLabel: 'OK',
  cancelLabel: 'Cancel',
  clearLabel: 'Clear',
  todayLabel: 'Today',
  clearable: false,
  showTodayButton: false
};

var InlineWrapper = function InlineWrapper(_ref) {
  var open = _ref.open;
      _ref.wider;
      var children = _ref.children,
      PopoverProps = _ref.PopoverProps;
      _ref.onClear;
      var onDismiss = _ref.onDismiss;
      _ref.onSetToday;
      var onAccept = _ref.onAccept;
      _ref.showTabs;
      var DateInputProps = _ref.DateInputProps,
      InputComponent = _ref.InputComponent,
      other = _objectWithoutProperties$4(_ref, ["open", "wider", "children", "PopoverProps", "onClear", "onDismiss", "onSetToday", "onAccept", "showTabs", "DateInputProps", "InputComponent"]);

  var ref = React.useRef();
  useKeyDown(open, {
    Enter: onAccept
  });
  return React.createElement(React.Fragment, null, React.createElement(InputComponent, _extends$f({}, other, DateInputProps, {
    inputRef: ref
  })), React.createElement(Popover$1, _extends$f({
    open: open,
    onClose: onDismiss,
    anchorEl: ref.current,
    anchorOrigin: {
      vertical: 'bottom',
      horizontal: 'center'
    },
    transformOrigin: {
      vertical: 'top',
      horizontal: 'center'
    },
    children: children
  }, PopoverProps)));
};

function getWrapperFromVariant(variant) {
  switch (variant) {
    case 'inline':
      return InlineWrapper;

    case 'static':
      return StaticWrapper;

    default:
      return ModalWrapper;
  }
}
var VariantContext = React.createContext(null);
var Wrapper$A = function Wrapper(_ref) {
  var variant = _ref.variant,
      props = _objectWithoutProperties$4(_ref, ["variant"]);

  var Component = getWrapperFromVariant(variant);
  return React.createElement(VariantContext.Provider, {
    value: variant || 'dialog'
  }, React.createElement(Component, props));
};var Rifm =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(Rifm, _React$Component);

  function Rifm(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;
    _this._state = null;
    _this._del = false;

    _this._handleChange = function (evt) {


      var stateValue = _this.state.value;
      var value = evt.target.value;
      var input = evt.target;
      var op = value.length > stateValue.length;
      var del = _this._del;

      var noOp = stateValue === _this.props.format(value);

      _this.setState({
        value: value,
        local: true
      }, function () {
        var selectionStart = input.selectionStart;
        var refuse = _this.props.refuse || /[^\d]+/g;
        var before = value.substr(0, selectionStart).replace(refuse, '');
        _this._state = {
          input: input,
          before: before,
          op: op,
          di: del && noOp,
          del: del
        };

        if (_this.props.replace && _this.props.replace(stateValue) && op && !noOp) {
          var start = -1;

          for (var i = 0; i !== before.length; ++i) {
            start = Math.max(start, value.toLowerCase().indexOf(before[i].toLowerCase(), start + 1));
          }

          var c = value.substr(start + 1).replace(refuse, '')[0];
          start = value.indexOf(c, start + 1);
          value = "" + value.substr(0, start) + value.substr(start + 1);
        }

        var fv = _this.props.format(value);

        if (stateValue === fv) {
          _this.setState({
            value: value
          });
        } else {
          _this.props.onChange(fv);
        }
      });
    };

    _this._hKD = function (evt) {
      if (evt.code === 'Delete') {
        _this._del = true;
      }
    };

    _this._hKU = function (evt) {
      if (evt.code === 'Delete') {
        _this._del = false;
      }
    };

    _this.state = {
      value: props.value,
      local: true
    };
    return _this;
  }

  Rifm.getDerivedStateFromProps = function getDerivedStateFromProps(props, state) {
    return {
      value: state.local ? state.value : props.value,
      local: false
    };
  };

  var _proto = Rifm.prototype;

  _proto.render = function render() {
    var _handleChange = this._handleChange,
        value = this.state.value,
        children = this.props.children;
    return children({
      value: value,
      onChange: _handleChange
    });
  } // delete when  https://developer.mozilla.org/en-US/docs/Web/API/InputEvent/inputType will be supported by all major browsers
  ;

  _proto.componentWillUnmount = function componentWillUnmount() {
    document.removeEventListener('keydown', this._hKD);
    document.removeEventListener('keyup', this._hKU);
  } // delete when  https://developer.mozilla.org/en-US/docs/Web/API/InputEvent/inputType will be supported by all major browsers
  ;

  _proto.componentDidMount = function componentDidMount() {
    document.addEventListener('keydown', this._hKD);
    document.addEventListener('keyup', this._hKU);
  };

  _proto.componentDidUpdate = function componentDidUpdate() {
    var _state = this._state;

    if (_state) {
      var value = this.state.value;
      var start = -1;

      for (var i = 0; i !== _state.before.length; ++i) {
        start = Math.max(start, value.toLowerCase().indexOf(_state.before[i].toLowerCase(), start + 1));
      } // format usually looks better without this


      if (this.props.replace && (_state.op || _state.del && !_state.di)) {
        while (value[start + 1] && (this.props.refuse || /[^\d]+/).test(value[start + 1])) {
          start += 1;
        }
      }

      _state.input.selectionStart = _state.input.selectionEnd = start + 1 + (_state.di ? 1 : 0);
    }

    this._state = null;
  };

  return Rifm;
}(React.Component);var useStyles$7 = makeStyles(function (theme) {
  return {
    day: {
      width: 36,
      height: 36,
      fontSize: theme.typography.caption.fontSize,
      margin: '0 2px',
      color: theme.palette.text.primary,
      fontWeight: theme.typography.fontWeightMedium,
      padding: 0
    },
    hidden: {
      opacity: 0,
      pointerEvents: 'none'
    },
    current: {
      color: theme.palette.primary.main,
      fontWeight: 600
    },
    daySelected: {
      color: theme.palette.primary.contrastText,
      backgroundColor: theme.palette.primary.main,
      fontWeight: theme.typography.fontWeightMedium,
      '&:hover': {
        backgroundColor: theme.palette.primary.main
      }
    },
    dayDisabled: {
      pointerEvents: 'none',
      color: theme.palette.text.hint
    }
  };
}, {
  name: 'MuiPickersDay'
});
var Day = function Day(_ref) {
  var children = _ref.children,
      disabled = _ref.disabled,
      hidden = _ref.hidden,
      current = _ref.current,
      selected = _ref.selected,
      other = _objectWithoutProperties$4(_ref, ["children", "disabled", "hidden", "current", "selected"]);

  var classes = useStyles$7();
  var className = clsx(classes.day, hidden && classes.hidden, current && classes.current, selected && classes.daySelected, disabled && classes.dayDisabled);
  return React.createElement(IconButton$1, _extends$f({
    className: className,
    tabIndex: hidden || disabled ? -1 : 0
  }, other), React.createElement(Typography$1, {
    variant: "body2",
    color: "inherit"
  }, children));
};
Day.displayName = 'Day';
Day.defaultProps = {
  disabled: false,
  hidden: false,
  current: false,
  selected: false
};

var Day$1 = Day;var findClosestEnabledDate = function findClosestEnabledDate(_ref) {
  var date = _ref.date,
      utils = _ref.utils,
      minDate = _ref.minDate,
      maxDate = _ref.maxDate,
      disableFuture = _ref.disableFuture,
      disablePast = _ref.disablePast,
      shouldDisableDate = _ref.shouldDisableDate;
  var today = utils.startOfDay(utils.date());

  if (disablePast && utils.isBefore(minDate, today)) {
    minDate = today;
  }

  if (disableFuture && utils.isAfter(maxDate, today)) {
    maxDate = today;
  }

  var forward = date;
  var backward = date;

  if (utils.isBefore(date, minDate)) {
    forward = utils.date(minDate);
    backward = null;
  }

  if (utils.isAfter(date, maxDate)) {
    if (backward) {
      backward = utils.date(maxDate);
    }

    forward = null;
  }

  while (forward || backward) {
    if (forward && utils.isAfter(forward, maxDate)) {
      forward = null;
    }

    if (backward && utils.isBefore(backward, minDate)) {
      backward = null;
    }

    if (forward) {
      if (!shouldDisableDate(forward)) {
        return forward;
      }

      forward = utils.addDays(forward, 1);
    }

    if (backward) {
      if (!shouldDisableDate(backward)) {
        return backward;
      }

      backward = utils.addDays(backward, -1);
    }
  } // fallback to today if no enabled days


  return utils.date();
};
var isYearOnlyView = function isYearOnlyView(views) {
  return views.length === 1 && views[0] === 'year';
};
var isYearAndMonthViews = function isYearAndMonthViews(views) {
  return views.length === 2 && arrayIncludes$4(views, 'month') && arrayIncludes$4(views, 'year');
};
var getFormatByViews = function getFormatByViews(views, utils) {
  if (isYearOnlyView(views)) {
    return utils.yearFormat;
  }

  if (isYearAndMonthViews(views)) {
    return utils.yearMonthFormat;
  }

  return utils.dateFormat;
};

var DayWrapper = function DayWrapper(_ref) {
  var children = _ref.children,
      value = _ref.value,
      disabled = _ref.disabled,
      onSelect = _ref.onSelect,
      dayInCurrentMonth = _ref.dayInCurrentMonth,
      other = _objectWithoutProperties$4(_ref, ["children", "value", "disabled", "onSelect", "dayInCurrentMonth"]);

  var handleClick = React.useCallback(function () {
    return onSelect(value);
  }, [onSelect, value]);
  return React.createElement("div", _extends$f({
    role: "presentation",
    onClick: dayInCurrentMonth && !disabled ? handleClick : undefined,
    onKeyPress: dayInCurrentMonth && !disabled ? handleClick : undefined
  }, other), children);
};

var animationDuration = 350;
var useStyles$6 = makeStyles(function (theme) {
  var slideTransition = theme.transitions.create('transform', {
    duration: animationDuration,
    easing: 'cubic-bezier(0.35, 0.8, 0.4, 1)'
  });
  return {
    transitionContainer: {
      display: 'block',
      position: 'relative',
      '& > *': {
        position: 'absolute',
        top: 0,
        right: 0,
        left: 0
      }
    },
    'slideEnter-left': {
      willChange: 'transform',
      transform: 'translate(100%)'
    },
    'slideEnter-right': {
      willChange: 'transform',
      transform: 'translate(-100%)'
    },
    slideEnterActive: {
      transform: 'translate(0%)',
      transition: slideTransition
    },
    slideExit: {
      transform: 'translate(0%)'
    },
    'slideExitActiveLeft-left': {
      willChange: 'transform',
      transform: 'translate(-200%)',
      transition: slideTransition
    },
    'slideExitActiveLeft-right': {
      willChange: 'transform',
      transform: 'translate(200%)',
      transition: slideTransition
    }
  };
}, {
  name: 'MuiPickersSlideTransition'
});

var SlideTransition = function SlideTransition(_ref) {
  var children = _ref.children,
      transKey = _ref.transKey,
      slideDirection = _ref.slideDirection,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? null : _ref$className;
  var classes = useStyles$6();
  var transitionClasses = {
    exit: classes.slideExit,
    enterActive: classes.slideEnterActive,
    // @ts-ignore
    enter: classes['slideEnter-' + slideDirection],
    // @ts-ignore
    exitActive: classes['slideExitActiveLeft-' + slideDirection]
  };
  return React.createElement(TransitionGroup$1, {
    className: clsx(classes.transitionContainer, className),
    childFactory: function childFactory(element) {
      return React.cloneElement(element, {
        classNames: transitionClasses
      });
    }
  }, React.createElement(CSSTransition$1, {
    mountOnEnter: true,
    unmountOnExit: true,
    key: transKey + slideDirection,
    timeout: animationDuration,
    classNames: transitionClasses,
    children: children
  }));
};

var ArrowLeftIcon = function ArrowLeftIcon(props) {
  return React__default['default'].createElement(SvgIcon$1, props, React__default['default'].createElement("path", {
    d: "M15.41 16.59L10.83 12l4.58-4.59L14 6l-6 6 6 6 1.41-1.41z"
  }), React__default['default'].createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0V0z"
  }));
};

var ArrowRightIcon = function ArrowRightIcon(props) {
  return React__default['default'].createElement(SvgIcon$1, props, React__default['default'].createElement("path", {
    d: "M8.59 16.59L13.17 12 8.59 7.41 10 6l6 6-6 6-1.41-1.41z"
  }), React__default['default'].createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0V0z"
  }));
};

var useStyles$1$3 = makeStyles(function (theme) {
  return {
    switchHeader: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      marginTop: theme.spacing(0.5),
      marginBottom: theme.spacing(1)
    },
    transitionContainer: {
      width: '100%',
      overflow: 'hidden',
      height: 23
    },
    iconButton: {
      zIndex: 1,
      backgroundColor: theme.palette.background.paper
    },
    daysHeader: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      maxHeight: 16
    },
    dayLabel: {
      width: 36,
      margin: '0 2px',
      textAlign: 'center',
      color: theme.palette.text.hint
    }
  };
}, {
  name: 'MuiPickersCalendarHeader'
});
var CalendarHeader = function CalendarHeader(_ref) {
  var currentMonth = _ref.currentMonth,
      onMonthChange = _ref.onMonthChange,
      leftArrowIcon = _ref.leftArrowIcon,
      rightArrowIcon = _ref.rightArrowIcon,
      leftArrowButtonProps = _ref.leftArrowButtonProps,
      rightArrowButtonProps = _ref.rightArrowButtonProps,
      disablePrevMonth = _ref.disablePrevMonth,
      disableNextMonth = _ref.disableNextMonth,
      slideDirection = _ref.slideDirection;
  var utils = useUtils();
  var classes = useStyles$1$3();
  var theme = useTheme();
  var rtl = theme.direction === 'rtl';

  var selectNextMonth = function selectNextMonth() {
    return onMonthChange(utils.getNextMonth(currentMonth), 'left');
  };

  var selectPreviousMonth = function selectPreviousMonth() {
    return onMonthChange(utils.getPreviousMonth(currentMonth), 'right');
  };

  return React.createElement("div", null, React.createElement("div", {
    className: classes.switchHeader
  }, React.createElement(IconButton$1, _extends$f({}, leftArrowButtonProps, {
    disabled: disablePrevMonth,
    onClick: selectPreviousMonth,
    className: classes.iconButton
  }), rtl ? rightArrowIcon : leftArrowIcon), React.createElement(SlideTransition, {
    slideDirection: slideDirection,
    transKey: currentMonth.toString(),
    className: classes.transitionContainer
  }, React.createElement(Typography$1, {
    align: "center",
    variant: "body1"
  }, utils.getCalendarHeaderText(currentMonth))), React.createElement(IconButton$1, _extends$f({}, rightArrowButtonProps, {
    disabled: disableNextMonth,
    onClick: selectNextMonth,
    className: classes.iconButton
  }), rtl ? leftArrowIcon : rightArrowIcon)), React.createElement("div", {
    className: classes.daysHeader
  }, utils.getWeekdays().map(function (day, index) {
    return React.createElement(Typography$1, {
      key: index // eslint-disable-line react/no-array-index-key
      ,
      variant: "caption",
      className: classes.dayLabel
    }, day);
  })));
};
CalendarHeader.displayName = 'CalendarHeader';
CalendarHeader.defaultProps = {
  leftArrowIcon: React.createElement(ArrowLeftIcon, null),
  rightArrowIcon: React.createElement(ArrowRightIcon, null),
  disablePrevMonth: false,
  disableNextMonth: false
};

var withUtils = function withUtils() {
  return function (Component) {
    var WithUtils = function WithUtils(props) {
      var utils = useUtils();
      return React.createElement(Component, _extends$f({
        utils: utils
      }, props));
    };

    WithUtils.displayName = "WithUtils(".concat(Component.displayName || Component.name, ")");
    return WithUtils;
  };
};

var KeyDownListener = function KeyDownListener(_ref) {
  var onKeyDown = _ref.onKeyDown;
  React.useEffect(function () {
    window.addEventListener('keydown', onKeyDown);
    return function () {
      window.removeEventListener('keydown', onKeyDown);
    };
  }, [onKeyDown]);
  return null;
};

var Calendar =
/*#__PURE__*/
function (_React$Component) {
  _inherits$d(Calendar, _React$Component);

  function Calendar() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck$d(this, Calendar);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn$d(this, (_getPrototypeOf2 = _getPrototypeOf(Calendar)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _this.state = {
      slideDirection: 'left',
      currentMonth: _this.props.utils.startOfMonth(_this.props.date),
      loadingQueue: 0
    };

    _this.pushToLoadingQueue = function () {
      var loadingQueue = _this.state.loadingQueue + 1;

      _this.setState({
        loadingQueue: loadingQueue
      });
    };

    _this.popFromLoadingQueue = function () {
      var loadingQueue = _this.state.loadingQueue;
      loadingQueue = loadingQueue <= 0 ? 0 : loadingQueue - 1;

      _this.setState({
        loadingQueue: loadingQueue
      });
    };

    _this.handleChangeMonth = function (newMonth, slideDirection) {
      _this.setState({
        currentMonth: newMonth,
        slideDirection: slideDirection
      });

      if (_this.props.onMonthChange) {
        var returnVal = _this.props.onMonthChange(newMonth);

        if (returnVal) {
          _this.pushToLoadingQueue();

          returnVal.then(function () {
            _this.popFromLoadingQueue();
          });
        }
      }
    };

    _this.validateMinMaxDate = function (day) {
      var _this$props = _this.props,
          minDate = _this$props.minDate,
          maxDate = _this$props.maxDate,
          utils = _this$props.utils,
          disableFuture = _this$props.disableFuture,
          disablePast = _this$props.disablePast;
      var now = utils.date();
      return Boolean(disableFuture && utils.isAfterDay(day, now) || disablePast && utils.isBeforeDay(day, now) || minDate && utils.isBeforeDay(day, utils.date(minDate)) || maxDate && utils.isAfterDay(day, utils.date(maxDate)));
    };

    _this.shouldDisablePrevMonth = function () {
      var _this$props2 = _this.props,
          utils = _this$props2.utils,
          disablePast = _this$props2.disablePast,
          minDate = _this$props2.minDate;
      var now = utils.date();
      var firstEnabledMonth = utils.startOfMonth(disablePast && utils.isAfter(now, utils.date(minDate)) ? now : utils.date(minDate));
      return !utils.isBefore(firstEnabledMonth, _this.state.currentMonth);
    };

    _this.shouldDisableNextMonth = function () {
      var _this$props3 = _this.props,
          utils = _this$props3.utils,
          disableFuture = _this$props3.disableFuture,
          maxDate = _this$props3.maxDate;
      var now = utils.date();
      var lastEnabledMonth = utils.startOfMonth(disableFuture && utils.isBefore(now, utils.date(maxDate)) ? now : utils.date(maxDate));
      return !utils.isAfter(lastEnabledMonth, _this.state.currentMonth);
    };

    _this.shouldDisableDate = function (day) {
      var shouldDisableDate = _this.props.shouldDisableDate;
      return _this.validateMinMaxDate(day) || Boolean(shouldDisableDate && shouldDisableDate(day));
    };

    _this.handleDaySelect = function (day) {
      var isFinish = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      var _this$props4 = _this.props,
          date = _this$props4.date,
          utils = _this$props4.utils;

      _this.props.onChange(utils.mergeDateAndTime(day, date), isFinish);
    };

    _this.moveToDay = function (day) {
      var utils = _this.props.utils;

      if (day && !_this.shouldDisableDate(day)) {
        if (utils.getMonth(day) !== utils.getMonth(_this.state.currentMonth)) {
          _this.handleChangeMonth(utils.startOfMonth(day), 'left');
        }

        _this.handleDaySelect(day, false);
      }
    };

    _this.handleKeyDown = function (event) {
      var _this$props5 = _this.props,
          theme = _this$props5.theme,
          date = _this$props5.date,
          utils = _this$props5.utils;
      runKeyHandler(event, {
        ArrowUp: function ArrowUp() {
          return _this.moveToDay(utils.addDays(date, -7));
        },
        ArrowDown: function ArrowDown() {
          return _this.moveToDay(utils.addDays(date, 7));
        },
        ArrowLeft: function ArrowLeft() {
          return _this.moveToDay(utils.addDays(date, theme.direction === 'ltr' ? -1 : 1));
        },
        ArrowRight: function ArrowRight() {
          return _this.moveToDay(utils.addDays(date, theme.direction === 'ltr' ? 1 : -1));
        }
      });
    };

    _this.renderWeeks = function () {
      var _this$props6 = _this.props,
          utils = _this$props6.utils,
          classes = _this$props6.classes;
      var weeks = utils.getWeekArray(_this.state.currentMonth);
      return weeks.map(function (week) {
        return React.createElement("div", {
          key: "week-".concat(week[0].toString()),
          className: classes.week
        }, _this.renderDays(week));
      });
    };

    _this.renderDays = function (week) {
      var _this$props7 = _this.props,
          date = _this$props7.date,
          renderDay = _this$props7.renderDay,
          utils = _this$props7.utils;
      var now = utils.date();
      var selectedDate = utils.startOfDay(date);
      var currentMonthNumber = utils.getMonth(_this.state.currentMonth);
      return week.map(function (day) {
        var disabled = _this.shouldDisableDate(day);

        var isDayInCurrentMonth = utils.getMonth(day) === currentMonthNumber;
        var dayComponent = React.createElement(Day$1, {
          disabled: disabled,
          current: utils.isSameDay(day, now),
          hidden: !isDayInCurrentMonth,
          selected: utils.isSameDay(selectedDate, day)
        }, utils.getDayText(day));

        if (renderDay) {
          dayComponent = renderDay(day, selectedDate, isDayInCurrentMonth, dayComponent);
        }

        return React.createElement(DayWrapper, {
          value: day,
          key: day.toString(),
          disabled: disabled,
          dayInCurrentMonth: isDayInCurrentMonth,
          onSelect: _this.handleDaySelect
        }, dayComponent);
      });
    };

    return _this;
  }

  _createClass$b(Calendar, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props8 = this.props,
          date = _this$props8.date,
          minDate = _this$props8.minDate,
          maxDate = _this$props8.maxDate,
          utils = _this$props8.utils,
          disablePast = _this$props8.disablePast,
          disableFuture = _this$props8.disableFuture;

      if (this.shouldDisableDate(date)) {
        var closestEnabledDate = findClosestEnabledDate({
          date: date,
          utils: utils,
          minDate: utils.date(minDate),
          maxDate: utils.date(maxDate),
          disablePast: Boolean(disablePast),
          disableFuture: Boolean(disableFuture),
          shouldDisableDate: this.shouldDisableDate
        });
        this.handleDaySelect(closestEnabledDate, false);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$state = this.state,
          currentMonth = _this$state.currentMonth,
          slideDirection = _this$state.slideDirection;
      var _this$props9 = this.props,
          classes = _this$props9.classes,
          allowKeyboardControl = _this$props9.allowKeyboardControl,
          leftArrowButtonProps = _this$props9.leftArrowButtonProps,
          leftArrowIcon = _this$props9.leftArrowIcon,
          rightArrowButtonProps = _this$props9.rightArrowButtonProps,
          rightArrowIcon = _this$props9.rightArrowIcon,
          loadingIndicator = _this$props9.loadingIndicator;
      var loadingElement = loadingIndicator ? loadingIndicator : React.createElement(CircularProgress$1, null);
      return React.createElement(React.Fragment, null, allowKeyboardControl && this.context !== 'static' && React.createElement(KeyDownListener, {
        onKeyDown: this.handleKeyDown
      }), React.createElement(CalendarHeader, {
        currentMonth: currentMonth,
        slideDirection: slideDirection,
        onMonthChange: this.handleChangeMonth,
        leftArrowIcon: leftArrowIcon,
        leftArrowButtonProps: leftArrowButtonProps,
        rightArrowIcon: rightArrowIcon,
        rightArrowButtonProps: rightArrowButtonProps,
        disablePrevMonth: this.shouldDisablePrevMonth(),
        disableNextMonth: this.shouldDisableNextMonth()
      }), React.createElement(SlideTransition, {
        slideDirection: slideDirection,
        transKey: currentMonth.toString(),
        className: classes.transitionContainer
      }, React.createElement(React.Fragment, null, this.state.loadingQueue > 0 && React.createElement("div", {
        className: classes.progressContainer
      }, loadingElement) || React.createElement("div", null, this.renderWeeks()))));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, state) {
      var utils = nextProps.utils,
          nextDate = nextProps.date;

      if (!utils.isEqual(nextDate, state.lastDate)) {
        var nextMonth = utils.getMonth(nextDate);
        var lastDate = state.lastDate || nextDate;
        var lastMonth = utils.getMonth(lastDate);
        return {
          lastDate: nextDate,
          currentMonth: nextProps.utils.startOfMonth(nextDate),
          // prettier-ignore
          slideDirection: nextMonth === lastMonth ? state.slideDirection : utils.isAfterDay(nextDate, lastDate) ? 'left' : 'right'
        };
      }

      return null;
    }
  }]);

  return Calendar;
}(React.Component);
Calendar.contextType = VariantContext;
Calendar.defaultProps = {
  minDate: new Date('1900-01-01'),
  maxDate: new Date('2100-01-01'),
  disablePast: false,
  disableFuture: false,
  allowKeyboardControl: true
};
var styles$2 = function styles(theme) {
  return {
    transitionContainer: {
      minHeight: 36 * 6,
      marginTop: theme.spacing(1.5)
    },
    progressContainer: {
      width: '100%',
      height: '100%',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center'
    },
    week: {
      display: 'flex',
      justifyContent: 'center'
    }
  };
};
var Calendar$1 = withStyles(styles$2, {
  name: 'MuiPickersCalendar',
  withTheme: true
})(withUtils()(Calendar));var ClockType;

(function (ClockType) {
  ClockType["HOURS"] = "hours";
  ClockType["MINUTES"] = "minutes";
  ClockType["SECONDS"] = "seconds";
})(ClockType || (ClockType = {}));

var ClockType$1 = ClockType;

var ClockPointer =
/*#__PURE__*/
function (_React$Component) {
  _inherits$d(ClockPointer, _React$Component);

  function ClockPointer() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck$d(this, ClockPointer);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn$d(this, (_getPrototypeOf2 = _getPrototypeOf(ClockPointer)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _this.state = {
      toAnimateTransform: false,
      previousType: undefined
    };

    _this.getAngleStyle = function () {
      var _this$props = _this.props,
          value = _this$props.value,
          isInner = _this$props.isInner,
          type = _this$props.type;
      var max = type === ClockType$1.HOURS ? 12 : 60;
      var angle = 360 / max * value;

      if (type === ClockType$1.HOURS && value > 12) {
        angle -= 360; // round up angle to max 360 degrees
      }

      return {
        height: isInner ? '26%' : '40%',
        transform: "rotateZ(".concat(angle, "deg)")
      };
    };

    return _this;
  }

  _createClass$b(ClockPointer, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          classes = _this$props2.classes,
          hasSelected = _this$props2.hasSelected;
      return React.createElement("div", {
        style: this.getAngleStyle(),
        className: clsx(classes.pointer, this.state.toAnimateTransform && classes.animateTransform)
      }, React.createElement("div", {
        className: clsx(classes.thumb, hasSelected && classes.noPoint)
      }));
    }
  }]);

  return ClockPointer;
}(React.Component);

ClockPointer.getDerivedStateFromProps = function (nextProps, state) {
  if (nextProps.type !== state.previousType) {
    return {
      toAnimateTransform: true,
      previousType: nextProps.type
    };
  }

  return {
    toAnimateTransform: false,
    previousType: nextProps.type
  };
};

var styles$1 = function styles(theme) {
  return createStyles({
    pointer: {
      width: 2,
      backgroundColor: theme.palette.primary.main,
      position: 'absolute',
      left: 'calc(50% - 1px)',
      bottom: '50%',
      transformOrigin: 'center bottom 0px'
    },
    animateTransform: {
      transition: theme.transitions.create(['transform', 'height'])
    },
    thumb: {
      width: 4,
      height: 4,
      backgroundColor: theme.palette.primary.contrastText,
      borderRadius: '100%',
      position: 'absolute',
      top: -21,
      left: -15,
      border: "14px solid ".concat(theme.palette.primary.main),
      boxSizing: 'content-box'
    },
    noPoint: {
      backgroundColor: theme.palette.primary.main
    }
  });
};
var ClockPointer$1 = withStyles(styles$1, {
  name: 'MuiPickersClockPointer'
})(ClockPointer);

var center = {
  x: 260 / 2,
  y: 260 / 2
};
var basePoint = {
  x: center.x,
  y: 0
};
var cx = basePoint.x - center.x;
var cy = basePoint.y - center.y;

var rad2deg = function rad2deg(rad) {
  return rad * 57.29577951308232;
};

var getAngleValue = function getAngleValue(step, offsetX, offsetY) {
  var x = offsetX - center.x;
  var y = offsetY - center.y;
  var atan = Math.atan2(cx, cy) - Math.atan2(x, y);
  var deg = rad2deg(atan);
  deg = Math.round(deg / step) * step;
  deg %= 360;
  var value = Math.floor(deg / step) || 0;
  var delta = Math.pow(x, 2) + Math.pow(y, 2);
  var distance = Math.sqrt(delta);
  return {
    value: value,
    distance: distance
  };
};

var getHours = function getHours(offsetX, offsetY, ampm) {
  var _getAngleValue = getAngleValue(30, offsetX, offsetY),
      value = _getAngleValue.value,
      distance = _getAngleValue.distance;

  value = value || 12;

  if (!ampm) {
    if (distance < 90) {
      value += 12;
      value %= 24;
    }
  } else {
    value %= 12;
  }

  return value;
};
var getMinutes = function getMinutes(offsetX, offsetY) {
  var step = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
  var angleStep = step * 6;

  var _getAngleValue2 = getAngleValue(angleStep, offsetX, offsetY),
      value = _getAngleValue2.value;

  value = value * step % 60;
  return value;
};
var getMeridiem = function getMeridiem(date, utils) {
  return utils.getHours(date) >= 12 ? 'pm' : 'am';
};
var convertToMeridiem = function convertToMeridiem(time, meridiem, ampm, utils) {
  if (ampm) {
    var currentMeridiem = utils.getHours(time) >= 12 ? 'pm' : 'am';

    if (currentMeridiem !== meridiem) {
      var hours = meridiem === 'am' ? utils.getHours(time) - 12 : utils.getHours(time) + 12;
      return utils.setHours(time, hours);
    }
  }

  return time;
};

var Clock$2 =
/*#__PURE__*/
function (_React$Component) {
  _inherits$d(Clock, _React$Component);

  function Clock() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck$d(this, Clock);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn$d(this, (_getPrototypeOf2 = _getPrototypeOf(Clock)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _this.isMoving = false;

    _this.handleTouchMove = function (e) {
      _this.isMoving = true;

      _this.setTime(e);
    };

    _this.handleTouchEnd = function (e) {
      if (_this.isMoving) {
        _this.setTime(e, true);

        _this.isMoving = false;
      }
    };

    _this.handleMove = function (e) {
      e.preventDefault();
      e.stopPropagation(); // MouseEvent.which is deprecated, but MouseEvent.buttons is not supported in Safari

      var isButtonPressed = typeof e.buttons === 'undefined' ? e.nativeEvent.which === 1 : e.buttons === 1;

      if (isButtonPressed) {
        _this.setTime(e.nativeEvent, false);
      }
    };

    _this.handleMouseUp = function (e) {
      if (_this.isMoving) {
        _this.isMoving = false;
      }

      _this.setTime(e.nativeEvent, true);
    };

    _this.hasSelected = function () {
      var _this$props = _this.props,
          type = _this$props.type,
          value = _this$props.value;

      if (type === ClockType$1.HOURS) {
        return true;
      }

      return value % 5 === 0;
    };

    return _this;
  }

  _createClass$b(Clock, [{
    key: "setTime",
    value: function setTime(e) {
      var isFinish = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var offsetX = e.offsetX,
          offsetY = e.offsetY;

      if (typeof offsetX === 'undefined') {
        var rect = e.target.getBoundingClientRect();
        offsetX = e.changedTouches[0].clientX - rect.left;
        offsetY = e.changedTouches[0].clientY - rect.top;
      }

      var value = this.props.type === ClockType$1.SECONDS || this.props.type === ClockType$1.MINUTES ? getMinutes(offsetX, offsetY, this.props.minutesStep) : getHours(offsetX, offsetY, Boolean(this.props.ampm));
      this.props.onChange(value, isFinish);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          classes = _this$props2.classes,
          value = _this$props2.value,
          children = _this$props2.children,
          type = _this$props2.type,
          ampm = _this$props2.ampm;
      var isPointerInner = !ampm && type === ClockType$1.HOURS && (value < 1 || value > 12);
      return React.createElement("div", {
        className: classes.container
      }, React.createElement("div", {
        className: classes.clock
      }, React.createElement("div", {
        role: "menu",
        tabIndex: -1,
        className: classes.squareMask,
        onTouchMove: this.handleTouchMove,
        onTouchEnd: this.handleTouchEnd,
        onMouseUp: this.handleMouseUp,
        onMouseMove: this.handleMove
      }), React.createElement("div", {
        className: classes.pin
      }), React.createElement(ClockPointer$1, {
        type: type,
        value: value,
        isInner: isPointerInner,
        hasSelected: this.hasSelected()
      }), children));
    }
  }]);

  return Clock;
}(React.Component);
Clock$2.defaultProps = {
  ampm: false,
  minutesStep: 1
};
var styles$1$1 = function styles(theme) {
  return createStyles({
    container: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'flex-end',
      margin: "".concat(theme.spacing(2), "px 0 ").concat(theme.spacing(1), "px")
    },
    clock: {
      backgroundColor: 'rgba(0,0,0,.07)',
      borderRadius: '50%',
      height: 260,
      width: 260,
      position: 'relative',
      pointerEvents: 'none'
    },
    squareMask: {
      width: '100%',
      height: '100%',
      position: 'absolute',
      pointerEvents: 'auto',
      outline: 'none',
      touchActions: 'none',
      userSelect: 'none',
      '&:active': {
        cursor: 'move'
      }
    },
    pin: {
      width: 6,
      height: 6,
      borderRadius: '50%',
      backgroundColor: theme.palette.primary.main,
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)'
    }
  });
};
var Clock$1$1 = withStyles(styles$1$1, {
  name: 'MuiPickersClock'
})(Clock$2);var positions = {
  0: [0, 40],
  1: [55, 19.6],
  2: [94.4, 59.5],
  3: [109, 114],
  4: [94.4, 168.5],
  5: [54.5, 208.4],
  6: [0, 223],
  7: [-54.5, 208.4],
  8: [-94.4, 168.5],
  9: [-109, 114],
  10: [-94.4, 59.5],
  11: [-54.5, 19.6],
  12: [0, 5],
  13: [36.9, 49.9],
  14: [64, 77],
  15: [74, 114],
  16: [64, 151],
  17: [37, 178],
  18: [0, 188],
  19: [-37, 178],
  20: [-64, 151],
  21: [-74, 114],
  22: [-64, 77],
  23: [-37, 50]
};
var useStyles$5 = makeStyles(function (theme) {
  var size = theme.spacing(4);
  return {
    clockNumber: {
      width: size,
      height: 32,
      userSelect: 'none',
      position: 'absolute',
      left: "calc((100% - ".concat(typeof size === 'number' ? "".concat(size, "px") : size, ") / 2)"),
      display: 'inline-flex',
      justifyContent: 'center',
      alignItems: 'center',
      borderRadius: '50%',
      color: theme.palette.type === 'light' ? theme.palette.text.primary : theme.palette.text.hint
    },
    clockNumberSelected: {
      color: theme.palette.primary.contrastText
    }
  };
}, {
  name: 'MuiPickersClockNumber'
});
var ClockNumber = function ClockNumber(_ref) {
  var selected = _ref.selected,
      label = _ref.label,
      index = _ref.index,
      isInner = _ref.isInner;
  var classes = useStyles$5();
  var className = clsx(classes.clockNumber, selected && classes.clockNumberSelected);
  var transformStyle = React.useMemo(function () {
    var position = positions[index];
    return {
      transform: "translate(".concat(position[0], "px, ").concat(position[1], "px")
    };
  }, [index]);
  return React.createElement(Typography$1, {
    component: "span",
    className: className,
    variant: isInner ? 'body2' : 'body1',
    style: transformStyle,
    children: label
  });
};

var getHourNumbers = function getHourNumbers(_ref) {
  var ampm = _ref.ampm,
      utils = _ref.utils,
      date = _ref.date;
  var currentHours = utils.getHours(date);
  var hourNumbers = [];
  var startHour = ampm ? 1 : 0;
  var endHour = ampm ? 12 : 23;

  var isSelected = function isSelected(hour) {
    if (ampm) {
      if (hour === 12) {
        return currentHours === 12 || currentHours === 0;
      }

      return currentHours === hour || currentHours - 12 === hour;
    }

    return currentHours === hour;
  };

  for (var hour = startHour; hour <= endHour; hour += 1) {
    var label = hour.toString();

    if (hour === 0) {
      label = '00';
    }

    var props = {
      index: hour,
      label: utils.formatNumber(label),
      selected: isSelected(hour),
      isInner: !ampm && (hour === 0 || hour > 12)
    };
    hourNumbers.push(React.createElement(ClockNumber, _extends$f({
      key: hour
    }, props)));
  }

  return hourNumbers;
};
var getMinutesNumbers = function getMinutesNumbers(_ref2) {
  var value = _ref2.value,
      utils = _ref2.utils;
  var f = utils.formatNumber;
  return [React.createElement(ClockNumber, {
    label: f('00'),
    selected: value === 0,
    index: 12,
    key: 12
  }), React.createElement(ClockNumber, {
    label: f('05'),
    selected: value === 5,
    index: 1,
    key: 1
  }), React.createElement(ClockNumber, {
    label: f('10'),
    selected: value === 10,
    index: 2,
    key: 2
  }), React.createElement(ClockNumber, {
    label: f('15'),
    selected: value === 15,
    index: 3,
    key: 3
  }), React.createElement(ClockNumber, {
    label: f('20'),
    selected: value === 20,
    index: 4,
    key: 4
  }), React.createElement(ClockNumber, {
    label: f('25'),
    selected: value === 25,
    index: 5,
    key: 5
  }), React.createElement(ClockNumber, {
    label: f('30'),
    selected: value === 30,
    index: 6,
    key: 6
  }), React.createElement(ClockNumber, {
    label: f('35'),
    selected: value === 35,
    index: 7,
    key: 7
  }), React.createElement(ClockNumber, {
    label: f('40'),
    selected: value === 40,
    index: 8,
    key: 8
  }), React.createElement(ClockNumber, {
    label: f('45'),
    selected: value === 45,
    index: 9,
    key: 9
  }), React.createElement(ClockNumber, {
    label: f('50'),
    selected: value === 50,
    index: 10,
    key: 10
  }), React.createElement(ClockNumber, {
    label: f('55'),
    selected: value === 55,
    index: 11,
    key: 11
  })];
};

var ClockView = function ClockView(_ref) {
  var type = _ref.type,
      onHourChange = _ref.onHourChange,
      onMinutesChange = _ref.onMinutesChange,
      onSecondsChange = _ref.onSecondsChange,
      ampm = _ref.ampm,
      date = _ref.date,
      minutesStep = _ref.minutesStep;
  var utils = useUtils();
  var viewProps = React.useMemo(function () {
    switch (type) {
      case ClockType$1.HOURS:
        return {
          value: utils.getHours(date),
          children: getHourNumbers({
            date: date,
            utils: utils,
            ampm: Boolean(ampm)
          }),
          onChange: function onChange(value, isFinish) {
            var currentMeridiem = getMeridiem(date, utils);
            var updatedTimeWithMeridiem = convertToMeridiem(utils.setHours(date, value), currentMeridiem, Boolean(ampm), utils);
            onHourChange(updatedTimeWithMeridiem, isFinish);
          }
        };

      case ClockType$1.MINUTES:
        var minutesValue = utils.getMinutes(date);
        return {
          value: minutesValue,
          children: getMinutesNumbers({
            value: minutesValue,
            utils: utils
          }),
          onChange: function onChange(value, isFinish) {
            var updatedTime = utils.setMinutes(date, value);
            onMinutesChange(updatedTime, isFinish);
          }
        };

      case ClockType$1.SECONDS:
        var secondsValue = utils.getSeconds(date);
        return {
          value: secondsValue,
          children: getMinutesNumbers({
            value: secondsValue,
            utils: utils
          }),
          onChange: function onChange(value, isFinish) {
            var updatedTime = utils.setSeconds(date, value);
            onSecondsChange(updatedTime, isFinish);
          }
        };

      default:
        throw new Error('You must provide the type for TimePickerView');
    }
  }, [ampm, date, onHourChange, onMinutesChange, onSecondsChange, type, utils]);
  return React.createElement(Clock$1$1, _extends$f({
    type: type,
    ampm: ampm,
    minutesStep: minutesStep
  }, viewProps));
};
ClockView.displayName = 'TimePickerView';
ClockView.defaultProps = {
  ampm: true,
  minutesStep: 1
};
React.memo(ClockView);function ownKeys$4(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$3(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$4(source, true).forEach(function (key) { _defineProperty$3(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$4(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
PropTypes.oneOfType([PropTypes.object, PropTypes.string, PropTypes.number, PropTypes.instanceOf(Date)]);
PropTypes.oneOf(['year', 'month', 'day']);
/* eslint-disable @typescript-eslint/no-object-literal-type-assertion */

var timePickerDefaultProps = {
  ampm: true,
  invalidDateMessage: 'Invalid Time Format'
};
var datePickerDefaultProps = {
  minDate: new Date('1900-01-01'),
  maxDate: new Date('2100-01-01'),
  invalidDateMessage: 'Invalid Date Format',
  minDateMessage: 'Date should not be before minimal date',
  maxDateMessage: 'Date should not be after maximal date',
  allowKeyboardControl: true
};
_objectSpread$3({}, timePickerDefaultProps, {}, datePickerDefaultProps, {
  showTabs: true
});

function useViews(views, openTo, onChange) {
  var _React$useState = React.useState(openTo && arrayIncludes$4(views, openTo) ? openTo : views[0]),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      openView = _React$useState2[0],
      setOpenView = _React$useState2[1];

  var handleChangeAndOpenNext = React.useCallback(function (date, isFinish) {
    var nextViewToOpen = views[views.indexOf(openView) + 1];

    if (isFinish && nextViewToOpen) {
      // do not close picker if needs to show next view
      onChange(date, false);
      setOpenView(nextViewToOpen);
      return;
    }

    onChange(date, Boolean(isFinish));
  }, [onChange, openView, views]);
  return {
    handleChangeAndOpenNext: handleChangeAndOpenNext,
    openView: openView,
    setOpenView: setOpenView
  };
}

var useStyles$2 = makeStyles(function (theme) {
  return {
    root: {
      height: 40,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      cursor: 'pointer',
      outline: 'none',
      '&:focus': {
        color: theme.palette.primary.main,
        fontWeight: theme.typography.fontWeightMedium
      }
    },
    yearSelected: {
      margin: '10px 0',
      fontWeight: theme.typography.fontWeightMedium
    },
    yearDisabled: {
      pointerEvents: 'none',
      color: theme.palette.text.hint
    }
  };
}, {
  name: 'MuiPickersYear'
});
var Year = function Year(_ref) {
  var onSelect = _ref.onSelect,
      forwardedRef = _ref.forwardedRef,
      value = _ref.value,
      selected = _ref.selected,
      disabled = _ref.disabled,
      children = _ref.children,
      other = _objectWithoutProperties$4(_ref, ["onSelect", "forwardedRef", "value", "selected", "disabled", "children"]);

  var classes = useStyles$2();
  var handleClick = React.useCallback(function () {
    return onSelect(value);
  }, [onSelect, value]);
  return React.createElement(Typography$1, _extends$f({
    role: "button",
    component: "div",
    tabIndex: disabled ? -1 : 0,
    onClick: handleClick,
    onKeyPress: handleClick,
    color: selected ? 'primary' : undefined,
    variant: selected ? 'h5' : 'subtitle1',
    children: children,
    ref: forwardedRef,
    className: clsx(classes.root, selected && classes.yearSelected, disabled && classes.yearDisabled)
  }, other));
};
Year.displayName = 'Year';
var Year$1 = React.forwardRef(function (props, ref) {
  return React.createElement(Year, _extends$f({}, props, {
    forwardedRef: ref
  }));
});

var useStyles$1$2 = makeStyles({
  container: {
    height: 300,
    overflowY: 'auto'
  }
}, {
  name: 'MuiPickersYearSelection'
});
var YearSelection = function YearSelection(_ref) {
  var date = _ref.date,
      onChange = _ref.onChange,
      onYearChange = _ref.onYearChange,
      minDate = _ref.minDate,
      maxDate = _ref.maxDate,
      disablePast = _ref.disablePast,
      disableFuture = _ref.disableFuture,
      animateYearScrolling = _ref.animateYearScrolling;
  var utils = useUtils();
  var classes = useStyles$1$2();
  var currentVariant = React.useContext(VariantContext);
  var selectedYearRef = React.useRef(null);
  React.useEffect(function () {
    if (selectedYearRef.current && selectedYearRef.current.scrollIntoView) {
      try {
        selectedYearRef.current.scrollIntoView({
          block: currentVariant === 'static' ? 'nearest' : 'center',
          behavior: animateYearScrolling ? 'smooth' : 'auto'
        });
      } catch (e) {
        // call without arguments in case when scrollIntoView works improperly (e.g. Firefox 52-57)
        selectedYearRef.current.scrollIntoView();
      }
    }
  }, []); // eslint-disable-line

  var currentYear = utils.getYear(date);
  var onYearSelect = React.useCallback(function (year) {
    var newDate = utils.setYear(date, year);

    if (onYearChange) {
      onYearChange(newDate);
    }

    onChange(newDate, true);
  }, [date, onChange, onYearChange, utils]);
  return React.createElement("div", {
    className: classes.container
  }, utils.getYearRange(minDate, maxDate).map(function (year) {
    var yearNumber = utils.getYear(year);
    var selected = yearNumber === currentYear;
    return React.createElement(Year$1, {
      key: utils.getYearText(year),
      selected: selected,
      value: yearNumber,
      onSelect: onYearSelect,
      ref: selected ? selectedYearRef : undefined,
      disabled: Boolean(disablePast && utils.isBeforeYear(year, utils.date()) || disableFuture && utils.isAfterYear(year, utils.date()))
    }, utils.getYearText(year));
  }));
};

var useStyles$2$1 = makeStyles(function (theme) {
  return {
    root: {
      flex: '1 0 33.33%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      cursor: 'pointer',
      outline: 'none',
      height: 75,
      transition: theme.transitions.create('font-size', {
        duration: '100ms'
      }),
      '&:focus': {
        color: theme.palette.primary.main,
        fontWeight: theme.typography.fontWeightMedium
      }
    },
    monthSelected: {
      color: theme.palette.primary.main,
      fontWeight: theme.typography.fontWeightMedium
    },
    monthDisabled: {
      pointerEvents: 'none',
      color: theme.palette.text.hint
    }
  };
}, {
  name: 'MuiPickersMonth'
});
var Month = function Month(_ref) {
  var selected = _ref.selected,
      onSelect = _ref.onSelect,
      disabled = _ref.disabled,
      value = _ref.value,
      children = _ref.children,
      other = _objectWithoutProperties$4(_ref, ["selected", "onSelect", "disabled", "value", "children"]);

  var classes = useStyles$2$1();
  var handleSelection = React.useCallback(function () {
    onSelect(value);
  }, [onSelect, value]);
  return React.createElement(Typography$1, _extends$f({
    role: "button",
    component: "div",
    className: clsx(classes.root, selected && classes.monthSelected, disabled && classes.monthDisabled),
    tabIndex: disabled ? -1 : 0,
    onClick: handleSelection,
    onKeyPress: handleSelection,
    color: selected ? 'primary' : undefined,
    variant: selected ? 'h5' : 'subtitle1',
    children: children
  }, other));
};
Month.displayName = 'Month';

var useStyles$3 = makeStyles({
  container: {
    width: 310,
    display: 'flex',
    flexWrap: 'wrap',
    alignContent: 'stretch'
  }
}, {
  name: 'MuiPickersMonthSelection'
});
var MonthSelection = function MonthSelection(_ref) {
  var disablePast = _ref.disablePast,
      disableFuture = _ref.disableFuture,
      minDate = _ref.minDate,
      maxDate = _ref.maxDate,
      date = _ref.date,
      onMonthChange = _ref.onMonthChange,
      onChange = _ref.onChange;
  var utils = useUtils();
  var classes = useStyles$3();
  var currentMonth = utils.getMonth(date);

  var shouldDisableMonth = function shouldDisableMonth(month) {
    var now = utils.date();
    var utilMinDate = utils.date(minDate);
    var utilMaxDate = utils.date(maxDate);
    var firstEnabledMonth = utils.startOfMonth(disablePast && utils.isAfter(now, utilMinDate) ? now : utilMinDate);
    var lastEnabledMonth = utils.startOfMonth(disableFuture && utils.isBefore(now, utilMaxDate) ? now : utilMaxDate);
    var isBeforeFirstEnabled = utils.isBefore(month, firstEnabledMonth);
    var isAfterLastEnabled = utils.isAfter(month, lastEnabledMonth);
    return isBeforeFirstEnabled || isAfterLastEnabled;
  };

  var onMonthSelect = React.useCallback(function (month) {
    var newDate = utils.setMonth(date, month);
    onChange(newDate, true);

    if (onMonthChange) {
      onMonthChange(newDate);
    }
  }, [date, onChange, onMonthChange, utils]);
  return React.createElement("div", {
    className: classes.container
  }, utils.getMonthArray(date).map(function (month) {
    var monthNumber = utils.getMonth(month);
    var monthText = utils.format(month, 'MMM');
    return React.createElement(Month, {
      key: monthText,
      value: monthNumber,
      selected: monthNumber === currentMonth,
      onSelect: onMonthSelect,
      disabled: shouldDisableMonth(month)
    }, monthText);
  }));
};

var getOrientation = function getOrientation() {
  if (typeof window === 'undefined') {
    return 'portrait';
  }

  if (window.screen && window.screen.orientation && window.screen.orientation.angle) {
    return Math.abs(window.screen.orientation.angle) === 90 ? 'landscape' : 'portrait';
  } // Support IOS safari


  if (window.orientation) {
    return Math.abs(Number(window.orientation)) === 90 ? 'landscape' : 'portrait';
  }

  return 'portrait';
};

function useIsLandscape(customOrientation) {
  var _React$useState = React.useState(getOrientation()),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      orientation = _React$useState2[0],
      setOrientation = _React$useState2[1];

  var eventHandler = React.useCallback(function () {
    return setOrientation(getOrientation());
  }, []);
  useIsomorphicEffect(function () {
    window.addEventListener('orientationchange', eventHandler);
    return function () {
      return window.removeEventListener('orientationchange', eventHandler);
    };
  }, [eventHandler]);
  var orientationToUse = customOrientation || orientation;
  return orientationToUse === 'landscape';
}

function ownKeys$1$2(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$1$2(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$1$2(source, true).forEach(function (key) { _defineProperty$3(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$1$2(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var viewsMap = {
  year: YearSelection,
  month: MonthSelection,
  date: Calendar$1,
  hours: ClockView,
  minutes: ClockView,
  seconds: ClockView
};
var useStyles$4 = makeStyles({
  container: {
    display: 'flex',
    flexDirection: 'column'
  },
  containerLandscape: {
    flexDirection: 'row'
  },
  pickerView: {
    overflowX: 'hidden',
    minHeight: VIEW_HEIGHT,
    minWidth: DIALOG_WIDTH,
    maxWidth: DIALOG_WIDTH_WIDER,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center'
  },
  pickerViewLandscape: {
    padding: '0 8px'
  }
}, {
  name: 'MuiPickersBasePicker'
});
var Picker = function Picker(_ref) {
  var date = _ref.date,
      views = _ref.views,
      disableToolbar = _ref.disableToolbar,
      onChange = _ref.onChange,
      openTo = _ref.openTo,
      unparsedMinDate = _ref.minDate,
      unparsedMaxDate = _ref.maxDate,
      ToolbarComponent = _ref.ToolbarComponent,
      orientation = _ref.orientation,
      rest = _objectWithoutProperties$4(_ref, ["date", "views", "disableToolbar", "onChange", "openTo", "minDate", "maxDate", "ToolbarComponent", "orientation"]);

  var utils = useUtils();
  var classes = useStyles$4();
  var isLandscape = useIsLandscape(orientation);

  var _useViews = useViews(views, openTo, onChange),
      openView = _useViews.openView,
      setOpenView = _useViews.setOpenView,
      handleChangeAndOpenNext = _useViews.handleChangeAndOpenNext;

  var minDate = React.useMemo(function () {
    return utils.date(unparsedMinDate);
  }, [unparsedMinDate, utils]);
  var maxDate = React.useMemo(function () {
    return utils.date(unparsedMaxDate);
  }, [unparsedMaxDate, utils]);
  return React.createElement("div", {
    className: clsx(classes.container, isLandscape && classes.containerLandscape)
  }, !disableToolbar && React.createElement(ToolbarComponent, _extends$f({}, rest, {
    views: views,
    isLandscape: isLandscape,
    date: date,
    onChange: onChange,
    setOpenView: setOpenView,
    openView: openView
  })), React.createElement("div", {
    className: clsx(classes.pickerView, isLandscape && classes.pickerViewLandscape)
  }, openView === 'year' && React.createElement(YearSelection, _extends$f({}, rest, {
    date: date,
    onChange: handleChangeAndOpenNext,
    minDate: minDate,
    maxDate: maxDate
  })), openView === 'month' && React.createElement(MonthSelection, _extends$f({}, rest, {
    date: date,
    onChange: handleChangeAndOpenNext,
    minDate: minDate,
    maxDate: maxDate
  })), openView === 'date' && React.createElement(Calendar$1, _extends$f({}, rest, {
    date: date,
    onChange: handleChangeAndOpenNext,
    minDate: minDate,
    maxDate: maxDate
  })), (openView === 'hours' || openView === 'minutes' || openView === 'seconds') && React.createElement(ClockView, _extends$f({}, rest, {
    date: date,
    type: openView,
    onHourChange: handleChangeAndOpenNext,
    onMinutesChange: handleChangeAndOpenNext,
    onSecondsChange: handleChangeAndOpenNext
  }))));
};
Picker.defaultProps = _objectSpread$1$2({}, datePickerDefaultProps, {
  views: Object.keys(viewsMap)
});var useStyles$1 = makeStyles(function (theme) {
  var textColor = theme.palette.type === 'light' ? theme.palette.primary.contrastText : theme.palette.getContrastText(theme.palette.background["default"]);
  return {
    toolbarTxt: {
      color: fade(textColor, 0.54)
    },
    toolbarBtnSelected: {
      color: textColor
    }
  };
}, {
  name: 'MuiPickersToolbarText'
});

var ToolbarText = function ToolbarText(_ref) {
  var selected = _ref.selected,
      label = _ref.label,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? null : _ref$className,
      other = _objectWithoutProperties$4(_ref, ["selected", "label", "className"]);

  var classes = useStyles$1();
  return React.createElement(Typography$1, _extends$f({
    children: label,
    className: clsx(classes.toolbarTxt, className, selected && classes.toolbarBtnSelected)
  }, other));
};

var ToolbarButton = function ToolbarButton(_ref) {
  var classes = _ref.classes,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? null : _ref$className,
      label = _ref.label,
      selected = _ref.selected,
      variant = _ref.variant,
      align = _ref.align,
      typographyClassName = _ref.typographyClassName,
      other = _objectWithoutProperties$4(_ref, ["classes", "className", "label", "selected", "variant", "align", "typographyClassName"]);

  return React.createElement(Button$3, _extends$f({
    variant: "text",
    className: clsx(classes.toolbarBtn, className)
  }, other), React.createElement(ToolbarText, {
    align: align,
    className: typographyClassName,
    variant: variant,
    label: label,
    selected: selected
  }));
};
ToolbarButton.defaultProps = {
  className: ''
};
var styles = createStyles({
  toolbarBtn: {
    padding: 0,
    minWidth: '16px',
    textTransform: 'none'
  }
});
var ToolbarButton$1 = withStyles(styles, {
  name: 'MuiPickersToolbarButton'
})(ToolbarButton);

var useStyles$1$1 = makeStyles(function (theme) {
  return {
    toolbar: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'center',
      height: 100,
      backgroundColor: theme.palette.type === 'light' ? theme.palette.primary.main : theme.palette.background["default"]
    },
    toolbarLandscape: {
      height: 'auto',
      maxWidth: 150,
      padding: 8,
      justifyContent: 'flex-start'
    }
  };
}, {
  name: 'MuiPickersToolbar'
});

var PickerToolbar = function PickerToolbar(_ref) {
  var children = _ref.children,
      isLandscape = _ref.isLandscape,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? null : _ref$className,
      other = _objectWithoutProperties$4(_ref, ["children", "isLandscape", "className"]);

  var classes = useStyles$1$1();
  return React.createElement(Toolbar$1, _extends$f({
    className: clsx(classes.toolbar, className, isLandscape && classes.toolbarLandscape)
  }, other), children);
};

function ownKeys$3(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$1(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$3(source, true).forEach(function (key) { _defineProperty$3(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$3(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var PureDateInput = function PureDateInput(_ref) {
  var inputValue = _ref.inputValue,
      inputVariant = _ref.inputVariant,
      validationError = _ref.validationError,
      InputProps = _ref.InputProps,
      onOpen = _ref.openPicker,
      _ref$TextFieldCompone = _ref.TextFieldComponent,
      TextFieldComponent = _ref$TextFieldCompone === void 0 ? TextField$1 : _ref$TextFieldCompone,
      other = _objectWithoutProperties$4(_ref, ["inputValue", "inputVariant", "validationError", "InputProps", "openPicker", "TextFieldComponent"]);

  var PureDateInputProps = React.useMemo(function () {
    return _objectSpread$1({}, InputProps, {
      readOnly: true
    });
  }, [InputProps]);
  return React.createElement(TextFieldComponent, _extends$f({
    error: Boolean(validationError),
    helperText: validationError
  }, other, {
    // do not overridable
    onClick: onOpen,
    value: inputValue,
    variant: inputVariant,
    InputProps: PureDateInputProps,
    onKeyDown: function onKeyDown(e) {
      // space
      if (e.keyCode === 32) {
        e.stopPropagation();
        onOpen();
      }
    }
  }));
};
PureDateInput.displayName = 'PureDateInput';

var KeyboardIcon = function KeyboardIcon(props) {
  return React__default['default'].createElement(SvgIcon$1, props, React__default['default'].createElement("path", {
    d: "M17 12h-5v5h5v-5zM16 1v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2h-1V1h-2zm3 18H5V8h14v11z"
  }), React__default['default'].createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }));
};

var getDisplayDate = function getDisplayDate(value, format, utils, isEmpty, _ref) {
  var invalidLabel = _ref.invalidLabel,
      emptyLabel = _ref.emptyLabel,
      labelFunc = _ref.labelFunc;
  var date = utils.date(value);

  if (labelFunc) {
    return labelFunc(isEmpty ? null : date, invalidLabel);
  }

  if (isEmpty) {
    return emptyLabel || '';
  }

  return utils.isValid(date) ? utils.format(date, format) : invalidLabel;
};

var getComparisonMaxDate = function getComparisonMaxDate(utils, strictCompareDates, date) {
  if (strictCompareDates) {
    return date;
  }

  return utils.endOfDay(date);
};

var getComparisonMinDate = function getComparisonMinDate(utils, strictCompareDates, date) {
  if (strictCompareDates) {
    return date;
  }

  return utils.startOfDay(date);
};

var validate = function validate(value, utils, _ref2) {
  var maxDate = _ref2.maxDate,
      minDate = _ref2.minDate,
      disablePast = _ref2.disablePast,
      disableFuture = _ref2.disableFuture,
      maxDateMessage = _ref2.maxDateMessage,
      minDateMessage = _ref2.minDateMessage,
      invalidDateMessage = _ref2.invalidDateMessage,
      strictCompareDates = _ref2.strictCompareDates;
  var parsedValue = utils.date(value); // if null - do not show error

  if (value === null) {
    return '';
  }

  if (!utils.isValid(value)) {
    return invalidDateMessage;
  }

  if (maxDate && utils.isAfter(parsedValue, getComparisonMaxDate(utils, !!strictCompareDates, utils.date(maxDate)))) {
    return maxDateMessage;
  }

  if (disableFuture && utils.isAfter(parsedValue, getComparisonMaxDate(utils, !!strictCompareDates, utils.date()))) {
    return maxDateMessage;
  }

  if (minDate && utils.isBefore(parsedValue, getComparisonMinDate(utils, !!strictCompareDates, utils.date(minDate)))) {
    return minDateMessage;
  }

  if (disablePast && utils.isBefore(parsedValue, getComparisonMinDate(utils, !!strictCompareDates, utils.date()))) {
    return minDateMessage;
  }

  return '';
};
function makeMaskFromFormat(format, numberMaskChar) {
  return format.replace(/[a-z]/gi, numberMaskChar);
}
var maskedDateFormatter = function maskedDateFormatter(mask, numberMaskChar, refuse) {
  return function (value) {
    var result = '';
    var parsed = value.replace(refuse, '');

    if (parsed === '') {
      return parsed;
    }

    var i = 0;
    var n = 0;

    while (i < mask.length) {
      var maskChar = mask[i];

      if (maskChar === numberMaskChar && n < parsed.length) {
        var parsedChar = parsed[n];
        result += parsedChar;
        n += 1;
      } else {
        result += maskChar;
      }

      i += 1;
    }

    return result;
  };
};

function ownKeys$1$1(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$1$1(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$1$1(source, true).forEach(function (key) { _defineProperty$3(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$1$1(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var KeyboardDateInput = function KeyboardDateInput(_ref) {
  var inputValue = _ref.inputValue,
      inputVariant = _ref.inputVariant,
      validationError = _ref.validationError,
      KeyboardButtonProps = _ref.KeyboardButtonProps,
      InputAdornmentProps = _ref.InputAdornmentProps,
      onOpen = _ref.openPicker,
      onChange = _ref.onChange,
      InputProps = _ref.InputProps,
      mask = _ref.mask,
      _ref$maskChar = _ref.maskChar,
      maskChar = _ref$maskChar === void 0 ? '_' : _ref$maskChar,
      _ref$refuse = _ref.refuse,
      refuse = _ref$refuse === void 0 ? /[^\d]+/gi : _ref$refuse,
      format = _ref.format,
      keyboardIcon = _ref.keyboardIcon,
      disabled = _ref.disabled,
      rifmFormatter = _ref.rifmFormatter,
      _ref$TextFieldCompone = _ref.TextFieldComponent,
      TextFieldComponent = _ref$TextFieldCompone === void 0 ? TextField$1 : _ref$TextFieldCompone,
      other = _objectWithoutProperties$4(_ref, ["inputValue", "inputVariant", "validationError", "KeyboardButtonProps", "InputAdornmentProps", "openPicker", "onChange", "InputProps", "mask", "maskChar", "refuse", "format", "keyboardIcon", "disabled", "rifmFormatter", "TextFieldComponent"]);

  var inputMask = mask || makeMaskFromFormat(format, maskChar); // prettier-ignore

  var formatter = React.useMemo(function () {
    return maskedDateFormatter(inputMask, maskChar, refuse);
  }, [inputMask, maskChar, refuse]);
  var position = InputAdornmentProps && InputAdornmentProps.position ? InputAdornmentProps.position : 'end';

  var handleChange = function handleChange(text) {
    var finalString = text === '' || text === inputMask ? null : text;
    onChange(finalString);
  };

  return React.createElement(Rifm, {
    key: inputMask,
    value: inputValue,
    onChange: handleChange,
    refuse: refuse,
    format: rifmFormatter || formatter
  }, function (_ref2) {
    var onChange = _ref2.onChange,
        value = _ref2.value;
    return React.createElement(TextFieldComponent, _extends$f({
      disabled: disabled,
      error: Boolean(validationError),
      helperText: validationError
    }, other, {
      value: value,
      onChange: onChange,
      variant: inputVariant,
      InputProps: _objectSpread$1$1({}, InputProps, _defineProperty$3({}, "".concat(position, "Adornment"), React.createElement(InputAdornment$1, _extends$f({
        position: position
      }, InputAdornmentProps), React.createElement(IconButton$1, _extends$f({
        disabled: disabled
      }, KeyboardButtonProps, {
        onClick: onOpen
      }), keyboardIcon))))
    }));
  });
};
KeyboardDateInput.defaultProps = {
  keyboardIcon: React.createElement(KeyboardIcon, null)
};

function useOpenState(_ref) {
  var open = _ref.open,
      onOpen = _ref.onOpen,
      onClose = _ref.onClose;
  var setIsOpenState = null;

  if (open === undefined || open === null) {
    // The component is uncontrolled, so we need to give it its own state.
    var _useState = React.useState(false);

    var _useState2 = _slicedToArray(_useState, 2);

    open = _useState2[0];
    setIsOpenState = _useState2[1];
  } // prettier-ignore


  var setIsOpen = React.useCallback(function (newIsOpen) {
    setIsOpenState && setIsOpenState(newIsOpen);
    return newIsOpen ? onOpen && onOpen() : onClose && onClose();
  }, [onOpen, onClose, setIsOpenState]);
  return {
    isOpen: open,
    setIsOpen: setIsOpen
  };
}

var useValueToDate = function useValueToDate(utils, _ref) {
  var value = _ref.value,
      initialFocusedDate = _ref.initialFocusedDate;
  var nowRef = React.useRef(utils.date());
  var date = utils.date(value || initialFocusedDate || nowRef.current);
  return date && utils.isValid(date) ? date : nowRef.current;
};

function useDateValues(props, options) {
  var utils = useUtils();
  var date = useValueToDate(utils, props);
  var format = props.format || options.getDefaultFormat();
  return {
    date: date,
    format: format
  };
}

function usePickerState(props, options) {
  var autoOk = props.autoOk,
      disabled = props.disabled,
      readOnly = props.readOnly,
      onAccept = props.onAccept,
      _onChange = props.onChange,
      onError = props.onError,
      value = props.value,
      variant = props.variant;
  var utils = useUtils();

  var _useOpenState = useOpenState(props),
      isOpen = _useOpenState.isOpen,
      setIsOpen = _useOpenState.setIsOpen;

  var _useDateValues = useDateValues(props, options),
      date = _useDateValues.date,
      format = _useDateValues.format;

  var _useState = React.useState(date),
      _useState2 = _slicedToArray(_useState, 2),
      pickerDate = _useState2[0],
      setPickerDate = _useState2[1];

  React.useEffect(function () {
    // if value was changed in closed state - treat it as accepted
    if (!isOpen && !utils.isEqual(pickerDate, date)) {
      setPickerDate(date);
    }
  }, [date, isOpen, pickerDate, utils]);
  var acceptDate = React.useCallback(function (acceptedDate) {
    _onChange(acceptedDate);

    if (onAccept) {
      onAccept(acceptedDate);
    }

    setIsOpen(false);
  }, [onAccept, _onChange, setIsOpen]);
  var wrapperProps = React.useMemo(function () {
    return {
      format: format,
      open: isOpen,
      onClear: function onClear() {
        return acceptDate(null);
      },
      onAccept: function onAccept() {
        return acceptDate(pickerDate);
      },
      onSetToday: function onSetToday() {
        return setPickerDate(utils.date());
      },
      onDismiss: function onDismiss() {
        setIsOpen(false);
      }
    };
  }, [acceptDate, format, isOpen, pickerDate, setIsOpen, utils]);
  var pickerProps = React.useMemo(function () {
    return {
      date: pickerDate,
      onChange: function onChange(newDate) {
        var isFinish = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
        setPickerDate(newDate);

        if (isFinish && autoOk) {
          acceptDate(newDate);
          return;
        } // simulate autoOk, but do not close the modal


        if (variant === 'inline' || variant === 'static') {
          _onChange(newDate);

          onAccept && onAccept(newDate);
        }
      }
    };
  }, [acceptDate, autoOk, onAccept, _onChange, pickerDate, variant]);
  var validationError = validate(value, utils, props);
  React.useEffect(function () {
    if (onError) {
      onError(validationError, value);
    }
  }, [onError, validationError, value]);
  var inputValue = getDisplayDate(date, format, utils, value === null, props);
  var inputProps = React.useMemo(function () {
    return {
      inputValue: inputValue,
      validationError: validationError,
      openPicker: function openPicker() {
        return !readOnly && !disabled && setIsOpen(true);
      }
    };
  }, [disabled, inputValue, readOnly, setIsOpen, validationError]);
  var pickerState = {
    pickerProps: pickerProps,
    inputProps: inputProps,
    wrapperProps: wrapperProps
  };
  React.useDebugValue(pickerState);
  return pickerState;
}

function ownKeys$2$1(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$2(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$2$1(source, true).forEach(function (key) { _defineProperty$3(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$2$1(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function parseInputString(value, utils, format) {
  try {
    return utils.parse(value, format);
  } catch (_unused) {
    return null;
  }
}

function useKeyboardPickerState(props, options) {
  var _props$format = props.format,
      format = _props$format === void 0 ? options.getDefaultFormat() : _props$format,
      inputValue = props.inputValue,
      _onChange = props.onChange,
      value = props.value;
  var utils = useUtils();
  var displayDate = getDisplayDate(value, format, utils, value === null, props);

  var _useState = React.useState(displayDate),
      _useState2 = _slicedToArray(_useState, 2),
      innerInputValue = _useState2[0],
      setInnerInputValue = _useState2[1];

  var dateValue = inputValue ? parseInputString(inputValue, utils, format) : value;
  React.useEffect(function () {
    if (value === null || utils.isValid(value)) {
      setInnerInputValue(displayDate);
    }
  }, [displayDate, setInnerInputValue, utils, value]);
  var handleKeyboardChange = React.useCallback(function (date) {
    _onChange(date, date === null ? null : utils.format(date, format));
  }, [format, _onChange, utils]);

  var _usePickerState = usePickerState( // Extend props interface
  _objectSpread$2({}, props, {
    value: dateValue,
    onChange: handleKeyboardChange
  }), options),
      innerInputProps = _usePickerState.inputProps,
      wrapperProps = _usePickerState.wrapperProps,
      pickerProps = _usePickerState.pickerProps;

  var inputProps = React.useMemo(function () {
    return _objectSpread$2({}, innerInputProps, {
      // reuse validation and open/close logic
      format: wrapperProps.format,
      inputValue: inputValue || innerInputValue,
      onChange: function onChange(value) {
        setInnerInputValue(value || '');
        var date = value === null ? null : utils.parse(value, wrapperProps.format);

        _onChange(date, value);
      }
    });
  }, [innerInputProps, innerInputValue, inputValue, _onChange, utils, wrapperProps.format]);
  return {
    inputProps: inputProps,
    wrapperProps: wrapperProps,
    pickerProps: pickerProps
  };
}

function makePickerWithState(_ref) {
  var Input = _ref.Input,
      useState = _ref.useState,
      useOptions = _ref.useOptions,
      getCustomProps = _ref.getCustomProps,
      DefaultToolbarComponent = _ref.DefaultToolbarComponent;

  function PickerWithState(props) {
    var allowKeyboardControl = props.allowKeyboardControl,
        ampm = props.ampm,
        animateYearScrolling = props.animateYearScrolling;
        props.autoOk;
        var dateRangeIcon = props.dateRangeIcon,
        disableFuture = props.disableFuture,
        disablePast = props.disablePast,
        disableToolbar = props.disableToolbar;
        props.emptyLabel;
        props.format;
        props.forwardedRef;
        var hideTabs = props.hideTabs;
        props.initialFocusedDate;
        props.invalidDateMessage;
        props.invalidLabel;
        props.labelFunc;
        var leftArrowButtonProps = props.leftArrowButtonProps,
        leftArrowIcon = props.leftArrowIcon,
        loadingIndicator = props.loadingIndicator,
        maxDate = props.maxDate;
        props.maxDateMessage;
        var minDate = props.minDate;
        props.minDateMessage;
        var minutesStep = props.minutesStep;
        props.onAccept;
        props.onChange;
        props.onClose;
        var onMonthChange = props.onMonthChange;
        props.onOpen;
        var onYearChange = props.onYearChange,
        openTo = props.openTo,
        orientation = props.orientation,
        renderDay = props.renderDay,
        rightArrowButtonProps = props.rightArrowButtonProps,
        rightArrowIcon = props.rightArrowIcon,
        shouldDisableDate = props.shouldDisableDate,
        strictCompareDates = props.strictCompareDates,
        timeIcon = props.timeIcon,
        _props$ToolbarCompone = props.ToolbarComponent,
        ToolbarComponent = _props$ToolbarCompone === void 0 ? DefaultToolbarComponent : _props$ToolbarCompone;
        props.value;
        var variant = props.variant,
        views = props.views,
        other = _objectWithoutProperties$4(props, ["allowKeyboardControl", "ampm", "animateYearScrolling", "autoOk", "dateRangeIcon", "disableFuture", "disablePast", "disableToolbar", "emptyLabel", "format", "forwardedRef", "hideTabs", "initialFocusedDate", "invalidDateMessage", "invalidLabel", "labelFunc", "leftArrowButtonProps", "leftArrowIcon", "loadingIndicator", "maxDate", "maxDateMessage", "minDate", "minDateMessage", "minutesStep", "onAccept", "onChange", "onClose", "onMonthChange", "onOpen", "onYearChange", "openTo", "orientation", "renderDay", "rightArrowButtonProps", "rightArrowIcon", "shouldDisableDate", "strictCompareDates", "timeIcon", "ToolbarComponent", "value", "variant", "views"]);

    var injectedProps = getCustomProps ? getCustomProps(props) : {};
    var options = useOptions(props);

    var _useState = useState(props, options),
        pickerProps = _useState.pickerProps,
        inputProps = _useState.inputProps,
        wrapperProps = _useState.wrapperProps;

    return React.createElement(Wrapper$A, _extends$f({
      variant: variant,
      InputComponent: Input,
      DateInputProps: inputProps
    }, injectedProps, wrapperProps, other), React.createElement(Picker, _extends$f({}, pickerProps, {
      allowKeyboardControl: allowKeyboardControl,
      ampm: ampm,
      animateYearScrolling: animateYearScrolling,
      dateRangeIcon: dateRangeIcon,
      disableFuture: disableFuture,
      disablePast: disablePast,
      disableToolbar: disableToolbar,
      hideTabs: hideTabs,
      leftArrowButtonProps: leftArrowButtonProps,
      leftArrowIcon: leftArrowIcon,
      loadingIndicator: loadingIndicator,
      maxDate: maxDate,
      minDate: minDate,
      minutesStep: minutesStep,
      onMonthChange: onMonthChange,
      onYearChange: onYearChange,
      openTo: openTo,
      orientation: orientation,
      renderDay: renderDay,
      rightArrowButtonProps: rightArrowButtonProps,
      rightArrowIcon: rightArrowIcon,
      shouldDisableDate: shouldDisableDate,
      strictCompareDates: strictCompareDates,
      timeIcon: timeIcon,
      ToolbarComponent: ToolbarComponent,
      views: views
    })));
  }

  return PickerWithState;
}var useStyles = makeStyles({
  toolbar: {
    flexDirection: 'column',
    alignItems: 'flex-start'
  },
  toolbarLandscape: {
    padding: 16
  },
  dateLandscape: {
    marginRight: 16
  }
}, {
  name: 'MuiPickersDatePickerRoot'
});
var DatePickerToolbar = function DatePickerToolbar(_ref) {
  var date = _ref.date,
      views = _ref.views,
      setOpenView = _ref.setOpenView,
      isLandscape = _ref.isLandscape,
      openView = _ref.openView;
  var utils = useUtils();
  var classes = useStyles();
  var isYearOnly = React.useMemo(function () {
    return isYearOnlyView(views);
  }, [views]);
  var isYearAndMonth = React.useMemo(function () {
    return isYearAndMonthViews(views);
  }, [views]);
  return React.createElement(PickerToolbar, {
    isLandscape: isLandscape,
    className: clsx(!isYearOnly && classes.toolbar, isLandscape && classes.toolbarLandscape)
  }, React.createElement(ToolbarButton$1, {
    variant: isYearOnly ? 'h3' : 'subtitle1',
    onClick: function onClick() {
      return setOpenView('year');
    },
    selected: openView === 'year',
    label: utils.getYearText(date)
  }), !isYearOnly && !isYearAndMonth && React.createElement(ToolbarButton$1, {
    variant: "h4",
    selected: openView === 'date',
    onClick: function onClick() {
      return setOpenView('date');
    },
    align: isLandscape ? 'left' : 'center',
    label: utils.getDatePickerHeaderText(date),
    className: clsx(isLandscape && classes.dateLandscape)
  }), isYearAndMonth && React.createElement(ToolbarButton$1, {
    variant: "h4",
    onClick: function onClick() {
      return setOpenView('month');
    },
    selected: openView === 'month',
    label: utils.getMonthText(date)
  }));
};

function ownKeys$2(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$2(source, true).forEach(function (key) { _defineProperty$3(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$2(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var defaultProps = _objectSpread({}, datePickerDefaultProps, {
  openTo: 'date',
  views: ['year', 'date']
});

function useOptions(props) {
  var utils = useUtils();
  return {
    getDefaultFormat: function getDefaultFormat() {
      return getFormatByViews(props.views, utils);
    }
  };
}

var DatePicker$1 = makePickerWithState({
  useOptions: useOptions,
  Input: PureDateInput,
  useState: usePickerState,
  DefaultToolbarComponent: DatePickerToolbar
});
var KeyboardDatePicker = makePickerWithState({
  useOptions: useOptions,
  Input: KeyboardDateInput,
  useState: useKeyboardPickerState,
  DefaultToolbarComponent: DatePickerToolbar
});
DatePicker$1.defaultProps = defaultProps;
KeyboardDatePicker.defaultProps = defaultProps;var customParseFormat$1 = {exports: {}};(function (module, exports) {
!function(t,e){module.exports=e();}(commonjsGlobal,(function(){var t={LTS:"h:mm:ss A",LT:"h:mm A",L:"MM/DD/YYYY",LL:"MMMM D, YYYY",LLL:"MMMM D, YYYY h:mm A",LLLL:"dddd, MMMM D, YYYY h:mm A"},e=/(\[[^[]*\])|([-:/.()\s]+)|(A|a|YYYY|YY?|MM?M?M?|Do|DD?|hh?|HH?|mm?|ss?|S{1,3}|z|ZZ?)/g,n=/\d\d/,r=/\d\d?/,i=/\d*[^\s\d-_:/()]+/,o={},s=function(t){return (t=+t)+(t>68?1900:2e3)};var a=function(t){return function(e){this[t]=+e;}},f=[/[+-]\d\d:?(\d\d)?|Z/,function(t){(this.zone||(this.zone={})).offset=function(t){if(!t)return 0;if("Z"===t)return 0;var e=t.match(/([+-]|\d\d)/g),n=60*e[1]+(+e[2]||0);return 0===n?0:"+"===e[0]?-n:n}(t);}],u=function(t){var e=o[t];return e&&(e.indexOf?e:e.s.concat(e.f))},h=function(t,e){var n,r=o.meridiem;if(r){for(var i=1;i<=24;i+=1)if(t.indexOf(r(i,0,e))>-1){n=i>12;break}}else n=t===(e?"pm":"PM");return n},d={A:[i,function(t){this.afternoon=h(t,!1);}],a:[i,function(t){this.afternoon=h(t,!0);}],S:[/\d/,function(t){this.milliseconds=100*+t;}],SS:[n,function(t){this.milliseconds=10*+t;}],SSS:[/\d{3}/,function(t){this.milliseconds=+t;}],s:[r,a("seconds")],ss:[r,a("seconds")],m:[r,a("minutes")],mm:[r,a("minutes")],H:[r,a("hours")],h:[r,a("hours")],HH:[r,a("hours")],hh:[r,a("hours")],D:[r,a("day")],DD:[n,a("day")],Do:[i,function(t){var e=o.ordinal,n=t.match(/\d+/);if(this.day=n[0],e)for(var r=1;r<=31;r+=1)e(r).replace(/\[|\]/g,"")===t&&(this.day=r);}],M:[r,a("month")],MM:[n,a("month")],MMM:[i,function(t){var e=u("months"),n=(u("monthsShort")||e.map((function(t){return t.substr(0,3)}))).indexOf(t)+1;if(n<1)throw new Error;this.month=n%12||n;}],MMMM:[i,function(t){var e=u("months").indexOf(t)+1;if(e<1)throw new Error;this.month=e%12||e;}],Y:[/[+-]?\d+/,a("year")],YY:[n,function(t){this.year=s(t);}],YYYY:[/\d{4}/,a("year")],Z:f,ZZ:f};function c(n){var r,i;r=n,i=o&&o.formats;for(var s=(n=r.replace(/(\[[^\]]+])|(LTS?|l{1,4}|L{1,4})/g,(function(e,n,r){var o=r&&r.toUpperCase();return n||i[r]||t[r]||i[o].replace(/(\[[^\]]+])|(MMMM|MM|DD|dddd)/g,(function(t,e,n){return e||n.slice(1)}))}))).match(e),a=s.length,f=0;f<a;f+=1){var u=s[f],h=d[u],c=h&&h[0],l=h&&h[1];s[f]=l?{regex:c,parser:l}:u.replace(/^\[|\]$/g,"");}return function(t){for(var e={},n=0,r=0;n<a;n+=1){var i=s[n];if("string"==typeof i)r+=i.length;else {var o=i.regex,f=i.parser,u=t.substr(r),h=o.exec(u)[0];f.call(e,h),t=t.replace(h,"");}}return function(t){var e=t.afternoon;if(void 0!==e){var n=t.hours;e?n<12&&(t.hours+=12):12===n&&(t.hours=0),delete t.afternoon;}}(e),e}}return function(t,e,n){n.p.customParseFormat=!0,t&&t.parseTwoDigitYear&&(s=t.parseTwoDigitYear);var r=e.prototype,i=r.parse;r.parse=function(t){var e=t.date,r=t.utc,s=t.args;this.$u=r;var a=s[1];if("string"==typeof a){var f=!0===s[2],u=!0===s[3],h=f||u,d=s[2];u&&(d=s[2]),o=this.$locale(),!f&&d&&(o=n.Ls[d]),this.$d=function(t,e,n){try{if(["x","X"].indexOf(e)>-1)return new Date(("X"===e?1e3:1)*t);var r=c(e)(t),i=r.year,o=r.month,s=r.day,a=r.hours,f=r.minutes,u=r.seconds,h=r.milliseconds,d=r.zone,l=new Date,m=s||(i||o?1:l.getDate()),M=i||l.getFullYear(),Y=0;i&&!o||(Y=o>0?o-1:l.getMonth());var p=a||0,v=f||0,D=u||0,g=h||0;return d?new Date(Date.UTC(M,Y,m,p,v,D,g+60*d.offset*1e3)):n?new Date(Date.UTC(M,Y,m,p,v,D,g)):new Date(M,Y,m,p,v,D,g)}catch(t){return new Date("")}}(e,a,r),this.init(),d&&!0!==d&&(this.$L=this.locale(d).$L),h&&e!==this.format(a)&&(this.$d=new Date("")),o={};}else if(a instanceof Array)for(var l=a.length,m=1;m<=l;m+=1){s[1]=a[m-1];var M=n.apply(this,s);if(M.isValid()){this.$d=M.$d,this.$L=M.$L,this.init();break}m===l&&(this.$d=new Date(""));}else i.call(this,t);};}}));
}(customParseFormat$1));

var customParseFormat = customParseFormat$1.exports;var advancedFormat$1 = {exports: {}};(function (module, exports) {
!function(e,t){module.exports=t();}(commonjsGlobal,(function(){return function(e,t,r){var n=t.prototype,s=n.format;r.en.ordinal=function(e){var t=["th","st","nd","rd"],r=e%100;return "["+e+(t[(r-20)%10]||t[r]||t[0])+"]"},n.format=function(e){var t=this,r=this.$locale(),n=this.$utils(),a=(e||"YYYY-MM-DDTHH:mm:ssZ").replace(/\[([^\]]+)]|Q|wo|ww|w|WW|W|zzz|z|gggg|GGGG|Do|X|x|k{1,2}|S/g,(function(e){switch(e){case"Q":return Math.ceil((t.$M+1)/3);case"Do":return r.ordinal(t.$D);case"gggg":return t.weekYear();case"GGGG":return t.isoWeekYear();case"wo":return r.ordinal(t.week(),"W");case"w":case"ww":return n.s(t.week(),"w"===e?1:2,"0");case"W":case"WW":return n.s(t.isoWeek(),"W"===e?1:2,"0");case"k":case"kk":return n.s(String(0===t.$H?24:t.$H),"k"===e?1:2,"0");case"X":return Math.floor(t.$d.getTime()/1e3);case"x":return t.$d.getTime();case"z":return "["+t.offsetName()+"]";case"zzz":return "["+t.offsetName("long")+"]";default:return e}}));return s.bind(this)(a)};}}));
}(advancedFormat$1));

var advancedFormat = advancedFormat$1.exports;dayjs__default['default'].extend(customParseFormat);
dayjs__default['default'].extend(advancedFormat);
var withLocale = function (dayjs, locale) {
    return !locale ? dayjs : function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return dayjs.apply(void 0, args).locale(locale);
    };
};
var DayjsUtils = /** @class */ (function () {
    function DayjsUtils(_a) {
        var _b = _a === void 0 ? {} : _a, locale = _b.locale, instance = _b.instance, dayjs = _b.dayjs;
        this.yearFormat = "YYYY";
        this.yearMonthFormat = "MMMM YYYY";
        this.dateTime12hFormat = "MMMM Do hh:mm a";
        this.dateTime24hFormat = "MMMM Do HH:mm";
        this.time12hFormat = "hh:mm A";
        this.time24hFormat = "HH:mm";
        this.dateFormat = "MMMM Do";
        this.dayjs = withLocale(instance || dayjs || dayjs__default['default'], locale);
        this.locale = locale;
    }
    DayjsUtils.prototype.parse = function (value, format) {
        if (value === "") {
            return null;
        }
        return this.dayjs(value, format);
    };
    DayjsUtils.prototype.date = function (value) {
        if (value === null) {
            return null;
        }
        return this.dayjs(value);
    };
    DayjsUtils.prototype.isValid = function (value) {
        return this.dayjs(value).isValid();
    };
    DayjsUtils.prototype.isNull = function (date) {
        return date === null;
    };
    DayjsUtils.prototype.getDiff = function (date, comparing, units, float) {
        return date.diff(comparing, units, float);
    };
    DayjsUtils.prototype.isAfter = function (date, value) {
        return date.isAfter(value);
    };
    DayjsUtils.prototype.isBefore = function (date, value) {
        return date.isBefore(value);
    };
    DayjsUtils.prototype.isAfterDay = function (date, value) {
        return date.isAfter(value, "day");
    };
    DayjsUtils.prototype.isBeforeDay = function (date, value) {
        return date.isBefore(value, "day");
    };
    DayjsUtils.prototype.isBeforeYear = function (date, value) {
        return date.isBefore(value, "year");
    };
    DayjsUtils.prototype.isAfterYear = function (date, value) {
        return date.isAfter(value, "year");
    };
    DayjsUtils.prototype.startOfDay = function (date) {
        return date.clone().startOf("day");
    };
    DayjsUtils.prototype.endOfDay = function (date) {
        return date.clone().endOf("day");
    };
    DayjsUtils.prototype.format = function (date, formatString) {
        return this.dayjs(date).format(formatString);
    };
    DayjsUtils.prototype.formatNumber = function (numberToFormat) {
        return numberToFormat;
    };
    DayjsUtils.prototype.getHours = function (date) {
        return date.hour();
    };
    DayjsUtils.prototype.addDays = function (date, count) {
        return count < 0
            ? date.clone().subtract(Math.abs(count), "day")
            : date.clone().add(count, "day");
    };
    DayjsUtils.prototype.setMonth = function (date, count) {
        return date.clone().set("month", count);
    };
    DayjsUtils.prototype.setHours = function (date, count) {
        return date.clone().set("hour", count);
    };
    DayjsUtils.prototype.getMinutes = function (date) {
        return date.minute();
    };
    DayjsUtils.prototype.setMinutes = function (date, count) {
        return date.clone().set("minute", count);
    };
    DayjsUtils.prototype.getSeconds = function (date) {
        return date.second();
    };
    DayjsUtils.prototype.setSeconds = function (date, count) {
        return date.clone().set("second", count);
    };
    DayjsUtils.prototype.getMonth = function (date) {
        return date.month();
    };
    DayjsUtils.prototype.isSameDay = function (date, comparing) {
        return date.isSame(comparing, "day");
    };
    DayjsUtils.prototype.isSameMonth = function (date, comparing) {
        return date.isSame(comparing, "month");
    };
    DayjsUtils.prototype.isSameYear = function (date, comparing) {
        return date.isSame(comparing, "year");
    };
    DayjsUtils.prototype.isSameHour = function (date, comparing) {
        return date.isSame(comparing, "hour");
    };
    DayjsUtils.prototype.getMeridiemText = function (ampm) {
        return ampm === "am" ? "AM" : "PM";
    };
    DayjsUtils.prototype.startOfMonth = function (date) {
        return date.clone().startOf("month");
    };
    DayjsUtils.prototype.endOfMonth = function (date) {
        return date.clone().endOf("month");
    };
    DayjsUtils.prototype.getNextMonth = function (date) {
        return date.clone().add(1, "month");
    };
    DayjsUtils.prototype.getPreviousMonth = function (date) {
        return date.clone().subtract(1, "month");
    };
    DayjsUtils.prototype.getMonthArray = function (date) {
        var firstMonth = date.clone().startOf("year");
        var monthArray = [firstMonth];
        while (monthArray.length < 12) {
            var prevMonth = monthArray[monthArray.length - 1];
            monthArray.push(this.getNextMonth(prevMonth));
        }
        return monthArray;
    };
    DayjsUtils.prototype.getMonthText = function (date) {
        return this.format(date, "MMMM");
    };
    DayjsUtils.prototype.getYear = function (date) {
        return date.year();
    };
    DayjsUtils.prototype.setYear = function (date, year) {
        return date.clone().set("year", year);
    };
    DayjsUtils.prototype.mergeDateAndTime = function (date, time) {
        return this.setMinutes(this.setHours(date, this.getHours(time)), this.getMinutes(time));
    };
    DayjsUtils.prototype.getWeekdays = function () {
        var _this = this;
        var start = this.dayjs().startOf("week");
        return [0, 1, 2, 3, 4, 5, 6].map(function (diff) { return _this.format(start.add(diff, "day"), "dd"); });
    };
    DayjsUtils.prototype.isEqual = function (value, comparing) {
        if (value === null && comparing === null) {
            return true;
        }
        return this.dayjs(value).isSame(comparing);
    };
    DayjsUtils.prototype.getWeekArray = function (date) {
        var start = this.dayjs(date)
            .clone()
            .startOf("month")
            .startOf("week");
        var end = this.dayjs(date)
            .clone()
            .endOf("month")
            .endOf("week");
        var count = 0;
        var current = start;
        var nestedWeeks = [];
        while (current.isBefore(end)) {
            var weekNumber = Math.floor(count / 7);
            nestedWeeks[weekNumber] = nestedWeeks[weekNumber] || [];
            nestedWeeks[weekNumber].push(current);
            current = current.clone().add(1, "day");
            count += 1;
        }
        return nestedWeeks;
    };
    DayjsUtils.prototype.getYearRange = function (start, end) {
        var startDate = this.dayjs(start).startOf("year");
        var endDate = this.dayjs(end).endOf("year");
        var years = [];
        var current = startDate;
        while (current.isBefore(endDate)) {
            years.push(current);
            current = current.clone().add(1, "year");
        }
        return years;
    };
    // displaying methods
    DayjsUtils.prototype.getCalendarHeaderText = function (date) {
        return this.format(date, "MMMM YYYY");
    };
    DayjsUtils.prototype.getYearText = function (date) {
        return this.format(date, "YYYY");
    };
    DayjsUtils.prototype.getDatePickerHeaderText = function (date) {
        return this.format(date, "ddd, MMM D");
    };
    DayjsUtils.prototype.getDateTimePickerHeaderText = function (date) {
        return this.format(date, "MMM D");
    };
    DayjsUtils.prototype.getDayText = function (date) {
        return this.format(date, "D");
    };
    DayjsUtils.prototype.getHourText = function (date, ampm) {
        return this.format(date, ampm ? "hh" : "HH");
    };
    DayjsUtils.prototype.getMinuteText = function (date) {
        return this.format(date, "mm");
    };
    DayjsUtils.prototype.getSecondText = function (date) {
        return this.format(date, "ss");
    };
    return DayjsUtils;
}());var baseAssignValue$1 = _baseAssignValue,
    eq$1 = eq_1;

/**
 * This function is like `assignValue` except that it doesn't assign
 * `undefined` values.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignMergeValue$2(object, key, value) {
  if ((value !== undefined && !eq$1(object[key], value)) ||
      (value === undefined && !(key in object))) {
    baseAssignValue$1(object, key, value);
  }
}

var _assignMergeValue = assignMergeValue$2;var _cloneBuffer = {exports: {}};(function (module, exports) {
var root = _root;

/** Detect free variable `exports`. */
var freeExports = exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && 'object' == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined,
    allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;

/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */
function cloneBuffer(buffer, isDeep) {
  if (isDeep) {
    return buffer.slice();
  }
  var length = buffer.length,
      result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

  buffer.copy(result);
  return result;
}

module.exports = cloneBuffer;
}(_cloneBuffer, _cloneBuffer.exports));var Uint8Array$1 = _Uint8Array;

/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */
function cloneArrayBuffer$3(arrayBuffer) {
  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
  new Uint8Array$1(result).set(new Uint8Array$1(arrayBuffer));
  return result;
}

var _cloneArrayBuffer = cloneArrayBuffer$3;var cloneArrayBuffer$2 = _cloneArrayBuffer;

/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */
function cloneTypedArray$2(typedArray, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer$2(typedArray.buffer) : typedArray.buffer;
  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}

var _cloneTypedArray = cloneTypedArray$2;/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */

function copyArray$2(source, array) {
  var index = -1,
      length = source.length;

  array || (array = Array(length));
  while (++index < length) {
    array[index] = source[index];
  }
  return array;
}

var _copyArray = copyArray$2;var isObject$7 = isObject_1;

/** Built-in value references. */
var objectCreate = Object.create;

/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */
var baseCreate$1 = (function() {
  function object() {}
  return function(proto) {
    if (!isObject$7(proto)) {
      return {};
    }
    if (objectCreate) {
      return objectCreate(proto);
    }
    object.prototype = proto;
    var result = new object;
    object.prototype = undefined;
    return result;
  };
}());

var _baseCreate = baseCreate$1;var baseCreate = _baseCreate,
    getPrototype = _getPrototype,
    isPrototype$1 = _isPrototype;

/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneObject$2(object) {
  return (typeof object.constructor == 'function' && !isPrototype$1(object))
    ? baseCreate(getPrototype(object))
    : {};
}

var _initCloneObject = initCloneObject$2;var isArrayLike$6 = isArrayLike_1,
    isObjectLike$4 = isObjectLike_1;

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject$5(value) {
  return isObjectLike$4(value) && isArrayLike$6(value);
}

var isArrayLikeObject_1 = isArrayLikeObject$5;/**
 * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */

function safeGet$2(object, key) {
  if (key === 'constructor' && typeof object[key] === 'function') {
    return;
  }

  if (key == '__proto__') {
    return;
  }

  return object[key];
}

var _safeGet = safeGet$2;var assignValue$1 = _assignValue,
    baseAssignValue = _baseAssignValue;

/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject$6(source, props, object, customizer) {
  var isNew = !object;
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];

    var newValue = customizer
      ? customizer(object[key], source[key], key, object, source)
      : undefined;

    if (newValue === undefined) {
      newValue = source[key];
    }
    if (isNew) {
      baseAssignValue(object, key, newValue);
    } else {
      assignValue$1(object, key, newValue);
    }
  }
  return object;
}

var _copyObject = copyObject$6;var copyObject$5 = _copyObject,
    keysIn$3 = keysIn_1;

/**
 * Converts `value` to a plain object flattening inherited enumerable string
 * keyed properties of `value` to own properties of the plain object.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {Object} Returns the converted plain object.
 * @example
 *
 * function Foo() {
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.assign({ 'a': 1 }, new Foo);
 * // => { 'a': 1, 'b': 2 }
 *
 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
 * // => { 'a': 1, 'b': 2, 'c': 3 }
 */
function toPlainObject$1(value) {
  return copyObject$5(value, keysIn$3(value));
}

var toPlainObject_1 = toPlainObject$1;var assignMergeValue$1 = _assignMergeValue,
    cloneBuffer$1 = _cloneBuffer.exports,
    cloneTypedArray$1 = _cloneTypedArray,
    copyArray$1 = _copyArray,
    initCloneObject$1 = _initCloneObject,
    isArguments$1 = isArguments_1,
    isArray$8 = isArray_1,
    isArrayLikeObject$4 = isArrayLikeObject_1,
    isBuffer$3 = isBuffer$7.exports,
    isFunction$1 = isFunction_1,
    isObject$6 = isObject_1,
    isPlainObject$2 = isPlainObject_1,
    isTypedArray$1 = isTypedArray_1,
    safeGet$1 = _safeGet,
    toPlainObject = toPlainObject_1;

/**
 * A specialized version of `baseMerge` for arrays and objects which performs
 * deep merges and tracks traversed objects enabling objects with circular
 * references to be merged.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {string} key The key of the value to merge.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} mergeFunc The function to merge values.
 * @param {Function} [customizer] The function to customize assigned values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */
function baseMergeDeep$1(object, source, key, srcIndex, mergeFunc, customizer, stack) {
  var objValue = safeGet$1(object, key),
      srcValue = safeGet$1(source, key),
      stacked = stack.get(srcValue);

  if (stacked) {
    assignMergeValue$1(object, key, stacked);
    return;
  }
  var newValue = customizer
    ? customizer(objValue, srcValue, (key + ''), object, source, stack)
    : undefined;

  var isCommon = newValue === undefined;

  if (isCommon) {
    var isArr = isArray$8(srcValue),
        isBuff = !isArr && isBuffer$3(srcValue),
        isTyped = !isArr && !isBuff && isTypedArray$1(srcValue);

    newValue = srcValue;
    if (isArr || isBuff || isTyped) {
      if (isArray$8(objValue)) {
        newValue = objValue;
      }
      else if (isArrayLikeObject$4(objValue)) {
        newValue = copyArray$1(objValue);
      }
      else if (isBuff) {
        isCommon = false;
        newValue = cloneBuffer$1(srcValue, true);
      }
      else if (isTyped) {
        isCommon = false;
        newValue = cloneTypedArray$1(srcValue, true);
      }
      else {
        newValue = [];
      }
    }
    else if (isPlainObject$2(srcValue) || isArguments$1(srcValue)) {
      newValue = objValue;
      if (isArguments$1(objValue)) {
        newValue = toPlainObject(objValue);
      }
      else if (!isObject$6(objValue) || isFunction$1(objValue)) {
        newValue = initCloneObject$1(srcValue);
      }
    }
    else {
      isCommon = false;
    }
  }
  if (isCommon) {
    // Recursively merge objects and arrays (susceptible to call stack limits).
    stack.set(srcValue, newValue);
    mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
    stack['delete'](srcValue);
  }
  assignMergeValue$1(object, key, newValue);
}

var _baseMergeDeep = baseMergeDeep$1;var Stack$1 = _Stack,
    assignMergeValue = _assignMergeValue,
    baseFor = _baseFor,
    baseMergeDeep = _baseMergeDeep,
    isObject$5 = isObject_1,
    keysIn$2 = keysIn_1,
    safeGet = _safeGet;

/**
 * The base implementation of `_.merge` without support for multiple sources.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} [customizer] The function to customize merged values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */
function baseMerge$1(object, source, srcIndex, customizer, stack) {
  if (object === source) {
    return;
  }
  baseFor(source, function(srcValue, key) {
    stack || (stack = new Stack$1);
    if (isObject$5(srcValue)) {
      baseMergeDeep(object, source, key, srcIndex, baseMerge$1, customizer, stack);
    }
    else {
      var newValue = customizer
        ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
        : undefined;

      if (newValue === undefined) {
        newValue = srcValue;
      }
      assignMergeValue(object, key, newValue);
    }
  }, keysIn$2);
}

var _baseMerge = baseMerge$1;var identity$2 = identity_1,
    overRest = _overRest,
    setToString = _setToString;

/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */
function baseRest$6(func, start) {
  return setToString(overRest(func, start, identity$2), func + '');
}

var _baseRest = baseRest$6;var eq = eq_1,
    isArrayLike$5 = isArrayLike_1,
    isIndex$1 = _isIndex,
    isObject$4 = isObject_1;

/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */
function isIterateeCall$2(value, index, object) {
  if (!isObject$4(object)) {
    return false;
  }
  var type = typeof index;
  if (type == 'number'
        ? (isArrayLike$5(object) && isIndex$1(index, object.length))
        : (type == 'string' && index in object)
      ) {
    return eq(object[index], value);
  }
  return false;
}

var _isIterateeCall = isIterateeCall$2;var baseRest$5 = _baseRest,
    isIterateeCall$1 = _isIterateeCall;

/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */
function createAssigner$1(assigner) {
  return baseRest$5(function(object, sources) {
    var index = -1,
        length = sources.length,
        customizer = length > 1 ? sources[length - 1] : undefined,
        guard = length > 2 ? sources[2] : undefined;

    customizer = (assigner.length > 3 && typeof customizer == 'function')
      ? (length--, customizer)
      : undefined;

    if (guard && isIterateeCall$1(sources[0], sources[1], guard)) {
      customizer = length < 3 ? undefined : customizer;
      length = 1;
    }
    object = Object(object);
    while (++index < length) {
      var source = sources[index];
      if (source) {
        assigner(object, source, index, customizer);
      }
    }
    return object;
  });
}

var _createAssigner = createAssigner$1;var baseMerge = _baseMerge,
    createAssigner = _createAssigner;

/**
 * This method is like `_.assign` except that it recursively merges own and
 * inherited enumerable string keyed properties of source objects into the
 * destination object. Source properties that resolve to `undefined` are
 * skipped if a destination value exists. Array and plain object properties
 * are merged recursively. Other objects and value types are overridden by
 * assignment. Source objects are applied from left to right. Subsequent
 * sources overwrite property assignments of previous sources.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 0.5.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = {
 *   'a': [{ 'b': 2 }, { 'd': 4 }]
 * };
 *
 * var other = {
 *   'a': [{ 'c': 3 }, { 'e': 5 }]
 * };
 *
 * _.merge(object, other);
 * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
 */
var merge$1 = createAssigner(function(object, source, srcIndex) {
  baseMerge(object, source, srcIndex);
});

var merge_1 = merge$1;// =============================
// Helpers
// =============================

/**
 * Get degree out of a direction for arrow icons
 * Note: Our arrow icon are all facing 'south' by default, that is why 'south' is equal to 0°
 * @param {String} dir - Direction, can be 'east', 'north', 'west' or 'south'
 * @returns {Number} - Returns corresponding degree
 */
var dir2deg = (function (dir) {
  switch (dir) {
    case 'east':
      return '270';

    case 'north':
      return '180';

    case 'west':
      return '90';

    /* SVG is facing south by default */

    case 'south':
    default:
      return '0';
  }
});// =============================
// Helpers
// =============================

/**
 * Pass view props to component
 * @param {Object} props - Set of key value pairs corresponding to the property and the value
 * @returns {Object} - Returns only the necessary props
 */
var getViewProps = (function (props) {
  var viewProps = [// Div
  'bgColor', // background color
  'whiteSpace', // White space (wrap, nowrap)
  'position', // Position (absolute, relative, etc)
  'hide', // Hide/Show element
  'height', // Height
  'minHeight', // Min Height
  'maxHeight', // Max Height
  'width', // Width
  'minWidth', // Min Width
  'maxWidth', // Max Width
  'opacity', // Opacity
  'overflow', // Overflow
  'overflowWrap', // Overflow wrap
  'order', // Flex order
  'margin', // Margin
  'mx', // Horizontal margin
  'ml', // margin-left
  'mr', // margin-right
  'my', // Vertical margin
  'mt', // margin-top
  'mb', // margin-bottom
  'padding', // Padding
  'px', // Horizontal padding
  'pl', // padding-left
  'pr', // padding-right
  'py', // Vertical padding
  'pt', // padding-top
  'pb', // padding-bottom
  'shrink', // flex-shrink
  // Flex
  'flex', // flex
  'align', // align-items
  'justify', // justify-content
  'direction', // flex-direction
  'wrap', // flex-wrap
  'flexBasis' // flex-basis
  ];
  var retProps = {};
  Object.keys(props).forEach(function (key) {
    if (viewProps.indexOf(key) >= 0) {
      retProps[key] = props[key];
    }
  });
  return retProps;
});var _templateObject$S;
// Helpers
// =============================

var hideScrollBar = styled.css(_templateObject$S || (_templateObject$S = _taggedTemplateLiteral$5(["\n  /* Hide scroll bar */\n  -ms-overflow-style: none;\n  scrollbar-width: none;\n\n  &::-webkit-scrollbar {\n    display: none;\n    width: 0 !important;\n  }\n"])));var _templateObject$R;
// Helpers
// =============================

var textEllipsis = styled.css(_templateObject$R || (_templateObject$R = _taggedTemplateLiteral$5(["\n  /** We need to specify a line-height >= 1.3 otherwise letters like 'g' or 'y' are truncated */\n  line-height: 1.3;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n"])));// =============================
// Helpers
// =============================

var helpers = {
  dir2deg: dir2deg,
  getViewProps: getViewProps,
  hideScrollbar: hideScrollBar,
  textEllipsis: textEllipsis
};var _templateObject$Q, _templateObject2$L;
// Theme
// =============================
// NOTE: These colors correspond to the theme of Admin-v2

var colors = {
  background: '#f4f4f4',
  text: '#7f7f7f',
  primary: '#39f',
  primaryText: '#ffffff',
  secondary: '#ffffff',
  secondaryText: '#000000',
  boxShadow: 'rgba(0, 0, 0, 0.1)',
  dropdown: {
    background: '#ffffff',
    text: '#7f7f7f'
  },
  chip: {
    background: '#ffffff',
    text: '#7f7f7f',
    outlineBackground: '#7f7f7f',
    outlineText: '#7f7f7f',
    backgroundAlternate: '#7f7f7f',
    textAlternate: '#ffffff',
    outlineBackgroundAlternate: '#7f7f7f',
    outlineTextAlternate: '#7f7f7f'
  },
  input: {
    background: '#f4f4f4',
    // Used for filter bar input backgrounds
    text: '#333333',
    helpers: {
      // For helper icons (reset, mandatory...)
      background: '#7f7f7f',
      text: '#ffffff'
    }
  },
  notification: {
    background: '#ffffff',
    text: '#7f7f7f',
    primary: '#39f',
    primaryText: '#ffffff',
    boxShadow: 'rgba(0, 0, 0, 0.1)'
  },
  tooltip: {
    background: '#ffffff',
    text: '#7f7f7f',
    primary: '#39f',
    primaryText: '#ffffff',
    boxShadow: 'rgba(0, 0, 0, 0.1)'
  },
  type: {
    cancel: '#828282',
    error: '#e5414f',
    success: '#44bd32',
    warning: '#fa9917'
  },
  black: '#000000',
  white: '#ffffff',
  // The values of filterbar are used to override colors
  // within context of filterBar (search input, lyrics input)
  // Use them through withCustomTheme
  filterBar: {
    background: '#ffffff',
    text: '#7f7f7f',
    primary: '#39f',
    primaryText: '#ffffff',
    input: {
      background: '#f4f4f4',
      // Used for filter bar input backgrounds
      text: '#333333',
      helpers: {
        // For helper icons (reset, mandatory...)
        background: '#7f7f7f',
        text: '#ffffff'
      }
    }
  }
};
var edgeVariant = 'round';
var coverConfig = {
  enableFilter: true
}; // NOTE: Font is not loaded on components anymore but this should be the default font
// You will need to load the font on the application

var fontFamily = {
  primary: '"Mulish", sans-serif'
};
var bp = {
  minHeight: 768,
  minWidth: 1024,
  sxga: 1280,
  wxgaplus: 1440,
  uxga: 1600,
  wuxga: 1920
};
var mediaAbove = Object.keys(bp).reduce(function (acc, label) {
  acc[label] = function () {
    return styled.css(_templateObject$Q || (_templateObject$Q = _taggedTemplateLiteral$5(["\n    @media (min-width: ", "em) {\n      ", ";\n    }\n  "])), bp[label] / 16, styled.css.apply(void 0, arguments));
  };

  return acc;
}, {});
var mediaBelow = Object.keys(bp).reduce(function (acc, label) {
  acc[label] = function () {
    return styled.css(_templateObject2$L || (_templateObject2$L = _taggedTemplateLiteral$5(["\n    @media (max-width: ", "em) {\n      ", ";\n    }\n  "])), (bp[label] - 1) / 16, styled.css.apply(void 0, arguments));
  };

  return acc;
}, {});
var fontWeight = {
  hairline: 100,
  thin: 200,
  light: 300,
  normal: 400,
  medium: 500,
  semibold: 600,
  bold: 700,
  extrabold: 800,
  black: 900
};

var pxToRem = function pxToRem(v) {
  return v / 10;
};

var transition = {
  slow: '1s',
  medium: '0.3s',
  fast: '0.1s',
  numeric: {
    slow: '1',
    medium: '0.3',
    fast: '0.1'
  }
};
var transitionTiming = {
  easeIn: 'cubic-bezier(0.55, 0.05, 0.67, 0.19)',
  easeOut: 'cubic-bezier(0.22, 0.61,0.35,1)',
  easeInOut: 'cubic-bezier(0.64, 0.04, 0.35, 1)',

  /** react-pose need array value */
  pose: {
    easeIn: [0.55, 0.05, 0.67, 0.19],
    easeOut: [0.22, 0.61, 0.35, 1],
    easeInOut: [0.64, 0.04, 0.35, 1]
  }
};
var zIndex = {
  scAppShellBackground: -10,
  scAppShellContent: 0,
  header: 10,
  sidePanel: 11,
  // Need to be above header
  scFilterBar: 30,
  scMusicPlayer: 35,
  scPresearch: 40,
  scPresearchCloseButton: 41,
  scHeader: 42,
  scSearchBar: 43,
  // Need to be above scHeader.
  // mui-mobile stepper: 1000
  // mui-app bar: 1100
  // mui-drawer: 1200
  // mui-modal: 1300
  modal: 1300,
  dropdown: 1350,
  // Need to be above modal
  scMenuBackground: 1400,
  scMenu: 1401,
  scMenuButton: 1402,
  // Need to be above 'scMenu', or you won't be able to close the menu
  scHeaderLogo: 1403,
  // Need to be above 'modal' and filterBar
  // mui-snackbar: 1400
  // mui-tooltip: 1500
  loader: 1600,
  initLoader: 1700,
  notifications: 1800,
  devTools: 9999
}; // =============================
// Theme Export
// =============================

var theme = {
  bp: bp,
  colors: colors,
  edgeVariant: edgeVariant,
  coverConfig: coverConfig,
  fontFamily: fontFamily,
  fontWeight: fontWeight,
  helpers: helpers,
  mediaAbove: mediaAbove,
  mediaBelow: mediaBelow,
  pxToRem: pxToRem,
  transition: transition,
  transitionTiming: transitionTiming,
  zIndex: zIndex
};// =============================
// Theme
// =============================

var muitheme = {
  // https://material-ui.com/customization/palette/
  palette: {
    primary: {
      main: theme.colors.primary,
      contrastText: theme.colors.primaryText
    }
  },
  shadows: Array(25).fill('none'),
  // Remove every box-shadow on every material ui components
  shape: {
    borderRadius: 5
  },
  typography: {
    fontFamily: theme.fontFamily.primary
  },
  overrides: {
    MuiPickersCalendarHeader: {
      iconButton: {
        color: theme.colors.dropdown.text,
        '&:disabled': {
          color: alpha$2(theme.colors.dropdown.text, 0.3)
        },
        '&:hover': {
          backgroundColor: alpha$2(theme.colors.dropdown.text, 0.1)
        }
      },
      switchHeader: {
        color: theme.colors.dropdown.text
      }
    },
    MuiPickersDay: {
      day: {
        color: theme.colors.dropdown.text,
        '&:hover': {
          backgroundColor: alpha$2(theme.colors.dropdown.text, 0.1)
        }
      },
      daySelected: {
        backgroundColor: theme.colors.primary,
        color: theme.colors.primaryText
      },
      dayDisabled: {
        color: alpha$2(theme.colors.dropdown.text, 0.3)
      },
      current: {
        color: theme.colors.primary
      }
    }
  },
  props: {
    MuiIconButton: {
      disableRipple: true
    }
  }
};var _templateObject$P, _templateObject2$K;
// Styles
// =============================

var GlobalStyle = /*#__PURE__*/React__default['default'].memo(styled.createGlobalStyle(_templateObject$P || (_templateObject$P = _taggedTemplateLiteral$5(["\n  html {\n    box-sizing: border-box;\n    color: ", ";\n    font-family: ", ";\n    font-size: 62.5%;\n    line-height: 1;\n    -webkit-font-smoothing: antialiased;\n\n    ", ";\n  }\n\n  body {\n    font-size: 14px;\n  }\n\n  /** We use wildcard because is-locked- might not be the 1st class on body. */\n  body[class*=\"is-locked-\"] {\n    overflow: hidden;\n    position: relative;\n  }\n\n  *,\n  *:before,\n  *:after {\n    box-sizing: inherit;\n  }\n\n  * {\n    word-break: break-word;\n  }\n\n  input:-webkit-autofill,\n  input:-webkit-autofill:hover,\n  input:-webkit-autofill:focus\n  input:-internal-autofill-previewed,\n  input:-internal-autofill-selected,\n  textarea:-webkit-autofill,\n  textarea:-webkit-autofill:hover\n  textarea:-webkit-autofill:focus,\n  textarea:-internal-autofill-previewed,\n  textarea:-internal-autofill-selected,\n  select:-webkit-autofill,\n  select:-webkit-autofill:hover,\n  select:-webkit-autofill:focus,\n  select:-internal-autofill-previewed,\n  select:-internal-autofill-selected {\n    background-color: transparent !important;\n    border: none !important;\n    box-shadow: none !important;\n    -webkit-box-shadow: none !important;\n    color: inherit !important;\n    -webkit-text-fill-color: inherit !important;\n    /** With such a long transition duration, browser can't change background-color & color... */\n    transition: background-color 5000s ease-in-out 0s, color 5000s ease-in-out 0s !important;\n  }\n\n  body,\n  h1,\n  h2,\n  h3,\n  h4,\n  h5,\n  h6,\n  p,\n  ol,\n  ul {\n    margin: 0;\n    padding: 0;\n    font-weight: inherit;\n  }\n\n  a {\n    color: inherit;\n    font-family: inherit;\n  }\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.colors.text;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.fontFamily.primary;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.mediaAbove.minWidth(_templateObject2$K || (_templateObject2$K = _taggedTemplateLiteral$5(["\n      min-width: ", "px;\n    "])), theme.bp.minWidth);
}));// =============================
// Styles
// =============================

var AppTheme = /*#__PURE__*/React__default['default'].memo(function (_ref) {
  var children = _ref.children,
      muiThemeOverride = _ref.muiThemeOverride,
      themeOverride = _ref.themeOverride;

  var Theme = merge_1(theme, themeOverride);

  var MuiTheme = createTheme(merge_1(muitheme, muiThemeOverride));
  return /*#__PURE__*/React__default['default'].createElement(styled.ThemeProvider, {
    theme: Theme
  }, /*#__PURE__*/React__default['default'].createElement(ThemeProvider, {
    theme: MuiTheme
  }, /*#__PURE__*/React__default['default'].createElement(MuiPickersUtilsProvider, {
    utils: DayjsUtils
  }, /*#__PURE__*/React__default['default'].createElement(GlobalStyle, {
    theme: Theme
  }), children)));
});
AppTheme.propTypes = {
  /** Children node */
  children: PropTypes__default['default'].node.isRequired,

  /** Object that override Mui theme object */
  muiThemeOverride: PropTypes__default['default'].object.isRequired,
  // eslint-disable-line react/forbid-prop-types

  /** Object that override theme object */
  themeOverride: PropTypes__default['default'].object.isRequired // eslint-disable-line react/forbid-prop-types

};// Theme
// =============================

var AppThemeProvider = /*#__PURE__*/React__default['default'].memo(function (_ref) {
  var children = _ref.children,
      locale = _ref.locale,
      themeOverride = _ref.themeOverride,
      muiThemeOverride = _ref.muiThemeOverride;
  dayjs__default['default'].locale(locale);
  dayjs__default['default'].extend(relativeTime);
  return /*#__PURE__*/React__default['default'].createElement(AppTheme, {
    themeOverride: themeOverride,
    muiThemeOverride: muiThemeOverride
  }, children);
});
AppThemeProvider.propTypes = {
  /** Children node */
  children: PropTypes__default['default'].node.isRequired,

  /** Locale used */
  locale: PropTypes__default['default'].string.isRequired,

  /** Object that override Mui theme object */
  muiThemeOverride: PropTypes__default['default'].object,
  // eslint-disable-line react/forbid-prop-types

  /** Object that override theme object */
  themeOverride: PropTypes__default['default'].object // eslint-disable-line react/forbid-prop-types

};
AppThemeProvider.defaultProps = {
  muiThemeOverride: {},
  themeOverride: {}
};var axios$2 = {exports: {}};var bind$2 = function bind(fn, thisArg) {
  return function wrap() {
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }
    return fn.apply(thisArg, args);
  };
};var bind$1 = bind$2;

/*global toString:true*/

// utils is a library of generic helper functions non-specific to axios

var toString = Object.prototype.toString;

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */
function isArray$7(val) {
  return toString.call(val) === '[object Array]';
}

/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */
function isUndefined$1(val) {
  return typeof val === 'undefined';
}

/**
 * Determine if a value is a Buffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Buffer, otherwise false
 */
function isBuffer$2(val) {
  return val !== null && !isUndefined$1(val) && val.constructor !== null && !isUndefined$1(val.constructor)
    && typeof val.constructor.isBuffer === 'function' && val.constructor.isBuffer(val);
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
function isArrayBuffer(val) {
  return toString.call(val) === '[object ArrayBuffer]';
}

/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */
function isFormData(val) {
  return (typeof FormData !== 'undefined') && (val instanceof FormData);
}

/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
  var result;
  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
    result = ArrayBuffer.isView(val);
  } else {
    result = (val) && (val.buffer) && (val.buffer instanceof ArrayBuffer);
  }
  return result;
}

/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */
function isString$2(val) {
  return typeof val === 'string';
}

/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */
function isNumber(val) {
  return typeof val === 'number';
}

/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */
function isObject$3(val) {
  return val !== null && typeof val === 'object';
}

/**
 * Determine if a value is a plain Object
 *
 * @param {Object} val The value to test
 * @return {boolean} True if value is a plain Object, otherwise false
 */
function isPlainObject$1(val) {
  if (toString.call(val) !== '[object Object]') {
    return false;
  }

  var prototype = Object.getPrototypeOf(val);
  return prototype === null || prototype === Object.prototype;
}

/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */
function isDate(val) {
  return toString.call(val) === '[object Date]';
}

/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */
function isFile(val) {
  return toString.call(val) === '[object File]';
}

/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */
function isBlob(val) {
  return toString.call(val) === '[object Blob]';
}

/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
function isFunction(val) {
  return toString.call(val) === '[object Function]';
}

/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */
function isStream(val) {
  return isObject$3(val) && isFunction(val.pipe);
}

/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */
function isURLSearchParams(val) {
  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
}

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */
function trim(str) {
  return str.replace(/^\s*/, '').replace(/\s*$/, '');
}

/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 */
function isStandardBrowserEnv() {
  if (typeof navigator !== 'undefined' && (navigator.product === 'ReactNative' ||
                                           navigator.product === 'NativeScript' ||
                                           navigator.product === 'NS')) {
    return false;
  }
  return (
    typeof window !== 'undefined' &&
    typeof document !== 'undefined'
  );
}

/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */
function forEach$1(obj, fn) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  // Force an array if not already something iterable
  if (typeof obj !== 'object') {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray$7(obj)) {
    // Iterate over array values
    for (var i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        fn.call(null, obj[key], key, obj);
      }
    }
  }
}

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function merge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (isPlainObject$1(result[key]) && isPlainObject$1(val)) {
      result[key] = merge(result[key], val);
    } else if (isPlainObject$1(val)) {
      result[key] = merge({}, val);
    } else if (isArray$7(val)) {
      result[key] = val.slice();
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach$1(arguments[i], assignValue);
  }
  return result;
}

/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */
function extend(a, b, thisArg) {
  forEach$1(b, function assignValue(val, key) {
    if (thisArg && typeof val === 'function') {
      a[key] = bind$1(val, thisArg);
    } else {
      a[key] = val;
    }
  });
  return a;
}

/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 * @return {string} content value without BOM
 */
function stripBOM(content) {
  if (content.charCodeAt(0) === 0xFEFF) {
    content = content.slice(1);
  }
  return content;
}

var utils$e = {
  isArray: isArray$7,
  isArrayBuffer: isArrayBuffer,
  isBuffer: isBuffer$2,
  isFormData: isFormData,
  isArrayBufferView: isArrayBufferView,
  isString: isString$2,
  isNumber: isNumber,
  isObject: isObject$3,
  isPlainObject: isPlainObject$1,
  isUndefined: isUndefined$1,
  isDate: isDate,
  isFile: isFile,
  isBlob: isBlob,
  isFunction: isFunction,
  isStream: isStream,
  isURLSearchParams: isURLSearchParams,
  isStandardBrowserEnv: isStandardBrowserEnv,
  forEach: forEach$1,
  merge: merge,
  extend: extend,
  trim: trim,
  stripBOM: stripBOM
};var utils$d = utils$e;

function encode(val) {
  return encodeURIComponent(val).
    replace(/%3A/gi, ':').
    replace(/%24/g, '$').
    replace(/%2C/gi, ',').
    replace(/%20/g, '+').
    replace(/%5B/gi, '[').
    replace(/%5D/gi, ']');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */
var buildURL$2 = function buildURL(url, params, paramsSerializer) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }

  var serializedParams;
  if (paramsSerializer) {
    serializedParams = paramsSerializer(params);
  } else if (utils$d.isURLSearchParams(params)) {
    serializedParams = params.toString();
  } else {
    var parts = [];

    utils$d.forEach(params, function serialize(val, key) {
      if (val === null || typeof val === 'undefined') {
        return;
      }

      if (utils$d.isArray(val)) {
        key = key + '[]';
      } else {
        val = [val];
      }

      utils$d.forEach(val, function parseValue(v) {
        if (utils$d.isDate(v)) {
          v = v.toISOString();
        } else if (utils$d.isObject(v)) {
          v = JSON.stringify(v);
        }
        parts.push(encode(key) + '=' + encode(v));
      });
    });

    serializedParams = parts.join('&');
  }

  if (serializedParams) {
    var hashmarkIndex = url.indexOf('#');
    if (hashmarkIndex !== -1) {
      url = url.slice(0, hashmarkIndex);
    }

    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
};var utils$c = utils$e;

function InterceptorManager$1() {
  this.handlers = [];
}

/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */
InterceptorManager$1.prototype.use = function use(fulfilled, rejected) {
  this.handlers.push({
    fulfilled: fulfilled,
    rejected: rejected
  });
  return this.handlers.length - 1;
};

/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */
InterceptorManager$1.prototype.eject = function eject(id) {
  if (this.handlers[id]) {
    this.handlers[id] = null;
  }
};

/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */
InterceptorManager$1.prototype.forEach = function forEach(fn) {
  utils$c.forEach(this.handlers, function forEachHandler(h) {
    if (h !== null) {
      fn(h);
    }
  });
};

var InterceptorManager_1 = InterceptorManager$1;var utils$b = utils$e;

/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */
var transformData$1 = function transformData(data, headers, fns) {
  /*eslint no-param-reassign:0*/
  utils$b.forEach(fns, function transform(fn) {
    data = fn(data, headers);
  });

  return data;
};var isCancel$1 = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};var utils$a = utils$e;

var normalizeHeaderName$1 = function normalizeHeaderName(headers, normalizedName) {
  utils$a.forEach(headers, function processHeader(value, name) {
    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
      headers[normalizedName] = value;
      delete headers[name];
    }
  });
};/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The error.
 */
var enhanceError$1 = function enhanceError(error, config, code, request, response) {
  error.config = config;
  if (code) {
    error.code = code;
  }

  error.request = request;
  error.response = response;
  error.isAxiosError = true;

  error.toJSON = function toJSON() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: this.config,
      code: this.code
    };
  };
  return error;
};var enhanceError = enhanceError$1;

/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */
var createError$2 = function createError(message, config, code, request, response) {
  var error = new Error(message);
  return enhanceError(error, config, code, request, response);
};var createError$1 = createError$2;

/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */
var settle$1 = function settle(resolve, reject, response) {
  var validateStatus = response.config.validateStatus;
  if (!response.status || !validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(createError$1(
      'Request failed with status code ' + response.status,
      response.config,
      null,
      response.request,
      response
    ));
  }
};var utils$9 = utils$e;

var cookies$1 = (
  utils$9.isStandardBrowserEnv() ?

  // Standard browser envs support document.cookie
    (function standardBrowserEnv() {
      return {
        write: function write(name, value, expires, path, domain, secure) {
          var cookie = [];
          cookie.push(name + '=' + encodeURIComponent(value));

          if (utils$9.isNumber(expires)) {
            cookie.push('expires=' + new Date(expires).toGMTString());
          }

          if (utils$9.isString(path)) {
            cookie.push('path=' + path);
          }

          if (utils$9.isString(domain)) {
            cookie.push('domain=' + domain);
          }

          if (secure === true) {
            cookie.push('secure');
          }

          document.cookie = cookie.join('; ');
        },

        read: function read(name) {
          var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
          return (match ? decodeURIComponent(match[3]) : null);
        },

        remove: function remove(name) {
          this.write(name, '', Date.now() - 86400000);
        }
      };
    })() :

  // Non standard browser env (web workers, react-native) lack needed support.
    (function nonStandardBrowserEnv() {
      return {
        write: function write() {},
        read: function read() { return null; },
        remove: function remove() {}
      };
    })()
);/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */
var isAbsoluteURL$1 = function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
};/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */
var combineURLs$1 = function combineURLs(baseURL, relativeURL) {
  return relativeURL
    ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
    : baseURL;
};var isAbsoluteURL = isAbsoluteURL$1;
var combineURLs = combineURLs$1;

/**
 * Creates a new URL by combining the baseURL with the requestedURL,
 * only when the requestedURL is not already an absolute URL.
 * If the requestURL is absolute, this function returns the requestedURL untouched.
 *
 * @param {string} baseURL The base URL
 * @param {string} requestedURL Absolute or relative URL to combine
 * @returns {string} The combined full path
 */
var buildFullPath$1 = function buildFullPath(baseURL, requestedURL) {
  if (baseURL && !isAbsoluteURL(requestedURL)) {
    return combineURLs(baseURL, requestedURL);
  }
  return requestedURL;
};var utils$8 = utils$e;

// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var ignoreDuplicateOf = [
  'age', 'authorization', 'content-length', 'content-type', 'etag',
  'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
  'last-modified', 'location', 'max-forwards', 'proxy-authorization',
  'referer', 'retry-after', 'user-agent'
];

/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */
var parseHeaders$1 = function parseHeaders(headers) {
  var parsed = {};
  var key;
  var val;
  var i;

  if (!headers) { return parsed; }

  utils$8.forEach(headers.split('\n'), function parser(line) {
    i = line.indexOf(':');
    key = utils$8.trim(line.substr(0, i)).toLowerCase();
    val = utils$8.trim(line.substr(i + 1));

    if (key) {
      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
        return;
      }
      if (key === 'set-cookie') {
        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
      } else {
        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
      }
    }
  });

  return parsed;
};var utils$7 = utils$e;

var isURLSameOrigin$1 = (
  utils$7.isStandardBrowserEnv() ?

  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
    (function standardBrowserEnv() {
      var msie = /(msie|trident)/i.test(navigator.userAgent);
      var urlParsingNode = document.createElement('a');
      var originURL;

      /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */
      function resolveURL(url) {
        var href = url;

        if (msie) {
        // IE needs attribute set twice to normalize properties
          urlParsingNode.setAttribute('href', href);
          href = urlParsingNode.href;
        }

        urlParsingNode.setAttribute('href', href);

        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
        return {
          href: urlParsingNode.href,
          protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
          host: urlParsingNode.host,
          search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
          hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
          hostname: urlParsingNode.hostname,
          port: urlParsingNode.port,
          pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
            urlParsingNode.pathname :
            '/' + urlParsingNode.pathname
        };
      }

      originURL = resolveURL(window.location.href);

      /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */
      return function isURLSameOrigin(requestURL) {
        var parsed = (utils$7.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
        return (parsed.protocol === originURL.protocol &&
            parsed.host === originURL.host);
      };
    })() :

  // Non standard browser envs (web workers, react-native) lack needed support.
    (function nonStandardBrowserEnv() {
      return function isURLSameOrigin() {
        return true;
      };
    })()
);var utils$6 = utils$e;
var settle = settle$1;
var cookies = cookies$1;
var buildURL$1 = buildURL$2;
var buildFullPath = buildFullPath$1;
var parseHeaders = parseHeaders$1;
var isURLSameOrigin = isURLSameOrigin$1;
var createError = createError$2;

var xhr = function xhrAdapter(config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    var requestData = config.data;
    var requestHeaders = config.headers;

    if (utils$6.isFormData(requestData)) {
      delete requestHeaders['Content-Type']; // Let the browser set it
    }

    var request = new XMLHttpRequest();

    // HTTP basic authentication
    if (config.auth) {
      var username = config.auth.username || '';
      var password = config.auth.password ? unescape(encodeURIComponent(config.auth.password)) : '';
      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
    }

    var fullPath = buildFullPath(config.baseURL, config.url);
    request.open(config.method.toUpperCase(), buildURL$1(fullPath, config.params, config.paramsSerializer), true);

    // Set the request timeout in MS
    request.timeout = config.timeout;

    // Listen for ready state
    request.onreadystatechange = function handleLoad() {
      if (!request || request.readyState !== 4) {
        return;
      }

      // The request errored out and we didn't get a response, this will be
      // handled by onerror instead
      // With one exception: request that using file: protocol, most browsers
      // will return status as 0 even though it's a successful request
      if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
        return;
      }

      // Prepare the response
      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
      var responseData = !config.responseType || config.responseType === 'text' ? request.responseText : request.response;
      var response = {
        data: responseData,
        status: request.status,
        statusText: request.statusText,
        headers: responseHeaders,
        config: config,
        request: request
      };

      settle(resolve, reject, response);

      // Clean up request
      request = null;
    };

    // Handle browser request cancellation (as opposed to a manual cancellation)
    request.onabort = function handleAbort() {
      if (!request) {
        return;
      }

      reject(createError('Request aborted', config, 'ECONNABORTED', request));

      // Clean up request
      request = null;
    };

    // Handle low level network errors
    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(createError('Network Error', config, null, request));

      // Clean up request
      request = null;
    };

    // Handle timeout
    request.ontimeout = function handleTimeout() {
      var timeoutErrorMessage = 'timeout of ' + config.timeout + 'ms exceeded';
      if (config.timeoutErrorMessage) {
        timeoutErrorMessage = config.timeoutErrorMessage;
      }
      reject(createError(timeoutErrorMessage, config, 'ECONNABORTED',
        request));

      // Clean up request
      request = null;
    };

    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if (utils$6.isStandardBrowserEnv()) {
      // Add xsrf header
      var xsrfValue = (config.withCredentials || isURLSameOrigin(fullPath)) && config.xsrfCookieName ?
        cookies.read(config.xsrfCookieName) :
        undefined;

      if (xsrfValue) {
        requestHeaders[config.xsrfHeaderName] = xsrfValue;
      }
    }

    // Add headers to the request
    if ('setRequestHeader' in request) {
      utils$6.forEach(requestHeaders, function setRequestHeader(val, key) {
        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
          // Remove Content-Type if data is undefined
          delete requestHeaders[key];
        } else {
          // Otherwise add header to the request
          request.setRequestHeader(key, val);
        }
      });
    }

    // Add withCredentials to request if needed
    if (!utils$6.isUndefined(config.withCredentials)) {
      request.withCredentials = !!config.withCredentials;
    }

    // Add responseType to request if needed
    if (config.responseType) {
      try {
        request.responseType = config.responseType;
      } catch (e) {
        // Expected DOMException thrown by browsers not compatible XMLHttpRequest Level 2.
        // But, this can be suppressed for 'json' type as it can be parsed by default 'transformResponse' function.
        if (config.responseType !== 'json') {
          throw e;
        }
      }
    }

    // Handle progress if needed
    if (typeof config.onDownloadProgress === 'function') {
      request.addEventListener('progress', config.onDownloadProgress);
    }

    // Not all browsers support upload events
    if (typeof config.onUploadProgress === 'function' && request.upload) {
      request.upload.addEventListener('progress', config.onUploadProgress);
    }

    if (config.cancelToken) {
      // Handle cancellation
      config.cancelToken.promise.then(function onCanceled(cancel) {
        if (!request) {
          return;
        }

        request.abort();
        reject(cancel);
        // Clean up request
        request = null;
      });
    }

    if (!requestData) {
      requestData = null;
    }

    // Send the request
    request.send(requestData);
  });
};var utils$5 = utils$e;
var normalizeHeaderName = normalizeHeaderName$1;

var DEFAULT_CONTENT_TYPE = {
  'Content-Type': 'application/x-www-form-urlencoded'
};

function setContentTypeIfUnset(headers, value) {
  if (!utils$5.isUndefined(headers) && utils$5.isUndefined(headers['Content-Type'])) {
    headers['Content-Type'] = value;
  }
}

function getDefaultAdapter() {
  var adapter;
  if (typeof XMLHttpRequest !== 'undefined') {
    // For browsers use XHR adapter
    adapter = xhr;
  } else if (typeof process !== 'undefined' && Object.prototype.toString.call(process) === '[object process]') {
    // For node use HTTP adapter
    adapter = xhr;
  }
  return adapter;
}

var defaults$2 = {
  adapter: getDefaultAdapter(),

  transformRequest: [function transformRequest(data, headers) {
    normalizeHeaderName(headers, 'Accept');
    normalizeHeaderName(headers, 'Content-Type');
    if (utils$5.isFormData(data) ||
      utils$5.isArrayBuffer(data) ||
      utils$5.isBuffer(data) ||
      utils$5.isStream(data) ||
      utils$5.isFile(data) ||
      utils$5.isBlob(data)
    ) {
      return data;
    }
    if (utils$5.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils$5.isURLSearchParams(data)) {
      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
      return data.toString();
    }
    if (utils$5.isObject(data)) {
      setContentTypeIfUnset(headers, 'application/json;charset=utf-8');
      return JSON.stringify(data);
    }
    return data;
  }],

  transformResponse: [function transformResponse(data) {
    /*eslint no-param-reassign:0*/
    if (typeof data === 'string') {
      try {
        data = JSON.parse(data);
      } catch (e) { /* Ignore */ }
    }
    return data;
  }],

  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,

  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',

  maxContentLength: -1,
  maxBodyLength: -1,

  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  }
};

defaults$2.headers = {
  common: {
    'Accept': 'application/json, text/plain, */*'
  }
};

utils$5.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
  defaults$2.headers[method] = {};
});

utils$5.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  defaults$2.headers[method] = utils$5.merge(DEFAULT_CONTENT_TYPE);
});

var defaults_1 = defaults$2;var utils$4 = utils$e;
var transformData = transformData$1;
var isCancel = isCancel$1;
var defaults$1 = defaults_1;

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }
}

/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */
var dispatchRequest$1 = function dispatchRequest(config) {
  throwIfCancellationRequested(config);

  // Ensure headers exist
  config.headers = config.headers || {};

  // Transform request data
  config.data = transformData(
    config.data,
    config.headers,
    config.transformRequest
  );

  // Flatten headers
  config.headers = utils$4.merge(
    config.headers.common || {},
    config.headers[config.method] || {},
    config.headers
  );

  utils$4.forEach(
    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
    function cleanHeaderConfig(method) {
      delete config.headers[method];
    }
  );

  var adapter = config.adapter || defaults$1.adapter;

  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);

    // Transform response data
    response.data = transformData(
      response.data,
      response.headers,
      config.transformResponse
    );

    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config);

      // Transform response data
      if (reason && reason.response) {
        reason.response.data = transformData(
          reason.response.data,
          reason.response.headers,
          config.transformResponse
        );
      }
    }

    return Promise.reject(reason);
  });
};var utils$3 = utils$e;

/**
 * Config-specific merge-function which creates a new config-object
 * by merging two configuration objects together.
 *
 * @param {Object} config1
 * @param {Object} config2
 * @returns {Object} New object resulting from merging config2 to config1
 */
var mergeConfig$2 = function mergeConfig(config1, config2) {
  // eslint-disable-next-line no-param-reassign
  config2 = config2 || {};
  var config = {};

  var valueFromConfig2Keys = ['url', 'method', 'data'];
  var mergeDeepPropertiesKeys = ['headers', 'auth', 'proxy', 'params'];
  var defaultToConfig2Keys = [
    'baseURL', 'transformRequest', 'transformResponse', 'paramsSerializer',
    'timeout', 'timeoutMessage', 'withCredentials', 'adapter', 'responseType', 'xsrfCookieName',
    'xsrfHeaderName', 'onUploadProgress', 'onDownloadProgress', 'decompress',
    'maxContentLength', 'maxBodyLength', 'maxRedirects', 'transport', 'httpAgent',
    'httpsAgent', 'cancelToken', 'socketPath', 'responseEncoding'
  ];
  var directMergeKeys = ['validateStatus'];

  function getMergedValue(target, source) {
    if (utils$3.isPlainObject(target) && utils$3.isPlainObject(source)) {
      return utils$3.merge(target, source);
    } else if (utils$3.isPlainObject(source)) {
      return utils$3.merge({}, source);
    } else if (utils$3.isArray(source)) {
      return source.slice();
    }
    return source;
  }

  function mergeDeepProperties(prop) {
    if (!utils$3.isUndefined(config2[prop])) {
      config[prop] = getMergedValue(config1[prop], config2[prop]);
    } else if (!utils$3.isUndefined(config1[prop])) {
      config[prop] = getMergedValue(undefined, config1[prop]);
    }
  }

  utils$3.forEach(valueFromConfig2Keys, function valueFromConfig2(prop) {
    if (!utils$3.isUndefined(config2[prop])) {
      config[prop] = getMergedValue(undefined, config2[prop]);
    }
  });

  utils$3.forEach(mergeDeepPropertiesKeys, mergeDeepProperties);

  utils$3.forEach(defaultToConfig2Keys, function defaultToConfig2(prop) {
    if (!utils$3.isUndefined(config2[prop])) {
      config[prop] = getMergedValue(undefined, config2[prop]);
    } else if (!utils$3.isUndefined(config1[prop])) {
      config[prop] = getMergedValue(undefined, config1[prop]);
    }
  });

  utils$3.forEach(directMergeKeys, function merge(prop) {
    if (prop in config2) {
      config[prop] = getMergedValue(config1[prop], config2[prop]);
    } else if (prop in config1) {
      config[prop] = getMergedValue(undefined, config1[prop]);
    }
  });

  var axiosKeys = valueFromConfig2Keys
    .concat(mergeDeepPropertiesKeys)
    .concat(defaultToConfig2Keys)
    .concat(directMergeKeys);

  var otherKeys = Object
    .keys(config1)
    .concat(Object.keys(config2))
    .filter(function filterAxiosKeys(key) {
      return axiosKeys.indexOf(key) === -1;
    });

  utils$3.forEach(otherKeys, mergeDeepProperties);

  return config;
};var utils$2 = utils$e;
var buildURL = buildURL$2;
var InterceptorManager = InterceptorManager_1;
var dispatchRequest = dispatchRequest$1;
var mergeConfig$1 = mergeConfig$2;

/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */
function Axios$1(instanceConfig) {
  this.defaults = instanceConfig;
  this.interceptors = {
    request: new InterceptorManager(),
    response: new InterceptorManager()
  };
}

/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */
Axios$1.prototype.request = function request(config) {
  /*eslint no-param-reassign:0*/
  // Allow for axios('example/url'[, config]) a la fetch API
  if (typeof config === 'string') {
    config = arguments[1] || {};
    config.url = arguments[0];
  } else {
    config = config || {};
  }

  config = mergeConfig$1(this.defaults, config);

  // Set config.method
  if (config.method) {
    config.method = config.method.toLowerCase();
  } else if (this.defaults.method) {
    config.method = this.defaults.method.toLowerCase();
  } else {
    config.method = 'get';
  }

  // Hook up interceptors middleware
  var chain = [dispatchRequest, undefined];
  var promise = Promise.resolve(config);

  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
    chain.unshift(interceptor.fulfilled, interceptor.rejected);
  });

  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
    chain.push(interceptor.fulfilled, interceptor.rejected);
  });

  while (chain.length) {
    promise = promise.then(chain.shift(), chain.shift());
  }

  return promise;
};

Axios$1.prototype.getUri = function getUri(config) {
  config = mergeConfig$1(this.defaults, config);
  return buildURL(config.url, config.params, config.paramsSerializer).replace(/^\?/, '');
};

// Provide aliases for supported request methods
utils$2.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios$1.prototype[method] = function(url, config) {
    return this.request(mergeConfig$1(config || {}, {
      method: method,
      url: url,
      data: (config || {}).data
    }));
  };
});

utils$2.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/
  Axios$1.prototype[method] = function(url, data, config) {
    return this.request(mergeConfig$1(config || {}, {
      method: method,
      url: url,
      data: data
    }));
  };
});

var Axios_1 = Axios$1;/**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */
function Cancel$1(message) {
  this.message = message;
}

Cancel$1.prototype.toString = function toString() {
  return 'Cancel' + (this.message ? ': ' + this.message : '');
};

Cancel$1.prototype.__CANCEL__ = true;

var Cancel_1 = Cancel$1;var Cancel = Cancel_1;

/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */
function CancelToken(executor) {
  if (typeof executor !== 'function') {
    throw new TypeError('executor must be a function.');
  }

  var resolvePromise;
  this.promise = new Promise(function promiseExecutor(resolve) {
    resolvePromise = resolve;
  });

  var token = this;
  executor(function cancel(message) {
    if (token.reason) {
      // Cancellation has already been requested
      return;
    }

    token.reason = new Cancel(message);
    resolvePromise(token.reason);
  });
}

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
CancelToken.prototype.throwIfRequested = function throwIfRequested() {
  if (this.reason) {
    throw this.reason;
  }
};

/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */
CancelToken.source = function source() {
  var cancel;
  var token = new CancelToken(function executor(c) {
    cancel = c;
  });
  return {
    token: token,
    cancel: cancel
  };
};

var CancelToken_1 = CancelToken;/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */
var spread = function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
};/**
 * Determines whether the payload is an error thrown by Axios
 *
 * @param {*} payload The value to test
 * @returns {boolean} True if the payload is an error thrown by Axios, otherwise false
 */
var isAxiosError = function isAxiosError(payload) {
  return (typeof payload === 'object') && (payload.isAxiosError === true);
};var utils$1 = utils$e;
var bind = bind$2;
var Axios = Axios_1;
var mergeConfig = mergeConfig$2;
var defaults = defaults_1;

/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */
function createInstance(defaultConfig) {
  var context = new Axios(defaultConfig);
  var instance = bind(Axios.prototype.request, context);

  // Copy axios.prototype to instance
  utils$1.extend(instance, Axios.prototype, context);

  // Copy context to instance
  utils$1.extend(instance, context);

  return instance;
}

// Create the default instance to be exported
var axios$1 = createInstance(defaults);

// Expose Axios class to allow class inheritance
axios$1.Axios = Axios;

// Factory for creating new instances
axios$1.create = function create(instanceConfig) {
  return createInstance(mergeConfig(axios$1.defaults, instanceConfig));
};

// Expose Cancel & CancelToken
axios$1.Cancel = Cancel_1;
axios$1.CancelToken = CancelToken_1;
axios$1.isCancel = isCancel$1;

// Expose all/spread
axios$1.all = function all(promises) {
  return Promise.all(promises);
};
axios$1.spread = spread;

// Expose isAxiosError
axios$1.isAxiosError = isAxiosError;

axios$2.exports = axios$1;

// Allow use of default import syntax in TypeScript
axios$2.exports.default = axios$1;var axios = axios$2.exports;var _templateObject$O, _templateObject2$J, _templateObject3$C, _templateObject4$x, _templateObject5$u, _templateObject6$n, _templateObject7$j, _templateObject8$i, _templateObject9$d, _templateObject10$c, _templateObject11$c, _templateObject12$a, _templateObject13$9, _templateObject14$9, _templateObject15$8, _templateObject16$5, _templateObject17$5, _templateObject18$4, _templateObject19$3, _templateObject20$3, _templateObject21$3, _templateObject22$2, _templateObject23$1, _templateObject24$1, _templateObject25$1, _templateObject26$1, _templateObject27$1, _templateObject28$1, _templateObject29$1, _templateObject30$1, _templateObject31$1, _templateObject32$1;
// Component
// =============================

var Div = styled__default['default'].div(_templateObject$O || (_templateObject$O = _taggedTemplateLiteral$5(["\n  ", ";\n\n  ", ";\n\n  ", ";\n\n  ", ";\n\n  ", ";\n\n  ", ";\n\n  ", ";\n\n  ", ";\n\n  ", ";\n\n  ", ";\n\n  ", ";\n\n  ", ";\n\n  ", ";\n\n  ", ";\n\n  ", ";\n\n  ", ";\n\n  ", ";\n\n  ", ";\n\n  ", ";\n\n  ", ";\n\n  ", ";\n\n  ", ";\n\n  ", ";\n\n  ", ";\n\n  ", ";\n\n  ", ";\n\n  ", ";\n\n  ", ";\n\n  ", ";\n\n  ", ";\n\n  ", ";\n"])), function (_ref) {
  var hide = _ref.hide;
  return hide && styled.css(_templateObject2$J || (_templateObject2$J = _taggedTemplateLiteral$5(["\n      display: none !important;\n    "])));
}, function (_ref2) {
  var display = _ref2.display;
  return display && styled.css(_templateObject3$C || (_templateObject3$C = _taggedTemplateLiteral$5(["\n      display: ", " !important;\n    "])), display);
}, function (_ref3) {
  var whiteSpace = _ref3.whiteSpace;
  return whiteSpace && styled.css(_templateObject4$x || (_templateObject4$x = _taggedTemplateLiteral$5(["\n      white-space: ", " !important;\n    "])), whiteSpace);
}, function (_ref4) {
  var bgColor = _ref4.bgColor;
  return bgColor && styled.css(_templateObject5$u || (_templateObject5$u = _taggedTemplateLiteral$5(["\n      background-color: ", " !important;\n    "])), bgColor);
}, function (_ref5) {
  var position = _ref5.position;
  return position && styled.css(_templateObject6$n || (_templateObject6$n = _taggedTemplateLiteral$5(["\n      position: ", " !important;\n    "])), position);
}, function (_ref6) {
  var height = _ref6.height;
  return height && styled.css(_templateObject7$j || (_templateObject7$j = _taggedTemplateLiteral$5(["\n      height: ", " !important;\n    "])), height);
}, function (_ref7) {
  var width = _ref7.width;
  return width && styled.css(_templateObject8$i || (_templateObject8$i = _taggedTemplateLiteral$5(["\n      width: ", " !important;\n    "])), width);
}, function (_ref8) {
  var minHeight = _ref8.minHeight;
  return minHeight && styled.css(_templateObject9$d || (_templateObject9$d = _taggedTemplateLiteral$5(["\n      min-height: ", " !important;\n    "])), minHeight);
}, function (_ref9) {
  var minWidth = _ref9.minWidth;
  return minWidth && styled.css(_templateObject10$c || (_templateObject10$c = _taggedTemplateLiteral$5(["\n      min-width: ", " !important;\n    "])), minWidth);
}, function (_ref10) {
  var maxHeight = _ref10.maxHeight;
  return maxHeight && styled.css(_templateObject11$c || (_templateObject11$c = _taggedTemplateLiteral$5(["\n      max-height: ", " !important;\n    "])), maxHeight);
}, function (_ref11) {
  var maxWidth = _ref11.maxWidth;
  return maxWidth && styled.css(_templateObject12$a || (_templateObject12$a = _taggedTemplateLiteral$5(["\n      max-width: ", " !important;\n    "])), maxWidth);
}, function (_ref12) {
  var margin = _ref12.margin;
  return margin && styled.css(_templateObject13$9 || (_templateObject13$9 = _taggedTemplateLiteral$5(["\n      margin: ", " !important;\n    "])), margin);
}, function (_ref13) {
  var mt = _ref13.mt;
  return mt && styled.css(_templateObject14$9 || (_templateObject14$9 = _taggedTemplateLiteral$5(["\n      margin-top: ", " !important;\n    "])), mt);
}, function (_ref14) {
  var mr = _ref14.mr;
  return mr && styled.css(_templateObject15$8 || (_templateObject15$8 = _taggedTemplateLiteral$5(["\n      margin-right: ", " !important;\n    "])), mr);
}, function (_ref15) {
  var mb = _ref15.mb;
  return mb && styled.css(_templateObject16$5 || (_templateObject16$5 = _taggedTemplateLiteral$5(["\n      margin-bottom: ", " !important;\n    "])), mb);
}, function (_ref16) {
  var ml = _ref16.ml;
  return ml && styled.css(_templateObject17$5 || (_templateObject17$5 = _taggedTemplateLiteral$5(["\n      margin-left: ", " !important;\n    "])), ml);
}, function (_ref17) {
  var mx = _ref17.mx;
  return mx && styled.css(_templateObject18$4 || (_templateObject18$4 = _taggedTemplateLiteral$5(["\n      margin-left: ", " !important;\n      margin-right: ", " !important;\n    "])), mx, mx);
}, function (_ref18) {
  var my = _ref18.my;
  return my && styled.css(_templateObject19$3 || (_templateObject19$3 = _taggedTemplateLiteral$5(["\n      margin-bottom: ", " !important;\n      margin-top: ", " !important;\n    "])), my, my);
}, function (_ref19) {
  var padding = _ref19.padding;
  return padding && styled.css(_templateObject20$3 || (_templateObject20$3 = _taggedTemplateLiteral$5(["\n      padding: ", " !important;\n    "])), padding);
}, function (_ref20) {
  var pt = _ref20.pt;
  return pt && styled.css(_templateObject21$3 || (_templateObject21$3 = _taggedTemplateLiteral$5(["\n      padding-top: ", " !important;\n    "])), pt);
}, function (_ref21) {
  var pr = _ref21.pr;
  return pr && styled.css(_templateObject22$2 || (_templateObject22$2 = _taggedTemplateLiteral$5(["\n      padding-right: ", " !important;\n    "])), pr);
}, function (_ref22) {
  var pb = _ref22.pb;
  return pb && styled.css(_templateObject23$1 || (_templateObject23$1 = _taggedTemplateLiteral$5(["\n      padding-bottom: ", " !important;\n    "])), pb);
}, function (_ref23) {
  var pl = _ref23.pl;
  return pl && styled.css(_templateObject24$1 || (_templateObject24$1 = _taggedTemplateLiteral$5(["\n      padding-left: ", " !important;\n    "])), pl);
}, function (_ref24) {
  var px = _ref24.px;
  return px && styled.css(_templateObject25$1 || (_templateObject25$1 = _taggedTemplateLiteral$5(["\n      padding-left: ", " !important;\n      padding-right: ", " !important;\n    "])), px, px);
}, function (_ref25) {
  var py = _ref25.py;
  return py && styled.css(_templateObject26$1 || (_templateObject26$1 = _taggedTemplateLiteral$5(["\n      padding-bottom: ", " !important;\n      padding-top: ", " !important;\n    "])), py, py);
}, function (_ref26) {
  var opacity = _ref26.opacity;
  return opacity && styled.css(_templateObject27$1 || (_templateObject27$1 = _taggedTemplateLiteral$5(["\n      opacity: ", " !important;\n    "])), opacity);
}, function (_ref27) {
  var overflow = _ref27.overflow;
  return overflow && styled.css(_templateObject28$1 || (_templateObject28$1 = _taggedTemplateLiteral$5(["\n      overflow: ", " !important;\n    "])), overflow);
}, function (_ref28) {
  var overflowWrap = _ref28.overflowWrap;
  return overflowWrap && styled.css(_templateObject29$1 || (_templateObject29$1 = _taggedTemplateLiteral$5(["\n      overflow-wrap: ", " !important;\n    "])), overflowWrap);
}, function (_ref29) {
  var order = _ref29.order;
  return order && styled.css(_templateObject30$1 || (_templateObject30$1 = _taggedTemplateLiteral$5(["\n      order: ", " !important;\n    "])), order);
}, function (_ref30) {
  var shrink = _ref30.shrink;
  return shrink && styled.css(_templateObject31$1 || (_templateObject31$1 = _taggedTemplateLiteral$5(["\n      flex-shrink: ", " !important;\n    "])), shrink);
}, function (_ref31) {
  var zIndex = _ref31.zIndex;
  return zIndex && styled.css(_templateObject32$1 || (_templateObject32$1 = _taggedTemplateLiteral$5(["\n      z-index: ", " !important;\n    "])), zIndex);
});var _templateObject$N, _templateObject2$I, _templateObject3$B, _templateObject4$w;
// Component
// =============================

var Wrapper$z = styled__default['default'].svg.attrs({
  height: '100%',
  width: '100%'
})(_templateObject$N || (_templateObject$N = _taggedTemplateLiteral$5(["\n  transform: rotate(", "deg);\n\n  ", ";\n"])), function (_ref) {
  var dir = _ref.dir;
  return dir2deg(dir);
}, function (_ref2) {
  var noTransition = _ref2.noTransition;
  return !noTransition && styled.css(_templateObject2$I || (_templateObject2$I = _taggedTemplateLiteral$5(["\n      transition: fill ", ",\n        fill-opacity ", ",\n        stroke ", ",\n        transform ", ";\n\n      * {\n        transition: fill ", ",\n          fill-opacity ", ",\n          stroke ", ",\n          transform ", ";\n      }\n    "])), function (_ref3) {
    var theme = _ref3.theme;
    return theme.transition.medium;
  }, function (_ref4) {
    var theme = _ref4.theme;
    return theme.transition.medium;
  }, function (_ref5) {
    var theme = _ref5.theme;
    return theme.transition.medium;
  }, function (_ref6) {
    var theme = _ref6.theme;
    return theme.transition.medium;
  }, function (_ref7) {
    var theme = _ref7.theme;
    return theme.transition.medium;
  }, function (_ref8) {
    var theme = _ref8.theme;
    return theme.transition.medium;
  }, function (_ref9) {
    var theme = _ref9.theme;
    return theme.transition.medium;
  }, function (_ref10) {
    var theme = _ref10.theme;
    return theme.transition.medium;
  });
});
var ExtraWrapper = styled__default['default'](Div)(_templateObject3$B || (_templateObject3$B = _taggedTemplateLiteral$5(["\n  align-items: center;\n  box-sizing: content-box;\n  display: inline-flex;\n  flex-shrink: 0;\n  justify-content: center;\n\n  /** Fix onClick box problem (https://stackoverflow.com/a/26264802) */\n  position: relative;\n\n  ", ";\n"])), function (_ref11) {
  var onClick = _ref11.onClick;
  return onClick && styled.css(_templateObject4$w || (_templateObject4$w = _taggedTemplateLiteral$5(["\n      cursor: pointer;\n    "])));
});var _excluded$1U = ["children", "className", "dir", "fill", "height", "innerClassName", "noTransition", "onClick", "title", "viewBox", "width"];
// Component
// =============================

/**
 *
 * Why an 'ExtraWrapper' ?
 * Because Chrome fail to render SVG properly if height
 * is not set, and since we want to be able to have responsive SVG
 * we only pass width props to SVG and let him adapt his height.
 * For some reason if SVG is wrapped in an extra div, Chrome
 * has no problem to render it properly.
 *
 * More info on why here:
 * https://stackoverflow.com/questions/36999302/chrome-fails-to-size-svg-element-nvd3-properly-in-flexbox#comment61557064_36999302
 */

var Svg$2 = /*#__PURE__*/React__default['default'].forwardRef(function (_ref, ref) {
  var children = _ref.children,
      className = _ref.className,
      dir = _ref.dir,
      fill = _ref.fill,
      height = _ref.height,
      innerClassName = _ref.innerClassName,
      noTransition = _ref.noTransition,
      onClick = _ref.onClick,
      title = _ref.title,
      viewBox = _ref.viewBox,
      width = _ref.width,
      rest = _objectWithoutProperties$7(_ref, _excluded$1U);

  return /*#__PURE__*/React__default['default'].createElement(ExtraWrapper, _extends$g({}, getViewProps(rest), {
    className: className,
    height: height,
    onClick: onClick,
    ref: ref,
    width: width
  }), /*#__PURE__*/React__default['default'].createElement(Wrapper$z, {
    className: innerClassName,
    dir: dir,
    fill: fill,
    noTransition: noTransition,
    viewBox: viewBox
  }, title && /*#__PURE__*/React__default['default'].createElement("title", null, title), children));
});
Svg$2.propTypes = {
  /** SVG content. */
  children: PropTypes__default['default'].node.isRequired,

  /** Props used by styled component to override styles */
  className: PropTypes__default['default'].string,

  /** Props used to set a className on Wrapper */
  innerClassName: PropTypes__default['default'].string,

  /** Icon's facing direction */
  dir: PropTypes__default['default'].string,

  /** SVG Fill color. */
  fill: PropTypes__default['default'].string,

  /** Set SVG height. */
  height: PropTypes__default['default'].string,

  /** If True, no transition will be applied. */
  noTransition: PropTypes__default['default'].bool,

  /** onClick handler. */
  onClick: PropTypes__default['default'].func,

  /** SVG title. */
  title: PropTypes__default['default'].string,

  /** SVG Viewbox. */
  viewBox: PropTypes__default['default'].string.isRequired,

  /** Set SVG width */
  width: PropTypes__default['default'].string
};
Svg$2.defaultProps = {
  className: '',
  innerClassName: '',
  dir: 'south',
  height: '',
  fill: '',
  noTransition: false,
  onClick: null,
  title: '',
  width: ''
};var _excluded$1T = ["fill", "onClick", "theme", "title"];
// Component
// =============================

var Close = /*#__PURE__*/React__default['default'].memo( /*#__PURE__*/React__default['default'].forwardRef(function (_ref, ref) {
  var fill = _ref.fill,
      onClick = _ref.onClick,
      theme = _ref.theme,
      title = _ref.title,
      rest = _objectWithoutProperties$7(_ref, _excluded$1T);

  return /*#__PURE__*/React__default['default'].createElement(Svg$2, _extends$g({
    fill: fill || theme.colors.text,
    onClick: onClick,
    ref: ref,
    title: title,
    viewBox: "0 0 16 16"
  }, rest), /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M14.737 0c-.323 0-.646.123-.893.37L8 6.214 2.156.37A1.259 1.259 0 0 0 1.263 0 1.263 1.263 0 0 0 .37 2.156L6.214 8 .37 13.844a1.263 1.263 0 0 0 1.786 1.786L8 9.786l5.844 5.844a1.259 1.259 0 0 0 1.786 0 1.263 1.263 0 0 0 0-1.786L9.786 8l5.844-5.844A1.263 1.263 0 0 0 14.737 0z"
  }));
}));
Close.propTypes = {
  /** Icon fill color. */
  fill: PropTypes__default['default'].string,

  /** onClick handler. */
  onClick: PropTypes__default['default'].func,

  /** Styled component theme. */
  theme: PropTypes__default['default'].object,
  // eslint-disable-line react/forbid-prop-types

  /** Icon title. */
  title: PropTypes__default['default'].string,

  /** Icon width (passed to Svg via ...rest props). */
  width: PropTypes__default['default'].string
};
Close.defaultProps = {
  fill: '',
  onClick: null,
  theme: null,
  title: '',
  width: '1.6rem'
};
var Close$1 = styled.withTheme(Close);var _templateObject$M, _templateObject2$H, _templateObject3$A, _templateObject4$v, _templateObject5$t, _templateObject6$m, _templateObject7$i, _templateObject8$h, _templateObject9$c, _templateObject10$b, _templateObject11$b, _templateObject12$9, _templateObject13$8, _templateObject14$8, _templateObject15$7, _templateObject16$4, _templateObject17$4, _templateObject18$3, _templateObject19$2, _templateObject20$2, _templateObject21$2, _templateObject22$1, _templateObject23, _templateObject24, _templateObject25, _templateObject26, _templateObject27, _templateObject28, _templateObject29, _templateObject30, _templateObject31, _templateObject32, _templateObject33, _templateObject34, _templateObject35, _templateObject36, _templateObject37, _templateObject38, _templateObject39, _templateObject40, _templateObject41, _templateObject42;
// Styles
// =============================

var DeleteChip = styled__default['default'].div(_templateObject$M || (_templateObject$M = _taggedTemplateLiteral$5(["\n  align-items: center;\n  border-radius: 3.6rem;\n  cursor: pointer;\n  display: inline-flex;\n  flex-shrink: 0;\n  justify-content: center;\n  margin-left: 1rem;\n  padding: 0.4rem;\n\n  &:hover {\n    svg {\n      opacity: 0.8;\n    }\n  }\n"])));
var Container$2 = styled__default['default'](Div)(_templateObject2$H || (_templateObject2$H = _taggedTemplateLiteral$5(["\n  align-items: center;\n  border: 0.2rem solid transparent;\n  cursor: initial;\n  display: inline-flex;\n  font-size: inherit;\n  font-weight: ", ";\n  max-width: 100%;\n  transition: background-color ", ",\n    box-shadow ", ",\n    color ", ";\n  user-select: none;\n\n  ", ";\n\n  ", ";\n\n  &:focus {\n    outline: none;\n  }\n\n  ", ";\n\n  ", ";\n\n  ", ";\n\n  ", ";\n\n  ", "\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.fontWeight.bold;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.transition.medium;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.transition.medium;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.transition.medium;
}, function (_ref5) {
  var size = _ref5.size;
  return size === 'normal' && styled.css(_templateObject3$A || (_templateObject3$A = _taggedTemplateLiteral$5(["\n    font-size: 1.4rem;\n  "])));
}, function (_ref6) {
  var size = _ref6.size;
  return size === 'small' && styled.css(_templateObject4$v || (_templateObject4$v = _taggedTemplateLiteral$5(["\n    font-size: 1.3rem;\n  "])));
}, function (_ref7) {
  var hoverable = _ref7.hoverable,
      noHover = _ref7.noHover,
      theme = _ref7.theme;
  return hoverable && !noHover && styled.css(_templateObject5$t || (_templateObject5$t = _taggedTemplateLiteral$5(["\n      &:hover {\n        box-shadow: 0 0.2rem 0.4rem 0.1rem ", ";\n      }\n    "])), theme.colors.boxShadow);
}, function (_ref8) {
  var oneLineChip = _ref8.oneLineChip;
  return oneLineChip ? styled.css(_templateObject6$m || (_templateObject6$m = _taggedTemplateLiteral$5(["\n          flex-shrink: 1;\n          min-width: 0;\n        "]))) : styled.css(_templateObject7$i || (_templateObject7$i = _taggedTemplateLiteral$5(["\n        "])));
}, function (_ref9) {
  var showCursor = _ref9.showCursor;
  return showCursor && styled.css(_templateObject8$h || (_templateObject8$h = _taggedTemplateLiteral$5(["\n      cursor: pointer;\n    "])));
}, function (_ref10) {
  var theme = _ref10.theme;

  switch (theme.edgeVariant) {
    case 'round':
      return styled.css(_templateObject9$c || (_templateObject9$c = _taggedTemplateLiteral$5(["\n          border-radius: 6rem;\n        "])));

    default:
    case 'square':
      return styled.css(_templateObject10$b || (_templateObject10$b = _taggedTemplateLiteral$5(["\n          border-radius: 0;\n        "])));
  }
}, function (_ref11) {
  var color = _ref11.color,
      fillVariant = _ref11.fillVariant,
      size = _ref11.size,
      theme = _ref11.theme;

  switch (fillVariant) {
    // Only used in inputs, that's why we use theme.colors.input.text.
    case 'textual':
      return styled.css(_templateObject11$b || (_templateObject11$b = _taggedTemplateLiteral$5(["\n          color: ", ";\n          font-weight: ", ";\n          margin-right: 0.4rem;\n          text-decoration: underline;\n          min-height: 2.1rem;\n        "])), theme.colors.input.text, theme.fontWeight.normal);

    case 'outline':
      return styled.css(_templateObject12$9 || (_templateObject12$9 = _taggedTemplateLiteral$5(["\n          background-color: transparent;\n          margin: 0.2rem 0.3rem 0.3rem 0;\n\n          ", ";\n\n          ", ";\n\n          ", ";\n\n          ", ";\n\n          ", ";\n\n          ", ";\n\n          /** Custom color */\n          ", "\n          }\n\n          &:first-child:last-child {\n            margin: 0;\n          }\n\n          &::first-line {\n            margin-top: 0;\n          }\n          &:focus {\n            box-shadow: 0 0.2rem 0.4rem 0.1rem ", ";\n          }\n        "])), size === 'normal' && styled.css(_templateObject13$8 || (_templateObject13$8 = _taggedTemplateLiteral$5(["\n            min-height: 3rem;\n            padding: 0.4rem 1rem;\n          "]))), size === 'small' && styled.css(_templateObject14$8 || (_templateObject14$8 = _taggedTemplateLiteral$5(["\n            min-height: 2.4rem;\n            padding: 0.2rem 0.4rem;\n          "]))), color === 'default' && styled.css(_templateObject15$7 || (_templateObject15$7 = _taggedTemplateLiteral$5(["\n              border: 2px solid ", ";\n              color: ", ";\n\n              svg path {\n                fill: ", ";\n              }\n            "])), theme.colors.chip.outlineBackground, theme.colors.chip.outlineText, theme.colors.chip.outlineText), color === 'alternate' && styled.css(_templateObject16$4 || (_templateObject16$4 = _taggedTemplateLiteral$5(["\n              border: 2px solid ", ";\n              color: ", ";\n\n              svg path {\n                fill: ", ";\n              }\n            "])), theme.colors.chip.outlineBackgroundAlternate, theme.colors.chip.outlineTextAlternate, theme.colors.chip.outlineTextAlternate), color === 'primary' && styled.css(_templateObject17$4 || (_templateObject17$4 = _taggedTemplateLiteral$5(["\n              border: 2px solid ", ";\n              color: ", ";\n\n              svg path {\n                fill: ", ";\n              }\n            "])), theme.colors.primary, theme.colors.primary, theme.colors.primary), color === 'secondary' && styled.css(_templateObject18$3 || (_templateObject18$3 = _taggedTemplateLiteral$5(["\n              border: 2px solid ", ";\n              color: ", ";\n\n              svg path {\n                fill: ", ";\n              }\n            "])), theme.colors.secondary, theme.colors.secondary, theme.colors.secondary), !['default', 'alternate', 'primary', 'secondary'].includes(color) && styled.css(_templateObject19$2 || (_templateObject19$2 = _taggedTemplateLiteral$5(["\n              border: 2px solid ", ";\n              color: ", ";\n\n              svg path {\n                fill: ", ";\n              }\n            "])), color, color, color), theme.colors.boxShadow);

    case 'faded':
      return styled.css(_templateObject20$2 || (_templateObject20$2 = _taggedTemplateLiteral$5(["\n          margin: 0.2rem 0.3rem 0.3rem 0;\n\n          ", ";\n\n          ", ";\n\n          ", ";\n\n          ", ";\n\n          ", ";\n\n          ", ";\n\n          /** Custom color */\n          ", "\n\n          &:first-child:last-child {\n            margin: 0;\n          }\n\n          &::first-line {\n            margin-top: 0;\n          }\n          &:focus {\n            box-shadow: 0 0.2rem 0.4rem 0.1rem ", ";\n          }\n        "])), size === 'normal' && styled.css(_templateObject21$2 || (_templateObject21$2 = _taggedTemplateLiteral$5(["\n            min-height: 3rem;\n            padding: 0.4rem 1rem;\n          "]))), size === 'small' && styled.css(_templateObject22$1 || (_templateObject22$1 = _taggedTemplateLiteral$5(["\n            min-height: 2.4rem;\n            padding: 0.2rem 0.4rem;\n          "]))), color === 'default' && styled.css(_templateObject23 || (_templateObject23 = _taggedTemplateLiteral$5(["\n              background-color: ", ";\n              border: 0.2rem solid ", ";\n              color: ", ";\n\n              svg path {\n                fill: ", ";\n              }\n            "])), alpha$2(theme.colors.chip.background, 0.5), theme.colors.chip.background, theme.colors.chip.text, theme.colors.chip.text), color === 'alternate' && styled.css(_templateObject24 || (_templateObject24 = _taggedTemplateLiteral$5(["\n              background-color: ", ";\n              border: 0.2rem solid ", ";\n              color: ", ";\n\n              svg path {\n                fill: ", ";\n              }\n            "])), alpha$2(theme.colors.chip.backgroundAlternate, 0.5), theme.colors.chip.backgroundAlternate, theme.colors.chip.textAlternate, theme.colors.chip.textAlternate), color === 'primary' && styled.css(_templateObject25 || (_templateObject25 = _taggedTemplateLiteral$5(["\n              background-color: ", ";\n              border: 0.2rem solid ", ";\n              color: ", ";\n\n              svg path {\n                fill: ", ";\n              }\n            "])), alpha$2(theme.colors.primary, 0.5), theme.colors.primary, theme.colors.primaryText, theme.colors.primaryText), color === 'secondary' && styled.css(_templateObject26 || (_templateObject26 = _taggedTemplateLiteral$5(["\n              background-color: ", ";\n              border: 0.2rem solid ", ";\n              color: ", ";\n\n              svg path {\n                fill: ", ";\n              }\n            "])), alpha$2(theme.colors.secondary, 0.5), theme.colors.secondary, theme.colors.secondaryText, theme.colors.secondaryText), !['default', 'alternate', 'primary', 'secondary'].includes(color) && styled.css(_templateObject27 || (_templateObject27 = _taggedTemplateLiteral$5(["\n              background-color: ", ";\n              border: 0.2rem solid ", ";\n              color: ", ";\n\n              svg path {\n                fill: ", ";\n              }\n            "])), alpha$2(color, 0.5), color, theme.colors.white, theme.colors.white), theme.colors.boxShadow);

    case 'plain':
    default:
      return styled.css(_templateObject28 || (_templateObject28 = _taggedTemplateLiteral$5(["\n          margin: 0.2rem 0.3rem 0.3rem 0;\n\n          ", ";\n\n          ", ";\n\n          ", ";\n\n          ", ";\n\n          ", ";\n\n          ", ";\n\n          /** Custom color */\n          ", "\n\n          &:first-child:last-child {\n            margin: 0;\n          }\n\n          &::first-line {\n            margin-top: 0;\n          }\n          &:focus {\n            box-shadow: 0 0.2rem 0.4rem 0.1rem ", ";\n          }\n        "])), size === 'normal' && styled.css(_templateObject29 || (_templateObject29 = _taggedTemplateLiteral$5(["\n            min-height: 3rem;\n            padding: 0.4rem 1rem;\n          "]))), size === 'small' && styled.css(_templateObject30 || (_templateObject30 = _taggedTemplateLiteral$5(["\n            min-height: 2.4rem;\n            padding: 0.2rem 0.4rem;\n          "]))), color === 'default' && styled.css(_templateObject31 || (_templateObject31 = _taggedTemplateLiteral$5(["\n              background-color: ", ";\n              color: ", ";\n\n              svg path {\n                fill: ", ";\n              }\n            "])), theme.colors.chip.background, theme.colors.chip.text, theme.colors.chip.text), color === 'alternate' && styled.css(_templateObject32 || (_templateObject32 = _taggedTemplateLiteral$5(["\n              background-color: ", ";\n              color: ", ";\n\n              svg path {\n                fill: ", ";\n              }\n            "])), theme.colors.chip.backgroundAlternate, theme.colors.chip.textAlternate, theme.colors.chip.textAlternate), color === 'primary' && styled.css(_templateObject33 || (_templateObject33 = _taggedTemplateLiteral$5(["\n              background-color: ", ";\n              color: ", ";\n\n              svg path {\n                fill: ", ";\n              }\n            "])), theme.colors.primary, theme.colors.primaryText, theme.colors.primaryText), color === 'secondary' && styled.css(_templateObject34 || (_templateObject34 = _taggedTemplateLiteral$5(["\n              background-color: ", ";\n              color: ", ";\n\n              svg path {\n                fill: ", ";\n              }\n            "])), theme.colors.secondary, theme.colors.secondaryText, theme.colors.secondaryText), !['default', 'alternate', 'primary', 'secondary'].includes(color) && styled.css(_templateObject35 || (_templateObject35 = _taggedTemplateLiteral$5(["\n              background-color: ", ";\n              color: ", ";\n\n              svg path {\n                fill: ", ";\n              }\n            "])), color, theme.colors.white, theme.colors.white), theme.colors.boxShadow);
  }
});
var FlexBreakWord = styled__default['default'](Div)(_templateObject36 || (_templateObject36 = _taggedTemplateLiteral$5(["\n  cursor: initial;\n  line-height: 1.3;\n  max-width: 100%;\n  overflow: auto;\n  overflow-wrap: break-word;\n  width: 100%;\n\n  ", ";\n\n  ", ";\n\n\n  ", ";\n"])), function (_ref12) {
  var showCursor = _ref12.showCursor;
  return showCursor && styled.css(_templateObject37 || (_templateObject37 = _taggedTemplateLiteral$5(["\n      cursor: pointer;\n    "])));
}, function (_ref13) {
  var fillVariant = _ref13.fillVariant;

  switch (fillVariant) {
    case 'textual':
      return styled.css(_templateObject38 || (_templateObject38 = _taggedTemplateLiteral$5(["\n          padding: 0;\n        "])));

    default:
      return styled.css(_templateObject39 || (_templateObject39 = _taggedTemplateLiteral$5(["\n          padding: 0 0.4rem;\n        "])));
  }
}, function (_ref14) {
  var oneLineChip = _ref14.oneLineChip,
      theme = _ref14.theme;
  return oneLineChip && styled.css(_templateObject40 || (_templateObject40 = _taggedTemplateLiteral$5(["\n    ", ";\n  "])), theme.helpers.textEllipsis);
});
var CrossIcon = styled__default['default'](Close$1).attrs({
  height: '0.7rem',
  width: '0.7rem'
})(_templateObject41 || (_templateObject41 = _taggedTemplateLiteral$5([""])));
var IndicationDot$1 = styled__default['default'].div(_templateObject42 || (_templateObject42 = _taggedTemplateLiteral$5(["\n  background-color: ", ";\n  border-radius: 50%;\n  border: 0.1rem solid ", ";\n  cursor: ", ";\n  height: 1rem;\n  margin-right: 0.3rem;\n  min-width: 1rem;\n  width: 1rem;\n"])), function (_ref15) {
  var dotColor = _ref15.dotColor;
  return dotColor;
}, function (_ref16) {
  var dotColor = _ref16.dotColor;
  return lighten(dotColor, 0.7);
}, function (_ref17) {
  var title = _ref17.title;
  return title ? 'help' : 'auto';
});// Component
// =============================

var Chip = /*#__PURE__*/function (_PureComponent) {
  _inherits$e(Chip, _PureComponent);

  var _super = _createSuper$1(Chip);

  function Chip() {
    var _this;

    _classCallCheck$k(this, Chip);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty$8(_assertThisInitialized$1(_this), "handleKeyDown", function (e) {
      var onDelete = _this.props.onDelete;
      e.preventDefault();
      if (onDelete && e.key === 'Backspace') onDelete(e);
    });

    _defineProperty$8(_assertThisInitialized$1(_this), "handleDoubleClick", function () {
      var onDoubleClick = _this.props.onDoubleClick;
      if (onDoubleClick) onDoubleClick();
    });

    _defineProperty$8(_assertThisInitialized$1(_this), "handleDeleteClick", function (e) {
      var onDelete = _this.props.onDelete;
      e.preventDefault();
      e.stopPropagation();
      if (onDelete) onDelete(e);
    });

    return _this;
  }

  _createClass$g(Chip, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          className = _this$props.className,
          color = _this$props.color,
          fillVariant = _this$props.fillVariant,
          indicationColor = _this$props.indicationColor,
          indicationTooltipMessage = _this$props.indicationTooltipMessage,
          name = _this$props.name,
          noHover = _this$props.noHover,
          onClick = _this$props.onClick,
          onDelete = _this$props.onDelete,
          onDoubleClick = _this$props.onDoubleClick,
          oneLineChip = _this$props.oneLineChip,
          size = _this$props.size;
      return /*#__PURE__*/React__default['default'].createElement(Container$2, {
        className: className,
        color: color,
        fillVariant: fillVariant,
        hoverable: !!onClick,
        noHover: noHover,
        onClick: onClick,
        onDoubleClick: this.handleDoubleClick,
        oneLineChip: oneLineChip,
        onKeyDown: this.handleKeyDown,
        showCursor: !!onClick || !!onDoubleClick,
        size: size,
        tabIndex: onDelete ? '-1' : null
      }, indicationColor && fillVariant !== 'textual' && /*#__PURE__*/React__default['default'].createElement(IndicationDot$1, {
        title: indicationTooltipMessage,
        dotColor: indicationColor
      }), /*#__PURE__*/React__default['default'].createElement(FlexBreakWord, {
        fillVariant: fillVariant,
        oneLineChip: oneLineChip,
        showCursor: !!onClick || !!onDoubleClick
      }, name), onDelete && fillVariant !== 'textual' && /*#__PURE__*/React__default['default'].createElement(DeleteChip, {
        onClick: this.handleDeleteClick
      }, /*#__PURE__*/React__default['default'].createElement(CrossIcon, null)));
    }
  }]);

  return Chip;
}(React.PureComponent);

_defineProperty$8(Chip, "propTypes", {
  /** Props used by styled component to override styles. */
  className: PropTypes__default['default'].string,

  /** Chip color. */
  color: PropTypes__default['default'].oneOfType([PropTypes__default['default'].oneOf(['default', 'alternate', 'primary', 'secondary']), PropTypes__default['default'].string]),

  /** Chip can be eitheir plain or outline. */
  fillVariant: PropTypes__default['default'].oneOf(['faded', 'plain', 'outline', 'textual']),

  /** Indication color */
  indicationColor: PropTypes__default['default'].string,

  /** Indication tooltip */
  indicationTooltipMessage: PropTypes__default['default'].string,

  /** Chip content. */
  name: PropTypes__default['default'].node.isRequired,

  /** If True, Chip wrapper won't show hover style. */
  noHover: PropTypes__default['default'].bool,

  /** OnClick callback function. */
  onClick: PropTypes__default['default'].func,

  /** If provided, will show a DeleteButton. */
  onDelete: PropTypes__default['default'].func,

  /** onDoubleClick callback function. */
  onDoubleClick: PropTypes__default['default'].func,

  /** If True, Chip value will be on one single line. */
  oneLineChip: PropTypes__default['default'].bool,

  /** Chip can be eitheir plain or outline. */
  size: PropTypes__default['default'].oneOf(['normal', 'small'])
});

_defineProperty$8(Chip, "defaultProps", {
  className: '',
  color: 'default',
  fillVariant: 'plain',
  indicationColor: null,
  indicationTooltipMessage: null,
  noHover: false,
  onClick: null,
  onDelete: null,
  onDoubleClick: null,
  oneLineChip: false,
  size: 'normal'
});var _templateObject$L, _templateObject2$G, _templateObject3$z, _templateObject4$u, _templateObject5$s;
// Styles
// =============================

var Wrapper$y = styled__default['default'].div(_templateObject$L || (_templateObject$L = _taggedTemplateLiteral$5(["\n  display: flex;\n  min-height: 5rem;\n  padding: 0.4rem 0;\n  outline: none;\n  position: relative;\n  width: 100%;\n\n  ", ";\n"])), function (_ref) {
  var theme = _ref.theme,
      variant = _ref.variant;
  var borderRadius = '0';

  if (variant === 'background') {
    if (theme.edgeVariant === 'round') borderRadius = '1rem';
    return styled.css(_templateObject2$G || (_templateObject2$G = _taggedTemplateLiteral$5(["\n        border: 0.1rem solid ", ";\n        border-radius: ", ";\n        padding: 0.4rem 2rem;\n      "])), alpha$2(theme.colors.text, 0.9), borderRadius);
  }

  if (variant === 'underline') {
    if (theme.edgeVariant === 'round') borderRadius = '0.5rem';
    return styled.css(_templateObject3$z || (_templateObject3$z = _taggedTemplateLiteral$5(["\n        margin-top: 1.2rem;\n        /** :after & :before are used to make the input animated bottom border */\n        &:after {\n          border: 0.1rem solid ", ";\n          border-radius: ", ";\n          bottom: 0;\n          content: '';\n          left: 0;\n          position: absolute;\n          transform: scaleX(0);\n          transition: transform ", ";\n          width: 100%;\n        }\n\n        &:before {\n          border: 0.1rem solid ", ";\n          border-radius: ", ";\n          bottom: 0;\n          content: '';\n          left: 0;\n          position: absolute;\n          width: 100%;\n        }\n\n        ", ";\n\n        ", ";\n      "])), theme.colors.primary, borderRadius, theme.transition.fast, alpha$2(theme.colors.text, 0.7), borderRadius, function (_ref2) {
      var active = _ref2.active;
      return active && styled.css(_templateObject4$u || (_templateObject4$u = _taggedTemplateLiteral$5(["\n            &:after {\n              transform: scaleX(1);\n            }\n          "])));
    }, function (_ref3) {
      var error = _ref3.error;
      return error && styled.css(_templateObject5$s || (_templateObject5$s = _taggedTemplateLiteral$5(["\n            &:after,\n            &:before {\n              border-color: ", ";\n            }\n          "])), theme.colors.type.error);
    });
  }

  return null;
});var _excluded$1S = ["active", "children", "className", "error", "getRef", "variant"];
// Component
// =============================

var Container$1 = /*#__PURE__*/function (_PureComponent) {
  _inherits$e(Container, _PureComponent);

  var _super = _createSuper$1(Container);

  function Container() {
    _classCallCheck$k(this, Container);

    return _super.apply(this, arguments);
  }

  _createClass$g(Container, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          active = _this$props.active,
          children = _this$props.children,
          className = _this$props.className,
          error = _this$props.error,
          getRef = _this$props.getRef,
          variant = _this$props.variant,
          rest = _objectWithoutProperties$7(_this$props, _excluded$1S);

      return /*#__PURE__*/React__default['default'].createElement(Wrapper$y, _extends$g({
        active: active,
        className: className,
        error: error,
        ref: getRef,
        variant: variant
      }, rest), children);
    }
  }]);

  return Container;
}(React.PureComponent);

_defineProperty$8(Container$1, "propTypes", {
  /** If true, show border colored. */
  active: PropTypes__default['default'].bool,

  /** The content of the container. */
  children: PropTypes__default['default'].node.isRequired,

  /** Props used by styled component to override styles */
  className: PropTypes__default['default'].string,

  /** If true, Container is on error. */
  error: PropTypes__default['default'].bool,

  /** Pass Container ref to parent. */
  getRef: PropTypes__default['default'].func,

  /** Input style variant. */
  variant: PropTypes__default['default'].oneOf(['background', 'underline'])
});

_defineProperty$8(Container$1, "defaultProps", {
  active: false,
  className: 'containerClassName',
  error: false,
  getRef: null,
  variant: 'background'
});var RelativePortal$1 = {};/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT$1 = 'Expected a function';

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** `Object#toString` result references. */
var symbolTag$2 = '[object Symbol]';

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof commonjsGlobal == 'object' && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Used for built-in method references. */
var objectProto$2 = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto$2.toString;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax$2 = Math.max,
    nativeMin$1 = Math.min;

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return root.Date.now();
};

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce$2(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT$1);
  }
  wait = toNumber$1(wait) || 0;
  if (isObject$2(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax$2(toNumber$1(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        result = wait - timeSinceLastCall;

    return maxing ? nativeMin$1(result, maxWait - timeSinceLastInvoke) : result;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

/**
 * Creates a throttled function that only invokes `func` at most once per
 * every `wait` milliseconds. The throttled function comes with a `cancel`
 * method to cancel delayed `func` invocations and a `flush` method to
 * immediately invoke them. Provide `options` to indicate whether `func`
 * should be invoked on the leading and/or trailing edge of the `wait`
 * timeout. The `func` is invoked with the last arguments provided to the
 * throttled function. Subsequent calls to the throttled function return the
 * result of the last `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the throttled function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.throttle` and `_.debounce`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to throttle.
 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=true]
 *  Specify invoking on the leading edge of the timeout.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new throttled function.
 * @example
 *
 * // Avoid excessively updating the position while scrolling.
 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
 *
 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
 * jQuery(element).on('click', throttled);
 *
 * // Cancel the trailing throttled invocation.
 * jQuery(window).on('popstate', throttled.cancel);
 */
function throttle$2(func, wait, options) {
  var leading = true,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT$1);
  }
  if (isObject$2(options)) {
    leading = 'leading' in options ? !!options.leading : leading;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }
  return debounce$2(func, wait, {
    'leading': leading,
    'maxWait': wait,
    'trailing': trailing
  });
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject$2(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike$3(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol$1(value) {
  return typeof value == 'symbol' ||
    (isObjectLike$3(value) && objectToString.call(value) == symbolTag$2);
}

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber$1(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol$1(value)) {
    return NAN;
  }
  if (isObject$2(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject$2(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

var lodash_throttle = throttle$2;var exenv = {exports: {}};/*!
  Copyright (c) 2015 Jed Watson.
  Based on code that is Copyright 2013-2015, Facebook, Inc.
  All rights reserved.
*/

(function (module) {
/* global define */

(function () {

	var canUseDOM = !!(
		typeof window !== 'undefined' &&
		window.document &&
		window.document.createElement
	);

	var ExecutionEnvironment = {

		canUseDOM: canUseDOM,

		canUseWorkers: typeof Worker !== 'undefined',

		canUseEventListeners:
			canUseDOM && !!(window.addEventListener || window.attachEvent),

		canUseViewport: canUseDOM && !!window.screen

	};

	if (module.exports) {
		module.exports = ExecutionEnvironment;
	} else {
		window.ExecutionEnvironment = ExecutionEnvironment;
	}

}());
}(exenv));var Portal$2 = {};Object.defineProperty(Portal$2, "__esModule", {
  value: true
});

var _extends$d = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass$a = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react$j = React__default['default'];

var _react2$j = _interopRequireDefault$p(_react$j);

var _propTypes$4 = PropTypes__default['default'];

var _propTypes2$4 = _interopRequireDefault$p(_propTypes$4);

var _reactDom$1 = ReactDOM__default['default'];

var _reactDom2 = _interopRequireDefault$p(_reactDom$1);

var _exenv$1 = exenv.exports;

function _interopRequireDefault$p(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties$3(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck$c(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn$c(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits$c(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Portal$1 = function (_React$Component) {
  _inherits$c(Portal, _React$Component);

  function Portal(props, context) {
    _classCallCheck$c(this, Portal);

    var _this = _possibleConstructorReturn$c(this, (Portal.__proto__ || Object.getPrototypeOf(Portal)).call(this, props, context));

    if (_exenv$1.canUseDOM) {
      _this.node = document.createElement('div');
      _this.root = null;
      _this.handleRootRef = function (root) {
        _this.root = root;
      };

      _this.handleOutClick = function (e) {
        var onOutClick = _this.props.onOutClick;

        if (typeof onOutClick === 'function') {
          if (_this.root && !_this.root.contains(e.target)) {
            onOutClick(e);
          }
          if (!_this.root) {
            onOutClick(e);
          }
        }
      };

      document.addEventListener('click', _this.handleOutClick, true);
    }
    return _this;
  }

  _createClass$a(Portal, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (_exenv$1.canUseDOM) {
        document.body.appendChild(this.node);
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (_exenv$1.canUseDOM) {
        document.removeEventListener('click', this.handleOutClick, true);
        document.body.removeChild(this.node);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props;
          _props.onOutClick;
          var props = _objectWithoutProperties$3(_props, ['onOutClick']);

      return _reactDom2.default.createPortal(_react2$j.default.createElement('div', _extends$d({}, props, { ref: this.handleRootRef })), this.node);
    }
  }]);

  return Portal;
}(_react2$j.default.Component);

Portal$1.propTypes = {
  onOutClick: _propTypes2$4.default.func
};
Portal$2.default = Portal$1;Object.defineProperty(RelativePortal$1, "__esModule", {
  value: true
});

var _extends$c = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass$9 = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react$i = React__default['default'];

var _react2$i = _interopRequireDefault$o(_react$i);

var _propTypes$3 = PropTypes__default['default'];

var _propTypes2$3 = _interopRequireDefault$o(_propTypes$3);

var _lodash = lodash_throttle;

var _lodash2 = _interopRequireDefault$o(_lodash);

var _exenv = exenv.exports;

var _Portal = Portal$2;

var _Portal2 = _interopRequireDefault$o(_Portal);

function _interopRequireDefault$o(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties$2(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck$b(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn$b(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits$b(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var listeners = {};

function fireListeners() {
  Object.keys(listeners).forEach(function (key) {
    return listeners[key]();
  });
}

function getPageOffset() {
  return {
    x: window.pageXOffset !== undefined ? window.pageXOffset : (document.documentElement || document.body.parentNode || document.body).scrollLeft,
    y: window.pageYOffset !== undefined ? window.pageYOffset : (document.documentElement || document.body.parentNode || document.body).scrollTop
  };
}

function initDOMListener() {
  document.body.addEventListener('wheel', (0, _lodash2.default)(fireListeners, 100, {
    leading: true,
    trailing: true
  }));
  window.addEventListener('resize', (0, _lodash2.default)(fireListeners, 50, {
    leading: true,
    trailing: true
  }));
}

if (_exenv.canUseDOM) {
  if (document.body) {
    initDOMListener();
  } else {
    document.addEventListener('DOMContentLoaded', initDOMListener);
  }
}

var listenerIdCounter = 0;
function subscribe(fn) {
  listenerIdCounter += 1;
  var id = listenerIdCounter;
  listeners[id] = fn;
  return function () {
    return delete listeners[id];
  };
}

var RelativePortal = function (_React$Component) {
  _inherits$b(RelativePortal, _React$Component);

  function RelativePortal() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck$b(this, RelativePortal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn$b(this, (_ref = RelativePortal.__proto__ || Object.getPrototypeOf(RelativePortal)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      right: 0,
      left: 0,
      top: 0
    }, _temp), _possibleConstructorReturn$b(_this, _ret);
  }

  _createClass$9(RelativePortal, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      this.handleScroll = function () {
        if (_this2.element) {
          var rect = _this2.element.getBoundingClientRect();
          var pageOffset = getPageOffset();
          var top = pageOffset.y + rect.top;
          var right = document.documentElement.clientWidth - rect.right - pageOffset.x;
          var left = pageOffset.x + rect.left;

          if (top !== _this2.state.top || left !== _this2.state.left || right !== _this2.state.right) {
            _this2.setState({ left: left, top: top, right: right });
          }
        }
      };
      this.unsubscribe = subscribe(this.handleScroll);
      this.handleScroll();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      this.handleScroll();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.unsubscribe();
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _props = this.props,
          Comp = _props.component,
          top = _props.top,
          left = _props.left,
          right = _props.right,
          fullWidth = _props.fullWidth,
          props = _objectWithoutProperties$2(_props, ['component', 'top', 'left', 'right', 'fullWidth']);

      var fromLeftOrRight = right !== undefined ? { right: this.state.right + right } : { left: this.state.left + left };

      var horizontalPosition = fullWidth ? { right: this.state.right + right, left: this.state.left + left } : fromLeftOrRight;

      return _react2$i.default.createElement(
        Comp,
        {
          ref: function ref(element) {
            _this3.element = element;
          }
        },
        _react2$i.default.createElement(
          _Portal2.default,
          props,
          _react2$i.default.createElement(
            'div',
            {
              style: _extends$c({
                position: 'absolute',
                top: this.state.top + top
              }, horizontalPosition)
            },
            this.props.children
          )
        )
      );
    }
  }]);

  return RelativePortal;
}(_react2$i.default.Component);

RelativePortal.propTypes = {
  right: _propTypes2$3.default.number,
  left: _propTypes2$3.default.number,
  fullWidth: _propTypes2$3.default.bool,
  top: _propTypes2$3.default.number,
  children: _propTypes2$3.default.any,
  onOutClick: _propTypes2$3.default.func,
  component: _propTypes2$3.default.string.isRequired
};
RelativePortal.defaultProps = {
  left: 0,
  top: 0,
  component: 'span'
};
var _default$3 = RelativePortal$1.default = RelativePortal;var _templateObject$K, _templateObject2$F, _templateObject3$y, _templateObject4$t;
// Styles
// =============================

var Wrapper$x = styled__default['default'](framerMotion.motion.div).attrs(function (_ref) {
  var theme = _ref.theme;
  return {
    initial: 'exit',
    animate: 'enter',
    exit: 'exit',
    transition: {
      duration: 0.15,
      ease: theme.transitionTiming.pose.easeInOut
    },
    variants: {
      exit: {
        opacity: 0,
        y: -10
      },
      enter: {
        opacity: 1,
        y: 0
      }
    }
  };
})(_templateObject$K || (_templateObject$K = _taggedTemplateLiteral$5(["\n  background: ", ";\n  left: 0;\n  position: absolute;\n  width: 100%;\n  z-index: ", ";\n\n  ", ";\n"])), function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.dropdown.background;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.zIndex.dropdown;
}, function (_ref4) {
  var theme = _ref4.theme,
      variant = _ref4.variant;
  var borderRadius = '0';

  if (variant === 'underline') {
    if (theme.edgeVariant === 'round') borderRadius = '0 0 1rem 1rem';
    return styled.css(_templateObject2$F || (_templateObject2$F = _taggedTemplateLiteral$5(["\n        border-radius: ", ";\n        top: 100%;\n      "])), borderRadius);
  }

  if (variant === 'background') {
    if (theme.edgeVariant === 'round') borderRadius = '1rem';
    return styled.css(_templateObject3$y || (_templateObject3$y = _taggedTemplateLiteral$5(["\n        border-radius: ", ";\n        top: calc(100% + 0.8rem);\n      "])), borderRadius);
  }

  return null;
});
var Overlay = styled__default['default'].div(_templateObject4$t || (_templateObject4$t = _taggedTemplateLiteral$5(["\n  bottom: 0;\n  left: 0;\n  position: fixed;\n  right: 0;\n  top: 0;\n  z-index: ", ";\n"])), function (_ref5) {
  var theme = _ref5.theme;
  return theme.zIndex.dropdown - 1;
});// Component
// =============================

var Dropdown$1 = /*#__PURE__*/function (_PureComponent) {
  _inherits$e(Dropdown, _PureComponent);

  var _super = _createSuper$1(Dropdown);

  function Dropdown() {
    _classCallCheck$k(this, Dropdown);

    return _super.apply(this, arguments);
  }

  _createClass$g(Dropdown, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var open = this.props.open; // If dropdown was closed & just go opened.

      if (typeof document !== 'undefined' && !prevProps.open && open) {
        document.body.classList.toggle('is-locked-input-dropdown', true);
      } else if (typeof document !== 'undefined' && prevProps.open && !open) {
        document.body.classList.toggle('is-locked-input-dropdown', false);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var open = this.props.open;

      if (open && typeof document !== 'undefined') {
        document.body.classList.toggle('is-locked-input-dropdown', false);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          className = _this$props.className,
          innerRef = _this$props.innerRef,
          onClickOutside = _this$props.onClickOutside,
          open = _this$props.open,
          variant = _this$props.variant;
      return /*#__PURE__*/React__default['default'].createElement(framerMotion.AnimatePresence, null, open && /*#__PURE__*/React__default['default'].createElement(_default$3, {
        component: "div",
        left: 0,
        fullWidth: true,
        right: 0,
        top: 0
      }, /*#__PURE__*/React__default['default'].createElement(Overlay, {
        className: "ignore-react-onclickoutside",
        onClick: onClickOutside
      }), /*#__PURE__*/React__default['default'].createElement(Wrapper$x, {
        className: className,
        ref: innerRef,
        open: open,
        variant: variant
      }, children)));
    }
  }]);

  return Dropdown;
}(React.PureComponent);

_defineProperty$8(Dropdown$1, "propTypes", {
  /** The content of the Dropdown. */
  children: PropTypes__default['default'].node,

  /** Props used by styled component to override styles */
  className: PropTypes__default['default'].string,

  /** Forwarded ref */
  innerRef: PropTypes__default['default'].func,

  /** Function used to close dropdown on click outside. */
  onClickOutside: PropTypes__default['default'].func.isRequired,

  /** If true, the Dropdown is open */
  open: PropTypes__default['default'].bool.isRequired,

  /** Input style variant. */
  variant: PropTypes__default['default'].oneOf(['background', 'underline'])
});

_defineProperty$8(Dropdown$1, "defaultProps", {
  children: null,
  className: '',
  innerRef: null,
  variant: 'background'
});

var Dropdown$2 = /*#__PURE__*/React__default['default'].forwardRef(function (props, ref) {
  return /*#__PURE__*/React__default['default'].createElement(Dropdown$1, _extends$g({
    innerRef: ref
  }, props));
});var _templateObject$J, _templateObject2$E, _templateObject3$x, _templateObject4$s, _templateObject5$r, _templateObject6$l, _templateObject7$h, _templateObject8$g, _templateObject9$b, _templateObject10$a, _templateObject11$a;
// Styles
// =============================

var Wrapper$w = styled__default['default'].div(_templateObject$J || (_templateObject$J = _taggedTemplateLiteral$5(["\n  ", ";\n  font-size: inherit;\n  font-weight: ", ";\n  pointer-events: none;\n  transition: color ", ",\n    font-size ", ",\n    transform ", ";\n  transform-origin: left;\n  width: 100%;\n\n  ", "\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.helpers.textEllipsis;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.fontWeight.semibold;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.transition.fast;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.transition.fast;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.transition.fast;
}, function (_ref6) {
  var active = _ref6.active,
      error = _ref6.error,
      inputFilled = _ref6.inputFilled,
      theme = _ref6.theme,
      variant = _ref6.variant;

  if (variant === 'underline') {
    return styled.css(_templateObject2$E || (_templateObject2$E = _taggedTemplateLiteral$5(["\n        color: ", ";\n        position: absolute;\n\n        ", ";\n\n        ", ";\n\n        ", ";\n      "])), alpha$2(theme.colors.background, 0.8), active && styled.css(_templateObject3$x || (_templateObject3$x = _taggedTemplateLiteral$5(["\n            color: ", ";\n            transform: translate3d(0, -100%, 0) scale(0.8);\n          "])), theme.colors.primary), error && styled.css(_templateObject4$s || (_templateObject4$s = _taggedTemplateLiteral$5(["\n            color: ", ";\n          "])), theme.colors.type.error), inputFilled && styled.css(_templateObject5$r || (_templateObject5$r = _taggedTemplateLiteral$5(["\n            color: ", ";\n            pointer-events: auto;\n            transform: translate3d(0, -100%, 0) scale(0.8);\n          "])), alpha$2(theme.colors.text, 0.8)));
  }

  if (variant === 'background') {
    return styled.css(_templateObject6$l || (_templateObject6$l = _taggedTemplateLiteral$5(["\n        color: ", ";\n        margin-bottom: 0.6rem;\n        transform: scale(0.8);\n\n        ", ";\n\n        ", ";\n      "])), alpha$2(theme.colors.text, 0.8), active && styled.css(_templateObject7$h || (_templateObject7$h = _taggedTemplateLiteral$5(["\n            color: ", ";\n          "])), theme.colors.primary), error && styled.css(_templateObject8$g || (_templateObject8$g = _taggedTemplateLiteral$5(["\n            color: ", ";\n          "])), theme.colors.type.error));
  }

  if (variant === 'switchInput') {
    return styled.css(_templateObject9$b || (_templateObject9$b = _taggedTemplateLiteral$5(["\n        color: ", ";\n        margin-bottom: -0.2rem;\n        transform: scale(0.8);\n\n        ", ";\n\n        ", ";\n      "])), alpha$2(theme.colors.text, 0.8), active && styled.css(_templateObject10$a || (_templateObject10$a = _taggedTemplateLiteral$5(["\n            color: ", ";\n          "])), theme.colors.primary), error && styled.css(_templateObject11$a || (_templateObject11$a = _taggedTemplateLiteral$5(["\n            color: ", ";\n          "])), theme.colors.type.error));
  }

  return null;
});var _excluded$1R = ["active", "className", "error", "inputFilled", "label", "optional", "lang", "variant"];
// Component
// =============================

var Label$2 = /*#__PURE__*/React__default['default'].memo(function (_ref) {
  var active = _ref.active,
      className = _ref.className,
      error = _ref.error,
      inputFilled = _ref.inputFilled,
      label = _ref.label,
      optional = _ref.optional,
      lang = _ref.lang,
      variant = _ref.variant,
      rest = _objectWithoutProperties$7(_ref, _excluded$1R);

  if (!label) return false;
  var message = label;
  if (optional) message = "".concat(label, " (").concat(lang.optional, ")");
  return /*#__PURE__*/React__default['default'].createElement(Wrapper$w, _extends$g({
    active: active,
    className: className,
    error: error,
    inputFilled: inputFilled,
    variant: variant
  }, rest), message);
});
Label$2.propTypes = {
  /** If true, rise the label and set primary color */
  active: PropTypes__default['default'].bool,

  /** Props used by styled component to override styles */
  className: PropTypes__default['default'].string,

  /** If true, label is on error */
  error: PropTypes__default['default'].bool,

  /** Is input associated with Label is filled, if true rise the label */
  inputFilled: PropTypes__default['default'].bool,

  /** Label name */
  label: PropTypes__default['default'].string,

  /** Translation strings. */
  lang: PropTypes__default['default'].object.isRequired,
  // eslint-disable-line react/forbid-prop-types

  /** If true, the input is optional. */
  optional: PropTypes__default['default'].bool,

  /** Input style variant. */
  variant: PropTypes__default['default'].oneOf(['background', 'switchInput', 'underline'])
};
Label$2.defaultProps = {
  active: false,
  className: '',
  error: false,
  inputFilled: false,
  label: '',
  optional: false,
  variant: 'background'
};var _excluded$1Q = ["dir", "fill", "onClick", "theme", "title"];
// Component
// =============================

var ArrowDropdown = /*#__PURE__*/React__default['default'].memo( /*#__PURE__*/React__default['default'].forwardRef(function (_ref, ref) {
  var dir = _ref.dir,
      fill = _ref.fill,
      onClick = _ref.onClick,
      theme = _ref.theme,
      title = _ref.title,
      rest = _objectWithoutProperties$7(_ref, _excluded$1Q);

  return /*#__PURE__*/React__default['default'].createElement(Svg$2, _extends$g({
    dir: dir,
    fill: fill || theme.colors.text,
    onClick: onClick,
    ref: ref,
    title: title,
    viewBox: "0 0 64 64"
  }, rest), /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M5.243 14.938c-0.941 0-1.896 0.366-2.61 1.080-1.429 1.429-1.429 3.792 0 5.221l26.741 26.741c0.69 0.69 1.664 1.080 2.61 1.080 0.937 0 1.871-0.341 2.61-1.080l26.704-26.706c1.496-1.408 1.515-3.827 0.086-5.256s-3.792-1.429-5.221 0c-0 0-0.001 0.001-0.001 0.001v0l-24.131 24.178-24.179-24.179c-0.715-0.715-1.67-1.080-2.61-1.080z"
  }));
}));
ArrowDropdown.propTypes = {
  /** Icon's facing direction */
  dir: PropTypes__default['default'].string,

  /** Icon fill color. */
  fill: PropTypes__default['default'].string,

  /** onClick handler. */
  onClick: PropTypes__default['default'].func,

  /** Styled component theme. */
  theme: PropTypes__default['default'].object,
  // eslint-disable-line react/forbid-prop-types

  /** Icon title. */
  title: PropTypes__default['default'].string,

  /** Icon width (passed to Svg via ...rest props). */
  width: PropTypes__default['default'].string
};
ArrowDropdown.defaultProps = {
  dir: 'south',
  fill: '',
  onClick: null,
  theme: null,
  title: '',
  width: '0.9rem'
};
var ArrowDropdown$1 = styled.withTheme(ArrowDropdown);var _templateObject$I, _templateObject2$D;
// Styles
// =============================

var ArrowIcon = styled__default['default'](ArrowDropdown$1).attrs(function (_ref) {
  var open = _ref.open;
  return {
    dir: open ? 'north' : 'south',
    width: '1rem'
  };
})(_templateObject$I || (_templateObject$I = _taggedTemplateLiteral$5(["\n  height: 2rem;\n\n  ", ";\n"])), function (_ref2) {
  var theme = _ref2.theme;
  return theme.mediaAbove.sxga(_templateObject2$D || (_templateObject2$D = _taggedTemplateLiteral$5(["\n    margin-left: 1.2rem;\n  "])));
});// Component
// =============================

var DropdownIndicator = /*#__PURE__*/function (_PureComponent) {
  _inherits$e(DropdownIndicator, _PureComponent);

  var _super = _createSuper$1(DropdownIndicator);

  function DropdownIndicator() {
    _classCallCheck$k(this, DropdownIndicator);

    return _super.apply(this, arguments);
  }

  _createClass$g(DropdownIndicator, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          onClick = _this$props.onClick,
          open = _this$props.open;
      return /*#__PURE__*/React__default['default'].createElement(ArrowIcon, {
        onClick: onClick,
        open: open
      });
    }
  }]);

  return DropdownIndicator;
}(React.PureComponent);

_defineProperty$8(DropdownIndicator, "propTypes", {
  /** Callback fired on onClick event. */
  onClick: PropTypes__default['default'].func.isRequired,

  /** If true, change arrow depending on if dropdown is opened */
  open: PropTypes__default['default'].bool.isRequired
});var _excluded$1P = ["fill", "onClick", "theme", "title"];
// Component
// =============================

var AddTeammate = /*#__PURE__*/React__default['default'].memo( /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var fill = _ref.fill,
      onClick = _ref.onClick,
      theme = _ref.theme,
      title = _ref.title,
      rest = _objectWithoutProperties$7(_ref, _excluded$1P);

  return /*#__PURE__*/React__default['default'].createElement(Svg$2, _extends$g({
    fill: fill || theme.colors.text,
    onClick: onClick,
    ref: ref,
    title: title,
    viewBox: "0 0 20 20"
  }, rest), /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M15.417 13.333c.23 0 .416.187.416.417V15h1.25a.417.417 0 0 1 0 .833h-1.25v1.25a.417.417 0 0 1-.833 0v-1.25h-1.25a.417.417 0 0 1 0-.833H15v-1.25c0-.23.187-.417.417-.417zm0-2.5a4.588 4.588 0 0 0-4.584 4.584A4.588 4.588 0 0 0 15.417 20 4.588 4.588 0 0 0 20 15.417a4.588 4.588 0 0 0-4.583-4.584z"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M13.737 6.982c-.045-.182-.173-.45-.404-.606v-2.21c0-1.342-.41-1.893-.841-2.212C12.409 1.307 11.717 0 9.167 0 6.585 0 5 2.427 5 4.167v2.209c-.23.156-.358.424-.404.606a.413.413 0 0 0-.013.101c0 .686.401 1.708.447 1.822.05.124.123.207.252.24.047.022.135.143.135.438 0 .792.594 1.672 1.231 2.257-.087.546-.494 1.985-1.363 2.348l-3.698 1.233C.572 15.759.23 16.61.012 17.48a.42.42 0 0 0-.012.102v2.001c0 .23.187.417.417.417h10.921a.415.415 0 0 0 .291-.714 5.375 5.375 0 0 1-1.63-3.87 5.41 5.41 0 0 1 2.42-4.51.427.427 0 0 0 .132-.14c.242-.423.366-.821.366-1.183 0-.295.087-.416.1-.429a.415.415 0 0 0 .286-.25c.046-.113.447-1.135.447-1.82"
  }));
}));
AddTeammate.propTypes = {
  /** Icon fill color. */
  fill: PropTypes__default['default'].string,

  /** onClick handler. */
  onClick: PropTypes__default['default'].func,

  /** Styled component theme. */
  theme: PropTypes__default['default'].object,
  // eslint-disable-line react/forbid-prop-types

  /** Icon title. */
  title: PropTypes__default['default'].string,

  /** Icon width (passed to Svg via ...rest props). */
  width: PropTypes__default['default'].string
};
AddTeammate.defaultProps = {
  fill: '',
  onClick: null,
  theme: null,
  title: '',
  width: '2rem'
};
var AddTeammate$1 = styled.withTheme(AddTeammate);var _excluded$1O = ["fill", "onClick", "theme", "title"];
// Component
// =============================

var Album = /*#__PURE__*/React__default['default'].memo( /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var fill = _ref.fill,
      onClick = _ref.onClick,
      theme = _ref.theme,
      title = _ref.title,
      rest = _objectWithoutProperties$7(_ref, _excluded$1O);

  return /*#__PURE__*/React__default['default'].createElement(Svg$2, _extends$g({
    fill: fill || theme.colors.text,
    onClick: onClick,
    ref: ref,
    title: title,
    viewBox: "0 0 81.3 81.3"
  }, rest), /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M40.6,12.5c-15.5,0-28.1,12.6-28.1,28.1 s12.6,28.1,28.1,28.1s28.1-12.6,28.1-28.1S56.1,12.5,40.6,12.5z M40.6,18.8c12.1,0,21.9,9.8,21.9,21.9s-9.8,21.9-21.9,21.9 s-21.9-9.8-21.9-21.9S28.5,18.8,40.6,18.8z"
  }), /*#__PURE__*/React__default['default'].createElement("circle", {
    cx: "40.6",
    cy: "40.6",
    r: "6.3"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M21.9,0c-4.7,0-8.2,0-11.2,0.3s-5.5,1-7.4,3 c-1.9,1.9-2.6,4.5-3,7.4S0,17.2,0,21.9v37.5c0,4.7,0,8.2,0.3,11.2c0.3,2.9,1,5.5,3,7.4s4.5,2.6,7.4,3c2.9,0.3,6.5,0.3,11.2,0.3h37.5 c4.7,0,8.2,0,11.2-0.3c2.9-0.3,5.5-1,7.4-3c1.9-1.9,2.6-4.5,3-7.4c0.3-2.9,0.3-6.5,0.3-11.2V21.9c0-4.7,0-8.2-0.3-11.2 c-0.3-2.9-1-5.5-3-7.4c-1.9-1.9-4.5-2.6-7.4-3C67.6,0,64.1,0,59.4,0L21.9,0L21.9,0z M21.9,6.3h37.5c4.7,0,8.1,0,10.5,0.3 c2.3,0.3,3.3,0.7,3.7,1.2c0.4,0.4,0.9,1.4,1.2,3.7C75,13.7,75,17.2,75,21.9v37.5c0,4.7,0,8.1-0.3,10.5c-0.3,2.3-0.7,3.3-1.2,3.7 c-0.4,0.4-1.4,0.9-3.7,1.2C67.5,75,64,75,59.4,75H21.9c-4.7,0-8.1,0-10.5-0.3c-2.3-0.3-3.3-0.7-3.7-1.2c-0.4-0.4-0.9-1.4-1.2-3.7 C6.3,67.5,6.3,64,6.3,59.4V21.9c0-4.7,0-8.1,0.3-10.5c0.3-2.3,0.7-3.3,1.2-3.7c0.4-0.4,1.4-0.9,3.7-1.2C13.7,6.3,17.2,6.3,21.9,6.3z"
  }));
}));
Album.propTypes = {
  /** Icon fill color. */
  fill: PropTypes__default['default'].string,

  /** onClick handler. */
  onClick: PropTypes__default['default'].func,

  /** Styled component theme. */
  theme: PropTypes__default['default'].object,
  // eslint-disable-line react/forbid-prop-types

  /** Icon title. */
  title: PropTypes__default['default'].string,

  /** Icon width (passed to Svg via ...rest props). */
  width: PropTypes__default['default'].string
};
Album.defaultProps = {
  fill: '',
  onClick: null,
  theme: null,
  title: '',
  width: '2rem'
};
var Album$1 = styled.withTheme(Album);var _excluded$1N = ["fill", "onClick", "theme", "title"];
// Component
// =============================

var Artist = /*#__PURE__*/React__default['default'].memo( /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var fill = _ref.fill,
      onClick = _ref.onClick,
      theme = _ref.theme,
      title = _ref.title,
      rest = _objectWithoutProperties$7(_ref, _excluded$1N);

  return /*#__PURE__*/React__default['default'].createElement(Svg$2, _extends$g({
    fill: fill || theme.colors.text,
    onClick: onClick,
    ref: ref,
    title: title,
    viewBox: "0 0 93.2 88.4"
  }, rest), /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M50.2,38.9c4.8-4.2,7.6-10.3,7.5-16.7C57.7,9.9,47.8,0,35.5,0S13.3,9.9,13.3,22.2c0,6.4,2.7,12.5,7.5,16.7 C8.2,44.6,0,57.2,0,71.2c0,4.2,2.2,10,12.6,13.8c7.4,2.5,15.1,3.7,22.9,3.5c26.2,0,35.5-9.3,35.5-17.3 C71.1,57.2,62.9,44.6,50.2,38.9z M35.5,8.7c7.4,0,13.5,6,13.5,13.5s-6,13.5-13.5,13.5S22,29.6,22,22.2S28.1,8.7,35.5,8.7 C35.5,8.7,35.5,8.7,35.5,8.7z M35.5,79.7c-15.8,0-26.8-4.5-26.8-8.6c0-14.8,12-26.8,26.8-26.8c14.8,0,26.8,12,26.8,26.8 C62.3,75.2,51.3,79.7,35.5,79.7z"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M87.1,3.6H68V26c-0.8-0.4-1.7-0.7-2.6-0.7c-3.5,0-6.3,3.2-6.1,7c0.2,3.5,3,6.2,6.2,6.1 c3.2-0.1,5.7-2.7,5.9-6.1c0-0.1,0-0.1,0-0.2c0-5.5-0.2-15.8-0.2-21.3c6.3,0,12.1-0.1,18.4,0.2c0,1.7,0.1,8.2,0.1,9.9 c-0.8-0.4-1.7-0.7-2.6-0.7c-3.7,0-6.7,3.6-6,7.7c0.4,2.7,2.4,4.8,4.9,5.3c3.8,0.7,7.2-2.4,7.2-6.5c0,0,0-0.1,0-0.1s0,0,0-0.1V10.2 C93.2,6.5,90.4,3.6,87.1,3.6L87.1,3.6z"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M77.3,15.3"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M76.9,12"
  }));
}));
Artist.propTypes = {
  /** Icon fill color. */
  fill: PropTypes__default['default'].string,

  /** onClick handler. */
  onClick: PropTypes__default['default'].func,

  /** Styled component theme. */
  theme: PropTypes__default['default'].object,
  // eslint-disable-line react/forbid-prop-types

  /** Icon title. */
  title: PropTypes__default['default'].string,

  /** Icon width (passed to Svg via ...rest props). */
  width: PropTypes__default['default'].string
};
Artist.defaultProps = {
  fill: '',
  onClick: null,
  theme: null,
  title: '',
  width: '2rem'
};
var Artist$1 = styled.withTheme(Artist);var _excluded$1M = ["dir", "fill", "onClick", "theme", "title"];
// Component
// =============================

var ArrowBreadcrumb = /*#__PURE__*/React__default['default'].memo( /*#__PURE__*/React__default['default'].forwardRef(function (_ref, ref) {
  var dir = _ref.dir,
      fill = _ref.fill,
      onClick = _ref.onClick,
      theme = _ref.theme,
      title = _ref.title,
      rest = _objectWithoutProperties$7(_ref, _excluded$1M);

  return /*#__PURE__*/React__default['default'].createElement(Svg$2, _extends$g({
    dir: dir,
    fill: fill || theme.colors.text,
    onClick: onClick,
    ref: ref,
    title: title,
    viewBox: "0 0 8 5"
  }, rest), /*#__PURE__*/React__default['default'].createElement("path", {
    fillRule: "evenodd",
    d: "M7.358786865008517 0.000794765309936607C7.183158204581831 0.009757754296250337 7.0196053140182775 0.09998829898750138 6.909904247213561 0.24843895531178672L3.9778411905528914 3.4162208857521192L1.0457781338922227 0.24843895531178672C0.9314207353589664 0.11793708177233896 0.7727788164411739 0.04341721159653542 0.6064462100929043 0.04206879697691163C0.3582668588382444 0.04420907065876602 0.13591712402584533 0.20825145552455768 0.043742690588047486 0.45721310731231307C-0.04843174284975034 0.7061747591000684 0.007865808249258793 0.9906366329357481 0.1862156742848606 1.1771046678187247L3.5480599607492103 4.809219454512527C3.786211956818119 5.063593515162494 4.1694704242876615 5.063593515162494 4.407622420356571 4.8092194545125215L7.769466706820923 1.1771046678187247C7.977051534905511 0.9985086630367644 8.054279902984558 0.6956176867266498 7.960627438834159 0.42736901767027796C7.866974974683764 0.15912034861390606 7.623833170031695 -0.013214382621825213 7.358786865008517 0.0007947653099319146L7.358786865008517 0.000794765309936607Z"
  }));
}));
ArrowBreadcrumb.propTypes = {
  /** Icon's facing direction */
  dir: PropTypes__default['default'].string,

  /** Icon fill color. */
  fill: PropTypes__default['default'].string,

  /** onClick handler. */
  onClick: PropTypes__default['default'].func,

  /** Styled component theme. */
  theme: PropTypes__default['default'].object,
  // eslint-disable-line react/forbid-prop-types

  /** Icon title. */
  title: PropTypes__default['default'].string,

  /** Icon width (passed to Svg via ...rest props). */
  width: PropTypes__default['default'].string
};
ArrowBreadcrumb.defaultProps = {
  dir: 'east',
  fill: '',
  onClick: null,
  theme: null,
  title: '',
  width: '1rem'
};
var ArrowBreadcrumb$1 = styled.withTheme(ArrowBreadcrumb);var _excluded$1L = ["dir", "fill", "onClick", "theme", "title"];
// Component
// =============================

var ArrowDirection = /*#__PURE__*/React__default['default'].memo( /*#__PURE__*/React__default['default'].forwardRef(function (_ref, ref) {
  var dir = _ref.dir,
      fill = _ref.fill,
      onClick = _ref.onClick,
      theme = _ref.theme,
      title = _ref.title,
      rest = _objectWithoutProperties$7(_ref, _excluded$1L);

  return /*#__PURE__*/React__default['default'].createElement(Svg$2, _extends$g({
    dir: dir,
    fill: fill || theme.colors.text,
    onClick: onClick,
    ref: ref,
    title: title,
    viewBox: "0 0 14.5 20"
  }, rest), /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M16.093 8.73H9.88L1.228 8.73l4.285-4.283a1.107 1.107 0 1 0-1.567-1.567l-6.174 6.175a1.09 1.09 0 0 0-.139.169c-.017.024-.028.052-.043.077-.02.037-.043.073-.06.113-.013.033-.02.067-.03.1-.01.036-.025.07-.032.108a.964.964 0 0 0-.018.172c0 .014-.004.029-.004.044 0 .018.004.033.005.051.002.055.006.11.017.165.008.04.022.076.033.115.009.03.017.062.03.091.017.044.04.084.063.124.013.022.023.046.037.068.042.061.088.12.14.171l6.174 6.173a1.107 1.107 0 1 0 1.567-1.566L1.23 10.945h8.65v-.007h6.214c.746 0 1.352-.494 1.352-1.104 0-.61-.606-1.104-1.353-1.104z",
    fillRule: "evenodd",
    transform: "rotate(-90 7.446 10)"
  }));
}));
ArrowDirection.propTypes = {
  /** Icon's facing direction */
  dir: PropTypes__default['default'].string,

  /** Icon fill color. */
  fill: PropTypes__default['default'].string,

  /** onClick handler. */
  onClick: PropTypes__default['default'].func,

  /** Styled component theme. */
  theme: PropTypes__default['default'].object,
  // eslint-disable-line react/forbid-prop-types

  /** Icon title. */
  title: PropTypes__default['default'].string,

  /** Icon width (passed to Svg via ...rest props). */
  width: PropTypes__default['default'].string
};
ArrowDirection.defaultProps = {
  dir: 'south',
  fill: '',
  onClick: null,
  theme: null,
  title: '',
  width: '1.45rem'
};
var ArrowDirection$1 = styled.withTheme(ArrowDirection);var _excluded$1K = ["dir", "fill", "onClick", "theme", "title"];
// Component
// =============================

var ArrowDouble = /*#__PURE__*/React__default['default'].memo( /*#__PURE__*/React__default['default'].forwardRef(function (_ref, ref) {
  var dir = _ref.dir,
      fill = _ref.fill,
      onClick = _ref.onClick,
      theme = _ref.theme,
      title = _ref.title,
      rest = _objectWithoutProperties$7(_ref, _excluded$1K);

  return /*#__PURE__*/React__default['default'].createElement(Svg$2, _extends$g({
    dir: dir,
    fill: fill || theme.colors.text,
    onClick: onClick,
    ref: ref,
    title: title,
    viewBox: "0 0 8 10"
  }, rest), /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M4 6.1l3.1-.9c.2-.2.5-.2.7 0 .2.1.3.4.1.6l-3.5 4c-.1.1-.2.2-.4.2-.1 0-.3-.1-.4-.2l-3.5-4C0 5.7 0 5.5 0 5.3c.1-.1.2-.3.4-.3s.4 0 .5.2l3.1.9zm0-5L7.1.2c.2-.2.5-.2.7 0 .2.1.3.4.1.6l-3.5 4c-.1.1-.2.2-.4.2-.1 0-.3-.1-.4-.2L.1.8C0 .7 0 .5 0 .3.1.2.2 0 .4 0s.4 0 .5.2l3.1.9z"
  }));
}));
ArrowDouble.propTypes = {
  /** Icon's facing direction */
  dir: PropTypes__default['default'].string,

  /** Icon fill color. */
  fill: PropTypes__default['default'].string,

  /** onClick handler. */
  onClick: PropTypes__default['default'].func,

  /** Styled component theme. */
  theme: PropTypes__default['default'].object,
  // eslint-disable-line react/forbid-prop-types

  /** Icon title. */
  title: PropTypes__default['default'].string,

  /** Icon width (passed to Svg via ...rest props). */
  width: PropTypes__default['default'].string
};
ArrowDouble.defaultProps = {
  dir: 'south',
  fill: '',
  onClick: null,
  theme: null,
  title: '',
  width: '1rem'
};
var ArrowDouble$1 = styled.withTheme(ArrowDouble);var _excluded$1J = ["dir", "fill", "onClick", "theme", "title"];
// Component
// =============================

var ArrowDropdownOutline = /*#__PURE__*/React__default['default'].memo( /*#__PURE__*/React__default['default'].forwardRef(function (_ref, ref) {
  var dir = _ref.dir,
      fill = _ref.fill,
      onClick = _ref.onClick,
      theme = _ref.theme,
      title = _ref.title,
      rest = _objectWithoutProperties$7(_ref, _excluded$1J);

  return /*#__PURE__*/React__default['default'].createElement(Svg$2, _extends$g({
    dir: dir,
    onClick: onClick,
    ref: ref,
    title: title,
    viewBox: "0 0 35 35"
  }, rest), /*#__PURE__*/React__default['default'].createElement("g", {
    transform: "rotate(-90 17.5 17.5)"
  }, /*#__PURE__*/React__default['default'].createElement("circle", {
    fill: "none",
    stroke: fill || theme.colors.text,
    strokeWidth: "2",
    cx: "17.5",
    cy: "17.5",
    r: "16.5"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    fill: fill || theme.colors.text,
    d: "M15.002509,17.5637573 C15.0169861,17.7026985 15.0738875,17.8338141 15.1654816,17.9392882 L19.2466045,22.7005929 C19.3930011,22.917243 19.6506186,23.0308078 19.9093062,22.9927297 C20.1679937,22.9546517 20.3819606,22.7716711 20.4597199,22.5220259 C20.5374791,22.2723808 20.4652664,22.0002612 20.2739581,21.8220188 L16.5683661,17.5 L20.2739581,13.1779812 C20.4652664,12.9997388 20.5374791,12.7276192 20.4597199,12.4779741 C20.3819606,12.2283289 20.1679937,12.0453483 19.9093062,12.0072703 C19.6506186,11.9691922 19.3930011,12.082757 19.2466045,12.2994071 L15.1654816,17.0607141 C15.0455416,17.1995558 14.9867715,17.3809596 15.002509,17.5637573 Z"
  })));
}));
ArrowDropdownOutline.propTypes = {
  /** Icon's facing direction */
  dir: PropTypes__default['default'].string,

  /** Icon fill color. */
  fill: PropTypes__default['default'].string,

  /** onClick handler. */
  onClick: PropTypes__default['default'].func,

  /** Styled component theme. */
  theme: PropTypes__default['default'].object,
  // eslint-disable-line react/forbid-prop-types

  /** Icon title. */
  title: PropTypes__default['default'].string,

  /** Icon width (passed to Svg via ...rest props). */
  width: PropTypes__default['default'].string
};
ArrowDropdownOutline.defaultProps = {
  dir: 'south',
  fill: '',
  onClick: null,
  theme: null,
  title: '',
  width: '0.9rem'
};
var ArrowDropdownOutline$1 = styled.withTheme(ArrowDropdownOutline);var _excluded$1I = ["dir", "fill", "onClick", "theme", "title"];
// Component
// =============================

var ArrowSingle = /*#__PURE__*/React__default['default'].memo( /*#__PURE__*/React__default['default'].forwardRef(function (_ref, ref) {
  var dir = _ref.dir,
      fill = _ref.fill,
      onClick = _ref.onClick,
      theme = _ref.theme,
      title = _ref.title,
      rest = _objectWithoutProperties$7(_ref, _excluded$1I);

  return /*#__PURE__*/React__default['default'].createElement(Svg$2, _extends$g({
    dir: dir,
    fill: fill || theme.colors.text,
    onClick: onClick,
    ref: ref,
    title: title,
    viewBox: "0 0 7 4.3"
  }, rest), /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M6.247.163l-2.734.79L.778.163a.437.437 0 1 0-.656.578l3.062 3.5a.437.437 0 0 0 .657 0L6.903.74a.437.437 0 0 0-.656-.578z"
  }));
}));
ArrowSingle.propTypes = {
  /** Icon's facing direction */
  dir: PropTypes__default['default'].string,

  /** Icon fill color. */
  fill: PropTypes__default['default'].string,

  /** onClick handler. */
  onClick: PropTypes__default['default'].func,

  /** Styled component theme. */
  theme: PropTypes__default['default'].object,
  // eslint-disable-line react/forbid-prop-types

  /** Icon title. */
  title: PropTypes__default['default'].string,

  /** Icon width (passed to Svg via ...rest props). */
  width: PropTypes__default['default'].string
};
ArrowSingle.defaultProps = {
  dir: 'south',
  fill: '',
  onClick: null,
  theme: null,
  title: '',
  width: '0.7rem'
};
var ArrowSingle$1 = styled.withTheme(ArrowSingle);var _excluded$1H = ["dir", "fill", "onClick", "theme", "title"];
// Component
// =============================

var ArrowSorting = /*#__PURE__*/React__default['default'].memo( /*#__PURE__*/React__default['default'].forwardRef(function (_ref, ref) {
  var dir = _ref.dir,
      fill = _ref.fill,
      onClick = _ref.onClick,
      theme = _ref.theme,
      title = _ref.title,
      rest = _objectWithoutProperties$7(_ref, _excluded$1H);

  return /*#__PURE__*/React__default['default'].createElement(Svg$2, _extends$g({
    dir: dir,
    fill: fill || theme.colors.text,
    onClick: onClick,
    ref: ref,
    title: title,
    viewBox: "0 0 1000 1000"
  }, rest), /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M32.3,239.5c-49.6-79-13.5-143,80.4-143h774.4c94,0,130.3,64.3,80.7,143.2L591.4,844.1c-49.3,79-129.4,79.3-179,0.3L32.3,239.5z"
  }));
}));
ArrowSorting.propTypes = {
  /** Icon's facing direction */
  dir: PropTypes__default['default'].string,

  /** Icon fill color. */
  fill: PropTypes__default['default'].string,

  /** onClick handler. */
  onClick: PropTypes__default['default'].func,

  /** Styled component theme. */
  theme: PropTypes__default['default'].object,
  // eslint-disable-line react/forbid-prop-types

  /** Icon title. */
  title: PropTypes__default['default'].string,

  /** Icon width (passed to Svg via ...rest props). */
  width: PropTypes__default['default'].string
};
ArrowSorting.defaultProps = {
  dir: 'south',
  fill: '',
  onClick: null,
  theme: null,
  title: '',
  width: '0.5rem'
};
var ArrowSorting$1 = styled.withTheme(ArrowSorting);var _excluded$1G = ["backgroundFill", "fill", "onClick", "theme", "title"];
// Component
// =============================

var AudioFile = /*#__PURE__*/React__default['default'].memo( /*#__PURE__*/React__default['default'].forwardRef(function (_ref, ref) {
  var backgroundFill = _ref.backgroundFill,
      fill = _ref.fill,
      onClick = _ref.onClick,
      theme = _ref.theme,
      title = _ref.title,
      rest = _objectWithoutProperties$7(_ref, _excluded$1G);

  return /*#__PURE__*/React__default['default'].createElement(Svg$2, _extends$g({
    onClick: onClick,
    ref: ref,
    title: title,
    viewBox: "0 0 14 18"
  }, rest), /*#__PURE__*/React__default['default'].createElement("path", {
    fill: backgroundFill || theme.colors.text,
    d: "M9.244,0c0.564,0,1.106,0.218,1.518,0.611l2.54,2.424C13.748,3.46,14,4.053,14,4.674V15.75 c0,1.243-0.997,2.25-2.217,2.25H2.216C0.997,18,0,16.993,0,15.75V2.25C0,1.007,0.997,0,2.216,0H9.244z M9.679,1.775v2.129 c0,0.155,0.124,0.281,0.276,0.281h2.232c0.25,0,0.372-0.312,0.189-0.486L10.146,1.57C9.969,1.401,9.679,1.529,9.679,1.775z"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    fill: fill || theme.colors.background,
    d: "M9.158,9.366C8.98,8.972,8.665,8.601,8.35,8.297C7.994,7.954,7.407,8.201,7.407,8.702l0.011,3.972 c0.005,0.033,0.005,0.072,0.005,0.111c0,1.148-0.919,2.082-2.061,2.082c-1.136,0-2.061-0.934-2.061-2.082 c0-1.158,0.925-2.092,2.061-2.092c0.238,0,0.465,0.039,0.676,0.117V6.547c0-0.973,1.13-1.49,1.845-0.844 c1.009,0.917,2.155,2.115,2.72,3.026c0.045,0.073,0.072,0.163,0.084,0.265C10.798,9.883,9.518,10.182,9.158,9.366z"
  }));
}));
AudioFile.propTypes = {
  /** Background Icon fill color. */
  backgroundFill: PropTypes__default['default'].string,

  /** Icon fill color. */
  fill: PropTypes__default['default'].string,

  /** onClick handler. */
  onClick: PropTypes__default['default'].func,

  /** Styled component theme. */
  theme: PropTypes__default['default'].object,
  // eslint-disable-line react/forbid-prop-types

  /** Icon title. */
  title: PropTypes__default['default'].string,

  /** Icon width (passed to Svg via ...rest props). */
  width: PropTypes__default['default'].string
};
AudioFile.defaultProps = {
  backgroundFill: '',
  fill: '',
  onClick: null,
  theme: null,
  title: '',
  width: '1.6rem'
};
var AudioFile$1 = styled.withTheme(AudioFile);var _excluded$1F = ["fill", "onClick", "theme", "title"];
// Component
// =============================

var Autotag = /*#__PURE__*/React__default['default'].memo( /*#__PURE__*/React__default['default'].forwardRef(function (_ref, ref) {
  var fill = _ref.fill,
      onClick = _ref.onClick,
      theme = _ref.theme,
      title = _ref.title,
      rest = _objectWithoutProperties$7(_ref, _excluded$1F);

  return /*#__PURE__*/React__default['default'].createElement(Svg$2, _extends$g({
    fill: fill || theme.colors.text,
    onClick: onClick,
    ref: ref,
    title: title,
    viewBox: "0 0 100 100"
  }, rest), /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M63.811,35.748c-1.932-1.932-5.063-1.932-6.994,0L6.448,86.115c-1.932,1.932-1.932,5.064,0,6.994l0.424,0.424  c1.932,1.932,5.063,1.932,6.994,0l50.368-50.367c1.932-1.932,1.932-5.064,0-6.996L63.811,35.748z"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M93.669,14.238c-1.437-0.209-2.612-0.381-2.612-0.381l-4.35-0.632c-0.484-0.071-1.059-0.487-1.273-0.926l-1.944-3.938  c0,0-0.525-1.066-1.169-2.367c-0.643-1.305-1.694-1.305-2.338,0c-0.644,1.301-1.168,2.367-1.168,2.367l-1.944,3.938  c-0.216,0.44-0.79,0.856-1.274,0.926l-4.346,0.631c0,0-1.175,0.172-2.613,0.381c-1.438,0.209-1.762,1.209-0.722,2.223  c1.039,1.014,1.892,1.844,1.892,1.844l3.145,3.064c0.35,0.342,0.568,1.018,0.486,1.5l-0.742,4.328c0,0-0.2,1.172-0.446,2.604  c-0.245,1.43,0.606,2.048,1.892,1.373c1.285-0.675,2.338-1.23,2.338-1.23l3.888-2.043c0.433-0.227,1.142-0.227,1.575,0l3.887,2.044  c0,0,1.052,0.554,2.338,1.23c1.286,0.676,2.136,0.057,1.891-1.373c-0.246-1.432-0.445-2.604-0.445-2.604l-0.742-4.328  c-0.083-0.482,0.135-1.158,0.486-1.5l3.144-3.064c0,0,0.853-0.83,1.892-1.844C95.432,15.447,95.105,14.447,93.669,14.238z"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M92.87,60.227c-1.231-0.179-2.239-0.326-2.239-0.326l-3.724-0.539c-0.415-0.063-0.908-0.42-1.093-0.795l-1.666-3.375  c0,0-0.45-0.914-1.002-2.029c-0.551-1.117-1.453-1.117-2.004,0c-0.552,1.115-1.002,2.029-1.002,2.029l-1.666,3.375  c-0.186,0.375-0.678,0.731-1.094,0.795L73.656,59.9c0,0-1.008,0.147-2.24,0.326c-1.23,0.178-1.509,1.037-0.618,1.905  c0.892,0.869,1.621,1.58,1.621,1.58l2.694,2.627c0.302,0.293,0.488,0.871,0.418,1.285l-0.637,3.709c0,0-0.172,1.005-0.384,2.231  c-0.21,1.228,0.519,1.756,1.622,1.179c1.102-0.58,2.004-1.056,2.004-1.056l3.33-1.752c0.373-0.192,0.981-0.192,1.354,0l3.33,1.752  c0,0,0.901,0.476,2.004,1.056c1.101,0.577,1.832,0.049,1.621-1.179c-0.211-1.226-0.383-2.231-0.383-2.231l-0.637-3.709  c-0.07-0.414,0.116-0.992,0.417-1.285l2.695-2.627c0,0,0.728-0.711,1.62-1.58C94.38,61.264,94.102,60.406,92.87,60.227z"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M 49.079 23.833 C 46.679 21.433 43.479 20.133 40.179 20.133 L 20.979 20.133 C 13.979 20.133 8.279 25.833 8.279 32.833 L 8.279 52.033 C 8.279 55.433 9.579 58.633 11.979 60.933 L 41.179 90.133 C 43.579 92.533 46.779 93.833 50.079 93.833 C 53.379 93.833 56.679 92.533 58.979 90.133 L 78.379 71.033 C 83.279 66.133 83.279 58.033 78.379 53.133 L 49.079 23.833 Z M 33.479 40.233 C 33.479 43.033 31.279 45.233 28.479 45.233 C 25.679 45.233 23.479 43.033 23.479 40.233 C 23.479 37.433 25.679 35.233 28.479 35.233 C 31.179 35.233 33.479 37.533 33.479 40.233 Z",
    style: {
      strokeOpacity: 0.09,
      strokeWidth: '41px',
      fill: alpha$2(fill || theme.colors.text, 0.3)
    }
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M 26.956 17.232 L 29.65 19.861 C 29.951 20.154 30.139 20.732 30.068 21.144 L 29.432 24.855 C 29.432 24.855 29.259 25.858 29.048 27.085 C 28.838 28.312 29.567 28.841 30.67 28.263 C 31.771 27.683 32.674 27.21 32.674 27.21 L 36.004 25.458 C 36.377 25.263 36.985 25.263 37.357 25.458 L 40.688 27.21 C 40.688 27.21 41.59 27.683 42.691 28.263 C 43.793 28.841 44.523 28.312 44.313 27.085 C 44.102 25.859 43.93 24.855 43.93 24.855 L 43.293 21.144 C 43.222 20.732 43.409 20.154 43.71 19.861 L 46.405 17.232 C 46.405 17.232 47.133 16.523 48.025 15.652 C 48.917 14.783 48.638 13.926 47.407 13.746 C 46.175 13.568 45.168 13.422 45.168 13.422 L 41.444 12.881 C 41.029 12.82 40.537 12.463 40.351 12.088 L 38.685 8.711 C 38.685 8.711 38.235 7.799 37.684 6.684 C 37.132 5.567 36.231 5.567 35.679 6.684 C 35.128 7.799 34.678 8.711 34.678 8.711 L 33.012 12.088 C 32.826 12.463 32.334 12.82 31.919 12.881 L 28.193 13.422 C 28.193 13.422 27.185 13.568 25.953 13.746 C 24.722 13.925 24.444 14.783 25.335 15.652 C 26.226 16.523 26.956 17.232 26.956 17.232 Z"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M 64.135 35.315 C 62.203 33.383 59.072 33.383 57.141 35.315 L 6.772 85.682 C 4.84 87.614 4.84 90.746 6.772 92.676 L 7.196 93.1 C 9.128 95.032 12.259 95.032 14.19 93.1 L 64.558 42.733 C 66.49 40.801 66.49 37.669 64.558 35.737 L 64.135 35.315 Z"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M 92.934 60.021 C 91.703 59.842 90.695 59.695 90.695 59.695 L 86.971 59.156 C 86.556 59.093 86.063 58.736 85.878 58.361 L 84.212 54.986 C 84.212 54.986 83.762 54.072 83.21 52.957 C 82.659 51.84 81.757 51.84 81.206 52.957 C 80.654 54.072 80.204 54.986 80.204 54.986 L 78.538 58.361 C 78.352 58.736 77.86 59.092 77.444 59.156 L 73.72 59.694 C 73.72 59.694 72.712 59.841 71.48 60.02 C 70.25 60.198 69.971 61.057 70.862 61.925 C 71.754 62.794 72.483 63.505 72.483 63.505 L 75.177 66.132 C 75.479 66.425 75.665 67.003 75.595 67.417 L 74.958 71.126 C 74.958 71.126 74.786 72.131 74.574 73.357 C 74.364 74.585 75.093 75.113 76.196 74.536 C 77.298 73.956 78.2 73.48 78.2 73.48 L 81.53 71.728 C 81.903 71.536 82.511 71.536 82.884 71.728 L 86.214 73.48 C 86.214 73.48 87.115 73.956 88.218 74.536 C 89.319 75.113 90.05 74.585 89.839 73.357 C 89.628 72.131 89.456 71.126 89.456 71.126 L 88.819 67.417 C 88.749 67.003 88.935 66.425 89.236 66.132 L 91.931 63.505 C 91.931 63.505 92.659 62.794 93.551 61.925 C 94.444 61.058 94.166 60.2 92.934 60.021 Z"
  }));
}));
Autotag.propTypes = {
  /** Icon fill color. */
  fill: PropTypes__default['default'].string,

  /** onClick handler. */
  onClick: PropTypes__default['default'].func,

  /** Styled component theme. */
  theme: PropTypes__default['default'].object,
  // eslint-disable-line react/forbid-prop-types

  /** Icon title. */
  title: PropTypes__default['default'].string,

  /** Icon width (passed to Svg via ...rest props). */
  width: PropTypes__default['default'].string
};
Autotag.defaultProps = {
  fill: '',
  onClick: null,
  theme: null,
  title: '',
  width: '2rem'
};
var Autotag$1 = styled.withTheme(Autotag);var _excluded$1E = ["fill", "onClick", "theme", "title"];
// Component
// =============================

var Camera = /*#__PURE__*/React__default['default'].memo( /*#__PURE__*/React__default['default'].forwardRef(function (_ref, ref) {
  var fill = _ref.fill,
      onClick = _ref.onClick,
      theme = _ref.theme,
      title = _ref.title,
      rest = _objectWithoutProperties$7(_ref, _excluded$1E);

  return /*#__PURE__*/React__default['default'].createElement(Svg$2, _extends$g({
    fill: fill || theme.colors.text,
    onClick: onClick,
    ref: ref,
    title: title,
    viewBox: "0 0 24 20"
  }, rest), /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M5.03 0a.692.692 0 0 0-.7.698c0 .392.308.699.7.699h2.849a.692.692 0 0 0 .698-.699.686.686 0 0 0-.67-.698H5.029zm6.956 7.74a3.732 3.732 0 0 1 3.716 3.715 3.714 3.714 0 0 1-3.716 3.716 3.714 3.714 0 0 1-3.716-3.716 3.732 3.732 0 0 1 3.716-3.716zm0-1.398a5.115 5.115 0 0 0-5.113 5.113 5.115 5.115 0 0 0 5.113 5.113 5.115 5.115 0 0 0 5.113-5.113 5.115 5.115 0 0 0-5.113-5.113zm9.388-2.43c.67 0 1.229.558 1.229 1.229v12.265h-.028c0 .67-.559 1.23-1.23 1.23H2.627a1.24 1.24 0 0 1-1.229-1.23V5.141c0-.67.559-1.23 1.23-1.23h18.747zM2.626 2.515A2.623 2.623 0 0 0 0 5.14v12.265a2.623 2.623 0 0 0 2.626 2.627h18.748A2.623 2.623 0 0 0 24 17.406V5.141c-.028-1.453-1.201-2.626-2.654-2.626H2.626z"
  }));
}));
Camera.propTypes = {
  /** Icon fill color. */
  fill: PropTypes__default['default'].string,

  /** onClick handler. */
  onClick: PropTypes__default['default'].func,

  /** Styled component theme. */
  theme: PropTypes__default['default'].object,
  // eslint-disable-line react/forbid-prop-types

  /** Icon title. */
  title: PropTypes__default['default'].string,

  /** Icon width (passed to Svg via ...rest props). */
  width: PropTypes__default['default'].string
};
Camera.defaultProps = {
  fill: '',
  onClick: null,
  theme: null,
  title: '',
  width: '2.4rem'
};
var Camera$1 = styled.withTheme(Camera);var _excluded$1D = ["fill", "onClick", "theme", "title"];
// Component
// =============================

var Check = /*#__PURE__*/React__default['default'].memo( /*#__PURE__*/React__default['default'].forwardRef(function (_ref, ref) {
  var fill = _ref.fill,
      onClick = _ref.onClick,
      theme = _ref.theme,
      title = _ref.title,
      rest = _objectWithoutProperties$7(_ref, _excluded$1D);

  return /*#__PURE__*/React__default['default'].createElement(Svg$2, _extends$g({
    fill: fill || theme.colors.text,
    onClick: onClick,
    ref: ref,
    title: title,
    viewBox: "0 0 12 9"
  }, rest), /*#__PURE__*/React__default['default'].createElement("path", {
    fillRule: "evenodd",
    d: "M11.077 0a.883.883 0 0 0-.61.274C8.273 2.5 6.274 4.695 4.14 6.887L1.443 4.704a.88.88 0 0 0-.878-.136.904.904 0 0 0-.232 1.54l3.33 2.695a.88.88 0 0 0 1.186-.07c2.385-2.42 4.53-4.805 6.88-7.188a.906.906 0 0 0 .2-1 .887.887 0 0 0-.852-.544z"
  }));
}));
Check.propTypes = {
  /** Icon fill color. */
  fill: PropTypes__default['default'].string,

  /** onClick handler. */
  onClick: PropTypes__default['default'].func,

  /** Styled component theme. */
  theme: PropTypes__default['default'].object,
  // eslint-disable-line react/forbid-prop-types

  /** Icon title. */
  title: PropTypes__default['default'].string,

  /** Icon width (passed to Svg via ...rest props). */
  width: PropTypes__default['default'].string
};
Check.defaultProps = {
  fill: '',
  onClick: null,
  theme: null,
  title: '',
  width: '1.2rem'
};
var Check$1 = styled.withTheme(Check);var _excluded$1C = ["checked", "fill", "onClick", "theme", "title"];
// Component
// =============================

var CheckBox = /*#__PURE__*/React__default['default'].memo( /*#__PURE__*/React__default['default'].forwardRef(function (_ref, ref) {
  var checked = _ref.checked,
      fill = _ref.fill,
      onClick = _ref.onClick,
      theme = _ref.theme,
      title = _ref.title,
      rest = _objectWithoutProperties$7(_ref, _excluded$1C);

  return /*#__PURE__*/React__default['default'].createElement(Svg$2, _extends$g({
    fill: fill || theme.colors.text,
    onClick: onClick,
    ref: ref,
    title: title,
    viewBox: "0 0 15 15"
  }, rest), checked ? /*#__PURE__*/React__default['default'].createElement("path", {
    fillRule: "evenodd",
    d: "M10 0H5C2.24042 0 0 2.24042 0 5V10C0 12.7596 2.24042 15 5 15H10C12.7596 15 15 12.7596 15 10V5C15 4.61575 14.9566 4.24156 14.8743 3.88209L8.76579 10.459C8.43495 10.8136 7.91099 10.8483 7.54224 10.5402L3.831 6.74415C3.56892 6.52556 3.43507 6.17303 3.47986 5.81937C3.52465 5.46571 3.74128 5.16464 4.04815 5.02957C4.35501 4.8945 4.70549 4.94596 4.96757 5.16455L8.02935 8.42365L13.9976 1.99781C13.0849 0.784915 11.6334 0 10 0Z"
  }) : /*#__PURE__*/React__default['default'].createElement("path", {
    fillRule: "evenodd",
    d: "M10,1H5C3.345,1,1,3.345,1,5v5c0,1.655,2.345,4,4,4h5c1.655,0,4-2.345,4-4V5C14,3.345,11.655,1,10,1z M10,0 H5C2.24,0,0,2.24,0,5v2.5V10c0,2.76,2.24,5,5,5h5c2.76,0,5-2.24,5-5V5C15,2.24,12.76,0,10,0z"
  }));
}));
CheckBox.propTypes = {
  /** If True, CheckBox is checked. */
  checked: PropTypes__default['default'].bool,

  /** Icon fill color. */
  fill: PropTypes__default['default'].string,

  /** onClick handler. */
  onClick: PropTypes__default['default'].func,

  /** Styled component theme. */
  theme: PropTypes__default['default'].object,
  // eslint-disable-line react/forbid-prop-types

  /** Icon title. */
  title: PropTypes__default['default'].string,

  /** Icon width (passed to Svg via ...rest props). */
  width: PropTypes__default['default'].string
};
CheckBox.defaultProps = {
  checked: false,
  fill: '',
  onClick: null,
  theme: null,
  title: '',
  width: '1.5rem'
};
var CheckBox$1 = styled.withTheme(CheckBox);var _excluded$1B = ["fill", "onClick", "theme", "title"];
// Component
// =============================

var Clipboard$1 = /*#__PURE__*/React__default['default'].memo( /*#__PURE__*/React__default['default'].forwardRef(function (_ref, ref) {
  var fill = _ref.fill,
      onClick = _ref.onClick;
      _ref.theme;
      var title = _ref.title,
      rest = _objectWithoutProperties$7(_ref, _excluded$1B);

  return /*#__PURE__*/React__default['default'].createElement(Svg$2, _extends$g({
    fill: fill || '#000',
    onClick: onClick,
    ref: ref,
    title: title,
    viewBox: "0 0 100 100"
  }, rest), /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M68 32h-4v-4c0-2.2-1.8-4-4-4H32c-2.2 0-4 1.8-4 4v36c0 2.2 1.8 4 4 4h4v4c0 2.2 1.8 4 4 4h28c2.2 0 4-1.8 4-4V36c0-2.2-1.8-4-4-4zm-32 4v28h-4V28h28v4H40c-2.2 0-4 1.8-4 4zm32 36H40V36h28v36z"
  }));
}));
Clipboard$1.propTypes = {
  /** Icon fill color. */
  fill: PropTypes__default['default'].string,

  /** onClick handler. */
  onClick: PropTypes__default['default'].func,

  /** Styled component theme. */
  theme: PropTypes__default['default'].object,
  // eslint-disable-line react/forbid-prop-types

  /** Icon title. */
  title: PropTypes__default['default'].string,

  /** Icon width (passed to Svg via ...rest props). */
  width: PropTypes__default['default'].string
};
Clipboard$1.defaultProps = {
  fill: '',
  onClick: null,
  theme: null,
  title: '',
  width: '1rem'
};
var Clipboard$2 = styled.withTheme(Clipboard$1);var _excluded$1A = ["fill", "onClick", "theme", "title"];
// Component
// =============================

var Clock = /*#__PURE__*/React__default['default'].memo( /*#__PURE__*/React__default['default'].forwardRef(function (_ref, ref) {
  var fill = _ref.fill,
      onClick = _ref.onClick,
      theme = _ref.theme,
      title = _ref.title,
      rest = _objectWithoutProperties$7(_ref, _excluded$1A);

  return /*#__PURE__*/React__default['default'].createElement(Svg$2, _extends$g({
    fill: fill || theme.colors.text,
    onClick: onClick,
    ref: ref,
    title: title,
    viewBox: "0 0 100 100"
  }, rest), /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M5273.1,2400.1v-2c0-2.8-5-4-9.7-4s-9.7,1.3-9.7,4v2c0,1.8,0.7,3.6,2,4.9l5,4.9c0.3,0.3,0.4,0.6,0.4,1v6.4     c0,0.4,0.2,0.7,0.6,0.8l2.9,0.9c0.5,0.1,1-0.2,1-0.8v-7.2c0-0.4,0.2-0.7,0.4-1l5.1-5C5272.4,2403.7,5273.1,2401.9,5273.1,2400.1z      M5263.4,2400c-4.8,0-7.4-1.3-7.5-1.8v0c0.1-0.5,2.7-1.8,7.5-1.8c4.8,0,7.3,1.3,7.5,1.8C5270.7,2398.7,5268.2,2400,5263.4,2400z"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M5268.4,2410.3c-0.6,0-1,0.4-1,1c0,0.6,0.4,1,1,1h4.3c0.6,0,1-0.4,1-1c0-0.6-0.4-1-1-1H5268.4z"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M5272.7,2413.7h-4.3c-0.6,0-1,0.4-1,1c0,0.6,0.4,1,1,1h4.3c0.6,0,1-0.4,1-1C5273.7,2414.1,5273.3,2413.7,5272.7,2413.7z"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M5272.7,2417h-4.3c-0.6,0-1,0.4-1,1c0,0.6,0.4,1,1,1h4.3c0.6,0,1-0.4,1-1C5273.7,2417.5,5273.3,2417,5272.7,2417z"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M50,2.5C23.8,2.5,2.5,23.8,2.5,50S23.8,97.5,50,97.5S97.5,76.2,97.5,50S76.2,2.5,50,2.5z M50,88c-20.9,0-38-17-38-38     s17-38,38-38c21,0,38,17,38,38S70.9,88,50,88z"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M68.6,53l-13.9-6.1V25.5c0-2.6-2.1-4.8-4.8-4.8s-4.8,2.1-4.8,4.8V50c0,1.9,1.1,3.6,2.8,4.4l16.7,7.3     c0.6,0.3,1.3,0.4,1.9,0.4c1.8,0,3.6-1.1,4.4-2.8C72.1,56.8,71,54,68.6,53z"
  }));
}));
Clock.propTypes = {
  /** Icon fill color. */
  fill: PropTypes__default['default'].string,

  /** onClick handler. */
  onClick: PropTypes__default['default'].func,

  /** Styled component theme. */
  theme: PropTypes__default['default'].object,
  // eslint-disable-line react/forbid-prop-types

  /** Icon title. */
  title: PropTypes__default['default'].string,

  /** Icon width (passed to Svg via ...rest props). */
  width: PropTypes__default['default'].string
};
Clock.defaultProps = {
  fill: '',
  onClick: null,
  theme: null,
  title: '',
  width: '2.4rem'
};
var Clock$1 = styled.withTheme(Clock);var _excluded$1z = ["fill", "onClick", "theme", "title"];
// Component
// =============================

var ClosePlayer = /*#__PURE__*/React__default['default'].memo( /*#__PURE__*/React__default['default'].forwardRef(function (_ref, ref) {
  var fill = _ref.fill,
      onClick = _ref.onClick,
      theme = _ref.theme,
      title = _ref.title,
      rest = _objectWithoutProperties$7(_ref, _excluded$1z);

  return /*#__PURE__*/React__default['default'].createElement(Svg$2, _extends$g({
    fill: fill || theme.colors.text,
    onClick: onClick,
    ref: ref,
    title: title,
    viewBox: "0 0 10 10"
  }, rest), /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M14.6773162,5.32268523 C15.1075628,5.75293203 15.1075626,6.45154347 14.6773158,6.88179003 L11.559,10 L14.6773158,13.1182066 C15.0768307,13.5177213 15.1053676,14.1486322 14.7629265,14.5812036 L14.6773162,14.6773114 C14.2470696,15.1075582 13.5484582,15.1075584 13.1182114,14.6773118 L13.1182114,14.6773118 L10,11.559 L6.88178959,14.6773118 C6.45154279,15.1075584 5.75293135,15.1075582 5.32268479,14.6773114 C4.89243823,14.2470646 4.89243843,13.5484532 5.32268523,13.1182066 L8.441,10 L5.32268523,6.88179003 C4.92317034,6.48227536 4.8946334,5.85136446 5.23707451,5.41879299 L5.32268479,5.32268523 C5.75293135,4.89243843 6.45154279,4.89243823 6.88178959,5.32268479 L6.88178959,5.32268479 L10,8.441 L13.1182114,5.32268479 C13.5484582,4.89243823 14.2470696,4.89243843 14.6773162,5.32268523 Z",
    transform: "translate(-5 -5)"
  }));
}));
ClosePlayer.propTypes = {
  /** Icon fill color. */
  fill: PropTypes__default['default'].string,

  /** onClick handler. */
  onClick: PropTypes__default['default'].func,

  /** Styled component theme. */
  theme: PropTypes__default['default'].object,
  // eslint-disable-line react/forbid-prop-types

  /** Icon title. */
  title: PropTypes__default['default'].string,

  /** Icon width (passed to Svg via ...rest props). */
  width: PropTypes__default['default'].string
};
ClosePlayer.defaultProps = {
  fill: '',
  onClick: null,
  theme: null,
  title: '',
  width: '1rem'
};
var ClosePlayer$1 = styled.withTheme(ClosePlayer);var _excluded$1y = ["fill", "onClick", "theme", "title"];
// Component
// =============================

var Contributors = /*#__PURE__*/React__default['default'].memo( /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var fill = _ref.fill,
      onClick = _ref.onClick,
      theme = _ref.theme,
      title = _ref.title,
      rest = _objectWithoutProperties$7(_ref, _excluded$1y);

  return /*#__PURE__*/React__default['default'].createElement(Svg$2, _extends$g({
    fill: fill || theme.colors.text,
    onClick: onClick,
    ref: ref,
    title: title,
    viewBox: "0 0 99.5 67.1"
  }, rest), /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M85.7,26.6C91.8,20.7,92,11,86.2,4.8C83.4,1.8,79.5,0,75.4,0c-6.8,0-12.7,4.5-14.6,11.1 C55,4.9,45.5,4.6,39.4,10.4c-0.2,0.2-0.4,0.4-0.7,0.7C36.2,2.9,27.6-1.6,19.6,0.9c-8,2.6-12.5,11.2-10,19.4 c0.8,2.5,2.2,4.8,4.1,6.7C5.4,31,0,39.6,0,49c0,2.4,1.1,6.9,8.6,9.8c5,1.6,10.2,2.4,15.5,2.3h4c1.7,1.8,3.8,3,6.2,3.7 c5,1.6,10.2,2.4,15.5,2.3c8.3,0,17.7-1.8,21.9-6.4h3.7c11.1,0.1,24.1-3.1,24.1-11.9C99.5,39.3,94.1,30.7,85.7,26.6L85.7,26.6z  M75.4,6.6c4.8,0,8.8,4,8.8,8.9s-3.9,8.9-8.8,8.9s-8.8-4-8.8-8.9c0,0,0,0,0,0c-0.1-4.8,3.8-8.8,8.5-8.9C75.2,6.6,75.3,6.6,75.4,6.6 z M64.3,26.1c0.2,0.1,0.4,0.3,0.5,0.5L64,27.2C64,27.2,64.3,26.1,64.3,26.1z M49.7,12.8c4.8,0,8.8,4,8.8,8.9s-3.9,8.9-8.8,8.9 s-8.8-4-8.8-8.9S44.9,12.8,49.7,12.8C49.7,12.8,49.7,12.8,49.7,12.8z M35.2,26.3c0.1,0.4,0.3,0.8,0.4,1.2L34.6,27 C34.6,27,35.2,26.3,35.2,26.3z M24.1,6.8c4.8,0,8.8,4,8.8,8.9s-3.9,8.9-8.8,8.9l0,0c-4.8,0-8.8-4-8.8-8.9S19.3,6.8,24.1,6.8z  M25.6,54.5h-1.5c-10.9,0-17.6-3.2-17.6-5.5c0-9.9,7.9-17.9,17.6-17.9l0,0c4.2,0,8.2,1.4,11.4,4.2C29.4,39.8,25.7,46.9,25.6,54.5z  M49.7,60.5c-10.9,0-17.6-3.2-17.6-5.5c0-9.9,7.9-17.9,17.6-17.9c9.7,0,17.6,8,17.6,17.9C67.4,57.3,60.6,60.5,49.7,60.5z  M75.4,54.2h-1.5c-0.2-7.6-3.9-14.7-10.1-19.1c7.3-6.5,18.5-5.7,24.9,1.7c2.8,3.3,4.4,7.5,4.3,11.8C93,51.1,86.3,54.2,75.4,54.2z"
  }));
}));
Contributors.propTypes = {
  /** Icon fill color. */
  fill: PropTypes__default['default'].string,

  /** onClick handler. */
  onClick: PropTypes__default['default'].func,

  /** Styled component theme. */
  theme: PropTypes__default['default'].object,
  // eslint-disable-line react/forbid-prop-types

  /** Icon title. */
  title: PropTypes__default['default'].string,

  /** Icon width (passed to Svg via ...rest props). */
  width: PropTypes__default['default'].string
};
Contributors.defaultProps = {
  fill: '',
  onClick: null,
  theme: null,
  title: '',
  width: '2rem'
};
var Contributors$1 = styled.withTheme(Contributors);var _excluded$1x = ["fill", "onClick", "theme", "title"];
// Component
// =============================

var Copyright = /*#__PURE__*/React__default['default'].memo( /*#__PURE__*/React__default['default'].forwardRef(function (_ref, ref) {
  var fill = _ref.fill,
      onClick = _ref.onClick,
      theme = _ref.theme,
      title = _ref.title,
      rest = _objectWithoutProperties$7(_ref, _excluded$1x);

  return /*#__PURE__*/React__default['default'].createElement(Svg$2, _extends$g({
    fill: fill || theme.colors.text,
    onClick: onClick,
    ref: ref,
    title: title,
    viewBox: "0 0 87.5 87.6"
  }, rest), /*#__PURE__*/React__default['default'].createElement("g", {
    transform: "translate(0,-288.53332)"
  }, /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M42.5,288.6C18.8,289.2,0,308.6,0,332.3c0,24.2,19.6,43.8,43.7,43.8s43.8-19.6,43.8-43.7c0,0,0,0,0,0 c0-24.2-19.5-43.8-43.7-43.8C43.4,288.5,42.9,288.5,42.5,288.6z M42.8,297.9c19-0.5,34.8,14.4,35.3,33.4c0,0.3,0,0.7,0,1 c0,19-15.4,34.4-34.4,34.4c-19,0-34.4-15.4-34.4-34.4c0,0,0,0,0,0C9.4,313.7,24.2,298.5,42.8,297.9z"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M33,344.5c-6.3-6.9-6.3-17.5,0-24.4c5.4-5.9,14.5-6.3,20.5-1c1.7,1.6,3,3.5,3.8,5.7c1.1,2.8,4.2,4.3,7,3.2 c2.8-1.1,4.2-4.2,3.2-7c-4.9-13.2-19.5-19.9-32.7-15c-3.8,1.4-7.2,3.7-10,6.7c-10.1,11.1-10.1,28,0,39.1 c9.5,10.4,25.5,11.1,35.9,1.7c3-2.7,5.3-6.1,6.7-10c1-2.8-0.4-6-3.3-7c-2.8-1-5.9,0.4-7,3.2c-2.8,7.5-11.1,11.3-18.6,8.5 C36.5,347.5,34.6,346.2,33,344.5L33,344.5z"
  })));
}));
Copyright.propTypes = {
  /** Icon fill color. */
  fill: PropTypes__default['default'].string,

  /** onClick handler. */
  onClick: PropTypes__default['default'].func,

  /** Styled component theme. */
  theme: PropTypes__default['default'].object,
  // eslint-disable-line react/forbid-prop-types

  /** Icon title. */
  title: PropTypes__default['default'].string,

  /** Icon width (passed to Svg via ...rest props). */
  width: PropTypes__default['default'].string
};
Copyright.defaultProps = {
  fill: '',
  onClick: null,
  theme: null,
  title: '',
  width: '2rem'
};
var Copyright$1 = styled.withTheme(Copyright);var _excluded$1w = ["backgroundColor", "fill", "onClick", "theme", "title"];
// Component
// =============================

var CrossBackground = /*#__PURE__*/React__default['default'].memo( /*#__PURE__*/React__default['default'].forwardRef(function (_ref, ref) {
  var backgroundColor = _ref.backgroundColor,
      fill = _ref.fill,
      onClick = _ref.onClick,
      theme = _ref.theme,
      title = _ref.title,
      rest = _objectWithoutProperties$7(_ref, _excluded$1w);

  return /*#__PURE__*/React__default['default'].createElement(Svg$2, _extends$g({
    onClick: onClick,
    ref: ref,
    title: title,
    viewBox: "0 0 25 25"
  }, rest), /*#__PURE__*/React__default['default'].createElement("path", {
    fill: backgroundColor || theme.colors.text,
    fillRule: "evenodd",
    d: "M12.5 0C19.399 0 25 5.601 25 12.5S19.399 25 12.5 25 0 19.399 0 12.5 5.601 0 12.5 0z"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    fill: fill || theme.colors.background,
    fillRule: "evenodd",
    d: "M16.224 8.76a.884.884 0 0 0-1.252 0L12.5 11.235 10.012 8.76a.884.884 0 0 0-1.252 0 .887.887 0 0 0 0 1.254l2.488 2.492-2.488 2.476a.887.887 0 0 0 0 1.254.86.86 0 0 0 .626.264c.23 0 .461-.083.626-.264l2.488-2.492 2.488 2.492a.86.86 0 0 0 .626.264c.231 0 .462-.083.626-.264a.887.887 0 0 0 0-1.254l-2.488-2.476 2.488-2.492a.903.903 0 0 0-.016-1.254z"
  }));
}));
CrossBackground.propTypes = {
  /** SVG background color */
  backgroundColor: PropTypes__default['default'].string,

  /** Icon fill color. */
  fill: PropTypes__default['default'].string.isRequired,

  /** onClick handler. */
  onClick: PropTypes__default['default'].func,

  /** Styled component theme. */
  theme: PropTypes__default['default'].object,
  // eslint-disable-line react/forbid-prop-types

  /** Icon title. */
  title: PropTypes__default['default'].string,

  /** Icon width (passed to Svg via ...rest props). */
  width: PropTypes__default['default'].string
};
CrossBackground.defaultProps = {
  backgroundColor: '',
  onClick: null,
  theme: null,
  title: '',
  width: '1.5rem'
};
var CrossBackground$1 = styled.withTheme(CrossBackground);var _excluded$1v = ["fill", "onClick", "theme", "title"];
// Component
// =============================

var CrossOutline = /*#__PURE__*/React__default['default'].memo( /*#__PURE__*/React__default['default'].forwardRef(function (_ref, ref) {
  var fill = _ref.fill,
      onClick = _ref.onClick,
      theme = _ref.theme,
      title = _ref.title,
      rest = _objectWithoutProperties$7(_ref, _excluded$1v);

  return /*#__PURE__*/React__default['default'].createElement(Svg$2, _extends$g({
    fill: fill || theme.colors.text,
    onClick: onClick,
    ref: ref,
    title: title,
    viewBox: "0 0 40 40"
  }, rest), /*#__PURE__*/React__default['default'].createElement("circle", {
    fillOpacity: "0",
    stroke: fill || theme.colors.text,
    strokeWidth: "2",
    cx: "20",
    cy: "20",
    r: "19"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    fillRule: "evenodd",
    d: "M19.981 18.567l-3.517-3.517a1 1 0 0 0-1.414 1.414l3.517 3.517-3.517 3.516a1.092 1.092 0 0 0 1.544 1.545l3.517-3.517 3.425 3.425a1 1 0 0 0 1.414-1.414l-3.425-3.425 3.425-3.425a1.092 1.092 0 0 0-1.544-1.544l-3.425 3.425z"
  }));
}));
CrossOutline.propTypes = {
  /** Icon fill color. */
  fill: PropTypes__default['default'].string,

  /** onClick handler. */
  onClick: PropTypes__default['default'].func,

  /** Styled component theme. */
  theme: PropTypes__default['default'].object,
  // eslint-disable-line react/forbid-prop-types

  /** Icon title. */
  title: PropTypes__default['default'].string,

  /** Icon width (passed to Svg via ...rest props). */
  width: PropTypes__default['default'].string
};
CrossOutline.defaultProps = {
  fill: '',
  onClick: null,
  theme: null,
  title: '',
  width: '4rem'
};
var CrossOutline$1 = styled.withTheme(CrossOutline);var _excluded$1u = ["fill", "onClick", "theme", "title"];
// Component
// =============================

var Description$2 = /*#__PURE__*/React__default['default'].memo( /*#__PURE__*/React__default['default'].forwardRef(function (_ref, ref) {
  var fill = _ref.fill,
      onClick = _ref.onClick,
      theme = _ref.theme,
      title = _ref.title,
      rest = _objectWithoutProperties$7(_ref, _excluded$1u);

  return /*#__PURE__*/React__default['default'].createElement(Svg$2, _extends$g({
    fill: fill || theme.colors.text,
    onClick: onClick,
    ref: ref,
    title: title,
    viewBox: "0 0 16 13"
  }, rest), /*#__PURE__*/React__default['default'].createElement("path", {
    fillRule: "evenodd",
    d: "M15.856.146a.5.5 0 0 1-.353.854h-6a.5.5 0 0 1 0-1h6a.5.5 0 0 1 .353.146zM1.003 0h5c1.015 0 1.009.432 1.001.992l-.001.15v1.715l.001.151c.008.56.014.992-1.001.992h-5C-.012 4-.007 3.568 0 3.008l.002-.15V1.142L0 .992C-.006.432-.012 0 1.003 0zm15 3.5a.5.5 0 0 0-.5-.5h-6a.5.5 0 0 0 0 1h6a.5.5 0 0 0 .5-.5zm0 3a.5.5 0 0 0-.5-.5h-15a.5.5 0 1 0 0 1h15a.5.5 0 0 0 .5-.5zm-.147 2.646a.5.5 0 0 1-.353.854h-15a.5.5 0 1 1 0-1h15a.5.5 0 0 1 .353.146zm0 3a.5.5 0 0 1-.353.854h-15a.5.5 0 1 1 0-1h15a.5.5 0 0 1 .353.146z"
  }));
}));
Description$2.propTypes = {
  /** Icon fill color. */
  fill: PropTypes__default['default'].string,

  /** onClick handler. */
  onClick: PropTypes__default['default'].func,

  /** Styled component theme. */
  theme: PropTypes__default['default'].object,
  // eslint-disable-line react/forbid-prop-types

  /** Icon title. */
  title: PropTypes__default['default'].string,

  /** Icon width (passed to Svg via ...rest props). */
  width: PropTypes__default['default'].string
};
Description$2.defaultProps = {
  fill: '',
  onClick: null,
  theme: null,
  title: '',
  width: '1.6rem'
};
var Description$3 = styled.withTheme(Description$2);var _excluded$1t = ["fill", "onClick", "theme", "title"];
// Component
// =============================

var Dot = /*#__PURE__*/React__default['default'].memo( /*#__PURE__*/React__default['default'].forwardRef(function (_ref, ref) {
  var fill = _ref.fill,
      onClick = _ref.onClick,
      theme = _ref.theme,
      title = _ref.title,
      rest = _objectWithoutProperties$7(_ref, _excluded$1t);

  return /*#__PURE__*/React__default['default'].createElement(Svg$2, _extends$g({
    fill: fill || theme.colors.text,
    onClick: onClick,
    ref: ref,
    title: title,
    viewBox: "0 0 3 3"
  }, rest), /*#__PURE__*/React__default['default'].createElement("ellipse", {
    rx: "1.5",
    ry: "1.5",
    cx: "1.5",
    cy: "1.5"
  }));
}));
Dot.propTypes = {
  /** Icon fill color. */
  fill: PropTypes__default['default'].string,

  /** onClick handler. */
  onClick: PropTypes__default['default'].func,

  /** Styled component theme. */
  theme: PropTypes__default['default'].object,
  // eslint-disable-line react/forbid-prop-types

  /** Icon title. */
  title: PropTypes__default['default'].string,

  /** Icon width (passed to Svg via ...rest props). */
  width: PropTypes__default['default'].string
};
Dot.defaultProps = {
  fill: '',
  onClick: null,
  theme: null,
  title: '',
  width: '0.3rem'
};
var Dot$1 = styled.withTheme(Dot);var _excluded$1s = ["fill", "onClick", "theme", "title"];
// Component
// =============================

var Draggable = /*#__PURE__*/React__default['default'].memo( /*#__PURE__*/React__default['default'].forwardRef(function (_ref, ref) {
  var fill = _ref.fill,
      onClick = _ref.onClick,
      theme = _ref.theme,
      title = _ref.title,
      rest = _objectWithoutProperties$7(_ref, _excluded$1s);

  return /*#__PURE__*/React__default['default'].createElement(Svg$2, _extends$g({
    fill: fill || theme.colors.text,
    onClick: onClick,
    ref: ref,
    title: title,
    viewBox: "0 0 8 12"
  }, rest), /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M2.9735794369408377,1.4328778695560789 C2.974634729995261,1.4397529925525734 2.975187768080209,1.4469766245364235 2.975187768080209,1.4545488628021523 C2.9699672638098447,2.1317113600957507 2.4753168169383426,2.743835581074715 1.790115176106007,2.879012896454138 C1.1766966638879854,2.998887339815948 0.5384802585120628,2.7323581351779285 0.2121937628776172,2.208226887718121 C-0.11670300978569352,1.680269630370335 -0.05536115109578613,0.9992815123668586 0.3414032350638049,0.5248852313787095 C0.7316418539701809,0.05814053234115466 1.4142331928799672,-0.12294621393275891 1.992412803399363,0.08619622337032738 C2.570180672384503,0.2966375304158932 2.960617793527528,0.8320697801520038 2.9735794369408377,1.4328778695560789 L2.9735794369408377,1.4328778695560789ZM7.998391668860774,1.4328792316794239 C7.999447161064669,1.4397539654978204 8.00000000000014,1.4469771110090468 8.00000000000014,1.4545488628021523 C7.994779097430836,2.1317113600957507 7.5001284514098625,2.743835581074715 6.814926810577522,2.879012896454138 C6.201508597083712,2.998887339815948 5.563292291282525,2.7323581351779285 5.23700579564808,2.208226887718121 C4.90810884872898,1.680269630370335 4.969450869227833,0.9992815123668586 5.366215168259531,0.5248852313787095 C5.756453737378537,0.05814053234115466 6.439045325225168,-0.12294621393275891 7.017224437870879,0.08619622337032738 C7.594992904304439,0.29663770068131146 7.985430224596935,0.8320706558027257 7.998391668860774,1.4328792316794239 L7.998391668860774,1.4328792316794239ZM2.9735794369408377,5.979175469118589 C2.974634729995261,5.986050689409609 2.975187768080209,5.9932742240989345 2.975187768080209,6.000846462364663 C2.9699672638098447,6.678008959658259 2.4753168169383426,7.290133180637223 1.790115176106007,7.425310301427598 C1.1766966638879854,7.5451849393784585 0.5384802585120628,7.278655540151388 0.2121937628776172,6.75452448728063 C-0.11670300978569352,6.226567035343795 -0.05536115109578613,5.545579306518417 0.3414032350638049,5.071182879588481 C0.7316418539701809,4.604438083256402 1.4142331928799672,4.423351568056985 1.992412803399363,4.632493932389176 C2.570180672384503,4.8429349840366145 2.960617793527528,5.378367768892611 2.9735794369408377,5.979175469118589 L2.9735794369408377,5.979175469118589ZM7.998391668860774,5.979176636652884 C7.999447161064669,5.986051467765805 8.00000000000014,5.993274613277032 8.00000000000014,6.000846462364663 C7.994779097430836,6.678008959658259 7.5001284514098625,7.290133180637223 6.814926810577522,7.425310301427598 C6.201508597083712,7.5451849393784585 5.563292291282525,7.278655540151388 5.23700579564808,6.75452448728063 C4.90810884872898,6.226567035343795 4.969450869227833,5.545579306518417 5.366215168259531,5.071182879588481 C5.756453737378537,4.604438083256402 6.439045325225168,4.423351568056985 7.017224437870879,4.632493932389176 C7.594992904304439,4.8429349840366145 7.985430224596935,5.37836815807071 7.998391668860774,5.979176636652884 L7.998391668860774,5.979176636652884ZM2.9735794369408377,10.525472679502997 C2.974634729995261,10.532347899794017 2.975187768080209,10.539571823661442 2.975187768080209,10.547143672749074 C2.9699672638098447,11.224306559220768 2.4753168169383426,11.836430780199734 1.790115176106007,11.971607900990106 C1.1766966638879854,12.09148253894097 0.5384802585120628,11.824953139713896 0.2121937628776172,11.300822086843139 C-0.11670300978569352,10.772864634906304 -0.05536115109578613,10.091876906080925 0.3414032350638049,9.617480479150991 C0.7316418539701809,9.150736071997011 1.4142331928799672,8.969649167619492 1.992412803399363,9.17879114277359 C2.570180672384503,9.389232972777224 2.960617793527528,9.924664200920825 2.9735794369408377,10.525472679502997 L2.9735794369408377,10.525472679502997ZM7.998391668860774,10.525474236215395 C7.999447161064669,10.532348678150214 8.00000000000014,10.539571823661442 8.00000000000014,10.547143672749074 C7.994779097430836,11.224306559220768 7.5001284514098625,11.836430780199734 6.814926810577522,11.971607900990106 C6.201508597083712,12.09148253894097 5.563292291282525,11.824953139713896 5.23700579564808,11.300822086843139 C4.90810884872898,10.772864634906304 4.969450869227833,10.091876906080925 5.366215168259531,9.617480479150991 C5.756453737378537,9.150736071997011 6.439045325225168,8.969649167619492 7.017224437870879,9.17879114277359 C7.594992904304439,9.389232972777224 7.985430224596935,9.924665757633218 7.998391668860774,10.525474236215395 L7.998391668860774,10.525474236215395Z"
  }));
}));
Draggable.propTypes = {
  /** Icon fill color. */
  fill: PropTypes__default['default'].string,

  /** onClick handler. */
  onClick: PropTypes__default['default'].func,

  /** Styled component theme. */
  theme: PropTypes__default['default'].object,
  // eslint-disable-line react/forbid-prop-types

  /** Icon title. */
  title: PropTypes__default['default'].string,

  /** Icon width (passed to Svg via ...rest props). */
  width: PropTypes__default['default'].string
};
Draggable.defaultProps = {
  fill: '',
  onClick: null,
  theme: null,
  title: '',
  width: '0.8rem'
};
var Draggable$1 = styled.withTheme(Draggable);var _excluded$1r = ["fill", "onClick", "theme", "title"];
// Component
// =============================

var Duplicate = /*#__PURE__*/React__default['default'].memo( /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var fill = _ref.fill,
      onClick = _ref.onClick,
      theme = _ref.theme,
      title = _ref.title,
      rest = _objectWithoutProperties$7(_ref, _excluded$1r);

  return /*#__PURE__*/React__default['default'].createElement(Svg$2, _extends$g({
    fill: fill || theme.colors.text,
    onClick: onClick,
    ref: ref,
    title: title,
    viewBox: "0 0 77 77"
  }, rest), /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M69,0H27.1c-4.4,0-8,3.6-8,8v41.9c0,4.4,3.6,8,8,8H69c4.4,0,8-3.6,8-8V8C77,3.6,73.4,0,69,0z M27.1,49.9V8H69v41.9H27.1z"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M8,77h41.9c4.4,0,8-3.6,8-8v-5c0-2.2-1.8-4-4-4c-2.2,0-4,1.8-4,4v5H8V27.1h5.2c2.2,0,4-1.8,4-4s-1.8-4-4-4H8 c-4.4,0-8,3.6-8,8V69C0,73.4,3.6,77,8,77z"
  }));
}));
Duplicate.propTypes = {
  /** Icon fill color. */
  fill: PropTypes__default['default'].string,

  /** onClick handler. */
  onClick: PropTypes__default['default'].func,

  /** Styled component theme. */
  theme: PropTypes__default['default'].object,
  // eslint-disable-line react/forbid-prop-types

  /** Icon title. */
  title: PropTypes__default['default'].string,

  /** Icon width (passed to Svg via ...rest props). */
  width: PropTypes__default['default'].string
};
Duplicate.defaultProps = {
  fill: '',
  onClick: null,
  theme: null,
  title: '',
  width: '2rem'
};
var Duplicate$1 = styled.withTheme(Duplicate);var _excluded$1q = ["fill", "onClick", "theme", "title"];
// Component
// =============================

var Download = /*#__PURE__*/React__default['default'].memo( /*#__PURE__*/React__default['default'].forwardRef(function (_ref, ref) {
  var fill = _ref.fill,
      onClick = _ref.onClick,
      theme = _ref.theme,
      title = _ref.title,
      rest = _objectWithoutProperties$7(_ref, _excluded$1q);

  return /*#__PURE__*/React__default['default'].createElement(Svg$2, _extends$g({
    fill: fill || theme.colors.text,
    onClick: onClick,
    ref: ref,
    title: title,
    viewBox: "0 0 100 100"
  }, rest), /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M89.7,68.05V85.62a3.81,3.81,0,0,1-.13,1h0a3.77,3.77,0,0,1-3.67,3H14.07a3.76,3.76,0,0,1-3.72-3.35,2.9,2.9,0,0,1,0-.67V68a3.76,3.76,0,0,1,3.75-3.75,3.8,3.8,0,0,1,2.65,1.1A3.76,3.76,0,0,1,17.8,68V82.1H82.23V68A3.76,3.76,0,0,1,86,64.27a3.8,3.8,0,0,1,2.65,1.1A4,4,0,0,1,89.7,68.05Z"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M71.63,50.45,53.2,68.87a.31.31,0,0,1-.1.1,4.34,4.34,0,0,1-2.42,1.23l-.23,0a2.27,2.27,0,0,1-.45,0h0l-.42,0-.23,0A4.24,4.24,0,0,1,46.93,69l-.1-.1L28.4,50.45a4.38,4.38,0,0,1,6.2-6.2L45.68,55.32V14.75a4.4,4.4,0,0,1,4.37-4.38,4.45,4.45,0,0,1,3.1,1.28,4.32,4.32,0,0,1,1.28,3.1V55.32L65.5,44.25a4.41,4.41,0,0,1,6.2,0A4.49,4.49,0,0,1,71.63,50.45Z"
  }));
}));
Download.propTypes = {
  /** Icon fill color. */
  fill: PropTypes__default['default'].string,

  /** onClick handler. */
  onClick: PropTypes__default['default'].func,

  /** Styled component theme. */
  theme: PropTypes__default['default'].object,
  // eslint-disable-line react/forbid-prop-types

  /** Icon title. */
  title: PropTypes__default['default'].string,

  /** Icon width (passed to Svg via ...rest props). */
  width: PropTypes__default['default'].string
};
Download.defaultProps = {
  fill: '',
  onClick: null,
  theme: null,
  title: '',
  width: '1.4rem'
};
var Download$1 = styled.withTheme(Download);var _excluded$1p = ["fill", "onClick", "theme", "title"];
// Component
// =============================

var Earth = /*#__PURE__*/React__default['default'].memo( /*#__PURE__*/React__default['default'].forwardRef(function (_ref, ref) {
  var fill = _ref.fill,
      onClick = _ref.onClick,
      theme = _ref.theme,
      title = _ref.title,
      rest = _objectWithoutProperties$7(_ref, _excluded$1p);

  return /*#__PURE__*/React__default['default'].createElement(Svg$2, _extends$g({
    fill: fill || theme.colors.text,
    onClick: onClick,
    ref: ref,
    title: title,
    viewBox: "0 0 20 20"
  }, rest), /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M20 10a9.928 9.928 0 0 0-2.938-7.063A9.928 9.928 0 0 0 10 0a9.928 9.928 0 0 0-7.063 2.938A9.928 9.928 0 0 0 0 10a9.928 9.928 0 0 0 2.938 7.063A9.928 9.928 0 0 0 10 20a9.928 9.928 0 0 0 7.063-2.938A9.928 9.928 0 0 0 20 10zm-1.438 1.75c-.312 1.688-1.125 3.188-2.375 4.438A8.804 8.804 0 0 1 10 18.75c-2.313 0-4.563-.938-6.125-2.625-1.313-1.313-2.125-2.938-2.438-4.75.125-.625.438-1.188.875-1.563.188-.187-.062-.75-.937-1.062a7.74 7.74 0 0 1 1.063-3.125C3.5 5.813 4.75 4.562 5 3.687c.375-.25.125-.5-.25-.687A8.693 8.693 0 0 1 10 1.25c1.313 0 2.625.313 3.938.875-.063.688-.876.625-1.376.063-.187 0-.5.062-.812.187-.938.375-2 1.313-1.625 1.75.625-.438 1.438-.25.875.625-.426.675-.833.441-1.242.205-.31-.178-.622-.358-.945-.143.374.313-1 .813-1.438.813-.39-.06-.248.081-.057.271.208.208.475.474.182.604-1.688.25.813 1.188.875-.188.812-.454 1.219.07 1.65.626.4.514.82 1.055 1.6.875-.438-.688.063-1.438.938-1.563.865.242.465.58.126.866-.272.23-.503.425-.002.509-.124.625-1.562.813-2.124 1.375-.713 0-1.247-.446-1.763-.876-.706-.589-1.378-1.15-2.425-.499-1.25.25-1.938 2-1.625 3.188.563 1.624 1.813 1.75 3.25 1.812 1.313.688 1 3.188 1.5 4.625.75.688 2.938 2.375 2.938.25-.157-1.2 1.125-3.404 1.952-4.826.164-.28.31-.53.422-.736.609-1.015.23-.877-.325-.675-.471.171-1.07.389-1.3-.013-.227-1.173.394-1.017 1.114-.837.468.118.979.246 1.324.024.308.19.678.173 1.03.157.577-.026 1.103-.05 1.22.844.188.874.438.687.688.312z"
  }));
}));
Earth.propTypes = {
  /** Icon fill color. */
  fill: PropTypes__default['default'].string,

  /** onClick handler. */
  onClick: PropTypes__default['default'].func,

  /** Styled component theme. */
  theme: PropTypes__default['default'].object,
  // eslint-disable-line react/forbid-prop-types

  /** Icon title. */
  title: PropTypes__default['default'].string,

  /** Icon width (passed to Svg via ...rest props). */
  width: PropTypes__default['default'].string
};
Earth.defaultProps = {
  fill: '',
  onClick: null,
  theme: null,
  title: '',
  width: '2rem'
};
var Earth$1 = styled.withTheme(Earth);var _excluded$1o = ["fill", "onClick", "theme", "title"];
// Component
// =============================

var Edit = /*#__PURE__*/React__default['default'].memo( /*#__PURE__*/React__default['default'].forwardRef(function (_ref, ref) {
  var fill = _ref.fill,
      onClick = _ref.onClick,
      theme = _ref.theme,
      title = _ref.title,
      rest = _objectWithoutProperties$7(_ref, _excluded$1o);

  return /*#__PURE__*/React__default['default'].createElement(Svg$2, _extends$g({
    fill: fill || theme.colors.text,
    onClick: onClick,
    ref: ref,
    title: title,
    viewBox: "0 0 512 512"
  }, rest), /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M432,260.6c-9.4,0-17,7.6-17,17v140.6c0,12.7-10.5,22.8-23.1,22.8H96.3C83.6,441,73,430.9,73,418.2V114.5   C73,101.8,83.6,92,96.3,92h114.6c9.4,0,17-7.6,17-17s-7.6-17-17-17H96.3C64.9,58,39,83.1,39,114.5v303.7   c0,31.4,25.9,56.8,57.3,56.8h295.6c31.4,0,57.1-25.3,57.1-56.8V277.6C449,268.3,441.4,260.6,432,260.6z"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M431.2,50.8c-8.9-9-20.7-14-33.3-14.1c-12.6,0-24.5,4.8-33.4,13.8L211.7,203.3c-5.7,5.7-9.8,12.8-12,20.5   L173.1,318c-1.7,6,0,12.4,4.5,16.8c3.2,3.1,7.5,4.8,11.9,4.8c1.7,0,3.4-0.2,5-0.8l91.6-28.2c7.3-2.2,14-6.3,19.4-11.7h0   l153.4-153.4c18.2-18.2,18.3-47.8,0.3-66.2L431.2,50.8z M355.2,107.9l46.2,47.2l-11.3,11.3l-46.2-47.2L355.2,107.9z M281.4,275   c-1.5,1.5-3.3,2.6-5.4,3.2l-61.8,19l18.1-64.2c0.6-2.1,1.8-4.1,3.3-5.7l84.1-84.1l46.2,47.2L281.4,275z M434.9,121.5l-9.5,9.5   l-46.2-47.2l9.2-9.1c2.5-2.5,5.7-3.7,9.2-3.7c0,0,0,0,0.1,0c3.5,0,6.8,1.3,9.2,3.8l28,28.5C439.9,108.3,439.9,116.5,434.9,121.5z"
  }));
}));
Edit.propTypes = {
  /** Icon fill color. */
  fill: PropTypes__default['default'].string,

  /** onClick handler. */
  onClick: PropTypes__default['default'].func,

  /** Styled component theme. */
  theme: PropTypes__default['default'].object,
  // eslint-disable-line react/forbid-prop-types

  /** Icon title. */
  title: PropTypes__default['default'].string,

  /** Icon width (passed to Svg via ...rest props). */
  width: PropTypes__default['default'].string
};
Edit.defaultProps = {
  fill: '',
  onClick: null,
  theme: null,
  title: '',
  width: '2rem'
};
var Edit$1 = styled.withTheme(Edit);var _excluded$1n = ["fill", "onClick", "theme", "title"];
// Component
// =============================

var Email = /*#__PURE__*/React__default['default'].memo( /*#__PURE__*/React__default['default'].forwardRef(function (_ref, ref) {
  var fill = _ref.fill,
      onClick = _ref.onClick,
      theme = _ref.theme,
      title = _ref.title,
      rest = _objectWithoutProperties$7(_ref, _excluded$1n);

  return /*#__PURE__*/React__default['default'].createElement(Svg$2, _extends$g({
    fill: fill || theme.colors.text,
    onClick: onClick,
    ref: ref,
    title: title,
    viewBox: "0 0 100 100"
  }, rest), /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M10.69,20A4.7,4.7,0,0,0,6,24.66V75.31A4.73,4.73,0,0,0,10.69,80H89.31A4.73,4.73,0,0,0,94,75.31V24.66A4.7,4.7,0,0,0,89.31,20Zm3,4H86.34L50,52.34ZM10,26.19,38.28,48.25,10,73.41Zm80,0V73.41L61.72,48.25ZM41.5,50.75l7.28,5.69a2,2,0,0,0,2.44,0l7.28-5.69L86.91,76H13.09Z"
  }));
}));
Email.propTypes = {
  /** Icon fill color. */
  fill: PropTypes__default['default'].string,

  /** onClick handler. */
  onClick: PropTypes__default['default'].func,

  /** Styled component theme. */
  theme: PropTypes__default['default'].object,
  // eslint-disable-line react/forbid-prop-types

  /** Icon title. */
  title: PropTypes__default['default'].string,

  /** Icon width (passed to Svg via ...rest props). */
  width: PropTypes__default['default'].string
};
Email.defaultProps = {
  fill: '',
  onClick: null,
  theme: null,
  title: '',
  width: '2rem'
};
var Email$1 = styled.withTheme(Email);var _excluded$1m = ["fill", "onClick", "theme", "title"];
// Component
// =============================

var Error$1 = /*#__PURE__*/React__default['default'].memo( /*#__PURE__*/React__default['default'].forwardRef(function (_ref, ref) {
  var fill = _ref.fill,
      onClick = _ref.onClick,
      theme = _ref.theme,
      title = _ref.title,
      rest = _objectWithoutProperties$7(_ref, _excluded$1m);

  return /*#__PURE__*/React__default['default'].createElement(Svg$2, _extends$g({
    fill: fill || theme.colors.type.error,
    onClick: onClick,
    ref: ref,
    title: title,
    viewBox: "0 0 25 25"
  }, rest), /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M12.5 2.527a9.93 9.93 0 0 1 6.193 2.155L4.682 18.692A9.93 9.93 0 0 1 2.527 12.5c.007-5.505 4.468-9.966 9.973-9.973zm7.96 3.962a9.93 9.93 0 0 1 2.013 6.011c0 5.508-4.465 9.973-9.973 9.973a9.93 9.93 0 0 1-6.01-2.014L20.46 6.49zM12.5 0C5.596 0 0 5.596 0 12.5S5.596 25 12.5 25 25 19.404 25 12.5A12.5 12.5 0 0 0 12.5 0z"
  }));
}));
Error$1.propTypes = {
  /** Icon fill color. */
  fill: PropTypes__default['default'].string,

  /** onClick handler. */
  onClick: PropTypes__default['default'].func,

  /** Styled component theme. */
  theme: PropTypes__default['default'].object,
  // eslint-disable-line react/forbid-prop-types

  /** Icon title. */
  title: PropTypes__default['default'].string,

  /** Icon width (passed to Svg via ...rest props). */
  width: PropTypes__default['default'].string
};
Error$1.defaultProps = {
  fill: '',
  onClick: null,
  theme: null,
  title: '',
  width: '2.5rem'
};
var _Error = styled.withTheme(Error$1);var _excluded$1l = ["fill", "onClick", "theme", "title"];
// Component
// =============================

var Error404 = /*#__PURE__*/React__default['default'].memo( /*#__PURE__*/React__default['default'].forwardRef(function (_ref, ref) {
  var fill = _ref.fill,
      onClick = _ref.onClick,
      theme = _ref.theme,
      title = _ref.title,
      rest = _objectWithoutProperties$7(_ref, _excluded$1l);

  return /*#__PURE__*/React__default['default'].createElement(Svg$2, _extends$g({
    fill: fill || theme.colors.text,
    onClick: onClick,
    ref: ref,
    title: title,
    viewBox: "0 0 73.1 65.6"
  }, rest), /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M6.6 65.6h60c3.6 0 6.6-2.9 6.6-6.6V6.6C73.2 3 70.3 0 66.6 0h-60C2.9 0 0 2.9 0 6.6v52.5c0 3.6 2.9 6.5 6.6 6.5zm0-63.7h60c2.6 0 4.7 2.1 4.7 4.7v4.7H1.9V6.6C1.9 4 4 1.9 6.6 1.9zM1.9 13.1h69.4V59c0 2.6-2.1 4.7-4.7 4.7h-60c-2.6 0-4.7-2.1-4.7-4.7V13.1z"
  }), /*#__PURE__*/React__default['default'].createElement("circle", {
    cx: "8.4",
    cy: "6.6",
    r: "1.9"
  }), /*#__PURE__*/React__default['default'].createElement("circle", {
    cx: "15.9",
    cy: "6.6",
    r: "1.9"
  }), /*#__PURE__*/React__default['default'].createElement("circle", {
    cx: "23.4",
    cy: "6.6",
    r: "1.9"
  }), /*#__PURE__*/React__default['default'].createElement("ellipse", {
    cx: "27.2",
    cy: "41.2",
    rx: "1.9",
    ry: "2.8"
  }), /*#__PURE__*/React__default['default'].createElement("ellipse", {
    cx: "45.9",
    cy: "41.2",
    rx: "1.9",
    ry: "2.8"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M28.1 51.6c0 .5.4.9.9.9h15c.5 0 .9-.4.9-.9s-.4-.9-.9-.9H29c-.5-.1-.9.3-.9.9z"
  }));
}));
Error404.propTypes = {
  /** Icon fill color. */
  fill: PropTypes__default['default'].string,

  /** onClick handler. */
  onClick: PropTypes__default['default'].func,

  /** Styled component theme. */
  theme: PropTypes__default['default'].object,
  // eslint-disable-line react/forbid-prop-types

  /** Icon title. */
  title: PropTypes__default['default'].string,

  /** Icon width (passed to Svg via ...rest props). */
  width: PropTypes__default['default'].string
};
Error404.defaultProps = {
  fill: '',
  onClick: null,
  theme: null,
  title: '',
  width: '13rem'
};
var Error404$1 = styled.withTheme(Error404);var _excluded$1k = ["fill", "onClick", "theme", "title"];
// Component
// =============================

var ErrorNoResult = /*#__PURE__*/React__default['default'].memo( /*#__PURE__*/React__default['default'].forwardRef(function (_ref, ref) {
  var fill = _ref.fill,
      onClick = _ref.onClick,
      theme = _ref.theme,
      title = _ref.title,
      rest = _objectWithoutProperties$7(_ref, _excluded$1k);

  return /*#__PURE__*/React__default['default'].createElement(Svg$2, _extends$g({
    fill: fill || theme.colors.text,
    onClick: onClick,
    ref: ref,
    title: title,
    viewBox: "0 0 73.1 65.6"
  }, rest), /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M6.6 65.6h60c3.6 0 6.6-2.9 6.6-6.6V6.6C73.2 3 70.3 0 66.6 0h-60C2.9 0 0 2.9 0 6.6v52.5c0 3.6 2.9 6.5 6.6 6.5zm0-63.7h60c2.6 0 4.7 2.1 4.7 4.7v4.7H1.9V6.6C1.9 4 4 1.9 6.6 1.9zM1.9 13.1h69.4V59c0 2.6-2.1 4.7-4.7 4.7h-60c-2.6 0-4.7-2.1-4.7-4.7V13.1z"
  }), /*#__PURE__*/React__default['default'].createElement("circle", {
    cx: "8.4",
    cy: "6.6",
    r: "1.9"
  }), /*#__PURE__*/React__default['default'].createElement("circle", {
    cx: "15.9",
    cy: "6.6",
    r: "1.9"
  }), /*#__PURE__*/React__default['default'].createElement("circle", {
    cx: "23.4",
    cy: "6.6",
    r: "1.9"
  }), /*#__PURE__*/React__default['default'].createElement("ellipse", {
    cx: "27.2",
    cy: "41.2",
    rx: "1.9",
    ry: "2.8"
  }), /*#__PURE__*/React__default['default'].createElement("ellipse", {
    cx: "45.9",
    cy: "41.2",
    rx: "1.9",
    ry: "2.8"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M28.1 51.6c0 .5.4.9.9.9h15c.5 0 .9-.4.9-.9s-.4-.9-.9-.9H29c-.5-.1-.9.3-.9.9z"
  }));
}));
ErrorNoResult.propTypes = {
  /** Icon fill color. */
  fill: PropTypes__default['default'].string,

  /** onClick handler. */
  onClick: PropTypes__default['default'].func,

  /** Styled component theme. */
  theme: PropTypes__default['default'].object,
  // eslint-disable-line react/forbid-prop-types

  /** Icon title. */
  title: PropTypes__default['default'].string,

  /** Icon width (passed to Svg via ...rest props). */
  width: PropTypes__default['default'].string
};
ErrorNoResult.defaultProps = {
  fill: '',
  onClick: null,
  theme: null,
  title: '',
  width: '13rem'
};
var ErrorNoResult$1 = styled.withTheme(ErrorNoResult);var _excluded$1j = ["fill", "onClick", "theme", "title"];
// Component
// =============================

var ExternalLink = /*#__PURE__*/React__default['default'].memo( /*#__PURE__*/React__default['default'].forwardRef(function (_ref, ref) {
  var fill = _ref.fill,
      onClick = _ref.onClick,
      theme = _ref.theme,
      title = _ref.title,
      rest = _objectWithoutProperties$7(_ref, _excluded$1j);

  return /*#__PURE__*/React__default['default'].createElement(Svg$2, _extends$g({
    fill: fill || theme.colors.text,
    onClick: onClick,
    ref: ref,
    title: title,
    viewBox: "0 0 13.3 13.3"
  }, rest), /*#__PURE__*/React__default['default'].createElement("path", {
    fillRule: "evenodd",
    d: "M13.27847671508789 0.43715858459472656C13.280179977416992 0.45821380615234375 13.289848327636719 0.47778987884521484 13.305461883544922 0.4918031692504883L13.305461883544922 0.5737705230712891C13.327136993408203 0.6254854202270508 13.336385726928711 0.6816682815551758 13.332450866699219 0.7377047538757324L13.332450866699219 5.846994400024414C13.332450866699219 6.299686431884766 12.969974517822266 6.666666030883789 12.52284049987793 6.666666030883789C12.075706481933594 6.666666030883789 11.713232040405273 6.299686431884766 11.713232040405273 5.846994400024414L11.713232040405273 2.7049179077148438L8.123964309692383 6.338798522949219C7.980305194854736 6.50163459777832 7.772780895233154 6.591678619384766 7.5572381019592285 6.584699630737305C7.343687534332275 6.5816192626953125 7.139989376068115 6.4932355880737305 6.990511417388916 6.338798522949219C6.835411548614502 6.189247131347656 6.747628688812256 5.981874465942383 6.747628688812256 5.76502799987793C6.747628688812256 5.548179626464844 6.835411548614502 5.34080696105957 6.990511417388916 5.191257476806641L10.579778671264648 1.6393442153930664L7.476276874542236 1.6393442153930664C7.029141902923584 1.6393442153930664 6.666667461395264 1.272364616394043 6.666667461395264 0.8196721076965332C6.666667461395264 0.36697959899902344 7.029141902923584 0 7.476276874542236 0L12.846683502197266 0L12.954631805419922 0.05464458465576172L13.00860595703125 0.05464458465576172L13.224502563476562 0.273223876953125L13.224502563476562 0.3278689384460449C13.251489639282227 0.3551912307739258 13.251489639282227 0.38251352310180664 13.27847671508789 0.43715858459472656ZM1.6826748847961426 11.64678955078125L10.317827224731445 11.64678955078125L10.317827224731445 8.808619499206543L12 8.808619499206543L12 12.489810943603516C12 12.95539665222168 11.623434066772461 13.332830429077148 11.158914566040039 13.332830429077148L0.8415884971618652 13.332830429077148C0.6161847114562988 13.340764999389648 0.39762067794799805 13.254497528076172 0.23813819885253906 13.094648361206055C0.07865524291992188 12.934799194335938 -0.007414102554321289 12.71573257446289 0.0005021095275878906 12.489810943603516L0.0005021095275878906 2.1768569946289062C-0.007414102554321289 1.950934886932373 0.07865524291992188 1.7318682670593262 0.23813819885253906 1.5720186233520508C0.39762067794799805 1.4121689796447754 0.6161847114562988 1.325901985168457 0.8415884971618652 1.3338360786437988L4.514332294464111 1.3338360786437988L4.514332294464111 3.0198774337768555L1.6826748847961426 3.0198774337768555L1.6826748847961426 11.64678955078125Z"
  }));
}));
ExternalLink.propTypes = {
  /** Icon fill color. */
  fill: PropTypes__default['default'].string,

  /** onClick handler. */
  onClick: PropTypes__default['default'].func,

  /** Styled component theme. */
  theme: PropTypes__default['default'].object,
  // eslint-disable-line react/forbid-prop-types

  /** Icon title. */
  title: PropTypes__default['default'].string,

  /** Icon width (passed to Svg via ...rest props). */
  width: PropTypes__default['default'].string
};
ExternalLink.defaultProps = {
  fill: '',
  onClick: null,
  theme: null,
  title: '',
  width: '1.6rem'
};
var ExternalLink$1 = styled.withTheme(ExternalLink);var _excluded$1i = ["fill", "onClick", "theme", "title"];
// Component
// =============================

var Eye = /*#__PURE__*/React__default['default'].memo( /*#__PURE__*/React__default['default'].forwardRef(function (_ref, ref) {
  var fill = _ref.fill,
      onClick = _ref.onClick,
      theme = _ref.theme,
      title = _ref.title,
      rest = _objectWithoutProperties$7(_ref, _excluded$1i);

  return /*#__PURE__*/React__default['default'].createElement(Svg$2, _extends$g({
    fill: fill || theme.colors.text,
    onClick: onClick,
    ref: ref,
    title: title,
    viewBox: "0 0 512 326.33"
  }, rest), /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M508.74,246C504.17,239.78,395.19,92.84,256,92.84S7.82,239.78,3.25,246a16.9,16.9,0,0,0,0,19.92c4.57,6.25,113.56,153.2,252.75,153.2s248.17-147,252.74-153.2A16.87,16.87,0,0,0,508.74,246ZM256,385.41C153.47,385.41,64.67,287.87,38.38,256,64.63,224.08,153.25,126.59,256,126.59c102.52,0,191.32,97.52,217.61,129.42C447.36,287.92,358.75,385.41,256,385.41Z",
    transform: "translate(0 -92.84)"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M256,154.73A101.27,101.27,0,1,0,357.27,256,101.39,101.39,0,0,0,256,154.73Zm0,168.79A67.52,67.52,0,1,1,323.51,256,67.6,67.6,0,0,1,256,323.52Z",
    transform: "translate(0 -92.84)"
  }));
}));
Eye.propTypes = {
  /** Icon fill color. */
  fill: PropTypes__default['default'].string,

  /** onClick handler. */
  onClick: PropTypes__default['default'].func,

  /** Styled component theme. */
  theme: PropTypes__default['default'].object,
  // eslint-disable-line react/forbid-prop-types

  /** Icon title. */
  title: PropTypes__default['default'].string,

  /** Icon width (passed to Svg via ...rest props). */
  width: PropTypes__default['default'].string
};
Eye.defaultProps = {
  fill: '',
  onClick: null,
  theme: null,
  title: '',
  width: '1.6rem'
};
var Eye$1 = styled.withTheme(Eye);var _excluded$1h = ["fill", "onClick", "theme", "title"];
// Component
// =============================

var Faq = /*#__PURE__*/React__default['default'].memo( /*#__PURE__*/React__default['default'].forwardRef(function (_ref, ref) {
  var fill = _ref.fill,
      onClick = _ref.onClick,
      theme = _ref.theme,
      title = _ref.title,
      rest = _objectWithoutProperties$7(_ref, _excluded$1h);

  return /*#__PURE__*/React__default['default'].createElement(Svg$2, _extends$g({
    fill: fill || theme.colors.primary,
    onClick: onClick,
    ref: ref,
    title: title,
    viewBox: "0 0 514 514"
  }, rest), /*#__PURE__*/React__default['default'].createElement("path", {
    fill: fill,
    fillRule: "evenodd",
    d: "M137.787,1.7189999999999988 C63.938,3.3000000000000003 3.4939999999999993,63.091 1.1599999999999993,136.919 C0,173.597 12.979999999999999,207.228 35.057,232.77800000000002 C44.99999999999999,244.28400000000002 47.838,260.317 42.723000000000006,274.637 L33.529,300.38 C30.539,308.753 40.236000000000004,315.90999999999997 47.356,310.585 L79.965,286.197 C89.668,278.94 101.989,276.241 113.87700000000001,278.583 C126.25600000000001,281.02200000000005 139.21800000000002,281.82800000000003 152.54900000000004,280.726 C222.68599999999998,274.922 277.999,216.918 280.51900000000006,146.585 C283.408,66.03 218.09,0 137.787,1.7189999999999988Z"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    fill: fill,
    fillRule: "evenodd",
    d: "M455.90099999999995,361.365 C444.073,375.63800000000003 440.32199999999995,394.927 446.549,412.377 L450.969,424.759 C445.389,431.22700000000003 439.486,437.413 433.289,443.295 L405.829,422.784 C394.241,414.143 379.592,410.716 365.38100000000003,413.359 C356.21700000000004,415.073 345.956,416.58799999999997 338.50600000000003,416.58799999999997 C254.34000000000003,416.58799999999997 186.11900000000003,348.36699999999996 186.11900000000003,264.20099999999996 C186.10900000000004,180.11899999999997 254.413,111.81399999999996 338.50600000000003,111.81399999999996 C422.66200000000003,111.81399999999996 490.89300000000003,180.03499999999997 490.89300000000003,264.20099999999996 C490.89500000000004,301.12699999999995 477.75,334.99199999999996 455.90099999999995,361.365Z"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    fill: "rgb(249,238,215)",
    fillRule: "evenodd",
    d: "M150.39300537109375,168.24298095703125 C150.39300537109375,154.83099365234375 150.65301513671875,147.09197998046875 164.8380126953125,136.00201416015625 C171.802978515625,130.58499145507812 193.72601318359375,113.04400634765625 193.72601318359375,88.79899597167969 C193.72601318359375,64.55400085449219 171.802978515625,46.240997314453125 138.78799438476562,46.240997314453125 C103.96701049804688,46.240997314453125 87.97500610351562,66.87599182128906 87.97500610351562,80.80299377441406 C87.97500610351562,90.86399841308594 96.48699951171875,95.50599670410156 103.45101928710938,95.50599670410156 C117.37799072265625,95.50599670410156 111.70501708984375,75.64498901367188 138.01300048828125,75.64498901367188 C150.91000366210938,75.64498901367188 161.22698974609375,81.32099914550781 161.22698974609375,93.18499755859375 C161.22698974609375,107.11300659179688 146.78302001953125,115.10899353027344 138.27099609375,122.33099365234375 C130.7919921875,128.77899169921875 120.989990234375,139.35400390625 120.989990234375,161.5360107421875 C120.989990234375,174.948974609375 124.60101318359375,178.8170166015625 135.17501831054688,178.8170166015625 C147.81399536132812,178.8170166015625 150.39300537109375,173.14498901367188 150.39300537109375,168.24298095703125 L150.39300537109375,168.24298095703125ZM135.43399047851562,236.33599853515625 C146.52398681640625,236.33599853515625 155.29498291015625,227.04998779296875 155.29498291015625,216.47598266601562 C155.29498291015625,205.64300537109375 146.2659912109375,196.614990234375 135.43399047851562,196.614990234375 C124.60198974609375,196.614990234375 115.83099365234375,205.64300537109375 115.83099365234375,216.47598266601562 C115.83099365234375,227.04998779296875 124.343994140625,236.33599853515625 135.43399047851562,236.33599853515625 L135.43399047851562,236.33599853515625Z"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    fill: "rgb(249,238,215)",
    fillRule: "evenodd",
    d: "M338.364013671875,307.43798828125 C345.11297607421875,307.43798828125 354.676025390625,303.781982421875 354.676025390625,295.06298828125 C354.676025390625,261.59600830078125 358.61199951171875,213.50601196289062 358.614013671875,180.03900146484375 C358.614013671875,169.07000732421875 349.333984375,162.88400268554688 338.364990234375,162.88400268554688 C326.83599853515625,162.88400268554688 317.83599853515625,169.07101440429688 317.83599853515625,180.03900146484375 C317.83599853515625,213.50701904296875 321.77197265625,261.59698486328125 321.77197265625,295.06298828125 C321.77197265625,303.781982421875 329.364013671875,307.43798828125 338.364013671875,307.43798828125 L338.364013671875,307.43798828125ZM338.64605712890625,370.1510009765625 C350.176025390625,370.1510009765625 360.01904296875,360.0270080566406 360.01904296875,348.49700927734375 C360.01904296875,336.68499755859375 350.177001953125,326.8420104980469 338.64605712890625,326.8420104980469 C326.27203369140625,326.8420104980469 316.99102783203125,336.68402099609375 316.99102783203125,348.49700927734375 C316.99102783203125,360.0270080566406 326.27105712890625,370.1510009765625 338.64605712890625,370.1510009765625 L338.64605712890625,370.1510009765625Z"
  }));
}));
Faq.propTypes = {
  /** Icon fill color. */
  fill: PropTypes__default['default'].string,

  /** onClick handler. */
  onClick: PropTypes__default['default'].func,

  /** Styled component theme. */
  theme: PropTypes__default['default'].object,
  // eslint-disable-line react/forbid-prop-types

  /** Icon title. */
  title: PropTypes__default['default'].string,

  /** Icon width (passed to Svg via ...rest props). */
  width: PropTypes__default['default'].string
};
Faq.defaultProps = {
  fill: '',
  onClick: null,
  theme: null,
  title: '',
  width: '2rem'
};
var Faq$1 = styled.withTheme(Faq);var _excluded$1g = ["fill", "onClick", "theme", "title"];
// Component
// =============================

var Filter = /*#__PURE__*/React__default['default'].memo( /*#__PURE__*/React__default['default'].forwardRef(function (_ref, ref) {
  var fill = _ref.fill,
      onClick = _ref.onClick,
      theme = _ref.theme,
      title = _ref.title,
      rest = _objectWithoutProperties$7(_ref, _excluded$1g);

  return /*#__PURE__*/React__default['default'].createElement(Svg$2, _extends$g({
    fill: fill || theme.colors.text,
    onClick: onClick,
    ref: ref,
    title: title,
    viewBox: "0 0 14 14"
  }, rest), /*#__PURE__*/React__default['default'].createElement("path", {
    clipRule: "evenodd",
    fillRule: "evenodd",
    d: "M6.6,1.5h6.7c0.4,0,0.8,0.3,0.8,0.8C14,2.7,13.7,3,13.2,3H6.6C6.2,3.9,5.4,4.6,4.4,4.6C3.4,4.6,2.6,4,2.3,3H0.8  C0.3,3,0,2.7,0,2.3c0,0,0,0,0,0c0-0.4,0.3-0.8,0.8-0.8h1.5C2.6,0.6,3.4,0,4.4,0C5.4,0,6.3,0.6,6.6,1.5L6.6,1.5z M3.7,2.3  C3.7,2.7,4,3,4.4,3s0.8-0.3,0.8-0.8c0-0.4-0.3-0.8-0.7-0.8c0,0,0,0,0,0C4,1.5,3.7,1.9,3.7,2.3C3.7,2.3,3.7,2.3,3.7,2.3L3.7,2.3z M0,7c0,0.4,0.3,0.8,0.8,0.8h6.7c0.3,0.9,1.2,1.5,2.2,1.5c1,0,1.8-0.6,2.2-1.5h1.5C13.7,7.8,14,7.4,14,7c0-0.4-0.3-0.8-0.7-0.8 c0,0,0,0,0,0h-1.5c-0.3-0.9-1.2-1.5-2.2-1.5c-1,0-1.8,0.6-2.2,1.5H0.8C0.3,6.2,0,6.6,0,7C0,7,0,7,0,7z M9.6,6.2 C9.2,6.2,8.8,6.6,8.8,7c0,0,0,0,0,0c0,0.4,0.3,0.8,0.8,0.8s0.8-0.3,0.8-0.8C10.4,6.6,10,6.2,9.6,6.2C9.6,6.2,9.6,6.2,9.6,6.2z M13.2,11H6.6C6.3,10,5.4,9.4,4.4,9.4c-1,0-1.8,0.6-2.2,1.5H0.8C0.3,11,0,11.3,0,11.7c0,0,0,0,0,0c0,0.4,0.3,0.8,0.8,0.8h1.5 C2.6,13.4,3.4,14,4.4,14c1,0,1.8-0.6,2.2-1.5h6.7c0.4,0,0.8-0.3,0.8-0.8C14,11.3,13.7,11,13.2,11C13.3,11,13.2,11,13.2,11L13.2,11z  M3.7,11.7c0,0.4,0.3,0.8,0.8,0.8s0.8-0.3,0.8-0.8c0-0.4-0.3-0.8-0.7-0.8c0,0,0,0,0,0C4,11,3.7,11.3,3.7,11.7  C3.7,11.7,3.7,11.7,3.7,11.7L3.7,11.7z"
  }));
}));
Filter.propTypes = {
  /** Icon fill color. */
  fill: PropTypes__default['default'].string,

  /** onClick handler. */
  onClick: PropTypes__default['default'].func,

  /** Styled component theme. */
  theme: PropTypes__default['default'].object,
  // eslint-disable-line react/forbid-prop-types

  /** Icon title. */
  title: PropTypes__default['default'].string,

  /** Icon width (passed to Svg via ...rest props). */
  width: PropTypes__default['default'].string
};
Filter.defaultProps = {
  fill: '',
  onClick: null,
  theme: null,
  title: '',
  width: '4rem'
};
var Filter$1 = styled.withTheme(Filter);var _excluded$1f = ["fill", "onClick", "theme", "title"];
// Component
// =============================

var FilterOutline = /*#__PURE__*/React__default['default'].memo( /*#__PURE__*/React__default['default'].forwardRef(function (_ref, ref) {
  var fill = _ref.fill,
      onClick = _ref.onClick,
      theme = _ref.theme,
      title = _ref.title,
      rest = _objectWithoutProperties$7(_ref, _excluded$1f);

  return /*#__PURE__*/React__default['default'].createElement(Svg$2, _extends$g({
    fill: fill || theme.colors.text,
    onClick: onClick,
    ref: ref,
    title: title,
    viewBox: "0 0 40 40"
  }, rest), /*#__PURE__*/React__default['default'].createElement("circle", {
    fillOpacity: "0",
    stroke: fill || theme.colors.text,
    strokeWidth: "2",
    cx: "20",
    cy: "20",
    r: "19"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    fillRule: "evenodd",
    d: "M19.574 14.522h6.665c.426 0 .761.335.761.76 0 .427-.335.761-.76.761h-6.666c-.335.883-1.157 1.522-2.161 1.522a2.28 2.28 0 0 1-2.16-1.522H13.76a.753.753 0 0 1-.761-.76c0-.426.335-.761.76-.761h1.492C15.587 13.639 16.41 13 17.413 13a2.28 2.28 0 0 1 2.16 1.522zm-2.922.76c0 .427.335.761.761.761s.76-.334.76-.76a.753.753 0 0 0-.76-.761.753.753 0 0 0-.76.76zM13 20c0 .426.335.76.76.76h6.666a2.28 2.28 0 0 0 2.161 1.523c1.004 0 1.826-.64 2.16-1.522h1.492c.426 0 .761-.335.761-.761a.753.753 0 0 0-.76-.76h-1.492a2.28 2.28 0 0 0-2.161-1.523c-1.004 0-1.826.64-2.16 1.522H13.76A.753.753 0 0 0 13 20zm9.587-.76a.753.753 0 0 0-.76.76c0 .426.334.76.76.76s.76-.334.76-.76a.753.753 0 0 0-.76-.76zm3.652 4.717h-6.665a2.28 2.28 0 0 0-2.161-1.522c-1.004 0-1.826.639-2.16 1.522H13.76a.753.753 0 0 0-.761.76c0 .426.335.761.76.761h1.492A2.28 2.28 0 0 0 17.413 27c1.004 0 1.826-.64 2.16-1.522h6.666c.426 0 .761-.335.761-.76a.753.753 0 0 0-.76-.761zm-9.587.76c0 .426.335.761.761.761s.76-.335.76-.76a.753.753 0 0 0-.76-.761.753.753 0 0 0-.76.76z"
  }));
}));
FilterOutline.propTypes = {
  /** Icon fill color. */
  fill: PropTypes__default['default'].string,

  /** onClick handler. */
  onClick: PropTypes__default['default'].func,

  /** Styled component theme. */
  theme: PropTypes__default['default'].object,
  // eslint-disable-line react/forbid-prop-types

  /** Icon title. */
  title: PropTypes__default['default'].string,

  /** Icon width (passed to Svg via ...rest props). */
  width: PropTypes__default['default'].string
};
FilterOutline.defaultProps = {
  fill: '',
  onClick: null,
  theme: null,
  title: '',
  width: '4rem'
};
var FilterOutline$1 = styled.withTheme(FilterOutline);var _excluded$1e = ["fill", "onClick", "theme", "title"];
// Component
// =============================

var HeadPhone = /*#__PURE__*/React__default['default'].memo( /*#__PURE__*/React__default['default'].forwardRef(function (_ref, ref) {
  var fill = _ref.fill,
      onClick = _ref.onClick,
      theme = _ref.theme,
      title = _ref.title,
      rest = _objectWithoutProperties$7(_ref, _excluded$1e);

  return /*#__PURE__*/React__default['default'].createElement(Svg$2, _extends$g({
    fill: fill || theme.colors.text,
    onClick: onClick,
    ref: ref,
    title: title,
    viewBox: "0 0 16 19"
  }, rest), /*#__PURE__*/React__default['default'].createElement("path", {
    fillRule: "evenodd",
    d: "M0.005279064178466797 12.883212089538574C0.014531135559082031 13.06325912475586 0.042142391204833984 13.240846633911133 0.10746622085571289 13.411579132080078C0.2714061737060547 13.837823867797852 0.595428466796875 14.192705154418945 1.0158863067626953 14.375932693481445C1.2325329780578613 14.471794128417969 1.4587087631225586 14.521915435791016 1.6944146156311035 14.524402618408203L1.698648452758789 14.524442672729492L1.702178955078125 14.524444580078125C1.731710433959961 14.524467468261719 1.761242389678955 14.524761199951172 1.790773868560791 14.52505874633789C1.8932018280029297 14.526084899902344 1.9955453872680664 14.527111053466797 2.0978899002075195 14.516727447509766C2.3351211547851562 14.493583679199219 2.560779571533203 14.428007125854492 2.7690796852111816 14.312284469604492C3.1721792221069336 14.090484619140625 3.476914405822754 13.700885772705078 3.592637062072754 13.255353927612305C3.6427831649780273 13.066341400146484 3.648569107055664 12.875399589538574 3.648569107055664 12.6806001663208L3.648569107055664 8.908052444458008C3.648569107055664 8.109567642211914 3.1008167266845703 7.378588676452637 2.3042616844177246 7.212719917297363C2.1268205642700195 7.176074028015137 1.9493799209594727 7.174145698547363 1.770009994506836 7.174145698547363C1.575976848602295 7.174145698547363 1.3838567733764648 7.191368103027344 1.197462558746338 7.250591278076172C1.2031054496765137 7.192011833190918 1.2095389366149902 7.133435249328613 1.2168660163879395 7.074859619140625C1.3029980659484863 6.494903564453125 1.4572482109069824 5.927894592285156 1.6768364906311035 5.384958267211914C1.820666790008545 5.050348281860352 1.9898390769958496 4.724987506866455 2.1808242797851562 4.414167881011963C2.2772598266601562 4.2579426765441895 2.377552032470703 4.107503890991211 2.4855599403381348 3.958993434906006C2.512561798095703 3.920419216156006 2.541492462158203 3.8837738037109375 2.5684943199157715 3.847128391265869C2.5780367851257324 3.833768844604492 2.589468479156494 3.8204092979431152 2.599050521850586 3.80704927444458C2.6474623680114746 3.7459259033203125 2.696317672729492 3.6852455139160156 2.74786376953125 3.627255916595459C2.9850945472717285 3.3456649780273438 3.2454700469970703 3.081432342529297 3.5212745666503906 2.8384151458740234C3.5887794494628906 2.7805542945861816 3.6562843322753906 2.7226929664611816 3.725717544555664 2.66483211517334C3.7585058212280273 2.6378297805786133 3.7912940979003906 2.610828399658203 3.8240814208984375 2.585754871368408C3.8262577056884766 2.583962917327881 3.8286542892456055 2.582026481628418 3.831188201904297 2.5800061225891113C3.841671943664551 2.572134494781494 3.8500146865844727 2.5658488273620605 3.856525421142578 2.5609230995178223C4.002768516540527 2.451033592224121 4.154576301574707 2.344937324523926 4.310115814208984 2.246302604675293C4.65395450592041 2.0264716148376465 5.014266014099121 1.8359260559082031 5.389267921447754 1.6746668815612793C5.930876731872559 1.4556479454040527 6.4964399337768555 1.301645278930664 7.0749101638793945 1.2154207229614258C7.688968658447266 1.1382579803466797 8.31241226196289 1.1382579803466797 8.926472663879395 1.2154202461242676C9.505080223083496 1.3016648292541504 10.070775032043457 1.4557199478149414 10.61250114440918 1.6748218536376953C10.947100639343262 1.8186492919921875 11.272453308105469 1.9878177642822266 11.583263397216797 2.178797721862793C11.73948860168457 2.275233268737793 11.889928817749023 2.375525951385498 12.03843879699707 2.4835338592529297C12.07701301574707 2.51053524017334 12.113658905029297 2.53946590423584 12.15030288696289 2.5664682388305664C12.16366958618164 2.5760140419006348 12.177032470703125 2.5874509811401367 12.190397262573242 2.5970354080200195C12.251520156860352 2.6454477310180664 12.31219482421875 2.6942977905273438 12.370176315307617 2.7458372116088867C12.65176773071289 2.9830684661865234 12.916000366210938 3.243443489074707 13.159015655517578 3.5192484855651855C13.216876983642578 3.5867528915405273 13.274738311767578 3.6542577743530273 13.332599639892578 3.723690986633301C13.359601974487305 3.756479263305664 13.386604309082031 3.7892675399780273 13.411676406860352 3.8220553398132324C13.413475036621094 3.824240207672119 13.415420532226562 3.8266472816467285 13.417449951171875 3.829192638397217C13.422611236572266 3.8360671997070312 13.42708969116211 3.842020034790039 13.430950164794922 3.8471388816833496C13.42774772644043 3.842705726623535 13.424530029296875 3.8383665084838867 13.421314239501953 3.8340768814086914C13.432958602905273 3.8488879203796387 13.446022033691406 3.8663082122802734 13.450252532958984 3.8721585273742676C13.453723907470703 3.876959800720215 13.45124626159668 3.8739700317382812 13.437156677246094 3.8553552627563477C13.54681396484375 4.001336097717285 13.652688980102539 4.1528544425964355 13.751129150390625 4.308089256286621C13.970962524414062 4.651932239532471 14.161510467529297 5.0122480392456055 14.322771072387695 5.387256622314453C14.541147232055664 5.927281379699707 14.694889068603516 6.491120338439941 14.781255722045898 7.067821502685547C14.788759231567383 7.128556251525879 14.795343399047852 7.189292907714844 14.80112075805664 7.250036239624023C14.753652572631836 7.235496520996094 14.70515251159668 7.223018646240234 14.655693054199219 7.212719917297363C14.478252410888672 7.176074028015137 14.300811767578125 7.174145698547363 14.121440887451172 7.174145698547363C13.926641464233398 7.174145698547363 13.733772277832031 7.19150447845459 13.546686172485352 7.251294136047363C13.110799789428711 7.39016056060791 12.730844497680664 7.70646858215332 12.530258178710938 8.121140480041504C12.346542358398438 8.49887466430664 12.349300384521484 8.89342212677002 12.352121353149414 9.29662036895752C12.352468490600586 9.346341133117676 12.35281753540039 9.39619255065918 12.35281753540039 9.446161270141602L12.35281753540039 12.721102714538574C12.35281753540039 12.956405639648438 12.374032974243164 13.189777374267578 12.45889663696289 13.411579132080078C12.62283706665039 13.837823867797852 12.946859359741211 14.192705154418945 13.367317199707031 14.375932693481445C13.583963394165039 14.471794128417969 13.810140609741211 14.521915435791016 14.045845031738281 14.524402618408203L14.050079345703125 14.524442672729492L14.053609848022461 14.524444580078125C14.083141326904297 14.524467468261719 14.112672805786133 14.524761199951172 14.142204284667969 14.52505874633789C14.244665145874023 14.526084899902344 14.346992492675781 14.527109146118164 14.449321746826172 14.516727447509766C14.559412002563477 14.505987167358398 14.667009353637695 14.486108779907227 14.771537780761719 14.456321716308594C14.731979370117188 14.626836776733398 14.680057525634766 14.794548034667969 14.616508483886719 14.957977294921875C14.533721923828125 15.143730163574219 14.434669494628906 15.321758270263672 14.322025299072266 15.49072265625C14.291166305541992 15.53701400756836 14.258378982543945 15.58137321472168 14.227519989013672 15.625732421875L14.226547241210938 15.627099990844727C14.218215942382812 15.637733459472656 14.209632873535156 15.648393630981445 14.200517654418945 15.65852165222168C14.127225875854492 15.747241973876953 14.052007675170898 15.830177307128906 13.971000671386719 15.911182403564453C13.889995574951172 15.9921875 13.805133819580078 16.0693359375 13.718341827392578 16.140697479248047C13.71010971069336 16.14728355407715 13.701875686645508 16.15422248840332 13.693492889404297 16.161211013793945C13.645843505859375 16.195520401000977 13.59819221496582 16.22980308532715 13.550542831420898 16.26220703125C13.381509780883789 16.374895095825195 13.203409194946289 16.473979949951172 13.017576217651367 16.556785583496094C12.781017303466797 16.648836135864258 12.5364990234375 16.716487884521484 12.285144805908203 16.757492065429688C12.046167373657227 16.783802032470703 11.805213928222656 16.782649993896484 11.564802169799805 16.7814998626709C11.515634536743164 16.78126335144043 11.46649169921875 16.781028747558594 11.417394638061523 16.781028747558594L10.213440895080566 16.781028747558594C10.071325302124023 16.423526763916016 9.805241584777832 16.116500854492188 9.450116157531738 15.949756622314453C9.224457740783691 15.843677520751953 8.993013381958008 15.785816192626953 8.742280960083008 15.78388786315918L7.633275985717773 15.78388786315918C7.301538467407227 15.78388786315918 6.987159729003906 15.818605422973633 6.690138816833496 15.9825439453125C6.2368927001953125 16.231348037719727 5.949515342712402 16.694236755371094 5.889725685119629 17.201486587524414C5.8202924728393555 17.787813186645508 6.117313385009766 18.360637664794922 6.603346824645996 18.684661865234375C6.913867950439453 18.891033172607422 7.26682186126709 18.937320709228516 7.62748908996582 18.937320709228516L8.478048324584961 18.937320709228516C8.834858894348145 18.937320709228516 9.170454025268555 18.919963836669922 9.496404647827148 18.75023651123047C9.82968521118164 18.575422286987305 10.0801362991333 18.280874252319336 10.215672492980957 17.938251495361328L11.417394638061523 17.938251495361328C11.47022819519043 17.938251495361328 11.52322006225586 17.938566207885742 11.576278686523438 17.938879013061523L11.576385498046875 17.938879013061523C11.709236145019531 17.939666748046875 11.842504501342773 17.94045639038086 11.974790573120117 17.936323165893555C12.51675796508789 17.922821044921875 13.033651351928711 17.797456741333008 13.529327392578125 17.58722686767578C14.404960632324219 17.21498680114746 15.157155990600586 16.49943733215332 15.56989860534668 15.641162872314453C15.805200576782227 15.155128479003906 15.942138671875 14.64980697631836 15.988428115844727 14.111698150634766C16 13.968975067138672 16 13.826251983642578 16 13.683526992797852L16 7.991916656494141C15.998071670532227 7.044921875 15.832202911376953 6.088284492492676 15.49275016784668 5.203008651733398C15.147512435913086 4.3003740310668945 14.655691146850586 3.474888324737549 14.023077011108398 2.7439088821411133C13.427106857299805 2.055360794067383 12.69998550415039 1.465177059173584 11.905357360839844 1.0177173614501953C11.095300674438477 0.5625429153442383 10.198453903198242 0.24237775802612305 9.278461456298828 0.09965348243713379C8.283248901367188 -0.05271434783935547 7.282251358032227 -0.03342723846435547 6.2947540283203125 0.17873048782348633C5.392119407653809 0.37352967262268066 4.512629508972168 0.7380549907684326 3.735361099243164 1.2337322235107422C2.944591522216797 1.7390532493591309 2.2483291625976562 2.3735971450805664 1.6755037307739258 3.1161489486694336C1.0968918800354004 3.8644866943359375 0.653289794921875 4.7034735679626465 0.3678412437438965 5.606107711791992C0.12096691131591797 6.383376121520996 0.0013871192932128906 7.205004692077637 0.0013871192932128906 8.018918991088867L0.0013871192932128906 9.001165390014648C-0.0006909370422363281 9.099047660827637 -0.0000019073486328125 9.197572708129883 0.0006909370422363281 9.29662036895752C0.0010385513305664062 9.346341133117676 0.0013871192932128906 9.39619255065918 0.0013871192932128906 9.446161270141602L0.0013871192932128906 12.819466590881348C0.0013871192932128906 12.840815544128418 0.0027098655700683594 12.862098693847656 0.005279064178466797 12.883212089538574ZM13.421314239501953 3.8340768814086914C13.41554069519043 3.8263745307922363 13.409765243530273 3.8188304901123047 13.40399169921875 3.811241626739502C13.408918380737305 3.8178224563598633 13.413394927978516 3.823791980743408 13.417449951171875 3.829192638397217C13.418710708618164 3.8307738304138184 13.420003890991211 3.832408905029297 13.421314239501953 3.8340768814086914ZM3.8360729217529297 2.5761399269104004C3.8508872985839844 2.5644917488098145 3.86832332611084 2.551417827606201 3.8741817474365234 2.547182083129883C3.879060745239258 2.5436549186706543 3.8759098052978516 2.5462584495544434 3.856525421142578 2.5609230995178223C3.854066848754883 2.562769889831543 3.8516101837158203 2.5646185874938965 3.849154472351074 2.5664682388305664C3.844721794128418 2.5696921348571777 3.8403730392456055 2.572916030883789 3.8360729217529297 2.5761399269104004ZM3.8360729217529297 2.5761399269104004C3.8283748626708984 2.581912040710449 3.820834159851074 2.5876851081848145 3.8132476806640625 2.5934572219848633C3.81982421875 2.5885329246520996 3.825789451599121 2.584059238433838 3.831188201904297 2.5800061225891113C3.8327693939208984 2.5787453651428223 3.834404945373535 2.577451705932617 3.8360729217529297 2.5761399269104004ZM7.113697052001953 1.2097392082214355C7.129909515380859 1.2075624465942383 7.1461944580078125 1.2053141593933105 7.162671089172363 1.2028732299804688C7.146336555480957 1.2051095962524414 7.130012512207031 1.2073993682861328 7.113697052001953 1.2097392082214355ZM8.887688636779785 1.2097434997558594C8.871374130249023 1.2073993682861328 8.855050086975098 1.2051095962524414 8.838716506958008 1.2028732299804688C8.855193138122559 1.2053141593933105 8.871477127075195 1.2075624465942383 8.887688636779785 1.2097434997558594ZM10.646780014038086 1.6887860298156738L10.721132278442383 1.7197661399841309C10.696399688720703 1.7093024253845215 10.671615600585938 1.6989755630493164 10.646780014038086 1.6887860298156738ZM5.354599952697754 1.688788890838623C5.329767227172852 1.6989774703979492 5.304984092712402 1.709303379058838 5.280254364013672 1.7197661399841309L5.354599952697754 1.688788890838623ZM1.6907877922058105 5.350708961486816L1.721792221069336 5.276298522949219C1.711320400238037 5.301050186157227 1.7009854316711426 5.325854301452637 1.6907877922058105 5.350708961486816ZM14.308656692504883 5.352606773376465C14.298463821411133 5.327762603759766 14.28813362121582 5.302968978881836 14.277666091918945 5.278227806091309L14.308656692504883 5.352606773376465ZM1.2117695808410645 7.109743118286133C1.209425449371338 7.1260576248168945 1.2071356773376465 7.14238166809082 1.2048993110656738 7.158716201782227C1.2073402404785156 7.142239570617676 1.2095880508422852 7.125954627990723 1.2117695808410645 7.109743118286133ZM14.787612915039062 7.11107063293457C14.789815902709961 7.1274824142456055 14.79208755493164 7.143964767456055 14.794559478759766 7.16064453125C14.792295455932617 7.144110679626465 14.78997802734375 7.127586364746094 14.787612915039062 7.11107063293457ZM12.230634689331055 16.765949249267578C12.222539901733398 16.767080307006836 12.214410781860352 16.76824378967285 12.206235885620117 16.769454956054688C12.214374542236328 16.768314361572266 12.222505569458008 16.767147064208984 12.230634689331055 16.765949249267578Z"
  }));
}));
HeadPhone.propTypes = {
  /** Icon fill color. */
  fill: PropTypes__default['default'].string,

  /** onClick handler. */
  onClick: PropTypes__default['default'].func,

  /** Styled component theme. */
  theme: PropTypes__default['default'].object,
  // eslint-disable-line react/forbid-prop-types

  /** Icon title. */
  title: PropTypes__default['default'].string,

  /** Icon width (passed to Svg via ...rest props). */
  width: PropTypes__default['default'].string
};
HeadPhone.defaultProps = {
  fill: '',
  onClick: null,
  theme: null,
  title: '',
  width: '2rem'
};
var HeadPhone$1 = styled.withTheme(HeadPhone);var _excluded$1d = ["checked", "fill", "fillChecked", "onClick", "strokeWidth", "theme", "title"];
// Component
// =============================

var Heart = /*#__PURE__*/React__default['default'].memo( /*#__PURE__*/React__default['default'].forwardRef(function (_ref, ref) {
  var checked = _ref.checked,
      fill = _ref.fill,
      fillChecked = _ref.fillChecked,
      onClick = _ref.onClick,
      strokeWidth = _ref.strokeWidth,
      theme = _ref.theme,
      title = _ref.title,
      rest = _objectWithoutProperties$7(_ref, _excluded$1d);

  return /*#__PURE__*/React__default['default'].createElement(Svg$2, _extends$g({
    onClick: onClick,
    ref: ref,
    title: title,
    viewBox: "0 0 100 100"
  }, rest), /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M37.34,20a18.42,18.42,0,0,0-14.18,6.75A23.19,23.19,0,0,0,18,41.56c0,8.94,3.79,15.86,9.34,21.22s12.72,9.54,20.5,14.56L50,78.75l2.16-1.41c7.78-5,15-9.2,20.5-14.56S82,50.5,82,41.56a23.13,23.13,0,0,0-5.16-14.81A18.42,18.42,0,0,0,62.66,20,21.79,21.79,0,0,0,50,24.09,21.79,21.79,0,0,0,37.34,20Z",
    fillOpacity: checked ? '1' : '0',
    fillRule: "evenodd",
    stroke: checked ? fillChecked || theme.colors.primary : fill || theme.colors.text,
    fill: checked ? fillChecked || theme.colors.primary : fill || theme.colors.text,
    strokeWidth: strokeWidth
  }));
}));
Heart.propTypes = {
  /** If True, Heart is filled. */
  checked: PropTypes__default['default'].bool,

  /** Icon fill color. */
  fill: PropTypes__default['default'].string,

  /** Icon fill color when checked. */
  fillChecked: PropTypes__default['default'].string,

  /** onClick handler. */
  onClick: PropTypes__default['default'].func,

  /** Circle stroke width */
  strokeWidth: PropTypes__default['default'].number,

  /** Styled component theme. */
  theme: PropTypes__default['default'].object,
  // eslint-disable-line react/forbid-prop-types

  /** Icon title. */
  title: PropTypes__default['default'].string,

  /** Icon width (passed to Svg via ...rest props). */
  width: PropTypes__default['default'].string
};
Heart.defaultProps = {
  checked: false,
  fill: '',
  fillChecked: '',
  onClick: null,
  strokeWidth: 10,
  theme: null,
  title: '',
  width: '2rem'
};
var Heart$1 = styled.withTheme(Heart);var _excluded$1c = ["fill", "onClick", "theme", "title"];
// Component
// =============================

var Informations = /*#__PURE__*/React__default['default'].memo( /*#__PURE__*/React__default['default'].forwardRef(function (_ref, ref) {
  var fill = _ref.fill,
      onClick = _ref.onClick,
      theme = _ref.theme,
      title = _ref.title,
      rest = _objectWithoutProperties$7(_ref, _excluded$1c);

  return /*#__PURE__*/React__default['default'].createElement(Svg$2, _extends$g({
    fill: fill || theme.colors.primary,
    onClick: onClick,
    ref: ref,
    title: title,
    viewBox: "0 0 16 16"
  }, rest), /*#__PURE__*/React__default['default'].createElement("path", {
    fillRule: "evenodd",
    d: "M8,0 C3.583984375,0 0,3.5839996337890625 0,8 C0,12.416000366210938 3.583984375,16 8,16 C12.416015625,16 16,12.416000366210938 16,8 C16,3.5839996337890625 12.416015625,0 8,0 L8,0ZM6.8160400390625,4.883209228515625 C6.8160400390625,5.5360107421875 7.3472900390625,6.06719970703125 8,6.06719970703125 C8.65283203125,6.06719970703125 9.18408203125,5.5360107421875 9.18408203125,4.883209228515625 C9.18408203125,4.23040771484375 8.65283203125,3.6992034912109375 8,3.6992034912109375 C7.3472900390625,3.6992034912109375 6.8160400390625,4.23040771484375 6.8160400390625,4.883209228515625 L6.8160400390625,4.883209228515625ZM7.2320556640625,12 L7.2320556640625,7.552001953125 L8.76806640625,7.552001953125 L8.76806640625,12 L7.2320556640625,12 L7.2320556640625,12Z"
  }));
}));
Informations.propTypes = {
  /** Icon fill color. */
  fill: PropTypes__default['default'].string,

  /** onClick handler. */
  onClick: PropTypes__default['default'].func,

  /** Styled component theme. */
  theme: PropTypes__default['default'].object,
  // eslint-disable-line react/forbid-prop-types

  /** Icon title. */
  title: PropTypes__default['default'].string,

  /** Icon width (passed to Svg via ...rest props). */
  width: PropTypes__default['default'].string
};
Informations.defaultProps = {
  fill: '',
  onClick: null,
  theme: null,
  title: '',
  width: '1.5rem'
};
var Informations$1 = styled.withTheme(Informations);var _excluded$1b = ["fill", "onClick", "theme", "title"];
// Component
// =============================

var Knowledge = /*#__PURE__*/React__default['default'].memo( /*#__PURE__*/React__default['default'].forwardRef(function (_ref, ref) {
  var fill = _ref.fill,
      onClick = _ref.onClick,
      theme = _ref.theme,
      title = _ref.title,
      rest = _objectWithoutProperties$7(_ref, _excluded$1b);

  return /*#__PURE__*/React__default['default'].createElement(Svg$2, _extends$g({
    fill: fill || theme.colors.text,
    onClick: onClick,
    ref: ref,
    title: title,
    viewBox: "0 0 18 17"
  }, rest), /*#__PURE__*/React__default['default'].createElement("path", {
    fillRule: "evenodd",
    d: "M9.146912574768066 9.72178840637207C10.018168449401855 9.72178840637207 10.917530059814453 9.862313270568848 11.704471588134766 10.143363952636719C11.873101234436035 10.19957447052002 12.069835662841797 10.19957447052002 12.294677734375 10.115259170532227C12.688148498535156 9.94662857055664 13.109722137451172 9.862313270568848 13.559402465820312 9.777998924255371C12.491413116455078 12.279346466064453 11.086160659790039 11.970191955566406 10.973740577697754 13.768913269042969C10.917530059814453 14.865009307861328 10.917530059814453 16.91667938232422 10.917530059814453 16.94478416442871C10.917530059814453 17.085308074951172 10.777005195617676 17.225833892822266 10.636479377746582 17.225833892822266L4.734421730041504 17.225833892822266C4.565791130065918 17.225833892822266 4.453371047973633 17.085308074951172 4.453371047973633 16.94478416442871L4.453371047973633 14.19049072265625C4.3128461837768555 14.10617446899414 3.8350601196289062 13.88133430480957 2.09254789352417 13.600284576416016C1.249396800994873 13.459758758544922 0.7435059547424316 12.644712448120117 1.16508150100708 11.661036491394043C0.8840312957763672 11.379985809326172 0.6029806137084961 10.564939498901367 0.8840312957763672 9.693683624267578C0.6029806137084961 9.581263542175293 0.20951032638549805 9.356423377990723 0.0689849853515625 8.934847831726074C-0.09964513778686523 8.513272285461426 0.04088020324707031 8.007381439208984 0.49056053161621094 7.445280075073242C0.9964513778686523 6.826969146728516 1.3899221420288086 6.26486873626709 1.6990776062011719 5.730873107910156C1.9520225524902344 5.253087997436523 1.9520225524902344 4.803406715393066 1.9520225524902344 4.494251251220703C1.8958125114440918 3.0046846866607666 2.935698986053467 1.7680628299713135 4.1442155838012695 0.9811217784881592C5.5213623046875 0.08176016807556152 7.123350143432617 -0.19929003715515137 8.641021728515625 0.1379702091217041C8.0789213180542 0.22228550910949707 7.544925689697266 0.3909156322479248 7.010929107666016 0.6157562732696533C6.481498718261719 0.8459436893463135 6.498802185058594 1.3400719165802002 6.506964683532715 1.5731465816497803C6.508768081665039 1.6246473789215088 6.510125160217285 1.6634023189544678 6.505039215087891 1.6837475299835205C6.336408615112305 1.739957571029663 6.364513397216797 1.711852788925171 5.999148368835449 1.8523776531219482C5.661888122558594 1.9647982120513916 5.437047958374023 2.273953676223755 5.437047958374023 2.6393187046051025L5.437047958374023 9.356423377990723C5.437047958374023 9.637473106384277 5.577572822570801 9.890419006347656 5.802412986755371 10.030943870544434C6.05535888671875 10.19957447052002 6.336408615112305 10.227679252624512 6.589353561401367 10.143363952636719C7.37629508972168 9.862313270568848 8.275656700134277 9.72178840637207 9.146912574768066 9.72178840637207ZM17.46600341796875 2.2739531993865967C17.57842445373535 2.302058458328247 17.662738800048828 2.3582684993743896 17.77515983581543 2.386373281478882C17.88758087158203 2.4425833225250244 17.971893310546875 2.5268986225128174 18 2.6393187046051025L18 9.328317642211914C18 9.412632942199707 17.971893310546875 9.4969482421875 17.88758087158203 9.553157806396484C17.803264617919922 9.609368324279785 17.718948364257812 9.609368324279785 17.634634017944336 9.581262588500977C15.892122268676758 8.96295166015625 13.8404541015625 8.96295166015625 12.097942352294922 9.581262588500977C12.041730880737305 9.609368324279785 11.957416534423828 9.609368324279785 11.901206970214844 9.581262588500977C10.186799049377441 8.96295166015625 8.107026100158691 8.96295166015625 6.392618179321289 9.581262588500977C6.3083038330078125 9.609368324279785 6.2239885330200195 9.609368324279785 6.139673233032227 9.553157806396484C6.055357933044434 9.4969482421875 6.027253150939941 9.412632942199707 6.027253150939941 9.328317642211914L6.027253150939941 2.6393187046051025C6.027253150939941 2.5268986225128174 6.111568450927734 2.4144785404205322 6.2239885330200195 2.386373281478882C6.3083038330078125 2.3582684993743896 6.420723915100098 2.302058458328247 6.533143997192383 2.2739531993865967L6.533143997192383 8.063591003417969C6.533143997192383 8.344640731811523 6.67366886138916 8.625692367553711 6.8985090255737305 8.766216278076172C7.123350143432617 8.934846878051758 7.432504653930664 8.96295166015625 7.713555335998535 8.850532531738281C8.30376148223877 8.56948184967041 9.006387710571289 8.428956985473633 9.680908203125 8.428956985473633C10.38353443145752 8.428956985473633 11.05805492401123 8.56948184967041 11.676365852355957 8.850532531738281C11.901206970214844 8.934846878051758 12.154151916503906 8.934846878051758 12.350887298583984 8.850532531738281C12.969198226928711 8.56948184967041 13.643718719482422 8.428956985473633 14.318239212036133 8.428956985473633C14.992759704589844 8.428956985473633 15.667282104492188 8.56948184967041 16.28559112548828 8.850532531738281C16.538537979125977 8.96295166015625 16.847694396972656 8.934846878051758 17.072532653808594 8.79432201385498C17.325477600097656 8.653797149658203 17.46600341796875 8.372746467590332 17.46600341796875 8.091695785522461L17.46600341796875 2.2739531993865967Z"
  }));
}));
Knowledge.propTypes = {
  /** Icon fill color. */
  fill: PropTypes__default['default'].string,

  /** onClick handler. */
  onClick: PropTypes__default['default'].func,

  /** Styled component theme. */
  theme: PropTypes__default['default'].object,
  // eslint-disable-line react/forbid-prop-types

  /** Icon title. */
  title: PropTypes__default['default'].string,

  /** Icon width (passed to Svg via ...rest props). */
  width: PropTypes__default['default'].string
};
Knowledge.defaultProps = {
  fill: '',
  onClick: null,
  theme: null,
  title: '',
  width: '2rem'
};
var Knowledge$1 = styled.withTheme(Knowledge);var _excluded$1a = ["fill", "onClick", "theme", "title"];
// Component
// =============================

var LgMeta = /*#__PURE__*/React__default['default'].memo( /*#__PURE__*/React__default['default'].forwardRef(function (_ref, ref) {
  _ref.fill;
      var onClick = _ref.onClick;
      _ref.theme;
      var title = _ref.title,
      rest = _objectWithoutProperties$7(_ref, _excluded$1a);

  return /*#__PURE__*/React__default['default'].createElement(Svg$2, _extends$g({
    onClick: onClick,
    ref: ref,
    title: title,
    viewBox: "0 0 300 126.5"
  }, rest), /*#__PURE__*/React__default['default'].createElement("path", {
    fill: "#1D1D1B",
    d: "M0,62.6h18.2v7.1C22,63.7,28,61,35.7,61c8.4,0,14.2,3.6,17.6,10.6C58.6,64.3,65.9,61,75.9,61C90.2,61,99,71.2,99,86.8v38H80.8V88.7c0-7.1-2.4-11.3-10-11.3c-8.2,0-12.2,4.7-12.2,14v33.5H40.4V88.7c0-7.1-2.4-11.3-10-11.3c-8.2,0-12.2,4.7-12.2,14v33.5H0V62.6z"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    fill: "#1D1D1B",
    d: "M145.5,111.2c8,0,12.7-3.1,16.2-6l10.9,10.9c-5.6,6-13.8,10.4-26.7,10.4c-21.6,0-35.5-13.8-35.5-32.7s14.7-32.7,33.7-32.7c21.8,0,34.2,17.3,32.7,38.9h-47.5C131.2,106.8,136.4,111.2,145.5,111.2z M157.7,87.2c-1.3-6.4-5.8-10.9-13.6-10.9c-7.5,0-12.7,3.8-14.6,10.9H157.7z"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    fill: "#1D1D1B",
    d: "M184.8,77.7V62.6h7.3V30.5h18.2v32.2h14.6v15.1h-14.6V103c0,6.4,2,7.8,5.3,7.8c2.2,0,4-1.1,5.5-2.2l7.1,12.7c-3.1,2.5-8,5.1-15.6,5.1c-11.8,0-20.4-5.8-20.4-23.1V77.7H184.8z"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    fill: "#1D1D1B",
    d: "M234,93.7c0-18.9,12.7-32.7,28.9-32.7c9.5,0,15.5,3.3,18.9,8.7v-7.1H300v62.2h-18.2v-7.1c-3.5,5.5-9.5,8.7-18.9,8.7C246.7,126.5,234,112.7,234,93.7z M282.2,93.7c0-10.2-5.3-16.7-14.6-16.7c-9.3,0-14.9,6.5-14.9,16.7s5.6,16.7,14.9,16.7C276.9,110.5,282.2,103.9,282.2,93.7z"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    fill: "#FBDD30",
    d: "M190.3,0L190.3,0H98.4l0,0c0,25.4,20.6,46,46,46l0,0C169.7,46,190.3,25.1,190.3,0"
  }), /*#__PURE__*/React__default['default'].createElement("g", null, /*#__PURE__*/React__default['default'].createElement("path", {
    fill: "#1D1D1B",
    d: "M0,62.6h18.2v7.1C22,63.7,28,61,35.7,61c8.4,0,14.2,3.6,17.6,10.6C58.6,64.3,65.9,61,75.9,61C90.2,61,99,71.2,99,86.8v38H80.8V88.7c0-7.1-2.4-11.3-10-11.3c-8.2,0-12.2,4.7-12.2,14v33.5H40.4V88.7c0-7.1-2.4-11.3-10-11.3c-8.2,0-12.2,4.7-12.2,14v33.5H0V62.6z"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    fill: "#1D1D1B",
    d: "M145.5,111.2c8,0,12.7-3.1,16.2-6l10.9,10.9c-5.6,6-13.8,10.4-26.7,10.4c-21.6,0-35.5-13.8-35.5-32.7s14.7-32.7,33.7-32.7c21.8,0,34.2,17.3,32.7,38.9h-47.5C131.2,106.8,136.4,111.2,145.5,111.2z M157.7,87.2c-1.3-6.4-5.8-10.9-13.6-10.9c-7.5,0-12.7,3.8-14.6,10.9H157.7z"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    fill: "#1D1D1B",
    d: "M184.8,77.7V62.6h7.3V30.5h18.2v32.2h14.6v15.1h-14.6V103c0,6.4,2,7.8,5.3,7.8c2.2,0,4-1.1,5.5-2.2l7.1,12.7c-3.1,2.5-8,5.1-15.6,5.1c-11.8,0-20.4-5.8-20.4-23.1V77.7H184.8z"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    fill: "#1D1D1B",
    d: "M234,93.7c0-18.9,12.7-32.7,28.9-32.7c9.5,0,15.5,3.3,18.9,8.7v-7.1H300v62.2h-18.2v-7.1c-3.5,5.5-9.5,8.7-18.9,8.7C246.7,126.5,234,112.7,234,93.7z M282.2,93.7c0-10.2-5.3-16.7-14.6-16.7c-9.3,0-14.9,6.5-14.9,16.7s5.6,16.7,14.9,16.7C276.9,110.5,282.2,103.9,282.2,93.7z"
  })), /*#__PURE__*/React__default['default'].createElement("g", null, /*#__PURE__*/React__default['default'].createElement("path", {
    fill: "#1D1D1B",
    d: "M0,62.6h18.2v7.1C22,63.7,28,61,35.7,61c8.4,0,14.2,3.6,17.6,10.6C58.6,64.3,65.9,61,75.9,61C90.2,61,99,71.2,99,86.8v38H80.8V88.7c0-7.1-2.4-11.3-10-11.3c-8.2,0-12.2,4.7-12.2,14v33.5H40.4V88.7c0-7.1-2.4-11.3-10-11.3c-8.2,0-12.2,4.7-12.2,14v33.5H0V62.6z"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    fill: "#1D1D1B",
    d: "M145.5,111.2c8,0,12.7-3.1,16.2-6l10.9,10.9c-5.6,6-13.8,10.4-26.7,10.4c-21.6,0-35.5-13.8-35.5-32.7s14.7-32.7,33.7-32.7c21.8,0,34.2,17.3,32.7,38.9h-47.5C131.2,106.8,136.4,111.2,145.5,111.2z M157.7,87.2c-1.3-6.4-5.8-10.9-13.6-10.9c-7.5,0-12.7,3.8-14.6,10.9H157.7z"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    fill: "#1D1D1B",
    d: "M184.8,77.7V62.6h7.3V30.5h18.2v32.2h14.6v15.1h-14.6V103c0,6.4,2,7.8,5.3,7.8c2.2,0,4-1.1,5.5-2.2l7.1,12.7c-3.1,2.5-8,5.1-15.6,5.1c-11.8,0-20.4-5.8-20.4-23.1V77.7H184.8z"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    fill: "#1D1D1B",
    d: "M234,93.7c0-18.9,12.7-32.7,28.9-32.7c9.5,0,15.5,3.3,18.9,8.7v-7.1H300v62.2h-18.2v-7.1c-3.5,5.5-9.5,8.7-18.9,8.7C246.7,126.5,234,112.7,234,93.7z M282.2,93.7c0-10.2-5.3-16.7-14.6-16.7c-9.3,0-14.9,6.5-14.9,16.7s5.6,16.7,14.9,16.7C276.9,110.5,282.2,103.9,282.2,93.7z"
  })));
}));
LgMeta.propTypes = {
  /** Icon fill color. */
  fill: PropTypes__default['default'].string,

  /** onClick handler. */
  onClick: PropTypes__default['default'].func,

  /** Styled component theme. */
  theme: PropTypes__default['default'].object,
  // eslint-disable-line react/forbid-prop-types

  /** Icon title. */
  title: PropTypes__default['default'].string,

  /** Icon width (passed to Svg via ...rest props). */
  width: PropTypes__default['default'].string
};
LgMeta.defaultProps = {
  fill: '',
  onClick: null,
  theme: null,
  title: '',
  width: '10rem'
};
var LgMeta$1 = styled.withTheme(LgMeta);var _excluded$19 = ["fill", "onClick", "theme", "title"];
// Component
// =============================

var LgMewo = function LgMewo() {
  return /*#__PURE__*/React__default['default'].createElement("g", null, /*#__PURE__*/React__default['default'].createElement("path", {
    fill: "#1C7ABA",
    d: "M51.1,70.8L51.1,70.8c-10.2,0-18.6-8.4-18.6-18.6v0c0-10.2,8.4-18.6,18.6-18.6l0,0c10.2,0,18.6,8.4,18.6,18.6v0C69.7,62.4,61.3,70.8,51.1,70.8"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    fill: "#FCDE30",
    d: "M16.4,46.1L16.4,46.1V1.5l0,0c12.3,0,22.3,10,22.3,22.3v0C38.7,36.1,28.6,46.1,16.4,46.1"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    fill: "#E64026",
    d: "M16.4,78.5L16.4,78.5H1.6h0V63.7v0c0-8.2,6.7-14.9,14.9-14.9l0,0c8.2,0,14.9,6.7,14.9,14.9C31.3,71.9,24.6,78.5,16.4,78.5"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M104.6,33.5c-2.5,0.6-4.2,1.4-5.9,3.2l-1.1,1.1L97.6,36l-0.1-1.8l-5.2-0.1l-5.2,0V52v17.8h5.3h5.3V59.4c0-6.9,0.1-10.7,0.2-11.4c0.3-1.5,1.1-3.1,2-3.8c1.2-1.1,2.4-1.4,4.7-1.4c1.9,0,2,0,3,0.5c1.2,0.6,2,1.7,2.4,3.1c0.1,0.6,0.2,4,0.3,12.1l0.1,11.3h5.2h5.2v-9.9c0-5.5,0.1-10.5,0.2-11.1c0.3-2,0.8-3.1,1.9-4.2c0.8-0.8,1.2-1.1,2.1-1.3c1.3-0.4,3.9-0.5,5.1-0.1c1.2,0.3,2.3,1.4,2.8,2.7l0.4,1l0.1,11.5l0.1,11.5h5.3h5.3l-0.1-12.3c-0.1-11-0.1-12.5-0.4-13.7c-1-4.3-3.3-7.5-6.6-9.1c-2.3-1.1-3.3-1.3-6.7-1.3c-3.5,0-4.8,0.3-7.5,1.6c-1.4,0.7-2,1.1-3.3,2.5l-1.7,1.6l-0.7-1.1c-1.3-2-3.2-3.5-5.5-4.2C109.9,33.3,106.3,33.1,104.6,33.5z"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M166,33.5c-0.9,0.1-2.4,0.5-3.3,0.8c-5.9,2-10.3,6.7-11.9,12.7c-0.4,1.6-0.5,2.1-0.5,5c0,2.9,0.1,3.4,0.5,5c1.9,7.2,7.5,12,15.3,13.3c2.2,0.4,6.9,0.4,9,0c3.9-0.7,7.2-2.2,9.9-4.7l1-0.9l-3.1-3.1c-1.7-1.7-3.2-3.1-3.2-3.1s-0.6,0.3-1.1,0.7c-1.2,0.9-3.1,1.8-4.5,2.2c-1.7,0.4-4.6,0.5-6.1,0.2c-3.3-0.7-5.3-2.4-6.5-5.3l-0.3-0.9h13.5h13.5l0.1-0.5c0.2-0.7-0.1-4.5-0.4-6.2C185.8,38,177,31.8,166,33.5z M171.1,42.3c1.4,0.2,3.3,1.1,4.2,2.2c0.8,0.9,1.6,2.4,1.7,3.3l0.1,0.5h-8h-8l0.1-0.4c0.7-2.4,2.5-4.4,4.9-5.2c0.8-0.3,2.9-0.6,3.5-0.5C169.9,42.1,170.6,42.2,171.1,42.3z"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M212.8,42.1l-4.7,8.8l-0.9-2.1c-0.5-1.2-2-4.9-3.4-8.3l-2.5-6.2l-5.8-0.1c-4.6,0-5.8,0-5.8,0.2c0,0.1,3.7,8.4,8.2,18.3c5.3,11.9,8.2,18.1,8.4,18.1c0.1,0,2.4-3.9,5.7-9.8c3-5.4,5.5-9.9,5.6-9.9c0.1-0.1,2.5,4.3,5.5,9.8c2.9,5.5,5.4,10,5.5,10c0.2,0,16.8-36.2,16.8-36.6c0-0.1-2.3-0.1-5.2-0.1l-5.2,0.1l-3.5,8c-1.9,4.4-3.5,8.2-3.6,8.4c-0.1,0.3-1.2-1.6-5.1-8.5c-2.7-4.9-5.1-8.8-5.2-8.8C217.6,33.3,215.4,37.2,212.8,42.1z"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M262.3,33.5c-7.2,1.2-13,6-15.1,12.6c-1.1,3.2-1.2,7.4-0.3,10.8c1.6,6.4,6.8,11.5,13.4,13.2c2.2,0.6,6.5,0.8,8.9,0.4c6.9-1,12.9-5.8,15.1-12.2c1.4-4,1.2-9.4-0.2-13.2c-2.3-5.8-7.4-10-13.9-11.4C268.3,33.3,264.2,33.2,262.3,33.5z M267.8,42.4c1.6,0.4,2.8,1.1,3.9,2.1c2.5,2.5,3.4,7.3,2.2,11.2c-1.2,3.9-4.1,6-8.2,6c-5.2,0-8.5-3.9-8.5-9.9c0-3,0.9-5.4,2.6-7.2C261.7,42.6,264.8,41.7,267.8,42.4z"
  }));
};

var LgApp = /*#__PURE__*/React__default['default'].memo( /*#__PURE__*/React__default['default'].forwardRef(function (_ref, ref) {
  _ref.fill;
      var onClick = _ref.onClick;
      _ref.theme;
      var title = _ref.title,
      rest = _objectWithoutProperties$7(_ref, _excluded$19);

  return /*#__PURE__*/React__default['default'].createElement(Svg$2, _extends$g({
    onClick: onClick,
    ref: ref,
    title: title,
    viewBox: "0 0 286.3 80"
  }, rest), /*#__PURE__*/React__default['default'].createElement(LgMewo, null));
}));
LgApp.propTypes = {
  /** Icon fill color. */
  fill: PropTypes__default['default'].string,

  /** onClick handler. */
  onClick: PropTypes__default['default'].func,

  /** Styled component theme. */
  theme: PropTypes__default['default'].object,
  // eslint-disable-line react/forbid-prop-types

  /** Icon title. */
  title: PropTypes__default['default'].string,

  /** Icon width (passed to Svg via ...rest props). */
  width: PropTypes__default['default'].string
};
LgApp.defaultProps = {
  fill: '',
  onClick: null,
  theme: null,
  title: '',
  width: '12.4rem'
};
var LgApp$1 = styled.withTheme(LgApp);var _excluded$18 = ["fill", "onClick", "theme", "title"];
// Component
// =============================

var LgModo = /*#__PURE__*/React__default['default'].memo( /*#__PURE__*/React__default['default'].forwardRef(function (_ref, ref) {
  _ref.fill;
      var onClick = _ref.onClick;
      _ref.theme;
      var title = _ref.title,
      rest = _objectWithoutProperties$7(_ref, _excluded$18);

  return /*#__PURE__*/React__default['default'].createElement(Svg$2, _extends$g({
    onClick: onClick,
    ref: ref,
    title: title,
    viewBox: "0 0 300 130.3"
  }, rest), /*#__PURE__*/React__default['default'].createElement("path", {
    fill: "#1D1D1B",
    d: "M0,73.1h16.3v6.4c3.4-5.4,8.8-7.8,15.6-7.8c7.5,0,12.7,3.3,15.8,9.4c4.7-6.5,11.2-9.4,20.2-9.4c12.9,0,20.7,9.1,20.7,23.1v34H72.3V96.4c0-6.4-2.1-10.1-9-10.1c-7.3,0-10.9,4.2-10.9,12.5v30H36.2V96.4c0-6.4-2.1-10.1-9-10.1c-7.3,0-10.9,4.2-10.9,12.5v30H0V73.1z"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    fill: "#1D1D1B",
    d: "M98.9,100.9c0-16.9,13.4-29.3,30.5-29.3c17.1,0,30.5,12.4,30.5,29.3c0,16.9-13.4,29.3-30.5,29.3C112.2,130.3,98.9,117.9,98.9,100.9z M143,100.9c0-9-5.2-15.5-13.7-15.5c-8.5,0-13.7,6.5-13.7,15.5c0,9,5.2,15.5,13.7,15.5C137.8,116.4,143,109.9,143,100.9z"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    fill: "#1D1D1B",
    d: "M168.2,100.9c0-16.9,11.7-29.3,26.2-29.3c8.5,0,14.2,2.9,17.3,7.8l0.1-35.4h16.3l-0.1,84.8h-16.3v-6.4c-3.1,4.9-8.8,7.8-17.3,7.8C180,130.3,168.2,117.9,168.2,100.9z M212.1,100.9c0-9.1-5-15-13.4-15c-8.3,0-13.7,5.9-13.7,15c0,9.1,5.4,15,13.7,15C207,115.9,212.1,110.1,212.1,100.9z"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    fill: "#1D1D1B",
    d: "M239.1,100.9c0-16.9,13.4-29.3,30.5-29.3c17.1,0,30.5,12.4,30.5,29.3c0,16.9-13.4,29.3-30.5,29.3C252.4,130.3,239.1,117.9,239.1,100.9z M283.2,100.9c0-9-5.2-15.5-13.7-15.5c-8.5,0-13.7,6.5-13.7,15.5c0,9,5.2,15.5,13.7,15.5C278,116.4,283.2,109.9,283.2,100.9z"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    fill: "#1A7ABA",
    d: "M129.3,57.9L129.3,57.9c-15.9,0-28.9-13.1-28.9-28.9l0,0c0-15.9,13.1-28.9,28.9-28.9l0,0c15.9,0,28.9,13.1,28.9,28.9l0,0C158.2,44.8,145.2,57.9,129.3,57.9"
  }), /*#__PURE__*/React__default['default'].createElement("g", null, /*#__PURE__*/React__default['default'].createElement("path", {
    fill: "#1D1D1B",
    d: "M0,73.1h16.3v6.4c3.4-5.4,8.8-7.8,15.6-7.8c7.5,0,12.7,3.3,15.8,9.4c4.7-6.5,11.2-9.4,20.2-9.4c12.9,0,20.7,9.1,20.7,23.1v34H72.3V96.4c0-6.4-2.1-10.1-9-10.1c-7.3,0-10.9,4.2-10.9,12.5v30H36.2V96.4c0-6.4-2.1-10.1-9-10.1c-7.3,0-10.9,4.2-10.9,12.5v30H0V73.1z"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    fill: "#1D1D1B",
    d: "M98.9,100.9c0-16.9,13.4-29.3,30.5-29.3c17.1,0,30.5,12.4,30.5,29.3c0,16.9-13.4,29.3-30.5,29.3C112.2,130.3,98.9,117.9,98.9,100.9z M143,100.9c0-9-5.2-15.5-13.7-15.5c-8.5,0-13.7,6.5-13.7,15.5c0,9,5.2,15.5,13.7,15.5C137.8,116.4,143,109.9,143,100.9z"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    fill: "#1D1D1B",
    d: "M168.2,100.9c0-16.9,11.7-29.3,26.2-29.3c8.5,0,14.2,2.9,17.3,7.8l0.1-35.4h16.3l-0.1,84.8h-16.3v-6.4c-3.1,4.9-8.8,7.8-17.3,7.8C180,130.3,168.2,117.9,168.2,100.9z M212.1,100.9c0-9.1-5-15-13.4-15c-8.3,0-13.7,5.9-13.7,15c0,9.1,5.4,15,13.7,15C207,115.9,212.1,110.1,212.1,100.9z"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    fill: "#1D1D1B",
    d: "M239.1,100.9c0-16.9,13.4-29.3,30.5-29.3c17.1,0,30.5,12.4,30.5,29.3c0,16.9-13.4,29.3-30.5,29.3C252.4,130.3,239.1,117.9,239.1,100.9z M283.2,100.9c0-9-5.2-15.5-13.7-15.5c-8.5,0-13.7,6.5-13.7,15.5c0,9,5.2,15.5,13.7,15.5C278,116.4,283.2,109.9,283.2,100.9z"
  })), /*#__PURE__*/React__default['default'].createElement("path", {
    fill: "#1D1D1B",
    d: "M0,73.1h16.3v6.4c3.4-5.4,8.8-7.8,15.6-7.8c7.5,0,12.7,3.3,15.8,9.4c4.7-6.5,11.2-9.4,20.2-9.4c12.9,0,20.7,9.1,20.7,23.1v34H72.3V96.4c0-6.4-2.1-10.1-9-10.1c-7.3,0-10.9,4.2-10.9,12.5v30H36.2V96.4c0-6.4-2.1-10.1-9-10.1c-7.3,0-10.9,4.2-10.9,12.5v30H0V73.1z"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    fill: "#1D1D1B",
    d: "M98.9,100.9c0-16.9,13.4-29.3,30.5-29.3c17.1,0,30.5,12.4,30.5,29.3c0,16.9-13.4,29.3-30.5,29.3C112.2,130.3,98.9,117.9,98.9,100.9z M143,100.9c0-9-5.2-15.5-13.7-15.5c-8.5,0-13.7,6.5-13.7,15.5c0,9,5.2,15.5,13.7,15.5C137.8,116.4,143,109.9,143,100.9z"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    fill: "#1D1D1B",
    d: "M168.2,100.9c0-16.9,11.7-29.3,26.2-29.3c8.5,0,14.2,2.9,17.3,7.8l0.1-35.4h16.3l-0.1,84.8h-16.3v-6.4c-3.1,4.9-8.8,7.8-17.3,7.8C180,130.3,168.2,117.9,168.2,100.9z M212.1,100.9c0-9.1-5-15-13.4-15c-8.3,0-13.7,5.9-13.7,15c0,9.1,5.4,15,13.7,15C207,115.9,212.1,110.1,212.1,100.9z"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    fill: "#1D1D1B",
    d: "M239.1,100.9c0-16.9,13.4-29.3,30.5-29.3c17.1,0,30.5,12.4,30.5,29.3c0,16.9-13.4,29.3-30.5,29.3C252.4,130.3,239.1,117.9,239.1,100.9z M283.2,100.9c0-9-5.2-15.5-13.7-15.5c-8.5,0-13.7,6.5-13.7,15.5c0,9,5.2,15.5,13.7,15.5C278,116.4,283.2,109.9,283.2,100.9z"
  }));
}));
LgModo.propTypes = {
  /** Icon fill color. */
  fill: PropTypes__default['default'].string,

  /** onClick handler. */
  onClick: PropTypes__default['default'].func,

  /** Styled component theme. */
  theme: PropTypes__default['default'].object,
  // eslint-disable-line react/forbid-prop-types

  /** Icon title. */
  title: PropTypes__default['default'].string,

  /** Icon width (passed to Svg via ...rest props). */
  width: PropTypes__default['default'].string
};
LgModo.defaultProps = {
  fill: '',
  onClick: null,
  theme: null,
  title: '',
  width: '10rem'
};
var LgModo$1 = styled.withTheme(LgModo);var _excluded$17 = ["fill", "horizontal", "onClick", "theme", "title"];
// Component
// =============================

var LgMaia = /*#__PURE__*/React__default['default'].memo( /*#__PURE__*/React__default['default'].forwardRef(function (_ref, ref) {
  _ref.fill;
      var horizontal = _ref.horizontal,
      onClick = _ref.onClick;
      _ref.theme;
      var title = _ref.title,
      rest = _objectWithoutProperties$7(_ref, _excluded$17);

  return !horizontal ? /*#__PURE__*/React__default['default'].createElement(Svg$2, _extends$g({
    onClick: onClick,
    ref: ref,
    title: title,
    viewBox: "0 0 300 151.4"
  }, rest), /*#__PURE__*/React__default['default'].createElement("path", {
    fill: "#1D1D1B",
    d: "M0,84.9h18.9v7.4c4-6.2,10.2-9.1,18.2-9.1c8.7,0,14.8,3.8,18.4,11c5.5-7.6,13.1-11,23.5-11c15,0,24,10.6,24,26.9v39.6H84V112c0-7.4-2.5-11.7-10.4-11.7c-8.5,0-12.7,4.9-12.7,14.6v34.8H42V112c0-7.4-2.5-11.7-10.4-11.7c-8.5,0-12.7,4.9-12.7,14.6v34.8H0V84.9z"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    fill: "#1D1D1B",
    d: "M114.9,117.3c0-19.7,13.2-34.1,30.1-34.1c9.8,0,16.1,3.4,19.7,9.1v-7.4h18.9v64.7h-18.9v-7.4c-3.6,5.7-9.8,9.1-19.7,9.1C128.1,151.4,114.9,137,114.9,117.3z M165,117.3c0-10.6-5.5-17.4-15.1-17.4s-15.5,6.8-15.5,17.4c0,10.6,5.9,17.4,15.5,17.4S165,127.9,165,117.3z"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    fill: "#1D1D1B",
    d: "M197,63.4c0-6.8,5.7-11.9,11.9-11.9c6.4,0,11.9,5.1,11.9,11.9c0,6.8-5.5,11.9-11.9,11.9C202.7,75.3,197,70.2,197,63.4z M199.5,84.8h18.9v64.8h-18.9V84.8z"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    fill: "#1D1D1B",
    d: "M231.3,117.3c0-19.7,13.3-34.1,30.1-34.1c9.8,0,16.1,3.4,19.7,9.1v-7.4H300v64.7h-18.9v-7.4c-3.6,5.7-9.8,9.1-19.7,9.1C244.5,151.4,231.3,137,231.3,117.3z M281.5,117.3c0-10.6-5.5-17.4-15.1-17.4c-9.7,0-15.5,6.8-15.5,17.4c0,10.6,5.9,17.4,15.5,17.4C276,134.7,281.5,127.9,281.5,117.3z"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    fill: "#E54126",
    d: "M149.4,67.4L149.4,67.4h-33.6l0,0V33.8l0,0C115.8,15.2,131,0,149.6,0l0,0c18.6,0,33.8,15.2,33.8,33.8C183.2,52.4,168,67.4,149.4,67.4"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    fill: "#1D1D1B",
    d: "M0,84.9h18.9v7.4c4-6.2,10.2-9.1,18.2-9.1c8.7,0,14.8,3.8,18.4,11c5.5-7.6,13.1-11,23.5-11c15,0,24,10.6,24,26.9v39.6H84V112c0-7.4-2.5-11.7-10.4-11.7c-8.5,0-12.7,4.9-12.7,14.6v34.8H42V112c0-7.4-2.5-11.7-10.4-11.7c-8.5,0-12.7,4.9-12.7,14.6v34.8H0V84.9z"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    fill: "#1D1D1B",
    d: "M114.9,117.3c0-19.7,13.2-34.1,30.1-34.1c9.8,0,16.1,3.4,19.7,9.1v-7.4h18.9v64.7h-18.9v-7.4c-3.6,5.7-9.8,9.1-19.7,9.1C128.1,151.4,114.9,137,114.9,117.3z M165,117.3c0-10.6-5.5-17.4-15.1-17.4s-15.5,6.8-15.5,17.4c0,10.6,5.9,17.4,15.5,17.4S165,127.9,165,117.3z"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    fill: "#1D1D1B",
    d: "M197,63.4c0-6.8,5.7-11.9,11.9-11.9c6.4,0,11.9,5.1,11.9,11.9c0,6.8-5.5,11.9-11.9,11.9C202.7,75.3,197,70.2,197,63.4z M199.5,84.8h18.9v64.8h-18.9V84.8z"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    fill: "#1D1D1B",
    d: "M231.3,117.3c0-19.7,13.3-34.1,30.1-34.1c9.8,0,16.1,3.4,19.7,9.1v-7.4H300v64.7h-18.9v-7.4c-3.6,5.7-9.8,9.1-19.7,9.1C244.5,151.4,231.3,137,231.3,117.3z M281.5,117.3c0-10.6-5.5-17.4-15.1-17.4c-9.7,0-15.5,6.8-15.5,17.4c0,10.6,5.9,17.4,15.5,17.4C276,134.7,281.5,127.9,281.5,117.3z"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    fill: "#1D1D1B",
    d: "M0,84.9h18.9v7.4c4-6.2,10.2-9.1,18.2-9.1c8.7,0,14.8,3.8,18.4,11c5.5-7.6,13.1-11,23.5-11c15,0,24,10.6,24,26.9v39.6H84V112c0-7.4-2.5-11.7-10.4-11.7c-8.5,0-12.7,4.9-12.7,14.6v34.8H42V112c0-7.4-2.5-11.7-10.4-11.7c-8.5,0-12.7,4.9-12.7,14.6v34.8H0V84.9z"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    fill: "#1D1D1B",
    d: "M114.9,117.3c0-19.7,13.2-34.1,30.1-34.1c9.8,0,16.1,3.4,19.7,9.1v-7.4h18.9v64.7h-18.9v-7.4c-3.6,5.7-9.8,9.1-19.7,9.1C128.1,151.4,114.9,137,114.9,117.3z M165,117.3c0-10.6-5.5-17.4-15.1-17.4s-15.5,6.8-15.5,17.4c0,10.6,5.9,17.4,15.5,17.4S165,127.9,165,117.3z"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    fill: "#1D1D1B",
    d: "M197,63.4c0-6.8,5.7-11.9,11.9-11.9c6.4,0,11.9,5.1,11.9,11.9c0,6.8-5.5,11.9-11.9,11.9C202.7,75.3,197,70.2,197,63.4z M199.5,84.8h18.9v64.8h-18.9V84.8z"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    fill: "#1D1D1B",
    d: "M231.3,117.3c0-19.7,13.3-34.1,30.1-34.1c9.8,0,16.1,3.4,19.7,9.1v-7.4H300v64.7h-18.9v-7.4c-3.6,5.7-9.8,9.1-19.7,9.1C244.5,151.4,231.3,137,231.3,117.3z M281.5,117.3c0-10.6-5.5-17.4-15.1-17.4c-9.7,0-15.5,6.8-15.5,17.4c0,10.6,5.9,17.4,15.5,17.4C276,134.7,281.5,127.9,281.5,117.3z"
  })) : /*#__PURE__*/React__default['default'].createElement(Svg$2, _extends$g({
    onClick: onClick,
    title: title,
    viewBox: "0 0 300 79.7"
  }, rest), /*#__PURE__*/React__default['default'].createElement("path", {
    fill: "#1D1D1B",
    d: "M82.3,24.3H96v5.4c2.9-4.5,7.4-6.6,13.2-6.6c6.3,0,10.7,2.7,13.3,8c4-5.5,9.5-8,17-8c10.9,0,17.4,7.7,17.4,19.5v28.7h-13.7V43.9c0-5.4-1.8-8.5-7.6-8.5c-6.2,0-9.2,3.6-9.2,10.6v25.3h-13.7V43.9c0-5.4-1.8-8.5-7.6-8.5C99,35.4,96,39,96,46v25.3H82.3V24.3z"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    fill: "#1D1D1B",
    d: "M165.7,47.8c0-14.3,9.6-24.7,21.8-24.7c7.1,0,11.7,2.5,14.3,6.6v-5.4h13.7v47h-13.7v-5.4c-2.6,4.1-7.1,6.6-14.3,6.6C175.3,72.5,165.7,62.1,165.7,47.8z M202.1,47.8c0-7.7-4-12.6-11-12.6c-7,0-11.3,4.9-11.3,12.6c0,7.7,4.3,12.6,11.3,12.6C198.1,60.4,202.1,55.5,202.1,47.8z"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    fill: "#1D1D1B",
    d: "M225.3,8.7c0-4.9,4.1-8.7,8.7-8.7c4.7,0,8.7,3.7,8.7,8.7c0,4.9-4,8.7-8.7,8.7C229.4,17.3,225.3,13.6,225.3,8.7z M227.1,24.1h13.7v47.1h-13.7V24.1z"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    fill: "#1D1D1B",
    d: "M250.1,47.8c0-14.3,9.6-24.7,21.8-24.7c7.1,0,11.7,2.5,14.3,6.6v-5.4H300v47h-13.7v-5.4c-2.6,4.1-7.1,6.6-14.3,6.6C259.8,72.5,250.1,62.1,250.1,47.8z M286.5,47.8c0-7.7-4-12.6-11-12.6c-7,0-11.3,4.9-11.3,12.6c0,7.7,4.3,12.6,11.3,12.6C282.6,60.4,286.5,55.5,286.5,47.8z"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#E54126",
    d: "M32.7,79.7L32.7,79.7H0l0,0V47l0,0C0,28.8,14.8,14,32.9,14l0,0C51,14,65.8,28.8,65.8,47C65.6,65.1,50.8,79.7,32.7,79.7"
  }));
}));
LgMaia.propTypes = {
  /** Icon fill color. */
  fill: PropTypes__default['default'].string,

  /** If True, will render an horizontal version. */
  horizontal: PropTypes__default['default'].bool,

  /** onClick handler. */
  onClick: PropTypes__default['default'].func,

  /** Styled component theme. */
  theme: PropTypes__default['default'].object,
  // eslint-disable-line react/forbid-prop-types

  /** Icon title. */
  title: PropTypes__default['default'].string,

  /** Icon width (passed to Svg via ...rest props). */
  width: PropTypes__default['default'].string
};
LgMaia.defaultProps = {
  fill: '',
  horizontal: false,
  onClick: null,
  theme: null,
  title: '',
  width: '10rem'
};
var LgMaia$1 = styled.withTheme(LgMaia);var _excluded$16 = ["fill", "onClick", "theme", "title"];
// Component
// =============================

var Location = /*#__PURE__*/React__default['default'].memo( /*#__PURE__*/React__default['default'].forwardRef(function (_ref, ref) {
  var fill = _ref.fill,
      onClick = _ref.onClick,
      theme = _ref.theme,
      title = _ref.title,
      rest = _objectWithoutProperties$7(_ref, _excluded$16);

  return /*#__PURE__*/React__default['default'].createElement(Svg$2, _extends$g({
    fill: fill || theme.colors.text,
    onClick: onClick,
    ref: ref,
    title: title,
    viewBox: "0 0 24 24"
  }, rest), /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M12,8.25 C11.035,8.25 10.25,9.035 10.25,10 C10.25,10.965 11.035,11.75 12,11.75 C12.965,11.75 13.75,10.965 13.75,10 C13.75,9.035 12.965,8.25 12,8.25 M12,13.25 C10.208,13.25 8.75,11.792 8.75,10 C8.75,8.208 10.208,6.75 12,6.75 C13.792,6.75 15.25,8.208 15.25,10 C15.25,11.792 13.792,13.25 12,13.25 M12,3.5 C8.805,3.5 5.5,5.937 5.5,10.014 C5.5,13.153 9.517,18.055 11.89,20.455 C11.946,20.512 12.051,20.515 12.113,20.452 C14.483,18.055 18.5,13.153 18.5,10.014 C18.5,5.937 15.195,3.5 12,3.5 M12,22 C11.558,22 11.141,21.827 10.826,21.513 C9.684,20.357 4,14.387 4,10.014 C4,4.997 8.067,2 12,2 C15.933,2 20,4.997 20,10.014 C20,14.387 14.316,20.357 13.177,21.51 C12.859,21.827 12.442,22 12,22",
    id: "\uD83C\uDFA8-Color"
  }));
}));
Location.propTypes = {
  /** Icon fill color. */
  fill: PropTypes__default['default'].string,

  /** onClick handler. */
  onClick: PropTypes__default['default'].func,

  /** Styled component theme. */
  theme: PropTypes__default['default'].object,
  // eslint-disable-line react/forbid-prop-types

  /** Icon title. */
  title: PropTypes__default['default'].string,

  /** Icon width (passed to Svg via ...rest props). */
  width: PropTypes__default['default'].string
};
Location.defaultProps = {
  fill: '',
  onClick: null,
  theme: null,
  title: '',
  width: '2rem'
};
var Location$1 = styled.withTheme(Location);var _excluded$15 = ["fill", "onClick", "theme", "title"];
// Component
// =============================

var Lyrics = /*#__PURE__*/React__default['default'].memo( /*#__PURE__*/React__default['default'].forwardRef(function (_ref, ref) {
  var fill = _ref.fill,
      onClick = _ref.onClick,
      theme = _ref.theme,
      title = _ref.title,
      rest = _objectWithoutProperties$7(_ref, _excluded$15);

  return /*#__PURE__*/React__default['default'].createElement(Svg$2, _extends$g({
    fill: fill || theme.colors.text,
    onClick: onClick,
    ref: ref,
    title: title,
    viewBox: "-21 -21 682.66669 682.66669"
  }, rest), /*#__PURE__*/React__default['default'].createElement("path", {
    d: "m577.5 0h-465.078125c-34.460937 0-62.5 28.039062-62.5 62.5v502.5h-37.421875c-6.90625 0-12.5 5.59375-12.5 12.5 0 34.460938 28.039062 62.5 62.5 62.5h419.664062c1.316407 0 2.585938-.203125 3.78125-.585938 30.480469-4.136718 54.054688-30.316406 54.054688-61.914062v-182.4375c0-6.902344-5.59375-12.5-12.5-12.5s-12.5 5.597656-12.5 12.5v182.4375c0 20.679688-16.820312 37.5-37.5 37.5s-37.5-16.820312-37.5-37.5c0-6.90625-5.59375-12.5-12.5-12.5h-352.578125v-502.5c0-20.679688 16.820313-37.5 37.5-37.5h415.113281c-7.867187 10.453125-12.535156 23.441406-12.535156 37.5v232.5625c0 6.90625 5.59375 12.5 12.5 12.5s12.5-5.59375 12.5-12.5v-220.0625h87.5c6.90625 0 12.5-5.59375 12.5-12.5 0-34.460938-28.039062-62.5-62.5-62.5zm-515 615c-16.292969 0-30.191406-10.449219-35.351562-25h389.109374c1.882813 9.234375 5.804688 17.730469 11.277344 25zm479.644531-565c5.15625-14.550781 19.058594-25 35.355469-25s30.199219 10.449219 35.355469 25zm0 0"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    d: "m451.054688 506.9375h-168.746094c-6.902344 0-12.5 5.597656-12.5 12.5 0 6.90625 5.597656 12.5 12.5 12.5h168.746094c6.90625 0 12.5-5.59375 12.5-12.5 0-6.902344-5.59375-12.5-12.5-12.5zm0 0"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    d: "m451.054688 446.9375h-168.746094c-6.902344 0-12.5 5.597656-12.5 12.5 0 6.90625 5.597656 12.5 12.5 12.5h168.746094c6.90625 0 12.5-5.59375 12.5-12.5 0-6.902344-5.59375-12.5-12.5-12.5zm0 0"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    d: "m267.5 339.4375c0-6.902344-5.59375-12.5-12.5-12.5h-131.25c-6.90625 0-12.5 5.597656-12.5 12.5 0 6.90625 5.59375 12.5 12.5 12.5h131.25c6.90625 0 12.5-5.59375 12.5-12.5zm0 0"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    d: "m255 266.9375h-131.25c-6.90625 0-12.5 5.597656-12.5 12.5 0 6.90625 5.59375 12.5 12.5 12.5h131.25c6.90625 0 12.5-5.59375 12.5-12.5 0-6.902344-5.59375-12.5-12.5-12.5zm0 0"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    d: "m451.054688 147.5h-130.894532c-6.902344 0-12.5 5.59375-12.5 12.5s5.597656 12.5 12.5 12.5h130.894532c6.90625 0 12.5-5.59375 12.5-12.5s-5.59375-12.5-12.5-12.5zm0 0"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    d: "m451.054688 87.5h-130.894532c-6.902344 0-12.5 5.59375-12.5 12.5s5.597656 12.5 12.5 12.5h130.894532c6.90625 0 12.5-5.59375 12.5-12.5s-5.59375-12.5-12.5-12.5zm0 0"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    d: "m276.0625 80.371094c0-3.96875-1.878906-7.699219-5.070312-10.054688-3.1875-2.355468-7.3125-3.058594-11.101563-1.894531l-100 30.753906c-5.246094 1.613281-8.828125 6.457031-8.828125 11.949219v64.023438c-3.910156-1.390626-8.113281-2.148438-12.5-2.148438-20.675781 0-37.5 16.820312-37.5 37.5 0 20.675781 16.824219 37.5 37.5 37.5 20.679688 0 37.5-16.824219 37.5-37.5v-90.144531l75-23.066407v47.105469c-3.910156-1.386719-8.113281-2.148437-12.5-2.148437-20.675781 0-37.5 16.820312-37.5 37.5 0 20.679687 16.824219 37.5 37.5 37.5 20.679688 0 37.5-16.820313 37.5-37.5zm-137.5 142.628906c-6.886719 0-12.5-5.613281-12.5-12.5 0-6.898438 5.613281-12.5 12.5-12.5 6.898438 0 12.5 5.601562 12.5 12.5 0 6.886719-5.601562 12.5-12.5 12.5zm100-30.753906c-6.886719 0-12.5-5.609375-12.5-12.5 0-6.894532 5.613281-12.5 12.5-12.5 6.898438 0 12.5 5.605468 12.5 12.5 0 6.890625-5.601562 12.5-12.5 12.5zm0 0"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    d: "m463.554688 239.9375c0-3.964844-1.878907-7.703125-5.074219-10.054688-3.1875-2.359374-7.308594-3.0625-11.097657-1.894531l-100 30.753907c-5.25 1.613281-8.828124 6.457031-8.828124 11.945312v64.03125c-3.910157-1.394531-8.117188-2.15625-12.5-2.15625-20.679688 0-37.5 16.828125-37.5 37.5 0 20.679688 16.820312 37.5 37.5 37.5 20.679687 0 37.5-16.820312 37.5-37.5v-90.140625l75-23.0625v47.101563c-3.910157-1.386719-8.117188-2.148438-12.5-2.148438-20.679688 0-37.5 16.820312-37.5 37.5s16.820312 37.5 37.5 37.5c20.679687 0 37.5-16.820312 37.5-37.5zm-137.5 142.625c-6.894532 0-12.5-5.605469-12.5-12.5s5.605468-12.5 12.5-12.5c6.894531 0 12.5 5.605469 12.5 12.5s-5.605469 12.5-12.5 12.5zm100-30.75c-6.894532 0-12.5-5.609375-12.5-12.5 0-6.894531 5.605468-12.5 12.5-12.5 6.894531 0 12.5 5.605469 12.5 12.5 0 6.890625-5.605469 12.5-12.5 12.5zm0 0"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    d: "m212.269531 392.265625-19.765625-6.5625c-3.8125-1.269531-7.996094-.625-11.253906 1.722656-3.257812 2.347657-5.1875 6.125-5.1875 10.136719v61.523438c-3.910156-1.386719-8.117188-2.148438-12.5-2.148438-20.675781 0-37.5 16.820312-37.5 37.5s16.824219 37.5 37.5 37.5c20.679688 0 37.5-16.820312 37.5-37.5v-79.554688l3.332031 1.101563c10.023438 3.332031 17.503907 11.453125 20 21.71875 1.636719 6.710937 8.394531 10.828125 15.101563 9.195313 6.710937-1.632813 10.824218-8.390626 9.191406-15.101563-4.546875-18.695313-18.160156-33.472656-36.417969-39.53125zm-48.707031 114.671875c-6.886719 0-12.5-5.605469-12.5-12.5s5.613281-12.5 12.5-12.5c6.898438 0 12.5 5.605469 12.5 12.5s-5.601562 12.5-12.5 12.5zm0 0"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    d: "m527.5 332.5625c-3.285156 0-6.515625 1.339844-8.835938 3.664062-2.328124 2.324219-3.664062 5.550782-3.664062 8.835938 0 3.289062 1.335938 6.515625 3.664062 8.839844 2.320313 2.324218 5.550782 3.660156 8.835938 3.660156s6.515625-1.335938 8.835938-3.660156c2.328124-2.324219 3.664062-5.550782 3.664062-8.839844 0-3.285156-1.335938-6.511719-3.664062-8.835938-2.320313-2.324218-5.550782-3.664062-8.835938-3.664062zm0 0"
  }));
}));
Lyrics.propTypes = {
  /** Icon fill color. */
  fill: PropTypes__default['default'].string,

  /** onClick handler. */
  onClick: PropTypes__default['default'].func,

  /** Styled component theme. */
  theme: PropTypes__default['default'].object,
  // eslint-disable-line react/forbid-prop-types

  /** Icon title. */
  title: PropTypes__default['default'].string,

  /** Icon width (passed to Svg via ...rest props). */
  width: PropTypes__default['default'].string
};
Lyrics.defaultProps = {
  fill: '',
  onClick: null,
  theme: null,
  title: '',
  width: '1.8rem'
};
var Lyrics$1 = styled.withTheme(Lyrics);var _excluded$14 = ["fill", "onClick", "theme", "title"];
// Component
// =============================

var MagicWand = /*#__PURE__*/React__default['default'].memo( /*#__PURE__*/React__default['default'].forwardRef(function (_ref, ref) {
  var fill = _ref.fill,
      onClick = _ref.onClick,
      theme = _ref.theme,
      title = _ref.title,
      rest = _objectWithoutProperties$7(_ref, _excluded$14);

  return /*#__PURE__*/React__default['default'].createElement(Svg$2, _extends$g({
    fill: fill || theme.colors.text,
    onClick: onClick,
    ref: ref,
    title: title,
    viewBox: "0 0 100 100"
  }, rest), /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M63.81,35.75a4.94,4.94,0,0,0-7,0L6.45,86.11a5,5,0,0,0,0,7l.42.42a5,5,0,0,0,7,0L64.23,43.17a4.94,4.94,0,0,0,0-7Z"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M93.67,14.24l-2.61-.38-4.35-.64a1.89,1.89,0,0,1-1.28-.92L83.49,8.36,82.32,6c-.64-1.3-1.69-1.3-2.34,0L78.82,8.36,76.87,12.3a1.9,1.9,0,0,1-1.27.92l-4.35.64-2.61.38c-1.44.21-1.76,1.21-.72,2.22l1.89,1.84L73,21.37a1.92,1.92,0,0,1,.49,1.5L72.7,27.2s-.2,1.17-.45,2.6.61,2.05,1.89,1.37l2.34-1.23,3.89-2a1.87,1.87,0,0,1,1.57,0l3.89,2,2.34,1.23c1.28.68,2.13.06,1.89-1.37s-.45-2.6-.45-2.6l-.74-4.33a1.92,1.92,0,0,1,.49-1.5L92.5,18.3l1.89-1.84C95.43,15.45,95.11,14.45,93.67,14.24Z"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M27.23,17.35,29.92,20a1.63,1.63,0,0,1,.42,1.28L29.7,25l-.38,2.23c-.21,1.23.52,1.76,1.62,1.18l2-1.05,3.33-1.76a1.67,1.67,0,0,1,1.35,0L41,27.33l2,1.05c1.11.58,1.84.05,1.63-1.18S44.2,25,44.2,25l-.63-3.71A1.62,1.62,0,0,1,44,20l2.7-2.63,1.62-1.58c.89-.87.61-1.73-.62-1.91l-2.24-.32L41.72,13a1.64,1.64,0,0,1-1.1-.8L39,8.83l-1-2c-.55-1.12-1.46-1.12-2,0l-1,2L33.29,12.2a1.64,1.64,0,0,1-1.1.8l-3.72.54-2.24.32c-1.23.18-1.51,1-.62,1.91Z"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M92.87,60.23l-2.24-.33-3.72-.54a1.66,1.66,0,0,1-1.1-.79l-1.66-3.38-1-2c-.55-1.11-1.46-1.11-2,0l-1,2-1.67,3.38a1.61,1.61,0,0,1-1.09.79l-3.72.54-2.24.33c-1.23.17-1.51,1-.62,1.9l1.62,1.58,2.69,2.63a1.59,1.59,0,0,1,.42,1.28l-.64,3.71s-.17,1-.38,2.23.52,1.76,1.62,1.18l2-1,3.33-1.76a1.67,1.67,0,0,1,1.35,0l3.33,1.76,2,1c1.1.58,1.84.05,1.63-1.18s-.39-2.23-.39-2.23l-.64-3.71a1.63,1.63,0,0,1,.42-1.28l2.7-2.63,1.62-1.58C94.38,61.26,94.1,60.41,92.87,60.23Z"
  }));
}));
MagicWand.propTypes = {
  /** Icon fill color. */
  fill: PropTypes__default['default'].string,

  /** onClick handler. */
  onClick: PropTypes__default['default'].func,

  /** Styled component theme. */
  theme: PropTypes__default['default'].object,
  // eslint-disable-line react/forbid-prop-types

  /** Icon title. */
  title: PropTypes__default['default'].string,

  /** Icon width (passed to Svg via ...rest props). */
  width: PropTypes__default['default'].string
};
MagicWand.defaultProps = {
  fill: '',
  onClick: null,
  theme: null,
  title: '',
  width: '2rem'
};
var MagicWand$1 = styled.withTheme(MagicWand);var _excluded$13 = ["fill", "onClick", "theme", "title"];
// Component
// =============================

var MenuOutline = /*#__PURE__*/React__default['default'].memo( /*#__PURE__*/React__default['default'].forwardRef(function (_ref, ref) {
  var fill = _ref.fill,
      onClick = _ref.onClick,
      theme = _ref.theme,
      title = _ref.title,
      rest = _objectWithoutProperties$7(_ref, _excluded$13);

  return /*#__PURE__*/React__default['default'].createElement(Svg$2, _extends$g({
    fill: fill || theme.colors.text,
    onClick: onClick,
    ref: ref,
    title: title,
    viewBox: "0 0 40 40"
  }, rest), /*#__PURE__*/React__default['default'].createElement("circle", {
    fillOpacity: "0",
    stroke: fill || theme.colors.text,
    strokeWidth: "2",
    cx: "20",
    cy: "20",
    r: "19"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    fillRule: "evenodd",
    d: "M14 14h12a1 1 0 0 1 0 2H14a1 1 0 0 1 0-2z"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    fillRule: "evenodd",
    d: "M14 19h12a1 1 0 0 1 0 2H14a1 1 0 0 1 0-2z"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    fillRule: "evenodd",
    d: "M14 24h6.75a1 1 0 0 1 0 2H14a1 1 0 0 1 0-2z"
  }));
}));
MenuOutline.propTypes = {
  /** Icon fill color. */
  fill: PropTypes__default['default'].string,

  /** onClick handler. */
  onClick: PropTypes__default['default'].func,

  /** Styled component theme. */
  theme: PropTypes__default['default'].object,
  // eslint-disable-line react/forbid-prop-types

  /** Icon title. */
  title: PropTypes__default['default'].string,

  /** Icon width (passed to Svg via ...rest props). */
  width: PropTypes__default['default'].string
};
MenuOutline.defaultProps = {
  fill: '',
  onClick: null,
  theme: null,
  title: '',
  width: '4rem'
};
var MenuOutline$1 = styled.withTheme(MenuOutline);var _excluded$12 = ["fill", "onClick", "theme", "title"];
// Component
// =============================

var Microphone = /*#__PURE__*/React__default['default'].memo( /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var fill = _ref.fill,
      onClick = _ref.onClick,
      theme = _ref.theme,
      title = _ref.title,
      rest = _objectWithoutProperties$7(_ref, _excluded$12);

  return /*#__PURE__*/React__default['default'].createElement(Svg$2, _extends$g({
    fill: fill || theme.colors.text,
    onClick: onClick,
    ref: ref,
    title: title,
    viewBox: "0 0 70 91.7"
  }, rest), /*#__PURE__*/React__default['default'].createElement("g", {
    transform: "translate(0,-284.29999)"
  }, /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M35,284.3c-13.8,0-25,11.2-25,25V326c0,13.8,11.2,25,25,25s25-11.2,25-25v-16.7C60,295.5,48.8,284.3,35,284.3z  M35,292.6c9.3,0,16.7,7.4,16.7,16.7V326c0,9.3-7.4,16.7-16.7,16.7s-16.7-7.4-16.7-16.7v-16.7C18.3,300,25.7,292.6,35,292.6z  M4.1,334.2c-2.3,0-4.2,1.9-4.1,4.2c0,0.6,0.1,1.1,0.3,1.6C6,353.7,19.4,363.5,35,363.5c15.6,0,29.1-9.7,34.7-23.4 c0.9-2.1-0.1-4.6-2.3-5.4c-2.1-0.9-4.6,0.1-5.4,2.3c0,0,0,0,0,0c-4.4,10.6-14.9,18.2-27,18.2c-12.1,0-22.6-7.6-27-18.2 C7.4,335.3,5.9,334.2,4.1,334.2z M22.5,367.6c-2.3,0-4.2,1.9-4.2,4.2c0,2.3,1.9,4.2,4.2,4.2l0,0h25c2.3,0,4.2-1.9,4.2-4.2 c0-2.3-1.9-4.2-4.2-4.2H22.5z"
  })));
}));
Microphone.propTypes = {
  /** Icon fill color. */
  fill: PropTypes__default['default'].string,

  /** onClick handler. */
  onClick: PropTypes__default['default'].func,

  /** Styled component theme. */
  theme: PropTypes__default['default'].object,
  // eslint-disable-line react/forbid-prop-types

  /** Icon title. */
  title: PropTypes__default['default'].string,

  /** Icon width (passed to Svg via ...rest props). */
  width: PropTypes__default['default'].string
};
Microphone.defaultProps = {
  fill: '',
  onClick: null,
  theme: null,
  title: '',
  width: '2rem'
};
var Microphone$1 = styled.withTheme(Microphone);var _excluded$11 = ["fill", "onClick", "theme", "title"];
// Component
// =============================

var Next = /*#__PURE__*/React__default['default'].memo( /*#__PURE__*/React__default['default'].forwardRef(function (_ref, ref) {
  var fill = _ref.fill,
      onClick = _ref.onClick,
      theme = _ref.theme,
      title = _ref.title,
      rest = _objectWithoutProperties$7(_ref, _excluded$11);

  return /*#__PURE__*/React__default['default'].createElement(Svg$2, _extends$g({
    fill: fill || theme.colors.text,
    onClick: onClick,
    ref: ref,
    title: title,
    viewBox: "0 0 8 12"
  }, rest), /*#__PURE__*/React__default['default'].createElement("path", {
    fillRule: "evenodd",
    d: "M6.978.016c-.445.121-.756.668-.756 1.275v4.01L1.156 1.413C.622.988 0 1.473 0 2.263v7.352c0 .79.622 1.276 1.156.911l5.066-3.888v4.07c0 .608.311 1.155.756 1.276C7.51 12.106 8 11.498 8 10.77V1.231C8 .5 7.511-.106 6.978.016z"
  }));
}));
Next.propTypes = {
  /** Icon fill color. */
  fill: PropTypes__default['default'].string,

  /** onClick handler. */
  onClick: PropTypes__default['default'].func,

  /** Styled component theme. */
  theme: PropTypes__default['default'].object,
  // eslint-disable-line react/forbid-prop-types

  /** Icon title. */
  title: PropTypes__default['default'].string,

  /** Icon width (passed to Svg via ...rest props). */
  width: PropTypes__default['default'].string
};
Next.defaultProps = {
  fill: '',
  onClick: null,
  theme: null,
  title: '',
  width: '0.8rem'
};
var Next$1 = styled.withTheme(Next);var _excluded$10 = ["fill", "onClick", "theme", "title"];
// Component
// =============================

var MinusOutline = /*#__PURE__*/React__default['default'].memo( /*#__PURE__*/React__default['default'].forwardRef(function (_ref, ref) {
  var fill = _ref.fill,
      onClick = _ref.onClick,
      theme = _ref.theme,
      title = _ref.title,
      rest = _objectWithoutProperties$7(_ref, _excluded$10);

  return /*#__PURE__*/React__default['default'].createElement(Svg$2, _extends$g({
    fill: fill || theme.colors.text,
    onClick: onClick,
    ref: ref,
    title: title,
    viewBox: "0 0 20 20"
  }, rest), /*#__PURE__*/React__default['default'].createElement("circle", {
    fillOpacity: "0",
    stroke: fill || theme.colors.text,
    strokeWidth: "2",
    cx: "10",
    cy: "10",
    r: "9"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    fillRule: "evenodd",
    d: "M13.482716049382717,10.75 L6.5,10.75 L6.5,9.25 L13.5,9.25 L13.5,10.75 L13.482716049382717,10.75Z"
  }));
}));
MinusOutline.propTypes = {
  /** Icon fill color. */
  fill: PropTypes__default['default'].string,

  /** onClick handler. */
  onClick: PropTypes__default['default'].func,

  /** Styled component theme. */
  theme: PropTypes__default['default'].object,
  // eslint-disable-line react/forbid-prop-types

  /** Icon title. */
  title: PropTypes__default['default'].string,

  /** Icon width (passed to Svg via ...rest props). */
  width: PropTypes__default['default'].string
};
MinusOutline.defaultProps = {
  fill: '',
  onClick: null,
  theme: null,
  title: '',
  width: '2rem'
};
var MinusOutline$1 = styled.withTheme(MinusOutline);var _excluded$$ = ["fill", "onClick", "theme", "title"];
// Component
// =============================

var MinusRounded = /*#__PURE__*/React__default['default'].memo( /*#__PURE__*/React__default['default'].forwardRef(function (_ref, ref) {
  var fill = _ref.fill,
      onClick = _ref.onClick,
      theme = _ref.theme,
      title = _ref.title,
      rest = _objectWithoutProperties$7(_ref, _excluded$$);

  return /*#__PURE__*/React__default['default'].createElement(Svg$2, _extends$g({
    fill: fill || theme.colors.text,
    onClick: onClick,
    ref: ref,
    title: title,
    viewBox: "0 0 7 2"
  }, rest), /*#__PURE__*/React__default['default'].createElement("path", {
    fillRule: "evenodd",
    d: "M1 0h5a1 1 0 0 1 0 2H1a1 1 0 0 1 0-2z"
  }));
}));
MinusRounded.propTypes = {
  /** Icon fill color. */
  fill: PropTypes__default['default'].string,

  /** onClick handler. */
  onClick: PropTypes__default['default'].func,

  /** Styled component theme. */
  theme: PropTypes__default['default'].object,
  // eslint-disable-line react/forbid-prop-types

  /** Icon title. */
  title: PropTypes__default['default'].string,

  /** Icon width (passed to Svg via ...rest props). */
  width: PropTypes__default['default'].string
};
MinusRounded.defaultProps = {
  fill: '',
  onClick: null,
  theme: null,
  title: '',
  width: '0.7rem'
};
var MinusRounded$1 = styled.withTheme(MinusRounded);var _excluded$_ = ["fill", "hasNotifications", "onClick", "theme", "title"];
// Component
// =============================

var NotificationBell = /*#__PURE__*/React__default['default'].memo( /*#__PURE__*/React__default['default'].forwardRef(function (_ref, ref) {
  var fill = _ref.fill,
      hasNotifications = _ref.hasNotifications,
      onClick = _ref.onClick,
      theme = _ref.theme,
      title = _ref.title,
      rest = _objectWithoutProperties$7(_ref, _excluded$_);

  return /*#__PURE__*/React__default['default'].createElement(Svg$2, _extends$g({
    fill: fill || theme.colors.primary,
    onClick: onClick,
    ref: ref,
    title: title,
    viewBox: "0 0 377.25 381.97"
  }, rest), /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M188.6.11A113.35 113.35 0 0 0 70.66 107.77l-4.07 82.06C65 222.07 33.46 257.56 8.13 286.09a32 32 0 0 0 23.94 53.2h107.68a53.31 53.31 0 0 0 104.48 0h100.94a31.6 31.6 0 0 0 22.57-9.23 32.55 32.55 0 0 0 6.64-9.65 31.56 31.56 0 0 0-5.25-34.3c-25.34-28.54-56.89-64-58.47-96.27l-4.06-82A113.38 113.38 0 0 0 188.6.11z",
    fill: fill
  }), hasNotifications && /*#__PURE__*/React__default['default'].createElement("g", null, /*#__PURE__*/React__default['default'].createElement("circle", {
    cx: "274.92",
    cy: "101.77",
    r: "70",
    transform: "rotate(-45 274.913 101.767)",
    fill: "#fff"
  }), /*#__PURE__*/React__default['default'].createElement("circle", {
    cx: "274.92",
    cy: "102.48",
    r: "42.5",
    transform: "rotate(-45 274.917 102.476)",
    fill: "#e5414f"
  })));
}));
NotificationBell.propTypes = {
  /** Icon fill color. */
  fill: PropTypes__default['default'].string,

  /** onClick handler. */
  onClick: PropTypes__default['default'].func,

  /** Has notification */
  hasNotifications: PropTypes__default['default'].bool,

  /** Styled component theme. */
  theme: PropTypes__default['default'].object,
  // eslint-disable-line react/forbid-prop-types

  /** Icon title. */
  title: PropTypes__default['default'].string,

  /** Icon width (passed to Svg via ...rest props). */
  width: PropTypes__default['default'].string
};
NotificationBell.defaultProps = {
  fill: '',
  onClick: null,
  hasNotifications: false,
  theme: null,
  title: '',
  width: '2rem'
};
var NotificationBell$1 = styled.withTheme(NotificationBell);var _excluded$Z = ["fill", "onClick", "theme", "title"];
// Component
// =============================

var PaddingTop = /*#__PURE__*/React__default['default'].memo( /*#__PURE__*/React__default['default'].forwardRef(function (_ref, ref) {
  var fill = _ref.fill,
      onClick = _ref.onClick,
      theme = _ref.theme,
      title = _ref.title,
      rest = _objectWithoutProperties$7(_ref, _excluded$Z);

  return /*#__PURE__*/React__default['default'].createElement(Svg$2, _extends$g({
    fill: fill || theme.colors.text,
    onClick: onClick,
    ref: ref,
    title: title,
    viewBox: "0 0 24 22"
  }, rest), /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M19.8,19c0.6,0,1,0.5,1,1c0,0.6-0.5,1-1,1h-7.3c-0.6,0-1-0.5-1-1c0-0.6,0.5-1,1-1H19.8z M23,14c0.5,0,1,0.5,1,1c0,0.6-0.4,1-1,1H12.4c-0.5,0-1-0.5-1-1c0-0.6,0.4-1,1-1H23z M4.6,4.2C4.9,4,5.3,4.1,5.5,4.3l0,0l3.7,3.4c0.2,0.1,0.2,0.4,0.2,0.6c0,0.2-0.1,0.4-0.2,0.6l0,0l-3.7,3.4c-0.1,0.1-0.3,0.2-0.5,0.2c-0.1,0-0.2,0-0.3-0.1c-0.3-0.1-0.5-0.4-0.5-0.7l0,0V9.3H1c-0.6,0-1-0.5-1-1c0-0.6,0.5-1,1-1l0,0h3.1V4.9C4.2,4.6,4.4,4.3,4.6,4.2z M22.3,4.8c0.9,0,1.7,0.8,1.7,1.8l0,0v2.6c0,1-0.8,1.8-1.7,1.8l0,0h-9.2c-0.9,0-1.7-0.8-1.7-1.8l0,0V6.6c0-1,0.8-1.8,1.7-1.8l0,0H22.3z M19.8,0c0.6,0,1,0.5,1,1s-0.5,1-1,1h-7.3c-0.6,0-1-0.5-1-1s0.5-1,1-1H19.8z"
  }));
}));
PaddingTop.propTypes = {
  /** Icon fill color. */
  fill: PropTypes__default['default'].string,

  /** onClick handler. */
  onClick: PropTypes__default['default'].func,

  /** Styled component theme. */
  theme: PropTypes__default['default'].object,
  // eslint-disable-line react/forbid-prop-types

  /** Icon title. */
  title: PropTypes__default['default'].string,

  /** Icon width (passed to Svg via ...rest props). */
  width: PropTypes__default['default'].string
};
PaddingTop.defaultProps = {
  fill: '',
  onClick: null,
  theme: null,
  title: '',
  width: '2rem'
};
var PaddingTop$1 = styled.withTheme(PaddingTop);var _excluded$Y = ["fill", "onClick", "theme", "title"];
// Component
// =============================

var PaddingBottom = /*#__PURE__*/React__default['default'].memo( /*#__PURE__*/React__default['default'].forwardRef(function (_ref, ref) {
  var fill = _ref.fill,
      onClick = _ref.onClick,
      theme = _ref.theme,
      title = _ref.title,
      rest = _objectWithoutProperties$7(_ref, _excluded$Y);

  return /*#__PURE__*/React__default['default'].createElement(Svg$2, _extends$g({
    fill: fill || theme.colors.text,
    onClick: onClick,
    ref: ref,
    title: title,
    viewBox: "0 0 24 22"
  }, rest), /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M19.8,2.1c0.6,0,1-0.5,1-1c0-0.6-0.5-1-1-1h-7.3c-0.6,0-1,0.5-1,1c0,0.6,0.5,1,1,1H19.8z M23,7.1c0.5,0,1-0.5,1-1c0-0.6-0.4-1-1-1H12.4c-0.5,0-1,0.5-1,1c0,0.6,0.4,1,1,1H23z M4.6,16.9c0.3,0.1,0.6,0.1,0.8-0.1l0,0l3.7-3.4c0.2-0.1,0.2-0.4,0.2-0.6c0-0.2-0.1-0.4-0.2-0.6l0,0L5.5,8.8C5.3,8.7,5.2,8.6,5,8.6c-0.1,0-0.2,0-0.3,0.1C4.4,8.8,4.2,9.1,4.2,9.4l0,0v2.4H1c-0.6,0-1,0.5-1,1c0,0.6,0.5,1,1,1l0,0h3.1v2.4C4.2,16.5,4.4,16.8,4.6,16.9z M22.3,16.3c0.9,0,1.7-0.8,1.7-1.8l0,0v-2.6c0-1-0.8-1.8-1.7-1.8l0,0h-9.2c-0.9,0-1.7,0.8-1.7,1.8l0,0v2.6c0,1,0.8,1.8,1.7,1.8l0,0H22.3z M19.8,21.1c0.6,0,1-0.5,1-1s-0.5-1-1-1h-7.3c-0.6,0-1,0.5-1,1s0.5,1,1,1H19.8z"
  }));
}));
PaddingBottom.propTypes = {
  /** Icon fill color. */
  fill: PropTypes__default['default'].string,

  /** onClick handler. */
  onClick: PropTypes__default['default'].func,

  /** Styled component theme. */
  theme: PropTypes__default['default'].object,
  // eslint-disable-line react/forbid-prop-types

  /** Icon title. */
  title: PropTypes__default['default'].string,

  /** Icon width (passed to Svg via ...rest props). */
  width: PropTypes__default['default'].string
};
PaddingBottom.defaultProps = {
  fill: '',
  onClick: null,
  theme: null,
  title: '',
  width: '2rem'
};
var PaddingBottom$1 = styled.withTheme(PaddingBottom);var _excluded$X = ["fill", "onClick", "strokeWidth", "theme", "title"];
// Component
// =============================

var Pause = /*#__PURE__*/React__default['default'].memo( /*#__PURE__*/React__default['default'].forwardRef(function (_ref, ref) {
  var fill = _ref.fill,
      onClick = _ref.onClick;
      _ref.strokeWidth;
      var theme = _ref.theme,
      title = _ref.title,
      rest = _objectWithoutProperties$7(_ref, _excluded$X);

  return /*#__PURE__*/React__default['default'].createElement(Svg$2, _extends$g({
    fill: fill || theme.colors.text,
    onClick: onClick,
    ref: ref,
    title: title,
    viewBox: "0 0 61.5 90"
  }, rest), /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M10.5,0C4.7,0,0,4.7,0,10.5v69.1C0,85.3,4.7,90,10.5,90s10.5-4.7,10.5-10.5V10.5C20.9,4.7,16.2,0,10.5,0z"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M51,0c-5.8,0-10.5,4.7-10.5,10.5v69.1C40.6,85.3,45.2,90,51,90s10.5-4.7,10.5-10.5V10.5C61.5,4.7,56.8,0,51,0z"
  }));
}));
Pause.propTypes = {
  /** Icon fill color. */
  fill: PropTypes__default['default'].string,

  /** onClick handler. */
  onClick: PropTypes__default['default'].func,

  /** Circle stroke width */
  strokeWidth: PropTypes__default['default'].number,

  /** Styled component theme. */
  theme: PropTypes__default['default'].object,
  // eslint-disable-line react/forbid-prop-types

  /** Icon title. */
  title: PropTypes__default['default'].string,

  /** Icon width (passed to Svg via ...rest props). */
  width: PropTypes__default['default'].string
};
Pause.defaultProps = {
  fill: '',
  onClick: null,
  strokeWidth: 2,
  theme: null,
  title: '',
  width: '2rem'
};
var Pause$1 = styled.withTheme(Pause);var _excluded$W = ["fill", "onClick", "strokeWidth", "theme", "title"];
// Component
// =============================

var PauseOutline = /*#__PURE__*/React__default['default'].memo( /*#__PURE__*/React__default['default'].forwardRef(function (_ref, ref) {
  var fill = _ref.fill,
      onClick = _ref.onClick,
      strokeWidth = _ref.strokeWidth,
      theme = _ref.theme,
      title = _ref.title,
      rest = _objectWithoutProperties$7(_ref, _excluded$W);

  return /*#__PURE__*/React__default['default'].createElement(Svg$2, _extends$g({
    fill: fill || theme.colors.text,
    onClick: onClick,
    ref: ref,
    title: title,
    viewBox: "0 0 35 35"
  }, rest), /*#__PURE__*/React__default['default'].createElement("circle", {
    fillOpacity: "0",
    stroke: fill || theme.colors.text,
    strokeWidth: strokeWidth,
    cx: "17.5",
    cy: "17.5",
    r: "16"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    fillRule: "evenodd",
    d: "M14 11.5a1 1 0 0 1 1 1v10a1 1 0 0 1-2 0v-10a1 1 0 0 1 1-1z"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    fillRule: "evenodd",
    d: "M21 11.5a1 1 0 0 1 1 1v10a1 1 0 0 1-2 0v-10a1 1 0 0 1 1-1z"
  }));
}));
PauseOutline.propTypes = {
  /** Icon fill color. */
  fill: PropTypes__default['default'].string,

  /** onClick handler. */
  onClick: PropTypes__default['default'].func,

  /** Circle stroke width */
  strokeWidth: PropTypes__default['default'].number,

  /** Styled component theme. */
  theme: PropTypes__default['default'].object,
  // eslint-disable-line react/forbid-prop-types

  /** Icon title. */
  title: PropTypes__default['default'].string,

  /** Icon width (passed to Svg via ...rest props). */
  width: PropTypes__default['default'].string
};
PauseOutline.defaultProps = {
  fill: '',
  onClick: null,
  strokeWidth: 2,
  theme: null,
  title: '',
  width: '2rem'
};
var PauseOutline$1 = styled.withTheme(PauseOutline);var _excluded$V = ["fill", "onClick", "theme", "title"];
// Component
// =============================

var Phone = /*#__PURE__*/React__default['default'].memo( /*#__PURE__*/React__default['default'].forwardRef(function (_ref, ref) {
  var fill = _ref.fill,
      onClick = _ref.onClick,
      theme = _ref.theme,
      title = _ref.title,
      rest = _objectWithoutProperties$7(_ref, _excluded$V);

  return /*#__PURE__*/React__default['default'].createElement(Svg$2, _extends$g({
    fill: fill || theme.colors.text,
    onClick: onClick,
    ref: ref,
    title: title,
    viewBox: "0 0 24 24"
  }, rest), /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M14.0951413,15.6349113 C14.4032054,15.3281206 14.4032054,15.3281206 14.7731317,14.9599409 C15.1163317,14.6184402 15.3862752,14.3501484 15.5584055,14.1795738 C16.4159492,13.3295924 17.56147,13.3294938 18.4206664,14.1808168 C19.2192385,14.9721538 20.0281636,15.7806602 20.8512189,16.6098537 C21.7205208,17.4858749 21.7149773,18.6321551 20.8422178,19.5129439 C20.669514,19.6872154 20.3865368,19.894573 20.0019452,20.1421931 C19.9161506,20.1974321 19.825983,20.2541691 19.7319282,20.3121915 C19.4786941,20.4684115 19.2084679,20.6272041 18.9383848,20.7806423 C18.7763375,20.8727037 18.6498993,20.9427727 18.5875965,20.9764673 C17.599459,21.5464672 15.9942953,21.6698507 14.9647784,21.2720753 C14.8614213,21.2405943 14.6766481,21.1778192 14.4220106,21.0810773 C14.0027917,20.9218076 13.5370147,20.723256 13.0362318,20.4826964 C11.6078892,19.7965677 10.1801011,18.9099216 8.84594918,17.7999987 C8.31018314,17.3542781 7.79944428,16.8798673 7.31736814,16.3758875 C6.9284306,15.9692783 6.55875984,15.5456445 6.20786053,15.1067398 C5.05253139,13.6616547 4.14534552,12.1151549 3.45741619,10.568148 C3.21626121,10.0258417 3.0195142,9.52148984 2.86369255,9.06761129 C2.76909424,8.79206459 2.70859678,8.59224621 2.69184723,8.52223055 C2.30435126,7.45515271 2.52400923,5.84891368 3.17000571,4.90369599 C3.21037336,4.84121563 3.28113202,4.73403471 3.37427568,4.5968513 C3.52947347,4.36827363 3.69078851,4.13954905 3.85059781,3.92496627 C3.91993582,3.83186316 3.98767271,3.74323545 4.05350549,3.65970437 C4.22237168,3.44544069 4.37565767,3.26834189 4.51326986,3.13294564 C5.37223593,2.28817371 6.51573839,2.28935252 7.37626958,3.13436775 C7.72702882,3.47858681 9.24220738,4.99481829 9.79032511,5.54765555 C10.6773574,6.44300988 10.6793745,7.57473777 9.79346882,8.46502991 C9.66058529,8.59861774 9.37189906,8.88787677 8.97368141,9.28654989 C8.6354708,9.62510736 8.6354708,9.62510736 8.35443476,9.90634569 C8.20942671,10.0514428 8.15794448,10.1029566 8.12458954,10.1363294 C8.18098677,10.2795799 8.27449465,10.5009379 8.4019505,10.7764836 C8.64865991,11.3098424 8.93136877,11.8429334 9.24410871,12.3378039 C9.58490431,12.8770688 9.94045754,13.3365231 10.3035456,13.6905184 C10.6388551,14.0174309 11.0388274,14.3338464 11.4897933,14.6366 C12.0160795,14.9899195 12.5827929,15.3061071 13.149726,15.5795522 C13.4434651,15.7212295 13.6791615,15.8243142 13.839702,15.8893529 C13.8762059,15.8529863 13.9310058,15.7984017 14.0951413,15.6349113 Z M8.10049683,10.0739699 C8.10121625,10.0758739 8.10194551,10.0777993 8.10268457,10.0797459 C8.10210019,10.0779945 8.10131949,10.0760055 8.10049683,10.0739699 Z M20.1414426,17.3142809 C19.32034,16.4870546 18.5133607,15.680493 17.7168033,14.8911525 C17.2474397,14.4260899 16.7301698,14.4261344 16.2623344,14.8898443 C16.090788,15.0598402 15.8212209,15.3277579 15.4805031,15.6667887 C15.1087603,16.0367759 15.1087603,16.0367759 14.8008142,16.343449 C14.5545085,16.5887868 14.5545085,16.5887868 14.4929417,16.6501325 C14.2480285,16.8941224 13.8389019,16.9724005 13.5341822,16.8438945 C13.3660091,16.7786748 13.0801658,16.6562431 12.7152948,16.4802572 C12.1085391,16.1876047 11.5015638,15.8489537 10.9324071,15.4668533 C10.4341357,15.1323415 9.98752928,14.779034 9.60546116,14.4065339 C9.18015,13.9918737 8.77830656,13.4726021 8.3987665,12.8720291 C8.06060401,12.3369307 7.75808447,11.7664836 7.49434352,11.1963045 C7.33581232,10.8535773 7.22465459,10.5851818 7.16881939,10.4371081 C7.04195857,10.1213593 7.12761413,9.71925 7.36612614,9.48060345 C7.42231045,9.42439454 7.42231045,9.42439454 7.64709024,9.19947673 C7.92806542,8.91829931 7.92806542,8.91829931 8.26521961,8.58079945 C8.66383222,8.18173092 8.95229792,7.89269285 9.08455676,7.75973303 C9.58201916,7.25980749 9.58112362,6.75735443 9.08005912,6.25158891 C8.53511196,5.70194958 7.02245021,4.18823666 6.67573637,3.84798753 C6.2038585,3.38461796 5.68405781,3.38408211 5.21453772,3.84584351 C5.11188368,3.94684455 4.983972,4.09462716 4.83890383,4.27869504 C4.77898007,4.35472853 4.71673125,4.43617559 4.65261655,4.52226513 C4.50242958,4.72392761 4.34920558,4.94118009 4.20159753,5.15857948 C4.11305769,5.28898232 4.04641804,5.38992402 4.00282043,5.45709797 C3.52918181,6.1503384 3.35553196,7.42014516 3.64486262,8.2224574 C3.66885669,8.31222813 3.72265697,8.48992622 3.80950662,8.7429026 C3.95609824,9.16989584 4.14224986,9.64708687 4.37114646,10.1618267 C5.02622164,11.6349516 5.89066292,13.1085837 6.98892413,14.4822883 C7.32161347,14.898416 7.67183614,15.2997627 8.04000385,15.6846585 C8.4953444,16.1606878 8.97832751,16.6093172 9.4854973,17.0312476 C10.752169,18.0850315 12.1109776,18.9288419 13.4692318,19.5813025 C13.9437577,19.8092491 14.3836247,19.9967557 14.7771632,20.1462689 C15.0101801,20.2347967 15.1737315,20.2903619 15.2901199,20.3271616 C16.072234,20.6282968 17.3616799,20.5291815 18.0989221,20.1040921 C18.1670797,20.0670333 18.2881901,19.9999168 18.4444196,19.9111606 C18.7047977,19.763236 18.9650328,19.6103144 19.2068959,19.4611092 C19.2956747,19.4063416 19.3804341,19.3530076 19.4605959,19.3013953 C19.786798,19.0913694 20.0253836,18.9165417 20.1318914,18.8090714 C20.6198474,18.3166188 20.6223476,17.798903 20.1414426,17.3142809 Z"
  }));
}));
Phone.propTypes = {
  /** Icon fill color. */
  fill: PropTypes__default['default'].string,

  /** onClick handler. */
  onClick: PropTypes__default['default'].func,

  /** Styled component theme. */
  theme: PropTypes__default['default'].object,
  // eslint-disable-line react/forbid-prop-types

  /** Icon title. */
  title: PropTypes__default['default'].string,

  /** Icon width (passed to Svg via ...rest props). */
  width: PropTypes__default['default'].string
};
Phone.defaultProps = {
  fill: '',
  onClick: null,
  theme: null,
  title: '',
  width: '1.6rem'
};
var Phone$1 = styled.withTheme(Phone);var _excluded$U = ["fill", "onClick", "theme", "title"];
// Component
// =============================

var Picture = /*#__PURE__*/React__default['default'].memo( /*#__PURE__*/React__default['default'].forwardRef(function (_ref, ref) {
  var fill = _ref.fill,
      onClick = _ref.onClick,
      theme = _ref.theme,
      title = _ref.title,
      rest = _objectWithoutProperties$7(_ref, _excluded$U);

  return /*#__PURE__*/React__default['default'].createElement(Svg$2, _extends$g({
    fill: fill || theme.colors.text,
    onClick: onClick,
    ref: ref,
    title: title,
    viewBox: "0 0 30 30"
  }, rest), /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M8.518 6.764a2.632 2.632 0 0 0 0 5.261 2.632 2.632 0 0 0 0-5.26zm9.48 5.715c-.383 0-.775.172-1.025.548l-4.447 6.451c-.23.329-.581.502-.935.502-.32 0-.643-.142-.881-.44l-1.002-1.19a1.022 1.022 0 0 0-.816-.392c-.34 0-.677.158-.875.455l-4.009 5.95h22.36l-7.391-11.398a1.191 1.191 0 0 0-.979-.486zm6.804-10.663c1.816 0 3.32 1.503 3.32 3.32v19.603c0 1.816-1.504 3.32-3.32 3.32H5.198c-1.816 0-3.32-1.504-3.32-3.32V5.136c0-1.817 1.504-3.32 3.32-3.32h19.604zM5.198 0A5.186 5.186 0 0 0 0 5.198v19.604A5.186 5.186 0 0 0 5.198 30h19.604c2.88 0 5.26-2.317 5.198-5.198V5.198A5.186 5.186 0 0 0 24.802 0H5.198z"
  }));
}));
Picture.propTypes = {
  /** Icon fill color. */
  fill: PropTypes__default['default'].string,

  /** onClick handler. */
  onClick: PropTypes__default['default'].func,

  /** Styled component theme. */
  theme: PropTypes__default['default'].object,
  // eslint-disable-line react/forbid-prop-types

  /** Icon title. */
  title: PropTypes__default['default'].string,

  /** Icon width (passed to Svg via ...rest props). */
  width: PropTypes__default['default'].string
};
Picture.defaultProps = {
  fill: '',
  onClick: null,
  theme: null,
  title: '',
  width: '3rem'
};
var Picture$1 = styled.withTheme(Picture);var _excluded$T = ["fill", "onClick", "theme", "title"];
// Component
// =============================

var Playlist = /*#__PURE__*/React__default['default'].memo( /*#__PURE__*/React__default['default'].forwardRef(function (_ref, ref) {
  var fill = _ref.fill,
      onClick = _ref.onClick,
      theme = _ref.theme,
      title = _ref.title,
      rest = _objectWithoutProperties$7(_ref, _excluded$T);

  return /*#__PURE__*/React__default['default'].createElement(Svg$2, _extends$g({
    fill: fill || theme.colors.text,
    onClick: onClick,
    ref: ref,
    title: title,
    viewBox: "0 0 100 100"
  }, rest), /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M72.56,16.13a3.32,3.32,0,0,0-3.23,3.39V58.67a12.26,12.26,0,0,0-6.44-1.9C55.81,56.77,50,62.88,50,70.32s5.81,13.55,12.89,13.55c6.83,0,12.44-5.72,12.82-12.81a3.64,3.64,0,0,0,.07-.74V22.91H91.89a3.21,3.21,0,0,0,2.83-1.68,3.58,3.58,0,0,0,0-3.42,3.21,3.21,0,0,0-2.83-1.68Zm-64.44,9a3.21,3.21,0,0,0-2.84,1.68,3.58,3.58,0,0,0,0,3.42,3.21,3.21,0,0,0,2.83,1.68H59.67a3.18,3.18,0,0,0,2.82-1.68,3.53,3.53,0,0,0,0-3.42,3.18,3.18,0,0,0-2.82-1.68H8.12ZM5.28,44.91a3.19,3.19,0,0,1,2.83-1.68H59.67a3.16,3.16,0,0,1,2.82,1.68,3.51,3.51,0,0,1,0,3.41A3.16,3.16,0,0,1,59.67,50H8.11a3.17,3.17,0,0,1-2.82-1.68,3.51,3.51,0,0,1,0-3.41ZM5.28,63a3.19,3.19,0,0,1,2.83-1.68H40.34A3.19,3.19,0,0,1,43.17,63a3.56,3.56,0,0,1,0,3.41,3.19,3.19,0,0,1-2.83,1.68H8.11a3.17,3.17,0,0,1-2.82-1.68,3.51,3.51,0,0,1,0-3.41Zm57.6.58a6.78,6.78,0,1,1-6.44,6.77A6.57,6.57,0,0,1,62.88,63.55Z"
  }));
}));
Playlist.propTypes = {
  /** Icon fill color. */
  fill: PropTypes__default['default'].string,

  /** onClick handler. */
  onClick: PropTypes__default['default'].func,

  /** Styled component theme. */
  theme: PropTypes__default['default'].object,
  // eslint-disable-line react/forbid-prop-types

  /** Icon title. */
  title: PropTypes__default['default'].string,

  /** Icon width (passed to Svg via ...rest props). */
  width: PropTypes__default['default'].string
};
Playlist.defaultProps = {
  fill: '',
  onClick: null,
  theme: null,
  title: '',
  width: '2rem'
};
var Playlist$1 = styled.withTheme(Playlist);var _excluded$S = ["fill", "onClick", "strokeWidth", "theme", "title"];
// Component
// =============================

var PlayOutline = /*#__PURE__*/React__default['default'].memo( /*#__PURE__*/React__default['default'].forwardRef(function (_ref, ref) {
  var fill = _ref.fill,
      onClick = _ref.onClick,
      strokeWidth = _ref.strokeWidth,
      theme = _ref.theme,
      title = _ref.title,
      rest = _objectWithoutProperties$7(_ref, _excluded$S);

  return /*#__PURE__*/React__default['default'].createElement(Svg$2, _extends$g({
    fill: fill || theme.colors.text,
    onClick: onClick,
    ref: ref,
    title: title,
    viewBox: "0 0 40 40"
  }, rest), /*#__PURE__*/React__default['default'].createElement("circle", {
    fillOpacity: "0",
    stroke: fill || theme.colors.text,
    strokeWidth: strokeWidth,
    cx: "20",
    cy: "20",
    r: "19"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    fillRule: "evenodd",
    d: "M27.218 18.857l-8.705-6.56c-.956-.724-2.312-.04-2.312 1.149v13.108c0 1.188 1.356 1.873 2.312 1.15l8.705-6.561c.774-.555.774-1.718 0-2.286z"
  }));
}));
PlayOutline.propTypes = {
  /** Icon fill color. */
  fill: PropTypes__default['default'].string,

  /** onClick handler. */
  onClick: PropTypes__default['default'].func,

  /** Circle stroke width */
  strokeWidth: PropTypes__default['default'].number,

  /** Styled component theme. */
  theme: PropTypes__default['default'].object,
  // eslint-disable-line react/forbid-prop-types

  /** Icon title. */
  title: PropTypes__default['default'].string,

  /** Icon width (passed to Svg via ...rest props). */
  width: PropTypes__default['default'].string
};
PlayOutline.defaultProps = {
  fill: '',
  onClick: null,
  strokeWidth: 2,
  theme: null,
  title: '',
  width: '2rem'
};
var PlayOutline$1 = styled.withTheme(PlayOutline);var _excluded$R = ["fill", "onClick", "theme", "title"];
// Component
// =============================

var Plus = /*#__PURE__*/React__default['default'].memo( /*#__PURE__*/React__default['default'].forwardRef(function (_ref, ref) {
  var fill = _ref.fill,
      onClick = _ref.onClick,
      theme = _ref.theme,
      title = _ref.title,
      rest = _objectWithoutProperties$7(_ref, _excluded$R);

  return /*#__PURE__*/React__default['default'].createElement(Svg$2, _extends$g({
    fill: fill || theme.colors.text,
    onClick: onClick,
    ref: ref,
    title: title,
    viewBox: "0 0 100 100"
  }, rest), /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M50,12a5,5,0,0,0-5,5V45H17a5,5,0,0,0,0,10H45V83a5,5,0,0,0,10,0V55H83a5,5,0,0,0,0-10H55V17A5,5,0,0,0,50,12Z"
  }));
}));
Plus.propTypes = {
  /** Icon fill color. */
  fill: PropTypes__default['default'].string,

  /** onClick handler. */
  onClick: PropTypes__default['default'].func,

  /** Styled component theme. */
  theme: PropTypes__default['default'].object,
  // eslint-disable-line react/forbid-prop-types

  /** Icon title. */
  title: PropTypes__default['default'].string,

  /** Icon width (passed to Svg via ...rest props). */
  width: PropTypes__default['default'].string
};
Plus.defaultProps = {
  fill: '',
  onClick: null,
  theme: null,
  title: '',
  width: '1.6rem'
};
var Plus$1 = styled.withTheme(Plus);var _excluded$Q = ["fill", "onClick", "strokeWidth", "theme", "title"];
// Component
// =============================

var PlusOutline = /*#__PURE__*/React__default['default'].memo( /*#__PURE__*/React__default['default'].forwardRef(function (_ref, ref) {
  var fill = _ref.fill,
      onClick = _ref.onClick,
      strokeWidth = _ref.strokeWidth,
      theme = _ref.theme,
      title = _ref.title,
      rest = _objectWithoutProperties$7(_ref, _excluded$Q);

  return /*#__PURE__*/React__default['default'].createElement(Svg$2, _extends$g({
    fill: fill || theme.colors.text,
    onClick: onClick,
    ref: ref,
    title: title,
    viewBox: "0 0 20 20"
  }, rest), /*#__PURE__*/React__default['default'].createElement("circle", {
    fillOpacity: "0",
    stroke: fill || theme.colors.text,
    strokeWidth: strokeWidth,
    cx: "10",
    cy: "10",
    r: "9"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    fillRule: "evenodd",
    d: "M9.25,13.5 L9.25,10.75 L6.5,10.75 L6.5,9.25 L9.25,9.25 L9.25,6.5 L10.75,6.5 L10.75,9.25 L13.5,9.25 L13.5,10.75 L10.75,10.75 L10.75,13.5 L9.25,13.5Z"
  }));
}));
PlusOutline.propTypes = {
  /** Icon fill color. */
  fill: PropTypes__default['default'].string,

  /** onClick handler. */
  onClick: PropTypes__default['default'].func,

  /** Circle stroke width */
  strokeWidth: PropTypes__default['default'].number,

  /** Styled component theme. */
  theme: PropTypes__default['default'].object,
  // eslint-disable-line react/forbid-prop-types

  /** Icon title. */
  title: PropTypes__default['default'].string,

  /** Icon width (passed to Svg via ...rest props). */
  width: PropTypes__default['default'].string
};
PlusOutline.defaultProps = {
  fill: '',
  onClick: null,
  strokeWidth: 2,
  theme: null,
  title: '',
  width: '2rem'
};
var PlusOutline$1 = styled.withTheme(PlusOutline);var _excluded$P = ["fill", "onClick", "theme", "title"];
// Component
// =============================

var Previous = /*#__PURE__*/React__default['default'].memo( /*#__PURE__*/React__default['default'].forwardRef(function (_ref, ref) {
  var fill = _ref.fill,
      onClick = _ref.onClick,
      theme = _ref.theme,
      title = _ref.title,
      rest = _objectWithoutProperties$7(_ref, _excluded$P);

  return /*#__PURE__*/React__default['default'].createElement(Svg$2, _extends$g({
    fill: fill || theme.colors.text,
    onClick: onClick,
    ref: ref,
    title: title,
    viewBox: "0 0 8 12"
  }, rest), /*#__PURE__*/React__default['default'].createElement("path", {
    fillRule: "evenodd",
    transform: "matrix(-1 0 0 1 8 0)",
    d: "M6.978.016c-.445.121-.756.668-.756 1.275v4.01L1.156 1.413C.622.988 0 1.473 0 2.263v7.352c0 .79.622 1.276 1.156.911l5.066-3.888v4.07c0 .608.311 1.155.756 1.276C7.51 12.106 8 11.498 8 10.77V1.231C8 .5 7.511-.106 6.978.016z"
  }));
}));
Previous.propTypes = {
  /** Icon fill color. */
  fill: PropTypes__default['default'].string,

  /** onClick handler. */
  onClick: PropTypes__default['default'].func,

  /** Styled component theme. */
  theme: PropTypes__default['default'].object,
  // eslint-disable-line react/forbid-prop-types

  /** Icon title. */
  title: PropTypes__default['default'].string,

  /** Icon width (passed to Svg via ...rest props). */
  width: PropTypes__default['default'].string
};
Previous.defaultProps = {
  fill: '',
  onClick: null,
  theme: null,
  title: '',
  width: '0.8rem'
};
var Previous$1 = styled.withTheme(Previous);var _excluded$O = ["fill", "onClick", "theme", "title"];
// Component
// =============================

var PlusRounded = /*#__PURE__*/React__default['default'].memo( /*#__PURE__*/React__default['default'].forwardRef(function (_ref, ref) {
  var fill = _ref.fill,
      onClick = _ref.onClick,
      theme = _ref.theme,
      title = _ref.title,
      rest = _objectWithoutProperties$7(_ref, _excluded$O);

  return /*#__PURE__*/React__default['default'].createElement(Svg$2, _extends$g({
    fill: fill || theme.colors.text,
    onClick: onClick,
    ref: ref,
    title: title,
    viewBox: "0 0 7 7"
  }, rest), /*#__PURE__*/React__default['default'].createElement("path", {
    fillRule: "evenodd",
    d: "M3.5 0a1 1 0 0 1 1 1v1.5H6a1 1 0 0 1 0 2H4.5V6a1 1 0 0 1-2 0V4.5H1a1 1 0 0 1 0-2h1.5V1a1 1 0 0 1 1-1z"
  }));
}));
PlusRounded.propTypes = {
  /** Icon fill color. */
  fill: PropTypes__default['default'].string,

  /** onClick handler. */
  onClick: PropTypes__default['default'].func,

  /** Styled component theme. */
  theme: PropTypes__default['default'].object,
  // eslint-disable-line react/forbid-prop-types

  /** Icon title. */
  title: PropTypes__default['default'].string,

  /** Icon width (passed to Svg via ...rest props). */
  width: PropTypes__default['default'].string
};
PlusRounded.defaultProps = {
  fill: '',
  onClick: null,
  theme: null,
  title: '',
  width: '0.7rem'
};
var PlusRounded$1 = styled.withTheme(PlusRounded);var _excluded$N = ["fill", "onClick", "theme", "title"];
// Component
// =============================

var Search = /*#__PURE__*/React__default['default'].memo( /*#__PURE__*/React__default['default'].forwardRef(function (_ref, ref) {
  var fill = _ref.fill,
      onClick = _ref.onClick,
      theme = _ref.theme,
      title = _ref.title,
      rest = _objectWithoutProperties$7(_ref, _excluded$N);

  return /*#__PURE__*/React__default['default'].createElement(Svg$2, _extends$g({
    fill: fill || theme.colors.text,
    onClick: onClick,
    ref: ref,
    title: title,
    viewBox: "0 0 307 307"
  }, rest), /*#__PURE__*/React__default['default'].createElement("path", {
    className: "fil0",
    d: "M214 37c-49,-49 -129,-49 -177,0 -49,48 -49,128 0,177 43,43 110,48 161,13l63 71c24,26 63,-13 37,-37l-71 -63c35,-51 30,-118 -13,-161zm-28 149c-34,34 -88,34 -122,0 -34,-34 -34,-88 0,-122 34,-34 88,-34 122,0 34,34 34,88 0,122z"
  }));
}));
Search.propTypes = {
  /** Icon fill color. */
  fill: PropTypes__default['default'].string,

  /** onClick handler. */
  onClick: PropTypes__default['default'].func,

  /** Styled component theme. */
  theme: PropTypes__default['default'].object,
  // eslint-disable-line react/forbid-prop-types

  /** Icon title. */
  title: PropTypes__default['default'].string,

  /** Icon width (passed to Svg via ...rest props). */
  width: PropTypes__default['default'].string
};
Search.defaultProps = {
  fill: '',
  onClick: null,
  theme: null,
  title: '',
  width: '2rem'
};
var Search$1 = styled.withTheme(Search);var _excluded$M = ["fill", "onClick", "theme", "title"];
// Component
// =============================

var SearchMusic = /*#__PURE__*/React__default['default'].memo( /*#__PURE__*/React__default['default'].forwardRef(function (_ref, ref) {
  var fill = _ref.fill,
      onClick = _ref.onClick,
      theme = _ref.theme,
      title = _ref.title,
      rest = _objectWithoutProperties$7(_ref, _excluded$M);

  return /*#__PURE__*/React__default['default'].createElement(Svg$2, _extends$g({
    fill: fill || theme.colors.text,
    onClick: onClick,
    ref: ref,
    title: title,
    viewBox: "0 0 20 20"
  }, rest), /*#__PURE__*/React__default['default'].createElement("path", {
    fillRule: "evenodd",
    d: "M7.044189453125,8.1221923828125 L7.00823974609375,8.1221923828125 L7.00823974609375,6.936208724975586 C7.00823974609375,6.576820373535156 7.25982666015625,6.253368377685547 7.583251953125,6.145551681518555 L10.24273681640625,5.247079849243164 C10.759063720703125,5.074975967407227 11.308349609375,5.430341720581055 11.35382080078125,5.965858459472656 L11.356842041015625,5.965858459472656 L11.356842041015625,9.200359344482422 L11.0693359375,9.200359344482422 C11.249053955078125,9.523809432983398 10.961517333984375,10.06289291381836 10.386505126953125,10.314464569091797 C9.847412109375,10.60197639465332 9.2364501953125,10.566036224365234 9.09271240234375,10.206647872924805 C8.948944091796875,9.847259521484375 9.164581298828125,9.272235870361328 9.775543212890625,9.09254264831543 C10.091888427734375,8.973918914794922 10.3973388671875,8.909675598144531 10.6380615234375,8.935712814331055 L10.6380615234375,6.924230575561523 L7.762969970703125,7.882596969604492 L7.762969970703125,10.997304916381836 L7.635284423828125,10.997304916381836 C7.615325927734375,11.30218505859375 7.343048095703125,11.666189193725586 6.900421142578125,11.859838485717773 C6.361358642578125,12.147350311279297 5.750396728515625,12.111410140991211 5.60662841796875,11.752021789550781 C5.42694091796875,11.428571701049805 5.678497314453125,10.817609786987305 6.289459228515625,10.637916564941406 C6.560272216796875,10.53636360168457 6.8231201171875,10.474666595458984 7.044189453125,10.475347518920898 L7.044189453125,8.1221923828125Z"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    fillRule: "evenodd",
    d: "M2.52154541015625,2.522456169128418 C5.9012451171875,-0.8703699111938477 11.45867919921875,-0.83465576171875 14.885986328125,2.593883514404297 C18.1585693359375,5.867664337158203 18.33709716796875,11.081901550292969 15.40960693359375,14.486631393432617 L19.812713623046875,18.891353607177734 C20.0626220703125,19.1413516998291 20.0626220703125,19.558013916015625 19.812713623046875,19.808013916015625 C19.562835693359375,20.069915771484375 19.14630126953125,20.05801010131836 18.896392822265625,19.808013916015625 L14.4932861328125,15.403289794921875 C11.077880859375,18.343738555908203 5.86553955078125,18.16516876220703 2.59295654296875,14.891389846801758 C-0.8343505859375,11.462848663330078 -0.87005615234375,5.915281295776367 2.52154541015625,2.522456169128418 L2.52154541015625,2.522456169128418ZM3.50927734375,13.986637115478516 C6.424835205078125,16.903276443481445 11.1492919921875,16.93899154663086 14.04107666015625,14.046159744262695 C16.932830810546875,11.165233612060547 16.89715576171875,6.427183151245117 13.9815673828125,3.5105419158935547 C11.06597900390625,0.593902587890625 6.341552734375,0.5700931549072266 3.44976806640625,3.451019287109375 C0.5579833984375,6.331945419311523 0.581787109375,11.05809211730957 3.50927734375,13.986637115478516 L3.50927734375,13.986637115478516Z"
  }));
}));
SearchMusic.propTypes = {
  /** Icon fill color. */
  fill: PropTypes__default['default'].string,

  /** onClick handler. */
  onClick: PropTypes__default['default'].func,

  /** Styled component theme. */
  theme: PropTypes__default['default'].object,
  // eslint-disable-line react/forbid-prop-types

  /** Icon title. */
  title: PropTypes__default['default'].string,

  /** Icon width (passed to Svg via ...rest props). */
  width: PropTypes__default['default'].string
};
SearchMusic.defaultProps = {
  fill: '',
  onClick: null,
  theme: null,
  title: '',
  width: '2rem'
};
var SearchMusic$1 = styled.withTheme(SearchMusic);var _excluded$L = ["fill", "onClick", "theme", "title"];
// Component
// =============================

var Share = /*#__PURE__*/React__default['default'].memo( /*#__PURE__*/React__default['default'].forwardRef(function (_ref, ref) {
  var fill = _ref.fill,
      onClick = _ref.onClick,
      theme = _ref.theme,
      title = _ref.title,
      rest = _objectWithoutProperties$7(_ref, _excluded$L);

  return /*#__PURE__*/React__default['default'].createElement(Svg$2, _extends$g({
    fill: fill || theme.colors.text,
    onClick: onClick,
    ref: ref,
    title: title,
    viewBox: "0 0 100 100"
  }, rest), /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M54.17,22.58V33.33h25a4.17,4.17,0,0,1,4.16,4.17v50a4.17,4.17,0,0,1-4.16,4.17H20.83a4.17,4.17,0,0,1-4.16-4.17v-50a4.17,4.17,0,0,1,4.16-4.17h25V22.56l-4.7,4.71a4.17,4.17,0,0,1-5.9-5.89L47.07,9.54A4.14,4.14,0,0,1,50,8.33l0,0a4.09,4.09,0,0,1,2.9,1.19L64.75,21.38a4.17,4.17,0,0,1-5.89,5.89ZM45.83,41.67V33.33H29.17a4.17,4.17,0,0,1,0,8.34Zm8.34,0H75V33.33H54.17Zm-8.34,0H25V83.33H75V41.67H54.17V62.51a4.17,4.17,0,0,1-8.34,0Zm29.17,0H70.83a4.17,4.17,0,0,1,0-8.34H75Z"
  }));
}));
Share.propTypes = {
  /** Icon fill color. */
  fill: PropTypes__default['default'].string,

  /** onClick handler. */
  onClick: PropTypes__default['default'].func,

  /** Styled component theme. */
  theme: PropTypes__default['default'].object,
  // eslint-disable-line react/forbid-prop-types

  /** Icon title. */
  title: PropTypes__default['default'].string,

  /** Icon width (passed to Svg via ...rest props). */
  width: PropTypes__default['default'].string
};
Share.defaultProps = {
  fill: '',
  onClick: null,
  theme: null,
  title: '',
  width: '2.4rem'
};
var Share$1 = styled.withTheme(Share);var _excluded$K = ["fill", "onClick", "theme", "title"];
// Component
// =============================

var SmApple = /*#__PURE__*/React__default['default'].memo( /*#__PURE__*/React__default['default'].forwardRef(function (_ref, ref) {
  var fill = _ref.fill,
      onClick = _ref.onClick,
      theme = _ref.theme,
      title = _ref.title,
      rest = _objectWithoutProperties$7(_ref, _excluded$K);

  return /*#__PURE__*/React__default['default'].createElement(Svg$2, _extends$g({
    fill: fill || theme.colors.text,
    onClick: onClick,
    ref: ref,
    title: title,
    viewBox: "0 0 24 24"
  }, rest), /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M7.078 23.55c-.473-.316-.893-.703-1.244-1.15-.383-.463-.738-.95-1.064-1.454-.766-1.12-1.365-2.345-1.78-3.636-.5-1.502-.743-2.94-.743-4.347 0-1.57.34-2.94 1.002-4.09.49-.9 1.22-1.653 2.1-2.182.85-.53 1.84-.82 2.84-.84.35 0 .73.05 1.13.15.29.08.64.21 1.07.37.55.21.85.34.95.37.32.12.59.17.8.17.16 0 .39-.05.645-.13.145-.05.42-.14.81-.31.386-.14.692-.26.935-.35.37-.11.728-.21 1.05-.26.39-.06.777-.08 1.148-.05.71.05 1.36.2 1.94.42 1.02.41 1.843 1.05 2.457 1.96-.26.16-.5.346-.725.55-.487.43-.9.94-1.23 1.505-.43.77-.65 1.64-.644 2.52.015 1.083.29 2.035.84 2.86.387.6.904 1.114 1.534 1.536.31.21.582.355.84.45-.12.375-.252.74-.405 1.1-.347.807-.76 1.58-1.25 2.31-.432.63-.772 1.1-1.03 1.41-.402.48-.79.84-1.18 1.097-.43.285-.935.436-1.452.436-.35.015-.7-.03-1.034-.127-.29-.095-.576-.202-.856-.323-.293-.134-.596-.248-.905-.34-.38-.1-.77-.148-1.164-.147-.4 0-.79.05-1.16.145-.31.088-.61.196-.907.325-.42.175-.695.29-.855.34-.324.096-.656.154-.99.175-.52 0-1.004-.15-1.486-.45zm6.854-18.46c-.68.34-1.326.484-1.973.436-.1-.646 0-1.31.27-2.037.24-.62.56-1.18 1-1.68.46-.52 1.01-.95 1.63-1.26.66-.34 1.29-.52 1.89-.55.08.68 0 1.35-.25 2.07-.228.64-.568 1.23-1 1.76-.435.52-.975.95-1.586 1.26z"
  }));
}));
SmApple.propTypes = {
  /** Icon fill color. */
  fill: PropTypes__default['default'].string,

  /** onClick handler. */
  onClick: PropTypes__default['default'].func,

  /** Styled component theme. */
  theme: PropTypes__default['default'].object,
  // eslint-disable-line react/forbid-prop-types

  /** Icon title. */
  title: PropTypes__default['default'].string,

  /** Icon width (passed to Svg via ...rest props). */
  width: PropTypes__default['default'].string
};
SmApple.defaultProps = {
  fill: '',
  onClick: null,
  theme: null,
  title: '',
  width: '2rem'
};
var SmApple$1 = styled.withTheme(SmApple);var _excluded$J = ["fill", "onClick", "theme", "title"];
// Component
// =============================

var SmDeezer = /*#__PURE__*/React__default['default'].memo( /*#__PURE__*/React__default['default'].forwardRef(function (_ref, ref) {
  var fill = _ref.fill,
      onClick = _ref.onClick,
      theme = _ref.theme,
      title = _ref.title,
      rest = _objectWithoutProperties$7(_ref, _excluded$J);

  return /*#__PURE__*/React__default['default'].createElement(Svg$2, _extends$g({
    fill: fill || theme.colors.text,
    onClick: onClick,
    ref: ref,
    title: title,
    viewBox: "0 0 24 24"
  }, rest), /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M18.81 4.16v3.03H24V4.16h-5.19zM6.27 8.38v3.027h5.189V8.38h-5.19zm12.54 0v3.027H24V8.38h-5.19zM6.27 12.594v3.027h5.189v-3.027h-5.19zm6.271 0v3.027h5.19v-3.027h-5.19zm6.27 0v3.027H24v-3.027h-5.19zM0 16.81v3.029h5.19v-3.03H0zm6.27 0v3.029h5.189v-3.03h-5.19zm6.271 0v3.029h5.19v-3.03h-5.19zm6.27 0v3.029H24v-3.03h-5.19Z"
  }));
}));
SmDeezer.propTypes = {
  /** Icon fill color. */
  fill: PropTypes__default['default'].string,

  /** onClick handler. */
  onClick: PropTypes__default['default'].func,

  /** Styled component theme. */
  theme: PropTypes__default['default'].object,
  // eslint-disable-line react/forbid-prop-types

  /** Icon title. */
  title: PropTypes__default['default'].string,

  /** Icon width (passed to Svg via ...rest props). */
  width: PropTypes__default['default'].string
};
SmDeezer.defaultProps = {
  fill: '',
  onClick: null,
  theme: null,
  title: '',
  width: '2rem'
};
var SmDeezer$1 = styled.withTheme(SmDeezer);var _excluded$I = ["fill", "onClick", "theme", "title"];
// Component
// =============================

var SmFacebook = /*#__PURE__*/React__default['default'].memo( /*#__PURE__*/React__default['default'].forwardRef(function (_ref, ref) {
  var fill = _ref.fill,
      onClick = _ref.onClick,
      theme = _ref.theme,
      title = _ref.title,
      rest = _objectWithoutProperties$7(_ref, _excluded$I);

  return /*#__PURE__*/React__default['default'].createElement(Svg$2, _extends$g({
    fill: fill || theme.colors.text,
    onClick: onClick,
    ref: ref,
    title: title,
    viewBox: "0 0 24 24"
  }, rest), /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M23.9981 11.9991C23.9981 5.37216 18.626 0 11.9991 0C5.37216 0 0 5.37216 0 11.9991C0 17.9882 4.38789 22.9522 10.1242 23.8524V15.4676H7.07758V11.9991H10.1242V9.35553C10.1242 6.34826 11.9156 4.68714 14.6564 4.68714C15.9692 4.68714 17.3424 4.92149 17.3424 4.92149V7.87439H15.8294C14.3388 7.87439 13.8739 8.79933 13.8739 9.74824V11.9991H17.2018L16.6698 15.4676H13.8739V23.8524C19.6103 22.9522 23.9981 17.9882 23.9981 11.9991Z"
  }));
}));
SmFacebook.propTypes = {
  /** Icon fill color. */
  fill: PropTypes__default['default'].string,

  /** onClick handler. */
  onClick: PropTypes__default['default'].func,

  /** Styled component theme. */
  theme: PropTypes__default['default'].object,
  // eslint-disable-line react/forbid-prop-types

  /** Icon title. */
  title: PropTypes__default['default'].string,

  /** Icon width (passed to Svg via ...rest props). */
  width: PropTypes__default['default'].string
};
SmFacebook.defaultProps = {
  fill: '',
  onClick: null,
  theme: null,
  title: '',
  width: '2rem'
};
var SmFacebook$1 = styled.withTheme(SmFacebook);var _excluded$H = ["fill", "onClick", "theme", "title"];
// Component
// =============================

var SmInstagram = /*#__PURE__*/React__default['default'].memo( /*#__PURE__*/React__default['default'].forwardRef(function (_ref, ref) {
  var fill = _ref.fill,
      onClick = _ref.onClick,
      theme = _ref.theme,
      title = _ref.title,
      rest = _objectWithoutProperties$7(_ref, _excluded$H);

  return /*#__PURE__*/React__default['default'].createElement(Svg$2, _extends$g({
    fill: fill || theme.colors.text,
    onClick: onClick,
    ref: ref,
    title: title,
    viewBox: "0 0 24 24"
  }, rest), /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M12 0C8.74 0 8.333.015 7.053.072 5.775.132 4.905.333 4.14.63c-.789.306-1.459.717-2.126 1.384S.935 3.35.63 4.14C.333 4.905.131 5.775.072 7.053.012 8.333 0 8.74 0 12s.015 3.667.072 4.947c.06 1.277.261 2.148.558 2.913.306.788.717 1.459 1.384 2.126.667.666 1.336 1.079 2.126 1.384.766.296 1.636.499 2.913.558C8.333 23.988 8.74 24 12 24s3.667-.015 4.947-.072c1.277-.06 2.148-.262 2.913-.558.788-.306 1.459-.718 2.126-1.384.666-.667 1.079-1.335 1.384-2.126.296-.765.499-1.636.558-2.913.06-1.28.072-1.687.072-4.947s-.015-3.667-.072-4.947c-.06-1.277-.262-2.149-.558-2.913-.306-.789-.718-1.459-1.384-2.126C21.319 1.347 20.651.935 19.86.63c-.765-.297-1.636-.499-2.913-.558C15.667.012 15.26 0 12 0zm0 2.16c3.203 0 3.585.016 4.85.071 1.17.055 1.805.249 2.227.415.562.217.96.477 1.382.896.419.42.679.819.896 1.381.164.422.36 1.057.413 2.227.057 1.266.07 1.646.07 4.85s-.015 3.585-.074 4.85c-.061 1.17-.256 1.805-.421 2.227-.224.562-.479.96-.899 1.382-.419.419-.824.679-1.38.896-.42.164-1.065.36-2.235.413-1.274.057-1.649.07-4.859.07-3.211 0-3.586-.015-4.859-.074-1.171-.061-1.816-.256-2.236-.421-.569-.224-.96-.479-1.379-.899-.421-.419-.69-.824-.9-1.38-.165-.42-.359-1.065-.42-2.235-.045-1.26-.061-1.649-.061-4.844 0-3.196.016-3.586.061-4.861.061-1.17.255-1.814.42-2.234.21-.57.479-.96.9-1.381.419-.419.81-.689 1.379-.898.42-.166 1.051-.361 2.221-.421 1.275-.045 1.65-.06 4.859-.06l.045.03zm0 3.678c-3.405 0-6.162 2.76-6.162 6.162 0 3.405 2.76 6.162 6.162 6.162 3.405 0 6.162-2.76 6.162-6.162 0-3.405-2.76-6.162-6.162-6.162zM12 16c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4-1.79 4-4 4zm7.846-10.405c0 .795-.646 1.44-1.44 1.44-.795 0-1.44-.646-1.44-1.44 0-.794.646-1.439 1.44-1.439.793-.001 1.44.645 1.44 1.439z"
  }));
}));
SmInstagram.propTypes = {
  /** Icon fill color. */
  fill: PropTypes__default['default'].string,

  /** onClick handler. */
  onClick: PropTypes__default['default'].func,

  /** Styled component theme. */
  theme: PropTypes__default['default'].object,
  // eslint-disable-line react/forbid-prop-types

  /** Icon title. */
  title: PropTypes__default['default'].string,

  /** Icon width (passed to Svg via ...rest props). */
  width: PropTypes__default['default'].string
};
SmInstagram.defaultProps = {
  fill: '',
  onClick: null,
  theme: null,
  title: '',
  width: '2rem'
};
var SmInstagram$1 = styled.withTheme(SmInstagram);var _excluded$G = ["fill", "onClick", "theme", "title"];
// Component
// =============================

var SmLinkedin = /*#__PURE__*/React__default['default'].memo( /*#__PURE__*/React__default['default'].forwardRef(function (_ref, ref) {
  var fill = _ref.fill,
      onClick = _ref.onClick,
      theme = _ref.theme,
      title = _ref.title,
      rest = _objectWithoutProperties$7(_ref, _excluded$G);

  return /*#__PURE__*/React__default['default'].createElement(Svg$2, _extends$g({
    fill: fill || theme.colors.text,
    onClick: onClick,
    ref: ref,
    title: title,
    viewBox: "0 0 24 24"
  }, rest), /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"
  }));
}));
SmLinkedin.propTypes = {
  /** Icon fill color. */
  fill: PropTypes__default['default'].string,

  /** onClick handler. */
  onClick: PropTypes__default['default'].func,

  /** Styled component theme. */
  theme: PropTypes__default['default'].object,
  // eslint-disable-line react/forbid-prop-types

  /** Icon title. */
  title: PropTypes__default['default'].string,

  /** Icon width (passed to Svg via ...rest props). */
  width: PropTypes__default['default'].string
};
SmLinkedin.defaultProps = {
  fill: '',
  onClick: null,
  theme: null,
  title: '',
  width: '2rem'
};
var SmLinkedin$1 = styled.withTheme(SmLinkedin);var _excluded$F = ["fill", "onClick", "theme", "title"];
// Component
// =============================

var SmSpotify = /*#__PURE__*/React__default['default'].memo( /*#__PURE__*/React__default['default'].forwardRef(function (_ref, ref) {
  var fill = _ref.fill,
      onClick = _ref.onClick,
      theme = _ref.theme,
      title = _ref.title,
      rest = _objectWithoutProperties$7(_ref, _excluded$F);

  return /*#__PURE__*/React__default['default'].createElement(Svg$2, _extends$g({
    fill: fill || theme.colors.text,
    onClick: onClick,
    ref: ref,
    title: title,
    viewBox: "0 0 24 24"
  }, rest), /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M12 0C5.4 0 0 5.4 0 12s5.4 12 12 12 12-5.4 12-12S18.66 0 12 0zm5.521 17.34c-.24.359-.66.48-1.021.24-2.82-1.74-6.36-2.101-10.561-1.141-.418.122-.779-.179-.899-.539-.12-.421.18-.78.54-.9 4.56-1.021 8.52-.6 11.64 1.32.42.18.479.659.301 1.02zm1.44-3.3c-.301.42-.841.6-1.262.3-3.239-1.98-8.159-2.58-11.939-1.38-.479.12-1.02-.12-1.14-.6-.12-.48.12-1.021.6-1.141C9.6 9.9 15 10.561 18.72 12.84c.361.181.54.78.241 1.2zm.12-3.36C15.24 8.4 8.82 8.16 5.16 9.301c-.6.179-1.2-.181-1.38-.721-.18-.601.18-1.2.72-1.381 4.26-1.26 11.28-1.02 15.721 1.621.539.3.719 1.02.419 1.56-.299.421-1.02.599-1.559.3z"
  }));
}));
SmSpotify.propTypes = {
  /** Icon fill color. */
  fill: PropTypes__default['default'].string,

  /** onClick handler. */
  onClick: PropTypes__default['default'].func,

  /** Styled component theme. */
  theme: PropTypes__default['default'].object,
  // eslint-disable-line react/forbid-prop-types

  /** Icon title. */
  title: PropTypes__default['default'].string,

  /** Icon width (passed to Svg via ...rest props). */
  width: PropTypes__default['default'].string
};
SmSpotify.defaultProps = {
  fill: '',
  onClick: null,
  theme: null,
  title: '',
  width: '2rem'
};
var SmSpotify$1 = styled.withTheme(SmSpotify);var _excluded$E = ["fill", "onClick", "theme", "title"];
// Component
// =============================

var SmTwitter = /*#__PURE__*/React__default['default'].memo( /*#__PURE__*/React__default['default'].forwardRef(function (_ref, ref) {
  var fill = _ref.fill,
      onClick = _ref.onClick,
      theme = _ref.theme,
      title = _ref.title,
      rest = _objectWithoutProperties$7(_ref, _excluded$E);

  return /*#__PURE__*/React__default['default'].createElement(Svg$2, _extends$g({
    fill: fill || theme.colors.text,
    onClick: onClick,
    ref: ref,
    title: title,
    viewBox: "0 0 24 24"
  }, rest), /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M23.954 4.569c-.885.389-1.83.654-2.825.775 1.014-.611 1.794-1.574 2.163-2.723-.951.555-2.005.959-3.127 1.184-.896-.959-2.173-1.559-3.591-1.559-2.717 0-4.92 2.203-4.92 4.917 0 .39.045.765.127 1.124C7.691 8.094 4.066 6.13 1.64 3.161c-.427.722-.666 1.561-.666 2.475 0 1.71.87 3.213 2.188 4.096-.807-.026-1.566-.248-2.228-.616v.061c0 2.385 1.693 4.374 3.946 4.827-.413.111-.849.171-1.296.171-.314 0-.615-.03-.916-.086.631 1.953 2.445 3.377 4.604 3.417-1.68 1.319-3.809 2.105-6.102 2.105-.39 0-.779-.023-1.17-.067 2.189 1.394 4.768 2.209 7.557 2.209 9.054 0 13.999-7.496 13.999-13.986 0-.209 0-.42-.015-.63.961-.689 1.8-1.56 2.46-2.548l-.047-.02z"
  }));
}));
SmTwitter.propTypes = {
  /** Icon fill color. */
  fill: PropTypes__default['default'].string,

  /** onClick handler. */
  onClick: PropTypes__default['default'].func,

  /** Styled component theme. */
  theme: PropTypes__default['default'].object,
  // eslint-disable-line react/forbid-prop-types

  /** Icon title. */
  title: PropTypes__default['default'].string,

  /** Icon width (passed to Svg via ...rest props). */
  width: PropTypes__default['default'].string
};
SmTwitter.defaultProps = {
  fill: '',
  onClick: null,
  theme: null,
  title: '',
  width: '2rem'
};
var SmTwitter$1 = styled.withTheme(SmTwitter);var _excluded$D = ["fill", "onClick", "theme", "title"];
// Component
// =============================

var SmYoutube = /*#__PURE__*/React__default['default'].memo( /*#__PURE__*/React__default['default'].forwardRef(function (_ref, ref) {
  var fill = _ref.fill,
      onClick = _ref.onClick,
      theme = _ref.theme,
      title = _ref.title,
      rest = _objectWithoutProperties$7(_ref, _excluded$D);

  return /*#__PURE__*/React__default['default'].createElement(Svg$2, _extends$g({
    fill: fill || theme.colors.text,
    onClick: onClick,
    ref: ref,
    title: title,
    viewBox: "0 0 24 24"
  }, rest), /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M23.495 6.205a3.007 3.007 0 0 0-2.088-2.088c-1.87-.501-9.396-.501-9.396-.501s-7.507-.01-9.396.501A3.007 3.007 0 0 0 .527 6.205a31.247 31.247 0 0 0-.522 5.805 31.247 31.247 0 0 0 .522 5.783 3.007 3.007 0 0 0 2.088 2.088c1.868.502 9.396.502 9.396.502s7.506 0 9.396-.502a3.007 3.007 0 0 0 2.088-2.088 31.247 31.247 0 0 0 .5-5.783 31.247 31.247 0 0 0-.5-5.805zM9.609 15.601V8.408l6.264 3.602z"
  }));
}));
SmYoutube.propTypes = {
  /** Icon fill color. */
  fill: PropTypes__default['default'].string,

  /** onClick handler. */
  onClick: PropTypes__default['default'].func,

  /** Styled component theme. */
  theme: PropTypes__default['default'].object,
  // eslint-disable-line react/forbid-prop-types

  /** Icon title. */
  title: PropTypes__default['default'].string,

  /** Icon width (passed to Svg via ...rest props). */
  width: PropTypes__default['default'].string
};
SmYoutube.defaultProps = {
  fill: '',
  onClick: null,
  theme: null,
  title: '',
  width: '2rem'
};
var SmYoutube$1 = styled.withTheme(SmYoutube);var _excluded$C = ["fill", "onClick", "theme", "title"];
// Component
// =============================

var SpaceBottom = /*#__PURE__*/React__default['default'].memo( /*#__PURE__*/React__default['default'].forwardRef(function (_ref, ref) {
  var fill = _ref.fill,
      onClick = _ref.onClick,
      theme = _ref.theme,
      title = _ref.title,
      rest = _objectWithoutProperties$7(_ref, _excluded$C);

  return /*#__PURE__*/React__default['default'].createElement(Svg$2, _extends$g({
    fill: fill || theme.colors.text,
    onClick: onClick,
    ref: ref,
    title: title,
    viewBox: "0 0 24 24"
  }, rest), /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M19.83,2.1a1,1,0,0,0,0-2.1h-7.3a1,1,0,0,0,0,2.1ZM23,7a1,1,0,0,0,1-1,1,1,0,0,0-1-1H12.44a1,1,0,0,0-1,1,1,1,0,0,0,1,1Zm-3.21,5a1,1,0,0,0,0-2.1h-7.3a1,1,0,0,0,0,2.1ZM4.64,21.93a.79.79,0,0,0,.85-.14h0l3.65-3.4a.79.79,0,0,0,0-1.15h0L5.49,13.82A.78.78,0,0,0,5,13.61a.8.8,0,0,0-.31.07.79.79,0,0,0-.47.72h0v2.36H1a1,1,0,0,0,0,2.1H4.17v2.36A.79.79,0,0,0,4.64,21.93ZM22.32,21A1.77,1.77,0,0,0,24,19.16h0V16.54a1.77,1.77,0,0,0-1.69-1.83H13.17a1.77,1.77,0,0,0-1.69,1.83h0v2.62A1.77,1.77,0,0,0,13.17,21h9.15Z"
  }));
}));
SpaceBottom.propTypes = {
  /** Icon fill color. */
  fill: PropTypes__default['default'].string,

  /** onClick handler. */
  onClick: PropTypes__default['default'].func,

  /** Styled component theme. */
  theme: PropTypes__default['default'].object,
  // eslint-disable-line react/forbid-prop-types

  /** Icon title. */
  title: PropTypes__default['default'].string,

  /** Icon width (passed to Svg via ...rest props). */
  width: PropTypes__default['default'].string
};
SpaceBottom.defaultProps = {
  fill: '',
  onClick: null,
  theme: null,
  title: '',
  width: '2rem'
};
var SpaceBottom$1 = styled.withTheme(SpaceBottom);var _excluded$B = ["fill", "onClick", "theme", "title"];
// Component
// =============================

var SpaceTop = /*#__PURE__*/React__default['default'].memo( /*#__PURE__*/React__default['default'].forwardRef(function (_ref, ref) {
  var fill = _ref.fill,
      onClick = _ref.onClick,
      theme = _ref.theme,
      title = _ref.title,
      rest = _objectWithoutProperties$7(_ref, _excluded$B);

  return /*#__PURE__*/React__default['default'].createElement(Svg$2, _extends$g({
    fill: fill || theme.colors.text,
    onClick: onClick,
    ref: ref,
    title: title,
    viewBox: "0 0 24 24"
  }, rest), /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M19.83,19.9a1,1,0,0,1,0,2.1h-7.3a1,1,0,0,1,0-2.1ZM23,15a1.05,1.05,0,0,1,0,2.1H12.44a1.05,1.05,0,0,1,0-2.1Zm-3.21-5a1,1,0,0,1,0,2.1h-7.3a1,1,0,0,1,0-2.1ZM4.64.06a.79.79,0,0,1,.85.14h0l3.65,3.4a.79.79,0,0,1,0,1.15h0L5.49,8.17A.78.78,0,0,1,5,8.38a.8.8,0,0,1-.31-.07.79.79,0,0,1-.47-.72h0V5.24H1a1,1,0,0,1,0-2.1H4.17V.79A.79.79,0,0,1,4.64.06ZM22.32,1A1.77,1.77,0,0,1,24,2.83h0V5.45a1.77,1.77,0,0,1-1.69,1.83H13.17a1.77,1.77,0,0,1-1.69-1.83h0V2.83A1.77,1.77,0,0,1,13.17,1h9.15Z"
  }));
}));
SpaceTop.propTypes = {
  /** Icon fill color. */
  fill: PropTypes__default['default'].string,

  /** onClick handler. */
  onClick: PropTypes__default['default'].func,

  /** Styled component theme. */
  theme: PropTypes__default['default'].object,
  // eslint-disable-line react/forbid-prop-types

  /** Icon title. */
  title: PropTypes__default['default'].string,

  /** Icon width (passed to Svg via ...rest props). */
  width: PropTypes__default['default'].string
};
SpaceTop.defaultProps = {
  fill: '',
  onClick: null,
  theme: null,
  title: '',
  width: '2rem'
};
var SpaceTop$1 = styled.withTheme(SpaceTop);var _excluded$A = ["fill", "onClick", "theme", "title"];
// Component
// =============================

var Success = /*#__PURE__*/React__default['default'].memo( /*#__PURE__*/React__default['default'].forwardRef(function (_ref, ref) {
  var fill = _ref.fill,
      onClick = _ref.onClick,
      theme = _ref.theme,
      title = _ref.title,
      rest = _objectWithoutProperties$7(_ref, _excluded$A);

  return /*#__PURE__*/React__default['default'].createElement(Svg$2, _extends$g({
    fill: fill || theme.colors.type.success,
    onClick: onClick,
    ref: ref,
    title: title,
    viewBox: "0 0 25 25"
  }, rest), /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M11.33 13.28c.3 0 .602.115.828.345a1.165 1.165 0 0 1 0 1.656L7.47 19.97a1.171 1.171 0 0 1-1.657 0l-1.562-1.563a1.165 1.165 0 0 1 0-1.656c.226-.23.525-.346.825-.346.3 0 .6.116.831.346l.735.734 3.86-3.859c.226-.23.527-.346.828-.346zM8.205 8.593C3.68 8.594 0 12.274 0 16.797S3.68 25 8.205 25c4.516 0 8.204-3.68 8.204-8.203 0-4.524-3.688-8.203-8.204-8.203zM13.549 0c-.5 0-.937.313-1.102.773L10.94 4.922 7.915 7.43c.094-.008.196-.008.29-.008 5.172 0 9.376 4.203 9.376 9.375A9.384 9.384 0 0 1 12.744 25h5.142c2.383 0 5.266-1.633 5.759-4.07l1.258-6.25a5.09 5.09 0 0 0-1.055-4.227 5.063 5.063 0 0 0-3.923-1.86h-2.664l.922-2.859a4.384 4.384 0 0 0-.657-3.937A4.362 4.362 0 0 0 13.98 0h-.43z"
  }));
}));
Success.propTypes = {
  /** Icon fill color. */
  fill: PropTypes__default['default'].string,

  /** onClick handler. */
  onClick: PropTypes__default['default'].func,

  /** Styled component theme. */
  theme: PropTypes__default['default'].object,
  // eslint-disable-line react/forbid-prop-types

  /** Icon title. */
  title: PropTypes__default['default'].string,

  /** Icon width (passed to Svg via ...rest props). */
  width: PropTypes__default['default'].string
};
Success.defaultProps = {
  fill: '',
  onClick: null,
  theme: null,
  title: '',
  width: '2.5rem'
};
var Success$1 = styled.withTheme(Success);var _excluded$z = ["fill", "onClick", "theme", "title"];
// Component
// =============================

var Tag$1 = /*#__PURE__*/React__default['default'].memo( /*#__PURE__*/React__default['default'].forwardRef(function (_ref, ref) {
  var fill = _ref.fill,
      onClick = _ref.onClick,
      theme = _ref.theme,
      title = _ref.title,
      rest = _objectWithoutProperties$7(_ref, _excluded$z);

  return /*#__PURE__*/React__default['default'].createElement(Svg$2, _extends$g({
    fill: fill || theme.colors.text,
    onClick: onClick,
    ref: ref,
    title: title,
    viewBox: "0 0 96 96"
  }, rest), /*#__PURE__*/React__default['default'].createElement("g", null, /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M83.6,13.5l-27.8-2.9c-0.1,0-0.3,0-0.4,0c-2.9,0.1-5.6,1.3-7.7,3.3L14.6,47.1c-5.1,5.2-5.3,13.3-0.3,18.3  l20.3,20.3c2.4,2.4,5.6,3.6,8.9,3.6c3.4,0,6.9-1.4,9.5-4L86,52.3c2.1-2.1,3.2-4.8,3.3-7.7c0-0.1,0-0.3,0-0.4l-2.9-27.8  C86.2,14.9,85.1,13.7,83.6,13.5z M83.1,44.5c0,1.3-0.5,2.4-1.5,3.3L48.4,81c-2.7,2.7-7,2.8-9.5,0.3L18.7,60.9 c-2.5-2.5-2.4-6.8,0.3-9.5l33.1-33.1c0.9-0.8,2.1-1.4,3.3-1.5l25,2.6L83.1,44.5z"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M70.1,41.7c3.2-3.2,3.2-8.5,0-11.8c-1.7-1.6-3.6-2.4-5.9-2.4c-2.3,0-4.4,0.8-5.9,2.4l0,0l0,0  c-1.6,1.7-2.4,3.6-2.4,5.9c0,2.3,0.8,4.4,2.4,5.9c1.7,1.6,3.9,2.4,5.9,2.4C66.3,44.2,68.4,43.3,70.1,41.7z M65.6,37.3 c-0.8,0.8-2.1,0.8-2.9,0c-0.4-0.4-0.6-0.9-0.6-1.5c0-0.5,0.2-1,0.6-1.5l0,0c0.4-0.4,0.9-0.6,1.5-0.6c0.5,0,1,0.2,1.5,0.6  C66.4,35.2,66.4,36.5,65.6,37.3z"
  })));
}));
Tag$1.propTypes = {
  /** Icon fill color. */
  fill: PropTypes__default['default'].string,

  /** onClick handler. */
  onClick: PropTypes__default['default'].func,

  /** Styled component theme. */
  theme: PropTypes__default['default'].object,
  // eslint-disable-line react/forbid-prop-types

  /** Icon title. */
  title: PropTypes__default['default'].string,

  /** Icon width (passed to Svg via ...rest props). */
  width: PropTypes__default['default'].string
};
Tag$1.defaultProps = {
  fill: '',
  onClick: null,
  theme: null,
  title: '',
  width: '1.6rem'
};
var Tag$2 = styled.withTheme(Tag$1);var _excluded$y = ["fill", "onClick", "theme", "title"];
// Component
// =============================

var ThreeDot = /*#__PURE__*/React__default['default'].memo( /*#__PURE__*/React__default['default'].forwardRef(function (_ref, ref) {
  var fill = _ref.fill,
      onClick = _ref.onClick,
      theme = _ref.theme,
      title = _ref.title,
      rest = _objectWithoutProperties$7(_ref, _excluded$y);

  return /*#__PURE__*/React__default['default'].createElement(Svg$2, _extends$g({
    fill: fill || theme.colors.text,
    onClick: onClick,
    ref: ref,
    title: title,
    viewBox: "0 0 100 100"
  }, rest), /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M50,41a9,9,0,1,0,9,9A9,9,0,0,0,50,41Z"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M20,41a9,9,0,1,0,9,9A9,9,0,0,0,20,41Z"
  }), /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M80,41a9,9,0,1,0,9,9A9,9,0,0,0,80,41Z"
  }));
}));
ThreeDot.propTypes = {
  /** Icon fill color. */
  fill: PropTypes__default['default'].string,

  /** onClick handler. */
  onClick: PropTypes__default['default'].func,

  /** Styled component theme. */
  theme: PropTypes__default['default'].object,
  // eslint-disable-line react/forbid-prop-types

  /** Icon title. */
  title: PropTypes__default['default'].string,

  /** Icon width (passed to Svg via ...rest props). */
  width: PropTypes__default['default'].string
};
ThreeDot.defaultProps = {
  fill: '',
  onClick: null,
  theme: null,
  title: '',
  width: '1.8rem'
};
var ThreeDot$1 = styled.withTheme(ThreeDot);var _excluded$x = ["fill", "onClick", "theme", "title"];
// Component
// =============================

var TrashCan = /*#__PURE__*/React__default['default'].memo( /*#__PURE__*/React__default['default'].forwardRef(function (_ref, ref) {
  var fill = _ref.fill,
      onClick = _ref.onClick,
      theme = _ref.theme,
      title = _ref.title,
      rest = _objectWithoutProperties$7(_ref, _excluded$x);

  return /*#__PURE__*/React__default['default'].createElement(Svg$2, _extends$g({
    fill: fill || theme.colors.text,
    onClick: onClick,
    ref: ref,
    title: title,
    viewBox: "0 0 48 48"
  }, rest), /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M34,8 L45.9986107,8 C47.1039475,8 48,8.88772964 48,10 C48,11.1045695 47.1050616,12 45.9986107,12 L42,12 L42,43.5664682 C42,46.0150402 40.2147544,48 38.0098214,48 L9.99017859,48 C7.7864638,48 6,46.0163938 6,43.5664682 L6,12 L2.00138927,12 C0.896052496,12 0,11.1122704 0,10 C0,8.8954305 0.894938439,8 2.00138927,8 L14,8 L14,3.99582624 C14,1.78899235 15.7748666,0 17.99923,0 L30.00077,0 C32.2094838,0 34,1.79652125 34,3.99582624 L34,8 Z M10,43.5664682 C10,43.8950956 10.0944339,44 9.99017859,44 L38.0098214,44 C37.9055256,44 38,43.8950063 38,43.5664682 L38,12 L10,12 L10,43.5664682 Z M30,3.99582624 C30.0002134,4.00002063 18,4 18,4 L18,8 L30,8 L30,3.99582624 Z M14,19.9907951 C14,18.8913093 14.8877296,18 16,18 C17.1045695,18 18,18.8982124 18,19.9907951 L18,36.0092049 C18,37.1086907 17.1122704,38 16,38 C14.8954305,38 14,37.1017876 14,36.0092049 L14,19.9907951 Z M22,19.9907951 C22,18.8913093 22.8877296,18 24,18 C25.1045695,18 26,18.8982124 26,19.9907951 L26,36.0092049 C26,37.1086907 25.1122704,38 24,38 C22.8954305,38 22,37.1017876 22,36.0092049 L22,19.9907951 Z M30,19.9907951 C30,18.8913093 30.8877296,18 32,18 C33.1045695,18 34,18.8982124 34,19.9907951 L34,36.0092049 C34,37.1086907 33.1122704,38 32,38 C30.8954305,38 30,37.1017876 30,36.0092049 L30,19.9907951 Z"
  }));
}));
TrashCan.propTypes = {
  /** Icon fill color. */
  fill: PropTypes__default['default'].string,

  /** onClick handler. */
  onClick: PropTypes__default['default'].func,

  /** Styled component theme. */
  theme: PropTypes__default['default'].object,
  // eslint-disable-line react/forbid-prop-types

  /** Icon title. */
  title: PropTypes__default['default'].string,

  /** Icon width (passed to Svg via ...rest props). */
  width: PropTypes__default['default'].string
};
TrashCan.defaultProps = {
  fill: '',
  onClick: null,
  theme: null,
  title: '',
  width: '1.8rem'
};
var TrashCan$1 = styled.withTheme(TrashCan);var _excluded$w = ["fill", "onClick", "theme", "title"];
// Component
// =============================

var Upload = /*#__PURE__*/React__default['default'].memo( /*#__PURE__*/React__default['default'].forwardRef(function (_ref, ref) {
  var fill = _ref.fill,
      onClick = _ref.onClick,
      theme = _ref.theme,
      title = _ref.title,
      rest = _objectWithoutProperties$7(_ref, _excluded$w);

  return /*#__PURE__*/React__default['default'].createElement(Svg$2, _extends$g({
    fill: fill || theme.colors.text,
    onClick: onClick,
    ref: ref,
    title: title,
    viewBox: "0 0 30 30"
  }, rest), /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M14.997 8.423a.938.938 0 0 0-.641.26l-7.032 6.56a.937.937 0 0 0 1.29 1.36l5.448-5.08v12.373a.937.937 0 1 0 1.876 0V11.523l5.449 5.08a.938.938 0 1 0 1.289-1.36l-7.031-6.56a.938.938 0 0 0-.648-.26zM2.813 0A2.827 2.827 0 0 0 0 2.811v24.364a2.827 2.827 0 0 0 2.813 2.812h7.03a.942.942 0 0 0 .824-.465.937.937 0 0 0-.823-1.41H2.813a.915.915 0 0 1-.938-.937V2.811c0-.535.402-.937.938-.937h24.375c.535 0 .937.402.937.937v24.364a.915.915 0 0 1-.938.938h-7.03a.942.942 0 0 0-.824.464.937.937 0 0 0 .823 1.41h7.032A2.827 2.827 0 0 0 30 27.175V2.811A2.827 2.827 0 0 0 27.187 0H2.813zM15 26.218a.938.938 0 0 0-.938.957v1.875a.937.937 0 1 0 1.875 0v-1.875a.937.937 0 0 0-.937-.957z"
  }));
}));
Upload.propTypes = {
  /** Icon fill color. */
  fill: PropTypes__default['default'].string,

  /** onClick handler. */
  onClick: PropTypes__default['default'].func,

  /** Styled component theme. */
  theme: PropTypes__default['default'].object,
  // eslint-disable-line react/forbid-prop-types

  /** Icon title. */
  title: PropTypes__default['default'].string,

  /** Icon width (passed to Svg via ...rest props). */
  width: PropTypes__default['default'].string
};
Upload.defaultProps = {
  fill: '',
  onClick: null,
  theme: null,
  title: '',
  width: '3rem'
};
var Upload$1 = styled.withTheme(Upload);var _excluded$v = ["fill", "onClick", "theme", "title"];
// Component
// =============================

var Warning = /*#__PURE__*/React__default['default'].memo( /*#__PURE__*/React__default['default'].forwardRef(function (_ref, ref) {
  var fill = _ref.fill,
      onClick = _ref.onClick,
      theme = _ref.theme,
      title = _ref.title,
      rest = _objectWithoutProperties$7(_ref, _excluded$v);

  return /*#__PURE__*/React__default['default'].createElement(Svg$2, _extends$g({
    fill: fill || theme.colors.type.warning,
    onClick: onClick,
    ref: ref,
    title: title,
    viewBox: "0 0 25 21"
  }, rest), /*#__PURE__*/React__default['default'].createElement("path", {
    d: "M12.5 5.893c.553 0 1.001.45 1.001 1.005v6.793c0 .555-.448 1.005-1.002 1.005-.552 0-1-.45-1-1.005V6.898c0-.555.448-1.005 1-1.005h.002zm0 10.362c.553 0 1.001.45 1.001 1.005 0 .555-.448 1.005-1.002 1.005-.552 0-1-.45-1-1.005 0-.555.448-1.005 1-1.005h.002zM12.5 0c-.728 0-1.392.37-1.776.991L.319 17.788a2.084 2.084 0 0 0-.052 2.131A2.065 2.065 0 0 0 2.096 21h20.808c.771 0 1.455-.404 1.83-1.081a2.084 2.084 0 0 0-.053-2.13L14.276.99A2.077 2.077 0 0 0 12.5 0z"
  }));
}));
Warning.propTypes = {
  /** Icon fill color. */
  fill: PropTypes__default['default'].string,

  /** onClick handler. */
  onClick: PropTypes__default['default'].func,

  /** Styled component theme. */
  theme: PropTypes__default['default'].object,
  // eslint-disable-line react/forbid-prop-types

  /** Icon title. */
  title: PropTypes__default['default'].string,

  /** Icon width (passed to Svg via ...rest props). */
  width: PropTypes__default['default'].string
};
Warning.defaultProps = {
  fill: '',
  onClick: null,
  theme: null,
  title: '',
  width: '2.5rem'
};
var Warning$1 = styled.withTheme(Warning);// =============================
var index$1=/*#__PURE__*/Object.freeze({__proto__:null,AddTeammate: AddTeammate$1,Album: Album$1,Artist: Artist$1,ArrowBreadcrumb: ArrowBreadcrumb$1,ArrowDirection: ArrowDirection$1,ArrowDouble: ArrowDouble$1,ArrowDropdown: ArrowDropdown$1,ArrowDropdownOutline: ArrowDropdownOutline$1,ArrowSingle: ArrowSingle$1,ArrowSorting: ArrowSorting$1,AudioFile: AudioFile$1,Autotag: Autotag$1,Camera: Camera$1,Check: Check$1,CheckBox: CheckBox$1,Clipboard: Clipboard$2,Close: Close$1,Clock: Clock$1,ClosePlayer: ClosePlayer$1,Contributors: Contributors$1,Copyright: Copyright$1,CrossBackground: CrossBackground$1,CrossOutline: CrossOutline$1,Description: Description$3,Dot: Dot$1,Draggable: Draggable$1,Duplicate: Duplicate$1,Download: Download$1,Earth: Earth$1,Edit: Edit$1,Email: Email$1,Error: _Error,Error404: Error404$1,ErrorNoResult: ErrorNoResult$1,ExternalLink: ExternalLink$1,Eye: Eye$1,Faq: Faq$1,Filter: Filter$1,FilterOutline: FilterOutline$1,HeadPhone: HeadPhone$1,Heart: Heart$1,Informations: Informations$1,Knowledge: Knowledge$1,LgMeta: LgMeta$1,LgApp: LgApp$1,LgModo: LgModo$1,LgMaia: LgMaia$1,Location: Location$1,Lyrics: Lyrics$1,MagicWand: MagicWand$1,MenuOutline: MenuOutline$1,Microphone: Microphone$1,Next: Next$1,MinusOutline: MinusOutline$1,MinusRounded: MinusRounded$1,NotificationBell: NotificationBell$1,PaddingTop: PaddingTop$1,PaddingBottom: PaddingBottom$1,Pause: Pause$1,PauseOutline: PauseOutline$1,Phone: Phone$1,Picture: Picture$1,Playlist: Playlist$1,PlayOutline: PlayOutline$1,Plus: Plus$1,PlusOutline: PlusOutline$1,Previous: Previous$1,PlusRounded: PlusRounded$1,Search: Search$1,SearchMusic: SearchMusic$1,Share: Share$1,SmApple: SmApple$1,SmDeezer: SmDeezer$1,SmFacebook: SmFacebook$1,SmInstagram: SmInstagram$1,SmLinkedin: SmLinkedin$1,SmSpotify: SmSpotify$1,SmTwitter: SmTwitter$1,SmYoutube: SmYoutube$1,SpaceBottom: SpaceBottom$1,SpaceTop: SpaceTop$1,Success: Success$1,Tag: Tag$2,ThreeDot: ThreeDot$1,TrashCan: TrashCan$1,Upload: Upload$1,Warning: Warning$1});var _templateObject$H, _templateObject2$C, _templateObject3$w, _templateObject4$r, _templateObject5$q, _templateObject6$k, _templateObject7$g;
// Styles
// =============================

var Arrow = styled__default['default'].span(_templateObject$H || (_templateObject$H = _taggedTemplateLiteral$5(["\n  background-color: inherit;\n  border-radius: 0.3rem;\n  height: 1.2rem;\n  font-size: 0.7rem;\n  transform: rotate(45deg);\n  position: absolute;\n  width: 1.2rem;\n"])));
var animations = {
  bottom: styled.keyframes(_templateObject2$C || (_templateObject2$C = _taggedTemplateLiteral$5(["\n    from {\n      top: 0.5rem;\n    }\n\n    to {\n      top: 0;\n    }\n  "]))),
  left: styled.keyframes(_templateObject3$w || (_templateObject3$w = _taggedTemplateLiteral$5(["\n    from {\n      left: -0.5rem;\n    }\n\n    to {\n      left: 0;\n    }\n  "]))),
  right: styled.keyframes(_templateObject4$r || (_templateObject4$r = _taggedTemplateLiteral$5(["\n    from {\n      left: 0.5rem;\n    }\n\n    to {\n      left: 0;\n    }\n  "]))),
  top: styled.keyframes(_templateObject5$q || (_templateObject5$q = _taggedTemplateLiteral$5(["\n    from {\n      top: -0.5rem;\n    }\n\n    to {\n      top: 0;\n    }\n  "])))
};
var Wrapper$v = styled__default['default'](function (props) {
  return /*#__PURE__*/React__default['default'].createElement(Tooltip$4, _extends$g({
    enterDelay: props.enterDelay,
    placement: props.placement,
    TransitionComponent: Fade$1,
    classes: {
      tooltip: 'tooltip',
      popper: "".concat(props.className, " popper")
    }
  }, props));
})(_templateObject6$k || (_templateObject6$k = _taggedTemplateLiteral$5(["\n  & .tooltip {\n    background-color: ", ";\n    border-radius: 1rem;\n    box-shadow: 0 1.5rem 3rem 0 ", ";\n    color: ", ";\n    font-family: ", ";\n    font-size: 1.4rem;\n    font-weight: ", ";\n    line-height: 1.7rem;\n    padding: 2rem;\n    position: relative;\n    max-width: 50rem;\n  }\n\n  &.popper[x-placement^='bottom'] {\n    animation: ", " 300ms ", ";\n  }\n\n  &.popper[x-placement^='left'] {\n    animation: ", " 300ms ", ";\n  }\n\n  &.popper[x-placement^='right'] {\n    animation: ", " 300ms ", ";\n  }\n\n  &.popper[x-placement^='top'] {\n    animation: ", " 300ms ", ";\n  }\n\n  &.popper[x-placement='bottom'] ", " {\n    left: calc(50% - 0.6rem);\n    top: -0.5rem;\n  }\n\n  &.popper[x-placement='bottom-end'] ", " {\n    right: 1.2rem;\n    top: -0.5rem;\n  }\n\n  &.popper[x-placement='bottom-start'] ", " {\n    left: 1.2rem;\n    top: -0.5rem;\n  }\n\n  &.popper[x-placement='left'] ", " {\n    bottom: calc(50% - 0.6rem);\n    right: -0.5rem;\n  }\n\n  &.popper[x-placement='left-end'] ", " {\n    bottom: 0.8rem;\n    right: -0.5rem;\n  }\n\n  &.popper[x-placement='left-start'] ", " {\n    right: -0.5rem;\n    top: 0.8rem;\n  }\n\n  &.popper[x-placement='right'] ", " {\n    left: -0.5rem;\n    top: calc(50% - 0.6rem);\n  }\n\n  &.popper[x-placement='right-end'] ", " {\n    left: -0.5rem;\n    bottom: 0.8rem;\n  }\n\n  &.popper[x-placement='right-start'] ", " {\n    left: -0.5rem;\n    top: 0.8rem;\n  }\n\n  &.popper[x-placement='top'] ", " {\n    bottom: -0.5rem;\n    left: calc(50% - 0.6rem);\n  }\n\n  &.popper[x-placement='top-end'] ", " {\n    bottom: -0.5rem;\n    right: 1.2rem;\n  }\n\n  &.popper[x-placement='top-start'] ", " {\n    bottom: -0.5rem;\n    left: 1.2rem;\n  }\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.colors.tooltip.background;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.tooltip.boxShadow;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.colors.tooltip.text;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.fontFamily.primary;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.fontWeight.semibold;
}, animations.bottom, function (_ref6) {
  var theme = _ref6.theme;
  return theme.transitionTiming.easeOut;
}, animations.left, function (_ref7) {
  var theme = _ref7.theme;
  return theme.transitionTiming.easeOut;
}, animations.right, function (_ref8) {
  var theme = _ref8.theme;
  return theme.transitionTiming.easeOut;
}, animations.top, function (_ref9) {
  var theme = _ref9.theme;
  return theme.transitionTiming.easeOut;
}, Arrow, Arrow, Arrow, Arrow, Arrow, Arrow, Arrow, Arrow, Arrow, Arrow, Arrow, Arrow);
var Content$2 = styled__default['default'].span(_templateObject7$g || (_templateObject7$g = _taggedTemplateLiteral$5([""])));var _excluded$u = ["children", "className", "content", "interactive", "placement", "withArrow"];
// Component
// =============================

function getTitle(content, withArrow) {
  return /*#__PURE__*/React__default['default'].createElement(React__default['default'].Fragment, null, content, withArrow && /*#__PURE__*/React__default['default'].createElement(Arrow, {
    className: "arrow"
  }));
}

var Tooltip$2 = /*#__PURE__*/React__default['default'].memo( /*#__PURE__*/React__default['default'].forwardRef(function (_ref, ref) {
  var children = _ref.children,
      className = _ref.className,
      content = _ref.content,
      interactive = _ref.interactive,
      placement = _ref.placement,
      withArrow = _ref.withArrow,
      rest = _objectWithoutProperties$7(_ref, _excluded$u);

  return /*#__PURE__*/React__default['default'].createElement(Wrapper$v, _extends$g({
    className: className,
    interactive: interactive,
    placement: placement,
    title: getTitle(content, withArrow)
  }, rest), /*#__PURE__*/React__default['default'].createElement(Content$2, {
    ref: ref
  }, children));
}));
Tooltip$2.propTypes = {
  /** Element that will triger tooltip */
  children: PropTypes__default['default'].node.isRequired,

  /** Props used by styled component to override styles. */
  className: PropTypes__default['default'].string,

  /** Tooltip's content */
  content: PropTypes__default['default'].node.isRequired,

  /**
   * Makes a tooltip interactive, i.e. will not close when the
   * user hovers over the tooltip before the leaveDelay is expired.
   */
  interactive: PropTypes__default['default'].bool,

  /** Tooltip placement */
  placement: PropTypes__default['default'].oneOf(['bottom-end', 'bottom-start', 'bottom', 'left-end', 'left-start', 'left', 'right-end', 'right-start', 'right', 'top-end', 'top-start', 'top']),

  /** If True, will show arrow pointing on element . */
  withArrow: PropTypes__default['default'].bool
};
Tooltip$2.defaultProps = {
  className: '',
  interactive: false,
  placement: 'bottom-end',
  withArrow: false
};var _templateObject$G, _templateObject2$B;
// Styles
// =============================

var Wrapper$u = styled__default['default'](Div)(_templateObject$G || (_templateObject$G = _taggedTemplateLiteral$5(["\n  display: inline-flex;\n"])));
var InformationsIcon = styled__default['default'](Informations$1).attrs(function (_ref) {
  var color = _ref.color,
      theme = _ref.theme;
  return {
    fill: color === 'primary' ? theme.colors.primary : theme.colors.type[color]
  };
})(_templateObject2$B || (_templateObject2$B = _taggedTemplateLiteral$5([""])));var _excluded$t = ["className", "color", "content", "interactive", "placement", "width"];
// Component
// =============================

var InfoTooltip = /*#__PURE__*/function (_PureComponent) {
  _inherits$e(InfoTooltip, _PureComponent);

  var _super = _createSuper$1(InfoTooltip);

  function InfoTooltip() {
    _classCallCheck$k(this, InfoTooltip);

    return _super.apply(this, arguments);
  }

  _createClass$g(InfoTooltip, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          className = _this$props.className,
          color = _this$props.color,
          content = _this$props.content,
          interactive = _this$props.interactive,
          placement = _this$props.placement,
          width = _this$props.width,
          rest = _objectWithoutProperties$7(_this$props, _excluded$t);

      return /*#__PURE__*/React__default['default'].createElement(Wrapper$u, _extends$g({
        className: className
      }, getViewProps(rest)), /*#__PURE__*/React__default['default'].createElement(Tooltip$2, {
        content: content,
        interactive: interactive,
        placement: placement
      }, /*#__PURE__*/React__default['default'].createElement(InformationsIcon, {
        color: color,
        width: width
      })));
    }
  }]);

  return InfoTooltip;
}(React.PureComponent);

_defineProperty$8(InfoTooltip, "propTypes", {
  /** Props used by styled component to override styles. */
  className: PropTypes__default['default'].string,

  /** Tooltip's content */
  content: PropTypes__default['default'].node.isRequired,

  /**
   * Makes a tooltip interactive, i.e. will not close
   * when the user hovers over the tooltip before the leaveDelay is expired.
   */
  interactive: PropTypes__default['default'].bool,

  /** Color of Tooltip Icon */
  color: PropTypes__default['default'].oneOf(['primary', 'cancel', 'warning', 'error', 'success']),

  /** Tooltip placement */
  placement: PropTypes__default['default'].oneOf(['bottom-end', 'bottom-start', 'bottom', 'left-end', 'left-start', 'left', 'right-end', 'right-start', 'right', 'top-end', 'top-start', 'top']),

  /** Info icon width */
  width: PropTypes__default['default'].string
});

_defineProperty$8(InfoTooltip, "defaultProps", {
  className: '',
  color: 'primary',
  interactive: false,
  placement: 'top',
  width: '1.5rem'
});var _templateObject$F, _templateObject2$A;
// Styles
// =============================

var Wrapper$t = styled__default['default'](Div)(_templateObject$F || (_templateObject$F = _taggedTemplateLiteral$5(["\n  cursor: pointer;\n  display: flex;\n  line-height: 0;\n  transition: opacity ", ";\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.transition.fast;
});
var CloseIcon = styled__default['default'](CrossBackground$1).attrs(function (_ref2) {
  var hovered = _ref2.hovered,
      theme = _ref2.theme;
  return {
    backgroundColor: hovered ? theme.colors.type.error : theme.colors.input.helpers.background,
    fill: hovered ? theme.colors.white : theme.colors.input.helpers.text
  };
})(_templateObject2$A || (_templateObject2$A = _taggedTemplateLiteral$5(["\n  align-items: center;\n  height: 2rem;\n"])));var _excluded$s = ["className", "disabled", "onClick"];
// Component
// =============================

var ResetBtn = /*#__PURE__*/function (_PureComponent) {
  _inherits$e(ResetBtn, _PureComponent);

  var _super = _createSuper$1(ResetBtn);

  function ResetBtn(props) {
    var _this;

    _classCallCheck$k(this, ResetBtn);

    _this = _super.call(this, props);

    _defineProperty$8(_assertThisInitialized$1(_this), "handleMouseEnter", function () {
      _this.setState({
        hovered: true
      });
    });

    _defineProperty$8(_assertThisInitialized$1(_this), "handleMouseLeave", function () {
      _this.setState({
        hovered: false
      });
    });

    _this.state = {
      hovered: false
    };
    _this.wrapperRef = /*#__PURE__*/React__default['default'].createRef();
    return _this;
  }

  _createClass$g(ResetBtn, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      // Start listening to mouseenter & mouseleave when component mounts
      this.wrapperRef.current.addEventListener('mouseenter', this.handleMouseEnter);
      this.wrapperRef.current.addEventListener('mouseleave', this.handleMouseLeave);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      // Stop listening to mouseenter & mouseleave when component unmounts
      this.wrapperRef.current.removeEventListener('mouseenter', this.handleMouseEnter);
      this.wrapperRef.current.removeEventListener('mouseleave', this.handleMouseLeave);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          className = _this$props.className,
          disabled = _this$props.disabled,
          onClick = _this$props.onClick,
          rest = _objectWithoutProperties$7(_this$props, _excluded$s);

      var hovered = this.state.hovered;
      return /*#__PURE__*/React__default['default'].createElement(Wrapper$t, _extends$g({
        className: className,
        disabled: disabled,
        onClick: disabled ? null : onClick,
        ref: this.wrapperRef
      }, getViewProps(rest)), /*#__PURE__*/React__default['default'].createElement(CloseIcon, {
        hovered: hovered
      }));
    }
  }]);

  return ResetBtn;
}(React.PureComponent);

_defineProperty$8(ResetBtn, "propTypes", {
  className: PropTypes__default['default'].string,
  disabled: PropTypes__default['default'].bool,
  onClick: PropTypes__default['default'].func
});

_defineProperty$8(ResetBtn, "defaultProps", {
  className: '',
  disabled: false,
  onClick: null
});var _templateObject$E, _templateObject2$z, _templateObject3$v, _templateObject4$q, _templateObject5$p, _templateObject6$j, _templateObject7$f, _templateObject8$f, _templateObject9$a;
// Styles
// =============================

var Wrapper$s = styled__default['default'].div(_templateObject$E || (_templateObject$E = _taggedTemplateLiteral$5(["\n  align-items: center;\n  display: flex;\n  flex-grow: 0;\n  flex-shrink: 0;\n  justify-content: flex-end;\n  margin-left: 0.8rem;\n  max-width: 100%;\n"])));
var SearchIcon = styled__default['default'](Search$1).attrs(function (_ref) {
  var theme = _ref.theme;
  return {
    fill: theme.colors.input.helpers.background,
    width: '1.5rem' // Same as InfoTooltip & ResetBtn

  };
})(_templateObject2$z || (_templateObject2$z = _taggedTemplateLiteral$5(["\n  align-items: center;\n  height: 2rem;\n"])));
var MusicSearchIcon = styled__default['default'](SearchMusic$1).attrs(function (_ref2) {
  var theme = _ref2.theme;
  return {
    fill: theme.colors.input.helpers.background,
    width: '1.5rem' // Same as InfoTooltip & ResetBtn

  };
})(_templateObject3$v || (_templateObject3$v = _taggedTemplateLiteral$5(["\n  align-items: center;\n  height: 2rem;\n"])));
var EarthIcon = styled__default['default'](Earth$1).attrs(function (_ref3) {
  var theme = _ref3.theme;
  return {
    fill: theme.colors.input.helpers.background,
    width: '1.5rem' // Same as InfoTooltip & ResetBtn

  };
})(_templateObject4$q || (_templateObject4$q = _taggedTemplateLiteral$5(["\n  align-items: center;\n  height: 2rem;\n"])));
var WarningIcon = styled__default['default'](Warning$1).attrs(function (_ref4) {
  var theme = _ref4.theme;
  return {
    fill: theme.colors.type.error,
    width: '1.5rem' // Same as InfoTooltip & ResetBtn

  };
})(_templateObject5$p || (_templateObject5$p = _taggedTemplateLiteral$5(["\n  align-items: center;\n  height: 2rem;\n"])));
var StyledTooltip = styled__default['default'](Tooltip$2).attrs(function (_ref5) {
  var placement = _ref5.placement;
  return {
    placement: placement
  };
})(_templateObject6$j || (_templateObject6$j = _taggedTemplateLiteral$5(["\n  align-items: center;\n  height: 2rem;\n  line-height: 0;\n\n  &:not(:last-child) {\n    margin-right: 0.4rem;\n  }\n"])));
var StyledInfoTooltip = styled__default['default'](InfoTooltip).attrs(function (_ref6) {
  var placement = _ref6.placement;
  return {
    placement: placement
  };
})(_templateObject7$f || (_templateObject7$f = _taggedTemplateLiteral$5(["\n  align-items: center;\n  height: 2rem;\n  line-height: 0;\n\n  &:not(:last-child) {\n    margin-right: 0.4rem;\n  }\n"])));
var StyledResetButton = styled__default['default'](ResetBtn)(_templateObject8$f || (_templateObject8$f = _taggedTemplateLiteral$5(["\n  &:not(:last-child) {\n    margin-right: 0.4rem;\n  }\n"])));
var ItemActionBtn = styled__default['default'](ExternalLink$1).attrs(function (_ref7) {
  var theme = _ref7.theme;
  return {
    fill: theme.colors.input.helpers.background,
    width: '1.4rem' // Same as InfoTooltip & ResetBtn

  };
})(_templateObject9$a || (_templateObject9$a = _taggedTemplateLiteral$5(["\n  align-items: center;\n  height: 2rem;\n\n  &:not(:last-child) {\n    margin-right: 0.4rem;\n  }\n"])));// Component
// =============================

var Helpers = /*#__PURE__*/function (_PureComponent) {
  _inherits$e(Helpers, _PureComponent);

  var _super = _createSuper$1(Helpers);

  function Helpers() {
    var _this;

    _classCallCheck$k(this, Helpers);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty$8(_assertThisInitialized$1(_this), "renderHelpers", function () {});

    return _this;
  }

  _createClass$g(Helpers, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          additionalHelpers = _this$props.additionalHelpers,
          className = _this$props.className,
          disabled = _this$props.disabled,
          dropdownIndicator = _this$props.dropdownIndicator,
          isMusicSearch = _this$props.isMusicSearch,
          isSearch = _this$props.isSearch,
          isSearchMessage = _this$props.isSearchMessage,
          itemAction = _this$props.itemAction,
          isTranslatable = _this$props.isTranslatable,
          isTranslatableMessage = _this$props.isTranslatableMessage,
          onResetBtn = _this$props.onResetBtn,
          tooltipError = _this$props.tooltipError,
          tooltipInteractive = _this$props.tooltipInteractive,
          tooltipMessage = _this$props.tooltipMessage,
          tooltipPlacement = _this$props.tooltipPlacement; // If no helper are being used, return null.

      if (!dropdownIndicator && !isSearch && !itemAction && !isTranslatable && !onResetBtn && !tooltipError && !tooltipMessage && !additionalHelpers) return null;
      return /*#__PURE__*/React__default['default'].createElement(Wrapper$s, {
        className: className
      }, additionalHelpers, tooltipError && /*#__PURE__*/React__default['default'].createElement(StyledTooltip, {
        content: tooltipError,
        interactive: true,
        placement: tooltipPlacement
      }, /*#__PURE__*/React__default['default'].createElement(WarningIcon, null)), tooltipMessage && /*#__PURE__*/React__default['default'].createElement(StyledInfoTooltip, {
        content: tooltipMessage,
        interactive: tooltipInteractive,
        placement: tooltipPlacement
      }), isTranslatable && /*#__PURE__*/React__default['default'].createElement(StyledTooltip, {
        content: isTranslatableMessage,
        placement: tooltipPlacement
      }, /*#__PURE__*/React__default['default'].createElement(EarthIcon, null)), isSearch && /*#__PURE__*/React__default['default'].createElement(StyledTooltip, {
        content: isSearchMessage,
        placement: tooltipPlacement
      }, isMusicSearch && /*#__PURE__*/React__default['default'].createElement(MusicSearchIcon, null), !isMusicSearch && /*#__PURE__*/React__default['default'].createElement(SearchIcon, null)), itemAction && /*#__PURE__*/React__default['default'].createElement(ItemActionBtn, {
        onClick: function onClick(e) {
          e.stopPropagation();
          itemAction();
        }
      }), onResetBtn && /*#__PURE__*/React__default['default'].createElement(StyledResetButton, {
        disabled: disabled,
        onClick: function onClick(e) {
          e.stopPropagation();
          onResetBtn();
        }
      }), dropdownIndicator && /*#__PURE__*/React__default['default'].createElement(DropdownIndicator, {
        open: dropdownIndicator.opened,
        onClick: function onClick(e) {
          e.stopPropagation();
          dropdownIndicator.onClick();
        }
      }));
    }
  }]);

  return Helpers;
}(React.PureComponent);

_defineProperty$8(Helpers, "propTypes", {
  /** Node that will be rendered next to all helpers. */
  additionalHelpers: PropTypes__default['default'].node,

  /** Props used by styled component to override styles. */
  className: PropTypes__default['default'].string,

  /** If true, the input will be disabled. */
  disabled: PropTypes__default['default'].bool,

  /** Show dropdown indicator. */
  dropdownIndicator: PropTypes__default['default'].shape({
    opened: PropTypes__default['default'].bool.isRequired,
    onClick: PropTypes__default['default'].func.isRequired
  }),

  /** If True, icon will be music search. */
  isMusicSearch: PropTypes__default['default'].bool,

  /** If True, will show user this input is a search input. */
  isSearch: PropTypes__default['default'].bool,

  /** Message show in isSearch tooltip. */
  isSearchMessage: PropTypes__default['default'].string,

  /** If True, will show user this input is translatable. */
  isTranslatable: PropTypes__default['default'].bool,

  /** Message show in isTranslatable tooltip. */
  isTranslatableMessage: PropTypes__default['default'].string,

  /** Function that will be executed when clicking on the ItemActionBtn. */
  itemAction: PropTypes__default['default'].func,

  /** Callback function for reset button */
  onResetBtn: PropTypes__default['default'].func,

  /** Used to display error messsage as tooltip. */
  tooltipError: PropTypes__default['default'].string,

  /** If True, Tooltip will be interactive. */
  tooltipInteractive: PropTypes__default['default'].bool,

  /** If set, will add an InfoTooltip btn on input with tooltipMessage as content. */
  tooltipMessage: PropTypes__default['default'].node,

  /** Tooltip placement */
  tooltipPlacement: PropTypes__default['default'].oneOf(['bottom-end', 'bottom-start', 'bottom', 'left-end', 'left-start', 'left', 'right-end', 'right-start', 'right', 'top-end', 'top-start', 'top'])
});

_defineProperty$8(Helpers, "defaultProps", {
  additionalHelpers: null,
  className: '',
  disabled: false,
  dropdownIndicator: null,
  isMusicSearch: false,
  isSearch: false,
  isSearchMessage: '',
  itemAction: null,
  isTranslatable: false,
  isTranslatableMessage: '',
  onResetBtn: null,
  tooltipError: '',
  tooltipInteractive: false,
  tooltipMessage: '',
  tooltipPlacement: 'bottom'
});var _templateObject$D, _templateObject2$y;
// Styles
// =============================

var Wrapper$r = styled__default['default'](Div).attrs({
  as: 'input'
})(_templateObject$D || (_templateObject$D = _taggedTemplateLiteral$5(["\n  ", ";\n  background-color: transparent;\n  border: 0;\n  color: ", ";\n  display: flex;\n  flex: 1 1 auto;\n  font-family: ", ";\n  font-size: inherit;\n  font-weight: inherit;\n  outline: none;\n  width: 100%;\n\n  &:invalid {\n    border: 0;\n    box-shadow: none;\n  }\n\n  &:focus {\n    outline: none;\n  }\n\n  &::-webkit-input-placeholder {\n    color: inherit;\n    font-style: italic;\n    font-weight: inherit;\n    opacity: 0;\n    transition: opacity ", ";\n  }\n\n  &:-moz-placeholder {\n    color: inherit;\n    font-style: italic;\n    font-weight: inherit;\n    opacity: 0;\n    transition: opacity ", ";\n  }\n\n  &::-moz-placeholder {\n    color: inherit;\n    font-style: italic;\n    font-weight: inherit;\n    opacity: 0;\n    transition: opacity ", ";\n  }\n\n  &:-ms-input-placeholder {\n    color: inherit;\n    font-style: italic;\n    font-weight: inherit;\n    opacity: 0;\n    transition: opacity ", ";\n  }\n\n  ", ";\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.helpers.textEllipsis;
}, function (_ref2) {
  var error = _ref2.error,
      theme = _ref2.theme;
  return error ? theme.colors.type.error : theme.colors.input.text;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.fontFamily.primary;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.transition.medium;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.transition.medium;
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.transition.medium;
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.transition.medium;
}, function (_ref8) {
  var showPlaceholder = _ref8.showPlaceholder;
  return showPlaceholder && styled.css(_templateObject2$y || (_templateObject2$y = _taggedTemplateLiteral$5(["\n      &::-webkit-input-placeholder {\n        opacity: 0.6;\n      }\n\n      &:-moz-placeholder {\n        opacity: 0.6;\n      }\n\n      &::-moz-placeholder {\n        opacity: 0.6;\n      }\n\n      &:-ms-input-placeholder {\n        opacity: 0.6;\n      }\n    "])));
});var _excluded$r = ["autoComplete", "className", "disabled", "error", "innerRef", "name", "onBlur", "onChange", "onFocus", "onKeyDown", "placeholder", "readOnly", "showPlaceholder", "type", "value"];
// Component
// =============================

var InputBase$1 = /*#__PURE__*/function (_PureComponent) {
  _inherits$e(InputBase, _PureComponent);

  var _super = _createSuper$1(InputBase);

  function InputBase() {
    _classCallCheck$k(this, InputBase);

    return _super.apply(this, arguments);
  }

  _createClass$g(InputBase, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          autoComplete = _this$props.autoComplete,
          className = _this$props.className,
          disabled = _this$props.disabled,
          error = _this$props.error,
          innerRef = _this$props.innerRef,
          name = _this$props.name,
          onBlur = _this$props.onBlur,
          onChange = _this$props.onChange,
          onFocus = _this$props.onFocus,
          onKeyDown = _this$props.onKeyDown,
          placeholder = _this$props.placeholder,
          readOnly = _this$props.readOnly,
          showPlaceholder = _this$props.showPlaceholder,
          type = _this$props.type,
          value = _this$props.value,
          rest = _objectWithoutProperties$7(_this$props, _excluded$r);

      return /*#__PURE__*/React__default['default'].createElement(Wrapper$r, _extends$g({}, getViewProps(rest), {
        autoComplete: autoComplete,
        className: className,
        disabled: disabled,
        error: error,
        name: name,
        onBlur: onBlur,
        onChange: onChange,
        onFocus: onFocus,
        onKeyDown: onKeyDown,
        placeholder: placeholder,
        readOnly: readOnly,
        ref: innerRef,
        showPlaceholder: showPlaceholder,
        type: type,
        value: value
      }));
    }
  }]);

  return InputBase;
}(React.PureComponent);

_defineProperty$8(InputBase$1, "propTypes", {
  /** autoComplete pass through */
  autoComplete: PropTypes__default['default'].string,

  /** Props used by styled component to override styles. */
  className: PropTypes__default['default'].string,

  /** If true, the input will be disabled. */
  disabled: PropTypes__default['default'].bool,

  /** If true, the input will indicate an error. */
  error: PropTypes__default['default'].bool,

  /** Used to pass ref to parent */
  innerRef: PropTypes__default['default'].oneOfType([PropTypes__default['default'].func, PropTypes__default['default'].object]),

  /** Name attribute of the input element. */
  name: PropTypes__default['default'].string,

  /** onBlur handler */
  onBlur: PropTypes__default['default'].func,

  /** onChange handler */
  onChange: PropTypes__default['default'].func,

  /** onFocus handler */
  onFocus: PropTypes__default['default'].func,

  /** onkeyDown handler */
  onKeyDown: PropTypes__default['default'].func,

  /** The short hint displayed in the input before the user enters a value. */
  placeholder: PropTypes__default['default'].string,

  /** If True, input will be read only. */
  readOnly: PropTypes__default['default'].bool,

  /** If True, placeholder is shown */
  showPlaceholder: PropTypes__default['default'].bool,

  /** Type of the input element. It should be a valid HTML5 input type. */
  type: PropTypes__default['default'].string,

  /** value */
  value: PropTypes__default['default'].oneOfType([PropTypes__default['default'].string, PropTypes__default['default'].number])
});

_defineProperty$8(InputBase$1, "defaultProps", {
  autoComplete: undefined,
  className: '',
  disabled: false,
  error: false,
  innerRef: null,
  name: '',
  onBlur: null,
  onChange: null,
  onFocus: null,
  onKeyDown: null,
  placeholder: '',
  readOnly: false,
  showPlaceholder: true,
  type: 'text',
  value: undefined
});

var InputBase$2 = /*#__PURE__*/React__default['default'].forwardRef(function (props, ref) {
  return /*#__PURE__*/React__default['default'].createElement(InputBase$1, _extends$g({
    innerRef: ref
  }, props));
});var _templateObject$C, _templateObject2$x, _templateObject3$u;
// Styles
// =============================

var Wrapper$q = styled__default['default'](Div)(_templateObject$C || (_templateObject$C = _taggedTemplateLiteral$5(["\n  align-items: center;\n  display: flex;\n  flex: 1 0 auto;\n  max-width: 100%;\n"])));
var StyledInput$2 = styled__default['default'](InputBase$2)(_templateObject2$x || (_templateObject2$x = _taggedTemplateLiteral$5([""])));
var Prefix = styled__default['default'].div(_templateObject3$u || (_templateObject3$u = _taggedTemplateLiteral$5(["\n  flex-shrink: 0;\n  margin-right: 0.4rem;\n"])));var _excluded$q = ["autoComplete", "className", "disabled", "dropdownIndicator", "error", "getRef", "inputClassName", "isMusicSearch", "isSearch", "isSearchMessage", "isTranslatable", "isTranslatableMessage", "itemAction", "name", "onResetBtn", "placeholder", "readOnly", "showPlaceholder", "suffix", "tooltipError", "tooltipInteractive", "tooltipMessage", "tooltipPlacement", "value"];
// Component
// =============================

var Input$1 = /*#__PURE__*/function (_PureComponent) {
  _inherits$e(Input, _PureComponent);

  var _super = _createSuper$1(Input);

  function Input(props) {
    var _this;

    _classCallCheck$k(this, Input);

    _this = _super.call(this, props);

    _defineProperty$8(_assertThisInitialized$1(_this), "setInputRef", function (element) {
      var getInputRef = _this.props.getInputRef;
      _this.wrapperRef = element;
      if (getInputRef) getInputRef(element);
    });

    _defineProperty$8(_assertThisInitialized$1(_this), "setWrapperRef", function (element) {
      var getRef = _this.props.getRef;
      _this.wrapperRef = element;
      if (getRef) getRef(element);
    });

    _defineProperty$8(_assertThisInitialized$1(_this), "renderPrefix", function () {
      var prefix = _this.props.prefix;
      if (prefix) return /*#__PURE__*/React__default['default'].createElement(Prefix, null, prefix);
      return null;
    });

    _this.inputRef = /*#__PURE__*/React__default['default'].createRef();
    return _this;
  }

  _createClass$g(Input, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          autoComplete = _this$props.autoComplete,
          className = _this$props.className,
          disabled = _this$props.disabled,
          dropdownIndicator = _this$props.dropdownIndicator,
          error = _this$props.error;
          _this$props.getRef;
          var inputClassName = _this$props.inputClassName,
          isMusicSearch = _this$props.isMusicSearch,
          isSearch = _this$props.isSearch,
          isSearchMessage = _this$props.isSearchMessage,
          isTranslatable = _this$props.isTranslatable,
          isTranslatableMessage = _this$props.isTranslatableMessage,
          itemAction = _this$props.itemAction,
          name = _this$props.name,
          onResetBtn = _this$props.onResetBtn,
          placeholder = _this$props.placeholder,
          readOnly = _this$props.readOnly,
          showPlaceholder = _this$props.showPlaceholder,
          suffix = _this$props.suffix,
          tooltipError = _this$props.tooltipError,
          tooltipInteractive = _this$props.tooltipInteractive,
          tooltipMessage = _this$props.tooltipMessage,
          tooltipPlacement = _this$props.tooltipPlacement,
          value = _this$props.value,
          rest = _objectWithoutProperties$7(_this$props, _excluded$q);

      return /*#__PURE__*/React__default['default'].createElement(Wrapper$q, {
        className: className,
        ref: this.setWrapperRef
      }, this.renderPrefix(), /*#__PURE__*/React__default['default'].createElement(StyledInput$2, _extends$g({
        autoComplete: autoComplete,
        disabled: disabled,
        error: error,
        className: inputClassName,
        name: name,
        placeholder: placeholder,
        readOnly: readOnly,
        ref: this.setInputRef,
        showPlaceholder: showPlaceholder,
        value: value
      }, rest)), /*#__PURE__*/React__default['default'].createElement(Helpers, {
        additionalHelpers: suffix,
        disabled: disabled,
        dropdownIndicator: dropdownIndicator,
        isMusicSearch: isMusicSearch,
        isSearch: isSearch,
        isSearchMessage: isSearchMessage,
        isTranslatable: isTranslatable,
        isTranslatableMessage: isTranslatableMessage,
        itemAction: itemAction,
        onResetBtn: onResetBtn,
        tooltipError: tooltipError,
        tooltipInteractive: tooltipInteractive,
        tooltipMessage: tooltipMessage,
        tooltipPlacement: tooltipPlacement
      }));
    }
  }]);

  return Input;
}(React.PureComponent);

_defineProperty$8(Input$1, "propTypes", {
  /** Autocomplete */
  autoComplete: PropTypes__default['default'].string,

  /** Props used by styled component to override styles. */
  className: PropTypes__default['default'].string,

  /** If true, the input will be disabled. */
  disabled: PropTypes__default['default'].bool,

  /** Show dropdown indicator. */
  dropdownIndicator: PropTypes__default['default'].shape({
    opened: PropTypes__default['default'].bool.isRequired,
    onClick: PropTypes__default['default'].func.isRequired
  }),

  /** If true, the input will indicate an error. */
  error: PropTypes__default['default'].bool,

  /** Callback function used to get input ref. */
  getInputRef: PropTypes__default['default'].func,

  /** Callback function used to get input wrapper ref. */
  getRef: PropTypes__default['default'].func,

  /** Props used by styled component to override input styles. */
  inputClassName: PropTypes__default['default'].string,

  /** If True, icon will be music search. */
  isMusicSearch: PropTypes__default['default'].bool,

  /** If True, will show user this input is a search input. */
  isSearch: PropTypes__default['default'].bool,

  /** Message show in isSearch tooltip. */
  isSearchMessage: PropTypes__default['default'].string,

  /** If True, will show user this input is translatable. */
  isTranslatable: PropTypes__default['default'].bool,

  /** Message show in isTranslatable tooltip. */
  isTranslatableMessage: PropTypes__default['default'].string,

  /** Function that will be executed when clicking on the ItemActionBtn. */
  itemAction: PropTypes__default['default'].func,

  /** Name attribute of the input element. */
  name: PropTypes__default['default'].string.isRequired,

  /** Callback function for reset button */
  onResetBtn: PropTypes__default['default'].func,

  /** The short hint displayed in the input before the user enters a value. */
  placeholder: PropTypes__default['default'].string,

  /** Node that will be rendered as Prefix. */
  prefix: PropTypes__default['default'].node,

  /** If True, input will be read only. */
  readOnly: PropTypes__default['default'].bool,

  /** If True, placeholder is shown */
  showPlaceholder: PropTypes__default['default'].bool,

  /** Node that will be rendered as Suffix. */
  suffix: PropTypes__default['default'].node,

  /** Used to display error messsage as tooltip. */
  tooltipError: PropTypes__default['default'].string,

  /** If True, Tooltip will be interactive. */
  tooltipInteractive: PropTypes__default['default'].bool,

  /** If set, will add an InfoTooltip btn on input with tooltipMessage as content. */
  tooltipMessage: PropTypes__default['default'].node,

  /** Tooltip placement */
  tooltipPlacement: PropTypes__default['default'].oneOf(['bottom-end', 'bottom-start', 'bottom', 'left-end', 'left-start', 'left', 'right-end', 'right-start', 'right', 'top-end', 'top-start', 'top']),

  /** Type of the input element. It should be a valid HTML5 input type. */
  type: PropTypes__default['default'].string,

  /** value */
  value: PropTypes__default['default'].oneOfType([PropTypes__default['default'].string, PropTypes__default['default'].number])
});

_defineProperty$8(Input$1, "defaultProps", {
  autoComplete: undefined,
  className: '',
  disabled: false,
  dropdownIndicator: null,
  error: false,
  getInputRef: null,
  getRef: null,
  inputClassName: '',
  isMusicSearch: false,
  isSearch: false,
  isSearchMessage: '',
  itemAction: null,
  isTranslatable: false,
  isTranslatableMessage: '',
  onResetBtn: null,
  placeholder: '',
  prefix: null,
  readOnly: false,
  showPlaceholder: false,
  suffix: null,
  tooltipError: '',
  tooltipInteractive: false,
  tooltipMessage: '',
  tooltipPlacement: 'bottom',
  type: 'text',
  value: undefined
});var _templateObject$B, _templateObject2$w, _templateObject3$t, _templateObject4$p, _templateObject5$o, _templateObject6$i, _templateObject7$e, _templateObject8$e, _templateObject9$9, _templateObject10$9, _templateObject11$9, _templateObject12$8, _templateObject13$7, _templateObject14$7, _templateObject15$6;
// Styles
// =============================

var Wrapper$p = styled__default['default'](Div)(_templateObject$B || (_templateObject$B = _taggedTemplateLiteral$5(["\n  position: relative;\n  width: 100%;\n"])));
var OptionsContainer$1 = styled__default['default'].div.attrs({
  tabIndex: -1
})(_templateObject2$w || (_templateObject2$w = _taggedTemplateLiteral$5(["\n  & {\n    border-radius: inherit;\n    box-shadow: 0 0.4rem 1.5rem 0 ", ";\n    max-height: 18rem;\n    overflow: auto;\n\n    &:focus {\n      outline: 0;\n    }\n\n    /** Used when the dropdown has a search field, like GoogleFontsInput. */\n    ", ";\n  }\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.colors.boxShadow;
}, function (_ref2) {
  var noRadiusTop = _ref2.noRadiusTop;
  return noRadiusTop && styled.css(_templateObject3$t || (_templateObject3$t = _taggedTemplateLiteral$5(["\n        border-top-left-radius: 0;\n        border-top-right-radius: 0;\n      "])));
});
var Option = styled__default['default'].div.attrs({
  tabIndex: -1
})(_templateObject4$p || (_templateObject4$p = _taggedTemplateLiteral$5(["\n  align-items: center;\n  cursor: pointer;\n  display: flex;\n  flex-wrap: wrap;\n  font-size: 1.4rem;\n  line-height: 1.4;\n  min-height: 4rem;\n  padding: 1.2rem 2.8rem;\n  transition: 100ms linear;\n  word-break: break-all;\n\n  &:hover,\n  &:focus {\n    background-color: ", ";\n    outline: none;\n  }\n\n  ", ";\n\n  ", ";\n\n  ", ";\n  }\n"])), function (_ref3) {
  var theme = _ref3.theme;
  return alpha$2(theme.colors.primary, 0.1);
}, function (_ref4) {
  var centered = _ref4.centered;
  return centered && styled.css(_templateObject5$o || (_templateObject5$o = _taggedTemplateLiteral$5(["\n      justify-content: center;\n    "])));
}, function (_ref5) {
  var selected = _ref5.selected;
  return selected && styled.css(_templateObject6$i || (_templateObject6$i = _taggedTemplateLiteral$5(["\n      background-color: ", ";\n      outline: none;\n\n      &:hover,\n      &:focus {\n        background-color: ", ";\n      }\n    "])), function (_ref6) {
    var theme = _ref6.theme;
    return alpha$2(theme.colors.primary, 0.1);
  }, function (_ref7) {
    var theme = _ref7.theme;
    return alpha$2(theme.colors.primary, 0.2);
  });
}, function (_ref8) {
  var withCheckbox = _ref8.withCheckbox;
  return withCheckbox && styled.css(_templateObject7$e || (_templateObject7$e = _taggedTemplateLiteral$5(["\n      padding: 1.2rem;\n    "])));
});
var OnTheFlyPreview = styled__default['default'].div(_templateObject8$e || (_templateObject8$e = _taggedTemplateLiteral$5(["\n  color: ", ";\n  font-weight: ", ";\n  max-width: 100%;\n  overflow-wrap: break-word;\n"])), function (_ref9) {
  var theme = _ref9.theme;
  return theme.colors.input.text;
}, function (_ref10) {
  var theme = _ref10.theme;
  return theme.fontWeight.semibold;
});
var BreakWord = styled__default['default'].div(_templateObject9$9 || (_templateObject9$9 = _taggedTemplateLiteral$5(["\n  max-width: 100%;\n  overflow: auto;\n  overflow-wrap: break-word;\n  width: 100%;\n"])));
var InputBase = styled__default['default'](Input$1).attrs({
  inputClassName: 'inputClassName'
})(_templateObject10$9 || (_templateObject10$9 = _taggedTemplateLiteral$5(["\n  flex: 1 1 auto;\n  max-width: 100%;\n\n  & .inputClassName {\n    flex: 1 1 auto;\n    width: 5rem;\n  }\n"])));
var ClassicValueWrapper = styled__default['default'].div(_templateObject11$9 || (_templateObject11$9 = _taggedTemplateLiteral$5(["\n  color: ", ";\n  margin-right: 0.4rem;\n"])), function (_ref11) {
  var error = _ref11.error,
      theme = _ref11.theme;
  return error ? theme.colors.type.error : theme.colors.input.text;
});
var HelperText = styled__default['default'](Div)(_templateObject12$8 || (_templateObject12$8 = _taggedTemplateLiteral$5(["\n  color: ", ";\n  font-size: 0.8em;\n  margin-top: 0.4rem;\n"])), function (_ref12) {
  var error = _ref12.error,
      theme = _ref12.theme;
  return error ? theme.colors.type.error : theme.colors.text;
});
var DropdownInputHelpers = styled__default['default'](Helpers)(_templateObject13$7 || (_templateObject13$7 = _taggedTemplateLiteral$5(["\n  margin-left: auto;\n"])));
var ToggleDropdownPlaceholder = styled__default['default'].div(_templateObject14$7 || (_templateObject14$7 = _taggedTemplateLiteral$5(["\n  align-items: center;\n  display: flex;\n  flex: 1 1 auto;\n  font-style: italic;\n  justify-content: flex-start;\n  height: 3rem; /** Giving him too much height will break style on multiline values. */\n  position: relative;\n  width: 0;\n\n  /**\n    We need to put placeholder text in :before, else we won't be able to get the\n    textEllipsis to work because of ToggleDropdownPlaceholder being flex.\n  */\n  ", ";\n"])), function (_ref13) {
  var content = _ref13.content,
      theme = _ref13.theme;
  return content && styled.css(_templateObject15$6 || (_templateObject15$6 = _taggedTemplateLiteral$5(["\n      &:before {\n        ", ";\n        content: ", ";\n        font-size: inherit;\n        font-weight: inherit;\n        font-style: inherit;\n        left: 0;\n        opacity: 0.6;\n        position: absolute;\n        width: 100%;\n      }\n    "])), theme.helpers.textEllipsis, "'".concat(content, "'"));
});var _templateObject$A, _templateObject2$v, _templateObject3$s;
// Styles
// =============================

var StyledInput$1 = styled__default['default'](Input$1)(_templateObject$A || (_templateObject$A = _taggedTemplateLiteral$5(["\n  flex: 1 1 auto;\n  min-width: 25%;\n  width: auto;\n"])));
var ValueInput = styled__default['default'].div(_templateObject2$v || (_templateObject2$v = _taggedTemplateLiteral$5(["\n  align-items: center;\n  display: flex;\n  flex: 1 1 0;\n  flex-wrap: nowrap;\n  max-width: 100%;\n"])));
var StyledHelpers$3 = styled__default['default'](Helpers)(_templateObject3$s || (_templateObject3$s = _taggedTemplateLiteral$5(["\n  margin-left: auto;\n"])));var _excluded$p = ["className", "containerClassName", "disabled", "dropdownClassName", "error", "helperText", "itemAction", "lang", "name", "oneLineInput", "optional", "label", "placeholder", "showResetBtn", "suffix", "tooltipError", "tooltipInteractive", "tooltipMessage", "tooltipPlacement", "value", "variant"];
// Component
// =============================

var ApiSelectInput = /*#__PURE__*/function (_PureComponent) {
  _inherits$e(ApiSelectInput, _PureComponent);

  var _super = _createSuper$1(ApiSelectInput);

  function ApiSelectInput(props) {
    var _this;

    _classCallCheck$k(this, ApiSelectInput);

    _this = _super.call(this, props);

    _defineProperty$8(_assertThisInitialized$1(_this), "handleOnClickAway", function () {
      _this.handleCloseInput();
    });

    _defineProperty$8(_assertThisInitialized$1(_this), "closeDropdown", function () {
      return _this.setState({
        dropdownIsOpen: false
      });
    });

    _defineProperty$8(_assertThisInitialized$1(_this), "openDropdown", function (focusInput) {
      _this.setState({
        dropdownIsOpen: true
      }, function () {
        if (focusInput) {
          _this.inputRef.focus();
        }
      });
    });

    _defineProperty$8(_assertThisInitialized$1(_this), "handleClickOnValue", function () {
      var disabled = _this.props.disabled;
      var dropdownIsOpen = _this.state.dropdownIsOpen;
      if (disabled) return null;

      if (!dropdownIsOpen) {
        return _this.openDropdown(true);
      }

      return _this.closeDropdown();
    });

    _defineProperty$8(_assertThisInitialized$1(_this), "handleCloseInput", function () {
      return _this.setState({
        dropdownIsOpen: false,
        query: '',
        searching: false
      });
    });

    _defineProperty$8(_assertThisInitialized$1(_this), "handleOpenInput", function () {
      var disabled = _this.props.disabled;
      if (disabled) return null;
      return _this.setState({
        dropdownIsOpen: true
      }, function () {
        return _this.inputRef.focus();
      });
    });

    _defineProperty$8(_assertThisInitialized$1(_this), "handleQueryChange", function (e) {
      var searching = _this.state.searching;

      if (!searching) {
        _this.setState({
          searching: true
        });
      }

      _this.getEntity(e.target.value);

      _this.setState({
        query: e.target.value
      });
    });

    _defineProperty$8(_assertThisInitialized$1(_this), "handleOptionKeyDown", function (e) {
      var key = e.key,
          target = e.target;
      var onTheFlyEnabled = _this.props.onTheFlyEnabled;

      if (e.target.dataset.noOptions) {
        return _this.inputRef.focus();
      }

      switch (key) {
        // Tab
        case 'Tab':
          _this.handleCloseInput();

          break;
        // Enter: Save item

        case 'Enter':
          e.preventDefault();

          if (onTheFlyEnabled && e.target.dataset.onTheFlyQuery) {
            _this.handleOnTheFlyCreation(e.target.dataset.onTheFlyQuery);

            break;
          }

          _this.handleSelectOption({
            value: e.target.dataset.optionValue,
            search: e.target.dataset.optionSearch,
            label: e.target.dataset.optionLabel
          });

          break;
        // Arrow Up: Go to next item

        case 'ArrowUp':
          e.preventDefault();

          if (!target.previousSibling) {
            _this.animationContainerRef.lastChild.focus();

            break;
          }

          target.previousSibling.focus();
          break;
        // Arrow Down: Go to previous item

        case 'ArrowDown':
          e.preventDefault();

          if (!target.nextSibling) {
            _this.animationContainerRef.firstChild.focus();

            break;
          }

          target.nextSibling.focus();
          break;
        // If user is not navigating nor saving, we assume he wants to add some filter

        default:
          return _this.inputRef.focus();
      }

      return true;
    });

    _defineProperty$8(_assertThisInitialized$1(_this), "handleInputKeyDown", function (event) {
      var _this$props = _this.props,
          onTheFlyEnabled = _this$props.onTheFlyEnabled,
          value = _this$props.value;
      var _this$state = _this.state,
          query = _this$state.query,
          options = _this$state.options;
      var key = event.key; // Open Dropdown on keyDown, except if user press tab

      if (key !== 'Tab') _this.openDropdown();

      switch (key) {
        case 'Enter':
          event.preventDefault(); // If there are no result for the current query, we trigger on the fly creation

          if (onTheFlyEnabled) {
            if (!options.length) {
              _this.handleOnTheFlyCreation(query);
            }
          }

          _this.handleOnClickAway();

          break;

        case 'Backspace':
          // If query is present we only want to erase some part of it and search
          if (query) break;
          if (!query) _this.closeDropdown(); // Prevent Backspace from sending user to previous page

          event.preventDefault(); // Check if we have some Chip to remove

          if (!_this.inputWrapperRef.previousSibling) break;

          _this.setState({
            query: value.search,
            searching: true
          }, function () {
            return _this.inputRef.focus();
          });

          _this.getEntity(value.search);

          _this.openDropdown();

          break;
        // Arrow Down: Give focus to Dropdown first item

        case 'ArrowDown':
          event.preventDefault();
          if (_this.animationContainerRef.firstChild) _this.animationContainerRef.firstChild.focus();
          break;
      }
    });

    _defineProperty$8(_assertThisInitialized$1(_this), "getEntity", function (query) {
      var _this$props2 = _this.props,
          apiUrl = _this$props2.apiUrl,
          entity = _this$props2.entity,
          listAdditionalQuery = _this$props2.listAdditionalQuery,
          getEntityLabel = _this$props2.getEntityLabel,
          sessionToken = _this$props2.sessionToken,
          onFetchError = _this$props2.onFetchError,
          getSearchEntityLabel = _this$props2.getSearchEntityLabel;
      if (!query) return null; // Cancel last axios request

      if (_this.cancelAxios) _this.cancelAxios.cancel('Request canceled by user.'); // Generate new cancel token

      _this.cancelAxios = axios.CancelToken.source();
      _this.cancelToken = _this.cancelAxios.token; // NOTE: This takes care of & that was acting like a query seperator

      var encodedQuery = encodeURIComponent(query);
      if (listAdditionalQuery) encodedQuery += listAdditionalQuery;
      var url = "".concat(apiUrl, "/").concat(entity, "/list?search=").concat(encodedQuery);
      var config = {
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          'X-Auth': sessionToken
        },
        cancelToken: _this.cancelToken
      };
      return axios.get(url, config).then(function (res) {
        var nextOptions = res.data.results.map(function (o) {
          return {
            search: getSearchEntityLabel(o),
            label: getEntityLabel(o),
            value: o.id
          };
        });
        return _this.setState({
          options: nextOptions
        });
      })["catch"](onFetchError);
    });

    _defineProperty$8(_assertThisInitialized$1(_this), "handleOnTheFlyCreation", function (query) {
      var _this$props3 = _this.props,
          apiUrl = _this$props3.apiUrl,
          entity = _this$props3.entity,
          getEntityLabel = _this$props3.getEntityLabel,
          getSearchEntityLabel = _this$props3.getSearchEntityLabel,
          sessionToken = _this$props3.sessionToken,
          onTheFlyField = _this$props3.onTheFlyField,
          onTheFlyCreationSuccess = _this$props3.onTheFlyCreationSuccess,
          onTheFlyCreationError = _this$props3.onTheFlyCreationError,
          onTheFlyEnabled = _this$props3.onTheFlyEnabled,
          onTheFlyEndpoint = _this$props3.onTheFlyEndpoint,
          onTheFlyAdditionalData = _this$props3.onTheFlyAdditionalData;
      if (!onTheFlyEnabled) return;

      _this.setState({
        query: ''
      }, function () {
        var url = onTheFlyEndpoint || "".concat(apiUrl, "/").concat(entity);
        var config = {
          headers: {
            'X-Requested-With': 'XMLHttpRequest',
            'X-Auth': sessionToken
          }
        };
        return axios.post(url, _objectSpread2$2(_defineProperty$8({}, onTheFlyField, query), onTheFlyAdditionalData), config).then(function (res) {
          return _this.handleSelectOption({
            value: res.data.id,
            label: getEntityLabel(res.data),
            search: getSearchEntityLabel(res.data)
          }, true);
        }).then(onTheFlyCreationSuccess)["catch"](onTheFlyCreationError);
      });
    });

    _defineProperty$8(_assertThisInitialized$1(_this), "handleSelectOption", function (nextValue) {
      var onTheFly = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var _this$props4 = _this.props,
          onChange = _this$props4.onChange,
          value = _this$props4.value;

      _this.handleCloseInput();

      if (nextValue.value === value.value) {
        return null;
      }

      return onChange(nextValue, onTheFly);
    });

    _defineProperty$8(_assertThisInitialized$1(_this), "handleResetInput", function () {
      var _this$props5 = _this.props,
          resetBtnTriggersOnChange = _this$props5.resetBtnTriggersOnChange,
          onChange = _this$props5.onChange;

      _this.setState({
        dropdownIsOpen: false,
        query: '',
        searching: true
      }, function () {
        return _this.inputRef.focus();
      });

      if (resetBtnTriggersOnChange) {
        onChange({
          value: null,
          search: '',
          label: ''
        });
      }
    });

    _defineProperty$8(_assertThisInitialized$1(_this), "renderOnTheFlyOption", function () {
      var _this$props6 = _this.props,
          lang = _this$props6.lang,
          onTheFlyEnabled = _this$props6.onTheFlyEnabled;
      var query = _this.state.query;
      if (!query || !onTheFlyEnabled) return null;
      return /*#__PURE__*/React__default['default'].createElement(Option, {
        "data-on-the-fly-query": query,
        key: "key-".concat(query),
        onClick: function onClick() {
          return _this.handleOnTheFlyCreation(query);
        },
        onKeyDown: _this.handleOptionKeyDown
      }, "+\xA0", lang.create, "\xA0", /*#__PURE__*/React__default['default'].createElement(OnTheFlyPreview, null, /*#__PURE__*/React__default['default'].createElement(BreakWord, null, "\"".concat(query, "\""))));
    });

    _defineProperty$8(_assertThisInitialized$1(_this), "renderOptions", function () {
      var options = _this.state.options; // If we have no options

      if (!options.length) {
        return /*#__PURE__*/React__default['default'].createElement(OptionsContainer$1, {
          onKeyDown: _this.handleOptionKeyDown,
          "data-no-options": true,
          ref: function ref(node) {
            _this.animationContainerRef = node;
          }
        }, _this.renderOnTheFlyOption());
      }

      return /*#__PURE__*/React__default['default'].createElement(OptionsContainer$1, {
        ref: function ref(node) {
          _this.animationContainerRef = node;
        }
      }, options.map(function (option) {
        return /*#__PURE__*/React__default['default'].createElement(Option, {
          key: option.value,
          onClick: function onClick() {
            return _this.handleSelectOption(option);
          },
          onKeyDown: _this.handleOptionKeyDown,
          "data-option-value": option.value,
          "data-option-label": option.label,
          "data-option-search": option.search,
          selected: options.length === 1
        }, option.label);
      }), _this.renderOnTheFlyOption());
    });

    _defineProperty$8(_assertThisInitialized$1(_this), "handleGlobalClick", function () {
      var _this$props7 = _this.props,
          disabled = _this$props7.disabled,
          value = _this$props7.value;
      var searching = _this.state.searching;

      if (!disabled && value.value && !searching) {
        // Set current value as query + set searching as true (hide rendered value).
        _this.setState({
          query: value.search,
          searching: true
        }, function () {
          return _this.inputRef.focus();
        });

        _this.getEntity(value.search);

        _this.openDropdown();
      }
    });

    _defineProperty$8(_assertThisInitialized$1(_this), "renderValue", function () {
      var _this$props8 = _this.props,
          oneLineInput = _this$props8.oneLineInput,
          value = _this$props8.value;
      var searching = _this.state.searching;

      if (value.value && !searching) {
        return /*#__PURE__*/React__default['default'].createElement(Chip, {
          oneLineChip: oneLineInput,
          key: value.value,
          label: value.label,
          name: value.label,
          fillVariant: "textual",
          id: value.value,
          onClick: _this.handleClickOnValue
          /** Needed so the chip won't show weird hover because of the onClick. */
          ,
          noHover: true
        });
      }

      return null;
    });

    _this.state = {
      /** If true, dropdown is open. */
      dropdownIsOpen: false,

      /** Options list retrieved from API search as user type a query. */
      options: [],

      /** String used to build API request to search for entity. */
      query: '',

      /** Determines if the user is currently searching */
      searching: false
    };
    return _this;
  }

  _createClass$g(ApiSelectInput, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      var prevQuery = prevState.query;
      var nextQuery = this.state.query;

      if (prevQuery && !nextQuery) {
        this.closeDropdown();
      }
    }
    /** On click away */

  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props9 = this.props,
          className = _this$props9.className,
          containerClassName = _this$props9.containerClassName,
          disabled = _this$props9.disabled,
          dropdownClassName = _this$props9.dropdownClassName,
          error = _this$props9.error,
          helperText = _this$props9.helperText,
          itemAction = _this$props9.itemAction,
          lang = _this$props9.lang,
          name = _this$props9.name,
          oneLineInput = _this$props9.oneLineInput,
          optional = _this$props9.optional,
          label = _this$props9.label,
          placeholder = _this$props9.placeholder,
          showResetBtn = _this$props9.showResetBtn,
          suffix = _this$props9.suffix,
          tooltipError = _this$props9.tooltipError,
          tooltipInteractive = _this$props9.tooltipInteractive,
          tooltipMessage = _this$props9.tooltipMessage,
          tooltipPlacement = _this$props9.tooltipPlacement,
          value = _this$props9.value,
          variant = _this$props9.variant,
          rest = _objectWithoutProperties$7(_this$props9, _excluded$p);

      var _this$state2 = this.state,
          dropdownIsOpen = _this$state2.dropdownIsOpen,
          query = _this$state2.query,
          searching = _this$state2.searching;
      return /*#__PURE__*/React__default['default'].createElement(ClickAwayListener, {
        onClickAway: this.handleOnClickAway
      }, /*#__PURE__*/React__default['default'].createElement(Wrapper$p, _extends$g({
        className: className
      }, getViewProps(rest)), variant === 'background' && /*#__PURE__*/React__default['default'].createElement(Label$2, {
        active: dropdownIsOpen || !!query,
        error: error,
        label: label,
        lang: lang.Label,
        optional: optional,
        variant: "background"
      }), /*#__PURE__*/React__default['default'].createElement(Container$1, {
        active: dropdownIsOpen || !!query,
        containerClassName: containerClassName,
        error: error,
        getRef: function getRef(node) {
          _this2.containerRef = node;
        },
        onClick: this.handleOpenInput,
        variant: variant
      }, variant === 'underline' && /*#__PURE__*/React__default['default'].createElement(Label$2, {
        active: dropdownIsOpen || !!query,
        error: error,
        label: label,
        lang: lang.Label,
        inputFilled: !!value.value || !!query,
        optional: optional,
        variant: variant
      }), /*#__PURE__*/React__default['default'].createElement(ValueInput, {
        onClick: this.handleGlobalClick,
        oneLineInput: oneLineInput
      }, this.renderValue(), (!value.value || searching || dropdownIsOpen) && /*#__PURE__*/React__default['default'].createElement(StyledInput$1, {
        autoComplete: "off_workaround",
        disabled: disabled,
        error: error,
        getInputRef: function getInputRef(node) {
          _this2.inputRef = node;
        },
        getRef: function getRef(node) {
          _this2.inputWrapperRef = node;
        },
        label: label,
        name: name,
        onClick: this.handleOpenInput,
        onChange: this.handleQueryChange,
        onKeyDown: this.handleInputKeyDown,
        placeholder: value.value ? '' : placeholder,
        showPlaceholder: variant === 'background',
        value: query
      }), /*#__PURE__*/React__default['default'].createElement(StyledHelpers$3, {
        additionalHelpers: suffix,
        disabled: disabled,
        itemAction: itemAction,
        onResetBtn: showResetBtn ? this.handleResetInput : null,
        tooltipError: tooltipError,
        tooltipInteractive: tooltipInteractive,
        tooltipMessage: tooltipMessage,
        tooltipPlacement: tooltipPlacement
      }))), /*#__PURE__*/React__default['default'].createElement(Dropdown$2, {
        className: dropdownClassName,
        onClickOutside: this.handleOnClickAway,
        open: dropdownIsOpen,
        variant: variant
      }, /*#__PURE__*/React__default['default'].createElement(React__default['default'].Fragment, null, this.renderOptions())), helperText && /*#__PURE__*/React__default['default'].createElement(HelperText, {
        error: error
      }, helperText)));
    }
  }]);

  return ApiSelectInput;
}(React.PureComponent);

_defineProperty$8(ApiSelectInput, "propTypes", {
  /** API URL. */
  apiUrl: PropTypes__default['default'].string.isRequired,

  /** Props used by styled component to override styles */
  className: PropTypes__default['default'].string,

  /** Container classname. */
  containerClassName: PropTypes__default['default'].string,

  /** If true, the input will be disabled. */
  disabled: PropTypes__default['default'].bool,

  /** Dropdown classname. */
  dropdownClassName: PropTypes__default['default'].string,

  /** If true, the input will indicate an error.  */
  error: PropTypes__default['default'].bool,

  /** Entity name. */
  entity: PropTypes__default['default'].string.isRequired,

  /** Additional query for list endpoint */
  listAdditionalQuery: PropTypes__default['default'].string,

  /** Function used to get search label from entity object.  */
  getSearchEntityLabel: PropTypes__default['default'].func.isRequired,

  /** Function used to get label from entity object.  */
  getEntityLabel: PropTypes__default['default'].func.isRequired,

  /** The helper text content. */
  helperText: PropTypes__default['default'].string,

  /** Function that will be executed when clicking on the ItemActionBtn. */
  itemAction: PropTypes__default['default'].func,

  /** The label content. */
  label: PropTypes__default['default'].string,

  /** Translation strings. */
  lang: PropTypes__default['default'].object.isRequired,
  // eslint-disable-line react/forbid-prop-types

  /** Name attribute of the input element. */
  name: PropTypes__default['default'].string.isRequired,

  /** Callback fired when the value is changed. */
  onChange: PropTypes__default['default'].func.isRequired,

  /** Callback fired when fetch fail. */
  onFetchError: PropTypes__default['default'].func,

  /** If True, input will be a one liner with text-ellipsis. */
  oneLineInput: PropTypes__default['default'].bool,

  /** If true, the input is optional. */
  optional: PropTypes__default['default'].bool,

  /** Callback fired when on the fly entity creation suceeds. */
  onTheFlyCreationSuccess: PropTypes__default['default'].func,

  /** Callback fired when on the fly entity creation fail. */
  onTheFlyCreationError: PropTypes__default['default'].func,

  /** Mandatory field to create entity. */
  onTheFlyField: PropTypes__default['default'].string.isRequired,

  /** Disable on the fly creation */
  onTheFlyEnabled: PropTypes__default['default'].bool,

  /** Custom on the fly creation endpoint */
  onTheFlyEndpoint: PropTypes__default['default'].string,

  /** Custom data to add on on the fly creation */
  onTheFlyAdditionalData: PropTypes__default['default'].object,
  // eslint-disable-line react/forbid-prop-types

  /** The short hint displayed in the input before the user enters a value. */
  placeholder: PropTypes__default['default'].string,

  /** Session token use to access API. */
  sessionToken: PropTypes__default['default'].string.isRequired,

  /** If True, show reset button. */
  showResetBtn: PropTypes__default['default'].bool,

  /** Node that will be rendered as Suffix. */
  suffix: PropTypes__default['default'].node,

  /** If true, the reset button will trigger onChange. */
  resetBtnTriggersOnChange: PropTypes__default['default'].bool,

  /** Used to display error messsage as tooltip. */
  tooltipError: PropTypes__default['default'].string,

  /** If True, Tooltip will be interactive. */
  tooltipInteractive: PropTypes__default['default'].bool,

  /** If set, will add an InfoTooltip btn on input with tooltipMessage as content. */
  tooltipMessage: PropTypes__default['default'].node,

  /** Tooltip placement */
  tooltipPlacement: PropTypes__default['default'].oneOf(['bottom-end', 'bottom-start', 'bottom', 'left-end', 'left-start', 'left', 'right-end', 'right-start', 'right', 'top-end', 'top-start', 'top']),

  /** Value. */
  value: PropTypes__default['default'].shape({
    search: PropTypes__default['default'].string,
    label: PropTypes__default['default'].string,
    value: PropTypes__default['default'].string
  }),

  /** Input style variant. */
  variant: PropTypes__default['default'].oneOf(['background', 'underline'])
});

_defineProperty$8(ApiSelectInput, "defaultProps", {
  className: '',
  containerClassName: '',
  disabled: false,
  dropdownClassName: '',
  error: false,
  helperText: '',
  itemAction: null,
  label: '',
  listAdditionalQuery: '',
  oneLineInput: false,
  onFetchError: null,
  onTheFlyCreationSuccess: null,
  onTheFlyCreationError: null,
  onTheFlyEnabled: false,
  onTheFlyEndpoint: '',
  onTheFlyAdditionalData: {},
  optional: false,
  placeholder: '',
  showResetBtn: true,
  suffix: null,
  resetBtnTriggersOnChange: false,
  tooltipError: '',
  tooltipInteractive: false,
  tooltipMessage: '',
  tooltipPlacement: 'bottom',
  value: {
    search: '',
    label: '',
    value: null
  },
  variant: 'background'
});var _templateObject$z, _templateObject2$u, _templateObject3$r, _templateObject4$o, _templateObject5$n, _templateObject6$h;
// Styles
// =============================

var Wrapper$o = styled__default['default'].div(_templateObject$z || (_templateObject$z = _taggedTemplateLiteral$5(["\n  align-items: center;\n  border-radius: 50%;\n  display: flex;\n  height: 4.4rem;\n  font-family: ", ";\n  font-weight: ", ";\n  justify-content: center;\n  font-family: ", ";\n  text-transform: uppercase;\n  width: 4.4rem;\n\n  ", ";\n\n  ", ";\n\n  ", ";\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.fontFamily.primary;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.fontWeight.semibold;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.fontFamily.primary;
}, function (_ref4) {
  var color = _ref4.color;
  return color ? styled.css(_templateObject2$u || (_templateObject2$u = _taggedTemplateLiteral$5(["\n      background-color: ", ";\n      border: 0.1rem solid ", ";\n      color: ", ";\n    "])), lighten(color, '0.8'), color, color) : styled.css(_templateObject3$r || (_templateObject3$r = _taggedTemplateLiteral$5(["\n      /** NOTE: These are default colors, they shouldn't be used */\n      background-color: ", ";\n      border: 0.1rem solid #00b894;\n      color: #00b894;\n    "])), lighten('#00b894', '0.8'));
}, function (_ref5) {
  var onClick = _ref5.onClick;
  return onClick ? styled.css(_templateObject4$o || (_templateObject4$o = _taggedTemplateLiteral$5(["\n      cursor: pointer;\n    "]))) : styled.css(_templateObject5$n || (_templateObject5$n = _taggedTemplateLiteral$5(["\n      cursor: default;\n    "])));
}, function (_ref6) {
  var size = _ref6.size;
  return size && styled.css(_templateObject6$h || (_templateObject6$h = _taggedTemplateLiteral$5(["\n      height: ", "rem;\n      width: ", "rem;\n    "])), size, size);
});// =============================
// Component
// =============================

var Avatar = /*#__PURE__*/React__default['default'].memo( /*#__PURE__*/React__default['default'].forwardRef(function (_ref, ref) {
  var className = _ref.className,
      onClick = _ref.onClick,
      size = _ref.size,
      user = _ref.user;
  return /*#__PURE__*/React__default['default'].createElement(Wrapper$o, {
    className: className,
    color: get_1(user, 'avatar_color', ''),
    onClick: onClick,
    ref: ref,
    size: size
  }, get_1(user, 'first_name', '').substr(0, 1), get_1(user, 'last_name', '').substr(0, 1));
}));
Avatar.propTypes = {
  /** Props used by styled component to override styles */
  className: PropTypes__default['default'].string,

  /** onClick handler */
  onClick: PropTypes__default['default'].func,

  /** Size in rem */
  size: PropTypes__default['default'].number,

  /** User object */
  user: PropTypes__default['default'].shape({
    first_name: PropTypes__default['default'].string,
    last_name: PropTypes__default['default'].string,
    avatar_color: PropTypes__default['default'].string
  })
};
Avatar.defaultProps = {
  className: '',
  onClick: null,
  size: null,
  user: null
};var _templateObject$y, _templateObject2$t, _templateObject3$q, _templateObject4$n, _templateObject5$m, _templateObject6$g, _templateObject7$d, _templateObject8$d, _templateObject9$8, _templateObject10$8, _templateObject11$8, _templateObject12$7;
// Styles
// =============================

var resetStyles = styled.css(_templateObject$y || (_templateObject$y = _taggedTemplateLiteral$5(["\n  background-color: transparent;\n  /** We use a 0.2rem transparent border as a placeholder,\n  for Outline fillVariant, so every fillVariant have the\n  same width. */\n  border: 0.2rem solid transparent;\n  font-family: inherit;\n  outline: none;\n  user-select: none;\n"])));
var Wrapper$n = styled__default['default'](Div).attrs({
  as: 'button'
})(_templateObject2$t || (_templateObject2$t = _taggedTemplateLiteral$5(["\n  ", ";\n  align-items: center;\n  border-radius: ", ";\n  cursor: ", ";\n  display: flex;\n  font-weight: ", ";\n  position: relative;\n  transition-duration: ", ";\n  white-space: nowrap;\n  z-index: 0;\n\n  ", ";\n\n  ", ";\n\n  ", "\n\n  ", ";\n"])), resetStyles, function (_ref) {
  var theme = _ref.theme;
  return theme.edgeVariant === 'round' ? '1rem' : '0.2rem';
}, function (_ref2) {
  var disabled = _ref2.disabled;
  return disabled ? 'default' : 'pointer';
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.fontWeight.bold;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.transition.medium;
}, function (_ref5) {
  var centered = _ref5.centered;
  return centered && styled.css(_templateObject3$q || (_templateObject3$q = _taggedTemplateLiteral$5(["\n      margin-left: auto;\n      margin-right: auto;\n    "])));
}, function (_ref6) {
  var fullWidth = _ref6.fullWidth;
  return fullWidth && styled.css(_templateObject4$n || (_templateObject4$n = _taggedTemplateLiteral$5(["\n      justify-content: center;\n      text-align: center;\n      width: 100%;\n    "])));
}, function (_ref7) {
  var size = _ref7.size;

  switch (size) {
    case 'small':
      return styled.css(_templateObject5$m || (_templateObject5$m = _taggedTemplateLiteral$5(["\n          height: 3rem;\n          font-size: 1.2rem;\n          padding: 0 1.6rem;\n        "])));

    case 'medium':
    default:
      return styled.css(_templateObject6$g || (_templateObject6$g = _taggedTemplateLiteral$5(["\n          height: 5rem;\n          font-size: 1.4rem;\n          padding: 0 3.2rem;\n        "])));
  }
}, function (_ref8) {
  var color = _ref8.color,
      disabled = _ref8.disabled,
      fillVariant = _ref8.fillVariant,
      theme = _ref8.theme;
  var colors = {};

  if (color === 'primary') {
    colors.background = theme.colors.primary;
    colors.text = theme.colors.primaryText;
  }

  if (color === 'secondary') {
    colors.background = theme.colors.secondary;
    colors.text = theme.colors.secondaryText;
  }

  if (['cancel', 'error', 'success', 'warning'].includes(color)) {
    colors.background = theme.colors.type[color];
    colors.text = theme.colors.white;
  }

  if (disabled) {
    colors.background = theme.colors.type.cancel;
    colors.text = theme.colors.white;
  }

  switch (fillVariant) {
    case 'ghost':
      return styled.css(_templateObject7$d || (_templateObject7$d = _taggedTemplateLiteral$5(["\n          color: ", ";\n\n          ", ";\n        "])), colors.background, !disabled && styled.css(_templateObject8$d || (_templateObject8$d = _taggedTemplateLiteral$5(["\n              &:hover {\n                background-color: ", ";\n                color: ", ";\n              }\n            "])), colors.background, colors.text));

    case 'outline':
      return styled.css(_templateObject9$8 || (_templateObject9$8 = _taggedTemplateLiteral$5(["\n          border: 0.2rem solid ", ";\n          color: ", ";\n\n          ", ";\n        "])), colors.background, colors.background, !disabled && styled.css(_templateObject10$8 || (_templateObject10$8 = _taggedTemplateLiteral$5(["\n              &:hover {\n                border: 0.2rem solid ", ";\n                background-color: ", ";\n                color: ", ";\n              }\n            "])), colors.background, colors.background, colors.text));

    case 'plain':
    default:
      return styled.css(_templateObject11$8 || (_templateObject11$8 = _taggedTemplateLiteral$5(["\n          background-color: ", ";\n          color: ", ";\n\n          ", ";\n        "])), colors.background, colors.text, !disabled && styled.css(_templateObject12$7 || (_templateObject12$7 = _taggedTemplateLiteral$5(["\n              &:hover {\n                background-color: ", ";\n            "])), alpha$2(colors.background, 0.7)));
  }
});var _excluded$o = ["centered", "children", "className", "color", "disabled", "fillVariant", "fullWidth", "onClick", "size", "type"];
// Component
// =============================

var Button$1 = /*#__PURE__*/React__default['default'].memo( /*#__PURE__*/React__default['default'].forwardRef(function (_ref, ref) {
  var centered = _ref.centered,
      children = _ref.children,
      className = _ref.className,
      color = _ref.color,
      disabled = _ref.disabled,
      fillVariant = _ref.fillVariant,
      fullWidth = _ref.fullWidth,
      onClick = _ref.onClick,
      size = _ref.size,
      type = _ref.type,
      rest = _objectWithoutProperties$7(_ref, _excluded$o);

  return /*#__PURE__*/React__default['default'].createElement(Wrapper$n, _extends$g({
    centered: centered,
    className: className,
    color: color,
    disabled: disabled,
    fillVariant: fillVariant,
    fullWidth: fullWidth,
    onClick: onClick,
    ref: ref,
    size: size,
    type: type
  }, getViewProps(rest)), children);
}));
Button$1.propTypes = {
  /** If set to true, add margin left/right auto */
  centered: PropTypes__default['default'].bool,

  /** The content of the button. */
  children: PropTypes__default['default'].node.isRequired,

  /** Props used by styled component to override styles */
  className: PropTypes__default['default'].string,

  /** The color to use. */
  color: PropTypes__default['default'].oneOf(['primary', 'secondary', 'cancel', 'error', 'success', 'warning']),

  /** If true, the button will be disabled. */
  disabled: PropTypes__default['default'].bool,

  /** Button can be eitheir plain or outline. */
  fillVariant: PropTypes__default['default'].oneOf(['ghost', 'plain', 'outline']),

  /** If true, the button will take up the full width of its container. */
  fullWidth: PropTypes__default['default'].bool,

  /** Pass onClick handler */
  onClick: PropTypes__default['default'].func,

  /** Button size. */
  size: PropTypes__default['default'].oneOf(['small', 'medium']),

  /** Button type(same as html) */
  type: PropTypes__default['default'].oneOf(['submit', 'reset', 'button'])
};
Button$1.defaultProps = {
  centered: false,
  className: '',
  color: 'primary',
  disabled: false,
  fillVariant: 'plain',
  fullWidth: false,
  onClick: null,
  size: 'medium',
  type: 'button'
};var _templateObject$x, _templateObject2$s, _templateObject3$p, _templateObject4$m, _templateObject5$l, _templateObject6$f, _templateObject7$c, _templateObject8$c;
// Component
// =============================

var Flex = styled__default['default'](Div)(_templateObject$x || (_templateObject$x = _taggedTemplateLiteral$5(["\n  display: flex;\n\n  ", ";\n\n  ", ";\n\n  ", ";\n\n  ", ";\n\n  ", ";\n\n  ", ";\n\n  ", ";\n"])), function (_ref) {
  var align = _ref.align;
  return align && styled.css(_templateObject2$s || (_templateObject2$s = _taggedTemplateLiteral$5(["\n      align-items: ", " !important;\n    "])), align);
}, function (_ref2) {
  var justify = _ref2.justify;
  return justify && styled.css(_templateObject3$p || (_templateObject3$p = _taggedTemplateLiteral$5(["\n      justify-content: ", " !important;\n    "])), justify);
}, function (_ref3) {
  var direction = _ref3.direction;
  return direction && styled.css(_templateObject4$m || (_templateObject4$m = _taggedTemplateLiteral$5(["\n      flex-direction: ", " !important;\n    "])), direction);
}, function (_ref4) {
  var flex = _ref4.flex;
  return flex && styled.css(_templateObject5$l || (_templateObject5$l = _taggedTemplateLiteral$5(["\n      flex: ", " !important;\n    "])), flex);
}, function (_ref5) {
  var wrap = _ref5.wrap;
  return wrap && styled.css(_templateObject6$f || (_templateObject6$f = _taggedTemplateLiteral$5(["\n      flex-wrap: ", " !important;\n    "])), wrap);
}, function (_ref6) {
  var flexBasis = _ref6.flexBasis;
  return flexBasis && styled.css(_templateObject7$c || (_templateObject7$c = _taggedTemplateLiteral$5(["\n      flex-basis: ", " !important;\n    "])), flexBasis);
}, function (_ref7) {
  var alignContent = _ref7.alignContent;
  return alignContent && styled.css(_templateObject8$c || (_templateObject8$c = _taggedTemplateLiteral$5(["\n      align-content: ", " !important;\n    "])), alignContent);
});var _templateObject$w, _templateObject2$r, _templateObject3$o;
// Styles
// =============================

var Label$1 = styled__default['default'].div(_templateObject$w || (_templateObject$w = _taggedTemplateLiteral$5(["\n  font-size: 0.9em;\n  font-weight: ", ";\n  line-height: 1.5rem;\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.fontWeight.semibold;
});
var CheckBoxIcon = styled__default['default'](CheckBox$1).attrs(function (_ref2) {
  var checked = _ref2.checked,
      fillColor = _ref2.fillColor,
      fillColorChecked = _ref2.fillColorChecked,
      theme = _ref2.theme;
  return {
    height: '1.6rem',
    fill: checked ? fillColorChecked || theme.colors.primary : fillColor || theme.colors.text,
    width: '1.6rem'
  };
})(_templateObject2$r || (_templateObject2$r = _taggedTemplateLiteral$5(["\n  cursor: pointer;\n\n  &:not(:last-child) {\n    margin-right: 0.8rem;\n  }\n\n  ", ";\n"])), function (_ref3) {
  var disabled = _ref3.disabled;
  return disabled && styled.css(_templateObject3$o || (_templateObject3$o = _taggedTemplateLiteral$5(["\n      cursor: default;\n      filter: grayscale(1);\n    "])));
});var _excluded$n = ["checked", "className", "disabled", "error", "fillColor", "fillColorChecked", "helperText", "onChange", "label"];
// Component
// =============================

var Checkbox = /*#__PURE__*/function (_PureComponent) {
  _inherits$e(Checkbox, _PureComponent);

  var _super = _createSuper$1(Checkbox);

  function Checkbox() {
    var _this;

    _classCallCheck$k(this, Checkbox);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty$8(_assertThisInitialized$1(_this), "onChange", function () {
      var _this$props = _this.props,
          disabled = _this$props.disabled,
          onChange = _this$props.onChange,
          checked = _this$props.checked;
      if (onChange && !disabled) onChange(!checked);
    });

    return _this;
  }

  _createClass$g(Checkbox, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          checked = _this$props2.checked,
          className = _this$props2.className,
          disabled = _this$props2.disabled,
          error = _this$props2.error,
          fillColor = _this$props2.fillColor,
          fillColorChecked = _this$props2.fillColorChecked,
          helperText = _this$props2.helperText;
          _this$props2.onChange;
          var label = _this$props2.label,
          rest = _objectWithoutProperties$7(_this$props2, _excluded$n);

      return /*#__PURE__*/React__default['default'].createElement(Div, _extends$g({
        className: className
      }, getViewProps(rest)), /*#__PURE__*/React__default['default'].createElement(Flex, {
        align: "center"
      }, /*#__PURE__*/React__default['default'].createElement(CheckBoxIcon, {
        disabled: disabled,
        fillColor: fillColor,
        fillColorChecked: fillColorChecked,
        onClick: this.onChange,
        checked: checked
      }), label && /*#__PURE__*/React__default['default'].createElement(Label$1, null, label)), helperText && /*#__PURE__*/React__default['default'].createElement(HelperText, {
        error: error
      }, helperText));
    }
  }]);

  return Checkbox;
}(React.PureComponent);

_defineProperty$8(Checkbox, "propTypes", {
  /** Value */
  checked: PropTypes__default['default'].bool,

  /** Props used by styled component to override styles. */
  className: PropTypes__default['default'].string,

  /** If True, input is disabled. */
  disabled: PropTypes__default['default'].bool,

  /** If True, input has error. */
  error: PropTypes__default['default'].bool,

  /** Icon color when input is not checked. */
  fillColor: PropTypes__default['default'].string,

  /** Icon color when input is checked. */
  fillColorChecked: PropTypes__default['default'].string,

  /** The helper text content. */
  helperText: PropTypes__default['default'].string,

  /** The label content. */
  label: PropTypes__default['default'].string,

  /** Callback fired when the value is changed. */
  onChange: PropTypes__default['default'].func
});

_defineProperty$8(Checkbox, "defaultProps", {
  checked: false,
  className: '',
  disabled: false,
  error: false,
  fillColor: '',
  fillColorChecked: '',
  helperText: '',
  label: '',
  onChange: null
});var Chrome$2 = {};var Chrome$1 = {};var lib$1 = {};var flattenNames$1 = {};var baseGetTag = _baseGetTag,
    isArray$6 = isArray_1,
    isObjectLike$2 = isObjectLike_1;

/** `Object#toString` result references. */
var stringTag$2 = '[object String]';

/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */
function isString$1(value) {
  return typeof value == 'string' ||
    (!isArray$6(value) && isObjectLike$2(value) && baseGetTag(value) == stringTag$2);
}

var isString_1 = isString$1;var identity$1 = identity_1;

/**
 * Casts `value` to `identity` if it's not a function.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Function} Returns cast function.
 */
function castFunction$2(value) {
  return typeof value == 'function' ? value : identity$1;
}

var _castFunction = castFunction$2;var baseForOwn$1 = _baseForOwn,
    castFunction$1 = _castFunction;

/**
 * Iterates over own enumerable string keyed properties of an object and
 * invokes `iteratee` for each property. The iteratee is invoked with three
 * arguments: (value, key, object). Iteratee functions may exit iteration
 * early by explicitly returning `false`.
 *
 * @static
 * @memberOf _
 * @since 0.3.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns `object`.
 * @see _.forOwnRight
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.forOwn(new Foo, function(value, key) {
 *   console.log(key);
 * });
 * // => Logs 'a' then 'b' (iteration order is not guaranteed).
 */
function forOwn(object, iteratee) {
  return object && baseForOwn$1(object, castFunction$1(iteratee));
}

var forOwn_1 = forOwn;var isArrayLike$4 = isArrayLike_1;

/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseEach$1(eachFunc, fromRight) {
  return function(collection, iteratee) {
    if (collection == null) {
      return collection;
    }
    if (!isArrayLike$4(collection)) {
      return eachFunc(collection, iteratee);
    }
    var length = collection.length,
        index = fromRight ? length : -1,
        iterable = Object(collection);

    while ((fromRight ? index-- : ++index < length)) {
      if (iteratee(iterable[index], index, iterable) === false) {
        break;
      }
    }
    return collection;
  };
}

var _createBaseEach = createBaseEach$1;var baseForOwn = _baseForOwn,
    createBaseEach = _createBaseEach;

/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */
var baseEach$3 = createBaseEach(baseForOwn);

var _baseEach = baseEach$3;var baseEach$2 = _baseEach,
    isArrayLike$3 = isArrayLike_1;

/**
 * The base implementation of `_.map` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function baseMap$2(collection, iteratee) {
  var index = -1,
      result = isArrayLike$3(collection) ? Array(collection.length) : [];

  baseEach$2(collection, function(value, key, collection) {
    result[++index] = iteratee(value, key, collection);
  });
  return result;
}

var _baseMap = baseMap$2;var arrayMap$6 = _arrayMap,
    baseIteratee$5 = _baseIteratee,
    baseMap$1 = _baseMap,
    isArray$5 = isArray_1;

/**
 * Creates an array of values by running each element in `collection` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, index|key, collection).
 *
 * Many lodash methods are guarded to work as iteratees for methods like
 * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
 *
 * The guarded methods are:
 * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
 * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
 * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
 * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * _.map([4, 8], square);
 * // => [16, 64]
 *
 * _.map({ 'a': 4, 'b': 8 }, square);
 * // => [16, 64] (iteration order is not guaranteed)
 *
 * var users = [
 *   { 'user': 'barney' },
 *   { 'user': 'fred' }
 * ];
 *
 * // The `_.property` iteratee shorthand.
 * _.map(users, 'user');
 * // => ['barney', 'fred']
 */
function map(collection, iteratee) {
  var func = isArray$5(collection) ? arrayMap$6 : baseMap$1;
  return func(collection, baseIteratee$5(iteratee));
}

var map_1 = map;Object.defineProperty(flattenNames$1, "__esModule", {
  value: true
});
flattenNames$1.flattenNames = undefined;

var _isString2 = isString_1;

var _isString3 = _interopRequireDefault$n(_isString2);

var _forOwn2$2 = forOwn_1;

var _forOwn3$2 = _interopRequireDefault$n(_forOwn2$2);

var _isPlainObject2 = isPlainObject_1;

var _isPlainObject3 = _interopRequireDefault$n(_isPlainObject2);

var _map2 = map_1;

var _map3 = _interopRequireDefault$n(_map2);

function _interopRequireDefault$n(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var flattenNames = flattenNames$1.flattenNames = function flattenNames() {
  var things = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

  var names = [];

  (0, _map3.default)(things, function (thing) {
    if (Array.isArray(thing)) {
      flattenNames(thing).map(function (name) {
        return names.push(name);
      });
    } else if ((0, _isPlainObject3.default)(thing)) {
      (0, _forOwn3$2.default)(thing, function (value, key) {
        value === true && names.push(key);
        names.push(key + '-' + value);
      });
    } else if ((0, _isString3.default)(thing)) {
      names.push(thing);
    }
  });

  return names;
};

flattenNames$1.default = flattenNames;var mergeClasses$1 = {};/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */

function arrayEach$2(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (iteratee(array[index], index, array) === false) {
      break;
    }
  }
  return array;
}

var _arrayEach = arrayEach$2;var copyObject$4 = _copyObject,
    keys$3 = keys_1;

/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssign$1(object, source) {
  return object && copyObject$4(source, keys$3(source), object);
}

var _baseAssign = baseAssign$1;var copyObject$3 = _copyObject,
    keysIn$1 = keysIn_1;

/**
 * The base implementation of `_.assignIn` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssignIn$1(object, source) {
  return object && copyObject$3(source, keysIn$1(source), object);
}

var _baseAssignIn = baseAssignIn$1;var copyObject$2 = _copyObject,
    getSymbols = _getSymbols;

/**
 * Copies own symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbols$1(source, object) {
  return copyObject$2(source, getSymbols(source), object);
}

var _copySymbols = copySymbols$1;var copyObject$1 = _copyObject,
    getSymbolsIn = _getSymbolsIn;

/**
 * Copies own and inherited symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbolsIn$1(source, object) {
  return copyObject$1(source, getSymbolsIn(source), object);
}

var _copySymbolsIn = copySymbolsIn$1;/** Used for built-in method references. */

var objectProto$1 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$1 = objectProto$1.hasOwnProperty;

/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */
function initCloneArray$1(array) {
  var length = array.length,
      result = new array.constructor(length);

  // Add properties assigned by `RegExp#exec`.
  if (length && typeof array[0] == 'string' && hasOwnProperty$1.call(array, 'index')) {
    result.index = array.index;
    result.input = array.input;
  }
  return result;
}

var _initCloneArray = initCloneArray$1;var cloneArrayBuffer$1 = _cloneArrayBuffer;

/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */
function cloneDataView$1(dataView, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer$1(dataView.buffer) : dataView.buffer;
  return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}

var _cloneDataView = cloneDataView$1;/** Used to match `RegExp` flags from their coerced string values. */

var reFlags = /\w*$/;

/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */
function cloneRegExp$1(regexp) {
  var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
  result.lastIndex = regexp.lastIndex;
  return result;
}

var _cloneRegExp = cloneRegExp$1;var Symbol$1 = _Symbol;

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol$1 ? Symbol$1.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */
function cloneSymbol$1(symbol) {
  return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
}

var _cloneSymbol = cloneSymbol$1;var cloneArrayBuffer = _cloneArrayBuffer,
    cloneDataView = _cloneDataView,
    cloneRegExp = _cloneRegExp,
    cloneSymbol = _cloneSymbol,
    cloneTypedArray = _cloneTypedArray;

/** `Object#toString` result references. */
var boolTag$1 = '[object Boolean]',
    dateTag$1 = '[object Date]',
    mapTag$3 = '[object Map]',
    numberTag$1 = '[object Number]',
    regexpTag$1 = '[object RegExp]',
    setTag$3 = '[object Set]',
    stringTag$1 = '[object String]',
    symbolTag$1 = '[object Symbol]';

var arrayBufferTag$1 = '[object ArrayBuffer]',
    dataViewTag$1 = '[object DataView]',
    float32Tag$1 = '[object Float32Array]',
    float64Tag$1 = '[object Float64Array]',
    int8Tag$1 = '[object Int8Array]',
    int16Tag$1 = '[object Int16Array]',
    int32Tag$1 = '[object Int32Array]',
    uint8Tag$1 = '[object Uint8Array]',
    uint8ClampedTag$1 = '[object Uint8ClampedArray]',
    uint16Tag$1 = '[object Uint16Array]',
    uint32Tag$1 = '[object Uint32Array]';

/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneByTag$1(object, tag, isDeep) {
  var Ctor = object.constructor;
  switch (tag) {
    case arrayBufferTag$1:
      return cloneArrayBuffer(object);

    case boolTag$1:
    case dateTag$1:
      return new Ctor(+object);

    case dataViewTag$1:
      return cloneDataView(object, isDeep);

    case float32Tag$1: case float64Tag$1:
    case int8Tag$1: case int16Tag$1: case int32Tag$1:
    case uint8Tag$1: case uint8ClampedTag$1: case uint16Tag$1: case uint32Tag$1:
      return cloneTypedArray(object, isDeep);

    case mapTag$3:
      return new Ctor;

    case numberTag$1:
    case stringTag$1:
      return new Ctor(object);

    case regexpTag$1:
      return cloneRegExp(object);

    case setTag$3:
      return new Ctor;

    case symbolTag$1:
      return cloneSymbol(object);
  }
}

var _initCloneByTag = initCloneByTag$1;var getTag$3 = _getTag,
    isObjectLike$1 = isObjectLike_1;

/** `Object#toString` result references. */
var mapTag$2 = '[object Map]';

/**
 * The base implementation of `_.isMap` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 */
function baseIsMap$1(value) {
  return isObjectLike$1(value) && getTag$3(value) == mapTag$2;
}

var _baseIsMap = baseIsMap$1;var baseIsMap = _baseIsMap,
    baseUnary$4 = _baseUnary,
    nodeUtil$1 = _nodeUtil.exports;

/* Node.js helper references. */
var nodeIsMap = nodeUtil$1 && nodeUtil$1.isMap;

/**
 * Checks if `value` is classified as a `Map` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 * @example
 *
 * _.isMap(new Map);
 * // => true
 *
 * _.isMap(new WeakMap);
 * // => false
 */
var isMap$1 = nodeIsMap ? baseUnary$4(nodeIsMap) : baseIsMap;

var isMap_1 = isMap$1;var getTag$2 = _getTag,
    isObjectLike = isObjectLike_1;

/** `Object#toString` result references. */
var setTag$2 = '[object Set]';

/**
 * The base implementation of `_.isSet` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 */
function baseIsSet$1(value) {
  return isObjectLike(value) && getTag$2(value) == setTag$2;
}

var _baseIsSet = baseIsSet$1;var baseIsSet = _baseIsSet,
    baseUnary$3 = _baseUnary,
    nodeUtil = _nodeUtil.exports;

/* Node.js helper references. */
var nodeIsSet = nodeUtil && nodeUtil.isSet;

/**
 * Checks if `value` is classified as a `Set` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 * @example
 *
 * _.isSet(new Set);
 * // => true
 *
 * _.isSet(new WeakSet);
 * // => false
 */
var isSet$1 = nodeIsSet ? baseUnary$3(nodeIsSet) : baseIsSet;

var isSet_1 = isSet$1;var Stack = _Stack,
    arrayEach$1 = _arrayEach,
    assignValue = _assignValue,
    baseAssign = _baseAssign,
    baseAssignIn = _baseAssignIn,
    cloneBuffer = _cloneBuffer.exports,
    copyArray = _copyArray,
    copySymbols = _copySymbols,
    copySymbolsIn = _copySymbolsIn,
    getAllKeys = _getAllKeys,
    getAllKeysIn$1 = _getAllKeysIn,
    getTag$1 = _getTag,
    initCloneArray = _initCloneArray,
    initCloneByTag = _initCloneByTag,
    initCloneObject = _initCloneObject,
    isArray$4 = isArray_1,
    isBuffer$1 = isBuffer$7.exports,
    isMap = isMap_1,
    isObject$1 = isObject_1,
    isSet = isSet_1,
    keys$2 = keys_1,
    keysIn = keysIn_1;

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG$2 = 1,
    CLONE_FLAT_FLAG$1 = 2,
    CLONE_SYMBOLS_FLAG$2 = 4;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    mapTag$1 = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag$1 = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values supported by `_.clone`. */
var cloneableTags = {};
cloneableTags[argsTag] = cloneableTags[arrayTag] =
cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
cloneableTags[boolTag] = cloneableTags[dateTag] =
cloneableTags[float32Tag] = cloneableTags[float64Tag] =
cloneableTags[int8Tag] = cloneableTags[int16Tag] =
cloneableTags[int32Tag] = cloneableTags[mapTag$1] =
cloneableTags[numberTag] = cloneableTags[objectTag] =
cloneableTags[regexpTag] = cloneableTags[setTag$1] =
cloneableTags[stringTag] = cloneableTags[symbolTag] =
cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
cloneableTags[errorTag] = cloneableTags[funcTag] =
cloneableTags[weakMapTag] = false;

/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Deep clone
 *  2 - Flatten inherited properties
 *  4 - Clone symbols
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */
function baseClone$2(value, bitmask, customizer, key, object, stack) {
  var result,
      isDeep = bitmask & CLONE_DEEP_FLAG$2,
      isFlat = bitmask & CLONE_FLAT_FLAG$1,
      isFull = bitmask & CLONE_SYMBOLS_FLAG$2;

  if (customizer) {
    result = object ? customizer(value, key, object, stack) : customizer(value);
  }
  if (result !== undefined) {
    return result;
  }
  if (!isObject$1(value)) {
    return value;
  }
  var isArr = isArray$4(value);
  if (isArr) {
    result = initCloneArray(value);
    if (!isDeep) {
      return copyArray(value, result);
    }
  } else {
    var tag = getTag$1(value),
        isFunc = tag == funcTag || tag == genTag;

    if (isBuffer$1(value)) {
      return cloneBuffer(value, isDeep);
    }
    if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
      result = (isFlat || isFunc) ? {} : initCloneObject(value);
      if (!isDeep) {
        return isFlat
          ? copySymbolsIn(value, baseAssignIn(result, value))
          : copySymbols(value, baseAssign(result, value));
      }
    } else {
      if (!cloneableTags[tag]) {
        return object ? value : {};
      }
      result = initCloneByTag(value, tag, isDeep);
    }
  }
  // Check for circular references and return its corresponding clone.
  stack || (stack = new Stack);
  var stacked = stack.get(value);
  if (stacked) {
    return stacked;
  }
  stack.set(value, result);

  if (isSet(value)) {
    value.forEach(function(subValue) {
      result.add(baseClone$2(subValue, bitmask, customizer, subValue, value, stack));
    });
  } else if (isMap(value)) {
    value.forEach(function(subValue, key) {
      result.set(key, baseClone$2(subValue, bitmask, customizer, key, value, stack));
    });
  }

  var keysFunc = isFull
    ? (isFlat ? getAllKeysIn$1 : getAllKeys)
    : (isFlat ? keysIn : keys$2);

  var props = isArr ? undefined : keysFunc(value);
  arrayEach$1(props || value, function(subValue, key) {
    if (props) {
      key = subValue;
      subValue = value[key];
    }
    // Recursively populate clone (susceptible to call stack limits).
    assignValue(result, key, baseClone$2(subValue, bitmask, customizer, key, value, stack));
  });
  return result;
}

var _baseClone = baseClone$2;var baseClone$1 = _baseClone;

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG$1 = 1,
    CLONE_SYMBOLS_FLAG$1 = 4;

/**
 * This method is like `_.clone` except that it recursively clones `value`.
 *
 * @static
 * @memberOf _
 * @since 1.0.0
 * @category Lang
 * @param {*} value The value to recursively clone.
 * @returns {*} Returns the deep cloned value.
 * @see _.clone
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var deep = _.cloneDeep(objects);
 * console.log(deep[0] === objects[0]);
 * // => false
 */
function cloneDeep(value) {
  return baseClone$1(value, CLONE_DEEP_FLAG$1 | CLONE_SYMBOLS_FLAG$1);
}

var cloneDeep_1 = cloneDeep;Object.defineProperty(mergeClasses$1, "__esModule", {
  value: true
});
mergeClasses$1.mergeClasses = undefined;

var _forOwn2$1 = forOwn_1;

var _forOwn3$1 = _interopRequireDefault$m(_forOwn2$1);

var _cloneDeep2 = cloneDeep_1;

var _cloneDeep3 = _interopRequireDefault$m(_cloneDeep2);

var _extends$b = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _interopRequireDefault$m(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mergeClasses = mergeClasses$1.mergeClasses = function mergeClasses(classes) {
  var activeNames = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

  var styles = classes.default && (0, _cloneDeep3.default)(classes.default) || {};
  activeNames.map(function (name) {
    var toMerge = classes[name];
    if (toMerge) {
      (0, _forOwn3$1.default)(toMerge, function (value, key) {
        if (!styles[key]) {
          styles[key] = {};
        }

        styles[key] = _extends$b({}, styles[key], toMerge[key]);
      });
    }

    return name;
  });
  return styles;
};

mergeClasses$1.default = mergeClasses;var autoprefix$1 = {};Object.defineProperty(autoprefix$1, "__esModule", {
  value: true
});
autoprefix$1.autoprefix = undefined;

var _forOwn2 = forOwn_1;

var _forOwn3 = _interopRequireDefault$l(_forOwn2);

var _extends$a = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _interopRequireDefault$l(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var transforms = {
  borderRadius: function borderRadius(value) {
    return {
      msBorderRadius: value,
      MozBorderRadius: value,
      OBorderRadius: value,
      WebkitBorderRadius: value,
      borderRadius: value
    };
  },
  boxShadow: function boxShadow(value) {
    return {
      msBoxShadow: value,
      MozBoxShadow: value,
      OBoxShadow: value,
      WebkitBoxShadow: value,
      boxShadow: value
    };
  },
  userSelect: function userSelect(value) {
    return {
      WebkitTouchCallout: value,
      KhtmlUserSelect: value,
      MozUserSelect: value,
      msUserSelect: value,
      WebkitUserSelect: value,
      userSelect: value
    };
  },

  flex: function flex(value) {
    return {
      WebkitBoxFlex: value,
      MozBoxFlex: value,
      WebkitFlex: value,
      msFlex: value,
      flex: value
    };
  },
  flexBasis: function flexBasis(value) {
    return {
      WebkitFlexBasis: value,
      flexBasis: value
    };
  },
  justifyContent: function justifyContent(value) {
    return {
      WebkitJustifyContent: value,
      justifyContent: value
    };
  },

  transition: function transition(value) {
    return {
      msTransition: value,
      MozTransition: value,
      OTransition: value,
      WebkitTransition: value,
      transition: value
    };
  },

  transform: function transform(value) {
    return {
      msTransform: value,
      MozTransform: value,
      OTransform: value,
      WebkitTransform: value,
      transform: value
    };
  },
  absolute: function absolute(value) {
    var direction = value && value.split(' ');
    return {
      position: 'absolute',
      top: direction && direction[0],
      right: direction && direction[1],
      bottom: direction && direction[2],
      left: direction && direction[3]
    };
  },
  extend: function extend(name, otherElementStyles) {
    var otherStyle = otherElementStyles[name];
    if (otherStyle) {
      return otherStyle;
    }
    return {
      'extend': name
    };
  }
};

var autoprefix = autoprefix$1.autoprefix = function autoprefix(elements) {
  var prefixed = {};
  (0, _forOwn3.default)(elements, function (styles, element) {
    var expanded = {};
    (0, _forOwn3.default)(styles, function (value, key) {
      var transform = transforms[key];
      if (transform) {
        expanded = _extends$a({}, expanded, transform(value));
      } else {
        expanded[key] = value;
      }
    });
    prefixed[element] = expanded;
  });
  return prefixed;
};

autoprefix$1.default = autoprefix;var hover$1 = {};Object.defineProperty(hover$1, "__esModule", {
  value: true
});
hover$1.hover = undefined;

var _extends$9 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react$h = React__default['default'];

var _react2$h = _interopRequireDefault$k(_react$h);

function _interopRequireDefault$k(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck$a(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn$a(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits$a(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var hover = hover$1.hover = function hover(Component) {
  var Span = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'span';

  return function (_React$Component) {
    _inherits$a(Hover, _React$Component);

    function Hover() {
      var _ref;

      var _temp, _this, _ret;

      _classCallCheck$a(this, Hover);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn$a(this, (_ref = Hover.__proto__ || Object.getPrototypeOf(Hover)).call.apply(_ref, [this].concat(args))), _this), _this.state = { hover: false }, _this.handleMouseOver = function () {
        return _this.setState({ hover: true });
      }, _this.handleMouseOut = function () {
        return _this.setState({ hover: false });
      }, _this.render = function () {
        return _react2$h.default.createElement(
          Span,
          { onMouseOver: _this.handleMouseOver, onMouseOut: _this.handleMouseOut },
          _react2$h.default.createElement(Component, _extends$9({}, _this.props, _this.state))
        );
      }, _temp), _possibleConstructorReturn$a(_this, _ret);
    }

    return Hover;
  }(_react2$h.default.Component);
};

hover$1.default = hover;var active$1 = {};Object.defineProperty(active$1, "__esModule", {
  value: true
});
active$1.active = undefined;

var _extends$8 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react$g = React__default['default'];

var _react2$g = _interopRequireDefault$j(_react$g);

function _interopRequireDefault$j(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck$9(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn$9(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits$9(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var active = active$1.active = function active(Component) {
  var Span = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'span';

  return function (_React$Component) {
    _inherits$9(Active, _React$Component);

    function Active() {
      var _ref;

      var _temp, _this, _ret;

      _classCallCheck$9(this, Active);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn$9(this, (_ref = Active.__proto__ || Object.getPrototypeOf(Active)).call.apply(_ref, [this].concat(args))), _this), _this.state = { active: false }, _this.handleMouseDown = function () {
        return _this.setState({ active: true });
      }, _this.handleMouseUp = function () {
        return _this.setState({ active: false });
      }, _this.render = function () {
        return _react2$g.default.createElement(
          Span,
          { onMouseDown: _this.handleMouseDown, onMouseUp: _this.handleMouseUp },
          _react2$g.default.createElement(Component, _extends$8({}, _this.props, _this.state))
        );
      }, _temp), _possibleConstructorReturn$9(_this, _ret);
    }

    return Active;
  }(_react2$g.default.Component);
};

active$1.default = active;var loop = {};Object.defineProperty(loop, "__esModule", {
  value: true
});
var loopable = function loopable(i, length) {
  var props = {};
  var setProp = function setProp(name) {
    var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

    props[name] = value;
  };

  i === 0 && setProp('first-child');
  i === length - 1 && setProp('last-child');
  (i === 0 || i % 2 === 0) && setProp('even');
  Math.abs(i % 2) === 1 && setProp('odd');
  setProp('nth-child', i);

  return props;
};

loop.default = loopable;Object.defineProperty(lib$1, "__esModule", {
  value: true
});
lib$1.ReactCSS = lib$1.loop = lib$1.handleActive = lib$1.handleHover = lib$1.hover = undefined;

var _flattenNames = flattenNames$1;

var _flattenNames2 = _interopRequireDefault$i(_flattenNames);

var _mergeClasses = mergeClasses$1;

var _mergeClasses2 = _interopRequireDefault$i(_mergeClasses);

var _autoprefix = autoprefix$1;

var _autoprefix2 = _interopRequireDefault$i(_autoprefix);

var _hover2 = hover$1;

var _hover3 = _interopRequireDefault$i(_hover2);

var _active = active$1;

var _active2 = _interopRequireDefault$i(_active);

var _loop2 = loop;

var _loop3 = _interopRequireDefault$i(_loop2);

function _interopRequireDefault$i(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

lib$1.hover = _hover3.default;
lib$1.handleHover = _hover3.default;
lib$1.handleActive = _active2.default;
lib$1.loop = _loop3.default;
var ReactCSS = lib$1.ReactCSS = function ReactCSS(classes) {
  for (var _len = arguments.length, activations = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    activations[_key - 1] = arguments[_key];
  }

  var activeNames = (0, _flattenNames2.default)(activations);
  var merged = (0, _mergeClasses2.default)(classes, activeNames);
  return (0, _autoprefix2.default)(merged);
};

lib$1.default = ReactCSS;var common = {};var Alpha$1 = {};var alpha$1 = {};Object.defineProperty(alpha$1, "__esModule", {
  value: true
});
alpha$1.calculateChange = function calculateChange(e, hsl, direction, initialA, container) {
  var containerWidth = container.clientWidth;
  var containerHeight = container.clientHeight;
  var x = typeof e.pageX === 'number' ? e.pageX : e.touches[0].pageX;
  var y = typeof e.pageY === 'number' ? e.pageY : e.touches[0].pageY;
  var left = x - (container.getBoundingClientRect().left + window.pageXOffset);
  var top = y - (container.getBoundingClientRect().top + window.pageYOffset);

  if (direction === 'vertical') {
    var a = void 0;
    if (top < 0) {
      a = 0;
    } else if (top > containerHeight) {
      a = 1;
    } else {
      a = Math.round(top * 100 / containerHeight) / 100;
    }

    if (hsl.a !== a) {
      return {
        h: hsl.h,
        s: hsl.s,
        l: hsl.l,
        a: a,
        source: 'rgb'
      };
    }
  } else {
    var _a = void 0;
    if (left < 0) {
      _a = 0;
    } else if (left > containerWidth) {
      _a = 1;
    } else {
      _a = Math.round(left * 100 / containerWidth) / 100;
    }

    if (initialA !== _a) {
      return {
        h: hsl.h,
        s: hsl.s,
        l: hsl.l,
        a: _a,
        source: 'rgb'
      };
    }
  }
  return null;
};var Checkboard$1 = {};var checkboard$1 = {};Object.defineProperty(checkboard$1, "__esModule", {
  value: true
});
var checkboardCache = {};

var render = checkboard$1.render = function render(c1, c2, size, serverCanvas) {
  if (typeof document === 'undefined' && !serverCanvas) {
    return null;
  }
  var canvas = serverCanvas ? new serverCanvas() : document.createElement('canvas');
  canvas.width = size * 2;
  canvas.height = size * 2;
  var ctx = canvas.getContext('2d');
  if (!ctx) {
    return null;
  } // If no context can be found, return early.
  ctx.fillStyle = c1;
  ctx.fillRect(0, 0, canvas.width, canvas.height);
  ctx.fillStyle = c2;
  ctx.fillRect(0, 0, size, size);
  ctx.translate(size, size);
  ctx.fillRect(0, 0, size, size);
  return canvas.toDataURL();
};

checkboard$1.get = function get(c1, c2, size, serverCanvas) {
  var key = c1 + '-' + c2 + '-' + size + (serverCanvas ? '-server' : '');

  if (checkboardCache[key]) {
    return checkboardCache[key];
  }

  var checkboard = render(c1, c2, size, serverCanvas);
  checkboardCache[key] = checkboard;
  return checkboard;
};Object.defineProperty(Checkboard$1, "__esModule", {
  value: true
});
Checkboard$1.Checkboard = undefined;

var _extends$7 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react$f = React__default['default'];

var _react2$f = _interopRequireDefault$h(_react$f);

var _reactcss$a = lib$1;

var _reactcss2$a = _interopRequireDefault$h(_reactcss$a);

var _checkboard = checkboard$1;

var checkboard = _interopRequireWildcard$5(_checkboard);

function _interopRequireWildcard$5(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault$h(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Checkboard = Checkboard$1.Checkboard = function Checkboard(_ref) {
  var white = _ref.white,
      grey = _ref.grey,
      size = _ref.size,
      renderers = _ref.renderers,
      borderRadius = _ref.borderRadius,
      boxShadow = _ref.boxShadow,
      children = _ref.children;

  var styles = (0, _reactcss2$a.default)({
    'default': {
      grid: {
        borderRadius: borderRadius,
        boxShadow: boxShadow,
        absolute: '0px 0px 0px 0px',
        background: 'url(' + checkboard.get(white, grey, size, renderers.canvas) + ') center left'
      }
    }
  });
  return (0, _react$f.isValidElement)(children) ? _react2$f.default.cloneElement(children, _extends$7({}, children.props, { style: _extends$7({}, children.props.style, styles.grid) })) : _react2$f.default.createElement('div', { style: styles.grid });
};

Checkboard.defaultProps = {
  size: 8,
  white: 'transparent',
  grey: 'rgba(0,0,0,.08)',
  renderers: {}
};

Checkboard$1.default = Checkboard;Object.defineProperty(Alpha$1, "__esModule", {
  value: true
});
Alpha$1.Alpha = undefined;

var _extends$6 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass$8 = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react$e = React__default['default'];

var _react2$e = _interopRequireDefault$g(_react$e);

var _reactcss$9 = lib$1;

var _reactcss2$9 = _interopRequireDefault$g(_reactcss$9);

var _alpha = alpha$1;

var alpha = _interopRequireWildcard$4(_alpha);

var _Checkboard$1 = Checkboard$1;

var _Checkboard2$1 = _interopRequireDefault$g(_Checkboard$1);

function _interopRequireWildcard$4(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault$g(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck$8(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn$8(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits$8(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Alpha = Alpha$1.Alpha = function (_ref) {
  _inherits$8(Alpha, _ref);

  function Alpha() {
    var _ref2;

    var _temp, _this, _ret;

    _classCallCheck$8(this, Alpha);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn$8(this, (_ref2 = Alpha.__proto__ || Object.getPrototypeOf(Alpha)).call.apply(_ref2, [this].concat(args))), _this), _this.handleChange = function (e) {
      var change = alpha.calculateChange(e, _this.props.hsl, _this.props.direction, _this.props.a, _this.container);
      change && typeof _this.props.onChange === 'function' && _this.props.onChange(change, e);
    }, _this.handleMouseDown = function (e) {
      _this.handleChange(e);
      window.addEventListener('mousemove', _this.handleChange);
      window.addEventListener('mouseup', _this.handleMouseUp);
    }, _this.handleMouseUp = function () {
      _this.unbindEventListeners();
    }, _this.unbindEventListeners = function () {
      window.removeEventListener('mousemove', _this.handleChange);
      window.removeEventListener('mouseup', _this.handleMouseUp);
    }, _temp), _possibleConstructorReturn$8(_this, _ret);
  }

  _createClass$8(Alpha, [{
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.unbindEventListeners();
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var rgb = this.props.rgb;
      var styles = (0, _reactcss2$9.default)({
        'default': {
          alpha: {
            absolute: '0px 0px 0px 0px',
            borderRadius: this.props.radius
          },
          checkboard: {
            absolute: '0px 0px 0px 0px',
            overflow: 'hidden',
            borderRadius: this.props.radius
          },
          gradient: {
            absolute: '0px 0px 0px 0px',
            background: 'linear-gradient(to right, rgba(' + rgb.r + ',' + rgb.g + ',' + rgb.b + ', 0) 0%,\n           rgba(' + rgb.r + ',' + rgb.g + ',' + rgb.b + ', 1) 100%)',
            boxShadow: this.props.shadow,
            borderRadius: this.props.radius
          },
          container: {
            position: 'relative',
            height: '100%',
            margin: '0 3px'
          },
          pointer: {
            position: 'absolute',
            left: rgb.a * 100 + '%'
          },
          slider: {
            width: '4px',
            borderRadius: '1px',
            height: '8px',
            boxShadow: '0 0 2px rgba(0, 0, 0, .6)',
            background: '#fff',
            marginTop: '1px',
            transform: 'translateX(-2px)'
          }
        },
        'vertical': {
          gradient: {
            background: 'linear-gradient(to bottom, rgba(' + rgb.r + ',' + rgb.g + ',' + rgb.b + ', 0) 0%,\n           rgba(' + rgb.r + ',' + rgb.g + ',' + rgb.b + ', 1) 100%)'
          },
          pointer: {
            left: 0,
            top: rgb.a * 100 + '%'
          }
        },
        'overwrite': _extends$6({}, this.props.style)
      }, {
        vertical: this.props.direction === 'vertical',
        overwrite: true
      });

      return _react2$e.default.createElement(
        'div',
        { style: styles.alpha },
        _react2$e.default.createElement(
          'div',
          { style: styles.checkboard },
          _react2$e.default.createElement(_Checkboard2$1.default, { renderers: this.props.renderers })
        ),
        _react2$e.default.createElement('div', { style: styles.gradient }),
        _react2$e.default.createElement(
          'div',
          {
            style: styles.container,
            ref: function ref(container) {
              return _this2.container = container;
            },
            onMouseDown: this.handleMouseDown,
            onTouchMove: this.handleChange,
            onTouchStart: this.handleChange
          },
          _react2$e.default.createElement(
            'div',
            { style: styles.pointer },
            this.props.pointer ? _react2$e.default.createElement(this.props.pointer, this.props) : _react2$e.default.createElement('div', { style: styles.slider })
          )
        )
      );
    }
  }]);

  return Alpha;
}(_react$e.PureComponent || _react$e.Component);

Alpha$1.default = Alpha;var EditableInput$1 = {};Object.defineProperty(EditableInput$1, "__esModule", {
  value: true
});
EditableInput$1.EditableInput = undefined;

var _createClass$7 = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react$d = React__default['default'];

var _react2$d = _interopRequireDefault$f(_react$d);

var _reactcss$8 = lib$1;

var _reactcss2$8 = _interopRequireDefault$f(_reactcss$8);

function _interopRequireDefault$f(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty$2(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck$7(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn$7(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits$7(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DEFAULT_ARROW_OFFSET = 1;

var UP_KEY_CODE = 38;
var DOWN_KEY_CODE = 40;
var VALID_KEY_CODES = [UP_KEY_CODE, DOWN_KEY_CODE];
var isValidKeyCode = function isValidKeyCode(keyCode) {
  return VALID_KEY_CODES.indexOf(keyCode) > -1;
};
var getNumberValue = function getNumberValue(value) {
  return Number(String(value).replace(/%/g, ''));
};

var idCounter = 1;

var EditableInput = EditableInput$1.EditableInput = function (_ref) {
  _inherits$7(EditableInput, _ref);

  function EditableInput(props) {
    _classCallCheck$7(this, EditableInput);

    var _this = _possibleConstructorReturn$7(this, (EditableInput.__proto__ || Object.getPrototypeOf(EditableInput)).call(this));

    _this.handleBlur = function () {
      if (_this.state.blurValue) {
        _this.setState({ value: _this.state.blurValue, blurValue: null });
      }
    };

    _this.handleChange = function (e) {
      _this.setUpdatedValue(e.target.value, e);
    };

    _this.handleKeyDown = function (e) {
      // In case `e.target.value` is a percentage remove the `%` character
      // and update accordingly with a percentage
      // https://github.com/casesandberg/react-color/issues/383
      var value = getNumberValue(e.target.value);
      if (!isNaN(value) && isValidKeyCode(e.keyCode)) {
        var offset = _this.getArrowOffset();
        var updatedValue = e.keyCode === UP_KEY_CODE ? value + offset : value - offset;

        _this.setUpdatedValue(updatedValue, e);
      }
    };

    _this.handleDrag = function (e) {
      if (_this.props.dragLabel) {
        var newValue = Math.round(_this.props.value + e.movementX);
        if (newValue >= 0 && newValue <= _this.props.dragMax) {
          _this.props.onChange && _this.props.onChange(_this.getValueObjectWithLabel(newValue), e);
        }
      }
    };

    _this.handleMouseDown = function (e) {
      if (_this.props.dragLabel) {
        e.preventDefault();
        _this.handleDrag(e);
        window.addEventListener('mousemove', _this.handleDrag);
        window.addEventListener('mouseup', _this.handleMouseUp);
      }
    };

    _this.handleMouseUp = function () {
      _this.unbindEventListeners();
    };

    _this.unbindEventListeners = function () {
      window.removeEventListener('mousemove', _this.handleDrag);
      window.removeEventListener('mouseup', _this.handleMouseUp);
    };

    _this.state = {
      value: String(props.value).toUpperCase(),
      blurValue: String(props.value).toUpperCase()
    };

    _this.inputId = 'rc-editable-input-' + idCounter++;
    return _this;
  }

  _createClass$7(EditableInput, [{
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      if (this.props.value !== this.state.value && (prevProps.value !== this.props.value || prevState.value !== this.state.value)) {
        if (this.input === document.activeElement) {
          this.setState({ blurValue: String(this.props.value).toUpperCase() });
        } else {
          this.setState({ value: String(this.props.value).toUpperCase(), blurValue: !this.state.blurValue && String(this.props.value).toUpperCase() });
        }
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.unbindEventListeners();
    }
  }, {
    key: 'getValueObjectWithLabel',
    value: function getValueObjectWithLabel(value) {
      return _defineProperty$2({}, this.props.label, value);
    }
  }, {
    key: 'getArrowOffset',
    value: function getArrowOffset() {
      return this.props.arrowOffset || DEFAULT_ARROW_OFFSET;
    }
  }, {
    key: 'setUpdatedValue',
    value: function setUpdatedValue(value, e) {
      var onChangeValue = this.props.label ? this.getValueObjectWithLabel(value) : value;
      this.props.onChange && this.props.onChange(onChangeValue, e);

      this.setState({ value: value });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var styles = (0, _reactcss2$8.default)({
        'default': {
          wrap: {
            position: 'relative'
          }
        },
        'user-override': {
          wrap: this.props.style && this.props.style.wrap ? this.props.style.wrap : {},
          input: this.props.style && this.props.style.input ? this.props.style.input : {},
          label: this.props.style && this.props.style.label ? this.props.style.label : {}
        },
        'dragLabel-true': {
          label: {
            cursor: 'ew-resize'
          }
        }
      }, {
        'user-override': true
      }, this.props);

      return _react2$d.default.createElement(
        'div',
        { style: styles.wrap },
        _react2$d.default.createElement('input', {
          id: this.inputId,
          style: styles.input,
          ref: function ref(input) {
            return _this2.input = input;
          },
          value: this.state.value,
          onKeyDown: this.handleKeyDown,
          onChange: this.handleChange,
          onBlur: this.handleBlur,
          placeholder: this.props.placeholder,
          spellCheck: 'false'
        }),
        this.props.label && !this.props.hideLabel ? _react2$d.default.createElement(
          'label',
          {
            htmlFor: this.inputId,
            style: styles.label,
            onMouseDown: this.handleMouseDown
          },
          this.props.label
        ) : null
      );
    }
  }]);

  return EditableInput;
}(_react$d.PureComponent || _react$d.Component);

EditableInput$1.default = EditableInput;var Hue$1 = {};var hue$1 = {};Object.defineProperty(hue$1, "__esModule", {
  value: true
});
hue$1.calculateChange = function calculateChange(e, direction, hsl, container) {
  var containerWidth = container.clientWidth;
  var containerHeight = container.clientHeight;
  var x = typeof e.pageX === 'number' ? e.pageX : e.touches[0].pageX;
  var y = typeof e.pageY === 'number' ? e.pageY : e.touches[0].pageY;
  var left = x - (container.getBoundingClientRect().left + window.pageXOffset);
  var top = y - (container.getBoundingClientRect().top + window.pageYOffset);

  if (direction === 'vertical') {
    var h = void 0;
    if (top < 0) {
      h = 359;
    } else if (top > containerHeight) {
      h = 0;
    } else {
      var percent = -(top * 100 / containerHeight) + 100;
      h = 360 * percent / 100;
    }

    if (hsl.h !== h) {
      return {
        h: h,
        s: hsl.s,
        l: hsl.l,
        a: hsl.a,
        source: 'hsl'
      };
    }
  } else {
    var _h = void 0;
    if (left < 0) {
      _h = 0;
    } else if (left > containerWidth) {
      _h = 359;
    } else {
      var _percent = left * 100 / containerWidth;
      _h = 360 * _percent / 100;
    }

    if (hsl.h !== _h) {
      return {
        h: _h,
        s: hsl.s,
        l: hsl.l,
        a: hsl.a,
        source: 'hsl'
      };
    }
  }
  return null;
};Object.defineProperty(Hue$1, "__esModule", {
  value: true
});
Hue$1.Hue = undefined;

var _createClass$6 = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react$c = React__default['default'];

var _react2$c = _interopRequireDefault$e(_react$c);

var _reactcss$7 = lib$1;

var _reactcss2$7 = _interopRequireDefault$e(_reactcss$7);

var _hue = hue$1;

var hue = _interopRequireWildcard$3(_hue);

function _interopRequireWildcard$3(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault$e(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck$6(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn$6(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits$6(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Hue = Hue$1.Hue = function (_ref) {
  _inherits$6(Hue, _ref);

  function Hue() {
    var _ref2;

    var _temp, _this, _ret;

    _classCallCheck$6(this, Hue);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn$6(this, (_ref2 = Hue.__proto__ || Object.getPrototypeOf(Hue)).call.apply(_ref2, [this].concat(args))), _this), _this.handleChange = function (e) {
      var change = hue.calculateChange(e, _this.props.direction, _this.props.hsl, _this.container);
      change && typeof _this.props.onChange === 'function' && _this.props.onChange(change, e);
    }, _this.handleMouseDown = function (e) {
      _this.handleChange(e);
      window.addEventListener('mousemove', _this.handleChange);
      window.addEventListener('mouseup', _this.handleMouseUp);
    }, _this.handleMouseUp = function () {
      _this.unbindEventListeners();
    }, _temp), _possibleConstructorReturn$6(_this, _ret);
  }

  _createClass$6(Hue, [{
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.unbindEventListeners();
    }
  }, {
    key: 'unbindEventListeners',
    value: function unbindEventListeners() {
      window.removeEventListener('mousemove', this.handleChange);
      window.removeEventListener('mouseup', this.handleMouseUp);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props$direction = this.props.direction,
          direction = _props$direction === undefined ? 'horizontal' : _props$direction;


      var styles = (0, _reactcss2$7.default)({
        'default': {
          hue: {
            absolute: '0px 0px 0px 0px',
            borderRadius: this.props.radius,
            boxShadow: this.props.shadow
          },
          container: {
            padding: '0 2px',
            position: 'relative',
            height: '100%',
            borderRadius: this.props.radius
          },
          pointer: {
            position: 'absolute',
            left: this.props.hsl.h * 100 / 360 + '%'
          },
          slider: {
            marginTop: '1px',
            width: '4px',
            borderRadius: '1px',
            height: '8px',
            boxShadow: '0 0 2px rgba(0, 0, 0, .6)',
            background: '#fff',
            transform: 'translateX(-2px)'
          }
        },
        'vertical': {
          pointer: {
            left: '0px',
            top: -(this.props.hsl.h * 100 / 360) + 100 + '%'
          }
        }
      }, { vertical: direction === 'vertical' });

      return _react2$c.default.createElement(
        'div',
        { style: styles.hue },
        _react2$c.default.createElement(
          'div',
          {
            className: 'hue-' + direction,
            style: styles.container,
            ref: function ref(container) {
              return _this2.container = container;
            },
            onMouseDown: this.handleMouseDown,
            onTouchMove: this.handleChange,
            onTouchStart: this.handleChange
          },
          _react2$c.default.createElement(
            'style',
            null,
            '\n            .hue-horizontal {\n              background: linear-gradient(to right, #f00 0%, #ff0 17%, #0f0\n                33%, #0ff 50%, #00f 67%, #f0f 83%, #f00 100%);\n              background: -webkit-linear-gradient(to right, #f00 0%, #ff0\n                17%, #0f0 33%, #0ff 50%, #00f 67%, #f0f 83%, #f00 100%);\n            }\n\n            .hue-vertical {\n              background: linear-gradient(to top, #f00 0%, #ff0 17%, #0f0 33%,\n                #0ff 50%, #00f 67%, #f0f 83%, #f00 100%);\n              background: -webkit-linear-gradient(to top, #f00 0%, #ff0 17%,\n                #0f0 33%, #0ff 50%, #00f 67%, #f0f 83%, #f00 100%);\n            }\n          '
          ),
          _react2$c.default.createElement(
            'div',
            { style: styles.pointer },
            this.props.pointer ? _react2$c.default.createElement(this.props.pointer, this.props) : _react2$c.default.createElement('div', { style: styles.slider })
          )
        )
      );
    }
  }]);

  return Hue;
}(_react$c.PureComponent || _react$c.Component);

Hue$1.default = Hue;var Raised$1 = {};Object.defineProperty(Raised$1, "__esModule", {
  value: true
});
Raised$1.Raised = undefined;

var _react$b = React__default['default'];

var _react2$b = _interopRequireDefault$d(_react$b);

var _propTypes$2 = PropTypes__default['default'];

var _propTypes2$2 = _interopRequireDefault$d(_propTypes$2);

var _reactcss$6 = lib$1;

var _reactcss2$6 = _interopRequireDefault$d(_reactcss$6);

var _merge$1 = merge_1;

var _merge2$1 = _interopRequireDefault$d(_merge$1);

function _interopRequireDefault$d(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Raised = Raised$1.Raised = function Raised(_ref) {
  var zDepth = _ref.zDepth,
      radius = _ref.radius,
      background = _ref.background,
      children = _ref.children,
      _ref$styles = _ref.styles,
      passedStyles = _ref$styles === undefined ? {} : _ref$styles;

  var styles = (0, _reactcss2$6.default)((0, _merge2$1.default)({
    'default': {
      wrap: {
        position: 'relative',
        display: 'inline-block'
      },
      content: {
        position: 'relative'
      },
      bg: {
        absolute: '0px 0px 0px 0px',
        boxShadow: '0 ' + zDepth + 'px ' + zDepth * 4 + 'px rgba(0,0,0,.24)',
        borderRadius: radius,
        background: background
      }
    },
    'zDepth-0': {
      bg: {
        boxShadow: 'none'
      }
    },

    'zDepth-1': {
      bg: {
        boxShadow: '0 2px 10px rgba(0,0,0,.12), 0 2px 5px rgba(0,0,0,.16)'
      }
    },
    'zDepth-2': {
      bg: {
        boxShadow: '0 6px 20px rgba(0,0,0,.19), 0 8px 17px rgba(0,0,0,.2)'
      }
    },
    'zDepth-3': {
      bg: {
        boxShadow: '0 17px 50px rgba(0,0,0,.19), 0 12px 15px rgba(0,0,0,.24)'
      }
    },
    'zDepth-4': {
      bg: {
        boxShadow: '0 25px 55px rgba(0,0,0,.21), 0 16px 28px rgba(0,0,0,.22)'
      }
    },
    'zDepth-5': {
      bg: {
        boxShadow: '0 40px 77px rgba(0,0,0,.22), 0 27px 24px rgba(0,0,0,.2)'
      }
    },
    'square': {
      bg: {
        borderRadius: '0'
      }
    },
    'circle': {
      bg: {
        borderRadius: '50%'
      }
    }
  }, passedStyles), { 'zDepth-1': zDepth === 1 });

  return _react2$b.default.createElement(
    'div',
    { style: styles.wrap },
    _react2$b.default.createElement('div', { style: styles.bg }),
    _react2$b.default.createElement(
      'div',
      { style: styles.content },
      children
    )
  );
};

Raised.propTypes = {
  background: _propTypes2$2.default.string,
  zDepth: _propTypes2$2.default.oneOf([0, 1, 2, 3, 4, 5]),
  radius: _propTypes2$2.default.number,
  styles: _propTypes2$2.default.object
};

Raised.defaultProps = {
  background: '#fff',
  zDepth: 1,
  radius: 2,
  styles: {}
};

Raised$1.default = Raised;var Saturation$1 = {};var debounce$1 = debounce_1,
    isObject = isObject_1;

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a throttled function that only invokes `func` at most once per
 * every `wait` milliseconds. The throttled function comes with a `cancel`
 * method to cancel delayed `func` invocations and a `flush` method to
 * immediately invoke them. Provide `options` to indicate whether `func`
 * should be invoked on the leading and/or trailing edge of the `wait`
 * timeout. The `func` is invoked with the last arguments provided to the
 * throttled function. Subsequent calls to the throttled function return the
 * result of the last `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the throttled function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.throttle` and `_.debounce`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to throttle.
 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=true]
 *  Specify invoking on the leading edge of the timeout.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new throttled function.
 * @example
 *
 * // Avoid excessively updating the position while scrolling.
 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
 *
 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
 * jQuery(element).on('click', throttled);
 *
 * // Cancel the trailing throttled invocation.
 * jQuery(window).on('popstate', throttled.cancel);
 */
function throttle$1(func, wait, options) {
  var leading = true,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  if (isObject(options)) {
    leading = 'leading' in options ? !!options.leading : leading;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }
  return debounce$1(func, wait, {
    'leading': leading,
    'maxWait': wait,
    'trailing': trailing
  });
}

var throttle_1 = throttle$1;var saturation$1 = {};Object.defineProperty(saturation$1, "__esModule", {
  value: true
});
saturation$1.calculateChange = function calculateChange(e, hsl, container) {
  var _container$getBoundin = container.getBoundingClientRect(),
      containerWidth = _container$getBoundin.width,
      containerHeight = _container$getBoundin.height;

  var x = typeof e.pageX === 'number' ? e.pageX : e.touches[0].pageX;
  var y = typeof e.pageY === 'number' ? e.pageY : e.touches[0].pageY;
  var left = x - (container.getBoundingClientRect().left + window.pageXOffset);
  var top = y - (container.getBoundingClientRect().top + window.pageYOffset);

  if (left < 0) {
    left = 0;
  } else if (left > containerWidth) {
    left = containerWidth;
  }

  if (top < 0) {
    top = 0;
  } else if (top > containerHeight) {
    top = containerHeight;
  }

  var saturation = left / containerWidth;
  var bright = 1 - top / containerHeight;

  return {
    h: hsl.h,
    s: saturation,
    v: bright,
    a: hsl.a,
    source: 'hsv'
  };
};Object.defineProperty(Saturation$1, "__esModule", {
  value: true
});
Saturation$1.Saturation = undefined;

var _createClass$5 = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react$a = React__default['default'];

var _react2$a = _interopRequireDefault$c(_react$a);

var _reactcss$5 = lib$1;

var _reactcss2$5 = _interopRequireDefault$c(_reactcss$5);

var _throttle = throttle_1;

var _throttle2 = _interopRequireDefault$c(_throttle);

var _saturation = saturation$1;

var saturation = _interopRequireWildcard$2(_saturation);

function _interopRequireWildcard$2(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault$c(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck$5(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn$5(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits$5(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Saturation = Saturation$1.Saturation = function (_ref) {
  _inherits$5(Saturation, _ref);

  function Saturation(props) {
    _classCallCheck$5(this, Saturation);

    var _this = _possibleConstructorReturn$5(this, (Saturation.__proto__ || Object.getPrototypeOf(Saturation)).call(this, props));

    _this.handleChange = function (e) {
      typeof _this.props.onChange === 'function' && _this.throttle(_this.props.onChange, saturation.calculateChange(e, _this.props.hsl, _this.container), e);
    };

    _this.handleMouseDown = function (e) {
      _this.handleChange(e);
      var renderWindow = _this.getContainerRenderWindow();
      renderWindow.addEventListener('mousemove', _this.handleChange);
      renderWindow.addEventListener('mouseup', _this.handleMouseUp);
    };

    _this.handleMouseUp = function () {
      _this.unbindEventListeners();
    };

    _this.throttle = (0, _throttle2.default)(function (fn, data, e) {
      fn(data, e);
    }, 50);
    return _this;
  }

  _createClass$5(Saturation, [{
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.throttle.cancel();
      this.unbindEventListeners();
    }
  }, {
    key: 'getContainerRenderWindow',
    value: function getContainerRenderWindow() {
      var container = this.container;

      var renderWindow = window;
      while (!renderWindow.document.contains(container) && renderWindow.parent !== renderWindow) {
        renderWindow = renderWindow.parent;
      }
      return renderWindow;
    }
  }, {
    key: 'unbindEventListeners',
    value: function unbindEventListeners() {
      var renderWindow = this.getContainerRenderWindow();
      renderWindow.removeEventListener('mousemove', this.handleChange);
      renderWindow.removeEventListener('mouseup', this.handleMouseUp);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _ref2 = this.props.style || {},
          color = _ref2.color,
          white = _ref2.white,
          black = _ref2.black,
          pointer = _ref2.pointer,
          circle = _ref2.circle;

      var styles = (0, _reactcss2$5.default)({
        'default': {
          color: {
            absolute: '0px 0px 0px 0px',
            background: 'hsl(' + this.props.hsl.h + ',100%, 50%)',
            borderRadius: this.props.radius
          },
          white: {
            absolute: '0px 0px 0px 0px',
            borderRadius: this.props.radius
          },
          black: {
            absolute: '0px 0px 0px 0px',
            boxShadow: this.props.shadow,
            borderRadius: this.props.radius
          },
          pointer: {
            position: 'absolute',
            top: -(this.props.hsv.v * 100) + 100 + '%',
            left: this.props.hsv.s * 100 + '%',
            cursor: 'default'
          },
          circle: {
            width: '4px',
            height: '4px',
            boxShadow: '0 0 0 1.5px #fff, inset 0 0 1px 1px rgba(0,0,0,.3),\n            0 0 1px 2px rgba(0,0,0,.4)',
            borderRadius: '50%',
            cursor: 'hand',
            transform: 'translate(-2px, -2px)'
          }
        },
        'custom': {
          color: color,
          white: white,
          black: black,
          pointer: pointer,
          circle: circle
        }
      }, { 'custom': !!this.props.style });

      return _react2$a.default.createElement(
        'div',
        {
          style: styles.color,
          ref: function ref(container) {
            return _this2.container = container;
          },
          onMouseDown: this.handleMouseDown,
          onTouchMove: this.handleChange,
          onTouchStart: this.handleChange
        },
        _react2$a.default.createElement(
          'style',
          null,
          '\n          .saturation-white {\n            background: -webkit-linear-gradient(to right, #fff, rgba(255,255,255,0));\n            background: linear-gradient(to right, #fff, rgba(255,255,255,0));\n          }\n          .saturation-black {\n            background: -webkit-linear-gradient(to top, #000, rgba(0,0,0,0));\n            background: linear-gradient(to top, #000, rgba(0,0,0,0));\n          }\n        '
        ),
        _react2$a.default.createElement(
          'div',
          { style: styles.white, className: 'saturation-white' },
          _react2$a.default.createElement('div', { style: styles.black, className: 'saturation-black' }),
          _react2$a.default.createElement(
            'div',
            { style: styles.pointer },
            this.props.pointer ? _react2$a.default.createElement(this.props.pointer, this.props) : _react2$a.default.createElement('div', { style: styles.circle })
          )
        )
      );
    }
  }]);

  return Saturation;
}(_react$a.PureComponent || _react$a.Component);

Saturation$1.default = Saturation;var ColorWrap$1 = {};var color$2 = {};var arrayEach = _arrayEach,
    baseEach$1 = _baseEach,
    castFunction = _castFunction,
    isArray$3 = isArray_1;

/**
 * Iterates over elements of `collection` and invokes `iteratee` for each element.
 * The iteratee is invoked with three arguments: (value, index|key, collection).
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * **Note:** As with other "Collections" methods, objects with a "length"
 * property are iterated like arrays. To avoid this behavior use `_.forIn`
 * or `_.forOwn` for object iteration.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @alias each
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 * @see _.forEachRight
 * @example
 *
 * _.forEach([1, 2], function(value) {
 *   console.log(value);
 * });
 * // => Logs `1` then `2`.
 *
 * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
 *   console.log(key);
 * });
 * // => Logs 'a' then 'b' (iteration order is not guaranteed).
 */
function forEach(collection, iteratee) {
  var func = isArray$3(collection) ? arrayEach : baseEach$1;
  return func(collection, castFunction(iteratee));
}

var forEach_1 = forEach;var each$1 = forEach_1;var tinycolor = {exports: {}};(function (module) {
// TinyColor v1.4.2
// https://github.com/bgrins/TinyColor
// Brian Grinstead, MIT License

(function(Math) {

var trimLeft = /^\s+/,
    trimRight = /\s+$/,
    tinyCounter = 0,
    mathRound = Math.round,
    mathMin = Math.min,
    mathMax = Math.max,
    mathRandom = Math.random;

function tinycolor (color, opts) {

    color = (color) ? color : '';
    opts = opts || { };

    // If input is already a tinycolor, return itself
    if (color instanceof tinycolor) {
       return color;
    }
    // If we are called as a function, call using new instead
    if (!(this instanceof tinycolor)) {
        return new tinycolor(color, opts);
    }

    var rgb = inputToRGB(color);
    this._originalInput = color,
    this._r = rgb.r,
    this._g = rgb.g,
    this._b = rgb.b,
    this._a = rgb.a,
    this._roundA = mathRound(100*this._a) / 100,
    this._format = opts.format || rgb.format;
    this._gradientType = opts.gradientType;

    // Don't let the range of [0,255] come back in [0,1].
    // Potentially lose a little bit of precision here, but will fix issues where
    // .5 gets interpreted as half of the total, instead of half of 1
    // If it was supposed to be 128, this was already taken care of by `inputToRgb`
    if (this._r < 1) { this._r = mathRound(this._r); }
    if (this._g < 1) { this._g = mathRound(this._g); }
    if (this._b < 1) { this._b = mathRound(this._b); }

    this._ok = rgb.ok;
    this._tc_id = tinyCounter++;
}

tinycolor.prototype = {
    isDark: function() {
        return this.getBrightness() < 128;
    },
    isLight: function() {
        return !this.isDark();
    },
    isValid: function() {
        return this._ok;
    },
    getOriginalInput: function() {
      return this._originalInput;
    },
    getFormat: function() {
        return this._format;
    },
    getAlpha: function() {
        return this._a;
    },
    getBrightness: function() {
        //http://www.w3.org/TR/AERT#color-contrast
        var rgb = this.toRgb();
        return (rgb.r * 299 + rgb.g * 587 + rgb.b * 114) / 1000;
    },
    getLuminance: function() {
        //http://www.w3.org/TR/2008/REC-WCAG20-20081211/#relativeluminancedef
        var rgb = this.toRgb();
        var RsRGB, GsRGB, BsRGB, R, G, B;
        RsRGB = rgb.r/255;
        GsRGB = rgb.g/255;
        BsRGB = rgb.b/255;

        if (RsRGB <= 0.03928) {R = RsRGB / 12.92;} else {R = Math.pow(((RsRGB + 0.055) / 1.055), 2.4);}
        if (GsRGB <= 0.03928) {G = GsRGB / 12.92;} else {G = Math.pow(((GsRGB + 0.055) / 1.055), 2.4);}
        if (BsRGB <= 0.03928) {B = BsRGB / 12.92;} else {B = Math.pow(((BsRGB + 0.055) / 1.055), 2.4);}
        return (0.2126 * R) + (0.7152 * G) + (0.0722 * B);
    },
    setAlpha: function(value) {
        this._a = boundAlpha(value);
        this._roundA = mathRound(100*this._a) / 100;
        return this;
    },
    toHsv: function() {
        var hsv = rgbToHsv(this._r, this._g, this._b);
        return { h: hsv.h * 360, s: hsv.s, v: hsv.v, a: this._a };
    },
    toHsvString: function() {
        var hsv = rgbToHsv(this._r, this._g, this._b);
        var h = mathRound(hsv.h * 360), s = mathRound(hsv.s * 100), v = mathRound(hsv.v * 100);
        return (this._a == 1) ?
          "hsv("  + h + ", " + s + "%, " + v + "%)" :
          "hsva(" + h + ", " + s + "%, " + v + "%, "+ this._roundA + ")";
    },
    toHsl: function() {
        var hsl = rgbToHsl(this._r, this._g, this._b);
        return { h: hsl.h * 360, s: hsl.s, l: hsl.l, a: this._a };
    },
    toHslString: function() {
        var hsl = rgbToHsl(this._r, this._g, this._b);
        var h = mathRound(hsl.h * 360), s = mathRound(hsl.s * 100), l = mathRound(hsl.l * 100);
        return (this._a == 1) ?
          "hsl("  + h + ", " + s + "%, " + l + "%)" :
          "hsla(" + h + ", " + s + "%, " + l + "%, "+ this._roundA + ")";
    },
    toHex: function(allow3Char) {
        return rgbToHex(this._r, this._g, this._b, allow3Char);
    },
    toHexString: function(allow3Char) {
        return '#' + this.toHex(allow3Char);
    },
    toHex8: function(allow4Char) {
        return rgbaToHex(this._r, this._g, this._b, this._a, allow4Char);
    },
    toHex8String: function(allow4Char) {
        return '#' + this.toHex8(allow4Char);
    },
    toRgb: function() {
        return { r: mathRound(this._r), g: mathRound(this._g), b: mathRound(this._b), a: this._a };
    },
    toRgbString: function() {
        return (this._a == 1) ?
          "rgb("  + mathRound(this._r) + ", " + mathRound(this._g) + ", " + mathRound(this._b) + ")" :
          "rgba(" + mathRound(this._r) + ", " + mathRound(this._g) + ", " + mathRound(this._b) + ", " + this._roundA + ")";
    },
    toPercentageRgb: function() {
        return { r: mathRound(bound01(this._r, 255) * 100) + "%", g: mathRound(bound01(this._g, 255) * 100) + "%", b: mathRound(bound01(this._b, 255) * 100) + "%", a: this._a };
    },
    toPercentageRgbString: function() {
        return (this._a == 1) ?
          "rgb("  + mathRound(bound01(this._r, 255) * 100) + "%, " + mathRound(bound01(this._g, 255) * 100) + "%, " + mathRound(bound01(this._b, 255) * 100) + "%)" :
          "rgba(" + mathRound(bound01(this._r, 255) * 100) + "%, " + mathRound(bound01(this._g, 255) * 100) + "%, " + mathRound(bound01(this._b, 255) * 100) + "%, " + this._roundA + ")";
    },
    toName: function() {
        if (this._a === 0) {
            return "transparent";
        }

        if (this._a < 1) {
            return false;
        }

        return hexNames[rgbToHex(this._r, this._g, this._b, true)] || false;
    },
    toFilter: function(secondColor) {
        var hex8String = '#' + rgbaToArgbHex(this._r, this._g, this._b, this._a);
        var secondHex8String = hex8String;
        var gradientType = this._gradientType ? "GradientType = 1, " : "";

        if (secondColor) {
            var s = tinycolor(secondColor);
            secondHex8String = '#' + rgbaToArgbHex(s._r, s._g, s._b, s._a);
        }

        return "progid:DXImageTransform.Microsoft.gradient("+gradientType+"startColorstr="+hex8String+",endColorstr="+secondHex8String+")";
    },
    toString: function(format) {
        var formatSet = !!format;
        format = format || this._format;

        var formattedString = false;
        var hasAlpha = this._a < 1 && this._a >= 0;
        var needsAlphaFormat = !formatSet && hasAlpha && (format === "hex" || format === "hex6" || format === "hex3" || format === "hex4" || format === "hex8" || format === "name");

        if (needsAlphaFormat) {
            // Special case for "transparent", all other non-alpha formats
            // will return rgba when there is transparency.
            if (format === "name" && this._a === 0) {
                return this.toName();
            }
            return this.toRgbString();
        }
        if (format === "rgb") {
            formattedString = this.toRgbString();
        }
        if (format === "prgb") {
            formattedString = this.toPercentageRgbString();
        }
        if (format === "hex" || format === "hex6") {
            formattedString = this.toHexString();
        }
        if (format === "hex3") {
            formattedString = this.toHexString(true);
        }
        if (format === "hex4") {
            formattedString = this.toHex8String(true);
        }
        if (format === "hex8") {
            formattedString = this.toHex8String();
        }
        if (format === "name") {
            formattedString = this.toName();
        }
        if (format === "hsl") {
            formattedString = this.toHslString();
        }
        if (format === "hsv") {
            formattedString = this.toHsvString();
        }

        return formattedString || this.toHexString();
    },
    clone: function() {
        return tinycolor(this.toString());
    },

    _applyModification: function(fn, args) {
        var color = fn.apply(null, [this].concat([].slice.call(args)));
        this._r = color._r;
        this._g = color._g;
        this._b = color._b;
        this.setAlpha(color._a);
        return this;
    },
    lighten: function() {
        return this._applyModification(lighten, arguments);
    },
    brighten: function() {
        return this._applyModification(brighten, arguments);
    },
    darken: function() {
        return this._applyModification(darken, arguments);
    },
    desaturate: function() {
        return this._applyModification(desaturate, arguments);
    },
    saturate: function() {
        return this._applyModification(saturate, arguments);
    },
    greyscale: function() {
        return this._applyModification(greyscale, arguments);
    },
    spin: function() {
        return this._applyModification(spin, arguments);
    },

    _applyCombination: function(fn, args) {
        return fn.apply(null, [this].concat([].slice.call(args)));
    },
    analogous: function() {
        return this._applyCombination(analogous, arguments);
    },
    complement: function() {
        return this._applyCombination(complement, arguments);
    },
    monochromatic: function() {
        return this._applyCombination(monochromatic, arguments);
    },
    splitcomplement: function() {
        return this._applyCombination(splitcomplement, arguments);
    },
    triad: function() {
        return this._applyCombination(triad, arguments);
    },
    tetrad: function() {
        return this._applyCombination(tetrad, arguments);
    }
};

// If input is an object, force 1 into "1.0" to handle ratios properly
// String input requires "1.0" as input, so 1 will be treated as 1
tinycolor.fromRatio = function(color, opts) {
    if (typeof color == "object") {
        var newColor = {};
        for (var i in color) {
            if (color.hasOwnProperty(i)) {
                if (i === "a") {
                    newColor[i] = color[i];
                }
                else {
                    newColor[i] = convertToPercentage(color[i]);
                }
            }
        }
        color = newColor;
    }

    return tinycolor(color, opts);
};

// Given a string or object, convert that input to RGB
// Possible string inputs:
//
//     "red"
//     "#f00" or "f00"
//     "#ff0000" or "ff0000"
//     "#ff000000" or "ff000000"
//     "rgb 255 0 0" or "rgb (255, 0, 0)"
//     "rgb 1.0 0 0" or "rgb (1, 0, 0)"
//     "rgba (255, 0, 0, 1)" or "rgba 255, 0, 0, 1"
//     "rgba (1.0, 0, 0, 1)" or "rgba 1.0, 0, 0, 1"
//     "hsl(0, 100%, 50%)" or "hsl 0 100% 50%"
//     "hsla(0, 100%, 50%, 1)" or "hsla 0 100% 50%, 1"
//     "hsv(0, 100%, 100%)" or "hsv 0 100% 100%"
//
function inputToRGB(color) {

    var rgb = { r: 0, g: 0, b: 0 };
    var a = 1;
    var s = null;
    var v = null;
    var l = null;
    var ok = false;
    var format = false;

    if (typeof color == "string") {
        color = stringInputToObject(color);
    }

    if (typeof color == "object") {
        if (isValidCSSUnit(color.r) && isValidCSSUnit(color.g) && isValidCSSUnit(color.b)) {
            rgb = rgbToRgb(color.r, color.g, color.b);
            ok = true;
            format = String(color.r).substr(-1) === "%" ? "prgb" : "rgb";
        }
        else if (isValidCSSUnit(color.h) && isValidCSSUnit(color.s) && isValidCSSUnit(color.v)) {
            s = convertToPercentage(color.s);
            v = convertToPercentage(color.v);
            rgb = hsvToRgb(color.h, s, v);
            ok = true;
            format = "hsv";
        }
        else if (isValidCSSUnit(color.h) && isValidCSSUnit(color.s) && isValidCSSUnit(color.l)) {
            s = convertToPercentage(color.s);
            l = convertToPercentage(color.l);
            rgb = hslToRgb(color.h, s, l);
            ok = true;
            format = "hsl";
        }

        if (color.hasOwnProperty("a")) {
            a = color.a;
        }
    }

    a = boundAlpha(a);

    return {
        ok: ok,
        format: color.format || format,
        r: mathMin(255, mathMax(rgb.r, 0)),
        g: mathMin(255, mathMax(rgb.g, 0)),
        b: mathMin(255, mathMax(rgb.b, 0)),
        a: a
    };
}


// Conversion Functions
// --------------------

// `rgbToHsl`, `rgbToHsv`, `hslToRgb`, `hsvToRgb` modified from:
// <http://mjijackson.com/2008/02/rgb-to-hsl-and-rgb-to-hsv-color-model-conversion-algorithms-in-javascript>

// `rgbToRgb`
// Handle bounds / percentage checking to conform to CSS color spec
// <http://www.w3.org/TR/css3-color/>
// *Assumes:* r, g, b in [0, 255] or [0, 1]
// *Returns:* { r, g, b } in [0, 255]
function rgbToRgb(r, g, b){
    return {
        r: bound01(r, 255) * 255,
        g: bound01(g, 255) * 255,
        b: bound01(b, 255) * 255
    };
}

// `rgbToHsl`
// Converts an RGB color value to HSL.
// *Assumes:* r, g, and b are contained in [0, 255] or [0, 1]
// *Returns:* { h, s, l } in [0,1]
function rgbToHsl(r, g, b) {

    r = bound01(r, 255);
    g = bound01(g, 255);
    b = bound01(b, 255);

    var max = mathMax(r, g, b), min = mathMin(r, g, b);
    var h, s, l = (max + min) / 2;

    if(max == min) {
        h = s = 0; // achromatic
    }
    else {
        var d = max - min;
        s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
        switch(max) {
            case r: h = (g - b) / d + (g < b ? 6 : 0); break;
            case g: h = (b - r) / d + 2; break;
            case b: h = (r - g) / d + 4; break;
        }

        h /= 6;
    }

    return { h: h, s: s, l: l };
}

// `hslToRgb`
// Converts an HSL color value to RGB.
// *Assumes:* h is contained in [0, 1] or [0, 360] and s and l are contained [0, 1] or [0, 100]
// *Returns:* { r, g, b } in the set [0, 255]
function hslToRgb(h, s, l) {
    var r, g, b;

    h = bound01(h, 360);
    s = bound01(s, 100);
    l = bound01(l, 100);

    function hue2rgb(p, q, t) {
        if(t < 0) t += 1;
        if(t > 1) t -= 1;
        if(t < 1/6) return p + (q - p) * 6 * t;
        if(t < 1/2) return q;
        if(t < 2/3) return p + (q - p) * (2/3 - t) * 6;
        return p;
    }

    if(s === 0) {
        r = g = b = l; // achromatic
    }
    else {
        var q = l < 0.5 ? l * (1 + s) : l + s - l * s;
        var p = 2 * l - q;
        r = hue2rgb(p, q, h + 1/3);
        g = hue2rgb(p, q, h);
        b = hue2rgb(p, q, h - 1/3);
    }

    return { r: r * 255, g: g * 255, b: b * 255 };
}

// `rgbToHsv`
// Converts an RGB color value to HSV
// *Assumes:* r, g, and b are contained in the set [0, 255] or [0, 1]
// *Returns:* { h, s, v } in [0,1]
function rgbToHsv(r, g, b) {

    r = bound01(r, 255);
    g = bound01(g, 255);
    b = bound01(b, 255);

    var max = mathMax(r, g, b), min = mathMin(r, g, b);
    var h, s, v = max;

    var d = max - min;
    s = max === 0 ? 0 : d / max;

    if(max == min) {
        h = 0; // achromatic
    }
    else {
        switch(max) {
            case r: h = (g - b) / d + (g < b ? 6 : 0); break;
            case g: h = (b - r) / d + 2; break;
            case b: h = (r - g) / d + 4; break;
        }
        h /= 6;
    }
    return { h: h, s: s, v: v };
}

// `hsvToRgb`
// Converts an HSV color value to RGB.
// *Assumes:* h is contained in [0, 1] or [0, 360] and s and v are contained in [0, 1] or [0, 100]
// *Returns:* { r, g, b } in the set [0, 255]
 function hsvToRgb(h, s, v) {

    h = bound01(h, 360) * 6;
    s = bound01(s, 100);
    v = bound01(v, 100);

    var i = Math.floor(h),
        f = h - i,
        p = v * (1 - s),
        q = v * (1 - f * s),
        t = v * (1 - (1 - f) * s),
        mod = i % 6,
        r = [v, q, p, p, t, v][mod],
        g = [t, v, v, q, p, p][mod],
        b = [p, p, t, v, v, q][mod];

    return { r: r * 255, g: g * 255, b: b * 255 };
}

// `rgbToHex`
// Converts an RGB color to hex
// Assumes r, g, and b are contained in the set [0, 255]
// Returns a 3 or 6 character hex
function rgbToHex(r, g, b, allow3Char) {

    var hex = [
        pad2(mathRound(r).toString(16)),
        pad2(mathRound(g).toString(16)),
        pad2(mathRound(b).toString(16))
    ];

    // Return a 3 character hex if possible
    if (allow3Char && hex[0].charAt(0) == hex[0].charAt(1) && hex[1].charAt(0) == hex[1].charAt(1) && hex[2].charAt(0) == hex[2].charAt(1)) {
        return hex[0].charAt(0) + hex[1].charAt(0) + hex[2].charAt(0);
    }

    return hex.join("");
}

// `rgbaToHex`
// Converts an RGBA color plus alpha transparency to hex
// Assumes r, g, b are contained in the set [0, 255] and
// a in [0, 1]. Returns a 4 or 8 character rgba hex
function rgbaToHex(r, g, b, a, allow4Char) {

    var hex = [
        pad2(mathRound(r).toString(16)),
        pad2(mathRound(g).toString(16)),
        pad2(mathRound(b).toString(16)),
        pad2(convertDecimalToHex(a))
    ];

    // Return a 4 character hex if possible
    if (allow4Char && hex[0].charAt(0) == hex[0].charAt(1) && hex[1].charAt(0) == hex[1].charAt(1) && hex[2].charAt(0) == hex[2].charAt(1) && hex[3].charAt(0) == hex[3].charAt(1)) {
        return hex[0].charAt(0) + hex[1].charAt(0) + hex[2].charAt(0) + hex[3].charAt(0);
    }

    return hex.join("");
}

// `rgbaToArgbHex`
// Converts an RGBA color to an ARGB Hex8 string
// Rarely used, but required for "toFilter()"
function rgbaToArgbHex(r, g, b, a) {

    var hex = [
        pad2(convertDecimalToHex(a)),
        pad2(mathRound(r).toString(16)),
        pad2(mathRound(g).toString(16)),
        pad2(mathRound(b).toString(16))
    ];

    return hex.join("");
}

// `equals`
// Can be called with any tinycolor input
tinycolor.equals = function (color1, color2) {
    if (!color1 || !color2) { return false; }
    return tinycolor(color1).toRgbString() == tinycolor(color2).toRgbString();
};

tinycolor.random = function() {
    return tinycolor.fromRatio({
        r: mathRandom(),
        g: mathRandom(),
        b: mathRandom()
    });
};


// Modification Functions
// ----------------------
// Thanks to less.js for some of the basics here
// <https://github.com/cloudhead/less.js/blob/master/lib/less/functions.js>

function desaturate(color, amount) {
    amount = (amount === 0) ? 0 : (amount || 10);
    var hsl = tinycolor(color).toHsl();
    hsl.s -= amount / 100;
    hsl.s = clamp01(hsl.s);
    return tinycolor(hsl);
}

function saturate(color, amount) {
    amount = (amount === 0) ? 0 : (amount || 10);
    var hsl = tinycolor(color).toHsl();
    hsl.s += amount / 100;
    hsl.s = clamp01(hsl.s);
    return tinycolor(hsl);
}

function greyscale(color) {
    return tinycolor(color).desaturate(100);
}

function lighten (color, amount) {
    amount = (amount === 0) ? 0 : (amount || 10);
    var hsl = tinycolor(color).toHsl();
    hsl.l += amount / 100;
    hsl.l = clamp01(hsl.l);
    return tinycolor(hsl);
}

function brighten(color, amount) {
    amount = (amount === 0) ? 0 : (amount || 10);
    var rgb = tinycolor(color).toRgb();
    rgb.r = mathMax(0, mathMin(255, rgb.r - mathRound(255 * - (amount / 100))));
    rgb.g = mathMax(0, mathMin(255, rgb.g - mathRound(255 * - (amount / 100))));
    rgb.b = mathMax(0, mathMin(255, rgb.b - mathRound(255 * - (amount / 100))));
    return tinycolor(rgb);
}

function darken (color, amount) {
    amount = (amount === 0) ? 0 : (amount || 10);
    var hsl = tinycolor(color).toHsl();
    hsl.l -= amount / 100;
    hsl.l = clamp01(hsl.l);
    return tinycolor(hsl);
}

// Spin takes a positive or negative amount within [-360, 360] indicating the change of hue.
// Values outside of this range will be wrapped into this range.
function spin(color, amount) {
    var hsl = tinycolor(color).toHsl();
    var hue = (hsl.h + amount) % 360;
    hsl.h = hue < 0 ? 360 + hue : hue;
    return tinycolor(hsl);
}

// Combination Functions
// ---------------------
// Thanks to jQuery xColor for some of the ideas behind these
// <https://github.com/infusion/jQuery-xcolor/blob/master/jquery.xcolor.js>

function complement(color) {
    var hsl = tinycolor(color).toHsl();
    hsl.h = (hsl.h + 180) % 360;
    return tinycolor(hsl);
}

function triad(color) {
    var hsl = tinycolor(color).toHsl();
    var h = hsl.h;
    return [
        tinycolor(color),
        tinycolor({ h: (h + 120) % 360, s: hsl.s, l: hsl.l }),
        tinycolor({ h: (h + 240) % 360, s: hsl.s, l: hsl.l })
    ];
}

function tetrad(color) {
    var hsl = tinycolor(color).toHsl();
    var h = hsl.h;
    return [
        tinycolor(color),
        tinycolor({ h: (h + 90) % 360, s: hsl.s, l: hsl.l }),
        tinycolor({ h: (h + 180) % 360, s: hsl.s, l: hsl.l }),
        tinycolor({ h: (h + 270) % 360, s: hsl.s, l: hsl.l })
    ];
}

function splitcomplement(color) {
    var hsl = tinycolor(color).toHsl();
    var h = hsl.h;
    return [
        tinycolor(color),
        tinycolor({ h: (h + 72) % 360, s: hsl.s, l: hsl.l}),
        tinycolor({ h: (h + 216) % 360, s: hsl.s, l: hsl.l})
    ];
}

function analogous(color, results, slices) {
    results = results || 6;
    slices = slices || 30;

    var hsl = tinycolor(color).toHsl();
    var part = 360 / slices;
    var ret = [tinycolor(color)];

    for (hsl.h = ((hsl.h - (part * results >> 1)) + 720) % 360; --results; ) {
        hsl.h = (hsl.h + part) % 360;
        ret.push(tinycolor(hsl));
    }
    return ret;
}

function monochromatic(color, results) {
    results = results || 6;
    var hsv = tinycolor(color).toHsv();
    var h = hsv.h, s = hsv.s, v = hsv.v;
    var ret = [];
    var modification = 1 / results;

    while (results--) {
        ret.push(tinycolor({ h: h, s: s, v: v}));
        v = (v + modification) % 1;
    }

    return ret;
}

// Utility Functions
// ---------------------

tinycolor.mix = function(color1, color2, amount) {
    amount = (amount === 0) ? 0 : (amount || 50);

    var rgb1 = tinycolor(color1).toRgb();
    var rgb2 = tinycolor(color2).toRgb();

    var p = amount / 100;

    var rgba = {
        r: ((rgb2.r - rgb1.r) * p) + rgb1.r,
        g: ((rgb2.g - rgb1.g) * p) + rgb1.g,
        b: ((rgb2.b - rgb1.b) * p) + rgb1.b,
        a: ((rgb2.a - rgb1.a) * p) + rgb1.a
    };

    return tinycolor(rgba);
};


// Readability Functions
// ---------------------
// <http://www.w3.org/TR/2008/REC-WCAG20-20081211/#contrast-ratiodef (WCAG Version 2)

// `contrast`
// Analyze the 2 colors and returns the color contrast defined by (WCAG Version 2)
tinycolor.readability = function(color1, color2) {
    var c1 = tinycolor(color1);
    var c2 = tinycolor(color2);
    return (Math.max(c1.getLuminance(),c2.getLuminance())+0.05) / (Math.min(c1.getLuminance(),c2.getLuminance())+0.05);
};

// `isReadable`
// Ensure that foreground and background color combinations meet WCAG2 guidelines.
// The third argument is an optional Object.
//      the 'level' property states 'AA' or 'AAA' - if missing or invalid, it defaults to 'AA';
//      the 'size' property states 'large' or 'small' - if missing or invalid, it defaults to 'small'.
// If the entire object is absent, isReadable defaults to {level:"AA",size:"small"}.

// *Example*
//    tinycolor.isReadable("#000", "#111") => false
//    tinycolor.isReadable("#000", "#111",{level:"AA",size:"large"}) => false
tinycolor.isReadable = function(color1, color2, wcag2) {
    var readability = tinycolor.readability(color1, color2);
    var wcag2Parms, out;

    out = false;

    wcag2Parms = validateWCAG2Parms(wcag2);
    switch (wcag2Parms.level + wcag2Parms.size) {
        case "AAsmall":
        case "AAAlarge":
            out = readability >= 4.5;
            break;
        case "AAlarge":
            out = readability >= 3;
            break;
        case "AAAsmall":
            out = readability >= 7;
            break;
    }
    return out;

};

// `mostReadable`
// Given a base color and a list of possible foreground or background
// colors for that base, returns the most readable color.
// Optionally returns Black or White if the most readable color is unreadable.
// *Example*
//    tinycolor.mostReadable(tinycolor.mostReadable("#123", ["#124", "#125"],{includeFallbackColors:false}).toHexString(); // "#112255"
//    tinycolor.mostReadable(tinycolor.mostReadable("#123", ["#124", "#125"],{includeFallbackColors:true}).toHexString();  // "#ffffff"
//    tinycolor.mostReadable("#a8015a", ["#faf3f3"],{includeFallbackColors:true,level:"AAA",size:"large"}).toHexString(); // "#faf3f3"
//    tinycolor.mostReadable("#a8015a", ["#faf3f3"],{includeFallbackColors:true,level:"AAA",size:"small"}).toHexString(); // "#ffffff"
tinycolor.mostReadable = function(baseColor, colorList, args) {
    var bestColor = null;
    var bestScore = 0;
    var readability;
    var includeFallbackColors, level, size ;
    args = args || {};
    includeFallbackColors = args.includeFallbackColors ;
    level = args.level;
    size = args.size;

    for (var i= 0; i < colorList.length ; i++) {
        readability = tinycolor.readability(baseColor, colorList[i]);
        if (readability > bestScore) {
            bestScore = readability;
            bestColor = tinycolor(colorList[i]);
        }
    }

    if (tinycolor.isReadable(baseColor, bestColor, {"level":level,"size":size}) || !includeFallbackColors) {
        return bestColor;
    }
    else {
        args.includeFallbackColors=false;
        return tinycolor.mostReadable(baseColor,["#fff", "#000"],args);
    }
};


// Big List of Colors
// ------------------
// <http://www.w3.org/TR/css3-color/#svg-color>
var names = tinycolor.names = {
    aliceblue: "f0f8ff",
    antiquewhite: "faebd7",
    aqua: "0ff",
    aquamarine: "7fffd4",
    azure: "f0ffff",
    beige: "f5f5dc",
    bisque: "ffe4c4",
    black: "000",
    blanchedalmond: "ffebcd",
    blue: "00f",
    blueviolet: "8a2be2",
    brown: "a52a2a",
    burlywood: "deb887",
    burntsienna: "ea7e5d",
    cadetblue: "5f9ea0",
    chartreuse: "7fff00",
    chocolate: "d2691e",
    coral: "ff7f50",
    cornflowerblue: "6495ed",
    cornsilk: "fff8dc",
    crimson: "dc143c",
    cyan: "0ff",
    darkblue: "00008b",
    darkcyan: "008b8b",
    darkgoldenrod: "b8860b",
    darkgray: "a9a9a9",
    darkgreen: "006400",
    darkgrey: "a9a9a9",
    darkkhaki: "bdb76b",
    darkmagenta: "8b008b",
    darkolivegreen: "556b2f",
    darkorange: "ff8c00",
    darkorchid: "9932cc",
    darkred: "8b0000",
    darksalmon: "e9967a",
    darkseagreen: "8fbc8f",
    darkslateblue: "483d8b",
    darkslategray: "2f4f4f",
    darkslategrey: "2f4f4f",
    darkturquoise: "00ced1",
    darkviolet: "9400d3",
    deeppink: "ff1493",
    deepskyblue: "00bfff",
    dimgray: "696969",
    dimgrey: "696969",
    dodgerblue: "1e90ff",
    firebrick: "b22222",
    floralwhite: "fffaf0",
    forestgreen: "228b22",
    fuchsia: "f0f",
    gainsboro: "dcdcdc",
    ghostwhite: "f8f8ff",
    gold: "ffd700",
    goldenrod: "daa520",
    gray: "808080",
    green: "008000",
    greenyellow: "adff2f",
    grey: "808080",
    honeydew: "f0fff0",
    hotpink: "ff69b4",
    indianred: "cd5c5c",
    indigo: "4b0082",
    ivory: "fffff0",
    khaki: "f0e68c",
    lavender: "e6e6fa",
    lavenderblush: "fff0f5",
    lawngreen: "7cfc00",
    lemonchiffon: "fffacd",
    lightblue: "add8e6",
    lightcoral: "f08080",
    lightcyan: "e0ffff",
    lightgoldenrodyellow: "fafad2",
    lightgray: "d3d3d3",
    lightgreen: "90ee90",
    lightgrey: "d3d3d3",
    lightpink: "ffb6c1",
    lightsalmon: "ffa07a",
    lightseagreen: "20b2aa",
    lightskyblue: "87cefa",
    lightslategray: "789",
    lightslategrey: "789",
    lightsteelblue: "b0c4de",
    lightyellow: "ffffe0",
    lime: "0f0",
    limegreen: "32cd32",
    linen: "faf0e6",
    magenta: "f0f",
    maroon: "800000",
    mediumaquamarine: "66cdaa",
    mediumblue: "0000cd",
    mediumorchid: "ba55d3",
    mediumpurple: "9370db",
    mediumseagreen: "3cb371",
    mediumslateblue: "7b68ee",
    mediumspringgreen: "00fa9a",
    mediumturquoise: "48d1cc",
    mediumvioletred: "c71585",
    midnightblue: "191970",
    mintcream: "f5fffa",
    mistyrose: "ffe4e1",
    moccasin: "ffe4b5",
    navajowhite: "ffdead",
    navy: "000080",
    oldlace: "fdf5e6",
    olive: "808000",
    olivedrab: "6b8e23",
    orange: "ffa500",
    orangered: "ff4500",
    orchid: "da70d6",
    palegoldenrod: "eee8aa",
    palegreen: "98fb98",
    paleturquoise: "afeeee",
    palevioletred: "db7093",
    papayawhip: "ffefd5",
    peachpuff: "ffdab9",
    peru: "cd853f",
    pink: "ffc0cb",
    plum: "dda0dd",
    powderblue: "b0e0e6",
    purple: "800080",
    rebeccapurple: "663399",
    red: "f00",
    rosybrown: "bc8f8f",
    royalblue: "4169e1",
    saddlebrown: "8b4513",
    salmon: "fa8072",
    sandybrown: "f4a460",
    seagreen: "2e8b57",
    seashell: "fff5ee",
    sienna: "a0522d",
    silver: "c0c0c0",
    skyblue: "87ceeb",
    slateblue: "6a5acd",
    slategray: "708090",
    slategrey: "708090",
    snow: "fffafa",
    springgreen: "00ff7f",
    steelblue: "4682b4",
    tan: "d2b48c",
    teal: "008080",
    thistle: "d8bfd8",
    tomato: "ff6347",
    turquoise: "40e0d0",
    violet: "ee82ee",
    wheat: "f5deb3",
    white: "fff",
    whitesmoke: "f5f5f5",
    yellow: "ff0",
    yellowgreen: "9acd32"
};

// Make it easy to access colors via `hexNames[hex]`
var hexNames = tinycolor.hexNames = flip(names);


// Utilities
// ---------

// `{ 'name1': 'val1' }` becomes `{ 'val1': 'name1' }`
function flip(o) {
    var flipped = { };
    for (var i in o) {
        if (o.hasOwnProperty(i)) {
            flipped[o[i]] = i;
        }
    }
    return flipped;
}

// Return a valid alpha value [0,1] with all invalid values being set to 1
function boundAlpha(a) {
    a = parseFloat(a);

    if (isNaN(a) || a < 0 || a > 1) {
        a = 1;
    }

    return a;
}

// Take input from [0, n] and return it as [0, 1]
function bound01(n, max) {
    if (isOnePointZero(n)) { n = "100%"; }

    var processPercent = isPercentage(n);
    n = mathMin(max, mathMax(0, parseFloat(n)));

    // Automatically convert percentage into number
    if (processPercent) {
        n = parseInt(n * max, 10) / 100;
    }

    // Handle floating point rounding errors
    if ((Math.abs(n - max) < 0.000001)) {
        return 1;
    }

    // Convert into [0, 1] range if it isn't already
    return (n % max) / parseFloat(max);
}

// Force a number between 0 and 1
function clamp01(val) {
    return mathMin(1, mathMax(0, val));
}

// Parse a base-16 hex value into a base-10 integer
function parseIntFromHex(val) {
    return parseInt(val, 16);
}

// Need to handle 1.0 as 100%, since once it is a number, there is no difference between it and 1
// <http://stackoverflow.com/questions/7422072/javascript-how-to-detect-number-as-a-decimal-including-1-0>
function isOnePointZero(n) {
    return typeof n == "string" && n.indexOf('.') != -1 && parseFloat(n) === 1;
}

// Check to see if string passed in is a percentage
function isPercentage(n) {
    return typeof n === "string" && n.indexOf('%') != -1;
}

// Force a hex value to have 2 characters
function pad2(c) {
    return c.length == 1 ? '0' + c : '' + c;
}

// Replace a decimal with it's percentage value
function convertToPercentage(n) {
    if (n <= 1) {
        n = (n * 100) + "%";
    }

    return n;
}

// Converts a decimal to a hex value
function convertDecimalToHex(d) {
    return Math.round(parseFloat(d) * 255).toString(16);
}
// Converts a hex value to a decimal
function convertHexToDecimal(h) {
    return (parseIntFromHex(h) / 255);
}

var matchers = (function() {

    // <http://www.w3.org/TR/css3-values/#integers>
    var CSS_INTEGER = "[-\\+]?\\d+%?";

    // <http://www.w3.org/TR/css3-values/#number-value>
    var CSS_NUMBER = "[-\\+]?\\d*\\.\\d+%?";

    // Allow positive/negative integer/number.  Don't capture the either/or, just the entire outcome.
    var CSS_UNIT = "(?:" + CSS_NUMBER + ")|(?:" + CSS_INTEGER + ")";

    // Actual matching.
    // Parentheses and commas are optional, but not required.
    // Whitespace can take the place of commas or opening paren
    var PERMISSIVE_MATCH3 = "[\\s|\\(]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")\\s*\\)?";
    var PERMISSIVE_MATCH4 = "[\\s|\\(]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")\\s*\\)?";

    return {
        CSS_UNIT: new RegExp(CSS_UNIT),
        rgb: new RegExp("rgb" + PERMISSIVE_MATCH3),
        rgba: new RegExp("rgba" + PERMISSIVE_MATCH4),
        hsl: new RegExp("hsl" + PERMISSIVE_MATCH3),
        hsla: new RegExp("hsla" + PERMISSIVE_MATCH4),
        hsv: new RegExp("hsv" + PERMISSIVE_MATCH3),
        hsva: new RegExp("hsva" + PERMISSIVE_MATCH4),
        hex3: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
        hex6: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/,
        hex4: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
        hex8: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/
    };
})();

// `isValidCSSUnit`
// Take in a single string / number and check to see if it looks like a CSS unit
// (see `matchers` above for definition).
function isValidCSSUnit(color) {
    return !!matchers.CSS_UNIT.exec(color);
}

// `stringInputToObject`
// Permissive string parsing.  Take in a number of formats, and output an object
// based on detected format.  Returns `{ r, g, b }` or `{ h, s, l }` or `{ h, s, v}`
function stringInputToObject(color) {

    color = color.replace(trimLeft,'').replace(trimRight, '').toLowerCase();
    var named = false;
    if (names[color]) {
        color = names[color];
        named = true;
    }
    else if (color == 'transparent') {
        return { r: 0, g: 0, b: 0, a: 0, format: "name" };
    }

    // Try to match string input using regular expressions.
    // Keep most of the number bounding out of this function - don't worry about [0,1] or [0,100] or [0,360]
    // Just return an object and let the conversion functions handle that.
    // This way the result will be the same whether the tinycolor is initialized with string or object.
    var match;
    if ((match = matchers.rgb.exec(color))) {
        return { r: match[1], g: match[2], b: match[3] };
    }
    if ((match = matchers.rgba.exec(color))) {
        return { r: match[1], g: match[2], b: match[3], a: match[4] };
    }
    if ((match = matchers.hsl.exec(color))) {
        return { h: match[1], s: match[2], l: match[3] };
    }
    if ((match = matchers.hsla.exec(color))) {
        return { h: match[1], s: match[2], l: match[3], a: match[4] };
    }
    if ((match = matchers.hsv.exec(color))) {
        return { h: match[1], s: match[2], v: match[3] };
    }
    if ((match = matchers.hsva.exec(color))) {
        return { h: match[1], s: match[2], v: match[3], a: match[4] };
    }
    if ((match = matchers.hex8.exec(color))) {
        return {
            r: parseIntFromHex(match[1]),
            g: parseIntFromHex(match[2]),
            b: parseIntFromHex(match[3]),
            a: convertHexToDecimal(match[4]),
            format: named ? "name" : "hex8"
        };
    }
    if ((match = matchers.hex6.exec(color))) {
        return {
            r: parseIntFromHex(match[1]),
            g: parseIntFromHex(match[2]),
            b: parseIntFromHex(match[3]),
            format: named ? "name" : "hex"
        };
    }
    if ((match = matchers.hex4.exec(color))) {
        return {
            r: parseIntFromHex(match[1] + '' + match[1]),
            g: parseIntFromHex(match[2] + '' + match[2]),
            b: parseIntFromHex(match[3] + '' + match[3]),
            a: convertHexToDecimal(match[4] + '' + match[4]),
            format: named ? "name" : "hex8"
        };
    }
    if ((match = matchers.hex3.exec(color))) {
        return {
            r: parseIntFromHex(match[1] + '' + match[1]),
            g: parseIntFromHex(match[2] + '' + match[2]),
            b: parseIntFromHex(match[3] + '' + match[3]),
            format: named ? "name" : "hex"
        };
    }

    return false;
}

function validateWCAG2Parms(parms) {
    // return valid WCAG2 parms for isReadable.
    // If input parms are invalid, return {"level":"AA", "size":"small"}
    var level, size;
    parms = parms || {"level":"AA", "size":"small"};
    level = (parms.level || "AA").toUpperCase();
    size = (parms.size || "small").toLowerCase();
    if (level !== "AA" && level !== "AAA") {
        level = "AA";
    }
    if (size !== "small" && size !== "large") {
        size = "small";
    }
    return {"level":level, "size":size};
}

// Node: Export function
if (module.exports) {
    module.exports = tinycolor;
}
// AMD/requirejs: Define the module
else {
    window.tinycolor = tinycolor;
}

})(Math);
}(tinycolor));Object.defineProperty(color$2, "__esModule", {
  value: true
});
color$2.isvalidColorString = color$2.red = color$2.getContrastingColor = color$2.isValidHex = color$2.toState = color$2.simpleCheckForValidColor = undefined;

var _each = each$1;

var _each2 = _interopRequireDefault$b(_each);

var _tinycolor = tinycolor.exports;

var _tinycolor2 = _interopRequireDefault$b(_tinycolor);

function _interopRequireDefault$b(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

color$2.simpleCheckForValidColor = function simpleCheckForValidColor(data) {
  var keysToCheck = ['r', 'g', 'b', 'a', 'h', 's', 'l', 'v'];
  var checked = 0;
  var passed = 0;
  (0, _each2.default)(keysToCheck, function (letter) {
    if (data[letter]) {
      checked += 1;
      if (!isNaN(data[letter])) {
        passed += 1;
      }
      if (letter === 's' || letter === 'l') {
        var percentPatt = /^\d+%$/;
        if (percentPatt.test(data[letter])) {
          passed += 1;
        }
      }
    }
  });
  return checked === passed ? data : false;
};

var toState = color$2.toState = function toState(data, oldHue) {
  var color = data.hex ? (0, _tinycolor2.default)(data.hex) : (0, _tinycolor2.default)(data);
  var hsl = color.toHsl();
  var hsv = color.toHsv();
  var rgb = color.toRgb();
  var hex = color.toHex();
  if (hsl.s === 0) {
    hsl.h = oldHue || 0;
    hsv.h = oldHue || 0;
  }
  var transparent = hex === '000000' && rgb.a === 0;

  return {
    hsl: hsl,
    hex: transparent ? 'transparent' : '#' + hex,
    rgb: rgb,
    hsv: hsv,
    oldHue: data.h || oldHue || hsl.h,
    source: data.source
  };
};

color$2.isValidHex = function isValidHex(hex) {
  if (hex === 'transparent') {
    return true;
  }
  // disable hex4 and hex8
  var lh = String(hex).charAt(0) === '#' ? 1 : 0;
  return hex.length !== 4 + lh && hex.length < 7 + lh && (0, _tinycolor2.default)(hex).isValid();
};

color$2.getContrastingColor = function getContrastingColor(data) {
  if (!data) {
    return '#fff';
  }
  var col = toState(data);
  if (col.hex === 'transparent') {
    return 'rgba(0,0,0,0.4)';
  }
  var yiq = (col.rgb.r * 299 + col.rgb.g * 587 + col.rgb.b * 114) / 1000;
  return yiq >= 128 ? '#000' : '#fff';
};

color$2.red = {
  hsl: { a: 1, h: 0, l: 0.5, s: 1 },
  hex: '#ff0000',
  rgb: { r: 255, g: 0, b: 0, a: 1 },
  hsv: { h: 0, s: 1, v: 1, a: 1 }
};

color$2.isvalidColorString = function isvalidColorString(string, type) {
  var stringWithoutDegree = string.replace('°', '');
  return (0, _tinycolor2.default)(type + ' (' + stringWithoutDegree + ')')._ok;
};Object.defineProperty(ColorWrap$1, "__esModule", {
  value: true
});
ColorWrap$1.ColorWrap = undefined;

var _extends$5 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass$4 = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react$9 = React__default['default'];

var _react2$9 = _interopRequireDefault$a(_react$9);

var _debounce = debounce_1;

var _debounce2 = _interopRequireDefault$a(_debounce);

var _color$1 = color$2;

var color$1 = _interopRequireWildcard$1(_color$1);

function _interopRequireWildcard$1(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault$a(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck$4(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn$4(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits$4(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ColorWrap = ColorWrap$1.ColorWrap = function ColorWrap(Picker) {
  var ColorPicker = function (_ref) {
    _inherits$4(ColorPicker, _ref);

    function ColorPicker(props) {
      _classCallCheck$4(this, ColorPicker);

      var _this = _possibleConstructorReturn$4(this, (ColorPicker.__proto__ || Object.getPrototypeOf(ColorPicker)).call(this));

      _this.handleChange = function (data, event) {
        var isValidColor = color$1.simpleCheckForValidColor(data);
        if (isValidColor) {
          var colors = color$1.toState(data, data.h || _this.state.oldHue);
          _this.setState(colors);
          _this.props.onChangeComplete && _this.debounce(_this.props.onChangeComplete, colors, event);
          _this.props.onChange && _this.props.onChange(colors, event);
        }
      };

      _this.handleSwatchHover = function (data, event) {
        var isValidColor = color$1.simpleCheckForValidColor(data);
        if (isValidColor) {
          var colors = color$1.toState(data, data.h || _this.state.oldHue);
          _this.props.onSwatchHover && _this.props.onSwatchHover(colors, event);
        }
      };

      _this.state = _extends$5({}, color$1.toState(props.color, 0));

      _this.debounce = (0, _debounce2.default)(function (fn, data, event) {
        fn(data, event);
      }, 100);
      return _this;
    }

    _createClass$4(ColorPicker, [{
      key: 'render',
      value: function render() {
        var optionalEvents = {};
        if (this.props.onSwatchHover) {
          optionalEvents.onSwatchHover = this.handleSwatchHover;
        }

        return _react2$9.default.createElement(Picker, _extends$5({}, this.props, this.state, {
          onChange: this.handleChange
        }, optionalEvents));
      }
    }], [{
      key: 'getDerivedStateFromProps',
      value: function getDerivedStateFromProps(nextProps, state) {
        return _extends$5({}, color$1.toState(nextProps.color, state.oldHue));
      }
    }]);

    return ColorPicker;
  }(_react$9.PureComponent || _react$9.Component);

  ColorPicker.propTypes = _extends$5({}, Picker.propTypes);

  ColorPicker.defaultProps = _extends$5({}, Picker.defaultProps, {
    color: {
      h: 250,
      s: 0.50,
      l: 0.20,
      a: 1
    }
  });

  return ColorPicker;
};

ColorWrap$1.default = ColorWrap;var Swatch$1 = {};var interaction = {};Object.defineProperty(interaction, "__esModule", {
  value: true
});
interaction.handleFocus = undefined;

var _extends$4 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass$3 = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react$8 = React__default['default'];

var _react2$8 = _interopRequireDefault$9(_react$8);

function _interopRequireDefault$9(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck$3(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn$3(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits$3(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable no-invalid-this */


interaction.handleFocus = function handleFocus(Component) {
  var Span = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'span';
  return function (_React$Component) {
    _inherits$3(Focus, _React$Component);

    function Focus() {
      var _ref;

      var _temp, _this, _ret;

      _classCallCheck$3(this, Focus);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn$3(this, (_ref = Focus.__proto__ || Object.getPrototypeOf(Focus)).call.apply(_ref, [this].concat(args))), _this), _this.state = { focus: false }, _this.handleFocus = function () {
        return _this.setState({ focus: true });
      }, _this.handleBlur = function () {
        return _this.setState({ focus: false });
      }, _temp), _possibleConstructorReturn$3(_this, _ret);
    }

    _createClass$3(Focus, [{
      key: 'render',
      value: function render() {
        return _react2$8.default.createElement(
          Span,
          { onFocus: this.handleFocus, onBlur: this.handleBlur },
          _react2$8.default.createElement(Component, _extends$4({}, this.props, this.state))
        );
      }
    }]);

    return Focus;
  }(_react2$8.default.Component);
};Object.defineProperty(Swatch$1, "__esModule", {
  value: true
});
Swatch$1.Swatch = undefined;

var _extends$3 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react$7 = React__default['default'];

var _react2$7 = _interopRequireDefault$8(_react$7);

var _reactcss$4 = lib$1;

var _reactcss2$4 = _interopRequireDefault$8(_reactcss$4);

var _interaction = interaction;

var _Checkboard = Checkboard$1;

var _Checkboard2 = _interopRequireDefault$8(_Checkboard);

function _interopRequireDefault$8(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ENTER = 13;

var Swatch = Swatch$1.Swatch = function Swatch(_ref) {
  var color = _ref.color,
      style = _ref.style,
      _ref$onClick = _ref.onClick,
      onClick = _ref$onClick === undefined ? function () {} : _ref$onClick,
      onHover = _ref.onHover,
      _ref$title = _ref.title,
      title = _ref$title === undefined ? color : _ref$title,
      children = _ref.children,
      focus = _ref.focus,
      _ref$focusStyle = _ref.focusStyle,
      focusStyle = _ref$focusStyle === undefined ? {} : _ref$focusStyle;

  var transparent = color === 'transparent';
  var styles = (0, _reactcss2$4.default)({
    default: {
      swatch: _extends$3({
        background: color,
        height: '100%',
        width: '100%',
        cursor: 'pointer',
        position: 'relative',
        outline: 'none'
      }, style, focus ? focusStyle : {})
    }
  });

  var handleClick = function handleClick(e) {
    return onClick(color, e);
  };
  var handleKeyDown = function handleKeyDown(e) {
    return e.keyCode === ENTER && onClick(color, e);
  };
  var handleHover = function handleHover(e) {
    return onHover(color, e);
  };

  var optionalEvents = {};
  if (onHover) {
    optionalEvents.onMouseOver = handleHover;
  }

  return _react2$7.default.createElement(
    'div',
    _extends$3({
      style: styles.swatch,
      onClick: handleClick,
      title: title,
      tabIndex: 0,
      onKeyDown: handleKeyDown
    }, optionalEvents),
    children,
    transparent && _react2$7.default.createElement(_Checkboard2.default, {
      borderRadius: styles.swatch.borderRadius,
      boxShadow: 'inset 0 0 0 1px rgba(0,0,0,0.1)'
    })
  );
};

Swatch$1.default = (0, _interaction.handleFocus)(Swatch);(function (exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Alpha = Alpha$1;

Object.defineProperty(exports, 'Alpha', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Alpha).default;
  }
});

var _Checkboard = Checkboard$1;

Object.defineProperty(exports, 'Checkboard', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Checkboard).default;
  }
});

var _EditableInput = EditableInput$1;

Object.defineProperty(exports, 'EditableInput', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_EditableInput).default;
  }
});

var _Hue = Hue$1;

Object.defineProperty(exports, 'Hue', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Hue).default;
  }
});

var _Raised = Raised$1;

Object.defineProperty(exports, 'Raised', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Raised).default;
  }
});

var _Saturation = Saturation$1;

Object.defineProperty(exports, 'Saturation', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Saturation).default;
  }
});

var _ColorWrap = ColorWrap$1;

Object.defineProperty(exports, 'ColorWrap', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_ColorWrap).default;
  }
});

var _Swatch = Swatch$1;

Object.defineProperty(exports, 'Swatch', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Swatch).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
}(common));var ChromeFields$1 = {};/**
 * Checks if `value` is `undefined`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
 * @example
 *
 * _.isUndefined(void 0);
 * // => true
 *
 * _.isUndefined(null);
 * // => false
 */

function isUndefined(value) {
  return value === undefined;
}

var isUndefined_1 = isUndefined;var UnfoldMoreHorizontalIcon = {};Object.defineProperty(UnfoldMoreHorizontalIcon, "__esModule", {
  value: true
});

var _extends$2 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react$6 = React__default['default'];

var _react2$6 = _interopRequireDefault$7(_react$6);

function _interopRequireDefault$7(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties$1(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var DEFAULT_SIZE = 24;

UnfoldMoreHorizontalIcon.default = function (_ref) {
  var _ref$fill = _ref.fill,
      fill = _ref$fill === undefined ? 'currentColor' : _ref$fill,
      _ref$width = _ref.width,
      width = _ref$width === undefined ? DEFAULT_SIZE : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === undefined ? DEFAULT_SIZE : _ref$height,
      _ref$style = _ref.style,
      style = _ref$style === undefined ? {} : _ref$style,
      props = _objectWithoutProperties$1(_ref, ['fill', 'width', 'height', 'style']);

  return _react2$6.default.createElement(
    'svg',
    _extends$2({
      viewBox: '0 0 ' + DEFAULT_SIZE + ' ' + DEFAULT_SIZE,
      style: _extends$2({ fill: fill, width: width, height: height }, style)
    }, props),
    _react2$6.default.createElement('path', { d: 'M12,18.17L8.83,15L7.42,16.41L12,21L16.59,16.41L15.17,15M12,5.83L15.17,9L16.58,7.59L12,3L7.41,7.59L8.83,9L12,5.83Z' })
  );
};Object.defineProperty(ChromeFields$1, "__esModule", {
  value: true
});
ChromeFields$1.ChromeFields = undefined;

var _createClass$2 = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react$5 = React__default['default'];

var _react2$5 = _interopRequireDefault$6(_react$5);

var _reactcss$3 = lib$1;

var _reactcss2$3 = _interopRequireDefault$6(_reactcss$3);

var _color = color$2;

var color = _interopRequireWildcard(_color);

var _isUndefined = isUndefined_1;

var _isUndefined2 = _interopRequireDefault$6(_isUndefined);

var _common$1 = common;

var _UnfoldMoreHorizontalIcon = UnfoldMoreHorizontalIcon;

var _UnfoldMoreHorizontalIcon2 = _interopRequireDefault$6(_UnfoldMoreHorizontalIcon);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault$6(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck$2(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn$2(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits$2(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable react/no-did-mount-set-state, no-param-reassign */

var ChromeFields = ChromeFields$1.ChromeFields = function (_React$Component) {
  _inherits$2(ChromeFields, _React$Component);

  function ChromeFields(props) {
    _classCallCheck$2(this, ChromeFields);

    var _this = _possibleConstructorReturn$2(this, (ChromeFields.__proto__ || Object.getPrototypeOf(ChromeFields)).call(this));

    _this.toggleViews = function () {
      if (_this.state.view === 'hex') {
        _this.setState({ view: 'rgb' });
      } else if (_this.state.view === 'rgb') {
        _this.setState({ view: 'hsl' });
      } else if (_this.state.view === 'hsl') {
        if (_this.props.hsl.a === 1) {
          _this.setState({ view: 'hex' });
        } else {
          _this.setState({ view: 'rgb' });
        }
      }
    };

    _this.handleChange = function (data, e) {
      if (data.hex) {
        color.isValidHex(data.hex) && _this.props.onChange({
          hex: data.hex,
          source: 'hex'
        }, e);
      } else if (data.r || data.g || data.b) {
        _this.props.onChange({
          r: data.r || _this.props.rgb.r,
          g: data.g || _this.props.rgb.g,
          b: data.b || _this.props.rgb.b,
          source: 'rgb'
        }, e);
      } else if (data.a) {
        if (data.a < 0) {
          data.a = 0;
        } else if (data.a > 1) {
          data.a = 1;
        }

        _this.props.onChange({
          h: _this.props.hsl.h,
          s: _this.props.hsl.s,
          l: _this.props.hsl.l,
          a: Math.round(data.a * 100) / 100,
          source: 'rgb'
        }, e);
      } else if (data.h || data.s || data.l) {
        // Remove any occurances of '%'.
        if (typeof data.s === 'string' && data.s.includes('%')) {
          data.s = data.s.replace('%', '');
        }
        if (typeof data.l === 'string' && data.l.includes('%')) {
          data.l = data.l.replace('%', '');
        }

        // We store HSL as a unit interval so we need to override the 1 input to 0.01
        if (data.s == 1) {
          data.s = 0.01;
        } else if (data.l == 1) {
          data.l = 0.01;
        }

        _this.props.onChange({
          h: data.h || _this.props.hsl.h,
          s: Number(!(0, _isUndefined2.default)(data.s) ? data.s : _this.props.hsl.s),
          l: Number(!(0, _isUndefined2.default)(data.l) ? data.l : _this.props.hsl.l),
          source: 'hsl'
        }, e);
      }
    };

    _this.showHighlight = function (e) {
      e.currentTarget.style.background = '#eee';
    };

    _this.hideHighlight = function (e) {
      e.currentTarget.style.background = 'transparent';
    };

    if (props.hsl.a !== 1 && props.view === "hex") {
      _this.state = {
        view: "rgb"
      };
    } else {
      _this.state = {
        view: props.view
      };
    }
    return _this;
  }

  _createClass$2(ChromeFields, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var styles = (0, _reactcss2$3.default)({
        'default': {
          wrap: {
            paddingTop: '16px',
            display: 'flex'
          },
          fields: {
            flex: '1',
            display: 'flex',
            marginLeft: '-6px'
          },
          field: {
            paddingLeft: '6px',
            width: '100%'
          },
          alpha: {
            paddingLeft: '6px',
            width: '100%'
          },
          toggle: {
            width: '32px',
            textAlign: 'right',
            position: 'relative'
          },
          icon: {
            marginRight: '-4px',
            marginTop: '12px',
            cursor: 'pointer',
            position: 'relative'
          },
          iconHighlight: {
            position: 'absolute',
            width: '24px',
            height: '28px',
            background: '#eee',
            borderRadius: '4px',
            top: '10px',
            left: '12px',
            display: 'none'
          },
          input: {
            fontSize: '11px',
            color: '#333',
            width: '100%',
            borderRadius: '2px',
            border: 'none',
            boxShadow: 'inset 0 0 0 1px #dadada',
            height: '21px',
            textAlign: 'center'
          },
          label: {
            textTransform: 'uppercase',
            fontSize: '11px',
            lineHeight: '11px',
            color: '#969696',
            textAlign: 'center',
            display: 'block',
            marginTop: '12px'
          },
          svg: {
            fill: '#333',
            width: '24px',
            height: '24px',
            border: '1px transparent solid',
            borderRadius: '5px'
          }
        },
        'disableAlpha': {
          alpha: {
            display: 'none'
          }
        }
      }, this.props, this.state);

      var fields = void 0;
      if (this.state.view === 'hex') {
        fields = _react2$5.default.createElement(
          'div',
          { style: styles.fields, className: 'flexbox-fix' },
          _react2$5.default.createElement(
            'div',
            { style: styles.field },
            _react2$5.default.createElement(_common$1.EditableInput, {
              style: { input: styles.input, label: styles.label },
              label: 'hex', value: this.props.hex,
              onChange: this.handleChange
            })
          )
        );
      } else if (this.state.view === 'rgb') {
        fields = _react2$5.default.createElement(
          'div',
          { style: styles.fields, className: 'flexbox-fix' },
          _react2$5.default.createElement(
            'div',
            { style: styles.field },
            _react2$5.default.createElement(_common$1.EditableInput, {
              style: { input: styles.input, label: styles.label },
              label: 'r',
              value: this.props.rgb.r,
              onChange: this.handleChange
            })
          ),
          _react2$5.default.createElement(
            'div',
            { style: styles.field },
            _react2$5.default.createElement(_common$1.EditableInput, {
              style: { input: styles.input, label: styles.label },
              label: 'g',
              value: this.props.rgb.g,
              onChange: this.handleChange
            })
          ),
          _react2$5.default.createElement(
            'div',
            { style: styles.field },
            _react2$5.default.createElement(_common$1.EditableInput, {
              style: { input: styles.input, label: styles.label },
              label: 'b',
              value: this.props.rgb.b,
              onChange: this.handleChange
            })
          ),
          _react2$5.default.createElement(
            'div',
            { style: styles.alpha },
            _react2$5.default.createElement(_common$1.EditableInput, {
              style: { input: styles.input, label: styles.label },
              label: 'a',
              value: this.props.rgb.a,
              arrowOffset: 0.01,
              onChange: this.handleChange
            })
          )
        );
      } else if (this.state.view === 'hsl') {
        fields = _react2$5.default.createElement(
          'div',
          { style: styles.fields, className: 'flexbox-fix' },
          _react2$5.default.createElement(
            'div',
            { style: styles.field },
            _react2$5.default.createElement(_common$1.EditableInput, {
              style: { input: styles.input, label: styles.label },
              label: 'h',
              value: Math.round(this.props.hsl.h),
              onChange: this.handleChange
            })
          ),
          _react2$5.default.createElement(
            'div',
            { style: styles.field },
            _react2$5.default.createElement(_common$1.EditableInput, {
              style: { input: styles.input, label: styles.label },
              label: 's',
              value: Math.round(this.props.hsl.s * 100) + '%',
              onChange: this.handleChange
            })
          ),
          _react2$5.default.createElement(
            'div',
            { style: styles.field },
            _react2$5.default.createElement(_common$1.EditableInput, {
              style: { input: styles.input, label: styles.label },
              label: 'l',
              value: Math.round(this.props.hsl.l * 100) + '%',
              onChange: this.handleChange
            })
          ),
          _react2$5.default.createElement(
            'div',
            { style: styles.alpha },
            _react2$5.default.createElement(_common$1.EditableInput, {
              style: { input: styles.input, label: styles.label },
              label: 'a',
              value: this.props.hsl.a,
              arrowOffset: 0.01,
              onChange: this.handleChange
            })
          )
        );
      }

      return _react2$5.default.createElement(
        'div',
        { style: styles.wrap, className: 'flexbox-fix' },
        fields,
        _react2$5.default.createElement(
          'div',
          { style: styles.toggle },
          _react2$5.default.createElement(
            'div',
            { style: styles.icon, onClick: this.toggleViews, ref: function ref(icon) {
                return _this2.icon = icon;
              } },
            _react2$5.default.createElement(_UnfoldMoreHorizontalIcon2.default, {
              style: styles.svg,
              onMouseOver: this.showHighlight,
              onMouseEnter: this.showHighlight,
              onMouseOut: this.hideHighlight
            })
          )
        )
      );
    }
  }], [{
    key: 'getDerivedStateFromProps',
    value: function getDerivedStateFromProps(nextProps, state) {
      if (nextProps.hsl.a !== 1 && state.view === 'hex') {
        return { view: 'rgb' };
      }
      return null;
    }
  }]);

  return ChromeFields;
}(_react2$5.default.Component);

ChromeFields.defaultProps = {
  view: "hex"
};

ChromeFields$1.default = ChromeFields;var ChromePointer$1 = {};Object.defineProperty(ChromePointer$1, "__esModule", {
  value: true
});
ChromePointer$1.ChromePointer = undefined;

var _react$4 = React__default['default'];

var _react2$4 = _interopRequireDefault$5(_react$4);

var _reactcss$2 = lib$1;

var _reactcss2$2 = _interopRequireDefault$5(_reactcss$2);

function _interopRequireDefault$5(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ChromePointer = ChromePointer$1.ChromePointer = function ChromePointer() {
  var styles = (0, _reactcss2$2.default)({
    'default': {
      picker: {
        width: '12px',
        height: '12px',
        borderRadius: '6px',
        transform: 'translate(-6px, -1px)',
        backgroundColor: 'rgb(248, 248, 248)',
        boxShadow: '0 1px 4px 0 rgba(0, 0, 0, 0.37)'
      }
    }
  });

  return _react2$4.default.createElement('div', { style: styles.picker });
};

ChromePointer$1.default = ChromePointer;var ChromePointerCircle$1 = {};Object.defineProperty(ChromePointerCircle$1, "__esModule", {
  value: true
});
ChromePointerCircle$1.ChromePointerCircle = undefined;

var _react$3 = React__default['default'];

var _react2$3 = _interopRequireDefault$4(_react$3);

var _reactcss$1 = lib$1;

var _reactcss2$1 = _interopRequireDefault$4(_reactcss$1);

function _interopRequireDefault$4(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ChromePointerCircle = ChromePointerCircle$1.ChromePointerCircle = function ChromePointerCircle() {
  var styles = (0, _reactcss2$1.default)({
    'default': {
      picker: {
        width: '12px',
        height: '12px',
        borderRadius: '6px',
        boxShadow: 'inset 0 0 0 1px #fff',
        transform: 'translate(-6px, -6px)'
      }
    }
  });

  return _react2$3.default.createElement('div', { style: styles.picker });
};

ChromePointerCircle$1.default = ChromePointerCircle;Object.defineProperty(Chrome$1, "__esModule", {
  value: true
});
Chrome$1.Chrome = undefined;

var _react$2 = React__default['default'];

var _react2$2 = _interopRequireDefault$3(_react$2);

var _propTypes$1 = PropTypes__default['default'];

var _propTypes2$1 = _interopRequireDefault$3(_propTypes$1);

var _reactcss = lib$1;

var _reactcss2 = _interopRequireDefault$3(_reactcss);

var _merge = merge_1;

var _merge2 = _interopRequireDefault$3(_merge);

var _common = common;

var _ChromeFields = ChromeFields$1;

var _ChromeFields2 = _interopRequireDefault$3(_ChromeFields);

var _ChromePointer = ChromePointer$1;

var _ChromePointer2 = _interopRequireDefault$3(_ChromePointer);

var _ChromePointerCircle = ChromePointerCircle$1;

var _ChromePointerCircle2 = _interopRequireDefault$3(_ChromePointerCircle);

function _interopRequireDefault$3(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Chrome = Chrome$1.Chrome = function Chrome(_ref) {
  var width = _ref.width,
      onChange = _ref.onChange,
      disableAlpha = _ref.disableAlpha,
      rgb = _ref.rgb,
      hsl = _ref.hsl,
      hsv = _ref.hsv,
      hex = _ref.hex,
      renderers = _ref.renderers,
      _ref$styles = _ref.styles,
      passedStyles = _ref$styles === undefined ? {} : _ref$styles,
      _ref$className = _ref.className,
      className = _ref$className === undefined ? '' : _ref$className,
      defaultView = _ref.defaultView;

  var styles = (0, _reactcss2.default)((0, _merge2.default)({
    'default': {
      picker: {
        width: width,
        background: '#fff',
        borderRadius: '2px',
        boxShadow: '0 0 2px rgba(0,0,0,.3), 0 4px 8px rgba(0,0,0,.3)',
        boxSizing: 'initial',
        fontFamily: 'Menlo'
      },
      saturation: {
        width: '100%',
        paddingBottom: '55%',
        position: 'relative',
        borderRadius: '2px 2px 0 0',
        overflow: 'hidden'
      },
      Saturation: {
        radius: '2px 2px 0 0'
      },
      body: {
        padding: '16px 16px 12px'
      },
      controls: {
        display: 'flex'
      },
      color: {
        width: '32px'
      },
      swatch: {
        marginTop: '6px',
        width: '16px',
        height: '16px',
        borderRadius: '8px',
        position: 'relative',
        overflow: 'hidden'
      },
      active: {
        absolute: '0px 0px 0px 0px',
        borderRadius: '8px',
        boxShadow: 'inset 0 0 0 1px rgba(0,0,0,.1)',
        background: 'rgba(' + rgb.r + ', ' + rgb.g + ', ' + rgb.b + ', ' + rgb.a + ')',
        zIndex: '2'
      },
      toggles: {
        flex: '1'
      },
      hue: {
        height: '10px',
        position: 'relative',
        marginBottom: '8px'
      },
      Hue: {
        radius: '2px'
      },
      alpha: {
        height: '10px',
        position: 'relative'
      },
      Alpha: {
        radius: '2px'
      }
    },
    'disableAlpha': {
      color: {
        width: '22px'
      },
      alpha: {
        display: 'none'
      },
      hue: {
        marginBottom: '0px'
      },
      swatch: {
        width: '10px',
        height: '10px',
        marginTop: '0px'
      }
    }
  }, passedStyles), { disableAlpha: disableAlpha });

  return _react2$2.default.createElement(
    'div',
    { style: styles.picker, className: 'chrome-picker ' + className },
    _react2$2.default.createElement(
      'div',
      { style: styles.saturation },
      _react2$2.default.createElement(_common.Saturation, {
        style: styles.Saturation,
        hsl: hsl,
        hsv: hsv,
        pointer: _ChromePointerCircle2.default,
        onChange: onChange
      })
    ),
    _react2$2.default.createElement(
      'div',
      { style: styles.body },
      _react2$2.default.createElement(
        'div',
        { style: styles.controls, className: 'flexbox-fix' },
        _react2$2.default.createElement(
          'div',
          { style: styles.color },
          _react2$2.default.createElement(
            'div',
            { style: styles.swatch },
            _react2$2.default.createElement('div', { style: styles.active }),
            _react2$2.default.createElement(_common.Checkboard, { renderers: renderers })
          )
        ),
        _react2$2.default.createElement(
          'div',
          { style: styles.toggles },
          _react2$2.default.createElement(
            'div',
            { style: styles.hue },
            _react2$2.default.createElement(_common.Hue, {
              style: styles.Hue,
              hsl: hsl,
              pointer: _ChromePointer2.default,
              onChange: onChange
            })
          ),
          _react2$2.default.createElement(
            'div',
            { style: styles.alpha },
            _react2$2.default.createElement(_common.Alpha, {
              style: styles.Alpha,
              rgb: rgb,
              hsl: hsl,
              pointer: _ChromePointer2.default,
              renderers: renderers,
              onChange: onChange
            })
          )
        )
      ),
      _react2$2.default.createElement(_ChromeFields2.default, {
        rgb: rgb,
        hsl: hsl,
        hex: hex,
        view: defaultView,
        onChange: onChange,
        disableAlpha: disableAlpha
      })
    )
  );
};

Chrome.propTypes = {
  width: _propTypes2$1.default.oneOfType([_propTypes2$1.default.string, _propTypes2$1.default.number]),
  disableAlpha: _propTypes2$1.default.bool,
  styles: _propTypes2$1.default.object,
  defaultView: _propTypes2$1.default.oneOf(["hex", "rgb", "hsl"])
};

Chrome.defaultProps = {
  width: 225,
  disableAlpha: false,
  styles: {}
};

Chrome$1.default = (0, _common.ColorWrap)(Chrome);Object.defineProperty(Chrome$2, "__esModule", {
  value: true
});
var _default$2 = Chrome$2.default = undefined;

var _Chrome = Chrome$1;

var _Chrome2 = _interopRequireDefault$2(_Chrome);

function _interopRequireDefault$2(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_default$2 = Chrome$2.default = _Chrome2.default;var _templateObject$v, _templateObject2$q, _templateObject3$n, _templateObject4$l, _templateObject5$k, _templateObject6$e;
// Styles
// =============================

var ColorSquare = styled__default['default'].div(_templateObject$v || (_templateObject$v = _taggedTemplateLiteral$5(["\n  background-color: ", ";\n  border-radius: 0.5rem;\n  height: 1.8rem;\n  width: 1.8rem;\n"])), function (_ref) {
  var color = _ref.color;
  return color;
});
var enterAnimation = styled.keyframes(_templateObject2$q || (_templateObject2$q = _taggedTemplateLiteral$5(["\n  from {\n    opacity: 0;\n    transform: translate3d(0, 1rem, 0);\n  }\n\n  to {\n    opacity: 1;\n    transform: translate3d(0, 0, 0);\n  }\n"])));
var Animation = styled__default['default'].div(_templateObject3$n || (_templateObject3$n = _taggedTemplateLiteral$5(["\n  animation: ", " ", " ", " 1;\n  animation-fill-mode: forwards;\n  margin-top: 1rem;\n  opacity: 0;\n  position: absolute;\n  z-index: ", ";\n"])), enterAnimation, function (_ref2) {
  var theme = _ref2.theme;
  return theme.transition.medium;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.transitionTiming.easeInOut;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.zIndex.dropdown;
});
var StyledContainer$3 = styled__default['default'](Container$1)(_templateObject4$l || (_templateObject4$l = _taggedTemplateLiteral$5(["\n  align-items: center;\n  cursor: ", ";\n  display: flex;\n"])), function (_ref5) {
  var disabled = _ref5.disabled;
  return disabled ? 'default' : 'pointer';
});
var StyledHelpers$2 = styled__default['default'](Helpers)(_templateObject5$k || (_templateObject5$k = _taggedTemplateLiteral$5(["\n  margin-left: auto;\n"])));
var Value$1 = styled__default['default'].div(_templateObject6$e || (_templateObject6$e = _taggedTemplateLiteral$5(["\n  align-items: center;\n  color: ", ";\n  display: flex;\n  justify-content: flex-start;\n  line-height: 1;\n  font-size: inherit;\n  font-weight: inherit;\n  height: 100%;\n  margin-right: 1.2rem;\n  user-select: none;\n"])), function (_ref6) {
  var error = _ref6.error,
      theme = _ref6.theme;
  return error ? theme.colors.type.error : theme.colors.input.text;
});var _excluded$m = ["acceptTransparent", "className", "containerClassName", "disabled", "error", "helperText", "label", "lang", "optional", "tooltipError", "tooltipInteractive", "tooltipMessage", "tooltipPlacement", "value", "variant"];
// Component
// =============================

var ColorPicker = /*#__PURE__*/function (_PureComponent) {
  _inherits$e(ColorPicker, _PureComponent);

  var _super = _createSuper$1(ColorPicker);

  function ColorPicker(props) {
    var _this;

    _classCallCheck$k(this, ColorPicker);

    _this = _super.call(this, props);

    _defineProperty$8(_assertThisInitialized$1(_this), "handleChange", function (color) {
      var _this$props = _this.props,
          onChange = _this$props.onChange,
          disabled = _this$props.disabled;
      if (onChange && !disabled) onChange(color.hex);
    });

    _defineProperty$8(_assertThisInitialized$1(_this), "handleResetBtn", function () {
      var _this$props2 = _this.props,
          acceptTransparent = _this$props2.acceptTransparent,
          onChange = _this$props2.onChange,
          disabled = _this$props2.disabled;
      if (acceptTransparent && onChange && !disabled) onChange('');
    });

    _defineProperty$8(_assertThisInitialized$1(_this), "handleClick", function () {
      var disabled = _this.props.disabled;
      if (!disabled) _this.setState(function (state) {
        return {
          displayColorPicker: !state.displayColorPicker
        };
      });
    });

    _defineProperty$8(_assertThisInitialized$1(_this), "closeColor", function () {
      return _this.setState({
        displayColorPicker: false
      });
    });

    _defineProperty$8(_assertThisInitialized$1(_this), "renderValue", function () {
      var _this$props3 = _this.props,
          acceptTransparent = _this$props3.acceptTransparent,
          lang = _this$props3.lang,
          value = _this$props3.value;
      if (acceptTransparent && value === '') return lang.transparent;
      return value;
    });

    _this.state = {
      displayColorPicker: false
    };
    return _this;
  }

  _createClass$g(ColorPicker, [{
    key: "render",
    value: function render() {
      var _this$props4 = this.props,
          acceptTransparent = _this$props4.acceptTransparent,
          className = _this$props4.className,
          containerClassName = _this$props4.containerClassName,
          disabled = _this$props4.disabled,
          error = _this$props4.error,
          helperText = _this$props4.helperText,
          label = _this$props4.label,
          lang = _this$props4.lang,
          optional = _this$props4.optional,
          tooltipError = _this$props4.tooltipError,
          tooltipInteractive = _this$props4.tooltipInteractive,
          tooltipMessage = _this$props4.tooltipMessage,
          tooltipPlacement = _this$props4.tooltipPlacement,
          value = _this$props4.value,
          variant = _this$props4.variant,
          rest = _objectWithoutProperties$7(_this$props4, _excluded$m);

      var displayColorPicker = this.state.displayColorPicker;
      return /*#__PURE__*/React__default['default'].createElement(Wrapper$p, _extends$g({
        className: className
      }, getViewProps(rest)), /*#__PURE__*/React__default['default'].createElement(Label$2, {
        active: displayColorPicker,
        inputFilled: !!value,
        error: error,
        label: label,
        lang: lang.Label,
        optional: optional,
        variant: variant
      }), /*#__PURE__*/React__default['default'].createElement(StyledContainer$3, {
        className: containerClassName,
        disabled: disabled,
        onClick: this.handleClick,
        variant: variant
      }, /*#__PURE__*/React__default['default'].createElement(Value$1, {
        error: error
      }, this.renderValue()), /*#__PURE__*/React__default['default'].createElement(ColorSquare, {
        color: value
      }), /*#__PURE__*/React__default['default'].createElement(StyledHelpers$2, {
        onResetBtn: acceptTransparent ? this.handleResetBtn : null,
        tooltipError: tooltipError,
        tooltipInteractive: tooltipInteractive,
        tooltipMessage: tooltipMessage,
        tooltipPlacement: tooltipPlacement
      })), helperText && /*#__PURE__*/React__default['default'].createElement(HelperText, null, helperText), displayColorPicker && /*#__PURE__*/React__default['default'].createElement(Animation, null, /*#__PURE__*/React__default['default'].createElement(ClickAwayListener, {
        onClickAway: this.closeColor
      }, /*#__PURE__*/React__default['default'].createElement(_default$2, {
        color: value,
        disableAlpha: true,
        onChange: this.handleChange
      }))));
    }
  }]);

  return ColorPicker;
}(React.PureComponent);

ColorPicker.propTypes = {
  /** If True, will accept empty value as transparent. */
  acceptTransparent: PropTypes__default['default'].bool,

  /** Props used by styled component to override styles */
  className: PropTypes__default['default'].string,

  /** Container classname. */
  containerClassName: PropTypes__default['default'].string,

  /** If true, the input will be disabled. */
  disabled: PropTypes__default['default'].bool,

  /** If true, the input will indicate an error. */
  error: PropTypes__default['default'].bool,

  /** The helper text content. */
  helperText: PropTypes__default['default'].node,

  /** Label */
  label: PropTypes__default['default'].string,

  /** Translation strings. */
  lang: PropTypes__default['default'].object.isRequired,
  // eslint-disable-line react/forbid-prop-types

  /** onChange handler */
  onChange: PropTypes__default['default'].func,

  /** If true, the input is optional. */
  optional: PropTypes__default['default'].bool,

  /** Used to display error messsage as tooltip. */
  tooltipError: PropTypes__default['default'].string,

  /** If True, Tooltips will be interactive. */
  tooltipInteractive: PropTypes__default['default'].bool,

  /** If set, will add an InfoTooltip btn on input with tooltipMessage as content. */
  tooltipMessage: PropTypes__default['default'].node,

  /** Tooltip placement */
  tooltipPlacement: PropTypes__default['default'].oneOf(['bottom-end', 'bottom-start', 'bottom', 'left-end', 'left-start', 'left', 'right-end', 'right-start', 'right', 'top-end', 'top-start', 'top']),

  /** Value */
  value: PropTypes__default['default'].string,

  /** Input style variant. */
  variant: PropTypes__default['default'].oneOf(['background', 'underline'])
};
ColorPicker.defaultProps = {
  acceptTransparent: false,
  className: '',
  containerClassName: '',
  disabled: false,
  error: false,
  helperText: '',
  label: '',
  onChange: null,
  optional: false,
  tooltipError: '',
  tooltipInteractive: false,
  tooltipMessage: '',
  tooltipPlacement: 'bottom',
  value: '',
  variant: 'background'
};// =============================
// Component
// =============================
// eslint-disable-next-line max-len

var ConditionalWrapper = function ConditionalWrapper(_ref) {
  var condition = _ref.condition,
      Wrapper = _ref.Wrapper,
      children = _ref.children;
  return condition ? /*#__PURE__*/React__default['default'].cloneElement(Wrapper, {
    children: children
  }) : children;
};

ConditionalWrapper.propTypes = {
  /** Node wrapped. */
  children: PropTypes__default['default'].node.isRequired,

  /** If True, Wrapper is used. */
  condition: PropTypes__default['default'].bool.isRequired,

  /** Wrapper. */
  Wrapper: PropTypes__default['default'].node.isRequired
};var _excluded$l = ["DesktopComponent", "MobileComponent"];
// Helpers
// =============================

var Desktop = function Desktop(_ref) {
  var children = _ref.children;
  var isDesktop = reactResponsive.useMediaQuery({
    minWidth: 1024
  });
  return isDesktop ? children : null;
};
var Mobile = function Mobile(_ref2) {
  var children = _ref2.children;
  var isMobile = reactResponsive.useMediaQuery({
    maxWidth: 1023
  });
  return isMobile ? children : null;
};
// Components
// =============================

var WrapperSwitcher = function WrapperSwitcher(_ref3) {
  var DesktopComponent = _ref3.DesktopComponent,
      MobileComponent = _ref3.MobileComponent,
      rest = _objectWithoutProperties$7(_ref3, _excluded$l);

  var shouldRenderMobile = reactResponsive.useMediaQuery({
    maxWidth: 1023
  });

  if (shouldRenderMobile) {
    if ( /*#__PURE__*/React__default['default'].isValidElement(MobileComponent)) {
      return /*#__PURE__*/React__default['default'].cloneElement(MobileComponent, _objectSpread2$2({}, rest));
    }

    return /*#__PURE__*/React__default['default'].createElement(MobileComponent, rest);
  }

  if ( /*#__PURE__*/React__default['default'].isValidElement(DesktopComponent)) {
    return /*#__PURE__*/React__default['default'].cloneElement(DesktopComponent, _objectSpread2$2({}, rest));
  }

  return /*#__PURE__*/React__default['default'].createElement(DesktopComponent, rest);
};
WrapperSwitcher.propTypes = {
  DesktopComponent: PropTypes__default['default'].oneOfType([PropTypes__default['default'].elementType, PropTypes__default['default'].object]).isRequired,
  MobileComponent: PropTypes__default['default'].oneOfType([PropTypes__default['default'].elementType, PropTypes__default['default'].object]).isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  props: PropTypes__default['default'].object
};
WrapperSwitcher.defaultProps = {
  props: {}
};

var Responsive = function Responsive(_ref4) {
  var DesktopComponent = _ref4.DesktopComponent,
      MobileComponent = _ref4.MobileComponent,
      props = _ref4.props;
  return /*#__PURE__*/React__default['default'].createElement(React__default['default'].Fragment, null, DesktopComponent && /*#__PURE__*/React__default['default'].createElement(Desktop, null, /*#__PURE__*/React__default['default'].createElement(DesktopComponent, props)), MobileComponent && /*#__PURE__*/React__default['default'].createElement(Mobile, null, /*#__PURE__*/React__default['default'].createElement(MobileComponent, props)));
};

Responsive.propTypes = {
  DesktopComponent: PropTypes__default['default'].elementType,
  MobileComponent: PropTypes__default['default'].elementType,
  // eslint-disable-next-line react/forbid-prop-types
  props: PropTypes__default['default'].object.isRequired
};
Responsive.defaultProps = {
  DesktopComponent: null,
  MobileComponent: null
};var _templateObject$u, _templateObject2$p, _templateObject3$m, _templateObject4$k, _templateObject5$j, _templateObject6$d;
// Component
// =============================

var Wrapper$m = styled__default['default'].span.attrs(function (_ref) {
  var alt = _ref.alt;
  return {
    'aria-label': alt,
    role: 'img'
  };
})(_templateObject$u || (_templateObject$u = _taggedTemplateLiteral$5(["\n  background-color: ", ";\n  display: block;\n  left: 0;\n  overflow: hidden;\n  padding-top: 100%;\n  position: absolute;\n  top: 0;\n  transition: box-shadow ", ";\n  width: 100%;\n  z-index: 1;\n\n  ", "\n\n  ", "\n\n  ", "\n\n  ", "\n"])), function (_ref2) {
  var theme = _ref2.theme;
  return alpha$2(theme.colors.white, 0.8);
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.transition.medium;
}, function (_ref4) {
  var src = _ref4.src;
  return src && styled.css(_templateObject2$p || (_templateObject2$p = _taggedTemplateLiteral$5(["\n    background-image: url('", "');\n    background-position: center;\n    background-size: cover;\n  "])), src);
}, function (_ref5) {
  var noRadius = _ref5.noRadius;

  if (!noRadius) {
    return styled.css(_templateObject3$m || (_templateObject3$m = _taggedTemplateLiteral$5(["\n        border-radius: 0.5rem;\n      "])));
  }

  return null;
}, function (_ref6) {
  var imageHovered = _ref6.imageHovered,
      noBoxShadow = _ref6.noBoxShadow,
      theme = _ref6.theme;
  return imageHovered && !noBoxShadow && styled.css(_templateObject4$k || (_templateObject4$k = _taggedTemplateLiteral$5(["\n      box-shadow: 0 1.5rem 8rem 1rem ", ";\n    "])), theme.colors.boxShadow);
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.coverConfig.enableFilter && styled.css(_templateObject5$j || (_templateObject5$j = _taggedTemplateLiteral$5(["\n      &::before {\n        background-image: url(", ");\n        bottom: 0;\n        content: '';\n        left: 0;\n        position: absolute;\n        right: 0;\n        top: 0;\n      }\n\n      /** NOTE: These colors do not change (for cover filter) */\n      &::after {\n        background: radial-gradient(ellipse at center, #fcfff4 0%, #383838 100%);\n        border-radius: inherit;\n        border: 1px solid #808080;\n        bottom: 0;\n        content: '';\n        height: 100%;\n        left: 0;\n        opacity: 0.1;\n        position: absolute;\n        width: 100%;\n      }\n    "])), function (_ref8) {
    var coverFilter = _ref8.coverFilter;
    return coverFilter;
  });
});
var Img$2 = styled__default['default'](Div)(_templateObject6$d || (_templateObject6$d = _taggedTemplateLiteral$5(["\n  background-image: url('", "');\n  background-position: center;\n  background-size: cover;\n  height: 50%;\n  position: absolute;\n  width: 50%;\n\n  &:nth-of-type(1) {\n    left: 0;\n    top: 0;\n  }\n\n  &:nth-of-type(2) {\n    left: 50%;\n    top: 0;\n  }\n  &:nth-of-type(3) {\n    left: 0;\n    top: 50%;\n  }\n  &:nth-of-type(4) {\n    left: 50%;\n    top: 50%;\n  }\n"])), function (_ref9) {
  var src = _ref9.src;
  return src;
});// =============================
// Component
// =============================

var Image$1 = /*#__PURE__*/React__default['default'].memo(function (_ref) {
  var alt = _ref.alt,
      imageHovered = _ref.imageHovered,
      images = _ref.images,
      noBoxShadow = _ref.noBoxShadow,
      noRadius = _ref.noRadius,
      placeholderType = _ref.placeholderType,
      src = _ref.src,
      type = _ref.type;
  var placeholder = '';

  switch (placeholderType) {
    case 'album':
      placeholder = images.albumplaceholder;
      break;

    case 'artist':
      placeholder = images.artistplaceholder;
      break;

    case 'catalog':
      placeholder = images.catalogplaceholder;
      break;

    case 'label':
      placeholder = images.labelplaceholder;
      break;

    case 'playlist':
      placeholder = images.playlistplaceholder;
      break;

    case 'post':
      placeholder = images.postplaceholder;
      break;

    case 'publisher':
      placeholder = images.publisherplaceholder;
      break;

    case 'track':
      placeholder = images.trackplaceholder;
      break;

    default:
      placeholder = images.trackplaceholder;
      break;
  }

  var content = null;

  if (isArray_1(src)) {
    // We only show splitted cover if we have 4 or more cover.
    if (src.length >= 4) {
      content = /*#__PURE__*/React__default['default'].createElement(Wrapper$m, {
        alt: alt,
        coverFilter: images.filter,
        imageHovered: imageHovered,
        noBoxShadow: noBoxShadow,
        noRadius: noRadius,
        type: type
      }, /*#__PURE__*/React__default['default'].createElement(Img$2, {
        src: src[0] || placeholder
      }), /*#__PURE__*/React__default['default'].createElement(Img$2, {
        src: src[1] || placeholder
      }), /*#__PURE__*/React__default['default'].createElement(Img$2, {
        src: src[2] || placeholder
      }), /*#__PURE__*/React__default['default'].createElement(Img$2, {
        src: src[3] || placeholder
      }));
    } else {
      content = /*#__PURE__*/React__default['default'].createElement(Wrapper$m, {
        alt: alt,
        coverFilter: images.filter,
        imageHovered: imageHovered,
        noBoxShadow: noBoxShadow,
        noRadius: noRadius,
        src: src[0] || placeholder,
        type: type
      });
    }
  } else {
    content = /*#__PURE__*/React__default['default'].createElement(Wrapper$m, {
      alt: alt,
      coverFilter: images.filter,
      imageHovered: imageHovered,
      noBoxShadow: noBoxShadow,
      noRadius: noRadius,
      src: src || placeholder,
      type: type
    });
  }

  return content;
});
Image$1.propTypes = {
  /** Image alt. */
  alt: PropTypes__default['default'].string,

  /** If True, toggle hovered state */
  imageHovered: PropTypes__default['default'].bool,

  /** Passed Images */
  images: PropTypes__default['default'].shape({
    albumplaceholder: PropTypes__default['default'].string,
    artistplaceholder: PropTypes__default['default'].string,
    catalogplaceholder: PropTypes__default['default'].string,
    filter: PropTypes__default['default'].string,
    labelplaceholder: PropTypes__default['default'].string,
    playlistplaceholder: PropTypes__default['default'].string,
    postplaceholder: PropTypes__default['default'].string,
    publisherplaceholder: PropTypes__default['default'].string,
    trackplaceholder: PropTypes__default['default'].string,
    vynil: PropTypes__default['default'].string
  }).isRequired,

  /** If True, will render Cover without box-shadow */
  noBoxShadow: PropTypes__default['default'].bool,

  /** If True, will render Cover with border radius = 0. */
  noRadius: PropTypes__default['default'].bool,

  /** Type of placeholder to used if 'src' is empty. */
  placeholderType: PropTypes__default['default'].oneOf(['artist', 'album', 'catalog', 'label', 'post', 'playlist', 'publisher', 'track']).isRequired,

  /** Cover image source */
  src: PropTypes__default['default'].oneOfType([PropTypes__default['default'].string, PropTypes__default['default'].arrayOf(PropTypes__default['default'].string)]),

  /** Cover type. */
  type: PropTypes__default['default'].oneOf(['album', 'artist', 'catalog', 'label', 'post', 'playlist', 'publisher', 'track'])
};
Image$1.defaultProps = {
  alt: '',
  imageHovered: false,
  noBoxShadow: false,
  noRadius: false,
  src: '',
  type: ''
};var _templateObject$t, _templateObject2$o, _templateObject3$l;
// Component
// =============================

var Wrapper$l = styled__default['default'](Div)(_templateObject$t || (_templateObject$t = _taggedTemplateLiteral$5(["\n  align-items: center;\n  background-image: url('", "');\n  background-position: center;\n  background-size: cover;\n  display: flex;\n  justify-content: center;\n  position: relative;\n  width: 100%;\n"])), function (_ref) {
  var src = _ref.src;
  return src;
});
var Img$1 = styled__default['default'].img(_templateObject2$o || (_templateObject2$o = _taggedTemplateLiteral$5(["\n  left: 0;\n  right: 0;\n  bottom: 0;\n  top: 0;\n  width: 100%;\n"])));
var Cover$3 = styled__default['default'].div(_templateObject3$l || (_templateObject3$l = _taggedTemplateLiteral$5(["\n  background-image: url('", "');\n  background-position: center;\n  background-size: cover;\n  border-radius: 50%;\n  height: 36%;\n  left: calc(50% - 18%);\n  position: absolute;\n  top: calc(50% - 18%);\n  width: 36%;\n"])), function (_ref2) {
  var src = _ref2.src;
  return src;
});var _excluded$k = ["images", "src"];
// Component
// =============================

var Vynil = /*#__PURE__*/React__default['default'].memo(function (_ref) {
  var images = _ref.images,
      src = _ref.src,
      rest = _objectWithoutProperties$7(_ref, _excluded$k);

  return /*#__PURE__*/React__default['default'].createElement(Wrapper$l, getViewProps(rest), /*#__PURE__*/React__default['default'].createElement(Img$1, {
    src: images.vynil,
    alt: ""
  }), /*#__PURE__*/React__default['default'].createElement(Cover$3, {
    src: src
  }));
});
Vynil.propTypes = {
  /** Passed Images */
  images: PropTypes__default['default'].shape({
    vynil: PropTypes__default['default'].string
  }).isRequired,

  /** Vynil image source */
  src: PropTypes__default['default'].string.isRequired
};var tilt = {};Object.defineProperty(tilt, "__esModule", {
  value: true
});

var _extends$1 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass$1 = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react$1 = React__default['default'];

var _react2$1 = _interopRequireDefault$1(_react$1);

var _reactDom = ReactDOM__default['default'];

function _interopRequireDefault$1(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck$1(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn$1(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits$1(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Tilt = function (_Component) {
  _inherits$1(Tilt, _Component);

  function Tilt(props) {
    _classCallCheck$1(this, Tilt);

    var _this = _possibleConstructorReturn$1(this, (Tilt.__proto__ || Object.getPrototypeOf(Tilt)).call(this, props));

    _this.state = {
      style: {}
    };

    var defaultSettings = {
      reverse: false,
      max: 35,
      perspective: 1000,
      easing: "cubic-bezier(.03,.98,.52,.99)",
      scale: "1.1",
      speed: "1000",
      transition: true,
      axis: null,
      reset: true
    };

    _this.width = null;
    _this.height = null;
    _this.left = null;
    _this.top = null;
    _this.transitionTimeout = null;
    _this.updateCall = null;
    _this.element = null;
    _this.settings = Object.assign({}, defaultSettings, _this.props.options);
    _this.reverse = _this.settings.reverse ? -1 : 1;

    // Events
    _this.onMouseEnter = _this.onMouseEnter.bind(_this, _this.props.onMouseEnter);
    _this.onMouseMove = _this.onMouseMove.bind(_this, _this.props.onMouseMove);
    _this.onMouseLeave = _this.onMouseLeave.bind(_this, _this.props.onMouseLeave);
    return _this;
  }

  _createClass$1(Tilt, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.element = (0, _reactDom.findDOMNode)(this);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      clearTimeout(this.transitionTimeout);
      cancelAnimationFrame(this.updateCall);
    }
  }, {
    key: 'onMouseEnter',
    value: function onMouseEnter() {
      var cb = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function () {};
      var e = arguments[1];

      this.updateElementPosition();

      this.setState(Object.assign({}, this.state, {
        style: _extends$1({}, this.state.style, {
          willChange: "transform"
        })
      }));

      this.setTransition();

      return cb(e);
    }
  }, {
    key: 'reset',
    value: function reset() {
      var _this2 = this;

      window.requestAnimationFrame(function () {
        _this2.setState(Object.assign({}, _this2.state, {
          style: _extends$1({}, _this2.state.style, {
            transform: "perspective(" + _this2.settings.perspective + "px) " + "rotateX(0deg) " + "rotateY(0deg) " + "scale3d(1, 1, 1)" })
        }));
      });
    }
  }, {
    key: 'onMouseMove',
    value: function onMouseMove() {
      var cb = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function () {};
      var e = arguments[1];

      e.persist();

      if (this.updateCall !== null) {
        window.cancelAnimationFrame(this.updateCall);
      }

      this.event = e;
      this.updateCall = requestAnimationFrame(this.update.bind(this, e));

      return cb(e);
    }
  }, {
    key: 'setTransition',
    value: function setTransition() {
      var _this3 = this;

      clearTimeout(this.transitionTimeout);

      this.setState(Object.assign({}, this.state, {
        style: _extends$1({}, this.state.style, {
          transition: this.settings.speed + "ms " + this.settings.easing
        })
      }));

      this.transitionTimeout = setTimeout(function () {
        _this3.setState(Object.assign({}, _this3.state, {
          style: _extends$1({}, _this3.state.style, {
            transition: ''
          })
        }));
      }, this.settings.speed);
    }
  }, {
    key: 'onMouseLeave',
    value: function onMouseLeave() {
      var cb = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function () {};
      var e = arguments[1];

      this.setTransition();

      if (this.settings.reset) {
        this.reset();
      }
      return cb(e);
    }
  }, {
    key: 'getValues',
    value: function getValues(e) {
      var x = (e.nativeEvent.clientX - this.left) / this.width;
      var y = (e.nativeEvent.clientY - this.top) / this.height;
      var _x = Math.min(Math.max(x, 0), 1);
      var _y = Math.min(Math.max(y, 0), 1);

      var tiltX = (this.reverse * (this.settings.max / 2 - _x * this.settings.max)).toFixed(2);
      var tiltY = (this.reverse * (_y * this.settings.max - this.settings.max / 2)).toFixed(2);

      var percentageX = _x * 100;
      var percentageY = _y * 100;

      return {
        tiltX: tiltX,
        tiltY: tiltY,
        percentageX: percentageX,
        percentageY: percentageY
      };
    }
  }, {
    key: 'updateElementPosition',
    value: function updateElementPosition() {
      var rect = this.element.getBoundingClientRect();
      this.width = this.element.offsetWidth;
      this.height = this.element.offsetHeight;
      this.left = rect.left;
      this.top = rect.top;
    }
  }, {
    key: 'update',
    value: function update(e) {
      var values = this.getValues(e);

      this.setState(Object.assign({}, this.state, {
        style: _extends$1({}, this.state.style, {
          transform: "perspective(" + this.settings.perspective + "px) " + "rotateX(" + (this.settings.axis === "x" ? 0 : values.tiltY) + "deg) " + "rotateY(" + (this.settings.axis === "y" ? 0 : values.tiltX) + "deg) " + "scale3d(" + this.settings.scale + ", " + this.settings.scale + ", " + this.settings.scale + ")"
        })
      }));

      this.updateCall = null;
    }
  }, {
    key: 'render',
    value: function render() {
      var style = Object.assign({}, this.props.style, this.state.style);
      return _react2$1.default.createElement(
        'div',
        { style: style,
          className: this.props.className,
          onMouseEnter: this.onMouseEnter,
          onMouseMove: this.onMouseMove,
          onMouseLeave: this.onMouseLeave
        },
        this.props.children
      );
    }
  }]);

  return Tilt;
}(_react$1.Component);

var _default$1 = tilt.default = Tilt;var _excluded$j = ["noTilt"],
    _excluded2$5 = ["LinkComponent"],
    _excluded3$2 = ["LinkComponent"];

var _templateObject$s, _templateObject2$n, _templateObject3$k, _templateObject4$j, _templateObject5$i, _templateObject6$c, _templateObject7$b, _templateObject8$b, _templateObject9$7, _templateObject10$7, _templateObject11$7, _templateObject12$6, _templateObject13$6, _templateObject14$6, _templateObject15$5, _templateObject16$3, _templateObject17$3, _templateObject18$2, _templateObject19$1, _templateObject20$1, _templateObject21$1, _templateObject22;
// Component
// =============================

var VynilWrapper = styled__default['default'].div(_templateObject$s || (_templateObject$s = _taggedTemplateLiteral$5(["\n  left: 2%;\n  position: absolute;\n  transition: transform ", ";\n  top: 2%;\n  width: 96%;\n  z-index: 0;\n\n  ", ";\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.transition.medium;
}, function (_ref2) {
  var imageHovered = _ref2.imageHovered;
  return imageHovered && styled.css(_templateObject2$n || (_templateObject2$n = _taggedTemplateLiteral$5(["\n      transform: translate3d(40%, 0, 0) rotate(45deg);\n    "])));
});
var PlayContainer$1 = styled__default['default'].div(_templateObject3$k || (_templateObject3$k = _taggedTemplateLiteral$5(["\n  align-items: center;\n  background: rgba(0, 0, 0, 0.6);\n  bottom: 0;\n  display: flex;\n  justify-content: center;\n  left: 0;\n  opacity: 0;\n  pointer-events: none;\n  position: absolute;\n  top: 0;\n  transition: opacity ", ",\n    transform ", ";\n  right: 0;\n  z-index: 1;\n\n  ", ";\n\n  ", ";\n"])), function (_ref3) {
  var theme = _ref3.theme;
  return theme.transition.medium;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.transition.medium;
}, function (_ref5) {
  var imageHovered = _ref5.imageHovered;
  return imageHovered && styled.css(_templateObject4$j || (_templateObject4$j = _taggedTemplateLiteral$5(["\n      opacity: 1;\n      pointer-events: auto;\n    "])));
}, function (_ref6) {
  var noRadius = _ref6.noRadius;

  if (!noRadius) {
    return styled.css(_templateObject5$i || (_templateObject5$i = _taggedTemplateLiteral$5(["\n        border-radius: 0.5rem;\n      "])));
  }

  return null;
});
/** NOTE: The fill is fixed because the button is always above a dark layer */

var PlayButton$1 = styled__default['default'](PlayOutline$1).attrs(function (_ref7) {
  var playButtonSize = _ref7.playButtonSize;
  return {
    fill: '#ffffff',
    strokeWidth: 1,
    width: ['musicItem', 'small'].includes(playButtonSize) ? '60%' : '35%'
  };
})(_templateObject6$c || (_templateObject6$c = _taggedTemplateLiteral$5(["\n  max-height: 10rem;\n  max-width: 10rem;\n  transition: transform ", ";\n\n  &:hover {\n    transform: scale(1.1);\n  }\n"])), function (_ref8) {
  var theme = _ref8.theme;
  return theme.transition.medium;
});
/** NOTE: The fill is fixed because the button is always above a dark layer */

var PauseButton$1 = styled__default['default'](PauseOutline$1).attrs(function (_ref9) {
  var playButtonSize = _ref9.playButtonSize;
  return {
    fill: '#ffffff',
    strokeWidth: 1,
    width: ['musicItem', 'small'].includes(playButtonSize) ? '60%' : '35%'
  };
})(_templateObject7$b || (_templateObject7$b = _taggedTemplateLiteral$5(["\n  max-height: 10rem;\n  max-width: 10rem;\n  transition: transform ", ";\n\n  &:hover {\n    transform: scale(1.1);\n  }\n"])), function (_ref10) {
  var theme = _ref10.theme;
  return theme.transition.medium;
});
var tiltStyles = styled.css(_templateObject8$b || (_templateObject8$b = _taggedTemplateLiteral$5(["\n  padding-top: 100%;\n  position: relative;\n  width: 100%;\n\n  ", ";\n"])), function (_ref11) {
  var rounded = _ref11.rounded;
  return rounded && styled.css(_templateObject9$7 || (_templateObject9$7 = _taggedTemplateLiteral$5(["\n      border-radius: 50%;\n      overflow: hidden;\n    "])));
});
var StyledTiltTrue = styled__default['default'](_default$1).attrs(function () {
  return {
    options: {
      reverse: true,
      // reverse the tilt direction
      max: 15,
      // max tilt rotation (degrees)
      perspective: 1000,
      // Transform perspective, the lower the more extreme the tilt gets.
      scale: 1,
      // 2 = 200%, 1.5 = 150%, etc..
      speed: 1000,
      // Speed of the enter/exit transition
      transition: true,
      // Set a transition on enter/exit.
      axis: null,
      // What axis should be disabled. Can be X or Y.
      reset: true,
      // If the tilt effect has to be reset on exit.
      easing: 'cubic-bezier(.03,.98,.52,.99)' // Easing on enter/exit.

    }
  };
})(_templateObject10$7 || (_templateObject10$7 = _taggedTemplateLiteral$5(["\n  ", "\n"])), tiltStyles);
var StyledTiltFalse = styled__default['default'].div(_templateObject11$7 || (_templateObject11$7 = _taggedTemplateLiteral$5(["\n  ", "\n"])), tiltStyles);
var StyledTilt = /*#__PURE__*/React__default['default'].memo(function (_ref12) {
  var noTilt = _ref12.noTilt,
      props = _objectWithoutProperties$7(_ref12, _excluded$j);

  if (noTilt) {
    return /*#__PURE__*/React__default['default'].createElement(StyledTiltFalse, props);
  }

  return /*#__PURE__*/React__default['default'].createElement(StyledTiltTrue, props);
});
StyledTilt.propTypes = {
  noTilt: PropTypes__default['default'].bool.isRequired
};
var ImageWrapper$1 = styled__default['default'](function (_ref13) {
  var LinkComponent = _ref13.LinkComponent,
      props = _objectWithoutProperties$7(_ref13, _excluded2$5);

  return /*#__PURE__*/React__default['default'].createElement(LinkComponent, _extends$g({}, pick_1(props, ['className', 'children']), props.linkProps));
})(_templateObject12$6 || (_templateObject12$6 = _taggedTemplateLiteral$5(["\n  cursor: ", ";\n  display: inline-block;\n  position: relative;\n  user-select: none;\n  width: 100%;\n\n  ", ";\n"])), function (_ref14) {
  var linkProps = _ref14.linkProps;
  return Object.keys(linkProps).length ? 'pointer' : 'default';
}, function (_ref15) {
  var rounded = _ref15.rounded;
  return rounded && styled.css(_templateObject13$6 || (_templateObject13$6 = _taggedTemplateLiteral$5(["\n      border-radius: 50%;\n      overflow: hidden;\n    "])));
});
var ImageContainer$1 = styled__default['default'].div(_templateObject14$6 || (_templateObject14$6 = _taggedTemplateLiteral$5(["\n  position: relative;\n  transition: transform ", ";\n\n  &:not(:last-child) {\n    margin-bottom: 0.8rem;\n\n    ", ";\n  }\n\n  ", ";\n"])), function (_ref16) {
  var theme = _ref16.theme;
  return theme.transition.medium;
}, function (_ref17) {
  var theme = _ref17.theme;
  return theme.mediaAbove.minWidth(_templateObject15$5 || (_templateObject15$5 = _taggedTemplateLiteral$5(["\n      margin-bottom: 2rem;\n    "])));
}, function (_ref18) {
  var imageHovered = _ref18.imageHovered,
      noScale = _ref18.noScale,
      noTranslateY = _ref18.noTranslateY,
      vynil = _ref18.vynil;
  return imageHovered && (vynil || !noTranslateY || !noScale) && styled.css(_templateObject16$3 || (_templateObject16$3 = _taggedTemplateLiteral$5(["\n      transform: translate3d(", ", ", ", 0)\n        scale(", ");\n    "])), vynil ? '-10%' : '0', noTranslateY ? '0' : '-1.2rem', noScale ? '1' : '1.05');
});
var Type$2 = styled__default['default'].div(_templateObject17$3 || (_templateObject17$3 = _taggedTemplateLiteral$5(["\n  font-size: 1.3rem;\n  font-weight: ", ";\n\n  &:not(:last-child) {\n    margin-bottom: 0.4rem;\n  }\n"])), function (_ref19) {
  var theme = _ref19.theme;
  return theme.fontWeight.semibold;
});
var Title$2 = styled__default['default'](function (_ref20) {
  var LinkComponent = _ref20.LinkComponent,
      props = _objectWithoutProperties$7(_ref20, _excluded3$2);

  return /*#__PURE__*/React__default['default'].createElement(LinkComponent, _extends$g({}, pick_1(props, ['className', 'children']), props.linkProps));
})(_templateObject18$2 || (_templateObject18$2 = _taggedTemplateLiteral$5(["\n  display: inline-block;\n  font-size: 1.5rem;\n  line-height: 1.8rem;\n  font-weight: ", ";\n  max-width: 100%;\n  overflow-wrap: break-word;\n  text-decoration: none;\n\n  &:not(:last-child) {\n    margin-bottom: 0.8rem;\n  }\n"])), function (_ref21) {
  var theme = _ref21.theme;
  return theme.fontWeight.extrabold;
});
var Description$1 = styled__default['default'].div(_templateObject19$1 || (_templateObject19$1 = _taggedTemplateLiteral$5(["\n  font-size: 1.4rem;\n  font-weight: ", ";\n  max-height: 5.8rem;\n  line-height: 1.4;\n  opacity: 0.7;\n  overflow: hidden;\n  overflow-wrap: break-word;\n\n  &:not(:last-child) {\n    margin-bottom: 1.2rem;\n  }\n"])), function (_ref22) {
  var theme = _ref22.theme;
  return theme.fontWeight.normal;
});
var Date$3 = styled__default['default'].div(_templateObject20$1 || (_templateObject20$1 = _taggedTemplateLiteral$5(["\n  font-size: 1.4rem;\n  font-weight: ", ";\n  line-height: 1.6rem;\n  overflow-wrap: break-word;\n\n  &:not(:last-child) {\n    margin-bottom: 1.2rem;\n  }\n"])), function (_ref23) {
  var theme = _ref23.theme;
  return theme.fontWeight.normal;
});
var Wrapper$k = styled__default['default'](Div)(_templateObject21$1 || (_templateObject21$1 = _taggedTemplateLiteral$5(["\n  color: ", ";\n  display: inline-block;\n  flex-shrink: 0;\n  width: ", ";\n"])), function (_ref24) {
  var theme = _ref24.theme;
  return theme.colors.text;
}, function (_ref25) {
  var size = _ref25.size;
  return size ? "".concat(size) : '100%';
});
var StyledCheckbox$1 = styled__default['default'](CheckBox$1).attrs(function () {
  return {
    width: '1.6rem'
  };
})(_templateObject22 || (_templateObject22 = _taggedTemplateLiteral$5(["\n  left: 2rem;\n  position: absolute;\n  top: 2rem;\n  z-index: 2;\n\n  svg {\n    /**\n      Don't know why we need a border-radius of exactly 34% to make the border fit the checkbox SVG.\n      But its the perfect value, even if we have a smaller/bigger checkbox.\n    */\n    border-radius: 34%;\n    background-color: ", ";\n  }\n\n  svg path {\n    fill: ", ";\n  }\n"])), function (_ref26) {
  var theme = _ref26.theme;
  return theme.colors.white;
}, function (_ref27) {
  var theme = _ref27.theme;
  return theme.colors.black;
});var _excluded$i = ["route"],
    _excluded2$4 = ["route"],
    _excluded3$1 = ["alt", "className", "classNames", "date", "description", "images", "LinkComponent", "linkProps", "noBoxShadow", "noRadius", "noScale", "noTranslateY", "noTilt", "onPlay", "onPause", "onSelect", "isCurrent", "isPlaying", "isSelected", "placeholderType", "playButtonSize", "postDescription", "preDescription", "preText", "rounded", "size", "src", "title", "type", "vynil"];
// Helpers
// =============================
// eslint-disable-next-line react/prop-types

var BasicLink$1 = function BasicLink(_ref) {
  var route = _ref.route,
      props = _objectWithoutProperties$7(_ref, _excluded$i);

  return (
    /*#__PURE__*/
    // eslint-disable-next-line jsx-a11y/anchor-has-content
    React__default['default'].createElement("a", _extends$g({
      style: {
        cursor: 'pointer'
      },
      href: route
    }, props))
  );
}; // eslint-disable-next-line react/prop-types


var NoLink$1 = function NoLink(_ref2) {
  _ref2.route;
      var props = _objectWithoutProperties$7(_ref2, _excluded2$4);

  return /*#__PURE__*/React__default['default'].createElement("div", props);
}; // =============================
// Component
// =============================


var Cover$2 = /*#__PURE__*/function (_PureComponent) {
  _inherits$e(Cover, _PureComponent);

  var _super = _createSuper$1(Cover);

  function Cover() {
    var _this;

    _classCallCheck$k(this, Cover);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty$8(_assertThisInitialized$1(_this), "state", {
      imageHovered: false
    });

    _defineProperty$8(_assertThisInitialized$1(_this), "handleMouseEnter", function () {
      _this.setState({
        imageHovered: true
      });
    });

    _defineProperty$8(_assertThisInitialized$1(_this), "handleMouseLeave", function () {
      _this.setState({
        imageHovered: false
      });
    });

    _defineProperty$8(_assertThisInitialized$1(_this), "handlePlay", function (e) {
      var onPlay = _this.props.onPlay; // We don't want other onClick to be fired.

      e.stopPropagation(); // We don't want parents link to be clicked.

      e.preventDefault();
      onPlay();
    });

    _defineProperty$8(_assertThisInitialized$1(_this), "handlePause", function (e) {
      var onPause = _this.props.onPause; // We don't want other onClick to be fired.

      e.stopPropagation(); // We don't want parents link to be clicked.

      e.preventDefault();
      onPause();
    });

    _defineProperty$8(_assertThisInitialized$1(_this), "renderCheckbox", function () {
      var _this$props = _this.props,
          isSelected = _this$props.isSelected,
          onSelect = _this$props.onSelect;
      var imageHovered = _this.state.imageHovered;
      if (!onSelect) return null;
      if (!imageHovered && !isSelected) return null;
      return /*#__PURE__*/React__default['default'].createElement(StyledCheckbox$1, {
        checked: isSelected,
        imageHovered: imageHovered,
        onClick: onSelect
      });
    });

    return _this;
  }

  _createClass$g(Cover, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          alt = _this$props2.alt,
          className = _this$props2.className,
          classNames = _this$props2.classNames,
          date = _this$props2.date,
          description = _this$props2.description,
          images = _this$props2.images,
          LinkComponent = _this$props2.LinkComponent,
          linkProps = _this$props2.linkProps,
          noBoxShadow = _this$props2.noBoxShadow,
          noRadius = _this$props2.noRadius,
          noScale = _this$props2.noScale,
          noTranslateY = _this$props2.noTranslateY,
          noTilt = _this$props2.noTilt,
          onPlay = _this$props2.onPlay,
          onPause = _this$props2.onPause;
          _this$props2.onSelect;
          var isCurrent = _this$props2.isCurrent,
          isPlaying = _this$props2.isPlaying;
          _this$props2.isSelected;
          var placeholderType = _this$props2.placeholderType,
          playButtonSize = _this$props2.playButtonSize,
          postDescription = _this$props2.postDescription,
          preDescription = _this$props2.preDescription,
          preText = _this$props2.preText,
          rounded = _this$props2.rounded,
          size = _this$props2.size,
          src = _this$props2.src,
          title = _this$props2.title,
          type = _this$props2.type,
          vynil = _this$props2.vynil,
          rest = _objectWithoutProperties$7(_this$props2, _excluded3$1);

      var imageHovered = this.state.imageHovered;
      var notHoverable = !vynil && noTranslateY && noScale && noBoxShadow && !onPlay && !onPause;
      var Link = Object.keys(linkProps).length ? LinkComponent || BasicLink$1 : NoLink$1;
      return /*#__PURE__*/React__default['default'].createElement(Wrapper$k, _extends$g({
        className: className
      }, getViewProps(rest), {
        size: size
      }), /*#__PURE__*/React__default['default'].createElement(ImageContainer$1, {
        className: classNames.cover,
        imageHovered: imageHovered,
        noScale: noScale,
        noTranslateY: noTranslateY,
        vynil: vynil,
        onMouseEnter: notHoverable ? undefined : this.handleMouseEnter,
        onMouseLeave: notHoverable ? undefined : this.handleMouseLeave
      }, this.renderCheckbox(), /*#__PURE__*/React__default['default'].createElement(ImageWrapper$1, {
        LinkComponent: Link,
        linkProps: linkProps,
        rounded: rounded,
        noRadius: noRadius,
        type: type
      }, /*#__PURE__*/React__default['default'].createElement(StyledTilt, {
        noTilt: noTilt
      }, /*#__PURE__*/React__default['default'].createElement(Image$1, {
        alt: alt,
        images: images,
        imageHovered: imageHovered,
        noBoxShadow: noBoxShadow,
        noRadius: noRadius,
        placeholderType: placeholderType,
        type: type,
        src: src
      }), vynil && /*#__PURE__*/React__default['default'].createElement(VynilWrapper, {
        imageHovered: imageHovered
      }, /*#__PURE__*/React__default['default'].createElement(Vynil, {
        src: src,
        images: images
      })), (onPlay || onPause) && /*#__PURE__*/React__default['default'].createElement(PlayContainer$1, {
        imageHovered: imageHovered || isCurrent,
        noRadius: noRadius,
        type: type
      }, !isPlaying && /*#__PURE__*/React__default['default'].createElement(PlayButton$1, {
        playButtonSize: playButtonSize,
        onClick: this.handlePlay
      }), isPlaying && /*#__PURE__*/React__default['default'].createElement(PauseButton$1, {
        playButtonSize: playButtonSize,
        onClick: this.handlePause
      }))))), preText && /*#__PURE__*/React__default['default'].createElement(Type$2, {
        className: classNames.type
      }, preText), title && /*#__PURE__*/React__default['default'].createElement(Title$2, {
        className: classNames.title,
        LinkComponent: Link,
        linkProps: linkProps
      }, title), preDescription && /*#__PURE__*/React__default['default'].createElement(Description$1, {
        className: classNames.description
      }, preDescription), description && /*#__PURE__*/React__default['default'].createElement(Description$1, {
        className: classNames.description
      }, description), postDescription && /*#__PURE__*/React__default['default'].createElement(Description$1, {
        className: classNames.description
      }, postDescription), date && /*#__PURE__*/React__default['default'].createElement(Date$3, {
        className: classNames.date
      }, dayjs__default['default'](date).format('YYYY')));
    }
  }]);

  return Cover;
}(React.PureComponent);

_defineProperty$8(Cover$2, "propTypes", {
  /** Image alt. */
  alt: PropTypes__default['default'].string,

  /** Props used by styled component to override styles */
  className: PropTypes__default['default'].string,
  classNames: PropTypes__default['default'].shape({
    cover: PropTypes__default['default'].string,
    date: PropTypes__default['default'].string,
    description: PropTypes__default['default'].string,
    title: PropTypes__default['default'].string,
    type: PropTypes__default['default'].string
  }),

  /** An ISO 8601 string.  */
  date: PropTypes__default['default'].string,

  /** Cover Description. */
  description: PropTypes__default['default'].string,

  /** Passed Images */
  images: PropTypes__default['default'].shape({
    trackplaceholder: PropTypes__default['default'].string,
    postplaceholder: PropTypes__default['default'].string,
    artistplaceholder: PropTypes__default['default'].string,
    albumplaceholder: PropTypes__default['default'].string,
    catalogplaceholder: PropTypes__default['default'].string,
    labelplaceholder: PropTypes__default['default'].string,
    playlistplaceholder: PropTypes__default['default'].string,
    publisherplaceholder: PropTypes__default['default'].string,
    vynil: PropTypes__default['default'].string,
    filter: PropTypes__default['default'].string
  }).isRequired,

  /** If True, will show hovered state directly to see player controls */
  isCurrent: PropTypes__default['default'].bool,

  /** If True, will show pause button instead of play button */
  isPlaying: PropTypes__default['default'].bool,

  /** If True, Cover is selected. */
  isSelected: PropTypes__default['default'].bool,

  /** next-routes Link component. */
  LinkComponent: PropTypes__default['default'].any,
  // eslint-disable-line react/forbid-prop-types

  /** next-routes link props. */
  linkProps: PropTypes__default['default'].object,
  // eslint-disable-line react/forbid-prop-types

  /** If True, will render Cover without box-shadow */
  noBoxShadow: PropTypes__default['default'].bool,

  /** If True, will render Cover with border radius = 0. */
  noRadius: PropTypes__default['default'].bool,

  /** If True, will not scale Cover on hover. */
  noScale: PropTypes__default['default'].bool,

  /** If True, will render Cover without Tilt effect.  */
  noTilt: PropTypes__default['default'].bool,

  /** If True, Cover will no translate on Y axis on hover */
  noTranslateY: PropTypes__default['default'].bool,

  /** Function called when PlayButton is clicked */
  onPlay: PropTypes__default['default'].func,

  /** Function called when PauseButton is clicked */
  onPause: PropTypes__default['default'].func,

  /** Function called when checkbox is clicked. */
  onSelect: PropTypes__default['default'].func,

  /** Type of placeholder to used if 'src' is empty. */
  placeholderType: PropTypes__default['default'].oneOf(['artist', 'album', 'catalog', 'label', 'post', 'playlist', 'publisher', 'track']).isRequired,

  /** Play button size variant. */
  playButtonSize: PropTypes__default['default'].oneOf(['default', 'musicItem']),

  /** Post description. */
  postDescription: PropTypes__default['default'].node,

  /** Pre description. */
  preDescription: PropTypes__default['default'].node,

  /** Pre text. */
  preText: PropTypes__default['default'].string,

  /** If True, Cover will be a circle instead of a square */
  rounded: PropTypes__default['default'].bool,

  /** Cover size. */
  size: PropTypes__default['default'].string,

  /** Cover image source */
  src: PropTypes__default['default'].oneOfType([PropTypes__default['default'].string, PropTypes__default['default'].arrayOf(PropTypes__default['default'].string)]),

  /** Cover title. */
  title: PropTypes__default['default'].string,

  /** Cover type. */
  type: PropTypes__default['default'].oneOf(['artist', 'album', 'catalog', 'label', 'post', 'playlist', 'publisher', 'track']),

  /** If True, will show a vynil on hover */
  vynil: PropTypes__default['default'].bool
});

_defineProperty$8(Cover$2, "defaultProps", {
  alt: '',
  className: '',
  classNames: {
    cover: '',
    date: '',
    description: '',
    title: '',
    type: ''
  },
  date: '',
  description: '',
  isCurrent: false,
  isPlaying: false,
  isSelected: false,
  LinkComponent: null,
  linkProps: {},
  noBoxShadow: false,
  noRadius: false,
  noScale: false,
  noTilt: false,
  noTranslateY: false,
  onPlay: null,
  onPause: null,
  onSelect: null,
  playButtonSize: 'default',
  postDescription: null,
  preDescription: null,
  preText: '',
  rounded: false,
  size: '',
  src: '',
  title: '',
  type: '',
  vynil: false
});var _templateObject$r, _templateObject2$m, _templateObject3$j, _templateObject4$i, _templateObject5$h;
// Component
// =============================

var Wrapper$j = styled__default['default'].div.attrs(function (_ref) {
  var alt = _ref.alt;
  return {
    'aria-label': alt,
    role: 'img'
  };
})(_templateObject$r || (_templateObject$r = _taggedTemplateLiteral$5(["\n  background-color: ", ";\n  left: 0;\n  overflow: hidden;\n  padding-top: 100%;\n  position: absolute;\n  top: 0;\n  transition: box-shadow ", ";\n  width: 100%;\n  z-index: 1;\n\n  ", "\n\n  ", "\n\n  ", "\n"])), function (_ref2) {
  var theme = _ref2.theme;
  return alpha$2(theme.colors.white, 0.8);
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.transition.medium;
}, function (_ref4) {
  var src = _ref4.src;
  return src && styled.css(_templateObject2$m || (_templateObject2$m = _taggedTemplateLiteral$5(["\n    background-image: url('", "');\n    background-position: center;\n    background-size: cover;\n  "])), src);
}, function (_ref5) {
  var noRadius = _ref5.noRadius;

  if (!noRadius) {
    return styled.css(_templateObject3$j || (_templateObject3$j = _taggedTemplateLiteral$5(["\n        border-radius: 0.5rem;\n      "])));
  }

  return null;
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.coverConfig.enableFilter && styled.css(_templateObject4$i || (_templateObject4$i = _taggedTemplateLiteral$5(["\n      &::before {\n        background-image: url(", ");\n        bottom: 0;\n        content: '';\n        left: 0;\n        position: absolute;\n        right: 0;\n        top: 0;\n      }\n\n      /** NOTE: These colors do not change (for cover filter) */\n      &::after {\n        background: radial-gradient(ellipse at center, #fcfff4 0%, #383838 100%);\n        border-radius: inherit;\n        border: 1px solid #808080;\n        bottom: 0;\n        content: '';\n        height: 100%;\n        left: 0;\n        opacity: 0.1;\n        position: absolute;\n        width: 100%;\n      }\n    "])), function (_ref7) {
    var coverFilter = _ref7.coverFilter;
    return coverFilter;
  });
});
var Img = styled__default['default'](Div)(_templateObject5$h || (_templateObject5$h = _taggedTemplateLiteral$5(["\n  background-image: url('", "');\n  background-position: center;\n  background-size: cover;\n  height: 50%;\n  position: absolute;\n  width: 50%;\n\n  &:nth-of-type(1) {\n    left: 0;\n    top: 0;\n  }\n\n  &:nth-of-type(2) {\n    left: 50%;\n    top: 0;\n  }\n  &:nth-of-type(3) {\n    left: 0;\n    top: 50%;\n  }\n  &:nth-of-type(4) {\n    left: 50%;\n    top: 50%;\n  }\n"])), function (_ref8) {
  var src = _ref8.src;
  return src;
});// =============================
// Component
// =============================

var Image = /*#__PURE__*/React__default['default'].memo(function (_ref) {
  var alt = _ref.alt,
      images = _ref.images,
      noRadius = _ref.noRadius,
      placeholderType = _ref.placeholderType,
      src = _ref.src,
      type = _ref.type;
  var placeholder = '';

  switch (placeholderType) {
    case 'album':
      placeholder = images.albumplaceholder;
      break;

    case 'artist':
      placeholder = images.artistplaceholder;
      break;

    case 'catalog':
      placeholder = images.catalogplaceholder;
      break;

    case 'label':
      placeholder = images.labelplaceholder;
      break;

    case 'playlist':
      placeholder = images.playlistplaceholder;
      break;

    case 'post':
      placeholder = images.postplaceholder;
      break;

    case 'publisher':
      placeholder = images.publisherplaceholder;
      break;

    case 'track':
      placeholder = images.trackplaceholder;
      break;

    default:
      placeholder = images.trackplaceholder;
      break;
  }

  var content = null;

  if (isArray_1(src)) {
    // We only show splitted cover if we have 4 or more cover.
    if (src.length >= 4) {
      content = /*#__PURE__*/React__default['default'].createElement(Wrapper$j, {
        alt: alt,
        coverFilter: images.filter,
        noRadius: noRadius,
        type: type
      }, /*#__PURE__*/React__default['default'].createElement(Img, {
        src: src[0] || placeholder
      }), /*#__PURE__*/React__default['default'].createElement(Img, {
        src: src[1] || placeholder
      }), /*#__PURE__*/React__default['default'].createElement(Img, {
        src: src[2] || placeholder
      }), /*#__PURE__*/React__default['default'].createElement(Img, {
        src: src[3] || placeholder
      }));
    } else {
      content = /*#__PURE__*/React__default['default'].createElement(Wrapper$j, {
        alt: alt,
        coverFilter: images.filter,
        noRadius: noRadius,
        src: src[0] || placeholder,
        type: type
      });
    }
  } else {
    content = /*#__PURE__*/React__default['default'].createElement(Wrapper$j, {
      alt: alt,
      coverFilter: images.filter,
      noRadius: noRadius,
      src: src || placeholder,
      type: type
    });
  }

  return content;
});
Image.propTypes = {
  /** Image alt. */
  alt: PropTypes__default['default'].string,

  /** Passed Images */
  images: PropTypes__default['default'].shape({
    albumplaceholder: PropTypes__default['default'].string,
    artistplaceholder: PropTypes__default['default'].string,
    catalogplaceholder: PropTypes__default['default'].string,
    filter: PropTypes__default['default'].string,
    labelplaceholder: PropTypes__default['default'].string,
    playlistplaceholder: PropTypes__default['default'].string,
    postplaceholder: PropTypes__default['default'].string,
    publisherplaceholder: PropTypes__default['default'].string,
    trackplaceholder: PropTypes__default['default'].string,
    vynil: PropTypes__default['default'].string
  }).isRequired,

  /** If True, will render Cover with border radius = 0. */
  noRadius: PropTypes__default['default'].bool,

  /** Type of placeholder to used if 'src' is empty. */
  placeholderType: PropTypes__default['default'].oneOf(['album', 'artist', 'catalog', 'label', 'playlist', 'post', 'publisher', 'track']).isRequired,

  /** Cover image source */
  src: PropTypes__default['default'].oneOfType([PropTypes__default['default'].string, PropTypes__default['default'].arrayOf(PropTypes__default['default'].string)]),

  /** Cover type. */
  type: PropTypes__default['default'].oneOf(['album', 'artist', 'catalog', 'label', 'playlist', 'post', 'publisher', 'track'])
};
Image.defaultProps = {
  alt: '',
  noRadius: false,
  src: '',
  type: ''
};var _excluded$h = ["LinkComponent"],
    _excluded2$3 = ["LinkComponent"];

var _templateObject$q, _templateObject2$l, _templateObject3$i, _templateObject4$h, _templateObject5$g, _templateObject6$b, _templateObject7$a, _templateObject8$a, _templateObject9$6, _templateObject10$6, _templateObject11$6, _templateObject12$5, _templateObject13$5, _templateObject14$5, _templateObject15$4;
// Component
// =============================

var PlayContainer = styled__default['default'].div(_templateObject$q || (_templateObject$q = _taggedTemplateLiteral$5(["\n  align-items: center;\n  background: rgba(0, 0, 0, 0.6);\n  bottom: 0;\n  display: flex;\n  justify-content: center;\n  left: 0;\n  opacity: 0;\n  pointer-events: none;\n  position: absolute;\n  top: 0;\n  transition: opacity ", ",\n    transform ", ";\n  right: 0;\n  z-index: 1;\n\n  ", ";\n\n  ", ";\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.transition.medium;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.transition.medium;
}, function (_ref3) {
  var isCurrent = _ref3.isCurrent;
  return isCurrent && styled.css(_templateObject2$l || (_templateObject2$l = _taggedTemplateLiteral$5(["\n    opacity: 1;\n  "])));
}, function (_ref4) {
  var noRadius = _ref4.noRadius;

  if (!noRadius) {
    return styled.css(_templateObject3$i || (_templateObject3$i = _taggedTemplateLiteral$5(["\n        border-radius: 0.5rem;\n      "])));
  }

  return null;
});
/** NOTE: The fill is fixed because the button is always above a dark layer */

var PlayButton = styled__default['default'](PlayOutline$1).attrs(function (_ref5) {
  var playButtonSize = _ref5.playButtonSize;
  return {
    fill: '#ffffff',
    strokeWidth: 1,
    width: ['musicItem', 'small'].includes(playButtonSize) ? '60%' : '35%'
  };
})(_templateObject4$h || (_templateObject4$h = _taggedTemplateLiteral$5(["\n  max-height: 10rem;\n  max-width: 10rem;\n  transition: transform ", ";\n\n  &:hover {\n    transform: scale(1.1);\n  }\n"])), function (_ref6) {
  var theme = _ref6.theme;
  return theme.transition.medium;
});
/** NOTE: The fill is fixed because the button is always above a dark layer */

var PauseButton = styled__default['default'](PauseOutline$1).attrs(function (_ref7) {
  var playButtonSize = _ref7.playButtonSize;
  return {
    fill: '#ffffff',
    strokeWidth: 1,
    width: ['musicItem', 'small'].includes(playButtonSize) ? '60%' : '35%'
  };
})(_templateObject5$g || (_templateObject5$g = _taggedTemplateLiteral$5(["\n  max-height: 10rem;\n  max-width: 10rem;\n  transition: transform ", ";\n\n  &:hover {\n    transform: scale(1.1);\n  }\n"])), function (_ref8) {
  var theme = _ref8.theme;
  return theme.transition.medium;
});
var ImageWrapper = styled__default['default'](function (_ref9) {
  var LinkComponent = _ref9.LinkComponent,
      props = _objectWithoutProperties$7(_ref9, _excluded$h);

  return /*#__PURE__*/React__default['default'].createElement(LinkComponent, _extends$g({}, pick_1(props, ['className', 'children']), props.linkProps));
})(_templateObject6$b || (_templateObject6$b = _taggedTemplateLiteral$5(["\n  cursor: ", ";\n  display: inline-block;\n  position: relative;\n  user-select: none;\n  width: 100%;\n\n  ", ";\n\n  ", ";\n"])), function (_ref10) {
  var linkProps = _ref10.linkProps;
  return Object.keys(linkProps).length ? 'pointer' : 'default';
}, function (_ref11) {
  var rounded = _ref11.rounded;
  return rounded && styled.css(_templateObject7$a || (_templateObject7$a = _taggedTemplateLiteral$5(["\n      border-radius: 50%;\n      overflow: hidden;\n    "])));
}, function (_ref12) {
  var theme = _ref12.theme;
  return theme.mediaBelow.minWidth(_templateObject8$a || (_templateObject8$a = _taggedTemplateLiteral$5(["\n    padding-top: 100%;\n  "])));
});
var ImageContainer = styled__default['default'].div(_templateObject9$6 || (_templateObject9$6 = _taggedTemplateLiteral$5(["\n  position: relative;\n  transition: transform ", ";\n\n  &:not(:last-child) {\n    margin-bottom: 0.8rem;\n\n    ", ";\n  }\n"])), function (_ref13) {
  var theme = _ref13.theme;
  return theme.transition.medium;
}, function (_ref14) {
  var theme = _ref14.theme;
  return theme.mediaAbove.minWidth(_templateObject10$6 || (_templateObject10$6 = _taggedTemplateLiteral$5(["\n      margin-bottom: 2rem;\n    "])));
});
var Type$1 = styled__default['default'].div(_templateObject11$6 || (_templateObject11$6 = _taggedTemplateLiteral$5(["\n  font-size: 1.3rem;\n  font-weight: ", ";\n\n  &:not(:last-child) {\n    margin-bottom: 0.4rem;\n  }\n"])), function (_ref15) {
  var theme = _ref15.theme;
  return theme.fontWeight.semibold;
});
var Title$1 = styled__default['default'](function (_ref16) {
  var LinkComponent = _ref16.LinkComponent,
      props = _objectWithoutProperties$7(_ref16, _excluded2$3);

  return /*#__PURE__*/React__default['default'].createElement(LinkComponent, _extends$g({}, pick_1(props, ['className', 'children']), props.linkProps));
})(_templateObject12$5 || (_templateObject12$5 = _taggedTemplateLiteral$5(["\n  display: inline-block;\n  font-size: 1.5rem;\n  line-height: 1.8rem;\n  font-weight: ", ";\n  max-width: 100%;\n  overflow-wrap: break-word;\n  text-decoration: none;\n\n  &:not(:last-child) {\n    margin-bottom: 0.8rem;\n  }\n"])), function (_ref17) {
  var theme = _ref17.theme;
  return theme.fontWeight.extrabold;
});
var Description = styled__default['default'].div(_templateObject13$5 || (_templateObject13$5 = _taggedTemplateLiteral$5(["\n  font-size: 1.4rem;\n  font-weight: ", ";\n  max-height: 5.8rem;\n  line-height: 1.4;\n  opacity: 0.7;\n  overflow: hidden;\n  overflow-wrap: break-word;\n\n  &:not(:last-child) {\n    margin-bottom: 1.2rem;\n  }\n"])), function (_ref18) {
  var theme = _ref18.theme;
  return theme.fontWeight.normal;
});
var Date$2 = styled__default['default'].div(_templateObject14$5 || (_templateObject14$5 = _taggedTemplateLiteral$5(["\n  font-size: 1.4rem;\n  font-weight: ", ";\n  line-height: 1.6rem;\n  overflow-wrap: break-word;\n\n  &:not(:last-child) {\n    margin-bottom: 1.2rem;\n  }\n"])), function (_ref19) {
  var theme = _ref19.theme;
  return theme.fontWeight.normal;
});
var Wrapper$i = styled__default['default'](Div)(_templateObject15$4 || (_templateObject15$4 = _taggedTemplateLiteral$5(["\n  color: ", ";\n  display: inline-block;\n  flex-shrink: 0;\n  width: ", ";\n"])), function (_ref20) {
  var theme = _ref20.theme;
  return theme.colors.text;
}, function (_ref21) {
  var size = _ref21.size;
  return size ? "".concat(size) : '100%';
});var _excluded$g = ["route"],
    _excluded2$2 = ["route"],
    _excluded3 = ["alt", "className", "classNames", "date", "description", "images", "isCurrent", "isPlaying", "LinkComponent", "linkProps", "noControls", "noRadius", "onPause", "onPlay", "placeholderType", "playButtonSize", "postDescription", "preDescription", "preText", "rounded", "size", "src", "title", "type"];
// Helpers
// =============================
// eslint-disable-next-line react/prop-types

var BasicLink = function BasicLink(_ref) {
  var route = _ref.route,
      props = _objectWithoutProperties$7(_ref, _excluded$g);

  return (
    /*#__PURE__*/
    // eslint-disable-next-line jsx-a11y/anchor-has-content
    React__default['default'].createElement("a", _extends$g({
      style: {
        cursor: 'pointer'
      },
      href: route
    }, props))
  );
}; // eslint-disable-next-line react/prop-types


var NoLink = function NoLink(_ref2) {
  _ref2.route;
      var props = _objectWithoutProperties$7(_ref2, _excluded2$2);

  return /*#__PURE__*/React__default['default'].createElement("div", props);
}; // =============================
// Component
// =============================


var Cover$1 = /*#__PURE__*/function (_PureComponent) {
  _inherits$e(Cover, _PureComponent);

  var _super = _createSuper$1(Cover);

  function Cover() {
    var _this;

    _classCallCheck$k(this, Cover);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty$8(_assertThisInitialized$1(_this), "handleImageClick", function (e) {
      var _this$props = _this.props,
          isPlaying = _this$props.isPlaying,
          noControls = _this$props.noControls,
          onPause = _this$props.onPause,
          onPlay = _this$props.onPlay,
          type = _this$props.type;

      if (type === 'track' && (onPause || onPlay)) {
        if (noControls) return null; // We don't want other onClick to be fired.

        e.stopPropagation();
        e.preventDefault();
        if (isPlaying) return onPause();
        return onPlay();
      }

      return null;
    });

    return _this;
  }

  _createClass$g(Cover, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          alt = _this$props2.alt,
          className = _this$props2.className,
          classNames = _this$props2.classNames,
          date = _this$props2.date,
          description = _this$props2.description,
          images = _this$props2.images,
          isCurrent = _this$props2.isCurrent,
          isPlaying = _this$props2.isPlaying,
          LinkComponent = _this$props2.LinkComponent,
          linkProps = _this$props2.linkProps,
          noControls = _this$props2.noControls,
          noRadius = _this$props2.noRadius,
          onPause = _this$props2.onPause,
          onPlay = _this$props2.onPlay,
          placeholderType = _this$props2.placeholderType,
          playButtonSize = _this$props2.playButtonSize,
          postDescription = _this$props2.postDescription,
          preDescription = _this$props2.preDescription,
          preText = _this$props2.preText,
          rounded = _this$props2.rounded,
          size = _this$props2.size,
          src = _this$props2.src,
          title = _this$props2.title,
          type = _this$props2.type,
          rest = _objectWithoutProperties$7(_this$props2, _excluded3);

      var Link = Object.keys(linkProps).length ? LinkComponent || BasicLink : NoLink;
      return /*#__PURE__*/React__default['default'].createElement(Wrapper$i, _extends$g({
        className: className
      }, getViewProps(rest), {
        size: size
      }), /*#__PURE__*/React__default['default'].createElement(ImageContainer, {
        className: classNames.cover,
        onClick: this.handleImageClick
      }, /*#__PURE__*/React__default['default'].createElement(ImageWrapper, {
        LinkComponent: Link,
        linkProps: linkProps,
        noRadius: noRadius,
        rounded: rounded,
        type: type
      }, /*#__PURE__*/React__default['default'].createElement(Image, {
        alt: alt,
        images: images,
        noRadius: noRadius,
        placeholderType: placeholderType,
        src: src,
        type: type
      }), type === 'track' && (onPlay || onPause) && !noControls && /*#__PURE__*/React__default['default'].createElement(PlayContainer, {
        isCurrent: isCurrent,
        noRadius: noRadius,
        type: type
      }, !isPlaying && /*#__PURE__*/React__default['default'].createElement(PlayButton, {
        playButtonSize: playButtonSize
      }), isPlaying && /*#__PURE__*/React__default['default'].createElement(PauseButton, {
        playButtonSize: playButtonSize
      })))), preText && /*#__PURE__*/React__default['default'].createElement(Type$1, {
        className: classNames.type
      }, preText), title && /*#__PURE__*/React__default['default'].createElement(Title$1, {
        className: classNames.title,
        LinkComponent: Link,
        linkProps: linkProps
      }, title), preDescription && /*#__PURE__*/React__default['default'].createElement(Description, {
        className: classNames.description
      }, preDescription), description && /*#__PURE__*/React__default['default'].createElement(Description, {
        className: classNames.description
      }, description), postDescription && /*#__PURE__*/React__default['default'].createElement(Description, {
        className: classNames.description
      }, postDescription), date && /*#__PURE__*/React__default['default'].createElement(Date$2, {
        className: classNames.date
      }, dayjs__default['default'](date).format('YYYY')));
    }
  }]);

  return Cover;
}(React.PureComponent);

_defineProperty$8(Cover$1, "propTypes", {
  /** Image alt. */
  alt: PropTypes__default['default'].string,

  /** Props used by styled component to override styles */
  className: PropTypes__default['default'].string,
  classNames: PropTypes__default['default'].shape({
    cover: PropTypes__default['default'].string,
    date: PropTypes__default['default'].string,
    description: PropTypes__default['default'].string,
    title: PropTypes__default['default'].string,
    type: PropTypes__default['default'].string
  }),

  /** An ISO 8601 string.  */
  date: PropTypes__default['default'].string,

  /** Cover Description. */
  description: PropTypes__default['default'].string,

  /** Passed Images */
  images: PropTypes__default['default'].shape({
    trackplaceholder: PropTypes__default['default'].string,
    postplaceholder: PropTypes__default['default'].string,
    artistplaceholder: PropTypes__default['default'].string,
    albumplaceholder: PropTypes__default['default'].string,
    catalogplaceholder: PropTypes__default['default'].string,
    labelplaceholder: PropTypes__default['default'].string,
    playlistplaceholder: PropTypes__default['default'].string,
    publisherplaceholder: PropTypes__default['default'].string,
    vynil: PropTypes__default['default'].string,
    filter: PropTypes__default['default'].string
  }).isRequired,

  /** If True, will show hovered state directly to see player controls */
  isCurrent: PropTypes__default['default'].bool,

  /** If True, will show pause button instead of play button */
  isPlaying: PropTypes__default['default'].bool,

  /** next-routes Link component. */
  LinkComponent: PropTypes__default['default'].any,
  // eslint-disable-line react/forbid-prop-types

  /** next-routes link props. */
  linkProps: PropTypes__default['default'].object,
  // eslint-disable-line react/forbid-prop-types

  /**
   * If True, even with a type track, we won't show play/pause btn.
   * So user can click on the link
   * */
  noControls: PropTypes__default['default'].bool,

  /** If True, will render Cover with border radius = 0. */
  noRadius: PropTypes__default['default'].bool,

  /** Function called when PauseButton is clicked */
  onPause: PropTypes__default['default'].func,

  /** Function called when PlayButton is clicked */
  onPlay: PropTypes__default['default'].func,

  /** Type of placeholder to used if 'src' is empty. */
  placeholderType: PropTypes__default['default'].oneOf(['album', 'artist', 'catalog', 'label', 'playlist', 'post', 'publisher', 'track']).isRequired,

  /** Play button size variant. */
  playButtonSize: PropTypes__default['default'].oneOf(['default', 'musicItem']),

  /** Post description. */
  postDescription: PropTypes__default['default'].node,

  /** Pre description. */
  preDescription: PropTypes__default['default'].node,

  /** Pre text. */
  preText: PropTypes__default['default'].string,

  /** If True, Cover will be a circle instead of a square */
  rounded: PropTypes__default['default'].bool,

  /** Cover size. */
  size: PropTypes__default['default'].string,

  /** Cover image source */
  src: PropTypes__default['default'].oneOfType([PropTypes__default['default'].string, PropTypes__default['default'].arrayOf(PropTypes__default['default'].string)]),

  /** Cover title. */
  title: PropTypes__default['default'].string,

  /** Cover type. */
  type: PropTypes__default['default'].oneOf(['artist', 'album', 'catalog', 'label', 'post', 'playlist', 'publisher', 'track'])
});

_defineProperty$8(Cover$1, "defaultProps", {
  alt: '',
  className: '',
  classNames: {
    cover: '',
    date: '',
    description: '',
    title: '',
    type: ''
  },
  date: '',
  description: '',
  LinkComponent: null,
  linkProps: {},
  noControls: false,
  noRadius: false,
  onPlay: null,
  onPause: null,
  isCurrent: false,
  isPlaying: false,
  playButtonSize: 'default',
  postDescription: null,
  preDescription: null,
  preText: '',
  rounded: false,
  size: '',
  src: '',
  title: '',
  type: ''
});// Component
// =============================

var Cover = /*#__PURE__*/function (_PureComponent) {
  _inherits$e(Cover, _PureComponent);

  var _super = _createSuper$1(Cover);

  function Cover() {
    _classCallCheck$k(this, Cover);

    return _super.apply(this, arguments);
  }

  _createClass$g(Cover, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React__default['default'].createElement(Responsive, {
        DesktopComponent: Cover$2,
        MobileComponent: Cover$1,
        props: this.props
      });
    }
  }]);

  return Cover;
}(React.PureComponent);// =============================
// Component
// =============================

var Date$1 = /*#__PURE__*/React__default['default'].memo(function (_ref) {
  var className = _ref.className,
      date = _ref.date,
      variant = _ref.variant;
  return /*#__PURE__*/React__default['default'].createElement("span", {
    className: className
  }, variant === 'relative' && dayjs__default['default']().to(dayjs__default['default'](date)), variant === 'absolute' && dayjs__default['default'](date).format('D MMMM, YYYY'));
});
Date$1.propTypes = {
  /** Props used by styled component to override styles */
  className: PropTypes__default['default'].string,

  /** An ISO 8601 string.  */
  date: PropTypes__default['default'].string.isRequired,

  /** Variant */
  variant: PropTypes__default['default'].oneOf(['absolute', 'relative'])
};
Date$1.defaultProps = {
  className: '',
  variant: 'absolute'
};var _templateObject$p, _templateObject2$k;
// Styles
// =============================

var StyledDropdown = styled__default['default'](Dropdown$2)(_templateObject$p || (_templateObject$p = _taggedTemplateLiteral$5(["\n  overflow: hidden;\n  width: auto;\n"])));
var StyledHelpers$1 = styled__default['default'](Helpers)(_templateObject2$k || (_templateObject2$k = _taggedTemplateLiteral$5(["\n  margin-left: auto;\n"])));var _excluded$f = ["className", "containerClassName", "dateFormat", "disabled", "disableFuture", "disablePast", "dropdownClassName", "error", "helperText", "initialFocusedDate", "label", "lang", "optional", "tooltipError", "tooltipInteractive", "tooltipMessage", "tooltipPlacement", "suffix", "showResetBtn", "value", "variant", "withCalendar"];
// Component
// =============================

var DatePicker = /*#__PURE__*/function (_PureComponent) {
  _inherits$e(DatePicker, _PureComponent);

  var _super = _createSuper$1(DatePicker);

  function DatePicker(props) {
    var _this;

    _classCallCheck$k(this, DatePicker);

    _this = _super.call(this, props);

    _defineProperty$8(_assertThisInitialized$1(_this), "handleChange", function (val) {
      var _this$props = _this.props,
          onChange = _this$props.onChange,
          disabled = _this$props.disabled;
      if (disabled) return null; // Do nothing if input is empty.

      if (!val) return null; // Return null if date is not valid, for example when user is still writing.

      if (!val.isValid()) return null; // If value is out of range set internal error and prevent call to onChange.

      var date = dayjs__default['default'](val);

      if (date.isBefore(_this.minDate) || date.isAfter(_this.maxDate)) {
        return _this.setState({
          internalError: true
        });
      } // Reset previous error.


      _this.setState({
        internalError: false
      });

      var dateISO = date.toISOString();
      if (onChange) onChange(dateISO);
      return true;
    });

    _defineProperty$8(_assertThisInitialized$1(_this), "handleOnClickAway", function () {
      if (_this.inputRef) _this.inputRef.focus();
      return _this.closeDropdown();
    });

    _defineProperty$8(_assertThisInitialized$1(_this), "handleResetBtn", function () {
      var _this$props2 = _this.props,
          disabled = _this$props2.disabled,
          onChange = _this$props2.onChange;
      if (disabled) return null;
      if (onChange) onChange(null);

      if (_this.inputRef) {
        _this.inputRef.focus();
      }

      return true;
    });

    _defineProperty$8(_assertThisInitialized$1(_this), "closeDropdown", function () {
      return _this.setState({
        opened: false
      });
    });

    _defineProperty$8(_assertThisInitialized$1(_this), "openDropdown", function () {
      return _this.setState({
        opened: true
      });
    });

    _this.state = {
      internalError: false,
      opened: false
    };
    _this.maxDate = dayjs__default['default']('2100-01-01');
    _this.minDate = dayjs__default['default']('1000-01-01');
    return _this;
  }

  _createClass$g(DatePicker, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props3 = this.props,
          className = _this$props3.className,
          containerClassName = _this$props3.containerClassName,
          dateFormat = _this$props3.dateFormat,
          disabled = _this$props3.disabled,
          disableFuture = _this$props3.disableFuture,
          disablePast = _this$props3.disablePast,
          dropdownClassName = _this$props3.dropdownClassName,
          error = _this$props3.error,
          helperText = _this$props3.helperText,
          initialFocusedDate = _this$props3.initialFocusedDate,
          label = _this$props3.label,
          lang = _this$props3.lang,
          optional = _this$props3.optional,
          tooltipError = _this$props3.tooltipError,
          tooltipInteractive = _this$props3.tooltipInteractive,
          tooltipMessage = _this$props3.tooltipMessage,
          tooltipPlacement = _this$props3.tooltipPlacement,
          suffix = _this$props3.suffix,
          showResetBtn = _this$props3.showResetBtn,
          value = _this$props3.value,
          variant = _this$props3.variant,
          withCalendar = _this$props3.withCalendar,
          rest = _objectWithoutProperties$7(_this$props3, _excluded$f);

      var _this$state = this.state,
          internalError = _this$state.internalError,
          opened = _this$state.opened;
      return /*#__PURE__*/React__default['default'].createElement(ClickAwayListener, {
        onClickAway: this.closeDropdown
      }, /*#__PURE__*/React__default['default'].createElement(Wrapper$p, _extends$g({
        className: className
      }, getViewProps(rest)), /*#__PURE__*/React__default['default'].createElement(Label$2, {
        active: opened,
        inputFilled: !!value,
        error: error,
        label: label,
        lang: lang.Label,
        optional: optional,
        variant: variant
      }), /*#__PURE__*/React__default['default'].createElement(Container$1, {
        className: containerClassName,
        onClick: this.openDropdown,
        variant: variant
      }, /*#__PURE__*/React__default['default'].createElement(KeyboardDatePicker, {
        disabled: disabled,
        format: dateFormat,
        disableFuture: disableFuture,
        disablePast: disablePast,
        error: error || internalError,
        initialFocusedDate: initialFocusedDate,
        innerRef: function innerRef(node) {
          _this2.inputRef = node;
        },
        maxDate: this.maxDate,
        minDate: this.minDate,
        onChange: this.handleChange,
        placeholder: dateFormat,
        TextFieldComponent: InputBase$2,
        value: value
      }), /*#__PURE__*/React__default['default'].createElement(StyledHelpers$1, {
        additionalHelpers: suffix,
        onResetBtn: showResetBtn ? this.handleResetBtn : null,
        tooltipError: tooltipError,
        tooltipInteractive: tooltipInteractive,
        tooltipMessage: tooltipMessage,
        tooltipPlacement: tooltipPlacement
      })), helperText && /*#__PURE__*/React__default['default'].createElement(HelperText, {
        error: error
      }, helperText), withCalendar && /*#__PURE__*/React__default['default'].createElement(StyledDropdown, {
        className: dropdownClassName,
        onClickOutside: this.handleOnClickAway,
        open: opened,
        variant: variant
      }, /*#__PURE__*/React__default['default'].createElement(Calendar$1, {
        allowKeyboardControl: false,
        date: value && dayjs__default['default'](value) || dayjs__default['default'](),
        disableFuture: disableFuture,
        disablePast: disablePast,
        maxDate: this.maxDate,
        minDate: this.minDate,
        onChange: this.handleChange
      }))));
    }
  }]);

  return DatePicker;
}(React.PureComponent);

DatePicker.propTypes = {
  /** Props used by styled component to override styles */
  className: PropTypes__default['default'].string,

  /** Container classname. */
  containerClassName: PropTypes__default['default'].string,

  /** Date format */
  dateFormat: PropTypes__default['default'].oneOf(['DD/MM/YYYY', 'MM/DD/YYYY']),

  /** If true, the input will be disabled. */
  disabled: PropTypes__default['default'].bool,

  /** Disable future dates. */
  disableFuture: PropTypes__default['default'].bool,

  /** Disable past dates. */
  disablePast: PropTypes__default['default'].bool,

  /** Props used by styled component to override Dropdown container styles. */
  dropdownClassName: PropTypes__default['default'].string,

  /** If true, the input will indicate an error. */
  error: PropTypes__default['default'].bool,

  /** The helper text content. */
  helperText: PropTypes__default['default'].node,

  /** Date that will be initially highlighted if null was passed. */
  initialFocusedDate: PropTypes__default['default'].string,

  /** Label */
  label: PropTypes__default['default'].string,

  /** Translation strings. */
  lang: PropTypes__default['default'].object.isRequired,
  // eslint-disable-line react/forbid-prop-types

  /** onChange handler */
  onChange: PropTypes__default['default'].func,

  /** If true, the input is optional. */
  optional: PropTypes__default['default'].bool,

  /** Used to display error messsage as tooltip. */
  tooltipError: PropTypes__default['default'].string,

  /** If True, Tooltip will be interactive. */
  tooltipInteractive: PropTypes__default['default'].bool,

  /** If set, will add an InfoTooltip btn on input with tooltipMessage as content. */
  tooltipMessage: PropTypes__default['default'].node,

  /** Tooltip placement */
  tooltipPlacement: PropTypes__default['default'].oneOf(['bottom-end', 'bottom-start', 'bottom', 'left-end', 'left-start', 'left', 'right-end', 'right-start', 'right', 'top-end', 'top-start', 'top']),

  /** Node that will be rendered as Suffix. */
  suffix: PropTypes__default['default'].node,

  /** Render reset button. */
  showResetBtn: PropTypes__default['default'].bool,

  /** Value */
  value: PropTypes__default['default'].string,

  /** Input style variant. */
  variant: PropTypes__default['default'].oneOf(['background', 'underline']),

  /** If True, will render date picker with calendar. */
  withCalendar: PropTypes__default['default'].bool
};
DatePicker.defaultProps = {
  className: '',
  containerClassName: '',
  dateFormat: 'DD/MM/YYYY',
  disabled: false,
  disableFuture: false,
  disablePast: false,
  dropdownClassName: '',
  error: false,
  helperText: '',
  initialFocusedDate: null,
  label: '',
  onChange: null,
  optional: false,
  tooltipError: '',
  tooltipInteractive: false,
  tooltipMessage: '',
  tooltipPlacement: 'bottom',
  suffix: null,
  showResetBtn: true,
  value: null,
  variant: 'background',
  withCalendar: true
};/**
 * Simple ponyfill for Object.fromEntries
 */

var fromEntries = function fromEntries(entries) {
  return entries.reduce(function (acc, _ref) {
    var key = _ref[0],
        value = _ref[1];
    acc[key] = value;
    return acc;
  }, {});
};
/**
 * Small wrapper around `useLayoutEffect` to get rid of the warning on SSR envs
 */

var useIsomorphicLayoutEffect$1 = typeof window !== 'undefined' && window.document && window.document.createElement ? React__namespace.useLayoutEffect : React__namespace.useEffect;var top = 'top';
var bottom = 'bottom';
var right = 'right';
var left = 'left';
var auto = 'auto';
var basePlacements = [top, bottom, right, left];
var start = 'start';
var end = 'end';
var clippingParents = 'clippingParents';
var viewport = 'viewport';
var popper = 'popper';
var reference = 'reference';
var variationPlacements = /*#__PURE__*/basePlacements.reduce(function (acc, placement) {
  return acc.concat([placement + "-" + start, placement + "-" + end]);
}, []);
var placements$1 = /*#__PURE__*/[].concat(basePlacements, [auto]).reduce(function (acc, placement) {
  return acc.concat([placement, placement + "-" + start, placement + "-" + end]);
}, []); // modifiers that need to read the DOM

var beforeRead = 'beforeRead';
var read = 'read';
var afterRead = 'afterRead'; // pure-logic modifiers

var beforeMain = 'beforeMain';
var main = 'main';
var afterMain = 'afterMain'; // modifier with the purpose to write to the DOM (or write into a framework state)

var beforeWrite = 'beforeWrite';
var write = 'write';
var afterWrite = 'afterWrite';
var modifierPhases = [beforeRead, read, afterRead, beforeMain, main, afterMain, beforeWrite, write, afterWrite];function getNodeName(element) {
  return element ? (element.nodeName || '').toLowerCase() : null;
}function getWindow(node) {
  if (node == null) {
    return window;
  }

  if (node.toString() !== '[object Window]') {
    var ownerDocument = node.ownerDocument;
    return ownerDocument ? ownerDocument.defaultView || window : window;
  }

  return node;
}function isElement(node) {
  var OwnElement = getWindow(node).Element;
  return node instanceof OwnElement || node instanceof Element;
}

function isHTMLElement(node) {
  var OwnElement = getWindow(node).HTMLElement;
  return node instanceof OwnElement || node instanceof HTMLElement;
}

function isShadowRoot(node) {
  // IE 11 has no ShadowRoot
  if (typeof ShadowRoot === 'undefined') {
    return false;
  }

  var OwnElement = getWindow(node).ShadowRoot;
  return node instanceof OwnElement || node instanceof ShadowRoot;
}// and applies them to the HTMLElements such as popper and arrow

function applyStyles(_ref) {
  var state = _ref.state;
  Object.keys(state.elements).forEach(function (name) {
    var style = state.styles[name] || {};
    var attributes = state.attributes[name] || {};
    var element = state.elements[name]; // arrow is optional + virtual elements

    if (!isHTMLElement(element) || !getNodeName(element)) {
      return;
    } // Flow doesn't support to extend this property, but it's the most
    // effective way to apply styles to an HTMLElement
    // $FlowFixMe[cannot-write]


    Object.assign(element.style, style);
    Object.keys(attributes).forEach(function (name) {
      var value = attributes[name];

      if (value === false) {
        element.removeAttribute(name);
      } else {
        element.setAttribute(name, value === true ? '' : value);
      }
    });
  });
}

function effect$2(_ref2) {
  var state = _ref2.state;
  var initialStyles = {
    popper: {
      position: state.options.strategy,
      left: '0',
      top: '0',
      margin: '0'
    },
    arrow: {
      position: 'absolute'
    },
    reference: {}
  };
  Object.assign(state.elements.popper.style, initialStyles.popper);
  state.styles = initialStyles;

  if (state.elements.arrow) {
    Object.assign(state.elements.arrow.style, initialStyles.arrow);
  }

  return function () {
    Object.keys(state.elements).forEach(function (name) {
      var element = state.elements[name];
      var attributes = state.attributes[name] || {};
      var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them

      var style = styleProperties.reduce(function (style, property) {
        style[property] = '';
        return style;
      }, {}); // arrow is optional + virtual elements

      if (!isHTMLElement(element) || !getNodeName(element)) {
        return;
      }

      Object.assign(element.style, style);
      Object.keys(attributes).forEach(function (attribute) {
        element.removeAttribute(attribute);
      });
    });
  };
} // eslint-disable-next-line import/no-unused-modules


var applyStyles$1 = {
  name: 'applyStyles',
  enabled: true,
  phase: 'write',
  fn: applyStyles,
  effect: effect$2,
  requires: ['computeStyles']
};function getBasePlacement(placement) {
  return placement.split('-')[0];
}function getBoundingClientRect(element) {
  var rect = element.getBoundingClientRect();
  return {
    width: rect.width,
    height: rect.height,
    top: rect.top,
    right: rect.right,
    bottom: rect.bottom,
    left: rect.left,
    x: rect.left,
    y: rect.top
  };
}// means it doesn't take into account transforms.

function getLayoutRect(element) {
  var clientRect = getBoundingClientRect(element); // Use the clientRect sizes if it's not been transformed.
  // Fixes https://github.com/popperjs/popper-core/issues/1223

  var width = element.offsetWidth;
  var height = element.offsetHeight;

  if (Math.abs(clientRect.width - width) <= 1) {
    width = clientRect.width;
  }

  if (Math.abs(clientRect.height - height) <= 1) {
    height = clientRect.height;
  }

  return {
    x: element.offsetLeft,
    y: element.offsetTop,
    width: width,
    height: height
  };
}function contains$1(parent, child) {
  var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method

  if (parent.contains(child)) {
    return true;
  } // then fallback to custom implementation with Shadow DOM support
  else if (rootNode && isShadowRoot(rootNode)) {
      var next = child;

      do {
        if (next && parent.isSameNode(next)) {
          return true;
        } // $FlowFixMe[prop-missing]: need a better way to handle this...


        next = next.parentNode || next.host;
      } while (next);
    } // Give up, the result is false


  return false;
}function getComputedStyle$1(element) {
  return getWindow(element).getComputedStyle(element);
}function isTableElement(element) {
  return ['table', 'td', 'th'].indexOf(getNodeName(element)) >= 0;
}function getDocumentElement(element) {
  // $FlowFixMe[incompatible-return]: assume body is always available
  return ((isElement(element) ? element.ownerDocument : // $FlowFixMe[prop-missing]
  element.document) || window.document).documentElement;
}function getParentNode(element) {
  if (getNodeName(element) === 'html') {
    return element;
  }

  return (// this is a quicker (but less type safe) way to save quite some bytes from the bundle
    // $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ( // DOM Element detected
    isShadowRoot(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    getDocumentElement(element) // fallback

  );
}function getTrueOffsetParent(element) {
  if (!isHTMLElement(element) || // https://github.com/popperjs/popper-core/issues/837
  getComputedStyle$1(element).position === 'fixed') {
    return null;
  }

  return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block


function getContainingBlock(element) {
  var isFirefox = navigator.userAgent.toLowerCase().indexOf('firefox') !== -1;
  var isIE = navigator.userAgent.indexOf('Trident') !== -1;

  if (isIE && isHTMLElement(element)) {
    // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
    var elementCss = getComputedStyle$1(element);

    if (elementCss.position === 'fixed') {
      return null;
    }
  }

  var currentNode = getParentNode(element);

  while (isHTMLElement(currentNode) && ['html', 'body'].indexOf(getNodeName(currentNode)) < 0) {
    var css = getComputedStyle$1(currentNode); // This is non-exhaustive but covers the most common CSS properties that
    // create a containing block.
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block

    if (css.transform !== 'none' || css.perspective !== 'none' || css.contain === 'paint' || ['transform', 'perspective'].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === 'filter' || isFirefox && css.filter && css.filter !== 'none') {
      return currentNode;
    } else {
      currentNode = currentNode.parentNode;
    }
  }

  return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
// such as table ancestors and cross browser bugs.


function getOffsetParent$1(element) {
  var window = getWindow(element);
  var offsetParent = getTrueOffsetParent(element);

  while (offsetParent && isTableElement(offsetParent) && getComputedStyle$1(offsetParent).position === 'static') {
    offsetParent = getTrueOffsetParent(offsetParent);
  }

  if (offsetParent && (getNodeName(offsetParent) === 'html' || getNodeName(offsetParent) === 'body' && getComputedStyle$1(offsetParent).position === 'static')) {
    return window;
  }

  return offsetParent || getContainingBlock(element) || window;
}function getMainAxisFromPlacement(placement) {
  return ['top', 'bottom'].indexOf(placement) >= 0 ? 'x' : 'y';
}var max = Math.max;
var min = Math.min;
var round = Math.round;function within(min$1, value, max$1) {
  return max(min$1, min(value, max$1));
}function getFreshSideObject() {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
}function mergePaddingObject(paddingObject) {
  return Object.assign({}, getFreshSideObject(), paddingObject);
}function expandToHashMap(value, keys) {
  return keys.reduce(function (hashMap, key) {
    hashMap[key] = value;
    return hashMap;
  }, {});
}var toPaddingObject = function toPaddingObject(padding, state) {
  padding = typeof padding === 'function' ? padding(Object.assign({}, state.rects, {
    placement: state.placement
  })) : padding;
  return mergePaddingObject(typeof padding !== 'number' ? padding : expandToHashMap(padding, basePlacements));
};

function arrow(_ref) {
  var _state$modifiersData$;

  var state = _ref.state,
      name = _ref.name,
      options = _ref.options;
  var arrowElement = state.elements.arrow;
  var popperOffsets = state.modifiersData.popperOffsets;
  var basePlacement = getBasePlacement(state.placement);
  var axis = getMainAxisFromPlacement(basePlacement);
  var isVertical = [left, right].indexOf(basePlacement) >= 0;
  var len = isVertical ? 'height' : 'width';

  if (!arrowElement || !popperOffsets) {
    return;
  }

  var paddingObject = toPaddingObject(options.padding, state);
  var arrowRect = getLayoutRect(arrowElement);
  var minProp = axis === 'y' ? top : left;
  var maxProp = axis === 'y' ? bottom : right;
  var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
  var startDiff = popperOffsets[axis] - state.rects.reference[axis];
  var arrowOffsetParent = getOffsetParent$1(arrowElement);
  var clientSize = arrowOffsetParent ? axis === 'y' ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
  var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
  // outside of the popper bounds

  var min = paddingObject[minProp];
  var max = clientSize - arrowRect[len] - paddingObject[maxProp];
  var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
  var offset = within(min, center, max); // Prevents breaking syntax highlighting...

  var axisProp = axis;
  state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}

function effect$1(_ref2) {
  var state = _ref2.state,
      options = _ref2.options;
  var _options$element = options.element,
      arrowElement = _options$element === void 0 ? '[data-popper-arrow]' : _options$element;

  if (arrowElement == null) {
    return;
  } // CSS selector


  if (typeof arrowElement === 'string') {
    arrowElement = state.elements.popper.querySelector(arrowElement);

    if (!arrowElement) {
      return;
    }
  }

  if (!contains$1(state.elements.popper, arrowElement)) {

    return;
  }

  state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules


var arrow$1 = {
  name: 'arrow',
  enabled: true,
  phase: 'main',
  fn: arrow,
  effect: effect$1,
  requires: ['popperOffsets'],
  requiresIfExists: ['preventOverflow']
};var unsetSides = {
  top: 'auto',
  right: 'auto',
  bottom: 'auto',
  left: 'auto'
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.

function roundOffsetsByDPR(_ref) {
  var x = _ref.x,
      y = _ref.y;
  var win = window;
  var dpr = win.devicePixelRatio || 1;
  return {
    x: round(round(x * dpr) / dpr) || 0,
    y: round(round(y * dpr) / dpr) || 0
  };
}

function mapToStyles(_ref2) {
  var _Object$assign2;

  var popper = _ref2.popper,
      popperRect = _ref2.popperRect,
      placement = _ref2.placement,
      offsets = _ref2.offsets,
      position = _ref2.position,
      gpuAcceleration = _ref2.gpuAcceleration,
      adaptive = _ref2.adaptive,
      roundOffsets = _ref2.roundOffsets;

  var _ref3 = roundOffsets === true ? roundOffsetsByDPR(offsets) : typeof roundOffsets === 'function' ? roundOffsets(offsets) : offsets,
      _ref3$x = _ref3.x,
      x = _ref3$x === void 0 ? 0 : _ref3$x,
      _ref3$y = _ref3.y,
      y = _ref3$y === void 0 ? 0 : _ref3$y;

  var hasX = offsets.hasOwnProperty('x');
  var hasY = offsets.hasOwnProperty('y');
  var sideX = left;
  var sideY = top;
  var win = window;

  if (adaptive) {
    var offsetParent = getOffsetParent$1(popper);
    var heightProp = 'clientHeight';
    var widthProp = 'clientWidth';

    if (offsetParent === getWindow(popper)) {
      offsetParent = getDocumentElement(popper);

      if (getComputedStyle$1(offsetParent).position !== 'static') {
        heightProp = 'scrollHeight';
        widthProp = 'scrollWidth';
      }
    } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it


    offsetParent = offsetParent;

    if (placement === top) {
      sideY = bottom; // $FlowFixMe[prop-missing]

      y -= offsetParent[heightProp] - popperRect.height;
      y *= gpuAcceleration ? 1 : -1;
    }

    if (placement === left) {
      sideX = right; // $FlowFixMe[prop-missing]

      x -= offsetParent[widthProp] - popperRect.width;
      x *= gpuAcceleration ? 1 : -1;
    }
  }

  var commonStyles = Object.assign({
    position: position
  }, adaptive && unsetSides);

  if (gpuAcceleration) {
    var _Object$assign;

    return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? '0' : '', _Object$assign[sideX] = hasX ? '0' : '', _Object$assign.transform = (win.devicePixelRatio || 1) < 2 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
  }

  return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : '', _Object$assign2[sideX] = hasX ? x + "px" : '', _Object$assign2.transform = '', _Object$assign2));
}

function computeStyles(_ref4) {
  var state = _ref4.state,
      options = _ref4.options;
  var _options$gpuAccelerat = options.gpuAcceleration,
      gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat,
      _options$adaptive = options.adaptive,
      adaptive = _options$adaptive === void 0 ? true : _options$adaptive,
      _options$roundOffsets = options.roundOffsets,
      roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;

  var commonStyles = {
    placement: getBasePlacement(state.placement),
    popper: state.elements.popper,
    popperRect: state.rects.popper,
    gpuAcceleration: gpuAcceleration
  };

  if (state.modifiersData.popperOffsets != null) {
    state.styles.popper = Object.assign({}, state.styles.popper, mapToStyles(Object.assign({}, commonStyles, {
      offsets: state.modifiersData.popperOffsets,
      position: state.options.strategy,
      adaptive: adaptive,
      roundOffsets: roundOffsets
    })));
  }

  if (state.modifiersData.arrow != null) {
    state.styles.arrow = Object.assign({}, state.styles.arrow, mapToStyles(Object.assign({}, commonStyles, {
      offsets: state.modifiersData.arrow,
      position: 'absolute',
      adaptive: false,
      roundOffsets: roundOffsets
    })));
  }

  state.attributes.popper = Object.assign({}, state.attributes.popper, {
    'data-popper-placement': state.placement
  });
} // eslint-disable-next-line import/no-unused-modules


var computeStyles$1 = {
  name: 'computeStyles',
  enabled: true,
  phase: 'beforeWrite',
  fn: computeStyles,
  data: {}
};var passive = {
  passive: true
};

function effect(_ref) {
  var state = _ref.state,
      instance = _ref.instance,
      options = _ref.options;
  var _options$scroll = options.scroll,
      scroll = _options$scroll === void 0 ? true : _options$scroll,
      _options$resize = options.resize,
      resize = _options$resize === void 0 ? true : _options$resize;
  var window = getWindow(state.elements.popper);
  var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);

  if (scroll) {
    scrollParents.forEach(function (scrollParent) {
      scrollParent.addEventListener('scroll', instance.update, passive);
    });
  }

  if (resize) {
    window.addEventListener('resize', instance.update, passive);
  }

  return function () {
    if (scroll) {
      scrollParents.forEach(function (scrollParent) {
        scrollParent.removeEventListener('scroll', instance.update, passive);
      });
    }

    if (resize) {
      window.removeEventListener('resize', instance.update, passive);
    }
  };
} // eslint-disable-next-line import/no-unused-modules


var eventListeners = {
  name: 'eventListeners',
  enabled: true,
  phase: 'write',
  fn: function fn() {},
  effect: effect,
  data: {}
};var hash$1 = {
  left: 'right',
  right: 'left',
  bottom: 'top',
  top: 'bottom'
};
function getOppositePlacement(placement) {
  return placement.replace(/left|right|bottom|top/g, function (matched) {
    return hash$1[matched];
  });
}var hash = {
  start: 'end',
  end: 'start'
};
function getOppositeVariationPlacement(placement) {
  return placement.replace(/start|end/g, function (matched) {
    return hash[matched];
  });
}function getWindowScroll(node) {
  var win = getWindow(node);
  var scrollLeft = win.pageXOffset;
  var scrollTop = win.pageYOffset;
  return {
    scrollLeft: scrollLeft,
    scrollTop: scrollTop
  };
}function getWindowScrollBarX(element) {
  // If <html> has a CSS width greater than the viewport, then this will be
  // incorrect for RTL.
  // Popper 1 is broken in this case and never had a bug report so let's assume
  // it's not an issue. I don't think anyone ever specifies width on <html>
  // anyway.
  // Browsers where the left scrollbar doesn't cause an issue report `0` for
  // this (e.g. Edge 2019, IE11, Safari)
  return getBoundingClientRect(getDocumentElement(element)).left + getWindowScroll(element).scrollLeft;
}function getViewportRect(element) {
  var win = getWindow(element);
  var html = getDocumentElement(element);
  var visualViewport = win.visualViewport;
  var width = html.clientWidth;
  var height = html.clientHeight;
  var x = 0;
  var y = 0; // NB: This isn't supported on iOS <= 12. If the keyboard is open, the popper
  // can be obscured underneath it.
  // Also, `html.clientHeight` adds the bottom bar height in Safari iOS, even
  // if it isn't open, so if this isn't available, the popper will be detected
  // to overflow the bottom of the screen too early.

  if (visualViewport) {
    width = visualViewport.width;
    height = visualViewport.height; // Uses Layout Viewport (like Chrome; Safari does not currently)
    // In Chrome, it returns a value very close to 0 (+/-) but contains rounding
    // errors due to floating point numbers, so we need to check precision.
    // Safari returns a number <= 0, usually < -1 when pinch-zoomed
    // Feature detection fails in mobile emulation mode in Chrome.
    // Math.abs(win.innerWidth / visualViewport.scale - visualViewport.width) <
    // 0.001
    // Fallback here: "Not Safari" userAgent

    if (!/^((?!chrome|android).)*safari/i.test(navigator.userAgent)) {
      x = visualViewport.offsetLeft;
      y = visualViewport.offsetTop;
    }
  }

  return {
    width: width,
    height: height,
    x: x + getWindowScrollBarX(element),
    y: y
  };
}// of the `<html>` and `<body>` rect bounds if horizontally scrollable

function getDocumentRect(element) {
  var _element$ownerDocumen;

  var html = getDocumentElement(element);
  var winScroll = getWindowScroll(element);
  var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
  var width = max(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
  var height = max(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
  var x = -winScroll.scrollLeft + getWindowScrollBarX(element);
  var y = -winScroll.scrollTop;

  if (getComputedStyle$1(body || html).direction === 'rtl') {
    x += max(html.clientWidth, body ? body.clientWidth : 0) - width;
  }

  return {
    width: width,
    height: height,
    x: x,
    y: y
  };
}function isScrollParent(element) {
  // Firefox wants us to check `-x` and `-y` variations as well
  var _getComputedStyle = getComputedStyle$1(element),
      overflow = _getComputedStyle.overflow,
      overflowX = _getComputedStyle.overflowX,
      overflowY = _getComputedStyle.overflowY;

  return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}function getScrollParent(node) {
  if (['html', 'body', '#document'].indexOf(getNodeName(node)) >= 0) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
  }

  if (isHTMLElement(node) && isScrollParent(node)) {
    return node;
  }

  return getScrollParent(getParentNode(node));
}/*
given a DOM element, return the list of all scroll parents, up the list of ancesors
until we get to the top window object. This list is what we attach scroll listeners
to, because if any of these parent elements scroll, we'll need to re-calculate the
reference element's position.
*/

function listScrollParents(element, list) {
  var _element$ownerDocumen;

  if (list === void 0) {
    list = [];
  }

  var scrollParent = getScrollParent(element);
  var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
  var win = getWindow(scrollParent);
  var target = isBody ? [win].concat(win.visualViewport || [], isScrollParent(scrollParent) ? scrollParent : []) : scrollParent;
  var updatedList = list.concat(target);
  return isBody ? updatedList : // $FlowFixMe[incompatible-call]: isBody tells us target will be an HTMLElement here
  updatedList.concat(listScrollParents(getParentNode(target)));
}function rectToClientRect(rect) {
  return Object.assign({}, rect, {
    left: rect.x,
    top: rect.y,
    right: rect.x + rect.width,
    bottom: rect.y + rect.height
  });
}function getInnerBoundingClientRect(element) {
  var rect = getBoundingClientRect(element);
  rect.top = rect.top + element.clientTop;
  rect.left = rect.left + element.clientLeft;
  rect.bottom = rect.top + element.clientHeight;
  rect.right = rect.left + element.clientWidth;
  rect.width = element.clientWidth;
  rect.height = element.clientHeight;
  rect.x = rect.left;
  rect.y = rect.top;
  return rect;
}

function getClientRectFromMixedType(element, clippingParent) {
  return clippingParent === viewport ? rectToClientRect(getViewportRect(element)) : isHTMLElement(clippingParent) ? getInnerBoundingClientRect(clippingParent) : rectToClientRect(getDocumentRect(getDocumentElement(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`


function getClippingParents(element) {
  var clippingParents = listScrollParents(getParentNode(element));
  var canEscapeClipping = ['absolute', 'fixed'].indexOf(getComputedStyle$1(element).position) >= 0;
  var clipperElement = canEscapeClipping && isHTMLElement(element) ? getOffsetParent$1(element) : element;

  if (!isElement(clipperElement)) {
    return [];
  } // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414


  return clippingParents.filter(function (clippingParent) {
    return isElement(clippingParent) && contains$1(clippingParent, clipperElement) && getNodeName(clippingParent) !== 'body';
  });
} // Gets the maximum area that the element is visible in due to any number of
// clipping parents


function getClippingRect(element, boundary, rootBoundary) {
  var mainClippingParents = boundary === 'clippingParents' ? getClippingParents(element) : [].concat(boundary);
  var clippingParents = [].concat(mainClippingParents, [rootBoundary]);
  var firstClippingParent = clippingParents[0];
  var clippingRect = clippingParents.reduce(function (accRect, clippingParent) {
    var rect = getClientRectFromMixedType(element, clippingParent);
    accRect.top = max(rect.top, accRect.top);
    accRect.right = min(rect.right, accRect.right);
    accRect.bottom = min(rect.bottom, accRect.bottom);
    accRect.left = max(rect.left, accRect.left);
    return accRect;
  }, getClientRectFromMixedType(element, firstClippingParent));
  clippingRect.width = clippingRect.right - clippingRect.left;
  clippingRect.height = clippingRect.bottom - clippingRect.top;
  clippingRect.x = clippingRect.left;
  clippingRect.y = clippingRect.top;
  return clippingRect;
}function getVariation(placement) {
  return placement.split('-')[1];
}function computeOffsets(_ref) {
  var reference = _ref.reference,
      element = _ref.element,
      placement = _ref.placement;
  var basePlacement = placement ? getBasePlacement(placement) : null;
  var variation = placement ? getVariation(placement) : null;
  var commonX = reference.x + reference.width / 2 - element.width / 2;
  var commonY = reference.y + reference.height / 2 - element.height / 2;
  var offsets;

  switch (basePlacement) {
    case top:
      offsets = {
        x: commonX,
        y: reference.y - element.height
      };
      break;

    case bottom:
      offsets = {
        x: commonX,
        y: reference.y + reference.height
      };
      break;

    case right:
      offsets = {
        x: reference.x + reference.width,
        y: commonY
      };
      break;

    case left:
      offsets = {
        x: reference.x - element.width,
        y: commonY
      };
      break;

    default:
      offsets = {
        x: reference.x,
        y: reference.y
      };
  }

  var mainAxis = basePlacement ? getMainAxisFromPlacement(basePlacement) : null;

  if (mainAxis != null) {
    var len = mainAxis === 'y' ? 'height' : 'width';

    switch (variation) {
      case start:
        offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
        break;

      case end:
        offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
        break;
    }
  }

  return offsets;
}function detectOverflow(state, options) {
  if (options === void 0) {
    options = {};
  }

  var _options = options,
      _options$placement = _options.placement,
      placement = _options$placement === void 0 ? state.placement : _options$placement,
      _options$boundary = _options.boundary,
      boundary = _options$boundary === void 0 ? clippingParents : _options$boundary,
      _options$rootBoundary = _options.rootBoundary,
      rootBoundary = _options$rootBoundary === void 0 ? viewport : _options$rootBoundary,
      _options$elementConte = _options.elementContext,
      elementContext = _options$elementConte === void 0 ? popper : _options$elementConte,
      _options$altBoundary = _options.altBoundary,
      altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary,
      _options$padding = _options.padding,
      padding = _options$padding === void 0 ? 0 : _options$padding;
  var paddingObject = mergePaddingObject(typeof padding !== 'number' ? padding : expandToHashMap(padding, basePlacements));
  var altContext = elementContext === popper ? reference : popper;
  var referenceElement = state.elements.reference;
  var popperRect = state.rects.popper;
  var element = state.elements[altBoundary ? altContext : elementContext];
  var clippingClientRect = getClippingRect(isElement(element) ? element : element.contextElement || getDocumentElement(state.elements.popper), boundary, rootBoundary);
  var referenceClientRect = getBoundingClientRect(referenceElement);
  var popperOffsets = computeOffsets({
    reference: referenceClientRect,
    element: popperRect,
    strategy: 'absolute',
    placement: placement
  });
  var popperClientRect = rectToClientRect(Object.assign({}, popperRect, popperOffsets));
  var elementClientRect = elementContext === popper ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
  // 0 or negative = within the clipping rect

  var overflowOffsets = {
    top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
    bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
    left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
    right: elementClientRect.right - clippingClientRect.right + paddingObject.right
  };
  var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element

  if (elementContext === popper && offsetData) {
    var offset = offsetData[placement];
    Object.keys(overflowOffsets).forEach(function (key) {
      var multiply = [right, bottom].indexOf(key) >= 0 ? 1 : -1;
      var axis = [top, bottom].indexOf(key) >= 0 ? 'y' : 'x';
      overflowOffsets[key] += offset[axis] * multiply;
    });
  }

  return overflowOffsets;
}function computeAutoPlacement(state, options) {
  if (options === void 0) {
    options = {};
  }

  var _options = options,
      placement = _options.placement,
      boundary = _options.boundary,
      rootBoundary = _options.rootBoundary,
      padding = _options.padding,
      flipVariations = _options.flipVariations,
      _options$allowedAutoP = _options.allowedAutoPlacements,
      allowedAutoPlacements = _options$allowedAutoP === void 0 ? placements$1 : _options$allowedAutoP;
  var variation = getVariation(placement);
  var placements = variation ? flipVariations ? variationPlacements : variationPlacements.filter(function (placement) {
    return getVariation(placement) === variation;
  }) : basePlacements;
  var allowedPlacements = placements.filter(function (placement) {
    return allowedAutoPlacements.indexOf(placement) >= 0;
  });

  if (allowedPlacements.length === 0) {
    allowedPlacements = placements;
  } // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...


  var overflows = allowedPlacements.reduce(function (acc, placement) {
    acc[placement] = detectOverflow(state, {
      placement: placement,
      boundary: boundary,
      rootBoundary: rootBoundary,
      padding: padding
    })[getBasePlacement(placement)];
    return acc;
  }, {});
  return Object.keys(overflows).sort(function (a, b) {
    return overflows[a] - overflows[b];
  });
}function getExpandedFallbackPlacements(placement) {
  if (getBasePlacement(placement) === auto) {
    return [];
  }

  var oppositePlacement = getOppositePlacement(placement);
  return [getOppositeVariationPlacement(placement), oppositePlacement, getOppositeVariationPlacement(oppositePlacement)];
}

function flip$1(_ref) {
  var state = _ref.state,
      options = _ref.options,
      name = _ref.name;

  if (state.modifiersData[name]._skip) {
    return;
  }

  var _options$mainAxis = options.mainAxis,
      checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis,
      _options$altAxis = options.altAxis,
      checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis,
      specifiedFallbackPlacements = options.fallbackPlacements,
      padding = options.padding,
      boundary = options.boundary,
      rootBoundary = options.rootBoundary,
      altBoundary = options.altBoundary,
      _options$flipVariatio = options.flipVariations,
      flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio,
      allowedAutoPlacements = options.allowedAutoPlacements;
  var preferredPlacement = state.options.placement;
  var basePlacement = getBasePlacement(preferredPlacement);
  var isBasePlacement = basePlacement === preferredPlacement;
  var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [getOppositePlacement(preferredPlacement)] : getExpandedFallbackPlacements(preferredPlacement));
  var placements = [preferredPlacement].concat(fallbackPlacements).reduce(function (acc, placement) {
    return acc.concat(getBasePlacement(placement) === auto ? computeAutoPlacement(state, {
      placement: placement,
      boundary: boundary,
      rootBoundary: rootBoundary,
      padding: padding,
      flipVariations: flipVariations,
      allowedAutoPlacements: allowedAutoPlacements
    }) : placement);
  }, []);
  var referenceRect = state.rects.reference;
  var popperRect = state.rects.popper;
  var checksMap = new Map();
  var makeFallbackChecks = true;
  var firstFittingPlacement = placements[0];

  for (var i = 0; i < placements.length; i++) {
    var placement = placements[i];

    var _basePlacement = getBasePlacement(placement);

    var isStartVariation = getVariation(placement) === start;
    var isVertical = [top, bottom].indexOf(_basePlacement) >= 0;
    var len = isVertical ? 'width' : 'height';
    var overflow = detectOverflow(state, {
      placement: placement,
      boundary: boundary,
      rootBoundary: rootBoundary,
      altBoundary: altBoundary,
      padding: padding
    });
    var mainVariationSide = isVertical ? isStartVariation ? right : left : isStartVariation ? bottom : top;

    if (referenceRect[len] > popperRect[len]) {
      mainVariationSide = getOppositePlacement(mainVariationSide);
    }

    var altVariationSide = getOppositePlacement(mainVariationSide);
    var checks = [];

    if (checkMainAxis) {
      checks.push(overflow[_basePlacement] <= 0);
    }

    if (checkAltAxis) {
      checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
    }

    if (checks.every(function (check) {
      return check;
    })) {
      firstFittingPlacement = placement;
      makeFallbackChecks = false;
      break;
    }

    checksMap.set(placement, checks);
  }

  if (makeFallbackChecks) {
    // `2` may be desired in some cases – research later
    var numberOfChecks = flipVariations ? 3 : 1;

    var _loop = function _loop(_i) {
      var fittingPlacement = placements.find(function (placement) {
        var checks = checksMap.get(placement);

        if (checks) {
          return checks.slice(0, _i).every(function (check) {
            return check;
          });
        }
      });

      if (fittingPlacement) {
        firstFittingPlacement = fittingPlacement;
        return "break";
      }
    };

    for (var _i = numberOfChecks; _i > 0; _i--) {
      var _ret = _loop(_i);

      if (_ret === "break") break;
    }
  }

  if (state.placement !== firstFittingPlacement) {
    state.modifiersData[name]._skip = true;
    state.placement = firstFittingPlacement;
    state.reset = true;
  }
} // eslint-disable-next-line import/no-unused-modules


var flip$2 = {
  name: 'flip',
  enabled: true,
  phase: 'main',
  fn: flip$1,
  requiresIfExists: ['offset'],
  data: {
    _skip: false
  }
};function getSideOffsets(overflow, rect, preventedOffsets) {
  if (preventedOffsets === void 0) {
    preventedOffsets = {
      x: 0,
      y: 0
    };
  }

  return {
    top: overflow.top - rect.height - preventedOffsets.y,
    right: overflow.right - rect.width + preventedOffsets.x,
    bottom: overflow.bottom - rect.height + preventedOffsets.y,
    left: overflow.left - rect.width - preventedOffsets.x
  };
}

function isAnySideFullyClipped(overflow) {
  return [top, right, bottom, left].some(function (side) {
    return overflow[side] >= 0;
  });
}

function hide(_ref) {
  var state = _ref.state,
      name = _ref.name;
  var referenceRect = state.rects.reference;
  var popperRect = state.rects.popper;
  var preventedOffsets = state.modifiersData.preventOverflow;
  var referenceOverflow = detectOverflow(state, {
    elementContext: 'reference'
  });
  var popperAltOverflow = detectOverflow(state, {
    altBoundary: true
  });
  var referenceClippingOffsets = getSideOffsets(referenceOverflow, referenceRect);
  var popperEscapeOffsets = getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
  var isReferenceHidden = isAnySideFullyClipped(referenceClippingOffsets);
  var hasPopperEscaped = isAnySideFullyClipped(popperEscapeOffsets);
  state.modifiersData[name] = {
    referenceClippingOffsets: referenceClippingOffsets,
    popperEscapeOffsets: popperEscapeOffsets,
    isReferenceHidden: isReferenceHidden,
    hasPopperEscaped: hasPopperEscaped
  };
  state.attributes.popper = Object.assign({}, state.attributes.popper, {
    'data-popper-reference-hidden': isReferenceHidden,
    'data-popper-escaped': hasPopperEscaped
  });
} // eslint-disable-next-line import/no-unused-modules


var hide$1 = {
  name: 'hide',
  enabled: true,
  phase: 'main',
  requiresIfExists: ['preventOverflow'],
  fn: hide
};function distanceAndSkiddingToXY(placement, rects, offset) {
  var basePlacement = getBasePlacement(placement);
  var invertDistance = [left, top].indexOf(basePlacement) >= 0 ? -1 : 1;

  var _ref = typeof offset === 'function' ? offset(Object.assign({}, rects, {
    placement: placement
  })) : offset,
      skidding = _ref[0],
      distance = _ref[1];

  skidding = skidding || 0;
  distance = (distance || 0) * invertDistance;
  return [left, right].indexOf(basePlacement) >= 0 ? {
    x: distance,
    y: skidding
  } : {
    x: skidding,
    y: distance
  };
}

function offset(_ref2) {
  var state = _ref2.state,
      options = _ref2.options,
      name = _ref2.name;
  var _options$offset = options.offset,
      offset = _options$offset === void 0 ? [0, 0] : _options$offset;
  var data = placements$1.reduce(function (acc, placement) {
    acc[placement] = distanceAndSkiddingToXY(placement, state.rects, offset);
    return acc;
  }, {});
  var _data$state$placement = data[state.placement],
      x = _data$state$placement.x,
      y = _data$state$placement.y;

  if (state.modifiersData.popperOffsets != null) {
    state.modifiersData.popperOffsets.x += x;
    state.modifiersData.popperOffsets.y += y;
  }

  state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules


var offset$1 = {
  name: 'offset',
  enabled: true,
  phase: 'main',
  requires: ['popperOffsets'],
  fn: offset
};function popperOffsets(_ref) {
  var state = _ref.state,
      name = _ref.name;
  // Offsets are the actual position the popper needs to have to be
  // properly positioned near its reference element
  // This is the most basic placement, and will be adjusted by
  // the modifiers in the next step
  state.modifiersData[name] = computeOffsets({
    reference: state.rects.reference,
    element: state.rects.popper,
    strategy: 'absolute',
    placement: state.placement
  });
} // eslint-disable-next-line import/no-unused-modules


var popperOffsets$1 = {
  name: 'popperOffsets',
  enabled: true,
  phase: 'read',
  fn: popperOffsets,
  data: {}
};function getAltAxis(axis) {
  return axis === 'x' ? 'y' : 'x';
}function preventOverflow(_ref) {
  var state = _ref.state,
      options = _ref.options,
      name = _ref.name;
  var _options$mainAxis = options.mainAxis,
      checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis,
      _options$altAxis = options.altAxis,
      checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis,
      boundary = options.boundary,
      rootBoundary = options.rootBoundary,
      altBoundary = options.altBoundary,
      padding = options.padding,
      _options$tether = options.tether,
      tether = _options$tether === void 0 ? true : _options$tether,
      _options$tetherOffset = options.tetherOffset,
      tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
  var overflow = detectOverflow(state, {
    boundary: boundary,
    rootBoundary: rootBoundary,
    padding: padding,
    altBoundary: altBoundary
  });
  var basePlacement = getBasePlacement(state.placement);
  var variation = getVariation(state.placement);
  var isBasePlacement = !variation;
  var mainAxis = getMainAxisFromPlacement(basePlacement);
  var altAxis = getAltAxis(mainAxis);
  var popperOffsets = state.modifiersData.popperOffsets;
  var referenceRect = state.rects.reference;
  var popperRect = state.rects.popper;
  var tetherOffsetValue = typeof tetherOffset === 'function' ? tetherOffset(Object.assign({}, state.rects, {
    placement: state.placement
  })) : tetherOffset;
  var data = {
    x: 0,
    y: 0
  };

  if (!popperOffsets) {
    return;
  }

  if (checkMainAxis || checkAltAxis) {
    var mainSide = mainAxis === 'y' ? top : left;
    var altSide = mainAxis === 'y' ? bottom : right;
    var len = mainAxis === 'y' ? 'height' : 'width';
    var offset = popperOffsets[mainAxis];
    var min$1 = popperOffsets[mainAxis] + overflow[mainSide];
    var max$1 = popperOffsets[mainAxis] - overflow[altSide];
    var additive = tether ? -popperRect[len] / 2 : 0;
    var minLen = variation === start ? referenceRect[len] : popperRect[len];
    var maxLen = variation === start ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
    // outside the reference bounds

    var arrowElement = state.elements.arrow;
    var arrowRect = tether && arrowElement ? getLayoutRect(arrowElement) : {
      width: 0,
      height: 0
    };
    var arrowPaddingObject = state.modifiersData['arrow#persistent'] ? state.modifiersData['arrow#persistent'].padding : getFreshSideObject();
    var arrowPaddingMin = arrowPaddingObject[mainSide];
    var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
    // to include its full size in the calculation. If the reference is small
    // and near the edge of a boundary, the popper can overflow even if the
    // reference is not overflowing as well (e.g. virtual elements with no
    // width or height)

    var arrowLen = within(0, referenceRect[len], arrowRect[len]);
    var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - tetherOffsetValue : minLen - arrowLen - arrowPaddingMin - tetherOffsetValue;
    var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + tetherOffsetValue : maxLen + arrowLen + arrowPaddingMax + tetherOffsetValue;
    var arrowOffsetParent = state.elements.arrow && getOffsetParent$1(state.elements.arrow);
    var clientOffset = arrowOffsetParent ? mainAxis === 'y' ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
    var offsetModifierValue = state.modifiersData.offset ? state.modifiersData.offset[state.placement][mainAxis] : 0;
    var tetherMin = popperOffsets[mainAxis] + minOffset - offsetModifierValue - clientOffset;
    var tetherMax = popperOffsets[mainAxis] + maxOffset - offsetModifierValue;

    if (checkMainAxis) {
      var preventedOffset = within(tether ? min(min$1, tetherMin) : min$1, offset, tether ? max(max$1, tetherMax) : max$1);
      popperOffsets[mainAxis] = preventedOffset;
      data[mainAxis] = preventedOffset - offset;
    }

    if (checkAltAxis) {
      var _mainSide = mainAxis === 'x' ? top : left;

      var _altSide = mainAxis === 'x' ? bottom : right;

      var _offset = popperOffsets[altAxis];

      var _min = _offset + overflow[_mainSide];

      var _max = _offset - overflow[_altSide];

      var _preventedOffset = within(tether ? min(_min, tetherMin) : _min, _offset, tether ? max(_max, tetherMax) : _max);

      popperOffsets[altAxis] = _preventedOffset;
      data[altAxis] = _preventedOffset - _offset;
    }
  }

  state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules


var preventOverflow$1 = {
  name: 'preventOverflow',
  enabled: true,
  phase: 'main',
  fn: preventOverflow,
  requiresIfExists: ['offset']
};function getHTMLElementScroll(element) {
  return {
    scrollLeft: element.scrollLeft,
    scrollTop: element.scrollTop
  };
}function getNodeScroll(node) {
  if (node === getWindow(node) || !isHTMLElement(node)) {
    return getWindowScroll(node);
  } else {
    return getHTMLElementScroll(node);
  }
}// Composite means it takes into account transforms as well as layout.

function getCompositeRect(elementOrVirtualElement, offsetParent, isFixed) {
  if (isFixed === void 0) {
    isFixed = false;
  }

  var documentElement = getDocumentElement(offsetParent);
  var rect = getBoundingClientRect(elementOrVirtualElement);
  var isOffsetParentAnElement = isHTMLElement(offsetParent);
  var scroll = {
    scrollLeft: 0,
    scrollTop: 0
  };
  var offsets = {
    x: 0,
    y: 0
  };

  if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
    if (getNodeName(offsetParent) !== 'body' || // https://github.com/popperjs/popper-core/issues/1078
    isScrollParent(documentElement)) {
      scroll = getNodeScroll(offsetParent);
    }

    if (isHTMLElement(offsetParent)) {
      offsets = getBoundingClientRect(offsetParent);
      offsets.x += offsetParent.clientLeft;
      offsets.y += offsetParent.clientTop;
    } else if (documentElement) {
      offsets.x = getWindowScrollBarX(documentElement);
    }
  }

  return {
    x: rect.left + scroll.scrollLeft - offsets.x,
    y: rect.top + scroll.scrollTop - offsets.y,
    width: rect.width,
    height: rect.height
  };
}function order(modifiers) {
  var map = new Map();
  var visited = new Set();
  var result = [];
  modifiers.forEach(function (modifier) {
    map.set(modifier.name, modifier);
  }); // On visiting object, check for its dependencies and visit them recursively

  function sort(modifier) {
    visited.add(modifier.name);
    var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
    requires.forEach(function (dep) {
      if (!visited.has(dep)) {
        var depModifier = map.get(dep);

        if (depModifier) {
          sort(depModifier);
        }
      }
    });
    result.push(modifier);
  }

  modifiers.forEach(function (modifier) {
    if (!visited.has(modifier.name)) {
      // check for visited object
      sort(modifier);
    }
  });
  return result;
}

function orderModifiers(modifiers) {
  // order based on dependencies
  var orderedModifiers = order(modifiers); // order based on phase

  return modifierPhases.reduce(function (acc, phase) {
    return acc.concat(orderedModifiers.filter(function (modifier) {
      return modifier.phase === phase;
    }));
  }, []);
}function debounce(fn) {
  var pending;
  return function () {
    if (!pending) {
      pending = new Promise(function (resolve) {
        Promise.resolve().then(function () {
          pending = undefined;
          resolve(fn());
        });
      });
    }

    return pending;
  };
}function mergeByName(modifiers) {
  var merged = modifiers.reduce(function (merged, current) {
    var existing = merged[current.name];
    merged[current.name] = existing ? Object.assign({}, existing, current, {
      options: Object.assign({}, existing.options, current.options),
      data: Object.assign({}, existing.data, current.data)
    }) : current;
    return merged;
  }, {}); // IE11 does not support Object.values

  return Object.keys(merged).map(function (key) {
    return merged[key];
  });
}var DEFAULT_OPTIONS = {
  placement: 'bottom',
  modifiers: [],
  strategy: 'absolute'
};

function areValidElements() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  return !args.some(function (element) {
    return !(element && typeof element.getBoundingClientRect === 'function');
  });
}

function popperGenerator(generatorOptions) {
  if (generatorOptions === void 0) {
    generatorOptions = {};
  }

  var _generatorOptions = generatorOptions,
      _generatorOptions$def = _generatorOptions.defaultModifiers,
      defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def,
      _generatorOptions$def2 = _generatorOptions.defaultOptions,
      defaultOptions = _generatorOptions$def2 === void 0 ? DEFAULT_OPTIONS : _generatorOptions$def2;
  return function createPopper(reference, popper, options) {
    if (options === void 0) {
      options = defaultOptions;
    }

    var state = {
      placement: 'bottom',
      orderedModifiers: [],
      options: Object.assign({}, DEFAULT_OPTIONS, defaultOptions),
      modifiersData: {},
      elements: {
        reference: reference,
        popper: popper
      },
      attributes: {},
      styles: {}
    };
    var effectCleanupFns = [];
    var isDestroyed = false;
    var instance = {
      state: state,
      setOptions: function setOptions(options) {
        cleanupModifierEffects();
        state.options = Object.assign({}, defaultOptions, state.options, options);
        state.scrollParents = {
          reference: isElement(reference) ? listScrollParents(reference) : reference.contextElement ? listScrollParents(reference.contextElement) : [],
          popper: listScrollParents(popper)
        }; // Orders the modifiers based on their dependencies and `phase`
        // properties

        var orderedModifiers = orderModifiers(mergeByName([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers

        state.orderedModifiers = orderedModifiers.filter(function (m) {
          return m.enabled;
        }); // Validate the provided modifiers so that the consumer will get warned

        runModifierEffects();
        return instance.update();
      },
      // Sync update – it will always be executed, even if not necessary. This
      // is useful for low frequency updates where sync behavior simplifies the
      // logic.
      // For high frequency updates (e.g. `resize` and `scroll` events), always
      // prefer the async Popper#update method
      forceUpdate: function forceUpdate() {
        if (isDestroyed) {
          return;
        }

        var _state$elements = state.elements,
            reference = _state$elements.reference,
            popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
        // anymore

        if (!areValidElements(reference, popper)) {

          return;
        } // Store the reference and popper rects to be read by modifiers


        state.rects = {
          reference: getCompositeRect(reference, getOffsetParent$1(popper), state.options.strategy === 'fixed'),
          popper: getLayoutRect(popper)
        }; // Modifiers have the ability to reset the current update cycle. The
        // most common use case for this is the `flip` modifier changing the
        // placement, which then needs to re-run all the modifiers, because the
        // logic was previously ran for the previous placement and is therefore
        // stale/incorrect

        state.reset = false;
        state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
        // is filled with the initial data specified by the modifier. This means
        // it doesn't persist and is fresh on each update.
        // To ensure persistent data, use `${name}#persistent`

        state.orderedModifiers.forEach(function (modifier) {
          return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
        });

        for (var index = 0; index < state.orderedModifiers.length; index++) {

          if (state.reset === true) {
            state.reset = false;
            index = -1;
            continue;
          }

          var _state$orderedModifie = state.orderedModifiers[index],
              fn = _state$orderedModifie.fn,
              _state$orderedModifie2 = _state$orderedModifie.options,
              _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2,
              name = _state$orderedModifie.name;

          if (typeof fn === 'function') {
            state = fn({
              state: state,
              options: _options,
              name: name,
              instance: instance
            }) || state;
          }
        }
      },
      // Async and optimistically optimized update – it will not be executed if
      // not necessary (debounced to run at most once-per-tick)
      update: debounce(function () {
        return new Promise(function (resolve) {
          instance.forceUpdate();
          resolve(state);
        });
      }),
      destroy: function destroy() {
        cleanupModifierEffects();
        isDestroyed = true;
      }
    };

    if (!areValidElements(reference, popper)) {

      return instance;
    }

    instance.setOptions(options).then(function (state) {
      if (!isDestroyed && options.onFirstUpdate) {
        options.onFirstUpdate(state);
      }
    }); // Modifiers have the ability to execute arbitrary code before the first
    // update cycle runs. They will be executed in the same order as the update
    // cycle. This is useful when a modifier adds some persistent data that
    // other modifiers need to use, but the modifier is run after the dependent
    // one.

    function runModifierEffects() {
      state.orderedModifiers.forEach(function (_ref3) {
        var name = _ref3.name,
            _ref3$options = _ref3.options,
            options = _ref3$options === void 0 ? {} : _ref3$options,
            effect = _ref3.effect;

        if (typeof effect === 'function') {
          var cleanupFn = effect({
            state: state,
            name: name,
            instance: instance,
            options: options
          });

          var noopFn = function noopFn() {};

          effectCleanupFns.push(cleanupFn || noopFn);
        }
      });
    }

    function cleanupModifierEffects() {
      effectCleanupFns.forEach(function (fn) {
        return fn();
      });
      effectCleanupFns = [];
    }

    return instance;
  };
}var defaultModifiers = [eventListeners, popperOffsets$1, computeStyles$1, applyStyles$1, offset$1, flip$2, preventOverflow$1, arrow$1, hide$1];
var createPopper = /*#__PURE__*/popperGenerator({
  defaultModifiers: defaultModifiers
}); // eslint-disable-next-line import/no-unused-modules
/* global Map:readonly, Set:readonly, ArrayBuffer:readonly */

var hasElementType = typeof Element !== 'undefined';
var hasMap = typeof Map === 'function';
var hasSet = typeof Set === 'function';
var hasArrayBuffer = typeof ArrayBuffer === 'function' && !!ArrayBuffer.isView;

// Note: We **don't** need `envHasBigInt64Array` in fde es6/index.js

function equal(a, b) {
  // START: fast-deep-equal es6/index.js 3.1.1
  if (a === b) return true;

  if (a && b && typeof a == 'object' && typeof b == 'object') {
    if (a.constructor !== b.constructor) return false;

    var length, i, keys;
    if (Array.isArray(a)) {
      length = a.length;
      if (length != b.length) return false;
      for (i = length; i-- !== 0;)
        if (!equal(a[i], b[i])) return false;
      return true;
    }

    // START: Modifications:
    // 1. Extra `has<Type> &&` helpers in initial condition allow es6 code
    //    to co-exist with es5.
    // 2. Replace `for of` with es5 compliant iteration using `for`.
    //    Basically, take:
    //
    //    ```js
    //    for (i of a.entries())
    //      if (!b.has(i[0])) return false;
    //    ```
    //
    //    ... and convert to:
    //
    //    ```js
    //    it = a.entries();
    //    while (!(i = it.next()).done)
    //      if (!b.has(i.value[0])) return false;
    //    ```
    //
    //    **Note**: `i` access switches to `i.value`.
    var it;
    if (hasMap && (a instanceof Map) && (b instanceof Map)) {
      if (a.size !== b.size) return false;
      it = a.entries();
      while (!(i = it.next()).done)
        if (!b.has(i.value[0])) return false;
      it = a.entries();
      while (!(i = it.next()).done)
        if (!equal(i.value[1], b.get(i.value[0]))) return false;
      return true;
    }

    if (hasSet && (a instanceof Set) && (b instanceof Set)) {
      if (a.size !== b.size) return false;
      it = a.entries();
      while (!(i = it.next()).done)
        if (!b.has(i.value[0])) return false;
      return true;
    }
    // END: Modifications

    if (hasArrayBuffer && ArrayBuffer.isView(a) && ArrayBuffer.isView(b)) {
      length = a.length;
      if (length != b.length) return false;
      for (i = length; i-- !== 0;)
        if (a[i] !== b[i]) return false;
      return true;
    }

    if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
    if (a.valueOf !== Object.prototype.valueOf) return a.valueOf() === b.valueOf();
    if (a.toString !== Object.prototype.toString) return a.toString() === b.toString();

    keys = Object.keys(a);
    length = keys.length;
    if (length !== Object.keys(b).length) return false;

    for (i = length; i-- !== 0;)
      if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
    // END: fast-deep-equal

    // START: react-fast-compare
    // custom handling for DOM elements
    if (hasElementType && a instanceof Element) return false;

    // custom handling for React/Preact
    for (i = length; i-- !== 0;) {
      if ((keys[i] === '_owner' || keys[i] === '__v' || keys[i] === '__o') && a.$$typeof) {
        // React-specific: avoid traversing React elements' _owner
        // Preact-specific: avoid traversing Preact elements' __v and __o
        //    __v = $_original / $_vnode
        //    __o = $_owner
        // These properties contain circular references and are not needed when
        // comparing the actual elements (and not their owners)
        // .$$typeof and ._store on just reasonable markers of elements

        continue;
      }

      // all other properties should be traversed as usual
      if (!equal(a[keys[i]], b[keys[i]])) return false;
    }
    // END: react-fast-compare

    // START: fast-deep-equal
    return true;
  }

  return a !== a && b !== b;
}
// end fast-deep-equal

var reactFastCompare = function isEqual(a, b) {
  try {
    return equal(a, b);
  } catch (error) {
    if (((error.message || '').match(/stack|recursion/i))) {
      // warn on circular references, don't crash
      // browsers give this different errors name and messages:
      // chrome/safari: "RangeError", "Maximum call stack size exceeded"
      // firefox: "InternalError", too much recursion"
      // edge: "Error", "Out of stack space"
      console.warn('react-fast-compare cannot handle circular refs');
      return false;
    }
    // some other error. we should definitely know about these
    throw error;
  }
};var EMPTY_MODIFIERS = [];
var usePopper = function usePopper(referenceElement, popperElement, options) {
  if (options === void 0) {
    options = {};
  }

  var prevOptions = React__namespace.useRef(null);
  var optionsWithDefaults = {
    onFirstUpdate: options.onFirstUpdate,
    placement: options.placement || 'bottom',
    strategy: options.strategy || 'absolute',
    modifiers: options.modifiers || EMPTY_MODIFIERS
  };

  var _React$useState = React__namespace.useState({
    styles: {
      popper: {
        position: optionsWithDefaults.strategy,
        left: '0',
        top: '0'
      },
      arrow: {
        position: 'absolute'
      }
    },
    attributes: {}
  }),
      state = _React$useState[0],
      setState = _React$useState[1];

  var updateStateModifier = React__namespace.useMemo(function () {
    return {
      name: 'updateState',
      enabled: true,
      phase: 'write',
      fn: function fn(_ref) {
        var state = _ref.state;
        var elements = Object.keys(state.elements);
        setState({
          styles: fromEntries(elements.map(function (element) {
            return [element, state.styles[element] || {}];
          })),
          attributes: fromEntries(elements.map(function (element) {
            return [element, state.attributes[element]];
          }))
        });
      },
      requires: ['computeStyles']
    };
  }, []);
  var popperOptions = React__namespace.useMemo(function () {
    var newOptions = {
      onFirstUpdate: optionsWithDefaults.onFirstUpdate,
      placement: optionsWithDefaults.placement,
      strategy: optionsWithDefaults.strategy,
      modifiers: [].concat(optionsWithDefaults.modifiers, [updateStateModifier, {
        name: 'applyStyles',
        enabled: false
      }])
    };

    if (reactFastCompare(prevOptions.current, newOptions)) {
      return prevOptions.current || newOptions;
    } else {
      prevOptions.current = newOptions;
      return newOptions;
    }
  }, [optionsWithDefaults.onFirstUpdate, optionsWithDefaults.placement, optionsWithDefaults.strategy, optionsWithDefaults.modifiers, updateStateModifier]);
  var popperInstanceRef = React__namespace.useRef();
  useIsomorphicLayoutEffect$1(function () {
    if (popperInstanceRef.current) {
      popperInstanceRef.current.setOptions(popperOptions);
    }
  }, [popperOptions]);
  useIsomorphicLayoutEffect$1(function () {
    if (referenceElement == null || popperElement == null) {
      return;
    }

    var createPopper$1 = options.createPopper || createPopper;
    var popperInstance = createPopper$1(referenceElement, popperElement, popperOptions);
    popperInstanceRef.current = popperInstance;
    return function () {
      popperInstance.destroy();
      popperInstanceRef.current = null;
    };
  }, [referenceElement, popperElement, options.createPopper]);
  return {
    state: popperInstanceRef.current ? popperInstanceRef.current.state : null,
    styles: state.styles,
    attributes: state.attributes,
    update: popperInstanceRef.current ? popperInstanceRef.current.update : null,
    forceUpdate: popperInstanceRef.current ? popperInstanceRef.current.forceUpdate : null
  };
};var DropdownContext = /*#__PURE__*/React__default['default'].createContext({});var _templateObject$o, _templateObject2$j, _templateObject3$h, _templateObject4$g, _templateObject5$f, _templateObject6$a, _templateObject7$9, _templateObject8$9, _templateObject9$5, _templateObject10$5, _templateObject11$5, _templateObject12$4, _templateObject13$4, _templateObject14$4, _templateObject15$3, _templateObject16$2, _templateObject17$2;
// Styles
// =============================

var Wrapper$h = styled__default['default'].div(_templateObject$o || (_templateObject$o = _taggedTemplateLiteral$5(["\n  user-select: none;\n"])));
var Relative = styled__default['default'].div(_templateObject2$j || (_templateObject2$j = _taggedTemplateLiteral$5(["\n  position: relative;\n"])));
var DropdownContainer = styled__default['default'](framerMotion.motion.div).attrs(function (_ref) {
  var opened = _ref.opened,
      theme = _ref.theme;
  return {
    initial: 'close',
    animate: opened ? 'open' : 'close',
    exit: 'exit',
    variants: {
      open: {
        opacity: 1,
        transition: {
          duration: theme.transition.numeric.medium,
          ease: theme.transitionTiming.pose.easeInOut
        }
      },
      close: {
        opacity: 0,
        transition: {
          duration: theme.transition.numeric.medium,
          ease: theme.transitionTiming.pose.easeInOut
        }
      }
    }
  };
})(_templateObject3$h || (_templateObject3$h = _taggedTemplateLiteral$5(["\n  background: ", ";\n  border-radius: ", ";\n  box-shadow: 0 5px 30px 0 ", ";\n  color: ", ";\n  width: min-content;\n  z-index: ", ";\n\n  ", "\n\n  /** Need to be at the end. */\n  ", ";\n"])), function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.dropdown.background;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.edgeVariant === 'round' ? '0.5rem' : '0.2rem';
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.colors.boxShadow;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.colors.dropdown.text;
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.zIndex.dropdown;
}, function (_ref7) {
  var direction = _ref7.direction;

  /**
    Since we use translate to perform open/close animation
    we can not use it to center dropdown based on Container width.
    With something like:
      right: 50%;
      transform: translate3d(-50%, 0, 0);
    That's why 'south' & 'south-west' are the same, like 'north' & 'north-west'.
   */
  if (direction === 'south') {
    return styled.css(_templateObject4$g || (_templateObject4$g = _taggedTemplateLiteral$5(["\n        right: 0;\n        top: calc(100% + 2rem);\n      "])));
  }

  if (direction === 'south-east') {
    return styled.css(_templateObject5$f || (_templateObject5$f = _taggedTemplateLiteral$5(["\n        left: 0;\n        top: calc(100% + 2rem);\n      "])));
  }

  if (direction === 'south-west') {
    return styled.css(_templateObject6$a || (_templateObject6$a = _taggedTemplateLiteral$5(["\n        right: 0;\n        top: calc(100% + 2rem);\n      "])));
  }

  if (direction === 'north') {
    return styled.css(_templateObject7$9 || (_templateObject7$9 = _taggedTemplateLiteral$5(["\n        bottom: calc(100% + 2rem);\n        right: 0;\n      "])));
  }

  if (direction === 'north-east') {
    return styled.css(_templateObject8$9 || (_templateObject8$9 = _taggedTemplateLiteral$5(["\n        bottom: calc(100% + 2rem);\n        left: 0;\n      "])));
  }

  if (direction === 'north-west') {
    return styled.css(_templateObject9$5 || (_templateObject9$5 = _taggedTemplateLiteral$5(["\n        bottom: calc(100% + 2rem);\n        right: 0;\n      "])));
  }

  return null;
}, function (_ref8) {
  var dropdownStyles = _ref8.dropdownStyles;
  return dropdownStyles;
});
var ContentContainer = styled__default['default'].div(_templateObject10$5 || (_templateObject10$5 = _taggedTemplateLiteral$5(["\n  ", ";\n  overflow: auto;\n\n  ", ";\n\n  /** Need to be at the end. */\n  ", ";\n"])), hideScrollBar, function (_ref9) {
  var withoutStyles = _ref9.withoutStyles;
  return !withoutStyles && styled.css(_templateObject11$5 || (_templateObject11$5 = _taggedTemplateLiteral$5(["\n      max-height: 18rem;\n    "])));
}, function (_ref10) {
  var contentStyles = _ref10.contentStyles;
  return contentStyles;
});
var FooterHeaderCommon = styled__default['default'].div(_templateObject12$4 || (_templateObject12$4 = _taggedTemplateLiteral$5(["\n  align-items: center;\n  display: flex;\n  justify-content: flex-start;\n\n  ", ";\n"])), function (_ref11) {
  var withoutStyles = _ref11.withoutStyles;
  return !withoutStyles && styled.css(_templateObject13$4 || (_templateObject13$4 = _taggedTemplateLiteral$5(["\n      padding: 0.8rem 2rem;\n    "])));
});
var Footer = styled__default['default'](FooterHeaderCommon)(_templateObject14$4 || (_templateObject14$4 = _taggedTemplateLiteral$5(["\n  ", ";\n"])), function (_ref12) {
  var withoutStyles = _ref12.withoutStyles;
  return !withoutStyles && styled.css(_templateObject15$3 || (_templateObject15$3 = _taggedTemplateLiteral$5(["\n      border-top: 0.1rem solid ", ";\n    "])), function (_ref13) {
    var theme = _ref13.theme;
    return alpha$2(theme.colors.dropdown.text, 0.8);
  });
});
var Header$2 = styled__default['default'](FooterHeaderCommon)(_templateObject16$2 || (_templateObject16$2 = _taggedTemplateLiteral$5(["\n  ", ";\n"])), function (_ref14) {
  var withoutStyles = _ref14.withoutStyles;
  return !withoutStyles && styled.css(_templateObject17$2 || (_templateObject17$2 = _taggedTemplateLiteral$5(["\n      border-bottom: 0.1rem solid ", ";\n    "])), function (_ref15) {
    var theme = _ref15.theme;
    return alpha$2(theme.colors.dropdown.text, 0.8);
  });
});// Component
// =============================

var DropdownBase = function DropdownBase(props) {
  var children = props.children,
      className = props.className,
      contentStyles = props.contentStyles,
      dropdownClassName = props.dropdownClassName,
      dropdownStyles = props.dropdownStyles,
      footer = props.footer,
      handleClick = props.handleClick,
      handleClickAway = props.handleClickAway,
      header = props.header,
      opened = props.opened,
      placement = props.placement,
      togglerElement = props.togglerElement,
      withoutStyles = props.withoutStyles;

  var _useState = React.useState(null),
      _useState2 = _slicedToArray$7(_useState, 2),
      referenceElement = _useState2[0],
      setReferenceElement = _useState2[1];

  var _useState3 = React.useState(null),
      _useState4 = _slicedToArray$7(_useState3, 2),
      popperElement = _useState4[0],
      setPopperElement = _useState4[1];

  var _usePopper = usePopper(referenceElement, popperElement, {
    placement: placement,
    modifiers: [{
      name: 'offset',
      options: {
        offset: [0, 20]
      }
    }]
  }),
      update = _usePopper.update,
      styles = _usePopper.styles;

  var dropdownContext = {
    closeDropdown: handleClickAway,
    handleClick: handleClick,
    opened: opened,
    updatePopper: update
  };
  return /*#__PURE__*/React__default['default'].createElement(Wrapper$h, {
    className: className
  }, /*#__PURE__*/React__default['default'].createElement(DropdownContext.Provider, {
    value: dropdownContext
  }, /*#__PURE__*/React__default['default'].createElement(ClickAwayListener, {
    onClickAway: handleClickAway,
    mouseEvent: "onMouseDown"
  }, /*#__PURE__*/React__default['default'].createElement(Relative, null, /*#__PURE__*/React__default['default'].cloneElement(togglerElement, {
    ref: setReferenceElement,
    onClick: handleClick,
    style: {
      cursor: 'pointer'
    }
  }), opened && /*#__PURE__*/React__default['default'].createElement(_default$3, {
    component: "div",
    left: 0,
    right: 0,
    top: 0
  }, /*#__PURE__*/React__default['default'].createElement(DropdownContainer, {
    className: dropdownClassName,
    direction: placement,
    dropdownStyles: dropdownStyles,
    opened: opened,
    ref: setPopperElement,
    style: styles.popper,
    withoutStyles: withoutStyles
  }, header && /*#__PURE__*/React__default['default'].createElement(Header$2, {
    withoutStyles: withoutStyles
  }, header), /*#__PURE__*/React__default['default'].createElement(ContentContainer, {
    contentStyles: contentStyles,
    withoutStyles: withoutStyles
  }, children), footer && /*#__PURE__*/React__default['default'].createElement(Footer, {
    withoutStyles: withoutStyles
  }, footer)))))));
};

DropdownBase.propTypes = {
  /** Dropdown content. */
  children: PropTypes__default['default'].node,

  /** Props used by styled component to override styles. */
  className: PropTypes__default['default'].string,

  /** Props used to pass additionnal css to content wrapper.
   * We use this instead of className because this element is in a Portal,
   * which means we cannot use descendent selector to style it style it with
   * a custom className. */
  // eslint-disable-next-line react/forbid-prop-types
  contentStyles: PropTypes__default['default'].array,

  /**  Props used by styled component to override dropdown styles. */
  dropdownClassName: PropTypes__default['default'].string,

  /** Props used to pass additionnal css to dropdown wrapper.
  * We use this instead of className because this element is in a Portal,
  * which means we cannot use descendent selector to style it style it with
  * a custom className. */
  // eslint-disable-next-line react/forbid-prop-types
  dropdownStyles: PropTypes__default['default'].array,

  /** Component that will populate dropdown footer. */
  footer: PropTypes__default['default'].node,

  /**
   * Use to add actions to handleClick method.
   * Actions will be triggered after state opened is set to true.
   * */
  handleClick: PropTypes__default['default'].func,

  /**
   * Actions will be triggered on click outside of dropdown
   * */
  handleClickAway: PropTypes__default['default'].func.isRequired,

  /** Component that will populate dropdown header. */
  header: PropTypes__default['default'].node,

  /** If True, dropdown is opened. */
  opened: PropTypes__default['default'].bool,

  /** Dropdown placement. */
  placement: PropTypes__default['default'].oneOf(['auto', 'auto-start', 'auto-end', 'top', 'top-start', 'top-end', 'bottom', 'bottom-start', 'bottom-end', 'right', 'right-start', 'right-end', 'left', 'left-start', 'left-end']),

  /** Component that will be used as a toggler. */
  togglerElement: PropTypes__default['default'].node.isRequired,

  /** If True, won't aapply default style. */
  withoutStyles: PropTypes__default['default'].bool
};
DropdownBase.defaultProps = {
  children: null,
  className: '',
  dropdownClassName: '',
  contentStyles: null,
  dropdownStyles: null,
  footer: null,
  handleClick: null,
  header: null,
  opened: false,
  placement: 'south',
  withoutStyles: false
};

var DropdownClass = /*#__PURE__*/function (_PureComponent) {
  _inherits$e(DropdownClass, _PureComponent);

  var _super = _createSuper$1(DropdownClass);

  function DropdownClass(props) {
    var _this;

    _classCallCheck$k(this, DropdownClass);

    _this = _super.call(this, props);

    _defineProperty$8(_assertThisInitialized$1(_this), "state", {
      opened: false
    });

    _defineProperty$8(_assertThisInitialized$1(_this), "handleClick", function () {
      var handleClick = _this.props.handleClick;
      var id = _this.state.id;
      return _this.setState(function (state) {
        return {
          opened: !state.opened
        };
      }, function () {
        var opened = _this.state.opened;
        if (handleClick) handleClick();

        if (typeof document !== 'undefined') {
          if (opened) {
            document.body.classList.toggle("is-locked-dropdown-".concat(id), true);
          } else {
            document.body.classList.toggle("is-locked-dropdown-".concat(id), false);
          }
        }
      });
    });

    _defineProperty$8(_assertThisInitialized$1(_this), "handleClickAway", function () {
      var _this$state = _this.state,
          id = _this$state.id,
          opened = _this$state.opened;

      if (opened) {
        _this.setState({
          opened: false
        });

        if (typeof document !== 'undefined') {
          document.body.classList.toggle("is-locked-dropdown-".concat(id), false);
        }
      }
    });

    _this.state = {
      id: uuid.v4()
    };
    return _this;
  }

  _createClass$g(DropdownClass, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var _this$state2 = this.state,
          id = _this$state2.id,
          opened = _this$state2.opened;

      if (opened && typeof document !== 'undefined') {
        document.body.classList.toggle("is-locked-dropdown-".concat(id), false);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var opened = this.state.opened;
      return /*#__PURE__*/React__default['default'].createElement(DropdownBase, _extends$g({}, this.props, {
        handleClick: this.handleClick,
        handleClickAway: this.handleClickAway,
        opened: opened
      }));
    }
  }]);

  return DropdownClass;
}(React.PureComponent);

_defineProperty$8(DropdownClass, "propTypes", {
  /** Dropdown content. */
  children: PropTypes__default['default'].node,

  /** Props used by styled component to override styles. */
  className: PropTypes__default['default'].string,

  /** Props used to pass additionnal css to content wrapper.
   * We use this instead of className because this element is in a Portal,
   * which means we cannot use descendent selector to style it style it with
   * a custom className. */
  // eslint-disable-next-line react/forbid-prop-types
  contentStyles: PropTypes__default['default'].array,

  /**  Props used by styled component to override dropdown styles. */
  dropdownClassName: PropTypes__default['default'].string,

  /** Props used to pass additionnal css to dropdown wrapper.
   * We use this instead of className because this element is in a Portal,
   * which means we cannot use descendent selector to style it style it with
   * a custom className. */
  // eslint-disable-next-line react/forbid-prop-types
  dropdownStyles: PropTypes__default['default'].array,

  /** Dropdown direction. */
  placement: PropTypes__default['default'].oneOf(['auto', 'auto-start', 'auto-end', 'top', 'top-start', 'top-end', 'bottom', 'bottom-start', 'bottom-end', 'right', 'right-start', 'right-end', 'left', 'left-start', 'left-end']),

  /** Component that will populate dropdown footer. */
  footer: PropTypes__default['default'].node,

  /**
   * Use to add actions to handleClick method.
   * Actions will be triggered after state opened is set to true.
   * */
  handleClick: PropTypes__default['default'].func,

  /** Component that will populate dropdown header. */
  header: PropTypes__default['default'].node,

  /** Component that will be used as a toggler. */
  togglerElement: PropTypes__default['default'].node.isRequired,

  /** If True, won't apply default style. */
  withoutStyles: PropTypes__default['default'].bool
});

_defineProperty$8(DropdownClass, "defaultProps", {
  children: null,
  className: '',
  contentStyles: null,
  dropdownClassName: '',
  dropdownStyles: null,
  placement: 'bottom',
  footer: null,
  handleClick: null,
  header: null,
  withoutStyles: false
});

_defineProperty$8(DropdownClass, "contextType", DropdownContext);var baseEach = _baseEach;

/**
 * The base implementation of `_.filter` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function baseFilter$1(collection, predicate) {
  var result = [];
  baseEach(collection, function(value, index, collection) {
    if (predicate(value, index, collection)) {
      result.push(value);
    }
  });
  return result;
}

var _baseFilter = baseFilter$1;var arrayFilter = _arrayFilter,
    baseFilter = _baseFilter,
    baseIteratee$4 = _baseIteratee,
    isArray$2 = isArray_1;

/**
 * Iterates over elements of `collection`, returning an array of all elements
 * `predicate` returns truthy for. The predicate is invoked with three
 * arguments: (value, index|key, collection).
 *
 * **Note:** Unlike `_.remove`, this method returns a new array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 * @see _.reject
 * @example
 *
 * var users = [
 *   { 'user': 'barney', 'age': 36, 'active': true },
 *   { 'user': 'fred',   'age': 40, 'active': false }
 * ];
 *
 * _.filter(users, function(o) { return !o.active; });
 * // => objects for ['fred']
 *
 * // The `_.matches` iteratee shorthand.
 * _.filter(users, { 'age': 36, 'active': true });
 * // => objects for ['barney']
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.filter(users, ['active', false]);
 * // => objects for ['fred']
 *
 * // The `_.property` iteratee shorthand.
 * _.filter(users, 'active');
 * // => objects for ['barney']
 *
 * // Combining several predicates using `_.overEvery` or `_.overSome`.
 * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
 * // => objects for ['fred', 'barney']
 */
function filter(collection, predicate) {
  var func = isArray$2(collection) ? arrayFilter : baseFilter;
  return func(collection, baseIteratee$4(predicate));
}

var filter_1 = filter;/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */

function baseFindIndex$2(array, predicate, fromIndex, fromRight) {
  var length = array.length,
      index = fromIndex + (fromRight ? 1 : -1);

  while ((fromRight ? index-- : ++index < length)) {
    if (predicate(array[index], index, array)) {
      return index;
    }
  }
  return -1;
}

var _baseFindIndex = baseFindIndex$2;/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */

function baseIsNaN$1(value) {
  return value !== value;
}

var _baseIsNaN = baseIsNaN$1;/**
 * A specialized version of `_.indexOf` which performs strict equality
 * comparisons of values, i.e. `===`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */

function strictIndexOf$1(array, value, fromIndex) {
  var index = fromIndex - 1,
      length = array.length;

  while (++index < length) {
    if (array[index] === value) {
      return index;
    }
  }
  return -1;
}

var _strictIndexOf = strictIndexOf$1;var baseFindIndex$1 = _baseFindIndex,
    baseIsNaN = _baseIsNaN,
    strictIndexOf = _strictIndexOf;

/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseIndexOf$2(array, value, fromIndex) {
  return value === value
    ? strictIndexOf(array, value, fromIndex)
    : baseFindIndex$1(array, baseIsNaN, fromIndex);
}

var _baseIndexOf = baseIndexOf$2;var toNumber = toNumber_1;

/** Used as references for various `Number` constants. */
var INFINITY$1 = 1 / 0,
    MAX_INTEGER = 1.7976931348623157e+308;

/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */
function toFinite$1(value) {
  if (!value) {
    return value === 0 ? value : 0;
  }
  value = toNumber(value);
  if (value === INFINITY$1 || value === -INFINITY$1) {
    var sign = (value < 0 ? -1 : 1);
    return sign * MAX_INTEGER;
  }
  return value === value ? value : 0;
}

var toFinite_1 = toFinite$1;var toFinite = toFinite_1;

/**
 * Converts `value` to an integer.
 *
 * **Note:** This method is loosely based on
 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toInteger(3.2);
 * // => 3
 *
 * _.toInteger(Number.MIN_VALUE);
 * // => 0
 *
 * _.toInteger(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toInteger('3.2');
 * // => 3
 */
function toInteger$2(value) {
  var result = toFinite(value),
      remainder = result % 1;

  return result === result ? (remainder ? result - remainder : result) : 0;
}

var toInteger_1 = toInteger$2;var arrayMap$5 = _arrayMap;

/**
 * The base implementation of `_.values` and `_.valuesIn` which creates an
 * array of `object` property values corresponding to the property names
 * of `props`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} props The property names to get values for.
 * @returns {Object} Returns the array of property values.
 */
function baseValues$1(object, props) {
  return arrayMap$5(props, function(key) {
    return object[key];
  });
}

var _baseValues = baseValues$1;var baseValues = _baseValues,
    keys$1 = keys_1;

/**
 * Creates an array of the own enumerable string keyed property values of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property values.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.values(new Foo);
 * // => [1, 2] (iteration order is not guaranteed)
 *
 * _.values('hi');
 * // => ['h', 'i']
 */
function values$1(object) {
  return object == null ? [] : baseValues(object, keys$1(object));
}

var values_1 = values$1;var baseIndexOf$1 = _baseIndexOf,
    isArrayLike$2 = isArrayLike_1,
    isString = isString_1,
    toInteger$1 = toInteger_1,
    values = values_1;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax$1 = Math.max;

/**
 * Checks if `value` is in `collection`. If `collection` is a string, it's
 * checked for a substring of `value`, otherwise
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * is used for equality comparisons. If `fromIndex` is negative, it's used as
 * the offset from the end of `collection`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object|string} collection The collection to inspect.
 * @param {*} value The value to search for.
 * @param {number} [fromIndex=0] The index to search from.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
 * @returns {boolean} Returns `true` if `value` is found, else `false`.
 * @example
 *
 * _.includes([1, 2, 3], 1);
 * // => true
 *
 * _.includes([1, 2, 3], 1, 2);
 * // => false
 *
 * _.includes({ 'a': 1, 'b': 2 }, 1);
 * // => true
 *
 * _.includes('abcd', 'bc');
 * // => true
 */
function includes(collection, value, fromIndex, guard) {
  collection = isArrayLike$2(collection) ? collection : values(collection);
  fromIndex = (fromIndex && !guard) ? toInteger$1(fromIndex) : 0;

  var length = collection.length;
  if (fromIndex < 0) {
    fromIndex = nativeMax$1(length + fromIndex, 0);
  }
  return isString(collection)
    ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
    : (!!length && baseIndexOf$1(collection, value, fromIndex) > -1);
}

var includes_1 = includes;var _templateObject$n, _templateObject2$i, _templateObject3$g, _templateObject4$f, _templateObject5$e;
// Styles
// =============================

var OptionsContainer = styled__default['default'].div(_templateObject$n || (_templateObject$n = _taggedTemplateLiteral$5(["\n  ", ";\n  overflow: auto;\n\n  ", ";\n\n  /** Need to be at the end. */\n  ", ";\n"])), hideScrollBar, function (_ref) {
  var withoutStyles = _ref.withoutStyles;
  return !withoutStyles && styled.css(_templateObject2$i || (_templateObject2$i = _taggedTemplateLiteral$5(["\n      max-height: 18rem;\n    "])));
}, function (_ref2) {
  var optionsContainerStyles = _ref2.optionsContainerStyles;
  return optionsContainerStyles;
});
var DropdownOption = styled__default['default'].div(_templateObject3$g || (_templateObject3$g = _taggedTemplateLiteral$5(["\n  align-items: center;\n  cursor: pointer;\n  display: flex;\n  height: 4rem;\n  padding: 0 2rem;\n  transition: background-color ", ";\n\n  /** NOTE: We always use the brand color for the hover of items */\n  &:hover {\n    background-color: ", ";\n  }\n"])), function (_ref3) {
  var theme = _ref3.theme;
  return theme.transition.medium;
}, function (_ref4) {
  var theme = _ref4.theme;
  return alpha$2(theme.colors.primary, 0.2);
});
var FilterInputContainer = styled__default['default'].div(_templateObject4$f || (_templateObject4$f = _taggedTemplateLiteral$5(["\n  align-items: center;\n  display: flex;\n  height: 4rem;\n  justify-content: center;\n  margin: 0.8rem 0;\n  padding: 0.4rem 0.8rem;\n"])));
var FilterInput = styled__default['default'](InputBase$2).attrs({
  showPlaceholder: true
})(_templateObject5$e || (_templateObject5$e = _taggedTemplateLiteral$5(["\n  background-color: ", ";\n  color: ", ";\n  padding: 1.2rem 1.6rem;\n"])), function (_ref5) {
  var theme = _ref5.theme;
  return alpha$2(theme.colors.dropdown.text, 0.1);
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.colors.dropdown.text;
});// Component
// =============================

var DropdownList = /*#__PURE__*/function (_PureComponent) {
  _inherits$e(DropdownList, _PureComponent);

  var _super = _createSuper$1(DropdownList);

  function DropdownList() {
    var _this;

    _classCallCheck$k(this, DropdownList);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty$8(_assertThisInitialized$1(_this), "state", {
      filter: ''
    });

    _defineProperty$8(_assertThisInitialized$1(_this), "handleClick", function () {
      var _this$props = _this.props,
          handleClick = _this$props.handleClick,
          withFilter = _this$props.withFilter;
      if (handleClick) handleClick();
      if (withFilter && _this.inputRef) _this.inputRef.focus();
    });

    _defineProperty$8(_assertThisInitialized$1(_this), "handleFilterChange", function (e) {
      return _this.setState({
        filter: e.target.value
      });
    });

    _defineProperty$8(_assertThisInitialized$1(_this), "handleClickOption", function (option, closeDropdown) {
      var closeOnClick = _this.props.closeOnClick;

      if (!option.action && closeOnClick) {
        closeDropdown();
      }

      if (option.action) {
        option.action(option.name);
        closeDropdown();
      }
    });

    _defineProperty$8(_assertThisInitialized$1(_this), "renderOptions", function (closeDropdown) {
      var filter = _this.state.filter;
      var _this$props2 = _this.props,
          noOption = _this$props2.noOption,
          options = _this$props2.options,
          renderOption = _this$props2.renderOption,
          withFilter = _this$props2.withFilter; // eslint-disable-next-line max-len

      var optionsFiltered = withFilter ? filter_1(options, function (option) {
        return includes_1(deburr_1(option.label.toLowerCase()), deburr_1(filter.toLowerCase()));
      }) : options; // If no options available.

      if (!optionsFiltered.length) {
        if (noOption) return noOption;
        return null;
      } // If we specified a custom Option element.


      if (renderOption) {
        return optionsFiltered.map(function (option) {
          if (renderOption(option)) {
            return /*#__PURE__*/React__default['default'].cloneElement(renderOption(option), {
              key: option.name,
              onClick: function onClick() {
                return _this.handleClickOption(option, closeDropdown);
              }
            });
          }

          return /*#__PURE__*/React__default['default'].createElement(DropdownOption, {
            key: option.name,
            onClick: function onClick() {
              return _this.handleClickOption(option, closeDropdown);
            }
          }, option.label);
        });
      }

      return optionsFiltered.map(function (option) {
        return /*#__PURE__*/React__default['default'].createElement(DropdownOption, {
          key: option.name,
          onClick: function onClick() {
            return _this.handleClickOption(option, closeDropdown);
          }
        }, option.label);
      });
    });

    return _this;
  }

  _createClass$g(DropdownList, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props3 = this.props,
          className = _this$props3.className,
          contentStyles = _this$props3.contentStyles,
          dropdownClassName = _this$props3.dropdownClassName,
          dropdownStyles = _this$props3.dropdownStyles,
          placement = _this$props3.placement,
          footer = _this$props3.footer,
          header = _this$props3.header,
          lang = _this$props3.lang,
          optionsContainerStyles = _this$props3.optionsContainerStyles,
          togglerElement = _this$props3.togglerElement,
          withFilter = _this$props3.withFilter,
          withoutStyles = _this$props3.withoutStyles;
      return /*#__PURE__*/React__default['default'].createElement(DropdownClass, {
        className: className,
        contentStyles: contentStyles,
        dropdownClassName: dropdownClassName,
        dropdownStyles: dropdownStyles,
        placement: placement,
        footer: footer,
        handleClick: this.handleClick,
        header: header,
        togglerElement: togglerElement,
        withoutStyles: withoutStyles
      }, withFilter && /*#__PURE__*/React__default['default'].createElement(FilterInputContainer, null, /*#__PURE__*/React__default['default'].createElement(FilterInput, {
        innerRef: function innerRef(node) {
          _this2.inputRef = node;
        },
        onChange: this.handleFilterChange,
        name: "filterInput",
        placeholder: get_1(lang, 'search', '')
      })), /*#__PURE__*/React__default['default'].createElement(OptionsContainer, {
        optionsContainerStyles: optionsContainerStyles,
        withoutStyles: withoutStyles
      }, /*#__PURE__*/React__default['default'].createElement(DropdownContext.Consumer, null, function (_ref) {
        var closeDropdown = _ref.closeDropdown;
        return _this2.renderOptions(closeDropdown);
      })));
    }
  }]);

  return DropdownList;
}(React.PureComponent);

_defineProperty$8(DropdownList, "propTypes", {
  /** Props used by styled component to override styles. */
  className: PropTypes__default['default'].string,

  /** Should dropdown close after an option has been clicked. */
  closeOnClick: PropTypes__default['default'].bool,

  /** Props used to pass additionnal css to content wrapper.
   * We use this instead of className because this element is in a Portal,
   * which means we cannot use descendent selector to style it style it with
   * a custom className. */
  // eslint-disable-next-line react/forbid-prop-types
  contentStyles: PropTypes__default['default'].array,

  /**  Props used by styled component to override dropdown styles. */
  dropdownClassName: PropTypes__default['default'].string,

  /** Props used to pass additionnal css to dropdown wrapper.
  * We use this instead of className because this element is in a Portal,
  * which means we cannot use descendent selector to style it style it with
  * a custom className. */
  // eslint-disable-next-line react/forbid-prop-types
  dropdownStyles: PropTypes__default['default'].array,

  /**
   * Use to add actions to handleClick method.
   * Actions will be triggered after state opened is set to true.
   * */
  handleClick: PropTypes__default['default'].func,

  /** Dropdown direction. */
  placement: PropTypes__default['default'].oneOf(['auto', 'auto-start', 'auto-end', 'top', 'top-start', 'top-end', 'bottom', 'bottom-start', 'bottom-end', 'right', 'right-start', 'right-end', 'left', 'left-start', 'left-end']),

  /** Component that will populate dropdown footer. */
  footer: PropTypes__default['default'].node,

  /** Component that will populate dropdown header. */
  header: PropTypes__default['default'].node,

  /** Translation strings. Required only if withFilter true. */
  lang: function lang(props, propName, componentName) {
    if (props.withFilter) {
      if (typeof props[propName] === 'undefined') {
        return new Error("Failed prop type: The prop '".concat(propName, "' is marked as required in ").concat(componentName, ", but its value is 'undefined'"));
      }

      if (_typeof$6(props[propName]) !== 'object') {
        return new Error("Warning: Failed prop type: Invalid prop '".concat(propName, "' of type '").concat(_typeof$6(props[propName]), "' supplied to '").concat(componentName, "', expected 'object'"));
      }
    }

    return null;
  },

  /** Node rendered when no options available. */
  noOption: PropTypes__default['default'].node,

  /** Options list. */
  options: PropTypes__default['default'].arrayOf(PropTypes__default['default'].shape({
    action: PropTypes__default['default'].func,
    label: PropTypes__default['default'].string.isRequired,
    name: PropTypes__default['default'].string.isRequired
  })),

  /** Props used to pass additionnal css to options container.
  * We use this instead of className because this element is in a Portal,
  * which means we cannot use descendent selector to style it style it with
  * a custom className. */
  // eslint-disable-next-line react/forbid-prop-types
  optionsContainerStyles: PropTypes__default['default'].array,

  /** Function that render an Option element. (used for styles customisation) */
  renderOption: PropTypes__default['default'].func,

  /** Component that will be used as a toggler. */
  togglerElement: PropTypes__default['default'].node.isRequired,

  /** If True, will add a filter input to filter options. */
  withFilter: PropTypes__default['default'].bool,

  /** If True, won't aapply default style. */
  withoutStyles: PropTypes__default['default'].bool
});

_defineProperty$8(DropdownList, "defaultProps", {
  className: '',
  closeOnClick: true,
  contentStyles: null,
  dropdownClassName: '',
  dropdownStyles: null,
  handleClick: null,
  placement: 'bottom',
  footer: null,
  header: null,
  lang: null,
  noOption: null,
  options: [],
  optionsContainerStyles: null,
  renderOption: null,
  withFilter: false,
  withoutStyles: false
});

_defineProperty$8(DropdownList, "contextType", DropdownContext);var baseKeys = _baseKeys,
    getTag = _getTag,
    isArguments = isArguments_1,
    isArray$1 = isArray_1,
    isArrayLike$1 = isArrayLike_1,
    isBuffer = isBuffer$7.exports,
    isPrototype = _isPrototype,
    isTypedArray = isTypedArray_1;

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    setTag = '[object Set]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if `value` is an empty object, collection, map, or set.
 *
 * Objects are considered empty if they have no own enumerable string keyed
 * properties.
 *
 * Array-like values such as `arguments` objects, arrays, buffers, strings, or
 * jQuery-like collections are considered empty if they have a `length` of `0`.
 * Similarly, maps and sets are considered empty if they have a `size` of `0`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is empty, else `false`.
 * @example
 *
 * _.isEmpty(null);
 * // => true
 *
 * _.isEmpty(true);
 * // => true
 *
 * _.isEmpty(1);
 * // => true
 *
 * _.isEmpty([1, 2, 3]);
 * // => false
 *
 * _.isEmpty({ 'a': 1 });
 * // => false
 */
function isEmpty(value) {
  if (value == null) {
    return true;
  }
  if (isArrayLike$1(value) &&
      (isArray$1(value) || typeof value == 'string' || typeof value.splice == 'function' ||
        isBuffer(value) || isTypedArray(value) || isArguments(value))) {
    return !value.length;
  }
  var tag = getTag(value);
  if (tag == mapTag || tag == setTag) {
    return !value.size;
  }
  if (isPrototype(value)) {
    return !baseKeys(value).length;
  }
  for (var key in value) {
    if (hasOwnProperty.call(value, key)) {
      return false;
    }
  }
  return true;
}

var isEmpty_1 = isEmpty;var baseSet = _baseSet;

/**
 * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
 * it's created. Arrays are created for missing index properties while objects
 * are created for all other missing properties. Use `_.setWith` to customize
 * `path` creation.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.set(object, 'a[0].b.c', 4);
 * console.log(object.a[0].b.c);
 * // => 4
 *
 * _.set(object, ['x', '0', 'y', 'z'], 5);
 * console.log(object.x[0].y.z);
 * // => 5
 */
function set(object, path, value) {
  return object == null ? object : baseSet(object, path, value);
}

var set_1 = set;var removeAccents$2 = {exports: {}};var characterMap = {
	"À": "A",
	"Á": "A",
	"Â": "A",
	"Ã": "A",
	"Ä": "A",
	"Å": "A",
	"Ấ": "A",
	"Ắ": "A",
	"Ẳ": "A",
	"Ẵ": "A",
	"Ặ": "A",
	"Æ": "AE",
	"Ầ": "A",
	"Ằ": "A",
	"Ȃ": "A",
	"Ç": "C",
	"Ḉ": "C",
	"È": "E",
	"É": "E",
	"Ê": "E",
	"Ë": "E",
	"Ế": "E",
	"Ḗ": "E",
	"Ề": "E",
	"Ḕ": "E",
	"Ḝ": "E",
	"Ȇ": "E",
	"Ì": "I",
	"Í": "I",
	"Î": "I",
	"Ï": "I",
	"Ḯ": "I",
	"Ȋ": "I",
	"Ð": "D",
	"Ñ": "N",
	"Ò": "O",
	"Ó": "O",
	"Ô": "O",
	"Õ": "O",
	"Ö": "O",
	"Ø": "O",
	"Ố": "O",
	"Ṍ": "O",
	"Ṓ": "O",
	"Ȏ": "O",
	"Ù": "U",
	"Ú": "U",
	"Û": "U",
	"Ü": "U",
	"Ý": "Y",
	"à": "a",
	"á": "a",
	"â": "a",
	"ã": "a",
	"ä": "a",
	"å": "a",
	"ấ": "a",
	"ắ": "a",
	"ẳ": "a",
	"ẵ": "a",
	"ặ": "a",
	"æ": "ae",
	"ầ": "a",
	"ằ": "a",
	"ȃ": "a",
	"ç": "c",
	"ḉ": "c",
	"è": "e",
	"é": "e",
	"ê": "e",
	"ë": "e",
	"ế": "e",
	"ḗ": "e",
	"ề": "e",
	"ḕ": "e",
	"ḝ": "e",
	"ȇ": "e",
	"ì": "i",
	"í": "i",
	"î": "i",
	"ï": "i",
	"ḯ": "i",
	"ȋ": "i",
	"ð": "d",
	"ñ": "n",
	"ò": "o",
	"ó": "o",
	"ô": "o",
	"õ": "o",
	"ö": "o",
	"ø": "o",
	"ố": "o",
	"ṍ": "o",
	"ṓ": "o",
	"ȏ": "o",
	"ù": "u",
	"ú": "u",
	"û": "u",
	"ü": "u",
	"ý": "y",
	"ÿ": "y",
	"Ā": "A",
	"ā": "a",
	"Ă": "A",
	"ă": "a",
	"Ą": "A",
	"ą": "a",
	"Ć": "C",
	"ć": "c",
	"Ĉ": "C",
	"ĉ": "c",
	"Ċ": "C",
	"ċ": "c",
	"Č": "C",
	"č": "c",
	"C̆": "C",
	"c̆": "c",
	"Ď": "D",
	"ď": "d",
	"Đ": "D",
	"đ": "d",
	"Ē": "E",
	"ē": "e",
	"Ĕ": "E",
	"ĕ": "e",
	"Ė": "E",
	"ė": "e",
	"Ę": "E",
	"ę": "e",
	"Ě": "E",
	"ě": "e",
	"Ĝ": "G",
	"Ǵ": "G",
	"ĝ": "g",
	"ǵ": "g",
	"Ğ": "G",
	"ğ": "g",
	"Ġ": "G",
	"ġ": "g",
	"Ģ": "G",
	"ģ": "g",
	"Ĥ": "H",
	"ĥ": "h",
	"Ħ": "H",
	"ħ": "h",
	"Ḫ": "H",
	"ḫ": "h",
	"Ĩ": "I",
	"ĩ": "i",
	"Ī": "I",
	"ī": "i",
	"Ĭ": "I",
	"ĭ": "i",
	"Į": "I",
	"į": "i",
	"İ": "I",
	"ı": "i",
	"Ĳ": "IJ",
	"ĳ": "ij",
	"Ĵ": "J",
	"ĵ": "j",
	"Ķ": "K",
	"ķ": "k",
	"Ḱ": "K",
	"ḱ": "k",
	"K̆": "K",
	"k̆": "k",
	"Ĺ": "L",
	"ĺ": "l",
	"Ļ": "L",
	"ļ": "l",
	"Ľ": "L",
	"ľ": "l",
	"Ŀ": "L",
	"ŀ": "l",
	"Ł": "l",
	"ł": "l",
	"Ḿ": "M",
	"ḿ": "m",
	"M̆": "M",
	"m̆": "m",
	"Ń": "N",
	"ń": "n",
	"Ņ": "N",
	"ņ": "n",
	"Ň": "N",
	"ň": "n",
	"ŉ": "n",
	"N̆": "N",
	"n̆": "n",
	"Ō": "O",
	"ō": "o",
	"Ŏ": "O",
	"ŏ": "o",
	"Ő": "O",
	"ő": "o",
	"Œ": "OE",
	"œ": "oe",
	"P̆": "P",
	"p̆": "p",
	"Ŕ": "R",
	"ŕ": "r",
	"Ŗ": "R",
	"ŗ": "r",
	"Ř": "R",
	"ř": "r",
	"R̆": "R",
	"r̆": "r",
	"Ȓ": "R",
	"ȓ": "r",
	"Ś": "S",
	"ś": "s",
	"Ŝ": "S",
	"ŝ": "s",
	"Ş": "S",
	"Ș": "S",
	"ș": "s",
	"ş": "s",
	"Š": "S",
	"š": "s",
	"Ţ": "T",
	"ţ": "t",
	"ț": "t",
	"Ț": "T",
	"Ť": "T",
	"ť": "t",
	"Ŧ": "T",
	"ŧ": "t",
	"T̆": "T",
	"t̆": "t",
	"Ũ": "U",
	"ũ": "u",
	"Ū": "U",
	"ū": "u",
	"Ŭ": "U",
	"ŭ": "u",
	"Ů": "U",
	"ů": "u",
	"Ű": "U",
	"ű": "u",
	"Ų": "U",
	"ų": "u",
	"Ȗ": "U",
	"ȗ": "u",
	"V̆": "V",
	"v̆": "v",
	"Ŵ": "W",
	"ŵ": "w",
	"Ẃ": "W",
	"ẃ": "w",
	"X̆": "X",
	"x̆": "x",
	"Ŷ": "Y",
	"ŷ": "y",
	"Ÿ": "Y",
	"Y̆": "Y",
	"y̆": "y",
	"Ź": "Z",
	"ź": "z",
	"Ż": "Z",
	"ż": "z",
	"Ž": "Z",
	"ž": "z",
	"ſ": "s",
	"ƒ": "f",
	"Ơ": "O",
	"ơ": "o",
	"Ư": "U",
	"ư": "u",
	"Ǎ": "A",
	"ǎ": "a",
	"Ǐ": "I",
	"ǐ": "i",
	"Ǒ": "O",
	"ǒ": "o",
	"Ǔ": "U",
	"ǔ": "u",
	"Ǖ": "U",
	"ǖ": "u",
	"Ǘ": "U",
	"ǘ": "u",
	"Ǚ": "U",
	"ǚ": "u",
	"Ǜ": "U",
	"ǜ": "u",
	"Ứ": "U",
	"ứ": "u",
	"Ṹ": "U",
	"ṹ": "u",
	"Ǻ": "A",
	"ǻ": "a",
	"Ǽ": "AE",
	"ǽ": "ae",
	"Ǿ": "O",
	"ǿ": "o",
	"Þ": "TH",
	"þ": "th",
	"Ṕ": "P",
	"ṕ": "p",
	"Ṥ": "S",
	"ṥ": "s",
	"X́": "X",
	"x́": "x",
	"Ѓ": "Г",
	"ѓ": "г",
	"Ќ": "К",
	"ќ": "к",
	"A̋": "A",
	"a̋": "a",
	"E̋": "E",
	"e̋": "e",
	"I̋": "I",
	"i̋": "i",
	"Ǹ": "N",
	"ǹ": "n",
	"Ồ": "O",
	"ồ": "o",
	"Ṑ": "O",
	"ṑ": "o",
	"Ừ": "U",
	"ừ": "u",
	"Ẁ": "W",
	"ẁ": "w",
	"Ỳ": "Y",
	"ỳ": "y",
	"Ȁ": "A",
	"ȁ": "a",
	"Ȅ": "E",
	"ȅ": "e",
	"Ȉ": "I",
	"ȉ": "i",
	"Ȍ": "O",
	"ȍ": "o",
	"Ȑ": "R",
	"ȑ": "r",
	"Ȕ": "U",
	"ȕ": "u",
	"B̌": "B",
	"b̌": "b",
	"Č̣": "C",
	"č̣": "c",
	"Ê̌": "E",
	"ê̌": "e",
	"F̌": "F",
	"f̌": "f",
	"Ǧ": "G",
	"ǧ": "g",
	"Ȟ": "H",
	"ȟ": "h",
	"J̌": "J",
	"ǰ": "j",
	"Ǩ": "K",
	"ǩ": "k",
	"M̌": "M",
	"m̌": "m",
	"P̌": "P",
	"p̌": "p",
	"Q̌": "Q",
	"q̌": "q",
	"Ř̩": "R",
	"ř̩": "r",
	"Ṧ": "S",
	"ṧ": "s",
	"V̌": "V",
	"v̌": "v",
	"W̌": "W",
	"w̌": "w",
	"X̌": "X",
	"x̌": "x",
	"Y̌": "Y",
	"y̌": "y",
	"A̧": "A",
	"a̧": "a",
	"B̧": "B",
	"b̧": "b",
	"Ḑ": "D",
	"ḑ": "d",
	"Ȩ": "E",
	"ȩ": "e",
	"Ɛ̧": "E",
	"ɛ̧": "e",
	"Ḩ": "H",
	"ḩ": "h",
	"I̧": "I",
	"i̧": "i",
	"Ɨ̧": "I",
	"ɨ̧": "i",
	"M̧": "M",
	"m̧": "m",
	"O̧": "O",
	"o̧": "o",
	"Q̧": "Q",
	"q̧": "q",
	"U̧": "U",
	"u̧": "u",
	"X̧": "X",
	"x̧": "x",
	"Z̧": "Z",
	"z̧": "z",
};

var chars = Object.keys(characterMap).join('|');
var allAccents = new RegExp(chars, 'g');
var firstAccent = new RegExp(chars, '');

var removeAccents = function(string) {	
	return string.replace(allAccents, function(match) {
		return characterMap[match];
	});
};

var hasAccents = function(string) {
	return !!string.match(firstAccent);
};

removeAccents$2.exports = removeAccents;
removeAccents$2.exports.has = hasAccents;
removeAccents$2.exports.remove = removeAccents;

var removeAccents$1 = removeAccents$2.exports;// =============================
// Helpers
// =============================

/**
 * Get name from multilingual data
 * @param {Object[]} names - Language objects
 * @param {String} locale - locale to retrieve
 * @return {String} Name
 */
// eslint-disable-next-line import/prefer-default-export
var getName = function getName() {
  var names = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var locale = arguments.length > 1 ? arguments[1] : undefined;
  var name = names.find(function (n) {
    return n.locale === locale;
  });
  if (name) return name.value;
  return '';
};// Helpers
// =============================

var matches = function matches(text, search) {
  var searchValues = removeAccents$1(search).toLowerCase().split(/\s+/);
  var textValues = text.split(/\s+/);
  return searchValues.every(function (searchValue) {
    return textValues.find(function (textValue) {
      return textValue.indexOf(searchValue) === 0;
    });
  });
};

var synonymMatches = function synonymMatches(synonyms, search, locale) {
  var synonym = synonyms.find(function (e) {
    return e.locale === locale;
  });
  if (!synonym) return false;
  return synonym.values.some(function (s) {
    return matches(s, search);
  });
};

var versionMatches = function versionMatches(version, search, locale) {
  return matches(getName(version.search_names, locale), search);
};
var tagMatches = function tagMatches(tag, search, locale) {
  return matches(getName(tag.search_names, locale), search) || synonymMatches(tag.search_synonyms, search, locale);
};
var subCategoryMatches = function subCategoryMatches(subCategory, search, locale) {
  return matches(getName(subCategory.search_names, locale), search) || subCategory.tags.some(function (tag) {
    return tagMatches(tag, search, locale);
  });
};
var categoryMatches = function categoryMatches(category, search, locale) {
  return category.tags.some(function (tag) {
    return tagMatches(tag, search, locale);
  }) || category.sub_categories.some(function (subCategory) {
    return subCategoryMatches(subCategory, search, locale);
  });
};
var itemsFoundLength = function itemsFoundLength(categories, versions, search, locale) {
  return categories.reduce(function (acc, c) {
    return [].concat(_toConsumableArray$5(acc), _toConsumableArray$5(c.tags), _toConsumableArray$5(c.sub_categories.reduce(function (sacc, sc) {
      return [].concat(_toConsumableArray$5(sacc), _toConsumableArray$5(sc.tags));
    }, [])));
  }, []).filter(function (tag) {
    return tagMatches(tag, search, locale);
  }).length + versions.filter(function (version) {
    return versionMatches(version, search, locale);
  }).length;
};
var synonymFound = function synonymFound(synonyms, searchSynonyms, search) {
  if (!search) return undefined;
  var searchValues = removeAccents$1(search).toLowerCase().split(/\s+/);
  var matchedSynonymIndex = searchSynonyms.findIndex(function (s) {
    var synonymValues = s.split(/\s+/);
    return searchValues.every(function (searchValue) {
      return synonymValues.find(function (synonymValue) {
        return synonymValue.indexOf(searchValue) === 0;
      });
    });
  });
  if (matchedSynonymIndex === -1) return undefined;
  return synonyms[matchedSynonymIndex];
};
var tagSynonymFound = function tagSynonymFound(tag, search, locale) {
  var synonyms = tag.synonyms.find(function (e) {
    return e.locale === locale;
  });
  var searchSynonyms = tag.search_synonyms.find(function (e) {
    return e.locale === locale;
  });
  if (!synonyms || !searchSynonyms) return undefined;
  return synonymFound(synonyms.values, searchSynonyms.values, search);
};
var tagCategoriesOrder = [// genres
'5b532dd7450f084ddcd8354c', // area
'5b532dd7450f084ddcd83546', // periods
'5b532dd7450f084ddcd83549', // structures
'5b532dd7450f084ddcd83555', // mood
'5b532dd7450f084ddcd83552', // style
'5b532dd7450f084ddcd83558', // usage
'5b532dd7450f084ddcd8355b', // instruments
'5b532dd7450f084ddcd8354f', // sound
'5f22b65c388a470017da62a3', // gestures
'5d35f5dcb42d7b56380dfa63', // technics
'5d356e044ee859003222b01e', // nuance
'5d35908c9fd3b20032f574bf', // pal
'5b59c72cb8986ea19dc40781'];// =============================
// Internal
// =============================

var name = PropTypes__default['default'].shape({
  locale: PropTypes__default['default'].string,
  value: PropTypes__default['default'].string
});
var tag = PropTypes__default['default'].shape({
  id: PropTypes__default['default'].string,
  key: PropTypes__default['default'].string,
  color: PropTypes__default['default'].string,
  names: PropTypes__default['default'].arrayOf(name),
  synonyms: PropTypes__default['default'].arrayOf(PropTypes__default['default'].shape({
    locale: PropTypes__default['default'].string,
    values: PropTypes__default['default'].arrayOf(PropTypes__default['default'].string)
  })),
  search_names: PropTypes__default['default'].arrayOf(name),
  search_synonyms: PropTypes__default['default'].arrayOf(PropTypes__default['default'].shape({
    locale: PropTypes__default['default'].string,
    values: PropTypes__default['default'].arrayOf(PropTypes__default['default'].string)
  })),
  category_id: PropTypes__default['default'].string,
  category_key: PropTypes__default['default'].string,
  category_names: PropTypes__default['default'].arrayOf(name),
  sub_category_id: PropTypes__default['default'].string,
  sub_category_key: PropTypes__default['default'].string,
  sub_category_names: PropTypes__default['default'].arrayOf(name)
});
var subCategory = PropTypes__default['default'].shape({
  id: PropTypes__default['default'].string,
  key: PropTypes__default['default'].string,
  color: PropTypes__default['default'].string,
  names: PropTypes__default['default'].arrayOf(name),
  search_names: PropTypes__default['default'].arrayOf(name),
  category_id: PropTypes__default['default'].string,
  category_key: PropTypes__default['default'].string,
  category_names: PropTypes__default['default'].arrayOf(name),
  tags: PropTypes__default['default'].arrayOf(tag)
});
var category = PropTypes__default['default'].shape({
  id: PropTypes__default['default'].string,
  key: PropTypes__default['default'].string,
  names: PropTypes__default['default'].arrayOf(name),
  search_names: PropTypes__default['default'].arrayOf(name),
  color: PropTypes__default['default'].string,
  sub_categories: PropTypes__default['default'].arrayOf(subCategory),
  tags: PropTypes__default['default'].arrayOf(tag)
});
var version = PropTypes__default['default'].shape({
  id: PropTypes__default['default'].string,
  key: PropTypes__default['default'].string,
  names: PropTypes__default['default'].arrayOf(name),
  search_names: PropTypes__default['default'].arrayOf(name)
});
var facet = PropTypes__default['default'].shape({
  key: PropTypes__default['default'].string,
  from: PropTypes__default['default'].number,
  to: PropTypes__default['default'].number,
  docCount: PropTypes__default['default'].number
});
var openedBoxes = PropTypes__default['default'].shape({
  categories: PropTypes__default['default'].object,
  // eslint-disable-line react/forbid-prop-types
  subCategories: PropTypes__default['default'].object,
  // eslint-disable-line react/forbid-prop-types
  other: PropTypes__default['default'].shape({
    bpm: PropTypes__default['default'].bool,
    year: PropTypes__default['default'].bool,
    duration: PropTypes__default['default'].bool,
    versions: PropTypes__default['default'].bool
  })
});
var lang = PropTypes__default['default'].shape({
  title: PropTypes__default['default'].string,
  search: PropTypes__default['default'].string,
  duration: PropTypes__default['default'].string,
  year: PropTypes__default['default'].string,
  bpm: PropTypes__default['default'].string,
  versions: PropTypes__default['default'].string,
  maiaLoading: PropTypes__default['default'].string,
  noTags: PropTypes__default['default'].string
});var _templateObject$m, _templateObject2$h;
// Styles
// =============================

var Svg$1 = styled__default['default'].svg(_templateObject$m || (_templateObject$m = _taggedTemplateLiteral$5(["\n  max-width: 100%;\n  padding: 0 1.6rem;\n  transform-origin: bottom;\n"])));

var getScaleValue = function getScaleValue(val) {
  var retVal = val / 20;
  if (retVal > 1) retVal = 1;
  return retVal;
};

var Path$1 = styled__default['default'].path(_templateObject2$h || (_templateObject2$h = _taggedTemplateLiteral$5(["\n  height: 0%;\n  transform-origin: bottom;\n  transform: scaleY(", ");\n  transition: transform ", ";\n"])), function (_ref) {
  var percentage = _ref.percentage;
  return getScaleValue(percentage);
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.transition.medium;
});var _excluded$e = ["data", "title", "theme"];
// Component
// =============================

var Chart = /*#__PURE__*/function (_PureComponent) {
  _inherits$e(Chart, _PureComponent);

  var _super = _createSuper$1(Chart);

  function Chart() {
    _classCallCheck$k(this, Chart);

    return _super.apply(this, arguments);
  }

  _createClass$g(Chart, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          data = _this$props.data,
          title = _this$props.title,
          theme = _this$props.theme,
          rest = _objectWithoutProperties$7(_this$props, _excluded$e);

      var max = data.map(function (a) {
        return a.docCount;
      });
      var sum = max.reduce(function (a, b) {
        return a + b;
      }, 0);
      var values = sum > 0 ? data.map(function (val) {
        return val.docCount * 100 / sum;
      }) : data.map(function () {
        return 0;
      });
      return /*#__PURE__*/React__default['default'].createElement(Svg$1, _extends$g({
        key: "svg",
        fill: alpha$2(theme.colors.text, 0.2),
        viewBox: "0 0 208 39.43"
      }, getViewProps(rest)), /*#__PURE__*/React__default['default'].createElement("title", null, title), values.map(function (value, index) {
        return index === 0 ? /*#__PURE__*/React__default['default'].createElement(Path$1 // eslint-disable-next-line react/no-array-index-key
        , {
          key: index,
          fillRule: "evenodd",
          percentage: value,
          d: "M".concat(2 + 10 * index, " 0h4a2 2 0 0 1 2 2v35.43a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2z")
        }) : /*#__PURE__*/React__default['default'].createElement(Path$1 // eslint-disable-next-line react/no-array-index-key
        , {
          key: index,
          fillRule: "evenodd",
          percentage: value,
          d: "M".concat(2 + 10 * index, " 0h4a2 2 0 0 1 2 2v35.43a2 2 0 0 1-2 2h-4a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2z")
        });
      }));
    }
  }]);

  return Chart;
}(React.PureComponent);

_defineProperty$8(Chart, "propTypes", {
  /** Chart content. */
  data: PropTypes__default['default'].arrayOf(PropTypes__default['default'].shape({
    key: PropTypes__default['default'].string.isRequired,
    from: PropTypes__default['default'].number.isRequired,
    to: PropTypes__default['default'].number,
    docCount: PropTypes__default['default'].number.isRequired
  })),

  /** SVG title. */
  title: PropTypes__default['default'].string,

  /** Styled component theme. */
  theme: PropTypes__default['default'].object.isRequired // eslint-disable-line react/forbid-prop-types

});

_defineProperty$8(Chart, "defaultProps", {
  data: [],
  title: ''
});

var Chart$1 = styled.withTheme(Chart);var baseIsEqual = _baseIsEqual;

/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */
function isEqual(value, other) {
  return baseIsEqual(value, other);
}

var isEqual_1 = isEqual;function ownKeys$1(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2$1(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys$1(Object(source), true).forEach(function (key) {
        _defineProperty$3(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys$1(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn$d(this, result);
  };
}/* eslint-disable no-console */
var warned = {};
function warning(valid, message) {
}
function call(method, valid, message) {
  if (!valid && !warned[message]) {
    method(false, message);
    warned[message] = true;
  }
}
function warningOnce(valid, message) {
  call(warning, valid, message);
}
/* eslint-enable */var Track = function Track(props) {
  var _ref, _ref2;

  var className = props.className,
      included = props.included,
      vertical = props.vertical,
      style = props.style;
  var length = props.length,
      offset = props.offset,
      reverse = props.reverse;

  if (length < 0) {
    reverse = !reverse;
    length = Math.abs(length);
    offset = 100 - offset;
  }

  var positonStyle = vertical ? (_ref = {}, _defineProperty$3(_ref, reverse ? 'top' : 'bottom', "".concat(offset, "%")), _defineProperty$3(_ref, reverse ? 'bottom' : 'top', 'auto'), _defineProperty$3(_ref, "height", "".concat(length, "%")), _ref) : (_ref2 = {}, _defineProperty$3(_ref2, reverse ? 'right' : 'left', "".concat(offset, "%")), _defineProperty$3(_ref2, reverse ? 'left' : 'right', 'auto'), _defineProperty$3(_ref2, "width", "".concat(length, "%")), _ref2);

  var elStyle = _objectSpread2$1(_objectSpread2$1({}, style), positonStyle);

  return included ? /*#__PURE__*/React__default['default'].createElement("div", {
    className: className,
    style: elStyle
  }) : null;
};function _superPropBase(object, property) {
  while (!Object.prototype.hasOwnProperty.call(object, property)) {
    object = _getPrototypeOf(object);
    if (object === null) break;
  }

  return object;
}function _get(target, property, receiver) {
  if (typeof Reflect !== "undefined" && Reflect.get) {
    _get = Reflect.get;
  } else {
    _get = function _get(target, property, receiver) {
      var base = _superPropBase(target, property);
      if (!base) return;
      var desc = Object.getOwnPropertyDescriptor(base, property);

      if (desc.get) {
        return desc.get.call(receiver);
      }

      return desc.value;
    };
  }

  return _get(target, property, receiver || target);
}function addEventListenerWrap(target, eventType, cb, option) {
  /* eslint camelcase: 2 */
  var callback = ReactDOM__default['default'].unstable_batchedUpdates ? function run(e) {
    ReactDOM__default['default'].unstable_batchedUpdates(cb, e);
  } : cb;

  if (target.addEventListener) {
    target.addEventListener(eventType, callback, option);
  }

  return {
    remove: function remove() {
      if (target.removeEventListener) {
        target.removeEventListener(eventType, callback);
      }
    }
  };
}var classnames = {exports: {}};/*!
  Copyright (c) 2018 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/

(function (module) {
/* global define */

(function () {

	var hasOwn = {}.hasOwnProperty;

	function classNames() {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg)) {
				if (arg.length) {
					var inner = classNames.apply(null, arg);
					if (inner) {
						classes.push(inner);
					}
				}
			} else if (argType === 'object') {
				if (arg.toString === Object.prototype.toString) {
					for (var key in arg) {
						if (hasOwn.call(arg, key) && arg[key]) {
							classes.push(key);
						}
					}
				} else {
					classes.push(arg.toString());
				}
			}
		}

		return classes.join(' ');
	}

	if (module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else {
		window.classNames = classNames;
	}
}());
}(classnames));

var classNames = classnames.exports;var calcPoints = function calcPoints(vertical, marks, dots, step, min, max) {
  warningOnce(dots ? step > 0 : true, '`Slider[step]` should be a positive number in order to make Slider[dots] work.');
  var points = Object.keys(marks).map(parseFloat).sort(function (a, b) {
    return a - b;
  });

  if (dots && step) {
    for (var i = min; i <= max; i += step) {
      if (points.indexOf(i) === -1) {
        points.push(i);
      }
    }
  }

  return points;
};

var Steps = function Steps(_ref) {
  var prefixCls = _ref.prefixCls,
      vertical = _ref.vertical,
      reverse = _ref.reverse,
      marks = _ref.marks,
      dots = _ref.dots,
      step = _ref.step,
      included = _ref.included,
      lowerBound = _ref.lowerBound,
      upperBound = _ref.upperBound,
      max = _ref.max,
      min = _ref.min,
      dotStyle = _ref.dotStyle,
      activeDotStyle = _ref.activeDotStyle;
  var range = max - min;
  var elements = calcPoints(vertical, marks, dots, step, min, max).map(function (point) {
    var _classNames;

    var offset = "".concat(Math.abs(point - min) / range * 100, "%");
    var isActived = !included && point === upperBound || included && point <= upperBound && point >= lowerBound;
    var style = vertical ? _objectSpread2$1(_objectSpread2$1({}, dotStyle), {}, _defineProperty$3({}, reverse ? 'top' : 'bottom', offset)) : _objectSpread2$1(_objectSpread2$1({}, dotStyle), {}, _defineProperty$3({}, reverse ? 'right' : 'left', offset));

    if (isActived) {
      style = _objectSpread2$1(_objectSpread2$1({}, style), activeDotStyle);
    }

    var pointClassName = classNames((_classNames = {}, _defineProperty$3(_classNames, "".concat(prefixCls, "-dot"), true), _defineProperty$3(_classNames, "".concat(prefixCls, "-dot-active"), isActived), _defineProperty$3(_classNames, "".concat(prefixCls, "-dot-reverse"), reverse), _classNames));
    return /*#__PURE__*/React__default['default'].createElement("span", {
      className: pointClassName,
      style: style,
      key: point
    });
  });
  return /*#__PURE__*/React__default['default'].createElement("div", {
    className: "".concat(prefixCls, "-step")
  }, elements);
};var Marks = function Marks(_ref) {
  var className = _ref.className,
      vertical = _ref.vertical,
      reverse = _ref.reverse,
      marks = _ref.marks,
      included = _ref.included,
      upperBound = _ref.upperBound,
      lowerBound = _ref.lowerBound,
      max = _ref.max,
      min = _ref.min,
      onClickLabel = _ref.onClickLabel;
  var marksKeys = Object.keys(marks);
  var range = max - min;
  var elements = marksKeys.map(parseFloat).sort(function (a, b) {
    return a - b;
  }).map(function (point) {
    var _classNames;

    var markPoint = marks[point];
    var markPointIsObject = _typeof$2(markPoint) === 'object' && ! /*#__PURE__*/React__default['default'].isValidElement(markPoint);
    var markLabel = markPointIsObject ? markPoint.label : markPoint;

    if (!markLabel && markLabel !== 0) {
      return null;
    }

    var isActive = !included && point === upperBound || included && point <= upperBound && point >= lowerBound;
    var markClassName = classNames((_classNames = {}, _defineProperty$3(_classNames, "".concat(className, "-text"), true), _defineProperty$3(_classNames, "".concat(className, "-text-active"), isActive), _classNames));

    var bottomStyle = _defineProperty$3({
      marginBottom: '-50%'
    }, reverse ? 'top' : 'bottom', "".concat((point - min) / range * 100, "%"));

    var leftStyle = _defineProperty$3({
      transform: "translateX(".concat(reverse ? "50%" : "-50%", ")"),
      msTransform: "translateX(".concat(reverse ? "50%" : "-50%", ")")
    }, reverse ? 'right' : 'left', "".concat((point - min) / range * 100, "%"));

    var style = vertical ? bottomStyle : leftStyle;
    var markStyle = markPointIsObject ? _objectSpread2$1(_objectSpread2$1({}, style), markPoint.style) : style;
    return /*#__PURE__*/React__default['default'].createElement("span", {
      className: markClassName,
      style: markStyle,
      key: point,
      onMouseDown: function onMouseDown(e) {
        return onClickLabel(e, point);
      },
      onTouchStart: function onTouchStart(e) {
        return onClickLabel(e, point);
      }
    }, markLabel);
  });
  return /*#__PURE__*/React__default['default'].createElement("div", {
    className: className
  }, elements);
};var Handle$1 = /*#__PURE__*/function (_React$Component) {
  _inherits$d(Handle, _React$Component);

  var _super = _createSuper(Handle);

  function Handle() {
    var _this;

    _classCallCheck$d(this, Handle);

    _this = _super.apply(this, arguments);
    _this.state = {
      clickFocused: false
    };

    _this.setHandleRef = function (node) {
      _this.handle = node;
    };

    _this.handleMouseUp = function () {
      if (document.activeElement === _this.handle) {
        _this.setClickFocus(true);
      }
    };

    _this.handleMouseDown = function (e) {
      // avoid selecting text during drag
      // https://github.com/ant-design/ant-design/issues/25010
      e.preventDefault(); // fix https://github.com/ant-design/ant-design/issues/15324

      _this.focus();
    };

    _this.handleBlur = function () {
      _this.setClickFocus(false);
    };

    _this.handleKeyDown = function () {
      _this.setClickFocus(false);
    };

    return _this;
  }

  _createClass$b(Handle, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      // mouseup won't trigger if mouse moved out of handle,
      // so we listen on document here.
      this.onMouseUpListener = addEventListenerWrap(document, 'mouseup', this.handleMouseUp);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.onMouseUpListener) {
        this.onMouseUpListener.remove();
      }
    }
  }, {
    key: "setClickFocus",
    value: function setClickFocus(focused) {
      this.setState({
        clickFocused: focused
      });
    }
  }, {
    key: "clickFocus",
    value: function clickFocus() {
      this.setClickFocus(true);
      this.focus();
    }
  }, {
    key: "focus",
    value: function focus() {
      this.handle.focus();
    }
  }, {
    key: "blur",
    value: function blur() {
      this.handle.blur();
    }
  }, {
    key: "render",
    value: function render() {
      var _ref, _ref2;

      var _this$props = this.props,
          prefixCls = _this$props.prefixCls,
          vertical = _this$props.vertical,
          reverse = _this$props.reverse,
          offset = _this$props.offset,
          style = _this$props.style,
          disabled = _this$props.disabled,
          min = _this$props.min,
          max = _this$props.max,
          value = _this$props.value,
          tabIndex = _this$props.tabIndex,
          ariaLabel = _this$props.ariaLabel,
          ariaLabelledBy = _this$props.ariaLabelledBy,
          ariaValueTextFormatter = _this$props.ariaValueTextFormatter,
          restProps = _objectWithoutProperties$4(_this$props, ["prefixCls", "vertical", "reverse", "offset", "style", "disabled", "min", "max", "value", "tabIndex", "ariaLabel", "ariaLabelledBy", "ariaValueTextFormatter"]);

      var className = classNames(this.props.className, _defineProperty$3({}, "".concat(prefixCls, "-handle-click-focused"), this.state.clickFocused));
      var positionStyle = vertical ? (_ref = {}, _defineProperty$3(_ref, reverse ? 'top' : 'bottom', "".concat(offset, "%")), _defineProperty$3(_ref, reverse ? 'bottom' : 'top', 'auto'), _defineProperty$3(_ref, "transform", reverse ? null : "translateY(+50%)"), _ref) : (_ref2 = {}, _defineProperty$3(_ref2, reverse ? 'right' : 'left', "".concat(offset, "%")), _defineProperty$3(_ref2, reverse ? 'left' : 'right', 'auto'), _defineProperty$3(_ref2, "transform", "translateX(".concat(reverse ? '+' : '-', "50%)")), _ref2);

      var elStyle = _objectSpread2$1(_objectSpread2$1({}, style), positionStyle);

      var mergedTabIndex = tabIndex || 0;

      if (disabled || tabIndex === null) {
        mergedTabIndex = null;
      }

      var ariaValueText;

      if (ariaValueTextFormatter) {
        ariaValueText = ariaValueTextFormatter(value);
      }

      return /*#__PURE__*/React__default['default'].createElement("div", _extends$f({
        ref: this.setHandleRef,
        tabIndex: mergedTabIndex
      }, restProps, {
        className: className,
        style: elStyle,
        onBlur: this.handleBlur,
        onKeyDown: this.handleKeyDown,
        onMouseDown: this.handleMouseDown // aria attribute
        ,
        role: "slider",
        "aria-valuemin": min,
        "aria-valuemax": max,
        "aria-valuenow": value,
        "aria-disabled": !!disabled,
        "aria-label": ariaLabel,
        "aria-labelledby": ariaLabelledBy,
        "aria-valuetext": ariaValueText
      }));
    }
  }]);

  return Handle;
}(React__default['default'].Component);/**
 * @ignore
 * some key-codes definition and utils from closure-library
 * @author yiminghe@gmail.com
 */
var KeyCode = {
  /**
   * MAC_ENTER
   */
  MAC_ENTER: 3,

  /**
   * BACKSPACE
   */
  BACKSPACE: 8,

  /**
   * TAB
   */
  TAB: 9,

  /**
   * NUMLOCK on FF/Safari Mac
   */
  NUM_CENTER: 12,

  /**
   * ENTER
   */
  ENTER: 13,

  /**
   * SHIFT
   */
  SHIFT: 16,

  /**
   * CTRL
   */
  CTRL: 17,

  /**
   * ALT
   */
  ALT: 18,

  /**
   * PAUSE
   */
  PAUSE: 19,

  /**
   * CAPS_LOCK
   */
  CAPS_LOCK: 20,

  /**
   * ESC
   */
  ESC: 27,

  /**
   * SPACE
   */
  SPACE: 32,

  /**
   * PAGE_UP
   */
  PAGE_UP: 33,

  /**
   * PAGE_DOWN
   */
  PAGE_DOWN: 34,

  /**
   * END
   */
  END: 35,

  /**
   * HOME
   */
  HOME: 36,

  /**
   * LEFT
   */
  LEFT: 37,

  /**
   * UP
   */
  UP: 38,

  /**
   * RIGHT
   */
  RIGHT: 39,

  /**
   * DOWN
   */
  DOWN: 40,

  /**
   * PRINT_SCREEN
   */
  PRINT_SCREEN: 44,

  /**
   * INSERT
   */
  INSERT: 45,

  /**
   * DELETE
   */
  DELETE: 46,

  /**
   * ZERO
   */
  ZERO: 48,

  /**
   * ONE
   */
  ONE: 49,

  /**
   * TWO
   */
  TWO: 50,

  /**
   * THREE
   */
  THREE: 51,

  /**
   * FOUR
   */
  FOUR: 52,

  /**
   * FIVE
   */
  FIVE: 53,

  /**
   * SIX
   */
  SIX: 54,

  /**
   * SEVEN
   */
  SEVEN: 55,

  /**
   * EIGHT
   */
  EIGHT: 56,

  /**
   * NINE
   */
  NINE: 57,

  /**
   * QUESTION_MARK
   */
  QUESTION_MARK: 63,

  /**
   * A
   */
  A: 65,

  /**
   * B
   */
  B: 66,

  /**
   * C
   */
  C: 67,

  /**
   * D
   */
  D: 68,

  /**
   * E
   */
  E: 69,

  /**
   * F
   */
  F: 70,

  /**
   * G
   */
  G: 71,

  /**
   * H
   */
  H: 72,

  /**
   * I
   */
  I: 73,

  /**
   * J
   */
  J: 74,

  /**
   * K
   */
  K: 75,

  /**
   * L
   */
  L: 76,

  /**
   * M
   */
  M: 77,

  /**
   * N
   */
  N: 78,

  /**
   * O
   */
  O: 79,

  /**
   * P
   */
  P: 80,

  /**
   * Q
   */
  Q: 81,

  /**
   * R
   */
  R: 82,

  /**
   * S
   */
  S: 83,

  /**
   * T
   */
  T: 84,

  /**
   * U
   */
  U: 85,

  /**
   * V
   */
  V: 86,

  /**
   * W
   */
  W: 87,

  /**
   * X
   */
  X: 88,

  /**
   * Y
   */
  Y: 89,

  /**
   * Z
   */
  Z: 90,

  /**
   * META
   */
  META: 91,

  /**
   * WIN_KEY_RIGHT
   */
  WIN_KEY_RIGHT: 92,

  /**
   * CONTEXT_MENU
   */
  CONTEXT_MENU: 93,

  /**
   * NUM_ZERO
   */
  NUM_ZERO: 96,

  /**
   * NUM_ONE
   */
  NUM_ONE: 97,

  /**
   * NUM_TWO
   */
  NUM_TWO: 98,

  /**
   * NUM_THREE
   */
  NUM_THREE: 99,

  /**
   * NUM_FOUR
   */
  NUM_FOUR: 100,

  /**
   * NUM_FIVE
   */
  NUM_FIVE: 101,

  /**
   * NUM_SIX
   */
  NUM_SIX: 102,

  /**
   * NUM_SEVEN
   */
  NUM_SEVEN: 103,

  /**
   * NUM_EIGHT
   */
  NUM_EIGHT: 104,

  /**
   * NUM_NINE
   */
  NUM_NINE: 105,

  /**
   * NUM_MULTIPLY
   */
  NUM_MULTIPLY: 106,

  /**
   * NUM_PLUS
   */
  NUM_PLUS: 107,

  /**
   * NUM_MINUS
   */
  NUM_MINUS: 109,

  /**
   * NUM_PERIOD
   */
  NUM_PERIOD: 110,

  /**
   * NUM_DIVISION
   */
  NUM_DIVISION: 111,

  /**
   * F1
   */
  F1: 112,

  /**
   * F2
   */
  F2: 113,

  /**
   * F3
   */
  F3: 114,

  /**
   * F4
   */
  F4: 115,

  /**
   * F5
   */
  F5: 116,

  /**
   * F6
   */
  F6: 117,

  /**
   * F7
   */
  F7: 118,

  /**
   * F8
   */
  F8: 119,

  /**
   * F9
   */
  F9: 120,

  /**
   * F10
   */
  F10: 121,

  /**
   * F11
   */
  F11: 122,

  /**
   * F12
   */
  F12: 123,

  /**
   * NUMLOCK
   */
  NUMLOCK: 144,

  /**
   * SEMICOLON
   */
  SEMICOLON: 186,

  /**
   * DASH
   */
  DASH: 189,

  /**
   * EQUALS
   */
  EQUALS: 187,

  /**
   * COMMA
   */
  COMMA: 188,

  /**
   * PERIOD
   */
  PERIOD: 190,

  /**
   * SLASH
   */
  SLASH: 191,

  /**
   * APOSTROPHE
   */
  APOSTROPHE: 192,

  /**
   * SINGLE_QUOTE
   */
  SINGLE_QUOTE: 222,

  /**
   * OPEN_SQUARE_BRACKET
   */
  OPEN_SQUARE_BRACKET: 219,

  /**
   * BACKSLASH
   */
  BACKSLASH: 220,

  /**
   * CLOSE_SQUARE_BRACKET
   */
  CLOSE_SQUARE_BRACKET: 221,

  /**
   * WIN_KEY
   */
  WIN_KEY: 224,

  /**
   * MAC_FF_META
   */
  MAC_FF_META: 224,

  /**
   * WIN_IME
   */
  WIN_IME: 229,
  // ======================== Function ========================

  /**
   * whether text and modified key is entered at the same time.
   */
  isTextModifyingKeyEvent: function isTextModifyingKeyEvent(e) {
    var keyCode = e.keyCode;

    if (e.altKey && !e.ctrlKey || e.metaKey || // Function keys don't generate text
    keyCode >= KeyCode.F1 && keyCode <= KeyCode.F12) {
      return false;
    } // The following keys are quite harmless, even in combination with
    // CTRL, ALT or SHIFT.


    switch (keyCode) {
      case KeyCode.ALT:
      case KeyCode.CAPS_LOCK:
      case KeyCode.CONTEXT_MENU:
      case KeyCode.CTRL:
      case KeyCode.DOWN:
      case KeyCode.END:
      case KeyCode.ESC:
      case KeyCode.HOME:
      case KeyCode.INSERT:
      case KeyCode.LEFT:
      case KeyCode.MAC_FF_META:
      case KeyCode.META:
      case KeyCode.NUMLOCK:
      case KeyCode.NUM_CENTER:
      case KeyCode.PAGE_DOWN:
      case KeyCode.PAGE_UP:
      case KeyCode.PAUSE:
      case KeyCode.PRINT_SCREEN:
      case KeyCode.RIGHT:
      case KeyCode.SHIFT:
      case KeyCode.UP:
      case KeyCode.WIN_KEY:
      case KeyCode.WIN_KEY_RIGHT:
        return false;

      default:
        return true;
    }
  },

  /**
   * whether character is entered.
   */
  isCharacterKey: function isCharacterKey(keyCode) {
    if (keyCode >= KeyCode.ZERO && keyCode <= KeyCode.NINE) {
      return true;
    }

    if (keyCode >= KeyCode.NUM_ZERO && keyCode <= KeyCode.NUM_MULTIPLY) {
      return true;
    }

    if (keyCode >= KeyCode.A && keyCode <= KeyCode.Z) {
      return true;
    } // Safari sends zero key code for non-latin characters.


    if (window.navigator.userAgent.indexOf('WebKit') !== -1 && keyCode === 0) {
      return true;
    }

    switch (keyCode) {
      case KeyCode.SPACE:
      case KeyCode.QUESTION_MARK:
      case KeyCode.NUM_PLUS:
      case KeyCode.NUM_MINUS:
      case KeyCode.NUM_PERIOD:
      case KeyCode.NUM_DIVISION:
      case KeyCode.SEMICOLON:
      case KeyCode.DASH:
      case KeyCode.EQUALS:
      case KeyCode.COMMA:
      case KeyCode.PERIOD:
      case KeyCode.SLASH:
      case KeyCode.APOSTROPHE:
      case KeyCode.SINGLE_QUOTE:
      case KeyCode.OPEN_SQUARE_BRACKET:
      case KeyCode.BACKSLASH:
      case KeyCode.CLOSE_SQUARE_BRACKET:
        return true;

      default:
        return false;
    }
  }
};function isEventFromHandle(e, handles) {
  try {
    return Object.keys(handles).some(function (key) {
      return e.target === ReactDOM.findDOMNode(handles[key]);
    });
  } catch (error) {
    return false;
  }
}
function isValueOutOfRange(value, _ref) {
  var min = _ref.min,
      max = _ref.max;
  return value < min || value > max;
}
function isNotTouchEvent(e) {
  return e.touches.length > 1 || e.type.toLowerCase() === 'touchend' && e.touches.length > 0;
}
function getClosestPoint(val, _ref2) {
  var marks = _ref2.marks,
      step = _ref2.step,
      min = _ref2.min,
      max = _ref2.max;
  var points = Object.keys(marks).map(parseFloat);

  if (step !== null) {
    var baseNum = Math.pow(10, getPrecision(step));
    var maxSteps = Math.floor((max * baseNum - min * baseNum) / (step * baseNum));
    var steps = Math.min((val - min) / step, maxSteps);
    var closestStep = Math.round(steps) * step + min;
    points.push(closestStep);
  }

  var diffs = points.map(function (point) {
    return Math.abs(val - point);
  });
  return points[diffs.indexOf(Math.min.apply(Math, _toConsumableArray(diffs)))];
}
function getPrecision(step) {
  var stepString = step.toString();
  var precision = 0;

  if (stepString.indexOf('.') >= 0) {
    precision = stepString.length - stepString.indexOf('.') - 1;
  }

  return precision;
}
function getMousePosition(vertical, e) {
  return vertical ? e.clientY : e.pageX;
}
function getTouchPosition(vertical, e) {
  return vertical ? e.touches[0].clientY : e.touches[0].pageX;
}
function getHandleCenterPosition(vertical, handle) {
  var coords = handle.getBoundingClientRect();
  return vertical ? coords.top + coords.height * 0.5 : window.pageXOffset + coords.left + coords.width * 0.5;
}
function ensureValueInRange(val, _ref3) {
  var max = _ref3.max,
      min = _ref3.min;

  if (val <= min) {
    return min;
  }

  if (val >= max) {
    return max;
  }

  return val;
}
function ensureValuePrecision(val, props) {
  var step = props.step;
  var closestPoint = isFinite(getClosestPoint(val, props)) ? getClosestPoint(val, props) : 0; // eslint-disable-line

  return step === null ? closestPoint : parseFloat(closestPoint.toFixed(getPrecision(step)));
}
function pauseEvent(e) {
  e.stopPropagation();
  e.preventDefault();
}
function calculateNextValue(func, value, props) {
  var operations = {
    increase: function increase(a, b) {
      return a + b;
    },
    decrease: function decrease(a, b) {
      return a - b;
    }
  };
  var indexToGet = operations[func](Object.keys(props.marks).indexOf(JSON.stringify(value)), 1);
  var keyToGet = Object.keys(props.marks)[indexToGet];

  if (props.step) {
    return operations[func](value, props.step);
  }

  if (!!Object.keys(props.marks).length && !!props.marks[keyToGet]) {
    return props.marks[keyToGet];
  }

  return value;
}
function getKeyboardValueMutator(e, vertical, reverse) {
  var increase = 'increase';
  var decrease = 'decrease';
  var method = increase;

  switch (e.keyCode) {
    case KeyCode.UP:
      method = vertical && reverse ? decrease : increase;
      break;

    case KeyCode.RIGHT:
      method = !vertical && reverse ? decrease : increase;
      break;

    case KeyCode.DOWN:
      method = vertical && reverse ? increase : decrease;
      break;

    case KeyCode.LEFT:
      method = !vertical && reverse ? increase : decrease;
      break;

    case KeyCode.END:
      return function (value, props) {
        return props.max;
      };

    case KeyCode.HOME:
      return function (value, props) {
        return props.min;
      };

    case KeyCode.PAGE_UP:
      return function (value, props) {
        return value + props.step * 2;
      };

    case KeyCode.PAGE_DOWN:
      return function (value, props) {
        return value - props.step * 2;
      };

    default:
      return undefined;
  }

  return function (value, props) {
    return calculateNextValue(method, value, props);
  };
}/* eslint-disable @typescript-eslint/no-explicit-any */

function noop$3() {}

function createSlider(Component) {
  var _a; // eslint-disable-next-line @typescript-eslint/no-unused-vars


  return _a = /*#__PURE__*/function (_Component) {
    _inherits$d(ComponentEnhancer, _Component);

    var _super = _createSuper(ComponentEnhancer);

    function ComponentEnhancer(props) {
      var _this;

      _classCallCheck$d(this, ComponentEnhancer);

      _this = _super.call(this, props);

      _this.onDown = function (e, position) {
        var p = position;
        var _this$props = _this.props,
            draggableTrack = _this$props.draggableTrack,
            isVertical = _this$props.vertical;
        var bounds = _this.state.bounds;
        var value = draggableTrack && _this.positionGetValue ? _this.positionGetValue(p) || [] : [];
        var inPoint = isEventFromHandle(e, _this.handlesRefs);
        _this.dragTrack = draggableTrack && bounds.length >= 2 && !inPoint && !value.map(function (n, i) {
          var v = !i ? n >= bounds[i] : true;
          return i === value.length - 1 ? n <= bounds[i] : v;
        }).some(function (c) {
          return !c;
        });

        if (_this.dragTrack) {
          _this.dragOffset = p;
          _this.startBounds = _toConsumableArray(bounds);
        } else {
          if (!inPoint) {
            _this.dragOffset = 0;
          } else {
            var handlePosition = getHandleCenterPosition(isVertical, e.target);
            _this.dragOffset = p - handlePosition;
            p = handlePosition;
          }

          _this.onStart(p);
        }
      };

      _this.onMouseDown = function (e) {
        if (e.button !== 0) {
          return;
        }

        _this.removeDocumentEvents();

        var isVertical = _this.props.vertical;
        var position = getMousePosition(isVertical, e);

        _this.onDown(e, position);

        _this.addDocumentMouseEvents();
      };

      _this.onTouchStart = function (e) {
        if (isNotTouchEvent(e)) return;
        var isVertical = _this.props.vertical;
        var position = getTouchPosition(isVertical, e);

        _this.onDown(e, position);

        _this.addDocumentTouchEvents();

        pauseEvent(e);
      };

      _this.onFocus = function (e) {
        var _this$props2 = _this.props,
            onFocus = _this$props2.onFocus,
            vertical = _this$props2.vertical;

        if (isEventFromHandle(e, _this.handlesRefs) && !_this.dragTrack) {
          var handlePosition = getHandleCenterPosition(vertical, e.target);
          _this.dragOffset = 0;

          _this.onStart(handlePosition);

          pauseEvent(e);

          if (onFocus) {
            onFocus(e);
          }
        }
      };

      _this.onBlur = function (e) {
        var onBlur = _this.props.onBlur;

        if (!_this.dragTrack) {
          _this.onEnd();
        }

        if (onBlur) {
          onBlur(e);
        }
      };

      _this.onMouseUp = function () {
        if (_this.handlesRefs[_this.prevMovedHandleIndex]) {
          _this.handlesRefs[_this.prevMovedHandleIndex].clickFocus();
        }
      };

      _this.onMouseMove = function (e) {
        if (!_this.sliderRef) {
          _this.onEnd();

          return;
        }

        var position = getMousePosition(_this.props.vertical, e);

        _this.onMove(e, position - _this.dragOffset, _this.dragTrack, _this.startBounds);
      };

      _this.onTouchMove = function (e) {
        if (isNotTouchEvent(e) || !_this.sliderRef) {
          _this.onEnd();

          return;
        }

        var position = getTouchPosition(_this.props.vertical, e);

        _this.onMove(e, position - _this.dragOffset, _this.dragTrack, _this.startBounds);
      };

      _this.onKeyDown = function (e) {
        if (_this.sliderRef && isEventFromHandle(e, _this.handlesRefs)) {
          _this.onKeyboard(e);
        }
      };

      _this.onClickMarkLabel = function (e, value) {
        e.stopPropagation();

        _this.onChange({
          value: value
        }); // eslint-disable-next-line react/no-unused-state


        _this.setState({
          value: value
        }, function () {
          return _this.onEnd(true);
        });
      };

      _this.saveSlider = function (slider) {
        _this.sliderRef = slider;
      };

      var step = props.step,
          max = props.max,
          min = props.min;
      var isPointDiffEven = isFinite(max - min) ? (max - min) % step === 0 : true; // eslint-disable-line

      warningOnce(step && Math.floor(step) === step ? isPointDiffEven : true, "Slider[max] - Slider[min] (".concat(max - min, ") should be a multiple of Slider[step] (").concat(step, ")"));
      _this.handlesRefs = {};
      return _this;
    }

    _createClass$b(ComponentEnhancer, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        // Snapshot testing cannot handle refs, so be sure to null-check this.
        this.document = this.sliderRef && this.sliderRef.ownerDocument;
        var _this$props3 = this.props,
            autoFocus = _this$props3.autoFocus,
            disabled = _this$props3.disabled;

        if (autoFocus && !disabled) {
          this.focus();
        }
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        if (_get(_getPrototypeOf(ComponentEnhancer.prototype), "componentWillUnmount", this)) _get(_getPrototypeOf(ComponentEnhancer.prototype), "componentWillUnmount", this).call(this);
        this.removeDocumentEvents();
      }
    }, {
      key: "getSliderStart",
      value: function getSliderStart() {
        var slider = this.sliderRef;
        var _this$props4 = this.props,
            vertical = _this$props4.vertical,
            reverse = _this$props4.reverse;
        var rect = slider.getBoundingClientRect();

        if (vertical) {
          return reverse ? rect.bottom : rect.top;
        }

        return window.pageXOffset + (reverse ? rect.right : rect.left);
      }
    }, {
      key: "getSliderLength",
      value: function getSliderLength() {
        var slider = this.sliderRef;

        if (!slider) {
          return 0;
        }

        var coords = slider.getBoundingClientRect();
        return this.props.vertical ? coords.height : coords.width;
      }
    }, {
      key: "addDocumentTouchEvents",
      value: function addDocumentTouchEvents() {
        // just work for Chrome iOS Safari and Android Browser
        this.onTouchMoveListener = addEventListenerWrap(this.document, 'touchmove', this.onTouchMove);
        this.onTouchUpListener = addEventListenerWrap(this.document, 'touchend', this.onEnd);
      }
    }, {
      key: "addDocumentMouseEvents",
      value: function addDocumentMouseEvents() {
        this.onMouseMoveListener = addEventListenerWrap(this.document, 'mousemove', this.onMouseMove);
        this.onMouseUpListener = addEventListenerWrap(this.document, 'mouseup', this.onEnd);
      }
    }, {
      key: "removeDocumentEvents",
      value: function removeDocumentEvents() {
        /* eslint-disable @typescript-eslint/no-unused-expressions */
        this.onTouchMoveListener && this.onTouchMoveListener.remove();
        this.onTouchUpListener && this.onTouchUpListener.remove();
        this.onMouseMoveListener && this.onMouseMoveListener.remove();
        this.onMouseUpListener && this.onMouseUpListener.remove();
        /* eslint-enable no-unused-expressions */
      }
    }, {
      key: "focus",
      value: function focus() {
        var _this$handlesRefs$;

        if (this.props.disabled) {
          return;
        }

        (_this$handlesRefs$ = this.handlesRefs[0]) === null || _this$handlesRefs$ === void 0 ? void 0 : _this$handlesRefs$.focus();
      }
    }, {
      key: "blur",
      value: function blur() {
        var _this2 = this;

        if (this.props.disabled) {
          return;
        }

        Object.keys(this.handlesRefs).forEach(function (key) {
          var _this2$handlesRefs$ke, _this2$handlesRefs$ke2;

          (_this2$handlesRefs$ke = _this2.handlesRefs[key]) === null || _this2$handlesRefs$ke === void 0 ? void 0 : (_this2$handlesRefs$ke2 = _this2$handlesRefs$ke.blur) === null || _this2$handlesRefs$ke2 === void 0 ? void 0 : _this2$handlesRefs$ke2.call(_this2$handlesRefs$ke);
        });
      }
    }, {
      key: "calcValue",
      value: function calcValue(offset) {
        var _this$props5 = this.props,
            vertical = _this$props5.vertical,
            min = _this$props5.min,
            max = _this$props5.max;
        var ratio = Math.abs(Math.max(offset, 0) / this.getSliderLength());
        var value = vertical ? (1 - ratio) * (max - min) + min : ratio * (max - min) + min;
        return value;
      }
    }, {
      key: "calcValueByPos",
      value: function calcValueByPos(position) {
        var sign = this.props.reverse ? -1 : +1;
        var pixelOffset = sign * (position - this.getSliderStart());
        var nextValue = this.trimAlignValue(this.calcValue(pixelOffset));
        return nextValue;
      }
    }, {
      key: "calcOffset",
      value: function calcOffset(value) {
        var _this$props6 = this.props,
            min = _this$props6.min,
            max = _this$props6.max;
        var ratio = (value - min) / (max - min);
        return Math.max(0, ratio * 100);
      }
    }, {
      key: "saveHandle",
      value: function saveHandle(index, handle) {
        this.handlesRefs[index] = handle;
      }
    }, {
      key: "render",
      value: function render() {
        var _classNames;

        var _this$props7 = this.props,
            prefixCls = _this$props7.prefixCls,
            className = _this$props7.className,
            marks = _this$props7.marks,
            dots = _this$props7.dots,
            step = _this$props7.step,
            included = _this$props7.included,
            disabled = _this$props7.disabled,
            vertical = _this$props7.vertical,
            reverse = _this$props7.reverse,
            min = _this$props7.min,
            max = _this$props7.max,
            children = _this$props7.children,
            maximumTrackStyle = _this$props7.maximumTrackStyle,
            style = _this$props7.style,
            railStyle = _this$props7.railStyle,
            dotStyle = _this$props7.dotStyle,
            activeDotStyle = _this$props7.activeDotStyle;

        var _get$call = _get(_getPrototypeOf(ComponentEnhancer.prototype), "render", this).call(this),
            tracks = _get$call.tracks,
            handles = _get$call.handles;

        var sliderClassName = classNames(prefixCls, (_classNames = {}, _defineProperty$3(_classNames, "".concat(prefixCls, "-with-marks"), Object.keys(marks).length), _defineProperty$3(_classNames, "".concat(prefixCls, "-disabled"), disabled), _defineProperty$3(_classNames, "".concat(prefixCls, "-vertical"), vertical), _defineProperty$3(_classNames, className, className), _classNames));
        return /*#__PURE__*/React__default['default'].createElement("div", {
          ref: this.saveSlider,
          className: sliderClassName,
          onTouchStart: disabled ? noop$3 : this.onTouchStart,
          onMouseDown: disabled ? noop$3 : this.onMouseDown,
          onMouseUp: disabled ? noop$3 : this.onMouseUp,
          onKeyDown: disabled ? noop$3 : this.onKeyDown,
          onFocus: disabled ? noop$3 : this.onFocus,
          onBlur: disabled ? noop$3 : this.onBlur,
          style: style
        }, /*#__PURE__*/React__default['default'].createElement("div", {
          className: "".concat(prefixCls, "-rail"),
          style: _objectSpread2$1(_objectSpread2$1({}, maximumTrackStyle), railStyle)
        }), tracks, /*#__PURE__*/React__default['default'].createElement(Steps, {
          prefixCls: prefixCls,
          vertical: vertical,
          reverse: reverse,
          marks: marks,
          dots: dots,
          step: step,
          included: included,
          lowerBound: this.getLowerBound(),
          upperBound: this.getUpperBound(),
          max: max,
          min: min,
          dotStyle: dotStyle,
          activeDotStyle: activeDotStyle
        }), handles, /*#__PURE__*/React__default['default'].createElement(Marks, {
          className: "".concat(prefixCls, "-mark"),
          onClickLabel: disabled ? noop$3 : this.onClickMarkLabel,
          vertical: vertical,
          marks: marks,
          included: included,
          lowerBound: this.getLowerBound(),
          upperBound: this.getUpperBound(),
          max: max,
          min: min,
          reverse: reverse
        }), children);
      }
    }]);

    return ComponentEnhancer;
  }(Component), _a.displayName = "ComponentEnhancer(".concat(Component.displayName, ")"), _a.defaultProps = _objectSpread2$1(_objectSpread2$1({}, Component.defaultProps), {}, {
    prefixCls: 'rc-slider',
    className: '',
    min: 0,
    max: 100,
    step: 1,
    marks: {},
    handle: function handle(props) {
      var index = props.index,
          restProps = _objectWithoutProperties$4(props, ["index"]);

      delete restProps.dragging;

      if (restProps.value === null) {
        return null;
      }

      return /*#__PURE__*/React__default['default'].createElement(Handle$1, _extends$f({}, restProps, {
        key: index
      }));
    },
    onBeforeChange: noop$3,
    onChange: noop$3,
    onAfterChange: noop$3,
    included: true,
    disabled: false,
    dots: false,
    vertical: false,
    reverse: false,
    trackStyle: [{}],
    handleStyle: [{}],
    railStyle: {},
    dotStyle: {},
    activeDotStyle: {}
  }), _a;
}var Slider = /*#__PURE__*/function (_React$Component) {
  _inherits$d(Slider, _React$Component);

  var _super = _createSuper(Slider);

  /* eslint-enable */
  function Slider(props) {
    var _this;

    _classCallCheck$d(this, Slider);

    _this = _super.call(this, props);

    _this.positionGetValue = function (position) {
      return [];
    };

    _this.onEnd = function (force) {
      var dragging = _this.state.dragging;

      _this.removeDocumentEvents();

      if (dragging || force) {
        _this.props.onAfterChange(_this.getValue());
      }

      _this.setState({
        dragging: false
      });
    };

    var defaultValue = props.defaultValue !== undefined ? props.defaultValue : props.min;
    var value = props.value !== undefined ? props.value : defaultValue;
    _this.state = {
      value: _this.trimAlignValue(value),
      dragging: false
    };
    warningOnce(!('minimumTrackStyle' in props), 'minimumTrackStyle will be deprecated, please use trackStyle instead.');
    warningOnce(!('maximumTrackStyle' in props), 'maximumTrackStyle will be deprecated, please use railStyle instead.');
    return _this;
  }
  /**
   * [Legacy] Used for inherit other component.
   * It's a bad code style which should be refactor.
   */

  /* eslint-disable @typescript-eslint/no-unused-vars, class-methods-use-this */


  _createClass$b(Slider, [{
    key: "calcValueByPos",
    value: function calcValueByPos(value) {
      return 0;
    }
  }, {
    key: "calcOffset",
    value: function calcOffset(value) {
      return 0;
    }
  }, {
    key: "saveHandle",
    value: function saveHandle(index, h) {}
  }, {
    key: "removeDocumentEvents",
    value: function removeDocumentEvents() {}
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      var _this$props = this.props,
          min = _this$props.min,
          max = _this$props.max,
          value = _this$props.value,
          onChange = _this$props.onChange;

      if (!('min' in this.props || 'max' in this.props)) {
        return;
      }

      var theValue = value !== undefined ? value : prevState.value;
      var nextValue = this.trimAlignValue(theValue, this.props);

      if (nextValue === prevState.value) {
        return;
      } // eslint-disable-next-line


      this.setState({
        value: nextValue
      });

      if (!(min === prevProps.min && max === prevProps.max) && isValueOutOfRange(theValue, this.props)) {
        onChange(nextValue);
      }
    }
  }, {
    key: "onChange",
    value: function onChange(state) {
      var props = this.props;
      var isNotControlled = !('value' in props);
      var nextState = state.value > this.props.max ? _objectSpread2$1(_objectSpread2$1({}, state), {}, {
        value: this.props.max
      }) : state;

      if (isNotControlled) {
        this.setState(nextState);
      }

      var changedValue = nextState.value;
      props.onChange(changedValue);
    }
  }, {
    key: "onStart",
    value: function onStart(position) {
      this.setState({
        dragging: true
      });
      var props = this.props;
      var prevValue = this.getValue();
      props.onBeforeChange(prevValue);
      var value = this.calcValueByPos(position);
      this.startValue = value;
      this.startPosition = position;
      if (value === prevValue) return;
      this.prevMovedHandleIndex = 0;
      this.onChange({
        value: value
      });
    }
  }, {
    key: "onMove",
    value: function onMove(e, position) {
      pauseEvent(e);
      var oldValue = this.state.value;
      var value = this.calcValueByPos(position);
      if (value === oldValue) return;
      this.onChange({
        value: value
      });
    }
  }, {
    key: "onKeyboard",
    value: function onKeyboard(e) {
      var _this$props2 = this.props,
          reverse = _this$props2.reverse,
          vertical = _this$props2.vertical;
      var valueMutator = getKeyboardValueMutator(e, vertical, reverse);

      if (valueMutator) {
        pauseEvent(e);
        var state = this.state;
        var oldValue = state.value;
        var mutatedValue = valueMutator(oldValue, this.props);
        var value = this.trimAlignValue(mutatedValue);
        if (value === oldValue) return;
        this.onChange({
          value: value
        });
        this.props.onAfterChange(value);
        this.onEnd();
      }
    }
  }, {
    key: "getValue",
    value: function getValue() {
      return this.state.value;
    }
  }, {
    key: "getLowerBound",
    value: function getLowerBound() {
      var minPoint = this.props.startPoint || this.props.min;
      return this.state.value > minPoint ? minPoint : this.state.value;
    }
  }, {
    key: "getUpperBound",
    value: function getUpperBound() {
      if (this.state.value < this.props.startPoint) {
        return this.props.startPoint;
      }

      return this.state.value;
    }
  }, {
    key: "trimAlignValue",
    value: function trimAlignValue(v) {
      var nextProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      if (v === null) {
        return null;
      }

      var mergedProps = _objectSpread2$1(_objectSpread2$1({}, this.props), nextProps);

      var val = ensureValueInRange(v, mergedProps);
      return ensureValuePrecision(val, mergedProps);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props3 = this.props,
          prefixCls = _this$props3.prefixCls,
          vertical = _this$props3.vertical,
          included = _this$props3.included,
          disabled = _this$props3.disabled,
          minimumTrackStyle = _this$props3.minimumTrackStyle,
          trackStyle = _this$props3.trackStyle,
          handleStyle = _this$props3.handleStyle,
          tabIndex = _this$props3.tabIndex,
          ariaLabelForHandle = _this$props3.ariaLabelForHandle,
          ariaLabelledByForHandle = _this$props3.ariaLabelledByForHandle,
          ariaValueTextFormatterForHandle = _this$props3.ariaValueTextFormatterForHandle,
          min = _this$props3.min,
          max = _this$props3.max,
          startPoint = _this$props3.startPoint,
          reverse = _this$props3.reverse,
          handleGenerator = _this$props3.handle;
      var _this$state = this.state,
          value = _this$state.value,
          dragging = _this$state.dragging;
      var offset = this.calcOffset(value);
      var handle = handleGenerator({
        className: "".concat(prefixCls, "-handle"),
        prefixCls: prefixCls,
        vertical: vertical,
        offset: offset,
        value: value,
        dragging: dragging,
        disabled: disabled,
        min: min,
        max: max,
        reverse: reverse,
        index: 0,
        tabIndex: tabIndex,
        ariaLabel: ariaLabelForHandle,
        ariaLabelledBy: ariaLabelledByForHandle,
        ariaValueTextFormatter: ariaValueTextFormatterForHandle,
        style: handleStyle[0] || handleStyle,
        ref: function ref(h) {
          return _this2.saveHandle(0, h);
        }
      });
      var trackOffset = startPoint !== undefined ? this.calcOffset(startPoint) : 0;
      var mergedTrackStyle = trackStyle[0] || trackStyle;
      var track = /*#__PURE__*/React__default['default'].createElement(Track, {
        className: "".concat(prefixCls, "-track"),
        vertical: vertical,
        included: included,
        offset: trackOffset,
        reverse: reverse,
        length: offset - trackOffset,
        style: _objectSpread2$1(_objectSpread2$1({}, minimumTrackStyle), mergedTrackStyle)
      });
      return {
        tracks: track,
        handles: handle
      };
    }
  }]);

  return Slider;
}(React__default['default'].Component);

var Slider$1 = createSlider(Slider);var _trimAlignValue = function trimAlignValue(_ref) {
  var value = _ref.value,
      handle = _ref.handle,
      bounds = _ref.bounds,
      props = _ref.props;
  var allowCross = props.allowCross,
      pushable = props.pushable;
  var thershold = Number(pushable);
  var valInRange = ensureValueInRange(value, props);
  var valNotConflict = valInRange;

  if (!allowCross && handle != null && bounds !== undefined) {
    if (handle > 0 && valInRange <= bounds[handle - 1] + thershold) {
      valNotConflict = bounds[handle - 1] + thershold;
    }

    if (handle < bounds.length - 1 && valInRange >= bounds[handle + 1] - thershold) {
      valNotConflict = bounds[handle + 1] - thershold;
    }
  }

  return ensureValuePrecision(valNotConflict, props);
};

var Range$1 = /*#__PURE__*/function (_React$Component) {
  _inherits$d(Range, _React$Component);

  var _super = _createSuper(Range);

  function Range(props) {
    var _this;

    _classCallCheck$d(this, Range);

    _this = _super.call(this, props);

    _this.positionGetValue = function (position) {
      var bounds = _this.getValue();

      var value = _this.calcValueByPos(position);

      var closestBound = _this.getClosestBound(value);

      var index = _this.getBoundNeedMoving(value, closestBound);

      var prevValue = bounds[index];
      if (value === prevValue) return null;

      var nextBounds = _toConsumableArray(bounds);

      nextBounds[index] = value;
      return nextBounds;
    };

    _this.onEnd = function (force) {
      var handle = _this.state.handle;

      _this.removeDocumentEvents();

      if (!handle) {
        _this.dragTrack = false;
      }

      if (handle !== null || force) {
        _this.props.onAfterChange(_this.getValue());
      }

      _this.setState({
        handle: null
      });
    };

    var count = props.count,
        min = props.min,
        max = props.max;
    var initialValue = Array.apply(void 0, _toConsumableArray(Array(count + 1))).map(function () {
      return min;
    });
    var defaultValue = 'defaultValue' in props ? props.defaultValue : initialValue;
    var value = props.value !== undefined ? props.value : defaultValue;
    var bounds = value.map(function (v, i) {
      return _trimAlignValue({
        value: v,
        handle: i,
        props: props
      });
    });
    var recent = bounds[0] === max ? 0 : bounds.length - 1;
    _this.state = {
      handle: null,
      recent: recent,
      bounds: bounds
    };
    return _this;
  }
  /**
   * [Legacy] Used for inherit other component.
   * It's a bad code style which should be refactor.
   */

  /* eslint-disable @typescript-eslint/no-unused-vars, class-methods-use-this */


  _createClass$b(Range, [{
    key: "calcValueByPos",
    value: function calcValueByPos(value) {
      return 0;
    }
  }, {
    key: "getSliderLength",
    value: function getSliderLength() {
      return 0;
    }
  }, {
    key: "calcOffset",
    value: function calcOffset(value) {
      return 0;
    }
  }, {
    key: "saveHandle",
    value: function saveHandle(index, h) {}
  }, {
    key: "removeDocumentEvents",
    value: function removeDocumentEvents() {}
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      var _this2 = this;

      var _this$props = this.props,
          onChange = _this$props.onChange,
          value = _this$props.value,
          min = _this$props.min,
          max = _this$props.max;

      if (!('min' in this.props || 'max' in this.props)) {
        return;
      }

      if (min === prevProps.min && max === prevProps.max) {
        return;
      }

      var currentValue = value || prevState.bounds;

      if (currentValue.some(function (v) {
        return isValueOutOfRange(v, _this2.props);
      })) {
        var newValues = currentValue.map(function (v) {
          return ensureValueInRange(v, _this2.props);
        });
        onChange(newValues);
      }
    }
  }, {
    key: "onChange",
    value: function onChange(state) {
      var props = this.props;
      var isNotControlled = !('value' in props);

      if (isNotControlled) {
        this.setState(state);
      } else {
        var controlledState = {};
        ['handle', 'recent'].forEach(function (item) {
          if (state[item] !== undefined) {
            controlledState[item] = state[item];
          }
        });

        if (Object.keys(controlledState).length) {
          this.setState(controlledState);
        }
      }

      var data = _objectSpread2$1(_objectSpread2$1({}, this.state), state);

      var changedValue = data.bounds;
      props.onChange(changedValue);
    }
  }, {
    key: "onStart",
    value: function onStart(position) {
      var props = this.props,
          state = this.state;
      var bounds = this.getValue();
      props.onBeforeChange(bounds);
      var value = this.calcValueByPos(position);
      this.startValue = value;
      this.startPosition = position;
      var closestBound = this.getClosestBound(value);
      this.prevMovedHandleIndex = this.getBoundNeedMoving(value, closestBound);
      this.setState({
        handle: this.prevMovedHandleIndex,
        recent: this.prevMovedHandleIndex
      });
      var prevValue = bounds[this.prevMovedHandleIndex];
      if (value === prevValue) return;

      var nextBounds = _toConsumableArray(state.bounds);

      nextBounds[this.prevMovedHandleIndex] = value;
      this.onChange({
        bounds: nextBounds
      });
    }
  }, {
    key: "onMove",
    value: function onMove(e, position, dragTrack, startBounds) {
      pauseEvent(e);
      var state = this.state,
          props = this.props;
      var maxValue = props.max || 100;
      var minValue = props.min || 0;

      if (dragTrack) {
        var pos = props.vertical ? -position : position;
        pos = props.reverse ? -pos : pos;
        var max = maxValue - Math.max.apply(Math, _toConsumableArray(startBounds));
        var min = minValue - Math.min.apply(Math, _toConsumableArray(startBounds));
        var ratio = Math.min(Math.max(pos / (this.getSliderLength() / 100), min), max);
        var nextBounds = startBounds.map(function (v) {
          return Math.floor(Math.max(Math.min(v + ratio, maxValue), minValue));
        });

        if (state.bounds.map(function (c, i) {
          return c === nextBounds[i];
        }).some(function (c) {
          return !c;
        })) {
          this.onChange({
            bounds: nextBounds
          });
        }

        return;
      }

      var value = this.calcValueByPos(position);
      var oldValue = state.bounds[state.handle];
      if (value === oldValue) return;
      this.moveTo(value);
    }
  }, {
    key: "onKeyboard",
    value: function onKeyboard(e) {
      var _this$props2 = this.props,
          reverse = _this$props2.reverse,
          vertical = _this$props2.vertical;
      var valueMutator = getKeyboardValueMutator(e, vertical, reverse);

      if (valueMutator) {
        pauseEvent(e);
        var state = this.state,
            props = this.props;
        var bounds = state.bounds,
            handle = state.handle;
        var oldValue = bounds[handle === null ? state.recent : handle];
        var mutatedValue = valueMutator(oldValue, props);

        var value = _trimAlignValue({
          value: mutatedValue,
          handle: handle,
          bounds: state.bounds,
          props: props
        });

        if (value === oldValue) return;
        var isFromKeyboardEvent = true;
        this.moveTo(value, isFromKeyboardEvent);
      }
    }
  }, {
    key: "getValue",
    value: function getValue() {
      return this.state.bounds;
    }
  }, {
    key: "getClosestBound",
    value: function getClosestBound(value) {
      var bounds = this.state.bounds;
      var closestBound = 0;

      for (var i = 1; i < bounds.length - 1; i += 1) {
        if (value >= bounds[i]) {
          closestBound = i;
        }
      }

      if (Math.abs(bounds[closestBound + 1] - value) < Math.abs(bounds[closestBound] - value)) {
        closestBound += 1;
      }

      return closestBound;
    }
  }, {
    key: "getBoundNeedMoving",
    value: function getBoundNeedMoving(value, closestBound) {
      var _this$state = this.state,
          bounds = _this$state.bounds,
          recent = _this$state.recent;
      var boundNeedMoving = closestBound;
      var isAtTheSamePoint = bounds[closestBound + 1] === bounds[closestBound];

      if (isAtTheSamePoint && bounds[recent] === bounds[closestBound]) {
        boundNeedMoving = recent;
      }

      if (isAtTheSamePoint && value !== bounds[closestBound + 1]) {
        boundNeedMoving = value < bounds[closestBound + 1] ? closestBound : closestBound + 1;
      }

      return boundNeedMoving;
    }
  }, {
    key: "getLowerBound",
    value: function getLowerBound() {
      return this.state.bounds[0];
    }
  }, {
    key: "getUpperBound",
    value: function getUpperBound() {
      var bounds = this.state.bounds;
      return bounds[bounds.length - 1];
    }
    /**
     * Returns an array of possible slider points, taking into account both
     * `marks` and `step`. The result is cached.
     */

  }, {
    key: "getPoints",
    value: function getPoints() {
      var _this$props3 = this.props,
          marks = _this$props3.marks,
          step = _this$props3.step,
          min = _this$props3.min,
          max = _this$props3.max;
      var cache = this.internalPointsCache;

      if (!cache || cache.marks !== marks || cache.step !== step) {
        var pointsObject = _objectSpread2$1({}, marks);

        if (step !== null) {
          for (var point = min; point <= max; point += step) {
            pointsObject[point] = point;
          }
        }

        var points = Object.keys(pointsObject).map(parseFloat);
        points.sort(function (a, b) {
          return a - b;
        });
        this.internalPointsCache = {
          marks: marks,
          step: step,
          points: points
        };
      }

      return this.internalPointsCache.points;
    }
  }, {
    key: "moveTo",
    value: function moveTo(value, isFromKeyboardEvent) {
      var _this3 = this;

      var state = this.state,
          props = this.props;

      var nextBounds = _toConsumableArray(state.bounds);

      var handle = state.handle === null ? state.recent : state.handle;
      nextBounds[handle] = value;
      var nextHandle = handle;

      if (props.pushable !== false) {
        this.pushSurroundingHandles(nextBounds, nextHandle);
      } else if (props.allowCross) {
        nextBounds.sort(function (a, b) {
          return a - b;
        });
        nextHandle = nextBounds.indexOf(value);
      }

      this.onChange({
        recent: nextHandle,
        handle: nextHandle,
        bounds: nextBounds
      });

      if (isFromKeyboardEvent) {
        // known problem: because setState is async,
        // so trigger focus will invoke handler's onEnd and another handler's onStart too early,
        // cause onBeforeChange and onAfterChange receive wrong value.
        // here use setState callback to hack，but not elegant
        this.props.onAfterChange(nextBounds);
        this.setState({}, function () {
          _this3.handlesRefs[nextHandle].focus();
        });
        this.onEnd();
      }
    }
  }, {
    key: "pushSurroundingHandles",
    value: function pushSurroundingHandles(bounds, handle) {
      var value = bounds[handle];
      var pushable = this.props.pushable;
      var threshold = Number(pushable);
      var direction = 0;

      if (bounds[handle + 1] - value < threshold) {
        direction = +1; // push to right
      }

      if (value - bounds[handle - 1] < threshold) {
        direction = -1; // push to left
      }

      if (direction === 0) {
        return;
      }

      var nextHandle = handle + direction;
      var diffToNext = direction * (bounds[nextHandle] - value);

      if (!this.pushHandle(bounds, nextHandle, direction, threshold - diffToNext)) {
        // revert to original value if pushing is impossible
        // eslint-disable-next-line no-param-reassign
        bounds[handle] = bounds[nextHandle] - direction * threshold;
      }
    }
  }, {
    key: "pushHandle",
    value: function pushHandle(bounds, handle, direction, amount) {
      var originalValue = bounds[handle];
      var currentValue = bounds[handle];

      while (direction * (currentValue - originalValue) < amount) {
        if (!this.pushHandleOnePoint(bounds, handle, direction)) {
          // can't push handle enough to create the needed `amount` gap, so we
          // revert its position to the original value
          // eslint-disable-next-line no-param-reassign
          bounds[handle] = originalValue;
          return false;
        }

        currentValue = bounds[handle];
      } // the handle was pushed enough to create the needed `amount` gap


      return true;
    }
  }, {
    key: "pushHandleOnePoint",
    value: function pushHandleOnePoint(bounds, handle, direction) {
      var points = this.getPoints();
      var pointIndex = points.indexOf(bounds[handle]);
      var nextPointIndex = pointIndex + direction;

      if (nextPointIndex >= points.length || nextPointIndex < 0) {
        // reached the minimum or maximum available point, can't push anymore
        return false;
      }

      var nextHandle = handle + direction;
      var nextValue = points[nextPointIndex];
      var pushable = this.props.pushable;
      var threshold = Number(pushable);
      var diffToNext = direction * (bounds[nextHandle] - nextValue);

      if (!this.pushHandle(bounds, nextHandle, direction, threshold - diffToNext)) {
        // couldn't push next handle, so we won't push this one either
        return false;
      } // push the handle
      // eslint-disable-next-line no-param-reassign


      bounds[handle] = nextValue;
      return true;
    }
  }, {
    key: "trimAlignValue",
    value: function trimAlignValue(value) {
      var _this$state2 = this.state,
          handle = _this$state2.handle,
          bounds = _this$state2.bounds;
      return _trimAlignValue({
        value: value,
        handle: handle,
        bounds: bounds,
        props: this.props
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;

      var _this$state3 = this.state,
          handle = _this$state3.handle,
          bounds = _this$state3.bounds;
      var _this$props4 = this.props,
          prefixCls = _this$props4.prefixCls,
          vertical = _this$props4.vertical,
          included = _this$props4.included,
          disabled = _this$props4.disabled,
          min = _this$props4.min,
          max = _this$props4.max,
          reverse = _this$props4.reverse,
          handleGenerator = _this$props4.handle,
          trackStyle = _this$props4.trackStyle,
          handleStyle = _this$props4.handleStyle,
          tabIndex = _this$props4.tabIndex,
          ariaLabelGroupForHandles = _this$props4.ariaLabelGroupForHandles,
          ariaLabelledByGroupForHandles = _this$props4.ariaLabelledByGroupForHandles,
          ariaValueTextFormatterGroupForHandles = _this$props4.ariaValueTextFormatterGroupForHandles;
      var offsets = bounds.map(function (v) {
        return _this4.calcOffset(v);
      });
      var handleClassName = "".concat(prefixCls, "-handle");
      var handles = bounds.map(function (v, i) {
        var _classNames;

        var mergedTabIndex = tabIndex[i] || 0;

        if (disabled || tabIndex[i] === null) {
          mergedTabIndex = null;
        }

        var dragging = handle === i;
        return handleGenerator({
          className: classNames((_classNames = {}, _defineProperty$3(_classNames, handleClassName, true), _defineProperty$3(_classNames, "".concat(handleClassName, "-").concat(i + 1), true), _defineProperty$3(_classNames, "".concat(handleClassName, "-dragging"), dragging), _classNames)),
          prefixCls: prefixCls,
          vertical: vertical,
          dragging: dragging,
          offset: offsets[i],
          value: v,
          index: i,
          tabIndex: mergedTabIndex,
          min: min,
          max: max,
          reverse: reverse,
          disabled: disabled,
          style: handleStyle[i],
          ref: function ref(h) {
            return _this4.saveHandle(i, h);
          },
          ariaLabel: ariaLabelGroupForHandles[i],
          ariaLabelledBy: ariaLabelledByGroupForHandles[i],
          ariaValueTextFormatter: ariaValueTextFormatterGroupForHandles[i]
        });
      });
      var tracks = bounds.slice(0, -1).map(function (_, index) {
        var _classNames2;

        var i = index + 1;
        var trackClassName = classNames((_classNames2 = {}, _defineProperty$3(_classNames2, "".concat(prefixCls, "-track"), true), _defineProperty$3(_classNames2, "".concat(prefixCls, "-track-").concat(i), true), _classNames2));
        return /*#__PURE__*/React__default['default'].createElement(Track, {
          className: trackClassName,
          vertical: vertical,
          reverse: reverse,
          included: included,
          offset: offsets[i - 1],
          length: offsets[i] - offsets[i - 1],
          style: trackStyle[index],
          key: i
        });
      });
      return {
        tracks: tracks,
        handles: handles
      };
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props, state) {
      if (!('value' in props || 'min' in props || 'max' in props)) {
        return null;
      }

      var value = props.value || state.bounds;
      var nextBounds = value.map(function (v, i) {
        return _trimAlignValue({
          value: v,
          handle: i,
          bounds: state.bounds,
          props: props
        });
      });

      if (state.bounds.length === nextBounds.length) {
        if (nextBounds.every(function (v, i) {
          return v === state.bounds[i];
        })) {
          return null;
        }
      } else {
        nextBounds = value.map(function (v, i) {
          return _trimAlignValue({
            value: v,
            handle: i,
            props: props
          });
        });
      }

      return _objectSpread2$1(_objectSpread2$1({}, state), {}, {
        bounds: nextBounds
      });
    }
  }]);

  return Range;
}(React__default['default'].Component);
/* eslint-enable */


Range$1.displayName = 'Range';
Range$1.defaultProps = {
  count: 1,
  allowCross: true,
  pushable: false,
  draggableTrack: false,
  tabIndex: [],
  ariaLabelGroupForHandles: [],
  ariaLabelledByGroupForHandles: [],
  ariaValueTextFormatterGroupForHandles: []
};
var RangeUnstyled = createSlider(Range$1);var raf = function raf(callback) {
  return +setTimeout(callback, 16);
};

var caf = function caf(num) {
  return clearTimeout(num);
};

if (typeof window !== 'undefined' && 'requestAnimationFrame' in window) {
  raf = function raf(callback) {
    return window.requestAnimationFrame(callback);
  };

  caf = function caf(handle) {
    return window.cancelAnimationFrame(handle);
  };
}

var rafUUID = 0;
var rafIds = new Map();

function cleanup(id) {
  rafIds.delete(id);
}

function wrapperRaf(callback) {
  var times = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  rafUUID += 1;
  var id = rafUUID;

  function callRef(leftTimes) {
    if (leftTimes === 0) {
      // Clean up
      cleanup(id); // Trigger

      callback();
    } else {
      // Next raf
      var realId = raf(function () {
        callRef(leftTimes - 1);
      }); // Bind real raf id

      rafIds.set(id, realId);
    }
  }

  callRef(times);
  return id;
}

wrapperRaf.cancel = function (id) {
  var realId = rafIds.get(id);
  cleanup(realId);
  return caf(realId);
};function contains(root, n) {
  if (!root) {
    return false;
  }

  return root.contains(n);
}/**
 * Return if a node is a DOM node. Else will return by `findDOMNode`
 */

function findDOMNode(node) {
  if (node instanceof HTMLElement) {
    return node;
  }

  return ReactDOM__default['default'].findDOMNode(node);
}function fillRef(ref, node) {
  if (typeof ref === 'function') {
    ref(node);
  } else if (_typeof$2(ref) === 'object' && ref && 'current' in ref) {
    ref.current = node;
  }
}
/**
 * Merge refs into one ref function to support ref passing.
 */

function composeRef() {
  for (var _len = arguments.length, refs = new Array(_len), _key = 0; _key < _len; _key++) {
    refs[_key] = arguments[_key];
  }

  return function (node) {
    refs.forEach(function (ref) {
      fillRef(ref, node);
    });
  };
}
function supportRef(nodeOrComponent) {
  var _type$prototype, _nodeOrComponent$prot;

  var type = require$$0$2.isMemo(nodeOrComponent) ? nodeOrComponent.type.type : nodeOrComponent.type; // Function component node

  if (typeof type === 'function' && !((_type$prototype = type.prototype) === null || _type$prototype === void 0 ? void 0 : _type$prototype.render)) {
    return false;
  } // Class component


  if (typeof nodeOrComponent === 'function' && !((_nodeOrComponent$prot = nodeOrComponent.prototype) === null || _nodeOrComponent$prot === void 0 ? void 0 : _nodeOrComponent$prot.render)) {
    return false;
  }

  return true;
}
/* eslint-enable */function canUseDom() {
  return !!(typeof window !== 'undefined' && window.document && window.document.createElement);
}var Portal = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var didUpdate = props.didUpdate,
      getContainer = props.getContainer,
      children = props.children;
  var containerRef = React.useRef(); // Ref return nothing, only for wrapper check exist

  React.useImperativeHandle(ref, function () {
    return {};
  }); // Create container in client side with sync to avoid useEffect not get ref

  var initRef = React.useRef(false);

  if (!initRef.current && canUseDom()) {
    containerRef.current = getContainer();
    initRef.current = true;
  } // [Legacy] Used by `rc-trigger`


  React.useEffect(function () {
    didUpdate === null || didUpdate === void 0 ? void 0 : didUpdate(props);
  });
  React.useEffect(function () {
    return function () {
      var _containerRef$current, _containerRef$current2;

      // [Legacy] This should not be handle by Portal but parent PortalWrapper instead.
      // Since some component use `Portal` directly, we have to keep the logic here.
      (_containerRef$current = containerRef.current) === null || _containerRef$current === void 0 ? void 0 : (_containerRef$current2 = _containerRef$current.parentNode) === null || _containerRef$current2 === void 0 ? void 0 : _containerRef$current2.removeChild(containerRef.current);
    };
  }, []);
  return containerRef.current ? /*#__PURE__*/ReactDOM__default['default'].createPortal(children, containerRef.current) : null;
});function isPointsEq(a1, a2, isAlignPoint) {
  if (isAlignPoint) {
    return a1[0] === a2[0];
  }

  return a1[0] === a2[0] && a1[1] === a2[1];
}

function getAlignFromPlacement(builtinPlacements, placementStr, align) {
  var baseAlign = builtinPlacements[placementStr] || {};
  return _objectSpread2$1(_objectSpread2$1({}, baseAlign), align);
}
function getAlignPopupClassName(builtinPlacements, prefixCls, align, isAlignPoint) {
  var points = align.points;
  var placements = Object.keys(builtinPlacements);

  for (var i = 0; i < placements.length; i += 1) {
    var placement = placements[i];

    if (isPointsEq(builtinPlacements[placement].points, points, isAlignPoint)) {
      return "".concat(prefixCls, "-placement-").concat(placement);
    }
  }

  return '';
}var isMobile = (function () {
  if (typeof navigator === 'undefined' || typeof window === 'undefined') {
    return false;
  }

  var agent = navigator.userAgent || navigator.vendor || window.opera;

  if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(agent) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw-(n|u)|c55\/|capi|ccwa|cdm-|cell|chtm|cldc|cmd-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc-s|devi|dica|dmob|do(c|p)o|ds(12|-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(-|_)|g1 u|g560|gene|gf-5|g-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd-(m|p|t)|hei-|hi(pt|ta)|hp( i|ip)|hs-c|ht(c(-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i-(20|go|ma)|i230|iac( |-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|-[a-w])|libw|lynx|m1-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|-([1-8]|c))|phil|pire|pl(ay|uc)|pn-2|po(ck|rt|se)|prox|psio|pt-g|qa-a|qc(07|12|21|32|60|-[2-7]|i-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h-|oo|p-)|sdk\/|se(c(-|0|1)|47|mc|nd|ri)|sgh-|shar|sie(-|m)|sk-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h-|v-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl-|tdg-|tel(i|m)|tim-|t-mo|to(pl|sh)|ts(70|m-|m3|m5)|tx-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas-|your|zeto|zte-/i.test(agent === null || agent === void 0 ? void 0 : agent.substr(0, 4))) {
    return true;
  }

  return false;
});// Event wrapper. Copy from react source code

function makePrefixMap(styleProp, eventName) {
  var prefixes = {};
  prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
  prefixes["Webkit".concat(styleProp)] = "webkit".concat(eventName);
  prefixes["Moz".concat(styleProp)] = "moz".concat(eventName);
  prefixes["ms".concat(styleProp)] = "MS".concat(eventName);
  prefixes["O".concat(styleProp)] = "o".concat(eventName.toLowerCase());
  return prefixes;
}

function getVendorPrefixes(domSupport, win) {
  var prefixes = {
    animationend: makePrefixMap('Animation', 'AnimationEnd'),
    transitionend: makePrefixMap('Transition', 'TransitionEnd')
  };

  if (domSupport) {
    if (!('AnimationEvent' in win)) {
      delete prefixes.animationend.animation;
    }

    if (!('TransitionEvent' in win)) {
      delete prefixes.transitionend.transition;
    }
  }

  return prefixes;
}
var vendorPrefixes = getVendorPrefixes(canUseDom(), typeof window !== 'undefined' ? window : {});
var style = {};

if (canUseDom()) {
  var _document$createEleme = document.createElement('div');

  style = _document$createEleme.style;
}

var prefixedEventNames = {};
function getVendorPrefixedEventName(eventName) {
  if (prefixedEventNames[eventName]) {
    return prefixedEventNames[eventName];
  }

  var prefixMap = vendorPrefixes[eventName];

  if (prefixMap) {
    var stylePropList = Object.keys(prefixMap);
    var len = stylePropList.length;

    for (var i = 0; i < len; i += 1) {
      var styleProp = stylePropList[i];

      if (Object.prototype.hasOwnProperty.call(prefixMap, styleProp) && styleProp in style) {
        prefixedEventNames[eventName] = prefixMap[styleProp];
        return prefixedEventNames[eventName];
      }
    }
  }

  return '';
}
var internalAnimationEndName = getVendorPrefixedEventName('animationend');
var internalTransitionEndName = getVendorPrefixedEventName('transitionend');
var supportTransition = !!(internalAnimationEndName && internalTransitionEndName);
var animationEndName = internalAnimationEndName || 'animationend';
var transitionEndName = internalTransitionEndName || 'transitionend';
function getTransitionName$1(transitionName, transitionType) {
  if (!transitionName) return null;

  if (_typeof$2(transitionName) === 'object') {
    var type = transitionType.replace(/-\w/g, function (match) {
      return match[1].toUpperCase();
    });
    return transitionName[type];
  }

  return "".concat(transitionName, "-").concat(transitionType);
}var STATUS_NONE = 'none';
var STATUS_APPEAR = 'appear';
var STATUS_ENTER = 'enter';
var STATUS_LEAVE = 'leave';
var STEP_NONE = 'none';
var STEP_PREPARE = 'prepare';
var STEP_START = 'start';
var STEP_ACTIVE = 'active';
var STEP_ACTIVATED = 'end';function useMountStatus(defaultValue) {
  var destroyRef = React.useRef(false);

  var _useState = React.useState(defaultValue),
      _useState2 = _slicedToArray(_useState, 2),
      val = _useState2[0],
      setVal = _useState2[1];

  function setValue(next) {
    if (!destroyRef.current) {
      setVal(next);
    }
  }

  React.useEffect(function () {
    return function () {
      destroyRef.current = true;
    };
  }, []);
  return [val, setValue];
}var useIsomorphicLayoutEffect = canUseDom() ? React.useLayoutEffect : React.useEffect;var useNextFrame = (function () {
  var nextFrameRef = React__namespace.useRef(null);

  function cancelNextFrame() {
    wrapperRaf.cancel(nextFrameRef.current);
  }

  function nextFrame(callback) {
    var delay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
    cancelNextFrame();
    var nextFrameId = wrapperRaf(function () {
      if (delay <= 1) {
        callback({
          isCanceled: function isCanceled() {
            return nextFrameId !== nextFrameRef.current;
          }
        });
      } else {
        nextFrame(callback, delay - 1);
      }
    });
    nextFrameRef.current = nextFrameId;
  }

  React__namespace.useEffect(function () {
    return function () {
      cancelNextFrame();
    };
  }, []);
  return [nextFrame, cancelNextFrame];
});var STEP_QUEUE = [STEP_PREPARE, STEP_START, STEP_ACTIVE, STEP_ACTIVATED];
/** Skip current step */

var SkipStep = false;
/** Current step should be update in */

var DoStep = true;
function isActive(step) {
  return step === STEP_ACTIVE || step === STEP_ACTIVATED;
}
var useStepQueue = (function (status, callback) {
  var _React$useState = React__namespace.useState(STEP_NONE),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      step = _React$useState2[0],
      setStep = _React$useState2[1];

  var _useNextFrame = useNextFrame(),
      _useNextFrame2 = _slicedToArray(_useNextFrame, 2),
      nextFrame = _useNextFrame2[0],
      cancelNextFrame = _useNextFrame2[1];

  function startQueue() {
    setStep(STEP_PREPARE);
  }

  useIsomorphicLayoutEffect(function () {
    if (step !== STEP_NONE && step !== STEP_ACTIVATED) {
      var index = STEP_QUEUE.indexOf(step);
      var nextStep = STEP_QUEUE[index + 1];
      var result = callback(step);

      if (result === SkipStep) {
        // Skip when no needed
        setStep(nextStep);
      } else {
        // Do as frame for step update
        nextFrame(function (info) {
          function doNext() {
            // Skip since current queue is ood
            if (info.isCanceled()) return;
            setStep(nextStep);
          }

          if (result === true) {
            doNext();
          } else {
            // Only promise should be async
            Promise.resolve(result).then(doNext);
          }
        });
      }
    }
  }, [status, step]);
  React__namespace.useEffect(function () {
    return function () {
      cancelNextFrame();
    };
  }, []);
  return [startQueue, step];
});var useDomMotionEvents = (function (callback) {
  var cacheElementRef = React.useRef(); // Cache callback

  var callbackRef = React.useRef(callback);
  callbackRef.current = callback; // Internal motion event handler

  var onInternalMotionEnd = React__namespace.useCallback(function (event) {
    callbackRef.current(event);
  }, []); // Remove events

  function removeMotionEvents(element) {
    if (element) {
      element.removeEventListener(transitionEndName, onInternalMotionEnd);
      element.removeEventListener(animationEndName, onInternalMotionEnd);
    }
  } // Patch events


  function patchMotionEvents(element) {
    if (cacheElementRef.current && cacheElementRef.current !== element) {
      removeMotionEvents(cacheElementRef.current);
    }

    if (element && element !== cacheElementRef.current) {
      element.addEventListener(transitionEndName, onInternalMotionEnd);
      element.addEventListener(animationEndName, onInternalMotionEnd); // Save as cache in case dom removed trigger by `motionDeadline`

      cacheElementRef.current = element;
    }
  } // Clean up when removed


  React__namespace.useEffect(function () {
    return function () {
      removeMotionEvents(cacheElementRef.current);
    };
  }, []);
  return [patchMotionEvents, removeMotionEvents];
});function useStatus(supportMotion, visible, getElement, _ref) {
  var _ref$motionEnter = _ref.motionEnter,
      motionEnter = _ref$motionEnter === void 0 ? true : _ref$motionEnter,
      _ref$motionAppear = _ref.motionAppear,
      motionAppear = _ref$motionAppear === void 0 ? true : _ref$motionAppear,
      _ref$motionLeave = _ref.motionLeave,
      motionLeave = _ref$motionLeave === void 0 ? true : _ref$motionLeave,
      motionDeadline = _ref.motionDeadline,
      motionLeaveImmediately = _ref.motionLeaveImmediately,
      onAppearPrepare = _ref.onAppearPrepare,
      onEnterPrepare = _ref.onEnterPrepare,
      onLeavePrepare = _ref.onLeavePrepare,
      onAppearStart = _ref.onAppearStart,
      onEnterStart = _ref.onEnterStart,
      onLeaveStart = _ref.onLeaveStart,
      onAppearActive = _ref.onAppearActive,
      onEnterActive = _ref.onEnterActive,
      onLeaveActive = _ref.onLeaveActive,
      onAppearEnd = _ref.onAppearEnd,
      onEnterEnd = _ref.onEnterEnd,
      onLeaveEnd = _ref.onLeaveEnd,
      onVisibleChanged = _ref.onVisibleChanged;

  // Used for outer render usage to avoid `visible: false & status: none` to render nothing
  var _useState = useMountStatus(),
      _useState2 = _slicedToArray(_useState, 2),
      asyncVisible = _useState2[0],
      setAsyncVisible = _useState2[1];

  var _useState3 = useMountStatus(STATUS_NONE),
      _useState4 = _slicedToArray(_useState3, 2),
      status = _useState4[0],
      setStatus = _useState4[1];

  var _useState5 = useMountStatus(null),
      _useState6 = _slicedToArray(_useState5, 2),
      style = _useState6[0],
      setStyle = _useState6[1];

  var mountedRef = React.useRef(false);
  var deadlineRef = React.useRef(null);
  var destroyedRef = React.useRef(false); // =========================== Dom Node ===========================

  var cacheElementRef = React.useRef(null);

  function getDomElement() {
    var element = getElement();
    return element || cacheElementRef.current;
  } // ========================== Motion End ==========================


  var activeRef = React.useRef(false);

  function onInternalMotionEnd(event) {
    var element = getDomElement();

    if (event && !event.deadline && event.target !== element) {
      // event exists
      // not initiated by deadline
      // transitionEnd not fired by inner elements
      return;
    }

    var canEnd;

    if (status === STATUS_APPEAR && activeRef.current) {
      canEnd = onAppearEnd === null || onAppearEnd === void 0 ? void 0 : onAppearEnd(element, event);
    } else if (status === STATUS_ENTER && activeRef.current) {
      canEnd = onEnterEnd === null || onEnterEnd === void 0 ? void 0 : onEnterEnd(element, event);
    } else if (status === STATUS_LEAVE && activeRef.current) {
      canEnd = onLeaveEnd === null || onLeaveEnd === void 0 ? void 0 : onLeaveEnd(element, event);
    } // Only update status when `canEnd` and not destroyed


    if (canEnd !== false && !destroyedRef.current) {
      setStatus(STATUS_NONE);
      setStyle(null);
    }
  }

  var _useDomMotionEvents = useDomMotionEvents(onInternalMotionEnd),
      _useDomMotionEvents2 = _slicedToArray(_useDomMotionEvents, 1),
      patchMotionEvents = _useDomMotionEvents2[0]; // ============================= Step =============================


  var eventHandlers = React__namespace.useMemo(function () {
    var _ref2, _ref3, _ref4;

    switch (status) {
      case 'appear':
        return _ref2 = {}, _defineProperty$3(_ref2, STEP_PREPARE, onAppearPrepare), _defineProperty$3(_ref2, STEP_START, onAppearStart), _defineProperty$3(_ref2, STEP_ACTIVE, onAppearActive), _ref2;

      case 'enter':
        return _ref3 = {}, _defineProperty$3(_ref3, STEP_PREPARE, onEnterPrepare), _defineProperty$3(_ref3, STEP_START, onEnterStart), _defineProperty$3(_ref3, STEP_ACTIVE, onEnterActive), _ref3;

      case 'leave':
        return _ref4 = {}, _defineProperty$3(_ref4, STEP_PREPARE, onLeavePrepare), _defineProperty$3(_ref4, STEP_START, onLeaveStart), _defineProperty$3(_ref4, STEP_ACTIVE, onLeaveActive), _ref4;

      default:
        return {};
    }
  }, [status]);

  var _useStepQueue = useStepQueue(status, function (newStep) {
    // Only prepare step can be skip
    if (newStep === STEP_PREPARE) {
      var onPrepare = eventHandlers[STEP_PREPARE];

      if (!onPrepare) {
        return SkipStep;
      }

      return onPrepare(getDomElement());
    } // Rest step is sync update


    // Rest step is sync update
    if (step in eventHandlers) {
      var _eventHandlers$step;

      setStyle(((_eventHandlers$step = eventHandlers[step]) === null || _eventHandlers$step === void 0 ? void 0 : _eventHandlers$step.call(eventHandlers, getDomElement(), null)) || null);
    }

    if (step === STEP_ACTIVE) {
      // Patch events when motion needed
      patchMotionEvents(getDomElement());

      if (motionDeadline > 0) {
        clearTimeout(deadlineRef.current);
        deadlineRef.current = setTimeout(function () {
          onInternalMotionEnd({
            deadline: true
          });
        }, motionDeadline);
      }
    }

    return DoStep;
  }),
      _useStepQueue2 = _slicedToArray(_useStepQueue, 2),
      startStep = _useStepQueue2[0],
      step = _useStepQueue2[1];

  var active = isActive(step);
  activeRef.current = active; // ============================ Status ============================
  // Update with new status

  useIsomorphicLayoutEffect(function () {
    setAsyncVisible(visible);
    var isMounted = mountedRef.current;
    mountedRef.current = true;

    if (!supportMotion) {
      return;
    }

    var nextStatus; // Appear

    if (!isMounted && visible && motionAppear) {
      nextStatus = STATUS_APPEAR;
    } // Enter


    if (isMounted && visible && motionEnter) {
      nextStatus = STATUS_ENTER;
    } // Leave


    if (isMounted && !visible && motionLeave || !isMounted && motionLeaveImmediately && !visible && motionLeave) {
      nextStatus = STATUS_LEAVE;
    } // Update to next status


    if (nextStatus) {
      setStatus(nextStatus);
      startStep();
    }
  }, [visible]); // ============================ Effect ============================
  // Reset when motion changed

  React.useEffect(function () {
    if ( // Cancel appear
    status === STATUS_APPEAR && !motionAppear || // Cancel enter
    status === STATUS_ENTER && !motionEnter || // Cancel leave
    status === STATUS_LEAVE && !motionLeave) {
      setStatus(STATUS_NONE);
    }
  }, [motionAppear, motionEnter, motionLeave]);
  React.useEffect(function () {
    return function () {
      clearTimeout(deadlineRef.current);
      destroyedRef.current = true;
    };
  }, []); // Trigger `onVisibleChanged`

  React.useEffect(function () {
    if (asyncVisible !== undefined && status === STATUS_NONE) {
      onVisibleChanged === null || onVisibleChanged === void 0 ? void 0 : onVisibleChanged(asyncVisible);
    }
  }, [asyncVisible, status]); // ============================ Styles ============================

  var mergedStyle = style;

  if (eventHandlers[STEP_PREPARE] && step === STEP_START) {
    mergedStyle = _objectSpread2$1({
      transition: 'none'
    }, mergedStyle);
  }

  return [status, step, mergedStyle, asyncVisible !== null && asyncVisible !== void 0 ? asyncVisible : visible];
}var DomWrapper = /*#__PURE__*/function (_React$Component) {
  _inherits$d(DomWrapper, _React$Component);

  var _super = _createSuper(DomWrapper);

  function DomWrapper() {
    _classCallCheck$d(this, DomWrapper);

    return _super.apply(this, arguments);
  }

  _createClass$b(DomWrapper, [{
    key: "render",
    value: function render() {
      return this.props.children;
    }
  }]);

  return DomWrapper;
}(React__namespace.Component);/**
 * `transitionSupport` is used for none transition test case.
 * Default we use browser transition event support check.
 */

function genCSSMotion(config) {
  var transitionSupport = config;

  if (_typeof$2(config) === 'object') {
    transitionSupport = config.transitionSupport;
  }

  function isSupportTransition(props) {
    return !!(props.motionName && transitionSupport);
  }

  var CSSMotion = /*#__PURE__*/React__namespace.forwardRef(function (props, ref) {
    var _props$visible = props.visible,
        visible = _props$visible === void 0 ? true : _props$visible,
        _props$removeOnLeave = props.removeOnLeave,
        removeOnLeave = _props$removeOnLeave === void 0 ? true : _props$removeOnLeave,
        forceRender = props.forceRender,
        children = props.children,
        motionName = props.motionName,
        leavedClassName = props.leavedClassName,
        eventProps = props.eventProps;
    var supportMotion = isSupportTransition(props); // Ref to the react node, it may be a HTMLElement

    var nodeRef = React.useRef(); // Ref to the dom wrapper in case ref can not pass to HTMLElement

    var wrapperNodeRef = React.useRef();

    function getDomElement() {
      try {
        return findDOMNode(nodeRef.current || wrapperNodeRef.current);
      } catch (e) {
        // Only happen when `motionDeadline` trigger but element removed.
        return null;
      }
    }

    var _useStatus = useStatus(supportMotion, visible, getDomElement, props),
        _useStatus2 = _slicedToArray(_useStatus, 4),
        status = _useStatus2[0],
        statusStep = _useStatus2[1],
        statusStyle = _useStatus2[2],
        mergedVisible = _useStatus2[3]; // Record whether content has rended
    // Will return null for un-rendered even when `removeOnLeave={false}`


    var renderedRef = React__namespace.useRef(mergedVisible);

    if (mergedVisible) {
      renderedRef.current = true;
    } // ====================== Refs ======================


    var originRef = React.useRef(ref);
    originRef.current = ref;
    var setNodeRef = React__namespace.useCallback(function (node) {
      nodeRef.current = node;
      fillRef(originRef.current, node);
    }, []); // ===================== Render =====================

    var motionChildren;

    var mergedProps = _objectSpread2$1(_objectSpread2$1({}, eventProps), {}, {
      visible: visible
    });

    if (!children) {
      // No children
      motionChildren = null;
    } else if (status === STATUS_NONE || !isSupportTransition(props)) {
      // Stable children
      if (mergedVisible) {
        motionChildren = children(_objectSpread2$1({}, mergedProps), setNodeRef);
      } else if (!removeOnLeave && renderedRef.current) {
        motionChildren = children(_objectSpread2$1(_objectSpread2$1({}, mergedProps), {}, {
          className: leavedClassName
        }), setNodeRef);
      } else if (forceRender) {
        motionChildren = children(_objectSpread2$1(_objectSpread2$1({}, mergedProps), {}, {
          style: {
            display: 'none'
          }
        }), setNodeRef);
      } else {
        motionChildren = null;
      }
    } else {
      var _classNames;

      // In motion
      var statusSuffix;

      if (statusStep === STEP_PREPARE) {
        statusSuffix = 'prepare';
      } else if (isActive(statusStep)) {
        statusSuffix = 'active';
      } else if (statusStep === STEP_START) {
        statusSuffix = 'start';
      }

      motionChildren = children(_objectSpread2$1(_objectSpread2$1({}, mergedProps), {}, {
        className: classNames(getTransitionName$1(motionName, status), (_classNames = {}, _defineProperty$3(_classNames, getTransitionName$1(motionName, "".concat(status, "-").concat(statusSuffix)), statusSuffix), _defineProperty$3(_classNames, motionName, typeof motionName === 'string'), _classNames)),
        style: statusStyle
      }), setNodeRef);
    }

    return /*#__PURE__*/React__namespace.createElement(DomWrapper, {
      ref: wrapperNodeRef
    }, motionChildren);
  });
  CSSMotion.displayName = 'CSSMotion';
  return CSSMotion;
}
var CSSMotion = genCSSMotion(supportTransition);function getMotion(_ref) {
  var prefixCls = _ref.prefixCls,
      motion = _ref.motion,
      animation = _ref.animation,
      transitionName = _ref.transitionName;

  if (motion) {
    return motion;
  }

  if (animation) {
    return {
      motionName: "".concat(prefixCls, "-").concat(animation)
    };
  }

  if (transitionName) {
    return {
      motionName: transitionName
    };
  }

  return null;
}function Mask(props) {
  var prefixCls = props.prefixCls,
      visible = props.visible,
      zIndex = props.zIndex,
      mask = props.mask,
      maskMotion = props.maskMotion,
      maskAnimation = props.maskAnimation,
      maskTransitionName = props.maskTransitionName;

  if (!mask) {
    return null;
  }

  var motion = {};

  if (maskMotion || maskTransitionName || maskAnimation) {
    motion = _objectSpread2$1({
      motionAppear: true
    }, getMotion({
      motion: maskMotion,
      prefixCls: prefixCls,
      transitionName: maskTransitionName,
      animation: maskAnimation
    }));
  }

  return /*#__PURE__*/React__namespace.createElement(CSSMotion, _extends$f({}, motion, {
    visible: visible,
    removeOnLeave: true
  }), function (_ref) {
    var className = _ref.className;
    return /*#__PURE__*/React__namespace.createElement("div", {
      style: {
        zIndex: zIndex
      },
      className: classNames("".concat(prefixCls, "-mask"), className)
    });
  });
}var isVisible = (function (element) {
  if (!element) {
    return false;
  }

  if (element.offsetParent) {
    return true;
  }

  if (element.getBBox) {
    var box = element.getBBox();

    if (box.width || box.height) {
      return true;
    }
  }

  if (element.getBoundingClientRect) {
    var _box = element.getBoundingClientRect();

    if (_box.width || _box.height) {
      return true;
    }
  }

  return false;
});function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty$1(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function (obj) {
      return typeof obj;
    };
  } else {
    _typeof = function (obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _defineProperty$1(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var vendorPrefix;
var jsCssMap = {
  Webkit: '-webkit-',
  Moz: '-moz-',
  // IE did it wrong again ...
  ms: '-ms-',
  O: '-o-'
};

function getVendorPrefix() {
  if (vendorPrefix !== undefined) {
    return vendorPrefix;
  }

  vendorPrefix = '';
  var style = document.createElement('p').style;
  var testProp = 'Transform';

  for (var key in jsCssMap) {
    if (key + testProp in style) {
      vendorPrefix = key;
    }
  }

  return vendorPrefix;
}

function getTransitionName() {
  return getVendorPrefix() ? "".concat(getVendorPrefix(), "TransitionProperty") : 'transitionProperty';
}

function getTransformName() {
  return getVendorPrefix() ? "".concat(getVendorPrefix(), "Transform") : 'transform';
}
function setTransitionProperty(node, value) {
  var name = getTransitionName();

  if (name) {
    node.style[name] = value;

    if (name !== 'transitionProperty') {
      node.style.transitionProperty = value;
    }
  }
}

function setTransform(node, value) {
  var name = getTransformName();

  if (name) {
    node.style[name] = value;

    if (name !== 'transform') {
      node.style.transform = value;
    }
  }
}

function getTransitionProperty(node) {
  return node.style.transitionProperty || node.style[getTransitionName()];
}
function getTransformXY(node) {
  var style = window.getComputedStyle(node, null);
  var transform = style.getPropertyValue('transform') || style.getPropertyValue(getTransformName());

  if (transform && transform !== 'none') {
    var matrix = transform.replace(/[^0-9\-.,]/g, '').split(',');
    return {
      x: parseFloat(matrix[12] || matrix[4], 0),
      y: parseFloat(matrix[13] || matrix[5], 0)
    };
  }

  return {
    x: 0,
    y: 0
  };
}
var matrix2d = /matrix\((.*)\)/;
var matrix3d = /matrix3d\((.*)\)/;
function setTransformXY(node, xy) {
  var style = window.getComputedStyle(node, null);
  var transform = style.getPropertyValue('transform') || style.getPropertyValue(getTransformName());

  if (transform && transform !== 'none') {
    var arr;
    var match2d = transform.match(matrix2d);

    if (match2d) {
      match2d = match2d[1];
      arr = match2d.split(',').map(function (item) {
        return parseFloat(item, 10);
      });
      arr[4] = xy.x;
      arr[5] = xy.y;
      setTransform(node, "matrix(".concat(arr.join(','), ")"));
    } else {
      var match3d = transform.match(matrix3d)[1];
      arr = match3d.split(',').map(function (item) {
        return parseFloat(item, 10);
      });
      arr[12] = xy.x;
      arr[13] = xy.y;
      setTransform(node, "matrix3d(".concat(arr.join(','), ")"));
    }
  } else {
    setTransform(node, "translateX(".concat(xy.x, "px) translateY(").concat(xy.y, "px) translateZ(0)"));
  }
}

var RE_NUM = /[\-+]?(?:\d*\.|)\d+(?:[eE][\-+]?\d+|)/.source;
var getComputedStyleX; // https://stackoverflow.com/a/3485654/3040605

function forceRelayout(elem) {
  var originalStyle = elem.style.display;
  elem.style.display = 'none';
  elem.offsetHeight; // eslint-disable-line

  elem.style.display = originalStyle;
}

function css(el, name, v) {
  var value = v;

  if (_typeof(name) === 'object') {
    for (var i in name) {
      if (name.hasOwnProperty(i)) {
        css(el, i, name[i]);
      }
    }

    return undefined;
  }

  if (typeof value !== 'undefined') {
    if (typeof value === 'number') {
      value = "".concat(value, "px");
    }

    el.style[name] = value;
    return undefined;
  }

  return getComputedStyleX(el, name);
}

function getClientPosition(elem) {
  var box;
  var x;
  var y;
  var doc = elem.ownerDocument;
  var body = doc.body;
  var docElem = doc && doc.documentElement; // 根据 GBS 最新数据，A-Grade Browsers 都已支持 getBoundingClientRect 方法，不用再考虑传统的实现方式

  box = elem.getBoundingClientRect(); // 注：jQuery 还考虑减去 docElem.clientLeft/clientTop
  // 但测试发现，这样反而会导致当 html 和 body 有边距/边框样式时，获取的值不正确
  // 此外，ie6 会忽略 html 的 margin 值，幸运地是没有谁会去设置 html 的 margin

  x = box.left;
  y = box.top; // In IE, most of the time, 2 extra pixels are added to the top and left
  // due to the implicit 2-pixel inset border.  In IE6/7 quirks mode and
  // IE6 standards mode, this border can be overridden by setting the
  // document element's border to zero -- thus, we cannot rely on the
  // offset always being 2 pixels.
  // In quirks mode, the offset can be determined by querying the body's
  // clientLeft/clientTop, but in standards mode, it is found by querying
  // the document element's clientLeft/clientTop.  Since we already called
  // getClientBoundingRect we have already forced a reflow, so it is not
  // too expensive just to query them all.
  // ie 下应该减去窗口的边框吧，毕竟默认 absolute 都是相对窗口定位的
  // 窗口边框标准是设 documentElement ,quirks 时设置 body
  // 最好禁止在 body 和 html 上边框 ，但 ie < 9 html 默认有 2px ，减去
  // 但是非 ie 不可能设置窗口边框，body html 也不是窗口 ,ie 可以通过 html,body 设置
  // 标准 ie 下 docElem.clientTop 就是 border-top
  // ie7 html 即窗口边框改变不了。永远为 2
  // 但标准 firefox/chrome/ie9 下 docElem.clientTop 是窗口边框，即使设了 border-top 也为 0

  x -= docElem.clientLeft || body.clientLeft || 0;
  y -= docElem.clientTop || body.clientTop || 0;
  return {
    left: x,
    top: y
  };
}

function getScroll(w, top) {
  var ret = w["page".concat(top ? 'Y' : 'X', "Offset")];
  var method = "scroll".concat(top ? 'Top' : 'Left');

  if (typeof ret !== 'number') {
    var d = w.document; // ie6,7,8 standard mode

    ret = d.documentElement[method];

    if (typeof ret !== 'number') {
      // quirks mode
      ret = d.body[method];
    }
  }

  return ret;
}

function getScrollLeft(w) {
  return getScroll(w);
}

function getScrollTop(w) {
  return getScroll(w, true);
}

function getOffset(el) {
  var pos = getClientPosition(el);
  var doc = el.ownerDocument;
  var w = doc.defaultView || doc.parentWindow;
  pos.left += getScrollLeft(w);
  pos.top += getScrollTop(w);
  return pos;
}
/**
 * A crude way of determining if an object is a window
 * @member util
 */


function isWindow(obj) {
  // must use == for ie8

  /* eslint eqeqeq:0 */
  return obj !== null && obj !== undefined && obj == obj.window;
}

function getDocument(node) {
  if (isWindow(node)) {
    return node.document;
  }

  if (node.nodeType === 9) {
    return node;
  }

  return node.ownerDocument;
}

function _getComputedStyle(elem, name, cs) {
  var computedStyle = cs;
  var val = '';
  var d = getDocument(elem);
  computedStyle = computedStyle || d.defaultView.getComputedStyle(elem, null); // https://github.com/kissyteam/kissy/issues/61

  if (computedStyle) {
    val = computedStyle.getPropertyValue(name) || computedStyle[name];
  }

  return val;
}

var _RE_NUM_NO_PX = new RegExp("^(".concat(RE_NUM, ")(?!px)[a-z%]+$"), 'i');

var RE_POS = /^(top|right|bottom|left)$/;
var CURRENT_STYLE = 'currentStyle';
var RUNTIME_STYLE = 'runtimeStyle';
var LEFT = 'left';
var PX = 'px';

function _getComputedStyleIE(elem, name) {
  // currentStyle maybe null
  // http://msdn.microsoft.com/en-us/library/ms535231.aspx
  var ret = elem[CURRENT_STYLE] && elem[CURRENT_STYLE][name]; // 当 width/height 设置为百分比时，通过 pixelLeft 方式转换的 width/height 值
  // 一开始就处理了! CUSTOM_STYLE.height,CUSTOM_STYLE.width ,cssHook 解决@2011-08-19
  // 在 ie 下不对，需要直接用 offset 方式
  // borderWidth 等值也有问题，但考虑到 borderWidth 设为百分比的概率很小，这里就不考虑了
  // From the awesome hack by Dean Edwards
  // http://erik.eae.net/archives/2007/07/27/18.54.15/#comment-102291
  // If we're not dealing with a regular pixel number
  // but a number that has a weird ending, we need to convert it to pixels
  // exclude left right for relativity

  if (_RE_NUM_NO_PX.test(ret) && !RE_POS.test(name)) {
    // Remember the original values
    var style = elem.style;
    var left = style[LEFT];
    var rsLeft = elem[RUNTIME_STYLE][LEFT]; // prevent flashing of content

    elem[RUNTIME_STYLE][LEFT] = elem[CURRENT_STYLE][LEFT]; // Put in the new values to get a computed value out

    style[LEFT] = name === 'fontSize' ? '1em' : ret || 0;
    ret = style.pixelLeft + PX; // Revert the changed values

    style[LEFT] = left;
    elem[RUNTIME_STYLE][LEFT] = rsLeft;
  }

  return ret === '' ? 'auto' : ret;
}

if (typeof window !== 'undefined') {
  getComputedStyleX = window.getComputedStyle ? _getComputedStyle : _getComputedStyleIE;
}

function getOffsetDirection(dir, option) {
  if (dir === 'left') {
    return option.useCssRight ? 'right' : dir;
  }

  return option.useCssBottom ? 'bottom' : dir;
}

function oppositeOffsetDirection(dir) {
  if (dir === 'left') {
    return 'right';
  } else if (dir === 'right') {
    return 'left';
  } else if (dir === 'top') {
    return 'bottom';
  } else if (dir === 'bottom') {
    return 'top';
  }
} // 设置 elem 相对 elem.ownerDocument 的坐标


function setLeftTop(elem, offset, option) {
  // set position first, in-case top/left are set even on static elem
  if (css(elem, 'position') === 'static') {
    elem.style.position = 'relative';
  }

  var presetH = -999;
  var presetV = -999;
  var horizontalProperty = getOffsetDirection('left', option);
  var verticalProperty = getOffsetDirection('top', option);
  var oppositeHorizontalProperty = oppositeOffsetDirection(horizontalProperty);
  var oppositeVerticalProperty = oppositeOffsetDirection(verticalProperty);

  if (horizontalProperty !== 'left') {
    presetH = 999;
  }

  if (verticalProperty !== 'top') {
    presetV = 999;
  }

  var originalTransition = '';
  var originalOffset = getOffset(elem);

  if ('left' in offset || 'top' in offset) {
    originalTransition = getTransitionProperty(elem) || '';
    setTransitionProperty(elem, 'none');
  }

  if ('left' in offset) {
    elem.style[oppositeHorizontalProperty] = '';
    elem.style[horizontalProperty] = "".concat(presetH, "px");
  }

  if ('top' in offset) {
    elem.style[oppositeVerticalProperty] = '';
    elem.style[verticalProperty] = "".concat(presetV, "px");
  } // force relayout


  forceRelayout(elem);
  var old = getOffset(elem);
  var originalStyle = {};

  for (var key in offset) {
    if (offset.hasOwnProperty(key)) {
      var dir = getOffsetDirection(key, option);
      var preset = key === 'left' ? presetH : presetV;
      var off = originalOffset[key] - old[key];

      if (dir === key) {
        originalStyle[dir] = preset + off;
      } else {
        originalStyle[dir] = preset - off;
      }
    }
  }

  css(elem, originalStyle); // force relayout

  forceRelayout(elem);

  if ('left' in offset || 'top' in offset) {
    setTransitionProperty(elem, originalTransition);
  }

  var ret = {};

  for (var _key in offset) {
    if (offset.hasOwnProperty(_key)) {
      var _dir = getOffsetDirection(_key, option);

      var _off = offset[_key] - originalOffset[_key];

      if (_key === _dir) {
        ret[_dir] = originalStyle[_dir] + _off;
      } else {
        ret[_dir] = originalStyle[_dir] - _off;
      }
    }
  }

  css(elem, ret);
}

function setTransform$1(elem, offset) {
  var originalOffset = getOffset(elem);
  var originalXY = getTransformXY(elem);
  var resultXY = {
    x: originalXY.x,
    y: originalXY.y
  };

  if ('left' in offset) {
    resultXY.x = originalXY.x + offset.left - originalOffset.left;
  }

  if ('top' in offset) {
    resultXY.y = originalXY.y + offset.top - originalOffset.top;
  }

  setTransformXY(elem, resultXY);
}

function setOffset(elem, offset, option) {
  if (option.ignoreShake) {
    var oriOffset = getOffset(elem);
    var oLeft = oriOffset.left.toFixed(0);
    var oTop = oriOffset.top.toFixed(0);
    var tLeft = offset.left.toFixed(0);
    var tTop = offset.top.toFixed(0);

    if (oLeft === tLeft && oTop === tTop) {
      return;
    }
  }

  if (option.useCssRight || option.useCssBottom) {
    setLeftTop(elem, offset, option);
  } else if (option.useCssTransform && getTransformName() in document.body.style) {
    setTransform$1(elem, offset);
  } else {
    setLeftTop(elem, offset, option);
  }
}

function each(arr, fn) {
  for (var i = 0; i < arr.length; i++) {
    fn(arr[i]);
  }
}

function isBorderBoxFn(elem) {
  return getComputedStyleX(elem, 'boxSizing') === 'border-box';
}

var BOX_MODELS = ['margin', 'border', 'padding'];
var CONTENT_INDEX = -1;
var PADDING_INDEX = 2;
var BORDER_INDEX = 1;
var MARGIN_INDEX = 0;

function swap(elem, options, callback) {
  var old = {};
  var style = elem.style;
  var name; // Remember the old values, and insert the new ones

  for (name in options) {
    if (options.hasOwnProperty(name)) {
      old[name] = style[name];
      style[name] = options[name];
    }
  }

  callback.call(elem); // Revert the old values

  for (name in options) {
    if (options.hasOwnProperty(name)) {
      style[name] = old[name];
    }
  }
}

function getPBMWidth(elem, props, which) {
  var value = 0;
  var prop;
  var j;
  var i;

  for (j = 0; j < props.length; j++) {
    prop = props[j];

    if (prop) {
      for (i = 0; i < which.length; i++) {
        var cssProp = void 0;

        if (prop === 'border') {
          cssProp = "".concat(prop).concat(which[i], "Width");
        } else {
          cssProp = prop + which[i];
        }

        value += parseFloat(getComputedStyleX(elem, cssProp)) || 0;
      }
    }
  }

  return value;
}

var domUtils = {
  getParent: function getParent(element) {
    var parent = element;

    do {
      if (parent.nodeType === 11 && parent.host) {
        parent = parent.host;
      } else {
        parent = parent.parentNode;
      }
    } while (parent && parent.nodeType !== 1 && parent.nodeType !== 9);

    return parent;
  }
};
each(['Width', 'Height'], function (name) {
  domUtils["doc".concat(name)] = function (refWin) {
    var d = refWin.document;
    return Math.max( // firefox chrome documentElement.scrollHeight< body.scrollHeight
    // ie standard mode : documentElement.scrollHeight> body.scrollHeight
    d.documentElement["scroll".concat(name)], // quirks : documentElement.scrollHeight 最大等于可视窗口多一点？
    d.body["scroll".concat(name)], domUtils["viewport".concat(name)](d));
  };

  domUtils["viewport".concat(name)] = function (win) {
    // pc browser includes scrollbar in window.innerWidth
    var prop = "client".concat(name);
    var doc = win.document;
    var body = doc.body;
    var documentElement = doc.documentElement;
    var documentElementProp = documentElement[prop]; // 标准模式取 documentElement
    // backcompat 取 body

    return doc.compatMode === 'CSS1Compat' && documentElementProp || body && body[prop] || documentElementProp;
  };
});
/*
 得到元素的大小信息
 @param elem
 @param name
 @param {String} [extra]  'padding' : (css width) + padding
 'border' : (css width) + padding + border
 'margin' : (css width) + padding + border + margin
 */

function getWH(elem, name, ex) {
  var extra = ex;

  if (isWindow(elem)) {
    return name === 'width' ? domUtils.viewportWidth(elem) : domUtils.viewportHeight(elem);
  } else if (elem.nodeType === 9) {
    return name === 'width' ? domUtils.docWidth(elem) : domUtils.docHeight(elem);
  }

  var which = name === 'width' ? ['Left', 'Right'] : ['Top', 'Bottom'];
  var borderBoxValue = name === 'width' ? elem.getBoundingClientRect().width : elem.getBoundingClientRect().height;
  var isBorderBox = isBorderBoxFn(elem);
  var cssBoxValue = 0;

  if (borderBoxValue === null || borderBoxValue === undefined || borderBoxValue <= 0) {
    borderBoxValue = undefined; // Fall back to computed then un computed css if necessary

    cssBoxValue = getComputedStyleX(elem, name);

    if (cssBoxValue === null || cssBoxValue === undefined || Number(cssBoxValue) < 0) {
      cssBoxValue = elem.style[name] || 0;
    } // Normalize '', auto, and prepare for extra


    cssBoxValue = parseFloat(cssBoxValue) || 0;
  }

  if (extra === undefined) {
    extra = isBorderBox ? BORDER_INDEX : CONTENT_INDEX;
  }

  var borderBoxValueOrIsBorderBox = borderBoxValue !== undefined || isBorderBox;
  var val = borderBoxValue || cssBoxValue;

  if (extra === CONTENT_INDEX) {
    if (borderBoxValueOrIsBorderBox) {
      return val - getPBMWidth(elem, ['border', 'padding'], which);
    }

    return cssBoxValue;
  } else if (borderBoxValueOrIsBorderBox) {
    if (extra === BORDER_INDEX) {
      return val;
    }

    return val + (extra === PADDING_INDEX ? -getPBMWidth(elem, ['border'], which) : getPBMWidth(elem, ['margin'], which));
  }

  return cssBoxValue + getPBMWidth(elem, BOX_MODELS.slice(extra), which);
}

var cssShow = {
  position: 'absolute',
  visibility: 'hidden',
  display: 'block'
}; // fix #119 : https://github.com/kissyteam/kissy/issues/119

function getWHIgnoreDisplay() {
  for (var _len = arguments.length, args = new Array(_len), _key2 = 0; _key2 < _len; _key2++) {
    args[_key2] = arguments[_key2];
  }

  var val;
  var elem = args[0]; // in case elem is window
  // elem.offsetWidth === undefined

  if (elem.offsetWidth !== 0) {
    val = getWH.apply(undefined, args);
  } else {
    swap(elem, cssShow, function () {
      val = getWH.apply(undefined, args);
    });
  }

  return val;
}

each(['width', 'height'], function (name) {
  var first = name.charAt(0).toUpperCase() + name.slice(1);

  domUtils["outer".concat(first)] = function (el, includeMargin) {
    return el && getWHIgnoreDisplay(el, name, includeMargin ? MARGIN_INDEX : BORDER_INDEX);
  };

  var which = name === 'width' ? ['Left', 'Right'] : ['Top', 'Bottom'];

  domUtils[name] = function (elem, v) {
    var val = v;

    if (val !== undefined) {
      if (elem) {
        var isBorderBox = isBorderBoxFn(elem);

        if (isBorderBox) {
          val += getPBMWidth(elem, ['padding', 'border'], which);
        }

        return css(elem, name, val);
      }

      return undefined;
    }

    return elem && getWHIgnoreDisplay(elem, name, CONTENT_INDEX);
  };
});

function mix(to, from) {
  for (var i in from) {
    if (from.hasOwnProperty(i)) {
      to[i] = from[i];
    }
  }

  return to;
}

var utils = {
  getWindow: function getWindow(node) {
    if (node && node.document && node.setTimeout) {
      return node;
    }

    var doc = node.ownerDocument || node;
    return doc.defaultView || doc.parentWindow;
  },
  getDocument: getDocument,
  offset: function offset(el, value, option) {
    if (typeof value !== 'undefined') {
      setOffset(el, value, option || {});
    } else {
      return getOffset(el);
    }
  },
  isWindow: isWindow,
  each: each,
  css: css,
  clone: function clone(obj) {
    var i;
    var ret = {};

    for (i in obj) {
      if (obj.hasOwnProperty(i)) {
        ret[i] = obj[i];
      }
    }

    var overflow = obj.overflow;

    if (overflow) {
      for (i in obj) {
        if (obj.hasOwnProperty(i)) {
          ret.overflow[i] = obj.overflow[i];
        }
      }
    }

    return ret;
  },
  mix: mix,
  getWindowScrollLeft: function getWindowScrollLeft(w) {
    return getScrollLeft(w);
  },
  getWindowScrollTop: function getWindowScrollTop(w) {
    return getScrollTop(w);
  },
  merge: function merge() {
    var ret = {};

    for (var i = 0; i < arguments.length; i++) {
      utils.mix(ret, i < 0 || arguments.length <= i ? undefined : arguments[i]);
    }

    return ret;
  },
  viewportWidth: 0,
  viewportHeight: 0
};
mix(utils, domUtils);

/**
 * 得到会导致元素显示不全的祖先元素
 */

var getParent = utils.getParent;

function getOffsetParent(element) {
  if (utils.isWindow(element) || element.nodeType === 9) {
    return null;
  } // ie 这个也不是完全可行

  /*
   <div style="width: 50px;height: 100px;overflow: hidden">
   <div style="width: 50px;height: 100px;position: relative;" id="d6">
   元素 6 高 100px 宽 50px<br/>
   </div>
   </div>
   */
  // element.offsetParent does the right thing in ie7 and below. Return parent with layout!
  //  In other browsers it only includes elements with position absolute, relative or
  // fixed, not elements with overflow set to auto or scroll.
  //        if (UA.ie && ieMode < 8) {
  //            return element.offsetParent;
  //        }
  // 统一的 offsetParent 方法


  var doc = utils.getDocument(element);
  var body = doc.body;
  var parent;
  var positionStyle = utils.css(element, 'position');
  var skipStatic = positionStyle === 'fixed' || positionStyle === 'absolute';

  if (!skipStatic) {
    return element.nodeName.toLowerCase() === 'html' ? null : getParent(element);
  }

  for (parent = getParent(element); parent && parent !== body && parent.nodeType !== 9; parent = getParent(parent)) {
    positionStyle = utils.css(parent, 'position');

    if (positionStyle !== 'static') {
      return parent;
    }
  }

  return null;
}

var getParent$1 = utils.getParent;
function isAncestorFixed(element) {
  if (utils.isWindow(element) || element.nodeType === 9) {
    return false;
  }

  var doc = utils.getDocument(element);
  var body = doc.body;
  var parent = null;

  for (parent = getParent$1(element); // 修复元素位于 document.documentElement 下导致崩溃问题
  parent && parent !== body && parent !== doc; parent = getParent$1(parent)) {
    var positionStyle = utils.css(parent, 'position');

    if (positionStyle === 'fixed') {
      return true;
    }
  }

  return false;
}

/**
 * 获得元素的显示部分的区域
 */

function getVisibleRectForElement(element, alwaysByViewport) {
  var visibleRect = {
    left: 0,
    right: Infinity,
    top: 0,
    bottom: Infinity
  };
  var el = getOffsetParent(element);
  var doc = utils.getDocument(element);
  var win = doc.defaultView || doc.parentWindow;
  var body = doc.body;
  var documentElement = doc.documentElement; // Determine the size of the visible rect by climbing the dom accounting for
  // all scrollable containers.

  while (el) {
    // clientWidth is zero for inline block elements in ie.
    if ((navigator.userAgent.indexOf('MSIE') === -1 || el.clientWidth !== 0) && // body may have overflow set on it, yet we still get the entire
    // viewport. In some browsers, el.offsetParent may be
    // document.documentElement, so check for that too.
    el !== body && el !== documentElement && utils.css(el, 'overflow') !== 'visible') {
      var pos = utils.offset(el); // add border

      pos.left += el.clientLeft;
      pos.top += el.clientTop;
      visibleRect.top = Math.max(visibleRect.top, pos.top);
      visibleRect.right = Math.min(visibleRect.right, // consider area without scrollBar
      pos.left + el.clientWidth);
      visibleRect.bottom = Math.min(visibleRect.bottom, pos.top + el.clientHeight);
      visibleRect.left = Math.max(visibleRect.left, pos.left);
    } else if (el === body || el === documentElement) {
      break;
    }

    el = getOffsetParent(el);
  } // Set element position to fixed
  // make sure absolute element itself don't affect it's visible area
  // https://github.com/ant-design/ant-design/issues/7601


  var originalPosition = null;

  if (!utils.isWindow(element) && element.nodeType !== 9) {
    originalPosition = element.style.position;
    var position = utils.css(element, 'position');

    if (position === 'absolute') {
      element.style.position = 'fixed';
    }
  }

  var scrollX = utils.getWindowScrollLeft(win);
  var scrollY = utils.getWindowScrollTop(win);
  var viewportWidth = utils.viewportWidth(win);
  var viewportHeight = utils.viewportHeight(win);
  var documentWidth = documentElement.scrollWidth;
  var documentHeight = documentElement.scrollHeight; // scrollXXX on html is sync with body which means overflow: hidden on body gets wrong scrollXXX.
  // We should cut this ourself.

  var bodyStyle = window.getComputedStyle(body);

  if (bodyStyle.overflowX === 'hidden') {
    documentWidth = win.innerWidth;
  }

  if (bodyStyle.overflowY === 'hidden') {
    documentHeight = win.innerHeight;
  } // Reset element position after calculate the visible area


  if (element.style) {
    element.style.position = originalPosition;
  }

  if (alwaysByViewport || isAncestorFixed(element)) {
    // Clip by viewport's size.
    visibleRect.left = Math.max(visibleRect.left, scrollX);
    visibleRect.top = Math.max(visibleRect.top, scrollY);
    visibleRect.right = Math.min(visibleRect.right, scrollX + viewportWidth);
    visibleRect.bottom = Math.min(visibleRect.bottom, scrollY + viewportHeight);
  } else {
    // Clip by document's size.
    var maxVisibleWidth = Math.max(documentWidth, scrollX + viewportWidth);
    visibleRect.right = Math.min(visibleRect.right, maxVisibleWidth);
    var maxVisibleHeight = Math.max(documentHeight, scrollY + viewportHeight);
    visibleRect.bottom = Math.min(visibleRect.bottom, maxVisibleHeight);
  }

  return visibleRect.top >= 0 && visibleRect.left >= 0 && visibleRect.bottom > visibleRect.top && visibleRect.right > visibleRect.left ? visibleRect : null;
}

function adjustForViewport(elFuturePos, elRegion, visibleRect, overflow) {
  var pos = utils.clone(elFuturePos);
  var size = {
    width: elRegion.width,
    height: elRegion.height
  };

  if (overflow.adjustX && pos.left < visibleRect.left) {
    pos.left = visibleRect.left;
  } // Left edge inside and right edge outside viewport, try to resize it.


  if (overflow.resizeWidth && pos.left >= visibleRect.left && pos.left + size.width > visibleRect.right) {
    size.width -= pos.left + size.width - visibleRect.right;
  } // Right edge outside viewport, try to move it.


  if (overflow.adjustX && pos.left + size.width > visibleRect.right) {
    // 保证左边界和可视区域左边界对齐
    pos.left = Math.max(visibleRect.right - size.width, visibleRect.left);
  } // Top edge outside viewport, try to move it.


  if (overflow.adjustY && pos.top < visibleRect.top) {
    pos.top = visibleRect.top;
  } // Top edge inside and bottom edge outside viewport, try to resize it.


  if (overflow.resizeHeight && pos.top >= visibleRect.top && pos.top + size.height > visibleRect.bottom) {
    size.height -= pos.top + size.height - visibleRect.bottom;
  } // Bottom edge outside viewport, try to move it.


  if (overflow.adjustY && pos.top + size.height > visibleRect.bottom) {
    // 保证上边界和可视区域上边界对齐
    pos.top = Math.max(visibleRect.bottom - size.height, visibleRect.top);
  }

  return utils.mix(pos, size);
}

function getRegion(node) {
  var offset;
  var w;
  var h;

  if (!utils.isWindow(node) && node.nodeType !== 9) {
    offset = utils.offset(node);
    w = utils.outerWidth(node);
    h = utils.outerHeight(node);
  } else {
    var win = utils.getWindow(node);
    offset = {
      left: utils.getWindowScrollLeft(win),
      top: utils.getWindowScrollTop(win)
    };
    w = utils.viewportWidth(win);
    h = utils.viewportHeight(win);
  }

  offset.width = w;
  offset.height = h;
  return offset;
}

/**
 * 获取 node 上的 align 对齐点 相对于页面的坐标
 */
function getAlignOffset(region, align) {
  var V = align.charAt(0);
  var H = align.charAt(1);
  var w = region.width;
  var h = region.height;
  var x = region.left;
  var y = region.top;

  if (V === 'c') {
    y += h / 2;
  } else if (V === 'b') {
    y += h;
  }

  if (H === 'c') {
    x += w / 2;
  } else if (H === 'r') {
    x += w;
  }

  return {
    left: x,
    top: y
  };
}

function getElFuturePos(elRegion, refNodeRegion, points, offset, targetOffset) {
  var p1 = getAlignOffset(refNodeRegion, points[1]);
  var p2 = getAlignOffset(elRegion, points[0]);
  var diff = [p2.left - p1.left, p2.top - p1.top];
  return {
    left: Math.round(elRegion.left - diff[0] + offset[0] - targetOffset[0]),
    top: Math.round(elRegion.top - diff[1] + offset[1] - targetOffset[1])
  };
}

/**
 * align dom node flexibly
 * @author yiminghe@gmail.com
 */

function isFailX(elFuturePos, elRegion, visibleRect) {
  return elFuturePos.left < visibleRect.left || elFuturePos.left + elRegion.width > visibleRect.right;
}

function isFailY(elFuturePos, elRegion, visibleRect) {
  return elFuturePos.top < visibleRect.top || elFuturePos.top + elRegion.height > visibleRect.bottom;
}

function isCompleteFailX(elFuturePos, elRegion, visibleRect) {
  return elFuturePos.left > visibleRect.right || elFuturePos.left + elRegion.width < visibleRect.left;
}

function isCompleteFailY(elFuturePos, elRegion, visibleRect) {
  return elFuturePos.top > visibleRect.bottom || elFuturePos.top + elRegion.height < visibleRect.top;
}

function flip(points, reg, map) {
  var ret = [];
  utils.each(points, function (p) {
    ret.push(p.replace(reg, function (m) {
      return map[m];
    }));
  });
  return ret;
}

function flipOffset(offset, index) {
  offset[index] = -offset[index];
  return offset;
}

function convertOffset(str, offsetLen) {
  var n;

  if (/%$/.test(str)) {
    n = parseInt(str.substring(0, str.length - 1), 10) / 100 * offsetLen;
  } else {
    n = parseInt(str, 10);
  }

  return n || 0;
}

function normalizeOffset(offset, el) {
  offset[0] = convertOffset(offset[0], el.width);
  offset[1] = convertOffset(offset[1], el.height);
}
/**
 * @param el
 * @param tgtRegion 参照节点所占的区域: { left, top, width, height }
 * @param align
 */


function doAlign(el, tgtRegion, align, isTgtRegionVisible) {
  var points = align.points;
  var offset = align.offset || [0, 0];
  var targetOffset = align.targetOffset || [0, 0];
  var overflow = align.overflow;
  var source = align.source || el;
  offset = [].concat(offset);
  targetOffset = [].concat(targetOffset);
  overflow = overflow || {};
  var newOverflowCfg = {};
  var fail = 0;
  var alwaysByViewport = !!(overflow && overflow.alwaysByViewport); // 当前节点可以被放置的显示区域

  var visibleRect = getVisibleRectForElement(source, alwaysByViewport); // 当前节点所占的区域, left/top/width/height

  var elRegion = getRegion(source); // 将 offset 转换成数值，支持百分比

  normalizeOffset(offset, elRegion);
  normalizeOffset(targetOffset, tgtRegion); // 当前节点将要被放置的位置

  var elFuturePos = getElFuturePos(elRegion, tgtRegion, points, offset, targetOffset); // 当前节点将要所处的区域

  var newElRegion = utils.merge(elRegion, elFuturePos); // 如果可视区域不能完全放置当前节点时允许调整

  if (visibleRect && (overflow.adjustX || overflow.adjustY) && isTgtRegionVisible) {
    if (overflow.adjustX) {
      // 如果横向不能放下
      if (isFailX(elFuturePos, elRegion, visibleRect)) {
        // 对齐位置反下
        var newPoints = flip(points, /[lr]/gi, {
          l: 'r',
          r: 'l'
        }); // 偏移量也反下

        var newOffset = flipOffset(offset, 0);
        var newTargetOffset = flipOffset(targetOffset, 0);
        var newElFuturePos = getElFuturePos(elRegion, tgtRegion, newPoints, newOffset, newTargetOffset);

        if (!isCompleteFailX(newElFuturePos, elRegion, visibleRect)) {
          fail = 1;
          points = newPoints;
          offset = newOffset;
          targetOffset = newTargetOffset;
        }
      }
    }

    if (overflow.adjustY) {
      // 如果纵向不能放下
      if (isFailY(elFuturePos, elRegion, visibleRect)) {
        // 对齐位置反下
        var _newPoints = flip(points, /[tb]/gi, {
          t: 'b',
          b: 't'
        }); // 偏移量也反下


        var _newOffset = flipOffset(offset, 1);

        var _newTargetOffset = flipOffset(targetOffset, 1);

        var _newElFuturePos = getElFuturePos(elRegion, tgtRegion, _newPoints, _newOffset, _newTargetOffset);

        if (!isCompleteFailY(_newElFuturePos, elRegion, visibleRect)) {
          fail = 1;
          points = _newPoints;
          offset = _newOffset;
          targetOffset = _newTargetOffset;
        }
      }
    } // 如果失败，重新计算当前节点将要被放置的位置


    if (fail) {
      elFuturePos = getElFuturePos(elRegion, tgtRegion, points, offset, targetOffset);
      utils.mix(newElRegion, elFuturePos);
    }

    var isStillFailX = isFailX(elFuturePos, elRegion, visibleRect);
    var isStillFailY = isFailY(elFuturePos, elRegion, visibleRect); // 检查反下后的位置是否可以放下了，如果仍然放不下：
    // 1. 复原修改过的定位参数

    if (isStillFailX || isStillFailY) {
      var _newPoints2 = points; // 重置对应部分的翻转逻辑

      if (isStillFailX) {
        _newPoints2 = flip(points, /[lr]/gi, {
          l: 'r',
          r: 'l'
        });
      }

      if (isStillFailY) {
        _newPoints2 = flip(points, /[tb]/gi, {
          t: 'b',
          b: 't'
        });
      }

      points = _newPoints2;
      offset = align.offset || [0, 0];
      targetOffset = align.targetOffset || [0, 0];
    } // 2. 只有指定了可以调整当前方向才调整


    newOverflowCfg.adjustX = overflow.adjustX && isStillFailX;
    newOverflowCfg.adjustY = overflow.adjustY && isStillFailY; // 确实要调整，甚至可能会调整高度宽度

    if (newOverflowCfg.adjustX || newOverflowCfg.adjustY) {
      newElRegion = adjustForViewport(elFuturePos, elRegion, visibleRect, newOverflowCfg);
    }
  } // need judge to in case set fixed with in css on height auto element


  if (newElRegion.width !== elRegion.width) {
    utils.css(source, 'width', utils.width(source) + newElRegion.width - elRegion.width);
  }

  if (newElRegion.height !== elRegion.height) {
    utils.css(source, 'height', utils.height(source) + newElRegion.height - elRegion.height);
  } // https://github.com/kissyteam/kissy/issues/190
  // 相对于屏幕位置没变，而 left/top 变了
  // 例如 <div 'relative'><el absolute></div>


  utils.offset(source, {
    left: newElRegion.left,
    top: newElRegion.top
  }, {
    useCssRight: align.useCssRight,
    useCssBottom: align.useCssBottom,
    useCssTransform: align.useCssTransform,
    ignoreShake: align.ignoreShake
  });
  return {
    points: points,
    offset: offset,
    targetOffset: targetOffset,
    overflow: newOverflowCfg
  };
}
/**
 *  2012-04-26 yiminghe@gmail.com
 *   - 优化智能对齐算法
 *   - 慎用 resizeXX
 *
 *  2011-07-13 yiminghe@gmail.com note:
 *   - 增加智能对齐，以及大小调整选项
 **/

function isOutOfVisibleRect(target, alwaysByViewport) {
  var visibleRect = getVisibleRectForElement(target, alwaysByViewport);
  var targetRegion = getRegion(target);
  return !visibleRect || targetRegion.left + targetRegion.width <= visibleRect.left || targetRegion.top + targetRegion.height <= visibleRect.top || targetRegion.left >= visibleRect.right || targetRegion.top >= visibleRect.bottom;
}

function alignElement(el, refNode, align) {
  var target = align.target || refNode;
  var refNodeRegion = getRegion(target);
  var isTargetNotOutOfVisible = !isOutOfVisibleRect(target, align.overflow && align.overflow.alwaysByViewport);
  return doAlign(el, refNodeRegion, align, isTargetNotOutOfVisible);
}

alignElement.__getOffsetParent = getOffsetParent;
alignElement.__getVisibleRectForElement = getVisibleRectForElement;

/**
 * `tgtPoint`: { pageX, pageY } or { clientX, clientY }.
 * If client position provided, will internal convert to page position.
 */

function alignPoint(el, tgtPoint, align) {
  var pageX;
  var pageY;
  var doc = utils.getDocument(el);
  var win = doc.defaultView || doc.parentWindow;
  var scrollX = utils.getWindowScrollLeft(win);
  var scrollY = utils.getWindowScrollTop(win);
  var viewportWidth = utils.viewportWidth(win);
  var viewportHeight = utils.viewportHeight(win);

  if ('pageX' in tgtPoint) {
    pageX = tgtPoint.pageX;
  } else {
    pageX = scrollX + tgtPoint.clientX;
  }

  if ('pageY' in tgtPoint) {
    pageY = tgtPoint.pageY;
  } else {
    pageY = scrollY + tgtPoint.clientY;
  }

  var tgtRegion = {
    left: pageX,
    top: pageY,
    width: 0,
    height: 0
  };
  var pointInView = pageX >= 0 && pageX <= scrollX + viewportWidth && pageY >= 0 && pageY <= scrollY + viewportHeight; // Provide default target point

  var points = [align.points[0], 'cc'];
  return doAlign(el, tgtRegion, _objectSpread2(_objectSpread2({}, align), {}, {
    points: points
  }), pointInView);
}/**
 * A collection of shims that provide minimal functionality of the ES6 collections.
 *
 * These implementations are not meant to be used outside of the ResizeObserver
 * modules as they cover only a limited range of use cases.
 */
/* eslint-disable require-jsdoc, valid-jsdoc */
var MapShim = (function () {
    if (typeof Map !== 'undefined') {
        return Map;
    }
    /**
     * Returns index in provided array that matches the specified key.
     *
     * @param {Array<Array>} arr
     * @param {*} key
     * @returns {number}
     */
    function getIndex(arr, key) {
        var result = -1;
        arr.some(function (entry, index) {
            if (entry[0] === key) {
                result = index;
                return true;
            }
            return false;
        });
        return result;
    }
    return /** @class */ (function () {
        function class_1() {
            this.__entries__ = [];
        }
        Object.defineProperty(class_1.prototype, "size", {
            /**
             * @returns {boolean}
             */
            get: function () {
                return this.__entries__.length;
            },
            enumerable: true,
            configurable: true
        });
        /**
         * @param {*} key
         * @returns {*}
         */
        class_1.prototype.get = function (key) {
            var index = getIndex(this.__entries__, key);
            var entry = this.__entries__[index];
            return entry && entry[1];
        };
        /**
         * @param {*} key
         * @param {*} value
         * @returns {void}
         */
        class_1.prototype.set = function (key, value) {
            var index = getIndex(this.__entries__, key);
            if (~index) {
                this.__entries__[index][1] = value;
            }
            else {
                this.__entries__.push([key, value]);
            }
        };
        /**
         * @param {*} key
         * @returns {void}
         */
        class_1.prototype.delete = function (key) {
            var entries = this.__entries__;
            var index = getIndex(entries, key);
            if (~index) {
                entries.splice(index, 1);
            }
        };
        /**
         * @param {*} key
         * @returns {void}
         */
        class_1.prototype.has = function (key) {
            return !!~getIndex(this.__entries__, key);
        };
        /**
         * @returns {void}
         */
        class_1.prototype.clear = function () {
            this.__entries__.splice(0);
        };
        /**
         * @param {Function} callback
         * @param {*} [ctx=null]
         * @returns {void}
         */
        class_1.prototype.forEach = function (callback, ctx) {
            if (ctx === void 0) { ctx = null; }
            for (var _i = 0, _a = this.__entries__; _i < _a.length; _i++) {
                var entry = _a[_i];
                callback.call(ctx, entry[1], entry[0]);
            }
        };
        return class_1;
    }());
})();

/**
 * Detects whether window and document objects are available in current environment.
 */
var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined' && window.document === document;

// Returns global object of a current environment.
var global$1 = (function () {
    if (typeof global !== 'undefined' && global.Math === Math) {
        return global;
    }
    if (typeof self !== 'undefined' && self.Math === Math) {
        return self;
    }
    if (typeof window !== 'undefined' && window.Math === Math) {
        return window;
    }
    // eslint-disable-next-line no-new-func
    return Function('return this')();
})();

/**
 * A shim for the requestAnimationFrame which falls back to the setTimeout if
 * first one is not supported.
 *
 * @returns {number} Requests' identifier.
 */
var requestAnimationFrame$1 = (function () {
    if (typeof requestAnimationFrame === 'function') {
        // It's required to use a bounded function because IE sometimes throws
        // an "Invalid calling object" error if rAF is invoked without the global
        // object on the left hand side.
        return requestAnimationFrame.bind(global$1);
    }
    return function (callback) { return setTimeout(function () { return callback(Date.now()); }, 1000 / 60); };
})();

// Defines minimum timeout before adding a trailing call.
var trailingTimeout = 2;
/**
 * Creates a wrapper function which ensures that provided callback will be
 * invoked only once during the specified delay period.
 *
 * @param {Function} callback - Function to be invoked after the delay period.
 * @param {number} delay - Delay after which to invoke callback.
 * @returns {Function}
 */
function throttle (callback, delay) {
    var leadingCall = false, trailingCall = false, lastCallTime = 0;
    /**
     * Invokes the original callback function and schedules new invocation if
     * the "proxy" was called during current request.
     *
     * @returns {void}
     */
    function resolvePending() {
        if (leadingCall) {
            leadingCall = false;
            callback();
        }
        if (trailingCall) {
            proxy();
        }
    }
    /**
     * Callback invoked after the specified delay. It will further postpone
     * invocation of the original function delegating it to the
     * requestAnimationFrame.
     *
     * @returns {void}
     */
    function timeoutCallback() {
        requestAnimationFrame$1(resolvePending);
    }
    /**
     * Schedules invocation of the original function.
     *
     * @returns {void}
     */
    function proxy() {
        var timeStamp = Date.now();
        if (leadingCall) {
            // Reject immediately following calls.
            if (timeStamp - lastCallTime < trailingTimeout) {
                return;
            }
            // Schedule new call to be in invoked when the pending one is resolved.
            // This is important for "transitions" which never actually start
            // immediately so there is a chance that we might miss one if change
            // happens amids the pending invocation.
            trailingCall = true;
        }
        else {
            leadingCall = true;
            trailingCall = false;
            setTimeout(timeoutCallback, delay);
        }
        lastCallTime = timeStamp;
    }
    return proxy;
}

// Minimum delay before invoking the update of observers.
var REFRESH_DELAY = 20;
// A list of substrings of CSS properties used to find transition events that
// might affect dimensions of observed elements.
var transitionKeys = ['top', 'right', 'bottom', 'left', 'width', 'height', 'size', 'weight'];
// Check if MutationObserver is available.
var mutationObserverSupported = typeof MutationObserver !== 'undefined';
/**
 * Singleton controller class which handles updates of ResizeObserver instances.
 */
var ResizeObserverController = /** @class */ (function () {
    /**
     * Creates a new instance of ResizeObserverController.
     *
     * @private
     */
    function ResizeObserverController() {
        /**
         * Indicates whether DOM listeners have been added.
         *
         * @private {boolean}
         */
        this.connected_ = false;
        /**
         * Tells that controller has subscribed for Mutation Events.
         *
         * @private {boolean}
         */
        this.mutationEventsAdded_ = false;
        /**
         * Keeps reference to the instance of MutationObserver.
         *
         * @private {MutationObserver}
         */
        this.mutationsObserver_ = null;
        /**
         * A list of connected observers.
         *
         * @private {Array<ResizeObserverSPI>}
         */
        this.observers_ = [];
        this.onTransitionEnd_ = this.onTransitionEnd_.bind(this);
        this.refresh = throttle(this.refresh.bind(this), REFRESH_DELAY);
    }
    /**
     * Adds observer to observers list.
     *
     * @param {ResizeObserverSPI} observer - Observer to be added.
     * @returns {void}
     */
    ResizeObserverController.prototype.addObserver = function (observer) {
        if (!~this.observers_.indexOf(observer)) {
            this.observers_.push(observer);
        }
        // Add listeners if they haven't been added yet.
        if (!this.connected_) {
            this.connect_();
        }
    };
    /**
     * Removes observer from observers list.
     *
     * @param {ResizeObserverSPI} observer - Observer to be removed.
     * @returns {void}
     */
    ResizeObserverController.prototype.removeObserver = function (observer) {
        var observers = this.observers_;
        var index = observers.indexOf(observer);
        // Remove observer if it's present in registry.
        if (~index) {
            observers.splice(index, 1);
        }
        // Remove listeners if controller has no connected observers.
        if (!observers.length && this.connected_) {
            this.disconnect_();
        }
    };
    /**
     * Invokes the update of observers. It will continue running updates insofar
     * it detects changes.
     *
     * @returns {void}
     */
    ResizeObserverController.prototype.refresh = function () {
        var changesDetected = this.updateObservers_();
        // Continue running updates if changes have been detected as there might
        // be future ones caused by CSS transitions.
        if (changesDetected) {
            this.refresh();
        }
    };
    /**
     * Updates every observer from observers list and notifies them of queued
     * entries.
     *
     * @private
     * @returns {boolean} Returns "true" if any observer has detected changes in
     *      dimensions of it's elements.
     */
    ResizeObserverController.prototype.updateObservers_ = function () {
        // Collect observers that have active observations.
        var activeObservers = this.observers_.filter(function (observer) {
            return observer.gatherActive(), observer.hasActive();
        });
        // Deliver notifications in a separate cycle in order to avoid any
        // collisions between observers, e.g. when multiple instances of
        // ResizeObserver are tracking the same element and the callback of one
        // of them changes content dimensions of the observed target. Sometimes
        // this may result in notifications being blocked for the rest of observers.
        activeObservers.forEach(function (observer) { return observer.broadcastActive(); });
        return activeObservers.length > 0;
    };
    /**
     * Initializes DOM listeners.
     *
     * @private
     * @returns {void}
     */
    ResizeObserverController.prototype.connect_ = function () {
        // Do nothing if running in a non-browser environment or if listeners
        // have been already added.
        if (!isBrowser || this.connected_) {
            return;
        }
        // Subscription to the "Transitionend" event is used as a workaround for
        // delayed transitions. This way it's possible to capture at least the
        // final state of an element.
        document.addEventListener('transitionend', this.onTransitionEnd_);
        window.addEventListener('resize', this.refresh);
        if (mutationObserverSupported) {
            this.mutationsObserver_ = new MutationObserver(this.refresh);
            this.mutationsObserver_.observe(document, {
                attributes: true,
                childList: true,
                characterData: true,
                subtree: true
            });
        }
        else {
            document.addEventListener('DOMSubtreeModified', this.refresh);
            this.mutationEventsAdded_ = true;
        }
        this.connected_ = true;
    };
    /**
     * Removes DOM listeners.
     *
     * @private
     * @returns {void}
     */
    ResizeObserverController.prototype.disconnect_ = function () {
        // Do nothing if running in a non-browser environment or if listeners
        // have been already removed.
        if (!isBrowser || !this.connected_) {
            return;
        }
        document.removeEventListener('transitionend', this.onTransitionEnd_);
        window.removeEventListener('resize', this.refresh);
        if (this.mutationsObserver_) {
            this.mutationsObserver_.disconnect();
        }
        if (this.mutationEventsAdded_) {
            document.removeEventListener('DOMSubtreeModified', this.refresh);
        }
        this.mutationsObserver_ = null;
        this.mutationEventsAdded_ = false;
        this.connected_ = false;
    };
    /**
     * "Transitionend" event handler.
     *
     * @private
     * @param {TransitionEvent} event
     * @returns {void}
     */
    ResizeObserverController.prototype.onTransitionEnd_ = function (_a) {
        var _b = _a.propertyName, propertyName = _b === void 0 ? '' : _b;
        // Detect whether transition may affect dimensions of an element.
        var isReflowProperty = transitionKeys.some(function (key) {
            return !!~propertyName.indexOf(key);
        });
        if (isReflowProperty) {
            this.refresh();
        }
    };
    /**
     * Returns instance of the ResizeObserverController.
     *
     * @returns {ResizeObserverController}
     */
    ResizeObserverController.getInstance = function () {
        if (!this.instance_) {
            this.instance_ = new ResizeObserverController();
        }
        return this.instance_;
    };
    /**
     * Holds reference to the controller's instance.
     *
     * @private {ResizeObserverController}
     */
    ResizeObserverController.instance_ = null;
    return ResizeObserverController;
}());

/**
 * Defines non-writable/enumerable properties of the provided target object.
 *
 * @param {Object} target - Object for which to define properties.
 * @param {Object} props - Properties to be defined.
 * @returns {Object} Target object.
 */
var defineConfigurable = (function (target, props) {
    for (var _i = 0, _a = Object.keys(props); _i < _a.length; _i++) {
        var key = _a[_i];
        Object.defineProperty(target, key, {
            value: props[key],
            enumerable: false,
            writable: false,
            configurable: true
        });
    }
    return target;
});

/**
 * Returns the global object associated with provided element.
 *
 * @param {Object} target
 * @returns {Object}
 */
var getWindowOf = (function (target) {
    // Assume that the element is an instance of Node, which means that it
    // has the "ownerDocument" property from which we can retrieve a
    // corresponding global object.
    var ownerGlobal = target && target.ownerDocument && target.ownerDocument.defaultView;
    // Return the local global object if it's not possible extract one from
    // provided element.
    return ownerGlobal || global$1;
});

// Placeholder of an empty content rectangle.
var emptyRect = createRectInit(0, 0, 0, 0);
/**
 * Converts provided string to a number.
 *
 * @param {number|string} value
 * @returns {number}
 */
function toFloat(value) {
    return parseFloat(value) || 0;
}
/**
 * Extracts borders size from provided styles.
 *
 * @param {CSSStyleDeclaration} styles
 * @param {...string} positions - Borders positions (top, right, ...)
 * @returns {number}
 */
function getBordersSize(styles) {
    var positions = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        positions[_i - 1] = arguments[_i];
    }
    return positions.reduce(function (size, position) {
        var value = styles['border-' + position + '-width'];
        return size + toFloat(value);
    }, 0);
}
/**
 * Extracts paddings sizes from provided styles.
 *
 * @param {CSSStyleDeclaration} styles
 * @returns {Object} Paddings box.
 */
function getPaddings(styles) {
    var positions = ['top', 'right', 'bottom', 'left'];
    var paddings = {};
    for (var _i = 0, positions_1 = positions; _i < positions_1.length; _i++) {
        var position = positions_1[_i];
        var value = styles['padding-' + position];
        paddings[position] = toFloat(value);
    }
    return paddings;
}
/**
 * Calculates content rectangle of provided SVG element.
 *
 * @param {SVGGraphicsElement} target - Element content rectangle of which needs
 *      to be calculated.
 * @returns {DOMRectInit}
 */
function getSVGContentRect(target) {
    var bbox = target.getBBox();
    return createRectInit(0, 0, bbox.width, bbox.height);
}
/**
 * Calculates content rectangle of provided HTMLElement.
 *
 * @param {HTMLElement} target - Element for which to calculate the content rectangle.
 * @returns {DOMRectInit}
 */
function getHTMLElementContentRect(target) {
    // Client width & height properties can't be
    // used exclusively as they provide rounded values.
    var clientWidth = target.clientWidth, clientHeight = target.clientHeight;
    // By this condition we can catch all non-replaced inline, hidden and
    // detached elements. Though elements with width & height properties less
    // than 0.5 will be discarded as well.
    //
    // Without it we would need to implement separate methods for each of
    // those cases and it's not possible to perform a precise and performance
    // effective test for hidden elements. E.g. even jQuery's ':visible' filter
    // gives wrong results for elements with width & height less than 0.5.
    if (!clientWidth && !clientHeight) {
        return emptyRect;
    }
    var styles = getWindowOf(target).getComputedStyle(target);
    var paddings = getPaddings(styles);
    var horizPad = paddings.left + paddings.right;
    var vertPad = paddings.top + paddings.bottom;
    // Computed styles of width & height are being used because they are the
    // only dimensions available to JS that contain non-rounded values. It could
    // be possible to utilize the getBoundingClientRect if only it's data wasn't
    // affected by CSS transformations let alone paddings, borders and scroll bars.
    var width = toFloat(styles.width), height = toFloat(styles.height);
    // Width & height include paddings and borders when the 'border-box' box
    // model is applied (except for IE).
    if (styles.boxSizing === 'border-box') {
        // Following conditions are required to handle Internet Explorer which
        // doesn't include paddings and borders to computed CSS dimensions.
        //
        // We can say that if CSS dimensions + paddings are equal to the "client"
        // properties then it's either IE, and thus we don't need to subtract
        // anything, or an element merely doesn't have paddings/borders styles.
        if (Math.round(width + horizPad) !== clientWidth) {
            width -= getBordersSize(styles, 'left', 'right') + horizPad;
        }
        if (Math.round(height + vertPad) !== clientHeight) {
            height -= getBordersSize(styles, 'top', 'bottom') + vertPad;
        }
    }
    // Following steps can't be applied to the document's root element as its
    // client[Width/Height] properties represent viewport area of the window.
    // Besides, it's as well not necessary as the <html> itself neither has
    // rendered scroll bars nor it can be clipped.
    if (!isDocumentElement(target)) {
        // In some browsers (only in Firefox, actually) CSS width & height
        // include scroll bars size which can be removed at this step as scroll
        // bars are the only difference between rounded dimensions + paddings
        // and "client" properties, though that is not always true in Chrome.
        var vertScrollbar = Math.round(width + horizPad) - clientWidth;
        var horizScrollbar = Math.round(height + vertPad) - clientHeight;
        // Chrome has a rather weird rounding of "client" properties.
        // E.g. for an element with content width of 314.2px it sometimes gives
        // the client width of 315px and for the width of 314.7px it may give
        // 314px. And it doesn't happen all the time. So just ignore this delta
        // as a non-relevant.
        if (Math.abs(vertScrollbar) !== 1) {
            width -= vertScrollbar;
        }
        if (Math.abs(horizScrollbar) !== 1) {
            height -= horizScrollbar;
        }
    }
    return createRectInit(paddings.left, paddings.top, width, height);
}
/**
 * Checks whether provided element is an instance of the SVGGraphicsElement.
 *
 * @param {Element} target - Element to be checked.
 * @returns {boolean}
 */
var isSVGGraphicsElement = (function () {
    // Some browsers, namely IE and Edge, don't have the SVGGraphicsElement
    // interface.
    if (typeof SVGGraphicsElement !== 'undefined') {
        return function (target) { return target instanceof getWindowOf(target).SVGGraphicsElement; };
    }
    // If it's so, then check that element is at least an instance of the
    // SVGElement and that it has the "getBBox" method.
    // eslint-disable-next-line no-extra-parens
    return function (target) { return (target instanceof getWindowOf(target).SVGElement &&
        typeof target.getBBox === 'function'); };
})();
/**
 * Checks whether provided element is a document element (<html>).
 *
 * @param {Element} target - Element to be checked.
 * @returns {boolean}
 */
function isDocumentElement(target) {
    return target === getWindowOf(target).document.documentElement;
}
/**
 * Calculates an appropriate content rectangle for provided html or svg element.
 *
 * @param {Element} target - Element content rectangle of which needs to be calculated.
 * @returns {DOMRectInit}
 */
function getContentRect(target) {
    if (!isBrowser) {
        return emptyRect;
    }
    if (isSVGGraphicsElement(target)) {
        return getSVGContentRect(target);
    }
    return getHTMLElementContentRect(target);
}
/**
 * Creates rectangle with an interface of the DOMRectReadOnly.
 * Spec: https://drafts.fxtf.org/geometry/#domrectreadonly
 *
 * @param {DOMRectInit} rectInit - Object with rectangle's x/y coordinates and dimensions.
 * @returns {DOMRectReadOnly}
 */
function createReadOnlyRect(_a) {
    var x = _a.x, y = _a.y, width = _a.width, height = _a.height;
    // If DOMRectReadOnly is available use it as a prototype for the rectangle.
    var Constr = typeof DOMRectReadOnly !== 'undefined' ? DOMRectReadOnly : Object;
    var rect = Object.create(Constr.prototype);
    // Rectangle's properties are not writable and non-enumerable.
    defineConfigurable(rect, {
        x: x, y: y, width: width, height: height,
        top: y,
        right: x + width,
        bottom: height + y,
        left: x
    });
    return rect;
}
/**
 * Creates DOMRectInit object based on the provided dimensions and the x/y coordinates.
 * Spec: https://drafts.fxtf.org/geometry/#dictdef-domrectinit
 *
 * @param {number} x - X coordinate.
 * @param {number} y - Y coordinate.
 * @param {number} width - Rectangle's width.
 * @param {number} height - Rectangle's height.
 * @returns {DOMRectInit}
 */
function createRectInit(x, y, width, height) {
    return { x: x, y: y, width: width, height: height };
}

/**
 * Class that is responsible for computations of the content rectangle of
 * provided DOM element and for keeping track of it's changes.
 */
var ResizeObservation = /** @class */ (function () {
    /**
     * Creates an instance of ResizeObservation.
     *
     * @param {Element} target - Element to be observed.
     */
    function ResizeObservation(target) {
        /**
         * Broadcasted width of content rectangle.
         *
         * @type {number}
         */
        this.broadcastWidth = 0;
        /**
         * Broadcasted height of content rectangle.
         *
         * @type {number}
         */
        this.broadcastHeight = 0;
        /**
         * Reference to the last observed content rectangle.
         *
         * @private {DOMRectInit}
         */
        this.contentRect_ = createRectInit(0, 0, 0, 0);
        this.target = target;
    }
    /**
     * Updates content rectangle and tells whether it's width or height properties
     * have changed since the last broadcast.
     *
     * @returns {boolean}
     */
    ResizeObservation.prototype.isActive = function () {
        var rect = getContentRect(this.target);
        this.contentRect_ = rect;
        return (rect.width !== this.broadcastWidth ||
            rect.height !== this.broadcastHeight);
    };
    /**
     * Updates 'broadcastWidth' and 'broadcastHeight' properties with a data
     * from the corresponding properties of the last observed content rectangle.
     *
     * @returns {DOMRectInit} Last observed content rectangle.
     */
    ResizeObservation.prototype.broadcastRect = function () {
        var rect = this.contentRect_;
        this.broadcastWidth = rect.width;
        this.broadcastHeight = rect.height;
        return rect;
    };
    return ResizeObservation;
}());

var ResizeObserverEntry = /** @class */ (function () {
    /**
     * Creates an instance of ResizeObserverEntry.
     *
     * @param {Element} target - Element that is being observed.
     * @param {DOMRectInit} rectInit - Data of the element's content rectangle.
     */
    function ResizeObserverEntry(target, rectInit) {
        var contentRect = createReadOnlyRect(rectInit);
        // According to the specification following properties are not writable
        // and are also not enumerable in the native implementation.
        //
        // Property accessors are not being used as they'd require to define a
        // private WeakMap storage which may cause memory leaks in browsers that
        // don't support this type of collections.
        defineConfigurable(this, { target: target, contentRect: contentRect });
    }
    return ResizeObserverEntry;
}());

var ResizeObserverSPI = /** @class */ (function () {
    /**
     * Creates a new instance of ResizeObserver.
     *
     * @param {ResizeObserverCallback} callback - Callback function that is invoked
     *      when one of the observed elements changes it's content dimensions.
     * @param {ResizeObserverController} controller - Controller instance which
     *      is responsible for the updates of observer.
     * @param {ResizeObserver} callbackCtx - Reference to the public
     *      ResizeObserver instance which will be passed to callback function.
     */
    function ResizeObserverSPI(callback, controller, callbackCtx) {
        /**
         * Collection of resize observations that have detected changes in dimensions
         * of elements.
         *
         * @private {Array<ResizeObservation>}
         */
        this.activeObservations_ = [];
        /**
         * Registry of the ResizeObservation instances.
         *
         * @private {Map<Element, ResizeObservation>}
         */
        this.observations_ = new MapShim();
        if (typeof callback !== 'function') {
            throw new TypeError('The callback provided as parameter 1 is not a function.');
        }
        this.callback_ = callback;
        this.controller_ = controller;
        this.callbackCtx_ = callbackCtx;
    }
    /**
     * Starts observing provided element.
     *
     * @param {Element} target - Element to be observed.
     * @returns {void}
     */
    ResizeObserverSPI.prototype.observe = function (target) {
        if (!arguments.length) {
            throw new TypeError('1 argument required, but only 0 present.');
        }
        // Do nothing if current environment doesn't have the Element interface.
        if (typeof Element === 'undefined' || !(Element instanceof Object)) {
            return;
        }
        if (!(target instanceof getWindowOf(target).Element)) {
            throw new TypeError('parameter 1 is not of type "Element".');
        }
        var observations = this.observations_;
        // Do nothing if element is already being observed.
        if (observations.has(target)) {
            return;
        }
        observations.set(target, new ResizeObservation(target));
        this.controller_.addObserver(this);
        // Force the update of observations.
        this.controller_.refresh();
    };
    /**
     * Stops observing provided element.
     *
     * @param {Element} target - Element to stop observing.
     * @returns {void}
     */
    ResizeObserverSPI.prototype.unobserve = function (target) {
        if (!arguments.length) {
            throw new TypeError('1 argument required, but only 0 present.');
        }
        // Do nothing if current environment doesn't have the Element interface.
        if (typeof Element === 'undefined' || !(Element instanceof Object)) {
            return;
        }
        if (!(target instanceof getWindowOf(target).Element)) {
            throw new TypeError('parameter 1 is not of type "Element".');
        }
        var observations = this.observations_;
        // Do nothing if element is not being observed.
        if (!observations.has(target)) {
            return;
        }
        observations.delete(target);
        if (!observations.size) {
            this.controller_.removeObserver(this);
        }
    };
    /**
     * Stops observing all elements.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.disconnect = function () {
        this.clearActive();
        this.observations_.clear();
        this.controller_.removeObserver(this);
    };
    /**
     * Collects observation instances the associated element of which has changed
     * it's content rectangle.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.gatherActive = function () {
        var _this = this;
        this.clearActive();
        this.observations_.forEach(function (observation) {
            if (observation.isActive()) {
                _this.activeObservations_.push(observation);
            }
        });
    };
    /**
     * Invokes initial callback function with a list of ResizeObserverEntry
     * instances collected from active resize observations.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.broadcastActive = function () {
        // Do nothing if observer doesn't have active observations.
        if (!this.hasActive()) {
            return;
        }
        var ctx = this.callbackCtx_;
        // Create ResizeObserverEntry instance for every active observation.
        var entries = this.activeObservations_.map(function (observation) {
            return new ResizeObserverEntry(observation.target, observation.broadcastRect());
        });
        this.callback_.call(ctx, entries, ctx);
        this.clearActive();
    };
    /**
     * Clears the collection of active observations.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.clearActive = function () {
        this.activeObservations_.splice(0);
    };
    /**
     * Tells whether observer has active observations.
     *
     * @returns {boolean}
     */
    ResizeObserverSPI.prototype.hasActive = function () {
        return this.activeObservations_.length > 0;
    };
    return ResizeObserverSPI;
}());

// Registry of internal observers. If WeakMap is not available use current shim
// for the Map collection as it has all required methods and because WeakMap
// can't be fully polyfilled anyway.
var observers = typeof WeakMap !== 'undefined' ? new WeakMap() : new MapShim();
/**
 * ResizeObserver API. Encapsulates the ResizeObserver SPI implementation
 * exposing only those methods and properties that are defined in the spec.
 */
var ResizeObserver = /** @class */ (function () {
    /**
     * Creates a new instance of ResizeObserver.
     *
     * @param {ResizeObserverCallback} callback - Callback that is invoked when
     *      dimensions of the observed elements change.
     */
    function ResizeObserver(callback) {
        if (!(this instanceof ResizeObserver)) {
            throw new TypeError('Cannot call a class as a function.');
        }
        if (!arguments.length) {
            throw new TypeError('1 argument required, but only 0 present.');
        }
        var controller = ResizeObserverController.getInstance();
        var observer = new ResizeObserverSPI(callback, controller, this);
        observers.set(this, observer);
    }
    return ResizeObserver;
}());
// Expose public methods of ResizeObserver.
[
    'observe',
    'unobserve',
    'disconnect'
].forEach(function (method) {
    ResizeObserver.prototype[method] = function () {
        var _a;
        return (_a = observers.get(this))[method].apply(_a, arguments);
    };
});

var index = (function () {
    // Export existing implementation if available.
    if (typeof global$1.ResizeObserver !== 'undefined') {
        return global$1.ResizeObserver;
    }
    return ResizeObserver;
})();function isSamePoint(prev, next) {
  if (prev === next) return true;
  if (!prev || !next) return false;

  if ('pageX' in next && 'pageY' in next) {
    return prev.pageX === next.pageX && prev.pageY === next.pageY;
  }

  if ('clientX' in next && 'clientY' in next) {
    return prev.clientX === next.clientX && prev.clientY === next.clientY;
  }

  return false;
}
function restoreFocus(activeElement, container) {
  // Focus back if is in the container
  if (activeElement !== document.activeElement && contains(container, activeElement) && typeof activeElement.focus === 'function') {
    activeElement.focus();
  }
}
function monitorResize(element, callback) {
  var prevWidth = null;
  var prevHeight = null;

  function onResize(_ref) {
    var _ref2 = _slicedToArray(_ref, 1),
        target = _ref2[0].target;

    if (!document.documentElement.contains(target)) return;

    var _target$getBoundingCl = target.getBoundingClientRect(),
        width = _target$getBoundingCl.width,
        height = _target$getBoundingCl.height;

    var fixedWidth = Math.floor(width);
    var fixedHeight = Math.floor(height);

    if (prevWidth !== fixedWidth || prevHeight !== fixedHeight) {
      // https://webkit.org/blog/9997/resizeobserver-in-webkit/
      Promise.resolve().then(function () {
        callback({
          width: fixedWidth,
          height: fixedHeight
        });
      });
    }

    prevWidth = fixedWidth;
    prevHeight = fixedHeight;
  }

  var resizeObserver = new index(onResize);

  if (element) {
    resizeObserver.observe(element);
  }

  return function () {
    resizeObserver.disconnect();
  };
}var useBuffer = (function (callback, buffer) {
  var calledRef = React__default['default'].useRef(false);
  var timeoutRef = React__default['default'].useRef(null);

  function cancelTrigger() {
    window.clearTimeout(timeoutRef.current);
  }

  function trigger(force) {
    if (!calledRef.current || force === true) {
      if (callback() === false) {
        // Not delay since callback cancelled self
        return;
      }

      calledRef.current = true;
      cancelTrigger();
      timeoutRef.current = window.setTimeout(function () {
        calledRef.current = false;
      }, buffer);
    } else {
      cancelTrigger();
      timeoutRef.current = window.setTimeout(function () {
        calledRef.current = false;
        trigger();
      }, buffer);
    }
  }

  return [trigger, function () {
    calledRef.current = false;
    cancelTrigger();
  }];
});function getElement(func) {
  if (typeof func !== 'function') return null;
  return func();
}

function getPoint(point) {
  if (_typeof$2(point) !== 'object' || !point) return null;
  return point;
}

var Align = function Align(_ref, ref) {
  var children = _ref.children,
      disabled = _ref.disabled,
      target = _ref.target,
      align = _ref.align,
      onAlign = _ref.onAlign,
      monitorWindowResize = _ref.monitorWindowResize,
      _ref$monitorBufferTim = _ref.monitorBufferTime,
      monitorBufferTime = _ref$monitorBufferTim === void 0 ? 0 : _ref$monitorBufferTim;
  var cacheRef = React__default['default'].useRef({});
  var nodeRef = React__default['default'].useRef();
  var childNode = React__default['default'].Children.only(children); // ===================== Align ======================
  // We save the props here to avoid closure makes props ood

  var forceAlignPropsRef = React__default['default'].useRef({});
  forceAlignPropsRef.current.disabled = disabled;
  forceAlignPropsRef.current.target = target;
  forceAlignPropsRef.current.onAlign = onAlign;

  var _useBuffer = useBuffer(function () {
    var _forceAlignPropsRef$c = forceAlignPropsRef.current,
        latestDisabled = _forceAlignPropsRef$c.disabled,
        latestTarget = _forceAlignPropsRef$c.target,
        latestOnAlign = _forceAlignPropsRef$c.onAlign;

    if (!latestDisabled && latestTarget) {
      var source = nodeRef.current;
      var result;
      var element = getElement(latestTarget);
      var point = getPoint(latestTarget);
      cacheRef.current.element = element;
      cacheRef.current.point = point; // IE lose focus after element realign
      // We should record activeElement and restore later

      var _document = document,
          activeElement = _document.activeElement; // We only align when element is visible

      if (element && isVisible(element)) {
        result = alignElement(source, element, align);
      } else if (point) {
        result = alignPoint(source, point, align);
      }

      restoreFocus(activeElement, source);

      if (latestOnAlign && result) {
        latestOnAlign(source, result);
      }

      return true;
    }

    return false;
  }, monitorBufferTime),
      _useBuffer2 = _slicedToArray(_useBuffer, 2),
      _forceAlign = _useBuffer2[0],
      cancelForceAlign = _useBuffer2[1]; // ===================== Effect =====================
  // Listen for target updated


  var resizeMonitor = React__default['default'].useRef({
    cancel: function cancel() {}
  }); // Listen for source updated

  var sourceResizeMonitor = React__default['default'].useRef({
    cancel: function cancel() {}
  });
  React__default['default'].useEffect(function () {
    var element = getElement(target);
    var point = getPoint(target);

    if (nodeRef.current !== sourceResizeMonitor.current.element) {
      sourceResizeMonitor.current.cancel();
      sourceResizeMonitor.current.element = nodeRef.current;
      sourceResizeMonitor.current.cancel = monitorResize(nodeRef.current, _forceAlign);
    }

    if (cacheRef.current.element !== element || !isSamePoint(cacheRef.current.point, point)) {
      _forceAlign(); // Add resize observer


      if (resizeMonitor.current.element !== element) {
        resizeMonitor.current.cancel();
        resizeMonitor.current.element = element;
        resizeMonitor.current.cancel = monitorResize(element, _forceAlign);
      }
    }
  }); // Listen for disabled change

  React__default['default'].useEffect(function () {
    if (!disabled) {
      _forceAlign();
    } else {
      cancelForceAlign();
    }
  }, [disabled]); // Listen for window resize

  var winResizeRef = React__default['default'].useRef(null);
  React__default['default'].useEffect(function () {
    if (monitorWindowResize) {
      if (!winResizeRef.current) {
        winResizeRef.current = addEventListenerWrap(window, 'resize', _forceAlign);
      }
    } else if (winResizeRef.current) {
      winResizeRef.current.remove();
      winResizeRef.current = null;
    }
  }, [monitorWindowResize]); // Clear all if unmount

  React__default['default'].useEffect(function () {
    return function () {
      resizeMonitor.current.cancel();
      sourceResizeMonitor.current.cancel();
      if (winResizeRef.current) winResizeRef.current.remove();
      cancelForceAlign();
    };
  }, []); // ====================== Ref =======================

  React__default['default'].useImperativeHandle(ref, function () {
    return {
      forceAlign: function forceAlign() {
        return _forceAlign(true);
      }
    };
  }); // ===================== Render =====================

  if (React__default['default'].isValidElement(childNode)) {
    childNode = React__default['default'].cloneElement(childNode, {
      ref: composeRef(childNode.ref, nodeRef)
    });
  }

  return childNode;
};

var RefAlign = React__default['default'].forwardRef(Align);
RefAlign.displayName = 'Align';var regenerator = runtime.exports;function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}var StatusQueue = ['measure', 'align', null, 'motion'];
var useVisibleStatus = (function (visible, doMeasure) {
  var _useState = React.useState(null),
      _useState2 = _slicedToArray(_useState, 2),
      status = _useState2[0],
      setInternalStatus = _useState2[1];

  var rafRef = React.useRef();
  var destroyRef = React.useRef(false);

  function setStatus(nextStatus) {
    if (!destroyRef.current) {
      setInternalStatus(nextStatus);
    }
  }

  function cancelRaf() {
    wrapperRaf.cancel(rafRef.current);
  }

  function goNextStatus(callback) {
    cancelRaf();
    rafRef.current = wrapperRaf(function () {
      // Only align should be manually trigger
      setStatus(function (prev) {
        switch (status) {
          case 'align':
            return 'motion';

          case 'motion':
            return 'stable';
        }

        return prev;
      });
      callback === null || callback === void 0 ? void 0 : callback();
    });
  } // Init status


  React.useEffect(function () {
    setStatus('measure');
  }, [visible]); // Go next status

  React.useEffect(function () {
    switch (status) {
      case 'measure':
        doMeasure();
        break;
    }

    if (status) {
      rafRef.current = wrapperRaf( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regenerator.mark(function _callee() {
        var index, nextStatus;
        return regenerator.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                index = StatusQueue.indexOf(status);
                nextStatus = StatusQueue[index + 1];

                if (nextStatus && index !== -1) {
                  setStatus(nextStatus);
                }

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      })));
    }
  }, [status]);
  React.useEffect(function () {
    return function () {
      destroyRef.current = true;
      cancelRaf();
    };
  }, []);
  return [status, goNextStatus];
});var useStretchStyle = (function (stretch) {
  var _React$useState = React__namespace.useState({
    width: 0,
    height: 0
  }),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      targetSize = _React$useState2[0],
      setTargetSize = _React$useState2[1];

  function measureStretch(element) {
    setTargetSize({
      width: element.offsetWidth,
      height: element.offsetHeight
    });
  } // Merge stretch style


  var style = React__namespace.useMemo(function () {
    var sizeStyle = {};

    if (stretch) {
      var width = targetSize.width,
          height = targetSize.height; // Stretch with target

      if (stretch.indexOf('height') !== -1 && height) {
        sizeStyle.height = height;
      } else if (stretch.indexOf('minHeight') !== -1 && height) {
        sizeStyle.minHeight = height;
      }

      if (stretch.indexOf('width') !== -1 && width) {
        sizeStyle.width = width;
      } else if (stretch.indexOf('minWidth') !== -1 && width) {
        sizeStyle.minWidth = width;
      }
    }

    return sizeStyle;
  }, [stretch, targetSize]);
  return [style, measureStretch];
});var PopupInner = /*#__PURE__*/React__namespace.forwardRef(function (props, ref) {
  var visible = props.visible,
      prefixCls = props.prefixCls,
      className = props.className,
      style = props.style,
      children = props.children,
      zIndex = props.zIndex,
      stretch = props.stretch,
      destroyPopupOnHide = props.destroyPopupOnHide,
      forceRender = props.forceRender,
      align = props.align,
      point = props.point,
      getRootDomNode = props.getRootDomNode,
      getClassNameFromAlign = props.getClassNameFromAlign,
      onAlign = props.onAlign,
      onMouseEnter = props.onMouseEnter,
      onMouseLeave = props.onMouseLeave,
      onMouseDown = props.onMouseDown,
      onTouchStart = props.onTouchStart;
  var alignRef = React.useRef();
  var elementRef = React.useRef();

  var _useState = React.useState(),
      _useState2 = _slicedToArray(_useState, 2),
      alignedClassName = _useState2[0],
      setAlignedClassName = _useState2[1]; // ======================= Measure ========================


  var _useStretchStyle = useStretchStyle(stretch),
      _useStretchStyle2 = _slicedToArray(_useStretchStyle, 2),
      stretchStyle = _useStretchStyle2[0],
      measureStretchStyle = _useStretchStyle2[1];

  function doMeasure() {
    if (stretch) {
      measureStretchStyle(getRootDomNode());
    }
  } // ======================== Status ========================


  var _useVisibleStatus = useVisibleStatus(visible, doMeasure),
      _useVisibleStatus2 = _slicedToArray(_useVisibleStatus, 2),
      status = _useVisibleStatus2[0],
      goNextStatus = _useVisibleStatus2[1]; // ======================== Aligns ========================


  var prepareResolveRef = React.useRef(); // `target` on `rc-align` can accept as a function to get the bind element or a point.
  // ref: https://www.npmjs.com/package/rc-align

  function getAlignTarget() {
    if (point) {
      return point;
    }

    return getRootDomNode;
  }

  function forceAlign() {
    var _alignRef$current;

    (_alignRef$current = alignRef.current) === null || _alignRef$current === void 0 ? void 0 : _alignRef$current.forceAlign();
  }

  function onInternalAlign(popupDomNode, matchAlign) {
    if (status === 'align') {
      var nextAlignedClassName = getClassNameFromAlign(matchAlign);
      setAlignedClassName(nextAlignedClassName); // Repeat until not more align needed

      if (alignedClassName !== nextAlignedClassName) {
        Promise.resolve().then(function () {
          forceAlign();
        });
      } else {
        goNextStatus(function () {
          var _prepareResolveRef$cu;

          (_prepareResolveRef$cu = prepareResolveRef.current) === null || _prepareResolveRef$cu === void 0 ? void 0 : _prepareResolveRef$cu.call(prepareResolveRef);
        });
      }

      onAlign === null || onAlign === void 0 ? void 0 : onAlign(popupDomNode, matchAlign);
    }
  } // ======================== Motion ========================


  var motion = _objectSpread2$1({}, getMotion(props));

  ['onAppearEnd', 'onEnterEnd', 'onLeaveEnd'].forEach(function (eventName) {
    var originHandler = motion[eventName];

    motion[eventName] = function (element, event) {
      goNextStatus();
      return originHandler === null || originHandler === void 0 ? void 0 : originHandler(element, event);
    };
  });

  function onShowPrepare() {
    return new Promise(function (resolve) {
      prepareResolveRef.current = resolve;
    });
  } // Go to stable directly when motion not provided


  React__namespace.useEffect(function () {
    if (!motion.motionName && status === 'motion') {
      goNextStatus();
    }
  }, [motion.motionName, status]); // ========================= Refs =========================

  React__namespace.useImperativeHandle(ref, function () {
    return {
      forceAlign: forceAlign,
      getElement: function getElement() {
        return elementRef.current;
      }
    };
  }); // ======================== Render ========================

  var mergedStyle = _objectSpread2$1(_objectSpread2$1({}, stretchStyle), {}, {
    zIndex: zIndex,
    opacity: status === 'motion' || status === 'stable' || !visible ? undefined : 0,
    pointerEvents: status === 'stable' ? undefined : 'none'
  }, style); // Align status


  var alignDisabled = true;

  if ((align === null || align === void 0 ? void 0 : align.points) && (status === 'align' || status === 'stable')) {
    alignDisabled = false;
  }

  var childNode = children; // Wrapper when multiple children

  if (React__namespace.Children.count(children) > 1) {
    childNode = /*#__PURE__*/React__namespace.createElement("div", {
      className: "".concat(prefixCls, "-content")
    }, children);
  }

  return /*#__PURE__*/React__namespace.createElement(CSSMotion, _extends$f({
    visible: visible,
    ref: elementRef,
    leavedClassName: "".concat(prefixCls, "-hidden")
  }, motion, {
    onAppearPrepare: onShowPrepare,
    onEnterPrepare: onShowPrepare,
    removeOnLeave: destroyPopupOnHide,
    forceRender: forceRender
  }), function (_ref, motionRef) {
    var motionClassName = _ref.className,
        motionStyle = _ref.style;
    var mergedClassName = classNames(prefixCls, className, alignedClassName, motionClassName);
    return /*#__PURE__*/React__namespace.createElement(RefAlign, {
      target: getAlignTarget(),
      key: "popup",
      ref: alignRef,
      monitorWindowResize: true,
      disabled: alignDisabled,
      align: align,
      onAlign: onInternalAlign
    }, /*#__PURE__*/React__namespace.createElement("div", {
      ref: motionRef,
      className: mergedClassName,
      onMouseEnter: onMouseEnter,
      onMouseLeave: onMouseLeave,
      onMouseDownCapture: onMouseDown,
      onTouchStartCapture: onTouchStart,
      style: _objectSpread2$1(_objectSpread2$1({}, motionStyle), mergedStyle)
    }, childNode));
  });
});
PopupInner.displayName = 'PopupInner';var MobilePopupInner = /*#__PURE__*/React__namespace.forwardRef(function (props, ref) {
  var prefixCls = props.prefixCls,
      visible = props.visible,
      zIndex = props.zIndex,
      children = props.children,
      _props$mobile = props.mobile;
  _props$mobile = _props$mobile === void 0 ? {} : _props$mobile;
  var popupClassName = _props$mobile.popupClassName,
      popupStyle = _props$mobile.popupStyle,
      _props$mobile$popupMo = _props$mobile.popupMotion,
      popupMotion = _props$mobile$popupMo === void 0 ? {} : _props$mobile$popupMo,
      popupRender = _props$mobile.popupRender;
  var elementRef = React__namespace.useRef(); // ========================= Refs =========================

  React__namespace.useImperativeHandle(ref, function () {
    return {
      forceAlign: function forceAlign() {},
      getElement: function getElement() {
        return elementRef.current;
      }
    };
  }); // ======================== Render ========================

  var mergedStyle = _objectSpread2$1({
    zIndex: zIndex
  }, popupStyle);

  var childNode = children; // Wrapper when multiple children

  if (React__namespace.Children.count(children) > 1) {
    childNode = /*#__PURE__*/React__namespace.createElement("div", {
      className: "".concat(prefixCls, "-content")
    }, children);
  } // Mobile support additional render


  if (popupRender) {
    childNode = popupRender(childNode);
  }

  return /*#__PURE__*/React__namespace.createElement(CSSMotion, _extends$f({
    visible: visible,
    ref: elementRef,
    removeOnLeave: true
  }, popupMotion), function (_ref, motionRef) {
    var motionClassName = _ref.className,
        motionStyle = _ref.style;
    var mergedClassName = classNames(prefixCls, popupClassName, motionClassName);
    return /*#__PURE__*/React__namespace.createElement("div", {
      ref: motionRef,
      className: mergedClassName,
      style: _objectSpread2$1(_objectSpread2$1({}, motionStyle), mergedStyle)
    }, childNode);
  });
});
MobilePopupInner.displayName = 'MobilePopupInner';var Popup = /*#__PURE__*/React__namespace.forwardRef(function (_ref, ref) {
  var visible = _ref.visible,
      mobile = _ref.mobile,
      props = _objectWithoutProperties$4(_ref, ["visible", "mobile"]);

  var _useState = React.useState(visible),
      _useState2 = _slicedToArray(_useState, 2),
      innerVisible = _useState2[0],
      serInnerVisible = _useState2[1];

  var _useState3 = React.useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      inMobile = _useState4[0],
      setInMobile = _useState4[1];

  var cloneProps = _objectSpread2$1(_objectSpread2$1({}, props), {}, {
    visible: innerVisible
  }); // We check mobile in visible changed here.
  // And this also delay set `innerVisible` to avoid popup component render flash


  React.useEffect(function () {
    serInnerVisible(visible);

    if (visible && mobile) {
      setInMobile(isMobile());
    }
  }, [visible, mobile]);
  var popupNode = inMobile ? /*#__PURE__*/React__namespace.createElement(MobilePopupInner, _extends$f({}, cloneProps, {
    mobile: mobile,
    ref: ref
  })) : /*#__PURE__*/React__namespace.createElement(PopupInner, _extends$f({}, cloneProps, {
    ref: ref
  })); // We can use fragment directly but this may failed some selector usage. Keep as origin logic

  return /*#__PURE__*/React__namespace.createElement("div", null, /*#__PURE__*/React__namespace.createElement(Mask, cloneProps), popupNode);
});
Popup.displayName = 'Popup';var TriggerContext = /*#__PURE__*/React__namespace.createContext(null);function noop$2() {}

function returnEmptyString() {
  return '';
}

function returnDocument(element) {
  if (element) {
    return element.ownerDocument;
  }

  return window.document;
}

var ALL_HANDLERS = ['onClick', 'onMouseDown', 'onTouchStart', 'onMouseEnter', 'onMouseLeave', 'onFocus', 'onBlur', 'onContextMenu'];
/**
 * Internal usage. Do not use in your code since this will be removed.
 */

function generateTrigger(PortalComponent) {
  var Trigger = /*#__PURE__*/function (_React$Component) {
    _inherits$d(Trigger, _React$Component);

    var _super = _createSuper(Trigger);

    function Trigger(props) {
      var _this;

      _classCallCheck$d(this, Trigger);

      _this = _super.call(this, props);
      _this.popupRef = /*#__PURE__*/React__namespace.createRef();
      _this.triggerRef = /*#__PURE__*/React__namespace.createRef();

      _this.onMouseEnter = function (e) {
        var mouseEnterDelay = _this.props.mouseEnterDelay;

        _this.fireEvents('onMouseEnter', e);

        _this.delaySetPopupVisible(true, mouseEnterDelay, mouseEnterDelay ? null : e);
      };

      _this.onMouseMove = function (e) {
        _this.fireEvents('onMouseMove', e);

        _this.setPoint(e);
      };

      _this.onMouseLeave = function (e) {
        _this.fireEvents('onMouseLeave', e);

        _this.delaySetPopupVisible(false, _this.props.mouseLeaveDelay);
      };

      _this.onPopupMouseEnter = function () {
        _this.clearDelayTimer();
      };

      _this.onPopupMouseLeave = function (e) {
        var _this$popupRef$curren;

        // https://github.com/react-component/trigger/pull/13
        // react bug?
        if (e.relatedTarget && !e.relatedTarget.setTimeout && contains((_this$popupRef$curren = _this.popupRef.current) === null || _this$popupRef$curren === void 0 ? void 0 : _this$popupRef$curren.getElement(), e.relatedTarget)) {
          return;
        }

        _this.delaySetPopupVisible(false, _this.props.mouseLeaveDelay);
      };

      _this.onFocus = function (e) {
        _this.fireEvents('onFocus', e); // incase focusin and focusout


        _this.clearDelayTimer();

        if (_this.isFocusToShow()) {
          _this.focusTime = Date.now();

          _this.delaySetPopupVisible(true, _this.props.focusDelay);
        }
      };

      _this.onMouseDown = function (e) {
        _this.fireEvents('onMouseDown', e);

        _this.preClickTime = Date.now();
      };

      _this.onTouchStart = function (e) {
        _this.fireEvents('onTouchStart', e);

        _this.preTouchTime = Date.now();
      };

      _this.onBlur = function (e) {
        _this.fireEvents('onBlur', e);

        _this.clearDelayTimer();

        if (_this.isBlurToHide()) {
          _this.delaySetPopupVisible(false, _this.props.blurDelay);
        }
      };

      _this.onContextMenu = function (e) {
        e.preventDefault();

        _this.fireEvents('onContextMenu', e);

        _this.setPopupVisible(true, e);
      };

      _this.onContextMenuClose = function () {
        if (_this.isContextMenuToShow()) {
          _this.close();
        }
      };

      _this.onClick = function (event) {
        _this.fireEvents('onClick', event); // focus will trigger click


        if (_this.focusTime) {
          var preTime;

          if (_this.preClickTime && _this.preTouchTime) {
            preTime = Math.min(_this.preClickTime, _this.preTouchTime);
          } else if (_this.preClickTime) {
            preTime = _this.preClickTime;
          } else if (_this.preTouchTime) {
            preTime = _this.preTouchTime;
          }

          if (Math.abs(preTime - _this.focusTime) < 20) {
            return;
          }

          _this.focusTime = 0;
        }

        _this.preClickTime = 0;
        _this.preTouchTime = 0; // Only prevent default when all the action is click.
        // https://github.com/ant-design/ant-design/issues/17043
        // https://github.com/ant-design/ant-design/issues/17291

        if (_this.isClickToShow() && (_this.isClickToHide() || _this.isBlurToHide()) && event && event.preventDefault) {
          event.preventDefault();
        }

        var nextVisible = !_this.state.popupVisible;

        if (_this.isClickToHide() && !nextVisible || nextVisible && _this.isClickToShow()) {
          _this.setPopupVisible(!_this.state.popupVisible, event);
        }
      };

      _this.onPopupMouseDown = function () {
        _this.hasPopupMouseDown = true;
        clearTimeout(_this.mouseDownTimeout);
        _this.mouseDownTimeout = window.setTimeout(function () {
          _this.hasPopupMouseDown = false;
        }, 0);

        if (_this.context) {
          var _this$context;

          (_this$context = _this.context).onPopupMouseDown.apply(_this$context, arguments);
        }
      };

      _this.onDocumentClick = function (event) {
        if (_this.props.mask && !_this.props.maskClosable) {
          return;
        }

        var target = event.target;

        var root = _this.getRootDomNode();

        var popupNode = _this.getPopupDomNode();

        if ( // mousedown on the target should also close popup when action is contextMenu.
        // https://github.com/ant-design/ant-design/issues/29853
        (!contains(root, target) || _this.isContextMenuOnly()) && !contains(popupNode, target) && !_this.hasPopupMouseDown) {
          _this.close();
        }
      };

      _this.getRootDomNode = function () {
        var getTriggerDOMNode = _this.props.getTriggerDOMNode;

        if (getTriggerDOMNode) {
          return getTriggerDOMNode(_this.triggerRef.current);
        }

        try {
          var domNode = findDOMNode(_this.triggerRef.current);

          if (domNode) {
            return domNode;
          }
        } catch (err) {// Do nothing
        }

        return ReactDOM__default['default'].findDOMNode(_assertThisInitialized(_this));
      };

      _this.getPopupClassNameFromAlign = function (align) {
        var className = [];
        var _this$props = _this.props,
            popupPlacement = _this$props.popupPlacement,
            builtinPlacements = _this$props.builtinPlacements,
            prefixCls = _this$props.prefixCls,
            alignPoint = _this$props.alignPoint,
            getPopupClassNameFromAlign = _this$props.getPopupClassNameFromAlign;

        if (popupPlacement && builtinPlacements) {
          className.push(getAlignPopupClassName(builtinPlacements, prefixCls, align, alignPoint));
        }

        if (getPopupClassNameFromAlign) {
          className.push(getPopupClassNameFromAlign(align));
        }

        return className.join(' ');
      };

      _this.getComponent = function () {
        var _this$props2 = _this.props,
            prefixCls = _this$props2.prefixCls,
            destroyPopupOnHide = _this$props2.destroyPopupOnHide,
            popupClassName = _this$props2.popupClassName,
            onPopupAlign = _this$props2.onPopupAlign,
            popupMotion = _this$props2.popupMotion,
            popupAnimation = _this$props2.popupAnimation,
            popupTransitionName = _this$props2.popupTransitionName,
            popupStyle = _this$props2.popupStyle,
            mask = _this$props2.mask,
            maskAnimation = _this$props2.maskAnimation,
            maskTransitionName = _this$props2.maskTransitionName,
            maskMotion = _this$props2.maskMotion,
            zIndex = _this$props2.zIndex,
            popup = _this$props2.popup,
            stretch = _this$props2.stretch,
            alignPoint = _this$props2.alignPoint,
            mobile = _this$props2.mobile,
            forceRender = _this$props2.forceRender;
        var _this$state = _this.state,
            popupVisible = _this$state.popupVisible,
            point = _this$state.point;

        var align = _this.getPopupAlign();

        var mouseProps = {};

        if (_this.isMouseEnterToShow()) {
          mouseProps.onMouseEnter = _this.onPopupMouseEnter;
        }

        if (_this.isMouseLeaveToHide()) {
          mouseProps.onMouseLeave = _this.onPopupMouseLeave;
        }

        mouseProps.onMouseDown = _this.onPopupMouseDown;
        mouseProps.onTouchStart = _this.onPopupMouseDown;
        return /*#__PURE__*/React__namespace.createElement(Popup, _extends$f({
          prefixCls: prefixCls,
          destroyPopupOnHide: destroyPopupOnHide,
          visible: popupVisible,
          point: alignPoint && point,
          className: popupClassName,
          align: align,
          onAlign: onPopupAlign,
          animation: popupAnimation,
          getClassNameFromAlign: _this.getPopupClassNameFromAlign
        }, mouseProps, {
          stretch: stretch,
          getRootDomNode: _this.getRootDomNode,
          style: popupStyle,
          mask: mask,
          zIndex: zIndex,
          transitionName: popupTransitionName,
          maskAnimation: maskAnimation,
          maskTransitionName: maskTransitionName,
          maskMotion: maskMotion,
          ref: _this.popupRef,
          motion: popupMotion,
          mobile: mobile,
          forceRender: forceRender
        }), typeof popup === 'function' ? popup() : popup);
      };

      _this.attachParent = function (popupContainer) {
        wrapperRaf.cancel(_this.attachId);
        var _this$props3 = _this.props,
            getPopupContainer = _this$props3.getPopupContainer,
            getDocument = _this$props3.getDocument;

        var domNode = _this.getRootDomNode();

        var mountNode;

        if (!getPopupContainer) {
          mountNode = getDocument(_this.getRootDomNode()).body;
        } else if (domNode || getPopupContainer.length === 0) {
          // Compatible for legacy getPopupContainer with domNode argument.
          // If no need `domNode` argument, will call directly.
          // https://codesandbox.io/s/eloquent-mclean-ss93m?file=/src/App.js
          mountNode = getPopupContainer(domNode);
        }

        if (mountNode) {
          mountNode.appendChild(popupContainer);
        } else {
          // Retry after frame render in case parent not ready
          _this.attachId = wrapperRaf(function () {
            _this.attachParent(popupContainer);
          });
        }
      };

      _this.getContainer = function () {
        var getDocument = _this.props.getDocument;
        var popupContainer = getDocument(_this.getRootDomNode()).createElement('div'); // Make sure default popup container will never cause scrollbar appearing
        // https://github.com/react-component/trigger/issues/41

        popupContainer.style.position = 'absolute';
        popupContainer.style.top = '0';
        popupContainer.style.left = '0';
        popupContainer.style.width = '100%';

        _this.attachParent(popupContainer);

        return popupContainer;
      };

      _this.setPoint = function (point) {
        var alignPoint = _this.props.alignPoint;
        if (!alignPoint || !point) return;

        _this.setState({
          point: {
            pageX: point.pageX,
            pageY: point.pageY
          }
        });
      };

      _this.handlePortalUpdate = function () {
        if (_this.state.prevPopupVisible !== _this.state.popupVisible) {
          _this.props.afterPopupVisibleChange(_this.state.popupVisible);
        }
      };

      _this.triggerContextValue = {
        onPopupMouseDown: _this.onPopupMouseDown
      };
      var popupVisible;

      if ('popupVisible' in props) {
        popupVisible = !!props.popupVisible;
      } else {
        popupVisible = !!props.defaultPopupVisible;
      }

      _this.state = {
        prevPopupVisible: popupVisible,
        popupVisible: popupVisible
      };
      ALL_HANDLERS.forEach(function (h) {
        _this["fire".concat(h)] = function (e) {
          _this.fireEvents(h, e);
        };
      });
      return _this;
    }

    _createClass$b(Trigger, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        this.componentDidUpdate();
      }
    }, {
      key: "componentDidUpdate",
      value: function componentDidUpdate() {
        var props = this.props;
        var state = this.state; // We must listen to `mousedown` or `touchstart`, edge case:
        // https://github.com/ant-design/ant-design/issues/5804
        // https://github.com/react-component/calendar/issues/250
        // https://github.com/react-component/trigger/issues/50

        if (state.popupVisible) {
          var currentDocument;

          if (!this.clickOutsideHandler && (this.isClickToHide() || this.isContextMenuToShow())) {
            currentDocument = props.getDocument(this.getRootDomNode());
            this.clickOutsideHandler = addEventListenerWrap(currentDocument, 'mousedown', this.onDocumentClick);
          } // always hide on mobile


          if (!this.touchOutsideHandler) {
            currentDocument = currentDocument || props.getDocument(this.getRootDomNode());
            this.touchOutsideHandler = addEventListenerWrap(currentDocument, 'touchstart', this.onDocumentClick);
          } // close popup when trigger type contains 'onContextMenu' and document is scrolling.


          if (!this.contextMenuOutsideHandler1 && this.isContextMenuToShow()) {
            currentDocument = currentDocument || props.getDocument(this.getRootDomNode());
            this.contextMenuOutsideHandler1 = addEventListenerWrap(currentDocument, 'scroll', this.onContextMenuClose);
          } // close popup when trigger type contains 'onContextMenu' and window is blur.


          if (!this.contextMenuOutsideHandler2 && this.isContextMenuToShow()) {
            this.contextMenuOutsideHandler2 = addEventListenerWrap(window, 'blur', this.onContextMenuClose);
          }

          return;
        }

        this.clearOutsideHandler();
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        this.clearDelayTimer();
        this.clearOutsideHandler();
        clearTimeout(this.mouseDownTimeout);
        wrapperRaf.cancel(this.attachId);
      }
    }, {
      key: "getPopupDomNode",
      value: function getPopupDomNode() {
        var _this$popupRef$curren2;

        // for test
        return ((_this$popupRef$curren2 = this.popupRef.current) === null || _this$popupRef$curren2 === void 0 ? void 0 : _this$popupRef$curren2.getElement()) || null;
      }
    }, {
      key: "getPopupAlign",
      value: function getPopupAlign() {
        var props = this.props;
        var popupPlacement = props.popupPlacement,
            popupAlign = props.popupAlign,
            builtinPlacements = props.builtinPlacements;

        if (popupPlacement && builtinPlacements) {
          return getAlignFromPlacement(builtinPlacements, popupPlacement, popupAlign);
        }

        return popupAlign;
      }
      /**
       * @param popupVisible    Show or not the popup element
       * @param event           SyntheticEvent, used for `pointAlign`
       */

    }, {
      key: "setPopupVisible",
      value: function setPopupVisible(popupVisible, event) {
        var alignPoint = this.props.alignPoint;
        var prevPopupVisible = this.state.popupVisible;
        this.clearDelayTimer();

        if (prevPopupVisible !== popupVisible) {
          if (!('popupVisible' in this.props)) {
            this.setState({
              popupVisible: popupVisible,
              prevPopupVisible: prevPopupVisible
            });
          }

          this.props.onPopupVisibleChange(popupVisible);
        } // Always record the point position since mouseEnterDelay will delay the show


        if (alignPoint && event && popupVisible) {
          this.setPoint(event);
        }
      }
    }, {
      key: "delaySetPopupVisible",
      value: function delaySetPopupVisible(visible, delayS, event) {
        var _this2 = this;

        var delay = delayS * 1000;
        this.clearDelayTimer();

        if (delay) {
          var point = event ? {
            pageX: event.pageX,
            pageY: event.pageY
          } : null;
          this.delayTimer = window.setTimeout(function () {
            _this2.setPopupVisible(visible, point);

            _this2.clearDelayTimer();
          }, delay);
        } else {
          this.setPopupVisible(visible, event);
        }
      }
    }, {
      key: "clearDelayTimer",
      value: function clearDelayTimer() {
        if (this.delayTimer) {
          clearTimeout(this.delayTimer);
          this.delayTimer = null;
        }
      }
    }, {
      key: "clearOutsideHandler",
      value: function clearOutsideHandler() {
        if (this.clickOutsideHandler) {
          this.clickOutsideHandler.remove();
          this.clickOutsideHandler = null;
        }

        if (this.contextMenuOutsideHandler1) {
          this.contextMenuOutsideHandler1.remove();
          this.contextMenuOutsideHandler1 = null;
        }

        if (this.contextMenuOutsideHandler2) {
          this.contextMenuOutsideHandler2.remove();
          this.contextMenuOutsideHandler2 = null;
        }

        if (this.touchOutsideHandler) {
          this.touchOutsideHandler.remove();
          this.touchOutsideHandler = null;
        }
      }
    }, {
      key: "createTwoChains",
      value: function createTwoChains(event) {
        var childPros = this.props.children.props;
        var props = this.props;

        if (childPros[event] && props[event]) {
          return this["fire".concat(event)];
        }

        return childPros[event] || props[event];
      }
    }, {
      key: "isClickToShow",
      value: function isClickToShow() {
        var _this$props4 = this.props,
            action = _this$props4.action,
            showAction = _this$props4.showAction;
        return action.indexOf('click') !== -1 || showAction.indexOf('click') !== -1;
      }
    }, {
      key: "isContextMenuOnly",
      value: function isContextMenuOnly() {
        var action = this.props.action;
        return action === 'contextMenu' || action.length === 1 && action[0] === 'contextMenu';
      }
    }, {
      key: "isContextMenuToShow",
      value: function isContextMenuToShow() {
        var _this$props5 = this.props,
            action = _this$props5.action,
            showAction = _this$props5.showAction;
        return action.indexOf('contextMenu') !== -1 || showAction.indexOf('contextMenu') !== -1;
      }
    }, {
      key: "isClickToHide",
      value: function isClickToHide() {
        var _this$props6 = this.props,
            action = _this$props6.action,
            hideAction = _this$props6.hideAction;
        return action.indexOf('click') !== -1 || hideAction.indexOf('click') !== -1;
      }
    }, {
      key: "isMouseEnterToShow",
      value: function isMouseEnterToShow() {
        var _this$props7 = this.props,
            action = _this$props7.action,
            showAction = _this$props7.showAction;
        return action.indexOf('hover') !== -1 || showAction.indexOf('mouseEnter') !== -1;
      }
    }, {
      key: "isMouseLeaveToHide",
      value: function isMouseLeaveToHide() {
        var _this$props8 = this.props,
            action = _this$props8.action,
            hideAction = _this$props8.hideAction;
        return action.indexOf('hover') !== -1 || hideAction.indexOf('mouseLeave') !== -1;
      }
    }, {
      key: "isFocusToShow",
      value: function isFocusToShow() {
        var _this$props9 = this.props,
            action = _this$props9.action,
            showAction = _this$props9.showAction;
        return action.indexOf('focus') !== -1 || showAction.indexOf('focus') !== -1;
      }
    }, {
      key: "isBlurToHide",
      value: function isBlurToHide() {
        var _this$props10 = this.props,
            action = _this$props10.action,
            hideAction = _this$props10.hideAction;
        return action.indexOf('focus') !== -1 || hideAction.indexOf('blur') !== -1;
      }
    }, {
      key: "forcePopupAlign",
      value: function forcePopupAlign() {
        if (this.state.popupVisible) {
          var _this$popupRef$curren3;

          (_this$popupRef$curren3 = this.popupRef.current) === null || _this$popupRef$curren3 === void 0 ? void 0 : _this$popupRef$curren3.forceAlign();
        }
      }
    }, {
      key: "fireEvents",
      value: function fireEvents(type, e) {
        var childCallback = this.props.children.props[type];

        if (childCallback) {
          childCallback(e);
        }

        var callback = this.props[type];

        if (callback) {
          callback(e);
        }
      }
    }, {
      key: "close",
      value: function close() {
        this.setPopupVisible(false);
      }
    }, {
      key: "render",
      value: function render() {
        var popupVisible = this.state.popupVisible;
        var _this$props11 = this.props,
            children = _this$props11.children,
            forceRender = _this$props11.forceRender,
            alignPoint = _this$props11.alignPoint,
            className = _this$props11.className,
            autoDestroy = _this$props11.autoDestroy;
        var child = React__namespace.Children.only(children);
        var newChildProps = {
          key: 'trigger'
        }; // ============================== Visible Handlers ==============================
        // >>> ContextMenu

        if (this.isContextMenuToShow()) {
          newChildProps.onContextMenu = this.onContextMenu;
        } else {
          newChildProps.onContextMenu = this.createTwoChains('onContextMenu');
        } // >>> Click


        if (this.isClickToHide() || this.isClickToShow()) {
          newChildProps.onClick = this.onClick;
          newChildProps.onMouseDown = this.onMouseDown;
          newChildProps.onTouchStart = this.onTouchStart;
        } else {
          newChildProps.onClick = this.createTwoChains('onClick');
          newChildProps.onMouseDown = this.createTwoChains('onMouseDown');
          newChildProps.onTouchStart = this.createTwoChains('onTouchStart');
        } // >>> Hover(enter)


        if (this.isMouseEnterToShow()) {
          newChildProps.onMouseEnter = this.onMouseEnter; // Point align

          if (alignPoint) {
            newChildProps.onMouseMove = this.onMouseMove;
          }
        } else {
          newChildProps.onMouseEnter = this.createTwoChains('onMouseEnter');
        } // >>> Hover(leave)


        if (this.isMouseLeaveToHide()) {
          newChildProps.onMouseLeave = this.onMouseLeave;
        } else {
          newChildProps.onMouseLeave = this.createTwoChains('onMouseLeave');
        } // >>> Focus


        if (this.isFocusToShow() || this.isBlurToHide()) {
          newChildProps.onFocus = this.onFocus;
          newChildProps.onBlur = this.onBlur;
        } else {
          newChildProps.onFocus = this.createTwoChains('onFocus');
          newChildProps.onBlur = this.createTwoChains('onBlur');
        } // =================================== Render ===================================


        var childrenClassName = classNames(child && child.props && child.props.className, className);

        if (childrenClassName) {
          newChildProps.className = childrenClassName;
        }

        var cloneProps = _objectSpread2$1({}, newChildProps);

        if (supportRef(child)) {
          cloneProps.ref = composeRef(this.triggerRef, child.ref);
        }

        var trigger = /*#__PURE__*/React__namespace.cloneElement(child, cloneProps);
        var portal; // prevent unmounting after it's rendered

        if (popupVisible || this.popupRef.current || forceRender) {
          portal = /*#__PURE__*/React__namespace.createElement(PortalComponent, {
            key: "portal",
            getContainer: this.getContainer,
            didUpdate: this.handlePortalUpdate
          }, this.getComponent());
        }

        if (!popupVisible && autoDestroy) {
          portal = null;
        }

        return /*#__PURE__*/React__namespace.createElement(TriggerContext.Provider, {
          value: this.triggerContextValue
        }, trigger, portal);
      }
    }], [{
      key: "getDerivedStateFromProps",
      value: function getDerivedStateFromProps(_ref, prevState) {
        var popupVisible = _ref.popupVisible;
        var newState = {};

        if (popupVisible !== undefined && prevState.popupVisible !== popupVisible) {
          newState.popupVisible = popupVisible;
          newState.prevPopupVisible = prevState.popupVisible;
        }

        return newState;
      }
    }]);

    return Trigger;
  }(React__namespace.Component);

  Trigger.contextType = TriggerContext;
  Trigger.defaultProps = {
    prefixCls: 'rc-trigger-popup',
    getPopupClassNameFromAlign: returnEmptyString,
    getDocument: returnDocument,
    onPopupVisibleChange: noop$2,
    afterPopupVisibleChange: noop$2,
    onPopupAlign: noop$2,
    popupClassName: '',
    mouseEnterDelay: 0,
    mouseLeaveDelay: 0.1,
    focusDelay: 0,
    blurDelay: 0.15,
    popupStyle: {},
    destroyPopupOnHide: false,
    popupAlign: {},
    defaultPopupVisible: false,
    mask: false,
    maskClosable: true,
    action: [],
    showAction: [],
    hideAction: [],
    autoDestroy: false
  };
  return Trigger;
}
var Trigger = generateTrigger(Portal);var autoAdjustOverflow = {
  adjustX: 1,
  adjustY: 1
};
var targetOffset = [0, 0];
var placements = {
  left: {
    points: ['cr', 'cl'],
    overflow: autoAdjustOverflow,
    offset: [-4, 0],
    targetOffset: targetOffset
  },
  right: {
    points: ['cl', 'cr'],
    overflow: autoAdjustOverflow,
    offset: [4, 0],
    targetOffset: targetOffset
  },
  top: {
    points: ['bc', 'tc'],
    overflow: autoAdjustOverflow,
    offset: [0, -4],
    targetOffset: targetOffset
  },
  bottom: {
    points: ['tc', 'bc'],
    overflow: autoAdjustOverflow,
    offset: [0, 4],
    targetOffset: targetOffset
  },
  topLeft: {
    points: ['bl', 'tl'],
    overflow: autoAdjustOverflow,
    offset: [0, -4],
    targetOffset: targetOffset
  },
  leftTop: {
    points: ['tr', 'tl'],
    overflow: autoAdjustOverflow,
    offset: [-4, 0],
    targetOffset: targetOffset
  },
  topRight: {
    points: ['br', 'tr'],
    overflow: autoAdjustOverflow,
    offset: [0, -4],
    targetOffset: targetOffset
  },
  rightTop: {
    points: ['tl', 'tr'],
    overflow: autoAdjustOverflow,
    offset: [4, 0],
    targetOffset: targetOffset
  },
  bottomRight: {
    points: ['tr', 'br'],
    overflow: autoAdjustOverflow,
    offset: [0, 4],
    targetOffset: targetOffset
  },
  rightBottom: {
    points: ['bl', 'br'],
    overflow: autoAdjustOverflow,
    offset: [4, 0],
    targetOffset: targetOffset
  },
  bottomLeft: {
    points: ['tl', 'bl'],
    overflow: autoAdjustOverflow,
    offset: [0, 4],
    targetOffset: targetOffset
  },
  leftBottom: {
    points: ['br', 'bl'],
    overflow: autoAdjustOverflow,
    offset: [-4, 0],
    targetOffset: targetOffset
  }
};var Content$1 = function Content(props) {
  var overlay = props.overlay,
      prefixCls = props.prefixCls,
      id = props.id,
      overlayInnerStyle = props.overlayInnerStyle;
  return /*#__PURE__*/React__namespace.createElement("div", {
    className: "".concat(prefixCls, "-inner"),
    id: id,
    role: "tooltip",
    style: overlayInnerStyle
  }, typeof overlay === 'function' ? overlay() : overlay);
};var Tooltip = function Tooltip(props, ref) {
  var overlayClassName = props.overlayClassName,
      _props$trigger = props.trigger,
      trigger = _props$trigger === void 0 ? ['hover'] : _props$trigger,
      _props$mouseEnterDela = props.mouseEnterDelay,
      mouseEnterDelay = _props$mouseEnterDela === void 0 ? 0 : _props$mouseEnterDela,
      _props$mouseLeaveDela = props.mouseLeaveDelay,
      mouseLeaveDelay = _props$mouseLeaveDela === void 0 ? 0.1 : _props$mouseLeaveDela,
      overlayStyle = props.overlayStyle,
      _props$prefixCls = props.prefixCls,
      prefixCls = _props$prefixCls === void 0 ? 'rc-tooltip' : _props$prefixCls,
      children = props.children,
      onVisibleChange = props.onVisibleChange,
      afterVisibleChange = props.afterVisibleChange,
      transitionName = props.transitionName,
      animation = props.animation,
      motion = props.motion,
      _props$placement = props.placement,
      placement = _props$placement === void 0 ? 'right' : _props$placement,
      _props$align = props.align,
      align = _props$align === void 0 ? {} : _props$align,
      _props$destroyTooltip = props.destroyTooltipOnHide,
      destroyTooltipOnHide = _props$destroyTooltip === void 0 ? false : _props$destroyTooltip,
      defaultVisible = props.defaultVisible,
      getTooltipContainer = props.getTooltipContainer,
      overlayInnerStyle = props.overlayInnerStyle,
      restProps = _objectWithoutProperties$4(props, ["overlayClassName", "trigger", "mouseEnterDelay", "mouseLeaveDelay", "overlayStyle", "prefixCls", "children", "onVisibleChange", "afterVisibleChange", "transitionName", "animation", "motion", "placement", "align", "destroyTooltipOnHide", "defaultVisible", "getTooltipContainer", "overlayInnerStyle"]);

  var domRef = React.useRef(null);
  React.useImperativeHandle(ref, function () {
    return domRef.current;
  });

  var extraProps = _objectSpread2$1({}, restProps);

  if ('visible' in props) {
    extraProps.popupVisible = props.visible;
  }

  var getPopupElement = function getPopupElement() {
    var _props$arrowContent = props.arrowContent,
        arrowContent = _props$arrowContent === void 0 ? null : _props$arrowContent,
        overlay = props.overlay,
        id = props.id;
    return [/*#__PURE__*/React__namespace.createElement("div", {
      className: "".concat(prefixCls, "-arrow"),
      key: "arrow"
    }, arrowContent), /*#__PURE__*/React__namespace.createElement(Content$1, {
      key: "content",
      prefixCls: prefixCls,
      id: id,
      overlay: overlay,
      overlayInnerStyle: overlayInnerStyle
    })];
  };

  var destroyTooltip = false;
  var autoDestroy = false;

  if (typeof destroyTooltipOnHide === 'boolean') {
    destroyTooltip = destroyTooltipOnHide;
  } else if (destroyTooltipOnHide && _typeof$2(destroyTooltipOnHide) === 'object') {
    var keepParent = destroyTooltipOnHide.keepParent;
    destroyTooltip = keepParent === true;
    autoDestroy = keepParent === false;
  }

  return /*#__PURE__*/React__namespace.createElement(Trigger, _extends$f({
    popupClassName: overlayClassName,
    prefixCls: prefixCls,
    popup: getPopupElement,
    action: trigger,
    builtinPlacements: placements,
    popupPlacement: placement,
    ref: domRef,
    popupAlign: align,
    getPopupContainer: getTooltipContainer,
    onPopupVisibleChange: onVisibleChange,
    afterPopupVisibleChange: afterVisibleChange,
    popupTransitionName: transitionName,
    popupAnimation: animation,
    popupMotion: motion,
    defaultPopupVisible: defaultVisible,
    destroyPopupOnHide: destroyTooltip,
    autoDestroy: autoDestroy,
    mouseLeaveDelay: mouseLeaveDelay,
    popupStyle: overlayStyle,
    mouseEnterDelay: mouseEnterDelay
  }, extraProps), children);
};

var Tooltip$1 = /*#__PURE__*/React.forwardRef(Tooltip);var SliderTooltip = /*#__PURE__*/React__namespace.forwardRef(function (props, ref) {
  var visible = props.visible,
      overlay = props.overlay;
  var innerRef = React__namespace.useRef(null);
  var tooltipRef = composeRef(ref, innerRef);
  var rafRef = React__namespace.useRef(null);

  function cancelKeepAlign() {
    wrapperRaf.cancel(rafRef.current);
  }

  function keepAlign() {
    rafRef.current = wrapperRaf(function () {
      var _innerRef$current;

      (_innerRef$current = innerRef.current) === null || _innerRef$current === void 0 ? void 0 : _innerRef$current.forcePopupAlign();
    });
  }

  React__namespace.useEffect(function () {
    if (visible) {
      keepAlign();
    } else {
      cancelKeepAlign();
    }

    return cancelKeepAlign;
  }, [visible, overlay]);
  return /*#__PURE__*/React__namespace.createElement(Tooltip$1, _extends$f({
    ref: tooltipRef
  }, props));
});function createSliderWithTooltip(Component) {
  var _a; // eslint-disable-next-line @typescript-eslint/no-unused-vars


  return _a = /*#__PURE__*/function (_React$Component) {
    _inherits$d(ComponentWrapper, _React$Component);

    var _super = _createSuper(ComponentWrapper);

    function ComponentWrapper() {
      var _this;

      _classCallCheck$d(this, ComponentWrapper);

      _this = _super.apply(this, arguments);
      _this.state = {
        visibles: {}
      };

      _this.handleTooltipVisibleChange = function (index, visible) {
        _this.setState(function (prevState) {
          return {
            visibles: _objectSpread2$1(_objectSpread2$1({}, prevState.visibles), {}, _defineProperty$3({}, index, visible))
          };
        });
      };

      _this.handleWithTooltip = function (_ref) {
        var value = _ref.value,
            dragging = _ref.dragging,
            index = _ref.index,
            disabled = _ref.disabled,
            restProps = _objectWithoutProperties$4(_ref, ["value", "dragging", "index", "disabled"]);

        var _this$props = _this.props,
            tipFormatter = _this$props.tipFormatter,
            tipProps = _this$props.tipProps,
            handleStyle = _this$props.handleStyle,
            getTooltipContainer = _this$props.getTooltipContainer;

        var _tipProps$prefixCls = tipProps.prefixCls,
            prefixCls = _tipProps$prefixCls === void 0 ? 'rc-slider-tooltip' : _tipProps$prefixCls,
            _tipProps$overlay = tipProps.overlay,
            overlay = _tipProps$overlay === void 0 ? tipFormatter(value) : _tipProps$overlay,
            _tipProps$placement = tipProps.placement,
            placement = _tipProps$placement === void 0 ? 'top' : _tipProps$placement,
            _tipProps$visible = tipProps.visible,
            visible = _tipProps$visible === void 0 ? false : _tipProps$visible,
            restTooltipProps = _objectWithoutProperties$4(tipProps, ["prefixCls", "overlay", "placement", "visible"]);

        var handleStyleWithIndex;

        if (Array.isArray(handleStyle)) {
          handleStyleWithIndex = handleStyle[index] || handleStyle[0];
        } else {
          handleStyleWithIndex = handleStyle;
        }

        return /*#__PURE__*/React__default['default'].createElement(SliderTooltip, _extends$f({}, restTooltipProps, {
          getTooltipContainer: getTooltipContainer,
          prefixCls: prefixCls,
          overlay: overlay,
          placement: placement,
          visible: !disabled && (_this.state.visibles[index] || dragging) || visible,
          key: index
        }), /*#__PURE__*/React__default['default'].createElement(Handle$1, _extends$f({}, restProps, {
          style: _objectSpread2$1({}, handleStyleWithIndex),
          value: value,
          onMouseEnter: function onMouseEnter() {
            return _this.handleTooltipVisibleChange(index, true);
          },
          onMouseLeave: function onMouseLeave() {
            return _this.handleTooltipVisibleChange(index, false);
          }
        })));
      };

      return _this;
    }

    _createClass$b(ComponentWrapper, [{
      key: "render",
      value: function render() {
        return /*#__PURE__*/React__default['default'].createElement(Component, _extends$f({}, this.props, {
          handle: this.handleWithTooltip
        }));
      }
    }]);

    return ComponentWrapper;
  }(React__default['default'].Component), _a.defaultProps = {
    tipFormatter: function tipFormatter(value) {
      return value;
    },
    handleStyle: [{}],
    tipProps: {},
    getTooltipContainer: function getTooltipContainer(node) {
      return node.parentNode;
    }
  }, _a;
}var InternalSlider = Slider$1;
InternalSlider.Range = RangeUnstyled;
InternalSlider.Handle = Handle$1;
InternalSlider.createSliderWithTooltip = createSliderWithTooltip;/* eslint-disable import/prefer-default-export */
// =============================
// Helpers
// =============================

/**
 * Get formatted duration
 * @param {number} duration - Duration in seconds
 * @return {string} - Formatted duration
 */
function presentDuration(duration) {
  var sec = Math.floor(duration % 60);
  var min = Math.floor(duration / 60);
  if (sec < 10) sec = "0".concat(sec);
  if (min < 10) min = "0".concat(min);
  return "".concat(min, ":").concat(sec);
}var _excluded$d = ["index", "dragging"],
    _excluded2$1 = ["index", "dragging"];

var _templateObject$l, _templateObject2$g, _templateObject3$f, _templateObject4$e, _templateObject5$d;
// Styles
// =============================

var Wrapper$g = styled__default['default'](Div)(_templateObject$l || (_templateObject$l = _taggedTemplateLiteral$5(["\n  padding: 1.6rem;\n  padding-top: 1.2rem;\n"])));
var Range = styled__default['default'](RangeUnstyled)(_templateObject2$g || (_templateObject2$g = _taggedTemplateLiteral$5(["\n  height: 1.4rem;\n  position: relative;\n  touch-action: none;\n  user-select: none;\n\n  & .rc-slider-rail {\n    background-color: ", ";\n    border-radius: 0.5rem;\n    height: 0.2rem;\n    position: absolute;\n    width: 100%;\n  }\n\n  & .rc-slider-track {\n    background-color: ", ";\n    border-radius: 0.5rem;\n    height: 0.2rem;\n    position: absolute;\n    width: 100%;\n  }\n\n  & .rc-slider-step {\n    background-color: transparent;\n    height: 0.2rem;\n    position: absolute;\n    width: 100%;\n  }\n\n  & .rc-slider-handle {\n    background-color: ", ";\n    border: 0;\n    border-radius: 50%;\n    cursor: grab;\n    height: 14px;\n    margin-left: -7px;\n    margin-top: -6px;\n    position: absolute;\n    transform: none !important; /** Override inline styles being js injected by rc-slider. */\n    touch-action: pan-x;\n    width: 14px;\n  }\n\n  & .rc-slider-tooltip {\n    color: ", ";\n    font-size: 1rem;\n\n    .inner {\n      background-color: transparent;\n    }\n  }\n"])), function (_ref) {
  var theme = _ref.theme;
  return alpha$2(theme.colors.primary, 0.1);
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.primary;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.colors.primary;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.colors.input.text;
});
var HandleBase = styled__default['default'](Handle$1)(_templateObject3$f || (_templateObject3$f = _taggedTemplateLiteral$5(["\n  outline: none;\n\n  &::after {\n    color: ", ";\n    font-size: 1rem;\n    font-weight: ", ";\n    position: absolute;\n    top: 3px;\n    word-break: initial;\n  }\n"])), function (_ref5) {
  var theme = _ref5.theme;
  return theme.colors.input.text;
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.fontWeight.bold;
});
var Handle = styled__default['default'](HandleBase)(_templateObject4$e || (_templateObject4$e = _taggedTemplateLiteral$5(["\n  &::after {\n    content: '", "';\n    ", "\n  }\n"])), function (_ref7) {
  var content = _ref7.content;
  return content;
}, function (_ref8) {
  var index = _ref8.index;
  return index ? 'left: 17px;' : 'right: 17px;';
});
var handle = function handle(_ref9) {
  var index = _ref9.index;
      _ref9.dragging;
      var rest = _objectWithoutProperties$7(_ref9, _excluded$d);

  var content = rest.value;
  if (rest.value === rest.min) content = "-".concat(rest.value);
  if (rest.value === rest.max) content = "".concat(rest.value, "+");
  return /*#__PURE__*/React__default['default'].createElement(Handle, _extends$g({
    key: index,
    index: index,
    content: content
  }, rest));
};
handle.propTypes = {
  index: PropTypes__default['default'].string.isRequired,
  dragging: PropTypes__default['default'].string.isRequired
};
var HandleDuration = styled__default['default'](HandleBase)(_templateObject5$d || (_templateObject5$d = _taggedTemplateLiteral$5(["\n  &::after {\n    content: '", "';\n    ", "\n  }\n"])), function (_ref10) {
  var content = _ref10.content;
  return content;
}, function (_ref11) {
  var index = _ref11.index;
  return index ? 'left: 17px' : 'right: 17px';
});
var handleDuration = function handleDuration(_ref12) {
  var index = _ref12.index;
      _ref12.dragging;
      var rest = _objectWithoutProperties$7(_ref12, _excluded2$1);

  var content = presentDuration(rest.value);
  if (rest.value === rest.min) content = "-".concat(presentDuration(rest.value));
  if (rest.value === rest.max) content = "".concat(presentDuration(rest.value), "+");
  return /*#__PURE__*/React__default['default'].createElement(HandleDuration, _extends$g({
    key: index,
    index: index,
    content: content
  }, rest));
};
handleDuration.propTypes = {
  index: PropTypes__default['default'].string.isRequired,
  dragging: PropTypes__default['default'].string.isRequired
};var _excluded$c = ["value", "className", "max", "min", "step", "name", "type", "onChange"];
// Component
// =============================

var InputRange = /*#__PURE__*/function (_PureComponent) {
  _inherits$e(InputRange, _PureComponent);

  var _super = _createSuper$1(InputRange);

  function InputRange() {
    var _this;

    _classCallCheck$k(this, InputRange);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty$8(_assertThisInitialized$1(_this), "adaptValueIn", function (value) {
      var _this$props = _this.props,
          min = _this$props.min,
          max = _this$props.max;
      if (value === undefined) return [min, max];
      if (value.length === 1) return [value[0], max];
      return value;
    });

    _defineProperty$8(_assertThisInitialized$1(_this), "adaptValueOut", function (value) {
      var _this$props2 = _this.props,
          min = _this$props2.min,
          max = _this$props2.max;
      if (value[0] === min && value[1] === max) return undefined;
      if (value[1] === max) return [value[0]];
      return value;
    });

    _defineProperty$8(_assertThisInitialized$1(_this), "handleChange", function (value) {
      var onChange = _this.props.onChange;
      onChange(_this.adaptValueOut(value));
    });

    return _this;
  }

  _createClass$g(InputRange, [{
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          value = _this$props3.value,
          className = _this$props3.className,
          max = _this$props3.max,
          min = _this$props3.min,
          step = _this$props3.step;
          _this$props3.name;
          var type = _this$props3.type;
          _this$props3.onChange;
          var rest = _objectWithoutProperties$7(_this$props3, _excluded$c);

      return /*#__PURE__*/React__default['default'].createElement(Wrapper$g, _extends$g({
        className: className
      }, getViewProps(rest)), /*#__PURE__*/React__default['default'].createElement(Range, {
        pushable: true,
        min: min,
        max: max,
        step: step,
        value: this.adaptValueIn(value),
        allowCross: false,
        handle: type === 'default' ? handle : handleDuration,
        onChange: this.handleChange
      }));
    }
  }]);

  return InputRange;
}(React.PureComponent); // Resettable uncontrolled component.
// Making this component uncontrollable - improves performance. And wrapping it
// with another component makes it resettable in case value changed, yet keeping
// the performance benefits.
// Since modern best practices suggest to not use componentWillUpdate, this is
// an attempt to make it work via getDerivedStateFromProps


_defineProperty$8(InputRange, "propTypes", {
  /** Props used by styled component to override styles */
  className: PropTypes__default['default'].string,

  /** Max range value */
  max: PropTypes__default['default'].number,

  /** Min range value */
  min: PropTypes__default['default'].number,

  /** Name attribute of the input element. */
  name: PropTypes__default['default'].string.isRequired,

  /** onChange handler */
  onChange: PropTypes__default['default'].func.isRequired,

  /** step range value */
  step: PropTypes__default['default'].number,

  /** Type of value displayed */
  type: PropTypes__default['default'].oneOf(['default', 'duration']),

  /** Value */
  value: PropTypes__default['default'].arrayOf(PropTypes__default['default'].oneOfType([PropTypes__default['default'].string, PropTypes__default['default'].number]))
});

_defineProperty$8(InputRange, "defaultProps", {
  className: '',
  max: 100,
  min: 0,
  step: undefined,
  type: 'default',
  value: undefined
});

var InputRangeResettable = /*#__PURE__*/function (_PureComponent2) {
  _inherits$e(InputRangeResettable, _PureComponent2);

  var _super2 = _createSuper$1(InputRangeResettable);

  function InputRangeResettable() {
    var _this2;

    _classCallCheck$k(this, InputRangeResettable);

    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    _this2 = _super2.call.apply(_super2, [this].concat(args));

    _defineProperty$8(_assertThisInitialized$1(_this2), "state", {
      // eslint-disable-next-line react/destructuring-assignment
      prevPropsValue: _this2.props.value,
      // eslint-disable-next-line react/destructuring-assignment
      value: _this2.props.value
    });

    _defineProperty$8(_assertThisInitialized$1(_this2), "handleUpdate", debounce_1(_this2.props.onChange, 300));

    _defineProperty$8(_assertThisInitialized$1(_this2), "handleChange", function (value) {
      _this2.setState(function () {
        return {
          value: value
        };
      });

      _this2.handleUpdate(value);
    });

    return _this2;
  }

  _createClass$g(InputRangeResettable, [{
    key: "render",
    value: function render() {
      var value = this.state.value;
      return /*#__PURE__*/React__default['default'].createElement(InputRange, _extends$g({}, this.props, {
        value: value,
        onChange: this.handleChange
      }));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props, state) {
      // props didn't change
      if (isEqual_1(props.value, state.prevPropsValue)) return null; // props is same as state, it is up to date. So just update prevPropsValue

      if (isEqual_1(props.value, state.value)) {
        return {
          prevPropsValue: props.value
        };
      } // props was really updated, so update value


      return {
        prevPropsValue: props.value,
        value: props.value
      };
    } // eslint-disable-next-line

  }]);

  return InputRangeResettable;
}(React.PureComponent);

_defineProperty$8(InputRangeResettable, "propTypes", {
  value: PropTypes__default['default'].arrayOf(PropTypes__default['default'].oneOfType([PropTypes__default['default'].string, PropTypes__default['default'].number])),
  onChange: PropTypes__default['default'].func.isRequired
});

_defineProperty$8(InputRangeResettable, "defaultProps", {
  value: undefined
});/**
 * Gets the last element of `array`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to query.
 * @returns {*} Returns the last element of `array`.
 * @example
 *
 * _.last([1, 2, 3]);
 * // => 3
 */

function last$1(array) {
  var length = array == null ? 0 : array.length;
  return length ? array[length - 1] : undefined;
}

var last_1 = last$1;var baseGet$1 = _baseGet,
    baseSlice = _baseSlice;

/**
 * Gets the parent value at `path` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} path The path to get the parent value of.
 * @returns {*} Returns the parent value.
 */
function parent$1(object, path) {
  return path.length < 2 ? object : baseGet$1(object, baseSlice(path, 0, -1));
}

var _parent = parent$1;var castPath$1 = _castPath,
    last = last_1,
    parent = _parent,
    toKey = _toKey;

/**
 * The base implementation of `_.unset`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The property path to unset.
 * @returns {boolean} Returns `true` if the property is deleted, else `false`.
 */
function baseUnset$2(object, path) {
  path = castPath$1(path, object);
  object = parent(object, path);
  return object == null || delete object[toKey(last(path))];
}

var _baseUnset = baseUnset$2;var isPlainObject = isPlainObject_1;

/**
 * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
 * objects.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {string} key The key of the property to inspect.
 * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
 */
function customOmitClone$1(value) {
  return isPlainObject(value) ? undefined : value;
}

var _customOmitClone = customOmitClone$1;var arrayMap$4 = _arrayMap,
    baseClone = _baseClone,
    baseUnset$1 = _baseUnset,
    castPath = _castPath,
    copyObject = _copyObject,
    customOmitClone = _customOmitClone,
    flatRest = _flatRest,
    getAllKeysIn = _getAllKeysIn;

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1,
    CLONE_FLAT_FLAG = 2,
    CLONE_SYMBOLS_FLAG = 4;

/**
 * The opposite of `_.pick`; this method creates an object composed of the
 * own and inherited enumerable property paths of `object` that are not omitted.
 *
 * **Note:** This method is considerably slower than `_.pick`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [paths] The property paths to omit.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.omit(object, ['a', 'c']);
 * // => { 'b': '2' }
 */
var omit = flatRest(function(object, paths) {
  var result = {};
  if (object == null) {
    return result;
  }
  var isDeep = false;
  paths = arrayMap$4(paths, function(path) {
    path = castPath(path, object);
    isDeep || (isDeep = path.length > 1);
    return path;
  });
  copyObject(object, getAllKeysIn(object), result);
  if (isDeep) {
    result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
  }
  var length = paths.length;
  while (length--) {
    baseUnset$1(result, paths[length]);
  }
  return result;
});

var omit_1 = omit;var _templateObject$k, _templateObject2$f, _templateObject3$e, _templateObject4$d, _templateObject5$c;
// Styles
// =============================

var Wrapper$f = styled__default['default'].div(_templateObject$k || (_templateObject$k = _taggedTemplateLiteral$5(["\n  position: relative;\n  width: 100%;\n"])));
var TextAreaInput$1 = styled__default['default'].textarea(_templateObject2$f || (_templateObject2$f = _taggedTemplateLiteral$5(["\n  background-color: transparent;\n  border: 0;\n  color: ", ";\n  font-family: ", ";\n  font-size: inherit;\n  font-weight: inherit;\n  margin: auto;\n  min-height: 1.8rem;\n  outline: 0;\n  position: relative;\n  resize: none;\n  white-space: pre-wrap;\n  width: 100%;\n\n  &:invalid {\n    border: 0;\n    box-shadow: none;\n  }\n\n  &:focus {\n    outline: none;\n  }\n\n  &::-webkit-input-placeholder {\n    color: inherit;\n    font-style: italic;\n    font-weight: inherit;\n    opacity: 0;\n    transition: opacity ", ";\n  }\n\n  &:-moz-placeholder {\n    color: inherit;\n    font-style: italic;\n    font-weight: inherit;\n    opacity: 0;\n    transition: opacity ", ";\n  }\n\n  &::-moz-placeholder {\n    color: inherit;\n    font-style: italic;\n    font-weight: inherit;\n    opacity: 0;\n    transition: opacity ", ";\n  }\n\n  &:-ms-input-placeholder {\n    color: inherit;\n    font-style: italic;\n    font-weight: inherit;\n    opacity: 0;\n    transition: opacity ", ";\n  }\n\n  ", ";\n"])), function (_ref) {
  var error = _ref.error,
      theme = _ref.theme;
  return error ? theme.colors.type.error : theme.colors.input.text;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.fontFamily.primary;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.transition.medium;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.transition.medium;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.transition.medium;
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.transition.medium;
}, function (_ref7) {
  var showPlaceholder = _ref7.showPlaceholder;
  return showPlaceholder && styled.css(_templateObject3$e || (_templateObject3$e = _taggedTemplateLiteral$5(["\n      &::-webkit-input-placeholder {\n        opacity: 0.6;\n      }\n\n      &:-moz-placeholder {\n        opacity: 0.6;\n      }\n\n      &::-moz-placeholder {\n        opacity: 0.6;\n      }\n\n      &:-ms-input-placeholder {\n        opacity: 0.6;\n      }\n    "])));
});
var StyledContainer$2 = styled__default['default'](Container$1)(_templateObject4$d || (_templateObject4$d = _taggedTemplateLiteral$5(["\n  background-color: ", ";\n  border: 0;\n  padding: 1.2rem 1.6rem;\n  padding-bottom: 3.2rem;\n\n"])), function (_ref8) {
  var theme = _ref8.theme;
  return theme.colors.input.background;
});
var PressEnterHelper = styled__default['default'].div(_templateObject5$c || (_templateObject5$c = _taggedTemplateLiteral$5(["\n  color: ", ";\n  position: absolute;\n  bottom: 1.2rem;\n  right: 1.2rem;\n  font-size: 1rem;\n  font-weight: ", ";\n"])), function (_ref9) {
  var theme = _ref9.theme;
  return theme.colors.input.text;
}, function (_ref10) {
  var theme = _ref10.theme;
  return theme.fontWeight.semibold;
});var _excluded$b = ["className", "containerClassName", "disabled", "error", "helperText", "lang", "name", "placeholder", "showPlaceholder"];
// Component
// =============================

var LyricsInput = /*#__PURE__*/function (_PureComponent) {
  _inherits$e(LyricsInput, _PureComponent);

  var _super = _createSuper$1(LyricsInput);

  function LyricsInput(props) {
    var _this;

    _classCallCheck$k(this, LyricsInput);

    _this = _super.call(this, props);

    _defineProperty$8(_assertThisInitialized$1(_this), "handleChange", function (e) {
      /** Recalculate textarea height on updates. */
      _this.inputRef.style.height = '0.5rem';
      _this.inputRef.style.height = "".concat(_this.inputRef.scrollHeight / 10, "rem");
      var value = e.target.value || ''; // 300 characters max

      if (value.length > 300) {
        value = value.substr(0, 300);
      }

      return _this.setState({
        value: value
      });
    });

    _defineProperty$8(_assertThisInitialized$1(_this), "handleClick", function () {
      return _this.inputRef.focus();
    });

    _defineProperty$8(_assertThisInitialized$1(_this), "handleKeyDown", function (event) {
      var onChange = _this.props.onChange;
      var value = _this.state.value; // Enter is use to submit form

      if (event.key === 'Enter' && !event.shiftKey) {
        event.preventDefault();
        return onChange(value);
      }

      return null;
    });

    _this.state = {
      value: ''
    };
    return _this;
  }

  _createClass$g(LyricsInput, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      /** Recalculate textarea height on updates. */
      this.inputRef.style.height = '0.5rem';
      this.inputRef.style.height = "".concat(this.inputRef.scrollHeight / 10, "rem");
    }
    /** Handle input change. */

  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          className = _this$props.className;
          _this$props.containerClassName;
          var disabled = _this$props.disabled,
          error = _this$props.error,
          helperText = _this$props.helperText,
          lang = _this$props.lang,
          name = _this$props.name,
          placeholder = _this$props.placeholder;
          _this$props.showPlaceholder;
          var rest = _objectWithoutProperties$7(_this$props, _excluded$b);

      var value = this.state.value;
      return /*#__PURE__*/React__default['default'].createElement(Wrapper$f, _extends$g({
        className: className,
        disabled: disabled,
        error: error,
        filled: !!value,
        onClick: this.handleClick
      }, omit_1(rest, ['onChange'])), /*#__PURE__*/React__default['default'].createElement(StyledContainer$2, {
        error: error
      }, /*#__PURE__*/React__default['default'].createElement(TextAreaInput$1, {
        tabIndex: "0",
        disabled: disabled,
        error: error,
        ref: function ref(node) {
          _this2.inputRef = node;
        },
        onKeyDown: this.handleKeyDown,
        name: name,
        onChange: this.handleChange,
        placeholder: placeholder,
        value: value
      }), /*#__PURE__*/React__default['default'].createElement(PressEnterHelper, null, lang.pressEnter)), helperText && /*#__PURE__*/React__default['default'].createElement(HelperText, {
        error: error
      }, helperText));
    }
  }]);

  return LyricsInput;
}(React.PureComponent);

_defineProperty$8(LyricsInput, "propTypes", {
  /** Props used by styled component to override styles */
  className: PropTypes__default['default'].string,

  /** Container classname. */
  containerClassName: PropTypes__default['default'].string,

  /** If true, the input will be disabled. */
  disabled: PropTypes__default['default'].bool,

  /** If true, the input will indicate an error. */
  error: PropTypes__default['default'].bool,

  /** The helper text content. */
  helperText: PropTypes__default['default'].string,

  /** If True, will show user this input is translatable. */
  isTranslatable: PropTypes__default['default'].bool,

  /** Message show in isTranslatable tooltip. */
  isTranslatableMessage: PropTypes__default['default'].string,

  /** The label content. */
  label: PropTypes__default['default'].string,

  /** Translation strings. */
  lang: PropTypes__default['default'].object.isRequired,
  // eslint-disable-line react/forbid-prop-types

  /** Name attribute of the input element. */
  name: PropTypes__default['default'].string.isRequired,

  /** Callback fired when the value is changed. */
  onChange: PropTypes__default['default'].func.isRequired,

  /** If true, the input is optional. */
  optional: PropTypes__default['default'].bool,

  /** The short hint displayed in the input before the user enters a value. */
  placeholder: PropTypes__default['default'].string,

  /** If True, placeholder is shown */
  showPlaceholder: PropTypes__default['default'].bool,

  /** If True, show reset button. */
  showResetBtn: PropTypes__default['default'].bool,

  /** If True, Tooltip will be interactive. */
  tooltipInteractive: PropTypes__default['default'].bool,

  /** If set, will add an InfoTooltip btn on input with tooltipMessage as content. */
  tooltipMessage: PropTypes__default['default'].node,

  /** Value. */
  value: PropTypes__default['default'].oneOfType([PropTypes__default['default'].string, PropTypes__default['default'].number]),

  /** Input style variant. */
  variant: PropTypes__default['default'].oneOf(['background', 'underline'])
});

_defineProperty$8(LyricsInput, "defaultProps", {
  className: '',
  containerClassName: '',
  disabled: false,
  error: false,
  helperText: '',
  isTranslatable: false,
  isTranslatableMessage: '',
  label: '',
  optional: false,
  placeholder: '',
  showPlaceholder: false,
  showResetBtn: false,
  tooltipInteractive: false,
  tooltipMessage: '',
  value: undefined,
  variant: 'background'
});var _templateObject$j, _templateObject2$e, _templateObject3$d, _templateObject4$c, _templateObject5$b, _templateObject6$9, _templateObject7$8, _templateObject8$8;
// Styles
// =============================

var Wrapper$e = styled__default['default'].div(_templateObject$j || (_templateObject$j = _taggedTemplateLiteral$5(["\n  font-size: 1.2rem;\n  margin-bottom: 2rem;\n"])));
var Header$1 = styled__default['default'].div(_templateObject2$e || (_templateObject2$e = _taggedTemplateLiteral$5(["\n  align-items: center;\n  cursor: pointer;\n  display: flex;\n"])));
var Title = styled__default['default'].div(_templateObject3$d || (_templateObject3$d = _taggedTemplateLiteral$5(["\n  align-items: center;\n  color: ", ";\n  display: flex;\n  font-size: 1.2rem;\n  font-weight: ", ";\n  margin-right: auto;\n  user-select: none;\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.colors.text;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.fontWeight.extrabold;
});
var ContentMotion = styled__default['default'](framerMotion.motion.div).attrs(function (_ref3) {
  var theme = _ref3.theme;
  return {
    initial: 'closed',
    animate: 'opened',
    exit: 'closed',
    variants: {
      closed: {
        height: 0,
        flip: true,
        marginTop: '0px',
        opacity: 0,
        transition: {
          duration: theme.transition.numeric.medium,
          ease: theme.transitionTiming.pose.easeInOut
        }
      },
      opened: {
        height: 'auto',
        flip: true,
        marginTop: '20px',
        opacity: 1,
        transition: {
          duration: theme.transition.numeric.medium,
          ease: theme.transitionTiming.pose.easeInOut
        }
      }
    }
  };
})(_templateObject4$c || (_templateObject4$c = _taggedTemplateLiteral$5(["\n  overflow: hidden;\n\n  ", ";\n\n  ", ";\n"])), function (_ref4) {
  var withPadding = _ref4.withPadding;
  return withPadding && styled.css(_templateObject5$b || (_templateObject5$b = _taggedTemplateLiteral$5(["\n      padding: 0 2.8rem;\n    "])));
}, function (_ref5) {
  var wideContent = _ref5.wideContent;
  return wideContent && styled.css(_templateObject6$9 || (_templateObject6$9 = _taggedTemplateLiteral$5(["\n      left: -3rem;\n      position: relative;\n      /** 6rem = FilterBar padding x2 */\n      width: calc(100% + 6rem);\n    "])));
});
var DropdownIcon$1 = styled__default['default'](ArrowDropdown$1).attrs(function (_ref6) {
  var opened = _ref6.opened,
      theme = _ref6.theme;
  return {
    dir: opened ? 'north' : 'south',
    fill: alpha$2(theme.colors.text, 0.8),
    width: '0.7rem'
  };
})(_templateObject7$8 || (_templateObject7$8 = _taggedTemplateLiteral$5([""])));
var IndicationDot = styled__default['default'].div(_templateObject8$8 || (_templateObject8$8 = _taggedTemplateLiteral$5(["\n  background-color: ", ";\n  border: 0.1rem solid ", ";\n  border-radius: 50%;\n  height: 1rem;\n  margin-right: 0.5rem;\n  min-width: 1rem;\n  width: 1rem;\n"])), function (_ref7) {
  var dotColor = _ref7.dotColor;
  return dotColor;
}, function (_ref8) {
  var dotColor = _ref8.dotColor;
  return lighten(dotColor, 0.7);
});// Component
// =============================

var TagBox = /*#__PURE__*/function (_PureComponent) {
  _inherits$e(TagBox, _PureComponent);

  var _super = _createSuper$1(TagBox);

  function TagBox() {
    var _this;

    _classCallCheck$k(this, TagBox);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty$8(_assertThisInitialized$1(_this), "handleClick", function () {
      var _this$props = _this.props,
          path = _this$props.path,
          opened = _this$props.opened,
          onOpen = _this$props.onOpen;
      onOpen(path, !opened);
    });

    return _this;
  }

  _createClass$g(TagBox, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          children = _this$props2.children,
          title = _this$props2.title,
          indicationColor = _this$props2.indicationColor,
          wideContent = _this$props2.wideContent,
          opened = _this$props2.opened,
          withPadding = _this$props2.withPadding;
      return /*#__PURE__*/React__default['default'].createElement(Wrapper$e, null, /*#__PURE__*/React__default['default'].createElement(Header$1, {
        opened: opened,
        onClick: this.handleClick
      }, /*#__PURE__*/React__default['default'].createElement(Title, null, indicationColor && /*#__PURE__*/React__default['default'].createElement(IndicationDot, {
        dotColor: indicationColor
      }), title), /*#__PURE__*/React__default['default'].createElement(DropdownIcon$1, {
        opened: opened
      })), /*#__PURE__*/React__default['default'].createElement(framerMotion.AnimatePresence, null, opened && /*#__PURE__*/React__default['default'].createElement(ContentMotion, {
        key: "content",
        wideContent: wideContent,
        withPadding: withPadding
      }, children)));
    }
  }]);

  return TagBox;
}(React.PureComponent);

_defineProperty$8(TagBox, "propTypes", {
  /** TagBox content */
  children: PropTypes__default['default'].node,

  /** Category title */
  title: PropTypes__default['default'].string.isRequired,

  /** Category color */
  indicationColor: PropTypes__default['default'].string,

  /** path for openedBoxes value */

  /** used to avoid arrow function on outside component */
  path: PropTypes__default['default'].string.isRequired,

  /** is opened */
  opened: PropTypes__default['default'].bool.isRequired,

  /** open event */
  onOpen: PropTypes__default['default'].func.isRequired,

  /** If True, Content will have FilterBar Width */
  wideContent: PropTypes__default['default'].bool,

  /** If True, Content will have padding, so range would fit in */
  withPadding: PropTypes__default['default'].bool
});

_defineProperty$8(TagBox, "defaultProps", {
  children: null,
  indicationColor: null,
  wideContent: false,
  withPadding: false
});var baseIndexOf = _baseIndexOf;

/**
 * A specialized version of `_.includes` for arrays without support for
 * specifying an index to search from.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */
function arrayIncludes$3(array, value) {
  var length = array == null ? 0 : array.length;
  return !!length && baseIndexOf(array, value, 0) > -1;
}

var _arrayIncludes = arrayIncludes$3;/**
 * This function is like `arrayIncludes` except that it accepts a comparator.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @param {Function} comparator The comparator invoked per element.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */

function arrayIncludesWith$3(array, value, comparator) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (comparator(value, array[index])) {
      return true;
    }
  }
  return false;
}

var _arrayIncludesWith = arrayIncludesWith$3;var SetCache$2 = _SetCache,
    arrayIncludes$2 = _arrayIncludes,
    arrayIncludesWith$2 = _arrayIncludesWith,
    arrayMap$3 = _arrayMap,
    baseUnary$2 = _baseUnary,
    cacheHas$2 = _cacheHas;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMin = Math.min;

/**
 * The base implementation of methods like `_.intersection`, without support
 * for iteratee shorthands, that accepts an array of arrays to inspect.
 *
 * @private
 * @param {Array} arrays The arrays to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new array of shared values.
 */
function baseIntersection$1(arrays, iteratee, comparator) {
  var includes = comparator ? arrayIncludesWith$2 : arrayIncludes$2,
      length = arrays[0].length,
      othLength = arrays.length,
      othIndex = othLength,
      caches = Array(othLength),
      maxLength = Infinity,
      result = [];

  while (othIndex--) {
    var array = arrays[othIndex];
    if (othIndex && iteratee) {
      array = arrayMap$3(array, baseUnary$2(iteratee));
    }
    maxLength = nativeMin(array.length, maxLength);
    caches[othIndex] = !comparator && (iteratee || (length >= 120 && array.length >= 120))
      ? new SetCache$2(othIndex && array)
      : undefined;
  }
  array = arrays[0];

  var index = -1,
      seen = caches[0];

  outer:
  while (++index < length && result.length < maxLength) {
    var value = array[index],
        computed = iteratee ? iteratee(value) : value;

    value = (comparator || value !== 0) ? value : 0;
    if (!(seen
          ? cacheHas$2(seen, computed)
          : includes(result, computed, comparator)
        )) {
      othIndex = othLength;
      while (--othIndex) {
        var cache = caches[othIndex];
        if (!(cache
              ? cacheHas$2(cache, computed)
              : includes(arrays[othIndex], computed, comparator))
            ) {
          continue outer;
        }
      }
      if (seen) {
        seen.push(computed);
      }
      result.push(value);
    }
  }
  return result;
}

var _baseIntersection = baseIntersection$1;var isArrayLikeObject$3 = isArrayLikeObject_1;

/**
 * Casts `value` to an empty array if it's not an array like object.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Array|Object} Returns the cast array-like object.
 */
function castArrayLikeObject$1(value) {
  return isArrayLikeObject$3(value) ? value : [];
}

var _castArrayLikeObject = castArrayLikeObject$1;var arrayMap$2 = _arrayMap,
    baseIntersection = _baseIntersection,
    baseRest$4 = _baseRest,
    castArrayLikeObject = _castArrayLikeObject;

/**
 * Creates an array of unique values that are included in all given arrays
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons. The order and references of result values are
 * determined by the first array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {...Array} [arrays] The arrays to inspect.
 * @returns {Array} Returns the new array of intersecting values.
 * @example
 *
 * _.intersection([2, 1], [2, 3]);
 * // => [2]
 */
var intersection = baseRest$4(function(arrays) {
  var mapped = arrayMap$2(arrays, castArrayLikeObject);
  return (mapped.length && mapped[0] === arrays[0])
    ? baseIntersection(mapped)
    : [];
});

var intersection_1 = intersection;/**
 * The base implementation of `_.sortBy` which uses `comparer` to define the
 * sort order of `array` and replaces criteria objects with their corresponding
 * values.
 *
 * @private
 * @param {Array} array The array to sort.
 * @param {Function} comparer The function to define sort order.
 * @returns {Array} Returns `array`.
 */

function baseSortBy$1(array, comparer) {
  var length = array.length;

  array.sort(comparer);
  while (length--) {
    array[length] = array[length].value;
  }
  return array;
}

var _baseSortBy = baseSortBy$1;var isSymbol = isSymbol_1;

/**
 * Compares values to sort them in ascending order.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {number} Returns the sort order indicator for `value`.
 */
function compareAscending$1(value, other) {
  if (value !== other) {
    var valIsDefined = value !== undefined,
        valIsNull = value === null,
        valIsReflexive = value === value,
        valIsSymbol = isSymbol(value);

    var othIsDefined = other !== undefined,
        othIsNull = other === null,
        othIsReflexive = other === other,
        othIsSymbol = isSymbol(other);

    if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
        (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
        (valIsNull && othIsDefined && othIsReflexive) ||
        (!valIsDefined && othIsReflexive) ||
        !valIsReflexive) {
      return 1;
    }
    if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
        (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
        (othIsNull && valIsDefined && valIsReflexive) ||
        (!othIsDefined && valIsReflexive) ||
        !othIsReflexive) {
      return -1;
    }
  }
  return 0;
}

var _compareAscending = compareAscending$1;var compareAscending = _compareAscending;

/**
 * Used by `_.orderBy` to compare multiple properties of a value to another
 * and stable sort them.
 *
 * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
 * specify an order of "desc" for descending or "asc" for ascending sort order
 * of corresponding values.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {boolean[]|string[]} orders The order to sort by for each property.
 * @returns {number} Returns the sort order indicator for `object`.
 */
function compareMultiple$1(object, other, orders) {
  var index = -1,
      objCriteria = object.criteria,
      othCriteria = other.criteria,
      length = objCriteria.length,
      ordersLength = orders.length;

  while (++index < length) {
    var result = compareAscending(objCriteria[index], othCriteria[index]);
    if (result) {
      if (index >= ordersLength) {
        return result;
      }
      var order = orders[index];
      return result * (order == 'desc' ? -1 : 1);
    }
  }
  // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
  // that causes it, under certain circumstances, to provide the same value for
  // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
  // for more details.
  //
  // This also ensures a stable sort in V8 and other engines.
  // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
  return object.index - other.index;
}

var _compareMultiple = compareMultiple$1;var arrayMap$1 = _arrayMap,
    baseGet = _baseGet,
    baseIteratee$3 = _baseIteratee,
    baseMap = _baseMap,
    baseSortBy = _baseSortBy,
    baseUnary$1 = _baseUnary,
    compareMultiple = _compareMultiple,
    identity = identity_1,
    isArray = isArray_1;

/**
 * The base implementation of `_.orderBy` without param guards.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
 * @param {string[]} orders The sort orders of `iteratees`.
 * @returns {Array} Returns the new sorted array.
 */
function baseOrderBy$1(collection, iteratees, orders) {
  if (iteratees.length) {
    iteratees = arrayMap$1(iteratees, function(iteratee) {
      if (isArray(iteratee)) {
        return function(value) {
          return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
        }
      }
      return iteratee;
    });
  } else {
    iteratees = [identity];
  }

  var index = -1;
  iteratees = arrayMap$1(iteratees, baseUnary$1(baseIteratee$3));

  var result = baseMap(collection, function(value, key, collection) {
    var criteria = arrayMap$1(iteratees, function(iteratee) {
      return iteratee(value);
    });
    return { 'criteria': criteria, 'index': ++index, 'value': value };
  });

  return baseSortBy(result, function(object, other) {
    return compareMultiple(object, other, orders);
  });
}

var _baseOrderBy = baseOrderBy$1;var baseFlatten$2 = _baseFlatten,
    baseOrderBy = _baseOrderBy,
    baseRest$3 = _baseRest,
    isIterateeCall = _isIterateeCall;

/**
 * Creates an array of elements, sorted in ascending order by the results of
 * running each element in a collection thru each iteratee. This method
 * performs a stable sort, that is, it preserves the original sort order of
 * equal elements. The iteratees are invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {...(Function|Function[])} [iteratees=[_.identity]]
 *  The iteratees to sort by.
 * @returns {Array} Returns the new sorted array.
 * @example
 *
 * var users = [
 *   { 'user': 'fred',   'age': 48 },
 *   { 'user': 'barney', 'age': 36 },
 *   { 'user': 'fred',   'age': 30 },
 *   { 'user': 'barney', 'age': 34 }
 * ];
 *
 * _.sortBy(users, [function(o) { return o.user; }]);
 * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
 *
 * _.sortBy(users, ['user', 'age']);
 * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
 */
var sortBy = baseRest$3(function(collection, iteratees) {
  if (collection == null) {
    return [];
  }
  var length = iteratees.length;
  if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
    iteratees = [];
  } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
    iteratees = [iteratees[0]];
  }
  return baseOrderBy(collection, baseFlatten$2(iteratees, 1), []);
});

var sortBy_1 = sortBy;/**
 * This method returns `undefined`.
 *
 * @static
 * @memberOf _
 * @since 2.3.0
 * @category Util
 * @example
 *
 * _.times(2, _.noop);
 * // => [undefined, undefined]
 */

function noop$1() {
  // No operation performed.
}

var noop_1 = noop$1;var Set$1 = _Set,
    noop = noop_1,
    setToArray$1 = _setToArray;

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Creates a set object of `values`.
 *
 * @private
 * @param {Array} values The values to add to the set.
 * @returns {Object} Returns the new set.
 */
var createSet$1 = !(Set$1 && (1 / setToArray$1(new Set$1([,-0]))[1]) == INFINITY) ? noop : function(values) {
  return new Set$1(values);
};

var _createSet = createSet$1;var SetCache$1 = _SetCache,
    arrayIncludes$1 = _arrayIncludes,
    arrayIncludesWith$1 = _arrayIncludesWith,
    cacheHas$1 = _cacheHas,
    createSet = _createSet,
    setToArray = _setToArray;

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE$1 = 200;

/**
 * The base implementation of `_.uniqBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 */
function baseUniq$1(array, iteratee, comparator) {
  var index = -1,
      includes = arrayIncludes$1,
      length = array.length,
      isCommon = true,
      result = [],
      seen = result;

  if (comparator) {
    isCommon = false;
    includes = arrayIncludesWith$1;
  }
  else if (length >= LARGE_ARRAY_SIZE$1) {
    var set = iteratee ? null : createSet(array);
    if (set) {
      return setToArray(set);
    }
    isCommon = false;
    includes = cacheHas$1;
    seen = new SetCache$1;
  }
  else {
    seen = iteratee ? [] : result;
  }
  outer:
  while (++index < length) {
    var value = array[index],
        computed = iteratee ? iteratee(value) : value;

    value = (comparator || value !== 0) ? value : 0;
    if (isCommon && computed === computed) {
      var seenIndex = seen.length;
      while (seenIndex--) {
        if (seen[seenIndex] === computed) {
          continue outer;
        }
      }
      if (iteratee) {
        seen.push(computed);
      }
      result.push(value);
    }
    else if (!includes(seen, computed, comparator)) {
      if (seen !== result) {
        seen.push(computed);
      }
      result.push(value);
    }
  }
  return result;
}

var _baseUniq = baseUniq$1;var baseFlatten$1 = _baseFlatten,
    baseRest$2 = _baseRest,
    baseUniq = _baseUniq,
    isArrayLikeObject$2 = isArrayLikeObject_1;

/**
 * Creates an array of unique values, in order, from all given arrays using
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {...Array} [arrays] The arrays to inspect.
 * @returns {Array} Returns the new array of combined values.
 * @example
 *
 * _.union([2], [1, 2]);
 * // => [2, 1]
 */
var union = baseRest$2(function(arrays) {
  return baseUniq(baseFlatten$1(arrays, 1, isArrayLikeObject$2, true));
});

var union_1 = union;var SetCache = _SetCache,
    arrayIncludes = _arrayIncludes,
    arrayIncludesWith = _arrayIncludesWith,
    arrayMap = _arrayMap,
    baseUnary = _baseUnary,
    cacheHas = _cacheHas;

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * The base implementation of methods like `_.difference` without support
 * for excluding multiple arrays or iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Array} values The values to exclude.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new array of filtered values.
 */
function baseDifference$2(array, values, iteratee, comparator) {
  var index = -1,
      includes = arrayIncludes,
      isCommon = true,
      length = array.length,
      result = [],
      valuesLength = values.length;

  if (!length) {
    return result;
  }
  if (iteratee) {
    values = arrayMap(values, baseUnary(iteratee));
  }
  if (comparator) {
    includes = arrayIncludesWith;
    isCommon = false;
  }
  else if (values.length >= LARGE_ARRAY_SIZE) {
    includes = cacheHas;
    isCommon = false;
    values = new SetCache(values);
  }
  outer:
  while (++index < length) {
    var value = array[index],
        computed = iteratee == null ? value : iteratee(value);

    value = (comparator || value !== 0) ? value : 0;
    if (isCommon && computed === computed) {
      var valuesIndex = valuesLength;
      while (valuesIndex--) {
        if (values[valuesIndex] === computed) {
          continue outer;
        }
      }
      result.push(value);
    }
    else if (!includes(values, computed, comparator)) {
      result.push(value);
    }
  }
  return result;
}

var _baseDifference = baseDifference$2;var baseDifference$1 = _baseDifference,
    baseFlatten = _baseFlatten,
    baseRest$1 = _baseRest,
    isArrayLikeObject$1 = isArrayLikeObject_1;

/**
 * Creates an array of `array` values not included in the other given arrays
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons. The order and references of result values are
 * determined by the first array.
 *
 * **Note:** Unlike `_.pullAll`, this method returns a new array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {...Array} [values] The values to exclude.
 * @returns {Array} Returns the new array of filtered values.
 * @see _.without, _.xor
 * @example
 *
 * _.difference([2, 1], [2, 3]);
 * // => [1]
 */
var difference = baseRest$1(function(array, values) {
  return isArrayLikeObject$1(array)
    ? baseDifference$1(array, baseFlatten(values, 1, isArrayLikeObject$1, true))
    : [];
});

var difference_1 = difference;var baseDifference = _baseDifference,
    baseRest = _baseRest,
    isArrayLikeObject = isArrayLikeObject_1;

/**
 * Creates an array excluding all given values using
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * **Note:** Unlike `_.pull`, this method returns a new array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {...*} [values] The values to exclude.
 * @returns {Array} Returns the new array of filtered values.
 * @see _.difference, _.xor
 * @example
 *
 * _.without([2, 1, 2, 3], 1, 2);
 * // => [3]
 */
var without = baseRest(function(array, values) {
  return isArrayLikeObject(array)
    ? baseDifference(array, values)
    : [];
});

var without_1 = without;var _templateObject$i;
// Styles
// =============================

var Svg = styled__default['default'](Div).attrs({
  as: 'svg'
})(_templateObject$i || (_templateObject$i = _taggedTemplateLiteral$5(["\n  background-color: ", ";\n  left: 0;\n  position: absolute;\n  top: 0;\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.colors.background;
});var _excluded$a = ["onClick", "title", "theme"];
// Component
// =============================

var Background$1 = /*#__PURE__*/React__default['default'].memo(function (_ref) {
  var onClick = _ref.onClick,
      title = _ref.title,
      theme = _ref.theme,
      rest = _objectWithoutProperties$7(_ref, _excluded$a);

  return /*#__PURE__*/React__default['default'].createElement(Svg, _extends$g({
    fill: alpha$2(theme.colors.text, 0.2),
    onClick: onClick,
    title: title,
    viewBox: "0 0 300 7"
  }, rest), /*#__PURE__*/React__default['default'].createElement("path", {
    fillRule: "evenodd",
    d: "M0,5.999999999999773 C0,5.999999999999773 64.67076394106351,5.999999999999773 84.83538197053176,5.999999999999773 C105,5.999999999999773 134.3259900631756,-2.282283612900061e-13 149.59986541994772,-2.2737367544323206e-13 C164.87374077671984,-2.26518989596458e-13 194.52409857291033,5.999999999999773 214.99095179994464,5.999999999999773 C235.45780502697895,5.999999999999773 300,5.999999999999773 300,5.999999999999773 L300,6.999999999999773 L0,6.999999999999773 L0,5.999999999999773Z"
  }));
});
Background$1.propTypes = {
  /** onClick handler. */
  onClick: PropTypes__default['default'].func,

  /** Styled component theme. */
  theme: PropTypes__default['default'].object.isRequired,
  // eslint-disable-line react/forbid-prop-types

  /** Icon title. */
  title: PropTypes__default['default'].string,

  /** Icon width (passed to Svg via ...rest props). */
  width: PropTypes__default['default'].string
};
Background$1.defaultProps = {
  onClick: null,
  title: '',
  width: '100%'
};
var Background$2 = styled.withTheme(Background$1);var _templateObject$h, _templateObject2$d, _templateObject3$c, _templateObject4$b, _templateObject5$a, _templateObject6$8, _templateObject7$7, _templateObject8$7, _templateObject9$4, _templateObject10$4, _templateObject11$4, _templateObject12$3, _templateObject13$3, _templateObject14$3, _templateObject15$2, _templateObject16$1, _templateObject17$1, _templateObject18$1, _templateObject19, _templateObject20, _templateObject21;
// Styles
// =============================

var Wrapper$d = styled__default['default'](framerMotion.motion.div).attrs(function () {
  return {
    layout: true
  };
})(_templateObject$h || (_templateObject$h = _taggedTemplateLiteral$5(["\n  &:not(:last-child) {\n    margin-bottom: ", ";\n  }\n"])), function (_ref) {
  var categoryTag = _ref.categoryTag;
  return categoryTag ? '1.6rem' : '2rem';
});
var Tag = styled__default['default'].div(_templateObject2$d || (_templateObject2$d = _taggedTemplateLiteral$5([""])));
var TagHeader = styled__default['default'].div(_templateObject3$c || (_templateObject3$c = _taggedTemplateLiteral$5(["\n  align-items: center;\n  display: flex;\n  justify-content: space-between;\n  padding: 0 3rem;\n\n  ", "\n"])), function (_ref2) {
  var available = _ref2.available;
  return !available && styled.css(_templateObject4$b || (_templateObject4$b = _taggedTemplateLiteral$5(["\n      opacity: 0.4;\n    "])));
});
var ChildHeader = styled__default['default'].div(_templateObject5$a || (_templateObject5$a = _taggedTemplateLiteral$5(["\n  align-items: center;\n  color: ", ";\n  display: flex;\n  justify-content: space-between;\n\n  &:not(:last-child) {\n    margin-bottom: 1rem;\n  }\n\n  ", "\n"])), function (_ref3) {
  var theme = _ref3.theme;
  return theme.colors.text;
}, function (_ref4) {
  var available = _ref4.available;
  return !available && styled.css(_templateObject6$8 || (_templateObject6$8 = _taggedTemplateLiteral$5(["\n      opacity: 0.4;\n    "])));
});
var TagName = styled__default['default'].div(_templateObject7$7 || (_templateObject7$7 = _taggedTemplateLiteral$5(["\n  align-items: center;\n  display: flex;\n  font-size: 1.2rem;\n  font-weight: ", ";\n  line-height: 1.4;\n  max-width: calc(100% - 6.4rem);\n  text-align: center;\n  transition: color ", ";\n\n  ", ";\n"])), function (_ref5) {
  var theme = _ref5.theme;
  return theme.fontWeight.bold;
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.transition.medium;
}, function (_ref7) {
  var hasChildren = _ref7.hasChildren;
  return hasChildren && styled.css(_templateObject8$7 || (_templateObject8$7 = _taggedTemplateLiteral$5(["\n      cursor: pointer;\n\n      &:hover {\n        color: ", ";\n\n        svg path {\n          fill: ", ";\n        }\n      }\n    "])), function (_ref8) {
    var theme = _ref8.theme;
    return theme.colors.primary;
  }, function (_ref9) {
    var theme = _ref9.theme;
    return theme.colors.primary;
  });
});
var MinusIcon = styled__default['default'](MinusOutline$1).attrs(function (_ref10) {
  var theme = _ref10.theme;
  return {
    fill: alpha$2(theme.colors.text, 0.8),
    width: '2rem'
  };
})(_templateObject9$4 || (_templateObject9$4 = _taggedTemplateLiteral$5(["\n  ", ";\n"])), function (_ref11) {
  var onClick = _ref11.onClick,
      selected = _ref11.selected,
      theme = _ref11.theme;
  return selected ? styled.css(_templateObject10$4 || (_templateObject10$4 = _taggedTemplateLiteral$5(["\n          svg path {\n            fill: ", ";\n          }\n\n          svg circle {\n            fill: ", ";\n            fill-opacity: 1;\n            stroke: ", ";\n          }\n        "])), theme.colors.primaryText, theme.colors.primary, theme.colors.primary) : styled.css(_templateObject11$4 || (_templateObject11$4 = _taggedTemplateLiteral$5(["\n          ", ";\n        "])), onClick && styled.css(_templateObject12$3 || (_templateObject12$3 = _taggedTemplateLiteral$5(["\n              cursor: pointer;\n\n              &:hover {\n                svg path {\n                  fill: ", ";\n                }\n\n                svg circle {\n                  fill: ", ";\n                  fill-opacity: 1;\n                  stroke: ", ";\n                }\n              }\n            "])), theme.colors.primaryText, theme.colors.primary, theme.colors.primary));
});
var PlusIcon = styled__default['default'](PlusOutline$1).attrs(function (_ref12) {
  var theme = _ref12.theme;
  return {
    fill: alpha$2(theme.colors.text, 0.8),
    width: '2rem'
  };
})(_templateObject13$3 || (_templateObject13$3 = _taggedTemplateLiteral$5(["\n  ", ";\n"])), function (_ref13) {
  var onClick = _ref13.onClick,
      selected = _ref13.selected,
      theme = _ref13.theme;
  return selected ? styled.css(_templateObject14$3 || (_templateObject14$3 = _taggedTemplateLiteral$5(["\n          svg path {\n            fill: ", ";\n          }\n\n          svg circle {\n            fill: ", ";\n            fill-opacity: 1;\n            stroke: ", ";\n          }\n        "])), theme.colors.primaryText, theme.colors.primary, theme.colors.primary) : styled.css(_templateObject15$2 || (_templateObject15$2 = _taggedTemplateLiteral$5(["\n          ", ";\n        "])), onClick && styled.css(_templateObject16$1 || (_templateObject16$1 = _taggedTemplateLiteral$5(["\n              cursor: pointer;\n\n              &:hover {\n                svg path {\n                  fill: ", ";\n                }\n\n                svg circle {\n                  fill: ", ";\n                  fill-opacity: 1;\n                  stroke: ", ";\n                }\n              }\n            "])), theme.colors.primaryText, theme.colors.primary, theme.colors.primary));
});
var DropdownIcon = styled__default['default'](ArrowDropdown$1).attrs(function (_ref14) {
  var opened = _ref14.opened,
      theme = _ref14.theme;
  return {
    dir: opened ? 'north' : 'south',
    fill: alpha$2(theme.colors.text, 0.8)
  };
})(_templateObject17$1 || (_templateObject17$1 = _taggedTemplateLiteral$5([""])));
var TagChildren = styled__default['default'](framerMotion.motion.div).attrs(function (_ref15) {
  var opened = _ref15.opened,
      theme = _ref15.theme;
  return {
    initial: opened ? 'opened' : 'closed',
    animate: opened ? 'opened' : 'closed',
    variants: {
      closed: {
        height: 0,
        marginTop: '0px',
        opacity: 0,
        duration: theme.transition.numeric.medium,
        ease: theme.transitionTiming.pose.easeInOut
      },
      opened: {
        height: 'auto',
        marginTop: '8px',
        opacity: 1,
        duration: theme.transition.numeric.medium,
        ease: theme.transitionTiming.pose.easeInOut
      }
    }
  };
})(_templateObject18$1 || (_templateObject18$1 = _taggedTemplateLiteral$5(["\n  background-color: ", ";\n  overflow: hidden;\n  position: relative;\n"])), function (_ref16) {
  var theme = _ref16.theme;
  return alpha$2(theme.colors.text, 0.2);
});
var ChildrenWrapper = styled__default['default'].div(_templateObject19 || (_templateObject19 = _taggedTemplateLiteral$5(["\n  ", ";\n\n  ", ";\n"])), function (_ref17) {
  var theme = _ref17.theme;
  return theme.mediaBelow.minWidth(_templateObject20 || (_templateObject20 = _taggedTemplateLiteral$5(["\n    padding: 2.4rem 3rem 2rem;\n  "])));
}, function (_ref18) {
  var theme = _ref18.theme;
  return theme.mediaAbove.minWidth(_templateObject21 || (_templateObject21 = _taggedTemplateLiteral$5(["\n    padding: 2rem 3rem 2rem;\n  "])));
});// Component
// =============================

var SubCategoryTag = /*#__PURE__*/function (_PureComponent) {
  _inherits$e(SubCategoryTag, _PureComponent);

  var _super = _createSuper$1(SubCategoryTag);

  function SubCategoryTag() {
    var _this;

    _classCallCheck$k(this, SubCategoryTag);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty$8(_assertThisInitialized$1(_this), "handleExclude", function () {
      var _this$props = _this.props,
          onExclude = _this$props.onExclude,
          tag = _this$props.tag;
      onExclude(tag.id);
    });

    _defineProperty$8(_assertThisInitialized$1(_this), "handleInclude", function () {
      var _this$props2 = _this.props,
          onInclude = _this$props2.onInclude,
          tag = _this$props2.tag;
      onInclude(tag.id);
    });

    _defineProperty$8(_assertThisInitialized$1(_this), "handleRemove", function () {
      var _this$props3 = _this.props,
          onRemove = _this$props3.onRemove,
          tag = _this$props3.tag;
      onRemove(tag.id);
    });

    _defineProperty$8(_assertThisInitialized$1(_this), "handleExcludeOnClick", function () {
      if (_this.isNot()) {
        return _this.handleRemove;
      }

      if (!_this.isAvailable('exclude')) return null;
      return _this.handleExclude;
    });

    _defineProperty$8(_assertThisInitialized$1(_this), "handleIncludeOnClick", function () {
      if (_this.isOr() || _this.is()) {
        return _this.handleRemove;
      }

      if (!_this.isAvailable('include')) return null;
      return _this.handleInclude;
    });

    _defineProperty$8(_assertThisInitialized$1(_this), "is", function () {
      var _this$props4 = _this.props,
          tag = _this$props4.tag,
          valueTags = _this$props4.valueTags;
      return includes_1(valueTags, tag.id);
    });

    _defineProperty$8(_assertThisInitialized$1(_this), "isNot", function () {
      var _this$props5 = _this.props,
          parentId = _this$props5.parentId,
          tag = _this$props5.tag,
          valueTagsNot = _this$props5.valueTagsNot;
      return intersection_1(valueTagsNot, [tag.id, parentId]).length > 0;
    });

    _defineProperty$8(_assertThisInitialized$1(_this), "isOr", function () {
      var _this$props6 = _this.props,
          parentId = _this$props6.parentId,
          tag = _this$props6.tag,
          valueTagsOr = _this$props6.valueTagsOr,
          valueTagsNot = _this$props6.valueTagsNot;
      return intersection_1(valueTagsOr, [parentId, tag.id]).length > 0 && !includes_1(valueTagsNot, tag.id);
    });

    _defineProperty$8(_assertThisInitialized$1(_this), "isAvailable", function (type) {
      var _this$props7 = _this.props,
          parentId = _this$props7.parentId,
          tag = _this$props7.tag,
          tagsAvailable = _this$props7.tagsAvailable,
          valueTags = _this$props7.valueTags,
          valueTagsNot = _this$props7.valueTagsNot,
          valueTagsOr = _this$props7.valueTagsOr; // If a tag is included, then the exclude button is available.

      if (type === 'exclude') {
        if (includes_1(valueTags, tag.id)) return true;
        if (includes_1(valueTagsOr, parentId)) return true;
      } // If a tag is excluded, then the include button is available.


      if (type === 'include') {
        if (includes_1(valueTagsNot, tag.id)) return true;
        if (includes_1(valueTagsNot, parentId)) return true;
      } // If we want the availability of the wrapper (to change opacity).


      if (type === 'global') {
        // If tag is excluded or included,
        // or if his parent is included or excluded,
        // then tag is available.
        if (includes_1(valueTags, tag.id)) return true;
        if (includes_1(valueTagsNot, tag.id)) return true;
        if (includes_1(valueTagsNot, parentId)) return true;
        if (includes_1(valueTagsOr, parentId)) return true;
      }

      return includes_1(tagsAvailable, tag.id);
    });

    return _this;
  }

  _createClass$g(SubCategoryTag, [{
    key: "render",
    value: function render() {
      var _this$props8 = this.props,
          locale = _this$props8.locale,
          search = _this$props8.search,
          tag = _this$props8.tag;
      var synonym = tagSynonymFound(tag, search, locale);
      return /*#__PURE__*/React__default['default'].createElement(ChildHeader, {
        available: this.isAvailable('global')
      }, /*#__PURE__*/React__default['default'].createElement(MinusIcon, {
        onClick: this.handleExcludeOnClick(),
        selected: this.isNot()
      }), /*#__PURE__*/React__default['default'].createElement(TagName, null, getName(tag.names, locale), synonym ? " (".concat(synonym, ")") : null), /*#__PURE__*/React__default['default'].createElement(PlusIcon, {
        onClick: this.handleIncludeOnClick(),
        selected: this.isOr() || this.is()
      }));
    }
  }]);

  return SubCategoryTag;
}(React.PureComponent);

_defineProperty$8(SubCategoryTag, "propTypes", {
  /** Lang used by user. */
  locale: PropTypes__default['default'].string.isRequired,
  onExclude: PropTypes__default['default'].func.isRequired,
  onInclude: PropTypes__default['default'].func.isRequired,
  onRemove: PropTypes__default['default'].func.isRequired,

  /** SubCategory parent id. */
  parentId: PropTypes__default['default'].string.isRequired,

  /** User search query string. */
  search: PropTypes__default['default'].string.isRequired,

  /** Current tag object being rendered. */
  tag: tag.isRequired,

  /** Tags available for inclusion or exclusion. */
  tagsAvailable: PropTypes__default['default'].arrayOf(PropTypes__default['default'].string).isRequired,

  /** Array of tag id that are included. */
  valueTags: PropTypes__default['default'].arrayOf(PropTypes__default['default'].string).isRequired,

  /** Array of tag id that are excluded. */
  valueTagsNot: PropTypes__default['default'].arrayOf(PropTypes__default['default'].string).isRequired,

  /** Array of subCategory tag id that are included. */
  valueTagsOr: PropTypes__default['default'].arrayOf(PropTypes__default['default'].string).isRequired
});// Component
// =============================

var SubCategorySwitcher = /*#__PURE__*/function (_PureComponent) {
  _inherits$e(SubCategorySwitcher, _PureComponent);

  var _super = _createSuper$1(SubCategorySwitcher);

  function SubCategorySwitcher() {
    var _this;

    _classCallCheck$k(this, SubCategorySwitcher);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty$8(_assertThisInitialized$1(_this), "getAllTagIds", function () {
      var tag = _this.props.tag;
      return tag.tags.map(function (t) {
        return t.id;
      });
    });

    _defineProperty$8(_assertThisInitialized$1(_this), "getAllTagIdsUnfiltered", function () {
      var initialTag = _this.props.initialTag;
      return initialTag.tags.map(function (t) {
        return t.id;
      });
    });

    _defineProperty$8(_assertThisInitialized$1(_this), "calcTagsNotForExcludeOne", function (id) {
      var _this$props = _this.props,
          tag = _this$props.tag,
          valueTagsNot = _this$props.valueTagsNot; // if subcategory is included - do not do anything

      if (valueTagsNot.includes(tag.id)) return valueTagsNot;

      var tagsNot = union_1(valueTagsNot, [id]); // add tag id
      // if all tags are included then substitute it with subcategory


      if (difference_1(_this.getAllTagIdsUnfiltered(), tagsNot).length) return tagsNot.sort();
      return union_1(without_1.apply(void 0, [tagsNot].concat(_toConsumableArray$5(_this.getAllTagIdsUnfiltered()))), [tag.id]).sort();
    });

    _defineProperty$8(_assertThisInitialized$1(_this), "calcTagsNotForIncludeOne", function (id) {
      var _this$props2 = _this.props,
          tag = _this$props2.tag,
          valueTagsNot = _this$props2.valueTagsNot; // if subcategory is not included just remove tag id from list if necessary

      if (!valueTagsNot.includes(tag.id)) return without_1.apply(void 0, [valueTagsNot].concat([id])).sort(); // if subcategory is included, add exclude tag ids of subcategory except the included one

      return difference_1(_this.getAllTagIdsUnfiltered(), [id]).sort();
    });

    _defineProperty$8(_assertThisInitialized$1(_this), "handleOpen", function () {
      var _this$props3 = _this.props,
          onOpen = _this$props3.onOpen,
          opened = _this$props3.opened,
          tag = _this$props3.tag;
      onOpen("subCategories['".concat(tag.id, "']"), !opened);
    });

    _defineProperty$8(_assertThisInitialized$1(_this), "handleIncludeOne", function (id) {
      var _this$props4 = _this.props,
          onChange = _this$props4.onChange,
          tag = _this$props4.tag,
          valueTags = _this$props4.valueTags,
          valueTagsOr = _this$props4.valueTagsOr;
      onChange({
        tags: union_1(valueTags, [id]).sort(),
        tagsNot: _this.calcTagsNotForIncludeOne(id),
        tagsOr: without_1.apply(void 0, [valueTagsOr].concat([tag.id])).sort()
      });
    });

    _defineProperty$8(_assertThisInitialized$1(_this), "handleExcludeOne", function (id) {
      var _this$props5 = _this.props,
          onChange = _this$props5.onChange,
          valueTags = _this$props5.valueTags,
          valueTagsOr = _this$props5.valueTagsOr;
      onChange({
        tags: without_1.apply(void 0, [valueTags].concat([id])).sort(),
        tagsNot: _this.calcTagsNotForExcludeOne(id),
        tagsOr: without_1.apply(void 0, [valueTagsOr].concat(_toConsumableArray$5(_this.calcTagsNotForExcludeOne(id)))).sort()
      });
    });

    _defineProperty$8(_assertThisInitialized$1(_this), "handleRemoveOne", function (id) {
      var _this$props6 = _this.props,
          onChange = _this$props6.onChange,
          valueTags = _this$props6.valueTags,
          valueTagsOr = _this$props6.valueTagsOr;
      onChange({
        tags: without_1.apply(void 0, [valueTags].concat([id])).sort(),
        tagsNot: _this.calcTagsNotForIncludeOne(id),
        tagsOr: without_1.apply(void 0, [valueTagsOr].concat(_toConsumableArray$5(_this.calcTagsNotForExcludeOne(id)))).sort()
      });
    });

    _defineProperty$8(_assertThisInitialized$1(_this), "handleIncludeAll", function () {
      var _this$props7 = _this.props,
          onChange = _this$props7.onChange,
          tag = _this$props7.tag,
          valueTags = _this$props7.valueTags,
          valueTagsNot = _this$props7.valueTagsNot,
          valueTagsOr = _this$props7.valueTagsOr;
      onChange({
        tags: without_1.apply(void 0, [valueTags].concat(_toConsumableArray$5(_this.getAllTagIdsUnfiltered()))).sort(),
        tagsNot: without_1.apply(void 0, [valueTagsNot].concat([].concat(_toConsumableArray$5(_this.getAllTagIdsUnfiltered()), [tag.id]))).sort(),
        tagsOr: union_1(valueTagsOr, [tag.id]).sort()
      });
    });

    _defineProperty$8(_assertThisInitialized$1(_this), "handleExcludeAll", function () {
      var _this$props8 = _this.props,
          onChange = _this$props8.onChange,
          tag = _this$props8.tag,
          valueTags = _this$props8.valueTags,
          valueTagsNot = _this$props8.valueTagsNot,
          valueTagsOr = _this$props8.valueTagsOr;
      onChange({
        tags: without_1.apply(void 0, [valueTags].concat(_toConsumableArray$5(_this.getAllTagIdsUnfiltered()))).sort(),
        tagsNot: without_1.apply(void 0, [union_1(valueTagsNot, [tag.id])].concat(_toConsumableArray$5(_this.getAllTagIdsUnfiltered()))).sort(),
        tagsOr: without_1.apply(void 0, [valueTagsOr].concat([tag.id])).sort()
      });
    });

    _defineProperty$8(_assertThisInitialized$1(_this), "handleRemoveAll", function () {
      var _this$props9 = _this.props,
          onChange = _this$props9.onChange,
          tag = _this$props9.tag,
          valueTags = _this$props9.valueTags,
          valueTagsNot = _this$props9.valueTagsNot,
          valueTagsOr = _this$props9.valueTagsOr;
      onChange({
        tags: without_1.apply(void 0, [valueTags].concat(_toConsumableArray$5(_this.getAllTagIdsUnfiltered()))).sort(),
        tagsNot: without_1.apply(void 0, [valueTagsNot].concat([].concat(_toConsumableArray$5(_this.getAllTagIdsUnfiltered()), [tag.id]))).sort(),
        tagsOr: without_1.apply(void 0, [valueTagsOr].concat([tag.id])).sort()
      });
    });

    _defineProperty$8(_assertThisInitialized$1(_this), "handleExcludeOnClick", function () {
      if (_this.isNot()) {
        return _this.handleRemoveAll;
      }

      if (!_this.isAvailable('exclude')) return null;
      return _this.handleExcludeAll;
    });

    _defineProperty$8(_assertThisInitialized$1(_this), "handleIncludeOnClick", function () {
      if (_this.isOr() || _this.is()) {
        return _this.handleRemoveAll;
      }

      if (!_this.isAvailable('include')) return null;
      return _this.handleIncludeAll;
    });

    _defineProperty$8(_assertThisInitialized$1(_this), "filterTags", function () {
      var _this$props10 = _this.props,
          locale = _this$props10.locale,
          search = _this$props10.search,
          tag = _this$props10.tag;
      var filteredTags = tag.tags.filter(function (t) {
        return tagMatches(t, search, locale);
      }); // Sort tags by name.

      return sortBy_1(filteredTags, function (t) {
        return getName(t.names, locale).toLowerCase();
      });
    });

    _defineProperty$8(_assertThisInitialized$1(_this), "is", function () {
      var _this$props11 = _this.props,
          tag = _this$props11.tag,
          valueTags = _this$props11.valueTags;
      var subCatTags = tag.tags.map(function (ta) {
        return ta.id;
      }); // eslint-disable-next-line max-len

      return includes_1(valueTags, tag.id) || intersection_1(valueTags, subCatTags).length === subCatTags.length;
    });

    _defineProperty$8(_assertThisInitialized$1(_this), "isNot", function () {
      var _this$props12 = _this.props,
          tag = _this$props12.tag,
          valueTagsNot = _this$props12.valueTagsNot;
      return includes_1(valueTagsNot, tag.id);
    });

    _defineProperty$8(_assertThisInitialized$1(_this), "isOr", function () {
      var _this$props13 = _this.props,
          tag = _this$props13.tag,
          valueTagsOr = _this$props13.valueTagsOr;
      return includes_1(valueTagsOr, tag.id);
    });

    _defineProperty$8(_assertThisInitialized$1(_this), "isAvailable", function (type) {
      var _this$props14 = _this.props,
          tag = _this$props14.tag,
          tagsAvailable = _this$props14.tagsAvailable,
          valueTags = _this$props14.valueTags,
          valueTagsNot = _this$props14.valueTagsNot,
          valueTagsOr = _this$props14.valueTagsOr;

      var childTags = _this.getAllTagIdsUnfiltered(); // If a tag is included, then the exclude button is available.


      if (type === 'exclude') {
        if (intersection_1(valueTags, childTags).length > 0) return true;
        if (includes_1(valueTagsOr, tag.id)) return true;
      } // If a tag is excluded, then the include button is available.


      if (type === 'include') {
        if (intersection_1(valueTagsNot, childTags).length > 0) return true;
        if (includes_1(valueTagsNot, tag.id)) return true;
      } // If we want the availability of the wrapper (to change opacity).


      if (type === 'global') {
        // If tag is excluded or included,
        // or if one of his child is included or excluded,
        // then tag is available.
        if (includes_1(valueTagsOr, tag.id)) return true;
        if (includes_1(valueTagsNot, tag.id)) return true;
        if (intersection_1(valueTagsNot, childTags).length > 0) return true;
        if (intersection_1(valueTags, childTags).length > 0) return true;
      }

      return intersection_1(tagsAvailable, childTags).length > 0;
    });

    _defineProperty$8(_assertThisInitialized$1(_this), "sortChildByAvailability", function () {
      var _this$props15 = _this.props,
          showUnavailableFilters = _this$props15.showUnavailableFilters,
          tagsAvailable = _this$props15.tagsAvailable,
          valueTags = _this$props15.valueTags,
          valueTagsNot = _this$props15.valueTagsNot; // We retrieve filtered list of tags.

      var filteredTags = _this.filterTags(); // If we don't show unavailable tags, we don't need to sort them based on their availability.


      if (!showUnavailableFilters) return filteredTags; // We sort tags based on their availability.

      var childTagSorted = sortBy_1(filteredTags, function (ct) {
        // Sort up if tag is available.
        if (includes_1(tagsAvailable, ct.id)) return false; // Sort up if tag is excluded.

        if (includes_1(valueTagsNot, ct.id)) return false; // Sort up if tag is included.

        if (includes_1(valueTags, ct.id)) return false; // Else sort down.

        return true;
      }); // We return an array of tags to render.


      return childTagSorted;
    });

    return _this;
  }

  _createClass$g(SubCategorySwitcher, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props16 = this.props,
          locale = _this$props16.locale,
          opened = _this$props16.opened,
          search = _this$props16.search,
          tag = _this$props16.tag,
          tagsAvailable = _this$props16.tagsAvailable,
          valueTags = _this$props16.valueTags,
          valueTagsNot = _this$props16.valueTagsNot,
          valueTagsOr = _this$props16.valueTagsOr;
      return /*#__PURE__*/React__default['default'].createElement(Wrapper$d, null, /*#__PURE__*/React__default['default'].createElement(Tag, null, /*#__PURE__*/React__default['default'].createElement(TagHeader, {
        available: this.isAvailable('global'),
        opened: opened
      }, /*#__PURE__*/React__default['default'].createElement(MinusIcon, {
        onClick: this.handleExcludeOnClick(),
        selected: this.isNot()
      }), /*#__PURE__*/React__default['default'].createElement(TagName, {
        hasChildren: true,
        onClick: this.handleOpen
      }, /*#__PURE__*/React__default['default'].createElement(DropdownIcon, {
        mr: "1.2rem",
        opened: opened
      }), getName(tag.names, locale), /*#__PURE__*/React__default['default'].createElement(DropdownIcon, {
        ml: "1.2rem",
        opened: opened
      })), /*#__PURE__*/React__default['default'].createElement(PlusIcon, {
        onClick: this.handleIncludeOnClick(),
        selected: this.isOr() || this.is()
      })), /*#__PURE__*/React__default['default'].createElement(TagChildren, {
        opened: opened
      }, /*#__PURE__*/React__default['default'].createElement(Background$2, null), /*#__PURE__*/React__default['default'].createElement(ChildrenWrapper, null, this.sortChildByAvailability().map(function (childTag) {
        return /*#__PURE__*/React__default['default'].createElement(SubCategoryTag, {
          key: childTag.id,
          locale: locale,
          onExclude: _this2.handleExcludeOne,
          onInclude: _this2.handleIncludeOne,
          onRemove: _this2.handleRemoveOne,
          parentId: tag.id,
          search: search,
          tag: childTag,
          tagsAvailable: tagsAvailable,
          valueTags: valueTags,
          valueTagsNot: valueTagsNot,
          valueTagsOr: valueTagsOr
        });
      })))));
    }
  }]);

  return SubCategorySwitcher;
}(React.PureComponent);

_defineProperty$8(SubCategorySwitcher, "propTypes", {
  initialTag: subCategory.isRequired,

  /** Lang used by user. */
  locale: PropTypes__default['default'].string.isRequired,
  onChange: PropTypes__default['default'].func.isRequired,
  onOpen: PropTypes__default['default'].func.isRequired,

  /** If True, dropdown containing chil tags is open. */
  opened: PropTypes__default['default'].bool.isRequired,

  /** User search query string. */
  search: PropTypes__default['default'].string.isRequired,

  /** If True, TagList will show unavailable tags. */
  showUnavailableFilters: PropTypes__default['default'].bool,

  /** Current tag object being rendered. */
  tag: subCategory.isRequired,

  /** Tags available for inclusion or exclusion. */
  tagsAvailable: PropTypes__default['default'].arrayOf(PropTypes__default['default'].string).isRequired,

  /** Array of tag id that are included. */
  valueTags: PropTypes__default['default'].arrayOf(PropTypes__default['default'].string).isRequired,

  /** Array of tag id that are excluded. */
  valueTagsNot: PropTypes__default['default'].arrayOf(PropTypes__default['default'].string).isRequired,

  /** Array of subCategory tag id that are included. */
  valueTagsOr: PropTypes__default['default'].arrayOf(PropTypes__default['default'].string).isRequired
});

_defineProperty$8(SubCategorySwitcher, "defaultProps", {
  showUnavailableFilters: false
});// Component
// =============================

var TagSwitcher = /*#__PURE__*/function (_PureComponent) {
  _inherits$e(TagSwitcher, _PureComponent);

  var _super = _createSuper$1(TagSwitcher);

  function TagSwitcher() {
    var _this;

    _classCallCheck$k(this, TagSwitcher);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty$8(_assertThisInitialized$1(_this), "handleExclude", function () {
      var _this$props = _this.props,
          onChange = _this$props.onChange,
          tag = _this$props.tag,
          valueTags = _this$props.valueTags,
          valueTagsNot = _this$props.valueTagsNot;
      onChange({
        excludes: union_1(valueTagsNot, [tag.id]).sort(),
        includes: without_1.apply(void 0, [valueTags].concat([tag.id])).sort()
      });
    });

    _defineProperty$8(_assertThisInitialized$1(_this), "handleInclude", function () {
      var _this$props2 = _this.props,
          onChange = _this$props2.onChange,
          tag = _this$props2.tag,
          valueTags = _this$props2.valueTags,
          valueTagsNot = _this$props2.valueTagsNot;
      onChange({
        excludes: without_1.apply(void 0, [valueTagsNot].concat([tag.id])).sort(),
        includes: union_1(valueTags, [tag.id]).sort()
      });
    });

    _defineProperty$8(_assertThisInitialized$1(_this), "handleRemove", function () {
      var _this$props3 = _this.props,
          onChange = _this$props3.onChange,
          tag = _this$props3.tag,
          valueTags = _this$props3.valueTags,
          valueTagsNot = _this$props3.valueTagsNot;
      onChange({
        excludes: without_1.apply(void 0, [valueTagsNot].concat([tag.id])).sort(),
        includes: without_1.apply(void 0, [valueTags].concat([tag.id])).sort()
      });
    });

    _defineProperty$8(_assertThisInitialized$1(_this), "handleExcludeOnClick", function () {
      if (_this.isNot()) {
        return _this.handleRemove;
      }

      if (!_this.isAvailable('exclude')) return null;
      return _this.handleExclude;
    });

    _defineProperty$8(_assertThisInitialized$1(_this), "handleIncludeOnClick", function () {
      if (_this.is()) {
        return _this.handleRemove;
      }

      if (!_this.isAvailable('include')) return null;
      return _this.handleInclude;
    });

    _defineProperty$8(_assertThisInitialized$1(_this), "is", function () {
      var _this$props4 = _this.props,
          valueTags = _this$props4.valueTags,
          tag = _this$props4.tag;
      return includes_1(valueTags, tag.id);
    });

    _defineProperty$8(_assertThisInitialized$1(_this), "isNot", function () {
      var _this$props5 = _this.props,
          valueTagsNot = _this$props5.valueTagsNot,
          tag = _this$props5.tag;
      return includes_1(valueTagsNot, tag.id);
    });

    _defineProperty$8(_assertThisInitialized$1(_this), "isAvailable", function (type) {
      var _this$props6 = _this.props,
          valueTags = _this$props6.valueTags,
          valueTagsNot = _this$props6.valueTagsNot,
          tag = _this$props6.tag,
          tagsAvailable = _this$props6.tagsAvailable; // If a tag is included, then the exclude button is available.

      if (type === 'exclude') {
        if (includes_1(valueTags, tag.id)) return true;
      } // If a tag is excluded, then the include button is available.


      if (type === 'include') {
        if (includes_1(valueTagsNot, tag.id)) return true;
      } // If we want the availability of the wrapper (to change opacity).


      if (type === 'global') {
        // If tag is excluded or included,
        // then it is available.
        if (includes_1(valueTags, tag.id)) return true;
        if (includes_1(valueTagsNot, tag.id)) return true;
      }

      return includes_1(tagsAvailable, tag.id);
    });

    return _this;
  }

  _createClass$g(TagSwitcher, [{
    key: "render",
    value: function render() {
      var _this$props7 = this.props,
          locale = _this$props7.locale,
          search = _this$props7.search,
          tag = _this$props7.tag;
      var synonym = tagSynonymFound(tag, search, locale);
      return /*#__PURE__*/React__default['default'].createElement(Wrapper$d, null, /*#__PURE__*/React__default['default'].createElement(Tag, null, /*#__PURE__*/React__default['default'].createElement(TagHeader, {
        available: this.isAvailable('global')
      }, /*#__PURE__*/React__default['default'].createElement(MinusIcon, {
        onClick: this.handleExcludeOnClick(),
        selected: this.isNot()
      }), /*#__PURE__*/React__default['default'].createElement(TagName, {
        hasChildren: false
      }, getName(tag.names, locale), synonym ? " (".concat(synonym, ")") : null), /*#__PURE__*/React__default['default'].createElement(PlusIcon, {
        onClick: this.handleIncludeOnClick(),
        selected: this.is()
      }))));
    }
  }]);

  return TagSwitcher;
}(React.PureComponent);

_defineProperty$8(TagSwitcher, "propTypes", {
  /** Lang used by user. */
  locale: PropTypes__default['default'].string.isRequired,
  onChange: PropTypes__default['default'].func.isRequired,

  /** User search query string. */
  search: PropTypes__default['default'].string.isRequired,

  /** Current tag object being rendered. */
  tag: tag.isRequired,

  /** Tags available for inclusion or exclusion. */
  tagsAvailable: PropTypes__default['default'].arrayOf(PropTypes__default['default'].string).isRequired,

  /** Array of tag id that are included. */
  valueTags: PropTypes__default['default'].arrayOf(PropTypes__default['default'].string).isRequired,

  /** Array of tag id that are excluded. */
  valueTagsNot: PropTypes__default['default'].arrayOf(PropTypes__default['default'].string).isRequired
});var _templateObject$g;
// Styles
// =============================

var Wrapper$c = styled__default['default'].div(_templateObject$g || (_templateObject$g = _taggedTemplateLiteral$5([""])));// Component
// =============================

var TagList = /*#__PURE__*/function (_PureComponent) {
  _inherits$e(TagList, _PureComponent);

  var _super = _createSuper$1(TagList);

  function TagList() {
    var _this;

    _classCallCheck$k(this, TagList);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty$8(_assertThisInitialized$1(_this), "filterCategories", function () {
      var _this$props = _this.props,
          locale = _this$props.locale,
          search = _this$props.search,
          tags = _this$props.tags;
      var filteredTagCategories = tags.filter(function (tagCat) {
        return categoryMatches(tagCat, search, locale);
      }); // Sort categories by order + name

      return sortBy_1(filteredTagCategories, function (tagCat) {
        var index = tagCategoriesOrder.indexOf(tagCat.id);

        if (index === -1) {
          index = Infinity;
        }

        return "".concat(index, "-").concat(getName(tagCat.names, locale).toLowerCase());
      });
    });

    _defineProperty$8(_assertThisInitialized$1(_this), "filterSubCategories", function (subCategories) {
      var _this$props2 = _this.props,
          search = _this$props2.search,
          locale = _this$props2.locale;
      var filteredSubCategories = subCategories.filter(function (subCat) {
        return subCategoryMatches(subCat, search, locale);
      }); // Sort subCategories by name.

      return sortBy_1(filteredSubCategories, function (subCategory) {
        return getName(subCategory.names, locale).toLowerCase();
      });
    });

    _defineProperty$8(_assertThisInitialized$1(_this), "filterTags", function (tags) {
      var _this$props3 = _this.props,
          search = _this$props3.search,
          locale = _this$props3.locale;
      var filteredTags = tags.filter(function (tag) {
        return tagMatches(tag, search, locale);
      }); // Sort tags by name.

      return sortBy_1(filteredTags, function (tag) {
        return getName(tag.names, locale).toLowerCase();
      });
    });

    _defineProperty$8(_assertThisInitialized$1(_this), "sortTagsByAvailability", function (tags) {
      var _this$props4 = _this.props,
          showUnavailableFilters = _this$props4.showUnavailableFilters,
          tagsAvailable = _this$props4.tagsAvailable,
          valueTags = _this$props4.valueTags,
          valueTagsNot = _this$props4.valueTagsNot; // We retrieve filtered list of tags.

      var filteredTags = _this.filterTags(tags); // If we don't show unavailable tags, we don't need to sort
      // subCategories based on their availability.


      if (!showUnavailableFilters) return filteredTags; // We sort subCategories based on their availability.

      return sortBy_1(filteredTags, function (tag) {
        // Sort up if tag is available
        if (includes_1(tagsAvailable, tag.id)) return false; // Sort up if tag is excluded.

        if (includes_1(valueTagsNot, tag.id)) return false; // Sort up if tag is included.

        if (includes_1(valueTags, tag.id)) return false; // Else sort down.

        return true;
      });
    });

    _defineProperty$8(_assertThisInitialized$1(_this), "sortSubCategoryByAvailability", function (subCategories) {
      var _this$props5 = _this.props,
          showUnavailableFilters = _this$props5.showUnavailableFilters,
          tagsAvailable = _this$props5.tagsAvailable,
          valueTags = _this$props5.valueTags,
          valueTagsNot = _this$props5.valueTagsNot,
          valueTagsOr = _this$props5.valueTagsOr; // We retrieve filtered list of subCategories.

      var filteredSubCategories = _this.filterSubCategories(subCategories); // If we don't show unavailable tags, we don't need to sort
      // subCategories based on their availability.


      if (!showUnavailableFilters) return filteredSubCategories; // We sort subCategories based on their availability.

      return sortBy_1(filteredSubCategories, function (subCategory) {
        // We retrieve all subCategory's tags.
        var subCategoryTags = get_1(subCategory, 'tags', []);

        var subCategoryChildTags = get_1(subCategory, 'subCategories.tags', []); // We retrieve tags ids.


        var subCategoryTagsId = subCategoryTags.map(function (subCatTag) {
          return subCatTag.id;
        });
        var subCategoryChildTagsId = subCategoryChildTags.map(function (subCatChildTag) {
          return subCatChildTag.id;
        }); // Merge tags ids.

        var allTagsId = union_1(subCategoryTagsId, subCategoryChildTagsId); // Sort up if there are tags available


        if (intersection_1(tagsAvailable, allTagsId).length > 0) return false; // Sort up if subCategory is excluded.

        if (includes_1(valueTagsNot, subCategory.id)) return false; // Sort up if subCategory is included.

        if (includes_1(valueTagsOr, subCategory.id)) return false; // Sort up if at least one child tag is excluded

        if (intersection_1(valueTagsNot, allTagsId).length > 0) return false; // Sort up if at least one child tag is included

        if (intersection_1(valueTags, allTagsId).length > 0) return false; // Else sort down.

        return true;
      });
    });

    _defineProperty$8(_assertThisInitialized$1(_this), "getInitialSubCategory", function (categoryId, subCategoryId) {
      var initialTags = _this.props.initialTags;
      var category = initialTags.find(function (c) {
        return c.id === categoryId;
      });
      return category.sub_categories.find(function (sc) {
        return sc.id === subCategoryId;
      });
    });

    _defineProperty$8(_assertThisInitialized$1(_this), "handleChange", function (_ref) {
      var includes = _ref.includes,
          excludes = _ref.excludes;
      var onChange = _this.props.onChange;
      onChange({
        tags: includes,
        tagsNot: excludes
      });
    });

    return _this;
  }

  _createClass$g(TagList, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props6 = this.props,
          locale = _this$props6.locale,
          onChange = _this$props6.onChange,
          onOpen = _this$props6.onOpen,
          openedBoxes = _this$props6.openedBoxes,
          search = _this$props6.search,
          showUnavailableFilters = _this$props6.showUnavailableFilters,
          tagsAvailable = _this$props6.tagsAvailable,
          tagsUnfiltered = _this$props6.tagsUnfiltered,
          valueTags = _this$props6.valueTags,
          valueTagsNot = _this$props6.valueTagsNot,
          valueTagsOr = _this$props6.valueTagsOr;
      return /*#__PURE__*/React__default['default'].createElement(Wrapper$c, null, this.filterCategories().map(function (category) {
        return /*#__PURE__*/React__default['default'].createElement(TagBox, {
          indicationColor: category.color,
          key: category.id,
          onOpen: onOpen,
          opened: !!openedBoxes.categories[category.id],
          path: "categories['".concat(category.id, "']"),
          tagsAvailable: tagsAvailable,
          title: getName(category.names, locale),
          wideContent: true
        }, _this2.sortTagsByAvailability(category.tags).map(function (tag) {
          return /*#__PURE__*/React__default['default'].createElement(TagSwitcher, {
            categoryTag: true,
            key: tag.id,
            locale: locale,
            onChange: _this2.handleChange,
            search: search,
            showUnavailableFilters: showUnavailableFilters,
            tag: tag,
            tagsAvailable: tagsAvailable,
            valueTags: valueTags,
            valueTagsNot: valueTagsNot,
            valueTagsOr: valueTagsOr
          });
        }), _this2.sortSubCategoryByAvailability(category.sub_categories).map(function (subCat) {
          return /*#__PURE__*/React__default['default'].createElement(SubCategorySwitcher, {
            initialTag: _this2.getInitialSubCategory(category.id, subCat.id),
            key: subCat.id,
            locale: locale,
            onChange: onChange,
            onOpen: onOpen,
            opened: !!openedBoxes.subCategories[subCat.id],
            search: search,
            showUnavailableFilters: showUnavailableFilters,
            tag: subCat,
            tagsAvailable: tagsAvailable,
            tagsUnfiltered: tagsUnfiltered,
            valueTags: valueTags,
            valueTagsNot: valueTagsNot,
            valueTagsOr: valueTagsOr
          });
        }));
      }));
    }
  }]);

  return TagList;
}(React.PureComponent);

_defineProperty$8(TagList, "propTypes", {
  initialTags: PropTypes__default['default'].arrayOf(category).isRequired,

  /** Lang used by user. */
  locale: PropTypes__default['default'].string.isRequired,
  onChange: PropTypes__default['default'].func.isRequired,
  onOpen: PropTypes__default['default'].func.isRequired,

  /** Array of opened tag box. */
  openedBoxes: openedBoxes.isRequired,

  /** User search query string. */
  search: PropTypes__default['default'].string.isRequired,

  /** If True, TagList will show unavailable tags. */
  showUnavailableFilters: PropTypes__default['default'].bool,

  /**  */
  tags: PropTypes__default['default'].arrayOf(category).isRequired,

  /** Tags available for inclusion or exclusion. */
  tagsAvailable: PropTypes__default['default'].arrayOf(PropTypes__default['default'].string).isRequired,

  /** All tags, even the unavailable ones. */
  tagsUnfiltered: PropTypes__default['default'].arrayOf(category).isRequired,

  /** Array of tag id that are included. */
  valueTags: PropTypes__default['default'].arrayOf(PropTypes__default['default'].string).isRequired,

  /** Array of tag id that are excluded. */
  valueTagsNot: PropTypes__default['default'].arrayOf(PropTypes__default['default'].string).isRequired,

  /** Array of subCategory tag id that are included. */
  valueTagsOr: PropTypes__default['default'].arrayOf(PropTypes__default['default'].string).isRequired
});

_defineProperty$8(TagList, "defaultProps", {
  showUnavailableFilters: false
});// Component
// =============================

var VersionSwitcher = /*#__PURE__*/function (_PureComponent) {
  _inherits$e(VersionSwitcher, _PureComponent);

  var _super = _createSuper$1(VersionSwitcher);

  function VersionSwitcher() {
    var _this;

    _classCallCheck$k(this, VersionSwitcher);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty$8(_assertThisInitialized$1(_this), "handleExclude", function () {
      var _this$props = _this.props,
          onChange = _this$props.onChange,
          valueVersions = _this$props.valueVersions,
          valueVersionsNot = _this$props.valueVersionsNot,
          version = _this$props.version;
      onChange({
        excludes: union_1(valueVersionsNot, [version.id]).sort(),
        includes: without_1.apply(void 0, [valueVersions].concat([version.id])).sort()
      });
    });

    _defineProperty$8(_assertThisInitialized$1(_this), "handleInclude", function () {
      var _this$props2 = _this.props,
          onChange = _this$props2.onChange,
          valueVersions = _this$props2.valueVersions,
          valueVersionsNot = _this$props2.valueVersionsNot,
          version = _this$props2.version;
      onChange({
        excludes: without_1.apply(void 0, [valueVersionsNot].concat([version.id])).sort(),
        includes: union_1(valueVersions, [version.id]).sort()
      });
    });

    _defineProperty$8(_assertThisInitialized$1(_this), "handleExcludeOnClick", function () {
      if (!_this.isAvailable('exclude')) return null;
      if (_this.isNot()) return null;
      return _this.handleExclude;
    });

    _defineProperty$8(_assertThisInitialized$1(_this), "handleIncludeOnClick", function () {
      if (!_this.isAvailable('include')) return null;
      if (_this.is()) return null;
      return _this.handleInclude;
    });

    _defineProperty$8(_assertThisInitialized$1(_this), "is", function () {
      var _this$props3 = _this.props,
          valueVersions = _this$props3.valueVersions,
          version = _this$props3.version;
      return includes_1(valueVersions, version.id);
    });

    _defineProperty$8(_assertThisInitialized$1(_this), "isNot", function () {
      var _this$props4 = _this.props,
          valueVersionsNot = _this$props4.valueVersionsNot,
          version = _this$props4.version;
      return includes_1(valueVersionsNot, version.id);
    });

    _defineProperty$8(_assertThisInitialized$1(_this), "isAvailable", function (type) {
      var _this$props5 = _this.props,
          valueVersions = _this$props5.valueVersions,
          valueVersionsNot = _this$props5.valueVersionsNot,
          version = _this$props5.version,
          versionsAvailable = _this$props5.versionsAvailable; // If a version is included, then the exclude button is available.

      if (type === 'exclude') {
        if (includes_1(valueVersions, version.id)) return true;
      } // If a version is excluded, then the include button is available.


      if (type === 'include') {
        if (includes_1(valueVersionsNot, version.id)) return true;
      } // If we want the availability of the wrapper (to change opacity).


      if (type === 'global') {
        // If version is excluded or included,
        // then it is available.
        if (includes_1(valueVersions, version.id)) return true;
        if (includes_1(valueVersionsNot, version.id)) return true;
      }

      return includes_1(versionsAvailable, version.id);
    });

    return _this;
  }

  _createClass$g(VersionSwitcher, [{
    key: "render",
    value: function render() {
      var _this$props6 = this.props,
          locale = _this$props6.locale,
          version = _this$props6.version;
      return /*#__PURE__*/React__default['default'].createElement(Wrapper$d, null, /*#__PURE__*/React__default['default'].createElement(Tag, null, /*#__PURE__*/React__default['default'].createElement(TagHeader, {
        available: this.isAvailable('global')
      }, /*#__PURE__*/React__default['default'].createElement(MinusIcon, {
        onClick: this.handleExcludeOnClick(),
        selected: this.isNot()
      }), /*#__PURE__*/React__default['default'].createElement(TagName, {
        hasChildren: false
      }, getName(version.names, locale)), /*#__PURE__*/React__default['default'].createElement(PlusIcon, {
        onClick: this.handleIncludeOnClick(),
        selected: this.is()
      }))));
    }
  }]);

  return VersionSwitcher;
}(React.PureComponent);

_defineProperty$8(VersionSwitcher, "propTypes", {
  /** Lang used by user. */
  locale: PropTypes__default['default'].string.isRequired,

  /** onChange function */
  onChange: PropTypes__default['default'].func.isRequired,

  /** Array of tag id that are included. */
  valueVersions: PropTypes__default['default'].arrayOf(PropTypes__default['default'].string).isRequired,

  /** Array of tag id that are excluded. */
  valueVersionsNot: PropTypes__default['default'].arrayOf(PropTypes__default['default'].string).isRequired,

  /** Current versin object being rendered. */
  version: tag.isRequired,

  /** Versions available for inclusion or exclusion. */
  versionsAvailable: PropTypes__default['default'].arrayOf(PropTypes__default['default'].string).isRequired
});

_defineProperty$8(VersionSwitcher, "defaultProps", {});var _templateObject$f;
// Styles
// =============================

var Wrapper$b = styled__default['default'].div(_templateObject$f || (_templateObject$f = _taggedTemplateLiteral$5([""])));// Component
// =============================

var VersionList = /*#__PURE__*/function (_PureComponent) {
  _inherits$e(VersionList, _PureComponent);

  var _super = _createSuper$1(VersionList);

  function VersionList() {
    var _this;

    _classCallCheck$k(this, VersionList);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty$8(_assertThisInitialized$1(_this), "filterVersions", function () {
      var _this$props = _this.props,
          locale = _this$props.locale,
          search = _this$props.search,
          versions = _this$props.versions;
      var filteredVersions = versions.filter(function (t) {
        return versionMatches(t, search, locale);
      }); // Sort by name.

      return sortBy_1(filteredVersions, function (version) {
        return getName(version.names, locale).toLowerCase();
      });
    });

    _defineProperty$8(_assertThisInitialized$1(_this), "sortVersionsByAvailability", function () {
      var _this$props2 = _this.props,
          valueVersions = _this$props2.valueVersions,
          valueVersionsNot = _this$props2.valueVersionsNot,
          versionsAvailable = _this$props2.versionsAvailable;

      var filteredVersions = _this.filterVersions();

      return sortBy_1(filteredVersions, function (version) {
        // Sort up if version is available
        if (includes_1(versionsAvailable, version.id)) return false; // Sort up if version is excluded

        if (includes_1(valueVersionsNot, version.id)) return false; // Sort up if version is included.

        if (includes_1(valueVersions, version.id)) return false; // Else sort down.

        return true;
      });
    });

    _defineProperty$8(_assertThisInitialized$1(_this), "handleChange", function (_ref) {
      var includes = _ref.includes,
          excludes = _ref.excludes;
      var onChange = _this.props.onChange;
      onChange({
        versions: includes,
        versionsNot: excludes
      });
    });

    return _this;
  }

  _createClass$g(VersionList, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props3 = this.props,
          lang = _this$props3.lang,
          locale = _this$props3.locale,
          onOpen = _this$props3.onOpen,
          openedBoxes = _this$props3.openedBoxes,
          search = _this$props3.search,
          showUnavailableFilters = _this$props3.showUnavailableFilters,
          valueVersions = _this$props3.valueVersions,
          valueVersionsNot = _this$props3.valueVersionsNot,
          versionsAvailable = _this$props3.versionsAvailable;
      return /*#__PURE__*/React__default['default'].createElement(Wrapper$b, null, /*#__PURE__*/React__default['default'].createElement(TagBox, {
        onOpen: onOpen,
        opened: !!openedBoxes.other.versions,
        path: "other.versions",
        title: lang.versions,
        wideContent: true
      }, this.sortVersionsByAvailability().map(function (version) {
        return /*#__PURE__*/React__default['default'].createElement(VersionSwitcher, {
          key: version.id,
          locale: locale,
          onChange: _this2.handleChange,
          search: search,
          showUnavailableFilters: showUnavailableFilters,
          valueVersions: valueVersions,
          valueVersionsNot: valueVersionsNot,
          version: version,
          versionsAvailable: versionsAvailable
        });
      })));
    }
  }]);

  return VersionList;
}(React.PureComponent);

_defineProperty$8(VersionList, "propTypes", {
  lang: lang.isRequired,
  locale: PropTypes__default['default'].string.isRequired,
  onChange: PropTypes__default['default'].func.isRequired,
  onOpen: PropTypes__default['default'].func.isRequired,
  openedBoxes: openedBoxes.isRequired,
  search: PropTypes__default['default'].string.isRequired,

  /** If True, TagList will show unavailable tags. */
  showUnavailableFilters: PropTypes__default['default'].bool,
  valueVersionsNot: PropTypes__default['default'].arrayOf(PropTypes__default['default'].string).isRequired,
  valueVersions: PropTypes__default['default'].arrayOf(PropTypes__default['default'].string).isRequired,
  versions: PropTypes__default['default'].arrayOf(version).isRequired,

  /** Versions available for inclusion or exclusion. */
  versionsAvailable: PropTypes__default['default'].arrayOf(PropTypes__default['default'].string).isRequired
});

_defineProperty$8(VersionList, "defaultProps", {
  showUnavailableFilters: false
});// =============================
// Component
// =============================

var WithCustomTheme = function WithCustomTheme(_ref) {
  var customTheme = _ref.customTheme,
      children = _ref.children;
  return /*#__PURE__*/React__default['default'].createElement(styled.ThemeProvider, {
    theme: function theme(_theme) {
      return merge_1({}, _theme, customTheme(_theme));
    }
  }, children);
};

WithCustomTheme.propTypes = {
  /** Function that return an object that will be merged into current theme. */
  customTheme: PropTypes__default['default'].func.isRequired,

  /** Children. */
  children: PropTypes__default['default'].node
};
WithCustomTheme.defaultProps = {
  children: null
};var _templateObject$e;
// Styles
// =============================

var Wrapper$a = styled__default['default'].div(_templateObject$e || (_templateObject$e = _taggedTemplateLiteral$5(["\n  position: relative;\n  width: 100%;\n"])));var _excluded$9 = ["autoComplete", "className", "containerClassName", "disabled", "error", "helperText", "isTranslatable", "isTranslatableMessage", "isSearch", "isMusicSearch", "isSearchMessage", "itemAction", "label", "lang", "name", "onResetBtn", "optional", "placeholder", "prefix", "showResetBtn", "showPlaceholder", "suffix", "tooltipError", "tooltipInteractive", "tooltipMessage", "tooltipPlacement", "type", "value", "variant"];
// Component
// =============================

var MewoInput = /*#__PURE__*/function (_PureComponent) {
  _inherits$e(MewoInput, _PureComponent);

  var _super = _createSuper$1(MewoInput);

  function MewoInput(props) {
    var _this;

    _classCallCheck$k(this, MewoInput);

    _this = _super.call(this, props);

    _defineProperty$8(_assertThisInitialized$1(_this), "handleChange", function (e) {
      var _this$props = _this.props,
          type = _this$props.type,
          onChange = _this$props.onChange,
          disabled = _this$props.disabled;

      if (!disabled) {
        // NOTE: Add cases for empty value as we go
        switch (type) {
          case 'text':
            onChange(e.target.value || '');
            break;

          default:
            onChange(e.target.value || null);
            break;
        }
      }
    });

    _defineProperty$8(_assertThisInitialized$1(_this), "handleClick", function () {
      return _this.inputRef.focus();
    });

    _defineProperty$8(_assertThisInitialized$1(_this), "handleBlur", function () {
      return _this.setState({
        focus: false
      });
    });

    _defineProperty$8(_assertThisInitialized$1(_this), "handleFocus", function () {
      return _this.setState({
        focus: true
      });
    });

    _defineProperty$8(_assertThisInitialized$1(_this), "handleResetBtn", function () {
      var _this$props2 = _this.props,
          type = _this$props2.type,
          onChange = _this$props2.onChange,
          disabled = _this$props2.disabled;

      if (!disabled) {
        // NOTE: Add cases for empty value as we go
        switch (type) {
          case 'text':
            onChange('');
            break;

          default:
            onChange(null);
            break;
        }
      }
    });

    _defineProperty$8(_assertThisInitialized$1(_this), "hasValue", function () {
      var _this$props3 = _this.props,
          type = _this$props3.type,
          value = _this$props3.value; // We accept 0 as a value for numeric input.

      if (type === 'number') {
        return value === 0 || !!value;
      }

      return !!value;
    });

    _defineProperty$8(_assertThisInitialized$1(_this), "renderPrefix", function () {
      var focus = _this.state.focus;
      var _this$props4 = _this.props,
          prefix = _this$props4.prefix,
          value = _this$props4.value,
          variant = _this$props4.variant;
      if (variant === 'background') return prefix;
      if (!!value || focus) return prefix;
      return null;
    });

    _defineProperty$8(_assertThisInitialized$1(_this), "renderSuffix", function () {
      var focus = _this.state.focus;
      var _this$props5 = _this.props,
          suffix = _this$props5.suffix,
          value = _this$props5.value,
          variant = _this$props5.variant;
      if (variant === 'background') return suffix;
      if (!!value || focus) return suffix;
      return null;
    });

    _this.state = {
      /** If true, input is focus. */
      focus: false
    };
    return _this;
  }
  /** Handle input change. */


  _createClass$g(MewoInput, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var focus = this.state.focus;

      var _this$props6 = this.props,
          autoComplete = _this$props6.autoComplete,
          className = _this$props6.className,
          containerClassName = _this$props6.containerClassName,
          disabled = _this$props6.disabled,
          error = _this$props6.error,
          helperText = _this$props6.helperText,
          isTranslatable = _this$props6.isTranslatable,
          isTranslatableMessage = _this$props6.isTranslatableMessage,
          isSearch = _this$props6.isSearch,
          isMusicSearch = _this$props6.isMusicSearch,
          isSearchMessage = _this$props6.isSearchMessage,
          itemAction = _this$props6.itemAction,
          label = _this$props6.label,
          lang = _this$props6.lang,
          name = _this$props6.name;
          _this$props6.onResetBtn;
          var optional = _this$props6.optional,
          placeholder = _this$props6.placeholder;
          _this$props6.prefix;
          var showResetBtn = _this$props6.showResetBtn,
          showPlaceholder = _this$props6.showPlaceholder;
          _this$props6.suffix;
          var tooltipError = _this$props6.tooltipError,
          tooltipInteractive = _this$props6.tooltipInteractive,
          tooltipMessage = _this$props6.tooltipMessage,
          tooltipPlacement = _this$props6.tooltipPlacement,
          type = _this$props6.type,
          value = _this$props6.value,
          variant = _this$props6.variant,
          rest = _objectWithoutProperties$7(_this$props6, _excluded$9);

      return /*#__PURE__*/React__default['default'].createElement(Wrapper$a, _extends$g({
        className: className,
        disabled: disabled,
        error: error,
        filled: this.hasValue(),
        focus: focus,
        onClick: this.handleClick
      }, omit_1(rest, ['onChange'])), variant === 'background' && /*#__PURE__*/React__default['default'].createElement(Label$2, {
        active: focus,
        error: error,
        label: label,
        lang: lang.Label,
        optional: optional,
        variant: "background"
      }), /*#__PURE__*/React__default['default'].createElement(Container$1, {
        active: focus,
        className: containerClassName,
        error: error,
        variant: variant
      }, variant === 'underline' && /*#__PURE__*/React__default['default'].createElement(Label$2, {
        active: focus,
        error: error,
        inputFilled: this.hasValue(),
        label: label,
        lang: lang.Label,
        optional: optional,
        variant: variant
      }), /*#__PURE__*/React__default['default'].createElement(Input$1, {
        autoComplete: autoComplete,
        disabled: disabled,
        error: error,
        getInputRef: function getInputRef(node) {
          _this2.inputRef = node;
        },
        isTranslatable: isTranslatable,
        isTranslatableMessage: isTranslatableMessage,
        isSearch: isSearch,
        isMusicSearch: isMusicSearch,
        isSearchMessage: isSearchMessage,
        itemAction: itemAction,
        name: name,
        onBlur: this.handleBlur,
        onChange: this.handleChange,
        onFocus: this.handleFocus,
        onResetBtn: showResetBtn ? function () {
          return _this2.handleResetBtn();
        } : null,
        placeholder: placeholder,
        prefix: this.renderPrefix(),
        showPlaceholder: showPlaceholder || focus || !!value || variant === 'background',
        suffix: this.renderSuffix(),
        tooltipError: tooltipError,
        tooltipInteractive: tooltipInteractive,
        tooltipMessage: tooltipMessage,
        tooltipPlacement: tooltipPlacement,
        type: type,
        value: value,
        variant: variant
      })), helperText && /*#__PURE__*/React__default['default'].createElement(HelperText, {
        error: error
      }, helperText));
    }
  }]);

  return MewoInput;
}(React.PureComponent);

_defineProperty$8(MewoInput, "propTypes", {
  /** Autocomplete */
  autoComplete: PropTypes__default['default'].string,

  /** Props used by styled component to override styles */
  className: PropTypes__default['default'].string,

  /** Container classname. */
  containerClassName: PropTypes__default['default'].string,

  /** If true, the input will be disabled. */
  disabled: PropTypes__default['default'].bool,

  /** If true, the input will indicate an error. */
  error: PropTypes__default['default'].bool,

  /** The helper text content. */
  helperText: PropTypes__default['default'].string,

  /** If True, icon will be music search. */
  isMusicSearch: PropTypes__default['default'].bool,

  /** If True, will show user this input is search. */
  isSearch: PropTypes__default['default'].bool,

  /** Message show in isSearch tooltip. */
  isSearchMessage: PropTypes__default['default'].string,

  /** If True, will show user this input is translatable. */
  isTranslatable: PropTypes__default['default'].bool,

  /** Message show in isTranslatable tooltip. */
  isTranslatableMessage: PropTypes__default['default'].string,

  /** Function that will be executed when clicking on the ItemActionBtn. */
  itemAction: PropTypes__default['default'].func,

  /** The label content. */
  label: PropTypes__default['default'].string,

  /** Translation strings. */
  lang: PropTypes__default['default'].object.isRequired,
  // eslint-disable-line react/forbid-prop-types

  /** Name attribute of the input element. */
  name: PropTypes__default['default'].string.isRequired,

  /** Callback fired when the value is changed. */
  onChange: PropTypes__default['default'].func.isRequired,

  /** Callback function for reset button */
  onResetBtn: PropTypes__default['default'].func,

  /** If true, the input is optional. */
  optional: PropTypes__default['default'].bool,

  /** The short hint displayed in the input before the user enters a value. */
  placeholder: PropTypes__default['default'].string,

  /** Node that will be rendered as Prefix. */
  prefix: PropTypes__default['default'].node,

  /** If True, show reset button. */
  showResetBtn: PropTypes__default['default'].bool,

  /** If True, placeholder is shown */
  showPlaceholder: PropTypes__default['default'].bool,

  /** Node that will be rendered as Suffix. */
  suffix: PropTypes__default['default'].node,

  /** Used to display error messsage as tooltip. */
  tooltipError: PropTypes__default['default'].string,

  /** If True, Tooltip will be interactive. */
  tooltipInteractive: PropTypes__default['default'].bool,

  /** If set, will add an InfoTooltip btn on input with tooltipMessage as content. */
  tooltipMessage: PropTypes__default['default'].node,

  /** Tooltip placement */
  tooltipPlacement: PropTypes__default['default'].oneOf(['bottom-end', 'bottom-start', 'bottom', 'left-end', 'left-start', 'left', 'right-end', 'right-start', 'right', 'top-end', 'top-start', 'top']),

  /** Type of the input element. It should be a valid HTML5 input type. */
  type: PropTypes__default['default'].string,

  /** Value. */
  value: PropTypes__default['default'].oneOfType([PropTypes__default['default'].string, PropTypes__default['default'].number]),

  /** Input style variant. */
  variant: PropTypes__default['default'].oneOf(['background', 'underline'])
});

_defineProperty$8(MewoInput, "defaultProps", {
  autoComplete: undefined,
  className: '',
  containerClassName: '',
  disabled: false,
  error: false,
  helperText: '',
  isMusicSearch: false,
  isSearch: false,
  isSearchMessage: '',
  isTranslatable: false,
  isTranslatableMessage: '',
  itemAction: null,
  label: '',
  onResetBtn: null,
  optional: false,
  placeholder: '',
  prefix: null,
  showResetBtn: false,
  showPlaceholder: false,
  suffix: null,
  tooltipError: '',
  tooltipInteractive: false,
  tooltipMessage: '',
  tooltipPlacement: 'bottom',
  type: 'text',
  value: undefined,
  variant: 'background'
});var _templateObject$d, _templateObject2$c, _templateObject3$b, _templateObject4$a, _templateObject5$9, _templateObject6$7, _templateObject7$6, _templateObject8$6, _templateObject9$3, _templateObject10$3, _templateObject11$3, _templateObject12$2, _templateObject13$2, _templateObject14$2, _templateObject15$1, _templateObject16, _templateObject17, _templateObject18;
// Styles
// =============================

var Wrapper$9 = styled__default['default'].div(_templateObject$d || (_templateObject$d = _taggedTemplateLiteral$5(["\n  background-color: ", ";\n  color: ", ";\n  display: flex;\n  flex-direction: column;\n  width: 30rem;\n  z-index: ", ";\n\n  ", ";\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.colors.background;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.text;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.zIndex.scFilterBar;
}, function (_ref4) {
  var visible = _ref4.visible;
  return !visible && styled.css(_templateObject2$c || (_templateObject2$c = _taggedTemplateLiteral$5(["\n       opacity: 0;\n       pointer-events: none;\n    "])));
});
var WrapperMobile = styled__default['default'](framerMotion.motion.div).attrs(function (_ref5) {
  var minimized = _ref5.minimized,
      theme = _ref5.theme;
  return {
    initial: 'close',
    animate: !minimized ? 'open' : 'close',
    exit: 'exit',
    variants: {
      open: {
        height: 'auto',
        transition: {
          duration: theme.transition.numeric.medium,
          ease: theme.transitionTiming.pose.easeInOut
        },
        transitionEnd: {
          overflow: 'visible'
        }
      },
      close: {
        height: '4.8rem',
        overflow: 'hidden',
        transition: {
          duration: theme.transition.numeric.medium,
          ease: theme.transitionTiming.pose.easeInOut
        }
      }
    }
  };
})(_templateObject3$b || (_templateObject3$b = _taggedTemplateLiteral$5(["\n  background-color: ", ";\n  color: ", ";\n  display: flex;\n  flex-direction: column;\n  padding-top: 0.4rem;\n  width: 100%;\n  z-index: ", ";\n\n  ", ";\n"])), function (_ref6) {
  var theme = _ref6.theme;
  return theme.colors.background;
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.colors.text;
}, function (_ref8) {
  var theme = _ref8.theme;
  return theme.zIndex.scFilterBar;
}, function (_ref9) {
  var visible = _ref9.visible;
  return !visible && styled.css(_templateObject4$a || (_templateObject4$a = _taggedTemplateLiteral$5(["\n       opacity: 0;\n       pointer-events: none;\n    "])));
});
var Header = styled__default['default'].div(_templateObject5$9 || (_templateObject5$9 = _taggedTemplateLiteral$5(["\n  flex-shrink: 0;\n  font-size: 1.2rem;\n  width: 100%;\n  z-index: 1;\n\n  ", ";\n\n  ", ";\n"])), function (_ref10) {
  var theme = _ref10.theme;
  return theme.mediaBelow.minWidth(_templateObject6$7 || (_templateObject6$7 = _taggedTemplateLiteral$5(["\n    margin-bottom: 3.2rem;\n  "])));
}, function (_ref11) {
  var theme = _ref11.theme;
  return theme.mediaAbove.minWidth(_templateObject7$6 || (_templateObject7$6 = _taggedTemplateLiteral$5(["\n    background: linear-gradient(\n        180deg,\n        ", " 0%,\n        ", " 90%,\n        ", " 100%\n      );\n    left: 0;\n    position: absolute;\n    top: 0;\n  "])), theme.colors.background, theme.colors.background, alpha$2(theme.colors.background, 0.001));
});
var FilterNumber = styled__default['default'].div(_templateObject8$6 || (_templateObject8$6 = _taggedTemplateLiteral$5(["\n  align-items: center;\n  display: flex;\n  font-size: 2rem;\n  font-weight: ", ";\n"])), function (_ref12) {
  var theme = _ref12.theme;
  return theme.fontWeight.bold;
});
var Content = styled__default['default'].div(_templateObject9$3 || (_templateObject9$3 = _taggedTemplateLiteral$5(["\n  ", ";\n  overflow-y: scroll;\n  overflow-x: hidden;\n  width: 100%;\n"])), hideScrollBar);
var Counter = styled__default['default'].div(_templateObject10$3 || (_templateObject10$3 = _taggedTemplateLiteral$5(["\n  align-items: center;\n  border-radius: 50%;\n  box-sizing: content-box;\n  display: inline-flex;\n  font-size: 0.5em;\n  min-height: 1.5rem;\n  justify-content: center;\n  margin-left: 1.2rem;\n  min-width: 1.5rem;\n  padding: 0.4rem;\n\n  ", ";\n\n  ", "\n"])), function (_ref13) {
  var small = _ref13.small;
  return small && styled.css(_templateObject11$3 || (_templateObject11$3 = _taggedTemplateLiteral$5(["\n      font-size: 0.8em;\n      margin-left: 0.8rem;\n      min-height: 1.4rem;\n      min-width: 1.4rem;\n    "])));
}, function (_ref14) {
  var color = _ref14.color,
      theme = _ref14.theme;

  if (color === 'primary') {
    return styled.css(_templateObject12$2 || (_templateObject12$2 = _taggedTemplateLiteral$5(["\n        background-color: ", ";\n        color: ", ";\n      "])), theme.colors.primary, theme.colors.primaryText);
  }

  return styled.css(_templateObject13$2 || (_templateObject13$2 = _taggedTemplateLiteral$5(["\n      background-color: ", ";\n      color: ", ";\n    "])), theme.colors.text, theme.colors.background);
});
var StyledInput = styled__default['default'](MewoInput).attrs({
  containerClassName: 'containerClassName',
  variant: 'background'
})(_templateObject14$2 || (_templateObject14$2 = _taggedTemplateLiteral$5(["\n  && .containerClassName {\n    background-color: ", ";\n    border: 0;\n    height: 3.5rem;\n    min-height: 3.5rem;\n    padding: 1rem 1.5rem;\n\n    ", ";\n\n    input {\n      color: ", ";\n    }\n  }\n"])), function (_ref15) {
  var theme = _ref15.theme;
  return theme.colors.input.background;
}, function (_ref16) {
  var theme = _ref16.theme;
  return theme.mediaAbove.minWidth(_templateObject15$1 || (_templateObject15$1 = _taggedTemplateLiteral$5(["\n      height: 4rem;\n      min-height: 4rem;\n    "])));
}, function (_ref17) {
  var theme = _ref17.theme;
  return theme.colors.input.text;
});
var StyledCheckbox = styled__default['default'](Checkbox).attrs(function (_ref18) {
  var theme = _ref18.theme;
  return {
    fillColor: theme.colors.text,
    fillColorChecked: theme.colors.primary
  };
})(_templateObject16 || (_templateObject16 = _taggedTemplateLiteral$5(["\n  font-size: 1.3rem;\n  font-weight: ", ";\n  margin-top: 1.5rem;\n"])), function (_ref19) {
  var theme = _ref19.theme;
  return theme.fontWeight.bold;
});
var TextIndication = styled__default['default'].div(_templateObject17 || (_templateObject17 = _taggedTemplateLiteral$5(["\n  align-items: center;\n  display: flex;\n  font-size: 1.3rem;\n  line-height: 1.4;\n  justify-content: center;\n  height: calc(100vh - 22rem);\n  text-align: center;\n"])));
var CloseBtn = styled__default['default'](ArrowDropdown$1).attrs(function (_ref20) {
  var icon = _ref20.icon,
      minimized = _ref20.minimized;
  return {
    as: icon === 'arrow' ? ArrowDropdown$1 : CrossOutline$1,
    dir: minimized ? 'north' : 'south',
    width: icon === 'arrow' ? '2rem' : '2.6rem'
  };
})(_templateObject18 || (_templateObject18 = _taggedTemplateLiteral$5(["\n  margin-left: auto;\n"])));// Component
// =============================

var MAX_TAGS_FOUND = 100;
var defaultOpenedBoxes = {
  categories: {},
  subCategories: {},
  other: {}
};

var FilterBar = /*#__PURE__*/function (_PureComponent) {
  _inherits$e(FilterBar, _PureComponent);

  var _super = _createSuper$1(FilterBar);

  function FilterBar(props) {
    var _this;

    _classCallCheck$k(this, FilterBar);

    _this = _super.call(this, props);

    _defineProperty$8(_assertThisInitialized$1(_this), "filtersCount", function () {
      var _value$tags, _value$tagsOr, _value$tagsNot, _value$versions, _value$versionsNot;

      var _this$props = _this.props,
          value = _this$props.value,
          searchFeatures = _this$props.searchFeatures;
      var filtersCount = (((_value$tags = value.tags) === null || _value$tags === void 0 ? void 0 : _value$tags.length) || 0) + (((_value$tagsOr = value.tagsOr) === null || _value$tagsOr === void 0 ? void 0 : _value$tagsOr.length) || 0) + (((_value$tagsNot = value.tagsNot) === null || _value$tagsNot === void 0 ? void 0 : _value$tagsNot.length) || 0) + (((_value$versions = value.versions) === null || _value$versions === void 0 ? void 0 : _value$versions.length) || 0) + (((_value$versionsNot = value.versionsNot) === null || _value$versionsNot === void 0 ? void 0 : _value$versionsNot.length) || 0);
      if (searchFeatures.duration) filtersCount += !!value.duration;
      if (searchFeatures.year) filtersCount += !!value.year;
      if (searchFeatures.bpm) filtersCount += !!value.bpm;
      if (searchFeatures.lyrics) filtersCount += !!value.lyrics;
      if (searchFeatures.stems) filtersCount += !!value.stems;
      return filtersCount;
    });

    _defineProperty$8(_assertThisInitialized$1(_this), "allOpened", function () {
      var _ref;

      var tags = _this.props.tags;
      return {
        categories: tags.map(function (t) {
          return t.id;
        }).reduce(function (acc, id) {
          return _objectSpread2$2(_objectSpread2$2({}, acc), {}, _defineProperty$8({}, id, true));
        }, {}),
        subCategories: (_ref = []).concat.apply(_ref, _toConsumableArray$5(tags.map(function (t) {
          return t.sub_categories;
        }))).map(function (t) {
          return t.id;
        }).reduce(function (acc, id) {
          return _objectSpread2$2(_objectSpread2$2({}, acc), {}, _defineProperty$8({}, id, true));
        }, {}),
        other: {
          versions: true
        }
      };
    });

    _defineProperty$8(_assertThisInitialized$1(_this), "initialVersionsByFacets", function () {
      var _this$props2 = _this.props,
          versions = _this$props2.versions,
          initialFacets = _this$props2.initialFacets;
      if (isEmpty_1(initialFacets || initialFacets.versions)) return versions;
      var existingVersionIds = Object.keys(initialFacets.versions);
      return versions.filter(function (v) {
        return existingVersionIds.includes(v.id);
      });
    });

    _defineProperty$8(_assertThisInitialized$1(_this), "versionsByFacets", function () {
      var _this$props3 = _this.props,
          versions = _this$props3.versions,
          facets = _this$props3.facets;
      if (isEmpty_1(facets || facets.versions)) return versions;
      var existingVersionIds = Object.keys(facets.versions);
      return versions.filter(function (v) {
        return existingVersionIds.includes(v.id);
      });
    });

    _defineProperty$8(_assertThisInitialized$1(_this), "versionsIdByFacets", function () {
      var versionsByFacets = _this.versionsByFacets();

      return versionsByFacets.map(function (version) {
        return version.id;
      });
    });

    _defineProperty$8(_assertThisInitialized$1(_this), "tagsByFacets", function () {
      var _this$props4 = _this.props,
          categories = _this$props4.tags,
          facets = _this$props4.facets,
          value = _this$props4.value;
      var initialTags = _this.state.initialTags;
      if (isEmpty_1(facets || facets.tags)) return categories;
      var existingTagIds = Object.keys(facets.tags);
      var initialExistingTagIds = Object.keys(initialTags);
      return categories.reduce(function (cAcc, c) {
        var tags = c.tags.filter(function (t) {
          return includes_1(existingTagIds, t.id) || includes_1(value.tagsNot, t.id) && includes_1(initialExistingTagIds, t.id);
        });
        var subCategories = c.sub_categories.reduce(function (sAcc, s) {
          // subCategory tags found
          var sTags = s.tags.filter(function (t) {
            return existingTagIds.includes(t.id) || includes_1(value.tagsNot, t.id) && includes_1(initialExistingTagIds, t.id) || includes_1(value.tagsNot, s.id) && includes_1(initialExistingTagIds, t.id);
          });
          if (sTags.length) return [].concat(_toConsumableArray$5(sAcc), [_objectSpread2$2(_objectSpread2$2({}, s), {}, {
            tags: sTags
          })]);
          return sAcc;
        }, []);
        if (!tags.length && !subCategories.length) return cAcc;
        return [].concat(_toConsumableArray$5(cAcc), [_objectSpread2$2(_objectSpread2$2({}, c), {}, {
          tags: tags,
          sub_categories: subCategories
        })]);
      }, []);
    });

    _defineProperty$8(_assertThisInitialized$1(_this), "initialTagsByFacets", function () {
      var _this$props5 = _this.props,
          categories = _this$props5.tags,
          initialFacets = _this$props5.initialFacets;
      if (isEmpty_1(initialFacets || initialFacets.tags)) return categories;
      var existingTagIds = Object.keys(initialFacets.tags);
      return categories.reduce(function (cAcc, c) {
        var tags = c.tags.filter(function (t) {
          return existingTagIds.includes(t.id);
        });
        var subCategories = c.sub_categories.reduce(function (sAcc, s) {
          // subCategory tags found
          var sTags = s.tags.filter(function (t) {
            return existingTagIds.includes(t.id);
          });
          if (sTags.length) return [].concat(_toConsumableArray$5(sAcc), [_objectSpread2$2(_objectSpread2$2({}, s), {}, {
            tags: sTags
          })]);
          return sAcc;
        }, []);
        if (!tags.length && !subCategories.length) return cAcc;
        return [].concat(_toConsumableArray$5(cAcc), [_objectSpread2$2(_objectSpread2$2({}, c), {}, {
          tags: tags,
          sub_categories: subCategories
        })]);
      }, []);
    });

    _defineProperty$8(_assertThisInitialized$1(_this), "tagsFound", function () {
      var _this$props6 = _this.props,
          tags = _this$props6.tags,
          locale = _this$props6.locale;
      var search = _this.state.search;
      return !!tags.filter(function (t) {
        return categoryMatches(t, search, locale);
      }).length;
    });

    _defineProperty$8(_assertThisInitialized$1(_this), "versionsFound", function () {
      var locale = _this.props.locale;
      var search = _this.state.search;
      return !!_this.versionsByFacets().filter(function (v) {
        return versionMatches(v, search, locale);
      }).length;
    });

    _defineProperty$8(_assertThisInitialized$1(_this), "handleSearch", function (search) {
      var locale = _this.props.locale; // NOTE: If there is no search field or too many tags found do not open any boxes
      // open all boxes otherwise, and they get filtered lower in a system
      // eslint-disable-next-line max-len

      var tooManyTags = itemsFoundLength(_this.tagsByFacets(), _this.versionsByFacets(), search, locale) > MAX_TAGS_FOUND;

      _this.setState(function () {
        return {
          search: search,
          openedBoxes: search && !tooManyTags ? _this.allOpened() : defaultOpenedBoxes
        };
      });
    });

    _defineProperty$8(_assertThisInitialized$1(_this), "handleOpen", function (path, value) {
      _this.setState(function (_ref2) {
        var openedBoxes = _ref2.openedBoxes;
        return {
          openedBoxes: set_1(cloneDeep_1(openedBoxes), path, value)
        };
      });
    });

    _defineProperty$8(_assertThisInitialized$1(_this), "handleChange", function (diff) {
      var _this$props7 = _this.props,
          value = _this$props7.value,
          onChange = _this$props7.onChange;
      onChange(_objectSpread2$2(_objectSpread2$2({}, value), diff));
    });

    var _initialTags = props.facets.tags;
    _this.state = {
      initialTags: _initialTags,
      openedBoxes: defaultOpenedBoxes,
      search: ''
    };
    return _this;
  }

  _createClass$g(FilterBar, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var prevSearch = prevProps.externalSearch;
      var nextSearch = this.props.externalSearch;

      if (prevSearch !== nextSearch) {
        this.handleSearch(nextSearch);
      }
    } // Calculate number of used filter.

  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props8 = this.props,
          className = _this$props8.className,
          classNames = _this$props8.classNames,
          displaySearchBar = _this$props8.displaySearchBar,
          facets = _this$props8.facets,
          lang = _this$props8.lang,
          locale = _this$props8.locale,
          maiaLoading = _this$props8.maiaLoading,
          minimized = _this$props8.minimized,
          minimizedOnClick = _this$props8.minimizedOnClick,
          onClose = _this$props8.onClose,
          onCloseIcon = _this$props8.onCloseIcon,
          onLyricsChange = _this$props8.onLyricsChange,
          opened = _this$props8.opened,
          searchFeatures = _this$props8.searchFeatures,
          showUnavailableFilters = _this$props8.showUnavailableFilters,
          tags = _this$props8.tags,
          value = _this$props8.value,
          visible = _this$props8.visible;
      var _this$state = this.state,
          openedBoxes = _this$state.openedBoxes,
          search = _this$state.search;
      var noFilterFound = !this.tagsFound() && !this.versionsFound() && search;
      return /*#__PURE__*/React__default['default'].createElement(WithCustomTheme, {
        customTheme: function customTheme(theme) {
          return {
            colors: theme.colors.filterBar
          };
        }
      }, /*#__PURE__*/React__default['default'].createElement(WrapperSwitcher, {
        DesktopComponent: /*#__PURE__*/React__default['default'].createElement(Wrapper$9, {
          className: className,
          opened: opened,
          visible: visible
        }),
        MobileComponent: /*#__PURE__*/React__default['default'].createElement(WrapperMobile, {
          className: className,
          minimized: minimized,
          onClick: minimized ? minimizedOnClick : null,
          opened: opened,
          visible: visible
        })
      }, /*#__PURE__*/React__default['default'].createElement(Header, {
        className: classNames.header,
        noSearchBar: !displaySearchBar
      }, /*#__PURE__*/React__default['default'].createElement(Flex, {
        align: "center",
        height: "4rem",
        mb: "3.2rem",
        width: "100%"
      }, /*#__PURE__*/React__default['default'].createElement(FilterNumber, null, lang.title, /*#__PURE__*/React__default['default'].createElement(Desktop, null, this.filtersCount() > 0 && /*#__PURE__*/React__default['default'].createElement(Counter, {
        color: "primary"
      }, this.filtersCount()))), onClose && /*#__PURE__*/React__default['default'].createElement(CloseBtn, {
        icon: onCloseIcon,
        minimized: minimized,
        onClick: onClose
      })), !maiaLoading && displaySearchBar && /*#__PURE__*/React__default['default'].createElement(StyledInput, {
        autoComplete: "off",
        icon: SearchMusic$1,
        name: "searchfilter",
        onChange: this.handleSearch,
        placeholder: lang.input.search,
        small: true,
        value: search,
        variant: "background",
        lang: lang.input
      })), /*#__PURE__*/React__default['default'].createElement(Content, {
        className: classNames.content,
        noSearchBar: !displaySearchBar
      }, maiaLoading && /*#__PURE__*/React__default['default'].createElement(TextIndication, {
        className: classNames.textIndication
      }, lang.maiaLoading), !maiaLoading && noFilterFound && /*#__PURE__*/React__default['default'].createElement(TextIndication, {
        className: classNames.textIndication
      }, lang.noTags), !maiaLoading && /*#__PURE__*/React__default['default'].createElement(React__default['default'].Fragment, null, !search && /*#__PURE__*/React__default['default'].createElement(React__default['default'].Fragment, null, searchFeatures.duration && /*#__PURE__*/React__default['default'].createElement(TagBox, {
        onOpen: this.handleOpen,
        opened: !!openedBoxes.other.duration,
        path: "other.duration",
        title: lang.duration,
        withPadding: true
      }, /*#__PURE__*/React__default['default'].createElement(Chart$1, {
        data: facets.duration,
        px: "1.6rem",
        maxWidth: "100%"
      }), /*#__PURE__*/React__default['default'].createElement(InputRangeResettable, {
        value: value.duration,
        min: 0,
        max: 600,
        step: 5,
        name: "duration",
        onChange: function onChange(duration) {
          return _this2.handleChange({
            duration: duration
          });
        },
        small: true,
        type: "duration"
      })), searchFeatures.year && /*#__PURE__*/React__default['default'].createElement(TagBox, {
        title: lang.year,
        opened: !!openedBoxes.other.year,
        onOpen: this.handleOpen,
        path: "other.year",
        withPadding: true
      }, /*#__PURE__*/React__default['default'].createElement(Chart$1, {
        data: facets.year,
        px: "1.6rem",
        maxWidth: "100%"
      }), /*#__PURE__*/React__default['default'].createElement(InputRangeResettable, {
        value: value.year,
        min: 1930,
        max: new Date().getFullYear(),
        name: "year",
        onChange: function onChange(year) {
          return _this2.handleChange({
            year: year
          });
        },
        small: true
      })), searchFeatures.bpm && /*#__PURE__*/React__default['default'].createElement(TagBox, {
        title: lang.bpm,
        opened: !!openedBoxes.other.bpm,
        onOpen: this.handleOpen,
        path: "other.bpm",
        withPadding: true
      }, /*#__PURE__*/React__default['default'].createElement(Chart$1, {
        data: facets.bpm,
        px: "1.6rem",
        maxWidth: "100%"
      }), /*#__PURE__*/React__default['default'].createElement(InputRangeResettable, {
        value: value.bpm,
        min: 30,
        max: 220,
        name: "bpm",
        onChange: function onChange(bpm) {
          return _this2.handleChange({
            bpm: bpm
          });
        },
        small: true
      }))), /*#__PURE__*/React__default['default'].createElement(TagList, {
        initialTags: this.initialTagsByFacets(),
        locale: locale,
        onChange: this.handleChange,
        onOpen: this.handleOpen,
        openedBoxes: openedBoxes,
        search: search,
        showUnavailableFilters: showUnavailableFilters,
        tags: showUnavailableFilters ? this.initialTagsByFacets() : this.tagsByFacets(),
        tagsAvailable: keys_1(facets.tags),
        tagsUnfiltered: tags,
        valueTags: value.tags,
        valueTagsNot: value.tagsNot,
        valueTagsOr: value.tagsOr
      }), this.versionsFound() && /*#__PURE__*/React__default['default'].createElement(VersionList, {
        lang: lang,
        locale: locale,
        onChange: this.handleChange,
        onOpen: this.handleOpen,
        openedBoxes: openedBoxes,
        search: search,
        showUnavailableFilters: showUnavailableFilters,
        valueVersions: value.versions,
        valueVersionsNot: value.versionsNot,
        versions: showUnavailableFilters ? this.initialVersionsByFacets() : this.versionsByFacets(),
        versionsAvailable: this.versionsIdByFacets()
      }), searchFeatures.lyrics && !search && /*#__PURE__*/React__default['default'].createElement(TagBox, {
        onOpen: this.handleOpen,
        opened: !!openedBoxes.other.lyrics,
        path: "other.lyrics",
        title: lang.lyrics
      }, /*#__PURE__*/React__default['default'].createElement(LyricsInput, {
        name: "other.lyrics",
        lang: lang.input,
        onChange: onLyricsChange,
        value: value.lyrics
      })), searchFeatures.stems && !search && /*#__PURE__*/React__default['default'].createElement(TagBox, {
        onOpen: this.handleOpen,
        opened: !!openedBoxes.other.stems,
        path: "other.stems",
        title: lang.stems
      }, /*#__PURE__*/React__default['default'].createElement(StyledCheckbox, {
        checked: value.stems,
        label: lang.onlyStems,
        onChange: function onChange() {
          return _this2.handleChange({
            stems: !value.stems
          });
        }
      }))))));
    }
  }]);

  return FilterBar;
}(React.PureComponent);

_defineProperty$8(FilterBar, "propTypes", {
  /** Props used by styled component to override styles */
  className: PropTypes__default['default'].string,

  /** ClassName used to style Content. */
  classNames: PropTypes__default['default'].shape({
    content: PropTypes__default['default'].string,
    header: PropTypes__default['default'].string,
    textIndication: PropTypes__default['default'].string
  }),

  /** Display search bar */
  displaySearchBar: PropTypes__default['default'].bool,

  /** External search, change this to any value to trigger search. */
  externalSearch: PropTypes__default['default'].string,

  /** Search filters (after being filtered by availability). */
  facets: PropTypes__default['default'].shape({
    duration: PropTypes__default['default'].arrayOf(facet),
    year: PropTypes__default['default'].arrayOf(facet),
    bpm: PropTypes__default['default'].arrayOf(facet),
    versions: PropTypes__default['default'].object,
    // eslint-disable-line react/forbid-prop-types
    tags: PropTypes__default['default'].object // eslint-disable-line react/forbid-prop-types

  }).isRequired,

  /** Initial search filters (even those non available anymore due to filtering). */
  initialFacets: PropTypes__default['default'].shape({
    duration: PropTypes__default['default'].arrayOf(facet),
    year: PropTypes__default['default'].arrayOf(facet),
    bpm: PropTypes__default['default'].arrayOf(facet),
    versions: PropTypes__default['default'].object,
    // eslint-disable-line react/forbid-prop-types
    tags: PropTypes__default['default'].object // eslint-disable-line react/forbid-prop-types

  }).isRequired,

  /** Translated text fields */
  lang: lang.isRequired,

  /** Locale used */
  locale: PropTypes__default['default'].string.isRequired,

  /** Maia is loading */
  maiaLoading: PropTypes__default['default'].bool,

  /** If True, will render only FilterBar's title. Used on mobile only. */
  minimized: PropTypes__default['default'].bool,

  /** Function executed on click when FilterBar is minimized. Used on mobile only. */
  minimizedOnClick: PropTypes__default['default'].func,

  /** Value changed events */
  onChange: PropTypes__default['default'].func.isRequired,

  /** Function trigger on CloseBtn click. */
  onClose: PropTypes__default['default'].func,

  /** Style of the close button icon. */
  onCloseIcon: PropTypes__default['default'].oneOf(['arrow', 'close']),

  /** Lyrics change event */
  onLyricsChange: PropTypes__default['default'].func,

  /** Filter bar is opened */
  opened: PropTypes__default['default'].bool,

  /** Enable of disable certain search features */
  searchFeatures: PropTypes__default['default'].shape({
    duration: PropTypes__default['default'].bool,
    year: PropTypes__default['default'].bool,
    bpm: PropTypes__default['default'].bool,
    lyrics: PropTypes__default['default'].bool,
    stems: PropTypes__default['default'].bool
  }),

  /** If True, will alway show all filters even if not usable in search. */
  showUnavailableFilters: PropTypes__default['default'].bool,

  /** All Tags Tree (even those not used in any tracks) */
  tags: PropTypes__default['default'].arrayOf(category).isRequired,

  /** Filter Value */
  value: PropTypes__default['default'].shape({
    tags: PropTypes__default['default'].arrayOf(PropTypes__default['default'].string),
    tagsOr: PropTypes__default['default'].arrayOf(PropTypes__default['default'].string),
    tagsNot: PropTypes__default['default'].arrayOf(PropTypes__default['default'].string),
    versions: PropTypes__default['default'].arrayOf(PropTypes__default['default'].string),
    versionsNot: PropTypes__default['default'].arrayOf(PropTypes__default['default'].string),
    duration: PropTypes__default['default'].arrayOf(PropTypes__default['default'].oneOfType([PropTypes__default['default'].number, PropTypes__default['default'].string])),
    year: PropTypes__default['default'].arrayOf(PropTypes__default['default'].oneOfType([PropTypes__default['default'].number, PropTypes__default['default'].string])),
    bpm: PropTypes__default['default'].arrayOf(PropTypes__default['default'].oneOfType([PropTypes__default['default'].number, PropTypes__default['default'].string])),
    lyrics: PropTypes__default['default'].string,
    stems: PropTypes__default['default'].bool
  }).isRequired,

  /** All Versions */
  versions: PropTypes__default['default'].arrayOf(version).isRequired,

  /** Filter bar is hidden */
  visible: PropTypes__default['default'].bool
});

_defineProperty$8(FilterBar, "defaultProps", {
  className: '',
  classNames: {
    content: '',
    header: ''
  },
  displaySearchBar: true,
  externalSearch: '',
  maiaLoading: false,
  minimized: false,
  minimizedOnClick: null,
  opened: false,
  onClose: null,
  onCloseIcon: 'arrow',
  onLyricsChange: null,
  searchFeatures: {
    duration: true,
    year: true,
    bpm: true,
    lyrics: true,
    stems: true
  },
  showUnavailableFilters: true,
  visible: true
});/**
 * Gets the first element of `array`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @alias first
 * @category Array
 * @param {Array} array The array to query.
 * @returns {*} Returns the first element of `array`.
 * @example
 *
 * _.head([1, 2, 3]);
 * // => 1
 *
 * _.head([]);
 * // => undefined
 */

function head(array) {
  return (array && array.length) ? array[0] : undefined;
}

var head_1 = head;var first = head_1;var whitelist = ['Roboto', 'Open Sans', 'Lato', 'Montserrat', 'Source Sans Pro', 'Raleway', 'Tomorrow', 'Poppins', 'Playfair Display', 'Mulish', 'Nunito', 'Rubik', 'Titillium Web', 'Fira Sans', 'Nunito Sans', 'Barlow', 'Josefin Sans', 'Libre Franklin', 'Exo 2', 'Barlow Condensed', 'IBM Plex Sans', 'Overpass', 'Kanit', 'EB Garamond', 'Zilla Slab', 'Prompt', 'Fira Sans Condensed', 'Exo', 'IBM Plex Serif', 'Cormorant Garamond', 'Alegreya Sans', 'Alegreya', 'Barlow Semi Condensed', 'Sarabun', 'Fira Sans Extra Condensed', 'Montserrat Alternates', 'Josefin Slab', 'Taviraj', 'Spectral', 'Public Sans', 'Cormorant', 'Alegreya Sans SC', 'Bai Jamjuree', 'Rosario', 'Trirong', 'Alegreya SC', 'Kulim Park', 'Krub', 'IBM Plex Sans Condensed', 'Chakra Petch', 'Cormorant Infant', 'Niramit', 'Be Vietnam', 'K2D', 'Spectral SC', 'Proza Libre', 'Livvic', 'Grenze', 'Kodchasan', 'Crimson Pro', 'KoHo', 'Fahkwang'];var _templateObject$c, _templateObject2$b, _templateObject3$a;
// Styles
// =============================

var Wrapper$8 = styled__default['default'].div(_templateObject$c || (_templateObject$c = _taggedTemplateLiteral$5(["\n  align-items: baseline;\n  display: flex;\n  justify-content: space-between;\n"])));
var Value = styled__default['default'].div.attrs(function (_ref) {
  var family = _ref.family;
  return {
    style: {
      fontFamily: family
    }
  };
})(_templateObject2$b || (_templateObject2$b = _taggedTemplateLiteral$5([""])));
var Preview = styled__default['default'].div.attrs(function (_ref2) {
  var family = _ref2.family;
  return {
    style: {
      fontFamily: family
    }
  };
})(_templateObject3$a || (_templateObject3$a = _taggedTemplateLiteral$5(["\n  margin-top: 2rem;\n  font-size: 1.2em;\n  width: 100%;\n"])));var _excluded$8 = ["className", "containerClassName", "disabled", "dropdownClassName", "error", "helperText", "label", "lang", "name", "optional", "previewText", "tooltipError", "tooltipInteractive", "tooltipMessage", "tooltipPlacement", "value", "variant"];
// Component
// =============================

var GoogleFontsInput = /*#__PURE__*/function (_Component) {
  _inherits$e(GoogleFontsInput, _Component);

  var _super = _createSuper$1(GoogleFontsInput);

  function GoogleFontsInput(props) {
    var _this;

    _classCallCheck$k(this, GoogleFontsInput);

    _this = _super.call(this, props);

    _defineProperty$8(_assertThisInitialized$1(_this), "componentDidMount", function () {
      var googleApiKey = _this.props.googleApiKey;
      axios({
        method: 'get',
        url: 'https://www.googleapis.com/webfonts/v1/webfonts',
        params: {
          key: googleApiKey,
          sort: 'alpha'
        }
      }).then(function (response) {
        var fonts = get_1(response, 'data.items');

        var options = filter_1(fonts, function (font) {
          return includes_1(whitelist, font.family);
        });

        _this.setState({
          options: options
        }, _this.loadFonts);
      })["catch"](function () {});
    });

    _defineProperty$8(_assertThisInitialized$1(_this), "handleRemoveFilter", function () {
      return _this.setState({
        filter: ''
      });
    });

    _defineProperty$8(_assertThisInitialized$1(_this), "handleFilterChange", function (e) {
      return _this.setState({
        filter: e.target.value
      });
    });

    _defineProperty$8(_assertThisInitialized$1(_this), "loadFonts", function () {
      var options = _this.state.options;
      var hrefs = options.map(function (option) {
        return "https://fonts.googleapis.com/css?family=".concat(option.family, "&display=swap");
      });
      var _document = document,
          head = _document.head;
      var l = hrefs.length;

      for (var i = 0; i < l; i += 1) {
        var link = document.createElement('link');
        link.type = 'text/css';
        link.rel = 'stylesheet';
        link.href = hrefs[i];
        head.appendChild(link);
      }
    });

    _defineProperty$8(_assertThisInitialized$1(_this), "handleOpenDropdown", function () {
      var disabled = _this.props.disabled;

      if (!disabled) {
        _this.inputRef.focus();

        _this.setState({
          opened: true
        });
      }
    });

    _defineProperty$8(_assertThisInitialized$1(_this), "handleCloseDropdown", function () {
      return _this.setState({
        opened: false
      });
    });

    _defineProperty$8(_assertThisInitialized$1(_this), "toggleDropdown", function () {
      var opened = _this.state.opened;

      if (!opened) {
        return _this.handleOpenDropdown();
      }

      return _this.handleCloseDropdown();
    });

    _defineProperty$8(_assertThisInitialized$1(_this), "handleInputKeyDown", function (event) {
      var key = event.key;
      /**
       * Sometimes dropdown can be closed but with focus,
       * so we open dropdown anytime input trigger an event.
       * */

      _this.setState({
        opened: true
      });

      switch (key) {
        // Tab
        case 'Tab':
          _this.setState({
            opened: false
          });

          break;

        case 'ArrowDown':
          event.preventDefault();

          _this.inputFilter.focus();

          _this.animationContainerRef.scrollTop = 0;
          break;

        case 'ArrowUp':
          event.preventDefault();
          if (_this.animationContainerRef.lastChild) _this.animationContainerRef.lastChild.focus();
          break;

        default:
          // If user is not navigating nor saving, we assume he wants to add some filter
          _this.inputFilter.focus();

          _this.animationContainerRef.scrollTop = 0;
          break;
      }
    });

    _defineProperty$8(_assertThisInitialized$1(_this), "handleFilterKeyDown", function (e) {
      var key = e.key;
      var _this$state = _this.state,
          filter = _this$state.filter,
          options = _this$state.options;
      /**
       * Sometimes dropdown can be closed but with focus,
       * so we open dropdown anytime filter input trigger an event.
       * */

      _this.setState({
        opened: true
      });

      switch (key) {
        // Tab
        case 'Tab':
          _this.setState({
            opened: false
          });

          break;
        // Arrow Up: Go to next item

        case 'ArrowUp':
          e.preventDefault();

          if (_this.animationContainerRef.lastChild) {
            _this.animationContainerRef.lastChild.focus();
          }

          break;
        // Arrow Down: Go to previous item

        case 'ArrowDown':
          e.preventDefault();

          if (_this.animationContainerRef.childNodes[1]) {
            // Since the filter input is the first child we need to target the 2nd one.
            _this.animationContainerRef.childNodes[1].focus();
          }

          break;

        case 'Enter':
          e.preventDefault();
          /** If user press enter in filter input, we suppose he want to add the closest option. */
          // eslint-disable-next-line no-case-declarations

          var firstOption = first(filter_1(options, function (option) {
            return includes_1(option.family.toLowerCase(), filter.toLowerCase());
          }));

          if (firstOption) {
            _this.handleSelectOption(firstOption.family);
          }

          break;
      }

      return true;
    });

    _defineProperty$8(_assertThisInitialized$1(_this), "handleOptionKeyDown", function (e) {
      var key = e.key,
          target = e.target;
      /**
       * Sometimes dropdown can be closed but with focus,
       * so we open dropdown anytime an option trigger an event.
       * */

      _this.setState({
        opened: true
      });

      if (e.target.dataset.noOptions) {
        return _this.inputRef.focus();
      }

      switch (key) {
        // Tab
        case 'Tab':
          _this.setState({
            opened: false
          });

          break;
        // Enter: Save item

        case 'Enter':
          e.preventDefault();

          _this.handleSelectOption(e.target.dataset.value);

          break;
        // Arrow Up: Go to next item

        case 'ArrowUp':
          e.preventDefault();

          if (!target.previousSibling) {
            _this.animationContainerRef.lastChild.focus();

            break;
          } // If target has no dataset value, then its the FilterInput.


          if (!target.previousSibling.dataset.value) {
            _this.inputFilter.focus();

            _this.animationContainerRef.scrollTop = 0;
            break;
          }

          target.previousSibling.focus();
          break;
        // Arrow Down: Go to previous item

        case 'ArrowDown':
          e.preventDefault();

          if (!target.nextSibling) {
            _this.inputFilter.focus();

            _this.animationContainerRef.scrollTop = 0;
            break;
          }

          target.nextSibling.focus();
          break;
        // If user is not navigating nor saving, we assume he wants to add some filter

        default:
          _this.inputFilter.focus();

          _this.animationContainerRef.scrollTop = 0;
          break;
      }

      return true;
    });

    _defineProperty$8(_assertThisInitialized$1(_this), "handleSelectOption", function (val) {
      var _this$props = _this.props,
          onChange = _this$props.onChange,
          disabled = _this$props.disabled; // We focus input and then we close the dropdown because 'focusing input' = opening dropdown

      _this.inputRef.focus();

      _this.setState({
        filter: '',
        opened: false
      });

      if (onChange && !disabled) {
        onChange(val);
      }
    });

    _defineProperty$8(_assertThisInitialized$1(_this), "renderValue", function () {
      var value = _this.props.value;
      return value;
    });

    _defineProperty$8(_assertThisInitialized$1(_this), "renderPlaceholder", function () {
      var _this$props2 = _this.props,
          placeholder = _this$props2.placeholder,
          value = _this$props2.value;
      if (value) return '';
      return placeholder;
    });

    _defineProperty$8(_assertThisInitialized$1(_this), "renderInputValue", function () {
      var value = _this.props.value;
      return value;
    });

    _defineProperty$8(_assertThisInitialized$1(_this), "renderOptions", function () {
      var _this$state2 = _this.state,
          filter = _this$state2.filter,
          options = _this$state2.options;
      var _this$props3 = _this.props,
          name = _this$props3.name,
          value = _this$props3.value,
          searchInputPlaceholder = _this$props3.searchInputPlaceholder; // eslint-disable-next-line max-len

      var optionsToBeRendered = filter_1(options, function (option) {
        return includes_1(option.family.toLowerCase(), filter.toLowerCase());
      });

      return /*#__PURE__*/React__default['default'].createElement(OptionsContainer$1, {
        noRadiusTop: true,
        ref: function ref(node) {
          _this.animationContainerRef = node;
        }
      }, /*#__PURE__*/React__default['default'].createElement(Option, null, /*#__PURE__*/React__default['default'].createElement(InputBase, {
        getInputRef: function getInputRef(node) {
          _this.inputFilter = node;
        },
        name: name,
        onChange: _this.handleFilterChange,
        onKeyDown: _this.handleFilterKeyDown,
        placeholder: searchInputPlaceholder,
        showPlaceholder: true,
        tabIndex: "-1",
        value: filter
      })), optionsToBeRendered.map(function (option) {
        return /*#__PURE__*/React__default['default'].createElement(Option, {
          key: option.family,
          onClick: function onClick() {
            return _this.handleSelectOption(option.family);
          },
          onKeyDown: function onKeyDown(e) {
            return _this.handleOptionKeyDown(e);
          },
          selected: option.family === value,
          "data-value": option.family
        }, /*#__PURE__*/React__default['default'].createElement(Value, {
          family: option.family
        }, option.family));
      }));
    });

    _this.state = {
      filter: '',
      opened: false,
      options: []
    };
    return _this;
  }

  _createClass$g(GoogleFontsInput, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var opened = this.state.opened;

      var _this$props4 = this.props,
          className = _this$props4.className,
          containerClassName = _this$props4.containerClassName,
          disabled = _this$props4.disabled,
          dropdownClassName = _this$props4.dropdownClassName,
          error = _this$props4.error,
          helperText = _this$props4.helperText,
          label = _this$props4.label,
          lang = _this$props4.lang,
          name = _this$props4.name,
          optional = _this$props4.optional,
          previewText = _this$props4.previewText,
          tooltipError = _this$props4.tooltipError,
          tooltipInteractive = _this$props4.tooltipInteractive,
          tooltipMessage = _this$props4.tooltipMessage,
          tooltipPlacement = _this$props4.tooltipPlacement,
          value = _this$props4.value,
          variant = _this$props4.variant,
          rest = _objectWithoutProperties$7(_this$props4, _excluded$8);

      return /*#__PURE__*/React__default['default'].createElement(Wrapper$p, _extends$g({
        className: className
      }, getViewProps(rest)), variant === 'background' && /*#__PURE__*/React__default['default'].createElement(Label$2, {
        active: opened,
        error: error,
        label: label,
        lang: lang.Label,
        optional: optional,
        variant: "background"
      }), /*#__PURE__*/React__default['default'].createElement(Wrapper$8, null, /*#__PURE__*/React__default['default'].createElement(ClickAwayListener, {
        onClickAway: this.handleCloseDropdown
      }, /*#__PURE__*/React__default['default'].createElement(Container$1, {
        active: opened,
        containerClassName: containerClassName,
        error: error,
        getRef: function getRef(node) {
          _this2.containerRef = node;
        },
        onClick: this.handleOpenDropdown,
        variant: variant
      }, variant === 'underline' && /*#__PURE__*/React__default['default'].createElement(Label$2, {
        active: opened,
        error: error,
        inputFilled: !!value,
        label: label,
        lang: lang.Label,
        optional: optional,
        variant: variant
      }), /*#__PURE__*/React__default['default'].createElement(Flex, {
        align: "center",
        flex: "1 1 0",
        wrap: "wrap"
      }, /*#__PURE__*/React__default['default'].createElement(InputBase, {
        disabled: disabled,
        dropdownIndicator: {
          opened: opened,
          onClick: this.toggleDropdown
        },
        error: error,
        getInputRef: function getInputRef(node) {
          _this2.inputRef = node;
        },
        getRef: function getRef(node) {
          _this2.inputWrapperRef = node;
        },
        name: name,
        onKeyDown: this.handleInputKeyDown,
        placeholder: this.renderPlaceholder(),
        readOnly: true,
        showPlaceholder: opened || !!value || variant === 'background',
        tooltipError: tooltipError,
        tooltipInteractive: tooltipInteractive,
        tooltipMessage: tooltipMessage,
        tooltipPlacement: tooltipPlacement,
        value: this.renderInputValue()
      }))))), /*#__PURE__*/React__default['default'].createElement(Dropdown$2, {
        className: dropdownClassName,
        onClickOutside: this.handleCloseDropdown,
        open: opened,
        variant: variant
      }, /*#__PURE__*/React__default['default'].createElement(React__default['default'].Fragment, null, this.renderOptions())), helperText && /*#__PURE__*/React__default['default'].createElement(HelperText, {
        error: error
      }, helperText), /*#__PURE__*/React__default['default'].createElement(Preview, {
        family: value
      }, previewText));
    }
  }]);

  return GoogleFontsInput;
}(React.Component);

_defineProperty$8(GoogleFontsInput, "propTypes", {
  /** Props used by styled component to override styles. */
  className: PropTypes__default['default'].string,

  /** Container classname. */
  containerClassName: PropTypes__default['default'].string,

  /** If true, the input will be disabled. */
  disabled: PropTypes__default['default'].bool,

  /** Dropdown classname. */
  dropdownClassName: PropTypes__default['default'].string,

  /** If true, the input will indicate an error.  */
  error: PropTypes__default['default'].bool,

  /** Google API Key. */
  googleApiKey: PropTypes__default['default'].string.isRequired,

  /** The helper text content. */
  helperText: PropTypes__default['default'].string,

  /** The label content. */
  label: PropTypes__default['default'].string,

  /** Translation strings. */
  lang: PropTypes__default['default'].object.isRequired,
  // eslint-disable-line react/forbid-prop-types

  /** Name attribute of the input element. */
  name: PropTypes__default['default'].string.isRequired,

  /** Callback fired when the value is changed. */
  onChange: PropTypes__default['default'].func.isRequired,

  /** If true, the input is optional. */
  optional: PropTypes__default['default'].bool,

  /** The short hint displayed in the input before the user enters a value. */
  placeholder: PropTypes__default['default'].string,

  /** The short hint displayed in font search input before the user enters a value. */
  searchInputPlaceholder: PropTypes__default['default'].string,

  /** Text used to preview font-family chosen. */
  previewText: PropTypes__default['default'].string,

  /** Used to display error messsage as tooltip. */
  tooltipError: PropTypes__default['default'].string,

  /** If True, Tooltip will be interactive. */
  tooltipInteractive: PropTypes__default['default'].bool,

  /** If set, will add an InfoTooltip btn on input with tooltipMessage as content. */
  tooltipMessage: PropTypes__default['default'].node,

  /** Tooltip placement */
  tooltipPlacement: PropTypes__default['default'].oneOf(['bottom-end', 'bottom-start', 'bottom', 'left-end', 'left-start', 'left', 'right-end', 'right-start', 'right', 'top-end', 'top-start', 'top']),

  /** Value. */
  value: PropTypes__default['default'].oneOfType([PropTypes__default['default'].string]),

  /** Input style variant. */
  variant: PropTypes__default['default'].oneOf(['background', 'underline'])
});

_defineProperty$8(GoogleFontsInput, "defaultProps", {
  className: '',
  containerClassName: '',
  disabled: false,
  dropdownClassName: '',
  error: false,
  helperText: '',
  label: '',
  optional: false,
  placeholder: '',
  searchInputPlaceholder: '',
  previewText: 'I watched the storm, so beautiful yet terrific.',
  tooltipError: '',
  tooltipInteractive: false,
  tooltipMessage: '',
  tooltipPlacement: 'bottom',
  value: '',
  variant: 'background'
});var _templateObject$b;
// Styles
// =============================
// eslint-disable-next-line import/prefer-default-export

var Wrapper$7 = styled__default['default'](Div)(_templateObject$b || (_templateObject$b = _taggedTemplateLiteral$5(["\n  height: 40rem;\n  width: 40rem;\n\n  /** NOTE: Googlemaps text need to be black. */\n  color: #000;\n"])));// Component
// =============================

var GoogleMaps = /*#__PURE__*/function (_PureComponent) {
  _inherits$e(GoogleMaps, _PureComponent);

  var _super = _createSuper$1(GoogleMaps);

  function GoogleMaps(props) {
    var _this;

    _classCallCheck$k(this, GoogleMaps);

    _this = _super.call(this, props); // Debounced Request for loading Google API

    _defineProperty$8(_assertThisInitialized$1(_this), "geocodePlaceId", function (geocoder, map, infowindow, placeId) {
      geocoder.geocode({
        placeId: placeId
      }, function (results, status) {
        if (status === 'OK') {
          if (results[0]) {
            map.setZoom(11);
            map.setCenter(results[0].geometry.location);
            var marker = new window.google.maps.Marker({
              map: map,
              position: results[0].geometry.location
            });
            infowindow.setContent(results[0].formatted_address);
            infowindow.open(map, marker);
          }
        }
      });
    });

    _defineProperty$8(_assertThisInitialized$1(_this), "loadGoogleApi", function () {
      var googleApiKey = _this.props.googleApiKey;
      var existingScript = document.getElementById('googlemapsapi');

      if (!existingScript) {
        var script = document.createElement('script');
        /**
         * Notes:
         * - This component don't need the "places" library
         * - GooglePlacesInput do need it
         * - We can't load the google maps api 2 times
         * - We can't load library dynamically
         * .
         * That's why we need to load it there too.
         * If someday we need another library for another component
         * we will also need to add it here and in GooglePlacesInput
         * */

        script.src = "https://maps.googleapis.com/maps/api/js?key=".concat(googleApiKey, "&libraries=places");
        script.id = 'googlemapsapi';
        script.async = true;
        script.defer = true;
        document.body.appendChild(script);

        script.onload = function () {
          return _this.setMapPosition();
        };
      } else if (window.google) {
        _this.setMapPosition();
      } else {
        _this.debounceLoadApi();
      }
    });

    _defineProperty$8(_assertThisInitialized$1(_this), "setMapPosition", function () {
      var _this$props = _this.props,
          id = _this$props.id,
          placeId = _this$props.placeId;
      var elem = document.getElementById(id);

      if (elem) {
        _this.map = new window.google.maps.Map(document.getElementById(id), {
          zoom: 11,
          disableDefaultUI: true,
          draggable: false
        });
        _this.geocoder = new window.google.maps.Geocoder();
        _this.infowindow = new window.google.maps.InfoWindow();

        _this.geocodePlaceId(_this.geocoder, _this.map, _this.infowindow, placeId);
      }
    });

    _this.debounceLoadApi = debounce_1(_this.loadGoogleApi, 1000, {
      leading: true,
      maxWait: 1000
    });
    return _this;
  }

  _createClass$g(GoogleMaps, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.debounceLoadApi();
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          className = _this$props2.className,
          id = _this$props2.id;
      return /*#__PURE__*/React__default['default'].createElement(Wrapper$7, {
        className: className,
        id: id
      });
    }
  }]);

  return GoogleMaps;
}(React.PureComponent);

_defineProperty$8(GoogleMaps, "propTypes", {
  /** Props used by styled component to override styles. */
  className: PropTypes__default['default'].string,

  /** Id used to identify where to init the google map. */
  id: PropTypes__default['default'].string.isRequired,

  /** Google API Key. */
  googleApiKey: PropTypes__default['default'].string.isRequired,

  /** place_id of the place we want to show in the map. */
  placeId: PropTypes__default['default'].string.isRequired
});

_defineProperty$8(GoogleMaps, "defaultProps", {
  className: ''
});var _templateObject$a, _templateObject2$a;
// Styles
// =============================

var StyledOptionsContainer = styled__default['default'](OptionsContainer$1)(_templateObject$a || (_templateObject$a = _taggedTemplateLiteral$5(["\n  max-height: none;\n"])));
var PoweredByGoogleLogo = styled__default['default'].div(_templateObject2$a || (_templateObject2$a = _taggedTemplateLiteral$5(["\n  background-image: url(https://maps.gstatic.com/mapfiles/api-3/images/powered-by-google-on-white3.png);\n  background-position: right 20px center;\n  background-repeat: no-repeat;\n  background-size: 120px 14px;\n  display: block;\n  height: 40px;\n  text-align: right;\n  width: 100%;\n"])));
var _excluded$7 = ["className", "containerClassName", "disabled", "dropdownClassName", "error", "helperText", "label", "lang", "name", "optional", "tooltipError", "tooltipInteractive", "tooltipMessage", "tooltipPlacement", "variant"];
// Component
// =============================

var GooglePlacesInput = /*#__PURE__*/function (_PureComponent) {
  _inherits$e(GooglePlacesInput, _PureComponent);

  var _super = _createSuper$1(GooglePlacesInput);

  function GooglePlacesInput(props) {
    var _this;

    _classCallCheck$k(this, GooglePlacesInput);

    _this = _super.call(this, props);

    _defineProperty$8(_assertThisInitialized$1(_this), "state", {
      isEditing: false,
      dropdownIsOpened: false,
      query: '',
      places: [],
      errorMessage: ''
    });

    _defineProperty$8(_assertThisInitialized$1(_this), "loadGoogleApi", function () {
      var googleApiKey = _this.props.googleApiKey;
      var existingScript = document.getElementById('googlemapsapi');

      if (!existingScript) {
        var script = document.createElement('script');
        script.src = "https://maps.googleapis.com/maps/api/js?key=".concat(googleApiKey, "&libraries=places");
        script.id = 'googlemapsapi';
        script.async = true;
        script.defer = true;
        document.body.appendChild(script);

        script.onload = function () {
          return _this.setApiMethods();
        };
      } else if (window.google) {
        _this.setApiMethods();
      } else {
        _this.debounceLoadApi();
      }
    });

    _defineProperty$8(_assertThisInitialized$1(_this), "setApiMethods", function () {
      var value = _this.props.value;
      _this.autocompleteApi = new window.google.maps.places.AutocompleteService(document.createElement('div'));
      _this.geocodingApi = new window.google.maps.Geocoder();
      _this.placesApi = new window.google.maps.places.PlacesService(document.createElement('div')); // When api methods are set, it's considered like a full mount
      // that's when we reverseGeocoding of existing value

      if (value) {
        _this.reverseGeocoding();
      }
    });

    _defineProperty$8(_assertThisInitialized$1(_this), "getAddressLabel", function (name) {
      var lang = _this.props.lang;

      switch (name) {
        case 'street_number':
          return lang.street_number;

        case 'route':
          return lang.route;

        case 'locality':
          return lang.locality;

        case 'postal_code':
          return lang.postal_code;

        case 'country':
          return lang.country;

        default:
          return name;
      }
    });

    _defineProperty$8(_assertThisInitialized$1(_this), "getErrorsFromStatus", function (status) {
      var lang = _this.props.lang;
      if (!lang || !lang.errors) return '';

      switch (status) {
        case 'ZERO_RESULTS':
          return lang.errors.ZERO_RESULTS;

        case 'INVALID_REQUEST':
          return lang.errors.INVALID_REQUEST;

        case 'UNKNOWN_ERROR':
          return lang.errors.UNKNOWN_ERROR;

        case 'ERROR':
          return lang.errors.ERROR;

        default:
          return lang.errors["default"];
      }
    });

    _defineProperty$8(_assertThisInitialized$1(_this), "reverseGeocoding", function () {
      var value = _this.props.value;

      if (!value) {
        return _this.setState({
          errorMessage: '',
          query: ''
        });
      }

      return _this.geocodingApi.geocode({
        placeId: value
      }, function (result, status) {
        var refreshedValue = _this.props.value; // NOTE: Sometimes racecondition happen here, when the props.value is
        // changed to fast. Then it starts several requests, and the one which
        // finishes the last wins. The line below saves from it.

        if (refreshedValue !== value) return;

        if (status === 'OK') {
          _this.setState({
            errorMessage: '',
            query: result[0].formatted_address
          });
        } else {
          _this.setState({
            errorMessage: _this.getErrorsFromStatus(status),
            query: ''
          });
        }
      });
    });

    _defineProperty$8(_assertThisInitialized$1(_this), "makeRequest", function () {
      var query = _this.state.query;

      _this.autocompleteApi.getQueryPredictions( // Query
      {
        input: query,
        types: ['address']
      }, // Callback
      function (result, status) {
        if (status === 'OK') {
          _this.setState({
            places: result
          });
        } else {
          _this.setState({
            places: [],
            errorMessage: _this.getErrorsFromStatus(status)
          });
        }
      });
    });

    _defineProperty$8(_assertThisInitialized$1(_this), "checkAddress", function (placeId) {
      var lang = _this.props.lang;
      return new Promise(function (resolve, reject) {
        _this.placesApi.getDetails({
          placeId: placeId
        }, function (result, status) {
          if (status === 'OK') {
            var addressComponent = []; // We get all types present in our API response

            var types = [];
            result.address_components.forEach(function (comp) {
              comp.types.forEach(function (type) {
                return types.push(type);
              });
            }); // We check which mandatory address component are present

            var check = addressComponent.map(function (comp) {
              return {
                name: comp,
                label: _this.getAddressLabel(comp),
                value: types.indexOf(comp) !== -1
              };
            });
            var errors = filter_1(check, function (comp) {
              return comp.value === false;
            }).map(function (error) {
              return error.label;
            });

            if (errors.length) {
              var error = "".concat(lang.missing_informations, " ").concat(errors);
              reject(error);
            }

            _this.setState({
              errorMessage: ''
            });

            resolve(result);
          } else {
            _this.setState({
              errorMessage: _this.getErrorsFromStatus(status)
            });

            reject(_this.getErrorsFromStatus(status));
          }
        });
      });
    });

    _defineProperty$8(_assertThisInitialized$1(_this), "handlePickItem", function (placeId) {
      var _this$props = _this.props,
          onChange = _this$props.onChange,
          disabled = _this$props.disabled;

      _this.setState({
        dropdownIsOpened: false
      });

      _this.checkAddress(placeId).then(function (result) {
        _this.setState({
          query: result.formatted_address
        });

        if (onChange && !disabled) {
          onChange(result.place_id);
        }
      })["catch"](function (err) {
        return _this.setState({
          errorMessage: err
        });
      });

      _this.inputRef.focus();
    });

    _defineProperty$8(_assertThisInitialized$1(_this), "handleChange", function (e) {
      var _this$props2 = _this.props,
          onChange = _this$props2.onChange,
          disabled = _this$props2.disabled;
      var val = e.target.value;

      _this.setState({
        query: val,
        dropdownIsOpened: true
      }, function () {
        if (val === '' && onChange && !disabled) {
          return onChange('');
        }

        return _this.debounceRequest();
      });
    });

    _defineProperty$8(_assertThisInitialized$1(_this), "handleOpenDropdown", function () {
      var disabled = _this.props.disabled;

      if (!disabled) {
        _this.inputRef.focus();

        _this.setState({
          dropdownIsOpened: true,
          isEditing: true
        });
      }
    });

    _defineProperty$8(_assertThisInitialized$1(_this), "handleCloseDropdown", function () {
      return _this.setState({
        dropdownIsOpened: false,
        isEditing: false
      });
    });

    _defineProperty$8(_assertThisInitialized$1(_this), "handleBlur", function () {
      return _this.setState({
        isEditing: false
      });
    });

    _defineProperty$8(_assertThisInitialized$1(_this), "toggleDropdown", function (shouldOpen) {
      if (shouldOpen) {
        return _this.handleOpenDropdown();
      }

      return _this.handleCloseDropdown();
    });

    _defineProperty$8(_assertThisInitialized$1(_this), "handleInputKeyDown", function (event) {
      var key = event.key; // Open Dropdown on keyDown, except if user press tab

      _this.toggleDropdown(key !== 'Tab'); // Clear errorMessage


      _this.setState({
        errorMessage: ''
      }); // KeyDown


      if (key === 'ArrowDown') {
        event.preventDefault();
        if (_this.dropDownRef.current.firstChild) _this.dropDownRef.current.firstChild.focus();
      }
    });

    _defineProperty$8(_assertThisInitialized$1(_this), "handleItemKeyDown", function (e) {
      var key = e.key,
          target = e.target;

      switch (key) {
        case 'Tab':
          _this.handleCloseDropdown();

          break;
        // Enter: Save item

        case 'Enter':
          e.preventDefault();

          _this.handlePickItem(target.dataset.id);

          break;
        // Arrow Up: Go to next item

        case 'ArrowUp':
          e.preventDefault();

          if (!target.previousSibling) {
            _this.dropDownRef.current.lastChild.previousSibling.focus();

            break;
          }

          target.previousSibling.focus();
          break;
        // Arrow Down: Go to previous item

        case 'ArrowDown':
          e.preventDefault();

          if (!target.nextSibling || target.nextSibling.dataset.google) {
            _this.dropDownRef.current.firstChild.focus();

            break;
          }

          target.nextSibling.focus();
          break;
        // If user is not navigating nor saving, we assume he wants to add some filter

        default:
          _this.inputRef.focus();

          break;
      }
    });

    _defineProperty$8(_assertThisInitialized$1(_this), "renderItem", function () {
      var places = _this.state.places;
      var retVal = places.map(function (place) {
        if (!place.place_id) return null; // We remove prediction without place_id

        return /*#__PURE__*/React__default['default'].createElement(Option, {
          height: "40px",
          key: place.place_id,
          "data-id": place.place_id,
          onClick: function onClick() {
            _this.handlePickItem(place.place_id);
          },
          onKeyDown: function onKeyDown(e) {
            return _this.handleItemKeyDown(e);
          },
          tabIndex: "-1"
        }, place.description);
      });
      if (retVal.length) retVal.push( /*#__PURE__*/React__default['default'].createElement(PoweredByGoogleLogo, {
        "data-google": true,
        key: "poweredByGoogleLogo"
      }));
      return retVal;
    });

    _this.dropDownRef = /*#__PURE__*/React__default['default'].createRef(); // Debounced Request for loading Google API

    _this.debounceLoadApi = debounce_1(_this.loadGoogleApi, 1000, {
      leading: true,
      maxWait: 1000
    }); // Debounced Request for textSearch

    _this.debounceRequest = debounce_1(_this.makeRequest, 200, {
      leading: true,
      maxWait: 300
    }); // Load Google API

    _this.debounceLoadApi();

    return _this;
  }

  _createClass$g(GooglePlacesInput, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var value = this.props.value;
      if (prevProps.value === value) return;
      this.reverseGeocoding();
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props3 = this.props,
          className = _this$props3.className,
          containerClassName = _this$props3.containerClassName,
          disabled = _this$props3.disabled,
          dropdownClassName = _this$props3.dropdownClassName,
          error = _this$props3.error,
          helperText = _this$props3.helperText,
          label = _this$props3.label,
          lang = _this$props3.lang,
          name = _this$props3.name,
          optional = _this$props3.optional,
          tooltipError = _this$props3.tooltipError,
          tooltipInteractive = _this$props3.tooltipInteractive,
          tooltipMessage = _this$props3.tooltipMessage,
          tooltipPlacement = _this$props3.tooltipPlacement,
          variant = _this$props3.variant,
          rest = _objectWithoutProperties$7(_this$props3, _excluded$7);

      var _this$state = this.state,
          isEditing = _this$state.isEditing,
          query = _this$state.query,
          dropdownIsOpened = _this$state.dropdownIsOpened,
          errorMessage = _this$state.errorMessage;
      return /*#__PURE__*/React__default['default'].createElement(ClickAwayListener, {
        onClickAway: this.handleCloseDropdown
      }, /*#__PURE__*/React__default['default'].createElement(Wrapper$p, _extends$g({
        className: className
      }, getViewProps(rest)), label && variant === 'background' && /*#__PURE__*/React__default['default'].createElement(Label$2, {
        active: isEditing,
        error: !!errorMessage || !!error,
        label: label,
        lang: lang.Label,
        optional: optional,
        variant: variant
      }), /*#__PURE__*/React__default['default'].createElement(Container$1, {
        active: isEditing,
        containerClassName: containerClassName,
        error: !!errorMessage || !!error,
        onClick: this.handleOpenDropdown,
        variant: variant
      }, label && variant === 'underline' && /*#__PURE__*/React__default['default'].createElement(Label$2, {
        active: isEditing,
        error: !!errorMessage || !!error,
        inputFilled: !!query,
        label: label,
        lang: lang.Label,
        optional: optional,
        variant: variant
      }), /*#__PURE__*/React__default['default'].createElement(Input$1, {
        autoComplete: "off_workaround",
        disabled: disabled,
        getInputRef: function getInputRef(node) {
          _this2.inputRef = node;
        },
        name: name,
        onBlur: this.handleBlur,
        onClick: this.handleOpenDropdown,
        onChange: this.handleChange,
        onKeyDown: this.handleInputKeyDown,
        tooltipError: tooltipError,
        tooltipInteractive: tooltipInteractive,
        tooltipMessage: tooltipMessage,
        tooltipPlacement: tooltipPlacement,
        value: query
      })), /*#__PURE__*/React__default['default'].createElement(Dropdown$2, {
        className: dropdownClassName,
        onClickOutside: this.handleCloseDropdown,
        open: dropdownIsOpened,
        variant: variant
      }, /*#__PURE__*/React__default['default'].createElement(StyledOptionsContainer, {
        ref: this.dropDownRef
      }, this.renderItem())), errorMessage && /*#__PURE__*/React__default['default'].createElement(HelperText, {
        error: true
      }, errorMessage), helperText && /*#__PURE__*/React__default['default'].createElement(HelperText, {
        error: !!error
      }, helperText)));
    }
  }]);

  return GooglePlacesInput;
}(React.PureComponent);

_defineProperty$8(GooglePlacesInput, "propTypes", {
  /** Props used by styled component to override styles */
  className: PropTypes__default['default'].string,

  /** Container classname. */
  containerClassName: PropTypes__default['default'].string,

  /** If True, Input will be disabled. */
  disabled: PropTypes__default['default'].bool,

  /** Dropdown classname. */
  dropdownClassName: PropTypes__default['default'].string,

  /** If true, the input will indicate an error.  */
  error: PropTypes__default['default'].bool,

  /** Google API Key */
  googleApiKey: PropTypes__default['default'].string.isRequired,

  /** The helper text content. */
  helperText: PropTypes__default['default'].string,

  /** Input label. */
  label: PropTypes__default['default'].string,

  /** Translation strings */
  lang: PropTypes__default['default'].object.isRequired,
  // eslint-disable-line react/forbid-prop-types

  /** Input name. */
  name: PropTypes__default['default'].string.isRequired,

  /** onChange handler */
  onChange: PropTypes__default['default'].func,

  /** If true, the input is optional. */
  optional: PropTypes__default['default'].bool,

  /** Used to display error messsage as tooltip. */
  tooltipError: PropTypes__default['default'].string,

  /** If True, Tooltip will be interactive. */
  tooltipInteractive: PropTypes__default['default'].bool,

  /** If set, will add an InfoTooltip btn on input with tooltipMessage as content. */
  tooltipMessage: PropTypes__default['default'].node,

  /** Tooltip placement */
  tooltipPlacement: PropTypes__default['default'].oneOf(['bottom-end', 'bottom-start', 'bottom', 'left-end', 'left-start', 'left', 'right-end', 'right-start', 'right', 'top-end', 'top-start', 'top']),

  /** Input value */
  value: PropTypes__default['default'].string,

  /** Input style variant. */
  variant: PropTypes__default['default'].oneOf(['background', 'underline'])
});

_defineProperty$8(GooglePlacesInput, "defaultProps", {
  className: '',
  containerClassName: '',
  disabled: false,
  dropdownClassName: '',
  error: false,
  helperText: '',
  label: '',
  onChange: null,
  optional: false,
  tooltipError: '',
  tooltipInteractive: false,
  tooltipMessage: '',
  tooltipPlacement: 'bottom',
  value: '',
  variant: 'background'
});var _templateObject$9, _templateObject2$9, _templateObject3$9, _templateObject4$9, _templateObject5$8, _templateObject6$6, _templateObject7$5, _templateObject8$5;
// Styles
// =============================

var Wrapper$6 = styled__default['default'].div(_templateObject$9 || (_templateObject$9 = _taggedTemplateLiteral$5(["\n  display: inline-block;\n  position: relative;\n"])));
var DropdownToggler = styled__default['default'].div(_templateObject2$9 || (_templateObject2$9 = _taggedTemplateLiteral$5(["\n  cursor: pointer;\n  align-items: center;\n  display: flex;\n  justify-content: flex-end;\n  width: 5rem;\n"])));
var ActiveLang = styled__default['default'].div(_templateObject3$9 || (_templateObject3$9 = _taggedTemplateLiteral$5(["\n  color: ", ";\n  font-size: 1.4rem;\n  font-weight: ", ";\n  margin-right: 1.2rem;\n  text-transform: uppercase;\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.colors.primary;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.fontWeight.semibold;
});
var Dropdown = styled__default['default'].div(_templateObject4$9 || (_templateObject4$9 = _taggedTemplateLiteral$5(["\n  background-color: ", ";\n  border-radius: 1.5rem;\n  box-shadow: 0 5px 30px 0 ", ";\n  overflow: visible;\n  padding: 2rem;\n  position: absolute;\n  right: 0;\n  top: calc(100% + 1.2rem);\n  transition: ", ";\n  transition-timing-function: ", ";\n  z-index: ", ";\n  width: 15rem;\n\n  ", ";\n"])), function (_ref3) {
  var theme = _ref3.theme;
  return theme.colors.dropdown.background;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.colors.boxShadow;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.transition.medium;
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.transitionTiming.easeInOut;
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.zIndex.dropdown;
}, function (_ref8) {
  var opened = _ref8.opened;
  return opened ? styled.css(_templateObject5$8 || (_templateObject5$8 = _taggedTemplateLiteral$5(["\n      opacity: 1;\n      transform: translate3d(0, 0, 0);\n      pointer-events: auto;\n    "]))) : styled.css(_templateObject6$6 || (_templateObject6$6 = _taggedTemplateLiteral$5(["\n      opacity: 0;\n      pointer-events: none;\n      transform: translate3d(0, -1rem, 0);\n    "])));
});
var Lang = styled__default['default'].div(_templateObject7$5 || (_templateObject7$5 = _taggedTemplateLiteral$5(["\n  align-items: center;\n  color: ", ";\n  cursor: pointer;\n  display: flex;\n  font-size: 1.4rem;\n  font-weight: ", ";\n\n  &:not(:last-child) {\n    margin-bottom: 0.5rem;\n  }\n\n  &:hover {\n    color: ", ";\n  }\n"])), function (_ref9) {
  var theme = _ref9.theme;
  return theme.colors.dropdown.text;
}, function (_ref10) {
  var theme = _ref10.theme;
  return theme.fontWeight.semibold;
}, function (_ref11) {
  var theme = _ref11.theme;
  return theme.colors.primary;
});
var LangCheckIcon = styled__default['default'](Check$1)(_templateObject8$5 || (_templateObject8$5 = _taggedTemplateLiteral$5(["\n  flex-shrink: 0;\n  margin-left: auto;\n"])));// Component
// =============================

var LangSwitcher = /*#__PURE__*/function (_PureComponent) {
  _inherits$e(LangSwitcher, _PureComponent);

  var _super = _createSuper$1(LangSwitcher);

  function LangSwitcher() {
    var _this;

    _classCallCheck$k(this, LangSwitcher);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty$8(_assertThisInitialized$1(_this), "state", {
      opened: false
    });

    _defineProperty$8(_assertThisInitialized$1(_this), "toggleDropdown", function () {
      _this.setState(function (prevState) {
        return {
          opened: !prevState.opened
        };
      });
    });

    _defineProperty$8(_assertThisInitialized$1(_this), "closeDropdown", function () {
      _this.setState({
        opened: false
      });
    });

    _defineProperty$8(_assertThisInitialized$1(_this), "pickLang", function (val) {
      var onChange = _this.props.onChange;
      onChange(val);

      _this.closeDropdown();
    });

    return _this;
  }

  _createClass$g(LangSwitcher, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          activeLang = _this$props.activeLang,
          className = _this$props.className,
          languages = _this$props.languages;
      var opened = this.state.opened;
      return /*#__PURE__*/React__default['default'].createElement(ClickAwayListener, {
        onClickAway: this.closeDropdown
      }, /*#__PURE__*/React__default['default'].createElement(Wrapper$6, {
        className: className
      }, /*#__PURE__*/React__default['default'].createElement(DropdownToggler, {
        onClick: this.toggleDropdown
      }, /*#__PURE__*/React__default['default'].createElement(ActiveLang, null, activeLang || languages[0].value), /*#__PURE__*/React__default['default'].createElement(ArrowSingle$1, {
        dir: opened ? 'north' : 'south'
      })), /*#__PURE__*/React__default['default'].createElement(Dropdown, {
        opened: opened
      }, languages.map(function (lang) {
        return /*#__PURE__*/React__default['default'].createElement(Lang, {
          onClick: function onClick() {
            return _this2.pickLang(lang.value);
          },
          key: lang.value
        }, lang.label, lang.filled && /*#__PURE__*/React__default['default'].createElement(LangCheckIcon, null));
      }))));
    }
  }]);

  return LangSwitcher;
}(React.PureComponent);

_defineProperty$8(LangSwitcher, "propTypes", {
  /** Active language */
  activeLang: PropTypes__default['default'].string,

  /** Props used by styled component to override styles. */
  className: PropTypes__default['default'].string,

  /** Array of languages available */
  languages: PropTypes__default['default'].arrayOf(PropTypes__default['default'].shape({
    filled: PropTypes__default['default'].bool.isRequired,
    label: PropTypes__default['default'].string.isRequired,
    value: PropTypes__default['default'].string.isRequired
  })).isRequired,

  /** Callback fired when the value is changed. */
  onChange: PropTypes__default['default'].func.isRequired
});

_defineProperty$8(LangSwitcher, "defaultProps", {
  activeLang: '',
  className: ''
});/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var VIEWBOX_WIDTH = 100;
var VIEWBOX_HEIGHT = 100;
var VIEWBOX_HEIGHT_HALF = 50;
var VIEWBOX_CENTER_X = 50;
var VIEWBOX_CENTER_Y = 50;

function Path(_a) {
    var className = _a.className, counterClockwise = _a.counterClockwise, dashRatio = _a.dashRatio, pathRadius = _a.pathRadius, strokeWidth = _a.strokeWidth, style = _a.style;
    return (React.createElement("path", { className: className, style: Object.assign({}, style, getDashStyle({ pathRadius: pathRadius, dashRatio: dashRatio, counterClockwise: counterClockwise })), d: getPathDescription({
            pathRadius: pathRadius,
            counterClockwise: counterClockwise,
        }), strokeWidth: strokeWidth, fillOpacity: 0 }));
}
function getPathDescription(_a) {
    var pathRadius = _a.pathRadius, counterClockwise = _a.counterClockwise;
    var radius = pathRadius;
    var rotation = counterClockwise ? 1 : 0;
    return "\n      M " + VIEWBOX_CENTER_X + "," + VIEWBOX_CENTER_Y + "\n      m 0,-" + radius + "\n      a " + radius + "," + radius + " " + rotation + " 1 1 0," + 2 * radius + "\n      a " + radius + "," + radius + " " + rotation + " 1 1 0,-" + 2 * radius + "\n    ";
}
function getDashStyle(_a) {
    var counterClockwise = _a.counterClockwise, dashRatio = _a.dashRatio, pathRadius = _a.pathRadius;
    var diameter = Math.PI * 2 * pathRadius;
    var gapLength = (1 - dashRatio) * diameter;
    return {
        strokeDasharray: diameter + "px " + diameter + "px",
        strokeDashoffset: (counterClockwise ? -gapLength : gapLength) + "px",
    };
}

var CircularProgressbar = (function (_super) {
    __extends(CircularProgressbar, _super);
    function CircularProgressbar() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CircularProgressbar.prototype.getBackgroundPadding = function () {
        if (!this.props.background) {
            return 0;
        }
        return this.props.backgroundPadding;
    };
    CircularProgressbar.prototype.getPathRadius = function () {
        return VIEWBOX_HEIGHT_HALF - this.props.strokeWidth / 2 - this.getBackgroundPadding();
    };
    CircularProgressbar.prototype.getPathRatio = function () {
        var _a = this.props, value = _a.value, minValue = _a.minValue, maxValue = _a.maxValue;
        var boundedValue = Math.min(Math.max(value, minValue), maxValue);
        return (boundedValue - minValue) / (maxValue - minValue);
    };
    CircularProgressbar.prototype.render = function () {
        var _a = this.props, circleRatio = _a.circleRatio, className = _a.className, classes = _a.classes, counterClockwise = _a.counterClockwise, styles = _a.styles, strokeWidth = _a.strokeWidth, text = _a.text;
        var pathRadius = this.getPathRadius();
        var pathRatio = this.getPathRatio();
        return (React.createElement("svg", { className: classes.root + " " + className, style: styles.root, viewBox: "0 0 " + VIEWBOX_WIDTH + " " + VIEWBOX_HEIGHT, "data-test-id": "CircularProgressbar" },
            this.props.background ? (React.createElement("circle", { className: classes.background, style: styles.background, cx: VIEWBOX_CENTER_X, cy: VIEWBOX_CENTER_Y, r: VIEWBOX_HEIGHT_HALF })) : null,
            React.createElement(Path, { className: classes.trail, counterClockwise: counterClockwise, dashRatio: circleRatio, pathRadius: pathRadius, strokeWidth: strokeWidth, style: styles.trail }),
            React.createElement(Path, { className: classes.path, counterClockwise: counterClockwise, dashRatio: pathRatio * circleRatio, pathRadius: pathRadius, strokeWidth: strokeWidth, style: styles.path }),
            text ? (React.createElement("text", { className: classes.text, style: styles.text, x: VIEWBOX_CENTER_X, y: VIEWBOX_CENTER_Y }, text)) : null));
    };
    CircularProgressbar.defaultProps = {
        background: false,
        backgroundPadding: 0,
        circleRatio: 1,
        classes: {
            root: 'CircularProgressbar',
            trail: 'CircularProgressbar-trail',
            path: 'CircularProgressbar-path',
            text: 'CircularProgressbar-text',
            background: 'CircularProgressbar-background',
        },
        counterClockwise: false,
        className: '',
        maxValue: 100,
        minValue: 0,
        strokeWidth: 8,
        styles: {
            root: {},
            trail: {},
            path: {},
            text: {},
            background: {},
        },
        text: '',
    };
    return CircularProgressbar;
}(React.Component));var _templateObject$8, _templateObject2$8, _templateObject3$8, _templateObject4$8, _templateObject5$7, _templateObject6$5, _templateObject7$4, _templateObject8$4;
// Styles
// =============================

var animation = styled.keyframes(_templateObject$8 || (_templateObject$8 = _taggedTemplateLiteral$5(["\n  from {\n    transform: translate3d(-100%, 0, 0);\n  }\n  to {\n    transform: translate3d(100vw, 0, 0);\n  }\n"])));
var Wrapper$5 = styled__default['default'].div(_templateObject2$8 || (_templateObject2$8 = _taggedTemplateLiteral$5(["\n  animation: ", " ", "\n    cubic-bezier(0.23, 0.82, 0.6, 0.32) infinite;\n  background-color: ", ";\n  height: 0.3rem;\n  position: fixed;\n  width: 30vw;\n  z-index: ", ";\n"])), animation, function (_ref) {
  var theme = _ref.theme;
  return theme.transition.slow;
}, function (_ref2) {
  var color = _ref2.color,
      theme = _ref2.theme;
  return color || theme.colors.primary;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.zIndex.loader;
});
var backgroundAnimation = styled.keyframes(_templateObject3$8 || (_templateObject3$8 = _taggedTemplateLiteral$5(["\n  from {\n    opacity: 1;\n  }\n\n  to {\n    opacity: 0;\n  }\n"])));
/**
 * NOTE: This is only used in Admin-v2 for init loader,
 * thus the white background
 * */

var Background = styled__default['default'].div(_templateObject4$8 || (_templateObject4$8 = _taggedTemplateLiteral$5(["\n  align-items: center;\n  animation-fill-mode: forwards;\n  background-color: ", ";\n  bottom: 0;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  left: 0;\n  position: fixed;\n  right: 0;\n  top: 0;\n  z-index: ", ";\n\n  ", ";\n"])), function (_ref4) {
  var theme = _ref4.theme;
  return theme.colors.white;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.zIndex.initLoader;
}, function (_ref6) {
  var theme = _ref6.theme,
      ready = _ref6.ready;
  return ready && styled.css(_templateObject5$7 || (_templateObject5$7 = _taggedTemplateLiteral$5(["\n      animation: ", " 500ms ", " 1;\n    "])), backgroundAnimation, theme.transitionTiming.easeInOut);
});
/**
 * NOTE: This is only used in Admin-v2 for init loader,
 * thus the fixed hex colors.
 * */

var CircleProgressbar = styled__default['default'](CircularProgressbar)(_templateObject6$5 || (_templateObject6$5 = _taggedTemplateLiteral$5(["\n  && {\n    margin-bottom: 0.8rem;\n    width: 8rem;\n\n    .CircularProgressbar-path {\n      stroke: ", ";\n      stroke-linecap: round;\n      transition: stroke-dashoffset 0.5s ease 0s;\n    }\n\n    .CircularProgressbar-trail {\n      stroke: #b2b2b2;\n    }\n  }\n"])), function (_ref7) {
  var theme = _ref7.theme;
  return theme.colors.primary;
});
var CircularContainer = styled__default['default'].div(_templateObject7$4 || (_templateObject7$4 = _taggedTemplateLiteral$5(["\n  align-items: center;\n  display: flex;\n  flex-direction: column;\n"])));
var CircularText = styled__default['default'].div(_templateObject8$4 || (_templateObject8$4 = _taggedTemplateLiteral$5(["\n  color: ", ";\n  font-size: 1.2rem;\n  font-weight: ", ";\n"])), function (_ref8) {
  var theme = _ref8.theme;
  return theme.colors.primary;
}, function (_ref9) {
  var theme = _ref9.theme;
  return theme.fontWeight.bold;
});// =============================
// Component
// =============================

var Loader = /*#__PURE__*/React__default['default'].memo(function (_ref) {
  var active = _ref.active,
      color = _ref.color,
      percentage = _ref.percentage,
      ready = _ref.ready,
      type = _ref.type;

  if (type === 'global') {
    if (active) return /*#__PURE__*/React__default['default'].createElement(Wrapper$5, {
      color: color
    });
    return null;
  }

  if (type === 'circular') {
    if (active) {
      return /*#__PURE__*/React__default['default'].createElement(CircularContainer, null, /*#__PURE__*/React__default['default'].createElement(CircleProgressbar, {
        strokeWidth: 2,
        value: percentage
      }), /*#__PURE__*/React__default['default'].createElement(CircularText, null, "".concat(percentage, "%")));
    }

    return null;
  }

  return /*#__PURE__*/React__default['default'].createElement(Background, {
    ready: ready
  }, /*#__PURE__*/React__default['default'].createElement(LgApp$1, {
    width: "40rem"
  }));
});
Loader.propTypes = {
  /** If true, loader is active. */
  active: PropTypes__default['default'].bool,

  /** Loader color. */
  color: PropTypes__default['default'].string,

  /** Loading percentage. */
  percentage: PropTypes__default['default'].number,

  /** If type is Init, and Ready is true, Loader will fade out. */
  ready: PropTypes__default['default'].bool,

  /** Init render Initial Loader while Global render the loader on top of the window. */
  type: PropTypes__default['default'].oneOf(['init', 'global', 'circular'])
};
Loader.defaultProps = {
  active: false,
  color: '',
  percentage: 0,
  ready: false,
  type: 'global'
};var reactClipboard = {exports: {}};var clipboard = {exports: {}};/*!
 * clipboard.js v2.0.8
 * https://clipboardjs.com/
 *
 * Licensed MIT © Zeno Rocha
 */

(function (module, exports) {
(function webpackUniversalModuleDefinition(root, factory) {
	module.exports = factory();
})(commonjsGlobal, function() {
return /******/ (function() { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ 134:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ clipboard; }
});

// EXTERNAL MODULE: ./node_modules/tiny-emitter/index.js
var tiny_emitter = __webpack_require__(279);
var tiny_emitter_default = /*#__PURE__*/__webpack_require__.n(tiny_emitter);
// EXTERNAL MODULE: ./node_modules/good-listener/src/listen.js
var listen = __webpack_require__(370);
var listen_default = /*#__PURE__*/__webpack_require__.n(listen);
// EXTERNAL MODULE: ./node_modules/select/src/select.js
var src_select = __webpack_require__(817);
var select_default = /*#__PURE__*/__webpack_require__.n(src_select);
function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }


/**
 * Inner class which performs selection from either `text` or `target`
 * properties and then executes copy or cut operations.
 */

var ClipboardAction = /*#__PURE__*/function () {
  /**
   * @param {Object} options
   */
  function ClipboardAction(options) {
    _classCallCheck(this, ClipboardAction);

    this.resolveOptions(options);
    this.initSelection();
  }
  /**
   * Defines base properties passed from constructor.
   * @param {Object} options
   */


  _createClass(ClipboardAction, [{
    key: "resolveOptions",
    value: function resolveOptions() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      this.action = options.action;
      this.container = options.container;
      this.emitter = options.emitter;
      this.target = options.target;
      this.text = options.text;
      this.trigger = options.trigger;
      this.selectedText = '';
    }
    /**
     * Decides which selection strategy is going to be applied based
     * on the existence of `text` and `target` properties.
     */

  }, {
    key: "initSelection",
    value: function initSelection() {
      if (this.text) {
        this.selectFake();
      } else if (this.target) {
        this.selectTarget();
      }
    }
    /**
     * Creates a fake textarea element, sets its value from `text` property,
     */

  }, {
    key: "createFakeElement",
    value: function createFakeElement() {
      var isRTL = document.documentElement.getAttribute('dir') === 'rtl';
      this.fakeElem = document.createElement('textarea'); // Prevent zooming on iOS

      this.fakeElem.style.fontSize = '12pt'; // Reset box model

      this.fakeElem.style.border = '0';
      this.fakeElem.style.padding = '0';
      this.fakeElem.style.margin = '0'; // Move element out of screen horizontally

      this.fakeElem.style.position = 'absolute';
      this.fakeElem.style[isRTL ? 'right' : 'left'] = '-9999px'; // Move element to the same position vertically

      var yPosition = window.pageYOffset || document.documentElement.scrollTop;
      this.fakeElem.style.top = "".concat(yPosition, "px");
      this.fakeElem.setAttribute('readonly', '');
      this.fakeElem.value = this.text;
      return this.fakeElem;
    }
    /**
     * Get's the value of fakeElem,
     * and makes a selection on it.
     */

  }, {
    key: "selectFake",
    value: function selectFake() {
      var _this = this;

      var fakeElem = this.createFakeElement();

      this.fakeHandlerCallback = function () {
        return _this.removeFake();
      };

      this.fakeHandler = this.container.addEventListener('click', this.fakeHandlerCallback) || true;
      this.container.appendChild(fakeElem);
      this.selectedText = select_default()(fakeElem);
      this.copyText();
      this.removeFake();
    }
    /**
     * Only removes the fake element after another click event, that way
     * a user can hit `Ctrl+C` to copy because selection still exists.
     */

  }, {
    key: "removeFake",
    value: function removeFake() {
      if (this.fakeHandler) {
        this.container.removeEventListener('click', this.fakeHandlerCallback);
        this.fakeHandler = null;
        this.fakeHandlerCallback = null;
      }

      if (this.fakeElem) {
        this.container.removeChild(this.fakeElem);
        this.fakeElem = null;
      }
    }
    /**
     * Selects the content from element passed on `target` property.
     */

  }, {
    key: "selectTarget",
    value: function selectTarget() {
      this.selectedText = select_default()(this.target);
      this.copyText();
    }
    /**
     * Executes the copy operation based on the current selection.
     */

  }, {
    key: "copyText",
    value: function copyText() {
      var succeeded;

      try {
        succeeded = document.execCommand(this.action);
      } catch (err) {
        succeeded = false;
      }

      this.handleResult(succeeded);
    }
    /**
     * Fires an event based on the copy operation result.
     * @param {Boolean} succeeded
     */

  }, {
    key: "handleResult",
    value: function handleResult(succeeded) {
      this.emitter.emit(succeeded ? 'success' : 'error', {
        action: this.action,
        text: this.selectedText,
        trigger: this.trigger,
        clearSelection: this.clearSelection.bind(this)
      });
    }
    /**
     * Moves focus away from `target` and back to the trigger, removes current selection.
     */

  }, {
    key: "clearSelection",
    value: function clearSelection() {
      if (this.trigger) {
        this.trigger.focus();
      }

      document.activeElement.blur();
      window.getSelection().removeAllRanges();
    }
    /**
     * Sets the `action` to be performed which can be either 'copy' or 'cut'.
     * @param {String} action
     */

  }, {
    key: "destroy",

    /**
     * Destroy lifecycle.
     */
    value: function destroy() {
      this.removeFake();
    }
  }, {
    key: "action",
    set: function set() {
      var action = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'copy';
      this._action = action;

      if (this._action !== 'copy' && this._action !== 'cut') {
        throw new Error('Invalid "action" value, use either "copy" or "cut"');
      }
    }
    /**
     * Gets the `action` property.
     * @return {String}
     */
    ,
    get: function get() {
      return this._action;
    }
    /**
     * Sets the `target` property using an element
     * that will be have its content copied.
     * @param {Element} target
     */

  }, {
    key: "target",
    set: function set(target) {
      if (target !== undefined) {
        if (target && _typeof(target) === 'object' && target.nodeType === 1) {
          if (this.action === 'copy' && target.hasAttribute('disabled')) {
            throw new Error('Invalid "target" attribute. Please use "readonly" instead of "disabled" attribute');
          }

          if (this.action === 'cut' && (target.hasAttribute('readonly') || target.hasAttribute('disabled'))) {
            throw new Error('Invalid "target" attribute. You can\'t cut text from elements with "readonly" or "disabled" attributes');
          }

          this._target = target;
        } else {
          throw new Error('Invalid "target" value, use a valid Element');
        }
      }
    }
    /**
     * Gets the `target` property.
     * @return {String|HTMLElement}
     */
    ,
    get: function get() {
      return this._target;
    }
  }]);

  return ClipboardAction;
}();

/* harmony default export */ var clipboard_action = (ClipboardAction);
function clipboard_typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { clipboard_typeof = function _typeof(obj) { return typeof obj; }; } else { clipboard_typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return clipboard_typeof(obj); }

function clipboard_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function clipboard_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function clipboard_createClass(Constructor, protoProps, staticProps) { if (protoProps) clipboard_defineProperties(Constructor.prototype, protoProps); if (staticProps) clipboard_defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (clipboard_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }




/**
 * Helper function to retrieve attribute value.
 * @param {String} suffix
 * @param {Element} element
 */

function getAttributeValue(suffix, element) {
  var attribute = "data-clipboard-".concat(suffix);

  if (!element.hasAttribute(attribute)) {
    return;
  }

  return element.getAttribute(attribute);
}
/**
 * Base class which takes one or more elements, adds event listeners to them,
 * and instantiates a new `ClipboardAction` on each click.
 */


var Clipboard = /*#__PURE__*/function (_Emitter) {
  _inherits(Clipboard, _Emitter);

  var _super = _createSuper(Clipboard);

  /**
   * @param {String|HTMLElement|HTMLCollection|NodeList} trigger
   * @param {Object} options
   */
  function Clipboard(trigger, options) {
    var _this;

    clipboard_classCallCheck(this, Clipboard);

    _this = _super.call(this);

    _this.resolveOptions(options);

    _this.listenClick(trigger);

    return _this;
  }
  /**
   * Defines if attributes would be resolved using internal setter functions
   * or custom functions that were passed in the constructor.
   * @param {Object} options
   */


  clipboard_createClass(Clipboard, [{
    key: "resolveOptions",
    value: function resolveOptions() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      this.action = typeof options.action === 'function' ? options.action : this.defaultAction;
      this.target = typeof options.target === 'function' ? options.target : this.defaultTarget;
      this.text = typeof options.text === 'function' ? options.text : this.defaultText;
      this.container = clipboard_typeof(options.container) === 'object' ? options.container : document.body;
    }
    /**
     * Adds a click event listener to the passed trigger.
     * @param {String|HTMLElement|HTMLCollection|NodeList} trigger
     */

  }, {
    key: "listenClick",
    value: function listenClick(trigger) {
      var _this2 = this;

      this.listener = listen_default()(trigger, 'click', function (e) {
        return _this2.onClick(e);
      });
    }
    /**
     * Defines a new `ClipboardAction` on each click event.
     * @param {Event} e
     */

  }, {
    key: "onClick",
    value: function onClick(e) {
      var trigger = e.delegateTarget || e.currentTarget;

      if (this.clipboardAction) {
        this.clipboardAction = null;
      }

      this.clipboardAction = new clipboard_action({
        action: this.action(trigger),
        target: this.target(trigger),
        text: this.text(trigger),
        container: this.container,
        trigger: trigger,
        emitter: this
      });
    }
    /**
     * Default `action` lookup function.
     * @param {Element} trigger
     */

  }, {
    key: "defaultAction",
    value: function defaultAction(trigger) {
      return getAttributeValue('action', trigger);
    }
    /**
     * Default `target` lookup function.
     * @param {Element} trigger
     */

  }, {
    key: "defaultTarget",
    value: function defaultTarget(trigger) {
      var selector = getAttributeValue('target', trigger);

      if (selector) {
        return document.querySelector(selector);
      }
    }
    /**
     * Returns the support of the given action, or all actions if no action is
     * given.
     * @param {String} [action]
     */

  }, {
    key: "defaultText",

    /**
     * Default `text` lookup function.
     * @param {Element} trigger
     */
    value: function defaultText(trigger) {
      return getAttributeValue('text', trigger);
    }
    /**
     * Destroy lifecycle.
     */

  }, {
    key: "destroy",
    value: function destroy() {
      this.listener.destroy();

      if (this.clipboardAction) {
        this.clipboardAction.destroy();
        this.clipboardAction = null;
      }
    }
  }], [{
    key: "isSupported",
    value: function isSupported() {
      var action = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ['copy', 'cut'];
      var actions = typeof action === 'string' ? [action] : action;
      var support = !!document.queryCommandSupported;
      actions.forEach(function (action) {
        support = support && !!document.queryCommandSupported(action);
      });
      return support;
    }
  }]);

  return Clipboard;
}((tiny_emitter_default()));

/* harmony default export */ var clipboard = (Clipboard);

/***/ }),

/***/ 828:
/***/ (function(module) {

var DOCUMENT_NODE_TYPE = 9;

/**
 * A polyfill for Element.matches()
 */
if (typeof Element !== 'undefined' && !Element.prototype.matches) {
    var proto = Element.prototype;

    proto.matches = proto.matchesSelector ||
                    proto.mozMatchesSelector ||
                    proto.msMatchesSelector ||
                    proto.oMatchesSelector ||
                    proto.webkitMatchesSelector;
}

/**
 * Finds the closest parent that matches a selector.
 *
 * @param {Element} element
 * @param {String} selector
 * @return {Function}
 */
function closest (element, selector) {
    while (element && element.nodeType !== DOCUMENT_NODE_TYPE) {
        if (typeof element.matches === 'function' &&
            element.matches(selector)) {
          return element;
        }
        element = element.parentNode;
    }
}

module.exports = closest;


/***/ }),

/***/ 438:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var closest = __webpack_require__(828);

/**
 * Delegates event to a selector.
 *
 * @param {Element} element
 * @param {String} selector
 * @param {String} type
 * @param {Function} callback
 * @param {Boolean} useCapture
 * @return {Object}
 */
function _delegate(element, selector, type, callback, useCapture) {
    var listenerFn = listener.apply(this, arguments);

    element.addEventListener(type, listenerFn, useCapture);

    return {
        destroy: function() {
            element.removeEventListener(type, listenerFn, useCapture);
        }
    }
}

/**
 * Delegates event to a selector.
 *
 * @param {Element|String|Array} [elements]
 * @param {String} selector
 * @param {String} type
 * @param {Function} callback
 * @param {Boolean} useCapture
 * @return {Object}
 */
function delegate(elements, selector, type, callback, useCapture) {
    // Handle the regular Element usage
    if (typeof elements.addEventListener === 'function') {
        return _delegate.apply(null, arguments);
    }

    // Handle Element-less usage, it defaults to global delegation
    if (typeof type === 'function') {
        // Use `document` as the first parameter, then apply arguments
        // This is a short way to .unshift `arguments` without running into deoptimizations
        return _delegate.bind(null, document).apply(null, arguments);
    }

    // Handle Selector-based usage
    if (typeof elements === 'string') {
        elements = document.querySelectorAll(elements);
    }

    // Handle Array-like based usage
    return Array.prototype.map.call(elements, function (element) {
        return _delegate(element, selector, type, callback, useCapture);
    });
}

/**
 * Finds closest match and invokes callback.
 *
 * @param {Element} element
 * @param {String} selector
 * @param {String} type
 * @param {Function} callback
 * @return {Function}
 */
function listener(element, selector, type, callback) {
    return function(e) {
        e.delegateTarget = closest(e.target, selector);

        if (e.delegateTarget) {
            callback.call(element, e);
        }
    }
}

module.exports = delegate;


/***/ }),

/***/ 879:
/***/ (function(__unused_webpack_module, exports) {

/**
 * Check if argument is a HTML element.
 *
 * @param {Object} value
 * @return {Boolean}
 */
exports.node = function(value) {
    return value !== undefined
        && value instanceof HTMLElement
        && value.nodeType === 1;
};

/**
 * Check if argument is a list of HTML elements.
 *
 * @param {Object} value
 * @return {Boolean}
 */
exports.nodeList = function(value) {
    var type = Object.prototype.toString.call(value);

    return value !== undefined
        && (type === '[object NodeList]' || type === '[object HTMLCollection]')
        && ('length' in value)
        && (value.length === 0 || exports.node(value[0]));
};

/**
 * Check if argument is a string.
 *
 * @param {Object} value
 * @return {Boolean}
 */
exports.string = function(value) {
    return typeof value === 'string'
        || value instanceof String;
};

/**
 * Check if argument is a function.
 *
 * @param {Object} value
 * @return {Boolean}
 */
exports.fn = function(value) {
    var type = Object.prototype.toString.call(value);

    return type === '[object Function]';
};


/***/ }),

/***/ 370:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var is = __webpack_require__(879);
var delegate = __webpack_require__(438);

/**
 * Validates all params and calls the right
 * listener function based on its target type.
 *
 * @param {String|HTMLElement|HTMLCollection|NodeList} target
 * @param {String} type
 * @param {Function} callback
 * @return {Object}
 */
function listen(target, type, callback) {
    if (!target && !type && !callback) {
        throw new Error('Missing required arguments');
    }

    if (!is.string(type)) {
        throw new TypeError('Second argument must be a String');
    }

    if (!is.fn(callback)) {
        throw new TypeError('Third argument must be a Function');
    }

    if (is.node(target)) {
        return listenNode(target, type, callback);
    }
    else if (is.nodeList(target)) {
        return listenNodeList(target, type, callback);
    }
    else if (is.string(target)) {
        return listenSelector(target, type, callback);
    }
    else {
        throw new TypeError('First argument must be a String, HTMLElement, HTMLCollection, or NodeList');
    }
}

/**
 * Adds an event listener to a HTML element
 * and returns a remove listener function.
 *
 * @param {HTMLElement} node
 * @param {String} type
 * @param {Function} callback
 * @return {Object}
 */
function listenNode(node, type, callback) {
    node.addEventListener(type, callback);

    return {
        destroy: function() {
            node.removeEventListener(type, callback);
        }
    }
}

/**
 * Add an event listener to a list of HTML elements
 * and returns a remove listener function.
 *
 * @param {NodeList|HTMLCollection} nodeList
 * @param {String} type
 * @param {Function} callback
 * @return {Object}
 */
function listenNodeList(nodeList, type, callback) {
    Array.prototype.forEach.call(nodeList, function(node) {
        node.addEventListener(type, callback);
    });

    return {
        destroy: function() {
            Array.prototype.forEach.call(nodeList, function(node) {
                node.removeEventListener(type, callback);
            });
        }
    }
}

/**
 * Add an event listener to a selector
 * and returns a remove listener function.
 *
 * @param {String} selector
 * @param {String} type
 * @param {Function} callback
 * @return {Object}
 */
function listenSelector(selector, type, callback) {
    return delegate(document.body, selector, type, callback);
}

module.exports = listen;


/***/ }),

/***/ 817:
/***/ (function(module) {

function select(element) {
    var selectedText;

    if (element.nodeName === 'SELECT') {
        element.focus();

        selectedText = element.value;
    }
    else if (element.nodeName === 'INPUT' || element.nodeName === 'TEXTAREA') {
        var isReadOnly = element.hasAttribute('readonly');

        if (!isReadOnly) {
            element.setAttribute('readonly', '');
        }

        element.select();
        element.setSelectionRange(0, element.value.length);

        if (!isReadOnly) {
            element.removeAttribute('readonly');
        }

        selectedText = element.value;
    }
    else {
        if (element.hasAttribute('contenteditable')) {
            element.focus();
        }

        var selection = window.getSelection();
        var range = document.createRange();

        range.selectNodeContents(element);
        selection.removeAllRanges();
        selection.addRange(range);

        selectedText = selection.toString();
    }

    return selectedText;
}

module.exports = select;


/***/ }),

/***/ 279:
/***/ (function(module) {

function E () {
  // Keep this empty so it's easier to inherit from
  // (via https://github.com/lipsmack from https://github.com/scottcorgan/tiny-emitter/issues/3)
}

E.prototype = {
  on: function (name, callback, ctx) {
    var e = this.e || (this.e = {});

    (e[name] || (e[name] = [])).push({
      fn: callback,
      ctx: ctx
    });

    return this;
  },

  once: function (name, callback, ctx) {
    var self = this;
    function listener () {
      self.off(name, listener);
      callback.apply(ctx, arguments);
    }
    listener._ = callback;
    return this.on(name, listener, ctx);
  },

  emit: function (name) {
    var data = [].slice.call(arguments, 1);
    var evtArr = ((this.e || (this.e = {}))[name] || []).slice();
    var i = 0;
    var len = evtArr.length;

    for (i; i < len; i++) {
      evtArr[i].fn.apply(evtArr[i].ctx, data);
    }

    return this;
  },

  off: function (name, callback) {
    var e = this.e || (this.e = {});
    var evts = e[name];
    var liveEvents = [];

    if (evts && callback) {
      for (var i = 0, len = evts.length; i < len; i++) {
        if (evts[i].fn !== callback && evts[i].fn._ !== callback)
          liveEvents.push(evts[i]);
      }
    }

    // Remove event from queue to prevent memory leak
    // Suggested by https://github.com/lazd
    // Ref: https://github.com/scottcorgan/tiny-emitter/commit/c6ebfaa9bc973b33d110a84a307742b7cf94c953#commitcomment-5024910

    (liveEvents.length)
      ? e[name] = liveEvents
      : delete e[name];

    return this;
  }
};

module.exports = E;
module.exports.TinyEmitter = E;


/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		if(__webpack_module_cache__[moduleId]) {
/******/ 			return __webpack_module_cache__[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	!function() {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = function(module) {
/******/ 			var getter = module && module.__esModule ?
/******/ 				function() { return module['default']; } :
/******/ 				function() { return module; };
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	!function() {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = function(exports, definition) {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	!function() {
/******/ 		__webpack_require__.o = function(obj, prop) { return Object.prototype.hasOwnProperty.call(obj, prop); };
/******/ 	}();
/******/ 	
/************************************************************************/
/******/ 	// module exports must be returned from runtime so entry inlining is disabled
/******/ 	// startup
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(134);
/******/ })()
.default;
});
}(clipboard));(function (module, exports) {
(function webpackUniversalModuleDefinition(root, factory) {
	module.exports = factory(clipboard.exports, PropTypes__default['default'], React__default['default'], ReactDOM__default['default']);
})(commonjsGlobal, function(__WEBPACK_EXTERNAL_MODULE_clipboard__, __WEBPACK_EXTERNAL_MODULE_prop_types__, __WEBPACK_EXTERNAL_MODULE_react__, __WEBPACK_EXTERNAL_MODULE_react_dom__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = "./index.js");
/******/ })
/************************************************************************/
/******/ ({

/***/ "./index.js":
/*!******************!*\
  !*** ./index.js ***!
  \******************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_dom__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! react-dom */ "react-dom");
/* harmony import */ var react_dom__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react_dom__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! prop-types */ "prop-types");
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_2__);
function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }





var ClipboardButton =
/*#__PURE__*/
function (_React$Component) {
  _inherits(ClipboardButton, _React$Component);

  function ClipboardButton() {
    _classCallCheck(this, ClipboardButton);

    return _possibleConstructorReturn(this, _getPrototypeOf(ClipboardButton).apply(this, arguments));
  }

  _createClass(ClipboardButton, [{
    key: "propsWith",
    value: function propsWith(regexp) {
      var remove = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var object = {};
      Object.keys(this.props).forEach(function (key) {
        if (key.search(regexp) !== -1) {
          var objectKey = remove ? key.replace(regexp, '') : key;
          object[objectKey] = this.props[key];
        }
      }, this);
      return object;
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.clipboard && this.clipboard.destroy();
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      // Support old API by trying to assign this.props.options first;
      var options = this.props.options || this.propsWith(/^option-/, true);
      var element = react_dom__WEBPACK_IMPORTED_MODULE_1___default.a.findDOMNode(this.element);

      if (!element) {
        return;
      }

      var Clipboard = __webpack_require__(/*! clipboard */ "clipboard");

      this.clipboard = new Clipboard(element, options);
      var callbacks = this.propsWith(/^on/, true);
      Object.keys(callbacks).forEach(function (callback) {
        this.clipboard.on(callback.toLowerCase(), this.props['on' + callback]);
      }, this);
    }
  }, {
    key: "render",
    value: function render() {
      var _this = this;

      var attributes = _objectSpread({
        title: this.props.title || '',
        type: this.getType(),
        className: this.props.className || '',
        style: this.props.style || {},
        ref: function ref(element) {
          return _this.element = element;
        },
        onClick: this.props.onClick
      }, this.propsWith(/^data-/), this.propsWith(/^button-/, true));

      var Clipboard = __webpack_require__(/*! clipboard */ "clipboard");

      if (!this.props.isVisibleWhenUnsupported && !Clipboard.isSupported()) {
        return null;
      }

      return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(this.getComponent(), attributes, this.props.children);
    }
  }, {
    key: "getType",
    value: function getType() {
      if (this.getComponent() === 'button' || this.getComponent() === 'input') {
        return this.props.type || 'button';
      } else {
        return undefined;
      }
    }
  }, {
    key: "getComponent",
    value: function getComponent() {
      return this.props.component || 'button';
    }
  }]);

  return ClipboardButton;
}(react__WEBPACK_IMPORTED_MODULE_0___default.a.Component);

_defineProperty(ClipboardButton, "propTypes", {
  options: function options(props, propName, componentName) {
    var options = props[propName];

    if (options && _typeof(options) !== 'object' || Array.isArray(options)) {
      return new Error("Invalid props '".concat(propName, "' supplied to '").concat(componentName, "'. ") + "'".concat(propName, "' is not an object."));
    }

    if (props['option-text'] !== undefined) {
      var optionText = props['option-text'];

      if (typeof optionText !== 'function') {
        return new Error("Invalid props 'option-text' supplied to '".concat(componentName, "'. ") + "'option-text' is not a function.");
      }
    }
  },
  title: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.string,
  type: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.string,
  className: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.string,
  style: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.object,
  component: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.any,
  children: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.any
});

_defineProperty(ClipboardButton, "defaultProps", {
  isVisibleWhenUnsupported: true,
  onClick: function onClick() {}
  /* Returns a object with all props that fulfill a certain naming pattern
   *
   * @param {RegExp} regexp - Regular expression representing which pattern
   *                          you'll be searching for.
   * @param {Boolean} remove - Determines if the regular expression should be
   *                           removed when transmitting the key from the props
   *                           to the new object.
   *
   * e.g:
   *
   * // Considering:
   * // this.props = {option-foo: 1, onBar: 2, data-foobar: 3 data-baz: 4};
   *
   * // *RegExps not using // so that this comment doesn't break up
   * this.propsWith(option-*, true); // returns {foo: 1}
   * this.propsWith(on*, true); // returns {Bar: 2}
   * this.propsWith(data-*); // returns {data-foobar: 1, data-baz: 4}
   */

});

/* harmony default export */ __webpack_exports__["default"] = (ClipboardButton);

/***/ }),

/***/ "clipboard":
/*!********************************************************************************************************!*\
  !*** external {"root":"ClipboardJS","amd":"clipboard","commonjs":"clipboard","commonjs2":"clipboard"} ***!
  \********************************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_clipboard__;

/***/ }),

/***/ "prop-types":
/*!*********************************************************************************************************!*\
  !*** external {"root":"PropTypes","amd":"prop-types","commonjs":"prop-types","commonjs2":"prop-types"} ***!
  \*********************************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_prop_types__;

/***/ }),

/***/ "react":
/*!**************************************************************************************!*\
  !*** external {"root":"React","amd":"react","commonjs":"react","commonjs2":"react"} ***!
  \**************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_react__;

/***/ }),

/***/ "react-dom":
/*!*****************************************************************************************************!*\
  !*** external {"root":"ReactDOM","amd":"react-dom","commonjs":"react-dom","commonjs2":"react-dom"} ***!
  \*****************************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_react_dom__;

/***/ })

/******/ });
});

}(reactClipboard));

var Clipboard = /*@__PURE__*/getDefaultExportFromCjs(reactClipboard.exports);var _templateObject$7, _templateObject2$7, _templateObject3$7, _templateObject4$7, _templateObject5$6, _templateObject6$4, _templateObject7$3, _templateObject8$3, _templateObject9$2, _templateObject10$2, _templateObject11$2;
// Styles
// =============================

var fadeIn = styled.keyframes(_templateObject$7 || (_templateObject$7 = _taggedTemplateLiteral$5(["\n  from {\n    opacity: 0;\n    transform: translate3d(-3rem, 0, 0);\n  }\n\n  to {\n    opacity: 1;\n    transform: translate3d(0, 0, 0);\n  }\n"])));
var Wrapper$4 = styled__default['default'].div(_templateObject2$7 || (_templateObject2$7 = _taggedTemplateLiteral$5(["\n  align-items: center;\n  animation: ", " ", "\n    ", " 1;\n  background-color: ", ";\n  color: ", ";\n  border-radius: 1.5rem;\n  box-shadow: 0 0.2rem 2rem 0 ", ";\n  display: flex;\n  font-family: ", ";\n  font-size: 1.2rem;\n  font-weight: ", ";\n  line-height: 1.5rem;\n  margin-top: 1rem;\n  min-height: 7rem;\n  padding: 2rem;\n  text-align: left;\n  width: 100%;\n\n  ", ";\n"])), fadeIn, function (_ref) {
  var theme = _ref.theme;
  return theme.transition.medium;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.transitionTiming.easeInOut;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.colors.notification.background;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.colors.notification.text;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.colors.notification.boxShadow;
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.fontFamily.primary;
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.fontWeight.semibold;
}, function (_ref8) {
  var theme = _ref8.theme;
  return theme.mediaAbove.minWidth(_templateObject3$7 || (_templateObject3$7 = _taggedTemplateLiteral$5(["\n    width: 37rem;\n  "])));
});
var Type = styled__default['default'].div(_templateObject4$7 || (_templateObject4$7 = _taggedTemplateLiteral$5(["\n  border-radius: 50%;\n  border: 0.1rem solid ", ";\n  flex-shrink: 0;\n  height: 1rem;\n  margin-right: 2rem;\n  width: 1rem;\n\n  ", ";\n\n  svg {\n    height: 2.5rem;\n  }\n"])), function (_ref9) {
  var theme = _ref9.theme,
      type = _ref9.type;
  return lighten(theme.colors.type[type], 0.7);
}, function (_ref10) {
  var theme = _ref10.theme,
      type = _ref10.type;
  return type && styled.css(_templateObject5$6 || (_templateObject5$6 = _taggedTemplateLiteral$5(["\n      background-color: ", ";\n    "])), theme.colors.type[type]);
});
var ReqId = styled__default['default'].div(_templateObject6$4 || (_templateObject6$4 = _taggedTemplateLiteral$5(["\n  align-items: center;\n  color: ", ";\n  cursor: pointer;\n  display: flex;\n  font-size: 1rem;\n  margin-top: 0.2rem;\n  transition: opacity ", ";\n\n  &:hover {\n    opacity: 0.7;\n  }\n"])), function (_ref11) {
  var theme = _ref11.theme;
  return alpha$2(theme.colors.notification.text, 0.8);
}, function (_ref12) {
  var theme = _ref12.theme;
  return theme.transition.medium;
});
var CloseButton = styled__default['default'].div(_templateObject7$3 || (_templateObject7$3 = _taggedTemplateLiteral$5(["\n  align-items: center;\n  cursor: pointer;\n  display: flex;\n  flex-shrink: 0;\n  justify-content: center;\n  margin-bottom: auto;\n  margin-left: auto;\n  padding: 1.2rem;\n  padding-top: 0;\n  transform: translate3d(1.2rem, 0, 0);\n\n  &:hover {\n    opacity: 0.7;\n  }\n"])));
var StyledClose = styled__default['default'](Close$1).attrs(function (_ref13) {
  var theme = _ref13.theme;
  return {
    fill: theme.colors.notification.text,
    width: '1rem'
  };
})(_templateObject8$3 || (_templateObject8$3 = _taggedTemplateLiteral$5([""])));
var ClipboardIcon = styled__default['default'](Clipboard$2).attrs(function (_ref14) {
  var theme = _ref14.theme;
  return {
    fill: alpha$2(theme.colors.notification.text, 0.8),
    width: '2.5rem'
  };
})(_templateObject9$2 || (_templateObject9$2 = _taggedTemplateLiteral$5([""])));
var Group = styled__default['default'].div(_templateObject10$2 || (_templateObject10$2 = _taggedTemplateLiteral$5(["\n  font-size: 1.2rem;\n"])));
var Message = styled__default['default'].span(_templateObject11$2 || (_templateObject11$2 = _taggedTemplateLiteral$5(["\n  font-weight: ", ";\n"])), function (_ref15) {
  var theme = _ref15.theme;
  return theme.fontWeight.semibold;
});// =============================
// Component
// =============================

var Notification = /*#__PURE__*/React__default['default'].memo(function (_ref) {
  var children = _ref.children,
      className = _ref.className,
      reqId = _ref.reqId,
      lang = _ref.lang,
      onClick = _ref.onClick,
      type = _ref.type;
  return /*#__PURE__*/React__default['default'].createElement(Wrapper$4, {
    className: className,
    onClick: onClick
  }, /*#__PURE__*/React__default['default'].createElement(Type, {
    type: type
  }), /*#__PURE__*/React__default['default'].createElement("div", null, /*#__PURE__*/React__default['default'].createElement(Group, null, /*#__PURE__*/React__default['default'].createElement(Message, null, children)), reqId && /*#__PURE__*/React__default['default'].createElement(Clipboard, {
    component: "div",
    "data-clipboard-text": reqId
  }, /*#__PURE__*/React__default['default'].createElement(ReqId, {
    onClick: function onClick(e) {
      e.stopPropagation();
    }
  }, lang.reqId, ":\xA0", reqId, /*#__PURE__*/React__default['default'].createElement(ClipboardIcon, null)))), onClick && /*#__PURE__*/React__default['default'].createElement(CloseButton, null, /*#__PURE__*/React__default['default'].createElement(StyledClose, null)));
});
Notification.propTypes = {
  /** Pass notification's content */
  children: PropTypes__default['default'].node.isRequired,

  /** Props used by styled component to override styles. */
  className: PropTypes__default['default'].string,

  /** Id of request that triggered notification */
  reqId: PropTypes__default['default'].string,

  /** onClick handler */
  onClick: PropTypes__default['default'].func,

  /** Translation strings */
  lang: PropTypes__default['default'].object.isRequired,
  // eslint-disable-line react/forbid-prop-types

  /** Pass notification's type */
  type: PropTypes__default['default'].oneOf(['error', 'success', 'warning']).isRequired
};
Notification.defaultProps = {
  className: '',
  reqId: '',
  onClick: null
};var _templateObject$6, _templateObject2$6, _templateObject3$6, _templateObject4$6;
// Styles
// =============================

var Label = styled__default['default'].div(_templateObject$6 || (_templateObject$6 = _taggedTemplateLiteral$5(["\n  font-size: 0.9em;\n  font-weight: ", ";\n  line-height: 1.5rem;\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.fontWeight.semibold;
});
var RadioIcon = styled__default['default'].div(_templateObject2$6 || (_templateObject2$6 = _taggedTemplateLiteral$5(["\n  background-color: #fff;\n  border: 0.2rem solid ", ";\n  border-radius: 50%;\n  cursor: pointer;\n  flex-shrink: 0;\n  height: 1.2rem;\n  width: 1.2rem;\n\n  &:not(:last-child) {\n    margin-right: 0.8rem;\n  }\n\n  ", ";\n\n  ", ";\n"])), function (_ref2) {
  var fillColor = _ref2.fillColor,
      theme = _ref2.theme;
  return alpha$2(fillColor || theme.colors.text, 0.6);
}, function (_ref3) {
  var checked = _ref3.checked,
      fillColorChecked = _ref3.fillColorChecked,
      theme = _ref3.theme;
  return checked && styled.css(_templateObject3$6 || (_templateObject3$6 = _taggedTemplateLiteral$5(["\n      border: 0.4rem solid ", ";\n    "])), fillColorChecked || theme.colors.primary);
}, function (_ref4) {
  var disabled = _ref4.disabled;
  return disabled && styled.css(_templateObject4$6 || (_templateObject4$6 = _taggedTemplateLiteral$5(["\n      cursor: default;\n      filter: grayscale(1);\n    "])));
});var _excluded$6 = ["className", "disabled", "fillColor", "fillColorChecked", "onChange", "value", "options", "error", "helperText"];
// Component
// =============================

var RadioInput = /*#__PURE__*/function (_PureComponent) {
  _inherits$e(RadioInput, _PureComponent);

  var _super = _createSuper$1(RadioInput);

  function RadioInput() {
    var _this;

    _classCallCheck$k(this, RadioInput);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty$8(_assertThisInitialized$1(_this), "onChange", function (value) {
      var _this$props = _this.props,
          disabled = _this$props.disabled,
          onChange = _this$props.onChange;
      if (onChange && !disabled) onChange(value);
    });

    return _this;
  }

  _createClass$g(RadioInput, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props2 = this.props,
          className = _this$props2.className,
          disabled = _this$props2.disabled,
          fillColor = _this$props2.fillColor,
          fillColorChecked = _this$props2.fillColorChecked;
          _this$props2.onChange;
          var value = _this$props2.value,
          options = _this$props2.options,
          error = _this$props2.error,
          helperText = _this$props2.helperText,
          rest = _objectWithoutProperties$7(_this$props2, _excluded$6);

      return /*#__PURE__*/React__default['default'].createElement(Div, _extends$g({
        className: className
      }, getViewProps(rest)), options.map(function (option, index) {
        return /*#__PURE__*/React__default['default'].createElement(Flex, {
          key: option.value,
          align: "center",
          mt: index > 0 ? '1.5rem' : 0
        }, /*#__PURE__*/React__default['default'].createElement(RadioIcon, {
          disabled: disabled,
          fillColor: fillColor,
          fillColorChecked: fillColorChecked,
          onClick: function onClick() {
            return _this2.onChange(option.value);
          },
          checked: value === option.value
        }), /*#__PURE__*/React__default['default'].createElement(Label, null, option.label));
      }), helperText && /*#__PURE__*/React__default['default'].createElement(HelperText, {
        error: error,
        mt: "1.5rem"
      }, helperText));
    }
  }]);

  return RadioInput;
}(React.PureComponent);

_defineProperty$8(RadioInput, "propTypes", {
  /** Props used by styled component to override styles. */
  className: PropTypes__default['default'].string,

  /** If True, input is disabled. */
  disabled: PropTypes__default['default'].bool,

  /** Icon color when input is not checked. */
  fillColor: PropTypes__default['default'].string,

  /** Icon color when input is checked. */
  fillColorChecked: PropTypes__default['default'].string,

  /** Callback fired when the value is changed. */
  onChange: PropTypes__default['default'].func,

  /** Value */
  value: PropTypes__default['default'].oneOfType([PropTypes__default['default'].string, PropTypes__default['default'].number]).isRequired,

  /** Options */
  options: PropTypes__default['default'].arrayOf(PropTypes__default['default'].shape({
    label: PropTypes__default['default'].string.isRequired,
    value: PropTypes__default['default'].oneOfType([PropTypes__default['default'].string, PropTypes__default['default'].number]).isRequired
  })).isRequired,

  /** If True, input has error. */
  error: PropTypes__default['default'].bool,

  /** The helper text content. */
  helperText: PropTypes__default['default'].string
});

_defineProperty$8(RadioInput, "defaultProps", {
  className: '',
  disabled: false,
  fillColor: '',
  fillColorChecked: '',
  onChange: null,
  error: false,
  helperText: ''
});var _templateObject$5, _templateObject2$5, _templateObject3$5, _templateObject4$5, _templateObject5$5, _templateObject6$3, _templateObject7$2, _templateObject8$2;
var Rating = styled__default['default'].div(_templateObject$5 || (_templateObject$5 = _taggedTemplateLiteral$5(["\n  border: none;\n  position: relative;\n\n  & > input {\n    display: none;\n  }\n\n  & > label {\n    color: #ddd;\n    float: right;\n  }\n\n  & > label::before {\n    ", ";\n    font-size: 2em;\n    display: inline-block;\n    margin: 3px;\n    /* stylelint-disable-next-line font-family-no-missing-generic-family-keyword */\n    font-family: FontAwesome;\n    content: '\f005';\n  }\n\n  & > .half::before {\n    content: \"\f089\";\n    position: absolute;\n  }\n\n  /* Animation Magic */\n  & > input:checked ~ label {\n    /* show gold star when clicked */\n    color: #ffd700;\n  }\n\n  &:not(:checked) > label:hover, /* hover current star */\n  &:not(:checked) > label:hover ~ label { /* hover previous stars in list */\n    ", ";\n  }\n\n  & > input:checked + label:hover, /* hover current star when changing rating */\n  & > input:checked ~ label:hover,\n  & > label:hover ~ input:checked ~ label, /* lighten current selection */\n  & > input:checked ~ label:hover ~ label {\n    ", ";\n  }\n\n  ", ";\n\n  ", ";\n"], ["\n  border: none;\n  position: relative;\n\n  & > input {\n    display: none;\n  }\n\n  & > label {\n    color: #ddd;\n    float: right;\n  }\n\n  & > label::before {\n    ", ";\n    font-size: 2em;\n    display: inline-block;\n    margin: 3px;\n    /* stylelint-disable-next-line font-family-no-missing-generic-family-keyword */\n    font-family: FontAwesome;\n    content: '\\f005';\n  }\n\n  & > .half::before {\n    content: \"\\f089\";\n    position: absolute;\n  }\n\n  /* Animation Magic */\n  & > input:checked ~ label {\n    /* show gold star when clicked */\n    color: #ffd700;\n  }\n\n  &:not(:checked) > label:hover, /* hover current star */\n  &:not(:checked) > label:hover ~ label { /* hover previous stars in list */\n    ", ";\n  }\n\n  & > input:checked + label:hover, /* hover current star when changing rating */\n  & > input:checked ~ label:hover,\n  & > label:hover ~ input:checked ~ label, /* lighten current selection */\n  & > input:checked ~ label:hover ~ label {\n    ", ";\n  }\n\n  ", ";\n\n  ", ";\n"])), function (props) {
  return props.activeHover && styled.css(_templateObject2$5 || (_templateObject2$5 = _taggedTemplateLiteral$5(["\n      cursor: pointer;\n    "])));
}, function (props) {
  return props.activeHover && styled.css(_templateObject3$5 || (_templateObject3$5 = _taggedTemplateLiteral$5(["\n      color: #ffd700;\n    "])));
}, function (props) {
  return props.activeHover && styled.css(_templateObject4$5 || (_templateObject4$5 = _taggedTemplateLiteral$5(["\n      color: #ffed85;\n    "])));
}, function (props) {
  return !props.activeHover && styled.css(_templateObject5$5 || (_templateObject5$5 = _taggedTemplateLiteral$5(["\n    /* NOTE: seems there is no easy way to fix this issue */\n    /* stylelint-disable-next-line no-descending-specificity */\n    & > label {\n      pointer-events: none;\n    }\n  "])));
}, function (props) {
  return props.disabled && styled.css(_templateObject6$3 || (_templateObject6$3 = _taggedTemplateLiteral$5(["\n    pointer-events: none;\n  "])));
});
var StyledContainer$1 = styled__default['default'](Container$1)(_templateObject7$2 || (_templateObject7$2 = _taggedTemplateLiteral$5(["\n  align-items: center;\n  border: 0;\n  display: flex;\n  min-height: 0;\n  padding: 0;\n"])));
var StyledHelpers = styled__default['default'](Helpers)(_templateObject8$2 || (_templateObject8$2 = _taggedTemplateLiteral$5(["\n  margin-left: auto;\n"])));var _excluded$5 = ["className", "containerClassName", "disabled", "error", "label", "lang", "name", "onChange", "optional", "showResetBtn", "tooltipError", "tooltipInteractive", "tooltipMessage", "tooltipPlacement", "value"];
// Component
// =============================

function handleClick(value, onChange) {
  if (onChange && value) {
    onChange(parseInt(value, 10));
  }
}

function handleResetBtn(onChange) {
  if (onChange) {
    onChange(0);
  }
}

var RatingInput = function RatingInput(_ref) {
  var className = _ref.className;
      _ref.containerClassName;
      var disabled = _ref.disabled,
      error = _ref.error,
      label = _ref.label,
      lang = _ref.lang,
      name = _ref.name,
      onChange = _ref.onChange,
      optional = _ref.optional,
      showResetBtn = _ref.showResetBtn,
      tooltipError = _ref.tooltipError,
      tooltipInteractive = _ref.tooltipInteractive,
      tooltipMessage = _ref.tooltipMessage,
      tooltipPlacement = _ref.tooltipPlacement,
      value = _ref.value,
      rest = _objectWithoutProperties$7(_ref, _excluded$5);

  var idPrefix = uuid.v4();
  return /*#__PURE__*/React__default['default'].createElement(Wrapper$p, _extends$g({
    className: className
  }, getViewProps(rest)), /*#__PURE__*/React__default['default'].createElement(Label$2, {
    error: error,
    label: label,
    lang: lang.Label,
    optional: optional
  }), /*#__PURE__*/React__default['default'].createElement(StyledContainer$1, null, /*#__PURE__*/React__default['default'].createElement(Rating, {
    activeHover: !!onChange,
    disabled: disabled,
    onClick: function onClick(e) {
      handleClick(e.target.value, onChange);
    }
  }, /*#__PURE__*/React__default['default'].createElement("input", {
    type: "radio",
    id: "".concat(idPrefix, "star5"),
    name: "".concat(idPrefix, "-").concat(name),
    value: "10",
    checked: value === 10,
    onChange: function onChange() {
      return null;
    }
  }), /*#__PURE__*/React__default['default'].createElement("label", {
    className: "full",
    htmlFor: "".concat(idPrefix, "star5")
  }), /*#__PURE__*/React__default['default'].createElement("input", {
    type: "radio",
    id: "".concat(idPrefix, "star4half"),
    name: "".concat(idPrefix, "-").concat(name),
    value: "9",
    checked: value === 9,
    onChange: function onChange() {
      return null;
    }
  }), /*#__PURE__*/React__default['default'].createElement("label", {
    className: "half",
    htmlFor: "".concat(idPrefix, "star4half")
  }), /*#__PURE__*/React__default['default'].createElement("input", {
    type: "radio",
    id: "".concat(idPrefix, "star4"),
    name: "".concat(idPrefix, "-").concat(name),
    value: "8",
    checked: value === 8,
    onChange: function onChange() {
      return null;
    }
  }), /*#__PURE__*/React__default['default'].createElement("label", {
    className: "full",
    htmlFor: "".concat(idPrefix, "star4")
  }), /*#__PURE__*/React__default['default'].createElement("input", {
    type: "radio",
    id: "".concat(idPrefix, "star3half"),
    name: "".concat(idPrefix, "-").concat(name),
    value: "7",
    checked: value === 7,
    onChange: function onChange() {
      return null;
    }
  }), /*#__PURE__*/React__default['default'].createElement("label", {
    className: "half",
    htmlFor: "".concat(idPrefix, "star3half")
  }), /*#__PURE__*/React__default['default'].createElement("input", {
    type: "radio",
    id: "".concat(idPrefix, "star3"),
    name: "".concat(idPrefix, "-").concat(name),
    value: "6",
    checked: value === 6,
    onChange: function onChange() {
      return null;
    }
  }), /*#__PURE__*/React__default['default'].createElement("label", {
    className: "full",
    htmlFor: "".concat(idPrefix, "star3")
  }), /*#__PURE__*/React__default['default'].createElement("input", {
    type: "radio",
    id: "".concat(idPrefix, "star2half"),
    name: "".concat(idPrefix, "-").concat(name),
    value: "5",
    checked: value === 5,
    onChange: function onChange() {
      return null;
    }
  }), /*#__PURE__*/React__default['default'].createElement("label", {
    className: "half",
    htmlFor: "".concat(idPrefix, "star2half")
  }), /*#__PURE__*/React__default['default'].createElement("input", {
    type: "radio",
    id: "".concat(idPrefix, "star2"),
    name: "".concat(idPrefix, "-").concat(name),
    value: "4",
    checked: value === 4,
    onChange: function onChange() {
      return null;
    }
  }), /*#__PURE__*/React__default['default'].createElement("label", {
    className: "full",
    htmlFor: "".concat(idPrefix, "star2")
  }), /*#__PURE__*/React__default['default'].createElement("input", {
    type: "radio",
    id: "".concat(idPrefix, "star1half"),
    name: "".concat(idPrefix, "-").concat(name),
    value: "3",
    checked: value === 3,
    onChange: function onChange() {
      return null;
    }
  }), /*#__PURE__*/React__default['default'].createElement("label", {
    className: "half",
    htmlFor: "".concat(idPrefix, "star1half")
  }), /*#__PURE__*/React__default['default'].createElement("input", {
    type: "radio",
    id: "".concat(idPrefix, "star1"),
    name: "".concat(idPrefix, "-").concat(name),
    value: "2",
    checked: value === 2,
    onChange: function onChange() {
      return null;
    }
  }), /*#__PURE__*/React__default['default'].createElement("label", {
    className: "full",
    htmlFor: "".concat(idPrefix, "star1")
  }), /*#__PURE__*/React__default['default'].createElement("input", {
    type: "radio",
    id: "".concat(idPrefix, "starhalf"),
    name: "".concat(idPrefix, "-").concat(name),
    value: "1",
    checked: value === 1,
    onChange: function onChange() {
      return null;
    }
  }), /*#__PURE__*/React__default['default'].createElement("label", {
    className: "half",
    htmlFor: "".concat(idPrefix, "starhalf")
  })), /*#__PURE__*/React__default['default'].createElement(StyledHelpers, {
    disabled: disabled,
    onResetBtn: showResetBtn ? function () {
      return handleResetBtn(onChange);
    } : null,
    tooltipError: tooltipError,
    tooltipInteractive: tooltipInteractive,
    tooltipMessage: tooltipMessage,
    tooltipPlacement: tooltipPlacement
  })));
};

RatingInput.propTypes = {
  /** Props used by styled component to override styles */
  className: PropTypes__default['default'].string,

  /** Container classname. */
  containerClassName: PropTypes__default['default'].string,

  /** If true, the input will be disabled. */
  disabled: PropTypes__default['default'].bool,

  /** If true, the input will indicate an error. */
  error: PropTypes__default['default'].bool,

  /** The helper text content. */
  helperText: PropTypes__default['default'].node,

  /** Label */
  label: PropTypes__default['default'].string,

  /** Translation strings. */
  lang: PropTypes__default['default'].object.isRequired,
  // eslint-disable-line react/forbid-prop-types

  /** onChange handler */
  onChange: PropTypes__default['default'].func,

  /** If true, the input is optional. */
  optional: PropTypes__default['default'].bool,

  /** Used to display error messsage as tooltip. */
  tooltipError: PropTypes__default['default'].string,

  /** If True, Tooltips will be interactive. */
  tooltipInteractive: PropTypes__default['default'].bool,

  /** If set, will add an InfoTooltip btn on input with tooltipMessage as content. */
  tooltipMessage: PropTypes__default['default'].node,

  /** Tooltip placement */
  tooltipPlacement: PropTypes__default['default'].oneOf(['bottom-end', 'bottom-start', 'bottom', 'left-end', 'left-start', 'left', 'right-end', 'right-start', 'right', 'top-end', 'top-start', 'top']),
  name: PropTypes__default['default'].string.isRequired,
  onClick: PropTypes__default['default'].func,

  /** If True, show reset button. */
  showResetBtn: PropTypes__default['default'].bool,
  value: PropTypes__default['default'].oneOfType([PropTypes__default['default'].number, PropTypes__default['default'].string])
};
RatingInput.defaultProps = {
  className: '',
  containerClassName: '',
  disabled: false,
  error: false,
  helperText: '',
  label: '',
  onChange: null,
  optional: false,
  tooltipError: '',
  tooltipInteractive: false,
  tooltipMessage: '',
  tooltipPlacement: 'bottom',
  onClick: null,
  showResetBtn: false,
  value: 1
};var baseIteratee$2 = _baseIteratee,
    isArrayLike = isArrayLike_1,
    keys = keys_1;

/**
 * Creates a `_.find` or `_.findLast` function.
 *
 * @private
 * @param {Function} findIndexFunc The function to find the collection index.
 * @returns {Function} Returns the new find function.
 */
function createFind$1(findIndexFunc) {
  return function(collection, predicate, fromIndex) {
    var iterable = Object(collection);
    if (!isArrayLike(collection)) {
      var iteratee = baseIteratee$2(predicate);
      collection = keys(collection);
      predicate = function(key) { return iteratee(iterable[key], key, iterable); };
    }
    var index = findIndexFunc(collection, predicate, fromIndex);
    return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
  };
}

var _createFind = createFind$1;var baseFindIndex = _baseFindIndex,
    baseIteratee$1 = _baseIteratee,
    toInteger = toInteger_1;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * This method is like `_.find` except that it returns the index of the first
 * element `predicate` returns truthy for instead of the element itself.
 *
 * @static
 * @memberOf _
 * @since 1.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {number} Returns the index of the found element, else `-1`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'active': false },
 *   { 'user': 'fred',    'active': false },
 *   { 'user': 'pebbles', 'active': true }
 * ];
 *
 * _.findIndex(users, function(o) { return o.user == 'barney'; });
 * // => 0
 *
 * // The `_.matches` iteratee shorthand.
 * _.findIndex(users, { 'user': 'fred', 'active': false });
 * // => 1
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.findIndex(users, ['active', false]);
 * // => 0
 *
 * // The `_.property` iteratee shorthand.
 * _.findIndex(users, 'active');
 * // => 2
 */
function findIndex$1(array, predicate, fromIndex) {
  var length = array == null ? 0 : array.length;
  if (!length) {
    return -1;
  }
  var index = fromIndex == null ? 0 : toInteger(fromIndex);
  if (index < 0) {
    index = nativeMax(length + index, 0);
  }
  return baseFindIndex(array, baseIteratee$1(predicate), index);
}

var findIndex_1 = findIndex$1;var createFind = _createFind,
    findIndex = findIndex_1;

/**
 * Iterates over elements of `collection`, returning the first element
 * `predicate` returns truthy for. The predicate is invoked with three
 * arguments: (value, index|key, collection).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {*} Returns the matched element, else `undefined`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'age': 36, 'active': true },
 *   { 'user': 'fred',    'age': 40, 'active': false },
 *   { 'user': 'pebbles', 'age': 1,  'active': true }
 * ];
 *
 * _.find(users, function(o) { return o.age < 40; });
 * // => object for 'barney'
 *
 * // The `_.matches` iteratee shorthand.
 * _.find(users, { 'age': 1, 'active': true });
 * // => object for 'pebbles'
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.find(users, ['active', false]);
 * // => object for 'fred'
 *
 * // The `_.property` iteratee shorthand.
 * _.find(users, 'active');
 * // => object for 'barney'
 */
var find = createFind(findIndex);

var find_1 = find;var baseUnset = _baseUnset,
    isIndex = _isIndex;

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * The base implementation of `_.pullAt` without support for individual
 * indexes or capturing the removed elements.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {number[]} indexes The indexes of elements to remove.
 * @returns {Array} Returns `array`.
 */
function basePullAt$1(array, indexes) {
  var length = array ? indexes.length : 0,
      lastIndex = length - 1;

  while (length--) {
    var index = indexes[length];
    if (length == lastIndex || index !== previous) {
      var previous = index;
      if (isIndex(index)) {
        splice.call(array, index, 1);
      } else {
        baseUnset(array, index);
      }
    }
  }
  return array;
}

var _basePullAt = basePullAt$1;var baseIteratee = _baseIteratee,
    basePullAt = _basePullAt;

/**
 * Removes all elements from `array` that `predicate` returns truthy for
 * and returns an array of the removed elements. The predicate is invoked
 * with three arguments: (value, index, array).
 *
 * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
 * to pull elements from an array by value.
 *
 * @static
 * @memberOf _
 * @since 2.0.0
 * @category Array
 * @param {Array} array The array to modify.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new array of removed elements.
 * @example
 *
 * var array = [1, 2, 3, 4];
 * var evens = _.remove(array, function(n) {
 *   return n % 2 == 0;
 * });
 *
 * console.log(array);
 * // => [1, 3]
 *
 * console.log(evens);
 * // => [2, 4]
 */
function remove(array, predicate) {
  var result = [];
  if (!(array && array.length)) {
    return result;
  }
  var index = -1,
      indexes = [],
      length = array.length;

  predicate = baseIteratee(predicate);
  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result.push(value);
      indexes.push(index);
    }
  }
  basePullAt(array, indexes);
  return result;
}

var remove_1 = remove;var _excluded$4 = ["className", "containerClassName", "disabled", "dropdownClassName", "error", "helperText", "label", "lang", "multiple", "name", "optional", "searchable", "showResetBtn", "suffix", "tooltipError", "tooltipMessage", "tooltipInteractive", "tooltipPlacement", "value", "variant"];
// Component
// =============================

var SelectInput = /*#__PURE__*/function (_PureComponent) {
  _inherits$e(SelectInput, _PureComponent);

  var _super = _createSuper$1(SelectInput);

  function SelectInput(props) {
    var _this;

    _classCallCheck$k(this, SelectInput);

    _this = _super.call(this, props);

    _defineProperty$8(_assertThisInitialized$1(_this), "handleCloseDropdown", function () {
      return _this.setState({
        opened: false
      });
    });

    _defineProperty$8(_assertThisInitialized$1(_this), "handleOpenDropdown", function () {
      var _this$props = _this.props,
          disabled = _this$props.disabled,
          searchable = _this$props.searchable;
      if (disabled) return null;
      return _this.setState({
        opened: true
      }, function () {
        if (searchable) {
          _this.inputRef.focus();
        } else {
          /* We need to use setTimeout to give react-relative-portal enough time to
          position the dropdown. */
          setTimeout(function () {
            var _this$animationContai;

            return (_this$animationContai = _this.animationContainerRef) === null || _this$animationContai === void 0 ? void 0 : _this$animationContai.firstChild.focus();
          }, 0);
        }
      });
    });

    _defineProperty$8(_assertThisInitialized$1(_this), "toggleDropdown", function () {
      var opened = _this.state.opened;

      if (!opened) {
        return _this.handleOpenDropdown();
      }

      return _this.handleCloseDropdown();
    });

    _defineProperty$8(_assertThisInitialized$1(_this), "handleDropdownIndicatorClick", function () {
      var disabled = _this.props.disabled;
      var opened = _this.state.opened;
      if (disabled) return null;
      return _this.setState({
        opened: !opened
      }, function () {
        // When clicking on indicator, we always go to firstChild focus
        // and never on input focus
        if (!opened) {
          /* We need to use setTimeout to give react-relative-portal enough time to
          position the dropdown. */
          setTimeout(function () {
            var _this$animationContai2;

            return (_this$animationContai2 = _this.animationContainerRef) === null || _this$animationContai2 === void 0 ? void 0 : _this$animationContai2.firstChild.focus();
          }, 0);
        }
      });
    });

    _defineProperty$8(_assertThisInitialized$1(_this), "getOptionFromValue", function (value) {
      var options = _this.props.options;
      return find_1(options, function (option) {
        return option.value === value;
      });
    });

    _defineProperty$8(_assertThisInitialized$1(_this), "handleRemoveFilter", function () {
      return _this.setState({
        filter: ''
      });
    });

    _defineProperty$8(_assertThisInitialized$1(_this), "handleFilterChange", function (e) {
      return _this.setState({
        filter: e.target.value
      });
    });

    _defineProperty$8(_assertThisInitialized$1(_this), "handleInputChange", function (e) {
      var _this$props2 = _this.props,
          disabled = _this$props2.disabled,
          handleInputChange = _this$props2.handleInputChange;
      if (disabled) return null;
      var value = e.target.value;

      if (handleInputChange) {
        handleInputChange(value);
      }

      return _this.setState({
        filter: value
      });
    });

    _defineProperty$8(_assertThisInitialized$1(_this), "handleSelectOption", function (val) {
      var _this$props3 = _this.props,
          disabled = _this$props3.disabled,
          multiple = _this$props3.multiple,
          options = _this$props3.options,
          onChange = _this$props3.onChange,
          selectAllValue = _this$props3.selectAllValue,
          value = _this$props3.value;
      if (disabled) return null;

      if (multiple) {
        var values = _toConsumableArray$5(value); // If we have all options checked
        // + if we are using the selectAllValue prop
        // Then we need to pass all the options IDs but the current option.


        if (selectAllValue && selectAllValue === value[0]) {
          var allOptions = options.map(function (option) {
            return option.value;
          });

          remove_1(allOptions, function (v) {
            return v === val;
          });

          onChange(allOptions);
          return _this.handleRemoveFilter();
        } // If we find the current option inside values, we need to remove it.


        if (find_1(values, function (v) {
          return v === val;
        })) {
          remove_1(values, function (v) {
            return v === val;
          });
        } else {
          if (value.length === options.length - 1 && selectAllValue) {
            // If we only miss 1 option to have all options selected
            // + if we are using the selectAllValue prop
            // Then we need to pass the selectAllValue instead.
            onChange([selectAllValue]);
            return _this.handleRemoveFilter();
          }

          values.push(val);
        }

        onChange(values);
        return _this.handleRemoveFilter();
      }

      _this.setState({
        opened: false
      });

      _this.handleRemoveFilter();

      if (val === value) return onChange('');
      return onChange(val);
    });

    _defineProperty$8(_assertThisInitialized$1(_this), "handleSelectAll", function () {
      var _this$props4 = _this.props,
          selectAllValue = _this$props4.selectAllValue,
          onChange = _this$props4.onChange,
          options = _this$props4.options,
          value = _this$props4.value;

      if (selectAllValue) {
        if (value[0] === selectAllValue) {
          return onChange([]);
        }

        return onChange([selectAllValue]);
      }

      if (value.length === options.length) return onChange('');
      return onChange(options.map(function (option) {
        return option.value;
      }));
    });

    _defineProperty$8(_assertThisInitialized$1(_this), "handleRemoveOptionFromChip", function (option) {
      var disabled = _this.props.disabled;
      if (disabled) return null;

      _this.handleSelectOption(option.value);

      return _this.focusInput();
    });

    _defineProperty$8(_assertThisInitialized$1(_this), "focusInput", function () {
      var _this$inputRef;

      var searchable = _this.props.searchable;
      if (searchable) return (_this$inputRef = _this.inputRef) === null || _this$inputRef === void 0 ? void 0 : _this$inputRef.focus();
      return null;
    });

    _defineProperty$8(_assertThisInitialized$1(_this), "isOptionSelected", function (val) {
      var _this$props5 = _this.props,
          multiple = _this$props5.multiple,
          selectAllValue = _this$props5.selectAllValue,
          value = _this$props5.value;

      if (multiple) {
        if (selectAllValue && value[0] === selectAllValue) {
          return true;
        }

        return !!find_1(value, function (v) {
          return v === val;
        });
      }

      return val === value;
    });

    _defineProperty$8(_assertThisInitialized$1(_this), "handleInputKeyDown", function (event) {
      var _this$animationContai3, _this$animationContai4;

      var key = event.key;
      var renderValuesVariant = _this.props.renderValuesVariant;
      var filter = _this.state.filter;

      switch (key) {
        // Backspace
        case 'Backspace':
          // If filter is present we only want to erase some part of it
          if (filter) break; // Prevent Backspace from sending user to previous page

          event.preventDefault();

          if (renderValuesVariant === 'chip') {
            // Check if we have some Chip to remove-
            var lastChip = _this.inputWrapperRef.previousSibling;
            if (!lastChip) break; // First time user press Backspace: Focus the item to show user is about to delete it
            // Deletion is handled by <Chip /> component via onDelete props

            if (document.activeElement !== lastChip) {
              lastChip.focus();
            }
          }

          break;
        // Tab

        case 'Tab':
          _this.setState({
            opened: false
          });

          break;

        case 'ArrowDown':
          event.preventDefault();
          (_this$animationContai3 = _this.animationContainerRef) === null || _this$animationContai3 === void 0 ? void 0 : _this$animationContai3.firstChild.focus();
          break;

        case 'ArrowUp':
          event.preventDefault();
          (_this$animationContai4 = _this.animationContainerRef) === null || _this$animationContai4 === void 0 ? void 0 : _this$animationContai4.lastChild.focus();
          break;
      }
    });

    _defineProperty$8(_assertThisInitialized$1(_this), "handleOptionKeyDown", function (e) {
      var multiple = _this.props.multiple;
      var key = e.key,
          target = e.target;

      if (e.target.dataset.noOptions) {
        return _this.focusInput();
      }

      switch (key) {
        // Tab
        case 'Tab':
          _this.setState({
            opened: false
          });

          break;
        // Enter: Save item

        case 'Enter':
          e.preventDefault();
          if (e.target.dataset.selectAll) _this.handleSelectAll();else _this.handleSelectOption(e.target.dataset.value);

          if (!multiple) {
            _this.focusInput();
          }

          break;
        // Arrow Up: Go to next item

        case 'ArrowUp':
          e.preventDefault();

          if (!target.previousSibling) {
            var _this$animationContai5;

            (_this$animationContai5 = _this.animationContainerRef) === null || _this$animationContai5 === void 0 ? void 0 : _this$animationContai5.lastChild.focus();
            break;
          }

          target.previousSibling.focus();
          break;
        // Arrow Down: Go to previous item

        case 'ArrowDown':
          e.preventDefault();

          if (!target.nextSibling) {
            var _this$animationContai6;

            (_this$animationContai6 = _this.animationContainerRef) === null || _this$animationContai6 === void 0 ? void 0 : _this$animationContai6.firstChild.focus();
            break;
          }

          target.nextSibling.focus();
          break;
        // If user is not navigating nor saving, we assume he wants to add some filter

        default:
          _this.focusInput();

          break;
      }

      return true;
    });

    _defineProperty$8(_assertThisInitialized$1(_this), "handleResetBtn", function () {
      var onChange = _this.props.onChange;

      _this.setState({
        filter: '',
        opened: false
      });

      onChange('');
    });

    _defineProperty$8(_assertThisInitialized$1(_this), "isSelectAllHelpersSelected", function () {
      var _this$props6 = _this.props,
          options = _this$props6.options,
          selectAllValue = _this$props6.selectAllValue,
          value = _this$props6.value;

      if (selectAllValue) {
        return selectAllValue === value[0];
      }

      return options.length === value.length;
    });

    _defineProperty$8(_assertThisInitialized$1(_this), "getSelectAllHelperText", function () {
      var _this$props7 = _this.props,
          lang = _this$props7.lang,
          options = _this$props7.options,
          selectAllLabel = _this$props7.selectAllLabel,
          selectAllValue = _this$props7.selectAllValue,
          value = _this$props7.value;

      if (selectAllValue) {
        if (selectAllLabel) return selectAllLabel;
        if (value[0] === selectAllValue) return lang.unselectAll;
        return lang.selectAll;
      }

      if (options.length === value.length) return lang.unselectAll;
      return lang.selectAll;
    });

    _defineProperty$8(_assertThisInitialized$1(_this), "renderSelectAllHelper", function () {
      var _this$props8 = _this.props,
          multiple = _this$props8.multiple,
          selectAllHelper = _this$props8.selectAllHelper;
      if (!multiple || !selectAllHelper) return null;
      return /*#__PURE__*/React__default['default'].createElement(Option, {
        "data-select-all": true,
        onClick: function onClick() {
          return _this.handleSelectAll();
        },
        onKeyDown: function onKeyDown(e) {
          return _this.handleOptionKeyDown(e);
        },
        selected: _this.isSelectAllHelpersSelected(),
        tabIndex: -1
      }, _this.getSelectAllHelperText());
    });

    _defineProperty$8(_assertThisInitialized$1(_this), "renderOptions", function () {
      var _this$props9 = _this.props,
          lang = _this$props9.lang,
          handleInputChange = _this$props9.handleInputChange,
          searchable = _this$props9.searchable,
          options = _this$props9.options,
          renderOptionsVariant = _this$props9.renderOptionsVariant;
      var filter = _this.state.filter;
      var optionsToBeRendered = options; // If we provide custom inputChange function, we override filter system

      if (!handleInputChange) {
        // We filter items
        if (searchable && filter) {
          optionsToBeRendered = options.filter(function (item) {
            // Search in the style of filter bar
            if (item.searchName) {
              var match = matches(item.searchName, filter);

              if (item.synonyms && item.searchSynonyms) {
                return match || item.searchSynonyms.some(function (synonym) {
                  return matches(synonym, filter);
                });
              }

              return match;
            } // Classic search


            return item.label.toLowerCase().indexOf(filter.toLowerCase()) !== -1;
          }).map(function (item) {
            if (item.synonyms && item.searchSynonyms) {
              var synonym = synonymFound(item.synonyms, item.searchSynonyms, filter);

              if (synonym) {
                return _objectSpread2$2(_objectSpread2$2({}, item), {}, {
                  label: "".concat(item.label, " (").concat(synonym, ")")
                });
              }
            }

            return item;
          });
        }
      } // If we filtered to much, and we have no options


      if (!optionsToBeRendered.length) {
        return /*#__PURE__*/React__default['default'].createElement(OptionsContainer$1, {
          onKeyDown: _this.handleOptionKeyDown,
          "data-no-options": true,
          ref: function ref(node) {
            _this.animationContainerRef = node;
          }
        }, /*#__PURE__*/React__default['default'].createElement(Option, {
          centered: true
        }, lang.noOptions));
      }

      if (renderOptionsVariant === 'classic') {
        return /*#__PURE__*/React__default['default'].createElement(OptionsContainer$1, {
          ref: function ref(node) {
            _this.animationContainerRef = node;
          }
        }, _this.renderSelectAllHelper(), optionsToBeRendered.map(function (option) {
          return /*#__PURE__*/React__default['default'].createElement(Option, {
            key: option.key || option.value,
            onClick: function onClick() {
              return _this.handleSelectOption(option.value);
            },
            onKeyDown: function onKeyDown(e) {
              return _this.handleOptionKeyDown(e);
            },
            selected: _this.isOptionSelected(option.value),
            "data-value": option.value
          }, option.label);
        }));
      } // if (renderOptionsVariant === 'check') {


      return /*#__PURE__*/React__default['default'].createElement(OptionsContainer$1, {
        ref: function ref(node) {
          _this.animationContainerRef = node;
        }
      }, _this.renderSelectAllHelper(), optionsToBeRendered.map(function (option) {
        return /*#__PURE__*/React__default['default'].createElement(Option, {
          key: option.key || option.value,
          onClick: function onClick() {
            return _this.handleSelectOption(option.value);
          },
          onKeyDown: function onKeyDown(e) {
            return _this.handleOptionKeyDown(e);
          },
          selected: _this.isOptionSelected(option.value),
          "data-value": option.value,
          withCheckbox: true
        }, /*#__PURE__*/React__default['default'].createElement(Checkbox, {
          checked: _this.isOptionSelected(option.value),
          mr: "1.2rem",
          tabIndex: -1
        }), option.label);
      }));
    });

    _defineProperty$8(_assertThisInitialized$1(_this), "renderInputValue", function () {
      var searchable = _this.props.searchable;
      var filter = _this.state.filter;
      if (searchable) return filter;
      return '';
    });

    _defineProperty$8(_assertThisInitialized$1(_this), "renderValue", function () {
      var _this$props10 = _this.props,
          countAll = _this$props10.countAll,
          countName = _this$props10.countName,
          countNamePlural = _this$props10.countNamePlural,
          error = _this$props10.error,
          multiple = _this$props10.multiple,
          options = _this$props10.options,
          renderValuesVariant = _this$props10.renderValuesVariant,
          selectAllValue = _this$props10.selectAllValue,
          value = _this$props10.value;

      if (renderValuesVariant === 'chip') {
        if (multiple) {
          if (value.length) {
            return value.map(function (val) {
              var option = _this.getOptionFromValue(val);

              return /*#__PURE__*/React__default['default'].createElement(Chip, {
                fillVariant: "plain",
                color: "primary",
                key: option.label,
                label: option.label,
                name: option.label,
                onDelete: function onDelete() {
                  return _this.handleRemoveOptionFromChip(option);
                }
              });
            });
          }

          return null;
        }

        if (value) {
          var option = _this.getOptionFromValue(value);

          return /*#__PURE__*/React__default['default'].createElement(Chip, {
            fillVariant: "plain",
            color: "primary",
            key: option.label,
            label: option.label,
            name: option.label,
            onClick: _this.toggleDropdown,
            onDelete: function onDelete() {
              return _this.handleRemoveOptionFromChip(option);
            }
          });
        }

        return null;
      }

      if (renderValuesVariant === 'count') {
        if (multiple) {
          if (!value.length) return '';

          if (value.length === options.length) {
            return /*#__PURE__*/React__default['default'].createElement(ClassicValueWrapper, {
              error: error,
              onClick: _this.toggleDropdown
            }, countAll);
          }

          if (value.length === 1) {
            if (selectAllValue && selectAllValue === value[0]) {
              return /*#__PURE__*/React__default['default'].createElement(ClassicValueWrapper, {
                error: error,
                onClick: _this.toggleDropdown
              }, countAll);
            }

            return /*#__PURE__*/React__default['default'].createElement(ClassicValueWrapper, {
              error: error,
              onClick: _this.toggleDropdown
            }, "1 ".concat(countName));
          }

          return /*#__PURE__*/React__default['default'].createElement(ClassicValueWrapper, {
            error: error,
            onClick: _this.toggleDropdown
          }, "".concat(value.length, " ").concat(countNamePlural));
        }

        if (value) {
          return /*#__PURE__*/React__default['default'].createElement(ClassicValueWrapper, {
            error: error,
            onClick: _this.toggleDropdown
          }, value);
        }

        return '';
      }
      /** renderValuesVariant === 'text' */


      if (multiple) {
        if (value.length) {
          return /*#__PURE__*/React__default['default'].createElement(ClassicValueWrapper, {
            error: error,
            onClick: _this.toggleDropdown
          }, value.map(function (val) {
            return _this.getOptionFromValue(val).label;
          }).join(', '));
        }

        return '';
      }

      if (value) {
        var _option = _this.getOptionFromValue(value);

        return /*#__PURE__*/React__default['default'].createElement(ClassicValueWrapper, {
          onClick: _this.toggleDropdown
        }, _option.label);
      }

      return '';
    });

    _defineProperty$8(_assertThisInitialized$1(_this), "renderPlaceholder", function () {
      var _this$props11 = _this.props,
          placeholder = _this$props11.placeholder,
          renderValuesVariant = _this$props11.renderValuesVariant,
          value = _this$props11.value;
      if (renderValuesVariant === 'text' && value) return '';
      return placeholder;
    });

    _this.state = {
      filter: '',
      opened: false
    };
    return _this;
  }

  _createClass$g(SelectInput, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$state = this.state,
          filter = _this$state.filter,
          opened = _this$state.opened;

      var _this$props12 = this.props,
          className = _this$props12.className,
          containerClassName = _this$props12.containerClassName,
          disabled = _this$props12.disabled,
          dropdownClassName = _this$props12.dropdownClassName,
          error = _this$props12.error,
          helperText = _this$props12.helperText,
          label = _this$props12.label,
          lang = _this$props12.lang,
          multiple = _this$props12.multiple,
          name = _this$props12.name,
          optional = _this$props12.optional,
          searchable = _this$props12.searchable,
          showResetBtn = _this$props12.showResetBtn,
          suffix = _this$props12.suffix,
          tooltipError = _this$props12.tooltipError,
          tooltipMessage = _this$props12.tooltipMessage,
          tooltipInteractive = _this$props12.tooltipInteractive,
          tooltipPlacement = _this$props12.tooltipPlacement,
          value = _this$props12.value,
          variant = _this$props12.variant,
          rest = _objectWithoutProperties$7(_this$props12, _excluded$4);

      return /*#__PURE__*/React__default['default'].createElement(ClickAwayListener, {
        onClickAway: this.handleCloseDropdown
      }, /*#__PURE__*/React__default['default'].createElement(Wrapper$p, _extends$g({
        className: className
      }, getViewProps(rest)), variant === 'background' && /*#__PURE__*/React__default['default'].createElement(Label$2, {
        active: opened || !!filter,
        error: error,
        label: label,
        lang: lang.Label,
        optional: optional,
        variant: variant
      }), /*#__PURE__*/React__default['default'].createElement(Container$1, {
        active: opened || !!filter,
        containerClassName: containerClassName,
        error: error,
        getRef: function getRef(node) {
          _this2.containerRef = node;
        },
        onClick: this.handleOpenDropdown,
        variant: variant
      }, variant === 'underline' && /*#__PURE__*/React__default['default'].createElement(Label$2, {
        active: opened || !!filter,
        error: error,
        inputFilled: (multiple ? !!value.length : !!value) || !!filter,
        label: label,
        lang: lang.Label,
        optional: optional,
        variant: variant
      }), /*#__PURE__*/React__default['default'].createElement(Flex, {
        align: "center",
        flex: "1 1 0",
        wrap: "wrap",
        maxWidth: "100%"
      }, this.renderValue(), searchable ? /*#__PURE__*/React__default['default'].createElement(InputBase, {
        autoComplete: "off_workaround",
        disabled: disabled,
        dropdownIndicator: {
          opened: opened,
          onClick: this.handleDropdownIndicatorClick
        },
        error: error,
        getInputRef: function getInputRef(node) {
          _this2.inputRef = node;
        },
        getRef: function getRef(node) {
          _this2.inputWrapperRef = node;
        },
        name: name,
        onChange: searchable ? this.handleInputChange : function () {},
        onKeyDown: this.handleInputKeyDown,
        onResetBtn: showResetBtn ? function () {
          return _this2.handleResetBtn();
        } : null,
        placeholder: this.renderPlaceholder(),
        showPlaceholder: opened || !!filter || (multiple ? !!value.length : !!value) || variant === 'background',
        suffix: suffix,
        tooltipError: tooltipError,
        tooltipInteractive: tooltipInteractive,
        tooltipMessage: tooltipMessage,
        tooltipPlacement: tooltipPlacement,
        value: this.renderInputValue()
      }) : /*#__PURE__*/React__default['default'].createElement(React__default['default'].Fragment, null, /*#__PURE__*/React__default['default'].createElement(ToggleDropdownPlaceholder, {
        content: this.renderPlaceholder(),
        onClick: this.handleOpenDropdown
      }), /*#__PURE__*/React__default['default'].createElement(DropdownInputHelpers, {
        additionalHelpers: suffix,
        disabled: disabled,
        dropdownIndicator: {
          opened: opened,
          onClick: this.handleDropdownIndicatorClick
        },
        onResetBtn: showResetBtn ? function () {
          return _this2.handleResetBtn();
        } : null,
        tooltipError: tooltipError,
        tooltipInteractive: tooltipInteractive,
        tooltipMessage: tooltipMessage,
        tooltipPlacement: tooltipPlacement
      })))), /*#__PURE__*/React__default['default'].createElement(Dropdown$2, {
        className: dropdownClassName,
        onClickOutside: this.handleCloseDropdown,
        open: opened,
        variant: variant
      }, /*#__PURE__*/React__default['default'].createElement(React__default['default'].Fragment, null, this.renderOptions())), helperText && /*#__PURE__*/React__default['default'].createElement(HelperText, {
        error: error
      }, helperText)));
    }
  }]);

  return SelectInput;
}(React.PureComponent);

_defineProperty$8(SelectInput, "propTypes", {
  /** Props used by styled component to override styles */
  className: PropTypes__default['default'].string,

  /** Container classname. */
  containerClassName: PropTypes__default['default'].string,

  /**
   * Display text used when renderOptionsVariant is set to
   * "count", and all options are selected
   */
  countAll: PropTypes__default['default'].string,

  /**
   * Display text used when renderOptionsVariant
   * is set to "count", and user selected <= 1 option
   */
  countName: PropTypes__default['default'].string,

  /**
   * Display text used when renderOptionsVariant is set
   * to "count", and user selected >= 2 options
   */
  countNamePlural: PropTypes__default['default'].string,

  /** If true, the input will be disabled. */
  disabled: PropTypes__default['default'].bool,

  /** Dropdown classname. */
  dropdownClassName: PropTypes__default['default'].string,

  /** If true, the input will indicate an error.  */
  error: PropTypes__default['default'].bool,

  /** Function that will override input default filter action  */
  handleInputChange: PropTypes__default['default'].func,

  /** The helper text content. */
  helperText: PropTypes__default['default'].string,

  /** The label content. */
  label: PropTypes__default['default'].string,

  /** Translation strings */
  lang: PropTypes__default['default'].object.isRequired,
  // eslint-disable-line react/forbid-prop-types

  /** If true, input support multiple option choice */
  multiple: PropTypes__default['default'].bool,

  /** Name attribute of the input element. */
  name: PropTypes__default['default'].string.isRequired,

  /**
   * If true, display an extra option to Select/Unselect
   * all options (only displayed if multiple is true)
   */
  selectAllHelper: PropTypes__default['default'].bool,

  /** Use to replace the default "Select all" text on the SelectAllHelper. */
  selectAllLabel: PropTypes__default['default'].string,

  /**
   * In order to reduce database storage, we can pass a string that will be store
   * instead of all the options ID.
   */
  selectAllValue: PropTypes__default['default'].string,

  /** If True, show reset button. */
  showResetBtn: PropTypes__default['default'].bool,

  /** Node that will be rendered as Suffix. */
  suffix: PropTypes__default['default'].node,

  /** Callback fired when the value is changed. */
  onChange: PropTypes__default['default'].func.isRequired,

  /** If true, the input is optional. */
  optional: PropTypes__default['default'].bool,

  /** Options array */
  options: PropTypes__default['default'].arrayOf(PropTypes__default['default'].shape({
    key: PropTypes__default['default'].string,
    label: PropTypes__default['default'].string.isRequired,
    searchName: PropTypes__default['default'].string,
    synonyms: PropTypes__default['default'].arrayOf(PropTypes__default['default'].string),
    searchSynonyms: PropTypes__default['default'].arrayOf(PropTypes__default['default'].string),
    value: PropTypes__default['default'].oneOfType([PropTypes__default['default'].object, PropTypes__default['default'].string, PropTypes__default['default'].number, PropTypes__default['default'].bool])
  })),

  /** The short hint displayed in the input before the user enters a value. */
  placeholder: PropTypes__default['default'].string,

  /** Variant for options rendering */
  renderOptionsVariant: PropTypes__default['default'].oneOf(['classic', 'check']),

  /** Variant for values rendering */
  renderValuesVariant: PropTypes__default['default'].oneOf(['chip', 'count', 'text']),

  /** If true, user will be able to filter options */
  searchable: PropTypes__default['default'].bool,

  /** Used to display error messsage as tooltip. */
  tooltipError: PropTypes__default['default'].string,

  /** If True, Tooltip will be interactive. */
  tooltipInteractive: PropTypes__default['default'].bool,

  /** If set, will add an InfoTooltip btn on input with tooltipMessage as content. */
  tooltipMessage: PropTypes__default['default'].node,

  /** Tooltip placement */
  tooltipPlacement: PropTypes__default['default'].oneOf(['bottom-end', 'bottom-start', 'bottom', 'left-end', 'left-start', 'left', 'right-end', 'right-start', 'right', 'top-end', 'top-start', 'top']),

  /** Value. */
  value: PropTypes__default['default'].oneOfType([PropTypes__default['default'].string, PropTypes__default['default'].number, PropTypes__default['default'].arrayOf(PropTypes__default['default'].oneOfType([PropTypes__default['default'].string, PropTypes__default['default'].number]))]),

  /** Input style variant. */
  variant: PropTypes__default['default'].oneOf(['background', 'underline'])
});

_defineProperty$8(SelectInput, "defaultProps", {
  className: '',
  containerClassName: '',
  countAll: '',
  countName: '',
  countNamePlural: '',
  disabled: false,
  dropdownClassName: '',
  error: false,
  handleInputChange: null,
  helperText: '',
  label: '',
  multiple: false,
  optional: false,
  options: [],
  placeholder: '',
  renderOptionsVariant: 'classic',
  renderValuesVariant: 'text',
  searchable: false,
  selectAllHelper: false,
  selectAllLabel: '',
  selectAllValue: '',
  showResetBtn: false,
  suffix: null,
  tooltipError: '',
  tooltipInteractive: false,
  tooltipMessage: '',
  tooltipPlacement: 'bottom',
  value: '',
  variant: 'background'
});var _templateObject$4, _templateObject2$4, _templateObject3$4, _templateObject4$4, _templateObject5$4, _templateObject6$2, _templateObject7$1, _templateObject8$1, _templateObject9$1, _templateObject10$1, _templateObject11$1, _templateObject12$1, _templateObject13$1, _templateObject14$1, _templateObject15;
// Styled Components
// =============================

var Wrapper$3 = styled__default['default'].div(_templateObject$4 || (_templateObject$4 = _taggedTemplateLiteral$5(["\n  position: relative;\n"])));
var Switch = styled__default['default'].div(_templateObject2$4 || (_templateObject2$4 = _taggedTemplateLiteral$5(["\n  border-radius: 1.2rem;\n  flex-shrink: 0;\n  height: 2.5rem;\n  position: relative;\n  transition: background-color ", ";\n  width: 5rem;\n\n  ", ";\n\n  ", ";\n\n  ", ";\n\n  &:after {\n    border-radius: 4.6rem;\n    box-shadow: 0 0.2rem 0.4rem 0 ", ";\n    content: '';\n    left: 0.1rem;\n    height: 2.3rem;\n    position: absolute;\n    top: 0.1rem;\n    transition: transform ", ";\n    width: 2.3rem;\n\n    ", ";\n  }\n\n  ", ";\n\n  ", ";\n\n  ", ";\n\n  ", ";\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.transition.medium;
}, function (_ref2) {
  var colors = _ref2.colors,
      theme = _ref2.theme;
  return colors === 'default' ? styled.css(_templateObject3$4 || (_templateObject3$4 = _taggedTemplateLiteral$5(["\n    background-color: ", ";\n  "])), alpha$2(theme.colors.text, 0.7)) : styled.css(_templateObject4$4 || (_templateObject4$4 = _taggedTemplateLiteral$5(["\n    background-color: ", ";\n  "])), colors.switchBackground);
}, function (_ref3) {
  var label = _ref3.label;
  return label && styled.css(_templateObject5$4 || (_templateObject5$4 = _taggedTemplateLiteral$5(["\n      margin-top: 1.2rem;\n    "])));
}, function (_ref4) {
  var clickable = _ref4.clickable;
  return clickable && styled.css(_templateObject6$2 || (_templateObject6$2 = _taggedTemplateLiteral$5(["\n      cursor: pointer;\n    "])));
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.colors.boxShadow;
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.transition.medium;
}, function (_ref7) {
  var colors = _ref7.colors,
      theme = _ref7.theme;
  return colors === 'default' ? styled.css(_templateObject7$1 || (_templateObject7$1 = _taggedTemplateLiteral$5(["\n      background-color: ", ";\n    "])), theme.colors.text) : styled.css(_templateObject8$1 || (_templateObject8$1 = _taggedTemplateLiteral$5(["\n      background-color: ", ";\n    "])), colors.switchCircle);
}, function (_ref8) {
  var theme = _ref8.theme,
      value = _ref8.value,
      reversed = _ref8.reversed;
  return value && !reversed && styled.css(_templateObject9$1 || (_templateObject9$1 = _taggedTemplateLiteral$5(["\n      background-color: ", ";\n\n      &:after {\n        transform: translate3d(calc(100% + 0.2rem), 0, 0);\n      }\n    "])), theme.colors.type.success);
}, function (_ref9) {
  var theme = _ref9.theme,
      value = _ref9.value,
      reversed = _ref9.reversed;
  return !value && reversed && styled.css(_templateObject10$1 || (_templateObject10$1 = _taggedTemplateLiteral$5(["\n      background-color: ", ";\n\n      &:after {\n        transform: translate3d(calc(100% + 0.2rem), 0, 0);\n      }\n    "])), theme.colors.type.success);
}, function (_ref10) {
  var textOff = _ref10.textOff;
  return textOff && styled.css(_templateObject11$1 || (_templateObject11$1 = _taggedTemplateLiteral$5(["\n      margin-left: 0.8rem;\n    "])));
}, function (_ref11) {
  var textOn = _ref11.textOn;
  return textOn && styled.css(_templateObject12$1 || (_templateObject12$1 = _taggedTemplateLiteral$5(["\n      margin-right: 0.8rem;\n    "])));
});
var Container = styled__default['default'].div(_templateObject13$1 || (_templateObject13$1 = _taggedTemplateLiteral$5(["\n  align-items: center;\n  display: flex;\n  padding: 0.8rem 0;\n"])));
var Text = styled__default['default'].div(_templateObject14$1 || (_templateObject14$1 = _taggedTemplateLiteral$5(["\n  font-size: 1.2rem;\n  ", ";\n"])), function (_ref12) {
  var active = _ref12.active,
      theme = _ref12.theme;
  return active && styled.css(_templateObject15 || (_templateObject15 = _taggedTemplateLiteral$5(["\n      color: ", ";\n    "])), theme.colors.text);
});// Component
// =============================

var SwitchInput = /*#__PURE__*/function (_PureComponent) {
  _inherits$e(SwitchInput, _PureComponent);

  var _super = _createSuper$1(SwitchInput);

  function SwitchInput() {
    var _this;

    _classCallCheck$k(this, SwitchInput);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty$8(_assertThisInitialized$1(_this), "handleChange", function () {
      var _this$props = _this.props,
          disabled = _this$props.disabled,
          onChange = _this$props.onChange,
          value = _this$props.value;

      if (onChange && !disabled) {
        onChange(!value);
      }
    });

    return _this;
  }

  _createClass$g(SwitchInput, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          colors = _this$props2.colors,
          disabled = _this$props2.disabled,
          error = _this$props2.error,
          helperText = _this$props2.helperText,
          label = _this$props2.label,
          lang = _this$props2.lang,
          onChange = _this$props2.onChange,
          optional = _this$props2.optional,
          reversed = _this$props2.reversed,
          textOn = _this$props2.textOn,
          textOff = _this$props2.textOff,
          value = _this$props2.value;
      return /*#__PURE__*/React__default['default'].createElement(Wrapper$3, {
        label: label
      }, label && /*#__PURE__*/React__default['default'].createElement(Label$2, {
        inputFilled: true,
        label: label,
        lang: lang.Label,
        optional: optional,
        variant: "switchInput"
      }), /*#__PURE__*/React__default['default'].createElement(Container, null, textOff && /*#__PURE__*/React__default['default'].createElement(Text, {
        active: !value
      }, textOff), /*#__PURE__*/React__default['default'].createElement(Switch, {
        colors: colors,
        clickable: !!onChange && !disabled,
        onClick: this.handleChange,
        textOff: textOff,
        textOn: textOn,
        value: value,
        reversed: reversed
      }), textOn && /*#__PURE__*/React__default['default'].createElement(Text, {
        active: value
      }, textOn)), helperText && /*#__PURE__*/React__default['default'].createElement(HelperText, {
        error: error
      }, helperText));
    }
  }]);

  return SwitchInput;
}(React.PureComponent);

_defineProperty$8(SwitchInput, "propTypes", {
  colors: PropTypes__default['default'].oneOfType([PropTypes__default['default'].oneOf(['default']), PropTypes__default['default'].shape({
    switchBackground: PropTypes__default['default'].string,
    switchCircle: PropTypes__default['default'].string
  })]),

  /** If true, the input will be disabled. */
  disabled: PropTypes__default['default'].bool,

  /** If True, input has error. */
  error: PropTypes__default['default'].bool,

  /** The helper text content. */
  helperText: PropTypes__default['default'].string,

  /** The label content. */
  label: PropTypes__default['default'].string,

  /** Translation strings. */
  lang: PropTypes__default['default'].object.isRequired,
  // eslint-disable-line react/forbid-prop-types

  /** Handle onChange event. */
  onChange: PropTypes__default['default'].func,

  /** If true, the input is optional. */
  optional: PropTypes__default['default'].bool,

  /** Reversed switch input . */
  reversed: PropTypes__default['default'].bool,

  /** Text showed when switch is OFF. */
  textOff: PropTypes__default['default'].string,

  /** Text showed when switch is ON. */
  textOn: PropTypes__default['default'].string,

  /** Value. */
  value: PropTypes__default['default'].bool
});

_defineProperty$8(SwitchInput, "defaultProps", {
  colors: 'default',
  disabled: false,
  error: false,
  helperText: '',
  label: '',
  onChange: null,
  optional: false,
  textOff: '',
  textOn: '',
  value: false,
  reversed: false
});var _templateObject$3, _templateObject2$3, _templateObject3$3, _templateObject4$3, _templateObject5$3;
// Styles
// =============================

var StyledContainer = styled__default['default'](Container$1)(_templateObject$3 || (_templateObject$3 = _taggedTemplateLiteral$5(["\n  ", ";\n"])), function (_ref) {
  var height = _ref.height;
  return height && styled.css(_templateObject2$3 || (_templateObject2$3 = _taggedTemplateLiteral$5(["\n    align-items: flex-start;\n    display: flex;\n    height: ", ";\n    justify-content: flex-start;\n  "])), height);
});
var TextAreaInput = styled__default['default'].textarea(_templateObject3$3 || (_templateObject3$3 = _taggedTemplateLiteral$5(["\n  ", ";\n  background-color: transparent;\n  border: 0;\n  color: ", ";\n  font-family: ", ";\n  font-size: inherit;\n  font-weight: inherit;\n  margin: auto;\n  min-height: 1.8rem;\n  outline: 0;\n  resize: none;\n  white-space: pre-wrap;\n  width: 100%;\n\n  &:invalid {\n    border: 0;\n    box-shadow: none;\n  }\n\n  &:focus {\n    outline: none;\n  }\n\n  &::-webkit-input-placeholder {\n    color: inherit;\n    font-style: italic;\n    font-weight: inherit;\n    opacity: 0;\n    transition: opacity ", ";\n  }\n\n  &:-moz-placeholder {\n    color: inherit;\n    font-style: italic;\n    font-weight: inherit;\n    opacity: 0;\n    transition: opacity ", ";\n  }\n\n  &::-moz-placeholder {\n    color: inherit;\n    font-style: italic;\n    font-weight: inherit;\n    opacity: 0;\n    transition: opacity ", ";\n  }\n\n  &:-ms-input-placeholder {\n    color: inherit;\n    font-style: italic;\n    font-weight: inherit;\n    opacity: 0;\n    transition: opacity ", ";\n  }\n\n  ", ";\n\n  ", ";\n"])), function (_ref2) {
  var theme = _ref2.theme;
  return theme.helpers.hideScrollbar;
}, function (_ref3) {
  var error = _ref3.error,
      theme = _ref3.theme;
  return error ? theme.colors.type.error : theme.colors.input.text;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.fontFamily.primary;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.transition.medium;
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.transition.medium;
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.transition.medium;
}, function (_ref8) {
  var theme = _ref8.theme;
  return theme.transition.medium;
}, function (_ref9) {
  var height = _ref9.height;
  return height && styled.css(_templateObject4$3 || (_templateObject4$3 = _taggedTemplateLiteral$5(["\n    height: 100%;\n    margin: 0;\n  "])));
}, function (_ref10) {
  var showPlaceholder = _ref10.showPlaceholder;
  return showPlaceholder && styled.css(_templateObject5$3 || (_templateObject5$3 = _taggedTemplateLiteral$5(["\n      &::-webkit-input-placeholder {\n        opacity: 0.6;\n      }\n\n      &:-moz-placeholder {\n        opacity: 0.6;\n      }\n\n      &::-moz-placeholder {\n        opacity: 0.6;\n      }\n\n      &:-ms-input-placeholder {\n        opacity: 0.6;\n      }\n    "])));
});var _excluded$3 = ["className", "containerClassName", "disabled", "error", "height", "helperText", "isTranslatable", "isTranslatableMessage", "label", "lang", "name", "onResetBtn", "optional", "placeholder", "showPlaceholder", "suffix", "tooltipError", "tooltipInteractive", "tooltipMessage", "tooltipPlacement", "value", "variant"];
// Component
// =============================

var TextArea = /*#__PURE__*/function (_PureComponent) {
  _inherits$e(TextArea, _PureComponent);

  var _super = _createSuper$1(TextArea);

  function TextArea(props) {
    var _this;

    _classCallCheck$k(this, TextArea);

    _this = _super.call(this, props);

    _defineProperty$8(_assertThisInitialized$1(_this), "handleChange", function (e) {
      var _this$props = _this.props,
          height = _this$props.height,
          onChange = _this$props.onChange,
          disabled = _this$props.disabled; // If no fixed height is specified, we adapt textarea height based on its content.

      if (!height) {
        /** Recalculate textarea height on updates. */
        _this.inputRef.style.height = '0.5rem';
        _this.inputRef.style.height = "".concat(_this.inputRef.scrollHeight / 10, "rem");
      }

      if (!disabled) {
        onChange(e.target.value || '');
      }
    });

    _defineProperty$8(_assertThisInitialized$1(_this), "handleClick", function () {
      return _this.inputRef.focus();
    });

    _defineProperty$8(_assertThisInitialized$1(_this), "handleBlur", function () {
      return _this.setState({
        focus: false
      });
    });

    _defineProperty$8(_assertThisInitialized$1(_this), "handleFocus", function () {
      return _this.setState({
        focus: true
      });
    });

    _this.state = {
      /** If true, input is focus. */
      focus: false
    };
    return _this;
  }

  _createClass$g(TextArea, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var height = this.props.height; // If no fixed height is specified, we adapt textarea height based on its content.

      if (height) return null;
      /** Recalculate textarea height on updates. */

      this.inputRef.style.height = '0.5rem';
      this.inputRef.style.height = "".concat(this.inputRef.scrollHeight / 10, "rem");
      return true;
    }
    /** Handle input change. */

  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props2 = this.props,
          className = _this$props2.className,
          containerClassName = _this$props2.containerClassName,
          disabled = _this$props2.disabled,
          error = _this$props2.error,
          height = _this$props2.height,
          helperText = _this$props2.helperText,
          isTranslatable = _this$props2.isTranslatable,
          isTranslatableMessage = _this$props2.isTranslatableMessage,
          label = _this$props2.label,
          lang = _this$props2.lang,
          name = _this$props2.name,
          onResetBtn = _this$props2.onResetBtn,
          optional = _this$props2.optional,
          placeholder = _this$props2.placeholder,
          showPlaceholder = _this$props2.showPlaceholder,
          suffix = _this$props2.suffix,
          tooltipError = _this$props2.tooltipError,
          tooltipInteractive = _this$props2.tooltipInteractive,
          tooltipMessage = _this$props2.tooltipMessage,
          tooltipPlacement = _this$props2.tooltipPlacement,
          value = _this$props2.value,
          variant = _this$props2.variant,
          rest = _objectWithoutProperties$7(_this$props2, _excluded$3);

      var focus = this.state.focus;
      return /*#__PURE__*/React__default['default'].createElement(Wrapper$p, _extends$g({
        className: className,
        disabled: disabled,
        error: error,
        filled: !!value,
        focus: focus,
        onClick: this.handleClick
      }, omit_1(rest, ['onChange'])), variant === 'background' && /*#__PURE__*/React__default['default'].createElement(Label$2, {
        active: focus,
        error: error,
        label: label,
        lang: lang.Label,
        optional: optional,
        variant: variant
      }), /*#__PURE__*/React__default['default'].createElement(StyledContainer, {
        active: focus,
        className: containerClassName,
        error: error,
        height: height,
        variant: variant
      }, variant === 'underline' && /*#__PURE__*/React__default['default'].createElement(Label$2, {
        active: focus,
        error: error,
        inputFilled: !!value,
        label: label,
        lang: lang.Label,
        optional: optional,
        variant: variant
      }), /*#__PURE__*/React__default['default'].createElement(TextAreaInput, {
        disabled: disabled,
        error: error,
        ref: function ref(node) {
          _this2.inputRef = node;
        },
        height: height,
        name: name,
        onBlur: this.handleBlur,
        onChange: this.handleChange,
        onFocus: this.handleFocus,
        placeholder: placeholder,
        showPlaceholder: showPlaceholder || focus || !!value || variant === 'background',
        value: value,
        variant: variant
      }), /*#__PURE__*/React__default['default'].createElement(Helpers, {
        additionalHelpers: suffix,
        disabled: disabled,
        isTranslatable: isTranslatable,
        isTranslatableMessage: isTranslatableMessage,
        onResetBtn: onResetBtn,
        tooltipError: tooltipError,
        tooltipInteractive: tooltipInteractive,
        tooltipMessage: tooltipMessage,
        tooltipPlacement: tooltipPlacement
      })), helperText && /*#__PURE__*/React__default['default'].createElement(HelperText, {
        error: error
      }, helperText));
    }
  }]);

  return TextArea;
}(React.PureComponent);

_defineProperty$8(TextArea, "propTypes", {
  /** Props used by styled component to override styles */
  className: PropTypes__default['default'].string,

  /** Container classname. */
  containerClassName: PropTypes__default['default'].string,

  /** If true, the input will be disabled. */
  disabled: PropTypes__default['default'].bool,

  /** If true, the input will indicate an error. */
  error: PropTypes__default['default'].bool,

  /** Can be used to set a fixed height to TextArea container. */
  height: PropTypes__default['default'].string,

  /** The helper text content. */
  helperText: PropTypes__default['default'].string,

  /** If True, will show user this input is translatable. */
  isTranslatable: PropTypes__default['default'].bool,

  /** Message show in isTranslatable tooltip. */
  isTranslatableMessage: PropTypes__default['default'].string,

  /** The label content. */
  label: PropTypes__default['default'].string,

  /** Translation strings. */
  lang: PropTypes__default['default'].object.isRequired,
  // eslint-disable-line react/forbid-prop-types

  /** Name attribute of the input element. */
  name: PropTypes__default['default'].string.isRequired,

  /** Callback fired when the value is changed. */
  onChange: PropTypes__default['default'].func.isRequired,

  /** Callback function for reset button */
  onResetBtn: PropTypes__default['default'].func,

  /** If true, the input is optional. */
  optional: PropTypes__default['default'].bool,

  /** The short hint displayed in the input before the user enters a value. */
  placeholder: PropTypes__default['default'].string,

  /** If True, placeholder is shown */
  showPlaceholder: PropTypes__default['default'].bool,

  /** Node that will be rendered as Suffix. */
  suffix: PropTypes__default['default'].node,

  /** Used to display error messsage as tooltip. */
  tooltipError: PropTypes__default['default'].string,

  /** If True, Tooltip will be interactive. */
  tooltipInteractive: PropTypes__default['default'].bool,

  /** If set, will add an InfoTooltip btn on input with tooltipMessage as content. */
  tooltipMessage: PropTypes__default['default'].node,

  /** Tooltip placement */
  tooltipPlacement: PropTypes__default['default'].oneOf(['bottom-end', 'bottom-start', 'bottom', 'left-end', 'left-start', 'left', 'right-end', 'right-start', 'right', 'top-end', 'top-start', 'top']),

  /** Value. */
  value: PropTypes__default['default'].oneOfType([PropTypes__default['default'].string, PropTypes__default['default'].number]),

  /** Input style variant. */
  variant: PropTypes__default['default'].oneOf(['background', 'underline'])
});

_defineProperty$8(TextArea, "defaultProps", {
  className: '',
  containerClassName: '',
  disabled: false,
  error: false,
  height: '',
  helperText: '',
  isTranslatable: false,
  isTranslatableMessage: '',
  label: '',
  onResetBtn: null,
  optional: false,
  placeholder: '',
  showPlaceholder: false,
  suffix: null,
  tooltipError: '',
  tooltipInteractive: false,
  tooltipMessage: '',
  tooltipPlacement: 'bottom',
  value: undefined,
  variant: 'background'
});var _templateObject$2, _templateObject2$2, _templateObject3$2, _templateObject4$2, _templateObject5$2, _templateObject6$1, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11, _templateObject12, _templateObject13, _templateObject14;
// Styles
// =============================

var Reset = styled__default['default'].div(_templateObject$2 || (_templateObject$2 = _taggedTemplateLiteral$5(["\n  color: inherit;\n  font-family: inherit;\n  font-size: inherit;\n  font-weight: inherit;\n  letter-spacing: inherit;\n  line-height: 1.3; /** Always 1.3 because of the overflow needed for text-overflow: ellipsis */\n  min-width: 20rem;\n  max-width: 100%;\n  outline: none;\n  white-space: nowrap;\n\n  width: 100%;\n\n  border: 0;\n  margin: 0;\n  padding: 0;\n"])));
var Button = styled__default['default'](Reset)(_templateObject2$2 || (_templateObject2$2 = _taggedTemplateLiteral$5(["\n  ", ";\n  background-color: transparent;\n  cursor: pointer;\n  margin: 0;\n  padding: 0;\n  text-align: left;\n\n  ", ";\n\n  ", ";\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.helpers.textEllipsis;
}, function (_ref2) {
  var multiline = _ref2.multiline;
  return multiline && styled.css(_templateObject3$2 || (_templateObject3$2 = _taggedTemplateLiteral$5(["\n      white-space: pre-wrap;\n    "])));
}, function (_ref3) {
  var value = _ref3.value;
  return !value && styled.css(_templateObject4$2 || (_templateObject4$2 = _taggedTemplateLiteral$5(["\n    opacity: 0.6;\n  "])));
});
var TextInput = styled__default['default'].div(_templateObject5$2 || (_templateObject5$2 = _taggedTemplateLiteral$5(["\n  display: inline-block;\n  flex: 1 1 auto;\n  height: 100%;\n  overflow: hidden;\n  padding: 0.4rem;\n  transition: background-color ", ";\n"])), function (_ref4) {
  var theme = _ref4.theme;
  return theme.transition.medium;
});
var EditIcon = styled__default['default'](Edit$1)(_templateObject6$1 || (_templateObject6$1 = _taggedTemplateLiteral$5(["\n  margin: 0 1.5rem;\n  transition: opacity ", ",\n    transform ", ";\n"])), function (_ref5) {
  var theme = _ref5.theme;
  return theme.transition.medium;
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.transition.medium;
});
var Wrapper$2 = styled__default['default'](Reset)(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral$5(["\n  align-items: center;\n  display: flex;\n  /** Since we add 0.4rem padding to TextInput, we need to re-align Wrapper. */\n  margin-left: -0.4rem;\n\n  &:hover {\n    background-color: ", ";\n  }\n\n  ", ";\n"])), function (_ref7) {
  var theme = _ref7.theme;
  return alpha$2(theme.colors.text, 0.2);
}, function (_ref8) {
  var editMode = _ref8.editMode;
  return editMode && styled.css(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral$5(["\n      background-color: ", ";\n    "])), function (_ref9) {
    var theme = _ref9.theme;
    return alpha$2(theme.colors.text, 0.2);
  });
});
var Form = styled__default['default'](Reset).attrs({
  as: 'form'
})(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral$5(["\n  height: 100%;\n\n  ", ";\n"])), function (_ref10) {
  var multiline = _ref10.multiline;
  return multiline && styled.css(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral$5(["\n      resize: none;\n      white-space: normal;\n    "])));
});
var Input = styled__default['default'](Reset).attrs(function (_ref11) {
  var multiline = _ref11.multiline;
  return {
    as: multiline ? 'textarea' : 'input'
  };
})(_templateObject11 || (_templateObject11 = _taggedTemplateLiteral$5(["\n  background-color: transparent;\n\n  ", ";\n\n  ", ";\n\n  ", ";\n"])), function (_ref12) {
  var height = _ref12.height,
      editMode = _ref12.editMode;
  return height && styled.css(_templateObject12 || (_templateObject12 = _taggedTemplateLiteral$5(["\n      height: ", ";\n    "])), editMode ? 'auto' : "".concat(height / 10, "rem"));
}, function (_ref13) {
  var width = _ref13.width;
  return width && styled.css(_templateObject13 || (_templateObject13 = _taggedTemplateLiteral$5(["\n      width: ", "rem;\n    "])), width / 10);
}, function (_ref14) {
  var multiline = _ref14.multiline;
  return multiline && styled.css(_templateObject14 || (_templateObject14 = _taggedTemplateLiteral$5(["\n      resize: none;\n      white-space: pre-wrap;\n    "])));
});// Component
// =============================

var TextToInput = /*#__PURE__*/function (_PureComponent) {
  _inherits$e(TextToInput, _PureComponent);

  var _super = _createSuper$1(TextToInput);

  function TextToInput(props) {
    var _this;

    _classCallCheck$k(this, TextToInput);

    _this = _super.call(this, props);

    _defineProperty$8(_assertThisInitialized$1(_this), "submitForm", function (event) {
      if (event) event.preventDefault();
      var _this$props = _this.props,
          onChange = _this$props.onChange,
          allowEmpty = _this$props.allowEmpty,
          propsValue = _this$props.value;
      var stateValue = _this.state.value; // If input empty, reset text

      if (!stateValue && !allowEmpty) return _this.toggleTextMode(); // If stateValue has changed from initial props

      if (stateValue !== propsValue) onChange(stateValue); // Go back to text mode & reset error

      return _this.setState({
        editMode: false
      });
    });

    _defineProperty$8(_assertThisInitialized$1(_this), "handleKeydown", function (event) {
      var multiline = _this.props.multiline;
      var editMode = _this.state.editMode;

      if (event.code === 'Escape' && editMode) {
        _this.toggleTextMode();
      }

      if (multiline && editMode && event.code === 'Enter' && !event.shiftKey) {
        event.preventDefault();

        _this.submitForm();
      }
    });

    _defineProperty$8(_assertThisInitialized$1(_this), "toggleTextMode", function () {
      var value = _this.props.value; // If user cancels his changes, reset state value
      // to props value

      _this.setState({
        value: value
      }); // Go back to text mode


      _this.setState({
        editMode: false
      });
    });

    _defineProperty$8(_assertThisInitialized$1(_this), "toggleEditMode", function () {
      var multiline = _this.props.multiline;

      _this.setState({
        editMode: true
      }, function () {
        // Focus input
        if (multiline) {
          _this.input.style.height = '0.5rem';
          _this.input.style.height = "".concat(_this.input.scrollHeight / 10, "rem");
        }

        _this.input.focus();
      });
    });

    _defineProperty$8(_assertThisInitialized$1(_this), "handleUpdate", function (event) {
      var value = event.target.value;
      var multiline = _this.props.multiline;
      /** Recalculate textarea height on updates. */

      if (multiline) {
        _this.input.style.height = '0.5rem';
        _this.input.style.height = "".concat(_this.input.scrollHeight / 10, "rem");
      }

      _this.setState({
        value: value
      });
    });

    _this.state = {
      editMode: false,
      height: 0,
      value: props.value || null,
      width: 0
    };
    _this.btnRef = /*#__PURE__*/React__default['default'].createRef();
    return _this;
  }

  _createClass$g(TextToInput, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      // Start listening to keydown when component mounts
      window.addEventListener('keydown', this.handleKeydown); // Input & Btn don't have the same width even if they have the
      // same text, so we need to fix their width.

      if (this.btnRef.current) {
        var _this$btnRef$current$ = this.btnRef.current.getBoundingClientRect(),
            height = _this$btnRef$current$.height,
            width = _this$btnRef$current$.width;

        this.setState({
          height: height,
          width: width
        });
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this2 = this;

      var value = this.props.value;

      if (prevProps.value !== value) {
        this.setState({
          value: value
        }, function () {
          // Update input width
          if (_this2.btnRef.current) {
            var _this2$btnRef$current = _this2.btnRef.current.getBoundingClientRect(),
                height = _this2$btnRef$current.height,
                width = _this2$btnRef$current.width;

            _this2.setState({
              height: height,
              width: width
            });
          }
        });
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      // Stop listening to keydown when component unmounts
      window.removeEventListener('keydown', this.handleKeydown);
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var _this$props2 = this.props,
          className = _this$props2.className,
          iconWidth = _this$props2.iconWidth,
          multiline = _this$props2.multiline,
          placeholder = _this$props2.placeholder;
      var _this$state = this.state,
          editMode = _this$state.editMode,
          height = _this$state.height,
          value = _this$state.value,
          width = _this$state.width;
      return /*#__PURE__*/React__default['default'].createElement(Wrapper$2, {
        className: className,
        editMode: editMode,
        multiline: multiline,
        onClick: !editMode ? this.toggleEditMode : null
      }, /*#__PURE__*/React__default['default'].createElement(TextInput, null, !editMode && /*#__PURE__*/React__default['default'].createElement(Button, {
        multiline: multiline,
        value: value,
        ref: this.btnRef
      }, value || placeholder), editMode && /*#__PURE__*/React__default['default'].createElement(Form, {
        multiline: multiline,
        onSubmit: this.submitForm
      }, /*#__PURE__*/React__default['default'].createElement(Input, {
        editMode: editMode,
        height: height,
        multiline: multiline,
        onBlur: this.submitForm,
        onChange: this.handleUpdate,
        placeholder: placeholder,
        ref: function ref(i) {
          _this3.input = i;
        },
        type: "text",
        value: value,
        width: width
      }))), /*#__PURE__*/React__default['default'].createElement(EditIcon, {
        width: "".concat(iconWidth, "rem"),
        onClick: this.submitForm
      }));
    }
  }]);

  return TextToInput;
}(React.PureComponent);

_defineProperty$8(TextToInput, "propTypes", {
  /** Allow empty value */
  allowEmpty: PropTypes__default['default'].bool,

  /** Props used by styled component to override styles */
  className: PropTypes__default['default'].string,

  /** Icon width */
  iconWidth: PropTypes__default['default'].string,

  /** If True, input will allow multiline input. */
  multiline: PropTypes__default['default'].bool,

  /** onChange handler */
  onChange: PropTypes__default['default'].func.isRequired,

  /** Placeholder. */
  placeholder: PropTypes__default['default'].string,

  /** Initial value */
  value: PropTypes__default['default'].string.isRequired
});

_defineProperty$8(TextToInput, "defaultProps", {
  allowEmpty: false,
  className: '',
  iconWidth: '2',
  multiline: false,
  placeholder: ''
});var _templateObject$1, _templateObject2$1, _templateObject3$1, _templateObject4$1, _templateObject5$1;
// Styles
// =============================

var Wrapper$1 = styled__default['default'](Div)(_templateObject$1 || (_templateObject$1 = _taggedTemplateLiteral$5(["\n  ", ";\n"])), function (_ref) {
  var align = _ref.align,
      centered = _ref.centered,
      color = _ref.color,
      faded = _ref.faded,
      family = _ref.family,
      inline = _ref.inline,
      onClick = _ref.onClick,
      size = _ref.size,
      theme = _ref.theme,
      weight = _ref.weight;
  return styled.css(_templateObject2$1 || (_templateObject2$1 = _taggedTemplateLiteral$5(["\n    ", ";\n    color: ", ";\n    ", ";\n    font-family: ", ";\n    font-size: ", ";\n    font-weight: ", ";\n    ", ";\n    opacity: ", ";\n    text-align: ", ";\n  "])), centered && styled.css(_templateObject3$1 || (_templateObject3$1 = _taggedTemplateLiteral$5(["\n        margin-left: auto;\n        margin-right: auto;\n      "]))), get_1(theme.colors, color, 'inherit'), inline && styled.css(_templateObject4$1 || (_templateObject4$1 = _taggedTemplateLiteral$5(["\n        display: inline-block;\n      "]))), theme.fontFamily[family], size === 'inherit' ? 'inherit' : "".concat(size, "rem"), weight === 'inherit' ? 'inherit' : theme.fontWeight[weight], onClick && styled.css(_templateObject5$1 || (_templateObject5$1 = _taggedTemplateLiteral$5(["\n        cursor: pointer;\n      "]))), faded ? '0.5' : '1', align);
});var _excluded$2 = ["align", "centered", "children", "className", "color", "faded", "family", "inline", "onClick", "size", "weight"];
// Component
// =============================

var Typo = /*#__PURE__*/React__default['default'].memo(function (_ref) {
  var align = _ref.align,
      centered = _ref.centered,
      children = _ref.children,
      className = _ref.className,
      color = _ref.color,
      faded = _ref.faded,
      family = _ref.family,
      inline = _ref.inline,
      onClick = _ref.onClick,
      size = _ref.size,
      weight = _ref.weight,
      rest = _objectWithoutProperties$7(_ref, _excluded$2);

  return /*#__PURE__*/React__default['default'].createElement(Wrapper$1, _extends$g({
    align: align,
    centered: centered,
    className: className,
    color: color,
    faded: faded,
    family: family,
    inline: inline,
    onClick: onClick,
    size: size,
    weight: weight
  }, getViewProps(rest)), children);
});
Typo.propTypes = {
  /** Text align */
  align: PropTypes__default['default'].string,

  /** Set margin left/right to auto  */
  centered: PropTypes__default['default'].bool,

  /** Text */
  children: PropTypes__default['default'].node.isRequired,

  /** Props used by styled component to override styles. */
  className: PropTypes__default['default'].string,

  /** Text color */
  color: PropTypes__default['default'].oneOf(['text', 'primary', 'inherit', 'type.success', 'type.error']),

  /** If True, will apply opacity: 0.5 to text. */
  faded: PropTypes__default['default'].bool,

  /** Font Familly */
  family: PropTypes__default['default'].oneOf(['primary']),

  /** Set display to inline-block */
  inline: PropTypes__default['default'].bool,

  /** onClick handler */
  onClick: PropTypes__default['default'].func,

  /** Font size */
  size: PropTypes__default['default'].oneOfType([PropTypes__default['default'].string, PropTypes__default['default'].number]),

  /** Font weight */
  weight: PropTypes__default['default'].string
};
Typo.defaultProps = {
  align: 'left',
  centered: false,
  className: '',
  color: 'inherit',
  faded: false,
  family: 'primary',
  inline: false,
  onClick: null,
  size: 'inherit',
  weight: 'inherit'
};var lib = {};Object.defineProperty(lib, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = React__default['default'];

var _react2 = _interopRequireDefault(_react);

var _propTypes = PropTypes__default['default'];

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = classnames.exports;

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// import styles from "./styles"

var cleanups = {
  // some useless stuff for us
  // that svgo doesn't remove
  title: /<title>.*<\/title>/gi,
  desc: /<desc>.*<\/desc>/gi,
  comment: /<!--.*-->/gi,
  defs: /<defs>.*<\/defs>/gi,

  // remove hardcoded dimensions
  width: / +width="\d+(\.\d+)?(px)?"/gi,
  height: / +height="\d+(\.\d+)?(px)?"/gi,

  // remove fill
  fill: / +fill="(none|#[0-9a-f]+)"/gi,

  // Sketch.app shit
  sketchMSShapeGroup: / +sketch:type="MSShapeGroup"/gi,
  sketchMSPage: / +sketch:type="MSPage"/gi,
  sketchMSLayerGroup: / +sketch:type="MSLayerGroup"/gi
};

// @styled(styles)

var SVGInline = function (_Component) {
  _inherits(SVGInline, _Component);

  function SVGInline() {
    _classCallCheck(this, SVGInline);

    return _possibleConstructorReturn(this, (SVGInline.__proto__ || Object.getPrototypeOf(SVGInline)).apply(this, arguments));
  }

  _createClass(SVGInline, [{
    key: "render",
    value: function render() {
      var _props = this.props,
          className = _props.className,
          component = _props.component,
          svg = _props.svg,
          fill = _props.fill,
          width = _props.width,
          accessibilityLabel = _props.accessibilityLabel,
          accessibilityDesc = _props.accessibilityDesc,
          classSuffix = _props.classSuffix,
          cleanupExceptions = _props.cleanupExceptions,
          componentProps = _objectWithoutProperties(_props, ["className", "component", "svg", "fill", "width", "accessibilityLabel", "accessibilityDesc", "classSuffix", "cleanupExceptions"]);

      var _props2 = this.props,
          cleanup = _props2.cleanup,
          height = _props2.height;


      if (
      // simple way to enable entire cleanup
      cleanup === true ||
      // passing cleanupExceptions enable cleanup as well
      cleanup.length === 0 && cleanupExceptions.length > 0) {
        cleanup = Object.keys(cleanups);
      }
      cleanup = cleanup.filter(function (key) {
        return !(cleanupExceptions.indexOf(key) > -1);
      });

      if (width && height === undefined) {
        height = width;
      }

      // remove useless props for wrapper
      delete componentProps.cleanup;
      delete componentProps.height;

      var classes = (0, _classnames2.default)(_defineProperty({
        SVGInline: true,
        "SVGInline--cleaned": cleanup.length
      }, className, className));
      var svgClasses = classes.split(" ").join(classSuffix + " ") + classSuffix;
      var svgStr = SVGInline.cleanupSvg(svg, cleanup).replace(/<svg/, "<svg class=\"" + svgClasses + "\"" + (fill ? " fill=\"" + fill + "\"" : "") + (width || height ? ' style="' + (width ? "width: " + width + ";" : "") + (height ? "height: " + height + ";" : "") + '"' : ""));
      var match = void 0;
      if (accessibilityDesc) {
        match = /<svg(.|\n|\r\n)*?>/.exec(svgStr);
        var pos = match.index + match[0].length;
        svgStr = svgStr.substr(0, pos) + ("<desc>" + accessibilityDesc + "</desc>") + svgStr.substr(pos);
      }
      if (accessibilityLabel) {
        match = match || /<svg(.|\n|\r\n)*?>/.exec(svgStr);
        var _pos = match.index + match[0].length - 1;
        var id = "SVGInline-" + SVGInline.idCount++ + "-title";
        svgStr = svgStr.substr(0, _pos) + (" role=\"img\" aria-labelledby=\"" + id + "\"") + svgStr.substr(_pos, 1) + ("<title id=\"" + id + "\">" + accessibilityLabel + "</title>") + svgStr.substr(_pos + 1);
      }
      return _react2.default.createElement(component, _extends({}, componentProps, { // take most props
        className: classes,
        dangerouslySetInnerHTML: {
          __html: svgStr
        }
      }));
    }
  }]);

  return SVGInline;
}(_react.Component);

SVGInline.propTypes = {
  className: _propTypes2.default.string,
  classSuffix: _propTypes2.default.string,
  component: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
  svg: _propTypes2.default.string.isRequired,
  fill: _propTypes2.default.string,
  cleanup: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.array]),
  cleanupExceptions: _propTypes2.default.array,
  width: _propTypes2.default.string,
  height: _propTypes2.default.string,
  accessibilityLabel: _propTypes2.default.string,
  accessibilityDesc: _propTypes2.default.string
};

SVGInline.defaultProps = {
  component: "span",
  classSuffix: "-svg",
  cleanup: [],
  cleanupExceptions: []
};

SVGInline.idCount = 0;

SVGInline.cleanupSvg = function (svg) {
  var cleanup = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

  return Object.keys(cleanups).filter(function (key) {
    return cleanup.indexOf(key) > -1;
  }).reduce(function (acc, key) {
    return acc.replace(cleanups[key], "");
  }, svg).trim();
};

var _default = lib.default = SVGInline;var _excluded$1 = ["color", "progress"],
    _excluded2 = ["color"];

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6;
// Styles
// =============================

var Wrapper = styled__default['default'](Div)(_templateObject || (_templateObject = _taggedTemplateLiteral$5(["\n  cursor: pointer;\n  flex-shrink: 0;\n  height: 4rem;\n  position: relative;\n  width: 100%;\n  opacity: ", ";\n  transition: opacity ", ";\n"])), function (_ref) {
  var visible = _ref.visible;
  return visible ? 1 : 0;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.transition.medium;
});
var ForegroundContainer = styled__default['default'].div.attrs(function (_ref3) {
  var progress = _ref3.progress;
  return {
    style: {
      width: "".concat(progress, "%")
    }
  };
})(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral$5(["\n  height: 100%;\n  left: 0;\n  overflow: hidden;\n  position: absolute;\n  top: 0;\n"])));
var ForegroundWaveform = styled__default['default'](function (_ref4) {
  _ref4.color;
      _ref4.progress;
      var rest = _objectWithoutProperties$7(_ref4, _excluded$1);

  return /*#__PURE__*/React__default['default'].createElement(_default, rest);
}).attrs(function (_ref5) {
  var progress = _ref5.progress;
  return {
    style: {
      width: "".concat(100 / progress * 100, "%")
    }
  };
})(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral$5(["\n  align-items: center;\n  display: flex;\n  height: 100%;\n  top: 0;\n  left: 0;\n  position: absolute;\n\n  svg {\n    height: 100%;\n    width: 100%;\n  }\n\n  svg g {\n    ", "\n  }\n"])), function (_ref6) {
  var color = _ref6.color,
      theme = _ref6.theme;
  return styled.css(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral$5(["\n      fill: ", ";\n    "])), alpha$2(color !== 'default' ? color : theme.colors.text, 0.9));
});
var BackgroundWaveform = styled__default['default'](function (_ref7) {
  _ref7.color;
      var rest = _objectWithoutProperties$7(_ref7, _excluded2);

  return /*#__PURE__*/React__default['default'].createElement(_default, rest);
})(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral$5(["\n  align-items: center;\n  display: flex;\n  height: 100%;\n  top: 0;\n  left: 0;\n  position: absolute;\n  width: 100%;\n\n  svg {\n    height: 100%;\n  }\n\n  svg g {\n    ", "\n  }\n"])), function (_ref8) {
  var color = _ref8.color,
      theme = _ref8.theme;
  return styled.css(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral$5(["\n      fill: ", "\n    "])), alpha$2(color !== 'default' ? color : theme.colors.text, 0.3));
});var _excluded = ["className", "color", "progress", "width"];
// Component
// =============================

var dummyWaveform = '<svg viewBox="0 0 300.000000 45.000000" preserveAspectRatio="none"><g><rect width="100%" height="100%" /></g></svg>';

var Waveform = /*#__PURE__*/function (_PureComponent) {
  _inherits$e(Waveform, _PureComponent);

  var _super = _createSuper$1(Waveform);

  function Waveform(props) {
    var _this;

    _classCallCheck$k(this, Waveform);

    _this = _super.call(this, props);

    _defineProperty$8(_assertThisInitialized$1(_this), "handleOnSeek", function (e) {
      var onSeek = _this.props.onSeek;
      if (!onSeek) return;
      var pos = e.nativeEvent.clientX;

      var _this$wrapperRef$curr = _this.wrapperRef.current.getBoundingClientRect(),
          width = _this$wrapperRef$curr.width,
          x = _this$wrapperRef$curr.x;

      var percentage = Math.min(Math.max(pos - x, 0) * 100 / width, 100);
      onSeek(percentage);
    });

    _this.state = {
      svgFile: null
    };
    _this.svgRef = /*#__PURE__*/React__default['default'].createRef();
    _this.wrapperRef = /*#__PURE__*/React__default['default'].createRef();
    return _this;
  }

  _createClass$g(Waveform, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      var svg = this.props.svg;

      if (svg) {
        // Load waveform
        axios.get(svg).then(function (_ref) {
          var data = _ref.data;
          var svgData = data.replace('preserveAspectRatio="xMidYMid meet"', 'preserveAspectRatio="none"');

          _this2.setState({
            svgFile: svgData
          });
        })["catch"](function () {
          _this2.setState({
            svgFile: dummyWaveform
          });
        });
      } else {
        this.setState({
          svgFile: dummyWaveform
        });
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this3 = this;

      var svg = this.props.svg;

      if (prevProps.svg !== svg) {
        if (svg) {
          axios.get(svg).then(function (_ref2) {
            var data = _ref2.data;
            var svgData = data.replace('preserveAspectRatio="xMidYMid meet"', 'preserveAspectRatio="none"');

            _this3.setState({
              svgFile: svgData
            });
          })["catch"](function () {
            _this3.setState({
              svgFile: dummyWaveform
            });
          });
        } else {
          this.setState({
            svgFile: dummyWaveform
          });
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          className = _this$props.className,
          color = _this$props.color,
          progress = _this$props.progress,
          width = _this$props.width,
          rest = _objectWithoutProperties$7(_this$props, _excluded);

      var svgFile = this.state.svgFile;
      return /*#__PURE__*/React__default['default'].createElement(Wrapper, _extends$g({
        className: className
      }, getViewProps(rest), {
        onClick: this.handleOnSeek,
        ref: this.wrapperRef,
        visible: !!svgFile,
        width: width
      }), svgFile && /*#__PURE__*/React__default['default'].createElement(React__default['default'].Fragment, null, /*#__PURE__*/React__default['default'].createElement(BackgroundWaveform, {
        color: color,
        height: "100%",
        svg: svgFile,
        width: width
      }), /*#__PURE__*/React__default['default'].createElement(ForegroundContainer, {
        progress: progress
      }, /*#__PURE__*/React__default['default'].createElement(ForegroundWaveform, {
        color: color,
        height: "100%",
        progress: progress,
        svg: svgFile,
        width: width
      }))));
    }
  }]);

  return Waveform;
}(React.PureComponent);

_defineProperty$8(Waveform, "propTypes", {
  /** Props used by styled component to override styles */
  className: PropTypes__default['default'].string,

  /** Waveform color. */
  color: PropTypes__default['default'].string,

  /** Callback function on seek */
  onSeek: PropTypes__default['default'].func,

  /** Progress of playback in percentage */
  progress: PropTypes__default['default'].number,

  /** SVG url */
  svg: PropTypes__default['default'].string,

  /** Width of the waveform in rem */
  width: PropTypes__default['default'].string.isRequired
});

_defineProperty$8(Waveform, "defaultProps", {
  className: '',
  color: 'default',
  onSeek: null,
  progress: 0,
  svg: null
});exports.ApiSelectInput=ApiSelectInput;exports.AppThemeProvider=AppThemeProvider;exports.Avatar=Avatar;exports.Button=Button$1;exports.CheckboxInput=Checkbox;exports.Chip=Chip;exports.ColorPicker=ColorPicker;exports.ConditionalWrapper=ConditionalWrapper;exports.Cover=Cover;exports.DateDisplayer=Date$1;exports.DatePicker=DatePicker;exports.Div=Div;exports.Dropdown=DropdownClass;exports.DropdownContext=DropdownContext;exports.DropdownList=DropdownList;exports.FilterBar=FilterBar;exports.Flex=Flex;exports.GoogleFontsInput=GoogleFontsInput;exports.GoogleMaps=GoogleMaps;exports.GooglePlacesInput=GooglePlacesInput;exports.Icons=index$1;exports.InfoTooltip=InfoTooltip;exports.Input=MewoInput;exports.InputBase=InputBase$2;exports.LangSwitcher=LangSwitcher;exports.Loader=Loader;exports.Notification=Notification;exports.RadioInput=RadioInput;exports.RatingInput=RatingInput;exports.SelectInput=SelectInput;exports.Svg=Svg$2;exports.SwitchInput=SwitchInput;exports.TextArea=TextArea;exports.TextToInput=TextToInput;exports.Tooltip=Tooltip$2;exports.Typo=Typo;exports.Waveform=Waveform;exports.WithCustomTheme=WithCustomTheme;exports.appTheme=theme;